var FP = Object.defineProperty;
var $P = (t, e, r) => e in t ? FP(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var Hi = (t, e, r) => ($P(t, typeof e != "symbol" ? e + "" : e, r), r);
import es from "web3";
import Ko from "bignumber.js";
import { numberToHex as ht, hexToNumber as qP } from "web3-utils";
import { useMemo as df } from "react";
var Se = /* @__PURE__ */ ((t) => (t.ethMainnet = "ethMainnetHttpProvider", t.ethGoerli = "ethGoerliHttpProvider", t.ethSepolia = "ethSepoliaHttpProvider", t.ethHolesky = "ethHoleskyHttpProvider", t.mumbai = "polygonMumbaiHttpWeb3KeyProvider", t.polygon = "polygonHttpWeb3KeyProvider", t.polygonZkEVM = "polygonZkEVMHttpWeb3KeyProvider", t.polygonZkEVMTestnet = "polygonZkEVMTestnetHttpWeb3KeyProvider", t.avalancheChain = "avalancheChainHttpProvider", t.avalancheChainTest = "avalancheChainTestHttpProvider", t.arbitrum = "arbitrumHttpProvider", t.arbitrumTestnet = "arbitrumTestnetHttpProvider", t.arbitrumSepoliaTestnet = "arbitrumSepoliaTestnetHttpProvider", t.arbitrumNova = "arbitrumNovaHttpProvider", t.binanceChain = "binanceChainHttpProvider", t.binanceChainTest = "binanceChainTestHttpProvider", t.ftmOpera = "ftmOperaHttpProvider", t.ftmTestnet = "ftmTestnetHttpProvider", t.gnosis = "gnosisHttpProvider", t.chiado = "chiadoHttpProvider", t.sokol = "sokolHttpProvider", t.xdc = "xdcMainnetHttpProvider", t.xdcTestnet = "xdcTestnetHttpProvider", t.optimism = "optimismHttpProvider", t.optimismTestnet = "optimismTestnetHttpProvider", t.optimismSepolia = "optimismSepoliaHttpProvider", t.opBNB = "opBNBHttpProvider", t.opBNBTestnet = "opBNBTestnetHttpProvider", t.linea = "lineaHttpProvider", t.lineaTestnet = "lineaTestnetHttpProvider", t.lineaSepolia = "lineaSepoliaHttpProvider", t.tron = "tronHttpProvider", t.base = "baseHttpProvider", t.baseTestnet = "baseTestnetHttpProvider", t.mantle = "mantleHttpProvider", t.mantleGoerli = "mantleGoerliHttpProvider", t.mantleSepolia = "mantleSepoliaHttpProvider", t.celo = "celoHttpProvider", t.blast = "blastHttpProvider", t.blastTestnet = "blastTestnetHttpProvider", t.zkSync = "zkSyncHttpProvider", t.zkSyncGoerli = "zkSyncGoerliHttpProvider", t.zkSyncSepolia = "zkSyncSepoliaHttpProvider", t.moonbeam = "moonbeamHttpProvider", t.taikoTestnet = "taikoTestnetHttpProvider", t.nervos = "nervosHttpProvider", t.tenet = "tenetHttpProvider", t.rollux = "rolluxHttpProvider", t.rolluxTestnet = "rolluxTestnetHttpProvider", t.chiliz = "chilizHttpProvider", t.flare = "flareHttpProvider", t.horizenEON = "horizenEONHttpProvider", t.horizenEONTestnet = "horizenEONTestnetHttpProvider", t.syscoin = "syscoinHttpProvider", t.bitTorrent = "bitTorrentHttpProvider", t.kava = "kavaHttpProvider", t.iotex = "iotexHttpProvider", t.harmony = "harmonyHttpProvider", t.zetaChainTestnet = "zetaChainTestnetHttpProvider", t.scroll = "scrollHttpProvider", t.scrollTestnet = "scrollTestnetHttpProvider", t.klaytn = "klaytnHttpProvider", t.klaytnTestnet = "klaytnTestnetHttpProvider", t.core = "coreHttpProvider", t.coreTestnet = "coreTestnetHttpProvider", t.incentivDevnet = "incentivDevnetHttpProvider", t.incentivTestnet = "incentivTestnetHttpProvider", t.mode = "modeHttpProvider", t.modeTestnet = "modeTestnetHttpProvider", t.xlayer = "xlayerHttpProvider", t.xlayerTestnet = "xlayerTestnetHttpProvider", t.fluentDevnet = "fluentDevnetHttpProvider", t.zircuitMainnet = "zircuitMainnetHttpProvider", t.zircuitTestnet = "zircuitTestnetHttpProvider", t.flowPreviewnet = "flowPreviewnetHttpProvider", t.flowTestnet = "flowTestnetHttpProvider", t.flow = "flowHttpProvider", t.bitlayer = "bitlayerHttpProvider", t.bitlayerTestnet = "bitlayerTestnetHttpProvider", t.berachain = "berachainHttpProvider", t.berachainTestnet = "berachainTestnetHttpProvider", t.fraxtal = "fraxtalHttpProvider", t.fraxtalTestnet = "fraxtalTestnetHttpProvider", t.corn = "cornHttpProvider", t.cornTestnet = "cornTestnetHttpProvider", t.swell = "swellHttpProvider", t.swellTestnet = "swellTestnetHttpProvider", t))(Se || {}), Qy = /* @__PURE__ */ ((t) => (t.ethCompatible = "ethCompatible", t))(Qy || {}), ee = /* @__PURE__ */ ((t) => (t[t.mainnet = 1] = "mainnet", t[t.ropsten = 3] = "ropsten", t[t.rinkeby = 4] = "rinkeby", t[t.goerli = 5] = "goerli", t[t.dev = 2018] = "dev", t[t.classic = 61] = "classic", t[t.mordor = 63] = "mordor", t[t.kotti = 6] = "kotti", t[t.smartchain = 56] = "smartchain", t[t.smartchainTestnet = 97] = "smartchainTestnet", t[t.arbitrum = 42161] = "arbitrum", t[t.arbitrumTestnet = 421613] = "arbitrumTestnet", t[t.arbitrumSepoliaTestnet = 421614] = "arbitrumSepoliaTestnet", t[t.arbitrumNova = 42170] = "arbitrumNova", t[t.avalanche = 43114] = "avalanche", t[t.avalancheTestnet = 43113] = "avalancheTestnet", t[t.polygon = 137] = "polygon", t[t.polygonZkEVM = 1101] = "polygonZkEVM", t[t.polygonZkEVMTestnet = 1442] = "polygonZkEVMTestnet", t[t.fantom = 250] = "fantom", t[t.fantomTestnet = 4002] = "fantomTestnet", t[t.mumbai = 80001] = "mumbai", t[t.gnosis = 100] = "gnosis", t[t.chiado = 10200] = "chiado", t[t.sokol = 77] = "sokol", t[t.xdc = 50] = "xdc", t[t.xdcTestnet = 51] = "xdcTestnet", t[t.sepolia = 11155111] = "sepolia", t[t.optimism = 10] = "optimism", t[t.optimismTestnet = 420] = "optimismTestnet", t[t.optimismSepolia = 11155420] = "optimismSepolia", t[t.linea = 59144] = "linea", t[t.lineaTestnet = 59140] = "lineaTestnet", t[t.lineaSepolia = 59141] = "lineaSepolia", t[t.holesky = 17e3] = "holesky", t[t.opBNB = 204] = "opBNB", t[t.opBNBTestnet = 5611] = "opBNBTestnet", t[t.tron = 728126428] = "tron", t[t.base = 8453] = "base", t[t.baseTestnet = 84532] = "baseTestnet", t[t.mantle = 5e3] = "mantle", t[t.mantleGoerli = 5001] = "mantleGoerli", t[t.mantleSepolia = 5003] = "mantleSepolia", t[t.celo = 42220] = "celo", t[t.blast = 81457] = "blast", t[t.blastTestnet = 168587773] = "blastTestnet", t[t.zkSync = 324] = "zkSync", t[t.zkSyncGoerli = 280] = "zkSyncGoerli", t[t.zkSyncSepolia = 300] = "zkSyncSepolia", t[t.moonbeam = 1284] = "moonbeam", t[t.taikoTestnet = 167008] = "taikoTestnet", t[t.nervos = 71402] = "nervos", t[t.tenet = 1559] = "tenet", t[t.rollux = 570] = "rollux", t[t.rolluxTestnet = 57e3] = "rolluxTestnet", t[t.chiliz = 88888] = "chiliz", t[t.flare = 14] = "flare", t[t.horizenEON = 7332] = "horizenEON", t[t.horizenEONTestnet = 1663] = "horizenEONTestnet", t[t.syscoin = 57] = "syscoin", t[t.bitTorrent = 199] = "bitTorrent", t[t.kava = 2222] = "kava", t[t.iotex = 4689] = "iotex", t[t.harmony = 16666e5] = "harmony", t[t.zetaChainTestnet = 7001] = "zetaChainTestnet", t[t.scroll = 534352] = "scroll", t[t.scrollTestnet = 534351] = "scrollTestnet", t[t.klaytn = 8217] = "klaytn", t[t.klaytnTestnet = 1001] = "klaytnTestnet", t[t.core = 1116] = "core", t[t.coreTestnet = 1115] = "coreTestnet", t[t.mode = 34443] = "mode", t[t.modeTestnet = 919] = "modeTestnet", t[t.xlayer = 196] = "xlayer", t[t.xlayerTestnet = 195] = "xlayerTestnet", t[t.fluentDevnet = 20993] = "fluentDevnet", t[t.zircuitMainnet = 48900] = "zircuitMainnet", t[t.zircuitTestnet = 48899] = "zircuitTestnet", t[t.flowPreviewnet = 646] = "flowPreviewnet", t[t.flowTestnet = 545] = "flowTestnet", t[t.flow = 747] = "flow", t[t.incentivDevnet = 16350] = "incentivDevnet", t[t.incentivTestnet = 827] = "incentivTestnet", t[t.bitlayer = 200901] = "bitlayer", t[t.bitlayerTestnet = 200810] = "bitlayerTestnet", t[t.berachain = 80085] = "berachain", t[t.berachainTestnet = 80084] = "berachainTestnet", t[t.fraxtal = 252] = "fraxtal", t[t.fraxtalTestnet = 2522] = "fraxtalTestnet", t[t.corn = 21e6] = "corn", t[t.cornTestnet = 21000001] = "cornTestnet", t[t.swell = 1923] = "swell", t[t.swellTestnet = 1924] = "swellTestnet", t))(ee || {}), st = /* @__PURE__ */ ((t) => (t.imtoken = "custom-imtoken", t.injected = "injected", t.math = "custom-math", t.trust = "custom-trust", t.trustViaWalletConnect = "custom-trust-walletconnect", t.binanceWallet = "custom-binance-wallet", t.coin98 = "custom-coin98", t.walletconnect = "custom-walletconnect", t.coinbase = "custom-coinbase", t.okxwallet = "custom-okxwallet", t.clover = "custom-clover", t.mirage = "custom-mirage", t.bybit = "custom-bybit", t.bitget = "custom-bitget", t.flow = "custom-flow", t))(st || {});
const ES = 25e3;
class Eh {
  constructor() {
    Hi(this, "_currentChain", 0);
    Hi(this, "provider", null);
    Hi(this, "web3", null);
  }
  static isInjected() {
    return typeof window.ethereum < "u";
  }
  isConnected() {
    return !!this.web3;
  }
  get currentChain() {
    if (!this._currentChain)
      throw new Error("Web3 is not connected");
    return this._currentChain;
  }
  set currentChain(e) {
    this._currentChain = e;
  }
  getFormattedBalance(e, r) {
    return new Ko(e).dividedBy(new Ko(10).pow(r));
  }
  async getErc20Balance(e, r) {
    const i = await e.methods.balanceOf(r).call();
    let s = await e.methods.decimals().call();
    return Number(s) || (s = 18), this.getFormattedBalance(i, s);
  }
  async getTokenBalance(e, r) {
    const i = await e.methods.balanceOf(r).call();
    let s = await e.methods.decimals().call();
    return Number(s) || (s = 18), this.getFormattedBalance(i, s);
  }
  getWeb3() {
    if (!this.web3)
      throw new Error("Web3 must be initialized");
    return this.web3;
  }
  async connect() {
    const e = this.getWeb3();
    this.currentChain = await e.eth.getChainId();
  }
  createContract(e, r) {
    const i = this.getWeb3();
    return new i.eth.Contract(e, r);
  }
  disconnect() {
    if (this.web3 = null, this.currentChain = 0, this.provider) {
      const e = typeof this.provider.disconnect == "function", r = typeof this.provider.reset == "function", i = typeof this.provider.close == "function";
      r && this.provider.reset(), e && this.provider.disconnect(), i && this.provider.close(), this.provider = null;
    }
  }
  async watchAsset(e) {
    var f;
    const i = this.getWeb3().currentProvider;
    if (!i)
      throw new Error("Failed to watch asset, there is no current provider");
    const s = {
      type: e.type,
      options: {
        address: e.address,
        symbol: e.symbol,
        decimals: e.decimals,
        image: e.image
      }
    };
    if (!await ((f = i.request) == null ? void 0 : f.call(i, {
      method: "wallet_watchAsset",
      params: s
    })))
      throw new Error("Failed to watch asset, something went wrong");
  }
  async executeBatchCalls(e) {
    const r = this.getWeb3(), i = new r.eth.BatchRequest(), s = e.map(
      (n) => new Promise((f, u) => {
        const h = (d, l) => d ? u(d) : f(l);
        i.add(n(h));
      })
    );
    return i.execute(), Promise.all(s);
  }
  async getContractMethodFee(e) {
    const r = await this.getSafeGasPriceWei(), i = this.getWeb3().utils.fromWei(r.toString());
    return new Ko(i).multipliedBy(e);
  }
  async getSafeGasPriceWei() {
    const e = await this.getWeb3().eth.getGasPrice();
    return new Ko(e).plus(ES);
  }
  async getBlockNumber() {
    if (!this.web3)
      throw new Error("web3 isn't defined");
    return this.web3.eth.getBlockNumber();
  }
}
class Ade extends Eh {
  constructor(r) {
    super();
    Hi(this, "url");
    this.web3 = new es(), this.url = r, this.web3.setProvider(new es.providers.HttpProvider(r));
  }
  get rpcUrl() {
    return this.url;
  }
}
class HP extends Eh {
  constructor(e) {
    super(), this.url = e, this.web3 = new es();
    const r = new es.providers.HttpProvider(e);
    this.web3.setProvider(r);
  }
  get rpcUrl() {
    return this.url;
  }
}
const Re = {
  [ee.mainnet]: "https://rpc.ankr.com/eth",
  [ee.goerli]: "https://rpc.ankr.com/eth_goerli",
  [ee.sepolia]: "https://rpc.ankr.com/eth_sepolia",
  [ee.arbitrum]: "https://rpc.ankr.com/arbitrum",
  [ee.arbitrumTestnet]: "https://goerli-rollup.arbitrum.io/rpc",
  [ee.arbitrumSepoliaTestnet]: "https://sepolia-rollup.arbitrum.io/rpc",
  [ee.arbitrumNova]: "https://rpc.ankr.com/arbitrumnova",
  [ee.avalanche]: "https://rpc.ankr.com/avalanche",
  [ee.avalancheTestnet]: "https://rpc.ankr.com/avalanche_fuji",
  [ee.smartchain]: "https://rpc.ankr.com/bsc",
  [ee.smartchainTestnet]: "https://rpc.ankr.com/bsc_testnet_chapel",
  [ee.fantom]: "https://rpc.ankr.com/fantom",
  [ee.fantomTestnet]: "https://rpc.ankr.com/fantom_testnet",
  [ee.mumbai]: "https://rpc.ankr.com/polygon_mumbai",
  [ee.polygon]: "https://rpc.ankr.com/polygon",
  [ee.polygonZkEVM]: "https://rpc.ankr.com/polygon_zkevm",
  [ee.polygonZkEVMTestnet]: "https://rpc.ankr.com/polygon_zkevm_testnet",
  [ee.gnosis]: "https://rpc.ankr.com/gnosis",
  [ee.chiado]: "https://rpc.chiadochain.net/",
  [ee.sokol]: "https://sokol.poa.network",
  [ee.xdc]: "https://erpc.xinfin.network",
  [ee.xdcTestnet]: "https://erpc.apothem.network",
  [ee.optimism]: "https://rpc.ankr.com/optimism",
  [ee.optimismTestnet]: "https://rpc.ankr.com/optimism_testnet",
  [ee.optimismSepolia]: "https://rpc.ankr.com/optimism_sepolia",
  [ee.linea]: "https://rpc.linea.build",
  [ee.lineaTestnet]: "https://rpc.goerli.linea.build",
  [ee.lineaSepolia]: "https://rpc.sepolia.linea.build",
  [ee.holesky]: "https://rpc.ankr.com/eth_holesky",
  [ee.opBNB]: "https://opbnb-mainnet-rpc.bnbchain.org",
  [ee.opBNBTestnet]: "https://opbnb-testnet-rpc.bnbchain.org",
  [ee.tron]: "https://rpc.ankr.com/tron_jsonrpc",
  [ee.base]: "https://rpc.ankr.com/base",
  [ee.baseTestnet]: "https://rpc.ankr.com/base_sepolia",
  [ee.mantle]: "https://rpc.ankr.com/mantle",
  [ee.mantleGoerli]: "https://rpc.ankr.com/mantle_testnet",
  [ee.mantleSepolia]: "https://rpc.ankr.com/mantle_sepolia",
  [ee.celo]: "https://rpc.ankr.com/celo",
  [ee.blast]: "https://rpc.ankr.com/blast",
  [ee.blastTestnet]: "https://rpc.ankr.com/blast_testnet_sepolia",
  [ee.zkSync]: "https://rpc.ankr.com/zksync_era",
  [ee.zkSyncSepolia]: "https://rpc.ankr.com/zksync_era_sepolia",
  [ee.zkSyncGoerli]: "https://rpc.ankr.com/zksync_era_testnet",
  [ee.moonbeam]: "https://rpc.ankr.com/moonbeam",
  [ee.taikoTestnet]: "https://rpc.ankr.com/taiko_katla",
  [ee.nervos]: "https://rpc.ankr.com/nervos",
  [ee.tenet]: "https://rpc.ankr.com/tenet_evm",
  [ee.rollux]: "https://rpc.ankr.com/rollux",
  [ee.rolluxTestnet]: "https://rpc.ankr.com/rollux_testnet",
  [ee.chiliz]: "https://rpc.ankr.com/chiliz",
  [ee.flare]: "https://rpc.ankr.com/flare",
  [ee.horizenEON]: "https://rpc.ankr.com/horizen_eon",
  [ee.horizenEONTestnet]: "https://rpc.ankr.com/horizen_gobi_testnet",
  [ee.syscoin]: "https://rpc.ankr.com/syscoin",
  [ee.bitTorrent]: "https://rpc.ankr.com/bttc",
  [ee.kava]: "https://rpc.ankr.com/kava_evm",
  [ee.iotex]: "https://rpc.ankr.com/iotex",
  [ee.harmony]: "https://rpc.ankr.com/harmony",
  [ee.zetaChainTestnet]: "https://rpc.ankr.com/zetachain_evm_athens_testnet",
  [ee.scroll]: "https://rpc.ankr.com/scroll",
  [ee.scrollTestnet]: "https://rpc.ankr.com/scroll_sepolia_testnet",
  [ee.klaytn]: "https://rpc.ankr.com/klaytn",
  [ee.klaytnTestnet]: "https://rpc.ankr.com/klaytn_testnet",
  [ee.core]: "https://rpc.coredao.org",
  [ee.coreTestnet]: "https://rpc.test.btcs.network",
  [ee.mode]: "https://mode.drpc.org",
  [ee.modeTestnet]: "https://sepolia.mode.network",
  [ee.xlayer]: "https://rpc.xlayer.tech",
  [ee.xlayerTestnet]: "https://testrpc.xlayer.tech",
  [ee.fluentDevnet]: "https://rpc.dev.thefluent.xyz/",
  [ee.zircuitMainnet]: "https://zircuit-mainnet.drpc.org",
  [ee.zircuitTestnet]: "https://zircuit1.p2pify.com/",
  [ee.flowPreviewnet]: "https://previewnet.evm.nodes.onflow.org",
  [ee.flowTestnet]: "https://testnet.evm.nodes.onflow.org",
  [ee.flow]: "https://mainnet.evm.nodes.onflow.org",
  [ee.incentivDevnet]: "https://rpc.ankr.com/incentiv_devnet",
  [ee.incentivTestnet]: "https://rpc.ankr.com/incentiv_testnet",
  [ee.bitlayer]: "https://rpc.ankr.com/bitlayer",
  [ee.bitlayerTestnet]: "https://rpc.ankr.com/bitlayer_testnet",
  [ee.berachain]: "https://artio.rpc.berachain.com",
  [ee.berachainTestnet]: "https://bartio.rpc.berachain.com",
  [ee.fraxtal]: "https://rpc.frax.com",
  [ee.fraxtalTestnet]: "https://rpc.testnet.frax.com",
  [ee.corn]: "https://maizenet-rpc.usecorn.com",
  [ee.cornTestnet]: "https://rpc.ankr.com/corn_testnet",
  [ee.swell]: "https://rpc.ankr.com/swell",
  [ee.swellTestnet]: "https://rpc.ankr.com/swell_sepolia"
}, WP = {
  [Se.ethMainnet]: ee.mainnet,
  [Se.ethGoerli]: ee.goerli,
  [Se.ethSepolia]: ee.sepolia,
  [Se.ethHolesky]: ee.holesky,
  [Se.arbitrum]: ee.arbitrum,
  [Se.arbitrumTestnet]: ee.arbitrumTestnet,
  [Se.arbitrumSepoliaTestnet]: ee.arbitrumSepoliaTestnet,
  [Se.arbitrumNova]: ee.arbitrumNova,
  [Se.avalancheChain]: ee.avalanche,
  [Se.avalancheChainTest]: ee.avalancheTestnet,
  [Se.binanceChain]: ee.smartchain,
  [Se.binanceChainTest]: ee.smartchainTestnet,
  [Se.ftmOpera]: ee.fantom,
  [Se.ftmTestnet]: ee.fantomTestnet,
  [Se.mumbai]: ee.mumbai,
  [Se.polygon]: ee.polygon,
  [Se.polygonZkEVM]: ee.polygonZkEVM,
  [Se.polygonZkEVMTestnet]: ee.polygonZkEVMTestnet,
  [Se.gnosis]: ee.gnosis,
  [Se.chiado]: ee.chiado,
  [Se.sokol]: ee.sokol,
  [Se.xdc]: ee.xdc,
  [Se.xdcTestnet]: ee.xdcTestnet,
  [Se.optimism]: ee.optimism,
  [Se.optimismTestnet]: ee.optimismTestnet,
  [Se.optimismSepolia]: ee.optimismSepolia,
  [Se.linea]: ee.linea,
  [Se.lineaTestnet]: ee.lineaTestnet,
  [Se.lineaSepolia]: ee.lineaSepolia,
  [Se.opBNB]: ee.opBNB,
  [Se.opBNBTestnet]: ee.opBNBTestnet,
  [Se.tron]: ee.tron,
  [Se.base]: ee.base,
  [Se.baseTestnet]: ee.baseTestnet,
  [Se.mantle]: ee.mantle,
  [Se.mantleGoerli]: ee.mantleGoerli,
  [Se.mantleSepolia]: ee.mantleSepolia,
  [Se.celo]: ee.celo,
  [Se.blast]: ee.blast,
  [Se.blastTestnet]: ee.blastTestnet,
  [Se.zkSync]: ee.zkSync,
  [Se.zkSyncGoerli]: ee.zkSyncGoerli,
  [Se.zkSyncSepolia]: ee.zkSyncSepolia,
  [Se.moonbeam]: ee.moonbeam,
  [Se.taikoTestnet]: ee.taikoTestnet,
  [Se.nervos]: ee.nervos,
  [Se.tenet]: ee.tenet,
  [Se.rollux]: ee.rollux,
  [Se.rolluxTestnet]: ee.rolluxTestnet,
  [Se.chiliz]: ee.chiliz,
  [Se.flare]: ee.flare,
  [Se.horizenEON]: ee.horizenEON,
  [Se.horizenEONTestnet]: ee.horizenEONTestnet,
  [Se.syscoin]: ee.syscoin,
  [Se.bitTorrent]: ee.bitTorrent,
  [Se.kava]: ee.kava,
  [Se.iotex]: ee.iotex,
  [Se.harmony]: ee.harmony,
  [Se.zetaChainTestnet]: ee.zetaChainTestnet,
  [Se.scroll]: ee.scroll,
  [Se.scrollTestnet]: ee.scrollTestnet,
  [Se.klaytn]: ee.klaytn,
  [Se.klaytnTestnet]: ee.klaytnTestnet,
  [Se.core]: ee.core,
  [Se.coreTestnet]: ee.coreTestnet,
  [Se.mode]: ee.mode,
  [Se.modeTestnet]: ee.modeTestnet,
  [Se.xlayer]: ee.xlayer,
  [Se.xlayerTestnet]: ee.xlayerTestnet,
  [Se.fluentDevnet]: ee.fluentDevnet,
  [Se.zircuitMainnet]: ee.zircuitMainnet,
  [Se.zircuitTestnet]: ee.zircuitTestnet,
  [Se.flowPreviewnet]: ee.flowPreviewnet,
  [Se.flowTestnet]: ee.flowTestnet,
  [Se.flow]: ee.flow,
  [Se.incentivDevnet]: ee.incentivDevnet,
  [Se.incentivTestnet]: ee.incentivTestnet,
  [Se.bitlayer]: ee.bitlayer,
  [Se.bitlayerTestnet]: ee.bitlayerTestnet,
  [Se.berachain]: ee.berachain,
  [Se.berachainTestnet]: ee.berachainTestnet,
  [Se.fraxtal]: ee.fraxtal,
  [Se.fraxtalTestnet]: ee.fraxtalTestnet,
  [Se.corn]: ee.corn,
  [Se.cornTestnet]: ee.cornTestnet,
  [Se.swell]: ee.swell,
  [Se.swellTestnet]: ee.swellTestnet
}, W_ = {
  [Se.ethMainnet]: Re[ee.mainnet],
  [Se.ethGoerli]: Re[ee.goerli],
  [Se.ethHolesky]: Re[ee.holesky],
  [Se.ethSepolia]: Re[ee.sepolia],
  [Se.arbitrum]: Re[ee.arbitrum],
  [Se.arbitrumTestnet]: Re[ee.arbitrumTestnet],
  [Se.arbitrumSepoliaTestnet]: Re[ee.arbitrumSepoliaTestnet],
  [Se.arbitrumNova]: Re[ee.arbitrumNova],
  [Se.avalancheChain]: Re[ee.avalanche],
  [Se.avalancheChainTest]: Re[ee.avalancheTestnet],
  [Se.binanceChain]: Re[ee.smartchain],
  [Se.binanceChainTest]: Re[ee.smartchainTestnet],
  [Se.ftmOpera]: Re[ee.fantom],
  [Se.ftmTestnet]: Re[ee.fantomTestnet],
  [Se.mumbai]: Re[ee.mumbai],
  [Se.polygon]: Re[ee.polygon],
  [Se.polygonZkEVM]: Re[ee.polygonZkEVM],
  [Se.polygonZkEVMTestnet]: Re[ee.polygonZkEVMTestnet],
  [Se.gnosis]: Re[ee.gnosis],
  [Se.chiado]: Re[ee.chiado],
  [Se.sokol]: Re[ee.sokol],
  [Se.xdc]: Re[ee.xdc],
  [Se.xdcTestnet]: Re[ee.xdcTestnet],
  [Se.optimism]: Re[ee.optimism],
  [Se.optimismTestnet]: Re[ee.optimismTestnet],
  [Se.optimismSepolia]: Re[ee.optimismSepolia],
  [Se.linea]: Re[ee.linea],
  [Se.lineaTestnet]: Re[ee.lineaTestnet],
  [Se.lineaSepolia]: Re[ee.lineaSepolia],
  [Se.opBNB]: Re[ee.opBNB],
  [Se.opBNBTestnet]: Re[ee.opBNBTestnet],
  [Se.tron]: Re[ee.tron],
  [Se.base]: Re[ee.base],
  [Se.baseTestnet]: Re[ee.baseTestnet],
  [Se.mantle]: Re[ee.mantle],
  [Se.mantleGoerli]: Re[ee.mantleGoerli],
  [Se.mantleSepolia]: Re[ee.mantleSepolia],
  [Se.celo]: Re[ee.celo],
  [Se.core]: Re[ee.core],
  [Se.coreTestnet]: Re[ee.coreTestnet],
  [Se.blast]: Re[ee.blast],
  [Se.blastTestnet]: Re[ee.blastTestnet],
  [Se.zkSync]: Re[ee.zkSync],
  [Se.zkSyncGoerli]: Re[ee.zkSyncGoerli],
  [Se.zkSyncSepolia]: Re[ee.zkSyncSepolia],
  [Se.moonbeam]: Re[ee.moonbeam],
  [Se.taikoTestnet]: Re[ee.taikoTestnet],
  [Se.nervos]: Re[ee.nervos],
  [Se.tenet]: Re[ee.tenet],
  [Se.rollux]: Re[ee.rollux],
  [Se.rolluxTestnet]: Re[ee.rolluxTestnet],
  [Se.chiliz]: Re[ee.chiliz],
  [Se.flare]: Re[ee.flare],
  [Se.horizenEON]: Re[ee.horizenEON],
  [Se.horizenEONTestnet]: Re[ee.horizenEONTestnet],
  [Se.syscoin]: Re[ee.syscoin],
  [Se.bitTorrent]: Re[ee.bitTorrent],
  [Se.kava]: Re[ee.kava],
  [Se.iotex]: Re[ee.iotex],
  [Se.harmony]: Re[ee.harmony],
  [Se.zetaChainTestnet]: Re[ee.zetaChainTestnet],
  [Se.scroll]: Re[ee.scroll],
  [Se.scrollTestnet]: Re[ee.scrollTestnet],
  [Se.klaytn]: Re[ee.klaytn],
  [Se.klaytnTestnet]: Re[ee.klaytnTestnet],
  [Se.mode]: Re[ee.mode],
  [Se.modeTestnet]: Re[ee.modeTestnet],
  [Se.xlayer]: Re[ee.xlayer],
  [Se.xlayerTestnet]: Re[ee.xlayerTestnet],
  [Se.fluentDevnet]: Re[ee.fluentDevnet],
  [Se.zircuitMainnet]: Re[ee.zircuitMainnet],
  [Se.zircuitTestnet]: Re[ee.zircuitTestnet],
  [Se.flowPreviewnet]: Re[ee.flowPreviewnet],
  [Se.flowTestnet]: Re[ee.flowTestnet],
  [Se.flow]: Re[ee.flow],
  [Se.incentivDevnet]: Re[ee.incentivDevnet],
  [Se.incentivTestnet]: Re[ee.incentivTestnet],
  [Se.bitlayer]: Re[ee.bitlayer],
  [Se.bitlayerTestnet]: Re[ee.bitlayerTestnet],
  [Se.berachain]: Re[ee.berachain],
  [Se.berachainTestnet]: Re[ee.berachainTestnet],
  [Se.fraxtal]: Re[ee.fraxtal],
  [Se.fraxtalTestnet]: Re[ee.fraxtalTestnet],
  [Se.corn]: Re[ee.corn],
  [Se.cornTestnet]: Re[ee.cornTestnet],
  [Se.swell]: Re[ee.swell],
  [Se.swellTestnet]: Re[ee.swellTestnet]
}, VP = "8632f6ad3de177c2e04ba5248e27a743", wt = 18, Zy = {
  [ee.mainnet]: {
    chainId: ht(ee.mainnet),
    chainName: "Mainnet",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.mainnet]],
    blockExplorerUrls: ["https://etherscan.io"]
  },
  [ee.goerli]: {
    chainId: ht(ee.goerli),
    chainName: "Goerli Test Network",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.goerli]],
    blockExplorerUrls: [
      "https://goerli.etherscan.io/",
      "https://blockscout.com/eth/goerli "
    ]
  },
  [ee.sepolia]: {
    chainId: ht(ee.sepolia),
    chainName: "Sepolia Test Network",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.sepolia]],
    blockExplorerUrls: ["https://sepolia.etherscan.io/"]
  },
  [ee.holesky]: {
    chainId: ht(ee.holesky),
    chainName: "Holesky Test Network",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.holesky]],
    blockExplorerUrls: ["https://holesky.etherscan.io/"]
  },
  [ee.smartchain]: {
    chainId: ht(ee.smartchain),
    chainName: "Binance Smart Chain",
    nativeCurrency: {
      name: "BNB",
      symbol: "BNB",
      decimals: wt
    },
    rpcUrls: [Re[ee.smartchain]],
    blockExplorerUrls: ["https://bscscan.com"]
  },
  [ee.smartchainTestnet]: {
    chainId: ht(ee.smartchainTestnet),
    chainName: "Binance Smart Chain - Testnet",
    nativeCurrency: {
      name: "BNB",
      symbol: "BNB",
      decimals: wt
    },
    rpcUrls: [Re[ee.smartchainTestnet]],
    blockExplorerUrls: ["https://testnet.bscscan.com"]
  },
  [ee.arbitrum]: {
    chainId: ht(ee.arbitrum),
    chainName: "Arbitrum One",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.arbitrum]],
    blockExplorerUrls: ["https://arbiscan.io/"]
  },
  [ee.arbitrumTestnet]: {
    chainId: ht(ee.arbitrumTestnet),
    chainName: "Arbitrum Goerli",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.arbitrumTestnet]],
    blockExplorerUrls: ["https://goerli.arbiscan.io/"]
  },
  [ee.arbitrumSepoliaTestnet]: {
    chainId: ht(ee.arbitrumSepoliaTestnet),
    chainName: "Arbitrum Sepolia",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.arbitrumSepoliaTestnet]],
    blockExplorerUrls: ["https://sepolia.arbiscan.io/"]
  },
  [ee.arbitrumNova]: {
    chainId: ht(ee.arbitrumNova),
    chainName: "Arbitrum Nova",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.arbitrumNova]],
    blockExplorerUrls: ["https://nova.arbiscan.io/"]
  },
  [ee.avalanche]: {
    chainId: ht(ee.avalanche),
    chainName: "Avalanche Mainnet C-Chain",
    nativeCurrency: {
      name: "AVAX",
      symbol: "AVAX",
      decimals: wt
    },
    rpcUrls: [Re[ee.avalanche]],
    blockExplorerUrls: ["https://snowtrace.io/"]
  },
  [ee.avalancheTestnet]: {
    chainId: ht(ee.avalancheTestnet),
    chainName: "Avalanche FUJI C-Chain",
    nativeCurrency: {
      name: "AVAX",
      symbol: "AVAX",
      decimals: wt
    },
    rpcUrls: [Re[ee.avalancheTestnet]],
    blockExplorerUrls: ["https://testnet.snowtrace.io/"]
  },
  [ee.fantom]: {
    chainId: ht(ee.fantom),
    chainName: "Fantom Opera",
    nativeCurrency: {
      name: "FTM",
      symbol: "FTM",
      decimals: wt
    },
    rpcUrls: [Re[ee.fantom]],
    blockExplorerUrls: ["https://ftmscan.com/"]
  },
  [ee.fantomTestnet]: {
    chainId: ht(ee.fantomTestnet),
    chainName: "Fantom testnet",
    nativeCurrency: {
      name: "FTM",
      symbol: "FTM",
      decimals: wt
    },
    rpcUrls: [Re[ee.fantomTestnet]],
    blockExplorerUrls: ["https://testnet.ftmscan.com/"]
  },
  [ee.polygon]: {
    chainId: ht(ee.polygon),
    chainName: "Polygon Mainnet",
    nativeCurrency: {
      name: "MATIC",
      symbol: "MATIC",
      decimals: wt
    },
    rpcUrls: [Re[ee.polygon]],
    blockExplorerUrls: ["https://polygonscan.com"]
  },
  [ee.mumbai]: {
    chainId: ht(ee.mumbai),
    chainName: "Polygon testnet",
    nativeCurrency: {
      name: "MATIC",
      symbol: "MATIC",
      decimals: wt
    },
    rpcUrls: [Re[ee.mumbai]],
    blockExplorerUrls: ["https://mumbai.polygonscan.com"]
  },
  [ee.polygonZkEVM]: {
    chainId: ht(ee.polygonZkEVM),
    chainName: "Polygon zkEVM",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.polygonZkEVM]],
    blockExplorerUrls: ["https://zkevm.polygonscan.com/"]
  },
  [ee.polygonZkEVMTestnet]: {
    chainId: ht(ee.polygonZkEVMTestnet),
    chainName: "zkEVM Testnet",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.polygonZkEVMTestnet]],
    blockExplorerUrls: ["https://testnet-zkevm.polygonscan.com"]
  },
  [ee.gnosis]: {
    chainId: ht(ee.gnosis),
    chainName: "Gnosis",
    nativeCurrency: {
      name: "xDai",
      symbol: "xDai",
      decimals: wt
    },
    rpcUrls: [Re[ee.gnosis]],
    blockExplorerUrls: ["https://blockscout.com/xdai/mainnet/"]
  },
  [ee.chiado]: {
    chainId: ht(ee.chiado),
    chainName: "Chiado",
    nativeCurrency: {
      name: "SPOA",
      symbol: "SPOA",
      decimals: wt
    },
    rpcUrls: [Re[ee.chiado]],
    blockExplorerUrls: ["https://blockscout.com/gnosis/chiado"]
  },
  [ee.sokol]: {
    chainId: ht(ee.sokol),
    chainName: "Sokol",
    nativeCurrency: {
      name: "SPOA",
      symbol: "SPOA",
      decimals: wt
    },
    rpcUrls: [Re[ee.sokol]],
    blockExplorerUrls: ["https://blockscout.com/poa/sokol/"]
  },
  [ee.xdc]: {
    chainId: ht(ee.xdc),
    chainName: "XDC Mainnet",
    nativeCurrency: {
      name: "XDC",
      symbol: "XDC",
      decimals: wt
    },
    rpcUrls: [Re[ee.xdc]],
    blockExplorerUrls: ["https://explorer.xinfin.network/"]
  },
  [ee.xdcTestnet]: {
    chainId: ht(ee.xdcTestnet),
    chainName: "XDC Apothem Testnet",
    nativeCurrency: {
      name: "TXDC",
      symbol: "TXDC",
      decimals: wt
    },
    rpcUrls: [Re[ee.xdcTestnet]],
    blockExplorerUrls: ["https://explorer.apothem.network/"]
  },
  [ee.optimism]: {
    chainId: ht(ee.optimism),
    chainName: "OP Mainnet",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.optimism]],
    blockExplorerUrls: ["https://optimistic.etherscan.io"]
  },
  [ee.optimismTestnet]: {
    chainId: ht(ee.optimismTestnet),
    chainName: "OP Testnet",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.optimismTestnet]],
    blockExplorerUrls: ["https://goerli-optimism.etherscan.io"]
  },
  [ee.optimismSepolia]: {
    chainId: ht(ee.optimismSepolia),
    chainName: "OP Testnet",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.optimismSepolia]],
    blockExplorerUrls: ["https://sepolia-optimism.etherscan.io/"]
  },
  [ee.linea]: {
    chainId: ht(ee.linea),
    chainName: "Linea Mainnet",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.linea]],
    blockExplorerUrls: ["https://lineascan.build"]
  },
  [ee.lineaTestnet]: {
    chainId: ht(ee.lineaTestnet),
    chainName: "Linea Goerli Testnet",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.lineaTestnet]],
    blockExplorerUrls: ["https://goerli.lineascan.build"]
  },
  [ee.lineaSepolia]: {
    chainId: ht(ee.lineaSepolia),
    chainName: "Linea Sepolia Testnet",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.lineaSepolia]],
    blockExplorerUrls: ["https://sepolia.lineascan.build/"]
  },
  [ee.opBNB]: {
    chainId: ht(ee.opBNB),
    chainName: "opBNB Mainnet",
    nativeCurrency: {
      name: "BNB",
      symbol: "BNB",
      decimals: wt
    },
    rpcUrls: [Re[ee.opBNB]],
    blockExplorerUrls: ["https://opbnbscan.com"]
  },
  [ee.opBNBTestnet]: {
    chainId: ht(ee.opBNBTestnet),
    chainName: "opBNB Mainnet",
    nativeCurrency: {
      name: "tBNB",
      symbol: "tBNB",
      decimals: wt
    },
    rpcUrls: [Re[ee.opBNBTestnet]],
    blockExplorerUrls: ["https://testnet.opbnbscan.com"]
  },
  [ee.mode]: {
    chainId: ht(ee.mode),
    chainName: "Mode",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.mode]],
    blockExplorerUrls: ["https://modescan.io"]
  },
  [ee.modeTestnet]: {
    chainId: ht(ee.modeTestnet),
    chainName: "Mode Testnet",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.modeTestnet]],
    blockExplorerUrls: ["https://testnet.modescan.io"]
  },
  [ee.blast]: {
    chainId: ht(ee.blast),
    chainName: "Blast",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.blast]],
    blockExplorerUrls: ["https://blastscan.io"]
  },
  [ee.blastTestnet]: {
    chainId: ht(ee.blastTestnet),
    chainName: "Blast Testnet",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.blastTestnet]],
    blockExplorerUrls: ["https://sepolia.blastscan.io"]
  },
  [ee.scroll]: {
    chainId: ht(ee.scroll),
    chainName: "Scroll",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.scroll]],
    blockExplorerUrls: ["https://scrollscan.com"]
  },
  [ee.scrollTestnet]: {
    chainId: ht(ee.scrollTestnet),
    chainName: "Scroll Testnet",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.scrollTestnet]],
    blockExplorerUrls: ["https://sepolia.scrollscan.com"]
  },
  [ee.core]: {
    chainId: ht(ee.core),
    chainName: "Core Blockchain Mainnet",
    nativeCurrency: {
      name: "CORE",
      symbol: "CORE",
      decimals: wt
    },
    rpcUrls: [Re[ee.core]],
    blockExplorerUrls: ["https://scan.coredao.org"]
  },
  [ee.coreTestnet]: {
    chainId: ht(ee.coreTestnet),
    chainName: "Core Blockchain Testnet",
    nativeCurrency: {
      name: "tCORE",
      symbol: "tCORE",
      decimals: wt
    },
    rpcUrls: [Re[ee.coreTestnet]],
    blockExplorerUrls: ["https://scan.test.btcs.network"]
  },
  [ee.mantleSepolia]: {
    chainId: ht(ee.mantleSepolia),
    chainName: "Mantle Testnet",
    nativeCurrency: {
      name: "MNT",
      symbol: "MNT",
      decimals: wt
    },
    rpcUrls: [Re[ee.mantleSepolia]],
    blockExplorerUrls: ["https://explorer-v2.sepolia.mantle.xyz"]
  },
  [ee.mantle]: {
    chainId: ht(ee.mantle),
    chainName: "Mantle",
    nativeCurrency: {
      name: "MNT",
      symbol: "MNT",
      decimals: wt
    },
    rpcUrls: [Re[ee.mantle]],
    blockExplorerUrls: ["https://explorer.mantle.xyz"]
  },
  [ee.baseTestnet]: {
    chainId: ht(ee.baseTestnet),
    chainName: "Base Testnet",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.baseTestnet]],
    blockExplorerUrls: ["https://sepolia.basescan.org"]
  },
  [ee.base]: {
    chainId: ht(ee.base),
    chainName: "Base",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.base]],
    blockExplorerUrls: ["https://basescan.org"]
  },
  [ee.xlayer]: {
    chainId: ht(ee.xlayer),
    chainName: "X Layer",
    nativeCurrency: {
      name: "OKB",
      symbol: "OKB",
      decimals: wt
    },
    rpcUrls: [Re[ee.xlayer]],
    blockExplorerUrls: ["https://www.oklink.com/xlayer"]
  },
  [ee.xlayerTestnet]: {
    chainId: ht(ee.xlayerTestnet),
    chainName: "X Layer Testnet",
    nativeCurrency: {
      name: "OKB",
      symbol: "OKB",
      decimals: wt
    },
    rpcUrls: [Re[ee.xlayerTestnet]],
    blockExplorerUrls: ["https://www.oklink.com/xlayer-test"]
  },
  [ee.fluentDevnet]: {
    chainId: ht(ee.fluentDevnet),
    chainName: "Fluent Devnet",
    nativeCurrency: {
      name: "Ethereum",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.fluentDevnet]],
    blockExplorerUrls: ["https://blockscout.dev.fluentlabs.xyz/"]
  },
  [ee.zircuitMainnet]: {
    chainId: ht(ee.zircuitMainnet),
    chainName: "Zircuit",
    nativeCurrency: {
      name: "Ethereum",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.zircuitMainnet]],
    blockExplorerUrls: ["https://explorer.zircuit.com/"]
  },
  [ee.zircuitTestnet]: {
    chainId: ht(ee.zircuitTestnet),
    chainName: "Zircuit Testnet",
    nativeCurrency: {
      name: "Ethereum",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.zircuitTestnet]],
    blockExplorerUrls: ["https://explorer.testnet.zircuit.com/"]
  },
  [ee.flowPreviewnet]: {
    chainId: ht(ee.flowPreviewnet),
    chainName: "Flow Previewnet",
    nativeCurrency: {
      name: "FLOW",
      symbol: "FLOW",
      decimals: wt
    },
    rpcUrls: [Re[ee.flowPreviewnet]],
    blockExplorerUrls: ["https://previewnet.flowdiver.io/"]
  },
  [ee.flowTestnet]: {
    chainId: ht(ee.flowTestnet),
    chainName: "Flow Testnet",
    nativeCurrency: {
      name: "FLOW",
      symbol: "FLOW",
      decimals: wt
    },
    rpcUrls: [Re[ee.flowTestnet]],
    blockExplorerUrls: ["https://evm-testnet.flowscan.io/"]
  },
  [ee.flow]: {
    chainId: ht(ee.flow),
    chainName: "Flow",
    nativeCurrency: {
      name: "FLOW",
      symbol: "FLOW",
      decimals: wt
    },
    rpcUrls: [Re[ee.flow]],
    blockExplorerUrls: ["https://evm.flowscan.io/"]
  },
  [ee.incentivDevnet]: {
    chainId: ht(ee.incentivDevnet),
    chainName: "Incentiv Devnet",
    nativeCurrency: {
      name: "INC",
      symbol: "INC",
      decimals: wt
    },
    rpcUrls: [Re[ee.incentivDevnet]]
  },
  [ee.incentivTestnet]: {
    chainId: ht(ee.incentivTestnet),
    chainName: "Incentiv Testnet",
    nativeCurrency: {
      name: "INC",
      symbol: "INC",
      decimals: wt
    },
    rpcUrls: [Re[ee.incentivTestnet]]
  },
  [ee.bitlayer]: {
    chainId: ht(ee.bitlayer),
    chainName: "Bitlayer",
    nativeCurrency: {
      name: "BTC",
      symbol: "BTC",
      decimals: wt
    },
    rpcUrls: [Re[ee.bitlayer]],
    blockExplorerUrls: ["https://www.btrscan.com/"]
  },
  [ee.bitlayerTestnet]: {
    chainId: ht(ee.bitlayerTestnet),
    chainName: "Bitlayer Testnet",
    nativeCurrency: {
      name: "BTC",
      symbol: "BTC",
      decimals: wt
    },
    rpcUrls: [Re[ee.bitlayerTestnet]],
    blockExplorerUrls: ["https://testnet.btrscan.com/"]
  },
  [ee.berachain]: {
    chainId: ht(ee.berachain),
    chainName: "Berachain",
    nativeCurrency: {
      name: "BERA",
      symbol: "BERA",
      decimals: wt
    },
    rpcUrls: [Re[ee.berachain]],
    blockExplorerUrls: ["https://artio.beratrail.io/"]
  },
  [ee.berachainTestnet]: {
    chainId: ht(ee.berachainTestnet),
    chainName: "Berachain Testnet",
    nativeCurrency: {
      name: "BERA",
      symbol: "BERA",
      decimals: wt
    },
    rpcUrls: [Re[ee.berachainTestnet]],
    blockExplorerUrls: ["https://bartio.beratrail.io/"]
  },
  [ee.fraxtal]: {
    chainId: ht(ee.fraxtal),
    chainName: "Fraxtal",
    nativeCurrency: {
      name: "frxETH",
      symbol: "frxETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.fraxtal]],
    blockExplorerUrls: ["https://fraxscan.com/"]
  },
  [ee.fraxtalTestnet]: {
    chainId: ht(ee.fraxtalTestnet),
    chainName: "Fraxtal Testnet",
    nativeCurrency: {
      name: "frxETH",
      symbol: "frxETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.fraxtalTestnet]],
    blockExplorerUrls: ["https://holesky.fraxscan.com/"]
  },
  [ee.corn]: {
    chainId: ht(ee.corn),
    chainName: "Corn",
    nativeCurrency: {
      name: "BTCN",
      symbol: "BTCN",
      decimals: wt
    },
    rpcUrls: [Re[ee.corn]],
    blockExplorerUrls: ["https://cornscan.io"]
  },
  [ee.cornTestnet]: {
    chainId: ht(ee.cornTestnet),
    chainName: "Corn Testnet",
    nativeCurrency: {
      name: "BTCN",
      symbol: "BTCN",
      decimals: wt
    },
    rpcUrls: [Re[ee.cornTestnet]],
    blockExplorerUrls: ["https://testnet.cornscan.io"]
  },
  [ee.swell]: {
    chainId: ht(ee.swell),
    chainName: "Swell",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.swell]],
    blockExplorerUrls: ["https://explorer.swellnetwork.io"]
  },
  [ee.swellTestnet]: {
    chainId: ht(ee.swellTestnet),
    chainName: "Swell Testnet",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: wt
    },
    rpcUrls: [Re[ee.swellTestnet]],
    blockExplorerUrls: ["https://swell-testnet-explorer.alt.technology"]
  }
}, GP = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjQ1NDQgMjguNDg5MkwzMS45OTkyIDE5Ljk0NDdMNDAuNTQ4NSAyOC40OTM3TDQ1LjUyMDQgMjMuNTIxOEwzMS45OTkyIDEwLjAwMDFMMTguNDgyNCAyMy41MTcyTDIzLjQ1NDQgMjguNDg5MloiIGZpbGw9IiNGM0JBMkYiLz4KPHBhdGggZD0iTTE5Ljk0NCAzMS45OTkzTDE0Ljk3MjIgMjcuMDI3NUwxMC4wMDAxIDMxLjk5OTZMMTQuOTcxOSAzNi45NzE1TDE5Ljk0NCAzMS45OTkzWiIgZmlsbD0iI0YzQkEyRiIvPgo8cGF0aCBkPSJNMjMuNDU0MyAzNS41MTA4TDMxLjk5OTEgNDQuMDU1M0w0MC41NDgxIDM1LjUwNjZMNDUuNTIyOCA0MC40NzU4TDQ1LjUyMDQgNDAuNDc4NkwzMS45OTkxIDUzLjk5OTlMMTguNDgyIDQwLjQ4MzFMMTguNDc1MSA0MC40NzYyTDIzLjQ1NDMgMzUuNTEwOFoiIGZpbGw9IiNGM0JBMkYiLz4KPHBhdGggZD0iTTQ5LjAyNzkgMzYuOTczOEw1NCAzMi4wMDE3TDQ5LjAyODEgMjcuMDI5OEw0NC4wNTYgMzIuMDAxOUw0OS4wMjc5IDM2Ljk3MzhaIiBmaWxsPSIjRjNCQTJGIi8+CjxwYXRoIGQ9Ik0zNy4wNDIxIDMxLjk5NzRIMzcuMDQ0MkwzMS45OTg5IDI2Ljk1MjFMMjguMjcwNCAzMC42ODA2SDI4LjI3TDI3Ljg0MTkgMzEuMTA5MUwyNi45NTgxIDMxLjk5MjlMMjYuOTUxMiAzMS45OTk4TDI2Ljk1ODEgMzIuMDA3MUwzMS45OTg5IDM3LjA0NzlMMzcuMDQ0MiAzMi4wMDI2TDM3LjA0NjYgMzEuOTk5OEwzNy4wNDIxIDMxLjk5NzRaIiBmaWxsPSIjRjNCQTJGIi8+Cjwvc3ZnPgo=", KP = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAzMyAzMiI+CiAgPHBhdGggZmlsbD0idXJsKCNncnF3cikiIGQ9Ik0yNC4zNDYgMEg3LjY4OEMzLjQ0MiAwIDAgMy40MzggMCA3LjY4djE2LjY0QzAgMjguNTYxIDMuNDQyIDMyIDcuNjg4IDMyaDE2LjY1OGM0LjI0NiAwIDcuNjg4LTMuNDM5IDcuNjg4LTcuNjhWNy42OGMwLTQuMjQyLTMuNDQyLTcuNjgtNy42ODgtNy42OFoiLz4KICA8cGF0aCBmaWxsPSIjMEMwQjBCIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi4wMTcgMjYuMjRjNS42NiAwIDEwLjI1LTQuNTg1IDEwLjI1LTEwLjI0IDAtNS42NTYtNC41OS0xMC4yNC0xMC4yNS0xMC4yNC01LjY2MiAwLTEwLjI1MSA0LjU4NC0xMC4yNTEgMTAuMjQgMCA1LjY1NSA0LjU5IDEwLjI0IDEwLjI1IDEwLjI0Wm0tMS44MS0xNS4xMjhjMC0uMjk1LjI0LS41MzMuNTM0LS41MzNoMi41NTFjLjI5NCAwIC41MzMuMjM4LjUzMy41MzN2My4xMTloLTMuNjE3djMuNTM4aDMuNjE3djMuMTE5YS41MzMuNTMzIDAgMCAxLS41MzMuNTMzaC0yLjU1MWEuNTMzLjUzMyAwIDAgMS0uNTM0LS41MzR2LTMuMDA0aC0zLjA4NGEuNTMzLjUzMyAwIDAgMS0uNTMzLS41MzR2LTIuNTg1YzAtLjI5NC4yMzktLjUzMy41MzMtLjUzM2gzLjA4NXYtMy4xMTlabTMuNjE4IDMuMTE5aDMuMDg2Yy4yOTQgMCAuNTMzLjIzOS41MzMuNTMzdjIuNTg1YS41MzMuNTMzIDAgMCAxLS41MzMuNTM0aC0zLjA4NVYxNC4yM1oiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPgogIDxkZWZzPgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJncnF3ciIgeDE9IjIuNjY3IiB4Mj0iMzAuNjM4IiB5MT0iMjkuMzMzIiB5Mj0iMS45NyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjQkRGREUyIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzlCREFGNiIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+Cjwvc3ZnPg==", YP = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA0MC43IDQwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0MC43IDQwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0Q5QjQzMjt9Cjwvc3R5bGU+CjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0zMy4zLDBINy40QzMuMywwLDAsMy4zLDAsNy4zdjI1LjRDMCwzNi43LDMuMyw0MCw3LjQsNDBoMjUuOWM0LjEsMCw3LjQtMy4zLDcuNC03LjNWNy4zCglDNDAuNywzLjMsMzcuNCwwLDMzLjMsMEwzMy4zLDB6IE0yNywxMGMzLDAsNS41LDIuNCw1LjUsNS40YzAsMC45LTAuMiwxLjgtMC42LDIuNmMtMC43LTAuNS0xLjUtMS0yLjMtMS4zYzAuMi0wLjQsMC4zLTAuOSwwLjMtMS4zCgljMC0xLjUtMS4zLTIuOC0yLjgtMi44Yy0xLjYsMC0yLjgsMS4zLTIuOCwyLjhjMCwwLjUsMC4xLDAuOSwwLjMsMS4zYy0wLjgsMC4zLTEuNiwwLjctMi4zLDEuM2MtMC41LTAuOC0wLjYtMS43LTAuNi0yLjYKCUMyMS42LDEyLjQsMjQsMTAsMjcsMTB6IE0xMy43LDMwYy0zLDAtNS41LTIuNC01LjUtNS40aDIuNmMwLDEuNSwxLjMsMi44LDIuOCwyLjhzMi44LTEuMywyLjgtMi44aDIuNkMxOS4yLDI3LjYsMTYuNywzMCwxMy43LDMwCglMMTMuNywzMHogTTEzLjcsMjIuNWMtMy41LDAtNi4zLTIuOC02LjMtNi4yYzAtMy40LDIuOC02LjMsNi4zLTYuM3M2LjQsMi44LDYuNCw2LjNDMjAuMSwxOS43LDE3LjIsMjIuNSwxMy43LDIyLjVMMTMuNywyMi41egoJIE0yNywzMGMtMy41LDAtNi40LTIuOC02LjQtNi4yYzAtMy41LDIuOC02LjMsNi40LTYuM2MzLjUsMCw2LjMsMi44LDYuMyw2LjNDMzMuNCwyNy4yLDMwLjUsMzAsMjcsMzBMMjcsMzB6IE0zMC44LDIzLjcKCWMwLDIuMS0xLjcsMy43LTMuOCwzLjdzLTMuOC0xLjctMy44LTMuN2MwLTIuMSwxLjctMy43LDMuOC0zLjdDMjkuMSwyMC4xLDMwLjgsMjEuNywzMC44LDIzLjd6IE0xNy40LDE2LjNjMCwyLjEtMS43LDMuNy0zLjgsMy43CgljLTIuMSwwLTMuOC0xLjctMy44LTMuN2MwLTIuMSwxLjctMy43LDMuOC0zLjdDMTUuOCwxMi42LDE3LjQsMTQuMiwxNy40LDE2LjNMMTcuNCwxNi4zeiIvPgo8L3N2Zz4K", QP = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBoZWlnaHQ9IjY0IiB3aWR0aD0iNjQiPgogIDxwYXRoIGZpbGw9IiMwMDUyRkYiIGQ9Ik0xMCA1MGMwIDIyLjA5MSAxNy45MDkgNDAgNDAgNDBzNDAtMTcuOTA5IDQwLTQwLTE3LjkwOS00MC00MC00MC00MCAxNy45MDktNDAgNDBaIi8+CiAgPHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMjEuODc1IDUwYzAgMTUuNTMzIDEyLjU5MiAyOC4xMjUgMjguMTI1IDI4LjEyNVM3OC4xMjUgNjUuNTMzIDc4LjEyNSA1MCA2NS41MzMgMjEuODc1IDUwIDIxLjg3NSAyMS44NzUgMzQuNDY3IDIxLjg3NSA1MFptMjAuOTM4LTkuMDYzYy0xLjAzNiAwLTEuODc2Ljg0LTEuODc2IDEuODc2djE0LjM3NGMwIDEuMDM2Ljg0IDEuODc2IDEuODc2IDEuODc2aDE0LjM3NGMxLjAzNiAwIDEuODc2LS44NCAxLjg3Ni0xLjg3NlY0Mi44MTNjMC0xLjAzNi0uODQtMS44NzYtMS44NzYtMS44NzZINDIuODEzWiIgY2xpcC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo=", ZP = "data:image/svg+xml;base64,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", JP = "data:image/svg+xml;base64,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", XP = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMzU1IiB2aWV3Qm94PSIwIDAgMzk3IDM1NSIgd2lkdGg9IjM5NyI+Cgk8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xIC0xKSI+CgkJPHBhdGggZD0ibTExNC42MjI2NDQgMzI3LjE5NTQ3MiA1Mi4wMDQ3MTcgMTMuODEwMTk4di0xOC4wNTk0OWw0LjI0NTI4My00LjI0OTI5MmgyOS43MTY5ODJ2MjEuMjQ2NDU5IDE0Ljg3MjUyM2gtMzEuODM5NjI0bC0zOS4yNjg4NjgtMTYuOTk3MTY5eiIgZmlsbD0iI2NkYmRiMiIvPgoJCTxwYXRoIGQ9Im0xOTkuNTI4MzA1IDMyNy4xOTU0NzIgNTAuOTQzMzk3IDEzLjgxMDE5OHYtMTguMDU5NDlsNC4yNDUyODMtNC4yNDkyOTJoMjkuNzE2OTgxdjIxLjI0NjQ1OSAxNC44NzI1MjNoLTMxLjgzOTYyM2wtMzkuMjY4ODY4LTE2Ljk5NzE2OXoiIGZpbGw9IiNjZGJkYjIiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDQ4My45NjIyNyAwKSIvPgoJCTxwYXRoIGQ9Im0xNzAuODcyNjQ0IDI4Ny44ODk1MjMtNC4yNDUyODMgMzUuMDU2NjU3IDUuMzA2NjA0LTQuMjQ5MjkyaDU1LjE4ODY4bDYuMzY3OTI1IDQuMjQ5MjkyLTQuMjQ1Mjg0LTM1LjA1NjY1Ny04LjQ5MDU2NS01LjMxMTYxNS00Mi40NTI4MzIgMS4wNjIzMjN6IiBmaWxsPSIjMzkzOTM5Ii8+PHBhdGggZD0ibTE0Mi4yMTY5ODQgNTAuOTkxNTAyMiAyNS40NzE2OTggNTkuNDkwMDg1OCAxMS42NzQ1MjggMTczLjE1ODY0M2g0MS4zOTE1MTFsMTIuNzM1ODQ5LTE3My4xNTg2NDMgMjMuMzQ5MDU2LTU5LjQ5MDA4NTh6IiBmaWxsPSIjZjg5YzM1Ii8+CgkJPHBhdGggZD0ibTMwLjc3ODMwMjMgMTgxLjY1NzIyNi0yOS43MTY5ODE1MyA4Ni4wNDgxNjEgNzQuMjkyNDUzOTMtNC4yNDkyOTNoNDcuNzU5NDM0M3YtMzcuMTgxMzAzbC0yLjEyMjY0MS03Ni40ODcyNTMtMTAuNjEzMjA4IDguNDk4NTgzeiIgZmlsbD0iI2Y4OWQzNSIvPgoJCTxwYXRoIGQ9Im04Ny4wMjgzMDMyIDE5MS4yMTgxMzQgODcuMDI4MzAyOCAyLjEyNDY0Ni05LjU1MTg4NiA0NC42MTc1NjMtNDEuMzkxNTExLTEwLjYyMzIyOXoiIGZpbGw9IiNkODdjMzAiLz4KCQk8cGF0aCBkPSJtODcuMDI4MzAzMiAxOTIuMjgwNDU3IDM2LjA4NDkwNTggMzMuOTk0MzM0djMzLjk5NDMzNHoiIGZpbGw9IiNlYThkM2EiLz4KCQk8cGF0aCBkPSJtMTIzLjExMzIwOSAyMjcuMzM3MTE0IDQyLjQ1MjgzMSAxMC42MjMyMjkgMTMuNzk3MTcgNDUuNjc5ODg4LTkuNTUxODg2IDUuMzExNjE1LTQ2LjY5ODExNS0yNy42MjAzOTh6IiBmaWxsPSIjZjg5ZDM1Ii8+CgkJPHBhdGggZD0ibTEyMy4xMTMyMDkgMjYxLjMzMTQ0OC04LjQ5MDU2NSA2NS44NjQwMjQgNTYuMjUtMzkuMzA1OTQ5eiIgZmlsbD0iI2ViOGYzNSIvPgoJCTxwYXRoIGQ9Im0xNzQuMDU2NjA2IDE5My4zNDI3OCA1LjMwNjYwNCA5MC4yOTc0NTEtMTUuOTE5ODEyLTQ2LjIxMTA0OXoiIGZpbGw9IiNlYThlM2EiLz4KCQk8cGF0aCBkPSJtNzQuMjkyNDUzOSAyNjIuMzkzNzcxIDQ4LjgyMDc1NTEtMS4wNjIzMjMtOC40OTA1NjUgNjUuODY0MDI0eiIgZmlsbD0iI2Q4N2MzMCIvPgoJCTxwYXRoIGQ9Im0yNC40MTAzNzc3IDM1NS44NzgxOTMgOTAuMjEyMjY2My0yOC42ODI3MjEtNDAuMzMwMTkwMS02NC44MDE3MDEtNzMuMjMxMTMzMTMgNS4zMTE2MTZ6IiBmaWxsPSIjZWI4ZjM1Ii8+CgkJPHBhdGggZD0ibTE2Ny42ODg2ODIgMTEwLjQ4MTU4OC00NS42MzY3OTMgMzguMjQzNjI3LTM1LjAyMzU4NTggNDIuNDkyOTE5IDg3LjAyODMwMjggMy4xODY5Njl6IiBmaWxsPSIjZTg4MjFlIi8+CgkJPHBhdGggZD0ibTExNC42MjI2NDQgMzI3LjE5NTQ3MiA1Ni4yNS0zOS4zMDU5NDktNC4yNDUyODMgMzMuOTk0MzM0djE5LjEyMTgxM2wtMzguMjA3NTQ4LTcuNDM2MjZ6IiBmaWxsPSIjZGZjZWMzIi8+CgkJPHBhdGggZD0ibTIyOS4yNDUyODYgMzI3LjE5NTQ3MiA1NS4xODg2OC0zOS4zMDU5NDktNC4yNDUyODMgMzMuOTk0MzM0djE5LjEyMTgxM2wtMzguMjA3NTQ4LTcuNDM2MjZ6IiBmaWxsPSIjZGZjZWMzIiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSA1MTMuNjc5MjUyIDApIi8+CgkJPHBhdGggZD0ibTEzMi42NjUwOTYgMjEyLjQ2NDU5My0xMS42NzQ1MjggMjQuNDMzNDI3IDQxLjM5MTUxLTEwLjYyMzIyOXoiIGZpbGw9IiMzOTM5MzkiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDI4My4zNzI2NDYgMCkiLz4KCQk8cGF0aCBkPSJtMjMuMzQ5MDU3IDEuMDYyMzIyOTYgMTQ0LjMzOTYyNSAxMDkuNDE5MjY1MDQtMjQuNDEwMzc4LTU5LjQ5MDA4NTh6IiBmaWxsPSIjZTg4ZjM1Ii8+PHBhdGggZD0ibTIzLjM0OTA1NyAxLjA2MjMyMjk2LTE5LjEwMzc3MzkyIDU4LjQyNzc2Mjk0IDEwLjYxMzIwNzcyIDYzLjczOTM3ODEtNy40MjkyNDU0MSA0LjI0OTI5MiAxMC42MTMyMDc3MSA5LjU2MDkwNi04LjQ5MDU2NjE3IDcuNDM2MjYxIDExLjY3NDUyODQ3IDEwLjYyMzIyOS03LjQyOTI0NTQgNi4zNzM5MzggMTYuOTgxMTMyMyAyMS4yNDY0NTkgNzkuNTk5MDU3Ny0yNC40MzM0MjhjMzguOTE1MDk2LTMxLjE2MTQ3MyA1OC4wMTg4NjktNDcuMDk2MzE4IDU3LjMxMTMyMi00Ny44MDQ1MzMtLjcwNzU0OC0uNzA4MjE1LTQ4LjgyMDc1Ni0zNy4xODEzMDM2LTE0NC4zMzk2MjUtMTA5LjQxOTI2NTA0eiIgZmlsbD0iIzhlNWEzMCIvPgoJCQoJCTxnIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDM5OS4wNTY2MTEgMCkiPgoJCQk8cGF0aCBkPSJtMzAuNzc4MzAyMyAxODEuNjU3MjI2LTI5LjcxNjk4MTUzIDg2LjA0ODE2MSA3NC4yOTI0NTM5My00LjI0OTI5M2g0Ny43NTk0MzQzdi0zNy4xODEzMDNsLTIuMTIyNjQxLTc2LjQ4NzI1My0xMC42MTMyMDggOC40OTg1ODN6IiBmaWxsPSIjZjg5ZDM1Ii8+CgkJCTxwYXRoIGQ9Im04Ny4wMjgzMDMyIDE5MS4yMTgxMzQgODcuMDI4MzAyOCAyLjEyNDY0Ni05LjU1MTg4NiA0NC42MTc1NjMtNDEuMzkxNTExLTEwLjYyMzIyOXoiIGZpbGw9IiNkODdjMzAiLz4KCQkJPHBhdGggZD0ibTg3LjAyODMwMzIgMTkyLjI4MDQ1NyAzNi4wODQ5MDU4IDMzLjk5NDMzNHYzMy45OTQzMzR6IiBmaWxsPSIjZWE4ZDNhIi8+CgkJCTxwYXRoIGQ9Im0xMjMuMTEzMjA5IDIyNy4zMzcxMTQgNDIuNDUyODMxIDEwLjYyMzIyOSAxMy43OTcxNyA0NS42Nzk4ODgtOS41NTE4ODYgNS4zMTE2MTUtNDYuNjk4MTE1LTI3LjYyMDM5OHoiIGZpbGw9IiNmODlkMzUiLz4KCQkJPHBhdGggZD0ibTEyMy4xMTMyMDkgMjYxLjMzMTQ0OC04LjQ5MDU2NSA2NS44NjQwMjQgNTUuMTg4NjgtMzguMjQzNjI2eiIgZmlsbD0iI2ViOGYzNSIvPjxwYXRoIGQ9Im0xNzQuMDU2NjA2IDE5My4zNDI3OCA1LjMwNjYwNCA5MC4yOTc0NTEtMTUuOTE5ODEyLTQ2LjIxMTA0OXoiIGZpbGw9IiNlYThlM2EiLz4KCQkJPHBhdGggZD0ibTc0LjI5MjQ1MzkgMjYyLjM5Mzc3MSA0OC44MjA3NTUxLTEuMDYyMzIzLTguNDkwNTY1IDY1Ljg2NDAyNHoiIGZpbGw9IiNkODdjMzAiLz48cGF0aCBkPSJtMjQuNDEwMzc3NyAzNTUuODc4MTkzIDkwLjIxMjI2NjMtMjguNjgyNzIxLTQwLjMzMDE5MDEtNjQuODAxNzAxLTczLjIzMTEzMzEzIDUuMzExNjE2eiIgZmlsbD0iI2ViOGYzNSIvPgoJCQk8cGF0aCBkPSJtMTY3LjY4ODY4MiAxMTAuNDgxNTg4LTQ1LjYzNjc5MyAzOC4yNDM2MjctMzUuMDIzNTg1OCA0Mi40OTI5MTkgODcuMDI4MzAyOCAzLjE4Njk2OXoiIGZpbGw9IiNlODgyMWUiLz4KCQkJPHBhdGggZD0ibTEzMi42NjUwOTYgMjEyLjQ2NDU5My0xMS42NzQ1MjggMjQuNDMzNDI3IDQxLjM5MTUxLTEwLjYyMzIyOXoiIGZpbGw9IiMzOTM5MzkiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDI4My4zNzI2NDYgMCkiLz4KCQkJPHBhdGggZD0ibTIzLjM0OTA1NyAxLjA2MjMyMjk2IDE0NC4zMzk2MjUgMTA5LjQxOTI2NTA0LTI0LjQxMDM3OC01OS40OTAwODU4eiIgZmlsbD0iI2U4OGYzNSIvPgoJCQk8cGF0aCBkPSJtMjMuMzQ5MDU3IDEuMDYyMzIyOTYtMTkuMTAzNzczOTIgNTguNDI3NzYyOTQgMTAuNjEzMjA3NzIgNjMuNzM5Mzc4MS03LjQyOTI0NTQxIDQuMjQ5MjkyIDEwLjYxMzIwNzcxIDkuNTYwOTA2LTguNDkwNTY2MTcgNy40MzYyNjEgMTEuNjc0NTI4NDcgMTAuNjIzMjI5LTcuNDI5MjQ1NCA2LjM3MzkzOCAxNi45ODExMzIzIDIxLjI0NjQ1OSA3OS41OTkwNTc3LTI0LjQzMzQyOGMzOC45MTUwOTYtMzEuMTYxNDczIDU4LjAxODg2OS00Ny4wOTYzMTggNTcuMzExMzIyLTQ3LjgwNDUzMy0uNzA3NTQ4LS43MDgyMTUtNDguODIwNzU2LTM3LjE4MTMwMzYtMTQ0LjMzOTYyNS0xMDkuNDE5MjY1MDR6IiBmaWxsPSIjOGU1YTMwIi8+CgkJPC9nPgoJPC9nPgo8L3N2Zz4=", ek = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQ4LjY0IDBIMTUuMzZDNi44NzY5MSAwIDAgNi44NzY5MSAwIDE1LjM2VjQ4LjY0QzAgNTcuMTIzMSA2Ljg3NjkxIDY0IDE1LjM2IDY0SDQ4LjY0QzU3LjEyMzEgNjQgNjQgNTcuMTIzMSA2NCA0OC42NFYxNS4zNkM2NCA2Ljg3NjkxIDU3LjEyMzEgMCA0OC42NCAwWiIgZmlsbD0iI0ZERkY1RCIvPgo8cGF0aCBkPSJNNDguNDU3MSA0OC4yMDY5TDQzLjc5MTMgMzUuOTg3MkM0My41ODg1IDM1LjUyNTEgNDMuMTgyNyAzNS4yMTcxIDQyLjY3NTYgMzUuMjE3MUg0MC43OTkxQzQwLjI5MTkgMzUuMjE3MSAzOS44MzU1IDM0LjkwOSAzOS42ODM0IDM0LjQ0NjlMMzIuMDc2MSAxNC42Mjg0SDI1LjEyODFMMTcuNzIzNiAzMy41MjI3QzE3LjQxOTMgMzQuMzQ0MiAxNy45NzcyIDM1LjIxNzEgMTguODM5MyAzNS4yMTcxQzE5LjcwMTUgMzUuMjE3MSAyMC4yNTk0IDM2LjA4OTkgMTkuOTU1MSAzNi45MTE0TDE1LjU0MjggNDguMjU4Mkg0OC40NTcxVjQ4LjIwNjlaTTI4LjQyNDYgMjAuNjM1NkwzMy42OTg5IDM0LjM5NTZDMzMuOTAxOCAzNC44NTc2IDM0LjMwNzUgMzUuMTY1NyAzNC44MTQ3IDM1LjE2NTdIMzYuNjkxMkMzNy4xOTgzIDM1LjE2NTcgMzcuNjU0OCAzNS40NzM4IDM3LjgwNjkgMzUuOTM1OUw0MC41NDU1IDQzLjA3MjZIMjMuNDU0NEwyNS44MzgxIDM2LjgwODdDMjYuMTQyNCAzNS45ODcyIDI1LjUzMzggMzUuMTY1NyAyNC43MjIzIDM1LjE2NTdIMjQuNjIwOUMyMy43NTg3IDM1LjE2NTcgMjMuMjAwOSAzNC4yOTI5IDIzLjUwNTIgMzMuNTIyN0wyOC40MjQ2IDIwLjYzNTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", tk = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwMCIgaGVpZ2h0PSIxMDAwIiB2aWV3Qm94PSIwIDAgMTAwMCAxMDAwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMTAwMCIgaGVpZ2h0PSIxMDAwIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTM4Mi44ODkgMTkwSDIwMy43NzhDMTk2LjE2OSAxOTAgMTkwIDE5Ni4xNjkgMTkwIDIwMy43NzhWMzgyLjg4OUMxOTAgMzkwLjQ5OCAxOTYuMTY5IDM5Ni42NjYgMjAzLjc3OCAzOTYuNjY2SDM4Mi44ODlDMzkwLjQ5OCAzOTYuNjY2IDM5Ni42NjYgMzkwLjQ5OCAzOTYuNjY2IDM4Mi44ODlWMjAzLjc3OEMzOTYuNjY2IDE5Ni4xNjkgMzkwLjQ5OCAxOTAgMzgyLjg4OSAxOTBaTTU4OS42NDQgMzk2LjY2N0g0MTAuNTMzQzQwMi45MjQgMzk2LjY2NyAzOTYuNzU1IDQwMi44MzUgMzk2Ljc1NSA0MTAuNDQ0VjU4OS41NTVDMzk2Ljc1NSA1OTcuMTY1IDQwMi45MjQgNjAzLjMzMyA0MTAuNTMzIDYwMy4zMzNINTg5LjY0NEM1OTcuMjUzIDYwMy4zMzMgNjAzLjQyMiA1OTcuMTY1IDYwMy40MjIgNTg5LjU1NVY0MTAuNDQ0QzYwMy40MjIgNDAyLjgzNSA1OTcuMjUzIDM5Ni42NjcgNTg5LjY0NCAzOTYuNjY3Wk02MTcuMTEyIDE5MEg3OTYuMjIyQzgwMy44MzIgMTkwIDgxMCAxOTYuMTY5IDgxMCAyMDMuNzc4VjM4Mi44ODlDODEwIDM5MC40OTggODAzLjgzMiAzOTYuNjY2IDc5Ni4yMjIgMzk2LjY2Nkg2MTcuMTEyQzYwOS41MDIgMzk2LjY2NiA2MDMuMzM0IDM5MC40OTggNjAzLjMzNCAzODIuODg5VjIwMy43NzhDNjAzLjMzNCAxOTYuMTY5IDYwOS41MDIgMTkwIDYxNy4xMTIgMTkwWk0zODIuODg5IDYwMy4zMzRIMjAzLjc3OEMxOTYuMTY5IDYwMy4zMzQgMTkwIDYwOS41MDIgMTkwIDYxNy4xMTJWNzk2LjIyMkMxOTAgODAzLjgzMiAxOTYuMTY5IDgxMCAyMDMuNzc4IDgxMEgzODIuODg5QzM5MC40OTggODEwIDM5Ni42NjYgODAzLjgzMiAzOTYuNjY2IDc5Ni4yMjJWNjE3LjExMkMzOTYuNjY2IDYwOS41MDIgMzkwLjQ5OCA2MDMuMzM0IDM4Mi44ODkgNjAzLjMzNFpNNjE3LjExMiA2MDMuMzM0SDc5Ni4yMjJDODAzLjgzMiA2MDMuMzM0IDgxMCA2MDkuNTAyIDgxMCA2MTcuMTEyVjc5Ni4yMjJDODEwIDgwMy44MzIgODAzLjgzMiA4MTAgNzk2LjIyMiA4MTBINjE3LjExMkM2MDkuNTAyIDgxMCA2MDMuMzM0IDgwMy44MzIgNjAzLjMzNCA3OTYuMjIyVjYxNy4xMTJDNjAzLjMzNCA2MDkuNTAyIDYwOS41MDIgNjAzLjMzNCA2MTcuMTEyIDYwMy4zMzRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K", rk = "data:image/svg+xml;base64,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", ik = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+Cgk8cGF0aCBkPSJNNTguNSAzMmMwIDE0LjYzNi0xMS44NjQgMjYuNS0yNi41IDI2LjVTNS41IDQ2LjYzNiA1LjUgMzIgMTcuMzY0IDUuNSAzMiA1LjUgNTguNSAxNy4zNjQgNTguNSAzMnoiCgkgICAgICBmaWxsPSIjZmZmIiBzdHJva2U9IiNGMkY1RkEiLz4KCTxwYXRoIGQ9Ik0yMS4zNyAyNS4yOThjNS44Ny01LjczIDE1LjM5LTUuNzMgMjEuMjYgMGwuNzA3LjY5YS43MjIuNzIyIDAgMDEwIDEuMDM4bC0yLjQxNyAyLjM2YS4zODIuMzgyIDAgMDEtLjUzMiAwbC0uOTcyLS45NWMtNC4wOTYtMy45OTgtMTAuNzM2LTMuOTk4LTE0LjgzMiAwbC0xLjA0MSAxLjAxN2EuMzgyLjM4MiAwIDAxLS41MzIgMGwtMi40MTctMi4zNmEuNzIyLjcyMiAwIDAxMC0xLjAzOGwuNzc2LS43NTd6bTI2LjI1OSA0Ljg4bDIuMTUgMi4xYS43MjEuNzIxIDAgMDEwIDEuMDM4bC05LjY5OSA5LjQ3YS43NjUuNzY1IDAgMDEtMS4wNjMgMGwtNi44ODQtNi43MjFhLjE5MS4xOTEgMCAwMC0uMjY2IDBsLTYuODg0IDYuNzJhLjc2NS43NjUgMCAwMS0xLjA2MyAwbC05LjctOS40N2EuNzIxLjcyMSAwIDAxMC0xLjAzN2wyLjE1MS0yLjFhLjc2NS43NjUgMCAwMTEuMDYzIDBsNi44ODUgNi43MmEuMTkxLjE5MSAwIDAwLjI2NSAwbDYuODg0LTYuNzJhLjc2NS43NjUgMCAwMTEuMDYzIDBsNi44ODUgNi43MmEuMTkxLjE5MSAwIDAwLjI2NiAwbDYuODg0LTYuNzJhLjc2NS43NjUgMCAwMTEuMDYzIDB6IgoJICAgICAgZmlsbD0iIzNCOTlGQyIvPgo8L3N2Zz4K", nk = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA0MCA0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iOC43MTA5IiBmaWxsPSIjMDBmMGZmIi8+CjxwYXRoIGQ9Im0xOC40NiAxNS43NjdoNy40Njg2bDcuNjQwNCA3LjU5MTZjMC40OTcgMC40OTM4IDAuNDk5NiAxLjI5NzEgMC4wMDUxIDEuNzkzNGwtOS43OTg0IDkuODQ3OWgtNy42OTM3bDIuMzI2LTIuMjYxMyA4LjU0LTguNDg2MS04LjQzMTYtOC40ODYyIiBmaWxsPSIjMWIxYjFiIi8+CjxwYXRoIGQ9Im0yMS41MjkgMjQuMjM0aC03LjQ2ODZsLTcuNjQwNC03LjU5MTdjLTAuNDk3MDItMC40OTM4LTAuNDk5NTYtMS4yOTctMC4wMDUwOC0xLjc5MzRsOS43OTg0LTkuODQ4NWg3LjY5MzdsLTIuMzI2IDIuMjYxMy04LjU0IDguNDg2MSA4LjQzMTYgOC40ODYyIiBmaWxsPSIjMWIxYjFiIi8+Cjwvc3ZnPg==", sk = "data:image/svg+xml;base64,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", ak = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTkwIiBoZWlnaHQ9IjU5MCIgdmlld0JveD0iMCAwIDU5MCA1OTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjI5NSIgY3k9IjI5NSIgcj0iMjk1IiBmaWxsPSIjMjJFNjgzIi8+CjxyZWN0IHg9IjI1NiIgeT0iMjUxIiB3aWR0aD0iODQiIGhlaWdodD0iODQiIGZpbGw9IndoaXRlIi8+CjxyZWN0IHg9IjM0MCIgeT0iMjUxIiB3aWR0aD0iODQiIGhlaWdodD0iODQiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=", xn = (t) => {
  switch (t) {
    case st.binanceWallet:
      return GP;
    case st.imtoken:
      return ZP;
    case st.math:
      return JP;
    case st.trustViaWalletConnect:
    case st.trust:
      return rk;
    case st.walletconnect:
      return ik;
    case st.okxwallet:
      return tk;
    case st.coinbase:
      return QP;
    case st.coin98:
      return YP;
    case st.clover:
      return KP;
    case st.mirage:
      return ek;
    case st.bitget:
      return nk;
    case st.bybit:
      return sk;
    case st.flow:
      return ak;
    case st.injected:
    default:
      return XP;
  }
}, IS = (t) => t && "isBybit" in t && t.isBybit, Ym = () => {
  const { bybitWallet: t, ethereum: e } = window;
  return !!(t && e);
}, Qm = (t) => !!(t != null && t.isClover), ok = () => {
  const { clover: t } = window;
  return !!t;
}, AS = () => {
  let { clover: t } = window;
  return !!(t && Array.isArray(t.providers) && t.providers.length > 0) && (t = t.providers.find(({ isClover: r }) => !!r)), t;
}, TS = (t) => !!(t != null && t.isCoin98), NS = () => {
  const { coin98: t, ethereum: e } = window;
  return !!(t && e);
}, DS = (t) => !!t, fk = "CoinbaseWallet", ck = (t) => !!(t != null && t.isWalletLink), CS = () => {
  const { ethereum: t } = window;
  if (!DS(t))
    return !1;
  let e = !!t.isCoinbaseWallet;
  if (t.providerMap) {
    const r = t.providerMap.get(fk);
    e = !!(r != null && r.isCoinbaseWallet) || !!(r != null && r.isCoinbaseBrowser);
  }
  return e;
};
function uk(t, e = 1e3, r = 100) {
  return new Promise((i) => {
    const s = Date.now(), n = () => {
      const f = window[t];
      f !== void 0 ? i(f) : Date.now() - s >= e ? i(void 0) : setTimeout(n, r);
    };
    n();
  });
}
const H0 = (t) => !!(t && "isFrw" in t && t.isFrw);
async function hk() {
  var r;
  const t = (r = window == null ? void 0 : window.trustwallet) == null ? void 0 : r.ethereum;
  if (t != null && t.isFlowWallet)
    return t;
  const e = await uk("frw");
  return H0(e) ? e : null;
}
const lk = () => {
  var t;
  return !!((t = window == null ? void 0 : window.frw) != null && t.isFrw);
}, dk = () => {
  var t, e;
  return !!((e = (t = window == null ? void 0 : window.trustwallet) == null ? void 0 : t.ethereum) != null && e.isFlowWallet);
}, Zm = (t) => t && "isOkxWallet" in t && t.isOkxWallet, Jm = () => !!window.okxwallet, OS = (t) => !!(t != null && t.isTrustWallet) || !!(t != null && t.isTrust), Xm = () => {
  const { trustwallet: t } = window;
  return !!(t != null && t.isTrustWallet) || !!(t != null && t.isTrust);
};
function pk(t) {
  return !!t.modal;
}
const RS = (t) => !!(t != null && t.isMirage), vk = () => {
  const t = window == null ? void 0 : window.mirage;
  if (!RS(t))
    throw new Error("Mirage wallet isn't installed");
  return t;
}, LS = (t) => t && "isBitKeep" in t && t.isBitKeep, e2 = () => {
  const { bitkeep: t, ethereum: e } = window;
  return !!(t && e);
};
function gk(t) {
  return pk(t) ? st.walletconnect : Zm(t) ? st.okxwallet : ck(t) ? st.coinbase : TS(t) ? st.coin98 : OS(t) ? st.trust : Qm(t) ? st.clover : RS(t) ? st.mirage : IS(t) ? st.bybit : LS(t) ? st.bitget : H0(t) ? st.flow : st.injected;
}
const Sn = (t) => {
  switch (t) {
    case st.okxwallet:
      return "OKX Wallet";
    case st.coinbase:
      return "Coinbase Wallet";
    case st.trustViaWalletConnect:
    case st.trust:
      return "Trust Wallet";
    case st.math:
      return "Math Wallet";
    case st.imtoken:
      return "imToken";
    case st.binanceWallet:
      return "Binance Wallet";
    case st.walletconnect:
      return "WalletConnect";
    case st.coin98:
      return "Coin98 Wallet";
    case st.clover:
      return "CLV Wallet";
    case st.injected:
      return "MetaMask";
    case st.mirage:
      return "Mirage Wallet";
    case st.bitget:
      return "Bitget Wallet";
    case st.bybit:
      return "Bybit Wallet";
    case st.flow:
      return "Flow Wallet";
    default:
      return "web3 wallet";
  }
};
var Qu = /* @__PURE__ */ ((t) => (t.AccountsChanged = "accountsChanged", t.Disconnect = "disconnect", t.Message = "message", t.ChainChanged = "chainChanged", t))(Qu || {});
const bk = Object.values(Qu), Mv = "CASK";
class yk {
  constructor(e) {
    Hi(this, "_storage");
    this._storage = e;
  }
  saveCurrentAccount(e) {
    this._storage.setItem(Mv, e);
  }
  getSavedCurrentAccount() {
    return this._storage.getItem(Mv);
  }
  removeSavedCurrentAccount() {
    this._storage.removeItem(Mv);
  }
}
async function mk(t) {
  const r = await (await fetch(t, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      jsonrpc: "2.0",
      id: 1,
      method: "eth_maxPriorityFeePerGas",
      params: []
    })
  })).json();
  return new Ko(qP(r == null ? void 0 : r.result));
}
function V_(t) {
  return !(!(t != null && t.on) || !(t != null && t.removeAllListeners) || !(t != null && t.once));
}
function Tde(t) {
  return t != null && t.on ? t : null;
}
function dd(t) {
  return !!t && typeof t == "object" && "request" in t;
}
const wk = 500, G_ = 500, _k = 4902, K_ = 4001, Mk = -32603, xk = 5e3, Y_ = "Network add denied by user", Sk = 3e9, Ek = 3e9, Ik = 2;
class Ak extends Eh {
  constructor() {
    super(...arguments);
    Hi(this, "walletMeta");
    Hi(this, "accounts", []);
    Hi(this, "persistStorageService", new yk(localStorage));
    Hi(this, "_currentAccount", null);
    Hi(this, "_rpcConfig", Re);
  }
  get rpcConfig() {
    return this._rpcConfig;
  }
  set rpcConfig(r) {
    this._rpcConfig = { ...Re, ...r };
  }
  get currentAccount() {
    return this._currentAccount || "";
  }
  set currentAccount(r) {
    r ? this.persistStorageService.saveCurrentAccount(r) : this.persistStorageService.removeSavedCurrentAccount(), this._currentAccount = r;
  }
  getWalletMeta() {
    if (!this.isConnected())
      throw new Error("Provider must be connected");
    return this.walletMeta;
  }
  setWalletMeta() {
    const r = this.provider;
    if (!this.isConnected() || !r)
      return;
    const i = gk(r);
    this.walletMeta = {
      name: Sn(i),
      icon: xn(i),
      id: i
    };
  }
  async connect() {
    await super.connect(), this.setWalletMeta();
    const r = this.getWeb3();
    await this.getUnlockedAccounts(r), this.addWalletEventsListener();
  }
  disconnect() {
    const r = this.provider;
    super.disconnect(), this.currentAccount = null, this.accounts = [], this.removeWalletEventsListener(r);
  }
  async sendTransactionAsync(r, i, s) {
    var P;
    const n = this.getWeb3(), f = this.getReadWeb3(), {
      data: u,
      estimate: h = !1,
      estimateFee: d = !1,
      extendedGasLimit: l,
      gasLimit: m = "0",
      value: b = "0",
      gasLimitMultiplier: M = 1
    } = s;
    let { nonce: A } = s;
    A || (A = await f.eth.getTransactionCount(r)), console.log(`Nonce: ${A}`), console.log(`this.currentChain: ${this.currentChain}`);
    const N = {
      from: r,
      to: i,
      value: ht(b),
      data: u,
      nonce: A,
      chainId: ht(this.currentChain)
    };
    if (h)
      try {
        const F = await f.eth.estimateGas(N), H = Math.round(
          F * M
        );
        l ? N.gas = ht(H + l) : N.gas = ht(H);
      } catch (F) {
        throw new Error(
          (P = F.message) != null ? P : "Failed to estimate gas limit for transaction."
        );
      }
    else
      N.gas = ht(m);
    const { maxFeePerGas: R, maxPriorityFeePerGas: O } = d ? await this.getMaxFees().catch(() => s) : s;
    if (O !== void 0 && (N.maxPriorityFeePerGas = ht(O)), R !== void 0 && (N.maxFeePerGas = ht(R)), !N.maxFeePerGas && !N.maxPriorityFeePerGas) {
      const F = await this.getSafeGasPriceWei();
      N.gasPrice = F.toString(10);
    }
    return console.log("Sending transaction via Web3: ", N), new Promise((F, H) => {
      const Q = n.eth.sendTransaction(N);
      Q.once("transactionHash", async (Z) => {
        console.log(`Just signed transaction has is: ${Z}`), Z && !Z.startsWith("0x") ? F({
          receiptPromise: Q,
          transactionHash: `0x${Z}`
        }) : F({
          receiptPromise: Q,
          transactionHash: Z
        });
      }).catch(H);
    });
  }
  getReadWeb3() {
    var n;
    const r = (n = this.rpcConfig) == null ? void 0 : n[this.currentChain];
    if (!r)
      throw console.error(
        "If you are using write provider with provider manager, please ensure that you have added RPC URL for current network to the configuration parameter: `rpcUrls`"
      ), new Error("Unable to create read web3 instance. RPC url not found");
    const i = new es(), s = new es.providers.HttpProvider(r);
    return i.setProvider(s), i;
  }
  async getMaxFees() {
    var u;
    if (this.isBinance())
      return {
        maxFeePerGas: Sk,
        maxPriorityFeePerGas: Ek
      };
    const r = this.getReadWeb3(), i = (u = this.rpcConfig) == null ? void 0 : u[this.currentChain];
    if (!i)
      return {};
    const [s, n] = await Promise.all([
      r.eth.getBlock("latest"),
      mk(i)
    ]);
    return !(s != null && s.baseFeePerGas) && typeof (s == null ? void 0 : s.baseFeePerGas) != "number" ? {} : {
      maxFeePerGas: +new Ko(s.baseFeePerGas).multipliedBy(Ik).plus(n),
      maxPriorityFeePerGas: +n
    };
  }
  isBinance() {
    return this.currentChain === ee.smartchain || this.currentChain === ee.smartchainTestnet;
  }
  async getUnlockedAccounts(r) {
    const i = await r.eth.getAccounts(), s = this.persistStorageService.getSavedCurrentAccount();
    if (!i.length || !i[0])
      throw new Error("Unable to detect unlocked MetaMask account");
    const n = i.find(
      (f) => f === s
    );
    return this.currentAccount = n || i[0], this.accounts = i, i;
  }
  async addTokenToWallet({
    chainId: r,
    ...i
  }) {
    const { provider: s } = this;
    if (!dd(s))
      throw new Error("This provider does not support the adding new tokens");
    return r && (await this.switchNetwork(r), await new Promise((n) => setTimeout(n, wk))), s.request({
      method: "wallet_watchAsset",
      params: { type: "ERC20", options: i }
    }).catch(() => !1);
  }
  async switchNetwork(r) {
    if (this.currentChain === r)
      return;
    const i = Zy[r], { provider: s } = this;
    if (!dd(s))
      throw new Error(
        "This provider does not support the network switching method"
      );
    try {
      await s.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: i.chainId }]
      }), await new Promise(
        (n) => setTimeout(n, G_)
      );
      return;
    } catch (n) {
      let f = n.code;
      if (f === xk) {
        const u = JSON.parse(
          n.message
        );
        f = u == null ? void 0 : u.code;
      }
      if (f === _k || f === Mk) {
        await this.addNetworkToWallet(r), await new Promise(
          (u) => setTimeout(u, G_)
        );
        return;
      }
      throw f === K_ ? new Error(Y_) : new Error(
        "Switch network error. Perhaps the network is not added to the RPC Config."
      );
    }
  }
  async addNetworkToWallet(r) {
    const i = Zy[r], { provider: s } = this;
    if (!dd(s))
      throw new Error(
        "This provider does not support the network adding method"
      );
    return s.request({
      method: "wallet_addEthereumChain",
      params: [i]
    }).catch((n) => {
      throw n.code === K_ ? new Error(Y_) : n;
    });
  }
  async signMessage(r, i = this.currentAccount) {
    const { provider: s } = this;
    if (!dd(s))
      throw new Error("This provider does not support the sign message method");
    return s.request({
      method: "personal_sign",
      params: [r, i]
    });
  }
  async getSafeGasPriceWei() {
    const r = await this.getReadWeb3().eth.getGasPrice();
    return new Ko(r).plus(ES);
  }
  addWalletEventsListener() {
    const r = this.provider;
    !V_(r) || (r.on(Qu.AccountsChanged, async (i) => {
      const s = i.length ? i[0] : void 0;
      s ? this.currentAccount = s : this.disconnect();
    }), r.on(Qu.ChainChanged, (i) => {
      const s = i.toString().startsWith("0x") ? i : es.utils.numberToHex(i), n = Number.parseInt(s, 16);
      this.currentChain = n;
    }), r.on(Qu.Disconnect, () => {
      this.disconnect();
    }));
  }
  removeWalletEventsListener(r = this.provider) {
    !V_(r) || bk.forEach((i) => {
      r.removeAllListeners(i);
    });
  }
}
var nt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function PS(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function pf(t) {
  var e = t.default;
  if (typeof e == "function") {
    var r = function() {
      return e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(i) {
    var s = Object.getOwnPropertyDescriptor(t, i);
    Object.defineProperty(r, i, s.get ? s : {
      enumerable: !0,
      get: function() {
        return t[i];
      }
    });
  }), r;
}
var Pr = { exports: {} }, ac = typeof Reflect == "object" ? Reflect : null, Q_ = ac && typeof ac.apply == "function" ? ac.apply : function(e, r, i) {
  return Function.prototype.apply.call(e, r, i);
}, Hd;
ac && typeof ac.ownKeys == "function" ? Hd = ac.ownKeys : Object.getOwnPropertySymbols ? Hd = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Hd = function(e) {
  return Object.getOwnPropertyNames(e);
};
function Tk(t) {
  console && console.warn && console.warn(t);
}
var kS = Number.isNaN || function(e) {
  return e !== e;
};
function xr() {
  xr.init.call(this);
}
Pr.exports = xr;
Pr.exports.once = Ok;
xr.EventEmitter = xr;
xr.prototype._events = void 0;
xr.prototype._eventsCount = 0;
xr.prototype._maxListeners = void 0;
var Z_ = 10;
function W0(t) {
  if (typeof t != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
}
Object.defineProperty(xr, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return Z_;
  },
  set: function(t) {
    if (typeof t != "number" || t < 0 || kS(t))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
    Z_ = t;
  }
});
xr.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
xr.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || kS(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function jS(t) {
  return t._maxListeners === void 0 ? xr.defaultMaxListeners : t._maxListeners;
}
xr.prototype.getMaxListeners = function() {
  return jS(this);
};
xr.prototype.emit = function(e) {
  for (var r = [], i = 1; i < arguments.length; i++)
    r.push(arguments[i]);
  var s = e === "error", n = this._events;
  if (n !== void 0)
    s = s && n.error === void 0;
  else if (!s)
    return !1;
  if (s) {
    var f;
    if (r.length > 0 && (f = r[0]), f instanceof Error)
      throw f;
    var u = new Error("Unhandled error." + (f ? " (" + f.message + ")" : ""));
    throw u.context = f, u;
  }
  var h = n[e];
  if (h === void 0)
    return !1;
  if (typeof h == "function")
    Q_(h, this, r);
  else
    for (var d = h.length, l = $S(h, d), i = 0; i < d; ++i)
      Q_(l[i], this, r);
  return !0;
};
function BS(t, e, r, i) {
  var s, n, f;
  if (W0(r), n = t._events, n === void 0 ? (n = t._events = /* @__PURE__ */ Object.create(null), t._eventsCount = 0) : (n.newListener !== void 0 && (t.emit(
    "newListener",
    e,
    r.listener ? r.listener : r
  ), n = t._events), f = n[e]), f === void 0)
    f = n[e] = r, ++t._eventsCount;
  else if (typeof f == "function" ? f = n[e] = i ? [r, f] : [f, r] : i ? f.unshift(r) : f.push(r), s = jS(t), s > 0 && f.length > s && !f.warned) {
    f.warned = !0;
    var u = new Error("Possible EventEmitter memory leak detected. " + f.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    u.name = "MaxListenersExceededWarning", u.emitter = t, u.type = e, u.count = f.length, Tk(u);
  }
  return t;
}
xr.prototype.addListener = function(e, r) {
  return BS(this, e, r, !1);
};
xr.prototype.on = xr.prototype.addListener;
xr.prototype.prependListener = function(e, r) {
  return BS(this, e, r, !0);
};
function Nk() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function zS(t, e, r) {
  var i = { fired: !1, wrapFn: void 0, target: t, type: e, listener: r }, s = Nk.bind(i);
  return s.listener = r, i.wrapFn = s, s;
}
xr.prototype.once = function(e, r) {
  return W0(r), this.on(e, zS(this, e, r)), this;
};
xr.prototype.prependOnceListener = function(e, r) {
  return W0(r), this.prependListener(e, zS(this, e, r)), this;
};
xr.prototype.removeListener = function(e, r) {
  var i, s, n, f, u;
  if (W0(r), s = this._events, s === void 0)
    return this;
  if (i = s[e], i === void 0)
    return this;
  if (i === r || i.listener === r)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete s[e], s.removeListener && this.emit("removeListener", e, i.listener || r));
  else if (typeof i != "function") {
    for (n = -1, f = i.length - 1; f >= 0; f--)
      if (i[f] === r || i[f].listener === r) {
        u = i[f].listener, n = f;
        break;
      }
    if (n < 0)
      return this;
    n === 0 ? i.shift() : Dk(i, n), i.length === 1 && (s[e] = i[0]), s.removeListener !== void 0 && this.emit("removeListener", e, u || r);
  }
  return this;
};
xr.prototype.off = xr.prototype.removeListener;
xr.prototype.removeAllListeners = function(e) {
  var r, i, s;
  if (i = this._events, i === void 0)
    return this;
  if (i.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : i[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete i[e]), this;
  if (arguments.length === 0) {
    var n = Object.keys(i), f;
    for (s = 0; s < n.length; ++s)
      f = n[s], f !== "removeListener" && this.removeAllListeners(f);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (r = i[e], typeof r == "function")
    this.removeListener(e, r);
  else if (r !== void 0)
    for (s = r.length - 1; s >= 0; s--)
      this.removeListener(e, r[s]);
  return this;
};
function US(t, e, r) {
  var i = t._events;
  if (i === void 0)
    return [];
  var s = i[e];
  return s === void 0 ? [] : typeof s == "function" ? r ? [s.listener || s] : [s] : r ? Ck(s) : $S(s, s.length);
}
xr.prototype.listeners = function(e) {
  return US(this, e, !0);
};
xr.prototype.rawListeners = function(e) {
  return US(this, e, !1);
};
xr.listenerCount = function(t, e) {
  return typeof t.listenerCount == "function" ? t.listenerCount(e) : FS.call(t, e);
};
xr.prototype.listenerCount = FS;
function FS(t) {
  var e = this._events;
  if (e !== void 0) {
    var r = e[t];
    if (typeof r == "function")
      return 1;
    if (r !== void 0)
      return r.length;
  }
  return 0;
}
xr.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Hd(this._events) : [];
};
function $S(t, e) {
  for (var r = new Array(e), i = 0; i < e; ++i)
    r[i] = t[i];
  return r;
}
function Dk(t, e) {
  for (; e + 1 < t.length; e++)
    t[e] = t[e + 1];
  t.pop();
}
function Ck(t) {
  for (var e = new Array(t.length), r = 0; r < e.length; ++r)
    e[r] = t[r].listener || t[r];
  return e;
}
function Ok(t, e) {
  return new Promise(function(r, i) {
    function s(f) {
      t.removeListener(e, n), i(f);
    }
    function n() {
      typeof t.removeListener == "function" && t.removeListener("error", s), r([].slice.call(arguments));
    }
    qS(t, e, n, { once: !0 }), e !== "error" && Rk(t, s, { once: !0 });
  });
}
function Rk(t, e, r) {
  typeof t.on == "function" && qS(t, "error", e, r);
}
function qS(t, e, r, i) {
  if (typeof t.on == "function")
    i.once ? t.once(e, r) : t.on(e, r);
  else if (typeof t.addEventListener == "function")
    t.addEventListener(e, function s(n) {
      i.once && t.removeEventListener(e, s), r(n);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof t);
}
var Qa;
(function(t) {
  t.Update = "Web3ReactUpdate", t.Error = "Web3ReactError", t.Deactivate = "Web3ReactDeactivate";
})(Qa || (Qa = {}));
function Lk(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
var Pk = /* @__PURE__ */ function(t) {
  Lk(e, t);
  function e(i) {
    var s, n = i === void 0 ? {} : i, f = n.supportedChainIds;
    return s = t.call(this) || this, s.supportedChainIds = f, s;
  }
  var r = e.prototype;
  return r.emitUpdate = function(s) {
    process.env.NODE_ENV !== "production" && console.log("Emitting '" + Qa.Update + "' with payload", s), this.emit(Qa.Update, s);
  }, r.emitError = function(s) {
    process.env.NODE_ENV !== "production" && console.log("Emitting '" + Qa.Error + "' with payload", s), this.emit(Qa.Error, s);
  }, r.emitDeactivate = function() {
    process.env.NODE_ENV !== "production" && console.log("Emitting '" + Qa.Deactivate + "'"), this.emit(Qa.Deactivate);
  }, e;
}(Pr.exports.EventEmitter), kk = process.env.NODE_ENV === "production";
function qf(t, e) {
  if (!kk) {
    if (t)
      return;
    var r = "Warning: " + e;
    typeof console < "u" && console.warn(r);
    try {
      throw Error(r);
    } catch {
    }
  }
}
function J_(t, e, r, i, s, n, f) {
  try {
    var u = t[n](f), h = u.value;
  } catch (d) {
    r(d);
    return;
  }
  u.done ? e(h) : Promise.resolve(h).then(i, s);
}
function Au(t) {
  return function() {
    var e = this, r = arguments;
    return new Promise(function(i, s) {
      var n = t.apply(e, r);
      function f(h) {
        J_(n, i, s, f, u, "next", h);
      }
      function u(h) {
        J_(n, i, s, f, u, "throw", h);
      }
      f(void 0);
    });
  };
}
function Jy() {
  return Jy = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, Jy.apply(this, arguments);
}
function t2(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
function Xy(t) {
  return Xy = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Xy(t);
}
function o0(t, e) {
  return o0 = Object.setPrototypeOf || function(i, s) {
    return i.__proto__ = s, i;
  }, o0(t, e);
}
function jk() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Wd(t, e, r) {
  return jk() ? Wd = Reflect.construct : Wd = function(s, n, f) {
    var u = [null];
    u.push.apply(u, n);
    var h = Function.bind.apply(s, u), d = new h();
    return f && o0(d, f.prototype), d;
  }, Wd.apply(null, arguments);
}
function Bk(t) {
  return Function.toString.call(t).indexOf("[native code]") !== -1;
}
function f0(t) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return f0 = function(i) {
    if (i === null || !Bk(i))
      return i;
    if (typeof i != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e < "u") {
      if (e.has(i))
        return e.get(i);
      e.set(i, s);
    }
    function s() {
      return Wd(i, arguments, Xy(this).constructor);
    }
    return s.prototype = Object.create(i.prototype, {
      constructor: {
        value: s,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), o0(s, i);
  }, f0(t);
}
function pd(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function zk(t, e) {
  return e = { exports: {} }, t(e, e.exports), e.exports;
}
var ks = zk(function(t) {
  var e = function(r) {
    var i = Object.prototype, s = i.hasOwnProperty, n, f = typeof Symbol == "function" ? Symbol : {}, u = f.iterator || "@@iterator", h = f.asyncIterator || "@@asyncIterator", d = f.toStringTag || "@@toStringTag";
    function l(_, x, E) {
      return Object.defineProperty(_, x, {
        value: E,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), _[x];
    }
    try {
      l({}, "");
    } catch {
      l = function(x, E, y) {
        return x[E] = y;
      };
    }
    function m(_, x, E, y) {
      var o = x && x.prototype instanceof P ? x : P, S = Object.create(o.prototype), J = new c(y || []);
      return S._invoke = W(_, E, J), S;
    }
    r.wrap = m;
    function b(_, x, E) {
      try {
        return { type: "normal", arg: _.call(x, E) };
      } catch (y) {
        return { type: "throw", arg: y };
      }
    }
    var M = "suspendedStart", A = "suspendedYield", N = "executing", R = "completed", O = {};
    function P() {
    }
    function F() {
    }
    function H() {
    }
    var Q = {};
    Q[u] = function() {
      return this;
    };
    var Z = Object.getPrototypeOf, B = Z && Z(Z(p([])));
    B && B !== i && s.call(B, u) && (Q = B);
    var Y = H.prototype = P.prototype = Object.create(Q);
    F.prototype = Y.constructor = H, H.constructor = F, F.displayName = l(
      H,
      d,
      "GeneratorFunction"
    );
    function ae(_) {
      ["next", "throw", "return"].forEach(function(x) {
        l(_, x, function(E) {
          return this._invoke(x, E);
        });
      });
    }
    r.isGeneratorFunction = function(_) {
      var x = typeof _ == "function" && _.constructor;
      return x ? x === F || (x.displayName || x.name) === "GeneratorFunction" : !1;
    }, r.mark = function(_) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(_, H) : (_.__proto__ = H, l(_, d, "GeneratorFunction")), _.prototype = Object.create(Y), _;
    }, r.awrap = function(_) {
      return { __await: _ };
    };
    function se(_, x) {
      function E(S, J, z, k) {
        var j = b(_[S], _, J);
        if (j.type === "throw")
          k(j.arg);
        else {
          var q = j.arg, K = q.value;
          return K && typeof K == "object" && s.call(K, "__await") ? x.resolve(K.__await).then(function(U) {
            E("next", U, z, k);
          }, function(U) {
            E("throw", U, z, k);
          }) : x.resolve(K).then(function(U) {
            q.value = U, z(q);
          }, function(U) {
            return E("throw", U, z, k);
          });
        }
      }
      var y;
      function o(S, J) {
        function z() {
          return new x(function(k, j) {
            E(S, J, k, j);
          });
        }
        return y = y ? y.then(
          z,
          z
        ) : z();
      }
      this._invoke = o;
    }
    ae(se.prototype), se.prototype[h] = function() {
      return this;
    }, r.AsyncIterator = se, r.async = function(_, x, E, y, o) {
      o === void 0 && (o = Promise);
      var S = new se(
        m(_, x, E, y),
        o
      );
      return r.isGeneratorFunction(x) ? S : S.next().then(function(J) {
        return J.done ? J.value : S.next();
      });
    };
    function W(_, x, E) {
      var y = M;
      return function(S, J) {
        if (y === N)
          throw new Error("Generator is already running");
        if (y === R) {
          if (S === "throw")
            throw J;
          return w();
        }
        for (E.method = S, E.arg = J; ; ) {
          var z = E.delegate;
          if (z) {
            var k = C(z, E);
            if (k) {
              if (k === O)
                continue;
              return k;
            }
          }
          if (E.method === "next")
            E.sent = E._sent = E.arg;
          else if (E.method === "throw") {
            if (y === M)
              throw y = R, E.arg;
            E.dispatchException(E.arg);
          } else
            E.method === "return" && E.abrupt("return", E.arg);
          y = N;
          var j = b(_, x, E);
          if (j.type === "normal") {
            if (y = E.done ? R : A, j.arg === O)
              continue;
            return {
              value: j.arg,
              done: E.done
            };
          } else
            j.type === "throw" && (y = R, E.method = "throw", E.arg = j.arg);
        }
      };
    }
    function C(_, x) {
      var E = _.iterator[x.method];
      if (E === n) {
        if (x.delegate = null, x.method === "throw") {
          if (_.iterator.return && (x.method = "return", x.arg = n, C(_, x), x.method === "throw"))
            return O;
          x.method = "throw", x.arg = new TypeError(
            "The iterator does not provide a 'throw' method"
          );
        }
        return O;
      }
      var y = b(E, _.iterator, x.arg);
      if (y.type === "throw")
        return x.method = "throw", x.arg = y.arg, x.delegate = null, O;
      var o = y.arg;
      if (!o)
        return x.method = "throw", x.arg = new TypeError("iterator result is not an object"), x.delegate = null, O;
      if (o.done)
        x[_.resultName] = o.value, x.next = _.nextLoc, x.method !== "return" && (x.method = "next", x.arg = n);
      else
        return o;
      return x.delegate = null, O;
    }
    ae(Y), l(Y, d, "Generator"), Y[u] = function() {
      return this;
    }, Y.toString = function() {
      return "[object Generator]";
    };
    function g(_) {
      var x = { tryLoc: _[0] };
      1 in _ && (x.catchLoc = _[1]), 2 in _ && (x.finallyLoc = _[2], x.afterLoc = _[3]), this.tryEntries.push(x);
    }
    function a(_) {
      var x = _.completion || {};
      x.type = "normal", delete x.arg, _.completion = x;
    }
    function c(_) {
      this.tryEntries = [{ tryLoc: "root" }], _.forEach(g, this), this.reset(!0);
    }
    r.keys = function(_) {
      var x = [];
      for (var E in _)
        x.push(E);
      return x.reverse(), function y() {
        for (; x.length; ) {
          var o = x.pop();
          if (o in _)
            return y.value = o, y.done = !1, y;
        }
        return y.done = !0, y;
      };
    };
    function p(_) {
      if (_) {
        var x = _[u];
        if (x)
          return x.call(_);
        if (typeof _.next == "function")
          return _;
        if (!isNaN(_.length)) {
          var E = -1, y = function o() {
            for (; ++E < _.length; )
              if (s.call(_, E))
                return o.value = _[E], o.done = !1, o;
            return o.value = n, o.done = !0, o;
          };
          return y.next = y;
        }
      }
      return { next: w };
    }
    r.values = p;
    function w() {
      return { value: n, done: !0 };
    }
    return c.prototype = {
      constructor: c,
      reset: function(_) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = n, this.done = !1, this.delegate = null, this.method = "next", this.arg = n, this.tryEntries.forEach(a), !_)
          for (var x in this)
            x.charAt(0) === "t" && s.call(this, x) && !isNaN(+x.slice(1)) && (this[x] = n);
      },
      stop: function() {
        this.done = !0;
        var _ = this.tryEntries[0], x = _.completion;
        if (x.type === "throw")
          throw x.arg;
        return this.rval;
      },
      dispatchException: function(_) {
        if (this.done)
          throw _;
        var x = this;
        function E(k, j) {
          return S.type = "throw", S.arg = _, x.next = k, j && (x.method = "next", x.arg = n), !!j;
        }
        for (var y = this.tryEntries.length - 1; y >= 0; --y) {
          var o = this.tryEntries[y], S = o.completion;
          if (o.tryLoc === "root")
            return E("end");
          if (o.tryLoc <= this.prev) {
            var J = s.call(o, "catchLoc"), z = s.call(o, "finallyLoc");
            if (J && z) {
              if (this.prev < o.catchLoc)
                return E(o.catchLoc, !0);
              if (this.prev < o.finallyLoc)
                return E(o.finallyLoc);
            } else if (J) {
              if (this.prev < o.catchLoc)
                return E(o.catchLoc, !0);
            } else if (z) {
              if (this.prev < o.finallyLoc)
                return E(o.finallyLoc);
            } else
              throw new Error("try statement without catch or finally");
          }
        }
      },
      abrupt: function(_, x) {
        for (var E = this.tryEntries.length - 1; E >= 0; --E) {
          var y = this.tryEntries[E];
          if (y.tryLoc <= this.prev && s.call(y, "finallyLoc") && this.prev < y.finallyLoc) {
            var o = y;
            break;
          }
        }
        o && (_ === "break" || _ === "continue") && o.tryLoc <= x && x <= o.finallyLoc && (o = null);
        var S = o ? o.completion : {};
        return S.type = _, S.arg = x, o ? (this.method = "next", this.next = o.finallyLoc, O) : this.complete(S);
      },
      complete: function(_, x) {
        if (_.type === "throw")
          throw _.arg;
        return _.type === "break" || _.type === "continue" ? this.next = _.arg : _.type === "return" ? (this.rval = this.arg = _.arg, this.method = "return", this.next = "end") : _.type === "normal" && x && (this.next = x), O;
      },
      finish: function(_) {
        for (var x = this.tryEntries.length - 1; x >= 0; --x) {
          var E = this.tryEntries[x];
          if (E.finallyLoc === _)
            return this.complete(E.completion, E.afterLoc), a(E), O;
        }
      },
      catch: function(_) {
        for (var x = this.tryEntries.length - 1; x >= 0; --x) {
          var E = this.tryEntries[x];
          if (E.tryLoc === _) {
            var y = E.completion;
            if (y.type === "throw") {
              var o = y.arg;
              a(E);
            }
            return o;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function(_, x, E) {
        return this.delegate = {
          iterator: p(_),
          resultName: x,
          nextLoc: E
        }, this.method === "next" && (this.arg = n), O;
      }
    }, r;
  }(
    t.exports
  );
  try {
    regeneratorRuntime = e;
  } catch {
    Function("r", "regeneratorRuntime = r")(e);
  }
});
function js(t) {
  return t.hasOwnProperty("result") ? t.result : t;
}
var xv = /* @__PURE__ */ function(t) {
  t2(e, t);
  function e() {
    var r;
    return r = t.call(this) || this, r.name = r.constructor.name, r.message = "No BSC provider was found on window.BinanceChain.", r;
  }
  return e;
}(/* @__PURE__ */ f0(Error)), Uk = /* @__PURE__ */ function(t) {
  t2(e, t);
  function e() {
    var r;
    return r = t.call(this) || this, r.name = r.constructor.name, r.message = "The user rejected the request.", r;
  }
  return e;
}(/* @__PURE__ */ f0(Error)), Fk = /* @__PURE__ */ function(t) {
  t2(e, t);
  function e(i) {
    var s;
    return s = t.call(this, i) || this, s.handleNetworkChanged = s.handleNetworkChanged.bind(pd(s)), s.handleChainChanged = s.handleChainChanged.bind(pd(s)), s.handleAccountsChanged = s.handleAccountsChanged.bind(pd(s)), s.handleClose = s.handleClose.bind(pd(s)), s;
  }
  var r = e.prototype;
  return r.handleChainChanged = function(s) {
    process.env.NODE_ENV !== "production" && console.log("Handling 'chainChanged' event with payload", s), this.emitUpdate({
      chainId: s,
      provider: window.BinanceChain
    });
  }, r.handleAccountsChanged = function(s) {
    process.env.NODE_ENV !== "production" && console.log("Handling 'accountsChanged' event with payload", s), s.length === 0 ? this.emitDeactivate() : this.emitUpdate({
      account: s[0]
    });
  }, r.handleClose = function(s, n) {
    process.env.NODE_ENV !== "production" && console.log("Handling 'close' event with payload", s, n), this.emitDeactivate();
  }, r.handleNetworkChanged = function(s) {
    process.env.NODE_ENV !== "production" && console.log("Handling 'networkChanged' event with payload", s), this.emitUpdate({
      chainId: s,
      provider: window.BinanceChain
    });
  }, r.activate = /* @__PURE__ */ function() {
    var i = /* @__PURE__ */ Au(/* @__PURE__ */ ks.mark(function n() {
      var f;
      return ks.wrap(function(h) {
        for (; ; )
          switch (h.prev = h.next) {
            case 0:
              if (window.BinanceChain) {
                h.next = 2;
                break;
              }
              throw new xv();
            case 2:
              return window.BinanceChain.on && (window.BinanceChain.on("chainChanged", this.handleChainChanged), window.BinanceChain.on("accountsChanged", this.handleAccountsChanged), window.BinanceChain.on("close", this.handleClose), window.BinanceChain.on("networkChanged", this.handleNetworkChanged)), window.BinanceChain.isMetaMask && (window.BinanceChain.autoRefreshOnNetworkChange = !1), h.prev = 4, h.next = 7, window.BinanceChain.send("eth_requestAccounts").then(function(d) {
                return js(d)[0];
              });
            case 7:
              f = h.sent, h.next = 15;
              break;
            case 10:
              if (h.prev = 10, h.t0 = h.catch(4), h.t0.code !== 4001) {
                h.next = 14;
                break;
              }
              throw new Uk();
            case 14:
              process.env.NODE_ENV !== "production" && qf(!1, "eth_requestAccounts was unsuccessful, falling back to enable");
            case 15:
              if (f) {
                h.next = 19;
                break;
              }
              return h.next = 18, window.BinanceChain.enable().then(function(d) {
                return d && js(d)[0];
              });
            case 18:
              f = h.sent;
            case 19:
              return h.abrupt("return", Jy({
                provider: window.BinanceChain
              }, f ? {
                account: f
              } : {}));
            case 20:
            case "end":
              return h.stop();
          }
      }, n, this, [[4, 10]]);
    }));
    function s() {
      return i.apply(this, arguments);
    }
    return s;
  }(), r.getProvider = /* @__PURE__ */ function() {
    var i = /* @__PURE__ */ Au(/* @__PURE__ */ ks.mark(function n() {
      return ks.wrap(function(u) {
        for (; ; )
          switch (u.prev = u.next) {
            case 0:
              return u.abrupt("return", window.BinanceChain);
            case 1:
            case "end":
              return u.stop();
          }
      }, n);
    }));
    function s() {
      return i.apply(this, arguments);
    }
    return s;
  }(), r.getChainId = /* @__PURE__ */ function() {
    var i = /* @__PURE__ */ Au(/* @__PURE__ */ ks.mark(function n() {
      var f;
      return ks.wrap(function(h) {
        for (; ; )
          switch (h.prev = h.next) {
            case 0:
              if (window.BinanceChain) {
                h.next = 2;
                break;
              }
              throw new xv();
            case 2:
              return h.prev = 2, h.next = 5, window.BinanceChain.send("eth_chainId").then(js);
            case 5:
              f = h.sent, h.next = 11;
              break;
            case 8:
              h.prev = 8, h.t0 = h.catch(2), process.env.NODE_ENV !== "production" && qf(!1, "eth_chainId was unsuccessful, falling back to net_version");
            case 11:
              if (f) {
                h.next = 21;
                break;
              }
              return h.prev = 12, h.next = 15, window.BinanceChain.send("net_version").then(js);
            case 15:
              f = h.sent, h.next = 21;
              break;
            case 18:
              h.prev = 18, h.t1 = h.catch(12), process.env.NODE_ENV !== "production" && qf(!1, "net_version was unsuccessful, falling back to net version v2");
            case 21:
              if (!f)
                try {
                  f = js(window.BinanceChain.send({
                    method: "net_version"
                  }));
                } catch {
                  process.env.NODE_ENV !== "production" && qf(!1, "net_version v2 was unsuccessful, falling back to manual matches and static properties");
                }
              return f || (window.BinanceChain.isDapper ? f = js(window.BinanceChain.cachedResults.net_version) : f = window.BinanceChain.chainId || window.BinanceChain.netVersion || window.BinanceChain.networkVersion || window.BinanceChain._chainId), h.abrupt("return", f);
            case 24:
            case "end":
              return h.stop();
          }
      }, n, null, [[2, 8], [12, 18]]);
    }));
    function s() {
      return i.apply(this, arguments);
    }
    return s;
  }(), r.getAccount = /* @__PURE__ */ function() {
    var i = /* @__PURE__ */ Au(/* @__PURE__ */ ks.mark(function n() {
      var f;
      return ks.wrap(function(h) {
        for (; ; )
          switch (h.prev = h.next) {
            case 0:
              if (window.BinanceChain) {
                h.next = 2;
                break;
              }
              throw new xv();
            case 2:
              return h.prev = 2, h.next = 5, window.BinanceChain.send("eth_accounts").then(function(d) {
                return js(d)[0];
              });
            case 5:
              f = h.sent, h.next = 11;
              break;
            case 8:
              h.prev = 8, h.t0 = h.catch(2), process.env.NODE_ENV !== "production" && qf(!1, "eth_accounts was unsuccessful, falling back to enable");
            case 11:
              if (f) {
                h.next = 21;
                break;
              }
              return h.prev = 12, h.next = 15, window.BinanceChain.enable().then(function(d) {
                return js(d)[0];
              });
            case 15:
              f = h.sent, h.next = 21;
              break;
            case 18:
              h.prev = 18, h.t1 = h.catch(12), process.env.NODE_ENV !== "production" && qf(!1, "enable was unsuccessful, falling back to eth_accounts v2");
            case 21:
              return f || (f = js(window.BinanceChain.send({
                method: "eth_accounts"
              }))[0]), h.abrupt("return", f);
            case 23:
            case "end":
              return h.stop();
          }
      }, n, null, [[2, 8], [12, 18]]);
    }));
    function s() {
      return i.apply(this, arguments);
    }
    return s;
  }(), r.deactivate = function() {
    window.BinanceChain && window.BinanceChain.removeListener && (window.BinanceChain.removeListener("chainChanged", this.handleChainChanged), window.BinanceChain.removeListener("accountsChanged", this.handleAccountsChanged), window.BinanceChain.removeListener("close", this.handleClose), window.BinanceChain.removeListener("networkChanged", this.handleNetworkChanged));
  }, r.isAuthorized = /* @__PURE__ */ function() {
    var i = /* @__PURE__ */ Au(/* @__PURE__ */ ks.mark(function n() {
      return ks.wrap(function(u) {
        for (; ; )
          switch (u.prev = u.next) {
            case 0:
              if (window.BinanceChain) {
                u.next = 2;
                break;
              }
              return u.abrupt("return", !1);
            case 2:
              return u.prev = 2, u.next = 5, window.BinanceChain.send("eth_accounts").then(function(h) {
                return js(h).length > 0;
              });
            case 5:
              return u.abrupt("return", u.sent);
            case 8:
              return u.prev = 8, u.t0 = u.catch(2), u.abrupt("return", !1);
            case 11:
            case "end":
              return u.stop();
          }
      }, n, null, [[2, 8]]);
    }));
    function s() {
      return i.apply(this, arguments);
    }
    return s;
  }(), e;
}(Pk), HS = {}, ch = {}, V0 = {};
Object.defineProperty(V0, "__esModule", { value: !0 });
V0.walletLogo = void 0;
const $k = (t, e) => {
  let r;
  switch (t) {
    case "standard":
      return r = e, `data:image/svg+xml,%3Csvg width='${e}' height='${r}' viewBox='0 0 1024 1024' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect width='1024' height='1024' fill='%230052FF'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M152 512C152 710.823 313.177 872 512 872C710.823 872 872 710.823 872 512C872 313.177 710.823 152 512 152C313.177 152 152 313.177 152 512ZM420 396C406.745 396 396 406.745 396 420V604C396 617.255 406.745 628 420 628H604C617.255 628 628 617.255 628 604V420C628 406.745 617.255 396 604 396H420Z' fill='white'/%3E %3C/svg%3E `;
    case "circle":
      return r = e, `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${e}' height='${r}' viewBox='0 0 999.81 999.81'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052fe;%7D.cls-2%7Bfill:%23fefefe;%7D.cls-3%7Bfill:%230152fe;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M655-115.9h56c.83,1.59,2.36.88,3.56,1a478,478,0,0,1,75.06,10.42C891.4-81.76,978.33-32.58,1049.19,44q116.7,126,131.94,297.61c.38,4.14-.34,8.53,1.78,12.45v59c-1.58.84-.91,2.35-1,3.56a482.05,482.05,0,0,1-10.38,74.05c-24,106.72-76.64,196.76-158.83,268.93s-178.18,112.82-287.2,122.6c-4.83.43-9.86-.25-14.51,1.77H654c-1-1.68-2.69-.91-4.06-1a496.89,496.89,0,0,1-105.9-18.59c-93.54-27.42-172.78-77.59-236.91-150.94Q199.34,590.1,184.87,426.58c-.47-5.19.25-10.56-1.77-15.59V355c1.68-1,.91-2.7,1-4.06a498.12,498.12,0,0,1,18.58-105.9c26-88.75,72.64-164.9,140.6-227.57q126-116.27,297.21-131.61C645.32-114.57,650.35-113.88,655-115.9Zm377.92,500c0-192.44-156.31-349.49-347.56-350.15-194.13-.68-350.94,155.13-352.29,347.42-1.37,194.55,155.51,352.1,348.56,352.47C876.15,734.23,1032.93,577.84,1032.93,384.11Z' transform='translate(-183.1 115.9)'/%3E%3Cpath class='cls-2' d='M1032.93,384.11c0,193.73-156.78,350.12-351.29,349.74-193-.37-349.93-157.92-348.56-352.47C334.43,189.09,491.24,33.28,685.37,34,876.62,34.62,1032.94,191.67,1032.93,384.11ZM683,496.81q43.74,0,87.48,0c15.55,0,25.32-9.72,25.33-25.21q0-87.48,0-175c0-15.83-9.68-25.46-25.59-25.46H595.77c-15.88,0-25.57,9.64-25.58,25.46q0,87.23,0,174.45c0,16.18,9.59,25.7,25.84,25.71Z' transform='translate(-183.1 115.9)'/%3E%3Cpath class='cls-3' d='M683,496.81H596c-16.25,0-25.84-9.53-25.84-25.71q0-87.23,0-174.45c0-15.82,9.7-25.46,25.58-25.46H770.22c15.91,0,25.59,9.63,25.59,25.46q0,87.47,0,175c0,15.49-9.78,25.2-25.33,25.21Q726.74,496.84,683,496.81Z' transform='translate(-183.1 115.9)'/%3E%3C/svg%3E`;
    case "text":
      return r = (0.1 * e).toFixed(2), `data:image/svg+xml,%3Csvg width='${e}' height='${r}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 528.15 53.64'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052ff;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3ECoinbase_Wordmark_SubBrands_ALL%3C/title%3E%3Cpath class='cls-1' d='M164.45,15a15,15,0,0,0-11.74,5.4V0h-8.64V52.92h8.5V48a15,15,0,0,0,11.88,5.62c10.37,0,18.21-8.21,18.21-19.3S174.67,15,164.45,15Zm-1.3,30.67c-6.19,0-10.73-4.83-10.73-11.31S157,23,163.22,23s10.66,4.82,10.66,11.37S169.34,45.65,163.15,45.65Zm83.31-14.91-6.34-.93c-3-.43-5.18-1.44-5.18-3.82,0-2.59,2.8-3.89,6.62-3.89,4.18,0,6.84,1.8,7.42,4.76h8.35c-.94-7.49-6.7-11.88-15.55-11.88-9.15,0-15.2,4.68-15.2,11.3,0,6.34,4,10,12,11.16l6.33.94c3.1.43,4.83,1.65,4.83,4,0,2.95-3,4.17-7.2,4.17-5.12,0-8-2.09-8.43-5.25h-8.49c.79,7.27,6.48,12.38,16.84,12.38,9.44,0,15.7-4.32,15.7-11.74C258.12,35.28,253.58,31.82,246.46,30.74Zm-27.65-2.3c0-8.06-4.9-13.46-15.27-13.46-9.79,0-15.26,5-16.34,12.6h8.57c.43-3,2.73-5.4,7.63-5.4,4.39,0,6.55,1.94,6.55,4.32,0,3.09-4,3.88-8.85,4.39-6.63.72-14.84,3-14.84,11.66,0,6.7,5,11,12.89,11,6.19,0,10.08-2.59,12-6.7.28,3.67,3,6.05,6.84,6.05h5v-7.7h-4.25Zm-8.5,9.36c0,5-4.32,8.64-9.57,8.64-3.24,0-6-1.37-6-4.25,0-3.67,4.39-4.68,8.42-5.11s6-1.22,7.13-2.88ZM281.09,15c-11.09,0-19.23,8.35-19.23,19.36,0,11.6,8.72,19.3,19.37,19.3,9,0,16.06-5.33,17.86-12.89h-9c-1.3,3.31-4.47,5.19-8.71,5.19-5.55,0-9.72-3.46-10.66-9.51H299.3V33.12C299.3,22.46,291.53,15,281.09,15Zm-9.87,15.26c1.37-5.18,5.26-7.7,9.72-7.7,4.9,0,8.64,2.8,9.51,7.7ZM19.3,23a9.84,9.84,0,0,1,9.5,7h9.14c-1.65-8.93-9-15-18.57-15A19,19,0,0,0,0,34.34c0,11.09,8.28,19.3,19.37,19.3,9.36,0,16.85-6,18.5-15H28.8a9.75,9.75,0,0,1-9.43,7.06c-6.27,0-10.66-4.83-10.66-11.31S13,23,19.3,23Zm41.11-8A19,19,0,0,0,41,34.34c0,11.09,8.28,19.3,19.37,19.3A19,19,0,0,0,79.92,34.27C79.92,23.33,71.64,15,60.41,15Zm.07,30.67c-6.19,0-10.73-4.83-10.73-11.31S54.22,23,60.41,23s10.8,4.89,10.8,11.37S66.67,45.65,60.48,45.65ZM123.41,15c-5.62,0-9.29,2.3-11.45,5.54V15.7h-8.57V52.92H112V32.69C112,27,115.63,23,121,23c5,0,8.06,3.53,8.06,8.64V52.92h8.64V31C137.66,21.6,132.84,15,123.41,15ZM92,.36a5.36,5.36,0,0,0-5.55,5.47,5.55,5.55,0,0,0,11.09,0A5.35,5.35,0,0,0,92,.36Zm-9.72,23h5.4V52.92h8.64V15.7h-14Zm298.17-7.7L366.2,52.92H372L375.29,44H392l3.33,8.88h6L386.87,15.7ZM377,39.23l6.45-17.56h.1l6.56,17.56ZM362.66,15.7l-7.88,29h-.11l-8.14-29H341l-8,28.93h-.1l-8-28.87H319L329.82,53h5.45l8.19-29.24h.11L352,53h5.66L368.1,15.7Zm135.25,0v4.86h12.32V52.92h5.6V20.56h12.32V15.7ZM467.82,52.92h25.54V48.06H473.43v-12h18.35V31.35H473.43V20.56h19.93V15.7H467.82ZM443,15.7h-5.6V52.92h24.32V48.06H443Zm-30.45,0h-5.61V52.92h24.32V48.06H412.52Z'/%3E%3C/svg%3E`;
    case "textWithLogo":
      return r = (0.25 * e).toFixed(2), `data:image/svg+xml,%3Csvg width='${e}' height='${r}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 308.44 77.61'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052ff;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M142.94,20.2l-7.88,29H135l-8.15-29h-5.55l-8,28.93h-.11l-8-28.87H99.27l10.84,37.27h5.44l8.2-29.24h.1l8.41,29.24h5.66L148.39,20.2Zm17.82,0L146.48,57.42h5.82l3.28-8.88h16.65l3.34,8.88h6L167.16,20.2Zm-3.44,23.52,6.45-17.55h.11l6.56,17.55ZM278.2,20.2v4.86h12.32V57.42h5.6V25.06h12.32V20.2ZM248.11,57.42h25.54V52.55H253.71V40.61h18.35V35.85H253.71V25.06h19.94V20.2H248.11ZM223.26,20.2h-5.61V57.42H242V52.55H223.26Zm-30.46,0h-5.6V57.42h24.32V52.55H192.8Zm-154,38A19.41,19.41,0,1,1,57.92,35.57H77.47a38.81,38.81,0,1,0,0,6.47H57.92A19.39,19.39,0,0,1,38.81,58.21Z'/%3E%3C/svg%3E`;
    case "textLight":
      return r = (0.1 * e).toFixed(2), `data:image/svg+xml,%3Csvg width='${e}' height='${r}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 528.15 53.64'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fefefe;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3ECoinbase_Wordmark_SubBrands_ALL%3C/title%3E%3Cpath class='cls-1' d='M164.45,15a15,15,0,0,0-11.74,5.4V0h-8.64V52.92h8.5V48a15,15,0,0,0,11.88,5.62c10.37,0,18.21-8.21,18.21-19.3S174.67,15,164.45,15Zm-1.3,30.67c-6.19,0-10.73-4.83-10.73-11.31S157,23,163.22,23s10.66,4.82,10.66,11.37S169.34,45.65,163.15,45.65Zm83.31-14.91-6.34-.93c-3-.43-5.18-1.44-5.18-3.82,0-2.59,2.8-3.89,6.62-3.89,4.18,0,6.84,1.8,7.42,4.76h8.35c-.94-7.49-6.7-11.88-15.55-11.88-9.15,0-15.2,4.68-15.2,11.3,0,6.34,4,10,12,11.16l6.33.94c3.1.43,4.83,1.65,4.83,4,0,2.95-3,4.17-7.2,4.17-5.12,0-8-2.09-8.43-5.25h-8.49c.79,7.27,6.48,12.38,16.84,12.38,9.44,0,15.7-4.32,15.7-11.74C258.12,35.28,253.58,31.82,246.46,30.74Zm-27.65-2.3c0-8.06-4.9-13.46-15.27-13.46-9.79,0-15.26,5-16.34,12.6h8.57c.43-3,2.73-5.4,7.63-5.4,4.39,0,6.55,1.94,6.55,4.32,0,3.09-4,3.88-8.85,4.39-6.63.72-14.84,3-14.84,11.66,0,6.7,5,11,12.89,11,6.19,0,10.08-2.59,12-6.7.28,3.67,3,6.05,6.84,6.05h5v-7.7h-4.25Zm-8.5,9.36c0,5-4.32,8.64-9.57,8.64-3.24,0-6-1.37-6-4.25,0-3.67,4.39-4.68,8.42-5.11s6-1.22,7.13-2.88ZM281.09,15c-11.09,0-19.23,8.35-19.23,19.36,0,11.6,8.72,19.3,19.37,19.3,9,0,16.06-5.33,17.86-12.89h-9c-1.3,3.31-4.47,5.19-8.71,5.19-5.55,0-9.72-3.46-10.66-9.51H299.3V33.12C299.3,22.46,291.53,15,281.09,15Zm-9.87,15.26c1.37-5.18,5.26-7.7,9.72-7.7,4.9,0,8.64,2.8,9.51,7.7ZM19.3,23a9.84,9.84,0,0,1,9.5,7h9.14c-1.65-8.93-9-15-18.57-15A19,19,0,0,0,0,34.34c0,11.09,8.28,19.3,19.37,19.3,9.36,0,16.85-6,18.5-15H28.8a9.75,9.75,0,0,1-9.43,7.06c-6.27,0-10.66-4.83-10.66-11.31S13,23,19.3,23Zm41.11-8A19,19,0,0,0,41,34.34c0,11.09,8.28,19.3,19.37,19.3A19,19,0,0,0,79.92,34.27C79.92,23.33,71.64,15,60.41,15Zm.07,30.67c-6.19,0-10.73-4.83-10.73-11.31S54.22,23,60.41,23s10.8,4.89,10.8,11.37S66.67,45.65,60.48,45.65ZM123.41,15c-5.62,0-9.29,2.3-11.45,5.54V15.7h-8.57V52.92H112V32.69C112,27,115.63,23,121,23c5,0,8.06,3.53,8.06,8.64V52.92h8.64V31C137.66,21.6,132.84,15,123.41,15ZM92,.36a5.36,5.36,0,0,0-5.55,5.47,5.55,5.55,0,0,0,11.09,0A5.35,5.35,0,0,0,92,.36Zm-9.72,23h5.4V52.92h8.64V15.7h-14Zm298.17-7.7L366.2,52.92H372L375.29,44H392l3.33,8.88h6L386.87,15.7ZM377,39.23l6.45-17.56h.1l6.56,17.56ZM362.66,15.7l-7.88,29h-.11l-8.14-29H341l-8,28.93h-.1l-8-28.87H319L329.82,53h5.45l8.19-29.24h.11L352,53h5.66L368.1,15.7Zm135.25,0v4.86h12.32V52.92h5.6V20.56h12.32V15.7ZM467.82,52.92h25.54V48.06H473.43v-12h18.35V31.35H473.43V20.56h19.93V15.7H467.82ZM443,15.7h-5.6V52.92h24.32V48.06H443Zm-30.45,0h-5.61V52.92h24.32V48.06H412.52Z'/%3E%3C/svg%3E`;
    case "textWithLogoLight":
      return r = (0.25 * e).toFixed(2), `data:image/svg+xml,%3Csvg width='${e}' height='${r}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 308.44 77.61'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fefefe;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M142.94,20.2l-7.88,29H135l-8.15-29h-5.55l-8,28.93h-.11l-8-28.87H99.27l10.84,37.27h5.44l8.2-29.24h.1l8.41,29.24h5.66L148.39,20.2Zm17.82,0L146.48,57.42h5.82l3.28-8.88h16.65l3.34,8.88h6L167.16,20.2Zm-3.44,23.52,6.45-17.55h.11l6.56,17.55ZM278.2,20.2v4.86h12.32V57.42h5.6V25.06h12.32V20.2ZM248.11,57.42h25.54V52.55H253.71V40.61h18.35V35.85H253.71V25.06h19.94V20.2H248.11ZM223.26,20.2h-5.61V57.42H242V52.55H223.26Zm-30.46,0h-5.6V57.42h24.32V52.55H192.8Zm-154,38A19.41,19.41,0,1,1,57.92,35.57H77.47a38.81,38.81,0,1,0,0,6.47H57.92A19.39,19.39,0,0,1,38.81,58.21Z'/%3E%3C/svg%3E`;
    default:
      return r = e, `data:image/svg+xml,%3Csvg width='${e}' height='${r}' viewBox='0 0 1024 1024' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect width='1024' height='1024' fill='%230052FF'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M152 512C152 710.823 313.177 872 512 872C710.823 872 872 710.823 872 512C872 313.177 710.823 152 512 152C313.177 152 152 313.177 152 512ZM420 396C406.745 396 396 406.745 396 420V604C396 617.255 406.745 628 420 628H604C617.255 628 628 617.255 628 604V420C628 406.745 617.255 396 604 396H420Z' fill='white'/%3E %3C/svg%3E `;
  }
};
V0.walletLogo = $k;
var G0 = {};
Object.defineProperty(G0, "__esModule", { value: !0 });
G0.ScopedLocalStorage = void 0;
class qk {
  constructor(e) {
    this.scope = e;
  }
  setItem(e, r) {
    localStorage.setItem(this.scopedKey(e), r);
  }
  getItem(e) {
    return localStorage.getItem(this.scopedKey(e));
  }
  removeItem(e) {
    localStorage.removeItem(this.scopedKey(e));
  }
  clear() {
    const e = this.scopedKey(""), r = [];
    for (let i = 0; i < localStorage.length; i++) {
      const s = localStorage.key(i);
      typeof s == "string" && s.startsWith(e) && r.push(s);
    }
    r.forEach((i) => localStorage.removeItem(i));
  }
  scopedKey(e) {
    return `${this.scope}:${e}`;
  }
}
G0.ScopedLocalStorage = qk;
var bc = {}, kc = {};
Object.defineProperty(kc, "__esModule", { value: !0 });
const Hk = Pr.exports;
function X_(t, e, r) {
  try {
    Reflect.apply(t, e, r);
  } catch (i) {
    setTimeout(() => {
      throw i;
    });
  }
}
function Wk(t) {
  const e = t.length, r = new Array(e);
  for (let i = 0; i < e; i += 1)
    r[i] = t[i];
  return r;
}
class Vk extends Hk.EventEmitter {
  emit(e, ...r) {
    let i = e === "error";
    const s = this._events;
    if (s !== void 0)
      i = i && s.error === void 0;
    else if (!i)
      return !1;
    if (i) {
      let f;
      if (r.length > 0 && ([f] = r), f instanceof Error)
        throw f;
      const u = new Error(`Unhandled error.${f ? ` (${f.message})` : ""}`);
      throw u.context = f, u;
    }
    const n = s[e];
    if (n === void 0)
      return !1;
    if (typeof n == "function")
      X_(n, this, r);
    else {
      const f = n.length, u = Wk(n);
      for (let h = 0; h < f; h += 1)
        X_(u[h], this, r);
    }
    return !0;
  }
}
kc.default = Vk;
var Ih = { exports: {} };
const Gk = {}, Kk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gk
}, Symbol.toStringTag, { value: "Module" })), dn = /* @__PURE__ */ pf(Kk);
(function(t) {
  (function(e, r) {
    function i(g, a) {
      if (!g)
        throw new Error(a || "Assertion failed");
    }
    function s(g, a) {
      g.super_ = a;
      var c = function() {
      };
      c.prototype = a.prototype, g.prototype = new c(), g.prototype.constructor = g;
    }
    function n(g, a, c) {
      if (n.isBN(g))
        return g;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, g !== null && ((a === "le" || a === "be") && (c = a, a = 10), this._init(g || 0, a || 10, c || "be"));
    }
    typeof e == "object" ? e.exports = n : r.BN = n, n.BN = n, n.wordSize = 26;
    var f;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? f = window.Buffer : f = dn.Buffer;
    } catch {
    }
    n.isBN = function(a) {
      return a instanceof n ? !0 : a !== null && typeof a == "object" && a.constructor.wordSize === n.wordSize && Array.isArray(a.words);
    }, n.max = function(a, c) {
      return a.cmp(c) > 0 ? a : c;
    }, n.min = function(a, c) {
      return a.cmp(c) < 0 ? a : c;
    }, n.prototype._init = function(a, c, p) {
      if (typeof a == "number")
        return this._initNumber(a, c, p);
      if (typeof a == "object")
        return this._initArray(a, c, p);
      c === "hex" && (c = 16), i(c === (c | 0) && c >= 2 && c <= 36), a = a.toString().replace(/\s+/g, "");
      var w = 0;
      a[0] === "-" && (w++, this.negative = 1), w < a.length && (c === 16 ? this._parseHex(a, w, p) : (this._parseBase(a, c, w), p === "le" && this._initArray(this.toArray(), c, p)));
    }, n.prototype._initNumber = function(a, c, p) {
      a < 0 && (this.negative = 1, a = -a), a < 67108864 ? (this.words = [a & 67108863], this.length = 1) : a < 4503599627370496 ? (this.words = [
        a & 67108863,
        a / 67108864 & 67108863
      ], this.length = 2) : (i(a < 9007199254740992), this.words = [
        a & 67108863,
        a / 67108864 & 67108863,
        1
      ], this.length = 3), p === "le" && this._initArray(this.toArray(), c, p);
    }, n.prototype._initArray = function(a, c, p) {
      if (i(typeof a.length == "number"), a.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(a.length / 3), this.words = new Array(this.length);
      for (var w = 0; w < this.length; w++)
        this.words[w] = 0;
      var _, x, E = 0;
      if (p === "be")
        for (w = a.length - 1, _ = 0; w >= 0; w -= 3)
          x = a[w] | a[w - 1] << 8 | a[w - 2] << 16, this.words[_] |= x << E & 67108863, this.words[_ + 1] = x >>> 26 - E & 67108863, E += 24, E >= 26 && (E -= 26, _++);
      else if (p === "le")
        for (w = 0, _ = 0; w < a.length; w += 3)
          x = a[w] | a[w + 1] << 8 | a[w + 2] << 16, this.words[_] |= x << E & 67108863, this.words[_ + 1] = x >>> 26 - E & 67108863, E += 24, E >= 26 && (E -= 26, _++);
      return this._strip();
    };
    function u(g, a) {
      var c = g.charCodeAt(a);
      if (c >= 48 && c <= 57)
        return c - 48;
      if (c >= 65 && c <= 70)
        return c - 55;
      if (c >= 97 && c <= 102)
        return c - 87;
      i(!1, "Invalid character in " + g);
    }
    function h(g, a, c) {
      var p = u(g, c);
      return c - 1 >= a && (p |= u(g, c - 1) << 4), p;
    }
    n.prototype._parseHex = function(a, c, p) {
      this.length = Math.ceil((a.length - c) / 6), this.words = new Array(this.length);
      for (var w = 0; w < this.length; w++)
        this.words[w] = 0;
      var _ = 0, x = 0, E;
      if (p === "be")
        for (w = a.length - 1; w >= c; w -= 2)
          E = h(a, c, w) << _, this.words[x] |= E & 67108863, _ >= 18 ? (_ -= 18, x += 1, this.words[x] |= E >>> 26) : _ += 8;
      else {
        var y = a.length - c;
        for (w = y % 2 === 0 ? c + 1 : c; w < a.length; w += 2)
          E = h(a, c, w) << _, this.words[x] |= E & 67108863, _ >= 18 ? (_ -= 18, x += 1, this.words[x] |= E >>> 26) : _ += 8;
      }
      this._strip();
    };
    function d(g, a, c, p) {
      for (var w = 0, _ = 0, x = Math.min(g.length, c), E = a; E < x; E++) {
        var y = g.charCodeAt(E) - 48;
        w *= p, y >= 49 ? _ = y - 49 + 10 : y >= 17 ? _ = y - 17 + 10 : _ = y, i(y >= 0 && _ < p, "Invalid character"), w += _;
      }
      return w;
    }
    n.prototype._parseBase = function(a, c, p) {
      this.words = [0], this.length = 1;
      for (var w = 0, _ = 1; _ <= 67108863; _ *= c)
        w++;
      w--, _ = _ / c | 0;
      for (var x = a.length - p, E = x % w, y = Math.min(x, x - E) + p, o = 0, S = p; S < y; S += w)
        o = d(a, S, S + w, c), this.imuln(_), this.words[0] + o < 67108864 ? this.words[0] += o : this._iaddn(o);
      if (E !== 0) {
        var J = 1;
        for (o = d(a, S, a.length, c), S = 0; S < E; S++)
          J *= c;
        this.imuln(J), this.words[0] + o < 67108864 ? this.words[0] += o : this._iaddn(o);
      }
      this._strip();
    }, n.prototype.copy = function(a) {
      a.words = new Array(this.length);
      for (var c = 0; c < this.length; c++)
        a.words[c] = this.words[c];
      a.length = this.length, a.negative = this.negative, a.red = this.red;
    };
    function l(g, a) {
      g.words = a.words, g.length = a.length, g.negative = a.negative, g.red = a.red;
    }
    if (n.prototype._move = function(a) {
      l(a, this);
    }, n.prototype.clone = function() {
      var a = new n(null);
      return this.copy(a), a;
    }, n.prototype._expand = function(a) {
      for (; this.length < a; )
        this.words[this.length++] = 0;
      return this;
    }, n.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, n.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        n.prototype[Symbol.for("nodejs.util.inspect.custom")] = m;
      } catch {
        n.prototype.inspect = m;
      }
    else
      n.prototype.inspect = m;
    function m() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var b = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], M = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], A = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    n.prototype.toString = function(a, c) {
      a = a || 10, c = c | 0 || 1;
      var p;
      if (a === 16 || a === "hex") {
        p = "";
        for (var w = 0, _ = 0, x = 0; x < this.length; x++) {
          var E = this.words[x], y = ((E << w | _) & 16777215).toString(16);
          _ = E >>> 24 - w & 16777215, _ !== 0 || x !== this.length - 1 ? p = b[6 - y.length] + y + p : p = y + p, w += 2, w >= 26 && (w -= 26, x--);
        }
        for (_ !== 0 && (p = _.toString(16) + p); p.length % c !== 0; )
          p = "0" + p;
        return this.negative !== 0 && (p = "-" + p), p;
      }
      if (a === (a | 0) && a >= 2 && a <= 36) {
        var o = M[a], S = A[a];
        p = "";
        var J = this.clone();
        for (J.negative = 0; !J.isZero(); ) {
          var z = J.modrn(S).toString(a);
          J = J.idivn(S), J.isZero() ? p = z + p : p = b[o - z.length] + z + p;
        }
        for (this.isZero() && (p = "0" + p); p.length % c !== 0; )
          p = "0" + p;
        return this.negative !== 0 && (p = "-" + p), p;
      }
      i(!1, "Base should be between 2 and 36");
    }, n.prototype.toNumber = function() {
      var a = this.words[0];
      return this.length === 2 ? a += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? a += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -a : a;
    }, n.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, f && (n.prototype.toBuffer = function(a, c) {
      return this.toArrayLike(f, a, c);
    }), n.prototype.toArray = function(a, c) {
      return this.toArrayLike(Array, a, c);
    };
    var N = function(a, c) {
      return a.allocUnsafe ? a.allocUnsafe(c) : new a(c);
    };
    n.prototype.toArrayLike = function(a, c, p) {
      this._strip();
      var w = this.byteLength(), _ = p || Math.max(1, w);
      i(w <= _, "byte array longer than desired length"), i(_ > 0, "Requested array length <= 0");
      var x = N(a, _), E = c === "le" ? "LE" : "BE";
      return this["_toArrayLike" + E](x, w), x;
    }, n.prototype._toArrayLikeLE = function(a, c) {
      for (var p = 0, w = 0, _ = 0, x = 0; _ < this.length; _++) {
        var E = this.words[_] << x | w;
        a[p++] = E & 255, p < a.length && (a[p++] = E >> 8 & 255), p < a.length && (a[p++] = E >> 16 & 255), x === 6 ? (p < a.length && (a[p++] = E >> 24 & 255), w = 0, x = 0) : (w = E >>> 24, x += 2);
      }
      if (p < a.length)
        for (a[p++] = w; p < a.length; )
          a[p++] = 0;
    }, n.prototype._toArrayLikeBE = function(a, c) {
      for (var p = a.length - 1, w = 0, _ = 0, x = 0; _ < this.length; _++) {
        var E = this.words[_] << x | w;
        a[p--] = E & 255, p >= 0 && (a[p--] = E >> 8 & 255), p >= 0 && (a[p--] = E >> 16 & 255), x === 6 ? (p >= 0 && (a[p--] = E >> 24 & 255), w = 0, x = 0) : (w = E >>> 24, x += 2);
      }
      if (p >= 0)
        for (a[p--] = w; p >= 0; )
          a[p--] = 0;
    }, Math.clz32 ? n.prototype._countBits = function(a) {
      return 32 - Math.clz32(a);
    } : n.prototype._countBits = function(a) {
      var c = a, p = 0;
      return c >= 4096 && (p += 13, c >>>= 13), c >= 64 && (p += 7, c >>>= 7), c >= 8 && (p += 4, c >>>= 4), c >= 2 && (p += 2, c >>>= 2), p + c;
    }, n.prototype._zeroBits = function(a) {
      if (a === 0)
        return 26;
      var c = a, p = 0;
      return (c & 8191) === 0 && (p += 13, c >>>= 13), (c & 127) === 0 && (p += 7, c >>>= 7), (c & 15) === 0 && (p += 4, c >>>= 4), (c & 3) === 0 && (p += 2, c >>>= 2), (c & 1) === 0 && p++, p;
    }, n.prototype.bitLength = function() {
      var a = this.words[this.length - 1], c = this._countBits(a);
      return (this.length - 1) * 26 + c;
    };
    function R(g) {
      for (var a = new Array(g.bitLength()), c = 0; c < a.length; c++) {
        var p = c / 26 | 0, w = c % 26;
        a[c] = g.words[p] >>> w & 1;
      }
      return a;
    }
    n.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var a = 0, c = 0; c < this.length; c++) {
        var p = this._zeroBits(this.words[c]);
        if (a += p, p !== 26)
          break;
      }
      return a;
    }, n.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, n.prototype.toTwos = function(a) {
      return this.negative !== 0 ? this.abs().inotn(a).iaddn(1) : this.clone();
    }, n.prototype.fromTwos = function(a) {
      return this.testn(a - 1) ? this.notn(a).iaddn(1).ineg() : this.clone();
    }, n.prototype.isNeg = function() {
      return this.negative !== 0;
    }, n.prototype.neg = function() {
      return this.clone().ineg();
    }, n.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, n.prototype.iuor = function(a) {
      for (; this.length < a.length; )
        this.words[this.length++] = 0;
      for (var c = 0; c < a.length; c++)
        this.words[c] = this.words[c] | a.words[c];
      return this._strip();
    }, n.prototype.ior = function(a) {
      return i((this.negative | a.negative) === 0), this.iuor(a);
    }, n.prototype.or = function(a) {
      return this.length > a.length ? this.clone().ior(a) : a.clone().ior(this);
    }, n.prototype.uor = function(a) {
      return this.length > a.length ? this.clone().iuor(a) : a.clone().iuor(this);
    }, n.prototype.iuand = function(a) {
      var c;
      this.length > a.length ? c = a : c = this;
      for (var p = 0; p < c.length; p++)
        this.words[p] = this.words[p] & a.words[p];
      return this.length = c.length, this._strip();
    }, n.prototype.iand = function(a) {
      return i((this.negative | a.negative) === 0), this.iuand(a);
    }, n.prototype.and = function(a) {
      return this.length > a.length ? this.clone().iand(a) : a.clone().iand(this);
    }, n.prototype.uand = function(a) {
      return this.length > a.length ? this.clone().iuand(a) : a.clone().iuand(this);
    }, n.prototype.iuxor = function(a) {
      var c, p;
      this.length > a.length ? (c = this, p = a) : (c = a, p = this);
      for (var w = 0; w < p.length; w++)
        this.words[w] = c.words[w] ^ p.words[w];
      if (this !== c)
        for (; w < c.length; w++)
          this.words[w] = c.words[w];
      return this.length = c.length, this._strip();
    }, n.prototype.ixor = function(a) {
      return i((this.negative | a.negative) === 0), this.iuxor(a);
    }, n.prototype.xor = function(a) {
      return this.length > a.length ? this.clone().ixor(a) : a.clone().ixor(this);
    }, n.prototype.uxor = function(a) {
      return this.length > a.length ? this.clone().iuxor(a) : a.clone().iuxor(this);
    }, n.prototype.inotn = function(a) {
      i(typeof a == "number" && a >= 0);
      var c = Math.ceil(a / 26) | 0, p = a % 26;
      this._expand(c), p > 0 && c--;
      for (var w = 0; w < c; w++)
        this.words[w] = ~this.words[w] & 67108863;
      return p > 0 && (this.words[w] = ~this.words[w] & 67108863 >> 26 - p), this._strip();
    }, n.prototype.notn = function(a) {
      return this.clone().inotn(a);
    }, n.prototype.setn = function(a, c) {
      i(typeof a == "number" && a >= 0);
      var p = a / 26 | 0, w = a % 26;
      return this._expand(p + 1), c ? this.words[p] = this.words[p] | 1 << w : this.words[p] = this.words[p] & ~(1 << w), this._strip();
    }, n.prototype.iadd = function(a) {
      var c;
      if (this.negative !== 0 && a.negative === 0)
        return this.negative = 0, c = this.isub(a), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && a.negative !== 0)
        return a.negative = 0, c = this.isub(a), a.negative = 1, c._normSign();
      var p, w;
      this.length > a.length ? (p = this, w = a) : (p = a, w = this);
      for (var _ = 0, x = 0; x < w.length; x++)
        c = (p.words[x] | 0) + (w.words[x] | 0) + _, this.words[x] = c & 67108863, _ = c >>> 26;
      for (; _ !== 0 && x < p.length; x++)
        c = (p.words[x] | 0) + _, this.words[x] = c & 67108863, _ = c >>> 26;
      if (this.length = p.length, _ !== 0)
        this.words[this.length] = _, this.length++;
      else if (p !== this)
        for (; x < p.length; x++)
          this.words[x] = p.words[x];
      return this;
    }, n.prototype.add = function(a) {
      var c;
      return a.negative !== 0 && this.negative === 0 ? (a.negative = 0, c = this.sub(a), a.negative ^= 1, c) : a.negative === 0 && this.negative !== 0 ? (this.negative = 0, c = a.sub(this), this.negative = 1, c) : this.length > a.length ? this.clone().iadd(a) : a.clone().iadd(this);
    }, n.prototype.isub = function(a) {
      if (a.negative !== 0) {
        a.negative = 0;
        var c = this.iadd(a);
        return a.negative = 1, c._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(a), this.negative = 1, this._normSign();
      var p = this.cmp(a);
      if (p === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var w, _;
      p > 0 ? (w = this, _ = a) : (w = a, _ = this);
      for (var x = 0, E = 0; E < _.length; E++)
        c = (w.words[E] | 0) - (_.words[E] | 0) + x, x = c >> 26, this.words[E] = c & 67108863;
      for (; x !== 0 && E < w.length; E++)
        c = (w.words[E] | 0) + x, x = c >> 26, this.words[E] = c & 67108863;
      if (x === 0 && E < w.length && w !== this)
        for (; E < w.length; E++)
          this.words[E] = w.words[E];
      return this.length = Math.max(this.length, E), w !== this && (this.negative = 1), this._strip();
    }, n.prototype.sub = function(a) {
      return this.clone().isub(a);
    };
    function O(g, a, c) {
      c.negative = a.negative ^ g.negative;
      var p = g.length + a.length | 0;
      c.length = p, p = p - 1 | 0;
      var w = g.words[0] | 0, _ = a.words[0] | 0, x = w * _, E = x & 67108863, y = x / 67108864 | 0;
      c.words[0] = E;
      for (var o = 1; o < p; o++) {
        for (var S = y >>> 26, J = y & 67108863, z = Math.min(o, a.length - 1), k = Math.max(0, o - g.length + 1); k <= z; k++) {
          var j = o - k | 0;
          w = g.words[j] | 0, _ = a.words[k] | 0, x = w * _ + J, S += x / 67108864 | 0, J = x & 67108863;
        }
        c.words[o] = J | 0, y = S | 0;
      }
      return y !== 0 ? c.words[o] = y | 0 : c.length--, c._strip();
    }
    var P = function(a, c, p) {
      var w = a.words, _ = c.words, x = p.words, E = 0, y, o, S, J = w[0] | 0, z = J & 8191, k = J >>> 13, j = w[1] | 0, q = j & 8191, K = j >>> 13, U = w[2] | 0, T = U & 8191, D = U >>> 13, te = w[3] | 0, ne = te & 8191, le = te >>> 13, X = w[4] | 0, $ = X & 8191, V = X >>> 13, re = w[5] | 0, fe = re & 8191, ue = re >>> 13, me = w[6] | 0, be = me & 8191, ve = me >>> 13, Ge = w[7] | 0, ye = Ge & 8191, pe = Ge >>> 13, Je = w[8] | 0, Ie = Je & 8191, we = Je >>> 13, at = w[9] | 0, Oe = at & 8191, Ee = at >>> 13, ft = _[0] | 0, Le = ft & 8191, Pe = ft >>> 13, Mt = _[1] | 0, Ve = Mt & 8191, ke = Mt >>> 13, Et = _[2] | 0, Ke = Et & 8191, Be = Et >>> 13, dt = _[3] | 0, ze = dt & 8191, Te = dt >>> 13, pt = _[4] | 0, Fe = pt & 8191, Ae = pt >>> 13, bt = _[5] | 0, He = bt & 8191, Ne = bt >>> 13, yt = _[6] | 0, $e = yt & 8191, De = yt >>> 13, vt = _[7] | 0, je = vt & 8191, Ce = vt >>> 13, mt = _[8] | 0, Ze = mt & 8191, qe = mt >>> 13, Dt = _[9] | 0, We = Dt & 8191, Qe = Dt >>> 13;
      p.negative = a.negative ^ c.negative, p.length = 19, y = Math.imul(z, Le), o = Math.imul(z, Pe), o = o + Math.imul(k, Le) | 0, S = Math.imul(k, Pe);
      var Qt = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Qt >>> 26) | 0, Qt &= 67108863, y = Math.imul(q, Le), o = Math.imul(q, Pe), o = o + Math.imul(K, Le) | 0, S = Math.imul(K, Pe), y = y + Math.imul(z, Ve) | 0, o = o + Math.imul(z, ke) | 0, o = o + Math.imul(k, Ve) | 0, S = S + Math.imul(k, ke) | 0;
      var Zt = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Zt >>> 26) | 0, Zt &= 67108863, y = Math.imul(T, Le), o = Math.imul(T, Pe), o = o + Math.imul(D, Le) | 0, S = Math.imul(D, Pe), y = y + Math.imul(q, Ve) | 0, o = o + Math.imul(q, ke) | 0, o = o + Math.imul(K, Ve) | 0, S = S + Math.imul(K, ke) | 0, y = y + Math.imul(z, Ke) | 0, o = o + Math.imul(z, Be) | 0, o = o + Math.imul(k, Ke) | 0, S = S + Math.imul(k, Be) | 0;
      var Jt = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Jt >>> 26) | 0, Jt &= 67108863, y = Math.imul(ne, Le), o = Math.imul(ne, Pe), o = o + Math.imul(le, Le) | 0, S = Math.imul(le, Pe), y = y + Math.imul(T, Ve) | 0, o = o + Math.imul(T, ke) | 0, o = o + Math.imul(D, Ve) | 0, S = S + Math.imul(D, ke) | 0, y = y + Math.imul(q, Ke) | 0, o = o + Math.imul(q, Be) | 0, o = o + Math.imul(K, Ke) | 0, S = S + Math.imul(K, Be) | 0, y = y + Math.imul(z, ze) | 0, o = o + Math.imul(z, Te) | 0, o = o + Math.imul(k, ze) | 0, S = S + Math.imul(k, Te) | 0;
      var Xt = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Xt >>> 26) | 0, Xt &= 67108863, y = Math.imul($, Le), o = Math.imul($, Pe), o = o + Math.imul(V, Le) | 0, S = Math.imul(V, Pe), y = y + Math.imul(ne, Ve) | 0, o = o + Math.imul(ne, ke) | 0, o = o + Math.imul(le, Ve) | 0, S = S + Math.imul(le, ke) | 0, y = y + Math.imul(T, Ke) | 0, o = o + Math.imul(T, Be) | 0, o = o + Math.imul(D, Ke) | 0, S = S + Math.imul(D, Be) | 0, y = y + Math.imul(q, ze) | 0, o = o + Math.imul(q, Te) | 0, o = o + Math.imul(K, ze) | 0, S = S + Math.imul(K, Te) | 0, y = y + Math.imul(z, Fe) | 0, o = o + Math.imul(z, Ae) | 0, o = o + Math.imul(k, Fe) | 0, S = S + Math.imul(k, Ae) | 0;
      var kt = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, y = Math.imul(fe, Le), o = Math.imul(fe, Pe), o = o + Math.imul(ue, Le) | 0, S = Math.imul(ue, Pe), y = y + Math.imul($, Ve) | 0, o = o + Math.imul($, ke) | 0, o = o + Math.imul(V, Ve) | 0, S = S + Math.imul(V, ke) | 0, y = y + Math.imul(ne, Ke) | 0, o = o + Math.imul(ne, Be) | 0, o = o + Math.imul(le, Ke) | 0, S = S + Math.imul(le, Be) | 0, y = y + Math.imul(T, ze) | 0, o = o + Math.imul(T, Te) | 0, o = o + Math.imul(D, ze) | 0, S = S + Math.imul(D, Te) | 0, y = y + Math.imul(q, Fe) | 0, o = o + Math.imul(q, Ae) | 0, o = o + Math.imul(K, Fe) | 0, S = S + Math.imul(K, Ae) | 0, y = y + Math.imul(z, He) | 0, o = o + Math.imul(z, Ne) | 0, o = o + Math.imul(k, He) | 0, S = S + Math.imul(k, Ne) | 0;
      var ar = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (ar >>> 26) | 0, ar &= 67108863, y = Math.imul(be, Le), o = Math.imul(be, Pe), o = o + Math.imul(ve, Le) | 0, S = Math.imul(ve, Pe), y = y + Math.imul(fe, Ve) | 0, o = o + Math.imul(fe, ke) | 0, o = o + Math.imul(ue, Ve) | 0, S = S + Math.imul(ue, ke) | 0, y = y + Math.imul($, Ke) | 0, o = o + Math.imul($, Be) | 0, o = o + Math.imul(V, Ke) | 0, S = S + Math.imul(V, Be) | 0, y = y + Math.imul(ne, ze) | 0, o = o + Math.imul(ne, Te) | 0, o = o + Math.imul(le, ze) | 0, S = S + Math.imul(le, Te) | 0, y = y + Math.imul(T, Fe) | 0, o = o + Math.imul(T, Ae) | 0, o = o + Math.imul(D, Fe) | 0, S = S + Math.imul(D, Ae) | 0, y = y + Math.imul(q, He) | 0, o = o + Math.imul(q, Ne) | 0, o = o + Math.imul(K, He) | 0, S = S + Math.imul(K, Ne) | 0, y = y + Math.imul(z, $e) | 0, o = o + Math.imul(z, De) | 0, o = o + Math.imul(k, $e) | 0, S = S + Math.imul(k, De) | 0;
      var lr = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (lr >>> 26) | 0, lr &= 67108863, y = Math.imul(ye, Le), o = Math.imul(ye, Pe), o = o + Math.imul(pe, Le) | 0, S = Math.imul(pe, Pe), y = y + Math.imul(be, Ve) | 0, o = o + Math.imul(be, ke) | 0, o = o + Math.imul(ve, Ve) | 0, S = S + Math.imul(ve, ke) | 0, y = y + Math.imul(fe, Ke) | 0, o = o + Math.imul(fe, Be) | 0, o = o + Math.imul(ue, Ke) | 0, S = S + Math.imul(ue, Be) | 0, y = y + Math.imul($, ze) | 0, o = o + Math.imul($, Te) | 0, o = o + Math.imul(V, ze) | 0, S = S + Math.imul(V, Te) | 0, y = y + Math.imul(ne, Fe) | 0, o = o + Math.imul(ne, Ae) | 0, o = o + Math.imul(le, Fe) | 0, S = S + Math.imul(le, Ae) | 0, y = y + Math.imul(T, He) | 0, o = o + Math.imul(T, Ne) | 0, o = o + Math.imul(D, He) | 0, S = S + Math.imul(D, Ne) | 0, y = y + Math.imul(q, $e) | 0, o = o + Math.imul(q, De) | 0, o = o + Math.imul(K, $e) | 0, S = S + Math.imul(K, De) | 0, y = y + Math.imul(z, je) | 0, o = o + Math.imul(z, Ce) | 0, o = o + Math.imul(k, je) | 0, S = S + Math.imul(k, Ce) | 0;
      var or = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (or >>> 26) | 0, or &= 67108863, y = Math.imul(Ie, Le), o = Math.imul(Ie, Pe), o = o + Math.imul(we, Le) | 0, S = Math.imul(we, Pe), y = y + Math.imul(ye, Ve) | 0, o = o + Math.imul(ye, ke) | 0, o = o + Math.imul(pe, Ve) | 0, S = S + Math.imul(pe, ke) | 0, y = y + Math.imul(be, Ke) | 0, o = o + Math.imul(be, Be) | 0, o = o + Math.imul(ve, Ke) | 0, S = S + Math.imul(ve, Be) | 0, y = y + Math.imul(fe, ze) | 0, o = o + Math.imul(fe, Te) | 0, o = o + Math.imul(ue, ze) | 0, S = S + Math.imul(ue, Te) | 0, y = y + Math.imul($, Fe) | 0, o = o + Math.imul($, Ae) | 0, o = o + Math.imul(V, Fe) | 0, S = S + Math.imul(V, Ae) | 0, y = y + Math.imul(ne, He) | 0, o = o + Math.imul(ne, Ne) | 0, o = o + Math.imul(le, He) | 0, S = S + Math.imul(le, Ne) | 0, y = y + Math.imul(T, $e) | 0, o = o + Math.imul(T, De) | 0, o = o + Math.imul(D, $e) | 0, S = S + Math.imul(D, De) | 0, y = y + Math.imul(q, je) | 0, o = o + Math.imul(q, Ce) | 0, o = o + Math.imul(K, je) | 0, S = S + Math.imul(K, Ce) | 0, y = y + Math.imul(z, Ze) | 0, o = o + Math.imul(z, qe) | 0, o = o + Math.imul(k, Ze) | 0, S = S + Math.imul(k, qe) | 0;
      var dr = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (dr >>> 26) | 0, dr &= 67108863, y = Math.imul(Oe, Le), o = Math.imul(Oe, Pe), o = o + Math.imul(Ee, Le) | 0, S = Math.imul(Ee, Pe), y = y + Math.imul(Ie, Ve) | 0, o = o + Math.imul(Ie, ke) | 0, o = o + Math.imul(we, Ve) | 0, S = S + Math.imul(we, ke) | 0, y = y + Math.imul(ye, Ke) | 0, o = o + Math.imul(ye, Be) | 0, o = o + Math.imul(pe, Ke) | 0, S = S + Math.imul(pe, Be) | 0, y = y + Math.imul(be, ze) | 0, o = o + Math.imul(be, Te) | 0, o = o + Math.imul(ve, ze) | 0, S = S + Math.imul(ve, Te) | 0, y = y + Math.imul(fe, Fe) | 0, o = o + Math.imul(fe, Ae) | 0, o = o + Math.imul(ue, Fe) | 0, S = S + Math.imul(ue, Ae) | 0, y = y + Math.imul($, He) | 0, o = o + Math.imul($, Ne) | 0, o = o + Math.imul(V, He) | 0, S = S + Math.imul(V, Ne) | 0, y = y + Math.imul(ne, $e) | 0, o = o + Math.imul(ne, De) | 0, o = o + Math.imul(le, $e) | 0, S = S + Math.imul(le, De) | 0, y = y + Math.imul(T, je) | 0, o = o + Math.imul(T, Ce) | 0, o = o + Math.imul(D, je) | 0, S = S + Math.imul(D, Ce) | 0, y = y + Math.imul(q, Ze) | 0, o = o + Math.imul(q, qe) | 0, o = o + Math.imul(K, Ze) | 0, S = S + Math.imul(K, qe) | 0, y = y + Math.imul(z, We) | 0, o = o + Math.imul(z, Qe) | 0, o = o + Math.imul(k, We) | 0, S = S + Math.imul(k, Qe) | 0;
      var pr = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (pr >>> 26) | 0, pr &= 67108863, y = Math.imul(Oe, Ve), o = Math.imul(Oe, ke), o = o + Math.imul(Ee, Ve) | 0, S = Math.imul(Ee, ke), y = y + Math.imul(Ie, Ke) | 0, o = o + Math.imul(Ie, Be) | 0, o = o + Math.imul(we, Ke) | 0, S = S + Math.imul(we, Be) | 0, y = y + Math.imul(ye, ze) | 0, o = o + Math.imul(ye, Te) | 0, o = o + Math.imul(pe, ze) | 0, S = S + Math.imul(pe, Te) | 0, y = y + Math.imul(be, Fe) | 0, o = o + Math.imul(be, Ae) | 0, o = o + Math.imul(ve, Fe) | 0, S = S + Math.imul(ve, Ae) | 0, y = y + Math.imul(fe, He) | 0, o = o + Math.imul(fe, Ne) | 0, o = o + Math.imul(ue, He) | 0, S = S + Math.imul(ue, Ne) | 0, y = y + Math.imul($, $e) | 0, o = o + Math.imul($, De) | 0, o = o + Math.imul(V, $e) | 0, S = S + Math.imul(V, De) | 0, y = y + Math.imul(ne, je) | 0, o = o + Math.imul(ne, Ce) | 0, o = o + Math.imul(le, je) | 0, S = S + Math.imul(le, Ce) | 0, y = y + Math.imul(T, Ze) | 0, o = o + Math.imul(T, qe) | 0, o = o + Math.imul(D, Ze) | 0, S = S + Math.imul(D, qe) | 0, y = y + Math.imul(q, We) | 0, o = o + Math.imul(q, Qe) | 0, o = o + Math.imul(K, We) | 0, S = S + Math.imul(K, Qe) | 0;
      var fr = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (fr >>> 26) | 0, fr &= 67108863, y = Math.imul(Oe, Ke), o = Math.imul(Oe, Be), o = o + Math.imul(Ee, Ke) | 0, S = Math.imul(Ee, Be), y = y + Math.imul(Ie, ze) | 0, o = o + Math.imul(Ie, Te) | 0, o = o + Math.imul(we, ze) | 0, S = S + Math.imul(we, Te) | 0, y = y + Math.imul(ye, Fe) | 0, o = o + Math.imul(ye, Ae) | 0, o = o + Math.imul(pe, Fe) | 0, S = S + Math.imul(pe, Ae) | 0, y = y + Math.imul(be, He) | 0, o = o + Math.imul(be, Ne) | 0, o = o + Math.imul(ve, He) | 0, S = S + Math.imul(ve, Ne) | 0, y = y + Math.imul(fe, $e) | 0, o = o + Math.imul(fe, De) | 0, o = o + Math.imul(ue, $e) | 0, S = S + Math.imul(ue, De) | 0, y = y + Math.imul($, je) | 0, o = o + Math.imul($, Ce) | 0, o = o + Math.imul(V, je) | 0, S = S + Math.imul(V, Ce) | 0, y = y + Math.imul(ne, Ze) | 0, o = o + Math.imul(ne, qe) | 0, o = o + Math.imul(le, Ze) | 0, S = S + Math.imul(le, qe) | 0, y = y + Math.imul(T, We) | 0, o = o + Math.imul(T, Qe) | 0, o = o + Math.imul(D, We) | 0, S = S + Math.imul(D, Qe) | 0;
      var ur = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (ur >>> 26) | 0, ur &= 67108863, y = Math.imul(Oe, ze), o = Math.imul(Oe, Te), o = o + Math.imul(Ee, ze) | 0, S = Math.imul(Ee, Te), y = y + Math.imul(Ie, Fe) | 0, o = o + Math.imul(Ie, Ae) | 0, o = o + Math.imul(we, Fe) | 0, S = S + Math.imul(we, Ae) | 0, y = y + Math.imul(ye, He) | 0, o = o + Math.imul(ye, Ne) | 0, o = o + Math.imul(pe, He) | 0, S = S + Math.imul(pe, Ne) | 0, y = y + Math.imul(be, $e) | 0, o = o + Math.imul(be, De) | 0, o = o + Math.imul(ve, $e) | 0, S = S + Math.imul(ve, De) | 0, y = y + Math.imul(fe, je) | 0, o = o + Math.imul(fe, Ce) | 0, o = o + Math.imul(ue, je) | 0, S = S + Math.imul(ue, Ce) | 0, y = y + Math.imul($, Ze) | 0, o = o + Math.imul($, qe) | 0, o = o + Math.imul(V, Ze) | 0, S = S + Math.imul(V, qe) | 0, y = y + Math.imul(ne, We) | 0, o = o + Math.imul(ne, Qe) | 0, o = o + Math.imul(le, We) | 0, S = S + Math.imul(le, Qe) | 0;
      var hr = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (hr >>> 26) | 0, hr &= 67108863, y = Math.imul(Oe, Fe), o = Math.imul(Oe, Ae), o = o + Math.imul(Ee, Fe) | 0, S = Math.imul(Ee, Ae), y = y + Math.imul(Ie, He) | 0, o = o + Math.imul(Ie, Ne) | 0, o = o + Math.imul(we, He) | 0, S = S + Math.imul(we, Ne) | 0, y = y + Math.imul(ye, $e) | 0, o = o + Math.imul(ye, De) | 0, o = o + Math.imul(pe, $e) | 0, S = S + Math.imul(pe, De) | 0, y = y + Math.imul(be, je) | 0, o = o + Math.imul(be, Ce) | 0, o = o + Math.imul(ve, je) | 0, S = S + Math.imul(ve, Ce) | 0, y = y + Math.imul(fe, Ze) | 0, o = o + Math.imul(fe, qe) | 0, o = o + Math.imul(ue, Ze) | 0, S = S + Math.imul(ue, qe) | 0, y = y + Math.imul($, We) | 0, o = o + Math.imul($, Qe) | 0, o = o + Math.imul(V, We) | 0, S = S + Math.imul(V, Qe) | 0;
      var qt = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (qt >>> 26) | 0, qt &= 67108863, y = Math.imul(Oe, He), o = Math.imul(Oe, Ne), o = o + Math.imul(Ee, He) | 0, S = Math.imul(Ee, Ne), y = y + Math.imul(Ie, $e) | 0, o = o + Math.imul(Ie, De) | 0, o = o + Math.imul(we, $e) | 0, S = S + Math.imul(we, De) | 0, y = y + Math.imul(ye, je) | 0, o = o + Math.imul(ye, Ce) | 0, o = o + Math.imul(pe, je) | 0, S = S + Math.imul(pe, Ce) | 0, y = y + Math.imul(be, Ze) | 0, o = o + Math.imul(be, qe) | 0, o = o + Math.imul(ve, Ze) | 0, S = S + Math.imul(ve, qe) | 0, y = y + Math.imul(fe, We) | 0, o = o + Math.imul(fe, Qe) | 0, o = o + Math.imul(ue, We) | 0, S = S + Math.imul(ue, Qe) | 0;
      var Er = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Er >>> 26) | 0, Er &= 67108863, y = Math.imul(Oe, $e), o = Math.imul(Oe, De), o = o + Math.imul(Ee, $e) | 0, S = Math.imul(Ee, De), y = y + Math.imul(Ie, je) | 0, o = o + Math.imul(Ie, Ce) | 0, o = o + Math.imul(we, je) | 0, S = S + Math.imul(we, Ce) | 0, y = y + Math.imul(ye, Ze) | 0, o = o + Math.imul(ye, qe) | 0, o = o + Math.imul(pe, Ze) | 0, S = S + Math.imul(pe, qe) | 0, y = y + Math.imul(be, We) | 0, o = o + Math.imul(be, Qe) | 0, o = o + Math.imul(ve, We) | 0, S = S + Math.imul(ve, Qe) | 0;
      var Ir = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Ir >>> 26) | 0, Ir &= 67108863, y = Math.imul(Oe, je), o = Math.imul(Oe, Ce), o = o + Math.imul(Ee, je) | 0, S = Math.imul(Ee, Ce), y = y + Math.imul(Ie, Ze) | 0, o = o + Math.imul(Ie, qe) | 0, o = o + Math.imul(we, Ze) | 0, S = S + Math.imul(we, qe) | 0, y = y + Math.imul(ye, We) | 0, o = o + Math.imul(ye, Qe) | 0, o = o + Math.imul(pe, We) | 0, S = S + Math.imul(pe, Qe) | 0;
      var Ar = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Ar >>> 26) | 0, Ar &= 67108863, y = Math.imul(Oe, Ze), o = Math.imul(Oe, qe), o = o + Math.imul(Ee, Ze) | 0, S = Math.imul(Ee, qe), y = y + Math.imul(Ie, We) | 0, o = o + Math.imul(Ie, Qe) | 0, o = o + Math.imul(we, We) | 0, S = S + Math.imul(we, Qe) | 0;
      var qr = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (qr >>> 26) | 0, qr &= 67108863, y = Math.imul(Oe, We), o = Math.imul(Oe, Qe), o = o + Math.imul(Ee, We) | 0, S = Math.imul(Ee, Qe);
      var zr = (E + y | 0) + ((o & 8191) << 13) | 0;
      return E = (S + (o >>> 13) | 0) + (zr >>> 26) | 0, zr &= 67108863, x[0] = Qt, x[1] = Zt, x[2] = Jt, x[3] = Xt, x[4] = kt, x[5] = ar, x[6] = lr, x[7] = or, x[8] = dr, x[9] = pr, x[10] = fr, x[11] = ur, x[12] = hr, x[13] = qt, x[14] = Er, x[15] = Ir, x[16] = Ar, x[17] = qr, x[18] = zr, E !== 0 && (x[19] = E, p.length++), p;
    };
    Math.imul || (P = O);
    function F(g, a, c) {
      c.negative = a.negative ^ g.negative, c.length = g.length + a.length;
      for (var p = 0, w = 0, _ = 0; _ < c.length - 1; _++) {
        var x = w;
        w = 0;
        for (var E = p & 67108863, y = Math.min(_, a.length - 1), o = Math.max(0, _ - g.length + 1); o <= y; o++) {
          var S = _ - o, J = g.words[S] | 0, z = a.words[o] | 0, k = J * z, j = k & 67108863;
          x = x + (k / 67108864 | 0) | 0, j = j + E | 0, E = j & 67108863, x = x + (j >>> 26) | 0, w += x >>> 26, x &= 67108863;
        }
        c.words[_] = E, p = x, x = w;
      }
      return p !== 0 ? c.words[_] = p : c.length--, c._strip();
    }
    function H(g, a, c) {
      return F(g, a, c);
    }
    n.prototype.mulTo = function(a, c) {
      var p, w = this.length + a.length;
      return this.length === 10 && a.length === 10 ? p = P(this, a, c) : w < 63 ? p = O(this, a, c) : w < 1024 ? p = F(this, a, c) : p = H(this, a, c), p;
    }, n.prototype.mul = function(a) {
      var c = new n(null);
      return c.words = new Array(this.length + a.length), this.mulTo(a, c);
    }, n.prototype.mulf = function(a) {
      var c = new n(null);
      return c.words = new Array(this.length + a.length), H(this, a, c);
    }, n.prototype.imul = function(a) {
      return this.clone().mulTo(a, this);
    }, n.prototype.imuln = function(a) {
      var c = a < 0;
      c && (a = -a), i(typeof a == "number"), i(a < 67108864);
      for (var p = 0, w = 0; w < this.length; w++) {
        var _ = (this.words[w] | 0) * a, x = (_ & 67108863) + (p & 67108863);
        p >>= 26, p += _ / 67108864 | 0, p += x >>> 26, this.words[w] = x & 67108863;
      }
      return p !== 0 && (this.words[w] = p, this.length++), c ? this.ineg() : this;
    }, n.prototype.muln = function(a) {
      return this.clone().imuln(a);
    }, n.prototype.sqr = function() {
      return this.mul(this);
    }, n.prototype.isqr = function() {
      return this.imul(this.clone());
    }, n.prototype.pow = function(a) {
      var c = R(a);
      if (c.length === 0)
        return new n(1);
      for (var p = this, w = 0; w < c.length && c[w] === 0; w++, p = p.sqr())
        ;
      if (++w < c.length)
        for (var _ = p.sqr(); w < c.length; w++, _ = _.sqr())
          c[w] !== 0 && (p = p.mul(_));
      return p;
    }, n.prototype.iushln = function(a) {
      i(typeof a == "number" && a >= 0);
      var c = a % 26, p = (a - c) / 26, w = 67108863 >>> 26 - c << 26 - c, _;
      if (c !== 0) {
        var x = 0;
        for (_ = 0; _ < this.length; _++) {
          var E = this.words[_] & w, y = (this.words[_] | 0) - E << c;
          this.words[_] = y | x, x = E >>> 26 - c;
        }
        x && (this.words[_] = x, this.length++);
      }
      if (p !== 0) {
        for (_ = this.length - 1; _ >= 0; _--)
          this.words[_ + p] = this.words[_];
        for (_ = 0; _ < p; _++)
          this.words[_] = 0;
        this.length += p;
      }
      return this._strip();
    }, n.prototype.ishln = function(a) {
      return i(this.negative === 0), this.iushln(a);
    }, n.prototype.iushrn = function(a, c, p) {
      i(typeof a == "number" && a >= 0);
      var w;
      c ? w = (c - c % 26) / 26 : w = 0;
      var _ = a % 26, x = Math.min((a - _) / 26, this.length), E = 67108863 ^ 67108863 >>> _ << _, y = p;
      if (w -= x, w = Math.max(0, w), y) {
        for (var o = 0; o < x; o++)
          y.words[o] = this.words[o];
        y.length = x;
      }
      if (x !== 0)
        if (this.length > x)
          for (this.length -= x, o = 0; o < this.length; o++)
            this.words[o] = this.words[o + x];
        else
          this.words[0] = 0, this.length = 1;
      var S = 0;
      for (o = this.length - 1; o >= 0 && (S !== 0 || o >= w); o--) {
        var J = this.words[o] | 0;
        this.words[o] = S << 26 - _ | J >>> _, S = J & E;
      }
      return y && S !== 0 && (y.words[y.length++] = S), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, n.prototype.ishrn = function(a, c, p) {
      return i(this.negative === 0), this.iushrn(a, c, p);
    }, n.prototype.shln = function(a) {
      return this.clone().ishln(a);
    }, n.prototype.ushln = function(a) {
      return this.clone().iushln(a);
    }, n.prototype.shrn = function(a) {
      return this.clone().ishrn(a);
    }, n.prototype.ushrn = function(a) {
      return this.clone().iushrn(a);
    }, n.prototype.testn = function(a) {
      i(typeof a == "number" && a >= 0);
      var c = a % 26, p = (a - c) / 26, w = 1 << c;
      if (this.length <= p)
        return !1;
      var _ = this.words[p];
      return !!(_ & w);
    }, n.prototype.imaskn = function(a) {
      i(typeof a == "number" && a >= 0);
      var c = a % 26, p = (a - c) / 26;
      if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= p)
        return this;
      if (c !== 0 && p++, this.length = Math.min(p, this.length), c !== 0) {
        var w = 67108863 ^ 67108863 >>> c << c;
        this.words[this.length - 1] &= w;
      }
      return this._strip();
    }, n.prototype.maskn = function(a) {
      return this.clone().imaskn(a);
    }, n.prototype.iaddn = function(a) {
      return i(typeof a == "number"), i(a < 67108864), a < 0 ? this.isubn(-a) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= a ? (this.words[0] = a - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(a), this.negative = 1, this) : this._iaddn(a);
    }, n.prototype._iaddn = function(a) {
      this.words[0] += a;
      for (var c = 0; c < this.length && this.words[c] >= 67108864; c++)
        this.words[c] -= 67108864, c === this.length - 1 ? this.words[c + 1] = 1 : this.words[c + 1]++;
      return this.length = Math.max(this.length, c + 1), this;
    }, n.prototype.isubn = function(a) {
      if (i(typeof a == "number"), i(a < 67108864), a < 0)
        return this.iaddn(-a);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(a), this.negative = 1, this;
      if (this.words[0] -= a, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var c = 0; c < this.length && this.words[c] < 0; c++)
          this.words[c] += 67108864, this.words[c + 1] -= 1;
      return this._strip();
    }, n.prototype.addn = function(a) {
      return this.clone().iaddn(a);
    }, n.prototype.subn = function(a) {
      return this.clone().isubn(a);
    }, n.prototype.iabs = function() {
      return this.negative = 0, this;
    }, n.prototype.abs = function() {
      return this.clone().iabs();
    }, n.prototype._ishlnsubmul = function(a, c, p) {
      var w = a.length + p, _;
      this._expand(w);
      var x, E = 0;
      for (_ = 0; _ < a.length; _++) {
        x = (this.words[_ + p] | 0) + E;
        var y = (a.words[_] | 0) * c;
        x -= y & 67108863, E = (x >> 26) - (y / 67108864 | 0), this.words[_ + p] = x & 67108863;
      }
      for (; _ < this.length - p; _++)
        x = (this.words[_ + p] | 0) + E, E = x >> 26, this.words[_ + p] = x & 67108863;
      if (E === 0)
        return this._strip();
      for (i(E === -1), E = 0, _ = 0; _ < this.length; _++)
        x = -(this.words[_] | 0) + E, E = x >> 26, this.words[_] = x & 67108863;
      return this.negative = 1, this._strip();
    }, n.prototype._wordDiv = function(a, c) {
      var p = this.length - a.length, w = this.clone(), _ = a, x = _.words[_.length - 1] | 0, E = this._countBits(x);
      p = 26 - E, p !== 0 && (_ = _.ushln(p), w.iushln(p), x = _.words[_.length - 1] | 0);
      var y = w.length - _.length, o;
      if (c !== "mod") {
        o = new n(null), o.length = y + 1, o.words = new Array(o.length);
        for (var S = 0; S < o.length; S++)
          o.words[S] = 0;
      }
      var J = w.clone()._ishlnsubmul(_, 1, y);
      J.negative === 0 && (w = J, o && (o.words[y] = 1));
      for (var z = y - 1; z >= 0; z--) {
        var k = (w.words[_.length + z] | 0) * 67108864 + (w.words[_.length + z - 1] | 0);
        for (k = Math.min(k / x | 0, 67108863), w._ishlnsubmul(_, k, z); w.negative !== 0; )
          k--, w.negative = 0, w._ishlnsubmul(_, 1, z), w.isZero() || (w.negative ^= 1);
        o && (o.words[z] = k);
      }
      return o && o._strip(), w._strip(), c !== "div" && p !== 0 && w.iushrn(p), {
        div: o || null,
        mod: w
      };
    }, n.prototype.divmod = function(a, c, p) {
      if (i(!a.isZero()), this.isZero())
        return {
          div: new n(0),
          mod: new n(0)
        };
      var w, _, x;
      return this.negative !== 0 && a.negative === 0 ? (x = this.neg().divmod(a, c), c !== "mod" && (w = x.div.neg()), c !== "div" && (_ = x.mod.neg(), p && _.negative !== 0 && _.iadd(a)), {
        div: w,
        mod: _
      }) : this.negative === 0 && a.negative !== 0 ? (x = this.divmod(a.neg(), c), c !== "mod" && (w = x.div.neg()), {
        div: w,
        mod: x.mod
      }) : (this.negative & a.negative) !== 0 ? (x = this.neg().divmod(a.neg(), c), c !== "div" && (_ = x.mod.neg(), p && _.negative !== 0 && _.isub(a)), {
        div: x.div,
        mod: _
      }) : a.length > this.length || this.cmp(a) < 0 ? {
        div: new n(0),
        mod: this
      } : a.length === 1 ? c === "div" ? {
        div: this.divn(a.words[0]),
        mod: null
      } : c === "mod" ? {
        div: null,
        mod: new n(this.modrn(a.words[0]))
      } : {
        div: this.divn(a.words[0]),
        mod: new n(this.modrn(a.words[0]))
      } : this._wordDiv(a, c);
    }, n.prototype.div = function(a) {
      return this.divmod(a, "div", !1).div;
    }, n.prototype.mod = function(a) {
      return this.divmod(a, "mod", !1).mod;
    }, n.prototype.umod = function(a) {
      return this.divmod(a, "mod", !0).mod;
    }, n.prototype.divRound = function(a) {
      var c = this.divmod(a);
      if (c.mod.isZero())
        return c.div;
      var p = c.div.negative !== 0 ? c.mod.isub(a) : c.mod, w = a.ushrn(1), _ = a.andln(1), x = p.cmp(w);
      return x < 0 || _ === 1 && x === 0 ? c.div : c.div.negative !== 0 ? c.div.isubn(1) : c.div.iaddn(1);
    }, n.prototype.modrn = function(a) {
      var c = a < 0;
      c && (a = -a), i(a <= 67108863);
      for (var p = (1 << 26) % a, w = 0, _ = this.length - 1; _ >= 0; _--)
        w = (p * w + (this.words[_] | 0)) % a;
      return c ? -w : w;
    }, n.prototype.modn = function(a) {
      return this.modrn(a);
    }, n.prototype.idivn = function(a) {
      var c = a < 0;
      c && (a = -a), i(a <= 67108863);
      for (var p = 0, w = this.length - 1; w >= 0; w--) {
        var _ = (this.words[w] | 0) + p * 67108864;
        this.words[w] = _ / a | 0, p = _ % a;
      }
      return this._strip(), c ? this.ineg() : this;
    }, n.prototype.divn = function(a) {
      return this.clone().idivn(a);
    }, n.prototype.egcd = function(a) {
      i(a.negative === 0), i(!a.isZero());
      var c = this, p = a.clone();
      c.negative !== 0 ? c = c.umod(a) : c = c.clone();
      for (var w = new n(1), _ = new n(0), x = new n(0), E = new n(1), y = 0; c.isEven() && p.isEven(); )
        c.iushrn(1), p.iushrn(1), ++y;
      for (var o = p.clone(), S = c.clone(); !c.isZero(); ) {
        for (var J = 0, z = 1; (c.words[0] & z) === 0 && J < 26; ++J, z <<= 1)
          ;
        if (J > 0)
          for (c.iushrn(J); J-- > 0; )
            (w.isOdd() || _.isOdd()) && (w.iadd(o), _.isub(S)), w.iushrn(1), _.iushrn(1);
        for (var k = 0, j = 1; (p.words[0] & j) === 0 && k < 26; ++k, j <<= 1)
          ;
        if (k > 0)
          for (p.iushrn(k); k-- > 0; )
            (x.isOdd() || E.isOdd()) && (x.iadd(o), E.isub(S)), x.iushrn(1), E.iushrn(1);
        c.cmp(p) >= 0 ? (c.isub(p), w.isub(x), _.isub(E)) : (p.isub(c), x.isub(w), E.isub(_));
      }
      return {
        a: x,
        b: E,
        gcd: p.iushln(y)
      };
    }, n.prototype._invmp = function(a) {
      i(a.negative === 0), i(!a.isZero());
      var c = this, p = a.clone();
      c.negative !== 0 ? c = c.umod(a) : c = c.clone();
      for (var w = new n(1), _ = new n(0), x = p.clone(); c.cmpn(1) > 0 && p.cmpn(1) > 0; ) {
        for (var E = 0, y = 1; (c.words[0] & y) === 0 && E < 26; ++E, y <<= 1)
          ;
        if (E > 0)
          for (c.iushrn(E); E-- > 0; )
            w.isOdd() && w.iadd(x), w.iushrn(1);
        for (var o = 0, S = 1; (p.words[0] & S) === 0 && o < 26; ++o, S <<= 1)
          ;
        if (o > 0)
          for (p.iushrn(o); o-- > 0; )
            _.isOdd() && _.iadd(x), _.iushrn(1);
        c.cmp(p) >= 0 ? (c.isub(p), w.isub(_)) : (p.isub(c), _.isub(w));
      }
      var J;
      return c.cmpn(1) === 0 ? J = w : J = _, J.cmpn(0) < 0 && J.iadd(a), J;
    }, n.prototype.gcd = function(a) {
      if (this.isZero())
        return a.abs();
      if (a.isZero())
        return this.abs();
      var c = this.clone(), p = a.clone();
      c.negative = 0, p.negative = 0;
      for (var w = 0; c.isEven() && p.isEven(); w++)
        c.iushrn(1), p.iushrn(1);
      do {
        for (; c.isEven(); )
          c.iushrn(1);
        for (; p.isEven(); )
          p.iushrn(1);
        var _ = c.cmp(p);
        if (_ < 0) {
          var x = c;
          c = p, p = x;
        } else if (_ === 0 || p.cmpn(1) === 0)
          break;
        c.isub(p);
      } while (!0);
      return p.iushln(w);
    }, n.prototype.invm = function(a) {
      return this.egcd(a).a.umod(a);
    }, n.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, n.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, n.prototype.andln = function(a) {
      return this.words[0] & a;
    }, n.prototype.bincn = function(a) {
      i(typeof a == "number");
      var c = a % 26, p = (a - c) / 26, w = 1 << c;
      if (this.length <= p)
        return this._expand(p + 1), this.words[p] |= w, this;
      for (var _ = w, x = p; _ !== 0 && x < this.length; x++) {
        var E = this.words[x] | 0;
        E += _, _ = E >>> 26, E &= 67108863, this.words[x] = E;
      }
      return _ !== 0 && (this.words[x] = _, this.length++), this;
    }, n.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, n.prototype.cmpn = function(a) {
      var c = a < 0;
      if (this.negative !== 0 && !c)
        return -1;
      if (this.negative === 0 && c)
        return 1;
      this._strip();
      var p;
      if (this.length > 1)
        p = 1;
      else {
        c && (a = -a), i(a <= 67108863, "Number is too big");
        var w = this.words[0] | 0;
        p = w === a ? 0 : w < a ? -1 : 1;
      }
      return this.negative !== 0 ? -p | 0 : p;
    }, n.prototype.cmp = function(a) {
      if (this.negative !== 0 && a.negative === 0)
        return -1;
      if (this.negative === 0 && a.negative !== 0)
        return 1;
      var c = this.ucmp(a);
      return this.negative !== 0 ? -c | 0 : c;
    }, n.prototype.ucmp = function(a) {
      if (this.length > a.length)
        return 1;
      if (this.length < a.length)
        return -1;
      for (var c = 0, p = this.length - 1; p >= 0; p--) {
        var w = this.words[p] | 0, _ = a.words[p] | 0;
        if (w !== _) {
          w < _ ? c = -1 : w > _ && (c = 1);
          break;
        }
      }
      return c;
    }, n.prototype.gtn = function(a) {
      return this.cmpn(a) === 1;
    }, n.prototype.gt = function(a) {
      return this.cmp(a) === 1;
    }, n.prototype.gten = function(a) {
      return this.cmpn(a) >= 0;
    }, n.prototype.gte = function(a) {
      return this.cmp(a) >= 0;
    }, n.prototype.ltn = function(a) {
      return this.cmpn(a) === -1;
    }, n.prototype.lt = function(a) {
      return this.cmp(a) === -1;
    }, n.prototype.lten = function(a) {
      return this.cmpn(a) <= 0;
    }, n.prototype.lte = function(a) {
      return this.cmp(a) <= 0;
    }, n.prototype.eqn = function(a) {
      return this.cmpn(a) === 0;
    }, n.prototype.eq = function(a) {
      return this.cmp(a) === 0;
    }, n.red = function(a) {
      return new W(a);
    }, n.prototype.toRed = function(a) {
      return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), a.convertTo(this)._forceRed(a);
    }, n.prototype.fromRed = function() {
      return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, n.prototype._forceRed = function(a) {
      return this.red = a, this;
    }, n.prototype.forceRed = function(a) {
      return i(!this.red, "Already a number in reduction context"), this._forceRed(a);
    }, n.prototype.redAdd = function(a) {
      return i(this.red, "redAdd works only with red numbers"), this.red.add(this, a);
    }, n.prototype.redIAdd = function(a) {
      return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, a);
    }, n.prototype.redSub = function(a) {
      return i(this.red, "redSub works only with red numbers"), this.red.sub(this, a);
    }, n.prototype.redISub = function(a) {
      return i(this.red, "redISub works only with red numbers"), this.red.isub(this, a);
    }, n.prototype.redShl = function(a) {
      return i(this.red, "redShl works only with red numbers"), this.red.shl(this, a);
    }, n.prototype.redMul = function(a) {
      return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, a), this.red.mul(this, a);
    }, n.prototype.redIMul = function(a) {
      return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, a), this.red.imul(this, a);
    }, n.prototype.redSqr = function() {
      return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, n.prototype.redISqr = function() {
      return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, n.prototype.redSqrt = function() {
      return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, n.prototype.redInvm = function() {
      return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, n.prototype.redNeg = function() {
      return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, n.prototype.redPow = function(a) {
      return i(this.red && !a.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, a);
    };
    var Q = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Z(g, a) {
      this.name = g, this.p = new n(a, 16), this.n = this.p.bitLength(), this.k = new n(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Z.prototype._tmp = function() {
      var a = new n(null);
      return a.words = new Array(Math.ceil(this.n / 13)), a;
    }, Z.prototype.ireduce = function(a) {
      var c = a, p;
      do
        this.split(c, this.tmp), c = this.imulK(c), c = c.iadd(this.tmp), p = c.bitLength();
      while (p > this.n);
      var w = p < this.n ? -1 : c.ucmp(this.p);
      return w === 0 ? (c.words[0] = 0, c.length = 1) : w > 0 ? c.isub(this.p) : c.strip !== void 0 ? c.strip() : c._strip(), c;
    }, Z.prototype.split = function(a, c) {
      a.iushrn(this.n, 0, c);
    }, Z.prototype.imulK = function(a) {
      return a.imul(this.k);
    };
    function B() {
      Z.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    s(B, Z), B.prototype.split = function(a, c) {
      for (var p = 4194303, w = Math.min(a.length, 9), _ = 0; _ < w; _++)
        c.words[_] = a.words[_];
      if (c.length = w, a.length <= 9) {
        a.words[0] = 0, a.length = 1;
        return;
      }
      var x = a.words[9];
      for (c.words[c.length++] = x & p, _ = 10; _ < a.length; _++) {
        var E = a.words[_] | 0;
        a.words[_ - 10] = (E & p) << 4 | x >>> 22, x = E;
      }
      x >>>= 22, a.words[_ - 10] = x, x === 0 && a.length > 10 ? a.length -= 10 : a.length -= 9;
    }, B.prototype.imulK = function(a) {
      a.words[a.length] = 0, a.words[a.length + 1] = 0, a.length += 2;
      for (var c = 0, p = 0; p < a.length; p++) {
        var w = a.words[p] | 0;
        c += w * 977, a.words[p] = c & 67108863, c = w * 64 + (c / 67108864 | 0);
      }
      return a.words[a.length - 1] === 0 && (a.length--, a.words[a.length - 1] === 0 && a.length--), a;
    };
    function Y() {
      Z.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    s(Y, Z);
    function ae() {
      Z.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    s(ae, Z);
    function se() {
      Z.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    s(se, Z), se.prototype.imulK = function(a) {
      for (var c = 0, p = 0; p < a.length; p++) {
        var w = (a.words[p] | 0) * 19 + c, _ = w & 67108863;
        w >>>= 26, a.words[p] = _, c = w;
      }
      return c !== 0 && (a.words[a.length++] = c), a;
    }, n._prime = function(a) {
      if (Q[a])
        return Q[a];
      var c;
      if (a === "k256")
        c = new B();
      else if (a === "p224")
        c = new Y();
      else if (a === "p192")
        c = new ae();
      else if (a === "p25519")
        c = new se();
      else
        throw new Error("Unknown prime " + a);
      return Q[a] = c, c;
    };
    function W(g) {
      if (typeof g == "string") {
        var a = n._prime(g);
        this.m = a.p, this.prime = a;
      } else
        i(g.gtn(1), "modulus must be greater than 1"), this.m = g, this.prime = null;
    }
    W.prototype._verify1 = function(a) {
      i(a.negative === 0, "red works only with positives"), i(a.red, "red works only with red numbers");
    }, W.prototype._verify2 = function(a, c) {
      i((a.negative | c.negative) === 0, "red works only with positives"), i(
        a.red && a.red === c.red,
        "red works only with red numbers"
      );
    }, W.prototype.imod = function(a) {
      return this.prime ? this.prime.ireduce(a)._forceRed(this) : (l(a, a.umod(this.m)._forceRed(this)), a);
    }, W.prototype.neg = function(a) {
      return a.isZero() ? a.clone() : this.m.sub(a)._forceRed(this);
    }, W.prototype.add = function(a, c) {
      this._verify2(a, c);
      var p = a.add(c);
      return p.cmp(this.m) >= 0 && p.isub(this.m), p._forceRed(this);
    }, W.prototype.iadd = function(a, c) {
      this._verify2(a, c);
      var p = a.iadd(c);
      return p.cmp(this.m) >= 0 && p.isub(this.m), p;
    }, W.prototype.sub = function(a, c) {
      this._verify2(a, c);
      var p = a.sub(c);
      return p.cmpn(0) < 0 && p.iadd(this.m), p._forceRed(this);
    }, W.prototype.isub = function(a, c) {
      this._verify2(a, c);
      var p = a.isub(c);
      return p.cmpn(0) < 0 && p.iadd(this.m), p;
    }, W.prototype.shl = function(a, c) {
      return this._verify1(a), this.imod(a.ushln(c));
    }, W.prototype.imul = function(a, c) {
      return this._verify2(a, c), this.imod(a.imul(c));
    }, W.prototype.mul = function(a, c) {
      return this._verify2(a, c), this.imod(a.mul(c));
    }, W.prototype.isqr = function(a) {
      return this.imul(a, a.clone());
    }, W.prototype.sqr = function(a) {
      return this.mul(a, a);
    }, W.prototype.sqrt = function(a) {
      if (a.isZero())
        return a.clone();
      var c = this.m.andln(3);
      if (i(c % 2 === 1), c === 3) {
        var p = this.m.add(new n(1)).iushrn(2);
        return this.pow(a, p);
      }
      for (var w = this.m.subn(1), _ = 0; !w.isZero() && w.andln(1) === 0; )
        _++, w.iushrn(1);
      i(!w.isZero());
      var x = new n(1).toRed(this), E = x.redNeg(), y = this.m.subn(1).iushrn(1), o = this.m.bitLength();
      for (o = new n(2 * o * o).toRed(this); this.pow(o, y).cmp(E) !== 0; )
        o.redIAdd(E);
      for (var S = this.pow(o, w), J = this.pow(a, w.addn(1).iushrn(1)), z = this.pow(a, w), k = _; z.cmp(x) !== 0; ) {
        for (var j = z, q = 0; j.cmp(x) !== 0; q++)
          j = j.redSqr();
        i(q < k);
        var K = this.pow(S, new n(1).iushln(k - q - 1));
        J = J.redMul(K), S = K.redSqr(), z = z.redMul(S), k = q;
      }
      return J;
    }, W.prototype.invm = function(a) {
      var c = a._invmp(this.m);
      return c.negative !== 0 ? (c.negative = 0, this.imod(c).redNeg()) : this.imod(c);
    }, W.prototype.pow = function(a, c) {
      if (c.isZero())
        return new n(1).toRed(this);
      if (c.cmpn(1) === 0)
        return a.clone();
      var p = 4, w = new Array(1 << p);
      w[0] = new n(1).toRed(this), w[1] = a;
      for (var _ = 2; _ < w.length; _++)
        w[_] = this.mul(w[_ - 1], a);
      var x = w[0], E = 0, y = 0, o = c.bitLength() % 26;
      for (o === 0 && (o = 26), _ = c.length - 1; _ >= 0; _--) {
        for (var S = c.words[_], J = o - 1; J >= 0; J--) {
          var z = S >> J & 1;
          if (x !== w[0] && (x = this.sqr(x)), z === 0 && E === 0) {
            y = 0;
            continue;
          }
          E <<= 1, E |= z, y++, !(y !== p && (_ !== 0 || J !== 0)) && (x = this.mul(x, w[E]), y = 0, E = 0);
        }
        o = 26;
      }
      return x;
    }, W.prototype.convertTo = function(a) {
      var c = a.umod(this.m);
      return c === a ? c.clone() : c;
    }, W.prototype.convertFrom = function(a) {
      var c = a.clone();
      return c.red = null, c;
    }, n.mont = function(a) {
      return new C(a);
    };
    function C(g) {
      W.call(this, g), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new n(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    s(C, W), C.prototype.convertTo = function(a) {
      return this.imod(a.ushln(this.shift));
    }, C.prototype.convertFrom = function(a) {
      var c = this.imod(a.mul(this.rinv));
      return c.red = null, c;
    }, C.prototype.imul = function(a, c) {
      if (a.isZero() || c.isZero())
        return a.words[0] = 0, a.length = 1, a;
      var p = a.imul(c), w = p.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _ = p.isub(w).iushrn(this.shift), x = _;
      return _.cmp(this.m) >= 0 ? x = _.isub(this.m) : _.cmpn(0) < 0 && (x = _.iadd(this.m)), x._forceRed(this);
    }, C.prototype.mul = function(a, c) {
      if (a.isZero() || c.isZero())
        return new n(0)._forceRed(this);
      var p = a.mul(c), w = p.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _ = p.isub(w).iushrn(this.shift), x = _;
      return _.cmp(this.m) >= 0 ? x = _.isub(this.m) : _.cmpn(0) < 0 && (x = _.iadd(this.m)), x._forceRed(this);
    }, C.prototype.invm = function(a) {
      var c = this.imod(a._invmp(this.m).mul(this.r2));
      return c._forceRed(this);
    };
  })(t, nt);
})(Ih);
var K0 = {}, so = {}, WS = uh;
uh.default = uh;
uh.stable = KS;
uh.stableStringify = KS;
var c0 = "[...]", VS = "[Circular]", nf = [], Yo = [];
function GS() {
  return {
    depthLimit: Number.MAX_SAFE_INTEGER,
    edgesLimit: Number.MAX_SAFE_INTEGER
  };
}
function uh(t, e, r, i) {
  typeof i > "u" && (i = GS()), em(t, "", 0, [], void 0, 0, i);
  var s;
  try {
    Yo.length === 0 ? s = JSON.stringify(t, e, r) : s = JSON.stringify(t, YS(e), r);
  } catch {
    return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
  } finally {
    for (; nf.length !== 0; ) {
      var n = nf.pop();
      n.length === 4 ? Object.defineProperty(n[0], n[1], n[3]) : n[0][n[1]] = n[2];
    }
  }
  return s;
}
function oc(t, e, r, i) {
  var s = Object.getOwnPropertyDescriptor(i, r);
  s.get !== void 0 ? s.configurable ? (Object.defineProperty(i, r, { value: t }), nf.push([i, r, e, s])) : Yo.push([e, r, t]) : (i[r] = t, nf.push([i, r, e]));
}
function em(t, e, r, i, s, n, f) {
  n += 1;
  var u;
  if (typeof t == "object" && t !== null) {
    for (u = 0; u < i.length; u++)
      if (i[u] === t) {
        oc(VS, t, e, s);
        return;
      }
    if (typeof f.depthLimit < "u" && n > f.depthLimit) {
      oc(c0, t, e, s);
      return;
    }
    if (typeof f.edgesLimit < "u" && r + 1 > f.edgesLimit) {
      oc(c0, t, e, s);
      return;
    }
    if (i.push(t), Array.isArray(t))
      for (u = 0; u < t.length; u++)
        em(t[u], u, u, i, t, n, f);
    else {
      var h = Object.keys(t);
      for (u = 0; u < h.length; u++) {
        var d = h[u];
        em(t[d], d, u, i, t, n, f);
      }
    }
    i.pop();
  }
}
function Yk(t, e) {
  return t < e ? -1 : t > e ? 1 : 0;
}
function KS(t, e, r, i) {
  typeof i > "u" && (i = GS());
  var s = tm(t, "", 0, [], void 0, 0, i) || t, n;
  try {
    Yo.length === 0 ? n = JSON.stringify(s, e, r) : n = JSON.stringify(s, YS(e), r);
  } catch {
    return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
  } finally {
    for (; nf.length !== 0; ) {
      var f = nf.pop();
      f.length === 4 ? Object.defineProperty(f[0], f[1], f[3]) : f[0][f[1]] = f[2];
    }
  }
  return n;
}
function tm(t, e, r, i, s, n, f) {
  n += 1;
  var u;
  if (typeof t == "object" && t !== null) {
    for (u = 0; u < i.length; u++)
      if (i[u] === t) {
        oc(VS, t, e, s);
        return;
      }
    try {
      if (typeof t.toJSON == "function")
        return;
    } catch {
      return;
    }
    if (typeof f.depthLimit < "u" && n > f.depthLimit) {
      oc(c0, t, e, s);
      return;
    }
    if (typeof f.edgesLimit < "u" && r + 1 > f.edgesLimit) {
      oc(c0, t, e, s);
      return;
    }
    if (i.push(t), Array.isArray(t))
      for (u = 0; u < t.length; u++)
        tm(t[u], u, u, i, t, n, f);
    else {
      var h = {}, d = Object.keys(t).sort(Yk);
      for (u = 0; u < d.length; u++) {
        var l = d[u];
        tm(t[l], l, u, i, t, n, f), h[l] = t[l];
      }
      if (typeof s < "u")
        nf.push([s, e, t]), s[e] = h;
      else
        return h;
    }
    i.pop();
  }
}
function YS(t) {
  return t = typeof t < "u" ? t : function(e, r) {
    return r;
  }, function(e, r) {
    if (Yo.length > 0)
      for (var i = 0; i < Yo.length; i++) {
        var s = Yo[i];
        if (s[1] === e && s[0] === r) {
          r = s[2], Yo.splice(i, 1);
          break;
        }
      }
    return t.call(this, e, r);
  };
}
Object.defineProperty(so, "__esModule", { value: !0 });
so.EthereumProviderError = so.EthereumRpcError = void 0;
const Qk = WS;
class QS extends Error {
  constructor(e, r, i) {
    if (!Number.isInteger(e))
      throw new Error('"code" must be an integer.');
    if (!r || typeof r != "string")
      throw new Error('"message" must be a nonempty string.');
    super(r), this.code = e, i !== void 0 && (this.data = i);
  }
  serialize() {
    const e = {
      code: this.code,
      message: this.message
    };
    return this.data !== void 0 && (e.data = this.data), this.stack && (e.stack = this.stack), e;
  }
  toString() {
    return Qk.default(this.serialize(), Xk, 2);
  }
}
so.EthereumRpcError = QS;
class Zk extends QS {
  constructor(e, r, i) {
    if (!Jk(e))
      throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
    super(e, r, i);
  }
}
so.EthereumProviderError = Zk;
function Jk(t) {
  return Number.isInteger(t) && t >= 1e3 && t <= 4999;
}
function Xk(t, e) {
  if (e !== "[Circular]")
    return e;
}
var r2 = {}, ao = {};
Object.defineProperty(ao, "__esModule", { value: !0 });
ao.errorValues = ao.errorCodes = void 0;
ao.errorCodes = {
  rpc: {
    invalidInput: -32e3,
    resourceNotFound: -32001,
    resourceUnavailable: -32002,
    transactionRejected: -32003,
    methodNotSupported: -32004,
    limitExceeded: -32005,
    parse: -32700,
    invalidRequest: -32600,
    methodNotFound: -32601,
    invalidParams: -32602,
    internal: -32603
  },
  provider: {
    userRejectedRequest: 4001,
    unauthorized: 4100,
    unsupportedMethod: 4200,
    disconnected: 4900,
    chainDisconnected: 4901
  }
};
ao.errorValues = {
  "-32700": {
    standard: "JSON RPC 2.0",
    message: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
  },
  "-32600": {
    standard: "JSON RPC 2.0",
    message: "The JSON sent is not a valid Request object."
  },
  "-32601": {
    standard: "JSON RPC 2.0",
    message: "The method does not exist / is not available."
  },
  "-32602": {
    standard: "JSON RPC 2.0",
    message: "Invalid method parameter(s)."
  },
  "-32603": {
    standard: "JSON RPC 2.0",
    message: "Internal JSON-RPC error."
  },
  "-32000": {
    standard: "EIP-1474",
    message: "Invalid input."
  },
  "-32001": {
    standard: "EIP-1474",
    message: "Resource not found."
  },
  "-32002": {
    standard: "EIP-1474",
    message: "Resource unavailable."
  },
  "-32003": {
    standard: "EIP-1474",
    message: "Transaction rejected."
  },
  "-32004": {
    standard: "EIP-1474",
    message: "Method not supported."
  },
  "-32005": {
    standard: "EIP-1474",
    message: "Request limit exceeded."
  },
  4001: {
    standard: "EIP-1193",
    message: "User rejected the request."
  },
  4100: {
    standard: "EIP-1193",
    message: "The requested account and/or method has not been authorized by the user."
  },
  4200: {
    standard: "EIP-1193",
    message: "The requested method is not supported by this Ethereum provider."
  },
  4900: {
    standard: "EIP-1193",
    message: "The provider is disconnected from all chains."
  },
  4901: {
    standard: "EIP-1193",
    message: "The provider is disconnected from the specified chain."
  }
};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.serializeError = t.isValidCode = t.getMessageFromCode = t.JSON_RPC_SERVER_ERROR_MESSAGE = void 0;
  const e = ao, r = so, i = e.errorCodes.rpc.internal, s = "Unspecified error message. This is a bug, please report it.", n = {
    code: i,
    message: f(i)
  };
  t.JSON_RPC_SERVER_ERROR_MESSAGE = "Unspecified server error.";
  function f(b, M = s) {
    if (Number.isInteger(b)) {
      const A = b.toString();
      if (m(e.errorValues, A))
        return e.errorValues[A].message;
      if (d(b))
        return t.JSON_RPC_SERVER_ERROR_MESSAGE;
    }
    return M;
  }
  t.getMessageFromCode = f;
  function u(b) {
    if (!Number.isInteger(b))
      return !1;
    const M = b.toString();
    return !!(e.errorValues[M] || d(b));
  }
  t.isValidCode = u;
  function h(b, { fallbackError: M = n, shouldIncludeStack: A = !1 } = {}) {
    var N, R;
    if (!M || !Number.isInteger(M.code) || typeof M.message != "string")
      throw new Error("Must provide fallback error with integer number code and string message.");
    if (b instanceof r.EthereumRpcError)
      return b.serialize();
    const O = {};
    if (b && typeof b == "object" && !Array.isArray(b) && m(b, "code") && u(b.code)) {
      const F = b;
      O.code = F.code, F.message && typeof F.message == "string" ? (O.message = F.message, m(F, "data") && (O.data = F.data)) : (O.message = f(O.code), O.data = { originalError: l(b) });
    } else {
      O.code = M.code;
      const F = (N = b) === null || N === void 0 ? void 0 : N.message;
      O.message = F && typeof F == "string" ? F : M.message, O.data = { originalError: l(b) };
    }
    const P = (R = b) === null || R === void 0 ? void 0 : R.stack;
    return A && b && P && typeof P == "string" && (O.stack = P), O;
  }
  t.serializeError = h;
  function d(b) {
    return b >= -32099 && b <= -32e3;
  }
  function l(b) {
    return b && typeof b == "object" && !Array.isArray(b) ? Object.assign({}, b) : b;
  }
  function m(b, M) {
    return Object.prototype.hasOwnProperty.call(b, M);
  }
})(r2);
var Y0 = {};
Object.defineProperty(Y0, "__esModule", { value: !0 });
Y0.ethErrors = void 0;
const i2 = so, ZS = r2, Ri = ao;
Y0.ethErrors = {
  rpc: {
    parse: (t) => Fn(Ri.errorCodes.rpc.parse, t),
    invalidRequest: (t) => Fn(Ri.errorCodes.rpc.invalidRequest, t),
    invalidParams: (t) => Fn(Ri.errorCodes.rpc.invalidParams, t),
    methodNotFound: (t) => Fn(Ri.errorCodes.rpc.methodNotFound, t),
    internal: (t) => Fn(Ri.errorCodes.rpc.internal, t),
    server: (t) => {
      if (!t || typeof t != "object" || Array.isArray(t))
        throw new Error("Ethereum RPC Server errors must provide single object argument.");
      const { code: e } = t;
      if (!Number.isInteger(e) || e > -32005 || e < -32099)
        throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
      return Fn(e, t);
    },
    invalidInput: (t) => Fn(Ri.errorCodes.rpc.invalidInput, t),
    resourceNotFound: (t) => Fn(Ri.errorCodes.rpc.resourceNotFound, t),
    resourceUnavailable: (t) => Fn(Ri.errorCodes.rpc.resourceUnavailable, t),
    transactionRejected: (t) => Fn(Ri.errorCodes.rpc.transactionRejected, t),
    methodNotSupported: (t) => Fn(Ri.errorCodes.rpc.methodNotSupported, t),
    limitExceeded: (t) => Fn(Ri.errorCodes.rpc.limitExceeded, t)
  },
  provider: {
    userRejectedRequest: (t) => Tu(Ri.errorCodes.provider.userRejectedRequest, t),
    unauthorized: (t) => Tu(Ri.errorCodes.provider.unauthorized, t),
    unsupportedMethod: (t) => Tu(Ri.errorCodes.provider.unsupportedMethod, t),
    disconnected: (t) => Tu(Ri.errorCodes.provider.disconnected, t),
    chainDisconnected: (t) => Tu(Ri.errorCodes.provider.chainDisconnected, t),
    custom: (t) => {
      if (!t || typeof t != "object" || Array.isArray(t))
        throw new Error("Ethereum Provider custom errors must provide single object argument.");
      const { code: e, message: r, data: i } = t;
      if (!r || typeof r != "string")
        throw new Error('"message" must be a nonempty string');
      return new i2.EthereumProviderError(e, r, i);
    }
  }
};
function Fn(t, e) {
  const [r, i] = JS(e);
  return new i2.EthereumRpcError(t, r || ZS.getMessageFromCode(t), i);
}
function Tu(t, e) {
  const [r, i] = JS(e);
  return new i2.EthereumProviderError(t, r || ZS.getMessageFromCode(t), i);
}
function JS(t) {
  if (t) {
    if (typeof t == "string")
      return [t];
    if (typeof t == "object" && !Array.isArray(t)) {
      const { message: e, data: r } = t;
      if (e && typeof e != "string")
        throw new Error("Must specify string message.");
      return [e || void 0, r];
    }
  }
  return [];
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.getMessageFromCode = t.serializeError = t.EthereumProviderError = t.EthereumRpcError = t.ethErrors = t.errorCodes = void 0;
  const e = so;
  Object.defineProperty(t, "EthereumRpcError", { enumerable: !0, get: function() {
    return e.EthereumRpcError;
  } }), Object.defineProperty(t, "EthereumProviderError", { enumerable: !0, get: function() {
    return e.EthereumProviderError;
  } });
  const r = r2;
  Object.defineProperty(t, "serializeError", { enumerable: !0, get: function() {
    return r.serializeError;
  } }), Object.defineProperty(t, "getMessageFromCode", { enumerable: !0, get: function() {
    return r.getMessageFromCode;
  } });
  const i = Y0;
  Object.defineProperty(t, "ethErrors", { enumerable: !0, get: function() {
    return i.ethErrors;
  } });
  const s = ao;
  Object.defineProperty(t, "errorCodes", { enumerable: !0, get: function() {
    return s.errorCodes;
  } });
})(K0);
var jc = {};
Object.defineProperty(jc, "__esModule", { value: !0 });
jc.EVENTS = void 0;
jc.EVENTS = {
  STARTED_CONNECTING: "walletlink_sdk.started.connecting",
  CONNECTED_STATE_CHANGE: "walletlink_sdk.connected",
  DISCONNECTED: "walletlink_sdk.disconnected",
  METADATA_DESTROYED: "walletlink_sdk_metadata_destroyed",
  LINKED: "walletlink_sdk.linked",
  FAILURE: "walletlink_sdk.generic_failure",
  SESSION_CONFIG_RECEIVED: "walletlink_sdk.session_config_event_received",
  ETH_ACCOUNTS_STATE: "walletlink_sdk.eth_accounts_state",
  SESSION_STATE_CHANGE: "walletlink_sdk.session_state_change",
  UNLINKED_ERROR_STATE: "walletlink_sdk.unlinked_error_state",
  SKIPPED_CLEARING_SESSION: "walletlink_sdk.skipped_clearing_session",
  GENERAL_ERROR: "walletlink_sdk.general_error",
  WEB3_REQUEST: "walletlink_sdk.web3.request",
  WEB3_REQUEST_PUBLISHED: "walletlink_sdk.web3.request_published",
  WEB3_RESPONSE: "walletlink_sdk.web3.response",
  UNKNOWN_ADDRESS_ENCOUNTERED: "walletlink_sdk.unknown_address_encountered"
};
var Bc = {};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var rm = function(t, e) {
  return rm = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
    r.__proto__ = i;
  } || function(r, i) {
    for (var s in i)
      i.hasOwnProperty(s) && (r[s] = i[s]);
  }, rm(t, e);
};
function it(t, e) {
  rm(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
function yc(t) {
  return typeof t == "function";
}
var e4 = !1, Zn = {
  Promise: void 0,
  set useDeprecatedSynchronousErrorHandling(t) {
    if (t) {
      var e = /* @__PURE__ */ new Error();
      "" + e.stack;
    }
    e4 = t;
  },
  get useDeprecatedSynchronousErrorHandling() {
    return e4;
  }
};
function ic(t) {
  setTimeout(function() {
    throw t;
  }, 0);
}
var u0 = {
  closed: !0,
  next: function(t) {
  },
  error: function(t) {
    if (Zn.useDeprecatedSynchronousErrorHandling)
      throw t;
    ic(t);
  },
  complete: function() {
  }
}, Ji = /* @__PURE__ */ function() {
  return Array.isArray || function(t) {
    return t && typeof t.length == "number";
  };
}();
function n2(t) {
  return t !== null && typeof t == "object";
}
var ej = /* @__PURE__ */ function() {
  function t(e) {
    return Error.call(this), this.message = e ? e.length + ` errors occurred during unsubscription:
` + e.map(function(r, i) {
      return i + 1 + ") " + r.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = e, this;
  }
  return t.prototype = /* @__PURE__ */ Object.create(Error.prototype), t;
}(), Zu = ej, Vr = /* @__PURE__ */ function() {
  function t(e) {
    this.closed = !1, this._parentOrParents = null, this._subscriptions = null, e && (this._ctorUnsubscribe = !0, this._unsubscribe = e);
  }
  return t.prototype.unsubscribe = function() {
    var e;
    if (!this.closed) {
      var r = this, i = r._parentOrParents, s = r._ctorUnsubscribe, n = r._unsubscribe, f = r._subscriptions;
      if (this.closed = !0, this._parentOrParents = null, this._subscriptions = null, i instanceof t)
        i.remove(this);
      else if (i !== null)
        for (var u = 0; u < i.length; ++u) {
          var h = i[u];
          h.remove(this);
        }
      if (yc(n)) {
        s && (this._unsubscribe = void 0);
        try {
          n.call(this);
        } catch (m) {
          e = m instanceof Zu ? t4(m.errors) : [m];
        }
      }
      if (Ji(f))
        for (var u = -1, d = f.length; ++u < d; ) {
          var l = f[u];
          if (n2(l))
            try {
              l.unsubscribe();
            } catch (b) {
              e = e || [], b instanceof Zu ? e = e.concat(t4(b.errors)) : e.push(b);
            }
        }
      if (e)
        throw new Zu(e);
    }
  }, t.prototype.add = function(e) {
    var r = e;
    if (!e)
      return t.EMPTY;
    switch (typeof e) {
      case "function":
        r = new t(e);
      case "object":
        if (r === this || r.closed || typeof r.unsubscribe != "function")
          return r;
        if (this.closed)
          return r.unsubscribe(), r;
        if (!(r instanceof t)) {
          var i = r;
          r = new t(), r._subscriptions = [i];
        }
        break;
      default:
        throw new Error("unrecognized teardown " + e + " added to Subscription.");
    }
    var s = r._parentOrParents;
    if (s === null)
      r._parentOrParents = this;
    else if (s instanceof t) {
      if (s === this)
        return r;
      r._parentOrParents = [s, this];
    } else if (s.indexOf(this) === -1)
      s.push(this);
    else
      return r;
    var n = this._subscriptions;
    return n === null ? this._subscriptions = [r] : n.push(r), r;
  }, t.prototype.remove = function(e) {
    var r = this._subscriptions;
    if (r) {
      var i = r.indexOf(e);
      i !== -1 && r.splice(i, 1);
    }
  }, t.EMPTY = function(e) {
    return e.closed = !0, e;
  }(new t()), t;
}();
function t4(t) {
  return t.reduce(function(e, r) {
    return e.concat(r instanceof Zu ? r.errors : r);
  }, []);
}
var h0 = /* @__PURE__ */ function() {
  return typeof Symbol == "function" ? /* @__PURE__ */ Symbol("rxSubscriber") : "@@rxSubscriber_" + /* @__PURE__ */ Math.random();
}(), St = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this) || this;
    switch (n.syncErrorValue = null, n.syncErrorThrown = !1, n.syncErrorThrowable = !1, n.isStopped = !1, arguments.length) {
      case 0:
        n.destination = u0;
        break;
      case 1:
        if (!r) {
          n.destination = u0;
          break;
        }
        if (typeof r == "object") {
          r instanceof e ? (n.syncErrorThrowable = r.syncErrorThrowable, n.destination = r, r.add(n)) : (n.syncErrorThrowable = !0, n.destination = new r4(n, r));
          break;
        }
      default:
        n.syncErrorThrowable = !0, n.destination = new r4(n, r, i, s);
        break;
    }
    return n;
  }
  return e.prototype[h0] = function() {
    return this;
  }, e.create = function(r, i, s) {
    var n = new e(r, i, s);
    return n.syncErrorThrowable = !1, n;
  }, e.prototype.next = function(r) {
    this.isStopped || this._next(r);
  }, e.prototype.error = function(r) {
    this.isStopped || (this.isStopped = !0, this._error(r));
  }, e.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, e.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, t.prototype.unsubscribe.call(this));
  }, e.prototype._next = function(r) {
    this.destination.next(r);
  }, e.prototype._error = function(r) {
    this.destination.error(r), this.unsubscribe();
  }, e.prototype._complete = function() {
    this.destination.complete(), this.unsubscribe();
  }, e.prototype._unsubscribeAndRecycle = function() {
    var r = this._parentOrParents;
    return this._parentOrParents = null, this.unsubscribe(), this.closed = !1, this.isStopped = !1, this._parentOrParents = r, this;
  }, e;
}(Vr), r4 = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s, n) {
    var f = t.call(this) || this;
    f._parentSubscriber = r;
    var u, h = f;
    return yc(i) ? u = i : i && (u = i.next, s = i.error, n = i.complete, i !== u0 && (h = Object.create(i), yc(h.unsubscribe) && f.add(h.unsubscribe.bind(h)), h.unsubscribe = f.unsubscribe.bind(f))), f._context = h, f._next = u, f._error = s, f._complete = n, f;
  }
  return e.prototype.next = function(r) {
    if (!this.isStopped && this._next) {
      var i = this._parentSubscriber;
      !Zn.useDeprecatedSynchronousErrorHandling || !i.syncErrorThrowable ? this.__tryOrUnsub(this._next, r) : this.__tryOrSetError(i, this._next, r) && this.unsubscribe();
    }
  }, e.prototype.error = function(r) {
    if (!this.isStopped) {
      var i = this._parentSubscriber, s = Zn.useDeprecatedSynchronousErrorHandling;
      if (this._error)
        !s || !i.syncErrorThrowable ? (this.__tryOrUnsub(this._error, r), this.unsubscribe()) : (this.__tryOrSetError(i, this._error, r), this.unsubscribe());
      else if (i.syncErrorThrowable)
        s ? (i.syncErrorValue = r, i.syncErrorThrown = !0) : ic(r), this.unsubscribe();
      else {
        if (this.unsubscribe(), s)
          throw r;
        ic(r);
      }
    }
  }, e.prototype.complete = function() {
    var r = this;
    if (!this.isStopped) {
      var i = this._parentSubscriber;
      if (this._complete) {
        var s = function() {
          return r._complete.call(r._context);
        };
        !Zn.useDeprecatedSynchronousErrorHandling || !i.syncErrorThrowable ? (this.__tryOrUnsub(s), this.unsubscribe()) : (this.__tryOrSetError(i, s), this.unsubscribe());
      } else
        this.unsubscribe();
    }
  }, e.prototype.__tryOrUnsub = function(r, i) {
    try {
      r.call(this._context, i);
    } catch (s) {
      if (this.unsubscribe(), Zn.useDeprecatedSynchronousErrorHandling)
        throw s;
      ic(s);
    }
  }, e.prototype.__tryOrSetError = function(r, i, s) {
    if (!Zn.useDeprecatedSynchronousErrorHandling)
      throw new Error("bad call");
    try {
      i.call(this._context, s);
    } catch (n) {
      return Zn.useDeprecatedSynchronousErrorHandling ? (r.syncErrorValue = n, r.syncErrorThrown = !0, !0) : (ic(n), !0);
    }
    return !1;
  }, e.prototype._unsubscribe = function() {
    var r = this._parentSubscriber;
    this._context = null, this._parentSubscriber = null, r.unsubscribe();
  }, e;
}(St);
function s2(t) {
  for (; t; ) {
    var e = t, r = e.closed, i = e.destination, s = e.isStopped;
    if (r || s)
      return !1;
    i && i instanceof St ? t = i : t = null;
  }
  return !0;
}
function tj(t, e, r) {
  if (t) {
    if (t instanceof St)
      return t;
    if (t[h0])
      return t[h0]();
  }
  return !t && !e && !r ? new St(u0) : new St(t, e, r);
}
var zc = /* @__PURE__ */ function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function oo(t) {
  return t;
}
function im() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  return XS(t);
}
function XS(t) {
  return t.length === 0 ? oo : t.length === 1 ? t[0] : function(r) {
    return t.reduce(function(i, s) {
      return s(i);
    }, r);
  };
}
var Vt = /* @__PURE__ */ function() {
  function t(e) {
    this._isScalar = !1, e && (this._subscribe = e);
  }
  return t.prototype.lift = function(e) {
    var r = new t();
    return r.source = this, r.operator = e, r;
  }, t.prototype.subscribe = function(e, r, i) {
    var s = this.operator, n = tj(e, r, i);
    if (s ? n.add(s.call(n, this.source)) : n.add(this.source || Zn.useDeprecatedSynchronousErrorHandling && !n.syncErrorThrowable ? this._subscribe(n) : this._trySubscribe(n)), Zn.useDeprecatedSynchronousErrorHandling && n.syncErrorThrowable && (n.syncErrorThrowable = !1, n.syncErrorThrown))
      throw n.syncErrorValue;
    return n;
  }, t.prototype._trySubscribe = function(e) {
    try {
      return this._subscribe(e);
    } catch (r) {
      Zn.useDeprecatedSynchronousErrorHandling && (e.syncErrorThrown = !0, e.syncErrorValue = r), s2(e) ? e.error(r) : console.warn(r);
    }
  }, t.prototype.forEach = function(e, r) {
    var i = this;
    return r = i4(r), new r(function(s, n) {
      var f;
      f = i.subscribe(function(u) {
        try {
          e(u);
        } catch (h) {
          n(h), f && f.unsubscribe();
        }
      }, n, s);
    });
  }, t.prototype._subscribe = function(e) {
    var r = this.source;
    return r && r.subscribe(e);
  }, t.prototype[zc] = function() {
    return this;
  }, t.prototype.pipe = function() {
    for (var e = [], r = 0; r < arguments.length; r++)
      e[r] = arguments[r];
    return e.length === 0 ? this : XS(e)(this);
  }, t.prototype.toPromise = function(e) {
    var r = this;
    return e = i4(e), new e(function(i, s) {
      var n;
      r.subscribe(function(f) {
        return n = f;
      }, function(f) {
        return s(f);
      }, function() {
        return i(n);
      });
    });
  }, t.create = function(e) {
    return new t(e);
  }, t;
}();
function i4(t) {
  if (t || (t = Zn.Promise || Promise), !t)
    throw new Error("no Promise impl found");
  return t;
}
var rj = /* @__PURE__ */ function() {
  function t() {
    return Error.call(this), this.message = "object unsubscribed", this.name = "ObjectUnsubscribedError", this;
  }
  return t.prototype = /* @__PURE__ */ Object.create(Error.prototype), t;
}(), eo = rj, e7 = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this) || this;
    return s.subject = r, s.subscriber = i, s.closed = !1, s;
  }
  return e.prototype.unsubscribe = function() {
    if (!this.closed) {
      this.closed = !0;
      var r = this.subject, i = r.observers;
      if (this.subject = null, !(!i || i.length === 0 || r.isStopped || r.closed)) {
        var s = i.indexOf(this.subscriber);
        s !== -1 && i.splice(s, 1);
      }
    }
  }, e;
}(Vr), t7 = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r) {
    var i = t.call(this, r) || this;
    return i.destination = r, i;
  }
  return e;
}(St), mi = /* @__PURE__ */ function(t) {
  it(e, t);
  function e() {
    var r = t.call(this) || this;
    return r.observers = [], r.closed = !1, r.isStopped = !1, r.hasError = !1, r.thrownError = null, r;
  }
  return e.prototype[h0] = function() {
    return new t7(this);
  }, e.prototype.lift = function(r) {
    var i = new n4(this, this);
    return i.operator = r, i;
  }, e.prototype.next = function(r) {
    if (this.closed)
      throw new eo();
    if (!this.isStopped)
      for (var i = this.observers, s = i.length, n = i.slice(), f = 0; f < s; f++)
        n[f].next(r);
  }, e.prototype.error = function(r) {
    if (this.closed)
      throw new eo();
    this.hasError = !0, this.thrownError = r, this.isStopped = !0;
    for (var i = this.observers, s = i.length, n = i.slice(), f = 0; f < s; f++)
      n[f].error(r);
    this.observers.length = 0;
  }, e.prototype.complete = function() {
    if (this.closed)
      throw new eo();
    this.isStopped = !0;
    for (var r = this.observers, i = r.length, s = r.slice(), n = 0; n < i; n++)
      s[n].complete();
    this.observers.length = 0;
  }, e.prototype.unsubscribe = function() {
    this.isStopped = !0, this.closed = !0, this.observers = null;
  }, e.prototype._trySubscribe = function(r) {
    if (this.closed)
      throw new eo();
    return t.prototype._trySubscribe.call(this, r);
  }, e.prototype._subscribe = function(r) {
    if (this.closed)
      throw new eo();
    return this.hasError ? (r.error(this.thrownError), Vr.EMPTY) : this.isStopped ? (r.complete(), Vr.EMPTY) : (this.observers.push(r), new e7(this, r));
  }, e.prototype.asObservable = function() {
    var r = new Vt();
    return r.source = this, r;
  }, e.create = function(r, i) {
    return new n4(r, i);
  }, e;
}(Vt), n4 = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this) || this;
    return s.destination = r, s.source = i, s;
  }
  return e.prototype.next = function(r) {
    var i = this.destination;
    i && i.next && i.next(r);
  }, e.prototype.error = function(r) {
    var i = this.destination;
    i && i.error && this.destination.error(r);
  }, e.prototype.complete = function() {
    var r = this.destination;
    r && r.complete && this.destination.complete();
  }, e.prototype._subscribe = function(r) {
    var i = this.source;
    return i ? this.source.subscribe(r) : Vr.EMPTY;
  }, e;
}(mi);
function a2() {
  return function(e) {
    return e.lift(new ij(e));
  };
}
var ij = /* @__PURE__ */ function() {
  function t(e) {
    this.connectable = e;
  }
  return t.prototype.call = function(e, r) {
    var i = this.connectable;
    i._refCount++;
    var s = new nj(e, i), n = r.subscribe(s);
    return s.closed || (s.connection = i.connect()), n;
  }, t;
}(), nj = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.connectable = i, s;
  }
  return e.prototype._unsubscribe = function() {
    var r = this.connectable;
    if (!r) {
      this.connection = null;
      return;
    }
    this.connectable = null;
    var i = r._refCount;
    if (i <= 0) {
      this.connection = null;
      return;
    }
    if (r._refCount = i - 1, i > 1) {
      this.connection = null;
      return;
    }
    var s = this.connection, n = r._connection;
    this.connection = null, n && (!s || n === s) && n.unsubscribe();
  }, e;
}(St), r7 = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this) || this;
    return s.source = r, s.subjectFactory = i, s._refCount = 0, s._isComplete = !1, s;
  }
  return e.prototype._subscribe = function(r) {
    return this.getSubject().subscribe(r);
  }, e.prototype.getSubject = function() {
    var r = this._subject;
    return (!r || r.isStopped) && (this._subject = this.subjectFactory()), this._subject;
  }, e.prototype.connect = function() {
    var r = this._connection;
    return r || (this._isComplete = !1, r = this._connection = new Vr(), r.add(this.source.subscribe(new aj(this.getSubject(), this))), r.closed && (this._connection = null, r = Vr.EMPTY)), r;
  }, e.prototype.refCount = function() {
    return a2()(this);
  }, e;
}(Vt), sj = /* @__PURE__ */ function() {
  var t = r7.prototype;
  return {
    operator: { value: null },
    _refCount: { value: 0, writable: !0 },
    _subject: { value: null, writable: !0 },
    _connection: { value: null, writable: !0 },
    _subscribe: { value: t._subscribe },
    _isComplete: { value: t._isComplete, writable: !0 },
    getSubject: { value: t.getSubject },
    connect: { value: t.connect },
    refCount: { value: t.refCount }
  };
}(), aj = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.connectable = i, s;
  }
  return e.prototype._error = function(r) {
    this._unsubscribe(), t.prototype._error.call(this, r);
  }, e.prototype._complete = function() {
    this.connectable._isComplete = !0, this._unsubscribe(), t.prototype._complete.call(this);
  }, e.prototype._unsubscribe = function() {
    var r = this.connectable;
    if (r) {
      this.connectable = null;
      var i = r._connection;
      r._refCount = 0, r._subject = null, r._connection = null, i && i.unsubscribe();
    }
  }, e;
}(t7);
function oj(t, e, r, i) {
  return function(s) {
    return s.lift(new fj(t, e, r, i));
  };
}
var fj = /* @__PURE__ */ function() {
  function t(e, r, i, s) {
    this.keySelector = e, this.elementSelector = r, this.durationSelector = i, this.subjectSelector = s;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new cj(e, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
  }, t;
}(), cj = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s, n, f) {
    var u = t.call(this, r) || this;
    return u.keySelector = i, u.elementSelector = s, u.durationSelector = n, u.subjectSelector = f, u.groups = null, u.attemptedToUnsubscribe = !1, u.count = 0, u;
  }
  return e.prototype._next = function(r) {
    var i;
    try {
      i = this.keySelector(r);
    } catch (s) {
      this.error(s);
      return;
    }
    this._group(r, i);
  }, e.prototype._group = function(r, i) {
    var s = this.groups;
    s || (s = this.groups = /* @__PURE__ */ new Map());
    var n = s.get(i), f;
    if (this.elementSelector)
      try {
        f = this.elementSelector(r);
      } catch (d) {
        this.error(d);
      }
    else
      f = r;
    if (!n) {
      n = this.subjectSelector ? this.subjectSelector() : new mi(), s.set(i, n);
      var u = new nm(i, n, this);
      if (this.destination.next(u), this.durationSelector) {
        var h = void 0;
        try {
          h = this.durationSelector(new nm(i, n));
        } catch (d) {
          this.error(d);
          return;
        }
        this.add(h.subscribe(new uj(i, n, this)));
      }
    }
    n.closed || n.next(f);
  }, e.prototype._error = function(r) {
    var i = this.groups;
    i && (i.forEach(function(s, n) {
      s.error(r);
    }), i.clear()), this.destination.error(r);
  }, e.prototype._complete = function() {
    var r = this.groups;
    r && (r.forEach(function(i, s) {
      i.complete();
    }), r.clear()), this.destination.complete();
  }, e.prototype.removeGroup = function(r) {
    this.groups.delete(r);
  }, e.prototype.unsubscribe = function() {
    this.closed || (this.attemptedToUnsubscribe = !0, this.count === 0 && t.prototype.unsubscribe.call(this));
  }, e;
}(St), uj = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, i) || this;
    return n.key = r, n.group = i, n.parent = s, n;
  }
  return e.prototype._next = function(r) {
    this.complete();
  }, e.prototype._unsubscribe = function() {
    var r = this, i = r.parent, s = r.key;
    this.key = this.parent = null, i && i.removeGroup(s);
  }, e;
}(St), nm = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this) || this;
    return n.key = r, n.groupSubject = i, n.refCountSubscription = s, n;
  }
  return e.prototype._subscribe = function(r) {
    var i = new Vr(), s = this, n = s.refCountSubscription, f = s.groupSubject;
    return n && !n.closed && i.add(new hj(n)), i.add(f.subscribe(r)), i;
  }, e;
}(Vt), hj = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r) {
    var i = t.call(this) || this;
    return i.parent = r, r.count++, i;
  }
  return e.prototype.unsubscribe = function() {
    var r = this.parent;
    !r.closed && !this.closed && (t.prototype.unsubscribe.call(this), r.count -= 1, r.count === 0 && r.attemptedToUnsubscribe && r.unsubscribe());
  }, e;
}(Vr), i7 = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r) {
    var i = t.call(this) || this;
    return i._value = r, i;
  }
  return Object.defineProperty(e.prototype, "value", {
    get: function() {
      return this.getValue();
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype._subscribe = function(r) {
    var i = t.prototype._subscribe.call(this, r);
    return i && !i.closed && r.next(this._value), i;
  }, e.prototype.getValue = function() {
    if (this.hasError)
      throw this.thrownError;
    if (this.closed)
      throw new eo();
    return this._value;
  }, e.prototype.next = function(r) {
    t.prototype.next.call(this, this._value = r);
  }, e;
}(mi), lj = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    return t.call(this) || this;
  }
  return e.prototype.schedule = function(r, i) {
    return this;
  }, e;
}(Vr), Ah = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r, i) || this;
    return s.scheduler = r, s.work = i, s.pending = !1, s;
  }
  return e.prototype.schedule = function(r, i) {
    if (i === void 0 && (i = 0), this.closed)
      return this;
    this.state = r;
    var s = this.id, n = this.scheduler;
    return s != null && (this.id = this.recycleAsyncId(n, s, i)), this.pending = !0, this.delay = i, this.id = this.id || this.requestAsyncId(n, this.id, i), this;
  }, e.prototype.requestAsyncId = function(r, i, s) {
    return s === void 0 && (s = 0), setInterval(r.flush.bind(r, this), s);
  }, e.prototype.recycleAsyncId = function(r, i, s) {
    if (s === void 0 && (s = 0), s !== null && this.delay === s && this.pending === !1)
      return i;
    clearInterval(i);
  }, e.prototype.execute = function(r, i) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var s = this._execute(r, i);
    if (s)
      return s;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, e.prototype._execute = function(r, i) {
    var s = !1, n = void 0;
    try {
      this.work(r);
    } catch (f) {
      s = !0, n = !!f && f || new Error(f);
    }
    if (s)
      return this.unsubscribe(), n;
  }, e.prototype._unsubscribe = function() {
    var r = this.id, i = this.scheduler, s = i.actions, n = s.indexOf(this);
    this.work = null, this.state = null, this.pending = !1, this.scheduler = null, n !== -1 && s.splice(n, 1), r != null && (this.id = this.recycleAsyncId(i, r, null)), this.delay = null;
  }, e;
}(lj), dj = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r, i) || this;
    return s.scheduler = r, s.work = i, s;
  }
  return e.prototype.schedule = function(r, i) {
    return i === void 0 && (i = 0), i > 0 ? t.prototype.schedule.call(this, r, i) : (this.delay = i, this.state = r, this.scheduler.flush(this), this);
  }, e.prototype.execute = function(r, i) {
    return i > 0 || this.closed ? t.prototype.execute.call(this, r, i) : this._execute(r, i);
  }, e.prototype.requestAsyncId = function(r, i, s) {
    return s === void 0 && (s = 0), s !== null && s > 0 || s === null && this.delay > 0 ? t.prototype.requestAsyncId.call(this, r, i, s) : r.flush(this);
  }, e;
}(Ah), sm = /* @__PURE__ */ function() {
  function t(e, r) {
    r === void 0 && (r = t.now), this.SchedulerAction = e, this.now = r;
  }
  return t.prototype.schedule = function(e, r, i) {
    return r === void 0 && (r = 0), new this.SchedulerAction(this, e).schedule(i, r);
  }, t.now = function() {
    return Date.now();
  }, t;
}(), Th = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    i === void 0 && (i = sm.now);
    var s = t.call(this, r, function() {
      return e.delegate && e.delegate !== s ? e.delegate.now() : i();
    }) || this;
    return s.actions = [], s.active = !1, s.scheduled = void 0, s;
  }
  return e.prototype.schedule = function(r, i, s) {
    return i === void 0 && (i = 0), e.delegate && e.delegate !== this ? e.delegate.schedule(r, i, s) : t.prototype.schedule.call(this, r, i, s);
  }, e.prototype.flush = function(r) {
    var i = this.actions;
    if (this.active) {
      i.push(r);
      return;
    }
    var s;
    this.active = !0;
    do
      if (s = r.execute(r.state, r.delay))
        break;
    while (r = i.shift());
    if (this.active = !1, s) {
      for (; r = i.shift(); )
        r.unsubscribe();
      throw s;
    }
  }, e;
}(sm), pj = /* @__PURE__ */ function(t) {
  it(e, t);
  function e() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return e;
}(Th), n7 = /* @__PURE__ */ new pj(dj), s7 = n7, mc = /* @__PURE__ */ new Vt(function(t) {
  return t.complete();
});
function Uc(t) {
  return t ? vj(t) : mc;
}
function vj(t) {
  return new Vt(function(e) {
    return t.schedule(function() {
      return e.complete();
    });
  });
}
function An(t) {
  return t && typeof t.schedule == "function";
}
var a7 = function(t) {
  return function(e) {
    for (var r = 0, i = t.length; r < i && !e.closed; r++)
      e.next(t[r]);
    e.complete();
  };
};
function o2(t, e) {
  return new Vt(function(r) {
    var i = new Vr(), s = 0;
    return i.add(e.schedule(function() {
      if (s === t.length) {
        r.complete();
        return;
      }
      r.next(t[s++]), r.closed || i.add(this.schedule());
    })), i;
  });
}
function Nh(t, e) {
  return e ? o2(t, e) : new Vt(a7(t));
}
function Q0() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var r = t[t.length - 1];
  return An(r) ? (t.pop(), o2(t, r)) : Nh(t);
}
function f2(t, e) {
  return e ? new Vt(function(r) {
    return e.schedule(gj, 0, { error: t, subscriber: r });
  }) : new Vt(function(r) {
    return r.error(t);
  });
}
function gj(t) {
  var e = t.error, r = t.subscriber;
  r.error(e);
}
var am;
am || (am = {});
var Ta = /* @__PURE__ */ function() {
  function t(e, r, i) {
    this.kind = e, this.value = r, this.error = i, this.hasValue = e === "N";
  }
  return t.prototype.observe = function(e) {
    switch (this.kind) {
      case "N":
        return e.next && e.next(this.value);
      case "E":
        return e.error && e.error(this.error);
      case "C":
        return e.complete && e.complete();
    }
  }, t.prototype.do = function(e, r, i) {
    var s = this.kind;
    switch (s) {
      case "N":
        return e && e(this.value);
      case "E":
        return r && r(this.error);
      case "C":
        return i && i();
    }
  }, t.prototype.accept = function(e, r, i) {
    return e && typeof e.next == "function" ? this.observe(e) : this.do(e, r, i);
  }, t.prototype.toObservable = function() {
    var e = this.kind;
    switch (e) {
      case "N":
        return Q0(this.value);
      case "E":
        return f2(this.error);
      case "C":
        return Uc();
    }
    throw new Error("unexpected notification kind value");
  }, t.createNext = function(e) {
    return typeof e < "u" ? new t("N", e) : t.undefinedValueNotification;
  }, t.createError = function(e) {
    return new t("E", void 0, e);
  }, t.createComplete = function() {
    return t.completeNotification;
  }, t.completeNotification = new t("C"), t.undefinedValueNotification = new t("N", void 0), t;
}();
function bj(t, e) {
  return e === void 0 && (e = 0), function(i) {
    return i.lift(new yj(t, e));
  };
}
var yj = /* @__PURE__ */ function() {
  function t(e, r) {
    r === void 0 && (r = 0), this.scheduler = e, this.delay = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new o7(e, this.scheduler, this.delay));
  }, t;
}(), o7 = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    s === void 0 && (s = 0);
    var n = t.call(this, r) || this;
    return n.scheduler = i, n.delay = s, n;
  }
  return e.dispatch = function(r) {
    var i = r.notification, s = r.destination;
    i.observe(s), this.unsubscribe();
  }, e.prototype.scheduleMessage = function(r) {
    var i = this.destination;
    i.add(this.scheduler.schedule(e.dispatch, this.delay, new mj(r, this.destination)));
  }, e.prototype._next = function(r) {
    this.scheduleMessage(Ta.createNext(r));
  }, e.prototype._error = function(r) {
    this.scheduleMessage(Ta.createError(r)), this.unsubscribe();
  }, e.prototype._complete = function() {
    this.scheduleMessage(Ta.createComplete()), this.unsubscribe();
  }, e;
}(St), mj = /* @__PURE__ */ function() {
  function t(e, r) {
    this.notification = e, this.destination = r;
  }
  return t;
}(), c2 = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    r === void 0 && (r = Number.POSITIVE_INFINITY), i === void 0 && (i = Number.POSITIVE_INFINITY);
    var n = t.call(this) || this;
    return n.scheduler = s, n._events = [], n._infiniteTimeWindow = !1, n._bufferSize = r < 1 ? 1 : r, n._windowTime = i < 1 ? 1 : i, i === Number.POSITIVE_INFINITY ? (n._infiniteTimeWindow = !0, n.next = n.nextInfiniteTimeWindow) : n.next = n.nextTimeWindow, n;
  }
  return e.prototype.nextInfiniteTimeWindow = function(r) {
    if (!this.isStopped) {
      var i = this._events;
      i.push(r), i.length > this._bufferSize && i.shift();
    }
    t.prototype.next.call(this, r);
  }, e.prototype.nextTimeWindow = function(r) {
    this.isStopped || (this._events.push(new wj(this._getNow(), r)), this._trimBufferThenGetEvents()), t.prototype.next.call(this, r);
  }, e.prototype._subscribe = function(r) {
    var i = this._infiniteTimeWindow, s = i ? this._events : this._trimBufferThenGetEvents(), n = this.scheduler, f = s.length, u;
    if (this.closed)
      throw new eo();
    if (this.isStopped || this.hasError ? u = Vr.EMPTY : (this.observers.push(r), u = new e7(this, r)), n && r.add(r = new o7(r, n)), i)
      for (var h = 0; h < f && !r.closed; h++)
        r.next(s[h]);
    else
      for (var h = 0; h < f && !r.closed; h++)
        r.next(s[h].value);
    return this.hasError ? r.error(this.thrownError) : this.isStopped && r.complete(), u;
  }, e.prototype._getNow = function() {
    return (this.scheduler || s7).now();
  }, e.prototype._trimBufferThenGetEvents = function() {
    for (var r = this._getNow(), i = this._bufferSize, s = this._windowTime, n = this._events, f = n.length, u = 0; u < f && !(r - n[u].time < s); )
      u++;
    return f > i && (u = Math.max(u, f - i)), u > 0 && n.splice(0, u), n;
  }, e;
}(mi), wj = /* @__PURE__ */ function() {
  function t(e, r) {
    this.time = e, this.value = r;
  }
  return t;
}(), Fc = /* @__PURE__ */ function(t) {
  it(e, t);
  function e() {
    var r = t !== null && t.apply(this, arguments) || this;
    return r.value = null, r.hasNext = !1, r.hasCompleted = !1, r;
  }
  return e.prototype._subscribe = function(r) {
    return this.hasError ? (r.error(this.thrownError), Vr.EMPTY) : this.hasCompleted && this.hasNext ? (r.next(this.value), r.complete(), Vr.EMPTY) : t.prototype._subscribe.call(this, r);
  }, e.prototype.next = function(r) {
    this.hasCompleted || (this.value = r, this.hasNext = !0);
  }, e.prototype.error = function(r) {
    this.hasCompleted || t.prototype.error.call(this, r);
  }, e.prototype.complete = function() {
    this.hasCompleted = !0, this.hasNext && t.prototype.next.call(this, this.value), t.prototype.complete.call(this);
  }, e;
}(mi), _j = 1, Mj = /* @__PURE__ */ function() {
  return /* @__PURE__ */ Promise.resolve();
}(), om = {};
function s4(t) {
  return t in om ? (delete om[t], !0) : !1;
}
var a4 = {
  setImmediate: function(t) {
    var e = _j++;
    return om[e] = !0, Mj.then(function() {
      return s4(e) && t();
    }), e;
  },
  clearImmediate: function(t) {
    s4(t);
  }
}, xj = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r, i) || this;
    return s.scheduler = r, s.work = i, s;
  }
  return e.prototype.requestAsyncId = function(r, i, s) {
    return s === void 0 && (s = 0), s !== null && s > 0 ? t.prototype.requestAsyncId.call(this, r, i, s) : (r.actions.push(this), r.scheduled || (r.scheduled = a4.setImmediate(r.flush.bind(r, null))));
  }, e.prototype.recycleAsyncId = function(r, i, s) {
    if (s === void 0 && (s = 0), s !== null && s > 0 || s === null && this.delay > 0)
      return t.prototype.recycleAsyncId.call(this, r, i, s);
    r.actions.length === 0 && (a4.clearImmediate(i), r.scheduled = void 0);
  }, e;
}(Ah), Sj = /* @__PURE__ */ function(t) {
  it(e, t);
  function e() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return e.prototype.flush = function(r) {
    this.active = !0, this.scheduled = void 0;
    var i = this.actions, s, n = -1, f = i.length;
    r = r || i.shift();
    do
      if (s = r.execute(r.state, r.delay))
        break;
    while (++n < f && (r = i.shift()));
    if (this.active = !1, s) {
      for (; ++n < f && (r = i.shift()); )
        r.unsubscribe();
      throw s;
    }
  }, e;
}(Th), f7 = /* @__PURE__ */ new Sj(xj), Vd = f7, c7 = /* @__PURE__ */ new Th(Ah), Xi = c7, Ej = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r, i) || this;
    return s.scheduler = r, s.work = i, s;
  }
  return e.prototype.requestAsyncId = function(r, i, s) {
    return s === void 0 && (s = 0), s !== null && s > 0 ? t.prototype.requestAsyncId.call(this, r, i, s) : (r.actions.push(this), r.scheduled || (r.scheduled = requestAnimationFrame(function() {
      return r.flush(null);
    })));
  }, e.prototype.recycleAsyncId = function(r, i, s) {
    if (s === void 0 && (s = 0), s !== null && s > 0 || s === null && this.delay > 0)
      return t.prototype.recycleAsyncId.call(this, r, i, s);
    r.actions.length === 0 && (cancelAnimationFrame(i), r.scheduled = void 0);
  }, e;
}(Ah), Ij = /* @__PURE__ */ function(t) {
  it(e, t);
  function e() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return e.prototype.flush = function(r) {
    this.active = !0, this.scheduled = void 0;
    var i = this.actions, s, n = -1, f = i.length;
    r = r || i.shift();
    do
      if (s = r.execute(r.state, r.delay))
        break;
    while (++n < f && (r = i.shift()));
    if (this.active = !1, s) {
      for (; ++n < f && (r = i.shift()); )
        r.unsubscribe();
      throw s;
    }
  }, e;
}(Th), u7 = /* @__PURE__ */ new Ij(Ej), Aj = u7, Tj = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    r === void 0 && (r = h7), i === void 0 && (i = Number.POSITIVE_INFINITY);
    var s = t.call(this, r, function() {
      return s.frame;
    }) || this;
    return s.maxFrames = i, s.frame = 0, s.index = -1, s;
  }
  return e.prototype.flush = function() {
    for (var r = this, i = r.actions, s = r.maxFrames, n, f; (f = i[0]) && f.delay <= s && (i.shift(), this.frame = f.delay, !(n = f.execute(f.state, f.delay))); )
      ;
    if (n) {
      for (; f = i.shift(); )
        f.unsubscribe();
      throw n;
    }
  }, e.frameTimeFactor = 10, e;
}(Th), h7 = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    s === void 0 && (s = r.index += 1);
    var n = t.call(this, r, i) || this;
    return n.scheduler = r, n.work = i, n.index = s, n.active = !0, n.index = r.index = s, n;
  }
  return e.prototype.schedule = function(r, i) {
    if (i === void 0 && (i = 0), !this.id)
      return t.prototype.schedule.call(this, r, i);
    this.active = !1;
    var s = new e(this.scheduler, this.work);
    return this.add(s), s.schedule(r, i);
  }, e.prototype.requestAsyncId = function(r, i, s) {
    s === void 0 && (s = 0), this.delay = r.frame + s;
    var n = r.actions;
    return n.push(this), n.sort(e.sortActions), !0;
  }, e.prototype.recycleAsyncId = function(r, i, s) {
  }, e.prototype._execute = function(r, i) {
    if (this.active === !0)
      return t.prototype._execute.call(this, r, i);
  }, e.sortActions = function(r, i) {
    return r.delay === i.delay ? r.index === i.index ? 0 : r.index > i.index ? 1 : -1 : r.delay > i.delay ? 1 : -1;
  }, e;
}(Ah);
function $s() {
}
function Nj(t) {
  return !!t && (t instanceof Vt || typeof t.lift == "function" && typeof t.subscribe == "function");
}
var Dj = /* @__PURE__ */ function() {
  function t() {
    return Error.call(this), this.message = "argument out of range", this.name = "ArgumentOutOfRangeError", this;
  }
  return t.prototype = /* @__PURE__ */ Object.create(Error.prototype), t;
}(), wc = Dj, Cj = /* @__PURE__ */ function() {
  function t() {
    return Error.call(this), this.message = "no elements in sequence", this.name = "EmptyError", this;
  }
  return t.prototype = /* @__PURE__ */ Object.create(Error.prototype), t;
}(), Dh = Cj, Oj = /* @__PURE__ */ function() {
  function t() {
    return Error.call(this), this.message = "Timeout has occurred", this.name = "TimeoutError", this;
  }
  return t.prototype = /* @__PURE__ */ Object.create(Error.prototype), t;
}(), l7 = Oj;
function ns(t, e) {
  return function(i) {
    if (typeof t != "function")
      throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
    return i.lift(new Rj(t, e));
  };
}
var Rj = /* @__PURE__ */ function() {
  function t(e, r) {
    this.project = e, this.thisArg = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new Lj(e, this.project, this.thisArg));
  }, t;
}(), Lj = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.project = i, n.count = 0, n.thisArg = s || n, n;
  }
  return e.prototype._next = function(r) {
    var i;
    try {
      i = this.project.call(this.thisArg, r, this.count++);
    } catch (s) {
      this.destination.error(s);
      return;
    }
    this.destination.next(i);
  }, e;
}(St);
function d7(t, e, r) {
  if (e)
    if (An(e))
      r = e;
    else
      return function() {
        for (var i = [], s = 0; s < arguments.length; s++)
          i[s] = arguments[s];
        return d7(t, r).apply(void 0, i).pipe(ns(function(n) {
          return Ji(n) ? e.apply(void 0, n) : e(n);
        }));
      };
  return function() {
    for (var i = [], s = 0; s < arguments.length; s++)
      i[s] = arguments[s];
    var n = this, f, u = {
      context: n,
      subject: f,
      callbackFunc: t,
      scheduler: r
    };
    return new Vt(function(h) {
      if (r) {
        var l = {
          args: i,
          subscriber: h,
          params: u
        };
        return r.schedule(Pj, 0, l);
      } else {
        if (!f) {
          f = new Fc();
          var d = function() {
            for (var m = [], b = 0; b < arguments.length; b++)
              m[b] = arguments[b];
            f.next(m.length <= 1 ? m[0] : m), f.complete();
          };
          try {
            t.apply(n, i.concat([d]));
          } catch (m) {
            s2(f) ? f.error(m) : console.warn(m);
          }
        }
        return f.subscribe(h);
      }
    });
  };
}
function Pj(t) {
  var e = this, r = t.args, i = t.subscriber, s = t.params, n = s.callbackFunc, f = s.context, u = s.scheduler, h = s.subject;
  if (!h) {
    h = s.subject = new Fc();
    var d = function() {
      for (var l = [], m = 0; m < arguments.length; m++)
        l[m] = arguments[m];
      var b = l.length <= 1 ? l[0] : l;
      e.add(u.schedule(kj, 0, { value: b, subject: h }));
    };
    try {
      n.apply(f, r.concat([d]));
    } catch (l) {
      h.error(l);
    }
  }
  this.add(h.subscribe(i));
}
function kj(t) {
  var e = t.value, r = t.subject;
  r.next(e), r.complete();
}
function p7(t, e, r) {
  if (e)
    if (An(e))
      r = e;
    else
      return function() {
        for (var i = [], s = 0; s < arguments.length; s++)
          i[s] = arguments[s];
        return p7(t, r).apply(void 0, i).pipe(ns(function(n) {
          return Ji(n) ? e.apply(void 0, n) : e(n);
        }));
      };
  return function() {
    for (var i = [], s = 0; s < arguments.length; s++)
      i[s] = arguments[s];
    var n = {
      subject: void 0,
      args: i,
      callbackFunc: t,
      scheduler: r,
      context: this
    };
    return new Vt(function(f) {
      var u = n.context, h = n.subject;
      if (r)
        return r.schedule(jj, 0, { params: n, subscriber: f, context: u });
      if (!h) {
        h = n.subject = new Fc();
        var d = function() {
          for (var l = [], m = 0; m < arguments.length; m++)
            l[m] = arguments[m];
          var b = l.shift();
          if (b) {
            h.error(b);
            return;
          }
          h.next(l.length <= 1 ? l[0] : l), h.complete();
        };
        try {
          t.apply(u, i.concat([d]));
        } catch (l) {
          s2(h) ? h.error(l) : console.warn(l);
        }
      }
      return h.subscribe(f);
    });
  };
}
function jj(t) {
  var e = this, r = t.params, i = t.subscriber, s = t.context, n = r.callbackFunc, f = r.args, u = r.scheduler, h = r.subject;
  if (!h) {
    h = r.subject = new Fc();
    var d = function() {
      for (var l = [], m = 0; m < arguments.length; m++)
        l[m] = arguments[m];
      var b = l.shift();
      if (b)
        e.add(u.schedule(o4, 0, { err: b, subject: h }));
      else {
        var M = l.length <= 1 ? l[0] : l;
        e.add(u.schedule(Bj, 0, { value: M, subject: h }));
      }
    };
    try {
      n.apply(s, f.concat([d]));
    } catch (l) {
      this.add(u.schedule(o4, 0, { err: l, subject: h }));
    }
  }
  this.add(h.subscribe(i));
}
function Bj(t) {
  var e = t.value, r = t.subject;
  r.next(e), r.complete();
}
function o4(t) {
  var e = t.err, r = t.subject;
  r.error(e);
}
var vf = /* @__PURE__ */ function(t) {
  it(e, t);
  function e() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return e.prototype.notifyNext = function(r, i, s, n, f) {
    this.destination.next(i);
  }, e.prototype.notifyError = function(r, i) {
    this.destination.error(r);
  }, e.prototype.notifyComplete = function(r) {
    this.destination.complete();
  }, e;
}(St), zj = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this) || this;
    return n.parent = r, n.outerValue = i, n.outerIndex = s, n.index = 0, n;
  }
  return e.prototype._next = function(r) {
    this.parent.notifyNext(this.outerValue, r, this.outerIndex, this.index++, this);
  }, e.prototype._error = function(r) {
    this.parent.notifyError(r, this), this.unsubscribe();
  }, e.prototype._complete = function() {
    this.parent.notifyComplete(this), this.unsubscribe();
  }, e;
}(St), Uj = function(t) {
  return function(e) {
    return t.then(function(r) {
      e.closed || (e.next(r), e.complete());
    }, function(r) {
      return e.error(r);
    }).then(null, ic), e;
  };
};
function Fj() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var fo = /* @__PURE__ */ Fj(), $j = function(t) {
  return function(e) {
    var r = t[fo]();
    do {
      var i = void 0;
      try {
        i = r.next();
      } catch (s) {
        return e.error(s), e;
      }
      if (i.done) {
        e.complete();
        break;
      }
      if (e.next(i.value), e.closed)
        break;
    } while (!0);
    return typeof r.return == "function" && e.add(function() {
      r.return && r.return();
    }), e;
  };
}, qj = function(t) {
  return function(e) {
    var r = t[zc]();
    if (typeof r.subscribe != "function")
      throw new TypeError("Provided object does not correctly implement Symbol.observable");
    return r.subscribe(e);
  };
}, v7 = function(t) {
  return t && typeof t.length == "number" && typeof t != "function";
};
function g7(t) {
  return !!t && typeof t.subscribe != "function" && typeof t.then == "function";
}
var hh = function(t) {
  if (!!t && typeof t[zc] == "function")
    return qj(t);
  if (v7(t))
    return a7(t);
  if (g7(t))
    return Uj(t);
  if (!!t && typeof t[fo] == "function")
    return $j(t);
  var e = n2(t) ? "an invalid object" : "'" + t + "'", r = "You provided " + e + " where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.";
  throw new TypeError(r);
};
function Da(t, e, r, i, s) {
  if (s === void 0 && (s = new zj(t, r, i)), !s.closed)
    return e instanceof Vt ? e.subscribe(s) : hh(e)(s);
}
var f4 = {};
function Hj() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var r = void 0, i = void 0;
  return An(t[t.length - 1]) && (i = t.pop()), typeof t[t.length - 1] == "function" && (r = t.pop()), t.length === 1 && Ji(t[0]) && (t = t[0]), Nh(t, i).lift(new u2(r));
}
var u2 = /* @__PURE__ */ function() {
  function t(e) {
    this.resultSelector = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new Wj(e, this.resultSelector));
  }, t;
}(), Wj = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.resultSelector = i, s.active = 0, s.values = [], s.observables = [], s;
  }
  return e.prototype._next = function(r) {
    this.values.push(f4), this.observables.push(r);
  }, e.prototype._complete = function() {
    var r = this.observables, i = r.length;
    if (i === 0)
      this.destination.complete();
    else {
      this.active = i, this.toRespond = i;
      for (var s = 0; s < i; s++) {
        var n = r[s];
        this.add(Da(this, n, void 0, s));
      }
    }
  }, e.prototype.notifyComplete = function(r) {
    (this.active -= 1) === 0 && this.destination.complete();
  }, e.prototype.notifyNext = function(r, i, s) {
    var n = this.values, f = n[s], u = this.toRespond ? f === f4 ? --this.toRespond : this.toRespond : 0;
    n[s] = i, u === 0 && (this.resultSelector ? this._tryResultSelector(n) : this.destination.next(n.slice()));
  }, e.prototype._tryResultSelector = function(r) {
    var i;
    try {
      i = this.resultSelector.apply(this, r);
    } catch (s) {
      this.destination.error(s);
      return;
    }
    this.destination.next(i);
  }, e;
}(vf);
function Vj(t, e) {
  return new Vt(function(r) {
    var i = new Vr();
    return i.add(e.schedule(function() {
      var s = t[zc]();
      i.add(s.subscribe({
        next: function(n) {
          i.add(e.schedule(function() {
            return r.next(n);
          }));
        },
        error: function(n) {
          i.add(e.schedule(function() {
            return r.error(n);
          }));
        },
        complete: function() {
          i.add(e.schedule(function() {
            return r.complete();
          }));
        }
      }));
    })), i;
  });
}
function Gj(t, e) {
  return new Vt(function(r) {
    var i = new Vr();
    return i.add(e.schedule(function() {
      return t.then(function(s) {
        i.add(e.schedule(function() {
          r.next(s), i.add(e.schedule(function() {
            return r.complete();
          }));
        }));
      }, function(s) {
        i.add(e.schedule(function() {
          return r.error(s);
        }));
      });
    })), i;
  });
}
function Kj(t, e) {
  if (!t)
    throw new Error("Iterable cannot be null");
  return new Vt(function(r) {
    var i = new Vr(), s;
    return i.add(function() {
      s && typeof s.return == "function" && s.return();
    }), i.add(e.schedule(function() {
      s = t[fo](), i.add(e.schedule(function() {
        if (!r.closed) {
          var n, f;
          try {
            var u = s.next();
            n = u.value, f = u.done;
          } catch (h) {
            r.error(h);
            return;
          }
          f ? r.complete() : (r.next(n), this.schedule());
        }
      }));
    })), i;
  });
}
function Yj(t) {
  return t && typeof t[zc] == "function";
}
function Qj(t) {
  return t && typeof t[fo] == "function";
}
function b7(t, e) {
  if (t != null) {
    if (Yj(t))
      return Vj(t, e);
    if (g7(t))
      return Gj(t, e);
    if (v7(t))
      return o2(t, e);
    if (Qj(t) || typeof t == "string")
      return Kj(t, e);
  }
  throw new TypeError((t !== null && typeof t || t) + " is not observable");
}
function ka(t, e) {
  return e ? b7(t, e) : t instanceof Vt ? t : new Vt(hh(t));
}
var Qr = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r) {
    var i = t.call(this) || this;
    return i.parent = r, i;
  }
  return e.prototype._next = function(r) {
    this.parent.notifyNext(r);
  }, e.prototype._error = function(r) {
    this.parent.notifyError(r), this.unsubscribe();
  }, e.prototype._complete = function() {
    this.parent.notifyComplete(), this.unsubscribe();
  }, e;
}(St), Zr = /* @__PURE__ */ function(t) {
  it(e, t);
  function e() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return e.prototype.notifyNext = function(r) {
    this.destination.next(r);
  }, e.prototype.notifyError = function(r) {
    this.destination.error(r);
  }, e.prototype.notifyComplete = function() {
    this.destination.complete();
  }, e;
}(St);
function Jr(t, e) {
  if (!e.closed) {
    if (t instanceof Vt)
      return t.subscribe(e);
    var r;
    try {
      r = hh(t)(e);
    } catch (i) {
      e.error(i);
    }
    return r;
  }
}
function sf(t, e, r) {
  return r === void 0 && (r = Number.POSITIVE_INFINITY), typeof e == "function" ? function(i) {
    return i.pipe(sf(function(s, n) {
      return ka(t(s, n)).pipe(ns(function(f, u) {
        return e(s, f, n, u);
      }));
    }, r));
  } : (typeof e == "number" && (r = e), function(i) {
    return i.lift(new Zj(t, r));
  });
}
var Zj = /* @__PURE__ */ function() {
  function t(e, r) {
    r === void 0 && (r = Number.POSITIVE_INFINITY), this.project = e, this.concurrent = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new Jj(e, this.project, this.concurrent));
  }, t;
}(), Jj = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    s === void 0 && (s = Number.POSITIVE_INFINITY);
    var n = t.call(this, r) || this;
    return n.project = i, n.concurrent = s, n.hasCompleted = !1, n.buffer = [], n.active = 0, n.index = 0, n;
  }
  return e.prototype._next = function(r) {
    this.active < this.concurrent ? this._tryNext(r) : this.buffer.push(r);
  }, e.prototype._tryNext = function(r) {
    var i, s = this.index++;
    try {
      i = this.project(r, s);
    } catch (n) {
      this.destination.error(n);
      return;
    }
    this.active++, this._innerSub(i);
  }, e.prototype._innerSub = function(r) {
    var i = new Qr(this), s = this.destination;
    s.add(i);
    var n = Jr(r, i);
    n !== i && s.add(n);
  }, e.prototype._complete = function() {
    this.hasCompleted = !0, this.active === 0 && this.buffer.length === 0 && this.destination.complete(), this.unsubscribe();
  }, e.prototype.notifyNext = function(r) {
    this.destination.next(r);
  }, e.prototype.notifyComplete = function() {
    var r = this.buffer;
    this.active--, r.length > 0 ? this._next(r.shift()) : this.active === 0 && this.hasCompleted && this.destination.complete();
  }, e;
}(Zr), Xj = sf;
function h2(t) {
  return t === void 0 && (t = Number.POSITIVE_INFINITY), sf(oo, t);
}
function y7() {
  return h2(1);
}
function lh() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  return y7()(Q0.apply(void 0, t));
}
function l2(t) {
  return new Vt(function(e) {
    var r;
    try {
      r = t();
    } catch (s) {
      e.error(s);
      return;
    }
    var i = r ? ka(r) : Uc();
    return i.subscribe(e);
  });
}
function eB() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  if (t.length === 1) {
    var r = t[0];
    if (Ji(r))
      return vd(r, null);
    if (n2(r) && Object.getPrototypeOf(r) === Object.prototype) {
      var i = Object.keys(r);
      return vd(i.map(function(n) {
        return r[n];
      }), i);
    }
  }
  if (typeof t[t.length - 1] == "function") {
    var s = t.pop();
    return t = t.length === 1 && Ji(t[0]) ? t[0] : t, vd(t, null).pipe(ns(function(n) {
      return s.apply(void 0, n);
    }));
  }
  return vd(t, null);
}
function vd(t, e) {
  return new Vt(function(r) {
    var i = t.length;
    if (i === 0) {
      r.complete();
      return;
    }
    for (var s = new Array(i), n = 0, f = 0, u = function(d) {
      var l = ka(t[d]), m = !1;
      r.add(l.subscribe({
        next: function(b) {
          m || (m = !0, f++), s[d] = b;
        },
        error: function(b) {
          return r.error(b);
        },
        complete: function() {
          n++, (n === i || !m) && (f === i && r.next(e ? e.reduce(function(b, M, A) {
            return b[M] = s[A], b;
          }, {}) : s), r.complete());
        }
      }));
    }, h = 0; h < i; h++)
      u(h);
  });
}
function m7(t, e, r, i) {
  return yc(r) && (i = r, r = void 0), i ? m7(t, e, r).pipe(ns(function(s) {
    return Ji(s) ? i.apply(void 0, s) : i(s);
  })) : new Vt(function(s) {
    function n(f) {
      arguments.length > 1 ? s.next(Array.prototype.slice.call(arguments)) : s.next(f);
    }
    w7(t, e, n, s, r);
  });
}
function w7(t, e, r, i, s) {
  var n;
  if (iB(t)) {
    var f = t;
    t.addEventListener(e, r, s), n = function() {
      return f.removeEventListener(e, r, s);
    };
  } else if (rB(t)) {
    var u = t;
    t.on(e, r), n = function() {
      return u.off(e, r);
    };
  } else if (tB(t)) {
    var h = t;
    t.addListener(e, r), n = function() {
      return h.removeListener(e, r);
    };
  } else if (t && t.length)
    for (var d = 0, l = t.length; d < l; d++)
      w7(t[d], e, r, i, s);
  else
    throw new TypeError("Invalid event target");
  i.add(n);
}
function tB(t) {
  return t && typeof t.addListener == "function" && typeof t.removeListener == "function";
}
function rB(t) {
  return t && typeof t.on == "function" && typeof t.off == "function";
}
function iB(t) {
  return t && typeof t.addEventListener == "function" && typeof t.removeEventListener == "function";
}
function _7(t, e, r) {
  return r ? _7(t, e).pipe(ns(function(i) {
    return Ji(i) ? r.apply(void 0, i) : r(i);
  })) : new Vt(function(i) {
    var s = function() {
      for (var f = [], u = 0; u < arguments.length; u++)
        f[u] = arguments[u];
      return i.next(f.length === 1 ? f[0] : f);
    }, n;
    try {
      n = t(s);
    } catch (f) {
      i.error(f);
      return;
    }
    if (!!yc(e))
      return function() {
        return e(s, n);
      };
  });
}
function nB(t, e, r, i, s) {
  var n, f;
  if (arguments.length == 1) {
    var u = t;
    f = u.initialState, e = u.condition, r = u.iterate, n = u.resultSelector || oo, s = u.scheduler;
  } else
    i === void 0 || An(i) ? (f = t, n = oo, s = i) : (f = t, n = i);
  return new Vt(function(h) {
    var d = f;
    if (s)
      return s.schedule(sB, 0, {
        subscriber: h,
        iterate: r,
        condition: e,
        resultSelector: n,
        state: d
      });
    do {
      if (e) {
        var l = void 0;
        try {
          l = e(d);
        } catch (b) {
          h.error(b);
          return;
        }
        if (!l) {
          h.complete();
          break;
        }
      }
      var m = void 0;
      try {
        m = n(d);
      } catch (b) {
        h.error(b);
        return;
      }
      if (h.next(m), h.closed)
        break;
      try {
        d = r(d);
      } catch (b) {
        h.error(b);
        return;
      }
    } while (!0);
  });
}
function sB(t) {
  var e = t.subscriber, r = t.condition;
  if (!e.closed) {
    if (t.needIterate)
      try {
        t.state = t.iterate(t.state);
      } catch (n) {
        e.error(n);
        return;
      }
    else
      t.needIterate = !0;
    if (r) {
      var i = void 0;
      try {
        i = r(t.state);
      } catch (n) {
        e.error(n);
        return;
      }
      if (!i) {
        e.complete();
        return;
      }
      if (e.closed)
        return;
    }
    var s;
    try {
      s = t.resultSelector(t.state);
    } catch (n) {
      e.error(n);
      return;
    }
    if (!e.closed && (e.next(s), !e.closed))
      return this.schedule(t);
  }
}
function aB(t, e, r) {
  return e === void 0 && (e = mc), r === void 0 && (r = mc), l2(function() {
    return t() ? e : r;
  });
}
function _c(t) {
  return !Ji(t) && t - parseFloat(t) + 1 >= 0;
}
function oB(t, e) {
  return t === void 0 && (t = 0), e === void 0 && (e = Xi), (!_c(t) || t < 0) && (t = 0), (!e || typeof e.schedule != "function") && (e = Xi), new Vt(function(r) {
    return r.add(e.schedule(fB, t, { subscriber: r, counter: 0, period: t })), r;
  });
}
function fB(t) {
  var e = t.subscriber, r = t.counter, i = t.period;
  e.next(r), this.schedule({ subscriber: e, counter: r + 1, period: i }, i);
}
function M7() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var r = Number.POSITIVE_INFINITY, i = null, s = t[t.length - 1];
  return An(s) ? (i = t.pop(), t.length > 1 && typeof t[t.length - 1] == "number" && (r = t.pop())) : typeof s == "number" && (r = t.pop()), i === null && t.length === 1 && t[0] instanceof Vt ? t[0] : h2(r)(Nh(t, i));
}
var x7 = /* @__PURE__ */ new Vt($s);
function cB() {
  return x7;
}
function fm() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  if (t.length === 0)
    return mc;
  var r = t[0], i = t.slice(1);
  return t.length === 1 && Ji(r) ? fm.apply(void 0, r) : new Vt(function(s) {
    var n = function() {
      return s.add(fm.apply(void 0, i).subscribe(s));
    };
    return ka(r).subscribe({
      next: function(f) {
        s.next(f);
      },
      error: n,
      complete: n
    });
  });
}
function uB(t, e) {
  return e ? new Vt(function(r) {
    var i = Object.keys(t), s = new Vr();
    return s.add(e.schedule(hB, 0, { keys: i, index: 0, subscriber: r, subscription: s, obj: t })), s;
  }) : new Vt(function(r) {
    for (var i = Object.keys(t), s = 0; s < i.length && !r.closed; s++) {
      var n = i[s];
      t.hasOwnProperty(n) && r.next([n, t[n]]);
    }
    r.complete();
  });
}
function hB(t) {
  var e = t.keys, r = t.index, i = t.subscriber, s = t.subscription, n = t.obj;
  if (!i.closed)
    if (r < e.length) {
      var f = e[r];
      i.next([f, n[f]]), s.add(this.schedule({ keys: e, index: r + 1, subscriber: i, subscription: s, obj: n }));
    } else
      i.complete();
}
function S7(t, e) {
  function r() {
    return !r.pred.apply(r.thisArg, arguments);
  }
  return r.pred = t, r.thisArg = e, r;
}
function co(t, e) {
  return function(i) {
    return i.lift(new lB(t, e));
  };
}
var lB = /* @__PURE__ */ function() {
  function t(e, r) {
    this.predicate = e, this.thisArg = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new dB(e, this.predicate, this.thisArg));
  }, t;
}(), dB = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.predicate = i, n.thisArg = s, n.count = 0, n;
  }
  return e.prototype._next = function(r) {
    var i;
    try {
      i = this.predicate.call(this.thisArg, r, this.count++);
    } catch (s) {
      this.destination.error(s);
      return;
    }
    i && this.destination.next(r);
  }, e;
}(St);
function pB(t, e, r) {
  return [
    co(e, r)(new Vt(hh(t))),
    co(S7(e, r))(new Vt(hh(t)))
  ];
}
function E7() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  if (t.length === 1)
    if (Ji(t[0]))
      t = t[0];
    else
      return t[0];
  return Nh(t, void 0).lift(new vB());
}
var vB = /* @__PURE__ */ function() {
  function t() {
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new gB(e));
  }, t;
}(), gB = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r) {
    var i = t.call(this, r) || this;
    return i.hasFirst = !1, i.observables = [], i.subscriptions = [], i;
  }
  return e.prototype._next = function(r) {
    this.observables.push(r);
  }, e.prototype._complete = function() {
    var r = this.observables, i = r.length;
    if (i === 0)
      this.destination.complete();
    else {
      for (var s = 0; s < i && !this.hasFirst; s++) {
        var n = r[s], f = Da(this, n, void 0, s);
        this.subscriptions && this.subscriptions.push(f), this.add(f);
      }
      this.observables = null;
    }
  }, e.prototype.notifyNext = function(r, i, s) {
    if (!this.hasFirst) {
      this.hasFirst = !0;
      for (var n = 0; n < this.subscriptions.length; n++)
        if (n !== s) {
          var f = this.subscriptions[n];
          f.unsubscribe(), this.remove(f);
        }
      this.subscriptions = null;
    }
    this.destination.next(i);
  }, e;
}(vf);
function bB(t, e, r) {
  return t === void 0 && (t = 0), new Vt(function(i) {
    e === void 0 && (e = t, t = 0);
    var s = 0, n = t;
    if (r)
      return r.schedule(yB, 0, {
        index: s,
        count: e,
        start: t,
        subscriber: i
      });
    do {
      if (s++ >= e) {
        i.complete();
        break;
      }
      if (i.next(n++), i.closed)
        break;
    } while (!0);
  });
}
function yB(t) {
  var e = t.start, r = t.index, i = t.count, s = t.subscriber;
  if (r >= i) {
    s.complete();
    return;
  }
  s.next(e), !s.closed && (t.index = r + 1, t.start = e + 1, this.schedule(t));
}
function I7(t, e, r) {
  t === void 0 && (t = 0);
  var i = -1;
  return _c(e) ? i = Number(e) < 1 && 1 || Number(e) : An(e) && (r = e), An(r) || (r = Xi), new Vt(function(s) {
    var n = _c(t) ? t : +t - r.now();
    return r.schedule(mB, n, {
      index: 0,
      period: i,
      subscriber: s
    });
  });
}
function mB(t) {
  var e = t.index, r = t.period, i = t.subscriber;
  if (i.next(e), !i.closed) {
    if (r === -1)
      return i.complete();
    t.index = e + 1, this.schedule(t, r);
  }
}
function wB(t, e) {
  return new Vt(function(r) {
    var i;
    try {
      i = t();
    } catch (u) {
      r.error(u);
      return;
    }
    var s;
    try {
      s = e(i);
    } catch (u) {
      r.error(u);
      return;
    }
    var n = s ? ka(s) : mc, f = n.subscribe(r);
    return function() {
      f.unsubscribe(), i && i.unsubscribe();
    };
  });
}
function A7() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var r = t[t.length - 1];
  return typeof r == "function" && t.pop(), Nh(t, void 0).lift(new T7(r));
}
var T7 = /* @__PURE__ */ function() {
  function t(e) {
    this.resultSelector = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new _B(e, this.resultSelector));
  }, t;
}(), _B = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.resultSelector = i, n.iterators = [], n.active = 0, n.resultSelector = typeof i == "function" ? i : void 0, n;
  }
  return e.prototype._next = function(r) {
    var i = this.iterators;
    Ji(r) ? i.push(new xB(r)) : typeof r[fo] == "function" ? i.push(new MB(r[fo]())) : i.push(new SB(this.destination, this, r));
  }, e.prototype._complete = function() {
    var r = this.iterators, i = r.length;
    if (this.unsubscribe(), i === 0) {
      this.destination.complete();
      return;
    }
    this.active = i;
    for (var s = 0; s < i; s++) {
      var n = r[s];
      if (n.stillUnsubscribed) {
        var f = this.destination;
        f.add(n.subscribe());
      } else
        this.active--;
    }
  }, e.prototype.notifyInactive = function() {
    this.active--, this.active === 0 && this.destination.complete();
  }, e.prototype.checkIterators = function() {
    for (var r = this.iterators, i = r.length, s = this.destination, n = 0; n < i; n++) {
      var f = r[n];
      if (typeof f.hasValue == "function" && !f.hasValue())
        return;
    }
    for (var u = !1, h = [], n = 0; n < i; n++) {
      var f = r[n], d = f.next();
      if (f.hasCompleted() && (u = !0), d.done) {
        s.complete();
        return;
      }
      h.push(d.value);
    }
    this.resultSelector ? this._tryresultSelector(h) : s.next(h), u && s.complete();
  }, e.prototype._tryresultSelector = function(r) {
    var i;
    try {
      i = this.resultSelector.apply(this, r);
    } catch (s) {
      this.destination.error(s);
      return;
    }
    this.destination.next(i);
  }, e;
}(St), MB = /* @__PURE__ */ function() {
  function t(e) {
    this.iterator = e, this.nextResult = e.next();
  }
  return t.prototype.hasValue = function() {
    return !0;
  }, t.prototype.next = function() {
    var e = this.nextResult;
    return this.nextResult = this.iterator.next(), e;
  }, t.prototype.hasCompleted = function() {
    var e = this.nextResult;
    return Boolean(e && e.done);
  }, t;
}(), xB = /* @__PURE__ */ function() {
  function t(e) {
    this.array = e, this.index = 0, this.length = 0, this.length = e.length;
  }
  return t.prototype[fo] = function() {
    return this;
  }, t.prototype.next = function(e) {
    var r = this.index++, i = this.array;
    return r < this.length ? { value: i[r], done: !1 } : { value: null, done: !0 };
  }, t.prototype.hasValue = function() {
    return this.array.length > this.index;
  }, t.prototype.hasCompleted = function() {
    return this.array.length === this.index;
  }, t;
}(), SB = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.parent = i, n.observable = s, n.stillUnsubscribed = !0, n.buffer = [], n.isComplete = !1, n;
  }
  return e.prototype[fo] = function() {
    return this;
  }, e.prototype.next = function() {
    var r = this.buffer;
    return r.length === 0 && this.isComplete ? { value: null, done: !0 } : { value: r.shift(), done: !1 };
  }, e.prototype.hasValue = function() {
    return this.buffer.length > 0;
  }, e.prototype.hasCompleted = function() {
    return this.buffer.length === 0 && this.isComplete;
  }, e.prototype.notifyComplete = function() {
    this.buffer.length > 0 ? (this.isComplete = !0, this.parent.notifyInactive()) : this.destination.complete();
  }, e.prototype.notifyNext = function(r) {
    this.buffer.push(r), this.parent.checkIterators();
  }, e.prototype.subscribe = function() {
    return Jr(this.observable, new Qr(this));
  }, e;
}(Zr);
const EB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Observable: Vt,
  ConnectableObservable: r7,
  GroupedObservable: nm,
  observable: zc,
  Subject: mi,
  BehaviorSubject: i7,
  ReplaySubject: c2,
  AsyncSubject: Fc,
  asap: Vd,
  asapScheduler: f7,
  async: Xi,
  asyncScheduler: c7,
  queue: s7,
  queueScheduler: n7,
  animationFrame: Aj,
  animationFrameScheduler: u7,
  VirtualTimeScheduler: Tj,
  VirtualAction: h7,
  Scheduler: sm,
  Subscription: Vr,
  Subscriber: St,
  Notification: Ta,
  get NotificationKind() {
    return am;
  },
  pipe: im,
  noop: $s,
  identity: oo,
  isObservable: Nj,
  ArgumentOutOfRangeError: wc,
  EmptyError: Dh,
  ObjectUnsubscribedError: eo,
  UnsubscriptionError: Zu,
  TimeoutError: l7,
  bindCallback: d7,
  bindNodeCallback: p7,
  combineLatest: Hj,
  concat: lh,
  defer: l2,
  empty: Uc,
  forkJoin: eB,
  from: ka,
  fromEvent: m7,
  fromEventPattern: _7,
  generate: nB,
  iif: aB,
  interval: oB,
  merge: M7,
  never: cB,
  of: Q0,
  onErrorResumeNext: fm,
  pairs: uB,
  partition: pB,
  race: E7,
  range: bB,
  throwError: f2,
  timer: I7,
  using: wB,
  zip: A7,
  scheduled: b7,
  EMPTY: mc,
  NEVER: x7,
  config: Zn
}, Symbol.toStringTag, { value: "Module" })), $c = /* @__PURE__ */ pf(EB);
function N7(t) {
  return function(r) {
    return r.lift(new IB(t));
  };
}
var IB = /* @__PURE__ */ function() {
  function t(e) {
    this.durationSelector = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new AB(e, this.durationSelector));
  }, t;
}(), AB = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.durationSelector = i, s.hasValue = !1, s;
  }
  return e.prototype._next = function(r) {
    if (this.value = r, this.hasValue = !0, !this.throttled) {
      var i = void 0;
      try {
        var s = this.durationSelector;
        i = s(r);
      } catch (f) {
        return this.destination.error(f);
      }
      var n = Jr(i, new Qr(this));
      !n || n.closed ? this.clearThrottle() : this.add(this.throttled = n);
    }
  }, e.prototype.clearThrottle = function() {
    var r = this, i = r.value, s = r.hasValue, n = r.throttled;
    n && (this.remove(n), this.throttled = void 0, n.unsubscribe()), s && (this.value = void 0, this.hasValue = !1, this.destination.next(i));
  }, e.prototype.notifyNext = function() {
    this.clearThrottle();
  }, e.prototype.notifyComplete = function() {
    this.clearThrottle();
  }, e;
}(Zr);
function TB(t, e) {
  return e === void 0 && (e = Xi), N7(function() {
    return I7(t, e);
  });
}
function NB(t) {
  return function(r) {
    return r.lift(new DB(t));
  };
}
var DB = /* @__PURE__ */ function() {
  function t(e) {
    this.closingNotifier = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new CB(e, this.closingNotifier));
  }, t;
}(), CB = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.buffer = [], s.add(Jr(i, new Qr(s))), s;
  }
  return e.prototype._next = function(r) {
    this.buffer.push(r);
  }, e.prototype.notifyNext = function() {
    var r = this.buffer;
    this.buffer = [], this.destination.next(r);
  }, e;
}(Zr);
function OB(t, e) {
  return e === void 0 && (e = null), function(i) {
    return i.lift(new RB(t, e));
  };
}
var RB = /* @__PURE__ */ function() {
  function t(e, r) {
    this.bufferSize = e, this.startBufferEvery = r, !r || e === r ? this.subscriberClass = LB : this.subscriberClass = PB;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new this.subscriberClass(e, this.bufferSize, this.startBufferEvery));
  }, t;
}(), LB = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.bufferSize = i, s.buffer = [], s;
  }
  return e.prototype._next = function(r) {
    var i = this.buffer;
    i.push(r), i.length == this.bufferSize && (this.destination.next(i), this.buffer = []);
  }, e.prototype._complete = function() {
    var r = this.buffer;
    r.length > 0 && this.destination.next(r), t.prototype._complete.call(this);
  }, e;
}(St), PB = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.bufferSize = i, n.startBufferEvery = s, n.buffers = [], n.count = 0, n;
  }
  return e.prototype._next = function(r) {
    var i = this, s = i.bufferSize, n = i.startBufferEvery, f = i.buffers, u = i.count;
    this.count++, u % n === 0 && f.push([]);
    for (var h = f.length; h--; ) {
      var d = f[h];
      d.push(r), d.length === s && (f.splice(h, 1), this.destination.next(d));
    }
  }, e.prototype._complete = function() {
    for (var r = this, i = r.buffers, s = r.destination; i.length > 0; ) {
      var n = i.shift();
      n.length > 0 && s.next(n);
    }
    t.prototype._complete.call(this);
  }, e;
}(St);
function kB(t) {
  var e = arguments.length, r = Xi;
  An(arguments[arguments.length - 1]) && (r = arguments[arguments.length - 1], e--);
  var i = null;
  e >= 2 && (i = arguments[1]);
  var s = Number.POSITIVE_INFINITY;
  return e >= 3 && (s = arguments[2]), function(f) {
    return f.lift(new jB(t, i, s, r));
  };
}
var jB = /* @__PURE__ */ function() {
  function t(e, r, i, s) {
    this.bufferTimeSpan = e, this.bufferCreationInterval = r, this.maxBufferSize = i, this.scheduler = s;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new zB(e, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
  }, t;
}(), BB = /* @__PURE__ */ function() {
  function t() {
    this.buffer = [];
  }
  return t;
}(), zB = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s, n, f) {
    var u = t.call(this, r) || this;
    u.bufferTimeSpan = i, u.bufferCreationInterval = s, u.maxBufferSize = n, u.scheduler = f, u.contexts = [];
    var h = u.openContext();
    if (u.timespanOnly = s == null || s < 0, u.timespanOnly) {
      var d = { subscriber: u, context: h, bufferTimeSpan: i };
      u.add(h.closeAction = f.schedule(c4, i, d));
    } else {
      var l = { subscriber: u, context: h }, m = { bufferTimeSpan: i, bufferCreationInterval: s, subscriber: u, scheduler: f };
      u.add(h.closeAction = f.schedule(D7, i, l)), u.add(f.schedule(UB, s, m));
    }
    return u;
  }
  return e.prototype._next = function(r) {
    for (var i = this.contexts, s = i.length, n, f = 0; f < s; f++) {
      var u = i[f], h = u.buffer;
      h.push(r), h.length == this.maxBufferSize && (n = u);
    }
    n && this.onBufferFull(n);
  }, e.prototype._error = function(r) {
    this.contexts.length = 0, t.prototype._error.call(this, r);
  }, e.prototype._complete = function() {
    for (var r = this, i = r.contexts, s = r.destination; i.length > 0; ) {
      var n = i.shift();
      s.next(n.buffer);
    }
    t.prototype._complete.call(this);
  }, e.prototype._unsubscribe = function() {
    this.contexts = null;
  }, e.prototype.onBufferFull = function(r) {
    this.closeContext(r);
    var i = r.closeAction;
    if (i.unsubscribe(), this.remove(i), !this.closed && this.timespanOnly) {
      r = this.openContext();
      var s = this.bufferTimeSpan, n = { subscriber: this, context: r, bufferTimeSpan: s };
      this.add(r.closeAction = this.scheduler.schedule(c4, s, n));
    }
  }, e.prototype.openContext = function() {
    var r = new BB();
    return this.contexts.push(r), r;
  }, e.prototype.closeContext = function(r) {
    this.destination.next(r.buffer);
    var i = this.contexts, s = i ? i.indexOf(r) : -1;
    s >= 0 && i.splice(i.indexOf(r), 1);
  }, e;
}(St);
function c4(t) {
  var e = t.subscriber, r = t.context;
  r && e.closeContext(r), e.closed || (t.context = e.openContext(), t.context.closeAction = this.schedule(t, t.bufferTimeSpan));
}
function UB(t) {
  var e = t.bufferCreationInterval, r = t.bufferTimeSpan, i = t.subscriber, s = t.scheduler, n = i.openContext(), f = this;
  i.closed || (i.add(n.closeAction = s.schedule(D7, r, { subscriber: i, context: n })), f.schedule(t, e));
}
function D7(t) {
  var e = t.subscriber, r = t.context;
  e.closeContext(r);
}
function FB(t, e) {
  return function(i) {
    return i.lift(new $B(t, e));
  };
}
var $B = /* @__PURE__ */ function() {
  function t(e, r) {
    this.openings = e, this.closingSelector = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new qB(e, this.openings, this.closingSelector));
  }, t;
}(), qB = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.closingSelector = s, n.contexts = [], n.add(Da(n, i)), n;
  }
  return e.prototype._next = function(r) {
    for (var i = this.contexts, s = i.length, n = 0; n < s; n++)
      i[n].buffer.push(r);
  }, e.prototype._error = function(r) {
    for (var i = this.contexts; i.length > 0; ) {
      var s = i.shift();
      s.subscription.unsubscribe(), s.buffer = null, s.subscription = null;
    }
    this.contexts = null, t.prototype._error.call(this, r);
  }, e.prototype._complete = function() {
    for (var r = this.contexts; r.length > 0; ) {
      var i = r.shift();
      this.destination.next(i.buffer), i.subscription.unsubscribe(), i.buffer = null, i.subscription = null;
    }
    this.contexts = null, t.prototype._complete.call(this);
  }, e.prototype.notifyNext = function(r, i) {
    r ? this.closeBuffer(r) : this.openBuffer(i);
  }, e.prototype.notifyComplete = function(r) {
    this.closeBuffer(r.context);
  }, e.prototype.openBuffer = function(r) {
    try {
      var i = this.closingSelector, s = i.call(this, r);
      s && this.trySubscribe(s);
    } catch (n) {
      this._error(n);
    }
  }, e.prototype.closeBuffer = function(r) {
    var i = this.contexts;
    if (i && r) {
      var s = r.buffer, n = r.subscription;
      this.destination.next(s), i.splice(i.indexOf(r), 1), this.remove(n), n.unsubscribe();
    }
  }, e.prototype.trySubscribe = function(r) {
    var i = this.contexts, s = [], n = new Vr(), f = { buffer: s, subscription: n };
    i.push(f);
    var u = Da(this, r, f);
    !u || u.closed ? this.closeBuffer(f) : (u.context = f, this.add(u), n.add(u));
  }, e;
}(vf);
function HB(t) {
  return function(e) {
    return e.lift(new WB(t));
  };
}
var WB = /* @__PURE__ */ function() {
  function t(e) {
    this.closingSelector = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new VB(e, this.closingSelector));
  }, t;
}(), VB = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.closingSelector = i, s.subscribing = !1, s.openBuffer(), s;
  }
  return e.prototype._next = function(r) {
    this.buffer.push(r);
  }, e.prototype._complete = function() {
    var r = this.buffer;
    r && this.destination.next(r), t.prototype._complete.call(this);
  }, e.prototype._unsubscribe = function() {
    this.buffer = void 0, this.subscribing = !1;
  }, e.prototype.notifyNext = function() {
    this.openBuffer();
  }, e.prototype.notifyComplete = function() {
    this.subscribing ? this.complete() : this.openBuffer();
  }, e.prototype.openBuffer = function() {
    var r = this.closingSubscription;
    r && (this.remove(r), r.unsubscribe());
    var i = this.buffer;
    this.buffer && this.destination.next(i), this.buffer = [];
    var s;
    try {
      var n = this.closingSelector;
      s = n();
    } catch (f) {
      return this.error(f);
    }
    r = new Vr(), this.closingSubscription = r, this.add(r), this.subscribing = !0, r.add(Jr(s, new Qr(this))), this.subscribing = !1;
  }, e;
}(Zr);
function GB(t) {
  return function(r) {
    var i = new KB(t), s = r.lift(i);
    return i.caught = s;
  };
}
var KB = /* @__PURE__ */ function() {
  function t(e) {
    this.selector = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new YB(e, this.selector, this.caught));
  }, t;
}(), YB = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.selector = i, n.caught = s, n;
  }
  return e.prototype.error = function(r) {
    if (!this.isStopped) {
      var i = void 0;
      try {
        i = this.selector(r, this.caught);
      } catch (f) {
        t.prototype.error.call(this, f);
        return;
      }
      this._unsubscribeAndRecycle();
      var s = new Qr(this);
      this.add(s);
      var n = Jr(i, s);
      n !== s && this.add(n);
    }
  }, e;
}(Zr);
function QB(t) {
  return function(e) {
    return e.lift(new u2(t));
  };
}
function ZB() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var r = null;
  return typeof t[t.length - 1] == "function" && (r = t.pop()), t.length === 1 && Ji(t[0]) && (t = t[0].slice()), function(i) {
    return i.lift.call(ka([i].concat(t)), new u2(r));
  };
}
function JB() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  return function(r) {
    return r.lift.call(lh.apply(void 0, [r].concat(t)));
  };
}
function C7(t, e) {
  return sf(t, e, 1);
}
function XB(t, e) {
  return C7(function() {
    return t;
  }, e);
}
function ez(t) {
  return function(e) {
    return e.lift(new tz(t, e));
  };
}
var tz = /* @__PURE__ */ function() {
  function t(e, r) {
    this.predicate = e, this.source = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new rz(e, this.predicate, this.source));
  }, t;
}(), rz = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.predicate = i, n.source = s, n.count = 0, n.index = 0, n;
  }
  return e.prototype._next = function(r) {
    this.predicate ? this._tryPredicate(r) : this.count++;
  }, e.prototype._tryPredicate = function(r) {
    var i;
    try {
      i = this.predicate(r, this.index++, this.source);
    } catch (s) {
      this.destination.error(s);
      return;
    }
    i && this.count++;
  }, e.prototype._complete = function() {
    this.destination.next(this.count), this.destination.complete();
  }, e;
}(St);
function iz(t) {
  return function(e) {
    return e.lift(new nz(t));
  };
}
var nz = /* @__PURE__ */ function() {
  function t(e) {
    this.durationSelector = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new sz(e, this.durationSelector));
  }, t;
}(), sz = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.durationSelector = i, s.hasValue = !1, s;
  }
  return e.prototype._next = function(r) {
    try {
      var i = this.durationSelector.call(this, r);
      i && this._tryNext(r, i);
    } catch (s) {
      this.destination.error(s);
    }
  }, e.prototype._complete = function() {
    this.emitValue(), this.destination.complete();
  }, e.prototype._tryNext = function(r, i) {
    var s = this.durationSubscription;
    this.value = r, this.hasValue = !0, s && (s.unsubscribe(), this.remove(s)), s = Jr(i, new Qr(this)), s && !s.closed && this.add(this.durationSubscription = s);
  }, e.prototype.notifyNext = function() {
    this.emitValue();
  }, e.prototype.notifyComplete = function() {
    this.emitValue();
  }, e.prototype.emitValue = function() {
    if (this.hasValue) {
      var r = this.value, i = this.durationSubscription;
      i && (this.durationSubscription = void 0, i.unsubscribe(), this.remove(i)), this.value = void 0, this.hasValue = !1, t.prototype._next.call(this, r);
    }
  }, e;
}(Zr);
function az(t, e) {
  return e === void 0 && (e = Xi), function(r) {
    return r.lift(new oz(t, e));
  };
}
var oz = /* @__PURE__ */ function() {
  function t(e, r) {
    this.dueTime = e, this.scheduler = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new fz(e, this.dueTime, this.scheduler));
  }, t;
}(), fz = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.dueTime = i, n.scheduler = s, n.debouncedSubscription = null, n.lastValue = null, n.hasValue = !1, n;
  }
  return e.prototype._next = function(r) {
    this.clearDebounce(), this.lastValue = r, this.hasValue = !0, this.add(this.debouncedSubscription = this.scheduler.schedule(cz, this.dueTime, this));
  }, e.prototype._complete = function() {
    this.debouncedNext(), this.destination.complete();
  }, e.prototype.debouncedNext = function() {
    if (this.clearDebounce(), this.hasValue) {
      var r = this.lastValue;
      this.lastValue = null, this.hasValue = !1, this.destination.next(r);
    }
  }, e.prototype.clearDebounce = function() {
    var r = this.debouncedSubscription;
    r !== null && (this.remove(r), r.unsubscribe(), this.debouncedSubscription = null);
  }, e;
}(St);
function cz(t) {
  t.debouncedNext();
}
function Ch(t) {
  return t === void 0 && (t = null), function(e) {
    return e.lift(new uz(t));
  };
}
var uz = /* @__PURE__ */ function() {
  function t(e) {
    this.defaultValue = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new hz(e, this.defaultValue));
  }, t;
}(), hz = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.defaultValue = i, s.isEmpty = !0, s;
  }
  return e.prototype._next = function(r) {
    this.isEmpty = !1, this.destination.next(r);
  }, e.prototype._complete = function() {
    this.isEmpty && this.destination.next(this.defaultValue), this.destination.complete();
  }, e;
}(St);
function O7(t) {
  return t instanceof Date && !isNaN(+t);
}
function lz(t, e) {
  e === void 0 && (e = Xi);
  var r = O7(t), i = r ? +t - e.now() : Math.abs(t);
  return function(s) {
    return s.lift(new dz(i, e));
  };
}
var dz = /* @__PURE__ */ function() {
  function t(e, r) {
    this.delay = e, this.scheduler = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new pz(e, this.delay, this.scheduler));
  }, t;
}(), pz = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.delay = i, n.scheduler = s, n.queue = [], n.active = !1, n.errored = !1, n;
  }
  return e.dispatch = function(r) {
    for (var i = r.source, s = i.queue, n = r.scheduler, f = r.destination; s.length > 0 && s[0].time - n.now() <= 0; )
      s.shift().notification.observe(f);
    if (s.length > 0) {
      var u = Math.max(0, s[0].time - n.now());
      this.schedule(r, u);
    } else
      this.unsubscribe(), i.active = !1;
  }, e.prototype._schedule = function(r) {
    this.active = !0;
    var i = this.destination;
    i.add(r.schedule(e.dispatch, this.delay, {
      source: this,
      destination: this.destination,
      scheduler: r
    }));
  }, e.prototype.scheduleNotification = function(r) {
    if (this.errored !== !0) {
      var i = this.scheduler, s = new vz(i.now() + this.delay, r);
      this.queue.push(s), this.active === !1 && this._schedule(i);
    }
  }, e.prototype._next = function(r) {
    this.scheduleNotification(Ta.createNext(r));
  }, e.prototype._error = function(r) {
    this.errored = !0, this.queue = [], this.destination.error(r), this.unsubscribe();
  }, e.prototype._complete = function() {
    this.scheduleNotification(Ta.createComplete()), this.unsubscribe();
  }, e;
}(St), vz = /* @__PURE__ */ function() {
  function t(e, r) {
    this.time = e, this.notification = r;
  }
  return t;
}();
function gz(t, e) {
  return e ? function(r) {
    return new yz(r, e).lift(new u4(t));
  } : function(r) {
    return r.lift(new u4(t));
  };
}
var u4 = /* @__PURE__ */ function() {
  function t(e) {
    this.delayDurationSelector = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new bz(e, this.delayDurationSelector));
  }, t;
}(), bz = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.delayDurationSelector = i, s.completed = !1, s.delayNotifierSubscriptions = [], s.index = 0, s;
  }
  return e.prototype.notifyNext = function(r, i, s, n, f) {
    this.destination.next(r), this.removeSubscription(f), this.tryComplete();
  }, e.prototype.notifyError = function(r, i) {
    this._error(r);
  }, e.prototype.notifyComplete = function(r) {
    var i = this.removeSubscription(r);
    i && this.destination.next(i), this.tryComplete();
  }, e.prototype._next = function(r) {
    var i = this.index++;
    try {
      var s = this.delayDurationSelector(r, i);
      s && this.tryDelay(s, r);
    } catch (n) {
      this.destination.error(n);
    }
  }, e.prototype._complete = function() {
    this.completed = !0, this.tryComplete(), this.unsubscribe();
  }, e.prototype.removeSubscription = function(r) {
    r.unsubscribe();
    var i = this.delayNotifierSubscriptions.indexOf(r);
    return i !== -1 && this.delayNotifierSubscriptions.splice(i, 1), r.outerValue;
  }, e.prototype.tryDelay = function(r, i) {
    var s = Da(this, r, i);
    if (s && !s.closed) {
      var n = this.destination;
      n.add(s), this.delayNotifierSubscriptions.push(s);
    }
  }, e.prototype.tryComplete = function() {
    this.completed && this.delayNotifierSubscriptions.length === 0 && this.destination.complete();
  }, e;
}(vf), yz = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this) || this;
    return s.source = r, s.subscriptionDelay = i, s;
  }
  return e.prototype._subscribe = function(r) {
    this.subscriptionDelay.subscribe(new mz(r, this.source));
  }, e;
}(Vt), mz = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this) || this;
    return s.parent = r, s.source = i, s.sourceSubscribed = !1, s;
  }
  return e.prototype._next = function(r) {
    this.subscribeToSource();
  }, e.prototype._error = function(r) {
    this.unsubscribe(), this.parent.error(r);
  }, e.prototype._complete = function() {
    this.unsubscribe(), this.subscribeToSource();
  }, e.prototype.subscribeToSource = function() {
    this.sourceSubscribed || (this.sourceSubscribed = !0, this.unsubscribe(), this.source.subscribe(this.parent));
  }, e;
}(St);
function wz() {
  return function(e) {
    return e.lift(new _z());
  };
}
var _z = /* @__PURE__ */ function() {
  function t() {
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new Mz(e));
  }, t;
}(), Mz = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r) {
    return t.call(this, r) || this;
  }
  return e.prototype._next = function(r) {
    r.observe(this.destination);
  }, e;
}(St);
function xz(t, e) {
  return function(r) {
    return r.lift(new Sz(t, e));
  };
}
var Sz = /* @__PURE__ */ function() {
  function t(e, r) {
    this.keySelector = e, this.flushes = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new Ez(e, this.keySelector, this.flushes));
  }, t;
}(), Ez = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.keySelector = i, n.values = /* @__PURE__ */ new Set(), s && n.add(Jr(s, new Qr(n))), n;
  }
  return e.prototype.notifyNext = function() {
    this.values.clear();
  }, e.prototype.notifyError = function(r) {
    this._error(r);
  }, e.prototype._next = function(r) {
    this.keySelector ? this._useKeySelector(r) : this._finalizeNext(r, r);
  }, e.prototype._useKeySelector = function(r) {
    var i, s = this.destination;
    try {
      i = this.keySelector(r);
    } catch (n) {
      s.error(n);
      return;
    }
    this._finalizeNext(i, r);
  }, e.prototype._finalizeNext = function(r, i) {
    var s = this.values;
    s.has(r) || (s.add(r), this.destination.next(i));
  }, e;
}(Zr);
function R7(t, e) {
  return function(r) {
    return r.lift(new Iz(t, e));
  };
}
var Iz = /* @__PURE__ */ function() {
  function t(e, r) {
    this.compare = e, this.keySelector = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new Az(e, this.compare, this.keySelector));
  }, t;
}(), Az = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.keySelector = s, n.hasKey = !1, typeof i == "function" && (n.compare = i), n;
  }
  return e.prototype.compare = function(r, i) {
    return r === i;
  }, e.prototype._next = function(r) {
    var i;
    try {
      var s = this.keySelector;
      i = s ? s(r) : r;
    } catch (u) {
      return this.destination.error(u);
    }
    var n = !1;
    if (this.hasKey)
      try {
        var f = this.compare;
        n = f(this.key, i);
      } catch (u) {
        return this.destination.error(u);
      }
    else
      this.hasKey = !0;
    n || (this.key = i, this.destination.next(r));
  }, e;
}(St);
function Tz(t, e) {
  return R7(function(r, i) {
    return e ? e(r[t], i[t]) : r[t] === i[t];
  });
}
function Z0(t) {
  return t === void 0 && (t = Cz), function(e) {
    return e.lift(new Nz(t));
  };
}
var Nz = /* @__PURE__ */ function() {
  function t(e) {
    this.errorFactory = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new Dz(e, this.errorFactory));
  }, t;
}(), Dz = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.errorFactory = i, s.hasValue = !1, s;
  }
  return e.prototype._next = function(r) {
    this.hasValue = !0, this.destination.next(r);
  }, e.prototype._complete = function() {
    if (this.hasValue)
      return this.destination.complete();
    var r = void 0;
    try {
      r = this.errorFactory();
    } catch (i) {
      r = i;
    }
    this.destination.error(r);
  }, e;
}(St);
function Cz() {
  return new Dh();
}
function d2(t) {
  return function(e) {
    return t === 0 ? Uc() : e.lift(new Oz(t));
  };
}
var Oz = /* @__PURE__ */ function() {
  function t(e) {
    if (this.total = e, this.total < 0)
      throw new wc();
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new Rz(e, this.total));
  }, t;
}(), Rz = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.total = i, s.count = 0, s;
  }
  return e.prototype._next = function(r) {
    var i = this.total, s = ++this.count;
    s <= i && (this.destination.next(r), s === i && (this.destination.complete(), this.unsubscribe()));
  }, e;
}(St);
function Lz(t, e) {
  if (t < 0)
    throw new wc();
  var r = arguments.length >= 2;
  return function(i) {
    return i.pipe(co(function(s, n) {
      return n === t;
    }), d2(1), r ? Ch(e) : Z0(function() {
      return new wc();
    }));
  };
}
function Pz() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  return function(r) {
    return lh(r, Q0.apply(void 0, t));
  };
}
function kz(t, e) {
  return function(r) {
    return r.lift(new jz(t, e, r));
  };
}
var jz = /* @__PURE__ */ function() {
  function t(e, r, i) {
    this.predicate = e, this.thisArg = r, this.source = i;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new Bz(e, this.predicate, this.thisArg, this.source));
  }, t;
}(), Bz = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s, n) {
    var f = t.call(this, r) || this;
    return f.predicate = i, f.thisArg = s, f.source = n, f.index = 0, f.thisArg = s || f, f;
  }
  return e.prototype.notifyComplete = function(r) {
    this.destination.next(r), this.destination.complete();
  }, e.prototype._next = function(r) {
    var i = !1;
    try {
      i = this.predicate.call(this.thisArg, r, this.index++, this.source);
    } catch (s) {
      this.destination.error(s);
      return;
    }
    i || this.notifyComplete(!1);
  }, e.prototype._complete = function() {
    this.notifyComplete(!0);
  }, e;
}(St);
function zz() {
  return function(t) {
    return t.lift(new Uz());
  };
}
var Uz = /* @__PURE__ */ function() {
  function t() {
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new Fz(e));
  }, t;
}(), Fz = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r) {
    var i = t.call(this, r) || this;
    return i.hasCompleted = !1, i.hasSubscription = !1, i;
  }
  return e.prototype._next = function(r) {
    this.hasSubscription || (this.hasSubscription = !0, this.add(Jr(r, new Qr(this))));
  }, e.prototype._complete = function() {
    this.hasCompleted = !0, this.hasSubscription || this.destination.complete();
  }, e.prototype.notifyComplete = function() {
    this.hasSubscription = !1, this.hasCompleted && this.destination.complete();
  }, e;
}(Zr);
function L7(t, e) {
  return e ? function(r) {
    return r.pipe(L7(function(i, s) {
      return ka(t(i, s)).pipe(ns(function(n, f) {
        return e(i, n, s, f);
      }));
    }));
  } : function(r) {
    return r.lift(new $z(t));
  };
}
var $z = /* @__PURE__ */ function() {
  function t(e) {
    this.project = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new qz(e, this.project));
  }, t;
}(), qz = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.project = i, s.hasSubscription = !1, s.hasCompleted = !1, s.index = 0, s;
  }
  return e.prototype._next = function(r) {
    this.hasSubscription || this.tryNext(r);
  }, e.prototype.tryNext = function(r) {
    var i, s = this.index++;
    try {
      i = this.project(r, s);
    } catch (n) {
      this.destination.error(n);
      return;
    }
    this.hasSubscription = !0, this._innerSub(i);
  }, e.prototype._innerSub = function(r) {
    var i = new Qr(this), s = this.destination;
    s.add(i);
    var n = Jr(r, i);
    n !== i && s.add(n);
  }, e.prototype._complete = function() {
    this.hasCompleted = !0, this.hasSubscription || this.destination.complete(), this.unsubscribe();
  }, e.prototype.notifyNext = function(r) {
    this.destination.next(r);
  }, e.prototype.notifyError = function(r) {
    this.destination.error(r);
  }, e.prototype.notifyComplete = function() {
    this.hasSubscription = !1, this.hasCompleted && this.destination.complete();
  }, e;
}(Zr);
function Hz(t, e, r) {
  return e === void 0 && (e = Number.POSITIVE_INFINITY), e = (e || 0) < 1 ? Number.POSITIVE_INFINITY : e, function(i) {
    return i.lift(new Wz(t, e, r));
  };
}
var Wz = /* @__PURE__ */ function() {
  function t(e, r, i) {
    this.project = e, this.concurrent = r, this.scheduler = i;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new Vz(e, this.project, this.concurrent, this.scheduler));
  }, t;
}(), Vz = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s, n) {
    var f = t.call(this, r) || this;
    return f.project = i, f.concurrent = s, f.scheduler = n, f.index = 0, f.active = 0, f.hasCompleted = !1, s < Number.POSITIVE_INFINITY && (f.buffer = []), f;
  }
  return e.dispatch = function(r) {
    var i = r.subscriber, s = r.result, n = r.value, f = r.index;
    i.subscribeToProjection(s, n, f);
  }, e.prototype._next = function(r) {
    var i = this.destination;
    if (i.closed) {
      this._complete();
      return;
    }
    var s = this.index++;
    if (this.active < this.concurrent) {
      i.next(r);
      try {
        var n = this.project, f = n(r, s);
        if (!this.scheduler)
          this.subscribeToProjection(f, r, s);
        else {
          var u = { subscriber: this, result: f, value: r, index: s }, h = this.destination;
          h.add(this.scheduler.schedule(e.dispatch, 0, u));
        }
      } catch (d) {
        i.error(d);
      }
    } else
      this.buffer.push(r);
  }, e.prototype.subscribeToProjection = function(r, i, s) {
    this.active++;
    var n = this.destination;
    n.add(Jr(r, new Qr(this)));
  }, e.prototype._complete = function() {
    this.hasCompleted = !0, this.hasCompleted && this.active === 0 && this.destination.complete(), this.unsubscribe();
  }, e.prototype.notifyNext = function(r) {
    this._next(r);
  }, e.prototype.notifyComplete = function() {
    var r = this.buffer;
    this.active--, r && r.length > 0 && this._next(r.shift()), this.hasCompleted && this.active === 0 && this.destination.complete();
  }, e;
}(Zr);
function Gz(t) {
  return function(e) {
    return e.lift(new Kz(t));
  };
}
var Kz = /* @__PURE__ */ function() {
  function t(e) {
    this.callback = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new Yz(e, this.callback));
  }, t;
}(), Yz = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.add(new Vr(i)), s;
  }
  return e;
}(St);
function Qz(t, e) {
  if (typeof t != "function")
    throw new TypeError("predicate is not a function");
  return function(r) {
    return r.lift(new P7(t, r, !1, e));
  };
}
var P7 = /* @__PURE__ */ function() {
  function t(e, r, i, s) {
    this.predicate = e, this.source = r, this.yieldIndex = i, this.thisArg = s;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new Zz(e, this.predicate, this.source, this.yieldIndex, this.thisArg));
  }, t;
}(), Zz = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s, n, f) {
    var u = t.call(this, r) || this;
    return u.predicate = i, u.source = s, u.yieldIndex = n, u.thisArg = f, u.index = 0, u;
  }
  return e.prototype.notifyComplete = function(r) {
    var i = this.destination;
    i.next(r), i.complete(), this.unsubscribe();
  }, e.prototype._next = function(r) {
    var i = this, s = i.predicate, n = i.thisArg, f = this.index++;
    try {
      var u = s.call(n || this, r, f, this.source);
      u && this.notifyComplete(this.yieldIndex ? f : r);
    } catch (h) {
      this.destination.error(h);
    }
  }, e.prototype._complete = function() {
    this.notifyComplete(this.yieldIndex ? -1 : void 0);
  }, e;
}(St);
function Jz(t, e) {
  return function(r) {
    return r.lift(new P7(t, r, !0, e));
  };
}
function Xz(t, e) {
  var r = arguments.length >= 2;
  return function(i) {
    return i.pipe(t ? co(function(s, n) {
      return t(s, n, i);
    }) : oo, d2(1), r ? Ch(e) : Z0(function() {
      return new Dh();
    }));
  };
}
function eU() {
  return function(e) {
    return e.lift(new tU());
  };
}
var tU = /* @__PURE__ */ function() {
  function t() {
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new rU(e));
  }, t;
}(), rU = /* @__PURE__ */ function(t) {
  it(e, t);
  function e() {
    return t !== null && t.apply(this, arguments) || this;
  }
  return e.prototype._next = function(r) {
  }, e;
}(St);
function iU() {
  return function(t) {
    return t.lift(new nU());
  };
}
var nU = /* @__PURE__ */ function() {
  function t() {
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new sU(e));
  }, t;
}(), sU = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r) {
    return t.call(this, r) || this;
  }
  return e.prototype.notifyComplete = function(r) {
    var i = this.destination;
    i.next(r), i.complete();
  }, e.prototype._next = function(r) {
    this.notifyComplete(!1);
  }, e.prototype._complete = function() {
    this.notifyComplete(!0);
  }, e;
}(St);
function l0(t) {
  return function(r) {
    return t === 0 ? Uc() : r.lift(new aU(t));
  };
}
var aU = /* @__PURE__ */ function() {
  function t(e) {
    if (this.total = e, this.total < 0)
      throw new wc();
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new oU(e, this.total));
  }, t;
}(), oU = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.total = i, s.ring = new Array(), s.count = 0, s;
  }
  return e.prototype._next = function(r) {
    var i = this.ring, s = this.total, n = this.count++;
    if (i.length < s)
      i.push(r);
    else {
      var f = n % s;
      i[f] = r;
    }
  }, e.prototype._complete = function() {
    var r = this.destination, i = this.count;
    if (i > 0)
      for (var s = this.count >= this.total ? this.total : this.count, n = this.ring, f = 0; f < s; f++) {
        var u = i++ % s;
        r.next(n[u]);
      }
    r.complete();
  }, e;
}(St);
function fU(t, e) {
  var r = arguments.length >= 2;
  return function(i) {
    return i.pipe(t ? co(function(s, n) {
      return t(s, n, i);
    }) : oo, l0(1), r ? Ch(e) : Z0(function() {
      return new Dh();
    }));
  };
}
function cU(t) {
  return function(e) {
    return e.lift(new uU(t));
  };
}
var uU = /* @__PURE__ */ function() {
  function t(e) {
    this.value = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new hU(e, this.value));
  }, t;
}(), hU = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.value = i, s;
  }
  return e.prototype._next = function(r) {
    this.destination.next(this.value);
  }, e;
}(St);
function lU() {
  return function(e) {
    return e.lift(new dU());
  };
}
var dU = /* @__PURE__ */ function() {
  function t() {
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new pU(e));
  }, t;
}(), pU = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r) {
    return t.call(this, r) || this;
  }
  return e.prototype._next = function(r) {
    this.destination.next(Ta.createNext(r));
  }, e.prototype._error = function(r) {
    var i = this.destination;
    i.next(Ta.createError(r)), i.complete();
  }, e.prototype._complete = function() {
    var r = this.destination;
    r.next(Ta.createComplete()), r.complete();
  }, e;
}(St);
function d0(t, e) {
  var r = !1;
  return arguments.length >= 2 && (r = !0), function(s) {
    return s.lift(new vU(t, e, r));
  };
}
var vU = /* @__PURE__ */ function() {
  function t(e, r, i) {
    i === void 0 && (i = !1), this.accumulator = e, this.seed = r, this.hasSeed = i;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new gU(e, this.accumulator, this.seed, this.hasSeed));
  }, t;
}(), gU = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s, n) {
    var f = t.call(this, r) || this;
    return f.accumulator = i, f._seed = s, f.hasSeed = n, f.index = 0, f;
  }
  return Object.defineProperty(e.prototype, "seed", {
    get: function() {
      return this._seed;
    },
    set: function(r) {
      this.hasSeed = !0, this._seed = r;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype._next = function(r) {
    if (!this.hasSeed)
      this.seed = r, this.destination.next(r);
    else
      return this._tryNext(r);
  }, e.prototype._tryNext = function(r) {
    var i = this.index++, s;
    try {
      s = this.accumulator(this.seed, r, i);
    } catch (n) {
      this.destination.error(n);
    }
    this.seed = s, this.destination.next(s);
  }, e;
}(St);
function J0(t, e) {
  return arguments.length >= 2 ? function(i) {
    return im(d0(t, e), l0(1), Ch(e))(i);
  } : function(i) {
    return im(d0(function(s, n, f) {
      return t(s, n, f + 1);
    }), l0(1))(i);
  };
}
function bU(t) {
  var e = typeof t == "function" ? function(r, i) {
    return t(r, i) > 0 ? r : i;
  } : function(r, i) {
    return r > i ? r : i;
  };
  return J0(e);
}
function yU() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  return function(r) {
    return r.lift.call(M7.apply(void 0, [r].concat(t)));
  };
}
function mU(t, e, r) {
  return r === void 0 && (r = Number.POSITIVE_INFINITY), typeof e == "function" ? sf(function() {
    return t;
  }, e, r) : (typeof e == "number" && (r = e), sf(function() {
    return t;
  }, r));
}
function wU(t, e, r) {
  return r === void 0 && (r = Number.POSITIVE_INFINITY), function(i) {
    return i.lift(new _U(t, e, r));
  };
}
var _U = /* @__PURE__ */ function() {
  function t(e, r, i) {
    this.accumulator = e, this.seed = r, this.concurrent = i;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new MU(e, this.accumulator, this.seed, this.concurrent));
  }, t;
}(), MU = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s, n) {
    var f = t.call(this, r) || this;
    return f.accumulator = i, f.acc = s, f.concurrent = n, f.hasValue = !1, f.hasCompleted = !1, f.buffer = [], f.active = 0, f.index = 0, f;
  }
  return e.prototype._next = function(r) {
    if (this.active < this.concurrent) {
      var i = this.index++, s = this.destination, n = void 0;
      try {
        var f = this.accumulator;
        n = f(this.acc, r, i);
      } catch (u) {
        return s.error(u);
      }
      this.active++, this._innerSub(n);
    } else
      this.buffer.push(r);
  }, e.prototype._innerSub = function(r) {
    var i = new Qr(this), s = this.destination;
    s.add(i);
    var n = Jr(r, i);
    n !== i && s.add(n);
  }, e.prototype._complete = function() {
    this.hasCompleted = !0, this.active === 0 && this.buffer.length === 0 && (this.hasValue === !1 && this.destination.next(this.acc), this.destination.complete()), this.unsubscribe();
  }, e.prototype.notifyNext = function(r) {
    var i = this.destination;
    this.acc = r, this.hasValue = !0, i.next(r);
  }, e.prototype.notifyComplete = function() {
    var r = this.buffer;
    this.active--, r.length > 0 ? this._next(r.shift()) : this.active === 0 && this.hasCompleted && (this.hasValue === !1 && this.destination.next(this.acc), this.destination.complete());
  }, e;
}(Zr);
function xU(t) {
  var e = typeof t == "function" ? function(r, i) {
    return t(r, i) < 0 ? r : i;
  } : function(r, i) {
    return r < i ? r : i;
  };
  return J0(e);
}
function af(t, e) {
  return function(i) {
    var s;
    if (typeof t == "function" ? s = t : s = function() {
      return t;
    }, typeof e == "function")
      return i.lift(new SU(s, e));
    var n = Object.create(i, sj);
    return n.source = i, n.subjectFactory = s, n;
  };
}
var SU = /* @__PURE__ */ function() {
  function t(e, r) {
    this.subjectFactory = e, this.selector = r;
  }
  return t.prototype.call = function(e, r) {
    var i = this.selector, s = this.subjectFactory(), n = i(s).subscribe(e);
    return n.add(r.subscribe(s)), n;
  }, t;
}();
function EU() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  return t.length === 1 && Ji(t[0]) && (t = t[0]), function(r) {
    return r.lift(new IU(t));
  };
}
var IU = /* @__PURE__ */ function() {
  function t(e) {
    this.nextSources = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new AU(e, this.nextSources));
  }, t;
}(), AU = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.destination = r, s.nextSources = i, s;
  }
  return e.prototype.notifyError = function() {
    this.subscribeToNextSource();
  }, e.prototype.notifyComplete = function() {
    this.subscribeToNextSource();
  }, e.prototype._error = function(r) {
    this.subscribeToNextSource(), this.unsubscribe();
  }, e.prototype._complete = function() {
    this.subscribeToNextSource(), this.unsubscribe();
  }, e.prototype.subscribeToNextSource = function() {
    var r = this.nextSources.shift();
    if (r) {
      var i = new Qr(this), s = this.destination;
      s.add(i);
      var n = Jr(r, i);
      n !== i && s.add(n);
    } else
      this.destination.complete();
  }, e;
}(Zr);
function TU() {
  return function(t) {
    return t.lift(new NU());
  };
}
var NU = /* @__PURE__ */ function() {
  function t() {
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new DU(e));
  }, t;
}(), DU = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r) {
    var i = t.call(this, r) || this;
    return i.hasPrev = !1, i;
  }
  return e.prototype._next = function(r) {
    var i;
    this.hasPrev ? i = [this.prev, r] : this.hasPrev = !0, this.prev = r, i && this.destination.next(i);
  }, e;
}(St);
function CU(t, e) {
  return function(r) {
    return [
      co(t, e)(r),
      co(S7(t, e))(r)
    ];
  };
}
function OU() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var r = t.length;
  if (r === 0)
    throw new Error("list of properties cannot be empty.");
  return function(i) {
    return ns(RU(t, r))(i);
  };
}
function RU(t, e) {
  var r = function(i) {
    for (var s = i, n = 0; n < e; n++) {
      var f = s != null ? s[t[n]] : void 0;
      if (f !== void 0)
        s = f;
      else
        return;
    }
    return s;
  };
  return r;
}
function LU(t) {
  return t ? af(function() {
    return new mi();
  }, t) : af(new mi());
}
function PU(t) {
  return function(e) {
    return af(new i7(t))(e);
  };
}
function kU() {
  return function(t) {
    return af(new Fc())(t);
  };
}
function jU(t, e, r, i) {
  r && typeof r != "function" && (i = r);
  var s = typeof r == "function" ? r : void 0, n = new c2(t, e, i);
  return function(f) {
    return af(function() {
      return n;
    }, s)(f);
  };
}
function BU() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  return function(i) {
    return t.length === 1 && Ji(t[0]) && (t = t[0]), i.lift.call(E7.apply(void 0, [i].concat(t)));
  };
}
function zU(t) {
  return t === void 0 && (t = -1), function(e) {
    return t === 0 ? Uc() : t < 0 ? e.lift(new h4(-1, e)) : e.lift(new h4(t - 1, e));
  };
}
var h4 = /* @__PURE__ */ function() {
  function t(e, r) {
    this.count = e, this.source = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new UU(e, this.count, this.source));
  }, t;
}(), UU = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.count = i, n.source = s, n;
  }
  return e.prototype.complete = function() {
    if (!this.isStopped) {
      var r = this, i = r.source, s = r.count;
      if (s === 0)
        return t.prototype.complete.call(this);
      s > -1 && (this.count = s - 1), i.subscribe(this._unsubscribeAndRecycle());
    }
  }, e;
}(St);
function FU(t) {
  return function(e) {
    return e.lift(new $U(t));
  };
}
var $U = /* @__PURE__ */ function() {
  function t(e) {
    this.notifier = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new qU(e, this.notifier, r));
  }, t;
}(), qU = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.notifier = i, n.source = s, n.sourceIsBeingSubscribedTo = !0, n;
  }
  return e.prototype.notifyNext = function() {
    this.sourceIsBeingSubscribedTo = !0, this.source.subscribe(this);
  }, e.prototype.notifyComplete = function() {
    if (this.sourceIsBeingSubscribedTo === !1)
      return t.prototype.complete.call(this);
  }, e.prototype.complete = function() {
    if (this.sourceIsBeingSubscribedTo = !1, !this.isStopped) {
      if (this.retries || this.subscribeToRetries(), !this.retriesSubscription || this.retriesSubscription.closed)
        return t.prototype.complete.call(this);
      this._unsubscribeAndRecycle(), this.notifications.next(void 0);
    }
  }, e.prototype._unsubscribe = function() {
    var r = this, i = r.notifications, s = r.retriesSubscription;
    i && (i.unsubscribe(), this.notifications = void 0), s && (s.unsubscribe(), this.retriesSubscription = void 0), this.retries = void 0;
  }, e.prototype._unsubscribeAndRecycle = function() {
    var r = this._unsubscribe;
    return this._unsubscribe = null, t.prototype._unsubscribeAndRecycle.call(this), this._unsubscribe = r, this;
  }, e.prototype.subscribeToRetries = function() {
    this.notifications = new mi();
    var r;
    try {
      var i = this.notifier;
      r = i(this.notifications);
    } catch {
      return t.prototype.complete.call(this);
    }
    this.retries = r, this.retriesSubscription = Jr(r, new Qr(this));
  }, e;
}(Zr);
function HU(t) {
  return t === void 0 && (t = -1), function(e) {
    return e.lift(new WU(t, e));
  };
}
var WU = /* @__PURE__ */ function() {
  function t(e, r) {
    this.count = e, this.source = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new VU(e, this.count, this.source));
  }, t;
}(), VU = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.count = i, n.source = s, n;
  }
  return e.prototype.error = function(r) {
    if (!this.isStopped) {
      var i = this, s = i.source, n = i.count;
      if (n === 0)
        return t.prototype.error.call(this, r);
      n > -1 && (this.count = n - 1), s.subscribe(this._unsubscribeAndRecycle());
    }
  }, e;
}(St);
function GU(t) {
  return function(e) {
    return e.lift(new KU(t, e));
  };
}
var KU = /* @__PURE__ */ function() {
  function t(e, r) {
    this.notifier = e, this.source = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new YU(e, this.notifier, this.source));
  }, t;
}(), YU = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.notifier = i, n.source = s, n;
  }
  return e.prototype.error = function(r) {
    if (!this.isStopped) {
      var i = this.errors, s = this.retries, n = this.retriesSubscription;
      if (s)
        this.errors = void 0, this.retriesSubscription = void 0;
      else {
        i = new mi();
        try {
          var f = this.notifier;
          s = f(i);
        } catch (u) {
          return t.prototype.error.call(this, u);
        }
        n = Jr(s, new Qr(this));
      }
      this._unsubscribeAndRecycle(), this.errors = i, this.retries = s, this.retriesSubscription = n, i.next(r);
    }
  }, e.prototype._unsubscribe = function() {
    var r = this, i = r.errors, s = r.retriesSubscription;
    i && (i.unsubscribe(), this.errors = void 0), s && (s.unsubscribe(), this.retriesSubscription = void 0), this.retries = void 0;
  }, e.prototype.notifyNext = function() {
    var r = this._unsubscribe;
    this._unsubscribe = null, this._unsubscribeAndRecycle(), this._unsubscribe = r, this.source.subscribe(this);
  }, e;
}(Zr);
function QU(t) {
  return function(e) {
    return e.lift(new ZU(t));
  };
}
var ZU = /* @__PURE__ */ function() {
  function t(e) {
    this.notifier = e;
  }
  return t.prototype.call = function(e, r) {
    var i = new JU(e), s = r.subscribe(i);
    return s.add(Jr(this.notifier, new Qr(i))), s;
  }, t;
}(), JU = /* @__PURE__ */ function(t) {
  it(e, t);
  function e() {
    var r = t !== null && t.apply(this, arguments) || this;
    return r.hasValue = !1, r;
  }
  return e.prototype._next = function(r) {
    this.value = r, this.hasValue = !0;
  }, e.prototype.notifyNext = function() {
    this.emitValue();
  }, e.prototype.notifyComplete = function() {
    this.emitValue();
  }, e.prototype.emitValue = function() {
    this.hasValue && (this.hasValue = !1, this.destination.next(this.value));
  }, e;
}(Zr);
function XU(t, e) {
  return e === void 0 && (e = Xi), function(r) {
    return r.lift(new eF(t, e));
  };
}
var eF = /* @__PURE__ */ function() {
  function t(e, r) {
    this.period = e, this.scheduler = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new tF(e, this.period, this.scheduler));
  }, t;
}(), tF = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.period = i, n.scheduler = s, n.hasValue = !1, n.add(s.schedule(rF, i, { subscriber: n, period: i })), n;
  }
  return e.prototype._next = function(r) {
    this.lastValue = r, this.hasValue = !0;
  }, e.prototype.notifyNext = function() {
    this.hasValue && (this.hasValue = !1, this.destination.next(this.lastValue));
  }, e;
}(St);
function rF(t) {
  var e = t.subscriber, r = t.period;
  e.notifyNext(), this.schedule(t, r);
}
function iF(t, e) {
  return function(r) {
    return r.lift(new nF(t, e));
  };
}
var nF = /* @__PURE__ */ function() {
  function t(e, r) {
    this.compareTo = e, this.comparator = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new sF(e, this.compareTo, this.comparator));
  }, t;
}(), sF = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.compareTo = i, n.comparator = s, n._a = [], n._b = [], n._oneComplete = !1, n.destination.add(i.subscribe(new aF(r, n))), n;
  }
  return e.prototype._next = function(r) {
    this._oneComplete && this._b.length === 0 ? this.emit(!1) : (this._a.push(r), this.checkValues());
  }, e.prototype._complete = function() {
    this._oneComplete ? this.emit(this._a.length === 0 && this._b.length === 0) : this._oneComplete = !0, this.unsubscribe();
  }, e.prototype.checkValues = function() {
    for (var r = this, i = r._a, s = r._b, n = r.comparator; i.length > 0 && s.length > 0; ) {
      var f = i.shift(), u = s.shift(), h = !1;
      try {
        h = n ? n(f, u) : f === u;
      } catch (d) {
        this.destination.error(d);
      }
      h || this.emit(!1);
    }
  }, e.prototype.emit = function(r) {
    var i = this.destination;
    i.next(r), i.complete();
  }, e.prototype.nextB = function(r) {
    this._oneComplete && this._a.length === 0 ? this.emit(!1) : (this._b.push(r), this.checkValues());
  }, e.prototype.completeB = function() {
    this._oneComplete ? this.emit(this._a.length === 0 && this._b.length === 0) : this._oneComplete = !0;
  }, e;
}(St), aF = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.parent = i, s;
  }
  return e.prototype._next = function(r) {
    this.parent.nextB(r);
  }, e.prototype._error = function(r) {
    this.parent.error(r), this.unsubscribe();
  }, e.prototype._complete = function() {
    this.parent.completeB(), this.unsubscribe();
  }, e;
}(St);
function oF() {
  return new mi();
}
function fF() {
  return function(t) {
    return a2()(af(oF)(t));
  };
}
function cF(t, e, r) {
  var i;
  return t && typeof t == "object" ? i = t : i = {
    bufferSize: t,
    windowTime: e,
    refCount: !1,
    scheduler: r
  }, function(s) {
    return s.lift(uF(i));
  };
}
function uF(t) {
  var e = t.bufferSize, r = e === void 0 ? Number.POSITIVE_INFINITY : e, i = t.windowTime, s = i === void 0 ? Number.POSITIVE_INFINITY : i, n = t.refCount, f = t.scheduler, u, h = 0, d, l = !1, m = !1;
  return function(M) {
    h++;
    var A;
    !u || l ? (l = !1, u = new c2(r, s, f), A = u.subscribe(this), d = M.subscribe({
      next: function(N) {
        u.next(N);
      },
      error: function(N) {
        l = !0, u.error(N);
      },
      complete: function() {
        m = !0, d = void 0, u.complete();
      }
    }), m && (d = void 0)) : A = u.subscribe(this), this.add(function() {
      h--, A.unsubscribe(), A = void 0, d && !m && n && h === 0 && (d.unsubscribe(), d = void 0, u = void 0);
    });
  };
}
function hF(t) {
  return function(e) {
    return e.lift(new lF(t, e));
  };
}
var lF = /* @__PURE__ */ function() {
  function t(e, r) {
    this.predicate = e, this.source = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new dF(e, this.predicate, this.source));
  }, t;
}(), dF = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.predicate = i, n.source = s, n.seenValue = !1, n.index = 0, n;
  }
  return e.prototype.applySingleValue = function(r) {
    this.seenValue ? this.destination.error("Sequence contains more than one element") : (this.seenValue = !0, this.singleValue = r);
  }, e.prototype._next = function(r) {
    var i = this.index++;
    this.predicate ? this.tryNext(r, i) : this.applySingleValue(r);
  }, e.prototype.tryNext = function(r, i) {
    try {
      this.predicate(r, i, this.source) && this.applySingleValue(r);
    } catch (s) {
      this.destination.error(s);
    }
  }, e.prototype._complete = function() {
    var r = this.destination;
    this.index > 0 ? (r.next(this.seenValue ? this.singleValue : void 0), r.complete()) : r.error(new Dh());
  }, e;
}(St);
function pF(t) {
  return function(e) {
    return e.lift(new vF(t));
  };
}
var vF = /* @__PURE__ */ function() {
  function t(e) {
    this.total = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new gF(e, this.total));
  }, t;
}(), gF = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.total = i, s.count = 0, s;
  }
  return e.prototype._next = function(r) {
    ++this.count > this.total && this.destination.next(r);
  }, e;
}(St);
function bF(t) {
  return function(e) {
    return e.lift(new yF(t));
  };
}
var yF = /* @__PURE__ */ function() {
  function t(e) {
    if (this._skipCount = e, this._skipCount < 0)
      throw new wc();
  }
  return t.prototype.call = function(e, r) {
    return this._skipCount === 0 ? r.subscribe(new St(e)) : r.subscribe(new mF(e, this._skipCount));
  }, t;
}(), mF = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s._skipCount = i, s._count = 0, s._ring = new Array(i), s;
  }
  return e.prototype._next = function(r) {
    var i = this._skipCount, s = this._count++;
    if (s < i)
      this._ring[s] = r;
    else {
      var n = s % i, f = this._ring, u = f[n];
      f[n] = r, this.destination.next(u);
    }
  }, e;
}(St);
function wF(t) {
  return function(e) {
    return e.lift(new _F(t));
  };
}
var _F = /* @__PURE__ */ function() {
  function t(e) {
    this.notifier = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new MF(e, this.notifier));
  }, t;
}(), MF = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    s.hasValue = !1;
    var n = new Qr(s);
    s.add(n), s.innerSubscription = n;
    var f = Jr(i, n);
    return f !== n && (s.add(f), s.innerSubscription = f), s;
  }
  return e.prototype._next = function(r) {
    this.hasValue && t.prototype._next.call(this, r);
  }, e.prototype.notifyNext = function() {
    this.hasValue = !0, this.innerSubscription && this.innerSubscription.unsubscribe();
  }, e.prototype.notifyComplete = function() {
  }, e;
}(Zr);
function xF(t) {
  return function(e) {
    return e.lift(new SF(t));
  };
}
var SF = /* @__PURE__ */ function() {
  function t(e) {
    this.predicate = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new EF(e, this.predicate));
  }, t;
}(), EF = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.predicate = i, s.skipping = !0, s.index = 0, s;
  }
  return e.prototype._next = function(r) {
    var i = this.destination;
    this.skipping && this.tryCallPredicate(r), this.skipping || i.next(r);
  }, e.prototype.tryCallPredicate = function(r) {
    try {
      var i = this.predicate(r, this.index++);
      this.skipping = Boolean(i);
    } catch (s) {
      this.destination.error(s);
    }
  }, e;
}(St);
function IF() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var r = t[t.length - 1];
  return An(r) ? (t.pop(), function(i) {
    return lh(t, i, r);
  }) : function(i) {
    return lh(t, i);
  };
}
var AF = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    i === void 0 && (i = 0), s === void 0 && (s = Vd);
    var n = t.call(this) || this;
    return n.source = r, n.delayTime = i, n.scheduler = s, (!_c(i) || i < 0) && (n.delayTime = 0), (!s || typeof s.schedule != "function") && (n.scheduler = Vd), n;
  }
  return e.create = function(r, i, s) {
    return i === void 0 && (i = 0), s === void 0 && (s = Vd), new e(r, i, s);
  }, e.dispatch = function(r) {
    var i = r.source, s = r.subscriber;
    return this.add(i.subscribe(s));
  }, e.prototype._subscribe = function(r) {
    var i = this.delayTime, s = this.source, n = this.scheduler;
    return n.schedule(e.dispatch, i, {
      source: s,
      subscriber: r
    });
  }, e;
}(Vt);
function TF(t, e) {
  return e === void 0 && (e = 0), function(i) {
    return i.lift(new NF(t, e));
  };
}
var NF = /* @__PURE__ */ function() {
  function t(e, r) {
    this.scheduler = e, this.delay = r;
  }
  return t.prototype.call = function(e, r) {
    return new AF(r, this.delay, this.scheduler).subscribe(e);
  }, t;
}();
function dh(t, e) {
  return typeof e == "function" ? function(r) {
    return r.pipe(dh(function(i, s) {
      return ka(t(i, s)).pipe(ns(function(n, f) {
        return e(i, n, s, f);
      }));
    }));
  } : function(r) {
    return r.lift(new DF(t));
  };
}
var DF = /* @__PURE__ */ function() {
  function t(e) {
    this.project = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new CF(e, this.project));
  }, t;
}(), CF = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.project = i, s.index = 0, s;
  }
  return e.prototype._next = function(r) {
    var i, s = this.index++;
    try {
      i = this.project(r, s);
    } catch (n) {
      this.destination.error(n);
      return;
    }
    this._innerSub(i);
  }, e.prototype._innerSub = function(r) {
    var i = this.innerSubscription;
    i && i.unsubscribe();
    var s = new Qr(this), n = this.destination;
    n.add(s), this.innerSubscription = Jr(r, s), this.innerSubscription !== s && n.add(this.innerSubscription);
  }, e.prototype._complete = function() {
    var r = this.innerSubscription;
    (!r || r.closed) && t.prototype._complete.call(this), this.unsubscribe();
  }, e.prototype._unsubscribe = function() {
    this.innerSubscription = void 0;
  }, e.prototype.notifyComplete = function() {
    this.innerSubscription = void 0, this.isStopped && t.prototype._complete.call(this);
  }, e.prototype.notifyNext = function(r) {
    this.destination.next(r);
  }, e;
}(Zr);
function OF() {
  return dh(oo);
}
function RF(t, e) {
  return e ? dh(function() {
    return t;
  }, e) : dh(function() {
    return t;
  });
}
function LF(t) {
  return function(e) {
    return e.lift(new PF(t));
  };
}
var PF = /* @__PURE__ */ function() {
  function t(e) {
    this.notifier = e;
  }
  return t.prototype.call = function(e, r) {
    var i = new kF(e), s = Jr(this.notifier, new Qr(i));
    return s && !i.seenValue ? (i.add(s), r.subscribe(i)) : i;
  }, t;
}(), kF = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r) {
    var i = t.call(this, r) || this;
    return i.seenValue = !1, i;
  }
  return e.prototype.notifyNext = function() {
    this.seenValue = !0, this.complete();
  }, e.prototype.notifyComplete = function() {
  }, e;
}(Zr);
function jF(t, e) {
  return e === void 0 && (e = !1), function(r) {
    return r.lift(new BF(t, e));
  };
}
var BF = /* @__PURE__ */ function() {
  function t(e, r) {
    this.predicate = e, this.inclusive = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new zF(e, this.predicate, this.inclusive));
  }, t;
}(), zF = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.predicate = i, n.inclusive = s, n.index = 0, n;
  }
  return e.prototype._next = function(r) {
    var i = this.destination, s;
    try {
      s = this.predicate(r, this.index++);
    } catch (n) {
      i.error(n);
      return;
    }
    this.nextOrComplete(r, s);
  }, e.prototype.nextOrComplete = function(r, i) {
    var s = this.destination;
    Boolean(i) ? s.next(r) : (this.inclusive && s.next(r), s.complete());
  }, e;
}(St);
function UF(t, e, r) {
  return function(s) {
    return s.lift(new FF(t, e, r));
  };
}
var FF = /* @__PURE__ */ function() {
  function t(e, r, i) {
    this.nextOrObserver = e, this.error = r, this.complete = i;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new $F(e, this.nextOrObserver, this.error, this.complete));
  }, t;
}(), $F = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s, n) {
    var f = t.call(this, r) || this;
    return f._tapNext = $s, f._tapError = $s, f._tapComplete = $s, f._tapError = s || $s, f._tapComplete = n || $s, yc(i) ? (f._context = f, f._tapNext = i) : i && (f._context = i, f._tapNext = i.next || $s, f._tapError = i.error || $s, f._tapComplete = i.complete || $s), f;
  }
  return e.prototype._next = function(r) {
    try {
      this._tapNext.call(this._context, r);
    } catch (i) {
      this.destination.error(i);
      return;
    }
    this.destination.next(r);
  }, e.prototype._error = function(r) {
    try {
      this._tapError.call(this._context, r);
    } catch (i) {
      this.destination.error(i);
      return;
    }
    this.destination.error(r);
  }, e.prototype._complete = function() {
    try {
      this._tapComplete.call(this._context);
    } catch (r) {
      this.destination.error(r);
      return;
    }
    return this.destination.complete();
  }, e;
}(St), k7 = {
  leading: !0,
  trailing: !1
};
function qF(t, e) {
  return e === void 0 && (e = k7), function(r) {
    return r.lift(new HF(t, !!e.leading, !!e.trailing));
  };
}
var HF = /* @__PURE__ */ function() {
  function t(e, r, i) {
    this.durationSelector = e, this.leading = r, this.trailing = i;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new WF(e, this.durationSelector, this.leading, this.trailing));
  }, t;
}(), WF = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s, n) {
    var f = t.call(this, r) || this;
    return f.destination = r, f.durationSelector = i, f._leading = s, f._trailing = n, f._hasValue = !1, f;
  }
  return e.prototype._next = function(r) {
    this._hasValue = !0, this._sendValue = r, this._throttled || (this._leading ? this.send() : this.throttle(r));
  }, e.prototype.send = function() {
    var r = this, i = r._hasValue, s = r._sendValue;
    i && (this.destination.next(s), this.throttle(s)), this._hasValue = !1, this._sendValue = void 0;
  }, e.prototype.throttle = function(r) {
    var i = this.tryDurationSelector(r);
    i && this.add(this._throttled = Jr(i, new Qr(this)));
  }, e.prototype.tryDurationSelector = function(r) {
    try {
      return this.durationSelector(r);
    } catch (i) {
      return this.destination.error(i), null;
    }
  }, e.prototype.throttlingDone = function() {
    var r = this, i = r._throttled, s = r._trailing;
    i && i.unsubscribe(), this._throttled = void 0, s && this.send();
  }, e.prototype.notifyNext = function() {
    this.throttlingDone();
  }, e.prototype.notifyComplete = function() {
    this.throttlingDone();
  }, e;
}(Zr);
function VF(t, e, r) {
  return e === void 0 && (e = Xi), r === void 0 && (r = k7), function(i) {
    return i.lift(new GF(t, e, r.leading, r.trailing));
  };
}
var GF = /* @__PURE__ */ function() {
  function t(e, r, i, s) {
    this.duration = e, this.scheduler = r, this.leading = i, this.trailing = s;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new KF(e, this.duration, this.scheduler, this.leading, this.trailing));
  }, t;
}(), KF = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s, n, f) {
    var u = t.call(this, r) || this;
    return u.duration = i, u.scheduler = s, u.leading = n, u.trailing = f, u._hasTrailingValue = !1, u._trailingValue = null, u;
  }
  return e.prototype._next = function(r) {
    this.throttled ? this.trailing && (this._trailingValue = r, this._hasTrailingValue = !0) : (this.add(this.throttled = this.scheduler.schedule(YF, this.duration, { subscriber: this })), this.leading ? this.destination.next(r) : this.trailing && (this._trailingValue = r, this._hasTrailingValue = !0));
  }, e.prototype._complete = function() {
    this._hasTrailingValue ? (this.destination.next(this._trailingValue), this.destination.complete()) : this.destination.complete();
  }, e.prototype.clearThrottle = function() {
    var r = this.throttled;
    r && (this.trailing && this._hasTrailingValue && (this.destination.next(this._trailingValue), this._trailingValue = null, this._hasTrailingValue = !1), r.unsubscribe(), this.remove(r), this.throttled = null);
  }, e;
}(St);
function YF(t) {
  var e = t.subscriber;
  e.clearThrottle();
}
function QF(t) {
  return t === void 0 && (t = Xi), function(e) {
    return l2(function() {
      return e.pipe(d0(function(r, i) {
        var s = r.current;
        return { value: i, current: t.now(), last: s };
      }, { current: t.now(), value: void 0, last: void 0 }), ns(function(r) {
        var i = r.current, s = r.last, n = r.value;
        return new ZF(n, i - s);
      }));
    });
  };
}
var ZF = /* @__PURE__ */ function() {
  function t(e, r) {
    this.value = e, this.interval = r;
  }
  return t;
}();
function j7(t, e, r) {
  return r === void 0 && (r = Xi), function(i) {
    var s = O7(t), n = s ? +t - r.now() : Math.abs(t);
    return i.lift(new JF(n, s, e, r));
  };
}
var JF = /* @__PURE__ */ function() {
  function t(e, r, i, s) {
    this.waitFor = e, this.absoluteTimeout = r, this.withObservable = i, this.scheduler = s;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new XF(e, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
  }, t;
}(), XF = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s, n, f) {
    var u = t.call(this, r) || this;
    return u.absoluteTimeout = i, u.waitFor = s, u.withObservable = n, u.scheduler = f, u.scheduleTimeout(), u;
  }
  return e.dispatchTimeout = function(r) {
    var i = r.withObservable;
    r._unsubscribeAndRecycle(), r.add(Jr(i, new Qr(r)));
  }, e.prototype.scheduleTimeout = function() {
    var r = this.action;
    r ? this.action = r.schedule(this, this.waitFor) : this.add(this.action = this.scheduler.schedule(e.dispatchTimeout, this.waitFor, this));
  }, e.prototype._next = function(r) {
    this.absoluteTimeout || this.scheduleTimeout(), t.prototype._next.call(this, r);
  }, e.prototype._unsubscribe = function() {
    this.action = void 0, this.scheduler = null, this.withObservable = null;
  }, e;
}(Zr);
function e$(t, e) {
  return e === void 0 && (e = Xi), j7(t, f2(new l7()), e);
}
function t$(t) {
  return t === void 0 && (t = Xi), ns(function(e) {
    return new r$(e, t.now());
  });
}
var r$ = /* @__PURE__ */ function() {
  function t(e, r) {
    this.value = e, this.timestamp = r;
  }
  return t;
}();
function i$(t, e, r) {
  return r === 0 ? [e] : (t.push(e), t);
}
function n$() {
  return J0(i$, []);
}
function s$(t) {
  return function(r) {
    return r.lift(new a$(t));
  };
}
var a$ = /* @__PURE__ */ function() {
  function t(e) {
    this.windowBoundaries = e;
  }
  return t.prototype.call = function(e, r) {
    var i = new o$(e), s = r.subscribe(i);
    return s.closed || i.add(Jr(this.windowBoundaries, new Qr(i))), s;
  }, t;
}(), o$ = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r) {
    var i = t.call(this, r) || this;
    return i.window = new mi(), r.next(i.window), i;
  }
  return e.prototype.notifyNext = function() {
    this.openWindow();
  }, e.prototype.notifyError = function(r) {
    this._error(r);
  }, e.prototype.notifyComplete = function() {
    this._complete();
  }, e.prototype._next = function(r) {
    this.window.next(r);
  }, e.prototype._error = function(r) {
    this.window.error(r), this.destination.error(r);
  }, e.prototype._complete = function() {
    this.window.complete(), this.destination.complete();
  }, e.prototype._unsubscribe = function() {
    this.window = null;
  }, e.prototype.openWindow = function() {
    var r = this.window;
    r && r.complete();
    var i = this.destination, s = this.window = new mi();
    i.next(s);
  }, e;
}(Zr);
function f$(t, e) {
  return e === void 0 && (e = 0), function(i) {
    return i.lift(new c$(t, e));
  };
}
var c$ = /* @__PURE__ */ function() {
  function t(e, r) {
    this.windowSize = e, this.startWindowEvery = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new u$(e, this.windowSize, this.startWindowEvery));
  }, t;
}(), u$ = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.destination = r, n.windowSize = i, n.startWindowEvery = s, n.windows = [new mi()], n.count = 0, r.next(n.windows[0]), n;
  }
  return e.prototype._next = function(r) {
    for (var i = this.startWindowEvery > 0 ? this.startWindowEvery : this.windowSize, s = this.destination, n = this.windowSize, f = this.windows, u = f.length, h = 0; h < u && !this.closed; h++)
      f[h].next(r);
    var d = this.count - n + 1;
    if (d >= 0 && d % i === 0 && !this.closed && f.shift().complete(), ++this.count % i === 0 && !this.closed) {
      var l = new mi();
      f.push(l), s.next(l);
    }
  }, e.prototype._error = function(r) {
    var i = this.windows;
    if (i)
      for (; i.length > 0 && !this.closed; )
        i.shift().error(r);
    this.destination.error(r);
  }, e.prototype._complete = function() {
    var r = this.windows;
    if (r)
      for (; r.length > 0 && !this.closed; )
        r.shift().complete();
    this.destination.complete();
  }, e.prototype._unsubscribe = function() {
    this.count = 0, this.windows = null;
  }, e;
}(St);
function h$(t) {
  var e = Xi, r = null, i = Number.POSITIVE_INFINITY;
  return An(arguments[3]) && (e = arguments[3]), An(arguments[2]) ? e = arguments[2] : _c(arguments[2]) && (i = Number(arguments[2])), An(arguments[1]) ? e = arguments[1] : _c(arguments[1]) && (r = Number(arguments[1])), function(n) {
    return n.lift(new l$(t, r, i, e));
  };
}
var l$ = /* @__PURE__ */ function() {
  function t(e, r, i, s) {
    this.windowTimeSpan = e, this.windowCreationInterval = r, this.maxWindowSize = i, this.scheduler = s;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new p$(e, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
  }, t;
}(), d$ = /* @__PURE__ */ function(t) {
  it(e, t);
  function e() {
    var r = t !== null && t.apply(this, arguments) || this;
    return r._numberOfNextedValues = 0, r;
  }
  return e.prototype.next = function(r) {
    this._numberOfNextedValues++, t.prototype.next.call(this, r);
  }, Object.defineProperty(e.prototype, "numberOfNextedValues", {
    get: function() {
      return this._numberOfNextedValues;
    },
    enumerable: !0,
    configurable: !0
  }), e;
}(mi), p$ = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s, n, f) {
    var u = t.call(this, r) || this;
    u.destination = r, u.windowTimeSpan = i, u.windowCreationInterval = s, u.maxWindowSize = n, u.scheduler = f, u.windows = [];
    var h = u.openWindow();
    if (s !== null && s >= 0) {
      var d = { subscriber: u, window: h, context: null }, l = { windowTimeSpan: i, windowCreationInterval: s, subscriber: u, scheduler: f };
      u.add(f.schedule(B7, i, d)), u.add(f.schedule(g$, s, l));
    } else {
      var m = { subscriber: u, window: h, windowTimeSpan: i };
      u.add(f.schedule(v$, i, m));
    }
    return u;
  }
  return e.prototype._next = function(r) {
    for (var i = this.windows, s = i.length, n = 0; n < s; n++) {
      var f = i[n];
      f.closed || (f.next(r), f.numberOfNextedValues >= this.maxWindowSize && this.closeWindow(f));
    }
  }, e.prototype._error = function(r) {
    for (var i = this.windows; i.length > 0; )
      i.shift().error(r);
    this.destination.error(r);
  }, e.prototype._complete = function() {
    for (var r = this.windows; r.length > 0; ) {
      var i = r.shift();
      i.closed || i.complete();
    }
    this.destination.complete();
  }, e.prototype.openWindow = function() {
    var r = new d$();
    this.windows.push(r);
    var i = this.destination;
    return i.next(r), r;
  }, e.prototype.closeWindow = function(r) {
    r.complete();
    var i = this.windows;
    i.splice(i.indexOf(r), 1);
  }, e;
}(St);
function v$(t) {
  var e = t.subscriber, r = t.windowTimeSpan, i = t.window;
  i && e.closeWindow(i), t.window = e.openWindow(), this.schedule(t, r);
}
function g$(t) {
  var e = t.windowTimeSpan, r = t.subscriber, i = t.scheduler, s = t.windowCreationInterval, n = r.openWindow(), f = this, u = { action: f, subscription: null }, h = { subscriber: r, window: n, context: u };
  u.subscription = i.schedule(B7, e, h), f.add(u.subscription), f.schedule(t, s);
}
function B7(t) {
  var e = t.subscriber, r = t.window, i = t.context;
  i && i.action && i.subscription && i.action.remove(i.subscription), e.closeWindow(r);
}
function b$(t, e) {
  return function(r) {
    return r.lift(new y$(t, e));
  };
}
var y$ = /* @__PURE__ */ function() {
  function t(e, r) {
    this.openings = e, this.closingSelector = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new m$(e, this.openings, this.closingSelector));
  }, t;
}(), m$ = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    return n.openings = i, n.closingSelector = s, n.contexts = [], n.add(n.openSubscription = Da(n, i, i)), n;
  }
  return e.prototype._next = function(r) {
    var i = this.contexts;
    if (i)
      for (var s = i.length, n = 0; n < s; n++)
        i[n].window.next(r);
  }, e.prototype._error = function(r) {
    var i = this.contexts;
    if (this.contexts = null, i)
      for (var s = i.length, n = -1; ++n < s; ) {
        var f = i[n];
        f.window.error(r), f.subscription.unsubscribe();
      }
    t.prototype._error.call(this, r);
  }, e.prototype._complete = function() {
    var r = this.contexts;
    if (this.contexts = null, r)
      for (var i = r.length, s = -1; ++s < i; ) {
        var n = r[s];
        n.window.complete(), n.subscription.unsubscribe();
      }
    t.prototype._complete.call(this);
  }, e.prototype._unsubscribe = function() {
    var r = this.contexts;
    if (this.contexts = null, r)
      for (var i = r.length, s = -1; ++s < i; ) {
        var n = r[s];
        n.window.unsubscribe(), n.subscription.unsubscribe();
      }
  }, e.prototype.notifyNext = function(r, i, s, n, f) {
    if (r === this.openings) {
      var u = void 0;
      try {
        var h = this.closingSelector;
        u = h(i);
      } catch (M) {
        return this.error(M);
      }
      var d = new mi(), l = new Vr(), m = { window: d, subscription: l };
      this.contexts.push(m);
      var b = Da(this, u, m);
      b.closed ? this.closeWindow(this.contexts.length - 1) : (b.context = m, l.add(b)), this.destination.next(d);
    } else
      this.closeWindow(this.contexts.indexOf(r));
  }, e.prototype.notifyError = function(r) {
    this.error(r);
  }, e.prototype.notifyComplete = function(r) {
    r !== this.openSubscription && this.closeWindow(this.contexts.indexOf(r.context));
  }, e.prototype.closeWindow = function(r) {
    if (r !== -1) {
      var i = this.contexts, s = i[r], n = s.window, f = s.subscription;
      i.splice(r, 1), n.complete(), f.unsubscribe();
    }
  }, e;
}(vf);
function w$(t) {
  return function(r) {
    return r.lift(new _$(t));
  };
}
var _$ = /* @__PURE__ */ function() {
  function t(e) {
    this.closingSelector = e;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new M$(e, this.closingSelector));
  }, t;
}(), M$ = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i) {
    var s = t.call(this, r) || this;
    return s.destination = r, s.closingSelector = i, s.openWindow(), s;
  }
  return e.prototype.notifyNext = function(r, i, s, n, f) {
    this.openWindow(f);
  }, e.prototype.notifyError = function(r) {
    this._error(r);
  }, e.prototype.notifyComplete = function(r) {
    this.openWindow(r);
  }, e.prototype._next = function(r) {
    this.window.next(r);
  }, e.prototype._error = function(r) {
    this.window.error(r), this.destination.error(r), this.unsubscribeClosingNotification();
  }, e.prototype._complete = function() {
    this.window.complete(), this.destination.complete(), this.unsubscribeClosingNotification();
  }, e.prototype.unsubscribeClosingNotification = function() {
    this.closingNotification && this.closingNotification.unsubscribe();
  }, e.prototype.openWindow = function(r) {
    r === void 0 && (r = null), r && (this.remove(r), r.unsubscribe());
    var i = this.window;
    i && i.complete();
    var s = this.window = new mi();
    this.destination.next(s);
    var n;
    try {
      var f = this.closingSelector;
      n = f();
    } catch (u) {
      this.destination.error(u), this.window.error(u);
      return;
    }
    this.add(this.closingNotification = Da(this, n));
  }, e;
}(vf);
function x$() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  return function(r) {
    var i;
    typeof t[t.length - 1] == "function" && (i = t.pop());
    var s = t;
    return r.lift(new S$(s, i));
  };
}
var S$ = /* @__PURE__ */ function() {
  function t(e, r) {
    this.observables = e, this.project = r;
  }
  return t.prototype.call = function(e, r) {
    return r.subscribe(new E$(e, this.observables, this.project));
  }, t;
}(), E$ = /* @__PURE__ */ function(t) {
  it(e, t);
  function e(r, i, s) {
    var n = t.call(this, r) || this;
    n.observables = i, n.project = s, n.toRespond = [];
    var f = i.length;
    n.values = new Array(f);
    for (var u = 0; u < f; u++)
      n.toRespond.push(u);
    for (var u = 0; u < f; u++) {
      var h = i[u];
      n.add(Da(n, h, void 0, u));
    }
    return n;
  }
  return e.prototype.notifyNext = function(r, i, s) {
    this.values[s] = i;
    var n = this.toRespond;
    if (n.length > 0) {
      var f = n.indexOf(s);
      f !== -1 && n.splice(f, 1);
    }
  }, e.prototype.notifyComplete = function() {
  }, e.prototype._next = function(r) {
    if (this.toRespond.length === 0) {
      var i = [r].concat(this.values);
      this.project ? this._tryProject(i) : this.destination.next(i);
    }
  }, e.prototype._tryProject = function(r) {
    var i;
    try {
      i = this.project.apply(this, r);
    } catch (s) {
      this.destination.error(s);
      return;
    }
    this.destination.next(i);
  }, e;
}(vf);
function I$() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  return function(i) {
    return i.lift.call(A7.apply(void 0, [i].concat(t)));
  };
}
function A$(t) {
  return function(e) {
    return e.lift(new T7(t));
  };
}
const T$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  audit: N7,
  auditTime: TB,
  buffer: NB,
  bufferCount: OB,
  bufferTime: kB,
  bufferToggle: FB,
  bufferWhen: HB,
  catchError: GB,
  combineAll: QB,
  combineLatest: ZB,
  concat: JB,
  concatAll: y7,
  concatMap: C7,
  concatMapTo: XB,
  count: ez,
  debounce: iz,
  debounceTime: az,
  defaultIfEmpty: Ch,
  delay: lz,
  delayWhen: gz,
  dematerialize: wz,
  distinct: xz,
  distinctUntilChanged: R7,
  distinctUntilKeyChanged: Tz,
  elementAt: Lz,
  endWith: Pz,
  every: kz,
  exhaust: zz,
  exhaustMap: L7,
  expand: Hz,
  filter: co,
  finalize: Gz,
  find: Qz,
  findIndex: Jz,
  first: Xz,
  groupBy: oj,
  ignoreElements: eU,
  isEmpty: iU,
  last: fU,
  map: ns,
  mapTo: cU,
  materialize: lU,
  max: bU,
  merge: yU,
  mergeAll: h2,
  mergeMap: sf,
  flatMap: Xj,
  mergeMapTo: mU,
  mergeScan: wU,
  min: xU,
  multicast: af,
  observeOn: bj,
  onErrorResumeNext: EU,
  pairwise: TU,
  partition: CU,
  pluck: OU,
  publish: LU,
  publishBehavior: PU,
  publishLast: kU,
  publishReplay: jU,
  race: BU,
  reduce: J0,
  repeat: zU,
  repeatWhen: FU,
  retry: HU,
  retryWhen: GU,
  refCount: a2,
  sample: QU,
  sampleTime: XU,
  scan: d0,
  sequenceEqual: iF,
  share: fF,
  shareReplay: cF,
  single: hF,
  skip: pF,
  skipLast: bF,
  skipUntil: wF,
  skipWhile: xF,
  startWith: IF,
  subscribeOn: TF,
  switchAll: OF,
  switchMap: dh,
  switchMapTo: RF,
  take: d2,
  takeLast: l0,
  takeUntil: LF,
  takeWhile: jF,
  tap: UF,
  throttle: qF,
  throttleTime: VF,
  throwIfEmpty: Z0,
  timeInterval: QF,
  timeout: e$,
  timeoutWith: j7,
  timestamp: t$,
  toArray: n$,
  window: s$,
  windowCount: f$,
  windowTime: h$,
  windowToggle: b$,
  windowWhen: w$,
  withLatestFrom: x$,
  zip: I$,
  zipAll: A$
}, Symbol.toStringTag, { value: "Module" })), X0 = /* @__PURE__ */ pf(T$);
var Oh = { exports: {} }, It = { exports: {} };
typeof Object.create == "function" ? It.exports = function(e, r) {
  r && (e.super_ = r, e.prototype = Object.create(r.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : It.exports = function(e, r) {
  if (r) {
    e.super_ = r;
    var i = function() {
    };
    i.prototype = r.prototype, e.prototype = new i(), e.prototype.constructor = e;
  }
};
var Ft = { exports: {} }, Tn = {}, ep = {};
ep.byteLength = C$;
ep.toByteArray = R$;
ep.fromByteArray = k$;
var Gs = [], Yn = [], N$ = typeof Uint8Array < "u" ? Uint8Array : Array, Sv = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Hf = 0, D$ = Sv.length; Hf < D$; ++Hf)
  Gs[Hf] = Sv[Hf], Yn[Sv.charCodeAt(Hf)] = Hf;
Yn["-".charCodeAt(0)] = 62;
Yn["_".charCodeAt(0)] = 63;
function z7(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = t.indexOf("=");
  r === -1 && (r = e);
  var i = r === e ? 0 : 4 - r % 4;
  return [r, i];
}
function C$(t) {
  var e = z7(t), r = e[0], i = e[1];
  return (r + i) * 3 / 4 - i;
}
function O$(t, e, r) {
  return (e + r) * 3 / 4 - r;
}
function R$(t) {
  var e, r = z7(t), i = r[0], s = r[1], n = new N$(O$(t, i, s)), f = 0, u = s > 0 ? i - 4 : i, h;
  for (h = 0; h < u; h += 4)
    e = Yn[t.charCodeAt(h)] << 18 | Yn[t.charCodeAt(h + 1)] << 12 | Yn[t.charCodeAt(h + 2)] << 6 | Yn[t.charCodeAt(h + 3)], n[f++] = e >> 16 & 255, n[f++] = e >> 8 & 255, n[f++] = e & 255;
  return s === 2 && (e = Yn[t.charCodeAt(h)] << 2 | Yn[t.charCodeAt(h + 1)] >> 4, n[f++] = e & 255), s === 1 && (e = Yn[t.charCodeAt(h)] << 10 | Yn[t.charCodeAt(h + 1)] << 4 | Yn[t.charCodeAt(h + 2)] >> 2, n[f++] = e >> 8 & 255, n[f++] = e & 255), n;
}
function L$(t) {
  return Gs[t >> 18 & 63] + Gs[t >> 12 & 63] + Gs[t >> 6 & 63] + Gs[t & 63];
}
function P$(t, e, r) {
  for (var i, s = [], n = e; n < r; n += 3)
    i = (t[n] << 16 & 16711680) + (t[n + 1] << 8 & 65280) + (t[n + 2] & 255), s.push(L$(i));
  return s.join("");
}
function k$(t) {
  for (var e, r = t.length, i = r % 3, s = [], n = 16383, f = 0, u = r - i; f < u; f += n)
    s.push(P$(t, f, f + n > u ? u : f + n));
  return i === 1 ? (e = t[r - 1], s.push(
    Gs[e >> 2] + Gs[e << 4 & 63] + "=="
  )) : i === 2 && (e = (t[r - 2] << 8) + t[r - 1], s.push(
    Gs[e >> 10] + Gs[e >> 4 & 63] + Gs[e << 2 & 63] + "="
  )), s.join("");
}
var p2 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
p2.read = function(t, e, r, i, s) {
  var n, f, u = s * 8 - i - 1, h = (1 << u) - 1, d = h >> 1, l = -7, m = r ? s - 1 : 0, b = r ? -1 : 1, M = t[e + m];
  for (m += b, n = M & (1 << -l) - 1, M >>= -l, l += u; l > 0; n = n * 256 + t[e + m], m += b, l -= 8)
    ;
  for (f = n & (1 << -l) - 1, n >>= -l, l += i; l > 0; f = f * 256 + t[e + m], m += b, l -= 8)
    ;
  if (n === 0)
    n = 1 - d;
  else {
    if (n === h)
      return f ? NaN : (M ? -1 : 1) * (1 / 0);
    f = f + Math.pow(2, i), n = n - d;
  }
  return (M ? -1 : 1) * f * Math.pow(2, n - i);
};
p2.write = function(t, e, r, i, s, n) {
  var f, u, h, d = n * 8 - s - 1, l = (1 << d) - 1, m = l >> 1, b = s === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, M = i ? 0 : n - 1, A = i ? 1 : -1, N = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (u = isNaN(e) ? 1 : 0, f = l) : (f = Math.floor(Math.log(e) / Math.LN2), e * (h = Math.pow(2, -f)) < 1 && (f--, h *= 2), f + m >= 1 ? e += b / h : e += b * Math.pow(2, 1 - m), e * h >= 2 && (f++, h /= 2), f + m >= l ? (u = 0, f = l) : f + m >= 1 ? (u = (e * h - 1) * Math.pow(2, s), f = f + m) : (u = e * Math.pow(2, m - 1) * Math.pow(2, s), f = 0)); s >= 8; t[r + M] = u & 255, M += A, u /= 256, s -= 8)
    ;
  for (f = f << s | u, d += s; d > 0; t[r + M] = f & 255, M += A, f /= 256, d -= 8)
    ;
  t[r + M - A] |= N * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(t) {
  var e = ep, r = p2, i = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  t.Buffer = u, t.SlowBuffer = P, t.INSPECT_MAX_BYTES = 50;
  var s = 2147483647;
  t.kMaxLength = s, u.TYPED_ARRAY_SUPPORT = n(), !u.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function n() {
    try {
      var X = new Uint8Array(1), $ = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf($, Uint8Array.prototype), Object.setPrototypeOf(X, $), X.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(u.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (!!u.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(u.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (!!u.isBuffer(this))
        return this.byteOffset;
    }
  });
  function f(X) {
    if (X > s)
      throw new RangeError('The value "' + X + '" is invalid for option "size"');
    var $ = new Uint8Array(X);
    return Object.setPrototypeOf($, u.prototype), $;
  }
  function u(X, $, V) {
    if (typeof X == "number") {
      if (typeof $ == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return m(X);
    }
    return h(X, $, V);
  }
  u.poolSize = 8192;
  function h(X, $, V) {
    if (typeof X == "string")
      return b(X, $);
    if (ArrayBuffer.isView(X))
      return A(X);
    if (X == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof X
      );
    if (te(X, ArrayBuffer) || X && te(X.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (te(X, SharedArrayBuffer) || X && te(X.buffer, SharedArrayBuffer)))
      return N(X, $, V);
    if (typeof X == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    var re = X.valueOf && X.valueOf();
    if (re != null && re !== X)
      return u.from(re, $, V);
    var fe = R(X);
    if (fe)
      return fe;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof X[Symbol.toPrimitive] == "function")
      return u.from(
        X[Symbol.toPrimitive]("string"),
        $,
        V
      );
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof X
    );
  }
  u.from = function(X, $, V) {
    return h(X, $, V);
  }, Object.setPrototypeOf(u.prototype, Uint8Array.prototype), Object.setPrototypeOf(u, Uint8Array);
  function d(X) {
    if (typeof X != "number")
      throw new TypeError('"size" argument must be of type number');
    if (X < 0)
      throw new RangeError('The value "' + X + '" is invalid for option "size"');
  }
  function l(X, $, V) {
    return d(X), X <= 0 ? f(X) : $ !== void 0 ? typeof V == "string" ? f(X).fill($, V) : f(X).fill($) : f(X);
  }
  u.alloc = function(X, $, V) {
    return l(X, $, V);
  };
  function m(X) {
    return d(X), f(X < 0 ? 0 : O(X) | 0);
  }
  u.allocUnsafe = function(X) {
    return m(X);
  }, u.allocUnsafeSlow = function(X) {
    return m(X);
  };
  function b(X, $) {
    if ((typeof $ != "string" || $ === "") && ($ = "utf8"), !u.isEncoding($))
      throw new TypeError("Unknown encoding: " + $);
    var V = F(X, $) | 0, re = f(V), fe = re.write(X, $);
    return fe !== V && (re = re.slice(0, fe)), re;
  }
  function M(X) {
    for (var $ = X.length < 0 ? 0 : O(X.length) | 0, V = f($), re = 0; re < $; re += 1)
      V[re] = X[re] & 255;
    return V;
  }
  function A(X) {
    if (te(X, Uint8Array)) {
      var $ = new Uint8Array(X);
      return N($.buffer, $.byteOffset, $.byteLength);
    }
    return M(X);
  }
  function N(X, $, V) {
    if ($ < 0 || X.byteLength < $)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (X.byteLength < $ + (V || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    var re;
    return $ === void 0 && V === void 0 ? re = new Uint8Array(X) : V === void 0 ? re = new Uint8Array(X, $) : re = new Uint8Array(X, $, V), Object.setPrototypeOf(re, u.prototype), re;
  }
  function R(X) {
    if (u.isBuffer(X)) {
      var $ = O(X.length) | 0, V = f($);
      return V.length === 0 || X.copy(V, 0, 0, $), V;
    }
    if (X.length !== void 0)
      return typeof X.length != "number" || ne(X.length) ? f(0) : M(X);
    if (X.type === "Buffer" && Array.isArray(X.data))
      return M(X.data);
  }
  function O(X) {
    if (X >= s)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s.toString(16) + " bytes");
    return X | 0;
  }
  function P(X) {
    return +X != X && (X = 0), u.alloc(+X);
  }
  u.isBuffer = function($) {
    return $ != null && $._isBuffer === !0 && $ !== u.prototype;
  }, u.compare = function($, V) {
    if (te($, Uint8Array) && ($ = u.from($, $.offset, $.byteLength)), te(V, Uint8Array) && (V = u.from(V, V.offset, V.byteLength)), !u.isBuffer($) || !u.isBuffer(V))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if ($ === V)
      return 0;
    for (var re = $.length, fe = V.length, ue = 0, me = Math.min(re, fe); ue < me; ++ue)
      if ($[ue] !== V[ue]) {
        re = $[ue], fe = V[ue];
        break;
      }
    return re < fe ? -1 : fe < re ? 1 : 0;
  }, u.isEncoding = function($) {
    switch (String($).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, u.concat = function($, V) {
    if (!Array.isArray($))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if ($.length === 0)
      return u.alloc(0);
    var re;
    if (V === void 0)
      for (V = 0, re = 0; re < $.length; ++re)
        V += $[re].length;
    var fe = u.allocUnsafe(V), ue = 0;
    for (re = 0; re < $.length; ++re) {
      var me = $[re];
      if (te(me, Uint8Array))
        ue + me.length > fe.length ? u.from(me).copy(fe, ue) : Uint8Array.prototype.set.call(
          fe,
          me,
          ue
        );
      else if (u.isBuffer(me))
        me.copy(fe, ue);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      ue += me.length;
    }
    return fe;
  };
  function F(X, $) {
    if (u.isBuffer(X))
      return X.length;
    if (ArrayBuffer.isView(X) || te(X, ArrayBuffer))
      return X.byteLength;
    if (typeof X != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof X
      );
    var V = X.length, re = arguments.length > 2 && arguments[2] === !0;
    if (!re && V === 0)
      return 0;
    for (var fe = !1; ; )
      switch ($) {
        case "ascii":
        case "latin1":
        case "binary":
          return V;
        case "utf8":
        case "utf-8":
          return q(X).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return V * 2;
        case "hex":
          return V >>> 1;
        case "base64":
          return T(X).length;
        default:
          if (fe)
            return re ? -1 : q(X).length;
          $ = ("" + $).toLowerCase(), fe = !0;
      }
  }
  u.byteLength = F;
  function H(X, $, V) {
    var re = !1;
    if (($ === void 0 || $ < 0) && ($ = 0), $ > this.length || ((V === void 0 || V > this.length) && (V = this.length), V <= 0) || (V >>>= 0, $ >>>= 0, V <= $))
      return "";
    for (X || (X = "utf8"); ; )
      switch (X) {
        case "hex":
          return x(this, $, V);
        case "utf8":
        case "utf-8":
          return a(this, $, V);
        case "ascii":
          return w(this, $, V);
        case "latin1":
        case "binary":
          return _(this, $, V);
        case "base64":
          return g(this, $, V);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return E(this, $, V);
        default:
          if (re)
            throw new TypeError("Unknown encoding: " + X);
          X = (X + "").toLowerCase(), re = !0;
      }
  }
  u.prototype._isBuffer = !0;
  function Q(X, $, V) {
    var re = X[$];
    X[$] = X[V], X[V] = re;
  }
  u.prototype.swap16 = function() {
    var $ = this.length;
    if ($ % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (var V = 0; V < $; V += 2)
      Q(this, V, V + 1);
    return this;
  }, u.prototype.swap32 = function() {
    var $ = this.length;
    if ($ % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (var V = 0; V < $; V += 4)
      Q(this, V, V + 3), Q(this, V + 1, V + 2);
    return this;
  }, u.prototype.swap64 = function() {
    var $ = this.length;
    if ($ % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (var V = 0; V < $; V += 8)
      Q(this, V, V + 7), Q(this, V + 1, V + 6), Q(this, V + 2, V + 5), Q(this, V + 3, V + 4);
    return this;
  }, u.prototype.toString = function() {
    var $ = this.length;
    return $ === 0 ? "" : arguments.length === 0 ? a(this, 0, $) : H.apply(this, arguments);
  }, u.prototype.toLocaleString = u.prototype.toString, u.prototype.equals = function($) {
    if (!u.isBuffer($))
      throw new TypeError("Argument must be a Buffer");
    return this === $ ? !0 : u.compare(this, $) === 0;
  }, u.prototype.inspect = function() {
    var $ = "", V = t.INSPECT_MAX_BYTES;
    return $ = this.toString("hex", 0, V).replace(/(.{2})/g, "$1 ").trim(), this.length > V && ($ += " ... "), "<Buffer " + $ + ">";
  }, i && (u.prototype[i] = u.prototype.inspect), u.prototype.compare = function($, V, re, fe, ue) {
    if (te($, Uint8Array) && ($ = u.from($, $.offset, $.byteLength)), !u.isBuffer($))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof $
      );
    if (V === void 0 && (V = 0), re === void 0 && (re = $ ? $.length : 0), fe === void 0 && (fe = 0), ue === void 0 && (ue = this.length), V < 0 || re > $.length || fe < 0 || ue > this.length)
      throw new RangeError("out of range index");
    if (fe >= ue && V >= re)
      return 0;
    if (fe >= ue)
      return -1;
    if (V >= re)
      return 1;
    if (V >>>= 0, re >>>= 0, fe >>>= 0, ue >>>= 0, this === $)
      return 0;
    for (var me = ue - fe, be = re - V, ve = Math.min(me, be), Ge = this.slice(fe, ue), ye = $.slice(V, re), pe = 0; pe < ve; ++pe)
      if (Ge[pe] !== ye[pe]) {
        me = Ge[pe], be = ye[pe];
        break;
      }
    return me < be ? -1 : be < me ? 1 : 0;
  };
  function Z(X, $, V, re, fe) {
    if (X.length === 0)
      return -1;
    if (typeof V == "string" ? (re = V, V = 0) : V > 2147483647 ? V = 2147483647 : V < -2147483648 && (V = -2147483648), V = +V, ne(V) && (V = fe ? 0 : X.length - 1), V < 0 && (V = X.length + V), V >= X.length) {
      if (fe)
        return -1;
      V = X.length - 1;
    } else if (V < 0)
      if (fe)
        V = 0;
      else
        return -1;
    if (typeof $ == "string" && ($ = u.from($, re)), u.isBuffer($))
      return $.length === 0 ? -1 : B(X, $, V, re, fe);
    if (typeof $ == "number")
      return $ = $ & 255, typeof Uint8Array.prototype.indexOf == "function" ? fe ? Uint8Array.prototype.indexOf.call(X, $, V) : Uint8Array.prototype.lastIndexOf.call(X, $, V) : B(X, [$], V, re, fe);
    throw new TypeError("val must be string, number or Buffer");
  }
  function B(X, $, V, re, fe) {
    var ue = 1, me = X.length, be = $.length;
    if (re !== void 0 && (re = String(re).toLowerCase(), re === "ucs2" || re === "ucs-2" || re === "utf16le" || re === "utf-16le")) {
      if (X.length < 2 || $.length < 2)
        return -1;
      ue = 2, me /= 2, be /= 2, V /= 2;
    }
    function ve(Ie, we) {
      return ue === 1 ? Ie[we] : Ie.readUInt16BE(we * ue);
    }
    var Ge;
    if (fe) {
      var ye = -1;
      for (Ge = V; Ge < me; Ge++)
        if (ve(X, Ge) === ve($, ye === -1 ? 0 : Ge - ye)) {
          if (ye === -1 && (ye = Ge), Ge - ye + 1 === be)
            return ye * ue;
        } else
          ye !== -1 && (Ge -= Ge - ye), ye = -1;
    } else
      for (V + be > me && (V = me - be), Ge = V; Ge >= 0; Ge--) {
        for (var pe = !0, Je = 0; Je < be; Je++)
          if (ve(X, Ge + Je) !== ve($, Je)) {
            pe = !1;
            break;
          }
        if (pe)
          return Ge;
      }
    return -1;
  }
  u.prototype.includes = function($, V, re) {
    return this.indexOf($, V, re) !== -1;
  }, u.prototype.indexOf = function($, V, re) {
    return Z(this, $, V, re, !0);
  }, u.prototype.lastIndexOf = function($, V, re) {
    return Z(this, $, V, re, !1);
  };
  function Y(X, $, V, re) {
    V = Number(V) || 0;
    var fe = X.length - V;
    re ? (re = Number(re), re > fe && (re = fe)) : re = fe;
    var ue = $.length;
    re > ue / 2 && (re = ue / 2);
    for (var me = 0; me < re; ++me) {
      var be = parseInt($.substr(me * 2, 2), 16);
      if (ne(be))
        return me;
      X[V + me] = be;
    }
    return me;
  }
  function ae(X, $, V, re) {
    return D(q($, X.length - V), X, V, re);
  }
  function se(X, $, V, re) {
    return D(K($), X, V, re);
  }
  function W(X, $, V, re) {
    return D(T($), X, V, re);
  }
  function C(X, $, V, re) {
    return D(U($, X.length - V), X, V, re);
  }
  u.prototype.write = function($, V, re, fe) {
    if (V === void 0)
      fe = "utf8", re = this.length, V = 0;
    else if (re === void 0 && typeof V == "string")
      fe = V, re = this.length, V = 0;
    else if (isFinite(V))
      V = V >>> 0, isFinite(re) ? (re = re >>> 0, fe === void 0 && (fe = "utf8")) : (fe = re, re = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    var ue = this.length - V;
    if ((re === void 0 || re > ue) && (re = ue), $.length > 0 && (re < 0 || V < 0) || V > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    fe || (fe = "utf8");
    for (var me = !1; ; )
      switch (fe) {
        case "hex":
          return Y(this, $, V, re);
        case "utf8":
        case "utf-8":
          return ae(this, $, V, re);
        case "ascii":
        case "latin1":
        case "binary":
          return se(this, $, V, re);
        case "base64":
          return W(this, $, V, re);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return C(this, $, V, re);
        default:
          if (me)
            throw new TypeError("Unknown encoding: " + fe);
          fe = ("" + fe).toLowerCase(), me = !0;
      }
  }, u.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function g(X, $, V) {
    return $ === 0 && V === X.length ? e.fromByteArray(X) : e.fromByteArray(X.slice($, V));
  }
  function a(X, $, V) {
    V = Math.min(X.length, V);
    for (var re = [], fe = $; fe < V; ) {
      var ue = X[fe], me = null, be = ue > 239 ? 4 : ue > 223 ? 3 : ue > 191 ? 2 : 1;
      if (fe + be <= V) {
        var ve, Ge, ye, pe;
        switch (be) {
          case 1:
            ue < 128 && (me = ue);
            break;
          case 2:
            ve = X[fe + 1], (ve & 192) === 128 && (pe = (ue & 31) << 6 | ve & 63, pe > 127 && (me = pe));
            break;
          case 3:
            ve = X[fe + 1], Ge = X[fe + 2], (ve & 192) === 128 && (Ge & 192) === 128 && (pe = (ue & 15) << 12 | (ve & 63) << 6 | Ge & 63, pe > 2047 && (pe < 55296 || pe > 57343) && (me = pe));
            break;
          case 4:
            ve = X[fe + 1], Ge = X[fe + 2], ye = X[fe + 3], (ve & 192) === 128 && (Ge & 192) === 128 && (ye & 192) === 128 && (pe = (ue & 15) << 18 | (ve & 63) << 12 | (Ge & 63) << 6 | ye & 63, pe > 65535 && pe < 1114112 && (me = pe));
        }
      }
      me === null ? (me = 65533, be = 1) : me > 65535 && (me -= 65536, re.push(me >>> 10 & 1023 | 55296), me = 56320 | me & 1023), re.push(me), fe += be;
    }
    return p(re);
  }
  var c = 4096;
  function p(X) {
    var $ = X.length;
    if ($ <= c)
      return String.fromCharCode.apply(String, X);
    for (var V = "", re = 0; re < $; )
      V += String.fromCharCode.apply(
        String,
        X.slice(re, re += c)
      );
    return V;
  }
  function w(X, $, V) {
    var re = "";
    V = Math.min(X.length, V);
    for (var fe = $; fe < V; ++fe)
      re += String.fromCharCode(X[fe] & 127);
    return re;
  }
  function _(X, $, V) {
    var re = "";
    V = Math.min(X.length, V);
    for (var fe = $; fe < V; ++fe)
      re += String.fromCharCode(X[fe]);
    return re;
  }
  function x(X, $, V) {
    var re = X.length;
    (!$ || $ < 0) && ($ = 0), (!V || V < 0 || V > re) && (V = re);
    for (var fe = "", ue = $; ue < V; ++ue)
      fe += le[X[ue]];
    return fe;
  }
  function E(X, $, V) {
    for (var re = X.slice($, V), fe = "", ue = 0; ue < re.length - 1; ue += 2)
      fe += String.fromCharCode(re[ue] + re[ue + 1] * 256);
    return fe;
  }
  u.prototype.slice = function($, V) {
    var re = this.length;
    $ = ~~$, V = V === void 0 ? re : ~~V, $ < 0 ? ($ += re, $ < 0 && ($ = 0)) : $ > re && ($ = re), V < 0 ? (V += re, V < 0 && (V = 0)) : V > re && (V = re), V < $ && (V = $);
    var fe = this.subarray($, V);
    return Object.setPrototypeOf(fe, u.prototype), fe;
  };
  function y(X, $, V) {
    if (X % 1 !== 0 || X < 0)
      throw new RangeError("offset is not uint");
    if (X + $ > V)
      throw new RangeError("Trying to access beyond buffer length");
  }
  u.prototype.readUintLE = u.prototype.readUIntLE = function($, V, re) {
    $ = $ >>> 0, V = V >>> 0, re || y($, V, this.length);
    for (var fe = this[$], ue = 1, me = 0; ++me < V && (ue *= 256); )
      fe += this[$ + me] * ue;
    return fe;
  }, u.prototype.readUintBE = u.prototype.readUIntBE = function($, V, re) {
    $ = $ >>> 0, V = V >>> 0, re || y($, V, this.length);
    for (var fe = this[$ + --V], ue = 1; V > 0 && (ue *= 256); )
      fe += this[$ + --V] * ue;
    return fe;
  }, u.prototype.readUint8 = u.prototype.readUInt8 = function($, V) {
    return $ = $ >>> 0, V || y($, 1, this.length), this[$];
  }, u.prototype.readUint16LE = u.prototype.readUInt16LE = function($, V) {
    return $ = $ >>> 0, V || y($, 2, this.length), this[$] | this[$ + 1] << 8;
  }, u.prototype.readUint16BE = u.prototype.readUInt16BE = function($, V) {
    return $ = $ >>> 0, V || y($, 2, this.length), this[$] << 8 | this[$ + 1];
  }, u.prototype.readUint32LE = u.prototype.readUInt32LE = function($, V) {
    return $ = $ >>> 0, V || y($, 4, this.length), (this[$] | this[$ + 1] << 8 | this[$ + 2] << 16) + this[$ + 3] * 16777216;
  }, u.prototype.readUint32BE = u.prototype.readUInt32BE = function($, V) {
    return $ = $ >>> 0, V || y($, 4, this.length), this[$] * 16777216 + (this[$ + 1] << 16 | this[$ + 2] << 8 | this[$ + 3]);
  }, u.prototype.readIntLE = function($, V, re) {
    $ = $ >>> 0, V = V >>> 0, re || y($, V, this.length);
    for (var fe = this[$], ue = 1, me = 0; ++me < V && (ue *= 256); )
      fe += this[$ + me] * ue;
    return ue *= 128, fe >= ue && (fe -= Math.pow(2, 8 * V)), fe;
  }, u.prototype.readIntBE = function($, V, re) {
    $ = $ >>> 0, V = V >>> 0, re || y($, V, this.length);
    for (var fe = V, ue = 1, me = this[$ + --fe]; fe > 0 && (ue *= 256); )
      me += this[$ + --fe] * ue;
    return ue *= 128, me >= ue && (me -= Math.pow(2, 8 * V)), me;
  }, u.prototype.readInt8 = function($, V) {
    return $ = $ >>> 0, V || y($, 1, this.length), this[$] & 128 ? (255 - this[$] + 1) * -1 : this[$];
  }, u.prototype.readInt16LE = function($, V) {
    $ = $ >>> 0, V || y($, 2, this.length);
    var re = this[$] | this[$ + 1] << 8;
    return re & 32768 ? re | 4294901760 : re;
  }, u.prototype.readInt16BE = function($, V) {
    $ = $ >>> 0, V || y($, 2, this.length);
    var re = this[$ + 1] | this[$] << 8;
    return re & 32768 ? re | 4294901760 : re;
  }, u.prototype.readInt32LE = function($, V) {
    return $ = $ >>> 0, V || y($, 4, this.length), this[$] | this[$ + 1] << 8 | this[$ + 2] << 16 | this[$ + 3] << 24;
  }, u.prototype.readInt32BE = function($, V) {
    return $ = $ >>> 0, V || y($, 4, this.length), this[$] << 24 | this[$ + 1] << 16 | this[$ + 2] << 8 | this[$ + 3];
  }, u.prototype.readFloatLE = function($, V) {
    return $ = $ >>> 0, V || y($, 4, this.length), r.read(this, $, !0, 23, 4);
  }, u.prototype.readFloatBE = function($, V) {
    return $ = $ >>> 0, V || y($, 4, this.length), r.read(this, $, !1, 23, 4);
  }, u.prototype.readDoubleLE = function($, V) {
    return $ = $ >>> 0, V || y($, 8, this.length), r.read(this, $, !0, 52, 8);
  }, u.prototype.readDoubleBE = function($, V) {
    return $ = $ >>> 0, V || y($, 8, this.length), r.read(this, $, !1, 52, 8);
  };
  function o(X, $, V, re, fe, ue) {
    if (!u.isBuffer(X))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if ($ > fe || $ < ue)
      throw new RangeError('"value" argument is out of bounds');
    if (V + re > X.length)
      throw new RangeError("Index out of range");
  }
  u.prototype.writeUintLE = u.prototype.writeUIntLE = function($, V, re, fe) {
    if ($ = +$, V = V >>> 0, re = re >>> 0, !fe) {
      var ue = Math.pow(2, 8 * re) - 1;
      o(this, $, V, re, ue, 0);
    }
    var me = 1, be = 0;
    for (this[V] = $ & 255; ++be < re && (me *= 256); )
      this[V + be] = $ / me & 255;
    return V + re;
  }, u.prototype.writeUintBE = u.prototype.writeUIntBE = function($, V, re, fe) {
    if ($ = +$, V = V >>> 0, re = re >>> 0, !fe) {
      var ue = Math.pow(2, 8 * re) - 1;
      o(this, $, V, re, ue, 0);
    }
    var me = re - 1, be = 1;
    for (this[V + me] = $ & 255; --me >= 0 && (be *= 256); )
      this[V + me] = $ / be & 255;
    return V + re;
  }, u.prototype.writeUint8 = u.prototype.writeUInt8 = function($, V, re) {
    return $ = +$, V = V >>> 0, re || o(this, $, V, 1, 255, 0), this[V] = $ & 255, V + 1;
  }, u.prototype.writeUint16LE = u.prototype.writeUInt16LE = function($, V, re) {
    return $ = +$, V = V >>> 0, re || o(this, $, V, 2, 65535, 0), this[V] = $ & 255, this[V + 1] = $ >>> 8, V + 2;
  }, u.prototype.writeUint16BE = u.prototype.writeUInt16BE = function($, V, re) {
    return $ = +$, V = V >>> 0, re || o(this, $, V, 2, 65535, 0), this[V] = $ >>> 8, this[V + 1] = $ & 255, V + 2;
  }, u.prototype.writeUint32LE = u.prototype.writeUInt32LE = function($, V, re) {
    return $ = +$, V = V >>> 0, re || o(this, $, V, 4, 4294967295, 0), this[V + 3] = $ >>> 24, this[V + 2] = $ >>> 16, this[V + 1] = $ >>> 8, this[V] = $ & 255, V + 4;
  }, u.prototype.writeUint32BE = u.prototype.writeUInt32BE = function($, V, re) {
    return $ = +$, V = V >>> 0, re || o(this, $, V, 4, 4294967295, 0), this[V] = $ >>> 24, this[V + 1] = $ >>> 16, this[V + 2] = $ >>> 8, this[V + 3] = $ & 255, V + 4;
  }, u.prototype.writeIntLE = function($, V, re, fe) {
    if ($ = +$, V = V >>> 0, !fe) {
      var ue = Math.pow(2, 8 * re - 1);
      o(this, $, V, re, ue - 1, -ue);
    }
    var me = 0, be = 1, ve = 0;
    for (this[V] = $ & 255; ++me < re && (be *= 256); )
      $ < 0 && ve === 0 && this[V + me - 1] !== 0 && (ve = 1), this[V + me] = ($ / be >> 0) - ve & 255;
    return V + re;
  }, u.prototype.writeIntBE = function($, V, re, fe) {
    if ($ = +$, V = V >>> 0, !fe) {
      var ue = Math.pow(2, 8 * re - 1);
      o(this, $, V, re, ue - 1, -ue);
    }
    var me = re - 1, be = 1, ve = 0;
    for (this[V + me] = $ & 255; --me >= 0 && (be *= 256); )
      $ < 0 && ve === 0 && this[V + me + 1] !== 0 && (ve = 1), this[V + me] = ($ / be >> 0) - ve & 255;
    return V + re;
  }, u.prototype.writeInt8 = function($, V, re) {
    return $ = +$, V = V >>> 0, re || o(this, $, V, 1, 127, -128), $ < 0 && ($ = 255 + $ + 1), this[V] = $ & 255, V + 1;
  }, u.prototype.writeInt16LE = function($, V, re) {
    return $ = +$, V = V >>> 0, re || o(this, $, V, 2, 32767, -32768), this[V] = $ & 255, this[V + 1] = $ >>> 8, V + 2;
  }, u.prototype.writeInt16BE = function($, V, re) {
    return $ = +$, V = V >>> 0, re || o(this, $, V, 2, 32767, -32768), this[V] = $ >>> 8, this[V + 1] = $ & 255, V + 2;
  }, u.prototype.writeInt32LE = function($, V, re) {
    return $ = +$, V = V >>> 0, re || o(this, $, V, 4, 2147483647, -2147483648), this[V] = $ & 255, this[V + 1] = $ >>> 8, this[V + 2] = $ >>> 16, this[V + 3] = $ >>> 24, V + 4;
  }, u.prototype.writeInt32BE = function($, V, re) {
    return $ = +$, V = V >>> 0, re || o(this, $, V, 4, 2147483647, -2147483648), $ < 0 && ($ = 4294967295 + $ + 1), this[V] = $ >>> 24, this[V + 1] = $ >>> 16, this[V + 2] = $ >>> 8, this[V + 3] = $ & 255, V + 4;
  };
  function S(X, $, V, re, fe, ue) {
    if (V + re > X.length)
      throw new RangeError("Index out of range");
    if (V < 0)
      throw new RangeError("Index out of range");
  }
  function J(X, $, V, re, fe) {
    return $ = +$, V = V >>> 0, fe || S(X, $, V, 4), r.write(X, $, V, re, 23, 4), V + 4;
  }
  u.prototype.writeFloatLE = function($, V, re) {
    return J(this, $, V, !0, re);
  }, u.prototype.writeFloatBE = function($, V, re) {
    return J(this, $, V, !1, re);
  };
  function z(X, $, V, re, fe) {
    return $ = +$, V = V >>> 0, fe || S(X, $, V, 8), r.write(X, $, V, re, 52, 8), V + 8;
  }
  u.prototype.writeDoubleLE = function($, V, re) {
    return z(this, $, V, !0, re);
  }, u.prototype.writeDoubleBE = function($, V, re) {
    return z(this, $, V, !1, re);
  }, u.prototype.copy = function($, V, re, fe) {
    if (!u.isBuffer($))
      throw new TypeError("argument should be a Buffer");
    if (re || (re = 0), !fe && fe !== 0 && (fe = this.length), V >= $.length && (V = $.length), V || (V = 0), fe > 0 && fe < re && (fe = re), fe === re || $.length === 0 || this.length === 0)
      return 0;
    if (V < 0)
      throw new RangeError("targetStart out of bounds");
    if (re < 0 || re >= this.length)
      throw new RangeError("Index out of range");
    if (fe < 0)
      throw new RangeError("sourceEnd out of bounds");
    fe > this.length && (fe = this.length), $.length - V < fe - re && (fe = $.length - V + re);
    var ue = fe - re;
    return this === $ && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(V, re, fe) : Uint8Array.prototype.set.call(
      $,
      this.subarray(re, fe),
      V
    ), ue;
  }, u.prototype.fill = function($, V, re, fe) {
    if (typeof $ == "string") {
      if (typeof V == "string" ? (fe = V, V = 0, re = this.length) : typeof re == "string" && (fe = re, re = this.length), fe !== void 0 && typeof fe != "string")
        throw new TypeError("encoding must be a string");
      if (typeof fe == "string" && !u.isEncoding(fe))
        throw new TypeError("Unknown encoding: " + fe);
      if ($.length === 1) {
        var ue = $.charCodeAt(0);
        (fe === "utf8" && ue < 128 || fe === "latin1") && ($ = ue);
      }
    } else
      typeof $ == "number" ? $ = $ & 255 : typeof $ == "boolean" && ($ = Number($));
    if (V < 0 || this.length < V || this.length < re)
      throw new RangeError("Out of range index");
    if (re <= V)
      return this;
    V = V >>> 0, re = re === void 0 ? this.length : re >>> 0, $ || ($ = 0);
    var me;
    if (typeof $ == "number")
      for (me = V; me < re; ++me)
        this[me] = $;
    else {
      var be = u.isBuffer($) ? $ : u.from($, fe), ve = be.length;
      if (ve === 0)
        throw new TypeError('The value "' + $ + '" is invalid for argument "value"');
      for (me = 0; me < re - V; ++me)
        this[me + V] = be[me % ve];
    }
    return this;
  };
  var k = /[^+/0-9A-Za-z-_]/g;
  function j(X) {
    if (X = X.split("=")[0], X = X.trim().replace(k, ""), X.length < 2)
      return "";
    for (; X.length % 4 !== 0; )
      X = X + "=";
    return X;
  }
  function q(X, $) {
    $ = $ || 1 / 0;
    for (var V, re = X.length, fe = null, ue = [], me = 0; me < re; ++me) {
      if (V = X.charCodeAt(me), V > 55295 && V < 57344) {
        if (!fe) {
          if (V > 56319) {
            ($ -= 3) > -1 && ue.push(239, 191, 189);
            continue;
          } else if (me + 1 === re) {
            ($ -= 3) > -1 && ue.push(239, 191, 189);
            continue;
          }
          fe = V;
          continue;
        }
        if (V < 56320) {
          ($ -= 3) > -1 && ue.push(239, 191, 189), fe = V;
          continue;
        }
        V = (fe - 55296 << 10 | V - 56320) + 65536;
      } else
        fe && ($ -= 3) > -1 && ue.push(239, 191, 189);
      if (fe = null, V < 128) {
        if (($ -= 1) < 0)
          break;
        ue.push(V);
      } else if (V < 2048) {
        if (($ -= 2) < 0)
          break;
        ue.push(
          V >> 6 | 192,
          V & 63 | 128
        );
      } else if (V < 65536) {
        if (($ -= 3) < 0)
          break;
        ue.push(
          V >> 12 | 224,
          V >> 6 & 63 | 128,
          V & 63 | 128
        );
      } else if (V < 1114112) {
        if (($ -= 4) < 0)
          break;
        ue.push(
          V >> 18 | 240,
          V >> 12 & 63 | 128,
          V >> 6 & 63 | 128,
          V & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return ue;
  }
  function K(X) {
    for (var $ = [], V = 0; V < X.length; ++V)
      $.push(X.charCodeAt(V) & 255);
    return $;
  }
  function U(X, $) {
    for (var V, re, fe, ue = [], me = 0; me < X.length && !(($ -= 2) < 0); ++me)
      V = X.charCodeAt(me), re = V >> 8, fe = V % 256, ue.push(fe), ue.push(re);
    return ue;
  }
  function T(X) {
    return e.toByteArray(j(X));
  }
  function D(X, $, V, re) {
    for (var fe = 0; fe < re && !(fe + V >= $.length || fe >= X.length); ++fe)
      $[fe + V] = X[fe];
    return fe;
  }
  function te(X, $) {
    return X instanceof $ || X != null && X.constructor != null && X.constructor.name != null && X.constructor.name === $.name;
  }
  function ne(X) {
    return X !== X;
  }
  var le = function() {
    for (var X = "0123456789abcdef", $ = new Array(256), V = 0; V < 16; ++V)
      for (var re = V * 16, fe = 0; fe < 16; ++fe)
        $[re + fe] = X[V] + X[fe];
    return $;
  }();
})(Tn);
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(t, e) {
  var r = Tn, i = r.Buffer;
  function s(f, u) {
    for (var h in f)
      u[h] = f[h];
  }
  i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = r : (s(r, e), e.Buffer = n);
  function n(f, u, h) {
    return i(f, u, h);
  }
  n.prototype = Object.create(i.prototype), s(i, n), n.from = function(f, u, h) {
    if (typeof f == "number")
      throw new TypeError("Argument must not be a number");
    return i(f, u, h);
  }, n.alloc = function(f, u, h) {
    if (typeof f != "number")
      throw new TypeError("Argument must be a number");
    var d = i(f);
    return u !== void 0 ? typeof h == "string" ? d.fill(u, h) : d.fill(u) : d.fill(0), d;
  }, n.allocUnsafe = function(f) {
    if (typeof f != "number")
      throw new TypeError("Argument must be a number");
    return i(f);
  }, n.allocUnsafeSlow = function(f) {
    if (typeof f != "number")
      throw new TypeError("Argument must be a number");
    return r.SlowBuffer(f);
  };
})(Ft, Ft.exports);
var U7 = Ft.exports.Buffer;
function tp(t, e) {
  this._block = U7.alloc(t), this._finalSize = e, this._blockSize = t, this._len = 0;
}
tp.prototype.update = function(t, e) {
  typeof t == "string" && (e = e || "utf8", t = U7.from(t, e));
  for (var r = this._block, i = this._blockSize, s = t.length, n = this._len, f = 0; f < s; ) {
    for (var u = n % i, h = Math.min(s - f, i - u), d = 0; d < h; d++)
      r[u + d] = t[f + d];
    n += h, f += h, n % i === 0 && this._update(r);
  }
  return this._len += s, this;
};
tp.prototype.digest = function(t) {
  var e = this._len % this._blockSize;
  this._block[e] = 128, this._block.fill(0, e + 1), e >= this._finalSize && (this._update(this._block), this._block.fill(0));
  var r = this._len * 8;
  if (r <= 4294967295)
    this._block.writeUInt32BE(r, this._blockSize - 4);
  else {
    var i = (r & 4294967295) >>> 0, s = (r - i) / 4294967296;
    this._block.writeUInt32BE(s, this._blockSize - 8), this._block.writeUInt32BE(i, this._blockSize - 4);
  }
  this._update(this._block);
  var n = this._hash();
  return t ? n.toString(t) : n;
};
tp.prototype._update = function() {
  throw new Error("_update must be implemented by subclass");
};
var qc = tp, j$ = It.exports, F7 = qc, B$ = Ft.exports.Buffer, z$ = [
  1518500249,
  1859775393,
  -1894007588,
  -899497514
], U$ = new Array(80);
function Rh() {
  this.init(), this._w = U$, F7.call(this, 64, 56);
}
j$(Rh, F7);
Rh.prototype.init = function() {
  return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
};
function F$(t) {
  return t << 5 | t >>> 27;
}
function $$(t) {
  return t << 30 | t >>> 2;
}
function q$(t, e, r, i) {
  return t === 0 ? e & r | ~e & i : t === 2 ? e & r | e & i | r & i : e ^ r ^ i;
}
Rh.prototype._update = function(t) {
  for (var e = this._w, r = this._a | 0, i = this._b | 0, s = this._c | 0, n = this._d | 0, f = this._e | 0, u = 0; u < 16; ++u)
    e[u] = t.readInt32BE(u * 4);
  for (; u < 80; ++u)
    e[u] = e[u - 3] ^ e[u - 8] ^ e[u - 14] ^ e[u - 16];
  for (var h = 0; h < 80; ++h) {
    var d = ~~(h / 20), l = F$(r) + q$(d, i, s, n) + f + e[h] + z$[d] | 0;
    f = n, n = s, s = $$(i), i = r, r = l;
  }
  this._a = r + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = n + this._d | 0, this._e = f + this._e | 0;
};
Rh.prototype._hash = function() {
  var t = B$.allocUnsafe(20);
  return t.writeInt32BE(this._a | 0, 0), t.writeInt32BE(this._b | 0, 4), t.writeInt32BE(this._c | 0, 8), t.writeInt32BE(this._d | 0, 12), t.writeInt32BE(this._e | 0, 16), t;
};
var H$ = Rh, W$ = It.exports, $7 = qc, V$ = Ft.exports.Buffer, G$ = [
  1518500249,
  1859775393,
  -1894007588,
  -899497514
], K$ = new Array(80);
function Lh() {
  this.init(), this._w = K$, $7.call(this, 64, 56);
}
W$(Lh, $7);
Lh.prototype.init = function() {
  return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
};
function Y$(t) {
  return t << 1 | t >>> 31;
}
function Q$(t) {
  return t << 5 | t >>> 27;
}
function Z$(t) {
  return t << 30 | t >>> 2;
}
function J$(t, e, r, i) {
  return t === 0 ? e & r | ~e & i : t === 2 ? e & r | e & i | r & i : e ^ r ^ i;
}
Lh.prototype._update = function(t) {
  for (var e = this._w, r = this._a | 0, i = this._b | 0, s = this._c | 0, n = this._d | 0, f = this._e | 0, u = 0; u < 16; ++u)
    e[u] = t.readInt32BE(u * 4);
  for (; u < 80; ++u)
    e[u] = Y$(e[u - 3] ^ e[u - 8] ^ e[u - 14] ^ e[u - 16]);
  for (var h = 0; h < 80; ++h) {
    var d = ~~(h / 20), l = Q$(r) + J$(d, i, s, n) + f + e[h] + G$[d] | 0;
    f = n, n = s, s = Z$(i), i = r, r = l;
  }
  this._a = r + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = n + this._d | 0, this._e = f + this._e | 0;
};
Lh.prototype._hash = function() {
  var t = V$.allocUnsafe(20);
  return t.writeInt32BE(this._a | 0, 0), t.writeInt32BE(this._b | 0, 4), t.writeInt32BE(this._c | 0, 8), t.writeInt32BE(this._d | 0, 12), t.writeInt32BE(this._e | 0, 16), t;
};
var X$ = Lh, eq = It.exports, q7 = qc, tq = Ft.exports.Buffer, rq = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
], iq = new Array(64);
function Ph() {
  this.init(), this._w = iq, q7.call(this, 64, 56);
}
eq(Ph, q7);
Ph.prototype.init = function() {
  return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
};
function nq(t, e, r) {
  return r ^ t & (e ^ r);
}
function sq(t, e, r) {
  return t & e | r & (t | e);
}
function aq(t) {
  return (t >>> 2 | t << 30) ^ (t >>> 13 | t << 19) ^ (t >>> 22 | t << 10);
}
function oq(t) {
  return (t >>> 6 | t << 26) ^ (t >>> 11 | t << 21) ^ (t >>> 25 | t << 7);
}
function fq(t) {
  return (t >>> 7 | t << 25) ^ (t >>> 18 | t << 14) ^ t >>> 3;
}
function cq(t) {
  return (t >>> 17 | t << 15) ^ (t >>> 19 | t << 13) ^ t >>> 10;
}
Ph.prototype._update = function(t) {
  for (var e = this._w, r = this._a | 0, i = this._b | 0, s = this._c | 0, n = this._d | 0, f = this._e | 0, u = this._f | 0, h = this._g | 0, d = this._h | 0, l = 0; l < 16; ++l)
    e[l] = t.readInt32BE(l * 4);
  for (; l < 64; ++l)
    e[l] = cq(e[l - 2]) + e[l - 7] + fq(e[l - 15]) + e[l - 16] | 0;
  for (var m = 0; m < 64; ++m) {
    var b = d + oq(f) + nq(f, u, h) + rq[m] + e[m] | 0, M = aq(r) + sq(r, i, s) | 0;
    d = h, h = u, u = f, f = n + b | 0, n = s, s = i, i = r, r = b + M | 0;
  }
  this._a = r + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = n + this._d | 0, this._e = f + this._e | 0, this._f = u + this._f | 0, this._g = h + this._g | 0, this._h = d + this._h | 0;
};
Ph.prototype._hash = function() {
  var t = tq.allocUnsafe(32);
  return t.writeInt32BE(this._a, 0), t.writeInt32BE(this._b, 4), t.writeInt32BE(this._c, 8), t.writeInt32BE(this._d, 12), t.writeInt32BE(this._e, 16), t.writeInt32BE(this._f, 20), t.writeInt32BE(this._g, 24), t.writeInt32BE(this._h, 28), t;
};
var H7 = Ph, uq = It.exports, hq = H7, lq = qc, dq = Ft.exports.Buffer, pq = new Array(64);
function rp() {
  this.init(), this._w = pq, lq.call(this, 64, 56);
}
uq(rp, hq);
rp.prototype.init = function() {
  return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
};
rp.prototype._hash = function() {
  var t = dq.allocUnsafe(28);
  return t.writeInt32BE(this._a, 0), t.writeInt32BE(this._b, 4), t.writeInt32BE(this._c, 8), t.writeInt32BE(this._d, 12), t.writeInt32BE(this._e, 16), t.writeInt32BE(this._f, 20), t.writeInt32BE(this._g, 24), t;
};
var vq = rp, gq = It.exports, W7 = qc, bq = Ft.exports.Buffer, l4 = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
], yq = new Array(160);
function kh() {
  this.init(), this._w = yq, W7.call(this, 128, 112);
}
gq(kh, W7);
kh.prototype.init = function() {
  return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
};
function d4(t, e, r) {
  return r ^ t & (e ^ r);
}
function p4(t, e, r) {
  return t & e | r & (t | e);
}
function v4(t, e) {
  return (t >>> 28 | e << 4) ^ (e >>> 2 | t << 30) ^ (e >>> 7 | t << 25);
}
function g4(t, e) {
  return (t >>> 14 | e << 18) ^ (t >>> 18 | e << 14) ^ (e >>> 9 | t << 23);
}
function mq(t, e) {
  return (t >>> 1 | e << 31) ^ (t >>> 8 | e << 24) ^ t >>> 7;
}
function wq(t, e) {
  return (t >>> 1 | e << 31) ^ (t >>> 8 | e << 24) ^ (t >>> 7 | e << 25);
}
function _q(t, e) {
  return (t >>> 19 | e << 13) ^ (e >>> 29 | t << 3) ^ t >>> 6;
}
function Mq(t, e) {
  return (t >>> 19 | e << 13) ^ (e >>> 29 | t << 3) ^ (t >>> 6 | e << 26);
}
function li(t, e) {
  return t >>> 0 < e >>> 0 ? 1 : 0;
}
kh.prototype._update = function(t) {
  for (var e = this._w, r = this._ah | 0, i = this._bh | 0, s = this._ch | 0, n = this._dh | 0, f = this._eh | 0, u = this._fh | 0, h = this._gh | 0, d = this._hh | 0, l = this._al | 0, m = this._bl | 0, b = this._cl | 0, M = this._dl | 0, A = this._el | 0, N = this._fl | 0, R = this._gl | 0, O = this._hl | 0, P = 0; P < 32; P += 2)
    e[P] = t.readInt32BE(P * 4), e[P + 1] = t.readInt32BE(P * 4 + 4);
  for (; P < 160; P += 2) {
    var F = e[P - 30], H = e[P - 15 * 2 + 1], Q = mq(F, H), Z = wq(H, F);
    F = e[P - 2 * 2], H = e[P - 2 * 2 + 1];
    var B = _q(F, H), Y = Mq(H, F), ae = e[P - 7 * 2], se = e[P - 7 * 2 + 1], W = e[P - 16 * 2], C = e[P - 16 * 2 + 1], g = Z + se | 0, a = Q + ae + li(g, Z) | 0;
    g = g + Y | 0, a = a + B + li(g, Y) | 0, g = g + C | 0, a = a + W + li(g, C) | 0, e[P] = a, e[P + 1] = g;
  }
  for (var c = 0; c < 160; c += 2) {
    a = e[c], g = e[c + 1];
    var p = p4(r, i, s), w = p4(l, m, b), _ = v4(r, l), x = v4(l, r), E = g4(f, A), y = g4(A, f), o = l4[c], S = l4[c + 1], J = d4(f, u, h), z = d4(A, N, R), k = O + y | 0, j = d + E + li(k, O) | 0;
    k = k + z | 0, j = j + J + li(k, z) | 0, k = k + S | 0, j = j + o + li(k, S) | 0, k = k + g | 0, j = j + a + li(k, g) | 0;
    var q = x + w | 0, K = _ + p + li(q, x) | 0;
    d = h, O = R, h = u, R = N, u = f, N = A, A = M + k | 0, f = n + j + li(A, M) | 0, n = s, M = b, s = i, b = m, i = r, m = l, l = k + q | 0, r = j + K + li(l, k) | 0;
  }
  this._al = this._al + l | 0, this._bl = this._bl + m | 0, this._cl = this._cl + b | 0, this._dl = this._dl + M | 0, this._el = this._el + A | 0, this._fl = this._fl + N | 0, this._gl = this._gl + R | 0, this._hl = this._hl + O | 0, this._ah = this._ah + r + li(this._al, l) | 0, this._bh = this._bh + i + li(this._bl, m) | 0, this._ch = this._ch + s + li(this._cl, b) | 0, this._dh = this._dh + n + li(this._dl, M) | 0, this._eh = this._eh + f + li(this._el, A) | 0, this._fh = this._fh + u + li(this._fl, N) | 0, this._gh = this._gh + h + li(this._gl, R) | 0, this._hh = this._hh + d + li(this._hl, O) | 0;
};
kh.prototype._hash = function() {
  var t = bq.allocUnsafe(64);
  function e(r, i, s) {
    t.writeInt32BE(r, s), t.writeInt32BE(i, s + 4);
  }
  return e(this._ah, this._al, 0), e(this._bh, this._bl, 8), e(this._ch, this._cl, 16), e(this._dh, this._dl, 24), e(this._eh, this._el, 32), e(this._fh, this._fl, 40), e(this._gh, this._gl, 48), e(this._hh, this._hl, 56), t;
};
var V7 = kh, xq = It.exports, Sq = V7, Eq = qc, Iq = Ft.exports.Buffer, Aq = new Array(160);
function ip() {
  this.init(), this._w = Aq, Eq.call(this, 128, 112);
}
xq(ip, Sq);
ip.prototype.init = function() {
  return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
};
ip.prototype._hash = function() {
  var t = Iq.allocUnsafe(48);
  function e(r, i, s) {
    t.writeInt32BE(r, s), t.writeInt32BE(i, s + 4);
  }
  return e(this._ah, this._al, 0), e(this._bh, this._bl, 8), e(this._ch, this._cl, 16), e(this._dh, this._dl, 24), e(this._eh, this._el, 32), e(this._fh, this._fl, 40), t;
};
var Tq = ip, gf = Oh.exports = function(e) {
  e = e.toLowerCase();
  var r = gf[e];
  if (!r)
    throw new Error(e + " is not supported (we accept pull requests)");
  return new r();
};
gf.sha = H$;
gf.sha1 = X$;
gf.sha224 = vq;
gf.sha256 = H7;
gf.sha384 = Tq;
gf.sha512 = V7;
var xt = {}, Nq = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, r = Symbol("test"), i = Object(r);
  if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(i) !== "[object Symbol]")
    return !1;
  var s = 42;
  e[r] = s;
  for (r in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var n = Object.getOwnPropertySymbols(e);
  if (n.length !== 1 || n[0] !== r || !Object.prototype.propertyIsEnumerable.call(e, r))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var f = Object.getOwnPropertyDescriptor(e, r);
    if (f.value !== s || f.enumerable !== !0)
      return !1;
  }
  return !0;
}, b4 = typeof Symbol < "u" && Symbol, Dq = Nq, Cq = function() {
  return typeof b4 != "function" || typeof Symbol != "function" || typeof b4("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : Dq();
}, Oq = "Function.prototype.bind called on incompatible ", Ev = Array.prototype.slice, Rq = Object.prototype.toString, Lq = "[object Function]", Pq = function(e) {
  var r = this;
  if (typeof r != "function" || Rq.call(r) !== Lq)
    throw new TypeError(Oq + r);
  for (var i = Ev.call(arguments, 1), s, n = function() {
    if (this instanceof s) {
      var l = r.apply(
        this,
        i.concat(Ev.call(arguments))
      );
      return Object(l) === l ? l : this;
    } else
      return r.apply(
        e,
        i.concat(Ev.call(arguments))
      );
  }, f = Math.max(0, r.length - i.length), u = [], h = 0; h < f; h++)
    u.push("$" + h);
  if (s = Function("binder", "return function (" + u.join(",") + "){ return binder.apply(this,arguments); }")(n), r.prototype) {
    var d = function() {
    };
    d.prototype = r.prototype, s.prototype = new d(), d.prototype = null;
  }
  return s;
}, kq = Pq, v2 = Function.prototype.bind || kq, jq = v2, Bq = jq.call(Function.call, Object.prototype.hasOwnProperty), cr, ph = SyntaxError, G7 = Function, fc = TypeError, Iv = function(t) {
  try {
    return G7('"use strict"; return (' + t + ").constructor;")();
  } catch {
  }
}, ef = Object.getOwnPropertyDescriptor;
if (ef)
  try {
    ef({}, "");
  } catch {
    ef = null;
  }
var Av = function() {
  throw new fc();
}, zq = ef ? function() {
  try {
    return arguments.callee, Av;
  } catch {
    try {
      return ef(arguments, "callee").get;
    } catch {
      return Av;
    }
  }
}() : Av, Wf = Cq(), Za = Object.getPrototypeOf || function(t) {
  return t.__proto__;
}, Xf = {}, Uq = typeof Uint8Array > "u" ? cr : Za(Uint8Array), cc = {
  "%AggregateError%": typeof AggregateError > "u" ? cr : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? cr : ArrayBuffer,
  "%ArrayIteratorPrototype%": Wf ? Za([][Symbol.iterator]()) : cr,
  "%AsyncFromSyncIteratorPrototype%": cr,
  "%AsyncFunction%": Xf,
  "%AsyncGenerator%": Xf,
  "%AsyncGeneratorFunction%": Xf,
  "%AsyncIteratorPrototype%": Xf,
  "%Atomics%": typeof Atomics > "u" ? cr : Atomics,
  "%BigInt%": typeof BigInt > "u" ? cr : BigInt,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? cr : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? cr : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? cr : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? cr : FinalizationRegistry,
  "%Function%": G7,
  "%GeneratorFunction%": Xf,
  "%Int8Array%": typeof Int8Array > "u" ? cr : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? cr : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? cr : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": Wf ? Za(Za([][Symbol.iterator]())) : cr,
  "%JSON%": typeof JSON == "object" ? JSON : cr,
  "%Map%": typeof Map > "u" ? cr : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !Wf ? cr : Za((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? cr : Promise,
  "%Proxy%": typeof Proxy > "u" ? cr : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? cr : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? cr : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !Wf ? cr : Za((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? cr : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": Wf ? Za(""[Symbol.iterator]()) : cr,
  "%Symbol%": Wf ? Symbol : cr,
  "%SyntaxError%": ph,
  "%ThrowTypeError%": zq,
  "%TypedArray%": Uq,
  "%TypeError%": fc,
  "%Uint8Array%": typeof Uint8Array > "u" ? cr : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? cr : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? cr : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? cr : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? cr : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? cr : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? cr : WeakSet
}, Fq = function t(e) {
  var r;
  if (e === "%AsyncFunction%")
    r = Iv("async function () {}");
  else if (e === "%GeneratorFunction%")
    r = Iv("function* () {}");
  else if (e === "%AsyncGeneratorFunction%")
    r = Iv("async function* () {}");
  else if (e === "%AsyncGenerator%") {
    var i = t("%AsyncGeneratorFunction%");
    i && (r = i.prototype);
  } else if (e === "%AsyncIteratorPrototype%") {
    var s = t("%AsyncGenerator%");
    s && (r = Za(s.prototype));
  }
  return cc[e] = r, r;
}, y4 = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, np = v2, p0 = Bq, $q = np.call(Function.call, Array.prototype.concat), qq = np.call(Function.apply, Array.prototype.splice), m4 = np.call(Function.call, String.prototype.replace), v0 = np.call(Function.call, String.prototype.slice), Hq = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Wq = /\\(\\)?/g, Vq = function(e) {
  var r = v0(e, 0, 1), i = v0(e, -1);
  if (r === "%" && i !== "%")
    throw new ph("invalid intrinsic syntax, expected closing `%`");
  if (i === "%" && r !== "%")
    throw new ph("invalid intrinsic syntax, expected opening `%`");
  var s = [];
  return m4(e, Hq, function(n, f, u, h) {
    s[s.length] = u ? m4(h, Wq, "$1") : f || n;
  }), s;
}, Gq = function(e, r) {
  var i = e, s;
  if (p0(y4, i) && (s = y4[i], i = "%" + s[0] + "%"), p0(cc, i)) {
    var n = cc[i];
    if (n === Xf && (n = Fq(i)), typeof n > "u" && !r)
      throw new fc("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: s,
      name: i,
      value: n
    };
  }
  throw new ph("intrinsic " + e + " does not exist!");
}, sp = function(e, r) {
  if (typeof e != "string" || e.length === 0)
    throw new fc("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof r != "boolean")
    throw new fc('"allowMissing" argument must be a boolean');
  var i = Vq(e), s = i.length > 0 ? i[0] : "", n = Gq("%" + s + "%", r), f = n.name, u = n.value, h = !1, d = n.alias;
  d && (s = d[0], qq(i, $q([0, 1], d)));
  for (var l = 1, m = !0; l < i.length; l += 1) {
    var b = i[l], M = v0(b, 0, 1), A = v0(b, -1);
    if ((M === '"' || M === "'" || M === "`" || A === '"' || A === "'" || A === "`") && M !== A)
      throw new ph("property names with quotes must have matching quotes");
    if ((b === "constructor" || !m) && (h = !0), s += "." + b, f = "%" + s + "%", p0(cc, f))
      u = cc[f];
    else if (u != null) {
      if (!(b in u)) {
        if (!r)
          throw new fc("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if (ef && l + 1 >= i.length) {
        var N = ef(u, b);
        m = !!N, m && "get" in N && !("originalValue" in N.get) ? u = N.get : u = u[b];
      } else
        m = p0(u, b), u = u[b];
      m && !h && (cc[f] = u);
    }
  }
  return u;
}, K7 = { exports: {} };
(function(t) {
  var e = v2, r = sp, i = r("%Function.prototype.apply%"), s = r("%Function.prototype.call%"), n = r("%Reflect.apply%", !0) || e.call(s, i), f = r("%Object.getOwnPropertyDescriptor%", !0), u = r("%Object.defineProperty%", !0), h = r("%Math.max%");
  if (u)
    try {
      u({}, "a", { value: 1 });
    } catch {
      u = null;
    }
  t.exports = function(m) {
    var b = n(e, s, arguments);
    if (f && u) {
      var M = f(b, "length");
      M.configurable && u(
        b,
        "length",
        { value: 1 + h(0, m.length - (arguments.length - 1)) }
      );
    }
    return b;
  };
  var d = function() {
    return n(e, i, arguments);
  };
  u ? u(t.exports, "apply", { value: d }) : t.exports.apply = d;
})(K7);
var Y7 = sp, Q7 = K7.exports, Kq = Q7(Y7("String.prototype.indexOf")), jh = function(e, r) {
  var i = Y7(e, !!r);
  return typeof i == "function" && Kq(e, ".prototype.") > -1 ? Q7(i) : i;
}, g2 = typeof Map == "function" && Map.prototype, Tv = Object.getOwnPropertyDescriptor && g2 ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, g0 = g2 && Tv && typeof Tv.get == "function" ? Tv.get : null, Yq = g2 && Map.prototype.forEach, b2 = typeof Set == "function" && Set.prototype, Nv = Object.getOwnPropertyDescriptor && b2 ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, b0 = b2 && Nv && typeof Nv.get == "function" ? Nv.get : null, Qq = b2 && Set.prototype.forEach, Zq = typeof WeakMap == "function" && WeakMap.prototype, Ju = Zq ? WeakMap.prototype.has : null, Jq = typeof WeakSet == "function" && WeakSet.prototype, Xu = Jq ? WeakSet.prototype.has : null, Xq = typeof WeakRef == "function" && WeakRef.prototype, w4 = Xq ? WeakRef.prototype.deref : null, eH = Boolean.prototype.valueOf, tH = Object.prototype.toString, rH = Function.prototype.toString, iH = String.prototype.match, cm = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, Dv = Object.getOwnPropertySymbols, um = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, Mc = typeof Symbol == "function" && typeof Symbol.iterator == "object", zi = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === Mc ? "object" : "symbol") ? Symbol.toStringTag : null, nH = Object.prototype.propertyIsEnumerable, _4 = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(t) {
  return t.__proto__;
} : null), Cv = dn.custom, Ov = Cv && J7(Cv) ? Cv : null, sH = function t(e, r, i, s) {
  var n = r || {};
  if (qo(n, "quoteStyle") && n.quoteStyle !== "single" && n.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (qo(n, "maxStringLength") && (typeof n.maxStringLength == "number" ? n.maxStringLength < 0 && n.maxStringLength !== 1 / 0 : n.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var f = qo(n, "customInspect") ? n.customInspect : !0;
  if (typeof f != "boolean" && f !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (qo(n, "indent") && n.indent !== null && n.indent !== "	" && !(parseInt(n.indent, 10) === n.indent && n.indent > 0))
    throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
  if (typeof e > "u")
    return "undefined";
  if (e === null)
    return "null";
  if (typeof e == "boolean")
    return e ? "true" : "false";
  if (typeof e == "string")
    return e9(e, n);
  if (typeof e == "number")
    return e === 0 ? 1 / 0 / e > 0 ? "0" : "-0" : String(e);
  if (typeof e == "bigint")
    return String(e) + "n";
  var u = typeof n.depth > "u" ? 5 : n.depth;
  if (typeof i > "u" && (i = 0), i >= u && u > 0 && typeof e == "object")
    return hm(e) ? "[Array]" : "[Object]";
  var h = SH(n, i);
  if (typeof s > "u")
    s = [];
  else if (X7(s, e) >= 0)
    return "[Circular]";
  function d(se, W, C) {
    if (W && (s = s.slice(), s.push(W)), C) {
      var g = {
        depth: n.depth
      };
      return qo(n, "quoteStyle") && (g.quoteStyle = n.quoteStyle), t(se, g, i + 1, s);
    }
    return t(se, n, i + 1, s);
  }
  if (typeof e == "function") {
    var l = vH(e), m = gd(e, d);
    return "[Function" + (l ? ": " + l : " (anonymous)") + "]" + (m.length > 0 ? " { " + m.join(", ") + " }" : "");
  }
  if (J7(e)) {
    var b = Mc ? String(e).replace(/^(Symbol\(.*\))_[^)]*$/, "$1") : um.call(e);
    return typeof e == "object" && !Mc ? Nu(b) : b;
  }
  if (_H(e)) {
    for (var M = "<" + String(e.nodeName).toLowerCase(), A = e.attributes || [], N = 0; N < A.length; N++)
      M += " " + A[N].name + "=" + Z7(aH(A[N].value), "double", n);
    return M += ">", e.childNodes && e.childNodes.length && (M += "..."), M += "</" + String(e.nodeName).toLowerCase() + ">", M;
  }
  if (hm(e)) {
    if (e.length === 0)
      return "[]";
    var R = gd(e, d);
    return h && !xH(R) ? "[" + lm(R, h) + "]" : "[ " + R.join(", ") + " ]";
  }
  if (cH(e)) {
    var O = gd(e, d);
    return O.length === 0 ? "[" + String(e) + "]" : "{ [" + String(e) + "] " + O.join(", ") + " }";
  }
  if (typeof e == "object" && f) {
    if (Ov && typeof e[Ov] == "function")
      return e[Ov]();
    if (f !== "symbol" && typeof e.inspect == "function")
      return e.inspect();
  }
  if (gH(e)) {
    var P = [];
    return Yq.call(e, function(se, W) {
      P.push(d(W, e, !0) + " => " + d(se, e));
    }), M4("Map", g0.call(e), P, h);
  }
  if (mH(e)) {
    var F = [];
    return Qq.call(e, function(se) {
      F.push(d(se, e));
    }), M4("Set", b0.call(e), F, h);
  }
  if (bH(e))
    return Rv("WeakMap");
  if (wH(e))
    return Rv("WeakSet");
  if (yH(e))
    return Rv("WeakRef");
  if (hH(e))
    return Nu(d(Number(e)));
  if (dH(e))
    return Nu(d(cm.call(e)));
  if (lH(e))
    return Nu(eH.call(e));
  if (uH(e))
    return Nu(d(String(e)));
  if (!oH(e) && !fH(e)) {
    var H = gd(e, d), Q = _4 ? _4(e) === Object.prototype : e instanceof Object || e.constructor === Object, Z = e instanceof Object ? "" : "null prototype", B = !Q && zi && Object(e) === e && zi in e ? vo(e).slice(8, -1) : Z ? "Object" : "", Y = Q || typeof e.constructor != "function" ? "" : e.constructor.name ? e.constructor.name + " " : "", ae = Y + (B || Z ? "[" + [].concat(B || [], Z || []).join(": ") + "] " : "");
    return H.length === 0 ? ae + "{}" : h ? ae + "{" + lm(H, h) + "}" : ae + "{ " + H.join(", ") + " }";
  }
  return String(e);
};
function Z7(t, e, r) {
  var i = (r.quoteStyle || e) === "double" ? '"' : "'";
  return i + t + i;
}
function aH(t) {
  return String(t).replace(/"/g, "&quot;");
}
function hm(t) {
  return vo(t) === "[object Array]" && (!zi || !(typeof t == "object" && zi in t));
}
function oH(t) {
  return vo(t) === "[object Date]" && (!zi || !(typeof t == "object" && zi in t));
}
function fH(t) {
  return vo(t) === "[object RegExp]" && (!zi || !(typeof t == "object" && zi in t));
}
function cH(t) {
  return vo(t) === "[object Error]" && (!zi || !(typeof t == "object" && zi in t));
}
function uH(t) {
  return vo(t) === "[object String]" && (!zi || !(typeof t == "object" && zi in t));
}
function hH(t) {
  return vo(t) === "[object Number]" && (!zi || !(typeof t == "object" && zi in t));
}
function lH(t) {
  return vo(t) === "[object Boolean]" && (!zi || !(typeof t == "object" && zi in t));
}
function J7(t) {
  if (Mc)
    return t && typeof t == "object" && t instanceof Symbol;
  if (typeof t == "symbol")
    return !0;
  if (!t || typeof t != "object" || !um)
    return !1;
  try {
    return um.call(t), !0;
  } catch {
  }
  return !1;
}
function dH(t) {
  if (!t || typeof t != "object" || !cm)
    return !1;
  try {
    return cm.call(t), !0;
  } catch {
  }
  return !1;
}
var pH = Object.prototype.hasOwnProperty || function(t) {
  return t in this;
};
function qo(t, e) {
  return pH.call(t, e);
}
function vo(t) {
  return tH.call(t);
}
function vH(t) {
  if (t.name)
    return t.name;
  var e = iH.call(rH.call(t), /^function\s*([\w$]+)/);
  return e ? e[1] : null;
}
function X7(t, e) {
  if (t.indexOf)
    return t.indexOf(e);
  for (var r = 0, i = t.length; r < i; r++)
    if (t[r] === e)
      return r;
  return -1;
}
function gH(t) {
  if (!g0 || !t || typeof t != "object")
    return !1;
  try {
    g0.call(t);
    try {
      b0.call(t);
    } catch {
      return !0;
    }
    return t instanceof Map;
  } catch {
  }
  return !1;
}
function bH(t) {
  if (!Ju || !t || typeof t != "object")
    return !1;
  try {
    Ju.call(t, Ju);
    try {
      Xu.call(t, Xu);
    } catch {
      return !0;
    }
    return t instanceof WeakMap;
  } catch {
  }
  return !1;
}
function yH(t) {
  if (!w4 || !t || typeof t != "object")
    return !1;
  try {
    return w4.call(t), !0;
  } catch {
  }
  return !1;
}
function mH(t) {
  if (!b0 || !t || typeof t != "object")
    return !1;
  try {
    b0.call(t);
    try {
      g0.call(t);
    } catch {
      return !0;
    }
    return t instanceof Set;
  } catch {
  }
  return !1;
}
function wH(t) {
  if (!Xu || !t || typeof t != "object")
    return !1;
  try {
    Xu.call(t, Xu);
    try {
      Ju.call(t, Ju);
    } catch {
      return !0;
    }
    return t instanceof WeakSet;
  } catch {
  }
  return !1;
}
function _H(t) {
  return !t || typeof t != "object" ? !1 : typeof HTMLElement < "u" && t instanceof HTMLElement ? !0 : typeof t.nodeName == "string" && typeof t.getAttribute == "function";
}
function e9(t, e) {
  if (t.length > e.maxStringLength) {
    var r = t.length - e.maxStringLength, i = "... " + r + " more character" + (r > 1 ? "s" : "");
    return e9(t.slice(0, e.maxStringLength), e) + i;
  }
  var s = t.replace(/(['\\])/g, "\\$1").replace(/[\x00-\x1f]/g, MH);
  return Z7(s, "single", e);
}
function MH(t) {
  var e = t.charCodeAt(0), r = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[e];
  return r ? "\\" + r : "\\x" + (e < 16 ? "0" : "") + e.toString(16).toUpperCase();
}
function Nu(t) {
  return "Object(" + t + ")";
}
function Rv(t) {
  return t + " { ? }";
}
function M4(t, e, r, i) {
  var s = i ? lm(r, i) : r.join(", ");
  return t + " (" + e + ") {" + s + "}";
}
function xH(t) {
  for (var e = 0; e < t.length; e++)
    if (X7(t[e], `
`) >= 0)
      return !1;
  return !0;
}
function SH(t, e) {
  var r;
  if (t.indent === "	")
    r = "	";
  else if (typeof t.indent == "number" && t.indent > 0)
    r = Array(t.indent + 1).join(" ");
  else
    return null;
  return {
    base: r,
    prev: Array(e + 1).join(r)
  };
}
function lm(t, e) {
  if (t.length === 0)
    return "";
  var r = `
` + e.prev + e.base;
  return r + t.join("," + r) + `
` + e.prev;
}
function gd(t, e) {
  var r = hm(t), i = [];
  if (r) {
    i.length = t.length;
    for (var s = 0; s < t.length; s++)
      i[s] = qo(t, s) ? e(t[s], t) : "";
  }
  var n = typeof Dv == "function" ? Dv(t) : [], f;
  if (Mc) {
    f = {};
    for (var u = 0; u < n.length; u++)
      f["$" + n[u]] = n[u];
  }
  for (var h in t)
    !qo(t, h) || r && String(Number(h)) === h && h < t.length || Mc && f["$" + h] instanceof Symbol || (/[^\w$]/.test(h) ? i.push(e(h, t) + ": " + e(t[h], t)) : i.push(h + ": " + e(t[h], t)));
  if (typeof Dv == "function")
    for (var d = 0; d < n.length; d++)
      nH.call(t, n[d]) && i.push("[" + e(n[d]) + "]: " + e(t[n[d]], t));
  return i;
}
var y2 = sp, Hc = jh, EH = sH, IH = y2("%TypeError%"), bd = y2("%WeakMap%", !0), yd = y2("%Map%", !0), AH = Hc("WeakMap.prototype.get", !0), TH = Hc("WeakMap.prototype.set", !0), NH = Hc("WeakMap.prototype.has", !0), DH = Hc("Map.prototype.get", !0), CH = Hc("Map.prototype.set", !0), OH = Hc("Map.prototype.has", !0), m2 = function(t, e) {
  for (var r = t, i; (i = r.next) !== null; r = i)
    if (i.key === e)
      return r.next = i.next, i.next = t.next, t.next = i, i;
}, RH = function(t, e) {
  var r = m2(t, e);
  return r && r.value;
}, LH = function(t, e, r) {
  var i = m2(t, e);
  i ? i.value = r : t.next = {
    key: e,
    next: t.next,
    value: r
  };
}, PH = function(t, e) {
  return !!m2(t, e);
}, kH = function() {
  var e, r, i, s = {
    assert: function(n) {
      if (!s.has(n))
        throw new IH("Side channel does not contain " + EH(n));
    },
    get: function(n) {
      if (bd && n && (typeof n == "object" || typeof n == "function")) {
        if (e)
          return AH(e, n);
      } else if (yd) {
        if (r)
          return DH(r, n);
      } else if (i)
        return RH(i, n);
    },
    has: function(n) {
      if (bd && n && (typeof n == "object" || typeof n == "function")) {
        if (e)
          return NH(e, n);
      } else if (yd) {
        if (r)
          return OH(r, n);
      } else if (i)
        return PH(i, n);
      return !1;
    },
    set: function(n, f) {
      bd && n && (typeof n == "object" || typeof n == "function") ? (e || (e = new bd()), TH(e, n, f)) : yd ? (r || (r = new yd()), CH(r, n, f)) : (i || (i = { key: {}, next: null }), LH(i, n, f));
    }
  };
  return s;
}, jH = String.prototype.replace, BH = /%20/g, Lv = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, w2 = {
  default: Lv.RFC3986,
  formatters: {
    RFC1738: function(t) {
      return jH.call(t, BH, "+");
    },
    RFC3986: function(t) {
      return String(t);
    }
  },
  RFC1738: Lv.RFC1738,
  RFC3986: Lv.RFC3986
}, zH = w2, Pv = Object.prototype.hasOwnProperty, Ho = Array.isArray, Bs = function() {
  for (var t = [], e = 0; e < 256; ++e)
    t.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
  return t;
}(), UH = function(e) {
  for (; e.length > 1; ) {
    var r = e.pop(), i = r.obj[r.prop];
    if (Ho(i)) {
      for (var s = [], n = 0; n < i.length; ++n)
        typeof i[n] < "u" && s.push(i[n]);
      r.obj[r.prop] = s;
    }
  }
}, t9 = function(e, r) {
  for (var i = r && r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, s = 0; s < e.length; ++s)
    typeof e[s] < "u" && (i[s] = e[s]);
  return i;
}, FH = function t(e, r, i) {
  if (!r)
    return e;
  if (typeof r != "object") {
    if (Ho(e))
      e.push(r);
    else if (e && typeof e == "object")
      (i && (i.plainObjects || i.allowPrototypes) || !Pv.call(Object.prototype, r)) && (e[r] = !0);
    else
      return [e, r];
    return e;
  }
  if (!e || typeof e != "object")
    return [e].concat(r);
  var s = e;
  return Ho(e) && !Ho(r) && (s = t9(e, i)), Ho(e) && Ho(r) ? (r.forEach(function(n, f) {
    if (Pv.call(e, f)) {
      var u = e[f];
      u && typeof u == "object" && n && typeof n == "object" ? e[f] = t(u, n, i) : e.push(n);
    } else
      e[f] = n;
  }), e) : Object.keys(r).reduce(function(n, f) {
    var u = r[f];
    return Pv.call(n, f) ? n[f] = t(n[f], u, i) : n[f] = u, n;
  }, s);
}, $H = function(e, r) {
  return Object.keys(r).reduce(function(i, s) {
    return i[s] = r[s], i;
  }, e);
}, qH = function(t, e, r) {
  var i = t.replace(/\+/g, " ");
  if (r === "iso-8859-1")
    return i.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(i);
  } catch {
    return i;
  }
}, HH = function(e, r, i, s, n) {
  if (e.length === 0)
    return e;
  var f = e;
  if (typeof e == "symbol" ? f = Symbol.prototype.toString.call(e) : typeof e != "string" && (f = String(e)), i === "iso-8859-1")
    return escape(f).replace(/%u[0-9a-f]{4}/gi, function(l) {
      return "%26%23" + parseInt(l.slice(2), 16) + "%3B";
    });
  for (var u = "", h = 0; h < f.length; ++h) {
    var d = f.charCodeAt(h);
    if (d === 45 || d === 46 || d === 95 || d === 126 || d >= 48 && d <= 57 || d >= 65 && d <= 90 || d >= 97 && d <= 122 || n === zH.RFC1738 && (d === 40 || d === 41)) {
      u += f.charAt(h);
      continue;
    }
    if (d < 128) {
      u = u + Bs[d];
      continue;
    }
    if (d < 2048) {
      u = u + (Bs[192 | d >> 6] + Bs[128 | d & 63]);
      continue;
    }
    if (d < 55296 || d >= 57344) {
      u = u + (Bs[224 | d >> 12] + Bs[128 | d >> 6 & 63] + Bs[128 | d & 63]);
      continue;
    }
    h += 1, d = 65536 + ((d & 1023) << 10 | f.charCodeAt(h) & 1023), u += Bs[240 | d >> 18] + Bs[128 | d >> 12 & 63] + Bs[128 | d >> 6 & 63] + Bs[128 | d & 63];
  }
  return u;
}, WH = function(e) {
  for (var r = [{ obj: { o: e }, prop: "o" }], i = [], s = 0; s < r.length; ++s)
    for (var n = r[s], f = n.obj[n.prop], u = Object.keys(f), h = 0; h < u.length; ++h) {
      var d = u[h], l = f[d];
      typeof l == "object" && l !== null && i.indexOf(l) === -1 && (r.push({ obj: f, prop: d }), i.push(l));
    }
  return UH(r), e;
}, VH = function(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}, GH = function(e) {
  return !e || typeof e != "object" ? !1 : !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
}, KH = function(e, r) {
  return [].concat(e, r);
}, YH = function(e, r) {
  if (Ho(e)) {
    for (var i = [], s = 0; s < e.length; s += 1)
      i.push(r(e[s]));
    return i;
  }
  return r(e);
}, r9 = {
  arrayToObject: t9,
  assign: $H,
  combine: KH,
  compact: WH,
  decode: qH,
  encode: HH,
  isBuffer: GH,
  isRegExp: VH,
  maybeMap: YH,
  merge: FH
}, i9 = kH, dm = r9, eh = w2, QH = Object.prototype.hasOwnProperty, x4 = {
  brackets: function(e) {
    return e + "[]";
  },
  comma: "comma",
  indices: function(e, r) {
    return e + "[" + r + "]";
  },
  repeat: function(e) {
    return e;
  }
}, Qo = Array.isArray, ZH = String.prototype.split, JH = Array.prototype.push, n9 = function(t, e) {
  JH.apply(t, Qo(e) ? e : [e]);
}, XH = Date.prototype.toISOString, S4 = eh.default, Ei = {
  addQueryPrefix: !1,
  allowDots: !1,
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encoder: dm.encode,
  encodeValuesOnly: !1,
  format: S4,
  formatter: eh.formatters[S4],
  indices: !1,
  serializeDate: function(e) {
    return XH.call(e);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, eW = function(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "symbol" || typeof e == "bigint";
}, kv = {}, tW = function t(e, r, i, s, n, f, u, h, d, l, m, b, M, A, N) {
  for (var R = e, O = N, P = 0, F = !1; (O = O.get(kv)) !== void 0 && !F; ) {
    var H = O.get(e);
    if (P += 1, typeof H < "u") {
      if (H === P)
        throw new RangeError("Cyclic object value");
      F = !0;
    }
    typeof O.get(kv) > "u" && (P = 0);
  }
  if (typeof u == "function" ? R = u(r, R) : R instanceof Date ? R = l(R) : i === "comma" && Qo(R) && (R = dm.maybeMap(R, function(w) {
    return w instanceof Date ? l(w) : w;
  })), R === null) {
    if (s)
      return f && !M ? f(r, Ei.encoder, A, "key", m) : r;
    R = "";
  }
  if (eW(R) || dm.isBuffer(R)) {
    if (f) {
      var Q = M ? r : f(r, Ei.encoder, A, "key", m);
      if (i === "comma" && M) {
        for (var Z = ZH.call(String(R), ","), B = "", Y = 0; Y < Z.length; ++Y)
          B += (Y === 0 ? "" : ",") + b(f(Z[Y], Ei.encoder, A, "value", m));
        return [b(Q) + "=" + B];
      }
      return [b(Q) + "=" + b(f(R, Ei.encoder, A, "value", m))];
    }
    return [b(r) + "=" + b(String(R))];
  }
  var ae = [];
  if (typeof R > "u")
    return ae;
  var se;
  if (i === "comma" && Qo(R))
    se = [{ value: R.length > 0 ? R.join(",") || null : void 0 }];
  else if (Qo(u))
    se = u;
  else {
    var W = Object.keys(R);
    se = h ? W.sort(h) : W;
  }
  for (var C = 0; C < se.length; ++C) {
    var g = se[C], a = typeof g == "object" && typeof g.value < "u" ? g.value : R[g];
    if (!(n && a === null)) {
      var c = Qo(R) ? typeof i == "function" ? i(r, g) : r : r + (d ? "." + g : "[" + g + "]");
      N.set(e, P);
      var p = i9();
      p.set(kv, N), n9(ae, t(
        a,
        c,
        i,
        s,
        n,
        f,
        u,
        h,
        d,
        l,
        m,
        b,
        M,
        A,
        p
      ));
    }
  }
  return ae;
}, rW = function(e) {
  if (!e)
    return Ei;
  if (e.encoder !== null && typeof e.encoder < "u" && typeof e.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var r = e.charset || Ei.charset;
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var i = eh.default;
  if (typeof e.format < "u") {
    if (!QH.call(eh.formatters, e.format))
      throw new TypeError("Unknown format option provided.");
    i = e.format;
  }
  var s = eh.formatters[i], n = Ei.filter;
  return (typeof e.filter == "function" || Qo(e.filter)) && (n = e.filter), {
    addQueryPrefix: typeof e.addQueryPrefix == "boolean" ? e.addQueryPrefix : Ei.addQueryPrefix,
    allowDots: typeof e.allowDots > "u" ? Ei.allowDots : !!e.allowDots,
    charset: r,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : Ei.charsetSentinel,
    delimiter: typeof e.delimiter > "u" ? Ei.delimiter : e.delimiter,
    encode: typeof e.encode == "boolean" ? e.encode : Ei.encode,
    encoder: typeof e.encoder == "function" ? e.encoder : Ei.encoder,
    encodeValuesOnly: typeof e.encodeValuesOnly == "boolean" ? e.encodeValuesOnly : Ei.encodeValuesOnly,
    filter: n,
    format: i,
    formatter: s,
    serializeDate: typeof e.serializeDate == "function" ? e.serializeDate : Ei.serializeDate,
    skipNulls: typeof e.skipNulls == "boolean" ? e.skipNulls : Ei.skipNulls,
    sort: typeof e.sort == "function" ? e.sort : null,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : Ei.strictNullHandling
  };
}, iW = function(t, e) {
  var r = t, i = rW(e), s, n;
  typeof i.filter == "function" ? (n = i.filter, r = n("", r)) : Qo(i.filter) && (n = i.filter, s = n);
  var f = [];
  if (typeof r != "object" || r === null)
    return "";
  var u;
  e && e.arrayFormat in x4 ? u = e.arrayFormat : e && "indices" in e ? u = e.indices ? "indices" : "repeat" : u = "indices";
  var h = x4[u];
  s || (s = Object.keys(r)), i.sort && s.sort(i.sort);
  for (var d = i9(), l = 0; l < s.length; ++l) {
    var m = s[l];
    i.skipNulls && r[m] === null || n9(f, tW(
      r[m],
      m,
      h,
      i.strictNullHandling,
      i.skipNulls,
      i.encode ? i.encoder : null,
      i.filter,
      i.sort,
      i.allowDots,
      i.serializeDate,
      i.format,
      i.formatter,
      i.encodeValuesOnly,
      i.charset,
      d
    ));
  }
  var b = f.join(i.delimiter), M = i.addQueryPrefix === !0 ? "?" : "";
  return i.charsetSentinel && (i.charset === "iso-8859-1" ? M += "utf8=%26%2310003%3B&" : M += "utf8=%E2%9C%93&"), b.length > 0 ? M + b : "";
}, xc = r9, pm = Object.prototype.hasOwnProperty, nW = Array.isArray, gi = {
  allowDots: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decoder: xc.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, sW = function(t) {
  return t.replace(/&#(\d+);/g, function(e, r) {
    return String.fromCharCode(parseInt(r, 10));
  });
}, s9 = function(t, e) {
  return t && typeof t == "string" && e.comma && t.indexOf(",") > -1 ? t.split(",") : t;
}, aW = "utf8=%26%2310003%3B", oW = "utf8=%E2%9C%93", fW = function(e, r) {
  var i = {}, s = r.ignoreQueryPrefix ? e.replace(/^\?/, "") : e, n = r.parameterLimit === 1 / 0 ? void 0 : r.parameterLimit, f = s.split(r.delimiter, n), u = -1, h, d = r.charset;
  if (r.charsetSentinel)
    for (h = 0; h < f.length; ++h)
      f[h].indexOf("utf8=") === 0 && (f[h] === oW ? d = "utf-8" : f[h] === aW && (d = "iso-8859-1"), u = h, h = f.length);
  for (h = 0; h < f.length; ++h)
    if (h !== u) {
      var l = f[h], m = l.indexOf("]="), b = m === -1 ? l.indexOf("=") : m + 1, M, A;
      b === -1 ? (M = r.decoder(l, gi.decoder, d, "key"), A = r.strictNullHandling ? null : "") : (M = r.decoder(l.slice(0, b), gi.decoder, d, "key"), A = xc.maybeMap(
        s9(l.slice(b + 1), r),
        function(N) {
          return r.decoder(N, gi.decoder, d, "value");
        }
      )), A && r.interpretNumericEntities && d === "iso-8859-1" && (A = sW(A)), l.indexOf("[]=") > -1 && (A = nW(A) ? [A] : A), pm.call(i, M) ? i[M] = xc.combine(i[M], A) : i[M] = A;
    }
  return i;
}, cW = function(t, e, r, i) {
  for (var s = i ? e : s9(e, r), n = t.length - 1; n >= 0; --n) {
    var f, u = t[n];
    if (u === "[]" && r.parseArrays)
      f = [].concat(s);
    else {
      f = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var h = u.charAt(0) === "[" && u.charAt(u.length - 1) === "]" ? u.slice(1, -1) : u, d = parseInt(h, 10);
      !r.parseArrays && h === "" ? f = { 0: s } : !isNaN(d) && u !== h && String(d) === h && d >= 0 && r.parseArrays && d <= r.arrayLimit ? (f = [], f[d] = s) : h !== "__proto__" && (f[h] = s);
    }
    s = f;
  }
  return s;
}, uW = function(e, r, i, s) {
  if (!!e) {
    var n = i.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e, f = /(\[[^[\]]*])/, u = /(\[[^[\]]*])/g, h = i.depth > 0 && f.exec(n), d = h ? n.slice(0, h.index) : n, l = [];
    if (d) {
      if (!i.plainObjects && pm.call(Object.prototype, d) && !i.allowPrototypes)
        return;
      l.push(d);
    }
    for (var m = 0; i.depth > 0 && (h = u.exec(n)) !== null && m < i.depth; ) {
      if (m += 1, !i.plainObjects && pm.call(Object.prototype, h[1].slice(1, -1)) && !i.allowPrototypes)
        return;
      l.push(h[1]);
    }
    return h && l.push("[" + n.slice(h.index) + "]"), cW(l, r, i, s);
  }
}, hW = function(e) {
  if (!e)
    return gi;
  if (e.decoder !== null && e.decoder !== void 0 && typeof e.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var r = typeof e.charset > "u" ? gi.charset : e.charset;
  return {
    allowDots: typeof e.allowDots > "u" ? gi.allowDots : !!e.allowDots,
    allowPrototypes: typeof e.allowPrototypes == "boolean" ? e.allowPrototypes : gi.allowPrototypes,
    allowSparse: typeof e.allowSparse == "boolean" ? e.allowSparse : gi.allowSparse,
    arrayLimit: typeof e.arrayLimit == "number" ? e.arrayLimit : gi.arrayLimit,
    charset: r,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : gi.charsetSentinel,
    comma: typeof e.comma == "boolean" ? e.comma : gi.comma,
    decoder: typeof e.decoder == "function" ? e.decoder : gi.decoder,
    delimiter: typeof e.delimiter == "string" || xc.isRegExp(e.delimiter) ? e.delimiter : gi.delimiter,
    depth: typeof e.depth == "number" || e.depth === !1 ? +e.depth : gi.depth,
    ignoreQueryPrefix: e.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof e.interpretNumericEntities == "boolean" ? e.interpretNumericEntities : gi.interpretNumericEntities,
    parameterLimit: typeof e.parameterLimit == "number" ? e.parameterLimit : gi.parameterLimit,
    parseArrays: e.parseArrays !== !1,
    plainObjects: typeof e.plainObjects == "boolean" ? e.plainObjects : gi.plainObjects,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : gi.strictNullHandling
  };
}, lW = function(t, e) {
  var r = hW(e);
  if (t === "" || t === null || typeof t > "u")
    return r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var i = typeof t == "string" ? fW(t, r) : t, s = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, n = Object.keys(i), f = 0; f < n.length; ++f) {
    var u = n[f], h = uW(u, i[u], r, typeof t == "string");
    s = xc.merge(s, h, r);
  }
  return r.allowSparse === !0 ? s : xc.compact(s);
}, dW = iW, pW = lW, vW = w2, gW = {
  formats: vW,
  parse: pW,
  stringify: dW
}, Bh = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.ProviderType = t.RegExpString = t.IntNumber = t.BigIntString = t.AddressString = t.HexString = t.OpaqueType = void 0;
  function e() {
    return (i) => i;
  }
  t.OpaqueType = e, t.HexString = e(), t.AddressString = e(), t.BigIntString = e();
  function r(i) {
    return Math.floor(i);
  }
  t.IntNumber = r, t.RegExpString = e(), function(i) {
    i.CoinbaseWallet = "CoinbaseWallet", i.MetaMask = "MetaMask", i.Unselected = "";
  }(t.ProviderType || (t.ProviderType = {}));
})(Bh);
var bW = nt && nt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(xt, "__esModule", { value: !0 });
xt.isInIFrame = xt.createQrUrl = xt.getFavicon = xt.range = xt.isBigNumber = xt.ensureParsedJSONObject = xt.ensureBN = xt.ensureRegExpString = xt.ensureIntNumber = xt.ensureBuffer = xt.ensureAddressString = xt.ensureEvenLengthHexString = xt.ensureHexString = xt.isHexString = xt.prepend0x = xt.strip0x = xt.has0xPrefix = xt.hexStringFromIntNumber = xt.intNumberFromHexString = xt.bigIntStringFromBN = xt.hexStringFromBuffer = xt.hexStringToUint8Array = xt.uint8ArrayToHex = xt.randomBytesHex = void 0;
const to = bW(Ih.exports), yW = gW, ts = Bh, a9 = /^[0-9]*$/, o9 = /^[a-f0-9]*$/;
function mW(t) {
  return f9(crypto.getRandomValues(new Uint8Array(t)));
}
xt.randomBytesHex = mW;
function f9(t) {
  return [...t].map((e) => e.toString(16).padStart(2, "0")).join("");
}
xt.uint8ArrayToHex = f9;
function wW(t) {
  return new Uint8Array(t.match(/.{1,2}/g).map((e) => parseInt(e, 16)));
}
xt.hexStringToUint8Array = wW;
function _W(t, e = !1) {
  const r = t.toString("hex");
  return (0, ts.HexString)(e ? "0x" + r : r);
}
xt.hexStringFromBuffer = _W;
function MW(t) {
  return (0, ts.BigIntString)(t.toString(10));
}
xt.bigIntStringFromBN = MW;
function xW(t) {
  return (0, ts.IntNumber)(new to.default(Uh(t, !1), 16).toNumber());
}
xt.intNumberFromHexString = xW;
function SW(t) {
  return (0, ts.HexString)("0x" + new to.default(t).toString(16));
}
xt.hexStringFromIntNumber = SW;
function _2(t) {
  return t.startsWith("0x") || t.startsWith("0X");
}
xt.has0xPrefix = _2;
function ap(t) {
  return _2(t) ? t.slice(2) : t;
}
xt.strip0x = ap;
function c9(t) {
  return _2(t) ? "0x" + t.slice(2) : "0x" + t;
}
xt.prepend0x = c9;
function zh(t) {
  if (typeof t != "string")
    return !1;
  const e = ap(t).toLowerCase();
  return o9.test(e);
}
xt.isHexString = zh;
function u9(t, e = !1) {
  if (typeof t == "string") {
    const r = ap(t).toLowerCase();
    if (o9.test(r))
      return (0, ts.HexString)(e ? "0x" + r : r);
  }
  throw new Error(`"${String(t)}" is not a hexadecimal string`);
}
xt.ensureHexString = u9;
function Uh(t, e = !1) {
  let r = u9(t, !1);
  return r.length % 2 === 1 && (r = (0, ts.HexString)("0" + r)), e ? (0, ts.HexString)("0x" + r) : r;
}
xt.ensureEvenLengthHexString = Uh;
function EW(t) {
  if (typeof t == "string") {
    const e = ap(t).toLowerCase();
    if (zh(e) && e.length === 40)
      return (0, ts.AddressString)(c9(e));
  }
  throw new Error(`Invalid Ethereum address: ${String(t)}`);
}
xt.ensureAddressString = EW;
function IW(t) {
  if (Buffer.isBuffer(t))
    return t;
  if (typeof t == "string")
    if (zh(t)) {
      const e = Uh(t, !1);
      return Buffer.from(e, "hex");
    } else
      return Buffer.from(t, "utf8");
  throw new Error(`Not binary data: ${String(t)}`);
}
xt.ensureBuffer = IW;
function h9(t) {
  if (typeof t == "number" && Number.isInteger(t))
    return (0, ts.IntNumber)(t);
  if (typeof t == "string") {
    if (a9.test(t))
      return (0, ts.IntNumber)(Number(t));
    if (zh(t))
      return (0, ts.IntNumber)(new to.default(Uh(t, !1), 16).toNumber());
  }
  throw new Error(`Not an integer: ${String(t)}`);
}
xt.ensureIntNumber = h9;
function AW(t) {
  if (t instanceof RegExp)
    return (0, ts.RegExpString)(t.toString());
  throw new Error(`Not a RegExp: ${String(t)}`);
}
xt.ensureRegExpString = AW;
function TW(t) {
  if (t !== null && (to.default.isBN(t) || l9(t)))
    return new to.default(t.toString(10), 10);
  if (typeof t == "number")
    return new to.default(h9(t));
  if (typeof t == "string") {
    if (a9.test(t))
      return new to.default(t, 10);
    if (zh(t))
      return new to.default(Uh(t, !1), 16);
  }
  throw new Error(`Not an integer: ${String(t)}`);
}
xt.ensureBN = TW;
function NW(t) {
  if (typeof t == "string")
    return JSON.parse(t);
  if (typeof t == "object")
    return t;
  throw new Error(`Not a JSON string or an object: ${String(t)}`);
}
xt.ensureParsedJSONObject = NW;
function l9(t) {
  if (t == null || typeof t.constructor != "function")
    return !1;
  const { constructor: e } = t;
  return typeof e.config == "function" && typeof e.EUCLID == "number";
}
xt.isBigNumber = l9;
function DW(t, e) {
  return Array.from({ length: e - t }, (r, i) => t + i);
}
xt.range = DW;
function CW() {
  const t = document.querySelector('link[sizes="192x192"]') || document.querySelector('link[sizes="180x180"]') || document.querySelector('link[rel="icon"]') || document.querySelector('link[rel="shortcut icon"]'), { protocol: e, host: r } = document.location, i = t ? t.getAttribute("href") : null;
  return !i || i.startsWith("javascript:") ? null : i.startsWith("http://") || i.startsWith("https://") || i.startsWith("data:") ? i : i.startsWith("//") ? e + i : `${e}//${r}${i}`;
}
xt.getFavicon = CW;
function OW(t, e, r, i, s, n) {
  const f = i ? "parent-id" : "id", u = (0, yW.stringify)({
    [f]: t,
    secret: e,
    server: r,
    v: s,
    chainId: n
  });
  return `${r}/#/link?${u}`;
}
xt.createQrUrl = OW;
function RW() {
  try {
    return window.frameElement !== null;
  } catch {
    return !1;
  }
}
xt.isInIFrame = RW;
Object.defineProperty(Bc, "__esModule", { value: !0 });
Bc.Session = void 0;
const LW = $c, E4 = X0, I4 = Oh.exports, A4 = xt, jv = "session:id", T4 = "session:secret", N4 = "session:linked";
class M2 {
  constructor(e, r, i, s) {
    this._storage = e, this._id = r || (0, A4.randomBytesHex)(16), this._secret = i || (0, A4.randomBytesHex)(32), this._key = new I4.sha256().update(`${this._id}, ${this._secret} WalletLink`).digest("hex"), this._linked = !!s;
  }
  static load(e) {
    const r = e.getItem(jv), i = e.getItem(N4), s = e.getItem(T4);
    return r && s ? new M2(e, r, s, i === "1") : null;
  }
  static get persistedSessionIdChange$() {
    return (0, LW.fromEvent)(window, "storage").pipe((0, E4.filter)((e) => e.key === jv), (0, E4.map)((e) => ({
      oldValue: e.oldValue || null,
      newValue: e.newValue || null
    })));
  }
  static hash(e) {
    return new I4.sha256().update(e).digest("hex");
  }
  get id() {
    return this._id;
  }
  get secret() {
    return this._secret;
  }
  get key() {
    return this._key;
  }
  get linked() {
    return this._linked;
  }
  set linked(e) {
    this._linked = e, this.persistLinked();
  }
  save() {
    return this._storage.setItem(jv, this._id), this._storage.setItem(T4, this._secret), this.persistLinked(), this;
  }
  persistLinked() {
    this._storage.setItem(N4, this._linked ? "1" : "0");
  }
}
Bc.Session = M2;
var Ss = {};
Object.defineProperty(Ss, "__esModule", { value: !0 });
Ss.WalletSDKRelayAbstract = Ss.APP_VERSION_KEY = Ss.LOCAL_STORAGE_ADDRESSES_KEY = Ss.WALLET_USER_NAME_KEY = void 0;
const D4 = K0;
Ss.WALLET_USER_NAME_KEY = "walletUsername";
Ss.LOCAL_STORAGE_ADDRESSES_KEY = "Addresses";
Ss.APP_VERSION_KEY = "AppVersion";
class PW {
  async makeEthereumJSONRPCRequest(e, r) {
    if (!r)
      throw new Error("Error: No jsonRpcUrl provided");
    return window.fetch(r, {
      method: "POST",
      body: JSON.stringify(e),
      mode: "cors",
      headers: { "Content-Type": "application/json" }
    }).then((i) => i.json()).then((i) => {
      if (!i)
        throw D4.ethErrors.rpc.parse({});
      const s = i, { error: n } = s;
      if (n)
        throw (0, D4.serializeError)(n);
      return s;
    });
  }
}
Ss.WalletSDKRelayAbstract = PW;
var y0 = { exports: {} }, d9 = Pr.exports.EventEmitter, Bv, C4;
function kW() {
  if (C4)
    return Bv;
  C4 = 1;
  function t(b, M) {
    var A = Object.keys(b);
    if (Object.getOwnPropertySymbols) {
      var N = Object.getOwnPropertySymbols(b);
      M && (N = N.filter(function(R) {
        return Object.getOwnPropertyDescriptor(b, R).enumerable;
      })), A.push.apply(A, N);
    }
    return A;
  }
  function e(b) {
    for (var M = 1; M < arguments.length; M++) {
      var A = arguments[M] != null ? arguments[M] : {};
      M % 2 ? t(Object(A), !0).forEach(function(N) {
        r(b, N, A[N]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(b, Object.getOwnPropertyDescriptors(A)) : t(Object(A)).forEach(function(N) {
        Object.defineProperty(b, N, Object.getOwnPropertyDescriptor(A, N));
      });
    }
    return b;
  }
  function r(b, M, A) {
    return M in b ? Object.defineProperty(b, M, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : b[M] = A, b;
  }
  function i(b, M) {
    if (!(b instanceof M))
      throw new TypeError("Cannot call a class as a function");
  }
  function s(b, M) {
    for (var A = 0; A < M.length; A++) {
      var N = M[A];
      N.enumerable = N.enumerable || !1, N.configurable = !0, "value" in N && (N.writable = !0), Object.defineProperty(b, N.key, N);
    }
  }
  function n(b, M, A) {
    return M && s(b.prototype, M), A && s(b, A), b;
  }
  var f = Tn, u = f.Buffer, h = dn, d = h.inspect, l = d && d.custom || "inspect";
  function m(b, M, A) {
    u.prototype.copy.call(b, M, A);
  }
  return Bv = /* @__PURE__ */ function() {
    function b() {
      i(this, b), this.head = null, this.tail = null, this.length = 0;
    }
    return n(b, [{
      key: "push",
      value: function(A) {
        var N = {
          data: A,
          next: null
        };
        this.length > 0 ? this.tail.next = N : this.head = N, this.tail = N, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(A) {
        var N = {
          data: A,
          next: this.head
        };
        this.length === 0 && (this.tail = N), this.head = N, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var A = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, A;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(A) {
        if (this.length === 0)
          return "";
        for (var N = this.head, R = "" + N.data; N = N.next; )
          R += A + N.data;
        return R;
      }
    }, {
      key: "concat",
      value: function(A) {
        if (this.length === 0)
          return u.alloc(0);
        for (var N = u.allocUnsafe(A >>> 0), R = this.head, O = 0; R; )
          m(R.data, N, O), O += R.data.length, R = R.next;
        return N;
      }
    }, {
      key: "consume",
      value: function(A, N) {
        var R;
        return A < this.head.data.length ? (R = this.head.data.slice(0, A), this.head.data = this.head.data.slice(A)) : A === this.head.data.length ? R = this.shift() : R = N ? this._getString(A) : this._getBuffer(A), R;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
    }, {
      key: "_getString",
      value: function(A) {
        var N = this.head, R = 1, O = N.data;
        for (A -= O.length; N = N.next; ) {
          var P = N.data, F = A > P.length ? P.length : A;
          if (F === P.length ? O += P : O += P.slice(0, A), A -= F, A === 0) {
            F === P.length ? (++R, N.next ? this.head = N.next : this.head = this.tail = null) : (this.head = N, N.data = P.slice(F));
            break;
          }
          ++R;
        }
        return this.length -= R, O;
      }
    }, {
      key: "_getBuffer",
      value: function(A) {
        var N = u.allocUnsafe(A), R = this.head, O = 1;
        for (R.data.copy(N), A -= R.data.length; R = R.next; ) {
          var P = R.data, F = A > P.length ? P.length : A;
          if (P.copy(N, N.length - A, 0, F), A -= F, A === 0) {
            F === P.length ? (++O, R.next ? this.head = R.next : this.head = this.tail = null) : (this.head = R, R.data = P.slice(F));
            break;
          }
          ++O;
        }
        return this.length -= O, N;
      }
    }, {
      key: l,
      value: function(A, N) {
        return d(this, e({}, N, {
          depth: 0,
          customInspect: !1
        }));
      }
    }]), b;
  }(), Bv;
}
function jW(t, e) {
  var r = this, i = this._readableState && this._readableState.destroyed, s = this._writableState && this._writableState.destroyed;
  return i || s ? (e ? e(t) : t && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process.nextTick(vm, this, t)) : process.nextTick(vm, this, t)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function(n) {
    !e && n ? r._writableState ? r._writableState.errorEmitted ? process.nextTick(Gd, r) : (r._writableState.errorEmitted = !0, process.nextTick(O4, r, n)) : process.nextTick(O4, r, n) : e ? (process.nextTick(Gd, r), e(n)) : process.nextTick(Gd, r);
  }), this);
}
function O4(t, e) {
  vm(t, e), Gd(t);
}
function Gd(t) {
  t._writableState && !t._writableState.emitClose || t._readableState && !t._readableState.emitClose || t.emit("close");
}
function BW() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function vm(t, e) {
  t.emit("error", e);
}
function zW(t, e) {
  var r = t._readableState, i = t._writableState;
  r && r.autoDestroy || i && i.autoDestroy ? t.destroy(e) : t.emit("error", e);
}
var p9 = {
  destroy: jW,
  undestroy: BW,
  errorOrDestroy: zW
}, bf = {};
function UW(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
var v9 = {};
function ss(t, e, r) {
  r || (r = Error);
  function i(n, f, u) {
    return typeof e == "string" ? e : e(n, f, u);
  }
  var s = /* @__PURE__ */ function(n) {
    UW(f, n);
    function f(u, h, d) {
      return n.call(this, i(u, h, d)) || this;
    }
    return f;
  }(r);
  s.prototype.name = r.name, s.prototype.code = t, v9[t] = s;
}
function R4(t, e) {
  if (Array.isArray(t)) {
    var r = t.length;
    return t = t.map(function(i) {
      return String(i);
    }), r > 2 ? "one of ".concat(e, " ").concat(t.slice(0, r - 1).join(", "), ", or ") + t[r - 1] : r === 2 ? "one of ".concat(e, " ").concat(t[0], " or ").concat(t[1]) : "of ".concat(e, " ").concat(t[0]);
  } else
    return "of ".concat(e, " ").concat(String(t));
}
function FW(t, e, r) {
  return t.substr(!r || r < 0 ? 0 : +r, e.length) === e;
}
function $W(t, e, r) {
  return (r === void 0 || r > t.length) && (r = t.length), t.substring(r - e.length, r) === e;
}
function qW(t, e, r) {
  return typeof r != "number" && (r = 0), r + e.length > t.length ? !1 : t.indexOf(e, r) !== -1;
}
ss("ERR_INVALID_OPT_VALUE", function(t, e) {
  return 'The value "' + e + '" is invalid for option "' + t + '"';
}, TypeError);
ss("ERR_INVALID_ARG_TYPE", function(t, e, r) {
  var i;
  typeof e == "string" && FW(e, "not ") ? (i = "must not be", e = e.replace(/^not /, "")) : i = "must be";
  var s;
  if ($W(t, " argument"))
    s = "The ".concat(t, " ").concat(i, " ").concat(R4(e, "type"));
  else {
    var n = qW(t, ".") ? "property" : "argument";
    s = 'The "'.concat(t, '" ').concat(n, " ").concat(i, " ").concat(R4(e, "type"));
  }
  return s += ". Received type ".concat(typeof r), s;
}, TypeError);
ss("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
ss("ERR_METHOD_NOT_IMPLEMENTED", function(t) {
  return "The " + t + " method is not implemented";
});
ss("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
ss("ERR_STREAM_DESTROYED", function(t) {
  return "Cannot call " + t + " after a stream was destroyed";
});
ss("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
ss("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
ss("ERR_STREAM_WRITE_AFTER_END", "write after end");
ss("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
ss("ERR_UNKNOWN_ENCODING", function(t) {
  return "Unknown encoding: " + t;
}, TypeError);
ss("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
bf.codes = v9;
var HW = bf.codes.ERR_INVALID_OPT_VALUE;
function WW(t, e, r) {
  return t.highWaterMark != null ? t.highWaterMark : e ? t[r] : null;
}
function VW(t, e, r, i) {
  var s = WW(e, i, r);
  if (s != null) {
    if (!(isFinite(s) && Math.floor(s) === s) || s < 0) {
      var n = i ? r : "highWaterMark";
      throw new HW(n, s);
    }
    return Math.floor(s);
  }
  return t.objectMode ? 16 : 16 * 1024;
}
var g9 = {
  getHighWaterMark: VW
}, zv, L4;
function x2() {
  if (L4)
    return zv;
  L4 = 1, zv = t;
  function t(r, i) {
    if (e("noDeprecation"))
      return r;
    var s = !1;
    function n() {
      if (!s) {
        if (e("throwDeprecation"))
          throw new Error(i);
        e("traceDeprecation") ? console.trace(i) : console.warn(i), s = !0;
      }
      return r.apply(this, arguments);
    }
    return n;
  }
  function e(r) {
    try {
      if (!nt.localStorage)
        return !1;
    } catch {
      return !1;
    }
    var i = nt.localStorage[r];
    return i == null ? !1 : String(i).toLowerCase() === "true";
  }
  return zv;
}
var Uv, P4;
function b9() {
  if (P4)
    return Uv;
  P4 = 1, Uv = Y;
  function t(k) {
    var j = this;
    this.next = null, this.entry = null, this.finish = function() {
      z(j, k);
    };
  }
  var e;
  Y.WritableState = Z;
  var r = {
    deprecate: x2()
  }, i = d9, s = Tn.Buffer, n = nt.Uint8Array || function() {
  };
  function f(k) {
    return s.from(k);
  }
  function u(k) {
    return s.isBuffer(k) || k instanceof n;
  }
  var h = p9, d = g9, l = d.getHighWaterMark, m = bf.codes, b = m.ERR_INVALID_ARG_TYPE, M = m.ERR_METHOD_NOT_IMPLEMENTED, A = m.ERR_MULTIPLE_CALLBACK, N = m.ERR_STREAM_CANNOT_PIPE, R = m.ERR_STREAM_DESTROYED, O = m.ERR_STREAM_NULL_VALUES, P = m.ERR_STREAM_WRITE_AFTER_END, F = m.ERR_UNKNOWN_ENCODING, H = h.errorOrDestroy;
  It.exports(Y, i);
  function Q() {
  }
  function Z(k, j, q) {
    e = e || Sc(), k = k || {}, typeof q != "boolean" && (q = j instanceof e), this.objectMode = !!k.objectMode, q && (this.objectMode = this.objectMode || !!k.writableObjectMode), this.highWaterMark = l(this, k, "writableHighWaterMark", q), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var K = k.decodeStrings === !1;
    this.decodeStrings = !K, this.defaultEncoding = k.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(U) {
      p(j, U);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = k.emitClose !== !1, this.autoDestroy = !!k.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new t(this);
  }
  Z.prototype.getBuffer = function() {
    for (var j = this.bufferedRequest, q = []; j; )
      q.push(j), j = j.next;
    return q;
  }, function() {
    try {
      Object.defineProperty(Z.prototype, "buffer", {
        get: r.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var B;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (B = Function.prototype[Symbol.hasInstance], Object.defineProperty(Y, Symbol.hasInstance, {
    value: function(j) {
      return B.call(this, j) ? !0 : this !== Y ? !1 : j && j._writableState instanceof Z;
    }
  })) : B = function(j) {
    return j instanceof this;
  };
  function Y(k) {
    e = e || Sc();
    var j = this instanceof e;
    if (!j && !B.call(Y, this))
      return new Y(k);
    this._writableState = new Z(k, this, j), this.writable = !0, k && (typeof k.write == "function" && (this._write = k.write), typeof k.writev == "function" && (this._writev = k.writev), typeof k.destroy == "function" && (this._destroy = k.destroy), typeof k.final == "function" && (this._final = k.final)), i.call(this);
  }
  Y.prototype.pipe = function() {
    H(this, new N());
  };
  function ae(k, j) {
    var q = new P();
    H(k, q), process.nextTick(j, q);
  }
  function se(k, j, q, K) {
    var U;
    return q === null ? U = new O() : typeof q != "string" && !j.objectMode && (U = new b("chunk", ["string", "Buffer"], q)), U ? (H(k, U), process.nextTick(K, U), !1) : !0;
  }
  Y.prototype.write = function(k, j, q) {
    var K = this._writableState, U = !1, T = !K.objectMode && u(k);
    return T && !s.isBuffer(k) && (k = f(k)), typeof j == "function" && (q = j, j = null), T ? j = "buffer" : j || (j = K.defaultEncoding), typeof q != "function" && (q = Q), K.ending ? ae(this, q) : (T || se(this, K, k, q)) && (K.pendingcb++, U = C(this, K, T, k, j, q)), U;
  }, Y.prototype.cork = function() {
    this._writableState.corked++;
  }, Y.prototype.uncork = function() {
    var k = this._writableState;
    k.corked && (k.corked--, !k.writing && !k.corked && !k.bufferProcessing && k.bufferedRequest && x(this, k));
  }, Y.prototype.setDefaultEncoding = function(j) {
    if (typeof j == "string" && (j = j.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((j + "").toLowerCase()) > -1))
      throw new F(j);
    return this._writableState.defaultEncoding = j, this;
  }, Object.defineProperty(Y.prototype, "writableBuffer", {
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function W(k, j, q) {
    return !k.objectMode && k.decodeStrings !== !1 && typeof j == "string" && (j = s.from(j, q)), j;
  }
  Object.defineProperty(Y.prototype, "writableHighWaterMark", {
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function C(k, j, q, K, U, T) {
    if (!q) {
      var D = W(j, K, U);
      K !== D && (q = !0, U = "buffer", K = D);
    }
    var te = j.objectMode ? 1 : K.length;
    j.length += te;
    var ne = j.length < j.highWaterMark;
    if (ne || (j.needDrain = !0), j.writing || j.corked) {
      var le = j.lastBufferedRequest;
      j.lastBufferedRequest = {
        chunk: K,
        encoding: U,
        isBuf: q,
        callback: T,
        next: null
      }, le ? le.next = j.lastBufferedRequest : j.bufferedRequest = j.lastBufferedRequest, j.bufferedRequestCount += 1;
    } else
      g(k, j, !1, te, K, U, T);
    return ne;
  }
  function g(k, j, q, K, U, T, D) {
    j.writelen = K, j.writecb = D, j.writing = !0, j.sync = !0, j.destroyed ? j.onwrite(new R("write")) : q ? k._writev(U, j.onwrite) : k._write(U, T, j.onwrite), j.sync = !1;
  }
  function a(k, j, q, K, U) {
    --j.pendingcb, q ? (process.nextTick(U, K), process.nextTick(S, k, j), k._writableState.errorEmitted = !0, H(k, K)) : (U(K), k._writableState.errorEmitted = !0, H(k, K), S(k, j));
  }
  function c(k) {
    k.writing = !1, k.writecb = null, k.length -= k.writelen, k.writelen = 0;
  }
  function p(k, j) {
    var q = k._writableState, K = q.sync, U = q.writecb;
    if (typeof U != "function")
      throw new A();
    if (c(q), j)
      a(k, q, K, j, U);
    else {
      var T = E(q) || k.destroyed;
      !T && !q.corked && !q.bufferProcessing && q.bufferedRequest && x(k, q), K ? process.nextTick(w, k, q, T, U) : w(k, q, T, U);
    }
  }
  function w(k, j, q, K) {
    q || _(k, j), j.pendingcb--, K(), S(k, j);
  }
  function _(k, j) {
    j.length === 0 && j.needDrain && (j.needDrain = !1, k.emit("drain"));
  }
  function x(k, j) {
    j.bufferProcessing = !0;
    var q = j.bufferedRequest;
    if (k._writev && q && q.next) {
      var K = j.bufferedRequestCount, U = new Array(K), T = j.corkedRequestsFree;
      T.entry = q;
      for (var D = 0, te = !0; q; )
        U[D] = q, q.isBuf || (te = !1), q = q.next, D += 1;
      U.allBuffers = te, g(k, j, !0, j.length, U, "", T.finish), j.pendingcb++, j.lastBufferedRequest = null, T.next ? (j.corkedRequestsFree = T.next, T.next = null) : j.corkedRequestsFree = new t(j), j.bufferedRequestCount = 0;
    } else {
      for (; q; ) {
        var ne = q.chunk, le = q.encoding, X = q.callback, $ = j.objectMode ? 1 : ne.length;
        if (g(k, j, !1, $, ne, le, X), q = q.next, j.bufferedRequestCount--, j.writing)
          break;
      }
      q === null && (j.lastBufferedRequest = null);
    }
    j.bufferedRequest = q, j.bufferProcessing = !1;
  }
  Y.prototype._write = function(k, j, q) {
    q(new M("_write()"));
  }, Y.prototype._writev = null, Y.prototype.end = function(k, j, q) {
    var K = this._writableState;
    return typeof k == "function" ? (q = k, k = null, j = null) : typeof j == "function" && (q = j, j = null), k != null && this.write(k, j), K.corked && (K.corked = 1, this.uncork()), K.ending || J(this, K, q), this;
  }, Object.defineProperty(Y.prototype, "writableLength", {
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function E(k) {
    return k.ending && k.length === 0 && k.bufferedRequest === null && !k.finished && !k.writing;
  }
  function y(k, j) {
    k._final(function(q) {
      j.pendingcb--, q && H(k, q), j.prefinished = !0, k.emit("prefinish"), S(k, j);
    });
  }
  function o(k, j) {
    !j.prefinished && !j.finalCalled && (typeof k._final == "function" && !j.destroyed ? (j.pendingcb++, j.finalCalled = !0, process.nextTick(y, k, j)) : (j.prefinished = !0, k.emit("prefinish")));
  }
  function S(k, j) {
    var q = E(j);
    if (q && (o(k, j), j.pendingcb === 0 && (j.finished = !0, k.emit("finish"), j.autoDestroy))) {
      var K = k._readableState;
      (!K || K.autoDestroy && K.endEmitted) && k.destroy();
    }
    return q;
  }
  function J(k, j, q) {
    j.ending = !0, S(k, j), q && (j.finished ? process.nextTick(q) : k.once("finish", q)), j.ended = !0, k.writable = !1;
  }
  function z(k, j, q) {
    var K = k.entry;
    for (k.entry = null; K; ) {
      var U = K.callback;
      j.pendingcb--, U(q), K = K.next;
    }
    j.corkedRequestsFree.next = k;
  }
  return Object.defineProperty(Y.prototype, "destroyed", {
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(j) {
      !this._writableState || (this._writableState.destroyed = j);
    }
  }), Y.prototype.destroy = h.destroy, Y.prototype._undestroy = h.undestroy, Y.prototype._destroy = function(k, j) {
    j(k);
  }, Uv;
}
var Fv, k4;
function Sc() {
  if (k4)
    return Fv;
  k4 = 1;
  var t = Object.keys || function(d) {
    var l = [];
    for (var m in d)
      l.push(m);
    return l;
  };
  Fv = f;
  var e = m9(), r = b9();
  It.exports(f, e);
  for (var i = t(r.prototype), s = 0; s < i.length; s++) {
    var n = i[s];
    f.prototype[n] || (f.prototype[n] = r.prototype[n]);
  }
  function f(d) {
    if (!(this instanceof f))
      return new f(d);
    e.call(this, d), r.call(this, d), this.allowHalfOpen = !0, d && (d.readable === !1 && (this.readable = !1), d.writable === !1 && (this.writable = !1), d.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", u)));
  }
  Object.defineProperty(f.prototype, "writableHighWaterMark", {
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(f.prototype, "writableBuffer", {
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(f.prototype, "writableLength", {
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function u() {
    this._writableState.ended || process.nextTick(h, this);
  }
  function h(d) {
    d.end();
  }
  return Object.defineProperty(f.prototype, "destroyed", {
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(l) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = l, this._writableState.destroyed = l);
    }
  }), Fv;
}
var $v = {}, j4;
function of() {
  if (j4)
    return $v;
  j4 = 1;
  var t = Ft.exports.Buffer, e = t.isEncoding || function(O) {
    switch (O = "" + O, O && O.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function r(O) {
    if (!O)
      return "utf8";
    for (var P; ; )
      switch (O) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return O;
        default:
          if (P)
            return;
          O = ("" + O).toLowerCase(), P = !0;
      }
  }
  function i(O) {
    var P = r(O);
    if (typeof P != "string" && (t.isEncoding === e || !e(O)))
      throw new Error("Unknown encoding: " + O);
    return P || O;
  }
  $v.StringDecoder = s;
  function s(O) {
    this.encoding = i(O);
    var P;
    switch (this.encoding) {
      case "utf16le":
        this.text = m, this.end = b, P = 4;
        break;
      case "utf8":
        this.fillLast = h, P = 4;
        break;
      case "base64":
        this.text = M, this.end = A, P = 3;
        break;
      default:
        this.write = N, this.end = R;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = t.allocUnsafe(P);
  }
  s.prototype.write = function(O) {
    if (O.length === 0)
      return "";
    var P, F;
    if (this.lastNeed) {
      if (P = this.fillLast(O), P === void 0)
        return "";
      F = this.lastNeed, this.lastNeed = 0;
    } else
      F = 0;
    return F < O.length ? P ? P + this.text(O, F) : this.text(O, F) : P || "";
  }, s.prototype.end = l, s.prototype.text = d, s.prototype.fillLast = function(O) {
    if (this.lastNeed <= O.length)
      return O.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    O.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, O.length), this.lastNeed -= O.length;
  };
  function n(O) {
    return O <= 127 ? 0 : O >> 5 === 6 ? 2 : O >> 4 === 14 ? 3 : O >> 3 === 30 ? 4 : O >> 6 === 2 ? -1 : -2;
  }
  function f(O, P, F) {
    var H = P.length - 1;
    if (H < F)
      return 0;
    var Q = n(P[H]);
    return Q >= 0 ? (Q > 0 && (O.lastNeed = Q - 1), Q) : --H < F || Q === -2 ? 0 : (Q = n(P[H]), Q >= 0 ? (Q > 0 && (O.lastNeed = Q - 2), Q) : --H < F || Q === -2 ? 0 : (Q = n(P[H]), Q >= 0 ? (Q > 0 && (Q === 2 ? Q = 0 : O.lastNeed = Q - 3), Q) : 0));
  }
  function u(O, P, F) {
    if ((P[0] & 192) !== 128)
      return O.lastNeed = 0, "\uFFFD";
    if (O.lastNeed > 1 && P.length > 1) {
      if ((P[1] & 192) !== 128)
        return O.lastNeed = 1, "\uFFFD";
      if (O.lastNeed > 2 && P.length > 2 && (P[2] & 192) !== 128)
        return O.lastNeed = 2, "\uFFFD";
    }
  }
  function h(O) {
    var P = this.lastTotal - this.lastNeed, F = u(this, O);
    if (F !== void 0)
      return F;
    if (this.lastNeed <= O.length)
      return O.copy(this.lastChar, P, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    O.copy(this.lastChar, P, 0, O.length), this.lastNeed -= O.length;
  }
  function d(O, P) {
    var F = f(this, O, P);
    if (!this.lastNeed)
      return O.toString("utf8", P);
    this.lastTotal = F;
    var H = O.length - (F - this.lastNeed);
    return O.copy(this.lastChar, 0, H), O.toString("utf8", P, H);
  }
  function l(O) {
    var P = O && O.length ? this.write(O) : "";
    return this.lastNeed ? P + "\uFFFD" : P;
  }
  function m(O, P) {
    if ((O.length - P) % 2 === 0) {
      var F = O.toString("utf16le", P);
      if (F) {
        var H = F.charCodeAt(F.length - 1);
        if (H >= 55296 && H <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = O[O.length - 2], this.lastChar[1] = O[O.length - 1], F.slice(0, -1);
      }
      return F;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = O[O.length - 1], O.toString("utf16le", P, O.length - 1);
  }
  function b(O) {
    var P = O && O.length ? this.write(O) : "";
    if (this.lastNeed) {
      var F = this.lastTotal - this.lastNeed;
      return P + this.lastChar.toString("utf16le", 0, F);
    }
    return P;
  }
  function M(O, P) {
    var F = (O.length - P) % 3;
    return F === 0 ? O.toString("base64", P) : (this.lastNeed = 3 - F, this.lastTotal = 3, F === 1 ? this.lastChar[0] = O[O.length - 1] : (this.lastChar[0] = O[O.length - 2], this.lastChar[1] = O[O.length - 1]), O.toString("base64", P, O.length - F));
  }
  function A(O) {
    var P = O && O.length ? this.write(O) : "";
    return this.lastNeed ? P + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : P;
  }
  function N(O) {
    return O.toString(this.encoding);
  }
  function R(O) {
    return O && O.length ? this.write(O) : "";
  }
  return $v;
}
var B4 = bf.codes.ERR_STREAM_PREMATURE_CLOSE;
function GW(t) {
  var e = !1;
  return function() {
    if (!e) {
      e = !0;
      for (var r = arguments.length, i = new Array(r), s = 0; s < r; s++)
        i[s] = arguments[s];
      t.apply(this, i);
    }
  };
}
function KW() {
}
function YW(t) {
  return t.setHeader && typeof t.abort == "function";
}
function y9(t, e, r) {
  if (typeof e == "function")
    return y9(t, null, e);
  e || (e = {}), r = GW(r || KW);
  var i = e.readable || e.readable !== !1 && t.readable, s = e.writable || e.writable !== !1 && t.writable, n = function() {
    t.writable || u();
  }, f = t._writableState && t._writableState.finished, u = function() {
    s = !1, f = !0, i || r.call(t);
  }, h = t._readableState && t._readableState.endEmitted, d = function() {
    i = !1, h = !0, s || r.call(t);
  }, l = function(A) {
    r.call(t, A);
  }, m = function() {
    var A;
    if (i && !h)
      return (!t._readableState || !t._readableState.ended) && (A = new B4()), r.call(t, A);
    if (s && !f)
      return (!t._writableState || !t._writableState.ended) && (A = new B4()), r.call(t, A);
  }, b = function() {
    t.req.on("finish", u);
  };
  return YW(t) ? (t.on("complete", u), t.on("abort", m), t.req ? b() : t.on("request", b)) : s && !t._writableState && (t.on("end", n), t.on("close", n)), t.on("end", d), t.on("finish", u), e.error !== !1 && t.on("error", l), t.on("close", m), function() {
    t.removeListener("complete", u), t.removeListener("abort", m), t.removeListener("request", b), t.req && t.req.removeListener("finish", u), t.removeListener("end", n), t.removeListener("close", n), t.removeListener("finish", u), t.removeListener("end", d), t.removeListener("error", l), t.removeListener("close", m);
  };
}
var S2 = y9, qv, z4;
function QW() {
  if (z4)
    return qv;
  z4 = 1;
  var t;
  function e(O, P, F) {
    return P in O ? Object.defineProperty(O, P, { value: F, enumerable: !0, configurable: !0, writable: !0 }) : O[P] = F, O;
  }
  var r = S2, i = Symbol("lastResolve"), s = Symbol("lastReject"), n = Symbol("error"), f = Symbol("ended"), u = Symbol("lastPromise"), h = Symbol("handlePromise"), d = Symbol("stream");
  function l(O, P) {
    return {
      value: O,
      done: P
    };
  }
  function m(O) {
    var P = O[i];
    if (P !== null) {
      var F = O[d].read();
      F !== null && (O[u] = null, O[i] = null, O[s] = null, P(l(F, !1)));
    }
  }
  function b(O) {
    process.nextTick(m, O);
  }
  function M(O, P) {
    return function(F, H) {
      O.then(function() {
        if (P[f]) {
          F(l(void 0, !0));
          return;
        }
        P[h](F, H);
      }, H);
    };
  }
  var A = Object.getPrototypeOf(function() {
  }), N = Object.setPrototypeOf((t = {
    get stream() {
      return this[d];
    },
    next: function() {
      var P = this, F = this[n];
      if (F !== null)
        return Promise.reject(F);
      if (this[f])
        return Promise.resolve(l(void 0, !0));
      if (this[d].destroyed)
        return new Promise(function(B, Y) {
          process.nextTick(function() {
            P[n] ? Y(P[n]) : B(l(void 0, !0));
          });
        });
      var H = this[u], Q;
      if (H)
        Q = new Promise(M(H, this));
      else {
        var Z = this[d].read();
        if (Z !== null)
          return Promise.resolve(l(Z, !1));
        Q = new Promise(this[h]);
      }
      return this[u] = Q, Q;
    }
  }, e(t, Symbol.asyncIterator, function() {
    return this;
  }), e(t, "return", function() {
    var P = this;
    return new Promise(function(F, H) {
      P[d].destroy(null, function(Q) {
        if (Q) {
          H(Q);
          return;
        }
        F(l(void 0, !0));
      });
    });
  }), t), A), R = function(P) {
    var F, H = Object.create(N, (F = {}, e(F, d, {
      value: P,
      writable: !0
    }), e(F, i, {
      value: null,
      writable: !0
    }), e(F, s, {
      value: null,
      writable: !0
    }), e(F, n, {
      value: null,
      writable: !0
    }), e(F, f, {
      value: P._readableState.endEmitted,
      writable: !0
    }), e(F, h, {
      value: function(Z, B) {
        var Y = H[d].read();
        Y ? (H[u] = null, H[i] = null, H[s] = null, Z(l(Y, !1))) : (H[i] = Z, H[s] = B);
      },
      writable: !0
    }), F));
    return H[u] = null, r(P, function(Q) {
      if (Q && Q.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var Z = H[s];
        Z !== null && (H[u] = null, H[i] = null, H[s] = null, Z(Q)), H[n] = Q;
        return;
      }
      var B = H[i];
      B !== null && (H[u] = null, H[i] = null, H[s] = null, B(l(void 0, !0))), H[f] = !0;
    }), P.on("readable", b.bind(null, H)), H;
  };
  return qv = R, qv;
}
var Hv, U4;
function ZW() {
  return U4 || (U4 = 1, Hv = function() {
    throw new Error("Readable.from is not available in the browser");
  }), Hv;
}
var Wv, F4;
function m9() {
  if (F4)
    return Wv;
  F4 = 1, Wv = ae;
  var t;
  ae.ReadableState = Y, Pr.exports.EventEmitter;
  var e = function(D, te) {
    return D.listeners(te).length;
  }, r = d9, i = Tn.Buffer, s = nt.Uint8Array || function() {
  };
  function n(T) {
    return i.from(T);
  }
  function f(T) {
    return i.isBuffer(T) || T instanceof s;
  }
  var u = dn, h;
  u && u.debuglog ? h = u.debuglog("stream") : h = function() {
  };
  var d = kW(), l = p9, m = g9, b = m.getHighWaterMark, M = bf.codes, A = M.ERR_INVALID_ARG_TYPE, N = M.ERR_STREAM_PUSH_AFTER_EOF, R = M.ERR_METHOD_NOT_IMPLEMENTED, O = M.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, P, F, H;
  It.exports(ae, r);
  var Q = l.errorOrDestroy, Z = ["error", "close", "destroy", "pause", "resume"];
  function B(T, D, te) {
    if (typeof T.prependListener == "function")
      return T.prependListener(D, te);
    !T._events || !T._events[D] ? T.on(D, te) : Array.isArray(T._events[D]) ? T._events[D].unshift(te) : T._events[D] = [te, T._events[D]];
  }
  function Y(T, D, te) {
    t = t || Sc(), T = T || {}, typeof te != "boolean" && (te = D instanceof t), this.objectMode = !!T.objectMode, te && (this.objectMode = this.objectMode || !!T.readableObjectMode), this.highWaterMark = b(this, T, "readableHighWaterMark", te), this.buffer = new d(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = T.emitClose !== !1, this.autoDestroy = !!T.autoDestroy, this.destroyed = !1, this.defaultEncoding = T.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, T.encoding && (P || (P = of().StringDecoder), this.decoder = new P(T.encoding), this.encoding = T.encoding);
  }
  function ae(T) {
    if (t = t || Sc(), !(this instanceof ae))
      return new ae(T);
    var D = this instanceof t;
    this._readableState = new Y(T, this, D), this.readable = !0, T && (typeof T.read == "function" && (this._read = T.read), typeof T.destroy == "function" && (this._destroy = T.destroy)), r.call(this);
  }
  Object.defineProperty(ae.prototype, "destroyed", {
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(D) {
      !this._readableState || (this._readableState.destroyed = D);
    }
  }), ae.prototype.destroy = l.destroy, ae.prototype._undestroy = l.undestroy, ae.prototype._destroy = function(T, D) {
    D(T);
  }, ae.prototype.push = function(T, D) {
    var te = this._readableState, ne;
    return te.objectMode ? ne = !0 : typeof T == "string" && (D = D || te.defaultEncoding, D !== te.encoding && (T = i.from(T, D), D = ""), ne = !0), se(this, T, D, !1, ne);
  }, ae.prototype.unshift = function(T) {
    return se(this, T, null, !0, !1);
  };
  function se(T, D, te, ne, le) {
    h("readableAddChunk", D);
    var X = T._readableState;
    if (D === null)
      X.reading = !1, p(T, X);
    else {
      var $;
      if (le || ($ = C(X, D)), $)
        Q(T, $);
      else if (X.objectMode || D && D.length > 0)
        if (typeof D != "string" && !X.objectMode && Object.getPrototypeOf(D) !== i.prototype && (D = n(D)), ne)
          X.endEmitted ? Q(T, new O()) : W(T, X, D, !0);
        else if (X.ended)
          Q(T, new N());
        else {
          if (X.destroyed)
            return !1;
          X.reading = !1, X.decoder && !te ? (D = X.decoder.write(D), X.objectMode || D.length !== 0 ? W(T, X, D, !1) : x(T, X)) : W(T, X, D, !1);
        }
      else
        ne || (X.reading = !1, x(T, X));
    }
    return !X.ended && (X.length < X.highWaterMark || X.length === 0);
  }
  function W(T, D, te, ne) {
    D.flowing && D.length === 0 && !D.sync ? (D.awaitDrain = 0, T.emit("data", te)) : (D.length += D.objectMode ? 1 : te.length, ne ? D.buffer.unshift(te) : D.buffer.push(te), D.needReadable && w(T)), x(T, D);
  }
  function C(T, D) {
    var te;
    return !f(D) && typeof D != "string" && D !== void 0 && !T.objectMode && (te = new A("chunk", ["string", "Buffer", "Uint8Array"], D)), te;
  }
  ae.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, ae.prototype.setEncoding = function(T) {
    P || (P = of().StringDecoder);
    var D = new P(T);
    this._readableState.decoder = D, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var te = this._readableState.buffer.head, ne = ""; te !== null; )
      ne += D.write(te.data), te = te.next;
    return this._readableState.buffer.clear(), ne !== "" && this._readableState.buffer.push(ne), this._readableState.length = ne.length, this;
  };
  var g = 1073741824;
  function a(T) {
    return T >= g ? T = g : (T--, T |= T >>> 1, T |= T >>> 2, T |= T >>> 4, T |= T >>> 8, T |= T >>> 16, T++), T;
  }
  function c(T, D) {
    return T <= 0 || D.length === 0 && D.ended ? 0 : D.objectMode ? 1 : T !== T ? D.flowing && D.length ? D.buffer.head.data.length : D.length : (T > D.highWaterMark && (D.highWaterMark = a(T)), T <= D.length ? T : D.ended ? D.length : (D.needReadable = !0, 0));
  }
  ae.prototype.read = function(T) {
    h("read", T), T = parseInt(T, 10);
    var D = this._readableState, te = T;
    if (T !== 0 && (D.emittedReadable = !1), T === 0 && D.needReadable && ((D.highWaterMark !== 0 ? D.length >= D.highWaterMark : D.length > 0) || D.ended))
      return h("read: emitReadable", D.length, D.ended), D.length === 0 && D.ended ? q(this) : w(this), null;
    if (T = c(T, D), T === 0 && D.ended)
      return D.length === 0 && q(this), null;
    var ne = D.needReadable;
    h("need readable", ne), (D.length === 0 || D.length - T < D.highWaterMark) && (ne = !0, h("length less than watermark", ne)), D.ended || D.reading ? (ne = !1, h("reading or ended", ne)) : ne && (h("do read"), D.reading = !0, D.sync = !0, D.length === 0 && (D.needReadable = !0), this._read(D.highWaterMark), D.sync = !1, D.reading || (T = c(te, D)));
    var le;
    return T > 0 ? le = j(T, D) : le = null, le === null ? (D.needReadable = D.length <= D.highWaterMark, T = 0) : (D.length -= T, D.awaitDrain = 0), D.length === 0 && (D.ended || (D.needReadable = !0), te !== T && D.ended && q(this)), le !== null && this.emit("data", le), le;
  };
  function p(T, D) {
    if (h("onEofChunk"), !D.ended) {
      if (D.decoder) {
        var te = D.decoder.end();
        te && te.length && (D.buffer.push(te), D.length += D.objectMode ? 1 : te.length);
      }
      D.ended = !0, D.sync ? w(T) : (D.needReadable = !1, D.emittedReadable || (D.emittedReadable = !0, _(T)));
    }
  }
  function w(T) {
    var D = T._readableState;
    h("emitReadable", D.needReadable, D.emittedReadable), D.needReadable = !1, D.emittedReadable || (h("emitReadable", D.flowing), D.emittedReadable = !0, process.nextTick(_, T));
  }
  function _(T) {
    var D = T._readableState;
    h("emitReadable_", D.destroyed, D.length, D.ended), !D.destroyed && (D.length || D.ended) && (T.emit("readable"), D.emittedReadable = !1), D.needReadable = !D.flowing && !D.ended && D.length <= D.highWaterMark, k(T);
  }
  function x(T, D) {
    D.readingMore || (D.readingMore = !0, process.nextTick(E, T, D));
  }
  function E(T, D) {
    for (; !D.reading && !D.ended && (D.length < D.highWaterMark || D.flowing && D.length === 0); ) {
      var te = D.length;
      if (h("maybeReadMore read 0"), T.read(0), te === D.length)
        break;
    }
    D.readingMore = !1;
  }
  ae.prototype._read = function(T) {
    Q(this, new R("_read()"));
  }, ae.prototype.pipe = function(T, D) {
    var te = this, ne = this._readableState;
    switch (ne.pipesCount) {
      case 0:
        ne.pipes = T;
        break;
      case 1:
        ne.pipes = [ne.pipes, T];
        break;
      default:
        ne.pipes.push(T);
        break;
    }
    ne.pipesCount += 1, h("pipe count=%d opts=%j", ne.pipesCount, D);
    var le = (!D || D.end !== !1) && T !== process.stdout && T !== process.stderr, X = le ? V : ye;
    ne.endEmitted ? process.nextTick(X) : te.once("end", X), T.on("unpipe", $);
    function $(pe, Je) {
      h("onunpipe"), pe === te && Je && Je.hasUnpiped === !1 && (Je.hasUnpiped = !0, ue());
    }
    function V() {
      h("onend"), T.end();
    }
    var re = y(te);
    T.on("drain", re);
    var fe = !1;
    function ue() {
      h("cleanup"), T.removeListener("close", ve), T.removeListener("finish", Ge), T.removeListener("drain", re), T.removeListener("error", be), T.removeListener("unpipe", $), te.removeListener("end", V), te.removeListener("end", ye), te.removeListener("data", me), fe = !0, ne.awaitDrain && (!T._writableState || T._writableState.needDrain) && re();
    }
    te.on("data", me);
    function me(pe) {
      h("ondata");
      var Je = T.write(pe);
      h("dest.write", Je), Je === !1 && ((ne.pipesCount === 1 && ne.pipes === T || ne.pipesCount > 1 && U(ne.pipes, T) !== -1) && !fe && (h("false write response, pause", ne.awaitDrain), ne.awaitDrain++), te.pause());
    }
    function be(pe) {
      h("onerror", pe), ye(), T.removeListener("error", be), e(T, "error") === 0 && Q(T, pe);
    }
    B(T, "error", be);
    function ve() {
      T.removeListener("finish", Ge), ye();
    }
    T.once("close", ve);
    function Ge() {
      h("onfinish"), T.removeListener("close", ve), ye();
    }
    T.once("finish", Ge);
    function ye() {
      h("unpipe"), te.unpipe(T);
    }
    return T.emit("pipe", te), ne.flowing || (h("pipe resume"), te.resume()), T;
  };
  function y(T) {
    return function() {
      var te = T._readableState;
      h("pipeOnDrain", te.awaitDrain), te.awaitDrain && te.awaitDrain--, te.awaitDrain === 0 && e(T, "data") && (te.flowing = !0, k(T));
    };
  }
  ae.prototype.unpipe = function(T) {
    var D = this._readableState, te = {
      hasUnpiped: !1
    };
    if (D.pipesCount === 0)
      return this;
    if (D.pipesCount === 1)
      return T && T !== D.pipes ? this : (T || (T = D.pipes), D.pipes = null, D.pipesCount = 0, D.flowing = !1, T && T.emit("unpipe", this, te), this);
    if (!T) {
      var ne = D.pipes, le = D.pipesCount;
      D.pipes = null, D.pipesCount = 0, D.flowing = !1;
      for (var X = 0; X < le; X++)
        ne[X].emit("unpipe", this, {
          hasUnpiped: !1
        });
      return this;
    }
    var $ = U(D.pipes, T);
    return $ === -1 ? this : (D.pipes.splice($, 1), D.pipesCount -= 1, D.pipesCount === 1 && (D.pipes = D.pipes[0]), T.emit("unpipe", this, te), this);
  }, ae.prototype.on = function(T, D) {
    var te = r.prototype.on.call(this, T, D), ne = this._readableState;
    return T === "data" ? (ne.readableListening = this.listenerCount("readable") > 0, ne.flowing !== !1 && this.resume()) : T === "readable" && !ne.endEmitted && !ne.readableListening && (ne.readableListening = ne.needReadable = !0, ne.flowing = !1, ne.emittedReadable = !1, h("on readable", ne.length, ne.reading), ne.length ? w(this) : ne.reading || process.nextTick(S, this)), te;
  }, ae.prototype.addListener = ae.prototype.on, ae.prototype.removeListener = function(T, D) {
    var te = r.prototype.removeListener.call(this, T, D);
    return T === "readable" && process.nextTick(o, this), te;
  }, ae.prototype.removeAllListeners = function(T) {
    var D = r.prototype.removeAllListeners.apply(this, arguments);
    return (T === "readable" || T === void 0) && process.nextTick(o, this), D;
  };
  function o(T) {
    var D = T._readableState;
    D.readableListening = T.listenerCount("readable") > 0, D.resumeScheduled && !D.paused ? D.flowing = !0 : T.listenerCount("data") > 0 && T.resume();
  }
  function S(T) {
    h("readable nexttick read 0"), T.read(0);
  }
  ae.prototype.resume = function() {
    var T = this._readableState;
    return T.flowing || (h("resume"), T.flowing = !T.readableListening, J(this, T)), T.paused = !1, this;
  };
  function J(T, D) {
    D.resumeScheduled || (D.resumeScheduled = !0, process.nextTick(z, T, D));
  }
  function z(T, D) {
    h("resume", D.reading), D.reading || T.read(0), D.resumeScheduled = !1, T.emit("resume"), k(T), D.flowing && !D.reading && T.read(0);
  }
  ae.prototype.pause = function() {
    return h("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (h("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function k(T) {
    var D = T._readableState;
    for (h("flow", D.flowing); D.flowing && T.read() !== null; )
      ;
  }
  ae.prototype.wrap = function(T) {
    var D = this, te = this._readableState, ne = !1;
    T.on("end", function() {
      if (h("wrapped end"), te.decoder && !te.ended) {
        var $ = te.decoder.end();
        $ && $.length && D.push($);
      }
      D.push(null);
    }), T.on("data", function($) {
      if (h("wrapped data"), te.decoder && ($ = te.decoder.write($)), !(te.objectMode && $ == null) && !(!te.objectMode && (!$ || !$.length))) {
        var V = D.push($);
        V || (ne = !0, T.pause());
      }
    });
    for (var le in T)
      this[le] === void 0 && typeof T[le] == "function" && (this[le] = function(V) {
        return function() {
          return T[V].apply(T, arguments);
        };
      }(le));
    for (var X = 0; X < Z.length; X++)
      T.on(Z[X], this.emit.bind(this, Z[X]));
    return this._read = function($) {
      h("wrapped _read", $), ne && (ne = !1, T.resume());
    }, this;
  }, typeof Symbol == "function" && (ae.prototype[Symbol.asyncIterator] = function() {
    return F === void 0 && (F = QW()), F(this);
  }), Object.defineProperty(ae.prototype, "readableHighWaterMark", {
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(ae.prototype, "readableBuffer", {
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(ae.prototype, "readableFlowing", {
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(D) {
      this._readableState && (this._readableState.flowing = D);
    }
  }), ae._fromList = j, Object.defineProperty(ae.prototype, "readableLength", {
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function j(T, D) {
    if (D.length === 0)
      return null;
    var te;
    return D.objectMode ? te = D.buffer.shift() : !T || T >= D.length ? (D.decoder ? te = D.buffer.join("") : D.buffer.length === 1 ? te = D.buffer.first() : te = D.buffer.concat(D.length), D.buffer.clear()) : te = D.buffer.consume(T, D.decoder), te;
  }
  function q(T) {
    var D = T._readableState;
    h("endReadable", D.endEmitted), D.endEmitted || (D.ended = !0, process.nextTick(K, D, T));
  }
  function K(T, D) {
    if (h("endReadableNT", T.endEmitted, T.length), !T.endEmitted && T.length === 0 && (T.endEmitted = !0, D.readable = !1, D.emit("end"), T.autoDestroy)) {
      var te = D._writableState;
      (!te || te.autoDestroy && te.finished) && D.destroy();
    }
  }
  typeof Symbol == "function" && (ae.from = function(T, D) {
    return H === void 0 && (H = ZW()), H(ae, T, D);
  });
  function U(T, D) {
    for (var te = 0, ne = T.length; te < ne; te++)
      if (T[te] === D)
        return te;
    return -1;
  }
  return Wv;
}
var w9 = Ca, op = bf.codes, JW = op.ERR_METHOD_NOT_IMPLEMENTED, XW = op.ERR_MULTIPLE_CALLBACK, eV = op.ERR_TRANSFORM_ALREADY_TRANSFORMING, tV = op.ERR_TRANSFORM_WITH_LENGTH_0, fp = Sc();
It.exports(Ca, fp);
function rV(t, e) {
  var r = this._transformState;
  r.transforming = !1;
  var i = r.writecb;
  if (i === null)
    return this.emit("error", new XW());
  r.writechunk = null, r.writecb = null, e != null && this.push(e), i(t);
  var s = this._readableState;
  s.reading = !1, (s.needReadable || s.length < s.highWaterMark) && this._read(s.highWaterMark);
}
function Ca(t) {
  if (!(this instanceof Ca))
    return new Ca(t);
  fp.call(this, t), this._transformState = {
    afterTransform: rV.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, t && (typeof t.transform == "function" && (this._transform = t.transform), typeof t.flush == "function" && (this._flush = t.flush)), this.on("prefinish", iV);
}
function iV() {
  var t = this;
  typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(e, r) {
    $4(t, e, r);
  }) : $4(this, null, null);
}
Ca.prototype.push = function(t, e) {
  return this._transformState.needTransform = !1, fp.prototype.push.call(this, t, e);
};
Ca.prototype._transform = function(t, e, r) {
  r(new JW("_transform()"));
};
Ca.prototype._write = function(t, e, r) {
  var i = this._transformState;
  if (i.writecb = r, i.writechunk = t, i.writeencoding = e, !i.transforming) {
    var s = this._readableState;
    (i.needTransform || s.needReadable || s.length < s.highWaterMark) && this._read(s.highWaterMark);
  }
};
Ca.prototype._read = function(t) {
  var e = this._transformState;
  e.writechunk !== null && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
};
Ca.prototype._destroy = function(t, e) {
  fp.prototype._destroy.call(this, t, function(r) {
    e(r);
  });
};
function $4(t, e, r) {
  if (e)
    return t.emit("error", e);
  if (r != null && t.push(r), t._writableState.length)
    throw new tV();
  if (t._transformState.transforming)
    throw new eV();
  return t.push(null);
}
var nV = vh, _9 = w9;
It.exports(vh, _9);
function vh(t) {
  if (!(this instanceof vh))
    return new vh(t);
  _9.call(this, t);
}
vh.prototype._transform = function(t, e, r) {
  r(null, t);
};
var Vv;
function sV(t) {
  var e = !1;
  return function() {
    e || (e = !0, t.apply(void 0, arguments));
  };
}
var M9 = bf.codes, aV = M9.ERR_MISSING_ARGS, oV = M9.ERR_STREAM_DESTROYED;
function q4(t) {
  if (t)
    throw t;
}
function fV(t) {
  return t.setHeader && typeof t.abort == "function";
}
function cV(t, e, r, i) {
  i = sV(i);
  var s = !1;
  t.on("close", function() {
    s = !0;
  }), Vv === void 0 && (Vv = S2), Vv(t, {
    readable: e,
    writable: r
  }, function(f) {
    if (f)
      return i(f);
    s = !0, i();
  });
  var n = !1;
  return function(f) {
    if (!s && !n) {
      if (n = !0, fV(t))
        return t.abort();
      if (typeof t.destroy == "function")
        return t.destroy();
      i(f || new oV("pipe"));
    }
  };
}
function H4(t) {
  t();
}
function uV(t, e) {
  return t.pipe(e);
}
function hV(t) {
  return !t.length || typeof t[t.length - 1] != "function" ? q4 : t.pop();
}
function lV() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  var i = hV(e);
  if (Array.isArray(e[0]) && (e = e[0]), e.length < 2)
    throw new aV("streams");
  var s, n = e.map(function(f, u) {
    var h = u < e.length - 1, d = u > 0;
    return cV(f, h, d, function(l) {
      s || (s = l), l && n.forEach(H4), !h && (n.forEach(H4), i(s));
    });
  });
  return e.reduce(uV);
}
var dV = lV;
(function(t, e) {
  e = t.exports = m9(), e.Stream = e, e.Readable = e, e.Writable = b9(), e.Duplex = Sc(), e.Transform = w9, e.PassThrough = nV, e.finished = S2, e.pipeline = dV;
})(y0, y0.exports);
const { Transform: pV } = y0.exports;
var vV = (t) => class x9 extends pV {
  constructor(r, i, s, n, f) {
    super(f), this._rate = r, this._capacity = i, this._delimitedSuffix = s, this._hashBitLength = n, this._options = f, this._state = new t(), this._state.initialize(r, i), this._finalized = !1;
  }
  _transform(r, i, s) {
    let n = null;
    try {
      this.update(r, i);
    } catch (f) {
      n = f;
    }
    s(n);
  }
  _flush(r) {
    let i = null;
    try {
      this.push(this.digest());
    } catch (s) {
      i = s;
    }
    r(i);
  }
  update(r, i) {
    if (!Buffer.isBuffer(r) && typeof r != "string")
      throw new TypeError("Data must be a string or a buffer");
    if (this._finalized)
      throw new Error("Digest already called");
    return Buffer.isBuffer(r) || (r = Buffer.from(r, i)), this._state.absorb(r), this;
  }
  digest(r) {
    if (this._finalized)
      throw new Error("Digest already called");
    this._finalized = !0, this._delimitedSuffix && this._state.absorbLastFewBits(this._delimitedSuffix);
    let i = this._state.squeeze(this._hashBitLength / 8);
    return r !== void 0 && (i = i.toString(r)), this._resetState(), i;
  }
  _resetState() {
    return this._state.initialize(this._rate, this._capacity), this;
  }
  _clone() {
    const r = new x9(this._rate, this._capacity, this._delimitedSuffix, this._hashBitLength, this._options);
    return this._state.copy(r._state), r._finalized = this._finalized, r;
  }
};
const { Transform: gV } = y0.exports;
var bV = (t) => class S9 extends gV {
  constructor(r, i, s, n) {
    super(n), this._rate = r, this._capacity = i, this._delimitedSuffix = s, this._options = n, this._state = new t(), this._state.initialize(r, i), this._finalized = !1;
  }
  _transform(r, i, s) {
    let n = null;
    try {
      this.update(r, i);
    } catch (f) {
      n = f;
    }
    s(n);
  }
  _flush() {
  }
  _read(r) {
    this.push(this.squeeze(r));
  }
  update(r, i) {
    if (!Buffer.isBuffer(r) && typeof r != "string")
      throw new TypeError("Data must be a string or a buffer");
    if (this._finalized)
      throw new Error("Squeeze already called");
    return Buffer.isBuffer(r) || (r = Buffer.from(r, i)), this._state.absorb(r), this;
  }
  squeeze(r, i) {
    this._finalized || (this._finalized = !0, this._state.absorbLastFewBits(this._delimitedSuffix));
    let s = this._state.squeeze(r);
    return i !== void 0 && (s = s.toString(i)), s;
  }
  _resetState() {
    return this._state.initialize(this._rate, this._capacity), this;
  }
  _clone() {
    const r = new S9(this._rate, this._capacity, this._delimitedSuffix, this._options);
    return this._state.copy(r._state), r._finalized = this._finalized, r;
  }
};
const yV = vV, mV = bV;
var wV = function(t) {
  const e = yV(t), r = mV(t);
  return function(i, s) {
    switch (typeof i == "string" ? i.toLowerCase() : i) {
      case "keccak224":
        return new e(1152, 448, null, 224, s);
      case "keccak256":
        return new e(1088, 512, null, 256, s);
      case "keccak384":
        return new e(832, 768, null, 384, s);
      case "keccak512":
        return new e(576, 1024, null, 512, s);
      case "sha3-224":
        return new e(1152, 448, 6, 224, s);
      case "sha3-256":
        return new e(1088, 512, 6, 256, s);
      case "sha3-384":
        return new e(832, 768, 6, 384, s);
      case "sha3-512":
        return new e(576, 1024, 6, 512, s);
      case "shake128":
        return new r(1344, 256, 31, s);
      case "shake256":
        return new r(1088, 512, 31, s);
      default:
        throw new Error("Invald algorithm: " + i);
    }
  };
}, E9 = {};
const W4 = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];
E9.p1600 = function(t) {
  for (let e = 0; e < 24; ++e) {
    const r = t[0] ^ t[10] ^ t[20] ^ t[30] ^ t[40], i = t[1] ^ t[11] ^ t[21] ^ t[31] ^ t[41], s = t[2] ^ t[12] ^ t[22] ^ t[32] ^ t[42], n = t[3] ^ t[13] ^ t[23] ^ t[33] ^ t[43], f = t[4] ^ t[14] ^ t[24] ^ t[34] ^ t[44], u = t[5] ^ t[15] ^ t[25] ^ t[35] ^ t[45], h = t[6] ^ t[16] ^ t[26] ^ t[36] ^ t[46], d = t[7] ^ t[17] ^ t[27] ^ t[37] ^ t[47], l = t[8] ^ t[18] ^ t[28] ^ t[38] ^ t[48], m = t[9] ^ t[19] ^ t[29] ^ t[39] ^ t[49];
    let b = l ^ (s << 1 | n >>> 31), M = m ^ (n << 1 | s >>> 31);
    const A = t[0] ^ b, N = t[1] ^ M, R = t[10] ^ b, O = t[11] ^ M, P = t[20] ^ b, F = t[21] ^ M, H = t[30] ^ b, Q = t[31] ^ M, Z = t[40] ^ b, B = t[41] ^ M;
    b = r ^ (f << 1 | u >>> 31), M = i ^ (u << 1 | f >>> 31);
    const Y = t[2] ^ b, ae = t[3] ^ M, se = t[12] ^ b, W = t[13] ^ M, C = t[22] ^ b, g = t[23] ^ M, a = t[32] ^ b, c = t[33] ^ M, p = t[42] ^ b, w = t[43] ^ M;
    b = s ^ (h << 1 | d >>> 31), M = n ^ (d << 1 | h >>> 31);
    const _ = t[4] ^ b, x = t[5] ^ M, E = t[14] ^ b, y = t[15] ^ M, o = t[24] ^ b, S = t[25] ^ M, J = t[34] ^ b, z = t[35] ^ M, k = t[44] ^ b, j = t[45] ^ M;
    b = f ^ (l << 1 | m >>> 31), M = u ^ (m << 1 | l >>> 31);
    const q = t[6] ^ b, K = t[7] ^ M, U = t[16] ^ b, T = t[17] ^ M, D = t[26] ^ b, te = t[27] ^ M, ne = t[36] ^ b, le = t[37] ^ M, X = t[46] ^ b, $ = t[47] ^ M;
    b = h ^ (r << 1 | i >>> 31), M = d ^ (i << 1 | r >>> 31);
    const V = t[8] ^ b, re = t[9] ^ M, fe = t[18] ^ b, ue = t[19] ^ M, me = t[28] ^ b, be = t[29] ^ M, ve = t[38] ^ b, Ge = t[39] ^ M, ye = t[48] ^ b, pe = t[49] ^ M, Je = A, Ie = N, we = O << 4 | R >>> 28, at = R << 4 | O >>> 28, Oe = P << 3 | F >>> 29, Ee = F << 3 | P >>> 29, ft = Q << 9 | H >>> 23, Le = H << 9 | Q >>> 23, Pe = Z << 18 | B >>> 14, Mt = B << 18 | Z >>> 14, Ve = Y << 1 | ae >>> 31, ke = ae << 1 | Y >>> 31, Et = W << 12 | se >>> 20, Ke = se << 12 | W >>> 20, Be = C << 10 | g >>> 22, dt = g << 10 | C >>> 22, ze = c << 13 | a >>> 19, Te = a << 13 | c >>> 19, pt = p << 2 | w >>> 30, Fe = w << 2 | p >>> 30, Ae = x << 30 | _ >>> 2, bt = _ << 30 | x >>> 2, He = E << 6 | y >>> 26, Ne = y << 6 | E >>> 26, yt = S << 11 | o >>> 21, $e = o << 11 | S >>> 21, De = J << 15 | z >>> 17, vt = z << 15 | J >>> 17, je = j << 29 | k >>> 3, Ce = k << 29 | j >>> 3, mt = q << 28 | K >>> 4, Ze = K << 28 | q >>> 4, qe = T << 23 | U >>> 9, Dt = U << 23 | T >>> 9, We = D << 25 | te >>> 7, Qe = te << 25 | D >>> 7, Qt = ne << 21 | le >>> 11, Zt = le << 21 | ne >>> 11, Jt = $ << 24 | X >>> 8, Xt = X << 24 | $ >>> 8, kt = V << 27 | re >>> 5, ar = re << 27 | V >>> 5, lr = fe << 20 | ue >>> 12, or = ue << 20 | fe >>> 12, dr = be << 7 | me >>> 25, pr = me << 7 | be >>> 25, fr = ve << 8 | Ge >>> 24, ur = Ge << 8 | ve >>> 24, hr = ye << 14 | pe >>> 18, qt = pe << 14 | ye >>> 18;
    t[0] = Je ^ ~Et & yt, t[1] = Ie ^ ~Ke & $e, t[10] = mt ^ ~lr & Oe, t[11] = Ze ^ ~or & Ee, t[20] = Ve ^ ~He & We, t[21] = ke ^ ~Ne & Qe, t[30] = kt ^ ~we & Be, t[31] = ar ^ ~at & dt, t[40] = Ae ^ ~qe & dr, t[41] = bt ^ ~Dt & pr, t[2] = Et ^ ~yt & Qt, t[3] = Ke ^ ~$e & Zt, t[12] = lr ^ ~Oe & ze, t[13] = or ^ ~Ee & Te, t[22] = He ^ ~We & fr, t[23] = Ne ^ ~Qe & ur, t[32] = we ^ ~Be & De, t[33] = at ^ ~dt & vt, t[42] = qe ^ ~dr & ft, t[43] = Dt ^ ~pr & Le, t[4] = yt ^ ~Qt & hr, t[5] = $e ^ ~Zt & qt, t[14] = Oe ^ ~ze & je, t[15] = Ee ^ ~Te & Ce, t[24] = We ^ ~fr & Pe, t[25] = Qe ^ ~ur & Mt, t[34] = Be ^ ~De & Jt, t[35] = dt ^ ~vt & Xt, t[44] = dr ^ ~ft & pt, t[45] = pr ^ ~Le & Fe, t[6] = Qt ^ ~hr & Je, t[7] = Zt ^ ~qt & Ie, t[16] = ze ^ ~je & mt, t[17] = Te ^ ~Ce & Ze, t[26] = fr ^ ~Pe & Ve, t[27] = ur ^ ~Mt & ke, t[36] = De ^ ~Jt & kt, t[37] = vt ^ ~Xt & ar, t[46] = ft ^ ~pt & Ae, t[47] = Le ^ ~Fe & bt, t[8] = hr ^ ~Je & Et, t[9] = qt ^ ~Ie & Ke, t[18] = je ^ ~mt & lr, t[19] = Ce ^ ~Ze & or, t[28] = Pe ^ ~Ve & He, t[29] = Mt ^ ~ke & Ne, t[38] = Jt ^ ~kt & we, t[39] = Xt ^ ~ar & at, t[48] = pt ^ ~Ae & qe, t[49] = Fe ^ ~bt & Dt, t[0] ^= W4[e * 2], t[1] ^= W4[e * 2 + 1];
  }
};
const m0 = E9;
function Wc() {
  this.state = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
  ], this.blockSize = null, this.count = 0, this.squeezing = !1;
}
Wc.prototype.initialize = function(t, e) {
  for (let r = 0; r < 50; ++r)
    this.state[r] = 0;
  this.blockSize = t / 8, this.count = 0, this.squeezing = !1;
};
Wc.prototype.absorb = function(t) {
  for (let e = 0; e < t.length; ++e)
    this.state[~~(this.count / 4)] ^= t[e] << 8 * (this.count % 4), this.count += 1, this.count === this.blockSize && (m0.p1600(this.state), this.count = 0);
};
Wc.prototype.absorbLastFewBits = function(t) {
  this.state[~~(this.count / 4)] ^= t << 8 * (this.count % 4), (t & 128) !== 0 && this.count === this.blockSize - 1 && m0.p1600(this.state), this.state[~~((this.blockSize - 1) / 4)] ^= 128 << 8 * ((this.blockSize - 1) % 4), m0.p1600(this.state), this.count = 0, this.squeezing = !0;
};
Wc.prototype.squeeze = function(t) {
  this.squeezing || this.absorbLastFewBits(1);
  const e = Buffer.alloc(t);
  for (let r = 0; r < t; ++r)
    e[r] = this.state[~~(this.count / 4)] >>> 8 * (this.count % 4) & 255, this.count += 1, this.count === this.blockSize && (m0.p1600(this.state), this.count = 0);
  return e;
};
Wc.prototype.copy = function(t) {
  for (let e = 0; e < 50; ++e)
    t.state[e] = this.state[e];
  t.blockSize = this.blockSize, t.count = this.count, t.squeezing = this.squeezing;
};
var _V = Wc, MV = wV(_V);
const xV = MV, SV = Ih.exports;
function I9(t) {
  return Buffer.allocUnsafe(t).fill(0);
}
function A9(t, e, r) {
  const i = I9(e);
  return t = cp(t), r ? t.length < e ? (t.copy(i), i) : t.slice(0, e) : t.length < e ? (t.copy(i, e - t.length), i) : t.slice(-e);
}
function EV(t, e) {
  return A9(t, e, !0);
}
function cp(t) {
  if (!Buffer.isBuffer(t))
    if (Array.isArray(t))
      t = Buffer.from(t);
    else if (typeof t == "string")
      T9(t) ? t = Buffer.from(TV(N9(t)), "hex") : t = Buffer.from(t);
    else if (typeof t == "number")
      t = intToBuffer(t);
    else if (t == null)
      t = Buffer.allocUnsafe(0);
    else if (SV.isBN(t))
      t = t.toArrayLike(Buffer);
    else if (t.toArray)
      t = Buffer.from(t.toArray());
    else
      throw new Error("invalid type");
  return t;
}
function IV(t) {
  return t = cp(t), "0x" + t.toString("hex");
}
function AV(t, e) {
  return t = cp(t), e || (e = 256), xV("keccak" + e).update(t).digest();
}
function TV(t) {
  return t.length % 2 ? "0" + t : t;
}
function T9(t) {
  return typeof t == "string" && t.match(/^0x[0-9A-Fa-f]*$/);
}
function N9(t) {
  return typeof t == "string" && t.startsWith("0x") ? t.slice(2) : t;
}
var D9 = {
  zeros: I9,
  setLength: A9,
  setLengthRight: EV,
  isHexString: T9,
  stripHexPrefix: N9,
  toBuffer: cp,
  bufferToHex: IV,
  keccak: AV
};
const ff = D9, Zo = Ih.exports;
function C9(t) {
  return t.startsWith("int[") ? "int256" + t.slice(3) : t === "int" ? "int256" : t.startsWith("uint[") ? "uint256" + t.slice(4) : t === "uint" ? "uint256" : t.startsWith("fixed[") ? "fixed128x128" + t.slice(5) : t === "fixed" ? "fixed128x128" : t.startsWith("ufixed[") ? "ufixed128x128" + t.slice(6) : t === "ufixed" ? "ufixed128x128" : t;
}
function uc(t) {
  return parseInt(/^\D+(\d+)$/.exec(t)[1], 10);
}
function V4(t) {
  var e = /^\D+(\d+)x(\d+)$/.exec(t);
  return [parseInt(e[1], 10), parseInt(e[2], 10)];
}
function O9(t) {
  var e = t.match(/(.*)\[(.*?)\]$/);
  return e ? e[2] === "" ? "dynamic" : parseInt(e[2], 10) : null;
}
function Wo(t) {
  var e = typeof t;
  if (e === "string")
    return ff.isHexString(t) ? new Zo(ff.stripHexPrefix(t), 16) : new Zo(t, 10);
  if (e === "number")
    return new Zo(t);
  if (t.toArray)
    return t;
  throw new Error("Argument is not a number");
}
function qs(t, e) {
  var r, i, s, n;
  if (t === "address")
    return qs("uint160", Wo(e));
  if (t === "bool")
    return qs("uint8", e ? 1 : 0);
  if (t === "string")
    return qs("bytes", new Buffer(e, "utf8"));
  if (DV(t)) {
    if (typeof e.length > "u")
      throw new Error("Not an array?");
    if (r = O9(t), r !== "dynamic" && r !== 0 && e.length > r)
      throw new Error("Elements exceed array size: " + r);
    s = [], t = t.slice(0, t.lastIndexOf("[")), typeof e == "string" && (e = JSON.parse(e));
    for (n in e)
      s.push(qs(t, e[n]));
    if (r === "dynamic") {
      var f = qs("uint256", e.length);
      s.unshift(f);
    }
    return Buffer.concat(s);
  } else {
    if (t === "bytes")
      return e = new Buffer(e), s = Buffer.concat([qs("uint256", e.length), e]), e.length % 32 !== 0 && (s = Buffer.concat([s, ff.zeros(32 - e.length % 32)])), s;
    if (t.startsWith("bytes")) {
      if (r = uc(t), r < 1 || r > 32)
        throw new Error("Invalid bytes<N> width: " + r);
      return ff.setLengthRight(e, 32);
    } else if (t.startsWith("uint")) {
      if (r = uc(t), r % 8 || r < 8 || r > 256)
        throw new Error("Invalid uint<N> width: " + r);
      if (i = Wo(e), i.bitLength() > r)
        throw new Error("Supplied uint exceeds width: " + r + " vs " + i.bitLength());
      if (i < 0)
        throw new Error("Supplied uint is negative");
      return i.toArrayLike(Buffer, "be", 32);
    } else if (t.startsWith("int")) {
      if (r = uc(t), r % 8 || r < 8 || r > 256)
        throw new Error("Invalid int<N> width: " + r);
      if (i = Wo(e), i.bitLength() > r)
        throw new Error("Supplied int exceeds width: " + r + " vs " + i.bitLength());
      return i.toTwos(256).toArrayLike(Buffer, "be", 32);
    } else if (t.startsWith("ufixed")) {
      if (r = V4(t), i = Wo(e), i < 0)
        throw new Error("Supplied ufixed is negative");
      return qs("uint256", i.mul(new Zo(2).pow(new Zo(r[1]))));
    } else if (t.startsWith("fixed"))
      return r = V4(t), qs("int256", Wo(e).mul(new Zo(2).pow(new Zo(r[1]))));
  }
  throw new Error("Unsupported or invalid type: " + t);
}
function NV(t) {
  return t === "string" || t === "bytes" || O9(t) === "dynamic";
}
function DV(t) {
  return t.lastIndexOf("]") === t.length - 1;
}
function CV(t, e) {
  var r = [], i = [], s = 32 * t.length;
  for (var n in t) {
    var f = C9(t[n]), u = e[n], h = qs(f, u);
    NV(f) ? (r.push(qs("uint256", s)), i.push(h), s += h.length) : r.push(h);
  }
  return Buffer.concat(r.concat(i));
}
function R9(t, e) {
  if (t.length !== e.length)
    throw new Error("Number of types are not matching the values");
  for (var r, i, s = [], n = 0; n < t.length; n++) {
    var f = C9(t[n]), u = e[n];
    if (f === "bytes")
      s.push(u);
    else if (f === "string")
      s.push(new Buffer(u, "utf8"));
    else if (f === "bool")
      s.push(new Buffer(u ? "01" : "00", "hex"));
    else if (f === "address")
      s.push(ff.setLength(u, 20));
    else if (f.startsWith("bytes")) {
      if (r = uc(f), r < 1 || r > 32)
        throw new Error("Invalid bytes<N> width: " + r);
      s.push(ff.setLengthRight(u, r));
    } else if (f.startsWith("uint")) {
      if (r = uc(f), r % 8 || r < 8 || r > 256)
        throw new Error("Invalid uint<N> width: " + r);
      if (i = Wo(u), i.bitLength() > r)
        throw new Error("Supplied uint exceeds width: " + r + " vs " + i.bitLength());
      s.push(i.toArrayLike(Buffer, "be", r / 8));
    } else if (f.startsWith("int")) {
      if (r = uc(f), r % 8 || r < 8 || r > 256)
        throw new Error("Invalid int<N> width: " + r);
      if (i = Wo(u), i.bitLength() > r)
        throw new Error("Supplied int exceeds width: " + r + " vs " + i.bitLength());
      s.push(i.toTwos(r).toArrayLike(Buffer, "be", r / 8));
    } else
      throw new Error("Unsupported or invalid type: " + f);
  }
  return Buffer.concat(s);
}
function OV(t, e) {
  return ff.keccak(R9(t, e));
}
var RV = {
  rawEncode: CV,
  solidityPack: R9,
  soliditySHA3: OV
};
const _s = D9, th = RV, L9 = {
  type: "object",
  properties: {
    types: {
      type: "object",
      additionalProperties: {
        type: "array",
        items: {
          type: "object",
          properties: {
            name: { type: "string" },
            type: { type: "string" }
          },
          required: ["name", "type"]
        }
      }
    },
    primaryType: { type: "string" },
    domain: { type: "object" },
    message: { type: "object" }
  },
  required: ["types", "primaryType", "domain", "message"]
}, Gv = {
  encodeData(t, e, r, i = !0) {
    const s = ["bytes32"], n = [this.hashType(t, r)];
    if (i) {
      const f = (u, h, d) => {
        if (r[h] !== void 0)
          return ["bytes32", d == null ? "0x0000000000000000000000000000000000000000000000000000000000000000" : _s.keccak(this.encodeData(h, d, r, i))];
        if (d === void 0)
          throw new Error(`missing value for field ${u} of type ${h}`);
        if (h === "bytes")
          return ["bytes32", _s.keccak(d)];
        if (h === "string")
          return typeof d == "string" && (d = Buffer.from(d, "utf8")), ["bytes32", _s.keccak(d)];
        if (h.lastIndexOf("]") === h.length - 1) {
          const l = h.slice(0, h.lastIndexOf("[")), m = d.map((b) => f(u, l, b));
          return ["bytes32", _s.keccak(th.rawEncode(
            m.map(([b]) => b),
            m.map(([, b]) => b)
          ))];
        }
        return [h, d];
      };
      for (const u of r[t]) {
        const [h, d] = f(u.name, u.type, e[u.name]);
        s.push(h), n.push(d);
      }
    } else
      for (const f of r[t]) {
        let u = e[f.name];
        if (u !== void 0)
          if (f.type === "bytes")
            s.push("bytes32"), u = _s.keccak(u), n.push(u);
          else if (f.type === "string")
            s.push("bytes32"), typeof u == "string" && (u = Buffer.from(u, "utf8")), u = _s.keccak(u), n.push(u);
          else if (r[f.type] !== void 0)
            s.push("bytes32"), u = _s.keccak(this.encodeData(f.type, u, r, i)), n.push(u);
          else {
            if (f.type.lastIndexOf("]") === f.type.length - 1)
              throw new Error("Arrays currently unimplemented in encodeData");
            s.push(f.type), n.push(u);
          }
      }
    return th.rawEncode(s, n);
  },
  encodeType(t, e) {
    let r = "", i = this.findTypeDependencies(t, e).filter((s) => s !== t);
    i = [t].concat(i.sort());
    for (const s of i) {
      if (!e[s])
        throw new Error("No type definition specified: " + s);
      r += s + "(" + e[s].map(({ name: f, type: u }) => u + " " + f).join(",") + ")";
    }
    return r;
  },
  findTypeDependencies(t, e, r = []) {
    if (t = t.match(/^\w*/)[0], r.includes(t) || e[t] === void 0)
      return r;
    r.push(t);
    for (const i of e[t])
      for (const s of this.findTypeDependencies(i.type, e, r))
        !r.includes(s) && r.push(s);
    return r;
  },
  hashStruct(t, e, r, i = !0) {
    return _s.keccak(this.encodeData(t, e, r, i));
  },
  hashType(t, e) {
    return _s.keccak(this.encodeType(t, e));
  },
  sanitizeData(t) {
    const e = {};
    for (const r in L9.properties)
      t[r] && (e[r] = t[r]);
    return e.types && (e.types = Object.assign({ EIP712Domain: [] }, e.types)), e;
  },
  hash(t, e = !0) {
    const r = this.sanitizeData(t), i = [Buffer.from("1901", "hex")];
    return i.push(this.hashStruct("EIP712Domain", r.domain, r.types, e)), r.primaryType !== "EIP712Domain" && i.push(this.hashStruct(r.primaryType, r.message, r.types, e)), _s.keccak(Buffer.concat(i));
  }
};
var LV = {
  TYPED_MESSAGE_SCHEMA: L9,
  TypedDataUtils: Gv,
  hashForSignTypedDataLegacy: function(t) {
    return PV(t.data);
  },
  hashForSignTypedData_v3: function(t) {
    return Gv.hash(t.data, !1);
  },
  hashForSignTypedData_v4: function(t) {
    return Gv.hash(t.data);
  }
};
function PV(t) {
  const e = new Error("Expect argument to be non-empty array");
  if (typeof t != "object" || !t.length)
    throw e;
  const r = t.map(function(n) {
    return n.type === "bytes" ? _s.toBuffer(n.value) : n.value;
  }), i = t.map(function(n) {
    return n.type;
  }), s = t.map(function(n) {
    if (!n.name)
      throw e;
    return n.type + " " + n.name;
  });
  return th.soliditySHA3(
    ["bytes32", "bytes32"],
    [
      th.soliditySHA3(new Array(t.length).fill("string"), s),
      th.soliditySHA3(i, r)
    ]
  );
}
var Ec = {};
Object.defineProperty(Ec, "__esModule", { value: !0 });
Ec.filterFromParam = Ec.FilterPolyfill = void 0;
const ec = Bh, Gi = xt, kV = 5 * 60 * 1e3, Vo = {
  jsonrpc: "2.0",
  id: 0
};
class jV {
  constructor(e) {
    this.logFilters = /* @__PURE__ */ new Map(), this.blockFilters = /* @__PURE__ */ new Set(), this.pendingTransactionFilters = /* @__PURE__ */ new Set(), this.cursors = /* @__PURE__ */ new Map(), this.timeouts = /* @__PURE__ */ new Map(), this.nextFilterId = (0, ec.IntNumber)(1), this.provider = e;
  }
  async newFilter(e) {
    const r = P9(e), i = this.makeFilterId(), s = await this.setInitialCursorPosition(i, r.fromBlock);
    return console.log(`Installing new log filter(${i}):`, r, "initial cursor position:", s), this.logFilters.set(i, r), this.setFilterTimeout(i), (0, Gi.hexStringFromIntNumber)(i);
  }
  async newBlockFilter() {
    const e = this.makeFilterId(), r = await this.setInitialCursorPosition(e, "latest");
    return console.log(`Installing new block filter (${e}) with initial cursor position:`, r), this.blockFilters.add(e), this.setFilterTimeout(e), (0, Gi.hexStringFromIntNumber)(e);
  }
  async newPendingTransactionFilter() {
    const e = this.makeFilterId(), r = await this.setInitialCursorPosition(e, "latest");
    return console.log(`Installing new block filter (${e}) with initial cursor position:`, r), this.pendingTransactionFilters.add(e), this.setFilterTimeout(e), (0, Gi.hexStringFromIntNumber)(e);
  }
  uninstallFilter(e) {
    const r = (0, Gi.intNumberFromHexString)(e);
    return console.log(`Uninstalling filter (${r})`), this.deleteFilter(r), !0;
  }
  getFilterChanges(e) {
    const r = (0, Gi.intNumberFromHexString)(e);
    return this.timeouts.has(r) && this.setFilterTimeout(r), this.logFilters.has(r) ? this.getLogFilterChanges(r) : this.blockFilters.has(r) ? this.getBlockFilterChanges(r) : this.pendingTransactionFilters.has(r) ? this.getPendingTransactionFilterChanges(r) : Promise.resolve(md());
  }
  async getFilterLogs(e) {
    const r = (0, Gi.intNumberFromHexString)(e), i = this.logFilters.get(r);
    return i ? this.sendAsyncPromise(Object.assign(Object.assign({}, Vo), { method: "eth_getLogs", params: [G4(i)] })) : md();
  }
  makeFilterId() {
    return (0, ec.IntNumber)(++this.nextFilterId);
  }
  sendAsyncPromise(e) {
    return new Promise((r, i) => {
      this.provider.sendAsync(e, (s, n) => {
        if (s)
          return i(s);
        if (Array.isArray(n) || n == null)
          return i(new Error(`unexpected response received: ${JSON.stringify(n)}`));
        r(n);
      });
    });
  }
  deleteFilter(e) {
    console.log(`Deleting filter (${e})`), this.logFilters.delete(e), this.blockFilters.delete(e), this.pendingTransactionFilters.delete(e), this.cursors.delete(e), this.timeouts.delete(e);
  }
  async getLogFilterChanges(e) {
    const r = this.logFilters.get(e), i = this.cursors.get(e);
    if (!i || !r)
      return md();
    const s = await this.getCurrentBlockHeight(), n = r.toBlock === "latest" ? s : r.toBlock;
    if (i > s || i > r.toBlock)
      return wd();
    console.log(`Fetching logs from ${i} to ${n} for filter ${e}`);
    const f = await this.sendAsyncPromise(Object.assign(Object.assign({}, Vo), { method: "eth_getLogs", params: [
      G4(Object.assign(Object.assign({}, r), { fromBlock: i, toBlock: n }))
    ] }));
    if (Array.isArray(f.result)) {
      const u = f.result.map((d) => (0, Gi.intNumberFromHexString)(d.blockNumber || "0x0")), h = Math.max(...u);
      if (h && h > i) {
        const d = (0, ec.IntNumber)(h + 1);
        console.log(`Moving cursor position for filter (${e}) from ${i} to ${d}`), this.cursors.set(e, d);
      }
    }
    return f;
  }
  async getBlockFilterChanges(e) {
    const r = this.cursors.get(e);
    if (!r)
      return md();
    const i = await this.getCurrentBlockHeight();
    if (r > i)
      return wd();
    console.log(`Fetching blocks from ${r} to ${i} for filter (${e})`);
    const s = (await Promise.all(
      (0, Gi.range)(r, i + 1).map((f) => this.getBlockHashByNumber((0, ec.IntNumber)(f)))
    )).filter((f) => !!f), n = (0, ec.IntNumber)(r + s.length);
    return console.log(`Moving cursor position for filter (${e}) from ${r} to ${n}`), this.cursors.set(e, n), Object.assign(Object.assign({}, Vo), { result: s });
  }
  async getPendingTransactionFilterChanges(e) {
    return Promise.resolve(wd());
  }
  async setInitialCursorPosition(e, r) {
    const i = await this.getCurrentBlockHeight(), s = typeof r == "number" && r > i ? r : i;
    return this.cursors.set(e, s), s;
  }
  setFilterTimeout(e) {
    const r = this.timeouts.get(e);
    r && window.clearTimeout(r);
    const i = window.setTimeout(() => {
      console.log(`Filter (${e}) timed out`), this.deleteFilter(e);
    }, kV);
    this.timeouts.set(e, i);
  }
  async getCurrentBlockHeight() {
    const { result: e } = await this.sendAsyncPromise(Object.assign(Object.assign({}, Vo), { method: "eth_blockNumber", params: [] }));
    return (0, Gi.intNumberFromHexString)((0, Gi.ensureHexString)(e));
  }
  async getBlockHashByNumber(e) {
    const r = await this.sendAsyncPromise(Object.assign(Object.assign({}, Vo), { method: "eth_getBlockByNumber", params: [(0, Gi.hexStringFromIntNumber)(e), !1] }));
    return r.result && typeof r.result.hash == "string" ? (0, Gi.ensureHexString)(r.result.hash) : null;
  }
}
Ec.FilterPolyfill = jV;
function P9(t) {
  return {
    fromBlock: K4(t.fromBlock),
    toBlock: K4(t.toBlock),
    addresses: t.address === void 0 ? null : Array.isArray(t.address) ? t.address : [t.address],
    topics: t.topics || []
  };
}
Ec.filterFromParam = P9;
function G4(t) {
  const e = {
    fromBlock: Y4(t.fromBlock),
    toBlock: Y4(t.toBlock),
    topics: t.topics
  };
  return t.addresses !== null && (e.address = t.addresses), e;
}
function K4(t) {
  if (t === void 0 || t === "latest" || t === "pending")
    return "latest";
  if (t === "earliest")
    return (0, ec.IntNumber)(0);
  if ((0, Gi.isHexString)(t))
    return (0, Gi.intNumberFromHexString)(t);
  throw new Error(`Invalid block option: ${String(t)}`);
}
function Y4(t) {
  return t === "latest" ? t : (0, Gi.hexStringFromIntNumber)(t);
}
function md() {
  return Object.assign(Object.assign({}, Vo), { error: { code: -32e3, message: "filter not found" } });
}
function wd() {
  return Object.assign(Object.assign({}, Vo), { result: [] });
}
var k9 = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.JSONRPCMethod = void 0, function(e) {
    e.eth_accounts = "eth_accounts", e.eth_coinbase = "eth_coinbase", e.net_version = "net_version", e.eth_chainId = "eth_chainId", e.eth_uninstallFilter = "eth_uninstallFilter", e.eth_requestAccounts = "eth_requestAccounts", e.eth_sign = "eth_sign", e.eth_ecRecover = "eth_ecRecover", e.personal_sign = "personal_sign", e.personal_ecRecover = "personal_ecRecover", e.eth_signTransaction = "eth_signTransaction", e.eth_sendRawTransaction = "eth_sendRawTransaction", e.eth_sendTransaction = "eth_sendTransaction", e.eth_signTypedData_v1 = "eth_signTypedData_v1", e.eth_signTypedData_v2 = "eth_signTypedData_v2", e.eth_signTypedData_v3 = "eth_signTypedData_v3", e.eth_signTypedData_v4 = "eth_signTypedData_v4", e.eth_signTypedData = "eth_signTypedData", e.cbWallet_arbitrary = "walletlink_arbitrary", e.wallet_addEthereumChain = "wallet_addEthereumChain", e.wallet_switchEthereumChain = "wallet_switchEthereumChain", e.wallet_watchAsset = "wallet_watchAsset", e.eth_subscribe = "eth_subscribe", e.eth_unsubscribe = "eth_unsubscribe", e.eth_newFilter = "eth_newFilter", e.eth_newBlockFilter = "eth_newBlockFilter", e.eth_newPendingTransactionFilter = "eth_newPendingTransactionFilter", e.eth_getFilterChanges = "eth_getFilterChanges", e.eth_getFilterLogs = "eth_getFilterLogs";
  }(t.JSONRPCMethod || (t.JSONRPCMethod = {}));
})(k9);
var up = {};
const Q4 = (t, e) => function() {
  const r = e.promiseModule, i = new Array(arguments.length);
  for (let s = 0; s < arguments.length; s++)
    i[s] = arguments[s];
  return new r((s, n) => {
    e.errorFirst ? i.push(function(f, u) {
      if (e.multiArgs) {
        const h = new Array(arguments.length - 1);
        for (let d = 1; d < arguments.length; d++)
          h[d - 1] = arguments[d];
        f ? (h.unshift(f), n(h)) : s(h);
      } else
        f ? n(f) : s(u);
    }) : i.push(function(f) {
      if (e.multiArgs) {
        const u = new Array(arguments.length - 1);
        for (let h = 0; h < arguments.length; h++)
          u[h] = arguments[h];
        s(u);
      } else
        s(f);
    }), t.apply(this, i);
  });
};
var BV = (t, e) => {
  e = Object.assign({
    exclude: [/.+(Sync|Stream)$/],
    errorFirst: !0,
    promiseModule: Promise
  }, e);
  const r = (s) => {
    const n = (f) => typeof f == "string" ? s === f : f.test(s);
    return e.include ? e.include.some(n) : !e.exclude.some(n);
  };
  let i;
  typeof t == "function" ? i = function() {
    return e.excludeMain ? t.apply(this, arguments) : Q4(t, e).apply(this, arguments);
  } : i = Object.create(Object.getPrototypeOf(t));
  for (const s in t) {
    const n = t[s];
    i[s] = typeof n == "function" && r(s) ? Q4(n, e) : n;
  }
  return i;
}, zV = FV, UV = Object.prototype.hasOwnProperty;
function FV() {
  for (var t = {}, e = 0; e < arguments.length; e++) {
    var r = arguments[e];
    for (var i in r)
      UV.call(r, i) && (t[i] = r[i]);
  }
  return t;
}
var $V = qV;
function qV(t) {
  t = t || {};
  var e = t.max || Number.MAX_SAFE_INTEGER, r = typeof t.start < "u" ? t.start : Math.floor(Math.random() * e);
  return function() {
    return r = r % e, r++;
  };
}
const HV = zV, WV = $V();
var VV = Ct;
function Ct(t) {
  const e = this;
  e.currentProvider = t;
}
Ct.prototype.getBalance = Fh(2, "eth_getBalance");
Ct.prototype.getCode = Fh(2, "eth_getCode");
Ct.prototype.getTransactionCount = Fh(2, "eth_getTransactionCount");
Ct.prototype.getStorageAt = Fh(3, "eth_getStorageAt");
Ct.prototype.call = Fh(2, "eth_call");
Ct.prototype.protocolVersion = Gt("eth_protocolVersion");
Ct.prototype.syncing = Gt("eth_syncing");
Ct.prototype.coinbase = Gt("eth_coinbase");
Ct.prototype.mining = Gt("eth_mining");
Ct.prototype.hashrate = Gt("eth_hashrate");
Ct.prototype.gasPrice = Gt("eth_gasPrice");
Ct.prototype.accounts = Gt("eth_accounts");
Ct.prototype.blockNumber = Gt("eth_blockNumber");
Ct.prototype.getBlockTransactionCountByHash = Gt("eth_getBlockTransactionCountByHash");
Ct.prototype.getBlockTransactionCountByNumber = Gt("eth_getBlockTransactionCountByNumber");
Ct.prototype.getUncleCountByBlockHash = Gt("eth_getUncleCountByBlockHash");
Ct.prototype.getUncleCountByBlockNumber = Gt("eth_getUncleCountByBlockNumber");
Ct.prototype.sign = Gt("eth_sign");
Ct.prototype.sendTransaction = Gt("eth_sendTransaction");
Ct.prototype.sendRawTransaction = Gt("eth_sendRawTransaction");
Ct.prototype.estimateGas = Gt("eth_estimateGas");
Ct.prototype.getBlockByHash = Gt("eth_getBlockByHash");
Ct.prototype.getBlockByNumber = Gt("eth_getBlockByNumber");
Ct.prototype.getTransactionByHash = Gt("eth_getTransactionByHash");
Ct.prototype.getTransactionByBlockHashAndIndex = Gt("eth_getTransactionByBlockHashAndIndex");
Ct.prototype.getTransactionByBlockNumberAndIndex = Gt("eth_getTransactionByBlockNumberAndIndex");
Ct.prototype.getTransactionReceipt = Gt("eth_getTransactionReceipt");
Ct.prototype.getUncleByBlockHashAndIndex = Gt("eth_getUncleByBlockHashAndIndex");
Ct.prototype.getUncleByBlockNumberAndIndex = Gt("eth_getUncleByBlockNumberAndIndex");
Ct.prototype.getCompilers = Gt("eth_getCompilers");
Ct.prototype.compileLLL = Gt("eth_compileLLL");
Ct.prototype.compileSolidity = Gt("eth_compileSolidity");
Ct.prototype.compileSerpent = Gt("eth_compileSerpent");
Ct.prototype.newFilter = Gt("eth_newFilter");
Ct.prototype.newBlockFilter = Gt("eth_newBlockFilter");
Ct.prototype.newPendingTransactionFilter = Gt("eth_newPendingTransactionFilter");
Ct.prototype.uninstallFilter = Gt("eth_uninstallFilter");
Ct.prototype.getFilterChanges = Gt("eth_getFilterChanges");
Ct.prototype.getFilterLogs = Gt("eth_getFilterLogs");
Ct.prototype.getLogs = Gt("eth_getLogs");
Ct.prototype.getWork = Gt("eth_getWork");
Ct.prototype.submitWork = Gt("eth_submitWork");
Ct.prototype.submitHashrate = Gt("eth_submitHashrate");
Ct.prototype.sendAsync = function(t, e) {
  this.currentProvider.sendAsync(GV(t), function(i, s) {
    if (!i && s.error && (i = new Error("EthQuery - RPC Error - " + s.error.message)), i)
      return e(i);
    e(null, s.result);
  });
};
function Gt(t) {
  return function() {
    const e = this;
    var r = [].slice.call(arguments), i = r.pop();
    e.sendAsync({
      method: t,
      params: r
    }, i);
  };
}
function Fh(t, e) {
  return function() {
    const r = this;
    var i = [].slice.call(arguments), s = i.pop();
    i.length < t && i.push("latest"), r.sendAsync({
      method: e,
      params: i
    }, s);
  };
}
function GV(t) {
  return HV({
    id: WV(),
    jsonrpc: "2.0",
    params: []
  }, t);
}
var j9 = {}, B9 = {}, KV = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, r = Symbol("test"), i = Object(r);
  if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(i) !== "[object Symbol]")
    return !1;
  var s = 42;
  e[r] = s;
  for (r in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var n = Object.getOwnPropertySymbols(e);
  if (n.length !== 1 || n[0] !== r || !Object.prototype.propertyIsEnumerable.call(e, r))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var f = Object.getOwnPropertyDescriptor(e, r);
    if (f.value !== s || f.enumerable !== !0)
      return !1;
  }
  return !0;
}, YV = KV, $h = function() {
  return YV() && !!Symbol.toStringTag;
}, QV = $h(), ZV = jh, gm = ZV("Object.prototype.toString"), hp = function(e) {
  return QV && e && typeof e == "object" && Symbol.toStringTag in e ? !1 : gm(e) === "[object Arguments]";
}, z9 = function(e) {
  return hp(e) ? !0 : e !== null && typeof e == "object" && typeof e.length == "number" && e.length >= 0 && gm(e) !== "[object Array]" && gm(e.callee) === "[object Function]";
}, JV = function() {
  return hp(arguments);
}();
hp.isLegacyArguments = z9;
var XV = JV ? hp : z9, eG = Object.prototype.toString, tG = Function.prototype.toString, rG = /^\s*(?:function)?\*/, U9 = $h(), Kv = Object.getPrototypeOf, iG = function() {
  if (!U9)
    return !1;
  try {
    return Function("return function*() {}")();
  } catch {
  }
}, Yv, nG = function(e) {
  if (typeof e != "function")
    return !1;
  if (rG.test(tG.call(e)))
    return !0;
  if (!U9) {
    var r = eG.call(e);
    return r === "[object GeneratorFunction]";
  }
  if (!Kv)
    return !1;
  if (typeof Yv > "u") {
    var i = iG();
    Yv = i ? Kv(i) : !1;
  }
  return Kv(e) === Yv;
}, sG = Object.prototype.hasOwnProperty, aG = Object.prototype.toString, E2 = function(e, r, i) {
  if (aG.call(r) !== "[object Function]")
    throw new TypeError("iterator must be a function");
  var s = e.length;
  if (s === +s)
    for (var n = 0; n < s; n++)
      r.call(i, e[n], n, e);
  else
    for (var f in e)
      sG.call(e, f) && r.call(i, e[f], f, e);
}, Qv = [
  "BigInt64Array",
  "BigUint64Array",
  "Float32Array",
  "Float64Array",
  "Int16Array",
  "Int32Array",
  "Int8Array",
  "Uint16Array",
  "Uint32Array",
  "Uint8Array",
  "Uint8ClampedArray"
], oG = typeof globalThis > "u" ? nt : globalThis, I2 = function() {
  for (var e = [], r = 0; r < Qv.length; r++)
    typeof oG[Qv[r]] == "function" && (e[e.length] = Qv[r]);
  return e;
}, Zv, Z4;
function A2() {
  if (Z4)
    return Zv;
  Z4 = 1;
  var t = sp, e = t("%Object.getOwnPropertyDescriptor%", !0);
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  return Zv = e, Zv;
}
var Jv, J4;
function fG() {
  if (J4)
    return Jv;
  J4 = 1;
  var t = E2, e = I2, r = jh, i = r("Object.prototype.toString"), s = $h(), n = typeof globalThis > "u" ? nt : globalThis, f = e(), u = r("Array.prototype.indexOf", !0) || function(A, N) {
    for (var R = 0; R < A.length; R += 1)
      if (A[R] === N)
        return R;
    return -1;
  }, h = r("String.prototype.slice"), d = {}, l = A2(), m = Object.getPrototypeOf;
  s && l && m && t(f, function(M) {
    var A = new n[M]();
    if (Symbol.toStringTag in A) {
      var N = m(A), R = l(N, Symbol.toStringTag);
      if (!R) {
        var O = m(N);
        R = l(O, Symbol.toStringTag);
      }
      d[M] = R.get;
    }
  });
  var b = function(A) {
    var N = !1;
    return t(d, function(R, O) {
      if (!N)
        try {
          N = R.call(A) === O;
        } catch {
        }
    }), N;
  };
  return Jv = function(A) {
    if (!A || typeof A != "object")
      return !1;
    if (!s || !(Symbol.toStringTag in A)) {
      var N = h(i(A), 8, -1);
      return u(f, N) > -1;
    }
    return l ? b(A) : !1;
  }, Jv;
}
var F9 = E2, cG = I2, $9 = jh, uG = $9("Object.prototype.toString"), q9 = $h(), X4 = typeof globalThis > "u" ? nt : globalThis, hG = cG(), lG = $9("String.prototype.slice"), H9 = {}, Xv = A2(), eg = Object.getPrototypeOf;
q9 && Xv && eg && F9(hG, function(t) {
  if (typeof X4[t] == "function") {
    var e = new X4[t]();
    if (Symbol.toStringTag in e) {
      var r = eg(e), i = Xv(r, Symbol.toStringTag);
      if (!i) {
        var s = eg(r);
        i = Xv(s, Symbol.toStringTag);
      }
      H9[t] = i.get;
    }
  }
});
var dG = function(e) {
  var r = !1;
  return F9(H9, function(i, s) {
    if (!r)
      try {
        var n = i.call(e);
        n === s && (r = n);
      } catch {
      }
  }), r;
}, pG = fG(), vG = function(e) {
  return pG(e) ? !q9 || !(Symbol.toStringTag in e) ? lG(uG(e), 8, -1) : dG(e) : !1;
}, W9 = E2, gG = I2, T2 = jh, bG = T2("Object.prototype.toString"), V9 = $h(), yG = typeof globalThis > "u" ? nt : globalThis, G9 = gG(), mG = T2("Array.prototype.indexOf", !0) || function(e, r) {
  for (var i = 0; i < e.length; i += 1)
    if (e[i] === r)
      return i;
  return -1;
}, wG = T2("String.prototype.slice"), K9 = {}, Kd = A2(), tg = Object.getPrototypeOf;
V9 && Kd && tg && W9(G9, function(t) {
  var e = new yG[t]();
  if (Symbol.toStringTag in e) {
    var r = tg(e), i = Kd(r, Symbol.toStringTag);
    if (!i) {
      var s = tg(r);
      i = Kd(s, Symbol.toStringTag);
    }
    K9[t] = i.get;
  }
});
var _G = function(e) {
  var r = !1;
  return W9(K9, function(i, s) {
    if (!r)
      try {
        r = i.call(e) === s;
      } catch {
      }
  }), r;
}, MG = function(e) {
  if (!e || typeof e != "object")
    return !1;
  if (!V9 || !(Symbol.toStringTag in e)) {
    var r = wG(bG(e), 8, -1);
    return mG(G9, r) > -1;
  }
  return Kd ? _G(e) : !1;
};
(function(t) {
  var e = XV, r = nG, i = vG, s = MG;
  function n(re) {
    return re.call.bind(re);
  }
  var f = typeof BigInt < "u", u = typeof Symbol < "u", h = n(Object.prototype.toString), d = n(Number.prototype.valueOf), l = n(String.prototype.valueOf), m = n(Boolean.prototype.valueOf);
  if (f)
    var b = n(BigInt.prototype.valueOf);
  if (u)
    var M = n(Symbol.prototype.valueOf);
  function A(re, fe) {
    if (typeof re != "object")
      return !1;
    try {
      return fe(re), !0;
    } catch {
      return !1;
    }
  }
  t.isArgumentsObject = e, t.isGeneratorFunction = r, t.isTypedArray = s;
  function N(re) {
    return typeof Promise < "u" && re instanceof Promise || re !== null && typeof re == "object" && typeof re.then == "function" && typeof re.catch == "function";
  }
  t.isPromise = N;
  function R(re) {
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(re) : s(re) || S(re);
  }
  t.isArrayBufferView = R;
  function O(re) {
    return i(re) === "Uint8Array";
  }
  t.isUint8Array = O;
  function P(re) {
    return i(re) === "Uint8ClampedArray";
  }
  t.isUint8ClampedArray = P;
  function F(re) {
    return i(re) === "Uint16Array";
  }
  t.isUint16Array = F;
  function H(re) {
    return i(re) === "Uint32Array";
  }
  t.isUint32Array = H;
  function Q(re) {
    return i(re) === "Int8Array";
  }
  t.isInt8Array = Q;
  function Z(re) {
    return i(re) === "Int16Array";
  }
  t.isInt16Array = Z;
  function B(re) {
    return i(re) === "Int32Array";
  }
  t.isInt32Array = B;
  function Y(re) {
    return i(re) === "Float32Array";
  }
  t.isFloat32Array = Y;
  function ae(re) {
    return i(re) === "Float64Array";
  }
  t.isFloat64Array = ae;
  function se(re) {
    return i(re) === "BigInt64Array";
  }
  t.isBigInt64Array = se;
  function W(re) {
    return i(re) === "BigUint64Array";
  }
  t.isBigUint64Array = W;
  function C(re) {
    return h(re) === "[object Map]";
  }
  C.working = typeof Map < "u" && C(/* @__PURE__ */ new Map());
  function g(re) {
    return typeof Map > "u" ? !1 : C.working ? C(re) : re instanceof Map;
  }
  t.isMap = g;
  function a(re) {
    return h(re) === "[object Set]";
  }
  a.working = typeof Set < "u" && a(/* @__PURE__ */ new Set());
  function c(re) {
    return typeof Set > "u" ? !1 : a.working ? a(re) : re instanceof Set;
  }
  t.isSet = c;
  function p(re) {
    return h(re) === "[object WeakMap]";
  }
  p.working = typeof WeakMap < "u" && p(/* @__PURE__ */ new WeakMap());
  function w(re) {
    return typeof WeakMap > "u" ? !1 : p.working ? p(re) : re instanceof WeakMap;
  }
  t.isWeakMap = w;
  function _(re) {
    return h(re) === "[object WeakSet]";
  }
  _.working = typeof WeakSet < "u" && _(/* @__PURE__ */ new WeakSet());
  function x(re) {
    return _(re);
  }
  t.isWeakSet = x;
  function E(re) {
    return h(re) === "[object ArrayBuffer]";
  }
  E.working = typeof ArrayBuffer < "u" && E(new ArrayBuffer());
  function y(re) {
    return typeof ArrayBuffer > "u" ? !1 : E.working ? E(re) : re instanceof ArrayBuffer;
  }
  t.isArrayBuffer = y;
  function o(re) {
    return h(re) === "[object DataView]";
  }
  o.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && o(new DataView(new ArrayBuffer(1), 0, 1));
  function S(re) {
    return typeof DataView > "u" ? !1 : o.working ? o(re) : re instanceof DataView;
  }
  t.isDataView = S;
  var J = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
  function z(re) {
    return h(re) === "[object SharedArrayBuffer]";
  }
  function k(re) {
    return typeof J > "u" ? !1 : (typeof z.working > "u" && (z.working = z(new J())), z.working ? z(re) : re instanceof J);
  }
  t.isSharedArrayBuffer = k;
  function j(re) {
    return h(re) === "[object AsyncFunction]";
  }
  t.isAsyncFunction = j;
  function q(re) {
    return h(re) === "[object Map Iterator]";
  }
  t.isMapIterator = q;
  function K(re) {
    return h(re) === "[object Set Iterator]";
  }
  t.isSetIterator = K;
  function U(re) {
    return h(re) === "[object Generator]";
  }
  t.isGeneratorObject = U;
  function T(re) {
    return h(re) === "[object WebAssembly.Module]";
  }
  t.isWebAssemblyCompiledModule = T;
  function D(re) {
    return A(re, d);
  }
  t.isNumberObject = D;
  function te(re) {
    return A(re, l);
  }
  t.isStringObject = te;
  function ne(re) {
    return A(re, m);
  }
  t.isBooleanObject = ne;
  function le(re) {
    return f && A(re, b);
  }
  t.isBigIntObject = le;
  function X(re) {
    return u && A(re, M);
  }
  t.isSymbolObject = X;
  function $(re) {
    return D(re) || te(re) || ne(re) || le(re) || X(re);
  }
  t.isBoxedPrimitive = $;
  function V(re) {
    return typeof Uint8Array < "u" && (y(re) || k(re));
  }
  t.isAnyArrayBuffer = V, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(re) {
    Object.defineProperty(t, re, {
      enumerable: !1,
      value: function() {
        throw new Error(re + " is not supported in userland");
      }
    });
  });
})(B9);
var xG = function(e) {
  return e && typeof e == "object" && typeof e.copy == "function" && typeof e.fill == "function" && typeof e.readUInt8 == "function";
};
(function(t) {
  var e = Object.getOwnPropertyDescriptors || function(S) {
    for (var J = Object.keys(S), z = {}, k = 0; k < J.length; k++)
      z[J[k]] = Object.getOwnPropertyDescriptor(S, J[k]);
    return z;
  }, r = /%[sdj%]/g;
  t.format = function(o) {
    if (!Q(o)) {
      for (var S = [], J = 0; J < arguments.length; J++)
        S.push(f(arguments[J]));
      return S.join(" ");
    }
    for (var J = 1, z = arguments, k = z.length, j = String(o).replace(r, function(K) {
      if (K === "%%")
        return "%";
      if (J >= k)
        return K;
      switch (K) {
        case "%s":
          return String(z[J++]);
        case "%d":
          return Number(z[J++]);
        case "%j":
          try {
            return JSON.stringify(z[J++]);
          } catch {
            return "[Circular]";
          }
        default:
          return K;
      }
    }), q = z[J]; J < k; q = z[++J])
      P(q) || !ae(q) ? j += " " + q : j += " " + f(q);
    return j;
  }, t.deprecate = function(o, S) {
    if (typeof process < "u" && process.noDeprecation === !0)
      return o;
    if (typeof process > "u")
      return function() {
        return t.deprecate(o, S).apply(this, arguments);
      };
    var J = !1;
    function z() {
      if (!J) {
        if (process.throwDeprecation)
          throw new Error(S);
        process.traceDeprecation ? console.trace(S) : console.error(S), J = !0;
      }
      return o.apply(this, arguments);
    }
    return z;
  };
  var i = {}, s = /^$/;
  if (process.env.NODE_DEBUG) {
    var n = process.env.NODE_DEBUG;
    n = n.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), s = new RegExp("^" + n + "$", "i");
  }
  t.debuglog = function(o) {
    if (o = o.toUpperCase(), !i[o])
      if (s.test(o)) {
        var S = process.pid;
        i[o] = function() {
          var J = t.format.apply(t, arguments);
          console.error("%s %d: %s", o, S, J);
        };
      } else
        i[o] = function() {
        };
    return i[o];
  };
  function f(o, S) {
    var J = {
      seen: [],
      stylize: h
    };
    return arguments.length >= 3 && (J.depth = arguments[2]), arguments.length >= 4 && (J.colors = arguments[3]), O(S) ? J.showHidden = S : S && t._extend(J, S), B(J.showHidden) && (J.showHidden = !1), B(J.depth) && (J.depth = 2), B(J.colors) && (J.colors = !1), B(J.customInspect) && (J.customInspect = !0), J.colors && (J.stylize = u), l(J, o, J.depth);
  }
  t.inspect = f, f.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, f.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    regexp: "red"
  };
  function u(o, S) {
    var J = f.styles[S];
    return J ? "\x1B[" + f.colors[J][0] + "m" + o + "\x1B[" + f.colors[J][1] + "m" : o;
  }
  function h(o, S) {
    return o;
  }
  function d(o) {
    var S = {};
    return o.forEach(function(J, z) {
      S[J] = !0;
    }), S;
  }
  function l(o, S, J) {
    if (o.customInspect && S && C(S.inspect) && S.inspect !== t.inspect && !(S.constructor && S.constructor.prototype === S)) {
      var z = S.inspect(J, o);
      return Q(z) || (z = l(o, z, J)), z;
    }
    var k = m(o, S);
    if (k)
      return k;
    var j = Object.keys(S), q = d(j);
    if (o.showHidden && (j = Object.getOwnPropertyNames(S)), W(S) && (j.indexOf("message") >= 0 || j.indexOf("description") >= 0))
      return b(S);
    if (j.length === 0) {
      if (C(S)) {
        var K = S.name ? ": " + S.name : "";
        return o.stylize("[Function" + K + "]", "special");
      }
      if (Y(S))
        return o.stylize(RegExp.prototype.toString.call(S), "regexp");
      if (se(S))
        return o.stylize(Date.prototype.toString.call(S), "date");
      if (W(S))
        return b(S);
    }
    var U = "", T = !1, D = ["{", "}"];
    if (R(S) && (T = !0, D = ["[", "]"]), C(S)) {
      var te = S.name ? ": " + S.name : "";
      U = " [Function" + te + "]";
    }
    if (Y(S) && (U = " " + RegExp.prototype.toString.call(S)), se(S) && (U = " " + Date.prototype.toUTCString.call(S)), W(S) && (U = " " + b(S)), j.length === 0 && (!T || S.length == 0))
      return D[0] + U + D[1];
    if (J < 0)
      return Y(S) ? o.stylize(RegExp.prototype.toString.call(S), "regexp") : o.stylize("[Object]", "special");
    o.seen.push(S);
    var ne;
    return T ? ne = M(o, S, J, q, j) : ne = j.map(function(le) {
      return A(o, S, J, q, le, T);
    }), o.seen.pop(), N(ne, U, D);
  }
  function m(o, S) {
    if (B(S))
      return o.stylize("undefined", "undefined");
    if (Q(S)) {
      var J = "'" + JSON.stringify(S).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return o.stylize(J, "string");
    }
    if (H(S))
      return o.stylize("" + S, "number");
    if (O(S))
      return o.stylize("" + S, "boolean");
    if (P(S))
      return o.stylize("null", "null");
  }
  function b(o) {
    return "[" + Error.prototype.toString.call(o) + "]";
  }
  function M(o, S, J, z, k) {
    for (var j = [], q = 0, K = S.length; q < K; ++q)
      _(S, String(q)) ? j.push(A(
        o,
        S,
        J,
        z,
        String(q),
        !0
      )) : j.push("");
    return k.forEach(function(U) {
      U.match(/^\d+$/) || j.push(A(
        o,
        S,
        J,
        z,
        U,
        !0
      ));
    }), j;
  }
  function A(o, S, J, z, k, j) {
    var q, K, U;
    if (U = Object.getOwnPropertyDescriptor(S, k) || { value: S[k] }, U.get ? U.set ? K = o.stylize("[Getter/Setter]", "special") : K = o.stylize("[Getter]", "special") : U.set && (K = o.stylize("[Setter]", "special")), _(z, k) || (q = "[" + k + "]"), K || (o.seen.indexOf(U.value) < 0 ? (P(J) ? K = l(o, U.value, null) : K = l(o, U.value, J - 1), K.indexOf(`
`) > -1 && (j ? K = K.split(`
`).map(function(T) {
      return "  " + T;
    }).join(`
`).slice(2) : K = `
` + K.split(`
`).map(function(T) {
      return "   " + T;
    }).join(`
`))) : K = o.stylize("[Circular]", "special")), B(q)) {
      if (j && k.match(/^\d+$/))
        return K;
      q = JSON.stringify("" + k), q.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (q = q.slice(1, -1), q = o.stylize(q, "name")) : (q = q.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), q = o.stylize(q, "string"));
    }
    return q + ": " + K;
  }
  function N(o, S, J) {
    var z = o.reduce(function(k, j) {
      return j.indexOf(`
`) >= 0, k + j.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    return z > 60 ? J[0] + (S === "" ? "" : S + `
 `) + " " + o.join(`,
  `) + " " + J[1] : J[0] + S + " " + o.join(", ") + " " + J[1];
  }
  t.types = B9;
  function R(o) {
    return Array.isArray(o);
  }
  t.isArray = R;
  function O(o) {
    return typeof o == "boolean";
  }
  t.isBoolean = O;
  function P(o) {
    return o === null;
  }
  t.isNull = P;
  function F(o) {
    return o == null;
  }
  t.isNullOrUndefined = F;
  function H(o) {
    return typeof o == "number";
  }
  t.isNumber = H;
  function Q(o) {
    return typeof o == "string";
  }
  t.isString = Q;
  function Z(o) {
    return typeof o == "symbol";
  }
  t.isSymbol = Z;
  function B(o) {
    return o === void 0;
  }
  t.isUndefined = B;
  function Y(o) {
    return ae(o) && a(o) === "[object RegExp]";
  }
  t.isRegExp = Y, t.types.isRegExp = Y;
  function ae(o) {
    return typeof o == "object" && o !== null;
  }
  t.isObject = ae;
  function se(o) {
    return ae(o) && a(o) === "[object Date]";
  }
  t.isDate = se, t.types.isDate = se;
  function W(o) {
    return ae(o) && (a(o) === "[object Error]" || o instanceof Error);
  }
  t.isError = W, t.types.isNativeError = W;
  function C(o) {
    return typeof o == "function";
  }
  t.isFunction = C;
  function g(o) {
    return o === null || typeof o == "boolean" || typeof o == "number" || typeof o == "string" || typeof o == "symbol" || typeof o > "u";
  }
  t.isPrimitive = g, t.isBuffer = xG;
  function a(o) {
    return Object.prototype.toString.call(o);
  }
  function c(o) {
    return o < 10 ? "0" + o.toString(10) : o.toString(10);
  }
  var p = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  function w() {
    var o = new Date(), S = [
      c(o.getHours()),
      c(o.getMinutes()),
      c(o.getSeconds())
    ].join(":");
    return [o.getDate(), p[o.getMonth()], S].join(" ");
  }
  t.log = function() {
    console.log("%s - %s", w(), t.format.apply(t, arguments));
  }, t.inherits = It.exports, t._extend = function(o, S) {
    if (!S || !ae(S))
      return o;
    for (var J = Object.keys(S), z = J.length; z--; )
      o[J[z]] = S[J[z]];
    return o;
  };
  function _(o, S) {
    return Object.prototype.hasOwnProperty.call(o, S);
  }
  var x = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
  t.promisify = function(S) {
    if (typeof S != "function")
      throw new TypeError('The "original" argument must be of type Function');
    if (x && S[x]) {
      var J = S[x];
      if (typeof J != "function")
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(J, x, {
        value: J,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), J;
    }
    function J() {
      for (var z, k, j = new Promise(function(U, T) {
        z = U, k = T;
      }), q = [], K = 0; K < arguments.length; K++)
        q.push(arguments[K]);
      q.push(function(U, T) {
        U ? k(U) : z(T);
      });
      try {
        S.apply(this, q);
      } catch (U) {
        k(U);
      }
      return j;
    }
    return Object.setPrototypeOf(J, Object.getPrototypeOf(S)), x && Object.defineProperty(J, x, {
      value: J,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(
      J,
      e(S)
    );
  }, t.promisify.custom = x;
  function E(o, S) {
    if (!o) {
      var J = new Error("Promise was rejected with a falsy value");
      J.reason = o, o = J;
    }
    return S(o);
  }
  function y(o) {
    if (typeof o != "function")
      throw new TypeError('The "original" argument must be of type Function');
    function S() {
      for (var J = [], z = 0; z < arguments.length; z++)
        J.push(arguments[z]);
      var k = J.pop();
      if (typeof k != "function")
        throw new TypeError("The last argument must be of type Function");
      var j = this, q = function() {
        return k.apply(j, arguments);
      };
      o.apply(this, J).then(
        function(K) {
          process.nextTick(q.bind(null, null, K));
        },
        function(K) {
          process.nextTick(E.bind(null, K, q));
        }
      );
    }
    return Object.setPrototypeOf(S, Object.getPrototypeOf(o)), Object.defineProperties(
      S,
      e(o)
    ), S;
  }
  t.callbackify = y;
})(j9);
const SG = j9, Y9 = Pr.exports;
var rg = typeof Reflect == "object" ? Reflect : null, EG = rg && typeof rg.apply == "function" ? rg.apply : function(e, r, i) {
  return Function.prototype.apply.call(e, r, i);
}, IG = N2;
function N2() {
  Y9.call(this);
}
SG.inherits(N2, Y9);
N2.prototype.emit = function(t) {
  for (var e = [], r = 1; r < arguments.length; r++)
    e.push(arguments[r]);
  var i = t === "error", s = this._events;
  if (s !== void 0)
    i = i && s.error === void 0;
  else if (!i)
    return !1;
  if (i) {
    var n;
    if (e.length > 0 && (n = e[0]), n instanceof Error)
      throw n;
    var f = new Error("Unhandled error." + (n ? " (" + n.message + ")" : ""));
    throw f.context = n, f;
  }
  var u = s[t];
  if (u === void 0)
    return !1;
  if (typeof u == "function")
    e6(u, this, e);
  else
    for (var h = u.length, d = AG(u, h), r = 0; r < h; ++r)
      e6(d[r], this, e);
  return !0;
};
function e6(t, e, r) {
  try {
    EG(t, e, r);
  } catch (i) {
    setTimeout(() => {
      throw i;
    });
  }
}
function AG(t, e) {
  for (var r = new Array(e), i = 0; i < e; ++i)
    r[i] = t[i];
  return r;
}
const TG = IG, NG = 1e3, DG = (t, e) => t + e, t6 = ["sync", "latest"];
class CG extends TG {
  constructor(e = {}) {
    super(), this._blockResetDuration = e.blockResetDuration || 20 * NG, this._blockResetTimeout, this._currentBlock = null, this._isRunning = !1, this._onNewListener = this._onNewListener.bind(this), this._onRemoveListener = this._onRemoveListener.bind(this), this._resetCurrentBlock = this._resetCurrentBlock.bind(this), this._setupInternalEvents();
  }
  isRunning() {
    return this._isRunning;
  }
  getCurrentBlock() {
    return this._currentBlock;
  }
  async getLatestBlock() {
    return this._currentBlock ? this._currentBlock : await new Promise((r) => this.once("latest", r));
  }
  removeAllListeners(e) {
    e ? super.removeAllListeners(e) : super.removeAllListeners(), this._setupInternalEvents(), this._onRemoveListener();
  }
  _start() {
  }
  _end() {
  }
  _setupInternalEvents() {
    this.removeListener("newListener", this._onNewListener), this.removeListener("removeListener", this._onRemoveListener), this.on("newListener", this._onNewListener), this.on("removeListener", this._onRemoveListener);
  }
  _onNewListener(e, r) {
    !t6.includes(e) || this._maybeStart();
  }
  _onRemoveListener(e, r) {
    this._getBlockTrackerEventCount() > 0 || this._maybeEnd();
  }
  _maybeStart() {
    this._isRunning || (this._isRunning = !0, this._cancelBlockResetTimeout(), this._start());
  }
  _maybeEnd() {
    !this._isRunning || (this._isRunning = !1, this._setupBlockResetTimeout(), this._end());
  }
  _getBlockTrackerEventCount() {
    return t6.map((e) => this.listenerCount(e)).reduce(DG);
  }
  _newPotentialLatest(e) {
    const r = this._currentBlock;
    r && r6(e) <= r6(r) || this._setCurrentBlock(e);
  }
  _setCurrentBlock(e) {
    const r = this._currentBlock;
    this._currentBlock = e, this.emit("latest", e), this.emit("sync", { oldBlock: r, newBlock: e });
  }
  _setupBlockResetTimeout() {
    this._cancelBlockResetTimeout(), this._blockResetTimeout = setTimeout(this._resetCurrentBlock, this._blockResetDuration), this._blockResetTimeout.unref && this._blockResetTimeout.unref();
  }
  _cancelBlockResetTimeout() {
    clearTimeout(this._blockResetTimeout);
  }
  _resetCurrentBlock() {
    this._currentBlock = null;
  }
}
var OG = CG;
function r6(t) {
  return Number.parseInt(t, 16);
}
const RG = BV, LG = OG, PG = 1e3;
class kG extends LG {
  constructor(e = {}) {
    if (!e.provider)
      throw new Error("PollingBlockTracker - no provider specified.");
    const r = e.pollingInterval || 20 * PG, i = e.retryTimeout || r / 10, s = e.keepEventLoopActive !== void 0 ? e.keepEventLoopActive : !0, n = e.setSkipCacheFlag || !1;
    super(Object.assign({
      blockResetDuration: r
    }, e)), this._provider = e.provider, this._pollingInterval = r, this._retryTimeout = i, this._keepEventLoopActive = s, this._setSkipCacheFlag = n;
  }
  async checkForLatestBlock() {
    return await this._updateLatestBlock(), await this.getLatestBlock();
  }
  _start() {
    this._performSync().catch((e) => this.emit("error", e));
  }
  async _performSync() {
    for (; this._isRunning; )
      try {
        await this._updateLatestBlock(), await i6(this._pollingInterval, !this._keepEventLoopActive);
      } catch (e) {
        const r = new Error(`PollingBlockTracker - encountered an error while attempting to update latest block:
${e.stack}`);
        try {
          this.emit("error", r);
        } catch {
          console.error(r);
        }
        await i6(this._retryTimeout, !this._keepEventLoopActive);
      }
  }
  async _updateLatestBlock() {
    const e = await this._fetchLatestBlock();
    this._newPotentialLatest(e);
  }
  async _fetchLatestBlock() {
    const e = { jsonrpc: "2.0", id: 1, method: "eth_blockNumber", params: [] };
    this._setSkipCacheFlag && (e.skipCache = !0);
    const r = await RG((i) => this._provider.sendAsync(e, i))();
    if (r.error)
      throw new Error(`PollingBlockTracker - encountered error fetching block:
${r.error}`);
    return r.result;
  }
}
var jG = kG;
function i6(t, e) {
  return new Promise((r) => {
    const i = setTimeout(r, t);
    i.unref && e && i.unref();
  });
}
var D2 = { exports: {} }, BG = function(e) {
  return (r, i, s, n) => {
    const f = e[r.method];
    return f === void 0 ? s() : typeof f == "function" ? f(r, i, s, n) : (i.result = f, n());
  };
};
(function(t) {
  t.exports = BG;
})(D2);
var C2 = {}, lp = {}, qh = {};
Object.defineProperty(qh, "__esModule", { value: !0 });
qh.getUniqueId = void 0;
const Q9 = 4294967295;
let ig = Math.floor(Math.random() * Q9);
function zG() {
  return ig = (ig + 1) % Q9, ig;
}
qh.getUniqueId = zG;
Object.defineProperty(lp, "__esModule", { value: !0 });
lp.createIdRemapMiddleware = void 0;
const UG = qh;
function FG() {
  return (t, e, r, i) => {
    const s = t.id, n = UG.getUniqueId();
    t.id = n, e.id = n, r((f) => {
      t.id = s, e.id = s, f();
    });
  };
}
lp.createIdRemapMiddleware = FG;
var dp = {};
Object.defineProperty(dp, "__esModule", { value: !0 });
dp.createAsyncMiddleware = void 0;
function $G(t) {
  return async (e, r, i, s) => {
    let n;
    const f = new Promise((l) => {
      n = l;
    });
    let u = null, h = !1;
    const d = async () => {
      h = !0, i((l) => {
        u = l, n();
      }), await f;
    };
    try {
      await t(e, r, d), h ? (await f, u(null)) : s(null);
    } catch (l) {
      u ? u(l) : s(l);
    }
  };
}
dp.createAsyncMiddleware = $G;
var pp = {};
Object.defineProperty(pp, "__esModule", { value: !0 });
pp.createScaffoldMiddleware = void 0;
function qG(t) {
  return (e, r, i, s) => {
    const n = t[e.method];
    return n === void 0 ? i() : typeof n == "function" ? n(e, r, i, s) : (r.result = n, s());
  };
}
pp.createScaffoldMiddleware = qG;
var Hh = {}, Z9 = {}, uo = {};
Object.defineProperty(uo, "__esModule", { value: !0 });
uo.EthereumProviderError = uo.EthereumRpcError = void 0;
const HG = WS;
class J9 extends Error {
  constructor(e, r, i) {
    if (!Number.isInteger(e))
      throw new Error('"code" must be an integer.');
    if (!r || typeof r != "string")
      throw new Error('"message" must be a nonempty string.');
    super(r), this.code = e, i !== void 0 && (this.data = i);
  }
  serialize() {
    const e = {
      code: this.code,
      message: this.message
    };
    return this.data !== void 0 && (e.data = this.data), this.stack && (e.stack = this.stack), e;
  }
  toString() {
    return HG.default(this.serialize(), GG, 2);
  }
}
uo.EthereumRpcError = J9;
class WG extends J9 {
  constructor(e, r, i) {
    if (!VG(e))
      throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
    super(e, r, i);
  }
}
uo.EthereumProviderError = WG;
function VG(t) {
  return Number.isInteger(t) && t >= 1e3 && t <= 4999;
}
function GG(t, e) {
  if (e !== "[Circular]")
    return e;
}
var O2 = {}, ho = {};
Object.defineProperty(ho, "__esModule", { value: !0 });
ho.errorValues = ho.errorCodes = void 0;
ho.errorCodes = {
  rpc: {
    invalidInput: -32e3,
    resourceNotFound: -32001,
    resourceUnavailable: -32002,
    transactionRejected: -32003,
    methodNotSupported: -32004,
    limitExceeded: -32005,
    parse: -32700,
    invalidRequest: -32600,
    methodNotFound: -32601,
    invalidParams: -32602,
    internal: -32603
  },
  provider: {
    userRejectedRequest: 4001,
    unauthorized: 4100,
    unsupportedMethod: 4200,
    disconnected: 4900,
    chainDisconnected: 4901
  }
};
ho.errorValues = {
  "-32700": {
    standard: "JSON RPC 2.0",
    message: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
  },
  "-32600": {
    standard: "JSON RPC 2.0",
    message: "The JSON sent is not a valid Request object."
  },
  "-32601": {
    standard: "JSON RPC 2.0",
    message: "The method does not exist / is not available."
  },
  "-32602": {
    standard: "JSON RPC 2.0",
    message: "Invalid method parameter(s)."
  },
  "-32603": {
    standard: "JSON RPC 2.0",
    message: "Internal JSON-RPC error."
  },
  "-32000": {
    standard: "EIP-1474",
    message: "Invalid input."
  },
  "-32001": {
    standard: "EIP-1474",
    message: "Resource not found."
  },
  "-32002": {
    standard: "EIP-1474",
    message: "Resource unavailable."
  },
  "-32003": {
    standard: "EIP-1474",
    message: "Transaction rejected."
  },
  "-32004": {
    standard: "EIP-1474",
    message: "Method not supported."
  },
  "-32005": {
    standard: "EIP-1474",
    message: "Request limit exceeded."
  },
  4001: {
    standard: "EIP-1193",
    message: "User rejected the request."
  },
  4100: {
    standard: "EIP-1193",
    message: "The requested account and/or method has not been authorized by the user."
  },
  4200: {
    standard: "EIP-1193",
    message: "The requested method is not supported by this Ethereum provider."
  },
  4900: {
    standard: "EIP-1193",
    message: "The provider is disconnected from all chains."
  },
  4901: {
    standard: "EIP-1193",
    message: "The provider is disconnected from the specified chain."
  }
};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.serializeError = t.isValidCode = t.getMessageFromCode = t.JSON_RPC_SERVER_ERROR_MESSAGE = void 0;
  const e = ho, r = uo, i = e.errorCodes.rpc.internal, s = "Unspecified error message. This is a bug, please report it.", n = {
    code: i,
    message: f(i)
  };
  t.JSON_RPC_SERVER_ERROR_MESSAGE = "Unspecified server error.";
  function f(b, M = s) {
    if (Number.isInteger(b)) {
      const A = b.toString();
      if (m(e.errorValues, A))
        return e.errorValues[A].message;
      if (d(b))
        return t.JSON_RPC_SERVER_ERROR_MESSAGE;
    }
    return M;
  }
  t.getMessageFromCode = f;
  function u(b) {
    if (!Number.isInteger(b))
      return !1;
    const M = b.toString();
    return !!(e.errorValues[M] || d(b));
  }
  t.isValidCode = u;
  function h(b, { fallbackError: M = n, shouldIncludeStack: A = !1 } = {}) {
    var N, R;
    if (!M || !Number.isInteger(M.code) || typeof M.message != "string")
      throw new Error("Must provide fallback error with integer number code and string message.");
    if (b instanceof r.EthereumRpcError)
      return b.serialize();
    const O = {};
    if (b && typeof b == "object" && !Array.isArray(b) && m(b, "code") && u(b.code)) {
      const F = b;
      O.code = F.code, F.message && typeof F.message == "string" ? (O.message = F.message, m(F, "data") && (O.data = F.data)) : (O.message = f(O.code), O.data = { originalError: l(b) });
    } else {
      O.code = M.code;
      const F = (N = b) === null || N === void 0 ? void 0 : N.message;
      O.message = F && typeof F == "string" ? F : M.message, O.data = { originalError: l(b) };
    }
    const P = (R = b) === null || R === void 0 ? void 0 : R.stack;
    return A && b && P && typeof P == "string" && (O.stack = P), O;
  }
  t.serializeError = h;
  function d(b) {
    return b >= -32099 && b <= -32e3;
  }
  function l(b) {
    return b && typeof b == "object" && !Array.isArray(b) ? Object.assign({}, b) : b;
  }
  function m(b, M) {
    return Object.prototype.hasOwnProperty.call(b, M);
  }
})(O2);
var vp = {};
Object.defineProperty(vp, "__esModule", { value: !0 });
vp.ethErrors = void 0;
const R2 = uo, X9 = O2, Li = ho;
vp.ethErrors = {
  rpc: {
    parse: (t) => $n(Li.errorCodes.rpc.parse, t),
    invalidRequest: (t) => $n(Li.errorCodes.rpc.invalidRequest, t),
    invalidParams: (t) => $n(Li.errorCodes.rpc.invalidParams, t),
    methodNotFound: (t) => $n(Li.errorCodes.rpc.methodNotFound, t),
    internal: (t) => $n(Li.errorCodes.rpc.internal, t),
    server: (t) => {
      if (!t || typeof t != "object" || Array.isArray(t))
        throw new Error("Ethereum RPC Server errors must provide single object argument.");
      const { code: e } = t;
      if (!Number.isInteger(e) || e > -32005 || e < -32099)
        throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
      return $n(e, t);
    },
    invalidInput: (t) => $n(Li.errorCodes.rpc.invalidInput, t),
    resourceNotFound: (t) => $n(Li.errorCodes.rpc.resourceNotFound, t),
    resourceUnavailable: (t) => $n(Li.errorCodes.rpc.resourceUnavailable, t),
    transactionRejected: (t) => $n(Li.errorCodes.rpc.transactionRejected, t),
    methodNotSupported: (t) => $n(Li.errorCodes.rpc.methodNotSupported, t),
    limitExceeded: (t) => $n(Li.errorCodes.rpc.limitExceeded, t)
  },
  provider: {
    userRejectedRequest: (t) => Du(Li.errorCodes.provider.userRejectedRequest, t),
    unauthorized: (t) => Du(Li.errorCodes.provider.unauthorized, t),
    unsupportedMethod: (t) => Du(Li.errorCodes.provider.unsupportedMethod, t),
    disconnected: (t) => Du(Li.errorCodes.provider.disconnected, t),
    chainDisconnected: (t) => Du(Li.errorCodes.provider.chainDisconnected, t),
    custom: (t) => {
      if (!t || typeof t != "object" || Array.isArray(t))
        throw new Error("Ethereum Provider custom errors must provide single object argument.");
      const { code: e, message: r, data: i } = t;
      if (!r || typeof r != "string")
        throw new Error('"message" must be a nonempty string');
      return new R2.EthereumProviderError(e, r, i);
    }
  }
};
function $n(t, e) {
  const [r, i] = eE(e);
  return new R2.EthereumRpcError(t, r || X9.getMessageFromCode(t), i);
}
function Du(t, e) {
  const [r, i] = eE(e);
  return new R2.EthereumProviderError(t, r || X9.getMessageFromCode(t), i);
}
function eE(t) {
  if (t) {
    if (typeof t == "string")
      return [t];
    if (typeof t == "object" && !Array.isArray(t)) {
      const { message: e, data: r } = t;
      if (e && typeof e != "string")
        throw new Error("Must specify string message.");
      return [e || void 0, r];
    }
  }
  return [];
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.getMessageFromCode = t.serializeError = t.EthereumProviderError = t.EthereumRpcError = t.ethErrors = t.errorCodes = void 0;
  const e = uo;
  Object.defineProperty(t, "EthereumRpcError", { enumerable: !0, get: function() {
    return e.EthereumRpcError;
  } }), Object.defineProperty(t, "EthereumProviderError", { enumerable: !0, get: function() {
    return e.EthereumProviderError;
  } });
  const r = O2;
  Object.defineProperty(t, "serializeError", { enumerable: !0, get: function() {
    return r.serializeError;
  } }), Object.defineProperty(t, "getMessageFromCode", { enumerable: !0, get: function() {
    return r.getMessageFromCode;
  } });
  const i = vp;
  Object.defineProperty(t, "ethErrors", { enumerable: !0, get: function() {
    return i.ethErrors;
  } });
  const s = ho;
  Object.defineProperty(t, "errorCodes", { enumerable: !0, get: function() {
    return s.errorCodes;
  } });
})(Z9);
var KG = nt && nt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Hh, "__esModule", { value: !0 });
Hh.JsonRpcEngine = void 0;
const YG = KG(kc), qn = Z9;
class Sa extends YG.default {
  constructor() {
    super(), this._middleware = [];
  }
  push(e) {
    this._middleware.push(e);
  }
  handle(e, r) {
    if (r && typeof r != "function")
      throw new Error('"callback" must be a function if provided.');
    return Array.isArray(e) ? r ? this._handleBatch(e, r) : this._handleBatch(e) : r ? this._handle(e, r) : this._promiseHandle(e);
  }
  asMiddleware() {
    return async (e, r, i, s) => {
      try {
        const [n, f, u] = await Sa._runAllMiddleware(e, r, this._middleware);
        return f ? (await Sa._runReturnHandlers(u), s(n)) : i(async (h) => {
          try {
            await Sa._runReturnHandlers(u);
          } catch (d) {
            return h(d);
          }
          return h();
        });
      } catch (n) {
        return s(n);
      }
    };
  }
  async _handleBatch(e, r) {
    try {
      const i = await Promise.all(
        e.map(this._promiseHandle.bind(this))
      );
      return r ? r(null, i) : i;
    } catch (i) {
      if (r)
        return r(i);
      throw i;
    }
  }
  _promiseHandle(e) {
    return new Promise((r) => {
      this._handle(e, (i, s) => {
        r(s);
      });
    });
  }
  async _handle(e, r) {
    if (!e || Array.isArray(e) || typeof e != "object") {
      const f = new qn.EthereumRpcError(qn.errorCodes.rpc.invalidRequest, `Requests must be plain objects. Received: ${typeof e}`, { request: e });
      return r(f, { id: void 0, jsonrpc: "2.0", error: f });
    }
    if (typeof e.method != "string") {
      const f = new qn.EthereumRpcError(qn.errorCodes.rpc.invalidRequest, `Must specify a string method. Received: ${typeof e.method}`, { request: e });
      return r(f, { id: e.id, jsonrpc: "2.0", error: f });
    }
    const i = Object.assign({}, e), s = {
      id: i.id,
      jsonrpc: i.jsonrpc
    };
    let n = null;
    try {
      await this._processRequest(i, s);
    } catch (f) {
      n = f;
    }
    return n && (delete s.result, s.error || (s.error = qn.serializeError(n))), r(n, s);
  }
  async _processRequest(e, r) {
    const [i, s, n] = await Sa._runAllMiddleware(e, r, this._middleware);
    if (Sa._checkForCompletion(e, r, s), await Sa._runReturnHandlers(n), i)
      throw i;
  }
  static async _runAllMiddleware(e, r, i) {
    const s = [];
    let n = null, f = !1;
    for (const u of i)
      if ([n, f] = await Sa._runMiddleware(e, r, u, s), f)
        break;
    return [n, f, s.reverse()];
  }
  static _runMiddleware(e, r, i, s) {
    return new Promise((n) => {
      const f = (h) => {
        const d = h || r.error;
        d && (r.error = qn.serializeError(d)), n([d, !0]);
      }, u = (h) => {
        r.error ? f(r.error) : (h && (typeof h != "function" && f(new qn.EthereumRpcError(qn.errorCodes.rpc.internal, `JsonRpcEngine: "next" return handlers must be functions. Received "${typeof h}" for request:
${ng(e)}`, { request: e })), s.push(h)), n([null, !1]));
      };
      try {
        i(e, r, u, f);
      } catch (h) {
        f(h);
      }
    });
  }
  static async _runReturnHandlers(e) {
    for (const r of e)
      await new Promise((i, s) => {
        r((n) => n ? s(n) : i());
      });
  }
  static _checkForCompletion(e, r, i) {
    if (!("result" in r) && !("error" in r))
      throw new qn.EthereumRpcError(qn.errorCodes.rpc.internal, `JsonRpcEngine: Response has no error or result for request:
${ng(e)}`, { request: e });
    if (!i)
      throw new qn.EthereumRpcError(qn.errorCodes.rpc.internal, `JsonRpcEngine: Nothing ended request:
${ng(e)}`, { request: e });
  }
}
Hh.JsonRpcEngine = Sa;
function ng(t) {
  return JSON.stringify(t, null, 2);
}
var gp = {};
Object.defineProperty(gp, "__esModule", { value: !0 });
gp.mergeMiddleware = void 0;
const QG = Hh;
function ZG(t) {
  const e = new QG.JsonRpcEngine();
  return t.forEach((r) => e.push(r)), e.asMiddleware();
}
gp.mergeMiddleware = ZG;
(function(t) {
  var e = nt && nt.__createBinding || (Object.create ? function(i, s, n, f) {
    f === void 0 && (f = n), Object.defineProperty(i, f, { enumerable: !0, get: function() {
      return s[n];
    } });
  } : function(i, s, n, f) {
    f === void 0 && (f = n), i[f] = s[n];
  }), r = nt && nt.__exportStar || function(i, s) {
    for (var n in i)
      n !== "default" && !Object.prototype.hasOwnProperty.call(s, n) && e(s, i, n);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), r(lp, t), r(dp, t), r(pp, t), r(qh, t), r(Hh, t), r(gp, t);
})(C2);
var tE = {}, L2 = {}, bm = function(t, e) {
  return bm = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
    r.__proto__ = i;
  } || function(r, i) {
    for (var s in i)
      Object.prototype.hasOwnProperty.call(i, s) && (r[s] = i[s]);
  }, bm(t, e);
};
function rE(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  bm(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
var w0 = function() {
  return w0 = Object.assign || function(e) {
    for (var r, i = 1, s = arguments.length; i < s; i++) {
      r = arguments[i];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, w0.apply(this, arguments);
};
function iE(t, e) {
  var r = {};
  for (var i in t)
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (r[i] = t[i]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, i = Object.getOwnPropertySymbols(t); s < i.length; s++)
      e.indexOf(i[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[s]) && (r[i[s]] = t[i[s]]);
  return r;
}
function nE(t, e, r, i) {
  var s = arguments.length, n = s < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, r) : i, f;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(t, e, r, i);
  else
    for (var u = t.length - 1; u >= 0; u--)
      (f = t[u]) && (n = (s < 3 ? f(n) : s > 3 ? f(e, r, n) : f(e, r)) || n);
  return s > 3 && n && Object.defineProperty(e, r, n), n;
}
function sE(t, e) {
  return function(r, i) {
    e(r, i, t);
  };
}
function JG(t, e, r, i, s, n) {
  function f(O) {
    if (O !== void 0 && typeof O != "function")
      throw new TypeError("Function expected");
    return O;
  }
  for (var u = i.kind, h = u === "getter" ? "get" : u === "setter" ? "set" : "value", d = !e && t ? i.static ? t : t.prototype : null, l = e || (d ? Object.getOwnPropertyDescriptor(d, i.name) : {}), m, b = !1, M = r.length - 1; M >= 0; M--) {
    var A = {};
    for (var N in i)
      A[N] = N === "access" ? {} : i[N];
    for (var N in i.access)
      A.access[N] = i.access[N];
    A.addInitializer = function(O) {
      if (b)
        throw new TypeError("Cannot add initializers after decoration has completed");
      n.push(f(O || null));
    };
    var R = (0, r[M])(u === "accessor" ? { get: l.get, set: l.set } : l[h], A);
    if (u === "accessor") {
      if (R === void 0)
        continue;
      if (R === null || typeof R != "object")
        throw new TypeError("Object expected");
      (m = f(R.get)) && (l.get = m), (m = f(R.set)) && (l.set = m), (m = f(R.init)) && s.unshift(m);
    } else
      (m = f(R)) && (u === "field" ? s.unshift(m) : l[h] = m);
  }
  d && Object.defineProperty(d, i.name, l), b = !0;
}
function XG(t, e, r) {
  for (var i = arguments.length > 2, s = 0; s < e.length; s++)
    r = i ? e[s].call(t, r) : e[s].call(t);
  return i ? r : void 0;
}
function eK(t) {
  return typeof t == "symbol" ? t : "".concat(t);
}
function tK(t, e, r) {
  return typeof e == "symbol" && (e = e.description ? "[".concat(e.description, "]") : ""), Object.defineProperty(t, "name", { configurable: !0, value: r ? "".concat(r, " ", e) : e });
}
function aE(t, e) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(t, e);
}
function oE(t, e, r, i) {
  function s(n) {
    return n instanceof r ? n : new r(function(f) {
      f(n);
    });
  }
  return new (r || (r = Promise))(function(n, f) {
    function u(l) {
      try {
        d(i.next(l));
      } catch (m) {
        f(m);
      }
    }
    function h(l) {
      try {
        d(i.throw(l));
      } catch (m) {
        f(m);
      }
    }
    function d(l) {
      l.done ? n(l.value) : s(l.value).then(u, h);
    }
    d((i = i.apply(t, e || [])).next());
  });
}
function fE(t, e) {
  var r = { label: 0, sent: function() {
    if (n[0] & 1)
      throw n[1];
    return n[1];
  }, trys: [], ops: [] }, i, s, n, f;
  return f = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (f[Symbol.iterator] = function() {
    return this;
  }), f;
  function u(d) {
    return function(l) {
      return h([d, l]);
    };
  }
  function h(d) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; f && (f = 0, d[0] && (r = 0)), r; )
      try {
        if (i = 1, s && (n = d[0] & 2 ? s.return : d[0] ? s.throw || ((n = s.return) && n.call(s), 0) : s.next) && !(n = n.call(s, d[1])).done)
          return n;
        switch (s = 0, n && (d = [d[0] & 2, n.value]), d[0]) {
          case 0:
          case 1:
            n = d;
            break;
          case 4:
            return r.label++, { value: d[1], done: !1 };
          case 5:
            r.label++, s = d[1], d = [0];
            continue;
          case 7:
            d = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (n = r.trys, !(n = n.length > 0 && n[n.length - 1]) && (d[0] === 6 || d[0] === 2)) {
              r = 0;
              continue;
            }
            if (d[0] === 3 && (!n || d[1] > n[0] && d[1] < n[3])) {
              r.label = d[1];
              break;
            }
            if (d[0] === 6 && r.label < n[1]) {
              r.label = n[1], n = d;
              break;
            }
            if (n && r.label < n[2]) {
              r.label = n[2], r.ops.push(d);
              break;
            }
            n[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        d = e.call(t, r);
      } catch (l) {
        d = [6, l], s = 0;
      } finally {
        i = n = 0;
      }
    if (d[0] & 5)
      throw d[1];
    return { value: d[0] ? d[1] : void 0, done: !0 };
  }
}
var bp = Object.create ? function(t, e, r, i) {
  i === void 0 && (i = r);
  var s = Object.getOwnPropertyDescriptor(e, r);
  (!s || ("get" in s ? !e.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
    return e[r];
  } }), Object.defineProperty(t, i, s);
} : function(t, e, r, i) {
  i === void 0 && (i = r), t[i] = e[r];
};
function cE(t, e) {
  for (var r in t)
    r !== "default" && !Object.prototype.hasOwnProperty.call(e, r) && bp(e, t, r);
}
function _0(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, r = e && t[e], i = 0;
  if (r)
    return r.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && i >= t.length && (t = void 0), { value: t && t[i++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function P2(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r)
    return t;
  var i = r.call(t), s, n = [], f;
  try {
    for (; (e === void 0 || e-- > 0) && !(s = i.next()).done; )
      n.push(s.value);
  } catch (u) {
    f = { error: u };
  } finally {
    try {
      s && !s.done && (r = i.return) && r.call(i);
    } finally {
      if (f)
        throw f.error;
    }
  }
  return n;
}
function uE() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t = t.concat(P2(arguments[e]));
  return t;
}
function hE() {
  for (var t = 0, e = 0, r = arguments.length; e < r; e++)
    t += arguments[e].length;
  for (var i = Array(t), s = 0, e = 0; e < r; e++)
    for (var n = arguments[e], f = 0, u = n.length; f < u; f++, s++)
      i[s] = n[f];
  return i;
}
function lE(t, e, r) {
  if (r || arguments.length === 2)
    for (var i = 0, s = e.length, n; i < s; i++)
      (n || !(i in e)) && (n || (n = Array.prototype.slice.call(e, 0, i)), n[i] = e[i]);
  return t.concat(n || Array.prototype.slice.call(e));
}
function Ic(t) {
  return this instanceof Ic ? (this.v = t, this) : new Ic(t);
}
function dE(t, e, r) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var i = r.apply(t, e || []), s, n = [];
  return s = {}, f("next"), f("throw"), f("return"), s[Symbol.asyncIterator] = function() {
    return this;
  }, s;
  function f(b) {
    i[b] && (s[b] = function(M) {
      return new Promise(function(A, N) {
        n.push([b, M, A, N]) > 1 || u(b, M);
      });
    });
  }
  function u(b, M) {
    try {
      h(i[b](M));
    } catch (A) {
      m(n[0][3], A);
    }
  }
  function h(b) {
    b.value instanceof Ic ? Promise.resolve(b.value.v).then(d, l) : m(n[0][2], b);
  }
  function d(b) {
    u("next", b);
  }
  function l(b) {
    u("throw", b);
  }
  function m(b, M) {
    b(M), n.shift(), n.length && u(n[0][0], n[0][1]);
  }
}
function pE(t) {
  var e, r;
  return e = {}, i("next"), i("throw", function(s) {
    throw s;
  }), i("return"), e[Symbol.iterator] = function() {
    return this;
  }, e;
  function i(s, n) {
    e[s] = t[s] ? function(f) {
      return (r = !r) ? { value: Ic(t[s](f)), done: !1 } : n ? n(f) : f;
    } : n;
  }
}
function vE(t) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], r;
  return e ? e.call(t) : (t = typeof _0 == "function" ? _0(t) : t[Symbol.iterator](), r = {}, i("next"), i("throw"), i("return"), r[Symbol.asyncIterator] = function() {
    return this;
  }, r);
  function i(n) {
    r[n] = t[n] && function(f) {
      return new Promise(function(u, h) {
        f = t[n](f), s(u, h, f.done, f.value);
      });
    };
  }
  function s(n, f, u, h) {
    Promise.resolve(h).then(function(d) {
      n({ value: d, done: u });
    }, f);
  }
}
function gE(t, e) {
  return Object.defineProperty ? Object.defineProperty(t, "raw", { value: e }) : t.raw = e, t;
}
var rK = Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
};
function bE(t) {
  if (t && t.__esModule)
    return t;
  var e = {};
  if (t != null)
    for (var r in t)
      r !== "default" && Object.prototype.hasOwnProperty.call(t, r) && bp(e, t, r);
  return rK(e, t), e;
}
function yE(t) {
  return t && t.__esModule ? t : { default: t };
}
function mE(t, e, r, i) {
  if (r === "a" && !i)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !i : !e.has(t))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? i : r === "a" ? i.call(t) : i ? i.value : e.get(t);
}
function wE(t, e, r, i, s) {
  if (i === "m")
    throw new TypeError("Private method is not writable");
  if (i === "a" && !s)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !s : !e.has(t))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return i === "a" ? s.call(t, r) : s ? s.value = r : e.set(t, r), r;
}
function _E(t, e) {
  if (e === null || typeof e != "object" && typeof e != "function")
    throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof t == "function" ? e === t : t.has(e);
}
function ME(t, e, r) {
  if (e != null) {
    if (typeof e != "object" && typeof e != "function")
      throw new TypeError("Object expected.");
    var i;
    if (r) {
      if (!Symbol.asyncDispose)
        throw new TypeError("Symbol.asyncDispose is not defined.");
      i = e[Symbol.asyncDispose];
    }
    if (i === void 0) {
      if (!Symbol.dispose)
        throw new TypeError("Symbol.dispose is not defined.");
      i = e[Symbol.dispose];
    }
    if (typeof i != "function")
      throw new TypeError("Object not disposable.");
    t.stack.push({ value: e, dispose: i, async: r });
  } else
    r && t.stack.push({ async: !0 });
  return e;
}
var iK = typeof SuppressedError == "function" ? SuppressedError : function(t, e, r) {
  var i = new Error(r);
  return i.name = "SuppressedError", i.error = t, i.suppressed = e, i;
};
function xE(t) {
  function e(i) {
    t.error = t.hasError ? new iK(i, t.error, "An error was suppressed during disposal.") : i, t.hasError = !0;
  }
  function r() {
    for (; t.stack.length; ) {
      var i = t.stack.pop();
      try {
        var s = i.dispose && i.dispose.call(i.value);
        if (i.async)
          return Promise.resolve(s).then(r, function(n) {
            return e(n), r();
          });
      } catch (n) {
        e(n);
      }
    }
    if (t.hasError)
      throw t.error;
  }
  return r();
}
const nK = {
  __extends: rE,
  __assign: w0,
  __rest: iE,
  __decorate: nE,
  __param: sE,
  __metadata: aE,
  __awaiter: oE,
  __generator: fE,
  __createBinding: bp,
  __exportStar: cE,
  __values: _0,
  __read: P2,
  __spread: uE,
  __spreadArrays: hE,
  __spreadArray: lE,
  __await: Ic,
  __asyncGenerator: dE,
  __asyncDelegator: pE,
  __asyncValues: vE,
  __makeTemplateObject: gE,
  __importStar: bE,
  __importDefault: yE,
  __classPrivateFieldGet: mE,
  __classPrivateFieldSet: wE,
  __classPrivateFieldIn: _E,
  __addDisposableResource: ME,
  __disposeResources: xE
}, sK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  __extends: rE,
  get __assign() {
    return w0;
  },
  __rest: iE,
  __decorate: nE,
  __param: sE,
  __esDecorate: JG,
  __runInitializers: XG,
  __propKey: eK,
  __setFunctionName: tK,
  __metadata: aE,
  __awaiter: oE,
  __generator: fE,
  __createBinding: bp,
  __exportStar: cE,
  __values: _0,
  __read: P2,
  __spread: uE,
  __spreadArrays: hE,
  __spreadArray: lE,
  __await: Ic,
  __asyncGenerator: dE,
  __asyncDelegator: pE,
  __asyncValues: vE,
  __makeTemplateObject: gE,
  __importStar: bE,
  __importDefault: yE,
  __classPrivateFieldGet: mE,
  __classPrivateFieldSet: wE,
  __classPrivateFieldIn: _E,
  __addDisposableResource: ME,
  __disposeResources: xE,
  default: nK
}, Symbol.toStringTag, { value: "Module" })), k2 = /* @__PURE__ */ pf(sK);
var yp = {};
Object.defineProperty(yp, "__esModule", { value: !0 });
var n6 = k2, aK = function() {
  function t(e) {
    if (this._maxConcurrency = e, this._queue = [], e <= 0)
      throw new Error("semaphore must be initialized to a positive value");
    this._value = e;
  }
  return t.prototype.acquire = function() {
    var e = this, r = this.isLocked(), i = new Promise(function(s) {
      return e._queue.push(s);
    });
    return r || this._dispatch(), i;
  }, t.prototype.runExclusive = function(e) {
    return n6.__awaiter(this, void 0, void 0, function() {
      var r, i, s;
      return n6.__generator(this, function(n) {
        switch (n.label) {
          case 0:
            return [4, this.acquire()];
          case 1:
            r = n.sent(), i = r[0], s = r[1], n.label = 2;
          case 2:
            return n.trys.push([2, , 4, 5]), [4, e(i)];
          case 3:
            return [2, n.sent()];
          case 4:
            return s(), [7];
          case 5:
            return [2];
        }
      });
    });
  }, t.prototype.isLocked = function() {
    return this._value <= 0;
  }, t.prototype.release = function() {
    if (this._maxConcurrency > 1)
      throw new Error("this method is unavailabel on semaphores with concurrency > 1; use the scoped release returned by acquire instead");
    if (this._currentReleaser) {
      var e = this._currentReleaser;
      this._currentReleaser = void 0, e();
    }
  }, t.prototype._dispatch = function() {
    var e = this, r = this._queue.shift();
    if (!!r) {
      var i = !1;
      this._currentReleaser = function() {
        i || (i = !0, e._value++, e._dispatch());
      }, r([this._value--, this._currentReleaser]);
    }
  }, t;
}();
yp.default = aK;
Object.defineProperty(L2, "__esModule", { value: !0 });
var s6 = k2, oK = yp, fK = function() {
  function t() {
    this._semaphore = new oK.default(1);
  }
  return t.prototype.acquire = function() {
    return s6.__awaiter(this, void 0, void 0, function() {
      var e, r;
      return s6.__generator(this, function(i) {
        switch (i.label) {
          case 0:
            return [4, this._semaphore.acquire()];
          case 1:
            return e = i.sent(), r = e[1], [2, r];
        }
      });
    });
  }, t.prototype.runExclusive = function(e) {
    return this._semaphore.runExclusive(function() {
      return e();
    });
  }, t.prototype.isLocked = function() {
    return this._semaphore.isLocked();
  }, t.prototype.release = function() {
    this._semaphore.release();
  }, t;
}();
L2.default = fK;
var mp = {};
Object.defineProperty(mp, "__esModule", { value: !0 });
mp.withTimeout = void 0;
var _d = k2;
function cK(t, e, r) {
  var i = this;
  return r === void 0 && (r = new Error("timeout")), {
    acquire: function() {
      return new Promise(function(s, n) {
        return _d.__awaiter(i, void 0, void 0, function() {
          var f, u, h;
          return _d.__generator(this, function(d) {
            switch (d.label) {
              case 0:
                return f = !1, setTimeout(function() {
                  f = !0, n(r);
                }, e), [4, t.acquire()];
              case 1:
                return u = d.sent(), f ? (h = Array.isArray(u) ? u[1] : u, h()) : s(u), [2];
            }
          });
        });
      });
    },
    runExclusive: function(s) {
      return _d.__awaiter(this, void 0, void 0, function() {
        var n, f;
        return _d.__generator(this, function(u) {
          switch (u.label) {
            case 0:
              n = function() {
              }, u.label = 1;
            case 1:
              return u.trys.push([1, , 7, 8]), [4, this.acquire()];
            case 2:
              return f = u.sent(), Array.isArray(f) ? (n = f[1], [4, s(f[0])]) : [3, 4];
            case 3:
              return [2, u.sent()];
            case 4:
              return n = f, [4, s()];
            case 5:
              return [2, u.sent()];
            case 6:
              return [3, 8];
            case 7:
              return n(), [7];
            case 8:
              return [2];
          }
        });
      });
    },
    release: function() {
      t.release();
    },
    isLocked: function() {
      return t.isLocked();
    }
  };
}
mp.withTimeout = cK;
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.withTimeout = t.Semaphore = t.Mutex = void 0;
  var e = L2;
  Object.defineProperty(t, "Mutex", { enumerable: !0, get: function() {
    return e.default;
  } });
  var r = yp;
  Object.defineProperty(t, "Semaphore", { enumerable: !0, get: function() {
    return r.default;
  } });
  var i = mp;
  Object.defineProperty(t, "withTimeout", { enumerable: !0, get: function() {
    return i.withTimeout;
  } });
})(tE);
const a6 = (t, e, r, i) => function(...s) {
  const n = e.promiseModule;
  return new n((f, u) => {
    e.multiArgs ? s.push((...d) => {
      e.errorFirst ? d[0] ? u(d) : (d.shift(), f(d)) : f(d);
    }) : e.errorFirst ? s.push((d, l) => {
      d ? u(d) : f(l);
    }) : s.push(f), Reflect.apply(t, this === r ? i : this, s);
  });
}, o6 = /* @__PURE__ */ new WeakMap();
var uK = (t, e) => {
  e = {
    exclude: [/.+(?:Sync|Stream)$/],
    errorFirst: !0,
    promiseModule: Promise,
    ...e
  };
  const r = typeof t;
  if (!(t !== null && (r === "object" || r === "function")))
    throw new TypeError(`Expected \`input\` to be a \`Function\` or \`Object\`, got \`${t === null ? "null" : r}\``);
  const i = (f, u) => {
    let h = o6.get(f);
    if (h || (h = {}, o6.set(f, h)), u in h)
      return h[u];
    const d = (A) => typeof A == "string" || typeof u == "symbol" ? u === A : A.test(u), l = Reflect.getOwnPropertyDescriptor(f, u), m = l === void 0 || l.writable || l.configurable, M = (e.include ? e.include.some(d) : !e.exclude.some(d)) && m;
    return h[u] = M, M;
  }, s = /* @__PURE__ */ new WeakMap(), n = new Proxy(t, {
    apply(f, u, h) {
      const d = s.get(f);
      if (d)
        return Reflect.apply(d, u, h);
      const l = e.excludeMain ? f : a6(f, e, n, f);
      return s.set(f, l), Reflect.apply(l, u, h);
    },
    get(f, u) {
      const h = f[u];
      if (!i(f, u) || h === Function.prototype[u])
        return h;
      const d = s.get(h);
      if (d)
        return d;
      if (typeof h == "function") {
        const l = a6(h, e, n, f);
        return s.set(h, l), l;
      }
      return h;
    }
  });
  return n;
};
const hK = kc.default;
class lK extends hK {
  constructor() {
    super(), this.updates = [];
  }
  async initialize() {
  }
  async update() {
    throw new Error("BaseFilter - no update method specified");
  }
  addResults(e) {
    this.updates = this.updates.concat(e), e.forEach((r) => this.emit("update", r));
  }
  addInitialResults(e) {
  }
  getChangesAndClear() {
    const e = this.updates;
    return this.updates = [], e;
  }
}
var j2 = lK;
const dK = j2;
class pK extends dK {
  constructor() {
    super(), this.allResults = [];
  }
  async update() {
    throw new Error("BaseFilterWithHistory - no update method specified");
  }
  addResults(e) {
    this.allResults = this.allResults.concat(e), super.addResults(e);
  }
  addInitialResults(e) {
    this.allResults = this.allResults.concat(e), super.addInitialResults(e);
  }
  getAllResults() {
    return this.allResults;
  }
}
var vK = pK, Wh = {
  minBlockRef: gK,
  maxBlockRef: bK,
  sortBlockRefs: B2,
  bnToHex: yK,
  blockRefIsNumber: mK,
  hexToInt: M0,
  incrementHexInt: wK,
  intToHex: SE,
  unsafeRandomBytes: _K
};
function gK(...t) {
  return B2(t)[0];
}
function bK(...t) {
  const e = B2(t);
  return e[e.length - 1];
}
function B2(t) {
  return t.sort((e, r) => e === "latest" || r === "earliest" ? 1 : r === "latest" || e === "earliest" ? -1 : M0(e) - M0(r));
}
function yK(t) {
  return "0x" + t.toString(16);
}
function mK(t) {
  return t && !["earliest", "latest", "pending"].includes(t);
}
function M0(t) {
  return t == null ? t : Number.parseInt(t, 16);
}
function wK(t) {
  if (t == null)
    return t;
  const e = M0(t);
  return SE(e + 1);
}
function SE(t) {
  if (t == null)
    return t;
  let e = t.toString(16);
  return e.length % 2 && (e = "0" + e), "0x" + e;
}
function _K(t) {
  let e = "0x";
  for (let r = 0; r < t; r++)
    e += f6(), e += f6();
  return e;
}
function f6() {
  return Math.floor(Math.random() * 16).toString(16);
}
const MK = VV, xK = uK, SK = vK, { bnToHex: Nde, hexToInt: Md, incrementHexInt: EK, minBlockRef: IK, blockRefIsNumber: AK } = Wh;
class TK extends SK {
  constructor({ provider: e, params: r }) {
    super(), this.type = "log", this.ethQuery = new MK(e), this.params = Object.assign({
      fromBlock: "latest",
      toBlock: "latest",
      address: void 0,
      topics: []
    }, r), this.params.address && (Array.isArray(this.params.address) || (this.params.address = [this.params.address]), this.params.address = this.params.address.map((i) => i.toLowerCase()));
  }
  async initialize({ currentBlock: e }) {
    let r = this.params.fromBlock;
    ["latest", "pending"].includes(r) && (r = e), r === "earliest" && (r = "0x0"), this.params.fromBlock = r;
    const i = IK(this.params.toBlock, e), s = Object.assign({}, this.params, { toBlock: i }), n = await this._fetchLogs(s);
    this.addInitialResults(n);
  }
  async update({ oldBlock: e, newBlock: r }) {
    const i = r;
    let s;
    e ? s = EK(e) : s = r;
    const n = Object.assign({}, this.params, { fromBlock: s, toBlock: i }), u = (await this._fetchLogs(n)).filter((h) => this.matchLog(h));
    this.addResults(u);
  }
  async _fetchLogs(e) {
    return await xK((i) => this.ethQuery.getLogs(e, i))();
  }
  matchLog(e) {
    if (Md(this.params.fromBlock) >= Md(e.blockNumber) || AK(this.params.toBlock) && Md(this.params.toBlock) <= Md(e.blockNumber))
      return !1;
    const r = e.address && e.address.toLowerCase();
    return this.params.address && r && !this.params.address.includes(r) ? !1 : this.params.topics.every((s, n) => {
      let f = e.topics[n];
      if (!f)
        return !1;
      f = f.toLowerCase();
      let u = Array.isArray(s) ? s : [s];
      return u.includes(null) ? !0 : (u = u.map((l) => l.toLowerCase()), u.includes(f));
    });
  }
}
var NK = TK, z2 = DK;
async function DK({ provider: t, fromBlock: e, toBlock: r }) {
  e || (e = r);
  const i = c6(e), n = c6(r) - i + 1, f = Array(n).fill().map((h, d) => i + d).map(CK);
  return await Promise.all(
    f.map((h) => OK(t, "eth_getBlockByNumber", [h, !1]))
  );
}
function c6(t) {
  return t == null ? t : Number.parseInt(t, 16);
}
function CK(t) {
  if (t == null)
    return t;
  const e = t.toString(16);
  return "0x" + e;
}
function OK(t, e, r) {
  return new Promise((i, s) => {
    t.sendAsync({ id: 1, jsonrpc: "2.0", method: e, params: r }, (n, f) => {
      if (n)
        return s(n);
      i(f.result);
    });
  });
}
const RK = j2, LK = z2, { incrementHexInt: PK } = Wh;
class kK extends RK {
  constructor({ provider: e, params: r }) {
    super(), this.type = "block", this.provider = e;
  }
  async update({ oldBlock: e, newBlock: r }) {
    const i = r, s = PK(e), f = (await LK({ provider: this.provider, fromBlock: s, toBlock: i })).map((u) => u.hash);
    this.addResults(f);
  }
}
var jK = kK;
const BK = j2, zK = z2, { incrementHexInt: UK } = Wh;
class FK extends BK {
  constructor({ provider: e }) {
    super(), this.type = "tx", this.provider = e;
  }
  async update({ oldBlock: e }) {
    const r = e, i = UK(e), s = await zK({ provider: this.provider, fromBlock: i, toBlock: r }), n = [];
    for (const f of s)
      n.push(...f.transactions);
    this.addResults(n);
  }
}
var $K = FK;
const qK = tE.Mutex, { createAsyncMiddleware: HK } = C2, WK = D2.exports, VK = NK, GK = jK, KK = $K, { intToHex: EE, hexToInt: sg } = Wh;
var YK = QK;
function QK({ blockTracker: t, provider: e }) {
  let r = 0, i = {};
  const s = new qK(), n = ZK({ mutex: s }), f = WK({
    eth_newFilter: n(ag(h)),
    eth_newBlockFilter: n(ag(d)),
    eth_newPendingTransactionFilter: n(ag(l)),
    eth_uninstallFilter: n(Yd(M)),
    eth_getFilterChanges: n(Yd(m)),
    eth_getFilterLogs: n(Yd(b))
  }), u = async ({ oldBlock: P, newBlock: F }) => {
    if (i.length === 0)
      return;
    const H = await s.acquire();
    try {
      await Promise.all(Vf(i).map(async (Q) => {
        try {
          await Q.update({ oldBlock: P, newBlock: F });
        } catch (Z) {
          console.error(Z);
        }
      }));
    } catch (Q) {
      console.error(Q);
    }
    H();
  };
  return f.newLogFilter = h, f.newBlockFilter = d, f.newPendingTransactionFilter = l, f.uninstallFilter = M, f.getFilterChanges = m, f.getFilterLogs = b, f.destroy = () => {
    R();
  }, f;
  async function h(P) {
    const F = new VK({ provider: e, params: P });
    return await A(F), F;
  }
  async function d() {
    const P = new GK({ provider: e });
    return await A(P), P;
  }
  async function l() {
    const P = new KK({ provider: e });
    return await A(P), P;
  }
  async function m(P) {
    const F = sg(P), H = i[F];
    if (!H)
      throw new Error(`No filter for index "${F}"`);
    return H.getChangesAndClear();
  }
  async function b(P) {
    const F = sg(P), H = i[F];
    if (!H)
      throw new Error(`No filter for index "${F}"`);
    return H.type === "log" ? results = H.getAllResults() : results = [], results;
  }
  async function M(P) {
    const F = sg(P), H = i[F], Q = Boolean(H);
    return Q && await N(F), Q;
  }
  async function A(P) {
    const F = Vf(i).length, H = await t.getLatestBlock();
    await P.initialize({ currentBlock: H }), r++, i[r] = P, P.id = r, P.idHex = EE(r);
    const Q = Vf(i).length;
    return O({ prevFilterCount: F, newFilterCount: Q }), r;
  }
  async function N(P) {
    const F = Vf(i).length;
    delete i[P];
    const H = Vf(i).length;
    O({ prevFilterCount: F, newFilterCount: H });
  }
  async function R() {
    const P = Vf(i).length;
    i = {}, O({ prevFilterCount: P, newFilterCount: 0 });
  }
  function O({ prevFilterCount: P, newFilterCount: F }) {
    if (P === 0 && F > 0) {
      t.on("sync", u);
      return;
    }
    if (P > 0 && F === 0) {
      t.removeListener("sync", u);
      return;
    }
  }
}
function ag(t) {
  return Yd(async (...e) => {
    const r = await t(...e);
    return EE(r.id);
  });
}
function Yd(t) {
  return HK(async (e, r) => {
    const i = await t.apply(null, e.params);
    r.result = i;
  });
}
function ZK({ mutex: t }) {
  return (e) => async (r, i, s, n) => {
    (await t.acquire())(), e(r, i, s, n);
  };
}
function Vf(t, e) {
  const r = [];
  for (let i in t)
    r.push(t[i]);
  return r;
}
const JK = kc.default, XK = D2.exports, { createAsyncMiddleware: u6 } = C2, eY = YK, { unsafeRandomBytes: tY, incrementHexInt: rY } = Wh, iY = z2;
var nY = sY;
function sY({ blockTracker: t, provider: e }) {
  const r = {}, i = eY({ blockTracker: t, provider: e });
  let s = !1;
  const n = new JK(), f = XK({
    eth_subscribe: u6(u),
    eth_unsubscribe: u6(h)
  });
  return f.destroy = l, { events: n, middleware: f };
  async function u(m, b) {
    if (s)
      throw new Error(
        "SubscriptionManager - attempting to use after destroying"
      );
    const M = m.params[0], A = tY(16);
    let N;
    switch (M) {
      case "newHeads":
        N = R({ subId: A });
        break;
      case "logs":
        const P = m.params[1], F = await i.newLogFilter(P);
        N = O({ subId: A, filter: F });
        break;
      default:
        throw new Error(`SubscriptionManager - unsupported subscription type "${M}"`);
    }
    r[A] = N, b.result = A;
    return;
    function R({ subId: P }) {
      const F = {
        type: M,
        destroy: async () => {
          t.removeListener("sync", F.update);
        },
        update: async ({ oldBlock: H, newBlock: Q }) => {
          const Z = Q, B = rY(H);
          (await iY({ provider: e, fromBlock: B, toBlock: Z })).map(aY).forEach((se) => {
            d(P, se);
          });
        }
      };
      return t.on("sync", F.update), F;
    }
    function O({ subId: P, filter: F }) {
      return F.on("update", (Q) => d(P, Q)), {
        type: M,
        destroy: async () => await i.uninstallFilter(F.idHex)
      };
    }
  }
  async function h(m, b) {
    if (s)
      throw new Error(
        "SubscriptionManager - attempting to use after destroying"
      );
    const M = m.params[0], A = r[M];
    if (!A) {
      b.result = !1;
      return;
    }
    delete r[M], await A.destroy(), b.result = !0;
  }
  function d(m, b) {
    n.emit("notification", {
      jsonrpc: "2.0",
      method: "eth_subscription",
      params: {
        subscription: m,
        result: b
      }
    });
  }
  function l() {
    n.removeAllListeners();
    for (const m in r)
      r[m].destroy(), delete r[m];
    s = !0;
  }
}
function aY(t) {
  return {
    hash: t.hash,
    parentHash: t.parentHash,
    sha3Uncles: t.sha3Uncles,
    miner: t.miner,
    stateRoot: t.stateRoot,
    transactionsRoot: t.transactionsRoot,
    receiptsRoot: t.receiptsRoot,
    logsBloom: t.logsBloom,
    difficulty: t.difficulty,
    number: t.number,
    gasLimit: t.gasLimit,
    gasUsed: t.gasUsed,
    nonce: t.nonce,
    mixHash: t.mixHash,
    timestamp: t.timestamp,
    extraData: t.extraData
  };
}
Object.defineProperty(up, "__esModule", { value: !0 });
up.SubscriptionManager = void 0;
const oY = jG, fY = nY, h6 = () => {
};
class cY {
  constructor(e) {
    const r = new oY({
      provider: e,
      pollingInterval: 15e3,
      setSkipCacheFlag: !0
    }), { events: i, middleware: s } = fY({
      blockTracker: r,
      provider: e
    });
    this.events = i, this.subscriptionMiddleware = s;
  }
  async handleRequest(e) {
    const r = {};
    return await this.subscriptionMiddleware(e, r, h6, h6), r;
  }
  destroy() {
    this.subscriptionMiddleware.destroy();
  }
}
up.SubscriptionManager = cY;
var U2 = nt && nt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(bc, "__esModule", { value: !0 });
bc.CoinbaseWalletProvider = void 0;
const uY = U2(kc), hY = U2(Ih.exports), Pi = K0, og = jc, l6 = Bc, d6 = Ss, Wt = xt, fg = U2(LV), lY = Ec, br = k9, dY = up, p6 = "DefaultChainId", v6 = "DefaultJsonRpcUrl", pY = [
  1,
  10,
  137,
  61,
  56,
  250,
  42161,
  100,
  43114,
  3,
  4,
  5,
  42,
  69,
  80001,
  97,
  4002,
  421611,
  43113
];
class vY extends uY.default {
  constructor(e) {
    var r, i;
    super(), this._filterPolyfill = new lY.FilterPolyfill(this), this._subscriptionManager = new dY.SubscriptionManager(this), this._relay = null, this._addresses = [], this.hasMadeFirstChainChangedEmission = !1, this._send = this.send.bind(this), this._sendAsync = this.sendAsync.bind(this), this.setProviderInfo = this.setProviderInfo.bind(this), this.updateProviderInfo = this.updateProviderInfo.bind(this), this.getChainId = this.getChainId.bind(this), this.setAppInfo = this.setAppInfo.bind(this), this.enable = this.enable.bind(this), this.close = this.close.bind(this), this.send = this.send.bind(this), this.sendAsync = this.sendAsync.bind(this), this.request = this.request.bind(this), this._setAddresses = this._setAddresses.bind(this), this.scanQRCode = this.scanQRCode.bind(this), this.genericRequest = this.genericRequest.bind(this), this._chainIdFromOpts = e.chainId, this._jsonRpcUrlFromOpts = e.jsonRpcUrl, this._overrideIsMetaMask = e.overrideIsMetaMask, this._relayProvider = e.relayProvider, this._storage = e.storage, this._relayEventManager = e.relayEventManager, this.diagnostic = e.diagnosticLogger, this.reloadOnDisconnect = !0, this.isCoinbaseWallet = (r = e.overrideIsCoinbaseWallet) !== null && r !== void 0 ? r : !0, this.isCoinbaseBrowser = (i = e.overrideIsCoinbaseBrowser) !== null && i !== void 0 ? i : !1, this.qrUrl = e.qrUrl, this.supportsAddressSwitching = e.supportsAddressSwitching, this.isLedger = e.isLedger;
    const s = this.getChainId(), n = (0, Wt.prepend0x)(s.toString(16));
    this.emit("connect", { chainIdStr: n });
    const f = this._storage.getItem(d6.LOCAL_STORAGE_ADDRESSES_KEY);
    if (f) {
      const u = f.split(" ");
      u[0] !== "" && (this._addresses = u.map((h) => (0, Wt.ensureAddressString)(h)), this.emit("accountsChanged", u));
    }
    this._subscriptionManager.events.on("notification", (u) => {
      this.emit("message", {
        type: u.method,
        data: u.params
      });
    }), this._addresses.length > 0 && this.initializeRelay(), window.addEventListener("message", (u) => {
      var h;
      if (!(u.origin !== location.origin || u.source !== window) && u.data.type === "walletLinkMessage") {
        if (u.data.data.action === "defaultChainChanged" || u.data.data.action === "dappChainSwitched") {
          const d = u.data.data.chainId, l = (h = u.data.data.jsonRpcUrl) !== null && h !== void 0 ? h : this.jsonRpcUrl;
          this.updateProviderInfo(l, Number(d));
        }
        u.data.data.action === "addressChanged" && this._setAddresses([u.data.data.address]);
      }
    });
  }
  get selectedAddress() {
    return this._addresses[0] || void 0;
  }
  get networkVersion() {
    return this.getChainId().toString(10);
  }
  get chainId() {
    return (0, Wt.prepend0x)(this.getChainId().toString(16));
  }
  get isWalletLink() {
    return !0;
  }
  get isMetaMask() {
    return this._overrideIsMetaMask;
  }
  get host() {
    return this.jsonRpcUrl;
  }
  get connected() {
    return !0;
  }
  isConnected() {
    return !0;
  }
  get jsonRpcUrl() {
    var e;
    return (e = this._storage.getItem(v6)) !== null && e !== void 0 ? e : this._jsonRpcUrlFromOpts;
  }
  set jsonRpcUrl(e) {
    this._storage.setItem(v6, e);
  }
  disableReloadOnDisconnect() {
    this.reloadOnDisconnect = !1;
  }
  setProviderInfo(e, r) {
    this.isLedger || this.isCoinbaseBrowser || (this._chainIdFromOpts = r, this._jsonRpcUrlFromOpts = e), this.updateProviderInfo(this._jsonRpcUrlFromOpts, this._chainIdFromOpts);
  }
  updateProviderInfo(e, r) {
    this.jsonRpcUrl = e;
    const i = this.getChainId();
    this._storage.setItem(p6, r.toString(10)), ((0, Wt.ensureIntNumber)(r) !== i || !this.hasMadeFirstChainChangedEmission) && (this.emit("chainChanged", this.getChainId()), this.hasMadeFirstChainChangedEmission = !0);
  }
  async watchAsset(e, r, i, s, n, f) {
    return !!(await (await this.initializeRelay()).watchAsset(e, r, i, s, n, f == null ? void 0 : f.toString()).promise).result;
  }
  async addEthereumChain(e, r, i, s, n, f) {
    var u, h;
    if ((0, Wt.ensureIntNumber)(e) === this.getChainId())
      return !1;
    const d = await this.initializeRelay(), l = d.inlineAddEthereumChain(e.toString());
    !this._isAuthorized() && !l && await d.requestEthereumAccounts().promise;
    const m = await d.addEthereumChain(e.toString(), r, n, i, s, f).promise;
    return ((u = m.result) === null || u === void 0 ? void 0 : u.isApproved) === !0 && this.updateProviderInfo(r[0], e), ((h = m.result) === null || h === void 0 ? void 0 : h.isApproved) === !0;
  }
  async switchEthereumChain(e) {
    pY.includes(e) && this.updateProviderInfo(this.jsonRpcUrl, e);
    const i = await (await this.initializeRelay()).switchEthereumChain(e.toString(10), this.selectedAddress || void 0).promise;
    if (i.errorCode)
      throw Pi.ethErrors.provider.custom({
        code: i.errorCode
      });
    const s = i.result;
    s.isApproved && s.rpcUrl.length > 0 && this.updateProviderInfo(s.rpcUrl, e);
  }
  setAppInfo(e, r) {
    this.initializeRelay().then((i) => i.setAppInfo(e, r));
  }
  async enable() {
    var e;
    return (e = this.diagnostic) === null || e === void 0 || e.log(og.EVENTS.ETH_ACCOUNTS_STATE, {
      method: "provider::enable",
      addresses_length: this._addresses.length,
      sessionIdHash: this._relay ? l6.Session.hash(this._relay.session.id) : void 0
    }), this._addresses.length > 0 ? [...this._addresses] : await this._send(br.JSONRPCMethod.eth_requestAccounts);
  }
  async close() {
    (await this.initializeRelay()).resetAndReload();
  }
  send(e, r) {
    if (typeof e == "string") {
      const s = e, n = Array.isArray(r) ? r : r !== void 0 ? [r] : [], f = {
        jsonrpc: "2.0",
        id: 0,
        method: s,
        params: n
      };
      return this._sendRequestAsync(f).then((u) => u.result);
    }
    if (typeof r == "function") {
      const s = e, n = r;
      return this._sendAsync(s, n);
    }
    if (Array.isArray(e))
      return e.map((n) => this._sendRequest(n));
    const i = e;
    return this._sendRequest(i);
  }
  async sendAsync(e, r) {
    if (typeof r != "function")
      throw new Error("callback is required");
    if (Array.isArray(e)) {
      const s = r;
      this._sendMultipleRequestsAsync(e).then((n) => s(null, n)).catch((n) => s(n, null));
      return;
    }
    const i = r;
    return this._sendRequestAsync(e).then((s) => i(null, s)).catch((s) => i(s, null));
  }
  async request(e) {
    if (!e || typeof e != "object" || Array.isArray(e))
      throw Pi.ethErrors.rpc.invalidRequest({
        message: "Expected a single, non-array, object argument.",
        data: e
      });
    const { method: r, params: i } = e;
    if (typeof r != "string" || r.length === 0)
      throw Pi.ethErrors.rpc.invalidRequest({
        message: "'args.method' must be a non-empty string.",
        data: e
      });
    if (i !== void 0 && !Array.isArray(i) && (typeof i != "object" || i === null))
      throw Pi.ethErrors.rpc.invalidRequest({
        message: "'args.params' must be an object or array if provided.",
        data: e
      });
    const s = i === void 0 ? [] : i, n = this._relayEventManager.makeRequestId();
    return (await this._sendRequestAsync({
      method: r,
      params: s,
      jsonrpc: "2.0",
      id: n
    })).result;
  }
  async scanQRCode(e) {
    const i = await (await this.initializeRelay()).scanQRCode((0, Wt.ensureRegExpString)(e)).promise;
    if (typeof i.result != "string")
      throw new Error("result was not a string");
    return i.result;
  }
  async genericRequest(e, r) {
    const s = await (await this.initializeRelay()).genericRequest(e, r).promise;
    if (typeof s.result != "string")
      throw new Error("result was not a string");
    return s.result;
  }
  async selectProvider(e) {
    const i = await (await this.initializeRelay()).selectProvider(e).promise;
    if (typeof i.result != "string")
      throw new Error("result was not a string");
    return i.result;
  }
  supportsSubscriptions() {
    return !1;
  }
  subscribe() {
    throw new Error("Subscriptions are not supported");
  }
  unsubscribe() {
    throw new Error("Subscriptions are not supported");
  }
  disconnect() {
    return !0;
  }
  _sendRequest(e) {
    const r = {
      jsonrpc: "2.0",
      id: e.id
    }, { method: i } = e;
    if (r.result = this._handleSynchronousMethods(e), r.result === void 0)
      throw new Error(`Coinbase Wallet does not support calling ${i} synchronously without a callback. Please provide a callback parameter to call ${i} asynchronously.`);
    return r;
  }
  _setAddresses(e, r) {
    if (!Array.isArray(e))
      throw new Error("addresses is not an array");
    const i = e.map((s) => (0, Wt.ensureAddressString)(s));
    JSON.stringify(i) !== JSON.stringify(this._addresses) && (this._addresses.length > 0 && this.supportsAddressSwitching === !1 && !r || (this._addresses = i, this.emit("accountsChanged", this._addresses), this._storage.setItem(d6.LOCAL_STORAGE_ADDRESSES_KEY, i.join(" "))));
  }
  _sendRequestAsync(e) {
    return new Promise((r, i) => {
      try {
        const s = this._handleSynchronousMethods(e);
        if (s !== void 0)
          return r({
            jsonrpc: "2.0",
            id: e.id,
            result: s
          });
        const n = this._handleAsynchronousFilterMethods(e);
        if (n !== void 0) {
          n.then((u) => r(Object.assign(Object.assign({}, u), { id: e.id }))).catch((u) => i(u));
          return;
        }
        const f = this._handleSubscriptionMethods(e);
        if (f !== void 0) {
          f.then((u) => r({
            jsonrpc: "2.0",
            id: e.id,
            result: u.result
          })).catch((u) => i(u));
          return;
        }
      } catch (s) {
        return i(s);
      }
      this._handleAsynchronousMethods(e).then((s) => s && r(Object.assign(Object.assign({}, s), { id: e.id }))).catch((s) => i(s));
    });
  }
  _sendMultipleRequestsAsync(e) {
    return Promise.all(e.map((r) => this._sendRequestAsync(r)));
  }
  _handleSynchronousMethods(e) {
    const { method: r } = e, i = e.params || [];
    switch (r) {
      case br.JSONRPCMethod.eth_accounts:
        return this._eth_accounts();
      case br.JSONRPCMethod.eth_coinbase:
        return this._eth_coinbase();
      case br.JSONRPCMethod.eth_uninstallFilter:
        return this._eth_uninstallFilter(i);
      case br.JSONRPCMethod.net_version:
        return this._net_version();
      case br.JSONRPCMethod.eth_chainId:
        return this._eth_chainId();
      default:
        return;
    }
  }
  async _handleAsynchronousMethods(e) {
    const { method: r } = e, i = e.params || [];
    switch (r) {
      case br.JSONRPCMethod.eth_requestAccounts:
        return this._eth_requestAccounts();
      case br.JSONRPCMethod.eth_sign:
        return this._eth_sign(i);
      case br.JSONRPCMethod.eth_ecRecover:
        return this._eth_ecRecover(i);
      case br.JSONRPCMethod.personal_sign:
        return this._personal_sign(i);
      case br.JSONRPCMethod.personal_ecRecover:
        return this._personal_ecRecover(i);
      case br.JSONRPCMethod.eth_signTransaction:
        return this._eth_signTransaction(i);
      case br.JSONRPCMethod.eth_sendRawTransaction:
        return this._eth_sendRawTransaction(i);
      case br.JSONRPCMethod.eth_sendTransaction:
        return this._eth_sendTransaction(i);
      case br.JSONRPCMethod.eth_signTypedData_v1:
        return this._eth_signTypedData_v1(i);
      case br.JSONRPCMethod.eth_signTypedData_v2:
        return this._throwUnsupportedMethodError();
      case br.JSONRPCMethod.eth_signTypedData_v3:
        return this._eth_signTypedData_v3(i);
      case br.JSONRPCMethod.eth_signTypedData_v4:
      case br.JSONRPCMethod.eth_signTypedData:
        return this._eth_signTypedData_v4(i);
      case br.JSONRPCMethod.cbWallet_arbitrary:
        return this._cbwallet_arbitrary(i);
      case br.JSONRPCMethod.wallet_addEthereumChain:
        return this._wallet_addEthereumChain(i);
      case br.JSONRPCMethod.wallet_switchEthereumChain:
        return this._wallet_switchEthereumChain(i);
      case br.JSONRPCMethod.wallet_watchAsset:
        return this._wallet_watchAsset(i);
    }
    return (await this.initializeRelay()).makeEthereumJSONRPCRequest(e, this.jsonRpcUrl);
  }
  _handleAsynchronousFilterMethods(e) {
    const { method: r } = e, i = e.params || [];
    switch (r) {
      case br.JSONRPCMethod.eth_newFilter:
        return this._eth_newFilter(i);
      case br.JSONRPCMethod.eth_newBlockFilter:
        return this._eth_newBlockFilter();
      case br.JSONRPCMethod.eth_newPendingTransactionFilter:
        return this._eth_newPendingTransactionFilter();
      case br.JSONRPCMethod.eth_getFilterChanges:
        return this._eth_getFilterChanges(i);
      case br.JSONRPCMethod.eth_getFilterLogs:
        return this._eth_getFilterLogs(i);
    }
  }
  _handleSubscriptionMethods(e) {
    switch (e.method) {
      case br.JSONRPCMethod.eth_subscribe:
      case br.JSONRPCMethod.eth_unsubscribe:
        return this._subscriptionManager.handleRequest(e);
    }
  }
  _isKnownAddress(e) {
    try {
      const r = (0, Wt.ensureAddressString)(e);
      return this._addresses.map((s) => (0, Wt.ensureAddressString)(s)).includes(r);
    } catch {
    }
    return !1;
  }
  _ensureKnownAddress(e) {
    var r;
    if (!this._isKnownAddress(e))
      throw (r = this.diagnostic) === null || r === void 0 || r.log(og.EVENTS.UNKNOWN_ADDRESS_ENCOUNTERED), new Error("Unknown Ethereum address");
  }
  _prepareTransactionParams(e) {
    const r = e.from ? (0, Wt.ensureAddressString)(e.from) : this.selectedAddress;
    if (!r)
      throw new Error("Ethereum address is unavailable");
    this._ensureKnownAddress(r);
    const i = e.to ? (0, Wt.ensureAddressString)(e.to) : null, s = e.value != null ? (0, Wt.ensureBN)(e.value) : new hY.default(0), n = e.data ? (0, Wt.ensureBuffer)(e.data) : Buffer.alloc(0), f = e.nonce != null ? (0, Wt.ensureIntNumber)(e.nonce) : null, u = e.gasPrice != null ? (0, Wt.ensureBN)(e.gasPrice) : null, h = e.maxFeePerGas != null ? (0, Wt.ensureBN)(e.maxFeePerGas) : null, d = e.maxPriorityFeePerGas != null ? (0, Wt.ensureBN)(e.maxPriorityFeePerGas) : null, l = e.gas != null ? (0, Wt.ensureBN)(e.gas) : null, m = this.getChainId();
    return {
      fromAddress: r,
      toAddress: i,
      weiValue: s,
      data: n,
      nonce: f,
      gasPriceInWei: u,
      maxFeePerGas: h,
      maxPriorityFeePerGas: d,
      gasLimit: l,
      chainId: m
    };
  }
  _isAuthorized() {
    return this._addresses.length > 0;
  }
  _requireAuthorization() {
    if (!this._isAuthorized())
      throw Pi.ethErrors.provider.unauthorized({});
  }
  _throwUnsupportedMethodError() {
    throw Pi.ethErrors.provider.unsupportedMethod({});
  }
  async _signEthereumMessage(e, r, i, s) {
    this._ensureKnownAddress(r);
    try {
      const f = await (await this.initializeRelay()).signEthereumMessage(e, r, i, s).promise;
      return { jsonrpc: "2.0", id: 0, result: f.result };
    } catch (n) {
      throw typeof n.message == "string" && n.message.match(/(denied|rejected)/i) ? Pi.ethErrors.provider.userRejectedRequest("User denied message signature") : n;
    }
  }
  async _ethereumAddressFromSignedMessage(e, r, i) {
    const n = await (await this.initializeRelay()).ethereumAddressFromSignedMessage(e, r, i).promise;
    return { jsonrpc: "2.0", id: 0, result: n.result };
  }
  _eth_accounts() {
    return [...this._addresses];
  }
  _eth_coinbase() {
    return this.selectedAddress || null;
  }
  _net_version() {
    return this.getChainId().toString(10);
  }
  _eth_chainId() {
    return (0, Wt.hexStringFromIntNumber)(this.getChainId());
  }
  getChainId() {
    const e = this._storage.getItem(p6);
    if (!e)
      return (0, Wt.ensureIntNumber)(this._chainIdFromOpts);
    const r = parseInt(e, 10);
    return (0, Wt.ensureIntNumber)(r);
  }
  async _eth_requestAccounts() {
    var e;
    if ((e = this.diagnostic) === null || e === void 0 || e.log(og.EVENTS.ETH_ACCOUNTS_STATE, {
      method: "provider::_eth_requestAccounts",
      addresses_length: this._addresses.length,
      sessionIdHash: this._relay ? l6.Session.hash(this._relay.session.id) : void 0
    }), this._addresses.length > 0)
      return Promise.resolve({
        jsonrpc: "2.0",
        id: 0,
        result: this._addresses
      });
    let r;
    try {
      r = await (await this.initializeRelay()).requestEthereumAccounts().promise;
    } catch (i) {
      throw typeof i.message == "string" && i.message.match(/(denied|rejected)/i) ? Pi.ethErrors.provider.userRejectedRequest("User denied account authorization") : i;
    }
    if (!r.result)
      throw new Error("accounts received is empty");
    return this._setAddresses(r.result), this.isLedger || this.isCoinbaseBrowser || await this.switchEthereumChain(this.getChainId()), { jsonrpc: "2.0", id: 0, result: this._addresses };
  }
  _eth_sign(e) {
    this._requireAuthorization();
    const r = (0, Wt.ensureAddressString)(e[0]), i = (0, Wt.ensureBuffer)(e[1]);
    return this._signEthereumMessage(i, r, !1);
  }
  _eth_ecRecover(e) {
    const r = (0, Wt.ensureBuffer)(e[0]), i = (0, Wt.ensureBuffer)(e[1]);
    return this._ethereumAddressFromSignedMessage(r, i, !1);
  }
  _personal_sign(e) {
    this._requireAuthorization();
    const r = (0, Wt.ensureBuffer)(e[0]), i = (0, Wt.ensureAddressString)(e[1]);
    return this._signEthereumMessage(r, i, !0);
  }
  _personal_ecRecover(e) {
    const r = (0, Wt.ensureBuffer)(e[0]), i = (0, Wt.ensureBuffer)(e[1]);
    return this._ethereumAddressFromSignedMessage(r, i, !0);
  }
  async _eth_signTransaction(e) {
    this._requireAuthorization();
    const r = this._prepareTransactionParams(e[0] || {});
    try {
      const s = await (await this.initializeRelay()).signEthereumTransaction(r).promise;
      return { jsonrpc: "2.0", id: 0, result: s.result };
    } catch (i) {
      throw typeof i.message == "string" && i.message.match(/(denied|rejected)/i) ? Pi.ethErrors.provider.userRejectedRequest("User denied transaction signature") : i;
    }
  }
  async _eth_sendRawTransaction(e) {
    const r = (0, Wt.ensureBuffer)(e[0]), s = await (await this.initializeRelay()).submitEthereumTransaction(r, this.getChainId()).promise;
    return { jsonrpc: "2.0", id: 0, result: s.result };
  }
  async _eth_sendTransaction(e) {
    this._requireAuthorization();
    const r = this._prepareTransactionParams(e[0] || {});
    try {
      const s = await (await this.initializeRelay()).signAndSubmitEthereumTransaction(r).promise;
      return { jsonrpc: "2.0", id: 0, result: s.result };
    } catch (i) {
      throw typeof i.message == "string" && i.message.match(/(denied|rejected)/i) ? Pi.ethErrors.provider.userRejectedRequest("User denied transaction signature") : i;
    }
  }
  async _eth_signTypedData_v1(e) {
    this._requireAuthorization();
    const r = (0, Wt.ensureParsedJSONObject)(e[0]), i = (0, Wt.ensureAddressString)(e[1]);
    this._ensureKnownAddress(i);
    const s = fg.default.hashForSignTypedDataLegacy({ data: r }), n = JSON.stringify(r, null, 2);
    return this._signEthereumMessage(s, i, !1, n);
  }
  async _eth_signTypedData_v3(e) {
    this._requireAuthorization();
    const r = (0, Wt.ensureAddressString)(e[0]), i = (0, Wt.ensureParsedJSONObject)(e[1]);
    this._ensureKnownAddress(r);
    const s = fg.default.hashForSignTypedData_v3({ data: i }), n = JSON.stringify(i, null, 2);
    return this._signEthereumMessage(s, r, !1, n);
  }
  async _eth_signTypedData_v4(e) {
    this._requireAuthorization();
    const r = (0, Wt.ensureAddressString)(e[0]), i = (0, Wt.ensureParsedJSONObject)(e[1]);
    this._ensureKnownAddress(r);
    const s = fg.default.hashForSignTypedData_v4({ data: i }), n = JSON.stringify(i, null, 2);
    return this._signEthereumMessage(s, r, !1, n);
  }
  async _cbwallet_arbitrary(e) {
    const r = e[0], i = e[1];
    if (typeof i != "string")
      throw new Error("parameter must be a string");
    if (typeof r != "object" || r === null)
      throw new Error("parameter must be an object");
    const s = await this.genericRequest(r, i);
    return { jsonrpc: "2.0", id: 0, result: s };
  }
  async _wallet_addEthereumChain(e) {
    var r, i, s, n;
    const f = e[0];
    if (((r = f.rpcUrls) === null || r === void 0 ? void 0 : r.length) === 0)
      return {
        jsonrpc: "2.0",
        id: 0,
        error: { code: 2, message: "please pass in at least 1 rpcUrl" }
      };
    if (!f.chainName || f.chainName.trim() === "")
      throw Pi.ethErrors.provider.custom({
        code: 0,
        message: "chainName is a required field"
      });
    if (!f.nativeCurrency)
      throw Pi.ethErrors.provider.custom({
        code: 0,
        message: "nativeCurrency is a required field"
      });
    const u = parseInt(f.chainId, 16);
    return await this.addEthereumChain(u, (i = f.rpcUrls) !== null && i !== void 0 ? i : [], (s = f.blockExplorerUrls) !== null && s !== void 0 ? s : [], f.chainName, (n = f.iconUrls) !== null && n !== void 0 ? n : [], f.nativeCurrency) ? { jsonrpc: "2.0", id: 0, result: null } : {
      jsonrpc: "2.0",
      id: 0,
      error: { code: 2, message: "unable to add ethereum chain" }
    };
  }
  async _wallet_switchEthereumChain(e) {
    const r = e[0];
    return await this.switchEthereumChain(parseInt(r.chainId, 16)), { jsonrpc: "2.0", id: 0, result: null };
  }
  async _wallet_watchAsset(e) {
    const r = Array.isArray(e) ? e[0] : e;
    if (!r.type)
      throw Pi.ethErrors.rpc.invalidParams({
        message: "Type is required"
      });
    if ((r == null ? void 0 : r.type) !== "ERC20")
      throw Pi.ethErrors.rpc.invalidParams({
        message: `Asset of type '${r.type}' is not supported`
      });
    if (!(r != null && r.options))
      throw Pi.ethErrors.rpc.invalidParams({
        message: "Options are required"
      });
    if (!(r != null && r.options.address))
      throw Pi.ethErrors.rpc.invalidParams({
        message: "Address is required"
      });
    const i = this.getChainId(), { address: s, symbol: n, image: f, decimals: u } = r.options, h = await this.watchAsset(r.type, s, n, u, f, i);
    return { jsonrpc: "2.0", id: 0, result: h };
  }
  _eth_uninstallFilter(e) {
    const r = (0, Wt.ensureHexString)(e[0]);
    return this._filterPolyfill.uninstallFilter(r);
  }
  async _eth_newFilter(e) {
    const r = e[0], i = await this._filterPolyfill.newFilter(r);
    return { jsonrpc: "2.0", id: 0, result: i };
  }
  async _eth_newBlockFilter() {
    const e = await this._filterPolyfill.newBlockFilter();
    return { jsonrpc: "2.0", id: 0, result: e };
  }
  async _eth_newPendingTransactionFilter() {
    const e = await this._filterPolyfill.newPendingTransactionFilter();
    return { jsonrpc: "2.0", id: 0, result: e };
  }
  _eth_getFilterChanges(e) {
    const r = (0, Wt.ensureHexString)(e[0]);
    return this._filterPolyfill.getFilterChanges(r);
  }
  _eth_getFilterLogs(e) {
    const r = (0, Wt.ensureHexString)(e[0]);
    return this._filterPolyfill.getFilterLogs(r);
  }
  initializeRelay() {
    return this._relay ? Promise.resolve(this._relay) : this._relayProvider().then((e) => (e.setAccountsCallback((r, i) => this._setAddresses(r, i)), e.setChainCallback((r, i) => {
      this.updateProviderInfo(i, parseInt(r, 10));
    }), e.setDappDefaultChainCallback(this._chainIdFromOpts), this._relay = e, e));
  }
}
bc.CoinbaseWalletProvider = vY;
var wp = {}, _p = {}, Vh, Rt, IE, AE, rh, g6, TE, x0 = {}, NE = [], gY = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function Ia(t, e) {
  for (var r in e)
    t[r] = e[r];
  return t;
}
function DE(t) {
  var e = t.parentNode;
  e && e.removeChild(t);
}
function ym(t, e, r) {
  var i, s, n, f = {};
  for (n in e)
    n == "key" ? i = e[n] : n == "ref" ? s = e[n] : f[n] = e[n];
  if (arguments.length > 2 && (f.children = arguments.length > 3 ? Vh.call(arguments, 2) : r), typeof t == "function" && t.defaultProps != null)
    for (n in t.defaultProps)
      f[n] === void 0 && (f[n] = t.defaultProps[n]);
  return ih(t, f, i, s, null);
}
function ih(t, e, r, i, s) {
  var n = { type: t, props: e, key: r, ref: i, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: s == null ? ++IE : s };
  return s == null && Rt.vnode != null && Rt.vnode(n), n;
}
function bY() {
  return { current: null };
}
function Gh(t) {
  return t.children;
}
function nh(t, e) {
  this.props = t, this.context = e;
}
function gh(t, e) {
  if (e == null)
    return t.__ ? gh(t.__, t.__.__k.indexOf(t) + 1) : null;
  for (var r; e < t.__k.length; e++)
    if ((r = t.__k[e]) != null && r.__e != null)
      return r.__e;
  return typeof t.type == "function" ? gh(t) : null;
}
function CE(t) {
  var e, r;
  if ((t = t.__) != null && t.__c != null) {
    for (t.__e = t.__c.base = null, e = 0; e < t.__k.length; e++)
      if ((r = t.__k[e]) != null && r.__e != null) {
        t.__e = t.__c.base = r.__e;
        break;
      }
    return CE(t);
  }
}
function mm(t) {
  (!t.__d && (t.__d = !0) && rh.push(t) && !S0.__r++ || g6 !== Rt.debounceRendering) && ((g6 = Rt.debounceRendering) || setTimeout)(S0);
}
function S0() {
  for (var t; S0.__r = rh.length; )
    t = rh.sort(function(e, r) {
      return e.__v.__b - r.__v.__b;
    }), rh = [], t.some(function(e) {
      var r, i, s, n, f, u;
      e.__d && (f = (n = (r = e).__v).__e, (u = r.__P) && (i = [], (s = Ia({}, n)).__v = n.__v + 1, F2(u, n, s, r.__n, u.ownerSVGElement !== void 0, n.__h != null ? [f] : null, i, f == null ? gh(n) : f, n.__h), kE(i, n), n.__e != f && CE(n)));
    });
}
function OE(t, e, r, i, s, n, f, u, h, d) {
  var l, m, b, M, A, N, R, O = i && i.__k || NE, P = O.length;
  for (r.__k = [], l = 0; l < e.length; l++)
    if ((M = r.__k[l] = (M = e[l]) == null || typeof M == "boolean" ? null : typeof M == "string" || typeof M == "number" || typeof M == "bigint" ? ih(null, M, null, null, M) : Array.isArray(M) ? ih(Gh, { children: M }, null, null, null) : M.__b > 0 ? ih(M.type, M.props, M.key, M.ref ? M.ref : null, M.__v) : M) != null) {
      if (M.__ = r, M.__b = r.__b + 1, (b = O[l]) === null || b && M.key == b.key && M.type === b.type)
        O[l] = void 0;
      else
        for (m = 0; m < P; m++) {
          if ((b = O[m]) && M.key == b.key && M.type === b.type) {
            O[m] = void 0;
            break;
          }
          b = null;
        }
      F2(t, M, b = b || x0, s, n, f, u, h, d), A = M.__e, (m = M.ref) && b.ref != m && (R || (R = []), b.ref && R.push(b.ref, null, M), R.push(m, M.__c || A, M)), A != null ? (N == null && (N = A), typeof M.type == "function" && M.__k === b.__k ? M.__d = h = RE(M, h, t) : h = PE(t, M, b, O, A, h), typeof r.type == "function" && (r.__d = h)) : h && b.__e == h && h.parentNode != t && (h = gh(b));
    }
  for (r.__e = N, l = P; l--; )
    O[l] != null && BE(O[l], O[l]);
  if (R)
    for (l = 0; l < R.length; l++)
      jE(R[l], R[++l], R[++l]);
}
function RE(t, e, r) {
  for (var i, s = t.__k, n = 0; s && n < s.length; n++)
    (i = s[n]) && (i.__ = t, e = typeof i.type == "function" ? RE(i, e, r) : PE(r, i, i, s, i.__e, e));
  return e;
}
function LE(t, e) {
  return e = e || [], t == null || typeof t == "boolean" || (Array.isArray(t) ? t.some(function(r) {
    LE(r, e);
  }) : e.push(t)), e;
}
function PE(t, e, r, i, s, n) {
  var f, u, h;
  if (e.__d !== void 0)
    f = e.__d, e.__d = void 0;
  else if (r == null || s != n || s.parentNode == null)
    e:
      if (n == null || n.parentNode !== t)
        t.appendChild(s), f = null;
      else {
        for (u = n, h = 0; (u = u.nextSibling) && h < i.length; h += 2)
          if (u == s)
            break e;
        t.insertBefore(s, n), f = n;
      }
  return f !== void 0 ? f : s.nextSibling;
}
function yY(t, e, r, i, s) {
  var n;
  for (n in r)
    n === "children" || n === "key" || n in e || E0(t, n, null, r[n], i);
  for (n in e)
    s && typeof e[n] != "function" || n === "children" || n === "key" || n === "value" || n === "checked" || r[n] === e[n] || E0(t, n, e[n], r[n], i);
}
function b6(t, e, r) {
  e[0] === "-" ? t.setProperty(e, r) : t[e] = r == null ? "" : typeof r != "number" || gY.test(e) ? r : r + "px";
}
function E0(t, e, r, i, s) {
  var n;
  e:
    if (e === "style")
      if (typeof r == "string")
        t.style.cssText = r;
      else {
        if (typeof i == "string" && (t.style.cssText = i = ""), i)
          for (e in i)
            r && e in r || b6(t.style, e, "");
        if (r)
          for (e in r)
            i && r[e] === i[e] || b6(t.style, e, r[e]);
      }
    else if (e[0] === "o" && e[1] === "n")
      n = e !== (e = e.replace(/Capture$/, "")), e = e.toLowerCase() in t ? e.toLowerCase().slice(2) : e.slice(2), t.l || (t.l = {}), t.l[e + n] = r, r ? i || t.addEventListener(e, n ? m6 : y6, n) : t.removeEventListener(e, n ? m6 : y6, n);
    else if (e !== "dangerouslySetInnerHTML") {
      if (s)
        e = e.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if (e !== "href" && e !== "list" && e !== "form" && e !== "tabIndex" && e !== "download" && e in t)
        try {
          t[e] = r == null ? "" : r;
          break e;
        } catch {
        }
      typeof r == "function" || (r == null || r === !1 && e.indexOf("-") == -1 ? t.removeAttribute(e) : t.setAttribute(e, r));
    }
}
function y6(t) {
  this.l[t.type + !1](Rt.event ? Rt.event(t) : t);
}
function m6(t) {
  this.l[t.type + !0](Rt.event ? Rt.event(t) : t);
}
function F2(t, e, r, i, s, n, f, u, h) {
  var d, l, m, b, M, A, N, R, O, P, F, H, Q, Z, B, Y = e.type;
  if (e.constructor !== void 0)
    return null;
  r.__h != null && (h = r.__h, u = e.__e = r.__e, e.__h = null, n = [u]), (d = Rt.__b) && d(e);
  try {
    e:
      if (typeof Y == "function") {
        if (R = e.props, O = (d = Y.contextType) && i[d.__c], P = d ? O ? O.props.value : d.__ : i, r.__c ? N = (l = e.__c = r.__c).__ = l.__E : ("prototype" in Y && Y.prototype.render ? e.__c = l = new Y(R, P) : (e.__c = l = new nh(R, P), l.constructor = Y, l.render = wY), O && O.sub(l), l.props = R, l.state || (l.state = {}), l.context = P, l.__n = i, m = l.__d = !0, l.__h = [], l._sb = []), l.__s == null && (l.__s = l.state), Y.getDerivedStateFromProps != null && (l.__s == l.state && (l.__s = Ia({}, l.__s)), Ia(l.__s, Y.getDerivedStateFromProps(R, l.__s))), b = l.props, M = l.state, m)
          Y.getDerivedStateFromProps == null && l.componentWillMount != null && l.componentWillMount(), l.componentDidMount != null && l.__h.push(l.componentDidMount);
        else {
          if (Y.getDerivedStateFromProps == null && R !== b && l.componentWillReceiveProps != null && l.componentWillReceiveProps(R, P), !l.__e && l.shouldComponentUpdate != null && l.shouldComponentUpdate(R, l.__s, P) === !1 || e.__v === r.__v) {
            for (l.props = R, l.state = l.__s, e.__v !== r.__v && (l.__d = !1), l.__v = e, e.__e = r.__e, e.__k = r.__k, e.__k.forEach(function(ae) {
              ae && (ae.__ = e);
            }), F = 0; F < l._sb.length; F++)
              l.__h.push(l._sb[F]);
            l._sb = [], l.__h.length && f.push(l);
            break e;
          }
          l.componentWillUpdate != null && l.componentWillUpdate(R, l.__s, P), l.componentDidUpdate != null && l.__h.push(function() {
            l.componentDidUpdate(b, M, A);
          });
        }
        if (l.context = P, l.props = R, l.__v = e, l.__P = t, H = Rt.__r, Q = 0, "prototype" in Y && Y.prototype.render) {
          for (l.state = l.__s, l.__d = !1, H && H(e), d = l.render(l.props, l.state, l.context), Z = 0; Z < l._sb.length; Z++)
            l.__h.push(l._sb[Z]);
          l._sb = [];
        } else
          do
            l.__d = !1, H && H(e), d = l.render(l.props, l.state, l.context), l.state = l.__s;
          while (l.__d && ++Q < 25);
        l.state = l.__s, l.getChildContext != null && (i = Ia(Ia({}, i), l.getChildContext())), m || l.getSnapshotBeforeUpdate == null || (A = l.getSnapshotBeforeUpdate(b, M)), B = d != null && d.type === Gh && d.key == null ? d.props.children : d, OE(t, Array.isArray(B) ? B : [B], e, r, i, s, n, f, u, h), l.base = e.__e, e.__h = null, l.__h.length && f.push(l), N && (l.__E = l.__ = null), l.__e = !1;
      } else
        n == null && e.__v === r.__v ? (e.__k = r.__k, e.__e = r.__e) : e.__e = mY(r.__e, e, r, i, s, n, f, h);
    (d = Rt.diffed) && d(e);
  } catch (ae) {
    e.__v = null, (h || n != null) && (e.__e = u, e.__h = !!h, n[n.indexOf(u)] = null), Rt.__e(ae, e, r);
  }
}
function kE(t, e) {
  Rt.__c && Rt.__c(e, t), t.some(function(r) {
    try {
      t = r.__h, r.__h = [], t.some(function(i) {
        i.call(r);
      });
    } catch (i) {
      Rt.__e(i, r.__v);
    }
  });
}
function mY(t, e, r, i, s, n, f, u) {
  var h, d, l, m = r.props, b = e.props, M = e.type, A = 0;
  if (M === "svg" && (s = !0), n != null) {
    for (; A < n.length; A++)
      if ((h = n[A]) && "setAttribute" in h == !!M && (M ? h.localName === M : h.nodeType === 3)) {
        t = h, n[A] = null;
        break;
      }
  }
  if (t == null) {
    if (M === null)
      return document.createTextNode(b);
    t = s ? document.createElementNS("http://www.w3.org/2000/svg", M) : document.createElement(M, b.is && b), n = null, u = !1;
  }
  if (M === null)
    m === b || u && t.data === b || (t.data = b);
  else {
    if (n = n && Vh.call(t.childNodes), d = (m = r.props || x0).dangerouslySetInnerHTML, l = b.dangerouslySetInnerHTML, !u) {
      if (n != null)
        for (m = {}, A = 0; A < t.attributes.length; A++)
          m[t.attributes[A].name] = t.attributes[A].value;
      (l || d) && (l && (d && l.__html == d.__html || l.__html === t.innerHTML) || (t.innerHTML = l && l.__html || ""));
    }
    if (yY(t, b, m, s, u), l)
      e.__k = [];
    else if (A = e.props.children, OE(t, Array.isArray(A) ? A : [A], e, r, i, s && M !== "foreignObject", n, f, n ? n[0] : r.__k && gh(r, 0), u), n != null)
      for (A = n.length; A--; )
        n[A] != null && DE(n[A]);
    u || ("value" in b && (A = b.value) !== void 0 && (A !== t.value || M === "progress" && !A || M === "option" && A !== m.value) && E0(t, "value", A, m.value, !1), "checked" in b && (A = b.checked) !== void 0 && A !== t.checked && E0(t, "checked", A, m.checked, !1));
  }
  return t;
}
function jE(t, e, r) {
  try {
    typeof t == "function" ? t(e) : t.current = e;
  } catch (i) {
    Rt.__e(i, r);
  }
}
function BE(t, e, r) {
  var i, s;
  if (Rt.unmount && Rt.unmount(t), (i = t.ref) && (i.current && i.current !== t.__e || jE(i, null, e)), (i = t.__c) != null) {
    if (i.componentWillUnmount)
      try {
        i.componentWillUnmount();
      } catch (n) {
        Rt.__e(n, e);
      }
    i.base = i.__P = null, t.__c = void 0;
  }
  if (i = t.__k)
    for (s = 0; s < i.length; s++)
      i[s] && BE(i[s], e, r || typeof t.type != "function");
  r || t.__e == null || DE(t.__e), t.__ = t.__e = t.__d = void 0;
}
function wY(t, e, r) {
  return this.constructor(t, r);
}
function zE(t, e, r) {
  var i, s, n;
  Rt.__ && Rt.__(t, e), s = (i = typeof r == "function") ? null : r && r.__k || e.__k, n = [], F2(e, t = (!i && r || e).__k = ym(Gh, null, [t]), s || x0, x0, e.ownerSVGElement !== void 0, !i && r ? [r] : s ? null : e.firstChild ? Vh.call(e.childNodes) : null, n, !i && r ? r : s ? s.__e : e.firstChild, i), kE(n, t);
}
function UE(t, e) {
  zE(t, e, UE);
}
function _Y(t, e, r) {
  var i, s, n, f = Ia({}, t.props);
  for (n in e)
    n == "key" ? i = e[n] : n == "ref" ? s = e[n] : f[n] = e[n];
  return arguments.length > 2 && (f.children = arguments.length > 3 ? Vh.call(arguments, 2) : r), ih(t.type, f, i || t.key, s || t.ref, null);
}
function MY(t, e) {
  var r = { __c: e = "__cC" + TE++, __: t, Consumer: function(i, s) {
    return i.children(s);
  }, Provider: function(i) {
    var s, n;
    return this.getChildContext || (s = [], (n = {})[e] = this, this.getChildContext = function() {
      return n;
    }, this.shouldComponentUpdate = function(f) {
      this.props.value !== f.value && s.some(mm);
    }, this.sub = function(f) {
      s.push(f);
      var u = f.componentWillUnmount;
      f.componentWillUnmount = function() {
        s.splice(s.indexOf(f), 1), u && u.call(f);
      };
    }), i.children;
  } };
  return r.Provider.__ = r.Consumer.contextType = r;
}
Vh = NE.slice, Rt = { __e: function(t, e, r, i) {
  for (var s, n, f; e = e.__; )
    if ((s = e.__c) && !s.__)
      try {
        if ((n = s.constructor) && n.getDerivedStateFromError != null && (s.setState(n.getDerivedStateFromError(t)), f = s.__d), s.componentDidCatch != null && (s.componentDidCatch(t, i || {}), f = s.__d), f)
          return s.__E = s;
      } catch (u) {
        t = u;
      }
  throw t;
} }, IE = 0, AE = function(t) {
  return t != null && t.constructor === void 0;
}, nh.prototype.setState = function(t, e) {
  var r;
  r = this.__s != null && this.__s !== this.state ? this.__s : this.__s = Ia({}, this.state), typeof t == "function" && (t = t(Ia({}, r), this.props)), t && Ia(r, t), t != null && this.__v && (e && this._sb.push(e), mm(this));
}, nh.prototype.forceUpdate = function(t) {
  this.__v && (this.__e = !0, t && this.__h.push(t), mm(this));
}, nh.prototype.render = Gh, rh = [], S0.__r = 0, TE = 0;
const xY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Component: nh,
  Fragment: Gh,
  cloneElement: _Y,
  createContext: MY,
  createElement: ym,
  createRef: bY,
  h: ym,
  hydrate: UE,
  get isValidElement() {
    return AE;
  },
  get options() {
    return Rt;
  },
  render: zE,
  toChildArray: LE
}, Symbol.toStringTag, { value: "Module" })), Kh = /* @__PURE__ */ pf(xY);
var Mp = {};
function FE(t) {
  var e, r, i = "";
  if (typeof t == "string" || typeof t == "number")
    i += t;
  else if (typeof t == "object")
    if (Array.isArray(t))
      for (e = 0; e < t.length; e++)
        t[e] && (r = FE(t[e])) && (i && (i += " "), i += r);
    else
      for (e in t)
        t[e] && (i && (i += " "), i += e);
  return i;
}
function SY() {
  for (var t = 0, e, r, i = ""; t < arguments.length; )
    (e = arguments[t++]) && (r = FE(e)) && (i && (i += " "), i += r);
  return i;
}
const EY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: SY
}, Symbol.toStringTag, { value: "Module" })), $E = /* @__PURE__ */ pf(EY);
var Oa, Br, cg, w6, Ac = 0, qE = [], Qd = [], _6 = Rt.__b, M6 = Rt.__r, x6 = Rt.diffed, S6 = Rt.__c, E6 = Rt.unmount;
function yf(t, e) {
  Rt.__h && Rt.__h(Br, t, Ac || e), Ac = 0;
  var r = Br.__H || (Br.__H = { __: [], __h: [] });
  return t >= r.__.length && r.__.push({ __V: Qd }), r.__[t];
}
function HE(t) {
  return Ac = 1, WE(GE, t);
}
function WE(t, e, r) {
  var i = yf(Oa++, 2);
  if (i.t = t, !i.__c && (i.__ = [r ? r(e) : GE(void 0, e), function(n) {
    var f = i.__N ? i.__N[0] : i.__[0], u = i.t(f, n);
    f !== u && (i.__N = [u, i.__[1]], i.__c.setState({}));
  }], i.__c = Br, !Br.u)) {
    Br.u = !0;
    var s = Br.shouldComponentUpdate;
    Br.shouldComponentUpdate = function(n, f, u) {
      if (!i.__c.__H)
        return !0;
      var h = i.__c.__H.__.filter(function(l) {
        return l.__c;
      });
      if (h.every(function(l) {
        return !l.__N;
      }))
        return !s || s.call(this, n, f, u);
      var d = !1;
      return h.forEach(function(l) {
        if (l.__N) {
          var m = l.__[0];
          l.__ = l.__N, l.__N = void 0, m !== l.__[0] && (d = !0);
        }
      }), !(!d && i.__c.props === n) && (!s || s.call(this, n, f, u));
    };
  }
  return i.__N || i.__;
}
function IY(t, e) {
  var r = yf(Oa++, 3);
  !Rt.__s && q2(r.__H, e) && (r.__ = t, r.i = e, Br.__H.__h.push(r));
}
function VE(t, e) {
  var r = yf(Oa++, 4);
  !Rt.__s && q2(r.__H, e) && (r.__ = t, r.i = e, Br.__h.push(r));
}
function AY(t) {
  return Ac = 5, $2(function() {
    return { current: t };
  }, []);
}
function TY(t, e, r) {
  Ac = 6, VE(function() {
    return typeof t == "function" ? (t(e()), function() {
      return t(null);
    }) : t ? (t.current = e(), function() {
      return t.current = null;
    }) : void 0;
  }, r == null ? r : r.concat(t));
}
function $2(t, e) {
  var r = yf(Oa++, 7);
  return q2(r.__H, e) ? (r.__V = t(), r.i = e, r.__h = t, r.__V) : r.__;
}
function NY(t, e) {
  return Ac = 8, $2(function() {
    return t;
  }, e);
}
function DY(t) {
  var e = Br.context[t.__c], r = yf(Oa++, 9);
  return r.c = t, e ? (r.__ == null && (r.__ = !0, e.sub(Br)), e.props.value) : t.__;
}
function CY(t, e) {
  Rt.useDebugValue && Rt.useDebugValue(e ? e(t) : t);
}
function OY(t) {
  var e = yf(Oa++, 10), r = HE();
  return e.__ = t, Br.componentDidCatch || (Br.componentDidCatch = function(i, s) {
    e.__ && e.__(i, s), r[1](i);
  }), [r[0], function() {
    r[1](void 0);
  }];
}
function RY() {
  var t = yf(Oa++, 11);
  return t.__ || (t.__ = "P" + function(e) {
    for (var r = 0, i = e.length; i > 0; )
      r = (r << 5) - r + e.charCodeAt(--i) | 0;
    return r;
  }(Br.__v.__m) + Oa), t.__;
}
function LY() {
  for (var t; t = qE.shift(); )
    if (t.__P && t.__H)
      try {
        t.__H.__h.forEach(Zd), t.__H.__h.forEach(wm), t.__H.__h = [];
      } catch (e) {
        t.__H.__h = [], Rt.__e(e, t.__v);
      }
}
Rt.__b = function(t) {
  typeof t.type != "function" || t.__m || t.__ === null ? t.__m || (t.__m = t.__ && t.__.__m ? t.__.__m : "") : t.__m = (t.__ && t.__.__m ? t.__.__m : "") + (t.__ && t.__.__k ? t.__.__k.indexOf(t) : 0), Br = null, _6 && _6(t);
}, Rt.__r = function(t) {
  M6 && M6(t), Oa = 0;
  var e = (Br = t.__c).__H;
  e && (cg === Br ? (e.__h = [], Br.__h = [], e.__.forEach(function(r) {
    r.__N && (r.__ = r.__N), r.__V = Qd, r.__N = r.i = void 0;
  })) : (e.__h.forEach(Zd), e.__h.forEach(wm), e.__h = [])), cg = Br;
}, Rt.diffed = function(t) {
  x6 && x6(t);
  var e = t.__c;
  e && e.__H && (e.__H.__h.length && (qE.push(e) !== 1 && w6 === Rt.requestAnimationFrame || ((w6 = Rt.requestAnimationFrame) || PY)(LY)), e.__H.__.forEach(function(r) {
    r.i && (r.__H = r.i), r.__V !== Qd && (r.__ = r.__V), r.i = void 0, r.__V = Qd;
  })), cg = Br = null;
}, Rt.__c = function(t, e) {
  e.some(function(r) {
    try {
      r.__h.forEach(Zd), r.__h = r.__h.filter(function(i) {
        return !i.__ || wm(i);
      });
    } catch (i) {
      e.some(function(s) {
        s.__h && (s.__h = []);
      }), e = [], Rt.__e(i, r.__v);
    }
  }), S6 && S6(t, e);
}, Rt.unmount = function(t) {
  E6 && E6(t);
  var e, r = t.__c;
  r && r.__H && (r.__H.__.forEach(function(i) {
    try {
      Zd(i);
    } catch (s) {
      e = s;
    }
  }), r.__H = void 0, e && Rt.__e(e, r.__v));
};
var I6 = typeof requestAnimationFrame == "function";
function PY(t) {
  var e, r = function() {
    clearTimeout(i), I6 && cancelAnimationFrame(e), setTimeout(t);
  }, i = setTimeout(r, 100);
  I6 && (e = requestAnimationFrame(r));
}
function Zd(t) {
  var e = Br, r = t.__c;
  typeof r == "function" && (t.__c = void 0, r()), Br = e;
}
function wm(t) {
  var e = Br;
  t.__c = t.__(), Br = e;
}
function q2(t, e) {
  return !t || t.length !== e.length || e.some(function(r, i) {
    return r !== t[i];
  });
}
function GE(t, e) {
  return typeof e == "function" ? e(t) : e;
}
const kY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useCallback: NY,
  useContext: DY,
  useDebugValue: CY,
  useEffect: IY,
  useErrorBoundary: OY,
  useId: RY,
  useImperativeHandle: TY,
  useLayoutEffect: VE,
  useMemo: $2,
  useReducer: WE,
  useRef: AY,
  useState: HE
}, Symbol.toStringTag, { value: "Module" })), H2 = /* @__PURE__ */ pf(kY);
var xp = {};
Object.defineProperty(xp, "__esModule", { value: !0 });
xp.LIB_VERSION = void 0;
xp.LIB_VERSION = "3.5.4";
var W2 = {};
Object.defineProperty(W2, "__esModule", { value: !0 });
W2.default = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTggMEMzLjU4IDAgMCAzLjU4IDAgOHMzLjU4IDggOCA4IDgtMy41OCA4LTgtMy41OC04LTgtOFptNS45MSA3aC0xLjk0Yy0uMS0xLjU3LS40Mi0zLS45MS00LjE1IDEuNDguODggMi41NSAyLjM4IDIuODUgNC4xNVpNOCAxNGMtLjQ1IDAtMS43Mi0xLjc3LTEuOTUtNWgzLjljLS4yMyAzLjIzLTEuNSA1LTEuOTUgNVpNNi4wNSA3QzYuMjggMy43NyA3LjU1IDIgOCAyYy40NSAwIDEuNzIgMS43NyAxLjk1IDVoLTMuOVpNNC45NCAyLjg1QzQuNDYgNCA0LjEzIDUuNDMgNC4wMyA3SDIuMDljLjMtMS43NyAxLjM3LTMuMjcgMi44NS00LjE1Wk0yLjA5IDloMS45NGMuMSAxLjU3LjQyIDMgLjkxIDQuMTVBNS45OTggNS45OTggMCAwIDEgMi4wOSA5Wm04Ljk3IDQuMTVjLjQ4LTEuMTUuODEtMi41OC45MS00LjE1aDEuOTRhNS45OTggNS45OTggMCAwIDEtMi44NSA0LjE1WiIgZmlsbD0iIzE2NTJGMCIvPjwvc3ZnPg==";
var V2 = {};
Object.defineProperty(V2, "__esModule", { value: !0 });
V2.default = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE1LjYzNSAyLjExN2EzLjg4OSAzLjg4OSAwIDAgMC01LjUyMSAwTDYuODkgNS4zMzVBMy44OTQgMy44OTQgMCAwIDAgNS44IDguNzM5Yy4wODMuNTA2LjI2OCAxLjAxMS41NTMgMS40NjYuMTUxLjI1My4zMzYuNDcyLjUzNy42OTFsLjYyMS42MjQgMS4xNDEtMS4xNDYtLjYyLS42MjRhMi4xMDUgMi4xMDUgMCAwIDEtLjQ4Ny0uNzQxIDIuMzQgMi4zNCAwIDAgMSAuNTAzLTIuNTFsMy4yMDYtMy4yMmEyLjI5MyAyLjI5MyAwIDAgMSAzLjIzOSAwYy44OS44OTQuODkgMi4zNDMgMCAzLjI1M2wtMS41MjcgMS41MzNjLjIzNC42NC4zMzUgMS4zMzEuMzAyIDIuMDA1bDIuMzgzLTIuMzkyYzEuNTEtMS41MzQgMS40OTMtNC4wMjgtLjAxNy01LjU2MVoiIGZpbGw9IiMxNjUyRjAiLz48cGF0aCBkPSJNMTEuMjcxIDcuNzQ1YTMuMTMgMy4xMyAwIDAgMC0uNTU0LS42OWwtLjYyLS42MjQtMS4xNDIgMS4xNDYuNjIxLjYyM2MuMjE4LjIyLjM4Ni40ODkuNDg3Ljc1OC4zMzUuODI2LjE2NyAxLjgyLS41MDQgMi40OTRsLTMuMjA1IDMuMjE5YTIuMjkzIDIuMjkzIDAgMCAxLTMuMjQgMCAyLjMxNiAyLjMxNiAwIDAgMSAwLTMuMjUybDEuNTI4LTEuNTM0YTQuODE1IDQuODE1IDAgMCAxLS4yODUtMi4wMDVsLTIuMzgzIDIuMzkzYTMuOTI3IDMuOTI3IDAgMCAwIDAgNS41NDQgMy45MDkgMy45MDkgMCAwIDAgNS41MzggMGwzLjIwNS0zLjIxOWEzLjk1OCAzLjk1OCAwIDAgMCAxLjA5MS0zLjQwNCA0LjIxMSA0LjIxMSAwIDAgMC0uNTM3LTEuNDQ5WiIgZmlsbD0iIzE2NTJGMCIvPjwvc3ZnPg==";
var G2 = {};
Object.defineProperty(G2, "__esModule", { value: !0 });
G2.default = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEgN3Y5aDE0VjdIMVptNy41IDQuMzlWMTRoLTF2LTIuNjFjLS40NC0uMTktLjc1LS42My0uNzUtMS4xNGExLjI1IDEuMjUgMCAwIDEgMi41IDBjMCAuNTEtLjMxLjk1LS43NSAxLjE0Wk01LjY3IDZWNC4zM0M1LjY3IDMuMDUgNi43MSAyIDggMnMyLjMzIDEuMDUgMi4zMyAyLjMzVjZoMlY0LjMzQzEyLjMzIDEuOTQgMTAuMzkgMCA4IDBTMy42NyAxLjk0IDMuNjcgNC4zM1Y2aDJaIiBmaWxsPSIjMTY1MkYwIi8+PC9zdmc+";
var K2 = {};
Object.defineProperty(K2, "__esModule", { value: !0 });
K2.default = `<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="50" cy="50" r="50" fill="white"/>
<circle cx="49.9996" cy="49.9996" r="43.6363" fill="#1B53E4"/>
<circle cx="49.9996" cy="49.9996" r="43.6363" stroke="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19.3379 49.9484C19.3379 66.8508 33.04 80.553 49.9425 80.553C66.8449 80.553 80.5471 66.8508 80.5471 49.9484C80.5471 33.0459 66.8449 19.3438 49.9425 19.3438C33.04 19.3438 19.3379 33.0459 19.3379 49.9484ZM44.0817 40.0799C41.8725 40.0799 40.0817 41.8708 40.0817 44.0799V55.8029C40.0817 58.012 41.8725 59.8029 44.0817 59.8029H55.8046C58.0138 59.8029 59.8046 58.012 59.8046 55.8029V44.0799C59.8046 41.8708 58.0138 40.0799 55.8046 40.0799H44.0817Z" fill="white"/>
</svg>

`;
var Sp = {};
function KE(t) {
  this.mode = En.MODE_8BIT_BYTE, this.data = t, this.parsedData = [];
  for (var e = 0, r = this.data.length; e < r; e++) {
    var i = [], s = this.data.charCodeAt(e);
    s > 65536 ? (i[0] = 240 | (s & 1835008) >>> 18, i[1] = 128 | (s & 258048) >>> 12, i[2] = 128 | (s & 4032) >>> 6, i[3] = 128 | s & 63) : s > 2048 ? (i[0] = 224 | (s & 61440) >>> 12, i[1] = 128 | (s & 4032) >>> 6, i[2] = 128 | s & 63) : s > 128 ? (i[0] = 192 | (s & 1984) >>> 6, i[1] = 128 | s & 63) : i[0] = s, this.parsedData.push(i);
  }
  this.parsedData = Array.prototype.concat.apply([], this.parsedData), this.parsedData.length != this.data.length && (this.parsedData.unshift(191), this.parsedData.unshift(187), this.parsedData.unshift(239));
}
KE.prototype = {
  getLength: function(t) {
    return this.parsedData.length;
  },
  write: function(t) {
    for (var e = 0, r = this.parsedData.length; e < r; e++)
      t.put(this.parsedData[e], 8);
  }
};
function Qs(t, e) {
  this.typeNumber = t, this.errorCorrectLevel = e, this.modules = null, this.moduleCount = 0, this.dataCache = null, this.dataList = [];
}
Qs.prototype = { addData: function(t) {
  var e = new KE(t);
  this.dataList.push(e), this.dataCache = null;
}, isDark: function(t, e) {
  if (t < 0 || this.moduleCount <= t || e < 0 || this.moduleCount <= e)
    throw new Error(t + "," + e);
  return this.modules[t][e];
}, getModuleCount: function() {
  return this.moduleCount;
}, make: function() {
  this.makeImpl(!1, this.getBestMaskPattern());
}, makeImpl: function(t, e) {
  this.moduleCount = this.typeNumber * 4 + 17, this.modules = new Array(this.moduleCount);
  for (var r = 0; r < this.moduleCount; r++) {
    this.modules[r] = new Array(this.moduleCount);
    for (var i = 0; i < this.moduleCount; i++)
      this.modules[r][i] = null;
  }
  this.setupPositionProbePattern(0, 0), this.setupPositionProbePattern(this.moduleCount - 7, 0), this.setupPositionProbePattern(0, this.moduleCount - 7), this.setupPositionAdjustPattern(), this.setupTimingPattern(), this.setupTypeInfo(t, e), this.typeNumber >= 7 && this.setupTypeNumber(t), this.dataCache == null && (this.dataCache = Qs.createData(this.typeNumber, this.errorCorrectLevel, this.dataList)), this.mapData(this.dataCache, e);
}, setupPositionProbePattern: function(t, e) {
  for (var r = -1; r <= 7; r++)
    if (!(t + r <= -1 || this.moduleCount <= t + r))
      for (var i = -1; i <= 7; i++)
        e + i <= -1 || this.moduleCount <= e + i || (0 <= r && r <= 6 && (i == 0 || i == 6) || 0 <= i && i <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= i && i <= 4 ? this.modules[t + r][e + i] = !0 : this.modules[t + r][e + i] = !1);
}, getBestMaskPattern: function() {
  for (var t = 0, e = 0, r = 0; r < 8; r++) {
    this.makeImpl(!0, r);
    var i = Wr.getLostPoint(this);
    (r == 0 || t > i) && (t = i, e = r);
  }
  return e;
}, createMovieClip: function(t, e, r) {
  var i = t.createEmptyMovieClip(e, r), s = 1;
  this.make();
  for (var n = 0; n < this.modules.length; n++)
    for (var f = n * s, u = 0; u < this.modules[n].length; u++) {
      var h = u * s, d = this.modules[n][u];
      d && (i.beginFill(0, 100), i.moveTo(h, f), i.lineTo(h + s, f), i.lineTo(h + s, f + s), i.lineTo(h, f + s), i.endFill());
    }
  return i;
}, setupTimingPattern: function() {
  for (var t = 8; t < this.moduleCount - 8; t++)
    this.modules[t][6] == null && (this.modules[t][6] = t % 2 == 0);
  for (var e = 8; e < this.moduleCount - 8; e++)
    this.modules[6][e] == null && (this.modules[6][e] = e % 2 == 0);
}, setupPositionAdjustPattern: function() {
  for (var t = Wr.getPatternPosition(this.typeNumber), e = 0; e < t.length; e++)
    for (var r = 0; r < t.length; r++) {
      var i = t[e], s = t[r];
      if (this.modules[i][s] == null)
        for (var n = -2; n <= 2; n++)
          for (var f = -2; f <= 2; f++)
            n == -2 || n == 2 || f == -2 || f == 2 || n == 0 && f == 0 ? this.modules[i + n][s + f] = !0 : this.modules[i + n][s + f] = !1;
    }
}, setupTypeNumber: function(t) {
  for (var e = Wr.getBCHTypeNumber(this.typeNumber), r = 0; r < 18; r++) {
    var i = !t && (e >> r & 1) == 1;
    this.modules[Math.floor(r / 3)][r % 3 + this.moduleCount - 8 - 3] = i;
  }
  for (var r = 0; r < 18; r++) {
    var i = !t && (e >> r & 1) == 1;
    this.modules[r % 3 + this.moduleCount - 8 - 3][Math.floor(r / 3)] = i;
  }
}, setupTypeInfo: function(t, e) {
  for (var r = this.errorCorrectLevel << 3 | e, i = Wr.getBCHTypeInfo(r), s = 0; s < 15; s++) {
    var n = !t && (i >> s & 1) == 1;
    s < 6 ? this.modules[s][8] = n : s < 8 ? this.modules[s + 1][8] = n : this.modules[this.moduleCount - 15 + s][8] = n;
  }
  for (var s = 0; s < 15; s++) {
    var n = !t && (i >> s & 1) == 1;
    s < 8 ? this.modules[8][this.moduleCount - s - 1] = n : s < 9 ? this.modules[8][15 - s - 1 + 1] = n : this.modules[8][15 - s - 1] = n;
  }
  this.modules[this.moduleCount - 8][8] = !t;
}, mapData: function(t, e) {
  for (var r = -1, i = this.moduleCount - 1, s = 7, n = 0, f = this.moduleCount - 1; f > 0; f -= 2)
    for (f == 6 && f--; ; ) {
      for (var u = 0; u < 2; u++)
        if (this.modules[i][f - u] == null) {
          var h = !1;
          n < t.length && (h = (t[n] >>> s & 1) == 1);
          var d = Wr.getMask(e, i, f - u);
          d && (h = !h), this.modules[i][f - u] = h, s--, s == -1 && (n++, s = 7);
        }
      if (i += r, i < 0 || this.moduleCount <= i) {
        i -= r, r = -r;
        break;
      }
    }
} };
Qs.PAD0 = 236;
Qs.PAD1 = 17;
Qs.createData = function(t, e, r) {
  for (var i = Ks.getRSBlocks(t, e), s = new YE(), n = 0; n < r.length; n++) {
    var f = r[n];
    s.put(f.mode, 4), s.put(f.getLength(), Wr.getLengthInBits(f.mode, t)), f.write(s);
  }
  for (var u = 0, n = 0; n < i.length; n++)
    u += i[n].dataCount;
  if (s.getLengthInBits() > u * 8)
    throw new Error("code length overflow. (" + s.getLengthInBits() + ">" + u * 8 + ")");
  for (s.getLengthInBits() + 4 <= u * 8 && s.put(0, 4); s.getLengthInBits() % 8 != 0; )
    s.putBit(!1);
  for (; !(s.getLengthInBits() >= u * 8 || (s.put(Qs.PAD0, 8), s.getLengthInBits() >= u * 8)); )
    s.put(Qs.PAD1, 8);
  return Qs.createBytes(s, i);
};
Qs.createBytes = function(t, e) {
  for (var r = 0, i = 0, s = 0, n = new Array(e.length), f = new Array(e.length), u = 0; u < e.length; u++) {
    var h = e[u].dataCount, d = e[u].totalCount - h;
    i = Math.max(i, h), s = Math.max(s, d), n[u] = new Array(h);
    for (var l = 0; l < n[u].length; l++)
      n[u][l] = 255 & t.buffer[l + r];
    r += h;
    var m = Wr.getErrorCorrectPolynomial(d), b = new hc(n[u], m.getLength() - 1), M = b.mod(m);
    f[u] = new Array(m.getLength() - 1);
    for (var l = 0; l < f[u].length; l++) {
      var A = l + M.getLength() - f[u].length;
      f[u][l] = A >= 0 ? M.get(A) : 0;
    }
  }
  for (var N = 0, l = 0; l < e.length; l++)
    N += e[l].totalCount;
  for (var R = new Array(N), O = 0, l = 0; l < i; l++)
    for (var u = 0; u < e.length; u++)
      l < n[u].length && (R[O++] = n[u][l]);
  for (var l = 0; l < s; l++)
    for (var u = 0; u < e.length; u++)
      l < f[u].length && (R[O++] = f[u][l]);
  return R;
};
var En = { MODE_NUMBER: 1 << 0, MODE_ALPHA_NUM: 1 << 1, MODE_8BIT_BYTE: 1 << 2, MODE_KANJI: 1 << 3 }, ro = { L: 1, M: 0, Q: 3, H: 2 }, Ga = { PATTERN000: 0, PATTERN001: 1, PATTERN010: 2, PATTERN011: 3, PATTERN100: 4, PATTERN101: 5, PATTERN110: 6, PATTERN111: 7 }, Wr = { PATTERN_POSITION_TABLE: [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70], [6, 26, 50, 74], [6, 30, 54, 78], [6, 30, 56, 82], [6, 30, 58, 86], [6, 34, 62, 90], [6, 28, 50, 72, 94], [6, 26, 50, 74, 98], [6, 30, 54, 78, 102], [6, 28, 54, 80, 106], [6, 32, 58, 84, 110], [6, 30, 58, 86, 114], [6, 34, 62, 90, 118], [6, 26, 50, 74, 98, 122], [6, 30, 54, 78, 102, 126], [6, 26, 52, 78, 104, 130], [6, 30, 56, 82, 108, 134], [6, 34, 60, 86, 112, 138], [6, 30, 58, 86, 114, 142], [6, 34, 62, 90, 118, 146], [6, 30, 54, 78, 102, 126, 150], [6, 24, 50, 76, 102, 128, 154], [6, 28, 54, 80, 106, 132, 158], [6, 32, 58, 84, 110, 136, 162], [6, 26, 54, 82, 110, 138, 166], [6, 30, 58, 86, 114, 142, 170]], G15: 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0, G18: 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0, G15_MASK: 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1, getBCHTypeInfo: function(t) {
  for (var e = t << 10; Wr.getBCHDigit(e) - Wr.getBCHDigit(Wr.G15) >= 0; )
    e ^= Wr.G15 << Wr.getBCHDigit(e) - Wr.getBCHDigit(Wr.G15);
  return (t << 10 | e) ^ Wr.G15_MASK;
}, getBCHTypeNumber: function(t) {
  for (var e = t << 12; Wr.getBCHDigit(e) - Wr.getBCHDigit(Wr.G18) >= 0; )
    e ^= Wr.G18 << Wr.getBCHDigit(e) - Wr.getBCHDigit(Wr.G18);
  return t << 12 | e;
}, getBCHDigit: function(t) {
  for (var e = 0; t != 0; )
    e++, t >>>= 1;
  return e;
}, getPatternPosition: function(t) {
  return Wr.PATTERN_POSITION_TABLE[t - 1];
}, getMask: function(t, e, r) {
  switch (t) {
    case Ga.PATTERN000:
      return (e + r) % 2 == 0;
    case Ga.PATTERN001:
      return e % 2 == 0;
    case Ga.PATTERN010:
      return r % 3 == 0;
    case Ga.PATTERN011:
      return (e + r) % 3 == 0;
    case Ga.PATTERN100:
      return (Math.floor(e / 2) + Math.floor(r / 3)) % 2 == 0;
    case Ga.PATTERN101:
      return e * r % 2 + e * r % 3 == 0;
    case Ga.PATTERN110:
      return (e * r % 2 + e * r % 3) % 2 == 0;
    case Ga.PATTERN111:
      return (e * r % 3 + (e + r) % 2) % 2 == 0;
    default:
      throw new Error("bad maskPattern:" + t);
  }
}, getErrorCorrectPolynomial: function(t) {
  for (var e = new hc([1], 0), r = 0; r < t; r++)
    e = e.multiply(new hc([1, bi.gexp(r)], 0));
  return e;
}, getLengthInBits: function(t, e) {
  if (1 <= e && e < 10)
    switch (t) {
      case En.MODE_NUMBER:
        return 10;
      case En.MODE_ALPHA_NUM:
        return 9;
      case En.MODE_8BIT_BYTE:
        return 8;
      case En.MODE_KANJI:
        return 8;
      default:
        throw new Error("mode:" + t);
    }
  else if (e < 27)
    switch (t) {
      case En.MODE_NUMBER:
        return 12;
      case En.MODE_ALPHA_NUM:
        return 11;
      case En.MODE_8BIT_BYTE:
        return 16;
      case En.MODE_KANJI:
        return 10;
      default:
        throw new Error("mode:" + t);
    }
  else if (e < 41)
    switch (t) {
      case En.MODE_NUMBER:
        return 14;
      case En.MODE_ALPHA_NUM:
        return 13;
      case En.MODE_8BIT_BYTE:
        return 16;
      case En.MODE_KANJI:
        return 12;
      default:
        throw new Error("mode:" + t);
    }
  else
    throw new Error("type:" + e);
}, getLostPoint: function(t) {
  for (var e = t.getModuleCount(), r = 0, i = 0; i < e; i++)
    for (var s = 0; s < e; s++) {
      for (var n = 0, f = t.isDark(i, s), u = -1; u <= 1; u++)
        if (!(i + u < 0 || e <= i + u))
          for (var h = -1; h <= 1; h++)
            s + h < 0 || e <= s + h || u == 0 && h == 0 || f == t.isDark(i + u, s + h) && n++;
      n > 5 && (r += 3 + n - 5);
    }
  for (var i = 0; i < e - 1; i++)
    for (var s = 0; s < e - 1; s++) {
      var d = 0;
      t.isDark(i, s) && d++, t.isDark(i + 1, s) && d++, t.isDark(i, s + 1) && d++, t.isDark(i + 1, s + 1) && d++, (d == 0 || d == 4) && (r += 3);
    }
  for (var i = 0; i < e; i++)
    for (var s = 0; s < e - 6; s++)
      t.isDark(i, s) && !t.isDark(i, s + 1) && t.isDark(i, s + 2) && t.isDark(i, s + 3) && t.isDark(i, s + 4) && !t.isDark(i, s + 5) && t.isDark(i, s + 6) && (r += 40);
  for (var s = 0; s < e; s++)
    for (var i = 0; i < e - 6; i++)
      t.isDark(i, s) && !t.isDark(i + 1, s) && t.isDark(i + 2, s) && t.isDark(i + 3, s) && t.isDark(i + 4, s) && !t.isDark(i + 5, s) && t.isDark(i + 6, s) && (r += 40);
  for (var l = 0, s = 0; s < e; s++)
    for (var i = 0; i < e; i++)
      t.isDark(i, s) && l++;
  var m = Math.abs(100 * l / e / e - 50) / 5;
  return r += m * 10, r;
} }, bi = { glog: function(t) {
  if (t < 1)
    throw new Error("glog(" + t + ")");
  return bi.LOG_TABLE[t];
}, gexp: function(t) {
  for (; t < 0; )
    t += 255;
  for (; t >= 256; )
    t -= 255;
  return bi.EXP_TABLE[t];
}, EXP_TABLE: new Array(256), LOG_TABLE: new Array(256) };
for (var Ii = 0; Ii < 8; Ii++)
  bi.EXP_TABLE[Ii] = 1 << Ii;
for (var Ii = 8; Ii < 256; Ii++)
  bi.EXP_TABLE[Ii] = bi.EXP_TABLE[Ii - 4] ^ bi.EXP_TABLE[Ii - 5] ^ bi.EXP_TABLE[Ii - 6] ^ bi.EXP_TABLE[Ii - 8];
for (var Ii = 0; Ii < 255; Ii++)
  bi.LOG_TABLE[bi.EXP_TABLE[Ii]] = Ii;
function hc(t, e) {
  if (t.length == null)
    throw new Error(t.length + "/" + e);
  for (var r = 0; r < t.length && t[r] == 0; )
    r++;
  this.num = new Array(t.length - r + e);
  for (var i = 0; i < t.length - r; i++)
    this.num[i] = t[i + r];
}
hc.prototype = { get: function(t) {
  return this.num[t];
}, getLength: function() {
  return this.num.length;
}, multiply: function(t) {
  for (var e = new Array(this.getLength() + t.getLength() - 1), r = 0; r < this.getLength(); r++)
    for (var i = 0; i < t.getLength(); i++)
      e[r + i] ^= bi.gexp(bi.glog(this.get(r)) + bi.glog(t.get(i)));
  return new hc(e, 0);
}, mod: function(t) {
  if (this.getLength() - t.getLength() < 0)
    return this;
  for (var e = bi.glog(this.get(0)) - bi.glog(t.get(0)), r = new Array(this.getLength()), i = 0; i < this.getLength(); i++)
    r[i] = this.get(i);
  for (var i = 0; i < t.getLength(); i++)
    r[i] ^= bi.gexp(bi.glog(t.get(i)) + e);
  return new hc(r, 0).mod(t);
} };
function Ks(t, e) {
  this.totalCount = t, this.dataCount = e;
}
Ks.RS_BLOCK_TABLE = [[1, 26, 19], [1, 26, 16], [1, 26, 13], [1, 26, 9], [1, 44, 34], [1, 44, 28], [1, 44, 22], [1, 44, 16], [1, 70, 55], [1, 70, 44], [2, 35, 17], [2, 35, 13], [1, 100, 80], [2, 50, 32], [2, 50, 24], [4, 25, 9], [1, 134, 108], [2, 67, 43], [2, 33, 15, 2, 34, 16], [2, 33, 11, 2, 34, 12], [2, 86, 68], [4, 43, 27], [4, 43, 19], [4, 43, 15], [2, 98, 78], [4, 49, 31], [2, 32, 14, 4, 33, 15], [4, 39, 13, 1, 40, 14], [2, 121, 97], [2, 60, 38, 2, 61, 39], [4, 40, 18, 2, 41, 19], [4, 40, 14, 2, 41, 15], [2, 146, 116], [3, 58, 36, 2, 59, 37], [4, 36, 16, 4, 37, 17], [4, 36, 12, 4, 37, 13], [2, 86, 68, 2, 87, 69], [4, 69, 43, 1, 70, 44], [6, 43, 19, 2, 44, 20], [6, 43, 15, 2, 44, 16], [4, 101, 81], [1, 80, 50, 4, 81, 51], [4, 50, 22, 4, 51, 23], [3, 36, 12, 8, 37, 13], [2, 116, 92, 2, 117, 93], [6, 58, 36, 2, 59, 37], [4, 46, 20, 6, 47, 21], [7, 42, 14, 4, 43, 15], [4, 133, 107], [8, 59, 37, 1, 60, 38], [8, 44, 20, 4, 45, 21], [12, 33, 11, 4, 34, 12], [3, 145, 115, 1, 146, 116], [4, 64, 40, 5, 65, 41], [11, 36, 16, 5, 37, 17], [11, 36, 12, 5, 37, 13], [5, 109, 87, 1, 110, 88], [5, 65, 41, 5, 66, 42], [5, 54, 24, 7, 55, 25], [11, 36, 12], [5, 122, 98, 1, 123, 99], [7, 73, 45, 3, 74, 46], [15, 43, 19, 2, 44, 20], [3, 45, 15, 13, 46, 16], [1, 135, 107, 5, 136, 108], [10, 74, 46, 1, 75, 47], [1, 50, 22, 15, 51, 23], [2, 42, 14, 17, 43, 15], [5, 150, 120, 1, 151, 121], [9, 69, 43, 4, 70, 44], [17, 50, 22, 1, 51, 23], [2, 42, 14, 19, 43, 15], [3, 141, 113, 4, 142, 114], [3, 70, 44, 11, 71, 45], [17, 47, 21, 4, 48, 22], [9, 39, 13, 16, 40, 14], [3, 135, 107, 5, 136, 108], [3, 67, 41, 13, 68, 42], [15, 54, 24, 5, 55, 25], [15, 43, 15, 10, 44, 16], [4, 144, 116, 4, 145, 117], [17, 68, 42], [17, 50, 22, 6, 51, 23], [19, 46, 16, 6, 47, 17], [2, 139, 111, 7, 140, 112], [17, 74, 46], [7, 54, 24, 16, 55, 25], [34, 37, 13], [4, 151, 121, 5, 152, 122], [4, 75, 47, 14, 76, 48], [11, 54, 24, 14, 55, 25], [16, 45, 15, 14, 46, 16], [6, 147, 117, 4, 148, 118], [6, 73, 45, 14, 74, 46], [11, 54, 24, 16, 55, 25], [30, 46, 16, 2, 47, 17], [8, 132, 106, 4, 133, 107], [8, 75, 47, 13, 76, 48], [7, 54, 24, 22, 55, 25], [22, 45, 15, 13, 46, 16], [10, 142, 114, 2, 143, 115], [19, 74, 46, 4, 75, 47], [28, 50, 22, 6, 51, 23], [33, 46, 16, 4, 47, 17], [8, 152, 122, 4, 153, 123], [22, 73, 45, 3, 74, 46], [8, 53, 23, 26, 54, 24], [12, 45, 15, 28, 46, 16], [3, 147, 117, 10, 148, 118], [3, 73, 45, 23, 74, 46], [4, 54, 24, 31, 55, 25], [11, 45, 15, 31, 46, 16], [7, 146, 116, 7, 147, 117], [21, 73, 45, 7, 74, 46], [1, 53, 23, 37, 54, 24], [19, 45, 15, 26, 46, 16], [5, 145, 115, 10, 146, 116], [19, 75, 47, 10, 76, 48], [15, 54, 24, 25, 55, 25], [23, 45, 15, 25, 46, 16], [13, 145, 115, 3, 146, 116], [2, 74, 46, 29, 75, 47], [42, 54, 24, 1, 55, 25], [23, 45, 15, 28, 46, 16], [17, 145, 115], [10, 74, 46, 23, 75, 47], [10, 54, 24, 35, 55, 25], [19, 45, 15, 35, 46, 16], [17, 145, 115, 1, 146, 116], [14, 74, 46, 21, 75, 47], [29, 54, 24, 19, 55, 25], [11, 45, 15, 46, 46, 16], [13, 145, 115, 6, 146, 116], [14, 74, 46, 23, 75, 47], [44, 54, 24, 7, 55, 25], [59, 46, 16, 1, 47, 17], [12, 151, 121, 7, 152, 122], [12, 75, 47, 26, 76, 48], [39, 54, 24, 14, 55, 25], [22, 45, 15, 41, 46, 16], [6, 151, 121, 14, 152, 122], [6, 75, 47, 34, 76, 48], [46, 54, 24, 10, 55, 25], [2, 45, 15, 64, 46, 16], [17, 152, 122, 4, 153, 123], [29, 74, 46, 14, 75, 47], [49, 54, 24, 10, 55, 25], [24, 45, 15, 46, 46, 16], [4, 152, 122, 18, 153, 123], [13, 74, 46, 32, 75, 47], [48, 54, 24, 14, 55, 25], [42, 45, 15, 32, 46, 16], [20, 147, 117, 4, 148, 118], [40, 75, 47, 7, 76, 48], [43, 54, 24, 22, 55, 25], [10, 45, 15, 67, 46, 16], [19, 148, 118, 6, 149, 119], [18, 75, 47, 31, 76, 48], [34, 54, 24, 34, 55, 25], [20, 45, 15, 61, 46, 16]];
Ks.getRSBlocks = function(t, e) {
  var r = Ks.getRsBlockTable(t, e);
  if (r == null)
    throw new Error("bad rs block @ typeNumber:" + t + "/errorCorrectLevel:" + e);
  for (var i = r.length / 3, s = [], n = 0; n < i; n++)
    for (var f = r[n * 3 + 0], u = r[n * 3 + 1], h = r[n * 3 + 2], d = 0; d < f; d++)
      s.push(new Ks(u, h));
  return s;
};
Ks.getRsBlockTable = function(t, e) {
  switch (e) {
    case ro.L:
      return Ks.RS_BLOCK_TABLE[(t - 1) * 4 + 0];
    case ro.M:
      return Ks.RS_BLOCK_TABLE[(t - 1) * 4 + 1];
    case ro.Q:
      return Ks.RS_BLOCK_TABLE[(t - 1) * 4 + 2];
    case ro.H:
      return Ks.RS_BLOCK_TABLE[(t - 1) * 4 + 3];
    default:
      return;
  }
};
function YE() {
  this.buffer = [], this.length = 0;
}
YE.prototype = { get: function(t) {
  var e = Math.floor(t / 8);
  return (this.buffer[e] >>> 7 - t % 8 & 1) == 1;
}, put: function(t, e) {
  for (var r = 0; r < e; r++)
    this.putBit((t >>> e - r - 1 & 1) == 1);
}, getLengthInBits: function() {
  return this.length;
}, putBit: function(t) {
  var e = Math.floor(this.length / 8);
  this.buffer.length <= e && this.buffer.push(0), t && (this.buffer[e] |= 128 >>> this.length % 8), this.length++;
} };
var ug = [[17, 14, 11, 7], [32, 26, 20, 14], [53, 42, 32, 24], [78, 62, 46, 34], [106, 84, 60, 44], [134, 106, 74, 58], [154, 122, 86, 64], [192, 152, 108, 84], [230, 180, 130, 98], [271, 213, 151, 119], [321, 251, 177, 137], [367, 287, 203, 155], [425, 331, 241, 177], [458, 362, 258, 194], [520, 412, 292, 220], [586, 450, 322, 250], [644, 504, 364, 280], [718, 560, 394, 310], [792, 624, 442, 338], [858, 666, 482, 382], [929, 711, 509, 403], [1003, 779, 565, 439], [1091, 857, 611, 461], [1171, 911, 661, 511], [1273, 997, 715, 535], [1367, 1059, 751, 593], [1465, 1125, 805, 625], [1528, 1190, 868, 658], [1628, 1264, 908, 698], [1732, 1370, 982, 742], [1840, 1452, 1030, 790], [1952, 1538, 1112, 842], [2068, 1628, 1168, 898], [2188, 1722, 1228, 958], [2303, 1809, 1283, 983], [2431, 1911, 1351, 1051], [2563, 1989, 1423, 1093], [2699, 2099, 1499, 1139], [2809, 2213, 1579, 1219], [2953, 2331, 1663, 1273]];
function QE(t) {
  if (this.options = {
    padding: 4,
    width: 256,
    height: 256,
    typeNumber: 4,
    color: "#000000",
    background: "#ffffff",
    ecl: "M",
    image: {
      svg: "",
      width: 0,
      height: 0
    }
  }, typeof t == "string" && (t = {
    content: t
  }), t)
    for (var e in t)
      this.options[e] = t[e];
  if (typeof this.options.content != "string")
    throw new Error("Expected 'content' as string!");
  if (this.options.content.length === 0)
    throw new Error("Expected 'content' to be non-empty!");
  if (!(this.options.padding >= 0))
    throw new Error("Expected 'padding' value to be non-negative!");
  if (!(this.options.width > 0) || !(this.options.height > 0))
    throw new Error("Expected 'width' or 'height' value to be higher than zero!");
  function r(h) {
    switch (h) {
      case "L":
        return ro.L;
      case "M":
        return ro.M;
      case "Q":
        return ro.Q;
      case "H":
        return ro.H;
      default:
        throw new Error("Unknwon error correction level: " + h);
    }
  }
  function i(h, d) {
    for (var l = s(h), m = 1, b = 0, M = 0, A = ug.length; M <= A; M++) {
      var N = ug[M];
      if (!N)
        throw new Error("Content too long: expected " + b + " but got " + l);
      switch (d) {
        case "L":
          b = N[0];
          break;
        case "M":
          b = N[1];
          break;
        case "Q":
          b = N[2];
          break;
        case "H":
          b = N[3];
          break;
        default:
          throw new Error("Unknwon error correction level: " + d);
      }
      if (l <= b)
        break;
      m++;
    }
    if (m > ug.length)
      throw new Error("Content too long");
    return m;
  }
  function s(h) {
    var d = encodeURI(h).toString().replace(/\%[0-9a-fA-F]{2}/g, "a");
    return d.length + (d.length != h ? 3 : 0);
  }
  var n = this.options.content, f = i(n, this.options.ecl), u = r(this.options.ecl);
  this.qrcode = new Qs(f, u), this.qrcode.addData(n), this.qrcode.make();
}
QE.prototype.svg = function(t) {
  var e = this.options || {}, r = this.qrcode.modules;
  typeof t > "u" && (t = { container: e.container || "svg" });
  for (var i = typeof e.pretty < "u" ? !!e.pretty : !0, s = i ? "  " : "", n = i ? `\r
` : "", f = e.width, u = e.height, h = r.length, d = f / (h + 2 * e.padding), l = u / (h + 2 * e.padding), m = typeof e.join < "u" ? !!e.join : !1, b = typeof e.swap < "u" ? !!e.swap : !1, M = typeof e.xmlDeclaration < "u" ? !!e.xmlDeclaration : !0, A = typeof e.predefined < "u" ? !!e.predefined : !1, N = A ? s + '<defs><path id="qrmodule" d="M0 0 h' + l + " v" + d + ' H0 z" style="fill:' + e.color + ';shape-rendering:crispEdges;" /></defs>' + n : "", R = s + '<rect x="0" y="0" width="' + f + '" height="' + u + '" style="fill:' + e.background + ';shape-rendering:crispEdges;"/>' + n, O = "", P = "", F = 0; F < h; F++)
    for (var H = 0; H < h; H++) {
      var Q = r[H][F];
      if (Q) {
        var Z = H * d + e.padding * d, B = F * l + e.padding * l;
        if (b) {
          var Y = Z;
          Z = B, B = Y;
        }
        if (m) {
          var ae = d + Z, se = l + B;
          Z = Number.isInteger(Z) ? Number(Z) : Z.toFixed(2), B = Number.isInteger(B) ? Number(B) : B.toFixed(2), ae = Number.isInteger(ae) ? Number(ae) : ae.toFixed(2), se = Number.isInteger(se) ? Number(se) : se.toFixed(2), P += "M" + Z + "," + B + " V" + se + " H" + ae + " V" + B + " H" + Z + " Z ";
        } else
          A ? O += s + '<use x="' + Z.toString() + '" y="' + B.toString() + '" href="#qrmodule" />' + n : O += s + '<rect x="' + Z.toString() + '" y="' + B.toString() + '" width="' + d + '" height="' + l + '" style="fill:' + e.color + ';shape-rendering:crispEdges;"/>' + n;
      }
    }
  m && (O = s + '<path x="0" y="0" style="fill:' + e.color + ';shape-rendering:crispEdges;" d="' + P + '" />');
  let W = "";
  if (this.options.image !== void 0 && this.options.image.svg) {
    const g = f * this.options.image.width / 100, a = u * this.options.image.height / 100, c = f / 2 - g / 2, p = u / 2 - a / 2;
    W += `<svg x="${c}" y="${p}" width="${g}" height="${a}" viewBox="0 0 100 100" preserveAspectRatio="xMinYMin meet">`, W += this.options.image.svg + n, W += "</svg>";
  }
  var C = "";
  switch (t.container) {
    case "svg":
      M && (C += '<?xml version="1.0" standalone="yes"?>' + n), C += '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="' + f + '" height="' + u + '">' + n, C += N + R + O, C += W, C += "</svg>";
      break;
    case "svg-viewbox":
      M && (C += '<?xml version="1.0" standalone="yes"?>' + n), C += '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 ' + f + " " + u + '">' + n, C += N + R + O, C += W, C += "</svg>";
      break;
    case "g":
      C += '<g width="' + f + '" height="' + u + '">' + n, C += N + R + O, C += W, C += "</g>";
      break;
    default:
      C += (N + R + O + W).replace(/^\s+/, "");
      break;
  }
  return C;
};
var jY = QE, BY = nt && nt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Sp, "__esModule", { value: !0 });
Sp.QRCode = void 0;
const zY = Kh, A6 = H2, UY = BY(jY), FY = (t) => {
  const [e, r] = (0, A6.useState)("");
  return (0, A6.useEffect)(() => {
    var i, s;
    const n = new UY.default({
      content: t.content,
      background: t.bgColor || "#ffffff",
      color: t.fgColor || "#000000",
      container: "svg",
      ecl: "M",
      width: (i = t.width) !== null && i !== void 0 ? i : 256,
      height: (s = t.height) !== null && s !== void 0 ? s : 256,
      padding: 0,
      image: t.image
    }), f = Buffer.from(n.svg(), "utf8").toString("base64");
    r(`data:image/svg+xml;base64,${f}`);
  }), e ? (0, zY.h)("img", { src: e, alt: "QR Code" }) : null;
};
Sp.QRCode = FY;
var Ep = {}, Y2 = {};
Object.defineProperty(Y2, "__esModule", { value: !0 });
Y2.default = ".-cbwsdk-css-reset .-cbwsdk-spinner{display:inline-block}.-cbwsdk-css-reset .-cbwsdk-spinner svg{display:inline-block;animation:2s linear infinite -cbwsdk-spinner-svg}.-cbwsdk-css-reset .-cbwsdk-spinner svg circle{animation:1.9s ease-in-out infinite both -cbwsdk-spinner-circle;display:block;fill:rgba(0,0,0,0);stroke-dasharray:283;stroke-dashoffset:280;stroke-linecap:round;stroke-width:10px;transform-origin:50% 50%}@keyframes -cbwsdk-spinner-svg{0%{transform:rotateZ(0deg)}100%{transform:rotateZ(360deg)}}@keyframes -cbwsdk-spinner-circle{0%,25%{stroke-dashoffset:280;transform:rotate(0)}50%,75%{stroke-dashoffset:75;transform:rotate(45deg)}100%{stroke-dashoffset:280;transform:rotate(360deg)}}";
var $Y = nt && nt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Ep, "__esModule", { value: !0 });
Ep.Spinner = void 0;
const xd = Kh, qY = $Y(Y2), HY = (t) => {
  var e;
  const r = (e = t.size) !== null && e !== void 0 ? e : 64, i = t.color || "#000";
  return (0, xd.h)(
    "div",
    { class: "-cbwsdk-spinner" },
    (0, xd.h)("style", null, qY.default),
    (0, xd.h)(
      "svg",
      { viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg", style: { width: r, height: r } },
      (0, xd.h)("circle", { style: { cx: 50, cy: 50, r: 45, stroke: i } })
    )
  );
};
Ep.Spinner = HY;
var Q2 = {};
Object.defineProperty(Q2, "__esModule", { value: !0 });
Q2.default = '.-cbwsdk-css-reset .-cbwsdk-extension-dialog{z-index:2147483647;position:fixed;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-backdrop{z-index:2147483647;position:fixed;top:0;left:0;right:0;bottom:0;transition:opacity .25s}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-backdrop.light{background-color:rgba(0,0,0,.5)}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-backdrop.dark{background-color:rgba(50,53,61,.4)}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-backdrop-hidden{opacity:0}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box{display:flex;position:relative;max-width:500px;flex-direction:column;transform:scale(1);transition:opacity .25s,transform .25s}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-hidden{opacity:0;transform:scale(0.85)}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-top{display:flex;flex-direction:row;border-radius:8px;overflow:hidden;min-height:300px}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-top.dark{color:#fff;background-color:#000;box-shadow:0 4px 16px rgba(255,255,255,.05)}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-top.light{background-color:#fff}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-top-subtext{margin-top:15px;font-size:12px;line-height:1.5}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-top-install-region{display:flex;flex-basis:50%;flex-direction:column;justify-content:center;padding:32px}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-top-install-region button{display:block;border-radius:8px;background-color:#1652f0;color:#fff;width:90%;min-width:fit-content;height:44px;margin-top:16px;font-size:16px;padding-left:16px;padding-right:16px;cursor:pointer;font-weight:500;text-align:center}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-top-install-region button.dark{background-color:#3773f5}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-top-info-region{display:flex;flex-basis:50%;flex-direction:column;justify-content:center}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-top-info-region.light{background-color:#fafbfc}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-top-info-region.dark{background-color:#141519}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-top-description{display:flex;flex-direction:row;align-items:center;padding-top:14px;padding-bottom:14px;padding-left:24px;padding-right:32px}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-top-description-icon-wrapper{display:block;position:relative;width:40px;height:40px;flex-shrink:0;flex-grow:0;border-radius:20px;background-color:#fff;box-shadow:0px 0px 8px rgba(0,0,0,.04),0px 16px 24px rgba(0,0,0,.06)}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-top-description-icon-wrapper img{position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-top-description-text{margin-left:16px;flex-grow:1;font-size:13px;line-height:19px;align-self:center}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-top-description-text.light{color:#000}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-top-description-text.dark{color:#fff}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-bottom{display:flex;flex-direction:row;overflow:hidden;border-radius:8px;margin-top:8px}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-bottom.light{background-color:#fff}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-bottom.dark{background-color:#000;box-shadow:0 4px 16px rgba(255,255,255,.05)}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-bottom-description-region{display:flex;flex-direction:column;justify-content:center;padding:32px;flex-grow:1}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-bottom-description{font-size:13px;line-height:19px;margin-top:12px;color:#aaa}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-bottom-description.dark{color:#fff}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-bottom-description.dark a{color:#3773f5}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-bottom-description a{font-size:inherit;line-height:inherit;color:#1652f0;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-bottom-qr-region{position:relative;flex-shrink:0;display:flex;flex-direction:column;justify-content:center;padding-left:24px;padding-right:24px;padding-top:16px;padding-bottom:16px}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-bottom-qr-wrapper{position:relative;display:block;padding:8px;border-radius:8px;box-shadow:0px 4px 12px rgba(0,0,0,.1);background-color:#fff}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-bottom-qr-wrapper img{display:block}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-bottom-qr-connecting{position:absolute;top:0;bottom:0;left:0;right:0;display:flex;flex-direction:column;align-items:center;justify-content:center}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-bottom-qr-connecting.light{background-color:rgba(255,255,255,.95)}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-bottom-qr-connecting.light>p{color:#000}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-bottom-qr-connecting.dark{background-color:rgba(20,21,25,.9)}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-bottom-qr-connecting.dark>p{color:#fff}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-bottom-qr-connecting>p{font-size:12px;font-weight:bold;margin-top:16px}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-cancel{position:absolute;-webkit-appearance:none;display:flex;align-items:center;justify-content:center;top:16px;right:16px;width:24px;height:24px;border-radius:12px;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-cancel.light{background-color:#fafbfc}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-cancel.dark{background-color:#141519}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-cancel-x{position:relative;display:block;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-cancel-x.light::before,.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-cancel-x.light::after{background-color:#000}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-cancel-x.dark::before,.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-cancel-x.dark::after{background-color:#fff}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-cancel-x::before,.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-cancel-x::after{content:"";position:absolute;display:block;top:-1px;left:-7px;width:14px;height:1px;transition:background-color .2s}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-cancel-x::before{transform:rotate(45deg)}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-cancel-x::after{transform:rotate(135deg)}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-cancel:hover .-cbwsdk-link-dialog-box-cancel-x-a,.-cbwsdk-css-reset .-cbwsdk-extension-dialog-box-cancel:hover .-cbwsdk-link-dialog-box-cancel-x-b{background-color:#000}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-container{display:block}.-cbwsdk-css-reset .-cbwsdk-extension-dialog-container-hidden{display:none}.-cbwsdk-css-reset .-cbwsdk-extension-dialog h2{display:block;text-align:left;font-size:22px;font-weight:600;line-height:28px}.-cbwsdk-css-reset .-cbwsdk-extension-dialog h2.light{color:#000}.-cbwsdk-css-reset .-cbwsdk-extension-dialog h2.dark{color:#fff}';
var Vc = nt && nt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Mp, "__esModule", { value: !0 });
Mp.TryExtensionLinkDialog = void 0;
const Is = Vc($E), tr = Kh, sh = H2, WY = xt, VY = xp, GY = Vc(W2), KY = Vc(V2), YY = Vc(G2), QY = Vc(K2), ZY = Sp, JY = Ep, XY = Vc(Q2), eQ = (t) => {
  const { isOpen: e, darkMode: r } = t, [i, s] = (0, sh.useState)(!e), [n, f] = (0, sh.useState)(!e);
  (0, sh.useEffect)(() => {
    const h = [
      window.setTimeout(() => {
        f(!e);
      }, 10)
    ];
    return e ? s(!1) : h.push(window.setTimeout(() => {
      s(!0);
    }, 360)), () => {
      h.forEach(window.clearTimeout);
    };
  }, [t.isOpen]);
  const u = r ? "dark" : "light";
  return (0, tr.h)(
    "div",
    { class: (0, Is.default)("-cbwsdk-extension-dialog-container", i && "-cbwsdk-extension-dialog-container-hidden") },
    (0, tr.h)("style", null, XY.default),
    (0, tr.h)("div", { class: (0, Is.default)("-cbwsdk-extension-dialog-backdrop", u, n && "-cbwsdk-extension-dialog-backdrop-hidden") }),
    (0, tr.h)(
      "div",
      { class: "-cbwsdk-extension-dialog" },
      (0, tr.h)(
        "div",
        { class: (0, Is.default)("-cbwsdk-extension-dialog-box", n && "-cbwsdk-extension-dialog-box-hidden") },
        (0, tr.h)(tQ, { darkMode: r, onInstallClick: () => {
          window.open("https://api.wallet.coinbase.com/rpc/v2/desktop/chrome", "_blank");
        } }),
        t.connectDisabled ? null : (0, tr.h)(rQ, { darkMode: r, version: t.version, sessionId: t.sessionId, sessionSecret: t.sessionSecret, linkAPIUrl: t.linkAPIUrl, isConnected: t.isConnected, isParentConnection: t.isParentConnection, chainId: t.chainId }),
        t.onCancel && (0, tr.h)(iQ, { darkMode: r, onClick: t.onCancel })
      )
    )
  );
};
Mp.TryExtensionLinkDialog = eQ;
const tQ = ({ darkMode: t, onInstallClick: e }) => {
  const [r, i] = (0, sh.useState)(!1), s = (0, sh.useCallback)(() => {
    r ? window.location.reload() : (e(), i(!0));
  }, [e, r]), n = t ? "dark" : "light";
  return (0, tr.h)(
    "div",
    { class: (0, Is.default)("-cbwsdk-extension-dialog-box-top", n) },
    (0, tr.h)(
      "div",
      { class: "-cbwsdk-extension-dialog-box-top-install-region" },
      (0, tr.h)("h2", { class: n }, "Try the Coinbase Wallet extension"),
      r && (0, tr.h)("div", { class: "-cbwsdk-extension-dialog-box-top-subtext" }, "After installing Coinbase Wallet, refresh the page and connect again."),
      (0, tr.h)("button", { type: "button", onClick: s }, r ? "Refresh" : "Install")
    ),
    (0, tr.h)(
      "div",
      { class: (0, Is.default)("-cbwsdk-extension-dialog-box-top-info-region", n) },
      (0, tr.h)(hg, { darkMode: t, icon: KY.default, text: "Connect to crypto apps with one click" }),
      (0, tr.h)(hg, { darkMode: t, icon: YY.default, text: "Your private key is stored securely" }),
      (0, tr.h)(hg, { darkMode: t, icon: GY.default, text: "Works with Ethereum, Polygon, and more" })
    )
  );
}, rQ = (t) => {
  const e = (0, WY.createQrUrl)(t.sessionId, t.sessionSecret, t.linkAPIUrl, t.isParentConnection, t.version, t.chainId), r = t.darkMode ? "dark" : "light";
  return (0, tr.h)(
    "div",
    { "data-testid": "scan-qr-box", class: (0, Is.default)("-cbwsdk-extension-dialog-box-bottom", r) },
    (0, tr.h)(
      "div",
      { class: "-cbwsdk-extension-dialog-box-bottom-description-region" },
      (0, tr.h)("h2", { class: r }, "Or scan to connect"),
      (0, tr.h)(
        "body",
        { class: (0, Is.default)("-cbwsdk-extension-dialog-box-bottom-description", r) },
        "Open",
        " ",
        (0, tr.h)("a", { href: "https://wallet.coinbase.com/", target: "_blank", rel: "noopener noreferrer" }, "Coinbase Wallet"),
        " ",
        "on your mobile phone and scan"
      )
    ),
    (0, tr.h)(
      "div",
      { class: "-cbwsdk-extension-dialog-box-bottom-qr-region" },
      (0, tr.h)(
        "div",
        { class: "-cbwsdk-extension-dialog-box-bottom-qr-wrapper" },
        (0, tr.h)(ZY.QRCode, { content: e, width: 150, height: 150, fgColor: "#000", bgColor: "transparent", image: {
          svg: QY.default,
          width: 34,
          height: 34
        } })
      ),
      (0, tr.h)("input", { type: "hidden", name: "cbwsdk-version", value: VY.LIB_VERSION }),
      (0, tr.h)("input", { type: "hidden", value: e }),
      !t.isConnected && (0, tr.h)(
        "div",
        { "data-testid": "connecting-spinner", class: (0, Is.default)("-cbwsdk-extension-dialog-box-bottom-qr-connecting", r) },
        (0, tr.h)(JY.Spinner, { size: 36, color: t.darkMode ? "#FFF" : "#000" }),
        (0, tr.h)("p", null, "Connecting...")
      )
    )
  );
}, hg = (t) => {
  const e = t.darkMode ? "dark" : "light";
  return (0, tr.h)(
    "div",
    { class: "-cbwsdk-extension-dialog-box-top-description" },
    (0, tr.h)(
      "div",
      { class: "-cbwsdk-extension-dialog-box-top-description-icon-wrapper" },
      (0, tr.h)("img", { src: t.icon })
    ),
    (0, tr.h)("body", { class: (0, Is.default)("-cbwsdk-extension-dialog-box-top-description-text", e) }, t.text)
  );
}, iQ = (t) => {
  const e = t.darkMode ? "dark" : "light";
  return (0, tr.h)(
    "button",
    { type: "button", class: (0, Is.default)("-cbwsdk-extension-dialog-box-cancel", e), onClick: t.onClick },
    (0, tr.h)("div", { class: (0, Is.default)("-cbwsdk-extension-dialog-box-cancel-x", e) })
  );
};
Object.defineProperty(_p, "__esModule", { value: !0 });
_p.LinkFlow = void 0;
const lg = Kh, T6 = $c, nQ = Mp;
class sQ {
  constructor(e) {
    this.extensionUI$ = new T6.BehaviorSubject({}), this.subscriptions = new T6.Subscription(), this.isConnected = !1, this.chainId = 1, this.isOpen = !1, this.onCancel = null, this.root = null, this.connectDisabled = !1, this.darkMode = e.darkMode, this.version = e.version, this.sessionId = e.sessionId, this.sessionSecret = e.sessionSecret, this.linkAPIUrl = e.linkAPIUrl, this.isParentConnection = e.isParentConnection, this.connected$ = e.connected$, this.chainId$ = e.chainId$;
  }
  attach(e) {
    this.root = document.createElement("div"), this.root.className = "-cbwsdk-link-flow-root", e.appendChild(this.root), this.render(), this.subscriptions.add(this.connected$.subscribe((r) => {
      this.isConnected !== r && (this.isConnected = r, this.render());
    })), this.subscriptions.add(this.chainId$.subscribe((r) => {
      this.chainId !== r && (this.chainId = r, this.render());
    }));
  }
  detach() {
    var e;
    !this.root || (this.subscriptions.unsubscribe(), (0, lg.render)(null, this.root), (e = this.root.parentElement) === null || e === void 0 || e.removeChild(this.root));
  }
  setConnectDisabled(e) {
    this.connectDisabled = e;
  }
  open(e) {
    this.isOpen = !0, this.onCancel = e.onCancel, this.render();
  }
  close() {
    this.isOpen = !1, this.onCancel = null, this.render();
  }
  render() {
    if (!this.root)
      return;
    const e = this.extensionUI$.subscribe(() => {
      !this.root || (0, lg.render)((0, lg.h)(nQ.TryExtensionLinkDialog, { darkMode: this.darkMode, version: this.version, sessionId: this.sessionId, sessionSecret: this.sessionSecret, linkAPIUrl: this.linkAPIUrl, isOpen: this.isOpen, isConnected: this.isConnected, isParentConnection: this.isParentConnection, chainId: this.chainId, onCancel: this.onCancel, connectDisabled: this.connectDisabled }), this.root);
    });
    this.subscriptions.add(e);
  }
}
_p.LinkFlow = sQ;
var ZE = {}, Z2 = {};
Object.defineProperty(Z2, "__esModule", { value: !0 });
Z2.default = ".-cbwsdk-css-reset .-gear-container{margin-left:16px !important;margin-right:9px !important;display:flex;align-items:center;justify-content:center;width:24px;height:24px;transition:opacity .25s}.-cbwsdk-css-reset .-gear-container *{user-select:none}.-cbwsdk-css-reset .-gear-container svg{opacity:0;position:absolute}.-cbwsdk-css-reset .-gear-icon{height:12px;width:12px;z-index:10000}.-cbwsdk-css-reset .-cbwsdk-snackbar{align-items:flex-end;display:flex;flex-direction:column;position:fixed;right:0;top:0;z-index:2147483647}.-cbwsdk-css-reset .-cbwsdk-snackbar *{user-select:none}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance{display:flex;flex-direction:column;margin:8px 16px 0 16px;overflow:visible;text-align:left;transform:translateX(0);transition:opacity .25s,transform .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header:hover .-gear-container svg{opacity:1}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header{display:flex;align-items:center;background:#fff;overflow:hidden;border:1px solid #e7ebee;box-sizing:border-box;border-radius:8px;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header-cblogo{margin:8px 8px 8px 8px}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header *{cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header-message{color:#000;font-size:13px;line-height:1.5;user-select:none}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu{background:#fff;transition:opacity .25s ease-in-out,transform .25s linear,visibility 0s;visibility:hidden;border:1px solid #e7ebee;box-sizing:border-box;border-radius:8px;opacity:0;flex-direction:column;padding-left:8px;padding-right:8px}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:last-child{margin-bottom:8px !important}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover{background:#f5f7f8;border-radius:6px;transition:background .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover span{color:#050f19;transition:color .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover svg path{fill:#000;transition:fill .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item{visibility:inherit;height:35px;margin-top:8px;margin-bottom:0;display:flex;flex-direction:row;align-items:center;padding:8px;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item *{visibility:inherit;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover{background:rgba(223,95,103,.2);transition:background .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover *{cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover svg path{fill:#df5f67;transition:fill .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover span{color:#df5f67;transition:color .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-info{color:#aaa;font-size:13px;margin:0 8px 0 32px;position:absolute}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-hidden{opacity:0;text-align:left;transform:translateX(25%);transition:opacity .5s linear}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-expanded .-cbwsdk-snackbar-instance-menu{opacity:1;display:flex;transform:translateY(8px);visibility:visible}";
(function(t) {
  var e = nt && nt.__importDefault || function(m) {
    return m && m.__esModule ? m : { default: m };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.SnackbarInstance = t.SnackbarContainer = t.Snackbar = void 0;
  const r = e($E), i = Kh, s = H2, n = e(Z2), f = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEuNDkyIDEwLjQxOWE4LjkzIDguOTMgMCAwMTguOTMtOC45M2gxMS4xNjNhOC45MyA4LjkzIDAgMDE4LjkzIDguOTN2MTEuMTYzYTguOTMgOC45MyAwIDAxLTguOTMgOC45M0gxMC40MjJhOC45MyA4LjkzIDAgMDEtOC45My04LjkzVjEwLjQxOXoiIGZpbGw9IiMxNjUyRjAiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjQxOSAwSDIxLjU4QzI3LjMzNSAwIDMyIDQuNjY1IDMyIDEwLjQxOVYyMS41OEMzMiAyNy4zMzUgMjcuMzM1IDMyIDIxLjU4MSAzMkgxMC40MkM0LjY2NSAzMiAwIDI3LjMzNSAwIDIxLjU4MVYxMC40MkMwIDQuNjY1IDQuNjY1IDAgMTAuNDE5IDB6bTAgMS40ODhhOC45MyA4LjkzIDAgMDAtOC45MyA4LjkzdjExLjE2M2E4LjkzIDguOTMgMCAwMDguOTMgOC45M0gyMS41OGE4LjkzIDguOTMgMCAwMDguOTMtOC45M1YxMC40MmE4LjkzIDguOTMgMCAwMC04LjkzLTguOTNIMTAuNDJ6IiBmaWxsPSIjZmZmIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS45OTggMjYuMDQ5Yy01LjU0OSAwLTEwLjA0Ny00LjQ5OC0xMC4wNDctMTAuMDQ3IDAtNS41NDggNC40OTgtMTAuMDQ2IDEwLjA0Ny0xMC4wNDYgNS41NDggMCAxMC4wNDYgNC40OTggMTAuMDQ2IDEwLjA0NiAwIDUuNTQ5LTQuNDk4IDEwLjA0Ny0xMC4wNDYgMTAuMDQ3eiIgZmlsbD0iI2ZmZiIvPjxwYXRoIGQ9Ik0xMi43NjIgMTQuMjU0YzAtLjgyMi42NjctMS40ODkgMS40ODktMS40ODloMy40OTdjLjgyMiAwIDEuNDg4LjY2NiAxLjQ4OCAxLjQ4OXYzLjQ5N2MwIC44MjItLjY2NiAxLjQ4OC0xLjQ4OCAxLjQ4OGgtMy40OTdhMS40ODggMS40ODggMCAwMS0xLjQ4OS0xLjQ4OHYtMy40OTh6IiBmaWxsPSIjMTY1MkYwIi8+PC9zdmc+", u = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEyIDYuNzV2LTEuNWwtMS43Mi0uNTdjLS4wOC0uMjctLjE5LS41Mi0uMzItLjc3bC44MS0xLjYyLTEuMDYtMS4wNi0xLjYyLjgxYy0uMjQtLjEzLS41LS4yNC0uNzctLjMyTDYuNzUgMGgtMS41bC0uNTcgMS43MmMtLjI3LjA4LS41My4xOS0uNzcuMzJsLTEuNjItLjgxLTEuMDYgMS4wNi44MSAxLjYyYy0uMTMuMjQtLjI0LjUtLjMyLjc3TDAgNS4yNXYxLjVsMS43Mi41N2MuMDguMjcuMTkuNTMuMzIuNzdsLS44MSAxLjYyIDEuMDYgMS4wNiAxLjYyLS44MWMuMjQuMTMuNS4yMy43Ny4zMkw1LjI1IDEyaDEuNWwuNTctMS43MmMuMjctLjA4LjUyLS4xOS43Ny0uMzJsMS42Mi44MSAxLjA2LTEuMDYtLjgxLTEuNjJjLjEzLS4yNC4yMy0uNS4zMi0uNzdMMTIgNi43NXpNNiA4LjVhMi41IDIuNSAwIDAxMC01IDIuNSAyLjUgMCAwMTAgNXoiIGZpbGw9IiMwNTBGMTkiLz48L3N2Zz4=";
  class h {
    constructor(b) {
      this.items = /* @__PURE__ */ new Map(), this.nextItemKey = 0, this.root = null, this.darkMode = b.darkMode;
    }
    attach(b) {
      this.root = document.createElement("div"), this.root.className = "-cbwsdk-snackbar-root", b.appendChild(this.root), this.render();
    }
    presentItem(b) {
      const M = this.nextItemKey++;
      return this.items.set(M, b), this.render(), () => {
        this.items.delete(M), this.render();
      };
    }
    clear() {
      this.items.clear(), this.render();
    }
    render() {
      !this.root || (0, i.render)((0, i.h)(
        "div",
        null,
        (0, i.h)(t.SnackbarContainer, { darkMode: this.darkMode }, Array.from(this.items.entries()).map(([b, M]) => (0, i.h)(t.SnackbarInstance, Object.assign({}, M, { key: b }))))
      ), this.root);
    }
  }
  t.Snackbar = h;
  const d = (m) => (0, i.h)(
    "div",
    { class: (0, r.default)("-cbwsdk-snackbar-container") },
    (0, i.h)("style", null, n.default),
    (0, i.h)("div", { class: "-cbwsdk-snackbar" }, m.children)
  );
  t.SnackbarContainer = d;
  const l = ({ autoExpand: m, message: b, menuItems: M }) => {
    const [A, N] = (0, s.useState)(!0), [R, O] = (0, s.useState)(m != null ? m : !1);
    (0, s.useEffect)(() => {
      const F = [
        window.setTimeout(() => {
          N(!1);
        }, 1),
        window.setTimeout(() => {
          O(!0);
        }, 1e4)
      ];
      return () => {
        F.forEach(window.clearTimeout);
      };
    });
    const P = () => {
      O(!R);
    };
    return (0, i.h)(
      "div",
      { class: (0, r.default)("-cbwsdk-snackbar-instance", A && "-cbwsdk-snackbar-instance-hidden", R && "-cbwsdk-snackbar-instance-expanded") },
      (0, i.h)(
        "div",
        { class: "-cbwsdk-snackbar-instance-header", onClick: P },
        (0, i.h)("img", { src: f, class: "-cbwsdk-snackbar-instance-header-cblogo" }),
        (0, i.h)("div", { class: "-cbwsdk-snackbar-instance-header-message" }, b),
        (0, i.h)(
          "div",
          { class: "-gear-container" },
          !R && (0, i.h)(
            "svg",
            { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            (0, i.h)("circle", { cx: "12", cy: "12", r: "12", fill: "#F5F7F8" })
          ),
          (0, i.h)("img", { src: u, class: "-gear-icon", title: "Expand" })
        )
      ),
      M && M.length > 0 && (0, i.h)("div", { class: "-cbwsdk-snackbar-instance-menu" }, M.map((F, H) => (0, i.h)(
        "div",
        { class: (0, r.default)("-cbwsdk-snackbar-instance-menu-item", F.isRed && "-cbwsdk-snackbar-instance-menu-item-is-red"), onClick: F.onClick, key: H },
        (0, i.h)(
          "svg",
          { width: F.svgWidth, height: F.svgHeight, viewBox: "0 0 10 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
          (0, i.h)("path", { "fill-rule": F.defaultFillRule, "clip-rule": F.defaultClipRule, d: F.path, fill: "#AAAAAA" })
        ),
        (0, i.h)("span", { class: (0, r.default)("-cbwsdk-snackbar-instance-menu-item-info", F.isRed && "-cbwsdk-snackbar-instance-menu-item-info-is-red") }, F.info)
      )))
    );
  };
  t.SnackbarInstance = l;
})(ZE);
var Ip = {}, J2 = {};
Object.defineProperty(J2, "__esModule", { value: !0 });
J2.default = '@namespace svg "http://www.w3.org/2000/svg";.-cbwsdk-css-reset,.-cbwsdk-css-reset *{animation:none;animation-delay:0;animation-direction:normal;animation-duration:0;animation-fill-mode:none;animation-iteration-count:1;animation-name:none;animation-play-state:running;animation-timing-function:ease;backface-visibility:visible;background:0;background-attachment:scroll;background-clip:border-box;background-color:rgba(0,0,0,0);background-image:none;background-origin:padding-box;background-position:0 0;background-position-x:0;background-position-y:0;background-repeat:repeat;background-size:auto auto;border:0;border-style:none;border-width:medium;border-color:inherit;border-bottom:0;border-bottom-color:inherit;border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom-style:none;border-bottom-width:medium;border-collapse:separate;border-image:none;border-left:0;border-left-color:inherit;border-left-style:none;border-left-width:medium;border-radius:0;border-right:0;border-right-color:inherit;border-right-style:none;border-right-width:medium;border-spacing:0;border-top:0;border-top-color:inherit;border-top-left-radius:0;border-top-right-radius:0;border-top-style:none;border-top-width:medium;bottom:auto;box-shadow:none;box-sizing:border-box;caption-side:top;clear:none;clip:auto;color:inherit;columns:auto;column-count:auto;column-fill:balance;column-gap:normal;column-rule:medium none currentColor;column-rule-color:currentColor;column-rule-style:none;column-rule-width:none;column-span:1;column-width:auto;content:normal;counter-increment:none;counter-reset:none;cursor:auto;direction:ltr;display:block;empty-cells:show;float:none;font:normal;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif;font-size:medium;font-style:normal;font-variant:normal;font-weight:normal;height:auto;hyphens:none;left:auto;letter-spacing:normal;line-height:normal;list-style:none;list-style-image:none;list-style-position:outside;list-style-type:disc;margin:0;margin-bottom:0;margin-left:0;margin-right:0;margin-top:0;max-height:none;max-width:none;min-height:0;min-width:0;opacity:1;orphans:0;outline:0;outline-color:invert;outline-style:none;outline-width:medium;overflow:visible;overflow-x:visible;overflow-y:visible;padding:0;padding-bottom:0;padding-left:0;padding-right:0;padding-top:0;page-break-after:auto;page-break-before:auto;page-break-inside:auto;perspective:none;perspective-origin:50% 50%;pointer-events:auto;position:static;quotes:"\\201C" "\\201D" "\\2018" "\\2019";right:auto;tab-size:8;table-layout:auto;text-align:inherit;text-align-last:auto;text-decoration:none;text-decoration-color:inherit;text-decoration-line:none;text-decoration-style:solid;text-indent:0;text-shadow:none;text-transform:none;top:auto;transform:none;transform-style:flat;transition:none;transition-delay:0s;transition-duration:0s;transition-property:none;transition-timing-function:ease;unicode-bidi:normal;vertical-align:baseline;visibility:visible;white-space:normal;widows:0;width:auto;word-spacing:normal;z-index:auto}.-cbwsdk-css-reset *{box-sizing:border-box;display:initial;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif;line-height:1}.-cbwsdk-css-reset [class*=container]{margin:0;padding:0}.-cbwsdk-css-reset style{display:none}';
var aQ = nt && nt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Ip, "__esModule", { value: !0 });
Ip.injectCssReset = void 0;
const oQ = aQ(J2);
function fQ() {
  const t = document.createElement("style");
  t.type = "text/css", t.appendChild(document.createTextNode(oQ.default)), document.documentElement.appendChild(t);
}
Ip.injectCssReset = fQ;
Object.defineProperty(wp, "__esModule", { value: !0 });
wp.WalletSDKUI = void 0;
const cQ = _p, uQ = ZE, hQ = Ip;
class lQ {
  constructor(e) {
    this.standalone = null, this.attached = !1, this.snackbar = new uQ.Snackbar({
      darkMode: e.darkMode
    }), this.linkFlow = new cQ.LinkFlow({
      darkMode: e.darkMode,
      version: e.version,
      sessionId: e.session.id,
      sessionSecret: e.session.secret,
      linkAPIUrl: e.linkAPIUrl,
      connected$: e.connected$,
      chainId$: e.chainId$,
      isParentConnection: !1
    });
  }
  attach() {
    if (this.attached)
      throw new Error("Coinbase Wallet SDK UI is already attached");
    const e = document.documentElement, r = document.createElement("div");
    r.className = "-cbwsdk-css-reset", e.appendChild(r), this.linkFlow.attach(r), this.snackbar.attach(r), this.attached = !0, (0, hQ.injectCssReset)();
  }
  setConnectDisabled(e) {
    this.linkFlow.setConnectDisabled(e);
  }
  addEthereumChain(e) {
  }
  watchAsset(e) {
  }
  switchEthereumChain(e) {
  }
  requestEthereumAccounts(e) {
    this.linkFlow.open({ onCancel: e.onCancel });
  }
  hideRequestEthereumAccounts() {
    this.linkFlow.close();
  }
  signEthereumMessage(e) {
  }
  signEthereumTransaction(e) {
  }
  submitEthereumTransaction(e) {
  }
  ethereumAddressFromSignedMessage(e) {
  }
  showConnecting(e) {
    let r;
    return e.isUnlinkedErrorState ? r = {
      autoExpand: !0,
      message: "Connection lost",
      menuItems: [
        {
          isRed: !1,
          info: "Reset connection",
          svgWidth: "10",
          svgHeight: "11",
          path: "M5.00008 0.96875C6.73133 0.96875 8.23758 1.94375 9.00008 3.375L10.0001 2.375V5.5H9.53133H7.96883H6.87508L7.80633 4.56875C7.41258 3.3875 6.31258 2.53125 5.00008 2.53125C3.76258 2.53125 2.70633 3.2875 2.25633 4.36875L0.812576 3.76875C1.50008 2.125 3.11258 0.96875 5.00008 0.96875ZM2.19375 6.43125C2.5875 7.6125 3.6875 8.46875 5 8.46875C6.2375 8.46875 7.29375 7.7125 7.74375 6.63125L9.1875 7.23125C8.5 8.875 6.8875 10.0312 5 10.0312C3.26875 10.0312 1.7625 9.05625 1 7.625L0 8.625V5.5H0.46875H2.03125H3.125L2.19375 6.43125Z",
          defaultFillRule: "evenodd",
          defaultClipRule: "evenodd",
          onClick: e.onResetConnection
        }
      ]
    } : r = {
      message: "Confirm on phone",
      menuItems: [
        {
          isRed: !0,
          info: "Cancel transaction",
          svgWidth: "11",
          svgHeight: "11",
          path: "M10.3711 1.52346L9.21775 0.370117L5.37109 4.21022L1.52444 0.370117L0.371094 1.52346L4.2112 5.37012L0.371094 9.21677L1.52444 10.3701L5.37109 6.53001L9.21775 10.3701L10.3711 9.21677L6.53099 5.37012L10.3711 1.52346Z",
          defaultFillRule: "inherit",
          defaultClipRule: "inherit",
          onClick: e.onCancel
        },
        {
          isRed: !1,
          info: "Reset connection",
          svgWidth: "10",
          svgHeight: "11",
          path: "M5.00008 0.96875C6.73133 0.96875 8.23758 1.94375 9.00008 3.375L10.0001 2.375V5.5H9.53133H7.96883H6.87508L7.80633 4.56875C7.41258 3.3875 6.31258 2.53125 5.00008 2.53125C3.76258 2.53125 2.70633 3.2875 2.25633 4.36875L0.812576 3.76875C1.50008 2.125 3.11258 0.96875 5.00008 0.96875ZM2.19375 6.43125C2.5875 7.6125 3.6875 8.46875 5 8.46875C6.2375 8.46875 7.29375 7.7125 7.74375 6.63125L9.1875 7.23125C8.5 8.875 6.8875 10.0312 5 10.0312C3.26875 10.0312 1.7625 9.05625 1 7.625L0 8.625V5.5H0.46875H2.03125H3.125L2.19375 6.43125Z",
          defaultFillRule: "evenodd",
          defaultClipRule: "evenodd",
          onClick: e.onResetConnection
        }
      ]
    }, this.snackbar.presentItem(r);
  }
  reloadUI() {
    document.location.reload();
  }
  inlineAccountsResponse() {
    return !1;
  }
  inlineAddEthereumChain(e) {
    return !1;
  }
  inlineWatchAsset() {
    return !1;
  }
  inlineSwitchEthereumChain() {
    return !1;
  }
  setStandalone(e) {
    this.standalone = e;
  }
  isStandalone() {
    var e;
    return (e = this.standalone) !== null && e !== void 0 ? e : !1;
  }
}
wp.WalletSDKUI = lQ;
var Ap = {}, Tp = {};
Object.defineProperty(Tp, "__esModule", { value: !0 });
var nc;
(function(t) {
  t.typeOfFunction = "function", t.boolTrue = !0;
})(nc || (nc = {}));
function JE(t, e, r) {
  if (!r || typeof r.value !== nc.typeOfFunction)
    throw new TypeError("Only methods can be decorated with @bind. <" + e + "> is not a method!");
  return {
    configurable: nc.boolTrue,
    get: function() {
      var i = r.value.bind(this);
      return Object.defineProperty(this, e, {
        value: i,
        configurable: nc.boolTrue,
        writable: nc.boolTrue
      }), i;
    }
  };
}
Tp.bind = JE;
Tp.default = JE;
var Np = {}, Jn = {};
Object.defineProperty(Jn, "__esModule", { value: !0 });
Jn.ClientMessagePublishEvent = Jn.ClientMessageSetSessionConfig = Jn.ClientMessageGetSessionConfig = Jn.ClientMessageIsLinked = Jn.ClientMessageHostSession = void 0;
function dQ(t) {
  return Object.assign({ type: "HostSession" }, t);
}
Jn.ClientMessageHostSession = dQ;
function pQ(t) {
  return Object.assign({ type: "IsLinked" }, t);
}
Jn.ClientMessageIsLinked = pQ;
function vQ(t) {
  return Object.assign({ type: "GetSessionConfig" }, t);
}
Jn.ClientMessageGetSessionConfig = vQ;
function gQ(t) {
  return Object.assign({ type: "SetSessionConfig" }, t);
}
Jn.ClientMessageSetSessionConfig = gQ;
function bQ(t) {
  return Object.assign({ type: "PublishEvent" }, t);
}
Jn.ClientMessagePublishEvent = bQ;
var XE = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.RxWebSocket = t.ConnectionState = void 0;
  const e = $c, r = X0;
  var i;
  (function(n) {
    n[n.DISCONNECTED = 0] = "DISCONNECTED", n[n.CONNECTING = 1] = "CONNECTING", n[n.CONNECTED = 2] = "CONNECTED";
  })(i = t.ConnectionState || (t.ConnectionState = {}));
  class s {
    constructor(f, u = WebSocket) {
      this.WebSocketClass = u, this.webSocket = null, this.connectionStateSubject = new e.BehaviorSubject(i.DISCONNECTED), this.incomingDataSubject = new e.Subject(), this.url = f.replace(/^http/, "ws");
    }
    connect() {
      return this.webSocket ? (0, e.throwError)(new Error("webSocket object is not null")) : new e.Observable((f) => {
        let u;
        try {
          this.webSocket = u = new this.WebSocketClass(this.url);
        } catch (h) {
          f.error(h);
          return;
        }
        this.connectionStateSubject.next(i.CONNECTING), u.onclose = (h) => {
          this.clearWebSocket(), f.error(new Error(`websocket error ${h.code}: ${h.reason}`)), this.connectionStateSubject.next(i.DISCONNECTED);
        }, u.onopen = (h) => {
          f.next(), f.complete(), this.connectionStateSubject.next(i.CONNECTED);
        }, u.onmessage = (h) => {
          this.incomingDataSubject.next(h.data);
        };
      }).pipe((0, r.take)(1));
    }
    disconnect() {
      const { webSocket: f } = this;
      if (!!f) {
        this.clearWebSocket(), this.connectionStateSubject.next(i.DISCONNECTED);
        try {
          f.close();
        } catch {
        }
      }
    }
    get connectionState$() {
      return this.connectionStateSubject.asObservable();
    }
    get incomingData$() {
      return this.incomingDataSubject.asObservable();
    }
    get incomingJSONData$() {
      return this.incomingData$.pipe((0, r.flatMap)((f) => {
        let u;
        try {
          u = JSON.parse(f);
        } catch {
          return (0, e.empty)();
        }
        return (0, e.of)(u);
      }));
    }
    sendData(f) {
      const { webSocket: u } = this;
      if (!u)
        throw new Error("websocket is not connected");
      u.send(f);
    }
    clearWebSocket() {
      const { webSocket: f } = this;
      !f || (this.webSocket = null, f.onclose = null, f.onerror = null, f.onmessage = null, f.onopen = null);
    }
  }
  t.RxWebSocket = s;
})(XE);
var Dp = {};
Object.defineProperty(Dp, "__esModule", { value: !0 });
Dp.isServerMessageFail = void 0;
function yQ(t) {
  return t && t.type === "Fail" && typeof t.id == "number" && typeof t.sessionId == "string" && typeof t.error == "string";
}
Dp.isServerMessageFail = yQ;
Object.defineProperty(Np, "__esModule", { value: !0 });
Np.WalletSDKConnection = void 0;
const gs = $c, sr = X0, Cu = Bc, Gf = Bh, Ou = Jn, Ru = jc, Sd = XE, dg = Dp, N6 = 1e4, mQ = 6e4;
class wQ {
  constructor(e, r, i, s, n = WebSocket) {
    this.sessionId = e, this.sessionKey = r, this.diagnostic = s, this.subscriptions = new gs.Subscription(), this.destroyed = !1, this.lastHeartbeatResponse = 0, this.nextReqId = (0, Gf.IntNumber)(1), this.connectedSubject = new gs.BehaviorSubject(!1), this.linkedSubject = new gs.BehaviorSubject(!1), this.sessionConfigSubject = new gs.ReplaySubject(1);
    const f = new Sd.RxWebSocket(i + "/rpc", n);
    this.ws = f, this.subscriptions.add(f.connectionState$.pipe(
      (0, sr.tap)((u) => {
        var h;
        return (h = this.diagnostic) === null || h === void 0 ? void 0 : h.log(Ru.EVENTS.CONNECTED_STATE_CHANGE, {
          state: u,
          sessionIdHash: Cu.Session.hash(e)
        });
      }),
      (0, sr.skip)(1),
      (0, sr.filter)((u) => u === Sd.ConnectionState.DISCONNECTED && !this.destroyed),
      (0, sr.delay)(5e3),
      (0, sr.filter)((u) => !this.destroyed),
      (0, sr.flatMap)((u) => f.connect()),
      (0, sr.retry)()
    ).subscribe()), this.subscriptions.add(f.connectionState$.pipe(
      (0, sr.skip)(2),
      (0, sr.switchMap)((u) => (0, gs.iif)(
        () => u === Sd.ConnectionState.CONNECTED,
        this.authenticate().pipe((0, sr.tap)((h) => this.sendIsLinked()), (0, sr.tap)((h) => this.sendGetSessionConfig()), (0, sr.map)((h) => !0)),
        (0, gs.of)(!1)
      )),
      (0, sr.distinctUntilChanged)(),
      (0, sr.catchError)((u) => (0, gs.of)(!1))
    ).subscribe((u) => this.connectedSubject.next(u))), this.subscriptions.add(f.connectionState$.pipe(
      (0, sr.skip)(1),
      (0, sr.switchMap)((u) => (0, gs.iif)(
        () => u === Sd.ConnectionState.CONNECTED,
        (0, gs.timer)(0, N6)
      ))
    ).subscribe((u) => u === 0 ? this.updateLastHeartbeat() : this.heartbeat())), this.subscriptions.add(f.incomingData$.pipe((0, sr.filter)((u) => u === "h")).subscribe((u) => this.updateLastHeartbeat())), this.subscriptions.add(f.incomingJSONData$.pipe((0, sr.filter)((u) => ["IsLinkedOK", "Linked"].includes(u.type))).subscribe((u) => {
      var h;
      const d = u;
      (h = this.diagnostic) === null || h === void 0 || h.log(Ru.EVENTS.LINKED, {
        sessionIdHash: Cu.Session.hash(e),
        linked: d.linked,
        type: u.type,
        onlineGuests: d.onlineGuests
      }), this.linkedSubject.next(d.linked || d.onlineGuests > 0);
    })), this.subscriptions.add(f.incomingJSONData$.pipe((0, sr.filter)((u) => ["GetSessionConfigOK", "SessionConfigUpdated"].includes(u.type))).subscribe((u) => {
      var h;
      const d = u;
      (h = this.diagnostic) === null || h === void 0 || h.log(Ru.EVENTS.SESSION_CONFIG_RECEIVED, {
        sessionIdHash: Cu.Session.hash(e),
        metadata_keys: d && d.metadata ? Object.keys(d.metadata) : void 0
      }), this.sessionConfigSubject.next({
        webhookId: d.webhookId,
        webhookUrl: d.webhookUrl,
        metadata: d.metadata
      });
    }));
  }
  connect() {
    var e;
    if (this.destroyed)
      throw new Error("instance is destroyed");
    (e = this.diagnostic) === null || e === void 0 || e.log(Ru.EVENTS.STARTED_CONNECTING, {
      sessionIdHash: Cu.Session.hash(this.sessionId)
    }), this.ws.connect().subscribe();
  }
  destroy() {
    var e;
    this.subscriptions.unsubscribe(), this.ws.disconnect(), (e = this.diagnostic) === null || e === void 0 || e.log(Ru.EVENTS.DISCONNECTED, {
      sessionIdHash: Cu.Session.hash(this.sessionId)
    }), this.destroyed = !0;
  }
  get isDestroyed() {
    return this.destroyed;
  }
  get connected$() {
    return this.connectedSubject.asObservable();
  }
  get onceConnected$() {
    return this.connected$.pipe((0, sr.filter)((e) => e), (0, sr.take)(1), (0, sr.map)(() => {
    }));
  }
  get linked$() {
    return this.linkedSubject.asObservable();
  }
  get onceLinked$() {
    return this.linked$.pipe((0, sr.filter)((e) => e), (0, sr.take)(1), (0, sr.map)(() => {
    }));
  }
  get sessionConfig$() {
    return this.sessionConfigSubject.asObservable();
  }
  get incomingEvent$() {
    return this.ws.incomingJSONData$.pipe((0, sr.filter)((e) => {
      if (e.type !== "Event")
        return !1;
      const r = e;
      return typeof r.sessionId == "string" && typeof r.eventId == "string" && typeof r.event == "string" && typeof r.data == "string";
    }), (0, sr.map)((e) => e));
  }
  setSessionMetadata(e, r) {
    const i = (0, Ou.ClientMessageSetSessionConfig)({
      id: (0, Gf.IntNumber)(this.nextReqId++),
      sessionId: this.sessionId,
      metadata: { [e]: r }
    });
    return this.onceConnected$.pipe((0, sr.flatMap)((s) => this.makeRequest(i)), (0, sr.map)((s) => {
      if ((0, dg.isServerMessageFail)(s))
        throw new Error(s.error || "failed to set session metadata");
    }));
  }
  publishEvent(e, r, i = !1) {
    const s = (0, Ou.ClientMessagePublishEvent)({
      id: (0, Gf.IntNumber)(this.nextReqId++),
      sessionId: this.sessionId,
      event: e,
      data: r,
      callWebhook: i
    });
    return this.onceLinked$.pipe((0, sr.flatMap)((n) => this.makeRequest(s)), (0, sr.map)((n) => {
      if ((0, dg.isServerMessageFail)(n))
        throw new Error(n.error || "failed to publish event");
      return n.eventId;
    }));
  }
  sendData(e) {
    this.ws.sendData(JSON.stringify(e));
  }
  updateLastHeartbeat() {
    this.lastHeartbeatResponse = Date.now();
  }
  heartbeat() {
    if (Date.now() - this.lastHeartbeatResponse > N6 * 2) {
      this.ws.disconnect();
      return;
    }
    try {
      this.ws.sendData("h");
    } catch {
    }
  }
  makeRequest(e, r = mQ) {
    const i = e.id;
    try {
      this.sendData(e);
    } catch (s) {
      return (0, gs.throwError)(s);
    }
    return this.ws.incomingJSONData$.pipe((0, sr.timeoutWith)(r, (0, gs.throwError)(new Error(`request ${i} timed out`))), (0, sr.filter)((s) => s.id === i), (0, sr.take)(1));
  }
  authenticate() {
    const e = (0, Ou.ClientMessageHostSession)({
      id: (0, Gf.IntNumber)(this.nextReqId++),
      sessionId: this.sessionId,
      sessionKey: this.sessionKey
    });
    return this.makeRequest(e).pipe((0, sr.map)((r) => {
      if ((0, dg.isServerMessageFail)(r))
        throw new Error(r.error || "failed to authentcate");
    }));
  }
  sendIsLinked() {
    const e = (0, Ou.ClientMessageIsLinked)({
      id: (0, Gf.IntNumber)(this.nextReqId++),
      sessionId: this.sessionId
    });
    this.sendData(e);
  }
  sendGetSessionConfig() {
    const e = (0, Ou.ClientMessageGetSessionConfig)({
      id: (0, Gf.IntNumber)(this.nextReqId++),
      sessionId: this.sessionId
    });
    this.sendData(e);
  }
}
Np.WalletSDKConnection = wQ;
var Cp = {};
Object.defineProperty(Cp, "__esModule", { value: !0 });
Cp.WalletUIError = void 0;
class bh extends Error {
  constructor(e, r) {
    super(e), this.message = e, this.errorCode = r;
  }
}
Cp.WalletUIError = bh;
bh.UserRejectedRequest = new bh("User rejected request");
bh.SwitchEthereumChainUnsupportedChainId = new bh("Unsupported chainId", 4902);
var Tc = {};
Object.defineProperty(Tc, "__esModule", { value: !0 });
Tc.decrypt = Tc.encrypt = void 0;
const _Q = $c, I0 = xt;
async function MQ(t, e) {
  if (e.length !== 64)
    throw Error("secret must be 256 bits");
  const r = crypto.getRandomValues(new Uint8Array(12)), i = await crypto.subtle.importKey("raw", (0, I0.hexStringToUint8Array)(e), { name: "aes-gcm" }, !1, ["encrypt", "decrypt"]), s = new TextEncoder(), n = await window.crypto.subtle.encrypt({
    name: "AES-GCM",
    iv: r
  }, i, s.encode(t)), f = 16, u = n.slice(n.byteLength - f), h = n.slice(0, n.byteLength - f), d = new Uint8Array(u), l = new Uint8Array(h), m = new Uint8Array([
    ...r,
    ...d,
    ...l
  ]);
  return (0, I0.uint8ArrayToHex)(m);
}
Tc.encrypt = MQ;
function xQ(t, e) {
  if (e.length !== 64)
    throw Error("secret must be 256 bits");
  return new _Q.Observable((r) => {
    (async function() {
      const i = await crypto.subtle.importKey("raw", (0, I0.hexStringToUint8Array)(e), { name: "aes-gcm" }, !1, ["encrypt", "decrypt"]), s = (0, I0.hexStringToUint8Array)(t), n = s.slice(0, 12), f = s.slice(12, 28), u = s.slice(28), h = new Uint8Array([
        ...u,
        ...f
      ]), d = {
        name: "AES-GCM",
        iv: new Uint8Array(n)
      };
      try {
        const l = await window.crypto.subtle.decrypt(d, i, h), m = new TextDecoder();
        r.next(m.decode(l)), r.complete();
      } catch (l) {
        r.error(l);
      }
    })();
  });
}
Tc.decrypt = xQ;
var X2 = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.Web3Method = void 0, function(e) {
    e.requestEthereumAccounts = "requestEthereumAccounts", e.signEthereumMessage = "signEthereumMessage", e.signEthereumTransaction = "signEthereumTransaction", e.submitEthereumTransaction = "submitEthereumTransaction", e.ethereumAddressFromSignedMessage = "ethereumAddressFromSignedMessage", e.scanQRCode = "scanQRCode", e.generic = "generic", e.childRequestEthereumAccounts = "childRequestEthereumAccounts", e.addEthereumChain = "addEthereumChain", e.switchEthereumChain = "switchEthereumChain", e.makeEthereumJSONRPCRequest = "makeEthereumJSONRPCRequest", e.watchAsset = "watchAsset", e.selectProvider = "selectProvider";
  }(t.Web3Method || (t.Web3Method = {}));
})(X2);
var Op = {}, Rp = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.RelayMessageType = void 0, function(e) {
    e.SESSION_ID_REQUEST = "SESSION_ID_REQUEST", e.SESSION_ID_RESPONSE = "SESSION_ID_RESPONSE", e.LINKED = "LINKED", e.UNLINKED = "UNLINKED", e.WEB3_REQUEST = "WEB3_REQUEST", e.WEB3_REQUEST_CANCELED = "WEB3_REQUEST_CANCELED", e.WEB3_RESPONSE = "WEB3_RESPONSE";
  }(t.RelayMessageType || (t.RelayMessageType = {}));
})(Rp);
Object.defineProperty(Op, "__esModule", { value: !0 });
Op.Web3RequestCanceledMessage = void 0;
const SQ = Rp;
function EQ(t) {
  return { type: SQ.RelayMessageType.WEB3_REQUEST_CANCELED, id: t };
}
Op.Web3RequestCanceledMessage = EQ;
var Lp = {};
Object.defineProperty(Lp, "__esModule", { value: !0 });
Lp.Web3RequestMessage = void 0;
const IQ = Rp;
function AQ(t) {
  return Object.assign({ type: IQ.RelayMessageType.WEB3_REQUEST }, t);
}
Lp.Web3RequestMessage = AQ;
var $r = {};
Object.defineProperty($r, "__esModule", { value: !0 });
$r.EthereumAddressFromSignedMessageResponse = $r.SubmitEthereumTransactionResponse = $r.SignEthereumTransactionResponse = $r.SignEthereumMessageResponse = $r.isRequestEthereumAccountsResponse = $r.SelectProviderResponse = $r.WatchAssetReponse = $r.RequestEthereumAccountsResponse = $r.SwitchEthereumChainResponse = $r.AddEthereumChainResponse = $r.ErrorResponse = void 0;
const oa = X2;
function TQ(t, e, r) {
  return { method: t, errorMessage: e, errorCode: r };
}
$r.ErrorResponse = TQ;
function NQ(t) {
  return {
    method: oa.Web3Method.addEthereumChain,
    result: t
  };
}
$r.AddEthereumChainResponse = NQ;
function DQ(t) {
  return {
    method: oa.Web3Method.switchEthereumChain,
    result: t
  };
}
$r.SwitchEthereumChainResponse = DQ;
function CQ(t) {
  return { method: oa.Web3Method.requestEthereumAccounts, result: t };
}
$r.RequestEthereumAccountsResponse = CQ;
function OQ(t) {
  return { method: oa.Web3Method.watchAsset, result: t };
}
$r.WatchAssetReponse = OQ;
function RQ(t) {
  return { method: oa.Web3Method.selectProvider, result: t };
}
$r.SelectProviderResponse = RQ;
function LQ(t) {
  return t && t.method === oa.Web3Method.requestEthereumAccounts;
}
$r.isRequestEthereumAccountsResponse = LQ;
function PQ(t) {
  return { method: oa.Web3Method.signEthereumMessage, result: t };
}
$r.SignEthereumMessageResponse = PQ;
function kQ(t) {
  return { method: oa.Web3Method.signEthereumTransaction, result: t };
}
$r.SignEthereumTransactionResponse = kQ;
function jQ(t) {
  return { method: oa.Web3Method.submitEthereumTransaction, result: t };
}
$r.SubmitEthereumTransactionResponse = jQ;
function BQ(t) {
  return {
    method: oa.Web3Method.ethereumAddressFromSignedMessage,
    result: t
  };
}
$r.EthereumAddressFromSignedMessageResponse = BQ;
var Nc = {};
Object.defineProperty(Nc, "__esModule", { value: !0 });
Nc.isWeb3ResponseMessage = Nc.Web3ResponseMessage = void 0;
const eI = Rp;
function zQ(t) {
  return Object.assign({ type: eI.RelayMessageType.WEB3_RESPONSE }, t);
}
Nc.Web3ResponseMessage = zQ;
function UQ(t) {
  return t && t.type === eI.RelayMessageType.WEB3_RESPONSE;
}
Nc.isWeb3ResponseMessage = UQ;
var FQ = nt && nt.__createBinding || (Object.create ? function(t, e, r, i) {
  i === void 0 && (i = r), Object.defineProperty(t, i, { enumerable: !0, get: function() {
    return e[r];
  } });
} : function(t, e, r, i) {
  i === void 0 && (i = r), t[i] = e[r];
}), $Q = nt && nt.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), tI = nt && nt.__decorate || function(t, e, r, i) {
  var s = arguments.length, n = s < 3 ? e : i === null ? i = Object.getOwnPropertyDescriptor(e, r) : i, f;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    n = Reflect.decorate(t, e, r, i);
  else
    for (var u = t.length - 1; u >= 0; u--)
      (f = t[u]) && (n = (s < 3 ? f(n) : s > 3 ? f(e, r, n) : f(e, r)) || n);
  return s > 3 && n && Object.defineProperty(e, r, n), n;
}, qQ = nt && nt.__importStar || function(t) {
  if (t && t.__esModule)
    return t;
  var e = {};
  if (t != null)
    for (var r in t)
      r !== "default" && Object.prototype.hasOwnProperty.call(t, r) && FQ(e, t, r);
  return $Q(e, t), e;
}, HQ = nt && nt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Ap, "__esModule", { value: !0 });
Ap.WalletSDKRelay = void 0;
const rI = HQ(Tp), D6 = K0, Lu = $c, Si = X0, Wi = jc, WQ = Np, pg = Cp, VQ = Bh, Fr = xt, Lo = qQ(Tc), Ka = Bc, Ed = Ss, di = X2, GQ = Op, KQ = Lp, _n = $r, Vi = Nc;
class xs extends Ed.WalletSDKRelayAbstract {
  constructor(e) {
    var r;
    super(), this.accountsCallback = null, this.chainCallback = null, this.dappDefaultChainSubject = new Lu.BehaviorSubject(1), this.dappDefaultChain = 1, this.appName = "", this.appLogoUrl = null, this.subscriptions = new Lu.Subscription(), this.linkAPIUrl = e.linkAPIUrl, this.storage = e.storage, this.options = e;
    const { session: i, ui: s, connection: n } = this.subscribe();
    if (this._session = i, this.connection = n, this.relayEventManager = e.relayEventManager, e.diagnosticLogger && e.eventListener)
      throw new Error("Can't have both eventListener and diagnosticLogger options, use only diagnosticLogger");
    e.eventListener ? this.diagnostic = {
      log: e.eventListener.onEvent
    } : this.diagnostic = e.diagnosticLogger, this._reloadOnDisconnect = (r = e.reloadOnDisconnect) !== null && r !== void 0 ? r : !0, this.ui = s;
  }
  subscribe() {
    this.subscriptions.add(this.dappDefaultChainSubject.subscribe((s) => {
      this.dappDefaultChain !== s && (this.dappDefaultChain = s);
    }));
    const e = Ka.Session.load(this.storage) || new Ka.Session(this.storage).save(), r = new WQ.WalletSDKConnection(e.id, e.key, this.linkAPIUrl, this.diagnostic);
    this.subscriptions.add(r.sessionConfig$.subscribe({
      next: (s) => {
        this.onSessionConfigChanged(s);
      },
      error: () => {
        var s;
        (s = this.diagnostic) === null || s === void 0 || s.log(Wi.EVENTS.GENERAL_ERROR, {
          message: "error while invoking session config callback"
        });
      }
    })), this.subscriptions.add(r.incomingEvent$.pipe((0, Si.filter)((s) => s.event === "Web3Response")).subscribe({ next: this.handleIncomingEvent })), this.subscriptions.add(r.linked$.pipe((0, Si.skip)(1), (0, Si.tap)((s) => {
      var n;
      this.isLinked = s;
      const f = this.storage.getItem(Ed.LOCAL_STORAGE_ADDRESSES_KEY);
      if (s && (this.session.linked = s), this.isUnlinkedErrorState = !1, f) {
        const u = f.split(" "), h = this.storage.getItem("IsStandaloneSigning") === "true";
        if (u[0] !== "" && !s && this.session.linked && !h) {
          this.isUnlinkedErrorState = !0;
          const d = this.getSessionIdHash();
          (n = this.diagnostic) === null || n === void 0 || n.log(Wi.EVENTS.UNLINKED_ERROR_STATE, {
            sessionIdHash: d
          });
        }
      }
    })).subscribe()), this.subscriptions.add(r.sessionConfig$.pipe((0, Si.filter)((s) => !!s.metadata && s.metadata.__destroyed === "1")).subscribe(() => {
      var s;
      const n = r.isDestroyed;
      return (s = this.diagnostic) === null || s === void 0 || s.log(Wi.EVENTS.METADATA_DESTROYED, {
        alreadyDestroyed: n,
        sessionIdHash: this.getSessionIdHash()
      }), this.resetAndReload();
    })), this.subscriptions.add(r.sessionConfig$.pipe((0, Si.filter)((s) => s.metadata && s.metadata.WalletUsername !== void 0)).pipe((0, Si.mergeMap)((s) => Lo.decrypt(s.metadata.WalletUsername, e.secret))).subscribe({
      next: (s) => {
        this.storage.setItem(Ed.WALLET_USER_NAME_KEY, s);
      },
      error: () => {
        var s;
        (s = this.diagnostic) === null || s === void 0 || s.log(Wi.EVENTS.GENERAL_ERROR, {
          message: "Had error decrypting",
          value: "username"
        });
      }
    })), this.subscriptions.add(r.sessionConfig$.pipe((0, Si.filter)((s) => s.metadata && s.metadata.AppVersion !== void 0)).pipe((0, Si.mergeMap)((s) => Lo.decrypt(s.metadata.AppVersion, e.secret))).subscribe({
      next: (s) => {
        this.storage.setItem(Ed.APP_VERSION_KEY, s);
      },
      error: () => {
        var s;
        (s = this.diagnostic) === null || s === void 0 || s.log(Wi.EVENTS.GENERAL_ERROR, {
          message: "Had error decrypting",
          value: "appversion"
        });
      }
    })), this.subscriptions.add(r.sessionConfig$.pipe((0, Si.filter)((s) => s.metadata && s.metadata.ChainId !== void 0 && s.metadata.JsonRpcUrl !== void 0)).pipe((0, Si.mergeMap)((s) => (0, Lu.zip)(Lo.decrypt(s.metadata.ChainId, e.secret), Lo.decrypt(s.metadata.JsonRpcUrl, e.secret)))).pipe((0, Si.distinctUntilChanged)()).subscribe({
      next: ([s, n]) => {
        this.chainCallback && this.chainCallback(s, n);
      },
      error: () => {
        var s;
        (s = this.diagnostic) === null || s === void 0 || s.log(Wi.EVENTS.GENERAL_ERROR, {
          message: "Had error decrypting",
          value: "chainId|jsonRpcUrl"
        });
      }
    })), this.subscriptions.add(r.sessionConfig$.pipe((0, Si.filter)((s) => s.metadata && s.metadata.EthereumAddress !== void 0)).pipe((0, Si.mergeMap)((s) => Lo.decrypt(s.metadata.EthereumAddress, e.secret))).subscribe({
      next: (s) => {
        this.accountsCallback && this.accountsCallback([s]), xs.accountRequestCallbackIds.size > 0 && (Array.from(xs.accountRequestCallbackIds.values()).forEach((n) => {
          const f = (0, Vi.Web3ResponseMessage)({
            id: n,
            response: (0, _n.RequestEthereumAccountsResponse)([
              s
            ])
          });
          this.invokeCallback(Object.assign(Object.assign({}, f), { id: n }));
        }), xs.accountRequestCallbackIds.clear());
      },
      error: () => {
        var s;
        (s = this.diagnostic) === null || s === void 0 || s.log(Wi.EVENTS.GENERAL_ERROR, {
          message: "Had error decrypting",
          value: "selectedAddress"
        });
      }
    }));
    const i = this.options.uiConstructor({
      linkAPIUrl: this.options.linkAPIUrl,
      version: this.options.version,
      darkMode: this.options.darkMode,
      session: e,
      connected$: r.connected$,
      chainId$: this.dappDefaultChainSubject
    });
    return r.connect(), { session: e, ui: i, connection: r };
  }
  attachUI() {
    this.ui.attach();
  }
  resetAndReload() {
    this.connection.setSessionMetadata("__destroyed", "1").pipe((0, Si.timeout)(1e3), (0, Si.catchError)((e) => (0, Lu.of)(null))).subscribe((e) => {
      var r, i, s;
      const n = this.ui.isStandalone();
      try {
        this.subscriptions.unsubscribe();
      } catch {
        (r = this.diagnostic) === null || r === void 0 || r.log(Wi.EVENTS.GENERAL_ERROR, {
          message: "Had error unsubscribing"
        });
      }
      (i = this.diagnostic) === null || i === void 0 || i.log(Wi.EVENTS.SESSION_STATE_CHANGE, {
        method: "relay::resetAndReload",
        sessionMetadataChange: "__destroyed, 1",
        sessionIdHash: this.getSessionIdHash()
      }), this.connection.destroy();
      const f = Ka.Session.load(this.storage);
      if ((f == null ? void 0 : f.id) === this._session.id ? this.storage.clear() : f && ((s = this.diagnostic) === null || s === void 0 || s.log(Wi.EVENTS.SKIPPED_CLEARING_SESSION, {
        sessionIdHash: this.getSessionIdHash(),
        storedSessionIdHash: Ka.Session.hash(f.id)
      })), this._reloadOnDisconnect) {
        this.ui.reloadUI();
        return;
      }
      this.accountsCallback && this.accountsCallback([], !0);
      const { session: u, ui: h, connection: d } = this.subscribe();
      this._session = u, this.connection = d, this.ui = h, n && this.ui.setStandalone && this.ui.setStandalone(!0), this.attachUI();
    }, (e) => {
      var r;
      (r = this.diagnostic) === null || r === void 0 || r.log(Wi.EVENTS.FAILURE, {
        method: "relay::resetAndReload",
        message: `failed to reset and reload with ${e}`,
        sessionIdHash: this.getSessionIdHash()
      });
    });
  }
  setAppInfo(e, r) {
    this.appName = e, this.appLogoUrl = r;
  }
  getStorageItem(e) {
    return this.storage.getItem(e);
  }
  get session() {
    return this._session;
  }
  setStorageItem(e, r) {
    this.storage.setItem(e, r);
  }
  signEthereumMessage(e, r, i, s) {
    return this.sendRequest({
      method: di.Web3Method.signEthereumMessage,
      params: {
        message: (0, Fr.hexStringFromBuffer)(e, !0),
        address: r,
        addPrefix: i,
        typedDataJson: s || null
      }
    });
  }
  ethereumAddressFromSignedMessage(e, r, i) {
    return this.sendRequest({
      method: di.Web3Method.ethereumAddressFromSignedMessage,
      params: {
        message: (0, Fr.hexStringFromBuffer)(e, !0),
        signature: (0, Fr.hexStringFromBuffer)(r, !0),
        addPrefix: i
      }
    });
  }
  signEthereumTransaction(e) {
    return this.sendRequest({
      method: di.Web3Method.signEthereumTransaction,
      params: {
        fromAddress: e.fromAddress,
        toAddress: e.toAddress,
        weiValue: (0, Fr.bigIntStringFromBN)(e.weiValue),
        data: (0, Fr.hexStringFromBuffer)(e.data, !0),
        nonce: e.nonce,
        gasPriceInWei: e.gasPriceInWei ? (0, Fr.bigIntStringFromBN)(e.gasPriceInWei) : null,
        maxFeePerGas: e.gasPriceInWei ? (0, Fr.bigIntStringFromBN)(e.gasPriceInWei) : null,
        maxPriorityFeePerGas: e.gasPriceInWei ? (0, Fr.bigIntStringFromBN)(e.gasPriceInWei) : null,
        gasLimit: e.gasLimit ? (0, Fr.bigIntStringFromBN)(e.gasLimit) : null,
        chainId: e.chainId,
        shouldSubmit: !1
      }
    });
  }
  signAndSubmitEthereumTransaction(e) {
    return this.sendRequest({
      method: di.Web3Method.signEthereumTransaction,
      params: {
        fromAddress: e.fromAddress,
        toAddress: e.toAddress,
        weiValue: (0, Fr.bigIntStringFromBN)(e.weiValue),
        data: (0, Fr.hexStringFromBuffer)(e.data, !0),
        nonce: e.nonce,
        gasPriceInWei: e.gasPriceInWei ? (0, Fr.bigIntStringFromBN)(e.gasPriceInWei) : null,
        maxFeePerGas: e.maxFeePerGas ? (0, Fr.bigIntStringFromBN)(e.maxFeePerGas) : null,
        maxPriorityFeePerGas: e.maxPriorityFeePerGas ? (0, Fr.bigIntStringFromBN)(e.maxPriorityFeePerGas) : null,
        gasLimit: e.gasLimit ? (0, Fr.bigIntStringFromBN)(e.gasLimit) : null,
        chainId: e.chainId,
        shouldSubmit: !0
      }
    });
  }
  submitEthereumTransaction(e, r) {
    return this.sendRequest({
      method: di.Web3Method.submitEthereumTransaction,
      params: {
        signedTransaction: (0, Fr.hexStringFromBuffer)(e, !0),
        chainId: r
      }
    });
  }
  scanQRCode(e) {
    return this.sendRequest({
      method: di.Web3Method.scanQRCode,
      params: { regExp: e }
    });
  }
  getQRCodeUrl() {
    return (0, Fr.createQrUrl)(this._session.id, this._session.secret, this.linkAPIUrl, !1, this.options.version, this.dappDefaultChain);
  }
  genericRequest(e, r) {
    return this.sendRequest({
      method: di.Web3Method.generic,
      params: {
        action: r,
        data: e
      }
    });
  }
  sendGenericMessage(e) {
    return this.sendRequest(e);
  }
  sendRequest(e) {
    let r = null;
    const i = (0, Fr.randomBytesHex)(8), s = (f) => {
      this.publishWeb3RequestCanceledEvent(i), this.handleErrorResponse(i, e.method, f), r == null || r();
    };
    return { promise: new Promise((f, u) => {
      this.ui.isStandalone() || (r = this.ui.showConnecting({
        isUnlinkedErrorState: this.isUnlinkedErrorState,
        onCancel: s,
        onResetConnection: this.resetAndReload
      })), this.relayEventManager.callbacks.set(i, (h) => {
        if (r == null || r(), h.errorMessage)
          return u(new Error(h.errorMessage));
        f(h);
      }), this.ui.isStandalone() ? this.sendRequestStandalone(i, e) : this.publishWeb3RequestEvent(i, e);
    }), cancel: s };
  }
  setConnectDisabled(e) {
    this.ui.setConnectDisabled(e);
  }
  setAccountsCallback(e) {
    this.accountsCallback = e;
  }
  setChainCallback(e) {
    this.chainCallback = e;
  }
  setDappDefaultChainCallback(e) {
    this.dappDefaultChainSubject.next(e);
  }
  publishWeb3RequestEvent(e, r) {
    var i;
    const s = (0, KQ.Web3RequestMessage)({ id: e, request: r }), n = Ka.Session.load(this.storage);
    (i = this.diagnostic) === null || i === void 0 || i.log(Wi.EVENTS.WEB3_REQUEST, {
      eventId: s.id,
      method: `relay::${s.request.method}`,
      sessionIdHash: this.getSessionIdHash(),
      storedSessionIdHash: n ? Ka.Session.hash(n.id) : "",
      isSessionMismatched: ((n == null ? void 0 : n.id) !== this._session.id).toString()
    }), this.subscriptions.add(this.publishEvent("Web3Request", s, !0).subscribe({
      next: (f) => {
        var u;
        (u = this.diagnostic) === null || u === void 0 || u.log(Wi.EVENTS.WEB3_REQUEST_PUBLISHED, {
          eventId: s.id,
          method: `relay::${s.request.method}`,
          sessionIdHash: this.getSessionIdHash(),
          storedSessionIdHash: n ? Ka.Session.hash(n.id) : "",
          isSessionMismatched: ((n == null ? void 0 : n.id) !== this._session.id).toString()
        });
      },
      error: (f) => {
        this.handleWeb3ResponseMessage((0, Vi.Web3ResponseMessage)({
          id: s.id,
          response: {
            method: s.request.method,
            errorMessage: f.message
          }
        }));
      }
    }));
  }
  publishWeb3RequestCanceledEvent(e) {
    const r = (0, GQ.Web3RequestCanceledMessage)(e);
    this.subscriptions.add(this.publishEvent("Web3RequestCanceled", r, !1).subscribe());
  }
  publishEvent(e, r, i) {
    const s = this.session.secret;
    return new Lu.Observable((n) => {
      Lo.encrypt(JSON.stringify(Object.assign(Object.assign({}, r), { origin: location.origin })), s).then((f) => {
        n.next(f), n.complete();
      });
    }).pipe((0, Si.mergeMap)((n) => this.connection.publishEvent(e, n, i)));
  }
  handleIncomingEvent(e) {
    try {
      this.subscriptions.add(Lo.decrypt(e.data, this.session.secret).pipe((0, Si.map)((r) => JSON.parse(r))).subscribe({
        next: (r) => {
          const i = (0, Vi.isWeb3ResponseMessage)(r) ? r : null;
          !i || this.handleWeb3ResponseMessage(i);
        },
        error: () => {
          var r;
          (r = this.diagnostic) === null || r === void 0 || r.log(Wi.EVENTS.GENERAL_ERROR, {
            message: "Had error decrypting",
            value: "incomingEvent"
          });
        }
      }));
    } catch {
      return;
    }
  }
  handleWeb3ResponseMessage(e) {
    var r;
    const { response: i } = e;
    if ((r = this.diagnostic) === null || r === void 0 || r.log(Wi.EVENTS.WEB3_RESPONSE, {
      eventId: e.id,
      method: `relay::${i.method}`,
      sessionIdHash: this.getSessionIdHash()
    }), (0, _n.isRequestEthereumAccountsResponse)(i)) {
      xs.accountRequestCallbackIds.forEach((s) => this.invokeCallback(Object.assign(Object.assign({}, e), { id: s }))), xs.accountRequestCallbackIds.clear();
      return;
    }
    this.invokeCallback(e);
  }
  handleErrorResponse(e, r, i, s) {
    this.handleWeb3ResponseMessage((0, Vi.Web3ResponseMessage)({
      id: e,
      response: (0, _n.ErrorResponse)(r, (i != null ? i : pg.WalletUIError.UserRejectedRequest).message, s)
    }));
  }
  invokeCallback(e) {
    const r = this.relayEventManager.callbacks.get(e.id);
    r && (r(e.response), this.relayEventManager.callbacks.delete(e.id));
  }
  requestEthereumAccounts() {
    const e = {
      method: di.Web3Method.requestEthereumAccounts,
      params: {
        appName: this.appName,
        appLogoUrl: this.appLogoUrl || null
      }
    }, r = (0, Fr.randomBytesHex)(8), i = (n) => {
      this.publishWeb3RequestCanceledEvent(r), this.handleErrorResponse(r, e.method, n);
    };
    return { promise: new Promise((n, f) => {
      var u;
      this.relayEventManager.callbacks.set(r, (d) => {
        if (this.ui.hideRequestEthereumAccounts(), d.errorMessage)
          return f(new Error(d.errorMessage));
        n(d);
      });
      const h = ((u = window == null ? void 0 : window.navigator) === null || u === void 0 ? void 0 : u.userAgent) || null;
      if (h && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(h)) {
        let d;
        try {
          (0, Fr.isInIFrame)() && window.top ? d = window.top.location : d = window.location;
        } catch {
          d = window.location;
        }
        d.href = `https://go.cb-w.com/xoXnYwQimhb?cb_url=${encodeURIComponent(d.href)}`;
        return;
      }
      if (this.ui.inlineAccountsResponse()) {
        const d = (l) => {
          this.handleWeb3ResponseMessage((0, Vi.Web3ResponseMessage)({
            id: r,
            response: (0, _n.RequestEthereumAccountsResponse)(l)
          }));
        };
        this.ui.requestEthereumAccounts({
          onCancel: i,
          onAccounts: d
        });
      } else {
        const d = D6.ethErrors.provider.userRejectedRequest("User denied account authorization");
        this.ui.requestEthereumAccounts({
          onCancel: () => i(d)
        });
      }
      xs.accountRequestCallbackIds.add(r), !this.ui.inlineAccountsResponse() && !this.ui.isStandalone() && this.publishWeb3RequestEvent(r, e);
    }), cancel: i };
  }
  selectProvider(e) {
    const r = {
      method: di.Web3Method.selectProvider,
      params: {
        providerOptions: e
      }
    }, i = (0, Fr.randomBytesHex)(8), s = (f) => {
      this.publishWeb3RequestCanceledEvent(i), this.handleErrorResponse(i, r.method, f);
    }, n = new Promise((f, u) => {
      this.relayEventManager.callbacks.set(i, (l) => {
        if (l.errorMessage)
          return u(new Error(l.errorMessage));
        f(l);
      });
      const h = (l) => {
        this.handleWeb3ResponseMessage((0, Vi.Web3ResponseMessage)({
          id: i,
          response: (0, _n.SelectProviderResponse)(VQ.ProviderType.Unselected)
        }));
      }, d = (l) => {
        this.handleWeb3ResponseMessage((0, Vi.Web3ResponseMessage)({
          id: i,
          response: (0, _n.SelectProviderResponse)(l)
        }));
      };
      this.ui.selectProvider && this.ui.selectProvider({
        onApprove: d,
        onCancel: h,
        providerOptions: e
      });
    });
    return { cancel: s, promise: n };
  }
  watchAsset(e, r, i, s, n, f) {
    const u = {
      method: di.Web3Method.watchAsset,
      params: {
        type: e,
        options: {
          address: r,
          symbol: i,
          decimals: s,
          image: n
        },
        chainId: f
      }
    };
    let h = null;
    const d = (0, Fr.randomBytesHex)(8), l = (b) => {
      this.publishWeb3RequestCanceledEvent(d), this.handleErrorResponse(d, u.method, b), h == null || h();
    };
    this.ui.inlineWatchAsset() || (h = this.ui.showConnecting({
      isUnlinkedErrorState: this.isUnlinkedErrorState,
      onCancel: l,
      onResetConnection: this.resetAndReload
    }));
    const m = new Promise((b, M) => {
      this.relayEventManager.callbacks.set(d, (R) => {
        if (h == null || h(), R.errorMessage)
          return M(new Error(R.errorMessage));
        b(R);
      });
      const A = (R) => {
        this.handleWeb3ResponseMessage((0, Vi.Web3ResponseMessage)({
          id: d,
          response: (0, _n.WatchAssetReponse)(!1)
        }));
      }, N = () => {
        this.handleWeb3ResponseMessage((0, Vi.Web3ResponseMessage)({
          id: d,
          response: (0, _n.WatchAssetReponse)(!0)
        }));
      };
      this.ui.inlineWatchAsset() && this.ui.watchAsset({
        onApprove: N,
        onCancel: A,
        type: e,
        address: r,
        symbol: i,
        decimals: s,
        image: n,
        chainId: f
      }), !this.ui.inlineWatchAsset() && !this.ui.isStandalone() && this.publishWeb3RequestEvent(d, u);
    });
    return { cancel: l, promise: m };
  }
  addEthereumChain(e, r, i, s, n, f) {
    const u = {
      method: di.Web3Method.addEthereumChain,
      params: {
        chainId: e,
        rpcUrls: r,
        blockExplorerUrls: s,
        chainName: n,
        iconUrls: i,
        nativeCurrency: f
      }
    };
    let h = null;
    const d = (0, Fr.randomBytesHex)(8), l = (b) => {
      this.publishWeb3RequestCanceledEvent(d), this.handleErrorResponse(d, u.method, b), h == null || h();
    };
    return this.ui.inlineAddEthereumChain(e) || (h = this.ui.showConnecting({
      isUnlinkedErrorState: this.isUnlinkedErrorState,
      onCancel: l,
      onResetConnection: this.resetAndReload
    })), { promise: new Promise((b, M) => {
      this.relayEventManager.callbacks.set(d, (R) => {
        if (h == null || h(), R.errorMessage)
          return M(new Error(R.errorMessage));
        b(R);
      });
      const A = (R) => {
        this.handleWeb3ResponseMessage((0, Vi.Web3ResponseMessage)({
          id: d,
          response: (0, _n.AddEthereumChainResponse)({
            isApproved: !1,
            rpcUrl: ""
          })
        }));
      }, N = (R) => {
        this.handleWeb3ResponseMessage((0, Vi.Web3ResponseMessage)({
          id: d,
          response: (0, _n.AddEthereumChainResponse)({ isApproved: !0, rpcUrl: R })
        }));
      };
      this.ui.inlineAddEthereumChain(e) && this.ui.addEthereumChain({
        onCancel: A,
        onApprove: N,
        chainId: u.params.chainId,
        rpcUrls: u.params.rpcUrls,
        blockExplorerUrls: u.params.blockExplorerUrls,
        chainName: u.params.chainName,
        iconUrls: u.params.iconUrls,
        nativeCurrency: u.params.nativeCurrency
      }), !this.ui.inlineAddEthereumChain(e) && !this.ui.isStandalone() && this.publishWeb3RequestEvent(d, u);
    }), cancel: l };
  }
  switchEthereumChain(e, r) {
    const i = {
      method: di.Web3Method.switchEthereumChain,
      params: Object.assign({ chainId: e }, { address: r })
    }, s = (0, Fr.randomBytesHex)(8), n = (u) => {
      this.publishWeb3RequestCanceledEvent(s), this.handleErrorResponse(s, i.method, u);
    };
    return { promise: new Promise((u, h) => {
      this.relayEventManager.callbacks.set(s, (m) => {
        if (m.errorMessage && m.errorCode)
          return h(D6.ethErrors.provider.custom({
            code: m.errorCode,
            message: "Unrecognized chain ID. Try adding the chain using addEthereumChain first."
          }));
        if (m.errorMessage)
          return h(new Error(m.errorMessage));
        u(m);
      });
      const d = (m) => {
        if (typeof m == "number") {
          const b = m;
          this.handleWeb3ResponseMessage((0, Vi.Web3ResponseMessage)({
            id: s,
            response: (0, _n.ErrorResponse)(di.Web3Method.switchEthereumChain, pg.WalletUIError.SwitchEthereumChainUnsupportedChainId.message, b)
          }));
        } else
          m instanceof pg.WalletUIError ? this.handleErrorResponse(s, di.Web3Method.switchEthereumChain, m, m.errorCode) : this.handleWeb3ResponseMessage((0, Vi.Web3ResponseMessage)({
            id: s,
            response: (0, _n.SwitchEthereumChainResponse)({
              isApproved: !1,
              rpcUrl: ""
            })
          }));
      }, l = (m) => {
        this.handleWeb3ResponseMessage((0, Vi.Web3ResponseMessage)({
          id: s,
          response: (0, _n.SwitchEthereumChainResponse)({
            isApproved: !0,
            rpcUrl: m
          })
        }));
      };
      this.ui.switchEthereumChain({
        onCancel: d,
        onApprove: l,
        chainId: i.params.chainId,
        address: i.params.address
      }), !this.ui.inlineSwitchEthereumChain() && !this.ui.isStandalone() && this.publishWeb3RequestEvent(s, i);
    }), cancel: n };
  }
  inlineAddEthereumChain(e) {
    return this.ui.inlineAddEthereumChain(e);
  }
  getSessionIdHash() {
    return Ka.Session.hash(this._session.id);
  }
  sendRequestStandalone(e, r) {
    const i = (n) => {
      this.handleErrorResponse(e, r.method, n);
    }, s = (n) => {
      this.handleWeb3ResponseMessage((0, Vi.Web3ResponseMessage)({
        id: e,
        response: n
      }));
    };
    switch (r.method) {
      case di.Web3Method.signEthereumMessage:
        this.ui.signEthereumMessage({
          request: r,
          onSuccess: s,
          onCancel: i
        });
        break;
      case di.Web3Method.signEthereumTransaction:
        this.ui.signEthereumTransaction({
          request: r,
          onSuccess: s,
          onCancel: i
        });
        break;
      case di.Web3Method.submitEthereumTransaction:
        this.ui.submitEthereumTransaction({
          request: r,
          onSuccess: s,
          onCancel: i
        });
        break;
      case di.Web3Method.ethereumAddressFromSignedMessage:
        this.ui.ethereumAddressFromSignedMessage({
          request: r,
          onSuccess: s
        });
        break;
      default:
        i();
        break;
    }
  }
  onSessionConfigChanged(e) {
  }
}
xs.accountRequestCallbackIds = /* @__PURE__ */ new Set();
tI([
  rI.default
], xs.prototype, "resetAndReload", null);
tI([
  rI.default
], xs.prototype, "handleIncomingEvent", null);
Ap.WalletSDKRelay = xs;
var Pp = {};
Object.defineProperty(Pp, "__esModule", { value: !0 });
Pp.WalletSDKRelayEventManager = void 0;
const YQ = xt;
class QQ {
  constructor() {
    this._nextRequestId = 0, this.callbacks = /* @__PURE__ */ new Map();
  }
  makeRequestId() {
    this._nextRequestId = (this._nextRequestId + 1) % 2147483647;
    const e = this._nextRequestId, r = (0, YQ.prepend0x)(e.toString(16));
    return this.callbacks.get(r) && this.callbacks.delete(r), e;
  }
}
Pp.WalletSDKRelayEventManager = QQ;
const ZQ = "@coinbase/wallet-sdk", JQ = "3.5.4", XQ = "Coinbase Wallet JavaScript SDK", eZ = [
  "cipher",
  "cipherbrowser",
  "coinbase",
  "coinbasewallet",
  "eth",
  "ether",
  "ethereum",
  "etherium",
  "injection",
  "toshi",
  "wallet",
  "walletlink",
  "web3"
], tZ = "dist/index.js", rZ = "dist/index.d.ts", iZ = "https://github.com/coinbase/coinbase-wallet-sdk.git", nZ = "Coinbase, Inc.", sZ = "Apache-2.0", aZ = {
  "pretest:unit": "node compile-assets.js",
  "test:unit": "jest",
  "test:unit:coverage": "yarn test:unit && open coverage/lcov-report/index.html",
  "test:karma": "yarn build-npm && karma start",
  prebuild: `node -p "'export const LIB_VERSION = ' + JSON.stringify(require('./package.json').version) + ';'" > src/version.ts`,
  build: "node compile-assets.js && webpack --config webpack.config.js",
  "build-npm": "tsc -p ./tsconfig.build.json",
  "build:dev": "export LINK_API_URL='http://localhost:3000'; yarn build",
  "build:dev:watch": "nodemon -e 'ts,tsx,js,json,css,scss,svg' --ignore 'src/**/*-css.ts' --ignore 'src/**/*-svg.ts' --watch src/ --exec 'yarn build:dev'",
  "build:prod": `yarn prebuild && yarn build && yarn build-npm && cp ./package.json ../../README.md ./LICENSE build/npm && cp -a src/vendor-js build/npm/dist && sed -i.bak 's|  "private": true,||g' build/npm/package.json && rm -f build/npm/package.json.bak`,
  "lint:types": "tsc --noEmit",
  "lint:prettier": 'prettier --check "{src,__tests__}/**/*.(js|ts|tsx)"',
  "lint:eslint": "eslint ./src --ext .ts,.tsx",
  "fix:eslint": "yarn lint:eslint --fix",
  "fix:prettier": "prettier . --write",
  release: "./scripts/release.sh"
}, oZ = {
  "@metamask/safe-event-emitter": "2.0.0",
  "@solana/web3.js": "1.52.0",
  "bind-decorator": "^1.0.11",
  "bn.js": "^5.1.1",
  buffer: "^6.0.3",
  clsx: "^1.1.0",
  "eth-block-tracker": "4.4.3",
  "eth-json-rpc-filters": "4.2.2",
  "eth-rpc-errors": "4.0.2",
  "json-rpc-engine": "6.1.0",
  keccak: "^3.0.1",
  preact: "^10.5.9",
  qs: "^6.10.3",
  rxjs: "^6.6.3",
  "sha.js": "^2.4.11",
  "stream-browserify": "^3.0.0",
  util: "^0.12.4"
}, fZ = {
  "@babel/core": "^7.17.9",
  "@babel/plugin-proposal-decorators": "^7.17.9",
  "@babel/plugin-transform-react-jsx": "^7.17.3",
  "@babel/preset-env": "^7.16.11",
  "@babel/preset-typescript": "^7.16.7",
  "@peculiar/webcrypto": "^1.3.3",
  "@testing-library/jest-dom": "^5.16.4",
  "@testing-library/preact": "^2.0.1",
  "@types/bn.js": "^4.11.6",
  "@types/jest": "^27.4.1",
  "@types/node": "^14.14.20",
  "@types/qs": "^6.9.7",
  "@types/sha.js": "^2.4.0",
  "@typescript-eslint/eslint-plugin": "^5.7.0",
  "@typescript-eslint/eslint-plugin-tslint": "^5.7.0",
  "@typescript-eslint/parser": "^5.7.0",
  "babel-jest": "^27.5.1",
  browserify: "17.0.0",
  "copy-webpack-plugin": "^6.4.1",
  "core-js": "^3.8.2",
  eslint: "^8.4.1",
  "eslint-config-prettier": "^8.3.0",
  "eslint-plugin-import": "^2.25.3",
  "eslint-plugin-preact": "^0.1.0",
  "eslint-plugin-prettier": "^4.0.0",
  "eslint-plugin-simple-import-sort": "^7.0.0",
  jasmine: "3.8.0",
  jest: "^27.5.1",
  "jest-chrome": "^0.7.2",
  "jest-websocket-mock": "^2.3.0",
  karma: "^6.3.15",
  "karma-browserify": "8.1.0",
  "karma-chrome-launcher": "^3.1.0",
  "karma-jasmine": "^4.0.1",
  nodemon: "^2.0.6",
  prettier: "^2.5.1",
  "raw-loader": "^4.0.2",
  "regenerator-runtime": "^0.13.7",
  sass: "^1.50.0",
  svgo: "^2.8.0",
  "ts-jest": "^27.1.4",
  "ts-loader": "^8.0.13",
  "ts-node": "^10.7.0",
  tslib: "^2.0.3",
  typescript: "^4.1.3",
  watchify: "4.0.0",
  webpack: "^5.72.0",
  "webpack-cli": "^4.9.2",
  "whatwg-fetch": "^3.5.0"
}, cZ = {
  node: ">= 10.0.0"
}, uZ = {
  name: ZQ,
  version: JQ,
  description: XQ,
  keywords: eZ,
  main: tZ,
  types: rZ,
  repository: iZ,
  author: nZ,
  license: sZ,
  scripts: aZ,
  dependencies: oZ,
  devDependencies: fZ,
  engines: cZ
};
Object.defineProperty(ch, "__esModule", { value: !0 });
ch.CoinbaseWalletSDK = void 0;
const hZ = V0, lZ = G0, dZ = bc, pZ = wp, vZ = Ap, gZ = Pp, bZ = xt, yZ = process.env.LINK_API_URL || "https://www.walletlink.org", iI = process.env.SDK_VERSION || uZ.version || "unknown";
class kp {
  constructor(e) {
    var r, i, s;
    this._appName = "", this._appLogoUrl = null, this._relay = null, this._relayEventManager = null;
    const n = e.linkAPIUrl || yZ;
    let f;
    if (e.uiConstructor ? f = e.uiConstructor : f = (d) => new pZ.WalletSDKUI(d), typeof e.overrideIsMetaMask > "u" ? this._overrideIsMetaMask = !1 : this._overrideIsMetaMask = e.overrideIsMetaMask, this._overrideIsCoinbaseWallet = (r = e.overrideIsCoinbaseWallet) !== null && r !== void 0 ? r : !0, this._overrideIsCoinbaseBrowser = (i = e.overrideIsCoinbaseBrowser) !== null && i !== void 0 ? i : !1, e.diagnosticLogger && e.eventListener)
      throw new Error("Can't have both eventListener and diagnosticLogger options, use only diagnosticLogger");
    e.eventListener ? this._diagnosticLogger = {
      log: e.eventListener.onEvent
    } : this._diagnosticLogger = e.diagnosticLogger, this._reloadOnDisconnect = (s = e.reloadOnDisconnect) !== null && s !== void 0 ? s : !0;
    const u = new URL(n), h = `${u.protocol}//${u.host}`;
    this._storage = new lZ.ScopedLocalStorage(`-walletlink:${h}`), this._storage.setItem("version", kp.VERSION), !(this.walletExtension || this.coinbaseBrowser) && (this._relayEventManager = new gZ.WalletSDKRelayEventManager(), this._relay = new vZ.WalletSDKRelay({
      linkAPIUrl: n,
      version: iI,
      darkMode: !!e.darkMode,
      uiConstructor: f,
      storage: this._storage,
      relayEventManager: this._relayEventManager,
      diagnosticLogger: this._diagnosticLogger
    }), this.setAppInfo(e.appName, e.appLogoUrl), !e.headlessMode && this._relay.attachUI());
  }
  makeWeb3Provider(e = "", r = 1) {
    const i = this.walletExtension;
    if (i)
      return this.isCipherProvider(i) || i.setProviderInfo(e, r), this._reloadOnDisconnect === !1 && typeof i.disableReloadOnDisconnect == "function" && i.disableReloadOnDisconnect(), i;
    const s = this.coinbaseBrowser;
    if (s)
      return s;
    const n = this._relay;
    if (!n || !this._relayEventManager || !this._storage)
      throw new Error("Relay not initialized, should never happen");
    return e || n.setConnectDisabled(!0), new dZ.CoinbaseWalletProvider({
      relayProvider: () => Promise.resolve(n),
      relayEventManager: this._relayEventManager,
      storage: this._storage,
      jsonRpcUrl: e,
      chainId: r,
      qrUrl: this.getQrUrl(),
      diagnosticLogger: this._diagnosticLogger,
      overrideIsMetaMask: this._overrideIsMetaMask,
      overrideIsCoinbaseWallet: this._overrideIsCoinbaseWallet,
      overrideIsCoinbaseBrowser: this._overrideIsCoinbaseBrowser
    });
  }
  setAppInfo(e, r) {
    var i;
    this._appName = e || "DApp", this._appLogoUrl = r || (0, bZ.getFavicon)();
    const s = this.walletExtension;
    s ? this.isCipherProvider(s) || s.setAppInfo(this._appName, this._appLogoUrl) : (i = this._relay) === null || i === void 0 || i.setAppInfo(this._appName, this._appLogoUrl);
  }
  disconnect() {
    var e;
    const r = this.walletExtension;
    r ? r.close() : (e = this._relay) === null || e === void 0 || e.resetAndReload();
  }
  getQrUrl() {
    var e, r;
    return (r = (e = this._relay) === null || e === void 0 ? void 0 : e.getQRCodeUrl()) !== null && r !== void 0 ? r : null;
  }
  getCoinbaseWalletLogo(e, r = 240) {
    return (0, hZ.walletLogo)(e, r);
  }
  get walletExtension() {
    var e;
    return (e = window.coinbaseWalletExtension) !== null && e !== void 0 ? e : window.walletLinkExtension;
  }
  get coinbaseBrowser() {
    var e, r;
    try {
      const i = (e = window.ethereum) !== null && e !== void 0 ? e : (r = window.top) === null || r === void 0 ? void 0 : r.ethereum;
      return i && "isCoinbaseBrowser" in i && i.isCoinbaseBrowser ? i : void 0;
    } catch {
      return;
    }
  }
  isCipherProvider(e) {
    return typeof e.isCipher == "boolean" && e.isCipher;
  }
}
ch.CoinbaseWalletSDK = kp;
kp.VERSION = iI;
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.CoinbaseWalletProvider = t.CoinbaseWalletSDK = void 0;
  const e = ch, r = bc;
  var i = ch;
  Object.defineProperty(t, "CoinbaseWalletSDK", { enumerable: !0, get: function() {
    return i.CoinbaseWalletSDK;
  } });
  var s = bc;
  Object.defineProperty(t, "CoinbaseWalletProvider", { enumerable: !0, get: function() {
    return s.CoinbaseWalletProvider;
  } }), t.default = e.CoinbaseWalletSDK, typeof window < "u" && (window.CoinbaseWalletSDK = e.CoinbaseWalletSDK, window.CoinbaseWalletProvider = r.CoinbaseWalletProvider, window.WalletLink = e.CoinbaseWalletSDK, window.WalletLinkProvider = r.CoinbaseWalletProvider);
})(HS);
const mZ = /* @__PURE__ */ PS(HS);
var C6 = globalThis && globalThis.__spreadArray || function(t, e, r) {
  if (r || arguments.length === 2)
    for (var i = 0, s = e.length, n; i < s; i++)
      (n || !(i in e)) && (n || (n = Array.prototype.slice.call(e, 0, i)), n[i] = e[i]);
  return t.concat(n || Array.prototype.slice.call(e));
}, wZ = function() {
  function t(e, r, i) {
    this.name = e, this.version = r, this.os = i, this.type = "browser";
  }
  return t;
}(), _Z = function() {
  function t(e) {
    this.version = e, this.type = "node", this.name = "node", this.os = process.platform;
  }
  return t;
}(), MZ = function() {
  function t(e, r, i, s) {
    this.name = e, this.version = r, this.os = i, this.bot = s, this.type = "bot-device";
  }
  return t;
}(), xZ = function() {
  function t() {
    this.type = "bot", this.bot = !0, this.name = "bot", this.version = null, this.os = null;
  }
  return t;
}(), SZ = function() {
  function t() {
    this.type = "react-native", this.name = "react-native", this.version = null, this.os = null;
  }
  return t;
}(), EZ = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/, IZ = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/, O6 = 3, AZ = [
  ["aol", /AOLShield\/([0-9\._]+)/],
  ["edge", /Edge\/([0-9\._]+)/],
  ["edge-ios", /EdgiOS\/([0-9\._]+)/],
  ["yandexbrowser", /YaBrowser\/([0-9\._]+)/],
  ["kakaotalk", /KAKAOTALK\s([0-9\.]+)/],
  ["samsung", /SamsungBrowser\/([0-9\.]+)/],
  ["silk", /\bSilk\/([0-9._-]+)\b/],
  ["miui", /MiuiBrowser\/([0-9\.]+)$/],
  ["beaker", /BeakerBrowser\/([0-9\.]+)/],
  ["edge-chromium", /EdgA?\/([0-9\.]+)/],
  [
    "chromium-webview",
    /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
  ],
  ["chrome", /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
  ["phantomjs", /PhantomJS\/([0-9\.]+)(:?\s|$)/],
  ["crios", /CriOS\/([0-9\.]+)(:?\s|$)/],
  ["firefox", /Firefox\/([0-9\.]+)(?:\s|$)/],
  ["fxios", /FxiOS\/([0-9\.]+)/],
  ["opera-mini", /Opera Mini.*Version\/([0-9\.]+)/],
  ["opera", /Opera\/([0-9\.]+)(?:\s|$)/],
  ["opera", /OPR\/([0-9\.]+)(:?\s|$)/],
  ["pie", /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/],
  ["pie", /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/],
  ["netfront", /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/],
  ["ie", /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
  ["ie", /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
  ["ie", /MSIE\s(7\.0)/],
  ["bb10", /BB10;\sTouch.*Version\/([0-9\.]+)/],
  ["android", /Android\s([0-9\.]+)/],
  ["ios", /Version\/([0-9\._]+).*Mobile.*Safari.*/],
  ["safari", /Version\/([0-9\._]+).*Safari/],
  ["facebook", /FB[AS]V\/([0-9\.]+)/],
  ["instagram", /Instagram\s([0-9\.]+)/],
  ["ios-webview", /AppleWebKit\/([0-9\.]+).*Mobile/],
  ["ios-webview", /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
  ["curl", /^curl\/([0-9\.]+)$/],
  ["searchbot", EZ]
], R6 = [
  ["iOS", /iP(hone|od|ad)/],
  ["Android OS", /Android/],
  ["BlackBerry OS", /BlackBerry|BB10/],
  ["Windows Mobile", /IEMobile/],
  ["Amazon OS", /Kindle/],
  ["Windows 3.11", /Win16/],
  ["Windows 95", /(Windows 95)|(Win95)|(Windows_95)/],
  ["Windows 98", /(Windows 98)|(Win98)/],
  ["Windows 2000", /(Windows NT 5.0)|(Windows 2000)/],
  ["Windows XP", /(Windows NT 5.1)|(Windows XP)/],
  ["Windows Server 2003", /(Windows NT 5.2)/],
  ["Windows Vista", /(Windows NT 6.0)/],
  ["Windows 7", /(Windows NT 6.1)/],
  ["Windows 8", /(Windows NT 6.2)/],
  ["Windows 8.1", /(Windows NT 6.3)/],
  ["Windows 10", /(Windows NT 10.0)/],
  ["Windows ME", /Windows ME/],
  ["Windows CE", /Windows CE|WinCE|Microsoft Pocket Internet Explorer/],
  ["Open BSD", /OpenBSD/],
  ["Sun OS", /SunOS/],
  ["Chrome OS", /CrOS/],
  ["Linux", /(Linux)|(X11)/],
  ["Mac OS", /(Mac_PowerPC)|(Macintosh)/],
  ["QNX", /QNX/],
  ["BeOS", /BeOS/],
  ["OS/2", /OS\/2/]
];
function TZ(t) {
  return t ? L6(t) : typeof document > "u" && typeof navigator < "u" && navigator.product === "ReactNative" ? new SZ() : typeof navigator < "u" ? L6(navigator.userAgent) : CZ();
}
function NZ(t) {
  return t !== "" && AZ.reduce(function(e, r) {
    var i = r[0], s = r[1];
    if (e)
      return e;
    var n = s.exec(t);
    return !!n && [i, n];
  }, !1);
}
function L6(t) {
  var e = NZ(t);
  if (!e)
    return null;
  var r = e[0], i = e[1];
  if (r === "searchbot")
    return new xZ();
  var s = i[1] && i[1].split(".").join("_").split("_").slice(0, 3);
  s ? s.length < O6 && (s = C6(C6([], s, !0), OZ(O6 - s.length), !0)) : s = [];
  var n = s.join("."), f = DZ(t), u = IZ.exec(t);
  return u && u[1] ? new MZ(r, n, f, u[1]) : new wZ(r, n, f);
}
function DZ(t) {
  for (var e = 0, r = R6.length; e < r; e++) {
    var i = R6[e], s = i[0], n = i[1], f = n.exec(t);
    if (f)
      return s;
  }
  return null;
}
function CZ() {
  var t = typeof process < "u" && process.version;
  return t ? new _Z(process.version.slice(1)) : null;
}
function OZ(t) {
  for (var e = [], r = 0; r < t; r++)
    e.push("0");
  return e;
}
var ct = {}, Yh = { exports: {} };
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
(function(t) {
  var e, r, i, s, n, f, u, h, d, l, m, b, M, A, N, R, O, P, F, H, Q, Z, B;
  (function(Y) {
    var ae = typeof nt == "object" ? nt : typeof self == "object" ? self : typeof this == "object" ? this : {};
    Y(se(ae, se(t.exports)));
    function se(W, C) {
      return W !== ae && (typeof Object.create == "function" ? Object.defineProperty(W, "__esModule", { value: !0 }) : W.__esModule = !0), function(g, a) {
        return W[g] = C ? C(g, a) : a;
      };
    }
  })(function(Y) {
    var ae = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(se, W) {
      se.__proto__ = W;
    } || function(se, W) {
      for (var C in W)
        W.hasOwnProperty(C) && (se[C] = W[C]);
    };
    e = function(se, W) {
      ae(se, W);
      function C() {
        this.constructor = se;
      }
      se.prototype = W === null ? Object.create(W) : (C.prototype = W.prototype, new C());
    }, r = Object.assign || function(se) {
      for (var W, C = 1, g = arguments.length; C < g; C++) {
        W = arguments[C];
        for (var a in W)
          Object.prototype.hasOwnProperty.call(W, a) && (se[a] = W[a]);
      }
      return se;
    }, i = function(se, W) {
      var C = {};
      for (var g in se)
        Object.prototype.hasOwnProperty.call(se, g) && W.indexOf(g) < 0 && (C[g] = se[g]);
      if (se != null && typeof Object.getOwnPropertySymbols == "function")
        for (var a = 0, g = Object.getOwnPropertySymbols(se); a < g.length; a++)
          W.indexOf(g[a]) < 0 && Object.prototype.propertyIsEnumerable.call(se, g[a]) && (C[g[a]] = se[g[a]]);
      return C;
    }, s = function(se, W, C, g) {
      var a = arguments.length, c = a < 3 ? W : g === null ? g = Object.getOwnPropertyDescriptor(W, C) : g, p;
      if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
        c = Reflect.decorate(se, W, C, g);
      else
        for (var w = se.length - 1; w >= 0; w--)
          (p = se[w]) && (c = (a < 3 ? p(c) : a > 3 ? p(W, C, c) : p(W, C)) || c);
      return a > 3 && c && Object.defineProperty(W, C, c), c;
    }, n = function(se, W) {
      return function(C, g) {
        W(C, g, se);
      };
    }, f = function(se, W) {
      if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
        return Reflect.metadata(se, W);
    }, u = function(se, W, C, g) {
      function a(c) {
        return c instanceof C ? c : new C(function(p) {
          p(c);
        });
      }
      return new (C || (C = Promise))(function(c, p) {
        function w(E) {
          try {
            x(g.next(E));
          } catch (y) {
            p(y);
          }
        }
        function _(E) {
          try {
            x(g.throw(E));
          } catch (y) {
            p(y);
          }
        }
        function x(E) {
          E.done ? c(E.value) : a(E.value).then(w, _);
        }
        x((g = g.apply(se, W || [])).next());
      });
    }, h = function(se, W) {
      var C = { label: 0, sent: function() {
        if (c[0] & 1)
          throw c[1];
        return c[1];
      }, trys: [], ops: [] }, g, a, c, p;
      return p = { next: w(0), throw: w(1), return: w(2) }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
        return this;
      }), p;
      function w(x) {
        return function(E) {
          return _([x, E]);
        };
      }
      function _(x) {
        if (g)
          throw new TypeError("Generator is already executing.");
        for (; C; )
          try {
            if (g = 1, a && (c = x[0] & 2 ? a.return : x[0] ? a.throw || ((c = a.return) && c.call(a), 0) : a.next) && !(c = c.call(a, x[1])).done)
              return c;
            switch (a = 0, c && (x = [x[0] & 2, c.value]), x[0]) {
              case 0:
              case 1:
                c = x;
                break;
              case 4:
                return C.label++, { value: x[1], done: !1 };
              case 5:
                C.label++, a = x[1], x = [0];
                continue;
              case 7:
                x = C.ops.pop(), C.trys.pop();
                continue;
              default:
                if (c = C.trys, !(c = c.length > 0 && c[c.length - 1]) && (x[0] === 6 || x[0] === 2)) {
                  C = 0;
                  continue;
                }
                if (x[0] === 3 && (!c || x[1] > c[0] && x[1] < c[3])) {
                  C.label = x[1];
                  break;
                }
                if (x[0] === 6 && C.label < c[1]) {
                  C.label = c[1], c = x;
                  break;
                }
                if (c && C.label < c[2]) {
                  C.label = c[2], C.ops.push(x);
                  break;
                }
                c[2] && C.ops.pop(), C.trys.pop();
                continue;
            }
            x = W.call(se, C);
          } catch (E) {
            x = [6, E], a = 0;
          } finally {
            g = c = 0;
          }
        if (x[0] & 5)
          throw x[1];
        return { value: x[0] ? x[1] : void 0, done: !0 };
      }
    }, B = function(se, W, C, g) {
      g === void 0 && (g = C), se[g] = W[C];
    }, d = function(se, W) {
      for (var C in se)
        C !== "default" && !W.hasOwnProperty(C) && (W[C] = se[C]);
    }, l = function(se) {
      var W = typeof Symbol == "function" && Symbol.iterator, C = W && se[W], g = 0;
      if (C)
        return C.call(se);
      if (se && typeof se.length == "number")
        return {
          next: function() {
            return se && g >= se.length && (se = void 0), { value: se && se[g++], done: !se };
          }
        };
      throw new TypeError(W ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }, m = function(se, W) {
      var C = typeof Symbol == "function" && se[Symbol.iterator];
      if (!C)
        return se;
      var g = C.call(se), a, c = [], p;
      try {
        for (; (W === void 0 || W-- > 0) && !(a = g.next()).done; )
          c.push(a.value);
      } catch (w) {
        p = { error: w };
      } finally {
        try {
          a && !a.done && (C = g.return) && C.call(g);
        } finally {
          if (p)
            throw p.error;
        }
      }
      return c;
    }, b = function() {
      for (var se = [], W = 0; W < arguments.length; W++)
        se = se.concat(m(arguments[W]));
      return se;
    }, M = function() {
      for (var se = 0, W = 0, C = arguments.length; W < C; W++)
        se += arguments[W].length;
      for (var g = Array(se), a = 0, W = 0; W < C; W++)
        for (var c = arguments[W], p = 0, w = c.length; p < w; p++, a++)
          g[a] = c[p];
      return g;
    }, A = function(se) {
      return this instanceof A ? (this.v = se, this) : new A(se);
    }, N = function(se, W, C) {
      if (!Symbol.asyncIterator)
        throw new TypeError("Symbol.asyncIterator is not defined.");
      var g = C.apply(se, W || []), a, c = [];
      return a = {}, p("next"), p("throw"), p("return"), a[Symbol.asyncIterator] = function() {
        return this;
      }, a;
      function p(o) {
        g[o] && (a[o] = function(S) {
          return new Promise(function(J, z) {
            c.push([o, S, J, z]) > 1 || w(o, S);
          });
        });
      }
      function w(o, S) {
        try {
          _(g[o](S));
        } catch (J) {
          y(c[0][3], J);
        }
      }
      function _(o) {
        o.value instanceof A ? Promise.resolve(o.value.v).then(x, E) : y(c[0][2], o);
      }
      function x(o) {
        w("next", o);
      }
      function E(o) {
        w("throw", o);
      }
      function y(o, S) {
        o(S), c.shift(), c.length && w(c[0][0], c[0][1]);
      }
    }, R = function(se) {
      var W, C;
      return W = {}, g("next"), g("throw", function(a) {
        throw a;
      }), g("return"), W[Symbol.iterator] = function() {
        return this;
      }, W;
      function g(a, c) {
        W[a] = se[a] ? function(p) {
          return (C = !C) ? { value: A(se[a](p)), done: a === "return" } : c ? c(p) : p;
        } : c;
      }
    }, O = function(se) {
      if (!Symbol.asyncIterator)
        throw new TypeError("Symbol.asyncIterator is not defined.");
      var W = se[Symbol.asyncIterator], C;
      return W ? W.call(se) : (se = typeof l == "function" ? l(se) : se[Symbol.iterator](), C = {}, g("next"), g("throw"), g("return"), C[Symbol.asyncIterator] = function() {
        return this;
      }, C);
      function g(c) {
        C[c] = se[c] && function(p) {
          return new Promise(function(w, _) {
            p = se[c](p), a(w, _, p.done, p.value);
          });
        };
      }
      function a(c, p, w, _) {
        Promise.resolve(_).then(function(x) {
          c({ value: x, done: w });
        }, p);
      }
    }, P = function(se, W) {
      return Object.defineProperty ? Object.defineProperty(se, "raw", { value: W }) : se.raw = W, se;
    }, F = function(se) {
      if (se && se.__esModule)
        return se;
      var W = {};
      if (se != null)
        for (var C in se)
          Object.hasOwnProperty.call(se, C) && (W[C] = se[C]);
      return W.default = se, W;
    }, H = function(se) {
      return se && se.__esModule ? se : { default: se };
    }, Q = function(se, W) {
      if (!W.has(se))
        throw new TypeError("attempted to get private field on non-instance");
      return W.get(se);
    }, Z = function(se, W, C) {
      if (!W.has(se))
        throw new TypeError("attempted to set private field on non-instance");
      return W.set(se, C), C;
    }, Y("__extends", e), Y("__assign", r), Y("__rest", i), Y("__decorate", s), Y("__param", n), Y("__metadata", f), Y("__awaiter", u), Y("__generator", h), Y("__exportStar", d), Y("__createBinding", B), Y("__values", l), Y("__read", m), Y("__spread", b), Y("__spreadArrays", M), Y("__await", A), Y("__asyncGenerator", N), Y("__asyncDelegator", R), Y("__asyncValues", O), Y("__makeTemplateObject", P), Y("__importStar", F), Y("__importDefault", H), Y("__classPrivateFieldGet", Q), Y("__classPrivateFieldSet", Z);
  });
})(Yh);
var vg = {}, Pu = {}, P6;
function RZ() {
  if (P6)
    return Pu;
  P6 = 1, Object.defineProperty(Pu, "__esModule", { value: !0 }), Pu.delay = void 0;
  function t(e) {
    return new Promise((r) => {
      setTimeout(() => {
        r(!0);
      }, e);
    });
  }
  return Pu.delay = t, Pu;
}
var Po = {}, gg = {}, ko = {}, k6;
function LZ() {
  return k6 || (k6 = 1, Object.defineProperty(ko, "__esModule", { value: !0 }), ko.ONE_THOUSAND = ko.ONE_HUNDRED = void 0, ko.ONE_HUNDRED = 100, ko.ONE_THOUSAND = 1e3), ko;
}
var bg = {}, j6;
function PZ() {
  return j6 || (j6 = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.ONE_YEAR = t.FOUR_WEEKS = t.THREE_WEEKS = t.TWO_WEEKS = t.ONE_WEEK = t.THIRTY_DAYS = t.SEVEN_DAYS = t.FIVE_DAYS = t.THREE_DAYS = t.ONE_DAY = t.TWENTY_FOUR_HOURS = t.TWELVE_HOURS = t.SIX_HOURS = t.THREE_HOURS = t.ONE_HOUR = t.SIXTY_MINUTES = t.THIRTY_MINUTES = t.TEN_MINUTES = t.FIVE_MINUTES = t.ONE_MINUTE = t.SIXTY_SECONDS = t.THIRTY_SECONDS = t.TEN_SECONDS = t.FIVE_SECONDS = t.ONE_SECOND = void 0, t.ONE_SECOND = 1, t.FIVE_SECONDS = 5, t.TEN_SECONDS = 10, t.THIRTY_SECONDS = 30, t.SIXTY_SECONDS = 60, t.ONE_MINUTE = t.SIXTY_SECONDS, t.FIVE_MINUTES = t.ONE_MINUTE * 5, t.TEN_MINUTES = t.ONE_MINUTE * 10, t.THIRTY_MINUTES = t.ONE_MINUTE * 30, t.SIXTY_MINUTES = t.ONE_MINUTE * 60, t.ONE_HOUR = t.SIXTY_MINUTES, t.THREE_HOURS = t.ONE_HOUR * 3, t.SIX_HOURS = t.ONE_HOUR * 6, t.TWELVE_HOURS = t.ONE_HOUR * 12, t.TWENTY_FOUR_HOURS = t.ONE_HOUR * 24, t.ONE_DAY = t.TWENTY_FOUR_HOURS, t.THREE_DAYS = t.ONE_DAY * 3, t.FIVE_DAYS = t.ONE_DAY * 5, t.SEVEN_DAYS = t.ONE_DAY * 7, t.THIRTY_DAYS = t.ONE_DAY * 30, t.ONE_WEEK = t.SEVEN_DAYS, t.TWO_WEEKS = t.ONE_WEEK * 2, t.THREE_WEEKS = t.ONE_WEEK * 3, t.FOUR_WEEKS = t.ONE_WEEK * 4, t.ONE_YEAR = t.ONE_DAY * 365;
  }(bg)), bg;
}
var B6;
function nI() {
  return B6 || (B6 = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    const e = Yh.exports;
    e.__exportStar(LZ(), t), e.__exportStar(PZ(), t);
  }(gg)), gg;
}
var z6;
function kZ() {
  if (z6)
    return Po;
  z6 = 1, Object.defineProperty(Po, "__esModule", { value: !0 }), Po.fromMiliseconds = Po.toMiliseconds = void 0;
  const t = nI();
  function e(i) {
    return i * t.ONE_THOUSAND;
  }
  Po.toMiliseconds = e;
  function r(i) {
    return Math.floor(i / t.ONE_THOUSAND);
  }
  return Po.fromMiliseconds = r, Po;
}
var U6;
function jZ() {
  return U6 || (U6 = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    const e = Yh.exports;
    e.__exportStar(RZ(), t), e.__exportStar(kZ(), t);
  }(vg)), vg;
}
var Kf = {}, F6;
function BZ() {
  if (F6)
    return Kf;
  F6 = 1, Object.defineProperty(Kf, "__esModule", { value: !0 }), Kf.Watch = void 0;
  class t {
    constructor() {
      this.timestamps = /* @__PURE__ */ new Map();
    }
    start(r) {
      if (this.timestamps.has(r))
        throw new Error(`Watch already started for label: ${r}`);
      this.timestamps.set(r, { started: Date.now() });
    }
    stop(r) {
      const i = this.get(r);
      if (typeof i.elapsed < "u")
        throw new Error(`Watch already stopped for label: ${r}`);
      const s = Date.now() - i.started;
      this.timestamps.set(r, { started: i.started, elapsed: s });
    }
    get(r) {
      const i = this.timestamps.get(r);
      if (typeof i > "u")
        throw new Error(`No timestamp found for label: ${r}`);
      return i;
    }
    elapsed(r) {
      const i = this.get(r);
      return i.elapsed || Date.now() - i.started;
    }
  }
  return Kf.Watch = t, Kf.default = t, Kf;
}
var yg = {}, ku = {}, $6;
function zZ() {
  if ($6)
    return ku;
  $6 = 1, Object.defineProperty(ku, "__esModule", { value: !0 }), ku.IWatch = void 0;
  class t {
  }
  return ku.IWatch = t, ku;
}
var q6;
function UZ() {
  return q6 || (q6 = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), Yh.exports.__exportStar(zZ(), t);
  }(yg)), yg;
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  const e = Yh.exports;
  e.__exportStar(jZ(), t), e.__exportStar(BZ(), t), e.__exportStar(UZ(), t), e.__exportStar(nI(), t);
})(ct);
var Rr = {};
Object.defineProperty(Rr, "__esModule", { value: !0 });
Rr.getLocalStorage = Rr.getLocalStorageOrThrow = Rr.getCrypto = Rr.getCryptoOrThrow = sI = Rr.getLocation = Rr.getLocationOrThrow = ew = Rr.getNavigator = Rr.getNavigatorOrThrow = Qh = Rr.getDocument = Rr.getDocumentOrThrow = Rr.getFromWindowOrThrow = Rr.getFromWindow = void 0;
function mf(t) {
  let e;
  return typeof window < "u" && typeof window[t] < "u" && (e = window[t]), e;
}
Rr.getFromWindow = mf;
function Gc(t) {
  const e = mf(t);
  if (!e)
    throw new Error(`${t} is not defined in Window`);
  return e;
}
Rr.getFromWindowOrThrow = Gc;
function FZ() {
  return Gc("document");
}
Rr.getDocumentOrThrow = FZ;
function $Z() {
  return mf("document");
}
var Qh = Rr.getDocument = $Z;
function qZ() {
  return Gc("navigator");
}
Rr.getNavigatorOrThrow = qZ;
function HZ() {
  return mf("navigator");
}
var ew = Rr.getNavigator = HZ;
function WZ() {
  return Gc("location");
}
Rr.getLocationOrThrow = WZ;
function VZ() {
  return mf("location");
}
var sI = Rr.getLocation = VZ;
function GZ() {
  return Gc("crypto");
}
Rr.getCryptoOrThrow = GZ;
function KZ() {
  return mf("crypto");
}
Rr.getCrypto = KZ;
function YZ() {
  return Gc("localStorage");
}
Rr.getLocalStorageOrThrow = YZ;
function QZ() {
  return mf("localStorage");
}
Rr.getLocalStorage = QZ;
var tw = {};
Object.defineProperty(tw, "__esModule", { value: !0 });
var aI = tw.getWindowMetadata = void 0;
const H6 = Rr;
function ZZ() {
  let t, e;
  try {
    t = H6.getDocumentOrThrow(), e = H6.getLocationOrThrow();
  } catch {
    return null;
  }
  function r() {
    const m = t.getElementsByTagName("link"), b = [];
    for (let M = 0; M < m.length; M++) {
      const A = m[M], N = A.getAttribute("rel");
      if (N && N.toLowerCase().indexOf("icon") > -1) {
        const R = A.getAttribute("href");
        if (R)
          if (R.toLowerCase().indexOf("https:") === -1 && R.toLowerCase().indexOf("http:") === -1 && R.indexOf("//") !== 0) {
            let O = e.protocol + "//" + e.host;
            if (R.indexOf("/") === 0)
              O += R;
            else {
              const P = e.pathname.split("/");
              P.pop(), O += P.join("/") + "/" + R;
            }
            b.push(O);
          } else if (R.indexOf("//") === 0) {
            const O = e.protocol + R;
            b.push(O);
          } else
            b.push(R);
      }
    }
    return b;
  }
  function i(...m) {
    const b = t.getElementsByTagName("meta");
    for (let M = 0; M < b.length; M++) {
      const A = b[M], N = ["itemprop", "property", "name"].map((R) => A.getAttribute(R)).filter((R) => R ? m.includes(R) : !1);
      if (N.length && N) {
        const R = A.getAttribute("content");
        if (R)
          return R;
      }
    }
    return "";
  }
  function s() {
    let m = i("name", "og:site_name", "og:title", "twitter:title");
    return m || (m = t.title), m;
  }
  function n() {
    return i("description", "og:description", "twitter:description", "keywords");
  }
  const f = s(), u = n(), h = e.origin, d = r();
  return {
    description: u,
    url: h,
    icons: d,
    name: f
  };
}
aI = tw.getWindowMetadata = ZZ;
var yh = {}, JZ = (t) => encodeURIComponent(t).replace(/[!'()*]/g, (e) => `%${e.charCodeAt(0).toString(16).toUpperCase()}`), oI = "%[a-f0-9]{2}", W6 = new RegExp("(" + oI + ")|([^%]+?)", "gi"), V6 = new RegExp("(" + oI + ")+", "gi");
function _m(t, e) {
  try {
    return [decodeURIComponent(t.join(""))];
  } catch {
  }
  if (t.length === 1)
    return t;
  e = e || 1;
  var r = t.slice(0, e), i = t.slice(e);
  return Array.prototype.concat.call([], _m(r), _m(i));
}
function XZ(t) {
  try {
    return decodeURIComponent(t);
  } catch {
    for (var e = t.match(W6) || [], r = 1; r < e.length; r++)
      t = _m(e, r).join(""), e = t.match(W6) || [];
    return t;
  }
}
function eJ(t) {
  for (var e = {
    "%FE%FF": "\uFFFD\uFFFD",
    "%FF%FE": "\uFFFD\uFFFD"
  }, r = V6.exec(t); r; ) {
    try {
      e[r[0]] = decodeURIComponent(r[0]);
    } catch {
      var i = XZ(r[0]);
      i !== r[0] && (e[r[0]] = i);
    }
    r = V6.exec(t);
  }
  e["%C2"] = "\uFFFD";
  for (var s = Object.keys(e), n = 0; n < s.length; n++) {
    var f = s[n];
    t = t.replace(new RegExp(f, "g"), e[f]);
  }
  return t;
}
var tJ = function(t) {
  if (typeof t != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof t + "`");
  try {
    return t = t.replace(/\+/g, " "), decodeURIComponent(t);
  } catch {
    return eJ(t);
  }
}, rJ = (t, e) => {
  if (!(typeof t == "string" && typeof e == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (e === "")
    return [t];
  const r = t.indexOf(e);
  return r === -1 ? [t] : [
    t.slice(0, r),
    t.slice(r + e.length)
  ];
}, iJ = function(t, e) {
  for (var r = {}, i = Object.keys(t), s = Array.isArray(e), n = 0; n < i.length; n++) {
    var f = i[n], u = t[f];
    (s ? e.indexOf(f) !== -1 : e(f, u, t)) && (r[f] = u);
  }
  return r;
};
(function(t) {
  const e = JZ, r = tJ, i = rJ, s = iJ, n = (P) => P == null, f = Symbol("encodeFragmentIdentifier");
  function u(P) {
    switch (P.arrayFormat) {
      case "index":
        return (F) => (H, Q) => {
          const Z = H.length;
          return Q === void 0 || P.skipNull && Q === null || P.skipEmptyString && Q === "" ? H : Q === null ? [...H, [l(F, P), "[", Z, "]"].join("")] : [
            ...H,
            [l(F, P), "[", l(Z, P), "]=", l(Q, P)].join("")
          ];
        };
      case "bracket":
        return (F) => (H, Q) => Q === void 0 || P.skipNull && Q === null || P.skipEmptyString && Q === "" ? H : Q === null ? [...H, [l(F, P), "[]"].join("")] : [...H, [l(F, P), "[]=", l(Q, P)].join("")];
      case "colon-list-separator":
        return (F) => (H, Q) => Q === void 0 || P.skipNull && Q === null || P.skipEmptyString && Q === "" ? H : Q === null ? [...H, [l(F, P), ":list="].join("")] : [...H, [l(F, P), ":list=", l(Q, P)].join("")];
      case "comma":
      case "separator":
      case "bracket-separator": {
        const F = P.arrayFormat === "bracket-separator" ? "[]=" : "=";
        return (H) => (Q, Z) => Z === void 0 || P.skipNull && Z === null || P.skipEmptyString && Z === "" ? Q : (Z = Z === null ? "" : Z, Q.length === 0 ? [[l(H, P), F, l(Z, P)].join("")] : [[Q, l(Z, P)].join(P.arrayFormatSeparator)]);
      }
      default:
        return (F) => (H, Q) => Q === void 0 || P.skipNull && Q === null || P.skipEmptyString && Q === "" ? H : Q === null ? [...H, l(F, P)] : [...H, [l(F, P), "=", l(Q, P)].join("")];
    }
  }
  function h(P) {
    let F;
    switch (P.arrayFormat) {
      case "index":
        return (H, Q, Z) => {
          if (F = /\[(\d*)\]$/.exec(H), H = H.replace(/\[\d*\]$/, ""), !F) {
            Z[H] = Q;
            return;
          }
          Z[H] === void 0 && (Z[H] = {}), Z[H][F[1]] = Q;
        };
      case "bracket":
        return (H, Q, Z) => {
          if (F = /(\[\])$/.exec(H), H = H.replace(/\[\]$/, ""), !F) {
            Z[H] = Q;
            return;
          }
          if (Z[H] === void 0) {
            Z[H] = [Q];
            return;
          }
          Z[H] = [].concat(Z[H], Q);
        };
      case "colon-list-separator":
        return (H, Q, Z) => {
          if (F = /(:list)$/.exec(H), H = H.replace(/:list$/, ""), !F) {
            Z[H] = Q;
            return;
          }
          if (Z[H] === void 0) {
            Z[H] = [Q];
            return;
          }
          Z[H] = [].concat(Z[H], Q);
        };
      case "comma":
      case "separator":
        return (H, Q, Z) => {
          const B = typeof Q == "string" && Q.includes(P.arrayFormatSeparator), Y = typeof Q == "string" && !B && m(Q, P).includes(P.arrayFormatSeparator);
          Q = Y ? m(Q, P) : Q;
          const ae = B || Y ? Q.split(P.arrayFormatSeparator).map((se) => m(se, P)) : Q === null ? Q : m(Q, P);
          Z[H] = ae;
        };
      case "bracket-separator":
        return (H, Q, Z) => {
          const B = /(\[\])$/.test(H);
          if (H = H.replace(/\[\]$/, ""), !B) {
            Z[H] = Q && m(Q, P);
            return;
          }
          const Y = Q === null ? [] : Q.split(P.arrayFormatSeparator).map((ae) => m(ae, P));
          if (Z[H] === void 0) {
            Z[H] = Y;
            return;
          }
          Z[H] = [].concat(Z[H], Y);
        };
      default:
        return (H, Q, Z) => {
          if (Z[H] === void 0) {
            Z[H] = Q;
            return;
          }
          Z[H] = [].concat(Z[H], Q);
        };
    }
  }
  function d(P) {
    if (typeof P != "string" || P.length !== 1)
      throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function l(P, F) {
    return F.encode ? F.strict ? e(P) : encodeURIComponent(P) : P;
  }
  function m(P, F) {
    return F.decode ? r(P) : P;
  }
  function b(P) {
    return Array.isArray(P) ? P.sort() : typeof P == "object" ? b(Object.keys(P)).sort((F, H) => Number(F) - Number(H)).map((F) => P[F]) : P;
  }
  function M(P) {
    const F = P.indexOf("#");
    return F !== -1 && (P = P.slice(0, F)), P;
  }
  function A(P) {
    let F = "";
    const H = P.indexOf("#");
    return H !== -1 && (F = P.slice(H)), F;
  }
  function N(P) {
    P = M(P);
    const F = P.indexOf("?");
    return F === -1 ? "" : P.slice(F + 1);
  }
  function R(P, F) {
    return F.parseNumbers && !Number.isNaN(Number(P)) && typeof P == "string" && P.trim() !== "" ? P = Number(P) : F.parseBooleans && P !== null && (P.toLowerCase() === "true" || P.toLowerCase() === "false") && (P = P.toLowerCase() === "true"), P;
  }
  function O(P, F) {
    F = Object.assign({
      decode: !0,
      sort: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ",",
      parseNumbers: !1,
      parseBooleans: !1
    }, F), d(F.arrayFormatSeparator);
    const H = h(F), Q = /* @__PURE__ */ Object.create(null);
    if (typeof P != "string" || (P = P.trim().replace(/^[?#&]/, ""), !P))
      return Q;
    for (const Z of P.split("&")) {
      if (Z === "")
        continue;
      let [B, Y] = i(F.decode ? Z.replace(/\+/g, " ") : Z, "=");
      Y = Y === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(F.arrayFormat) ? Y : m(Y, F), H(m(B, F), Y, Q);
    }
    for (const Z of Object.keys(Q)) {
      const B = Q[Z];
      if (typeof B == "object" && B !== null)
        for (const Y of Object.keys(B))
          B[Y] = R(B[Y], F);
      else
        Q[Z] = R(B, F);
    }
    return F.sort === !1 ? Q : (F.sort === !0 ? Object.keys(Q).sort() : Object.keys(Q).sort(F.sort)).reduce((Z, B) => {
      const Y = Q[B];
      return Boolean(Y) && typeof Y == "object" && !Array.isArray(Y) ? Z[B] = b(Y) : Z[B] = Y, Z;
    }, /* @__PURE__ */ Object.create(null));
  }
  t.extract = N, t.parse = O, t.stringify = (P, F) => {
    if (!P)
      return "";
    F = Object.assign({
      encode: !0,
      strict: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ","
    }, F), d(F.arrayFormatSeparator);
    const H = (Y) => F.skipNull && n(P[Y]) || F.skipEmptyString && P[Y] === "", Q = u(F), Z = {};
    for (const Y of Object.keys(P))
      H(Y) || (Z[Y] = P[Y]);
    const B = Object.keys(Z);
    return F.sort !== !1 && B.sort(F.sort), B.map((Y) => {
      const ae = P[Y];
      return ae === void 0 ? "" : ae === null ? l(Y, F) : Array.isArray(ae) ? ae.length === 0 && F.arrayFormat === "bracket-separator" ? l(Y, F) + "[]" : ae.reduce(Q(Y), []).join("&") : l(Y, F) + "=" + l(ae, F);
    }).filter((Y) => Y.length > 0).join("&");
  }, t.parseUrl = (P, F) => {
    F = Object.assign({
      decode: !0
    }, F);
    const [H, Q] = i(P, "#");
    return Object.assign(
      {
        url: H.split("?")[0] || "",
        query: O(N(P), F)
      },
      F && F.parseFragmentIdentifier && Q ? { fragmentIdentifier: m(Q, F) } : {}
    );
  }, t.stringifyUrl = (P, F) => {
    F = Object.assign({
      encode: !0,
      strict: !0,
      [f]: !0
    }, F);
    const H = M(P.url).split("?")[0] || "", Q = t.extract(P.url), Z = t.parse(Q, { sort: !1 }), B = Object.assign(Z, P.query);
    let Y = t.stringify(B, F);
    Y && (Y = `?${Y}`);
    let ae = A(P.url);
    return P.fragmentIdentifier && (ae = `#${F[f] ? l(P.fragmentIdentifier, F) : P.fragmentIdentifier}`), `${H}${Y}${ae}`;
  }, t.pick = (P, F, H) => {
    H = Object.assign({
      parseFragmentIdentifier: !0,
      [f]: !1
    }, H);
    const { url: Q, query: Z, fragmentIdentifier: B } = t.parseUrl(P, H);
    return t.stringifyUrl({
      url: Q,
      query: s(Z, F),
      fragmentIdentifier: B
    }, H);
  }, t.exclude = (P, F, H) => {
    const Q = Array.isArray(F) ? (Z) => !F.includes(Z) : (Z, B) => !F(Z, B);
    return t.pick(P, Q, H);
  };
})(yh);
var fI = { exports: {} };
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */
(function(t) {
  (function() {
    var e = "input is invalid type", r = "finalize already called", i = typeof window == "object", s = i ? window : {};
    s.JS_SHA3_NO_WINDOW && (i = !1);
    var n = !i && typeof self == "object", f = !s.JS_SHA3_NO_NODE_JS && typeof process == "object" && process.versions && process.versions.node;
    f ? s = nt : n && (s = self);
    var u = !s.JS_SHA3_NO_COMMON_JS && !0 && t.exports, h = !s.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", d = "0123456789abcdef".split(""), l = [31, 7936, 2031616, 520093696], m = [4, 1024, 262144, 67108864], b = [1, 256, 65536, 16777216], M = [6, 1536, 393216, 100663296], A = [0, 8, 16, 24], N = [
      1,
      0,
      32898,
      0,
      32906,
      2147483648,
      2147516416,
      2147483648,
      32907,
      0,
      2147483649,
      0,
      2147516545,
      2147483648,
      32777,
      2147483648,
      138,
      0,
      136,
      0,
      2147516425,
      0,
      2147483658,
      0,
      2147516555,
      0,
      139,
      2147483648,
      32905,
      2147483648,
      32771,
      2147483648,
      32770,
      2147483648,
      128,
      2147483648,
      32778,
      0,
      2147483658,
      2147483648,
      2147516545,
      2147483648,
      32896,
      2147483648,
      2147483649,
      0,
      2147516424,
      2147483648
    ], R = [224, 256, 384, 512], O = [128, 256], P = ["hex", "buffer", "arrayBuffer", "array", "digest"], F = {
      128: 168,
      256: 136
    };
    (s.JS_SHA3_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(z) {
      return Object.prototype.toString.call(z) === "[object Array]";
    }), h && (s.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(z) {
      return typeof z == "object" && z.buffer && z.buffer.constructor === ArrayBuffer;
    });
    for (var H = function(z, k, j) {
      return function(q) {
        return new o(z, k, z).update(q)[j]();
      };
    }, Q = function(z, k, j) {
      return function(q, K) {
        return new o(z, k, K).update(q)[j]();
      };
    }, Z = function(z, k, j) {
      return function(q, K, U, T) {
        return a["cshake" + z].update(q, K, U, T)[j]();
      };
    }, B = function(z, k, j) {
      return function(q, K, U, T) {
        return a["kmac" + z].update(q, K, U, T)[j]();
      };
    }, Y = function(z, k, j, q) {
      for (var K = 0; K < P.length; ++K) {
        var U = P[K];
        z[U] = k(j, q, U);
      }
      return z;
    }, ae = function(z, k) {
      var j = H(z, k, "hex");
      return j.create = function() {
        return new o(z, k, z);
      }, j.update = function(q) {
        return j.create().update(q);
      }, Y(j, H, z, k);
    }, se = function(z, k) {
      var j = Q(z, k, "hex");
      return j.create = function(q) {
        return new o(z, k, q);
      }, j.update = function(q, K) {
        return j.create(K).update(q);
      }, Y(j, Q, z, k);
    }, W = function(z, k) {
      var j = F[z], q = Z(z, k, "hex");
      return q.create = function(K, U, T) {
        return !U && !T ? a["shake" + z].create(K) : new o(z, k, K).bytepad([U, T], j);
      }, q.update = function(K, U, T, D) {
        return q.create(U, T, D).update(K);
      }, Y(q, Z, z, k);
    }, C = function(z, k) {
      var j = F[z], q = B(z, k, "hex");
      return q.create = function(K, U, T) {
        return new S(z, k, U).bytepad(["KMAC", T], j).bytepad([K], j);
      }, q.update = function(K, U, T, D) {
        return q.create(K, T, D).update(U);
      }, Y(q, B, z, k);
    }, g = [
      { name: "keccak", padding: b, bits: R, createMethod: ae },
      { name: "sha3", padding: M, bits: R, createMethod: ae },
      { name: "shake", padding: l, bits: O, createMethod: se },
      { name: "cshake", padding: m, bits: O, createMethod: W },
      { name: "kmac", padding: m, bits: O, createMethod: C }
    ], a = {}, c = [], p = 0; p < g.length; ++p)
      for (var w = g[p], _ = w.bits, x = 0; x < _.length; ++x) {
        var E = w.name + "_" + _[x];
        if (c.push(E), a[E] = w.createMethod(_[x], w.padding), w.name !== "sha3") {
          var y = w.name + _[x];
          c.push(y), a[y] = a[E];
        }
      }
    function o(z, k, j) {
      this.blocks = [], this.s = [], this.padding = k, this.outputBits = j, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (z << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = j >> 5, this.extraBytes = (j & 31) >> 3;
      for (var q = 0; q < 50; ++q)
        this.s[q] = 0;
    }
    o.prototype.update = function(z) {
      if (this.finalized)
        throw new Error(r);
      var k, j = typeof z;
      if (j !== "string") {
        if (j === "object") {
          if (z === null)
            throw new Error(e);
          if (h && z.constructor === ArrayBuffer)
            z = new Uint8Array(z);
          else if (!Array.isArray(z) && (!h || !ArrayBuffer.isView(z)))
            throw new Error(e);
        } else
          throw new Error(e);
        k = !0;
      }
      for (var q = this.blocks, K = this.byteCount, U = z.length, T = this.blockCount, D = 0, te = this.s, ne, le; D < U; ) {
        if (this.reset)
          for (this.reset = !1, q[0] = this.block, ne = 1; ne < T + 1; ++ne)
            q[ne] = 0;
        if (k)
          for (ne = this.start; D < U && ne < K; ++D)
            q[ne >> 2] |= z[D] << A[ne++ & 3];
        else
          for (ne = this.start; D < U && ne < K; ++D)
            le = z.charCodeAt(D), le < 128 ? q[ne >> 2] |= le << A[ne++ & 3] : le < 2048 ? (q[ne >> 2] |= (192 | le >> 6) << A[ne++ & 3], q[ne >> 2] |= (128 | le & 63) << A[ne++ & 3]) : le < 55296 || le >= 57344 ? (q[ne >> 2] |= (224 | le >> 12) << A[ne++ & 3], q[ne >> 2] |= (128 | le >> 6 & 63) << A[ne++ & 3], q[ne >> 2] |= (128 | le & 63) << A[ne++ & 3]) : (le = 65536 + ((le & 1023) << 10 | z.charCodeAt(++D) & 1023), q[ne >> 2] |= (240 | le >> 18) << A[ne++ & 3], q[ne >> 2] |= (128 | le >> 12 & 63) << A[ne++ & 3], q[ne >> 2] |= (128 | le >> 6 & 63) << A[ne++ & 3], q[ne >> 2] |= (128 | le & 63) << A[ne++ & 3]);
        if (this.lastByteIndex = ne, ne >= K) {
          for (this.start = ne - K, this.block = q[T], ne = 0; ne < T; ++ne)
            te[ne] ^= q[ne];
          J(te), this.reset = !0;
        } else
          this.start = ne;
      }
      return this;
    }, o.prototype.encode = function(z, k) {
      var j = z & 255, q = 1, K = [j];
      for (z = z >> 8, j = z & 255; j > 0; )
        K.unshift(j), z = z >> 8, j = z & 255, ++q;
      return k ? K.push(q) : K.unshift(q), this.update(K), K.length;
    }, o.prototype.encodeString = function(z) {
      var k, j = typeof z;
      if (j !== "string") {
        if (j === "object") {
          if (z === null)
            throw new Error(e);
          if (h && z.constructor === ArrayBuffer)
            z = new Uint8Array(z);
          else if (!Array.isArray(z) && (!h || !ArrayBuffer.isView(z)))
            throw new Error(e);
        } else
          throw new Error(e);
        k = !0;
      }
      var q = 0, K = z.length;
      if (k)
        q = K;
      else
        for (var U = 0; U < z.length; ++U) {
          var T = z.charCodeAt(U);
          T < 128 ? q += 1 : T < 2048 ? q += 2 : T < 55296 || T >= 57344 ? q += 3 : (T = 65536 + ((T & 1023) << 10 | z.charCodeAt(++U) & 1023), q += 4);
        }
      return q += this.encode(q * 8), this.update(z), q;
    }, o.prototype.bytepad = function(z, k) {
      for (var j = this.encode(k), q = 0; q < z.length; ++q)
        j += this.encodeString(z[q]);
      var K = k - j % k, U = [];
      return U.length = K, this.update(U), this;
    }, o.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var z = this.blocks, k = this.lastByteIndex, j = this.blockCount, q = this.s;
        if (z[k >> 2] |= this.padding[k & 3], this.lastByteIndex === this.byteCount)
          for (z[0] = z[j], k = 1; k < j + 1; ++k)
            z[k] = 0;
        for (z[j - 1] |= 2147483648, k = 0; k < j; ++k)
          q[k] ^= z[k];
        J(q);
      }
    }, o.prototype.toString = o.prototype.hex = function() {
      this.finalize();
      for (var z = this.blockCount, k = this.s, j = this.outputBlocks, q = this.extraBytes, K = 0, U = 0, T = "", D; U < j; ) {
        for (K = 0; K < z && U < j; ++K, ++U)
          D = k[K], T += d[D >> 4 & 15] + d[D & 15] + d[D >> 12 & 15] + d[D >> 8 & 15] + d[D >> 20 & 15] + d[D >> 16 & 15] + d[D >> 28 & 15] + d[D >> 24 & 15];
        U % z === 0 && (J(k), K = 0);
      }
      return q && (D = k[K], T += d[D >> 4 & 15] + d[D & 15], q > 1 && (T += d[D >> 12 & 15] + d[D >> 8 & 15]), q > 2 && (T += d[D >> 20 & 15] + d[D >> 16 & 15])), T;
    }, o.prototype.arrayBuffer = function() {
      this.finalize();
      var z = this.blockCount, k = this.s, j = this.outputBlocks, q = this.extraBytes, K = 0, U = 0, T = this.outputBits >> 3, D;
      q ? D = new ArrayBuffer(j + 1 << 2) : D = new ArrayBuffer(T);
      for (var te = new Uint32Array(D); U < j; ) {
        for (K = 0; K < z && U < j; ++K, ++U)
          te[U] = k[K];
        U % z === 0 && J(k);
      }
      return q && (te[K] = k[K], D = D.slice(0, T)), D;
    }, o.prototype.buffer = o.prototype.arrayBuffer, o.prototype.digest = o.prototype.array = function() {
      this.finalize();
      for (var z = this.blockCount, k = this.s, j = this.outputBlocks, q = this.extraBytes, K = 0, U = 0, T = [], D, te; U < j; ) {
        for (K = 0; K < z && U < j; ++K, ++U)
          D = U << 2, te = k[K], T[D] = te & 255, T[D + 1] = te >> 8 & 255, T[D + 2] = te >> 16 & 255, T[D + 3] = te >> 24 & 255;
        U % z === 0 && J(k);
      }
      return q && (D = U << 2, te = k[K], T[D] = te & 255, q > 1 && (T[D + 1] = te >> 8 & 255), q > 2 && (T[D + 2] = te >> 16 & 255)), T;
    };
    function S(z, k, j) {
      o.call(this, z, k, j);
    }
    S.prototype = new o(), S.prototype.finalize = function() {
      return this.encode(this.outputBits, !0), o.prototype.finalize.call(this);
    };
    var J = function(z) {
      var k, j, q, K, U, T, D, te, ne, le, X, $, V, re, fe, ue, me, be, ve, Ge, ye, pe, Je, Ie, we, at, Oe, Ee, ft, Le, Pe, Mt, Ve, ke, Et, Ke, Be, dt, ze, Te, pt, Fe, Ae, bt, He, Ne, yt, $e, De, vt, je, Ce, mt, Ze, qe, Dt, We, Qe, Qt, Zt, Jt, Xt, kt;
      for (q = 0; q < 48; q += 2)
        K = z[0] ^ z[10] ^ z[20] ^ z[30] ^ z[40], U = z[1] ^ z[11] ^ z[21] ^ z[31] ^ z[41], T = z[2] ^ z[12] ^ z[22] ^ z[32] ^ z[42], D = z[3] ^ z[13] ^ z[23] ^ z[33] ^ z[43], te = z[4] ^ z[14] ^ z[24] ^ z[34] ^ z[44], ne = z[5] ^ z[15] ^ z[25] ^ z[35] ^ z[45], le = z[6] ^ z[16] ^ z[26] ^ z[36] ^ z[46], X = z[7] ^ z[17] ^ z[27] ^ z[37] ^ z[47], $ = z[8] ^ z[18] ^ z[28] ^ z[38] ^ z[48], V = z[9] ^ z[19] ^ z[29] ^ z[39] ^ z[49], k = $ ^ (T << 1 | D >>> 31), j = V ^ (D << 1 | T >>> 31), z[0] ^= k, z[1] ^= j, z[10] ^= k, z[11] ^= j, z[20] ^= k, z[21] ^= j, z[30] ^= k, z[31] ^= j, z[40] ^= k, z[41] ^= j, k = K ^ (te << 1 | ne >>> 31), j = U ^ (ne << 1 | te >>> 31), z[2] ^= k, z[3] ^= j, z[12] ^= k, z[13] ^= j, z[22] ^= k, z[23] ^= j, z[32] ^= k, z[33] ^= j, z[42] ^= k, z[43] ^= j, k = T ^ (le << 1 | X >>> 31), j = D ^ (X << 1 | le >>> 31), z[4] ^= k, z[5] ^= j, z[14] ^= k, z[15] ^= j, z[24] ^= k, z[25] ^= j, z[34] ^= k, z[35] ^= j, z[44] ^= k, z[45] ^= j, k = te ^ ($ << 1 | V >>> 31), j = ne ^ (V << 1 | $ >>> 31), z[6] ^= k, z[7] ^= j, z[16] ^= k, z[17] ^= j, z[26] ^= k, z[27] ^= j, z[36] ^= k, z[37] ^= j, z[46] ^= k, z[47] ^= j, k = le ^ (K << 1 | U >>> 31), j = X ^ (U << 1 | K >>> 31), z[8] ^= k, z[9] ^= j, z[18] ^= k, z[19] ^= j, z[28] ^= k, z[29] ^= j, z[38] ^= k, z[39] ^= j, z[48] ^= k, z[49] ^= j, re = z[0], fe = z[1], Ne = z[11] << 4 | z[10] >>> 28, yt = z[10] << 4 | z[11] >>> 28, Ee = z[20] << 3 | z[21] >>> 29, ft = z[21] << 3 | z[20] >>> 29, Zt = z[31] << 9 | z[30] >>> 23, Jt = z[30] << 9 | z[31] >>> 23, Fe = z[40] << 18 | z[41] >>> 14, Ae = z[41] << 18 | z[40] >>> 14, ke = z[2] << 1 | z[3] >>> 31, Et = z[3] << 1 | z[2] >>> 31, ue = z[13] << 12 | z[12] >>> 20, me = z[12] << 12 | z[13] >>> 20, $e = z[22] << 10 | z[23] >>> 22, De = z[23] << 10 | z[22] >>> 22, Le = z[33] << 13 | z[32] >>> 19, Pe = z[32] << 13 | z[33] >>> 19, Xt = z[42] << 2 | z[43] >>> 30, kt = z[43] << 2 | z[42] >>> 30, Ze = z[5] << 30 | z[4] >>> 2, qe = z[4] << 30 | z[5] >>> 2, Ke = z[14] << 6 | z[15] >>> 26, Be = z[15] << 6 | z[14] >>> 26, be = z[25] << 11 | z[24] >>> 21, ve = z[24] << 11 | z[25] >>> 21, vt = z[34] << 15 | z[35] >>> 17, je = z[35] << 15 | z[34] >>> 17, Mt = z[45] << 29 | z[44] >>> 3, Ve = z[44] << 29 | z[45] >>> 3, Ie = z[6] << 28 | z[7] >>> 4, we = z[7] << 28 | z[6] >>> 4, Dt = z[17] << 23 | z[16] >>> 9, We = z[16] << 23 | z[17] >>> 9, dt = z[26] << 25 | z[27] >>> 7, ze = z[27] << 25 | z[26] >>> 7, Ge = z[36] << 21 | z[37] >>> 11, ye = z[37] << 21 | z[36] >>> 11, Ce = z[47] << 24 | z[46] >>> 8, mt = z[46] << 24 | z[47] >>> 8, bt = z[8] << 27 | z[9] >>> 5, He = z[9] << 27 | z[8] >>> 5, at = z[18] << 20 | z[19] >>> 12, Oe = z[19] << 20 | z[18] >>> 12, Qe = z[29] << 7 | z[28] >>> 25, Qt = z[28] << 7 | z[29] >>> 25, Te = z[38] << 8 | z[39] >>> 24, pt = z[39] << 8 | z[38] >>> 24, pe = z[48] << 14 | z[49] >>> 18, Je = z[49] << 14 | z[48] >>> 18, z[0] = re ^ ~ue & be, z[1] = fe ^ ~me & ve, z[10] = Ie ^ ~at & Ee, z[11] = we ^ ~Oe & ft, z[20] = ke ^ ~Ke & dt, z[21] = Et ^ ~Be & ze, z[30] = bt ^ ~Ne & $e, z[31] = He ^ ~yt & De, z[40] = Ze ^ ~Dt & Qe, z[41] = qe ^ ~We & Qt, z[2] = ue ^ ~be & Ge, z[3] = me ^ ~ve & ye, z[12] = at ^ ~Ee & Le, z[13] = Oe ^ ~ft & Pe, z[22] = Ke ^ ~dt & Te, z[23] = Be ^ ~ze & pt, z[32] = Ne ^ ~$e & vt, z[33] = yt ^ ~De & je, z[42] = Dt ^ ~Qe & Zt, z[43] = We ^ ~Qt & Jt, z[4] = be ^ ~Ge & pe, z[5] = ve ^ ~ye & Je, z[14] = Ee ^ ~Le & Mt, z[15] = ft ^ ~Pe & Ve, z[24] = dt ^ ~Te & Fe, z[25] = ze ^ ~pt & Ae, z[34] = $e ^ ~vt & Ce, z[35] = De ^ ~je & mt, z[44] = Qe ^ ~Zt & Xt, z[45] = Qt ^ ~Jt & kt, z[6] = Ge ^ ~pe & re, z[7] = ye ^ ~Je & fe, z[16] = Le ^ ~Mt & Ie, z[17] = Pe ^ ~Ve & we, z[26] = Te ^ ~Fe & ke, z[27] = pt ^ ~Ae & Et, z[36] = vt ^ ~Ce & bt, z[37] = je ^ ~mt & He, z[46] = Zt ^ ~Xt & Ze, z[47] = Jt ^ ~kt & qe, z[8] = pe ^ ~re & ue, z[9] = Je ^ ~fe & me, z[18] = Mt ^ ~Ie & at, z[19] = Ve ^ ~we & Oe, z[28] = Fe ^ ~ke & Ke, z[29] = Ae ^ ~Et & Be, z[38] = Ce ^ ~bt & Ne, z[39] = mt ^ ~He & yt, z[48] = Xt ^ ~Ze & Dt, z[49] = kt ^ ~qe & We, z[0] ^= N[q], z[1] ^= N[q + 1];
    };
    if (u)
      t.exports = a;
    else
      for (p = 0; p < c.length; ++p)
        s[c[p]] = a[c[p]];
  })();
})(fI);
const nJ = fI.exports, sJ = "logger/5.7.0";
let G6 = !1, K6 = !1;
const Jd = { debug: 1, default: 2, info: 2, warning: 3, error: 4, off: 5 };
let Y6 = Jd.default, mg = null;
function aJ() {
  try {
    const t = [];
    if (["NFD", "NFC", "NFKD", "NFKC"].forEach((e) => {
      try {
        if ("test".normalize(e) !== "test")
          throw new Error("bad normalize");
      } catch {
        t.push(e);
      }
    }), t.length)
      throw new Error("missing " + t.join(", "));
    if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769))
      throw new Error("broken implementation");
  } catch (t) {
    return t.message;
  }
  return null;
}
const Q6 = aJ();
var Mm;
(function(t) {
  t.DEBUG = "DEBUG", t.INFO = "INFO", t.WARNING = "WARNING", t.ERROR = "ERROR", t.OFF = "OFF";
})(Mm || (Mm = {}));
var Ms;
(function(t) {
  t.UNKNOWN_ERROR = "UNKNOWN_ERROR", t.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", t.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", t.NETWORK_ERROR = "NETWORK_ERROR", t.SERVER_ERROR = "SERVER_ERROR", t.TIMEOUT = "TIMEOUT", t.BUFFER_OVERRUN = "BUFFER_OVERRUN", t.NUMERIC_FAULT = "NUMERIC_FAULT", t.MISSING_NEW = "MISSING_NEW", t.INVALID_ARGUMENT = "INVALID_ARGUMENT", t.MISSING_ARGUMENT = "MISSING_ARGUMENT", t.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", t.CALL_EXCEPTION = "CALL_EXCEPTION", t.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", t.NONCE_EXPIRED = "NONCE_EXPIRED", t.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", t.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", t.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", t.ACTION_REJECTED = "ACTION_REJECTED";
})(Ms || (Ms = {}));
const Z6 = "0123456789abcdef";
class Mr {
  constructor(e) {
    Object.defineProperty(this, "version", {
      enumerable: !0,
      value: e,
      writable: !1
    });
  }
  _log(e, r) {
    const i = e.toLowerCase();
    Jd[i] == null && this.throwArgumentError("invalid log level name", "logLevel", e), !(Y6 > Jd[i]) && console.log.apply(console, r);
  }
  debug(...e) {
    this._log(Mr.levels.DEBUG, e);
  }
  info(...e) {
    this._log(Mr.levels.INFO, e);
  }
  warn(...e) {
    this._log(Mr.levels.WARNING, e);
  }
  makeError(e, r, i) {
    if (K6)
      return this.makeError("censored error", r, {});
    r || (r = Mr.errors.UNKNOWN_ERROR), i || (i = {});
    const s = [];
    Object.keys(i).forEach((h) => {
      const d = i[h];
      try {
        if (d instanceof Uint8Array) {
          let l = "";
          for (let m = 0; m < d.length; m++)
            l += Z6[d[m] >> 4], l += Z6[d[m] & 15];
          s.push(h + "=Uint8Array(0x" + l + ")");
        } else
          s.push(h + "=" + JSON.stringify(d));
      } catch {
        s.push(h + "=" + JSON.stringify(i[h].toString()));
      }
    }), s.push(`code=${r}`), s.push(`version=${this.version}`);
    const n = e;
    let f = "";
    switch (r) {
      case Ms.NUMERIC_FAULT: {
        f = "NUMERIC_FAULT";
        const h = e;
        switch (h) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            f += "-" + h;
            break;
          case "negative-power":
          case "negative-width":
            f += "-unsupported";
            break;
          case "unbound-bitwise-result":
            f += "-unbound-result";
            break;
        }
        break;
      }
      case Ms.CALL_EXCEPTION:
      case Ms.INSUFFICIENT_FUNDS:
      case Ms.MISSING_NEW:
      case Ms.NONCE_EXPIRED:
      case Ms.REPLACEMENT_UNDERPRICED:
      case Ms.TRANSACTION_REPLACED:
      case Ms.UNPREDICTABLE_GAS_LIMIT:
        f = r;
        break;
    }
    f && (e += " [ See: https://links.ethers.org/v5-errors-" + f + " ]"), s.length && (e += " (" + s.join(", ") + ")");
    const u = new Error(e);
    return u.reason = n, u.code = r, Object.keys(i).forEach(function(h) {
      u[h] = i[h];
    }), u;
  }
  throwError(e, r, i) {
    throw this.makeError(e, r, i);
  }
  throwArgumentError(e, r, i) {
    return this.throwError(e, Mr.errors.INVALID_ARGUMENT, {
      argument: r,
      value: i
    });
  }
  assert(e, r, i, s) {
    e || this.throwError(r, i, s);
  }
  assertArgument(e, r, i, s) {
    e || this.throwArgumentError(r, i, s);
  }
  checkNormalize(e) {
    Q6 && this.throwError("platform missing String.prototype.normalize", Mr.errors.UNSUPPORTED_OPERATION, {
      operation: "String.prototype.normalize",
      form: Q6
    });
  }
  checkSafeUint53(e, r) {
    typeof e == "number" && (r == null && (r = "value not safe"), (e < 0 || e >= 9007199254740991) && this.throwError(r, Mr.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "out-of-safe-range",
      value: e
    }), e % 1 && this.throwError(r, Mr.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "non-integer",
      value: e
    }));
  }
  checkArgumentCount(e, r, i) {
    i ? i = ": " + i : i = "", e < r && this.throwError("missing argument" + i, Mr.errors.MISSING_ARGUMENT, {
      count: e,
      expectedCount: r
    }), e > r && this.throwError("too many arguments" + i, Mr.errors.UNEXPECTED_ARGUMENT, {
      count: e,
      expectedCount: r
    });
  }
  checkNew(e, r) {
    (e === Object || e == null) && this.throwError("missing new", Mr.errors.MISSING_NEW, { name: r.name });
  }
  checkAbstract(e, r) {
    e === r ? this.throwError("cannot instantiate abstract class " + JSON.stringify(r.name) + " directly; use a sub-class", Mr.errors.UNSUPPORTED_OPERATION, { name: e.name, operation: "new" }) : (e === Object || e == null) && this.throwError("missing new", Mr.errors.MISSING_NEW, { name: r.name });
  }
  static globalLogger() {
    return mg || (mg = new Mr(sJ)), mg;
  }
  static setCensorship(e, r) {
    if (!e && r && this.globalLogger().throwError("cannot permanently disable censorship", Mr.errors.UNSUPPORTED_OPERATION, {
      operation: "setCensorship"
    }), G6) {
      if (!e)
        return;
      this.globalLogger().throwError("error censorship permanent", Mr.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    K6 = !!e, G6 = !!r;
  }
  static setLogLevel(e) {
    const r = Jd[e.toLowerCase()];
    if (r == null) {
      Mr.globalLogger().warn("invalid log level - " + e);
      return;
    }
    Y6 = r;
  }
  static from(e) {
    return new Mr(e);
  }
}
Mr.errors = Ms;
Mr.levels = Mm;
const oJ = "bytes/5.7.0", ri = new Mr(oJ);
function cI(t) {
  return !!t.toHexString;
}
function lc(t) {
  return t.slice || (t.slice = function() {
    const e = Array.prototype.slice.call(arguments);
    return lc(new Uint8Array(Array.prototype.slice.apply(t, e)));
  }), t;
}
function fJ(t) {
  return Zs(t) && !(t.length % 2) || rw(t);
}
function J6(t) {
  return typeof t == "number" && t == t && t % 1 === 0;
}
function rw(t) {
  if (t == null)
    return !1;
  if (t.constructor === Uint8Array)
    return !0;
  if (typeof t == "string" || !J6(t.length) || t.length < 0)
    return !1;
  for (let e = 0; e < t.length; e++) {
    const r = t[e];
    if (!J6(r) || r < 0 || r >= 256)
      return !1;
  }
  return !0;
}
function ai(t, e) {
  if (e || (e = {}), typeof t == "number") {
    ri.checkSafeUint53(t, "invalid arrayify value");
    const r = [];
    for (; t; )
      r.unshift(t & 255), t = parseInt(String(t / 256));
    return r.length === 0 && r.push(0), lc(new Uint8Array(r));
  }
  if (e.allowMissingPrefix && typeof t == "string" && t.substring(0, 2) !== "0x" && (t = "0x" + t), cI(t) && (t = t.toHexString()), Zs(t)) {
    let r = t.substring(2);
    r.length % 2 && (e.hexPad === "left" ? r = "0" + r : e.hexPad === "right" ? r += "0" : ri.throwArgumentError("hex data is odd-length", "value", t));
    const i = [];
    for (let s = 0; s < r.length; s += 2)
      i.push(parseInt(r.substring(s, s + 2), 16));
    return lc(new Uint8Array(i));
  }
  return rw(t) ? lc(new Uint8Array(t)) : ri.throwArgumentError("invalid arrayify value", "value", t);
}
function cJ(t) {
  const e = t.map((s) => ai(s)), r = e.reduce((s, n) => s + n.length, 0), i = new Uint8Array(r);
  return e.reduce((s, n) => (i.set(n, s), s + n.length), 0), lc(i);
}
function uJ(t, e) {
  t = ai(t), t.length > e && ri.throwArgumentError("value out of range", "value", arguments[0]);
  const r = new Uint8Array(e);
  return r.set(t, e - t.length), lc(r);
}
function Zs(t, e) {
  return !(typeof t != "string" || !t.match(/^0x[0-9A-Fa-f]*$/) || e && t.length !== 2 + 2 * e);
}
const wg = "0123456789abcdef";
function cn(t, e) {
  if (e || (e = {}), typeof t == "number") {
    ri.checkSafeUint53(t, "invalid hexlify value");
    let r = "";
    for (; t; )
      r = wg[t & 15] + r, t = Math.floor(t / 16);
    return r.length ? (r.length % 2 && (r = "0" + r), "0x" + r) : "0x00";
  }
  if (typeof t == "bigint")
    return t = t.toString(16), t.length % 2 ? "0x0" + t : "0x" + t;
  if (e.allowMissingPrefix && typeof t == "string" && t.substring(0, 2) !== "0x" && (t = "0x" + t), cI(t))
    return t.toHexString();
  if (Zs(t))
    return t.length % 2 && (e.hexPad === "left" ? t = "0x0" + t.substring(2) : e.hexPad === "right" ? t += "0" : ri.throwArgumentError("hex data is odd-length", "value", t)), t.toLowerCase();
  if (rw(t)) {
    let r = "0x";
    for (let i = 0; i < t.length; i++) {
      let s = t[i];
      r += wg[(s & 240) >> 4] + wg[s & 15];
    }
    return r;
  }
  return ri.throwArgumentError("invalid hexlify value", "value", t);
}
function hJ(t) {
  if (typeof t != "string")
    t = cn(t);
  else if (!Zs(t) || t.length % 2)
    return null;
  return (t.length - 2) / 2;
}
function X6(t, e, r) {
  return typeof t != "string" ? t = cn(t) : (!Zs(t) || t.length % 2) && ri.throwArgumentError("invalid hexData", "value", t), e = 2 + 2 * e, r != null ? "0x" + t.substring(e, 2 + 2 * r) : "0x" + t.substring(e);
}
function dc(t, e) {
  for (typeof t != "string" ? t = cn(t) : Zs(t) || ri.throwArgumentError("invalid hex string", "value", t), t.length > 2 * e + 2 && ri.throwArgumentError("value out of range", "value", arguments[1]); t.length < 2 * e + 2; )
    t = "0x0" + t.substring(2);
  return t;
}
function uI(t) {
  const e = {
    r: "0x",
    s: "0x",
    _vs: "0x",
    recoveryParam: 0,
    v: 0,
    yParityAndS: "0x",
    compact: "0x"
  };
  if (fJ(t)) {
    let r = ai(t);
    r.length === 64 ? (e.v = 27 + (r[32] >> 7), r[32] &= 127, e.r = cn(r.slice(0, 32)), e.s = cn(r.slice(32, 64))) : r.length === 65 ? (e.r = cn(r.slice(0, 32)), e.s = cn(r.slice(32, 64)), e.v = r[64]) : ri.throwArgumentError("invalid signature string", "signature", t), e.v < 27 && (e.v === 0 || e.v === 1 ? e.v += 27 : ri.throwArgumentError("signature invalid v byte", "signature", t)), e.recoveryParam = 1 - e.v % 2, e.recoveryParam && (r[32] |= 128), e._vs = cn(r.slice(32, 64));
  } else {
    if (e.r = t.r, e.s = t.s, e.v = t.v, e.recoveryParam = t.recoveryParam, e._vs = t._vs, e._vs != null) {
      const s = uJ(ai(e._vs), 32);
      e._vs = cn(s);
      const n = s[0] >= 128 ? 1 : 0;
      e.recoveryParam == null ? e.recoveryParam = n : e.recoveryParam !== n && ri.throwArgumentError("signature recoveryParam mismatch _vs", "signature", t), s[0] &= 127;
      const f = cn(s);
      e.s == null ? e.s = f : e.s !== f && ri.throwArgumentError("signature v mismatch _vs", "signature", t);
    }
    if (e.recoveryParam == null)
      e.v == null ? ri.throwArgumentError("signature missing v and recoveryParam", "signature", t) : e.v === 0 || e.v === 1 ? e.recoveryParam = e.v : e.recoveryParam = 1 - e.v % 2;
    else if (e.v == null)
      e.v = 27 + e.recoveryParam;
    else {
      const s = e.v === 0 || e.v === 1 ? e.v : 1 - e.v % 2;
      e.recoveryParam !== s && ri.throwArgumentError("signature recoveryParam mismatch v", "signature", t);
    }
    e.r == null || !Zs(e.r) ? ri.throwArgumentError("signature missing or invalid r", "signature", t) : e.r = dc(e.r, 32), e.s == null || !Zs(e.s) ? ri.throwArgumentError("signature missing or invalid s", "signature", t) : e.s = dc(e.s, 32);
    const r = ai(e.s);
    r[0] >= 128 && ri.throwArgumentError("signature s out of range", "signature", t), e.recoveryParam && (r[0] |= 128);
    const i = cn(r);
    e._vs && (Zs(e._vs) || ri.throwArgumentError("signature invalid _vs", "signature", t), e._vs = dc(e._vs, 32)), e._vs == null ? e._vs = i : e._vs !== i && ri.throwArgumentError("signature _vs mismatch v and s", "signature", t);
  }
  return e.yParityAndS = e._vs, e.compact = e.r + e.yParityAndS.substring(2), e;
}
function iw(t) {
  return "0x" + nJ.keccak_256(ai(t));
}
var hI = { exports: {} };
(function(t) {
  (function(e, r) {
    function i(g, a) {
      if (!g)
        throw new Error(a || "Assertion failed");
    }
    function s(g, a) {
      g.super_ = a;
      var c = function() {
      };
      c.prototype = a.prototype, g.prototype = new c(), g.prototype.constructor = g;
    }
    function n(g, a, c) {
      if (n.isBN(g))
        return g;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, g !== null && ((a === "le" || a === "be") && (c = a, a = 10), this._init(g || 0, a || 10, c || "be"));
    }
    typeof e == "object" ? e.exports = n : r.BN = n, n.BN = n, n.wordSize = 26;
    var f;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? f = window.Buffer : f = dn.Buffer;
    } catch {
    }
    n.isBN = function(a) {
      return a instanceof n ? !0 : a !== null && typeof a == "object" && a.constructor.wordSize === n.wordSize && Array.isArray(a.words);
    }, n.max = function(a, c) {
      return a.cmp(c) > 0 ? a : c;
    }, n.min = function(a, c) {
      return a.cmp(c) < 0 ? a : c;
    }, n.prototype._init = function(a, c, p) {
      if (typeof a == "number")
        return this._initNumber(a, c, p);
      if (typeof a == "object")
        return this._initArray(a, c, p);
      c === "hex" && (c = 16), i(c === (c | 0) && c >= 2 && c <= 36), a = a.toString().replace(/\s+/g, "");
      var w = 0;
      a[0] === "-" && (w++, this.negative = 1), w < a.length && (c === 16 ? this._parseHex(a, w, p) : (this._parseBase(a, c, w), p === "le" && this._initArray(this.toArray(), c, p)));
    }, n.prototype._initNumber = function(a, c, p) {
      a < 0 && (this.negative = 1, a = -a), a < 67108864 ? (this.words = [a & 67108863], this.length = 1) : a < 4503599627370496 ? (this.words = [
        a & 67108863,
        a / 67108864 & 67108863
      ], this.length = 2) : (i(a < 9007199254740992), this.words = [
        a & 67108863,
        a / 67108864 & 67108863,
        1
      ], this.length = 3), p === "le" && this._initArray(this.toArray(), c, p);
    }, n.prototype._initArray = function(a, c, p) {
      if (i(typeof a.length == "number"), a.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(a.length / 3), this.words = new Array(this.length);
      for (var w = 0; w < this.length; w++)
        this.words[w] = 0;
      var _, x, E = 0;
      if (p === "be")
        for (w = a.length - 1, _ = 0; w >= 0; w -= 3)
          x = a[w] | a[w - 1] << 8 | a[w - 2] << 16, this.words[_] |= x << E & 67108863, this.words[_ + 1] = x >>> 26 - E & 67108863, E += 24, E >= 26 && (E -= 26, _++);
      else if (p === "le")
        for (w = 0, _ = 0; w < a.length; w += 3)
          x = a[w] | a[w + 1] << 8 | a[w + 2] << 16, this.words[_] |= x << E & 67108863, this.words[_ + 1] = x >>> 26 - E & 67108863, E += 24, E >= 26 && (E -= 26, _++);
      return this._strip();
    };
    function u(g, a) {
      var c = g.charCodeAt(a);
      if (c >= 48 && c <= 57)
        return c - 48;
      if (c >= 65 && c <= 70)
        return c - 55;
      if (c >= 97 && c <= 102)
        return c - 87;
      i(!1, "Invalid character in " + g);
    }
    function h(g, a, c) {
      var p = u(g, c);
      return c - 1 >= a && (p |= u(g, c - 1) << 4), p;
    }
    n.prototype._parseHex = function(a, c, p) {
      this.length = Math.ceil((a.length - c) / 6), this.words = new Array(this.length);
      for (var w = 0; w < this.length; w++)
        this.words[w] = 0;
      var _ = 0, x = 0, E;
      if (p === "be")
        for (w = a.length - 1; w >= c; w -= 2)
          E = h(a, c, w) << _, this.words[x] |= E & 67108863, _ >= 18 ? (_ -= 18, x += 1, this.words[x] |= E >>> 26) : _ += 8;
      else {
        var y = a.length - c;
        for (w = y % 2 === 0 ? c + 1 : c; w < a.length; w += 2)
          E = h(a, c, w) << _, this.words[x] |= E & 67108863, _ >= 18 ? (_ -= 18, x += 1, this.words[x] |= E >>> 26) : _ += 8;
      }
      this._strip();
    };
    function d(g, a, c, p) {
      for (var w = 0, _ = 0, x = Math.min(g.length, c), E = a; E < x; E++) {
        var y = g.charCodeAt(E) - 48;
        w *= p, y >= 49 ? _ = y - 49 + 10 : y >= 17 ? _ = y - 17 + 10 : _ = y, i(y >= 0 && _ < p, "Invalid character"), w += _;
      }
      return w;
    }
    n.prototype._parseBase = function(a, c, p) {
      this.words = [0], this.length = 1;
      for (var w = 0, _ = 1; _ <= 67108863; _ *= c)
        w++;
      w--, _ = _ / c | 0;
      for (var x = a.length - p, E = x % w, y = Math.min(x, x - E) + p, o = 0, S = p; S < y; S += w)
        o = d(a, S, S + w, c), this.imuln(_), this.words[0] + o < 67108864 ? this.words[0] += o : this._iaddn(o);
      if (E !== 0) {
        var J = 1;
        for (o = d(a, S, a.length, c), S = 0; S < E; S++)
          J *= c;
        this.imuln(J), this.words[0] + o < 67108864 ? this.words[0] += o : this._iaddn(o);
      }
      this._strip();
    }, n.prototype.copy = function(a) {
      a.words = new Array(this.length);
      for (var c = 0; c < this.length; c++)
        a.words[c] = this.words[c];
      a.length = this.length, a.negative = this.negative, a.red = this.red;
    };
    function l(g, a) {
      g.words = a.words, g.length = a.length, g.negative = a.negative, g.red = a.red;
    }
    if (n.prototype._move = function(a) {
      l(a, this);
    }, n.prototype.clone = function() {
      var a = new n(null);
      return this.copy(a), a;
    }, n.prototype._expand = function(a) {
      for (; this.length < a; )
        this.words[this.length++] = 0;
      return this;
    }, n.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, n.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        n.prototype[Symbol.for("nodejs.util.inspect.custom")] = m;
      } catch {
        n.prototype.inspect = m;
      }
    else
      n.prototype.inspect = m;
    function m() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var b = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], M = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], A = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    n.prototype.toString = function(a, c) {
      a = a || 10, c = c | 0 || 1;
      var p;
      if (a === 16 || a === "hex") {
        p = "";
        for (var w = 0, _ = 0, x = 0; x < this.length; x++) {
          var E = this.words[x], y = ((E << w | _) & 16777215).toString(16);
          _ = E >>> 24 - w & 16777215, w += 2, w >= 26 && (w -= 26, x--), _ !== 0 || x !== this.length - 1 ? p = b[6 - y.length] + y + p : p = y + p;
        }
        for (_ !== 0 && (p = _.toString(16) + p); p.length % c !== 0; )
          p = "0" + p;
        return this.negative !== 0 && (p = "-" + p), p;
      }
      if (a === (a | 0) && a >= 2 && a <= 36) {
        var o = M[a], S = A[a];
        p = "";
        var J = this.clone();
        for (J.negative = 0; !J.isZero(); ) {
          var z = J.modrn(S).toString(a);
          J = J.idivn(S), J.isZero() ? p = z + p : p = b[o - z.length] + z + p;
        }
        for (this.isZero() && (p = "0" + p); p.length % c !== 0; )
          p = "0" + p;
        return this.negative !== 0 && (p = "-" + p), p;
      }
      i(!1, "Base should be between 2 and 36");
    }, n.prototype.toNumber = function() {
      var a = this.words[0];
      return this.length === 2 ? a += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? a += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -a : a;
    }, n.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, f && (n.prototype.toBuffer = function(a, c) {
      return this.toArrayLike(f, a, c);
    }), n.prototype.toArray = function(a, c) {
      return this.toArrayLike(Array, a, c);
    };
    var N = function(a, c) {
      return a.allocUnsafe ? a.allocUnsafe(c) : new a(c);
    };
    n.prototype.toArrayLike = function(a, c, p) {
      this._strip();
      var w = this.byteLength(), _ = p || Math.max(1, w);
      i(w <= _, "byte array longer than desired length"), i(_ > 0, "Requested array length <= 0");
      var x = N(a, _), E = c === "le" ? "LE" : "BE";
      return this["_toArrayLike" + E](x, w), x;
    }, n.prototype._toArrayLikeLE = function(a, c) {
      for (var p = 0, w = 0, _ = 0, x = 0; _ < this.length; _++) {
        var E = this.words[_] << x | w;
        a[p++] = E & 255, p < a.length && (a[p++] = E >> 8 & 255), p < a.length && (a[p++] = E >> 16 & 255), x === 6 ? (p < a.length && (a[p++] = E >> 24 & 255), w = 0, x = 0) : (w = E >>> 24, x += 2);
      }
      if (p < a.length)
        for (a[p++] = w; p < a.length; )
          a[p++] = 0;
    }, n.prototype._toArrayLikeBE = function(a, c) {
      for (var p = a.length - 1, w = 0, _ = 0, x = 0; _ < this.length; _++) {
        var E = this.words[_] << x | w;
        a[p--] = E & 255, p >= 0 && (a[p--] = E >> 8 & 255), p >= 0 && (a[p--] = E >> 16 & 255), x === 6 ? (p >= 0 && (a[p--] = E >> 24 & 255), w = 0, x = 0) : (w = E >>> 24, x += 2);
      }
      if (p >= 0)
        for (a[p--] = w; p >= 0; )
          a[p--] = 0;
    }, Math.clz32 ? n.prototype._countBits = function(a) {
      return 32 - Math.clz32(a);
    } : n.prototype._countBits = function(a) {
      var c = a, p = 0;
      return c >= 4096 && (p += 13, c >>>= 13), c >= 64 && (p += 7, c >>>= 7), c >= 8 && (p += 4, c >>>= 4), c >= 2 && (p += 2, c >>>= 2), p + c;
    }, n.prototype._zeroBits = function(a) {
      if (a === 0)
        return 26;
      var c = a, p = 0;
      return (c & 8191) === 0 && (p += 13, c >>>= 13), (c & 127) === 0 && (p += 7, c >>>= 7), (c & 15) === 0 && (p += 4, c >>>= 4), (c & 3) === 0 && (p += 2, c >>>= 2), (c & 1) === 0 && p++, p;
    }, n.prototype.bitLength = function() {
      var a = this.words[this.length - 1], c = this._countBits(a);
      return (this.length - 1) * 26 + c;
    };
    function R(g) {
      for (var a = new Array(g.bitLength()), c = 0; c < a.length; c++) {
        var p = c / 26 | 0, w = c % 26;
        a[c] = g.words[p] >>> w & 1;
      }
      return a;
    }
    n.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var a = 0, c = 0; c < this.length; c++) {
        var p = this._zeroBits(this.words[c]);
        if (a += p, p !== 26)
          break;
      }
      return a;
    }, n.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, n.prototype.toTwos = function(a) {
      return this.negative !== 0 ? this.abs().inotn(a).iaddn(1) : this.clone();
    }, n.prototype.fromTwos = function(a) {
      return this.testn(a - 1) ? this.notn(a).iaddn(1).ineg() : this.clone();
    }, n.prototype.isNeg = function() {
      return this.negative !== 0;
    }, n.prototype.neg = function() {
      return this.clone().ineg();
    }, n.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, n.prototype.iuor = function(a) {
      for (; this.length < a.length; )
        this.words[this.length++] = 0;
      for (var c = 0; c < a.length; c++)
        this.words[c] = this.words[c] | a.words[c];
      return this._strip();
    }, n.prototype.ior = function(a) {
      return i((this.negative | a.negative) === 0), this.iuor(a);
    }, n.prototype.or = function(a) {
      return this.length > a.length ? this.clone().ior(a) : a.clone().ior(this);
    }, n.prototype.uor = function(a) {
      return this.length > a.length ? this.clone().iuor(a) : a.clone().iuor(this);
    }, n.prototype.iuand = function(a) {
      var c;
      this.length > a.length ? c = a : c = this;
      for (var p = 0; p < c.length; p++)
        this.words[p] = this.words[p] & a.words[p];
      return this.length = c.length, this._strip();
    }, n.prototype.iand = function(a) {
      return i((this.negative | a.negative) === 0), this.iuand(a);
    }, n.prototype.and = function(a) {
      return this.length > a.length ? this.clone().iand(a) : a.clone().iand(this);
    }, n.prototype.uand = function(a) {
      return this.length > a.length ? this.clone().iuand(a) : a.clone().iuand(this);
    }, n.prototype.iuxor = function(a) {
      var c, p;
      this.length > a.length ? (c = this, p = a) : (c = a, p = this);
      for (var w = 0; w < p.length; w++)
        this.words[w] = c.words[w] ^ p.words[w];
      if (this !== c)
        for (; w < c.length; w++)
          this.words[w] = c.words[w];
      return this.length = c.length, this._strip();
    }, n.prototype.ixor = function(a) {
      return i((this.negative | a.negative) === 0), this.iuxor(a);
    }, n.prototype.xor = function(a) {
      return this.length > a.length ? this.clone().ixor(a) : a.clone().ixor(this);
    }, n.prototype.uxor = function(a) {
      return this.length > a.length ? this.clone().iuxor(a) : a.clone().iuxor(this);
    }, n.prototype.inotn = function(a) {
      i(typeof a == "number" && a >= 0);
      var c = Math.ceil(a / 26) | 0, p = a % 26;
      this._expand(c), p > 0 && c--;
      for (var w = 0; w < c; w++)
        this.words[w] = ~this.words[w] & 67108863;
      return p > 0 && (this.words[w] = ~this.words[w] & 67108863 >> 26 - p), this._strip();
    }, n.prototype.notn = function(a) {
      return this.clone().inotn(a);
    }, n.prototype.setn = function(a, c) {
      i(typeof a == "number" && a >= 0);
      var p = a / 26 | 0, w = a % 26;
      return this._expand(p + 1), c ? this.words[p] = this.words[p] | 1 << w : this.words[p] = this.words[p] & ~(1 << w), this._strip();
    }, n.prototype.iadd = function(a) {
      var c;
      if (this.negative !== 0 && a.negative === 0)
        return this.negative = 0, c = this.isub(a), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && a.negative !== 0)
        return a.negative = 0, c = this.isub(a), a.negative = 1, c._normSign();
      var p, w;
      this.length > a.length ? (p = this, w = a) : (p = a, w = this);
      for (var _ = 0, x = 0; x < w.length; x++)
        c = (p.words[x] | 0) + (w.words[x] | 0) + _, this.words[x] = c & 67108863, _ = c >>> 26;
      for (; _ !== 0 && x < p.length; x++)
        c = (p.words[x] | 0) + _, this.words[x] = c & 67108863, _ = c >>> 26;
      if (this.length = p.length, _ !== 0)
        this.words[this.length] = _, this.length++;
      else if (p !== this)
        for (; x < p.length; x++)
          this.words[x] = p.words[x];
      return this;
    }, n.prototype.add = function(a) {
      var c;
      return a.negative !== 0 && this.negative === 0 ? (a.negative = 0, c = this.sub(a), a.negative ^= 1, c) : a.negative === 0 && this.negative !== 0 ? (this.negative = 0, c = a.sub(this), this.negative = 1, c) : this.length > a.length ? this.clone().iadd(a) : a.clone().iadd(this);
    }, n.prototype.isub = function(a) {
      if (a.negative !== 0) {
        a.negative = 0;
        var c = this.iadd(a);
        return a.negative = 1, c._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(a), this.negative = 1, this._normSign();
      var p = this.cmp(a);
      if (p === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var w, _;
      p > 0 ? (w = this, _ = a) : (w = a, _ = this);
      for (var x = 0, E = 0; E < _.length; E++)
        c = (w.words[E] | 0) - (_.words[E] | 0) + x, x = c >> 26, this.words[E] = c & 67108863;
      for (; x !== 0 && E < w.length; E++)
        c = (w.words[E] | 0) + x, x = c >> 26, this.words[E] = c & 67108863;
      if (x === 0 && E < w.length && w !== this)
        for (; E < w.length; E++)
          this.words[E] = w.words[E];
      return this.length = Math.max(this.length, E), w !== this && (this.negative = 1), this._strip();
    }, n.prototype.sub = function(a) {
      return this.clone().isub(a);
    };
    function O(g, a, c) {
      c.negative = a.negative ^ g.negative;
      var p = g.length + a.length | 0;
      c.length = p, p = p - 1 | 0;
      var w = g.words[0] | 0, _ = a.words[0] | 0, x = w * _, E = x & 67108863, y = x / 67108864 | 0;
      c.words[0] = E;
      for (var o = 1; o < p; o++) {
        for (var S = y >>> 26, J = y & 67108863, z = Math.min(o, a.length - 1), k = Math.max(0, o - g.length + 1); k <= z; k++) {
          var j = o - k | 0;
          w = g.words[j] | 0, _ = a.words[k] | 0, x = w * _ + J, S += x / 67108864 | 0, J = x & 67108863;
        }
        c.words[o] = J | 0, y = S | 0;
      }
      return y !== 0 ? c.words[o] = y | 0 : c.length--, c._strip();
    }
    var P = function(a, c, p) {
      var w = a.words, _ = c.words, x = p.words, E = 0, y, o, S, J = w[0] | 0, z = J & 8191, k = J >>> 13, j = w[1] | 0, q = j & 8191, K = j >>> 13, U = w[2] | 0, T = U & 8191, D = U >>> 13, te = w[3] | 0, ne = te & 8191, le = te >>> 13, X = w[4] | 0, $ = X & 8191, V = X >>> 13, re = w[5] | 0, fe = re & 8191, ue = re >>> 13, me = w[6] | 0, be = me & 8191, ve = me >>> 13, Ge = w[7] | 0, ye = Ge & 8191, pe = Ge >>> 13, Je = w[8] | 0, Ie = Je & 8191, we = Je >>> 13, at = w[9] | 0, Oe = at & 8191, Ee = at >>> 13, ft = _[0] | 0, Le = ft & 8191, Pe = ft >>> 13, Mt = _[1] | 0, Ve = Mt & 8191, ke = Mt >>> 13, Et = _[2] | 0, Ke = Et & 8191, Be = Et >>> 13, dt = _[3] | 0, ze = dt & 8191, Te = dt >>> 13, pt = _[4] | 0, Fe = pt & 8191, Ae = pt >>> 13, bt = _[5] | 0, He = bt & 8191, Ne = bt >>> 13, yt = _[6] | 0, $e = yt & 8191, De = yt >>> 13, vt = _[7] | 0, je = vt & 8191, Ce = vt >>> 13, mt = _[8] | 0, Ze = mt & 8191, qe = mt >>> 13, Dt = _[9] | 0, We = Dt & 8191, Qe = Dt >>> 13;
      p.negative = a.negative ^ c.negative, p.length = 19, y = Math.imul(z, Le), o = Math.imul(z, Pe), o = o + Math.imul(k, Le) | 0, S = Math.imul(k, Pe);
      var Qt = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Qt >>> 26) | 0, Qt &= 67108863, y = Math.imul(q, Le), o = Math.imul(q, Pe), o = o + Math.imul(K, Le) | 0, S = Math.imul(K, Pe), y = y + Math.imul(z, Ve) | 0, o = o + Math.imul(z, ke) | 0, o = o + Math.imul(k, Ve) | 0, S = S + Math.imul(k, ke) | 0;
      var Zt = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Zt >>> 26) | 0, Zt &= 67108863, y = Math.imul(T, Le), o = Math.imul(T, Pe), o = o + Math.imul(D, Le) | 0, S = Math.imul(D, Pe), y = y + Math.imul(q, Ve) | 0, o = o + Math.imul(q, ke) | 0, o = o + Math.imul(K, Ve) | 0, S = S + Math.imul(K, ke) | 0, y = y + Math.imul(z, Ke) | 0, o = o + Math.imul(z, Be) | 0, o = o + Math.imul(k, Ke) | 0, S = S + Math.imul(k, Be) | 0;
      var Jt = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Jt >>> 26) | 0, Jt &= 67108863, y = Math.imul(ne, Le), o = Math.imul(ne, Pe), o = o + Math.imul(le, Le) | 0, S = Math.imul(le, Pe), y = y + Math.imul(T, Ve) | 0, o = o + Math.imul(T, ke) | 0, o = o + Math.imul(D, Ve) | 0, S = S + Math.imul(D, ke) | 0, y = y + Math.imul(q, Ke) | 0, o = o + Math.imul(q, Be) | 0, o = o + Math.imul(K, Ke) | 0, S = S + Math.imul(K, Be) | 0, y = y + Math.imul(z, ze) | 0, o = o + Math.imul(z, Te) | 0, o = o + Math.imul(k, ze) | 0, S = S + Math.imul(k, Te) | 0;
      var Xt = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Xt >>> 26) | 0, Xt &= 67108863, y = Math.imul($, Le), o = Math.imul($, Pe), o = o + Math.imul(V, Le) | 0, S = Math.imul(V, Pe), y = y + Math.imul(ne, Ve) | 0, o = o + Math.imul(ne, ke) | 0, o = o + Math.imul(le, Ve) | 0, S = S + Math.imul(le, ke) | 0, y = y + Math.imul(T, Ke) | 0, o = o + Math.imul(T, Be) | 0, o = o + Math.imul(D, Ke) | 0, S = S + Math.imul(D, Be) | 0, y = y + Math.imul(q, ze) | 0, o = o + Math.imul(q, Te) | 0, o = o + Math.imul(K, ze) | 0, S = S + Math.imul(K, Te) | 0, y = y + Math.imul(z, Fe) | 0, o = o + Math.imul(z, Ae) | 0, o = o + Math.imul(k, Fe) | 0, S = S + Math.imul(k, Ae) | 0;
      var kt = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, y = Math.imul(fe, Le), o = Math.imul(fe, Pe), o = o + Math.imul(ue, Le) | 0, S = Math.imul(ue, Pe), y = y + Math.imul($, Ve) | 0, o = o + Math.imul($, ke) | 0, o = o + Math.imul(V, Ve) | 0, S = S + Math.imul(V, ke) | 0, y = y + Math.imul(ne, Ke) | 0, o = o + Math.imul(ne, Be) | 0, o = o + Math.imul(le, Ke) | 0, S = S + Math.imul(le, Be) | 0, y = y + Math.imul(T, ze) | 0, o = o + Math.imul(T, Te) | 0, o = o + Math.imul(D, ze) | 0, S = S + Math.imul(D, Te) | 0, y = y + Math.imul(q, Fe) | 0, o = o + Math.imul(q, Ae) | 0, o = o + Math.imul(K, Fe) | 0, S = S + Math.imul(K, Ae) | 0, y = y + Math.imul(z, He) | 0, o = o + Math.imul(z, Ne) | 0, o = o + Math.imul(k, He) | 0, S = S + Math.imul(k, Ne) | 0;
      var ar = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (ar >>> 26) | 0, ar &= 67108863, y = Math.imul(be, Le), o = Math.imul(be, Pe), o = o + Math.imul(ve, Le) | 0, S = Math.imul(ve, Pe), y = y + Math.imul(fe, Ve) | 0, o = o + Math.imul(fe, ke) | 0, o = o + Math.imul(ue, Ve) | 0, S = S + Math.imul(ue, ke) | 0, y = y + Math.imul($, Ke) | 0, o = o + Math.imul($, Be) | 0, o = o + Math.imul(V, Ke) | 0, S = S + Math.imul(V, Be) | 0, y = y + Math.imul(ne, ze) | 0, o = o + Math.imul(ne, Te) | 0, o = o + Math.imul(le, ze) | 0, S = S + Math.imul(le, Te) | 0, y = y + Math.imul(T, Fe) | 0, o = o + Math.imul(T, Ae) | 0, o = o + Math.imul(D, Fe) | 0, S = S + Math.imul(D, Ae) | 0, y = y + Math.imul(q, He) | 0, o = o + Math.imul(q, Ne) | 0, o = o + Math.imul(K, He) | 0, S = S + Math.imul(K, Ne) | 0, y = y + Math.imul(z, $e) | 0, o = o + Math.imul(z, De) | 0, o = o + Math.imul(k, $e) | 0, S = S + Math.imul(k, De) | 0;
      var lr = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (lr >>> 26) | 0, lr &= 67108863, y = Math.imul(ye, Le), o = Math.imul(ye, Pe), o = o + Math.imul(pe, Le) | 0, S = Math.imul(pe, Pe), y = y + Math.imul(be, Ve) | 0, o = o + Math.imul(be, ke) | 0, o = o + Math.imul(ve, Ve) | 0, S = S + Math.imul(ve, ke) | 0, y = y + Math.imul(fe, Ke) | 0, o = o + Math.imul(fe, Be) | 0, o = o + Math.imul(ue, Ke) | 0, S = S + Math.imul(ue, Be) | 0, y = y + Math.imul($, ze) | 0, o = o + Math.imul($, Te) | 0, o = o + Math.imul(V, ze) | 0, S = S + Math.imul(V, Te) | 0, y = y + Math.imul(ne, Fe) | 0, o = o + Math.imul(ne, Ae) | 0, o = o + Math.imul(le, Fe) | 0, S = S + Math.imul(le, Ae) | 0, y = y + Math.imul(T, He) | 0, o = o + Math.imul(T, Ne) | 0, o = o + Math.imul(D, He) | 0, S = S + Math.imul(D, Ne) | 0, y = y + Math.imul(q, $e) | 0, o = o + Math.imul(q, De) | 0, o = o + Math.imul(K, $e) | 0, S = S + Math.imul(K, De) | 0, y = y + Math.imul(z, je) | 0, o = o + Math.imul(z, Ce) | 0, o = o + Math.imul(k, je) | 0, S = S + Math.imul(k, Ce) | 0;
      var or = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (or >>> 26) | 0, or &= 67108863, y = Math.imul(Ie, Le), o = Math.imul(Ie, Pe), o = o + Math.imul(we, Le) | 0, S = Math.imul(we, Pe), y = y + Math.imul(ye, Ve) | 0, o = o + Math.imul(ye, ke) | 0, o = o + Math.imul(pe, Ve) | 0, S = S + Math.imul(pe, ke) | 0, y = y + Math.imul(be, Ke) | 0, o = o + Math.imul(be, Be) | 0, o = o + Math.imul(ve, Ke) | 0, S = S + Math.imul(ve, Be) | 0, y = y + Math.imul(fe, ze) | 0, o = o + Math.imul(fe, Te) | 0, o = o + Math.imul(ue, ze) | 0, S = S + Math.imul(ue, Te) | 0, y = y + Math.imul($, Fe) | 0, o = o + Math.imul($, Ae) | 0, o = o + Math.imul(V, Fe) | 0, S = S + Math.imul(V, Ae) | 0, y = y + Math.imul(ne, He) | 0, o = o + Math.imul(ne, Ne) | 0, o = o + Math.imul(le, He) | 0, S = S + Math.imul(le, Ne) | 0, y = y + Math.imul(T, $e) | 0, o = o + Math.imul(T, De) | 0, o = o + Math.imul(D, $e) | 0, S = S + Math.imul(D, De) | 0, y = y + Math.imul(q, je) | 0, o = o + Math.imul(q, Ce) | 0, o = o + Math.imul(K, je) | 0, S = S + Math.imul(K, Ce) | 0, y = y + Math.imul(z, Ze) | 0, o = o + Math.imul(z, qe) | 0, o = o + Math.imul(k, Ze) | 0, S = S + Math.imul(k, qe) | 0;
      var dr = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (dr >>> 26) | 0, dr &= 67108863, y = Math.imul(Oe, Le), o = Math.imul(Oe, Pe), o = o + Math.imul(Ee, Le) | 0, S = Math.imul(Ee, Pe), y = y + Math.imul(Ie, Ve) | 0, o = o + Math.imul(Ie, ke) | 0, o = o + Math.imul(we, Ve) | 0, S = S + Math.imul(we, ke) | 0, y = y + Math.imul(ye, Ke) | 0, o = o + Math.imul(ye, Be) | 0, o = o + Math.imul(pe, Ke) | 0, S = S + Math.imul(pe, Be) | 0, y = y + Math.imul(be, ze) | 0, o = o + Math.imul(be, Te) | 0, o = o + Math.imul(ve, ze) | 0, S = S + Math.imul(ve, Te) | 0, y = y + Math.imul(fe, Fe) | 0, o = o + Math.imul(fe, Ae) | 0, o = o + Math.imul(ue, Fe) | 0, S = S + Math.imul(ue, Ae) | 0, y = y + Math.imul($, He) | 0, o = o + Math.imul($, Ne) | 0, o = o + Math.imul(V, He) | 0, S = S + Math.imul(V, Ne) | 0, y = y + Math.imul(ne, $e) | 0, o = o + Math.imul(ne, De) | 0, o = o + Math.imul(le, $e) | 0, S = S + Math.imul(le, De) | 0, y = y + Math.imul(T, je) | 0, o = o + Math.imul(T, Ce) | 0, o = o + Math.imul(D, je) | 0, S = S + Math.imul(D, Ce) | 0, y = y + Math.imul(q, Ze) | 0, o = o + Math.imul(q, qe) | 0, o = o + Math.imul(K, Ze) | 0, S = S + Math.imul(K, qe) | 0, y = y + Math.imul(z, We) | 0, o = o + Math.imul(z, Qe) | 0, o = o + Math.imul(k, We) | 0, S = S + Math.imul(k, Qe) | 0;
      var pr = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (pr >>> 26) | 0, pr &= 67108863, y = Math.imul(Oe, Ve), o = Math.imul(Oe, ke), o = o + Math.imul(Ee, Ve) | 0, S = Math.imul(Ee, ke), y = y + Math.imul(Ie, Ke) | 0, o = o + Math.imul(Ie, Be) | 0, o = o + Math.imul(we, Ke) | 0, S = S + Math.imul(we, Be) | 0, y = y + Math.imul(ye, ze) | 0, o = o + Math.imul(ye, Te) | 0, o = o + Math.imul(pe, ze) | 0, S = S + Math.imul(pe, Te) | 0, y = y + Math.imul(be, Fe) | 0, o = o + Math.imul(be, Ae) | 0, o = o + Math.imul(ve, Fe) | 0, S = S + Math.imul(ve, Ae) | 0, y = y + Math.imul(fe, He) | 0, o = o + Math.imul(fe, Ne) | 0, o = o + Math.imul(ue, He) | 0, S = S + Math.imul(ue, Ne) | 0, y = y + Math.imul($, $e) | 0, o = o + Math.imul($, De) | 0, o = o + Math.imul(V, $e) | 0, S = S + Math.imul(V, De) | 0, y = y + Math.imul(ne, je) | 0, o = o + Math.imul(ne, Ce) | 0, o = o + Math.imul(le, je) | 0, S = S + Math.imul(le, Ce) | 0, y = y + Math.imul(T, Ze) | 0, o = o + Math.imul(T, qe) | 0, o = o + Math.imul(D, Ze) | 0, S = S + Math.imul(D, qe) | 0, y = y + Math.imul(q, We) | 0, o = o + Math.imul(q, Qe) | 0, o = o + Math.imul(K, We) | 0, S = S + Math.imul(K, Qe) | 0;
      var fr = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (fr >>> 26) | 0, fr &= 67108863, y = Math.imul(Oe, Ke), o = Math.imul(Oe, Be), o = o + Math.imul(Ee, Ke) | 0, S = Math.imul(Ee, Be), y = y + Math.imul(Ie, ze) | 0, o = o + Math.imul(Ie, Te) | 0, o = o + Math.imul(we, ze) | 0, S = S + Math.imul(we, Te) | 0, y = y + Math.imul(ye, Fe) | 0, o = o + Math.imul(ye, Ae) | 0, o = o + Math.imul(pe, Fe) | 0, S = S + Math.imul(pe, Ae) | 0, y = y + Math.imul(be, He) | 0, o = o + Math.imul(be, Ne) | 0, o = o + Math.imul(ve, He) | 0, S = S + Math.imul(ve, Ne) | 0, y = y + Math.imul(fe, $e) | 0, o = o + Math.imul(fe, De) | 0, o = o + Math.imul(ue, $e) | 0, S = S + Math.imul(ue, De) | 0, y = y + Math.imul($, je) | 0, o = o + Math.imul($, Ce) | 0, o = o + Math.imul(V, je) | 0, S = S + Math.imul(V, Ce) | 0, y = y + Math.imul(ne, Ze) | 0, o = o + Math.imul(ne, qe) | 0, o = o + Math.imul(le, Ze) | 0, S = S + Math.imul(le, qe) | 0, y = y + Math.imul(T, We) | 0, o = o + Math.imul(T, Qe) | 0, o = o + Math.imul(D, We) | 0, S = S + Math.imul(D, Qe) | 0;
      var ur = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (ur >>> 26) | 0, ur &= 67108863, y = Math.imul(Oe, ze), o = Math.imul(Oe, Te), o = o + Math.imul(Ee, ze) | 0, S = Math.imul(Ee, Te), y = y + Math.imul(Ie, Fe) | 0, o = o + Math.imul(Ie, Ae) | 0, o = o + Math.imul(we, Fe) | 0, S = S + Math.imul(we, Ae) | 0, y = y + Math.imul(ye, He) | 0, o = o + Math.imul(ye, Ne) | 0, o = o + Math.imul(pe, He) | 0, S = S + Math.imul(pe, Ne) | 0, y = y + Math.imul(be, $e) | 0, o = o + Math.imul(be, De) | 0, o = o + Math.imul(ve, $e) | 0, S = S + Math.imul(ve, De) | 0, y = y + Math.imul(fe, je) | 0, o = o + Math.imul(fe, Ce) | 0, o = o + Math.imul(ue, je) | 0, S = S + Math.imul(ue, Ce) | 0, y = y + Math.imul($, Ze) | 0, o = o + Math.imul($, qe) | 0, o = o + Math.imul(V, Ze) | 0, S = S + Math.imul(V, qe) | 0, y = y + Math.imul(ne, We) | 0, o = o + Math.imul(ne, Qe) | 0, o = o + Math.imul(le, We) | 0, S = S + Math.imul(le, Qe) | 0;
      var hr = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (hr >>> 26) | 0, hr &= 67108863, y = Math.imul(Oe, Fe), o = Math.imul(Oe, Ae), o = o + Math.imul(Ee, Fe) | 0, S = Math.imul(Ee, Ae), y = y + Math.imul(Ie, He) | 0, o = o + Math.imul(Ie, Ne) | 0, o = o + Math.imul(we, He) | 0, S = S + Math.imul(we, Ne) | 0, y = y + Math.imul(ye, $e) | 0, o = o + Math.imul(ye, De) | 0, o = o + Math.imul(pe, $e) | 0, S = S + Math.imul(pe, De) | 0, y = y + Math.imul(be, je) | 0, o = o + Math.imul(be, Ce) | 0, o = o + Math.imul(ve, je) | 0, S = S + Math.imul(ve, Ce) | 0, y = y + Math.imul(fe, Ze) | 0, o = o + Math.imul(fe, qe) | 0, o = o + Math.imul(ue, Ze) | 0, S = S + Math.imul(ue, qe) | 0, y = y + Math.imul($, We) | 0, o = o + Math.imul($, Qe) | 0, o = o + Math.imul(V, We) | 0, S = S + Math.imul(V, Qe) | 0;
      var qt = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (qt >>> 26) | 0, qt &= 67108863, y = Math.imul(Oe, He), o = Math.imul(Oe, Ne), o = o + Math.imul(Ee, He) | 0, S = Math.imul(Ee, Ne), y = y + Math.imul(Ie, $e) | 0, o = o + Math.imul(Ie, De) | 0, o = o + Math.imul(we, $e) | 0, S = S + Math.imul(we, De) | 0, y = y + Math.imul(ye, je) | 0, o = o + Math.imul(ye, Ce) | 0, o = o + Math.imul(pe, je) | 0, S = S + Math.imul(pe, Ce) | 0, y = y + Math.imul(be, Ze) | 0, o = o + Math.imul(be, qe) | 0, o = o + Math.imul(ve, Ze) | 0, S = S + Math.imul(ve, qe) | 0, y = y + Math.imul(fe, We) | 0, o = o + Math.imul(fe, Qe) | 0, o = o + Math.imul(ue, We) | 0, S = S + Math.imul(ue, Qe) | 0;
      var Er = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Er >>> 26) | 0, Er &= 67108863, y = Math.imul(Oe, $e), o = Math.imul(Oe, De), o = o + Math.imul(Ee, $e) | 0, S = Math.imul(Ee, De), y = y + Math.imul(Ie, je) | 0, o = o + Math.imul(Ie, Ce) | 0, o = o + Math.imul(we, je) | 0, S = S + Math.imul(we, Ce) | 0, y = y + Math.imul(ye, Ze) | 0, o = o + Math.imul(ye, qe) | 0, o = o + Math.imul(pe, Ze) | 0, S = S + Math.imul(pe, qe) | 0, y = y + Math.imul(be, We) | 0, o = o + Math.imul(be, Qe) | 0, o = o + Math.imul(ve, We) | 0, S = S + Math.imul(ve, Qe) | 0;
      var Ir = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Ir >>> 26) | 0, Ir &= 67108863, y = Math.imul(Oe, je), o = Math.imul(Oe, Ce), o = o + Math.imul(Ee, je) | 0, S = Math.imul(Ee, Ce), y = y + Math.imul(Ie, Ze) | 0, o = o + Math.imul(Ie, qe) | 0, o = o + Math.imul(we, Ze) | 0, S = S + Math.imul(we, qe) | 0, y = y + Math.imul(ye, We) | 0, o = o + Math.imul(ye, Qe) | 0, o = o + Math.imul(pe, We) | 0, S = S + Math.imul(pe, Qe) | 0;
      var Ar = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Ar >>> 26) | 0, Ar &= 67108863, y = Math.imul(Oe, Ze), o = Math.imul(Oe, qe), o = o + Math.imul(Ee, Ze) | 0, S = Math.imul(Ee, qe), y = y + Math.imul(Ie, We) | 0, o = o + Math.imul(Ie, Qe) | 0, o = o + Math.imul(we, We) | 0, S = S + Math.imul(we, Qe) | 0;
      var qr = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (qr >>> 26) | 0, qr &= 67108863, y = Math.imul(Oe, We), o = Math.imul(Oe, Qe), o = o + Math.imul(Ee, We) | 0, S = Math.imul(Ee, Qe);
      var zr = (E + y | 0) + ((o & 8191) << 13) | 0;
      return E = (S + (o >>> 13) | 0) + (zr >>> 26) | 0, zr &= 67108863, x[0] = Qt, x[1] = Zt, x[2] = Jt, x[3] = Xt, x[4] = kt, x[5] = ar, x[6] = lr, x[7] = or, x[8] = dr, x[9] = pr, x[10] = fr, x[11] = ur, x[12] = hr, x[13] = qt, x[14] = Er, x[15] = Ir, x[16] = Ar, x[17] = qr, x[18] = zr, E !== 0 && (x[19] = E, p.length++), p;
    };
    Math.imul || (P = O);
    function F(g, a, c) {
      c.negative = a.negative ^ g.negative, c.length = g.length + a.length;
      for (var p = 0, w = 0, _ = 0; _ < c.length - 1; _++) {
        var x = w;
        w = 0;
        for (var E = p & 67108863, y = Math.min(_, a.length - 1), o = Math.max(0, _ - g.length + 1); o <= y; o++) {
          var S = _ - o, J = g.words[S] | 0, z = a.words[o] | 0, k = J * z, j = k & 67108863;
          x = x + (k / 67108864 | 0) | 0, j = j + E | 0, E = j & 67108863, x = x + (j >>> 26) | 0, w += x >>> 26, x &= 67108863;
        }
        c.words[_] = E, p = x, x = w;
      }
      return p !== 0 ? c.words[_] = p : c.length--, c._strip();
    }
    function H(g, a, c) {
      return F(g, a, c);
    }
    n.prototype.mulTo = function(a, c) {
      var p, w = this.length + a.length;
      return this.length === 10 && a.length === 10 ? p = P(this, a, c) : w < 63 ? p = O(this, a, c) : w < 1024 ? p = F(this, a, c) : p = H(this, a, c), p;
    }, n.prototype.mul = function(a) {
      var c = new n(null);
      return c.words = new Array(this.length + a.length), this.mulTo(a, c);
    }, n.prototype.mulf = function(a) {
      var c = new n(null);
      return c.words = new Array(this.length + a.length), H(this, a, c);
    }, n.prototype.imul = function(a) {
      return this.clone().mulTo(a, this);
    }, n.prototype.imuln = function(a) {
      var c = a < 0;
      c && (a = -a), i(typeof a == "number"), i(a < 67108864);
      for (var p = 0, w = 0; w < this.length; w++) {
        var _ = (this.words[w] | 0) * a, x = (_ & 67108863) + (p & 67108863);
        p >>= 26, p += _ / 67108864 | 0, p += x >>> 26, this.words[w] = x & 67108863;
      }
      return p !== 0 && (this.words[w] = p, this.length++), c ? this.ineg() : this;
    }, n.prototype.muln = function(a) {
      return this.clone().imuln(a);
    }, n.prototype.sqr = function() {
      return this.mul(this);
    }, n.prototype.isqr = function() {
      return this.imul(this.clone());
    }, n.prototype.pow = function(a) {
      var c = R(a);
      if (c.length === 0)
        return new n(1);
      for (var p = this, w = 0; w < c.length && c[w] === 0; w++, p = p.sqr())
        ;
      if (++w < c.length)
        for (var _ = p.sqr(); w < c.length; w++, _ = _.sqr())
          c[w] !== 0 && (p = p.mul(_));
      return p;
    }, n.prototype.iushln = function(a) {
      i(typeof a == "number" && a >= 0);
      var c = a % 26, p = (a - c) / 26, w = 67108863 >>> 26 - c << 26 - c, _;
      if (c !== 0) {
        var x = 0;
        for (_ = 0; _ < this.length; _++) {
          var E = this.words[_] & w, y = (this.words[_] | 0) - E << c;
          this.words[_] = y | x, x = E >>> 26 - c;
        }
        x && (this.words[_] = x, this.length++);
      }
      if (p !== 0) {
        for (_ = this.length - 1; _ >= 0; _--)
          this.words[_ + p] = this.words[_];
        for (_ = 0; _ < p; _++)
          this.words[_] = 0;
        this.length += p;
      }
      return this._strip();
    }, n.prototype.ishln = function(a) {
      return i(this.negative === 0), this.iushln(a);
    }, n.prototype.iushrn = function(a, c, p) {
      i(typeof a == "number" && a >= 0);
      var w;
      c ? w = (c - c % 26) / 26 : w = 0;
      var _ = a % 26, x = Math.min((a - _) / 26, this.length), E = 67108863 ^ 67108863 >>> _ << _, y = p;
      if (w -= x, w = Math.max(0, w), y) {
        for (var o = 0; o < x; o++)
          y.words[o] = this.words[o];
        y.length = x;
      }
      if (x !== 0)
        if (this.length > x)
          for (this.length -= x, o = 0; o < this.length; o++)
            this.words[o] = this.words[o + x];
        else
          this.words[0] = 0, this.length = 1;
      var S = 0;
      for (o = this.length - 1; o >= 0 && (S !== 0 || o >= w); o--) {
        var J = this.words[o] | 0;
        this.words[o] = S << 26 - _ | J >>> _, S = J & E;
      }
      return y && S !== 0 && (y.words[y.length++] = S), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, n.prototype.ishrn = function(a, c, p) {
      return i(this.negative === 0), this.iushrn(a, c, p);
    }, n.prototype.shln = function(a) {
      return this.clone().ishln(a);
    }, n.prototype.ushln = function(a) {
      return this.clone().iushln(a);
    }, n.prototype.shrn = function(a) {
      return this.clone().ishrn(a);
    }, n.prototype.ushrn = function(a) {
      return this.clone().iushrn(a);
    }, n.prototype.testn = function(a) {
      i(typeof a == "number" && a >= 0);
      var c = a % 26, p = (a - c) / 26, w = 1 << c;
      if (this.length <= p)
        return !1;
      var _ = this.words[p];
      return !!(_ & w);
    }, n.prototype.imaskn = function(a) {
      i(typeof a == "number" && a >= 0);
      var c = a % 26, p = (a - c) / 26;
      if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= p)
        return this;
      if (c !== 0 && p++, this.length = Math.min(p, this.length), c !== 0) {
        var w = 67108863 ^ 67108863 >>> c << c;
        this.words[this.length - 1] &= w;
      }
      return this._strip();
    }, n.prototype.maskn = function(a) {
      return this.clone().imaskn(a);
    }, n.prototype.iaddn = function(a) {
      return i(typeof a == "number"), i(a < 67108864), a < 0 ? this.isubn(-a) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= a ? (this.words[0] = a - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(a), this.negative = 1, this) : this._iaddn(a);
    }, n.prototype._iaddn = function(a) {
      this.words[0] += a;
      for (var c = 0; c < this.length && this.words[c] >= 67108864; c++)
        this.words[c] -= 67108864, c === this.length - 1 ? this.words[c + 1] = 1 : this.words[c + 1]++;
      return this.length = Math.max(this.length, c + 1), this;
    }, n.prototype.isubn = function(a) {
      if (i(typeof a == "number"), i(a < 67108864), a < 0)
        return this.iaddn(-a);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(a), this.negative = 1, this;
      if (this.words[0] -= a, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var c = 0; c < this.length && this.words[c] < 0; c++)
          this.words[c] += 67108864, this.words[c + 1] -= 1;
      return this._strip();
    }, n.prototype.addn = function(a) {
      return this.clone().iaddn(a);
    }, n.prototype.subn = function(a) {
      return this.clone().isubn(a);
    }, n.prototype.iabs = function() {
      return this.negative = 0, this;
    }, n.prototype.abs = function() {
      return this.clone().iabs();
    }, n.prototype._ishlnsubmul = function(a, c, p) {
      var w = a.length + p, _;
      this._expand(w);
      var x, E = 0;
      for (_ = 0; _ < a.length; _++) {
        x = (this.words[_ + p] | 0) + E;
        var y = (a.words[_] | 0) * c;
        x -= y & 67108863, E = (x >> 26) - (y / 67108864 | 0), this.words[_ + p] = x & 67108863;
      }
      for (; _ < this.length - p; _++)
        x = (this.words[_ + p] | 0) + E, E = x >> 26, this.words[_ + p] = x & 67108863;
      if (E === 0)
        return this._strip();
      for (i(E === -1), E = 0, _ = 0; _ < this.length; _++)
        x = -(this.words[_] | 0) + E, E = x >> 26, this.words[_] = x & 67108863;
      return this.negative = 1, this._strip();
    }, n.prototype._wordDiv = function(a, c) {
      var p = this.length - a.length, w = this.clone(), _ = a, x = _.words[_.length - 1] | 0, E = this._countBits(x);
      p = 26 - E, p !== 0 && (_ = _.ushln(p), w.iushln(p), x = _.words[_.length - 1] | 0);
      var y = w.length - _.length, o;
      if (c !== "mod") {
        o = new n(null), o.length = y + 1, o.words = new Array(o.length);
        for (var S = 0; S < o.length; S++)
          o.words[S] = 0;
      }
      var J = w.clone()._ishlnsubmul(_, 1, y);
      J.negative === 0 && (w = J, o && (o.words[y] = 1));
      for (var z = y - 1; z >= 0; z--) {
        var k = (w.words[_.length + z] | 0) * 67108864 + (w.words[_.length + z - 1] | 0);
        for (k = Math.min(k / x | 0, 67108863), w._ishlnsubmul(_, k, z); w.negative !== 0; )
          k--, w.negative = 0, w._ishlnsubmul(_, 1, z), w.isZero() || (w.negative ^= 1);
        o && (o.words[z] = k);
      }
      return o && o._strip(), w._strip(), c !== "div" && p !== 0 && w.iushrn(p), {
        div: o || null,
        mod: w
      };
    }, n.prototype.divmod = function(a, c, p) {
      if (i(!a.isZero()), this.isZero())
        return {
          div: new n(0),
          mod: new n(0)
        };
      var w, _, x;
      return this.negative !== 0 && a.negative === 0 ? (x = this.neg().divmod(a, c), c !== "mod" && (w = x.div.neg()), c !== "div" && (_ = x.mod.neg(), p && _.negative !== 0 && _.iadd(a)), {
        div: w,
        mod: _
      }) : this.negative === 0 && a.negative !== 0 ? (x = this.divmod(a.neg(), c), c !== "mod" && (w = x.div.neg()), {
        div: w,
        mod: x.mod
      }) : (this.negative & a.negative) !== 0 ? (x = this.neg().divmod(a.neg(), c), c !== "div" && (_ = x.mod.neg(), p && _.negative !== 0 && _.isub(a)), {
        div: x.div,
        mod: _
      }) : a.length > this.length || this.cmp(a) < 0 ? {
        div: new n(0),
        mod: this
      } : a.length === 1 ? c === "div" ? {
        div: this.divn(a.words[0]),
        mod: null
      } : c === "mod" ? {
        div: null,
        mod: new n(this.modrn(a.words[0]))
      } : {
        div: this.divn(a.words[0]),
        mod: new n(this.modrn(a.words[0]))
      } : this._wordDiv(a, c);
    }, n.prototype.div = function(a) {
      return this.divmod(a, "div", !1).div;
    }, n.prototype.mod = function(a) {
      return this.divmod(a, "mod", !1).mod;
    }, n.prototype.umod = function(a) {
      return this.divmod(a, "mod", !0).mod;
    }, n.prototype.divRound = function(a) {
      var c = this.divmod(a);
      if (c.mod.isZero())
        return c.div;
      var p = c.div.negative !== 0 ? c.mod.isub(a) : c.mod, w = a.ushrn(1), _ = a.andln(1), x = p.cmp(w);
      return x < 0 || _ === 1 && x === 0 ? c.div : c.div.negative !== 0 ? c.div.isubn(1) : c.div.iaddn(1);
    }, n.prototype.modrn = function(a) {
      var c = a < 0;
      c && (a = -a), i(a <= 67108863);
      for (var p = (1 << 26) % a, w = 0, _ = this.length - 1; _ >= 0; _--)
        w = (p * w + (this.words[_] | 0)) % a;
      return c ? -w : w;
    }, n.prototype.modn = function(a) {
      return this.modrn(a);
    }, n.prototype.idivn = function(a) {
      var c = a < 0;
      c && (a = -a), i(a <= 67108863);
      for (var p = 0, w = this.length - 1; w >= 0; w--) {
        var _ = (this.words[w] | 0) + p * 67108864;
        this.words[w] = _ / a | 0, p = _ % a;
      }
      return this._strip(), c ? this.ineg() : this;
    }, n.prototype.divn = function(a) {
      return this.clone().idivn(a);
    }, n.prototype.egcd = function(a) {
      i(a.negative === 0), i(!a.isZero());
      var c = this, p = a.clone();
      c.negative !== 0 ? c = c.umod(a) : c = c.clone();
      for (var w = new n(1), _ = new n(0), x = new n(0), E = new n(1), y = 0; c.isEven() && p.isEven(); )
        c.iushrn(1), p.iushrn(1), ++y;
      for (var o = p.clone(), S = c.clone(); !c.isZero(); ) {
        for (var J = 0, z = 1; (c.words[0] & z) === 0 && J < 26; ++J, z <<= 1)
          ;
        if (J > 0)
          for (c.iushrn(J); J-- > 0; )
            (w.isOdd() || _.isOdd()) && (w.iadd(o), _.isub(S)), w.iushrn(1), _.iushrn(1);
        for (var k = 0, j = 1; (p.words[0] & j) === 0 && k < 26; ++k, j <<= 1)
          ;
        if (k > 0)
          for (p.iushrn(k); k-- > 0; )
            (x.isOdd() || E.isOdd()) && (x.iadd(o), E.isub(S)), x.iushrn(1), E.iushrn(1);
        c.cmp(p) >= 0 ? (c.isub(p), w.isub(x), _.isub(E)) : (p.isub(c), x.isub(w), E.isub(_));
      }
      return {
        a: x,
        b: E,
        gcd: p.iushln(y)
      };
    }, n.prototype._invmp = function(a) {
      i(a.negative === 0), i(!a.isZero());
      var c = this, p = a.clone();
      c.negative !== 0 ? c = c.umod(a) : c = c.clone();
      for (var w = new n(1), _ = new n(0), x = p.clone(); c.cmpn(1) > 0 && p.cmpn(1) > 0; ) {
        for (var E = 0, y = 1; (c.words[0] & y) === 0 && E < 26; ++E, y <<= 1)
          ;
        if (E > 0)
          for (c.iushrn(E); E-- > 0; )
            w.isOdd() && w.iadd(x), w.iushrn(1);
        for (var o = 0, S = 1; (p.words[0] & S) === 0 && o < 26; ++o, S <<= 1)
          ;
        if (o > 0)
          for (p.iushrn(o); o-- > 0; )
            _.isOdd() && _.iadd(x), _.iushrn(1);
        c.cmp(p) >= 0 ? (c.isub(p), w.isub(_)) : (p.isub(c), _.isub(w));
      }
      var J;
      return c.cmpn(1) === 0 ? J = w : J = _, J.cmpn(0) < 0 && J.iadd(a), J;
    }, n.prototype.gcd = function(a) {
      if (this.isZero())
        return a.abs();
      if (a.isZero())
        return this.abs();
      var c = this.clone(), p = a.clone();
      c.negative = 0, p.negative = 0;
      for (var w = 0; c.isEven() && p.isEven(); w++)
        c.iushrn(1), p.iushrn(1);
      do {
        for (; c.isEven(); )
          c.iushrn(1);
        for (; p.isEven(); )
          p.iushrn(1);
        var _ = c.cmp(p);
        if (_ < 0) {
          var x = c;
          c = p, p = x;
        } else if (_ === 0 || p.cmpn(1) === 0)
          break;
        c.isub(p);
      } while (!0);
      return p.iushln(w);
    }, n.prototype.invm = function(a) {
      return this.egcd(a).a.umod(a);
    }, n.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, n.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, n.prototype.andln = function(a) {
      return this.words[0] & a;
    }, n.prototype.bincn = function(a) {
      i(typeof a == "number");
      var c = a % 26, p = (a - c) / 26, w = 1 << c;
      if (this.length <= p)
        return this._expand(p + 1), this.words[p] |= w, this;
      for (var _ = w, x = p; _ !== 0 && x < this.length; x++) {
        var E = this.words[x] | 0;
        E += _, _ = E >>> 26, E &= 67108863, this.words[x] = E;
      }
      return _ !== 0 && (this.words[x] = _, this.length++), this;
    }, n.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, n.prototype.cmpn = function(a) {
      var c = a < 0;
      if (this.negative !== 0 && !c)
        return -1;
      if (this.negative === 0 && c)
        return 1;
      this._strip();
      var p;
      if (this.length > 1)
        p = 1;
      else {
        c && (a = -a), i(a <= 67108863, "Number is too big");
        var w = this.words[0] | 0;
        p = w === a ? 0 : w < a ? -1 : 1;
      }
      return this.negative !== 0 ? -p | 0 : p;
    }, n.prototype.cmp = function(a) {
      if (this.negative !== 0 && a.negative === 0)
        return -1;
      if (this.negative === 0 && a.negative !== 0)
        return 1;
      var c = this.ucmp(a);
      return this.negative !== 0 ? -c | 0 : c;
    }, n.prototype.ucmp = function(a) {
      if (this.length > a.length)
        return 1;
      if (this.length < a.length)
        return -1;
      for (var c = 0, p = this.length - 1; p >= 0; p--) {
        var w = this.words[p] | 0, _ = a.words[p] | 0;
        if (w !== _) {
          w < _ ? c = -1 : w > _ && (c = 1);
          break;
        }
      }
      return c;
    }, n.prototype.gtn = function(a) {
      return this.cmpn(a) === 1;
    }, n.prototype.gt = function(a) {
      return this.cmp(a) === 1;
    }, n.prototype.gten = function(a) {
      return this.cmpn(a) >= 0;
    }, n.prototype.gte = function(a) {
      return this.cmp(a) >= 0;
    }, n.prototype.ltn = function(a) {
      return this.cmpn(a) === -1;
    }, n.prototype.lt = function(a) {
      return this.cmp(a) === -1;
    }, n.prototype.lten = function(a) {
      return this.cmpn(a) <= 0;
    }, n.prototype.lte = function(a) {
      return this.cmp(a) <= 0;
    }, n.prototype.eqn = function(a) {
      return this.cmpn(a) === 0;
    }, n.prototype.eq = function(a) {
      return this.cmp(a) === 0;
    }, n.red = function(a) {
      return new W(a);
    }, n.prototype.toRed = function(a) {
      return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), a.convertTo(this)._forceRed(a);
    }, n.prototype.fromRed = function() {
      return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, n.prototype._forceRed = function(a) {
      return this.red = a, this;
    }, n.prototype.forceRed = function(a) {
      return i(!this.red, "Already a number in reduction context"), this._forceRed(a);
    }, n.prototype.redAdd = function(a) {
      return i(this.red, "redAdd works only with red numbers"), this.red.add(this, a);
    }, n.prototype.redIAdd = function(a) {
      return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, a);
    }, n.prototype.redSub = function(a) {
      return i(this.red, "redSub works only with red numbers"), this.red.sub(this, a);
    }, n.prototype.redISub = function(a) {
      return i(this.red, "redISub works only with red numbers"), this.red.isub(this, a);
    }, n.prototype.redShl = function(a) {
      return i(this.red, "redShl works only with red numbers"), this.red.shl(this, a);
    }, n.prototype.redMul = function(a) {
      return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, a), this.red.mul(this, a);
    }, n.prototype.redIMul = function(a) {
      return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, a), this.red.imul(this, a);
    }, n.prototype.redSqr = function() {
      return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, n.prototype.redISqr = function() {
      return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, n.prototype.redSqrt = function() {
      return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, n.prototype.redInvm = function() {
      return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, n.prototype.redNeg = function() {
      return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, n.prototype.redPow = function(a) {
      return i(this.red && !a.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, a);
    };
    var Q = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Z(g, a) {
      this.name = g, this.p = new n(a, 16), this.n = this.p.bitLength(), this.k = new n(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Z.prototype._tmp = function() {
      var a = new n(null);
      return a.words = new Array(Math.ceil(this.n / 13)), a;
    }, Z.prototype.ireduce = function(a) {
      var c = a, p;
      do
        this.split(c, this.tmp), c = this.imulK(c), c = c.iadd(this.tmp), p = c.bitLength();
      while (p > this.n);
      var w = p < this.n ? -1 : c.ucmp(this.p);
      return w === 0 ? (c.words[0] = 0, c.length = 1) : w > 0 ? c.isub(this.p) : c.strip !== void 0 ? c.strip() : c._strip(), c;
    }, Z.prototype.split = function(a, c) {
      a.iushrn(this.n, 0, c);
    }, Z.prototype.imulK = function(a) {
      return a.imul(this.k);
    };
    function B() {
      Z.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    s(B, Z), B.prototype.split = function(a, c) {
      for (var p = 4194303, w = Math.min(a.length, 9), _ = 0; _ < w; _++)
        c.words[_] = a.words[_];
      if (c.length = w, a.length <= 9) {
        a.words[0] = 0, a.length = 1;
        return;
      }
      var x = a.words[9];
      for (c.words[c.length++] = x & p, _ = 10; _ < a.length; _++) {
        var E = a.words[_] | 0;
        a.words[_ - 10] = (E & p) << 4 | x >>> 22, x = E;
      }
      x >>>= 22, a.words[_ - 10] = x, x === 0 && a.length > 10 ? a.length -= 10 : a.length -= 9;
    }, B.prototype.imulK = function(a) {
      a.words[a.length] = 0, a.words[a.length + 1] = 0, a.length += 2;
      for (var c = 0, p = 0; p < a.length; p++) {
        var w = a.words[p] | 0;
        c += w * 977, a.words[p] = c & 67108863, c = w * 64 + (c / 67108864 | 0);
      }
      return a.words[a.length - 1] === 0 && (a.length--, a.words[a.length - 1] === 0 && a.length--), a;
    };
    function Y() {
      Z.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    s(Y, Z);
    function ae() {
      Z.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    s(ae, Z);
    function se() {
      Z.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    s(se, Z), se.prototype.imulK = function(a) {
      for (var c = 0, p = 0; p < a.length; p++) {
        var w = (a.words[p] | 0) * 19 + c, _ = w & 67108863;
        w >>>= 26, a.words[p] = _, c = w;
      }
      return c !== 0 && (a.words[a.length++] = c), a;
    }, n._prime = function(a) {
      if (Q[a])
        return Q[a];
      var c;
      if (a === "k256")
        c = new B();
      else if (a === "p224")
        c = new Y();
      else if (a === "p192")
        c = new ae();
      else if (a === "p25519")
        c = new se();
      else
        throw new Error("Unknown prime " + a);
      return Q[a] = c, c;
    };
    function W(g) {
      if (typeof g == "string") {
        var a = n._prime(g);
        this.m = a.p, this.prime = a;
      } else
        i(g.gtn(1), "modulus must be greater than 1"), this.m = g, this.prime = null;
    }
    W.prototype._verify1 = function(a) {
      i(a.negative === 0, "red works only with positives"), i(a.red, "red works only with red numbers");
    }, W.prototype._verify2 = function(a, c) {
      i((a.negative | c.negative) === 0, "red works only with positives"), i(
        a.red && a.red === c.red,
        "red works only with red numbers"
      );
    }, W.prototype.imod = function(a) {
      return this.prime ? this.prime.ireduce(a)._forceRed(this) : (l(a, a.umod(this.m)._forceRed(this)), a);
    }, W.prototype.neg = function(a) {
      return a.isZero() ? a.clone() : this.m.sub(a)._forceRed(this);
    }, W.prototype.add = function(a, c) {
      this._verify2(a, c);
      var p = a.add(c);
      return p.cmp(this.m) >= 0 && p.isub(this.m), p._forceRed(this);
    }, W.prototype.iadd = function(a, c) {
      this._verify2(a, c);
      var p = a.iadd(c);
      return p.cmp(this.m) >= 0 && p.isub(this.m), p;
    }, W.prototype.sub = function(a, c) {
      this._verify2(a, c);
      var p = a.sub(c);
      return p.cmpn(0) < 0 && p.iadd(this.m), p._forceRed(this);
    }, W.prototype.isub = function(a, c) {
      this._verify2(a, c);
      var p = a.isub(c);
      return p.cmpn(0) < 0 && p.iadd(this.m), p;
    }, W.prototype.shl = function(a, c) {
      return this._verify1(a), this.imod(a.ushln(c));
    }, W.prototype.imul = function(a, c) {
      return this._verify2(a, c), this.imod(a.imul(c));
    }, W.prototype.mul = function(a, c) {
      return this._verify2(a, c), this.imod(a.mul(c));
    }, W.prototype.isqr = function(a) {
      return this.imul(a, a.clone());
    }, W.prototype.sqr = function(a) {
      return this.mul(a, a);
    }, W.prototype.sqrt = function(a) {
      if (a.isZero())
        return a.clone();
      var c = this.m.andln(3);
      if (i(c % 2 === 1), c === 3) {
        var p = this.m.add(new n(1)).iushrn(2);
        return this.pow(a, p);
      }
      for (var w = this.m.subn(1), _ = 0; !w.isZero() && w.andln(1) === 0; )
        _++, w.iushrn(1);
      i(!w.isZero());
      var x = new n(1).toRed(this), E = x.redNeg(), y = this.m.subn(1).iushrn(1), o = this.m.bitLength();
      for (o = new n(2 * o * o).toRed(this); this.pow(o, y).cmp(E) !== 0; )
        o.redIAdd(E);
      for (var S = this.pow(o, w), J = this.pow(a, w.addn(1).iushrn(1)), z = this.pow(a, w), k = _; z.cmp(x) !== 0; ) {
        for (var j = z, q = 0; j.cmp(x) !== 0; q++)
          j = j.redSqr();
        i(q < k);
        var K = this.pow(S, new n(1).iushln(k - q - 1));
        J = J.redMul(K), S = K.redSqr(), z = z.redMul(S), k = q;
      }
      return J;
    }, W.prototype.invm = function(a) {
      var c = a._invmp(this.m);
      return c.negative !== 0 ? (c.negative = 0, this.imod(c).redNeg()) : this.imod(c);
    }, W.prototype.pow = function(a, c) {
      if (c.isZero())
        return new n(1).toRed(this);
      if (c.cmpn(1) === 0)
        return a.clone();
      var p = 4, w = new Array(1 << p);
      w[0] = new n(1).toRed(this), w[1] = a;
      for (var _ = 2; _ < w.length; _++)
        w[_] = this.mul(w[_ - 1], a);
      var x = w[0], E = 0, y = 0, o = c.bitLength() % 26;
      for (o === 0 && (o = 26), _ = c.length - 1; _ >= 0; _--) {
        for (var S = c.words[_], J = o - 1; J >= 0; J--) {
          var z = S >> J & 1;
          if (x !== w[0] && (x = this.sqr(x)), z === 0 && E === 0) {
            y = 0;
            continue;
          }
          E <<= 1, E |= z, y++, !(y !== p && (_ !== 0 || J !== 0)) && (x = this.mul(x, w[E]), y = 0, E = 0);
        }
        o = 26;
      }
      return x;
    }, W.prototype.convertTo = function(a) {
      var c = a.umod(this.m);
      return c === a ? c.clone() : c;
    }, W.prototype.convertFrom = function(a) {
      var c = a.clone();
      return c.red = null, c;
    }, n.mont = function(a) {
      return new C(a);
    };
    function C(g) {
      W.call(this, g), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new n(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    s(C, W), C.prototype.convertTo = function(a) {
      return this.imod(a.ushln(this.shift));
    }, C.prototype.convertFrom = function(a) {
      var c = this.imod(a.mul(this.rinv));
      return c.red = null, c;
    }, C.prototype.imul = function(a, c) {
      if (a.isZero() || c.isZero())
        return a.words[0] = 0, a.length = 1, a;
      var p = a.imul(c), w = p.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _ = p.isub(w).iushrn(this.shift), x = _;
      return _.cmp(this.m) >= 0 ? x = _.isub(this.m) : _.cmpn(0) < 0 && (x = _.iadd(this.m)), x._forceRed(this);
    }, C.prototype.mul = function(a, c) {
      if (a.isZero() || c.isZero())
        return new n(0)._forceRed(this);
      var p = a.mul(c), w = p.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _ = p.isub(w).iushrn(this.shift), x = _;
      return _.cmp(this.m) >= 0 ? x = _.isub(this.m) : _.cmpn(0) < 0 && (x = _.iadd(this.m)), x._forceRed(this);
    }, C.prototype.invm = function(a) {
      var c = this.imod(a._invmp(this.m).mul(this.r2));
      return c._forceRed(this);
    };
  })(t, nt);
})(hI);
const lJ = hI.exports, dJ = "bignumber/5.7.0";
var pJ = lJ.BN;
new Mr(dJ);
function vJ(t) {
  return new pJ(t, 36).toString(16);
}
const gJ = "strings/5.7.0", lI = new Mr(gJ);
var A0;
(function(t) {
  t.current = "", t.NFC = "NFC", t.NFD = "NFD", t.NFKC = "NFKC", t.NFKD = "NFKD";
})(A0 || (A0 = {}));
var pc;
(function(t) {
  t.UNEXPECTED_CONTINUE = "unexpected continuation byte", t.BAD_PREFIX = "bad codepoint prefix", t.OVERRUN = "string overrun", t.MISSING_CONTINUE = "missing continuation byte", t.OUT_OF_RANGE = "out of UTF-8 range", t.UTF16_SURROGATE = "UTF-16 surrogate", t.OVERLONG = "overlong representation";
})(pc || (pc = {}));
function bJ(t, e, r, i, s) {
  return lI.throwArgumentError(`invalid codepoint at offset ${e}; ${t}`, "bytes", r);
}
function dI(t, e, r, i, s) {
  if (t === pc.BAD_PREFIX || t === pc.UNEXPECTED_CONTINUE) {
    let n = 0;
    for (let f = e + 1; f < r.length && r[f] >> 6 === 2; f++)
      n++;
    return n;
  }
  return t === pc.OVERRUN ? r.length - e - 1 : 0;
}
function yJ(t, e, r, i, s) {
  return t === pc.OVERLONG ? (i.push(s), 0) : (i.push(65533), dI(t, e, r));
}
Object.freeze({
  error: bJ,
  ignore: dI,
  replace: yJ
});
function _g(t, e = A0.current) {
  e != A0.current && (lI.checkNormalize(), t = t.normalize(e));
  let r = [];
  for (let i = 0; i < t.length; i++) {
    const s = t.charCodeAt(i);
    if (s < 128)
      r.push(s);
    else if (s < 2048)
      r.push(s >> 6 | 192), r.push(s & 63 | 128);
    else if ((s & 64512) == 55296) {
      i++;
      const n = t.charCodeAt(i);
      if (i >= t.length || (n & 64512) !== 56320)
        throw new Error("invalid utf-8 string");
      const f = 65536 + ((s & 1023) << 10) + (n & 1023);
      r.push(f >> 18 | 240), r.push(f >> 12 & 63 | 128), r.push(f >> 6 & 63 | 128), r.push(f & 63 | 128);
    } else
      r.push(s >> 12 | 224), r.push(s >> 6 & 63 | 128), r.push(s & 63 | 128);
  }
  return ai(r);
}
const mJ = `Ethereum Signed Message:
`;
function pI(t) {
  return typeof t == "string" && (t = _g(t)), iw(cJ([
    _g(mJ),
    _g(String(t.length)),
    t
  ]));
}
const wJ = "address/5.7.0", Gu = new Mr(wJ);
function e5(t) {
  Zs(t, 20) || Gu.throwArgumentError("invalid address", "address", t), t = t.toLowerCase();
  const e = t.substring(2).split(""), r = new Uint8Array(40);
  for (let s = 0; s < 40; s++)
    r[s] = e[s].charCodeAt(0);
  const i = ai(iw(r));
  for (let s = 0; s < 40; s += 2)
    i[s >> 1] >> 4 >= 8 && (e[s] = e[s].toUpperCase()), (i[s >> 1] & 15) >= 8 && (e[s + 1] = e[s + 1].toUpperCase());
  return "0x" + e.join("");
}
const _J = 9007199254740991;
function MJ(t) {
  return Math.log10 ? Math.log10(t) : Math.log(t) / Math.LN10;
}
const nw = {};
for (let t = 0; t < 10; t++)
  nw[String(t)] = String(t);
for (let t = 0; t < 26; t++)
  nw[String.fromCharCode(65 + t)] = String(10 + t);
const t5 = Math.floor(MJ(_J));
function xJ(t) {
  t = t.toUpperCase(), t = t.substring(4) + t.substring(0, 2) + "00";
  let e = t.split("").map((i) => nw[i]).join("");
  for (; e.length >= t5; ) {
    let i = e.substring(0, t5);
    e = parseInt(i, 10) % 97 + e.substring(i.length);
  }
  let r = String(98 - parseInt(e, 10) % 97);
  for (; r.length < 2; )
    r = "0" + r;
  return r;
}
function SJ(t) {
  let e = null;
  if (typeof t != "string" && Gu.throwArgumentError("invalid address", "address", t), t.match(/^(0x)?[0-9a-fA-F]{40}$/))
    t.substring(0, 2) !== "0x" && (t = "0x" + t), e = e5(t), t.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && e !== t && Gu.throwArgumentError("bad address checksum", "address", t);
  else if (t.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
    for (t.substring(2, 4) !== xJ(t) && Gu.throwArgumentError("bad icap checksum", "address", t), e = vJ(t.substring(4)); e.length < 40; )
      e = "0" + e;
    e = e5("0x" + e);
  } else
    Gu.throwArgumentError("invalid address", "address", t);
  return e;
}
const EJ = "properties/5.7.0";
globalThis && globalThis.__awaiter;
new Mr(EJ);
function ju(t, e, r) {
  Object.defineProperty(t, e, {
    enumerable: !0,
    value: r,
    writable: !1
  });
}
var vI = { exports: {} };
(function(t) {
  (function(e, r) {
    function i(g, a) {
      if (!g)
        throw new Error(a || "Assertion failed");
    }
    function s(g, a) {
      g.super_ = a;
      var c = function() {
      };
      c.prototype = a.prototype, g.prototype = new c(), g.prototype.constructor = g;
    }
    function n(g, a, c) {
      if (n.isBN(g))
        return g;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, g !== null && ((a === "le" || a === "be") && (c = a, a = 10), this._init(g || 0, a || 10, c || "be"));
    }
    typeof e == "object" ? e.exports = n : r.BN = n, n.BN = n, n.wordSize = 26;
    var f;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? f = window.Buffer : f = dn.Buffer;
    } catch {
    }
    n.isBN = function(a) {
      return a instanceof n ? !0 : a !== null && typeof a == "object" && a.constructor.wordSize === n.wordSize && Array.isArray(a.words);
    }, n.max = function(a, c) {
      return a.cmp(c) > 0 ? a : c;
    }, n.min = function(a, c) {
      return a.cmp(c) < 0 ? a : c;
    }, n.prototype._init = function(a, c, p) {
      if (typeof a == "number")
        return this._initNumber(a, c, p);
      if (typeof a == "object")
        return this._initArray(a, c, p);
      c === "hex" && (c = 16), i(c === (c | 0) && c >= 2 && c <= 36), a = a.toString().replace(/\s+/g, "");
      var w = 0;
      a[0] === "-" && (w++, this.negative = 1), w < a.length && (c === 16 ? this._parseHex(a, w, p) : (this._parseBase(a, c, w), p === "le" && this._initArray(this.toArray(), c, p)));
    }, n.prototype._initNumber = function(a, c, p) {
      a < 0 && (this.negative = 1, a = -a), a < 67108864 ? (this.words = [a & 67108863], this.length = 1) : a < 4503599627370496 ? (this.words = [
        a & 67108863,
        a / 67108864 & 67108863
      ], this.length = 2) : (i(a < 9007199254740992), this.words = [
        a & 67108863,
        a / 67108864 & 67108863,
        1
      ], this.length = 3), p === "le" && this._initArray(this.toArray(), c, p);
    }, n.prototype._initArray = function(a, c, p) {
      if (i(typeof a.length == "number"), a.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(a.length / 3), this.words = new Array(this.length);
      for (var w = 0; w < this.length; w++)
        this.words[w] = 0;
      var _, x, E = 0;
      if (p === "be")
        for (w = a.length - 1, _ = 0; w >= 0; w -= 3)
          x = a[w] | a[w - 1] << 8 | a[w - 2] << 16, this.words[_] |= x << E & 67108863, this.words[_ + 1] = x >>> 26 - E & 67108863, E += 24, E >= 26 && (E -= 26, _++);
      else if (p === "le")
        for (w = 0, _ = 0; w < a.length; w += 3)
          x = a[w] | a[w + 1] << 8 | a[w + 2] << 16, this.words[_] |= x << E & 67108863, this.words[_ + 1] = x >>> 26 - E & 67108863, E += 24, E >= 26 && (E -= 26, _++);
      return this._strip();
    };
    function u(g, a) {
      var c = g.charCodeAt(a);
      if (c >= 48 && c <= 57)
        return c - 48;
      if (c >= 65 && c <= 70)
        return c - 55;
      if (c >= 97 && c <= 102)
        return c - 87;
      i(!1, "Invalid character in " + g);
    }
    function h(g, a, c) {
      var p = u(g, c);
      return c - 1 >= a && (p |= u(g, c - 1) << 4), p;
    }
    n.prototype._parseHex = function(a, c, p) {
      this.length = Math.ceil((a.length - c) / 6), this.words = new Array(this.length);
      for (var w = 0; w < this.length; w++)
        this.words[w] = 0;
      var _ = 0, x = 0, E;
      if (p === "be")
        for (w = a.length - 1; w >= c; w -= 2)
          E = h(a, c, w) << _, this.words[x] |= E & 67108863, _ >= 18 ? (_ -= 18, x += 1, this.words[x] |= E >>> 26) : _ += 8;
      else {
        var y = a.length - c;
        for (w = y % 2 === 0 ? c + 1 : c; w < a.length; w += 2)
          E = h(a, c, w) << _, this.words[x] |= E & 67108863, _ >= 18 ? (_ -= 18, x += 1, this.words[x] |= E >>> 26) : _ += 8;
      }
      this._strip();
    };
    function d(g, a, c, p) {
      for (var w = 0, _ = 0, x = Math.min(g.length, c), E = a; E < x; E++) {
        var y = g.charCodeAt(E) - 48;
        w *= p, y >= 49 ? _ = y - 49 + 10 : y >= 17 ? _ = y - 17 + 10 : _ = y, i(y >= 0 && _ < p, "Invalid character"), w += _;
      }
      return w;
    }
    n.prototype._parseBase = function(a, c, p) {
      this.words = [0], this.length = 1;
      for (var w = 0, _ = 1; _ <= 67108863; _ *= c)
        w++;
      w--, _ = _ / c | 0;
      for (var x = a.length - p, E = x % w, y = Math.min(x, x - E) + p, o = 0, S = p; S < y; S += w)
        o = d(a, S, S + w, c), this.imuln(_), this.words[0] + o < 67108864 ? this.words[0] += o : this._iaddn(o);
      if (E !== 0) {
        var J = 1;
        for (o = d(a, S, a.length, c), S = 0; S < E; S++)
          J *= c;
        this.imuln(J), this.words[0] + o < 67108864 ? this.words[0] += o : this._iaddn(o);
      }
      this._strip();
    }, n.prototype.copy = function(a) {
      a.words = new Array(this.length);
      for (var c = 0; c < this.length; c++)
        a.words[c] = this.words[c];
      a.length = this.length, a.negative = this.negative, a.red = this.red;
    };
    function l(g, a) {
      g.words = a.words, g.length = a.length, g.negative = a.negative, g.red = a.red;
    }
    if (n.prototype._move = function(a) {
      l(a, this);
    }, n.prototype.clone = function() {
      var a = new n(null);
      return this.copy(a), a;
    }, n.prototype._expand = function(a) {
      for (; this.length < a; )
        this.words[this.length++] = 0;
      return this;
    }, n.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, n.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        n.prototype[Symbol.for("nodejs.util.inspect.custom")] = m;
      } catch {
        n.prototype.inspect = m;
      }
    else
      n.prototype.inspect = m;
    function m() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var b = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], M = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], A = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    n.prototype.toString = function(a, c) {
      a = a || 10, c = c | 0 || 1;
      var p;
      if (a === 16 || a === "hex") {
        p = "";
        for (var w = 0, _ = 0, x = 0; x < this.length; x++) {
          var E = this.words[x], y = ((E << w | _) & 16777215).toString(16);
          _ = E >>> 24 - w & 16777215, w += 2, w >= 26 && (w -= 26, x--), _ !== 0 || x !== this.length - 1 ? p = b[6 - y.length] + y + p : p = y + p;
        }
        for (_ !== 0 && (p = _.toString(16) + p); p.length % c !== 0; )
          p = "0" + p;
        return this.negative !== 0 && (p = "-" + p), p;
      }
      if (a === (a | 0) && a >= 2 && a <= 36) {
        var o = M[a], S = A[a];
        p = "";
        var J = this.clone();
        for (J.negative = 0; !J.isZero(); ) {
          var z = J.modrn(S).toString(a);
          J = J.idivn(S), J.isZero() ? p = z + p : p = b[o - z.length] + z + p;
        }
        for (this.isZero() && (p = "0" + p); p.length % c !== 0; )
          p = "0" + p;
        return this.negative !== 0 && (p = "-" + p), p;
      }
      i(!1, "Base should be between 2 and 36");
    }, n.prototype.toNumber = function() {
      var a = this.words[0];
      return this.length === 2 ? a += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? a += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -a : a;
    }, n.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, f && (n.prototype.toBuffer = function(a, c) {
      return this.toArrayLike(f, a, c);
    }), n.prototype.toArray = function(a, c) {
      return this.toArrayLike(Array, a, c);
    };
    var N = function(a, c) {
      return a.allocUnsafe ? a.allocUnsafe(c) : new a(c);
    };
    n.prototype.toArrayLike = function(a, c, p) {
      this._strip();
      var w = this.byteLength(), _ = p || Math.max(1, w);
      i(w <= _, "byte array longer than desired length"), i(_ > 0, "Requested array length <= 0");
      var x = N(a, _), E = c === "le" ? "LE" : "BE";
      return this["_toArrayLike" + E](x, w), x;
    }, n.prototype._toArrayLikeLE = function(a, c) {
      for (var p = 0, w = 0, _ = 0, x = 0; _ < this.length; _++) {
        var E = this.words[_] << x | w;
        a[p++] = E & 255, p < a.length && (a[p++] = E >> 8 & 255), p < a.length && (a[p++] = E >> 16 & 255), x === 6 ? (p < a.length && (a[p++] = E >> 24 & 255), w = 0, x = 0) : (w = E >>> 24, x += 2);
      }
      if (p < a.length)
        for (a[p++] = w; p < a.length; )
          a[p++] = 0;
    }, n.prototype._toArrayLikeBE = function(a, c) {
      for (var p = a.length - 1, w = 0, _ = 0, x = 0; _ < this.length; _++) {
        var E = this.words[_] << x | w;
        a[p--] = E & 255, p >= 0 && (a[p--] = E >> 8 & 255), p >= 0 && (a[p--] = E >> 16 & 255), x === 6 ? (p >= 0 && (a[p--] = E >> 24 & 255), w = 0, x = 0) : (w = E >>> 24, x += 2);
      }
      if (p >= 0)
        for (a[p--] = w; p >= 0; )
          a[p--] = 0;
    }, Math.clz32 ? n.prototype._countBits = function(a) {
      return 32 - Math.clz32(a);
    } : n.prototype._countBits = function(a) {
      var c = a, p = 0;
      return c >= 4096 && (p += 13, c >>>= 13), c >= 64 && (p += 7, c >>>= 7), c >= 8 && (p += 4, c >>>= 4), c >= 2 && (p += 2, c >>>= 2), p + c;
    }, n.prototype._zeroBits = function(a) {
      if (a === 0)
        return 26;
      var c = a, p = 0;
      return (c & 8191) === 0 && (p += 13, c >>>= 13), (c & 127) === 0 && (p += 7, c >>>= 7), (c & 15) === 0 && (p += 4, c >>>= 4), (c & 3) === 0 && (p += 2, c >>>= 2), (c & 1) === 0 && p++, p;
    }, n.prototype.bitLength = function() {
      var a = this.words[this.length - 1], c = this._countBits(a);
      return (this.length - 1) * 26 + c;
    };
    function R(g) {
      for (var a = new Array(g.bitLength()), c = 0; c < a.length; c++) {
        var p = c / 26 | 0, w = c % 26;
        a[c] = g.words[p] >>> w & 1;
      }
      return a;
    }
    n.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var a = 0, c = 0; c < this.length; c++) {
        var p = this._zeroBits(this.words[c]);
        if (a += p, p !== 26)
          break;
      }
      return a;
    }, n.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, n.prototype.toTwos = function(a) {
      return this.negative !== 0 ? this.abs().inotn(a).iaddn(1) : this.clone();
    }, n.prototype.fromTwos = function(a) {
      return this.testn(a - 1) ? this.notn(a).iaddn(1).ineg() : this.clone();
    }, n.prototype.isNeg = function() {
      return this.negative !== 0;
    }, n.prototype.neg = function() {
      return this.clone().ineg();
    }, n.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, n.prototype.iuor = function(a) {
      for (; this.length < a.length; )
        this.words[this.length++] = 0;
      for (var c = 0; c < a.length; c++)
        this.words[c] = this.words[c] | a.words[c];
      return this._strip();
    }, n.prototype.ior = function(a) {
      return i((this.negative | a.negative) === 0), this.iuor(a);
    }, n.prototype.or = function(a) {
      return this.length > a.length ? this.clone().ior(a) : a.clone().ior(this);
    }, n.prototype.uor = function(a) {
      return this.length > a.length ? this.clone().iuor(a) : a.clone().iuor(this);
    }, n.prototype.iuand = function(a) {
      var c;
      this.length > a.length ? c = a : c = this;
      for (var p = 0; p < c.length; p++)
        this.words[p] = this.words[p] & a.words[p];
      return this.length = c.length, this._strip();
    }, n.prototype.iand = function(a) {
      return i((this.negative | a.negative) === 0), this.iuand(a);
    }, n.prototype.and = function(a) {
      return this.length > a.length ? this.clone().iand(a) : a.clone().iand(this);
    }, n.prototype.uand = function(a) {
      return this.length > a.length ? this.clone().iuand(a) : a.clone().iuand(this);
    }, n.prototype.iuxor = function(a) {
      var c, p;
      this.length > a.length ? (c = this, p = a) : (c = a, p = this);
      for (var w = 0; w < p.length; w++)
        this.words[w] = c.words[w] ^ p.words[w];
      if (this !== c)
        for (; w < c.length; w++)
          this.words[w] = c.words[w];
      return this.length = c.length, this._strip();
    }, n.prototype.ixor = function(a) {
      return i((this.negative | a.negative) === 0), this.iuxor(a);
    }, n.prototype.xor = function(a) {
      return this.length > a.length ? this.clone().ixor(a) : a.clone().ixor(this);
    }, n.prototype.uxor = function(a) {
      return this.length > a.length ? this.clone().iuxor(a) : a.clone().iuxor(this);
    }, n.prototype.inotn = function(a) {
      i(typeof a == "number" && a >= 0);
      var c = Math.ceil(a / 26) | 0, p = a % 26;
      this._expand(c), p > 0 && c--;
      for (var w = 0; w < c; w++)
        this.words[w] = ~this.words[w] & 67108863;
      return p > 0 && (this.words[w] = ~this.words[w] & 67108863 >> 26 - p), this._strip();
    }, n.prototype.notn = function(a) {
      return this.clone().inotn(a);
    }, n.prototype.setn = function(a, c) {
      i(typeof a == "number" && a >= 0);
      var p = a / 26 | 0, w = a % 26;
      return this._expand(p + 1), c ? this.words[p] = this.words[p] | 1 << w : this.words[p] = this.words[p] & ~(1 << w), this._strip();
    }, n.prototype.iadd = function(a) {
      var c;
      if (this.negative !== 0 && a.negative === 0)
        return this.negative = 0, c = this.isub(a), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && a.negative !== 0)
        return a.negative = 0, c = this.isub(a), a.negative = 1, c._normSign();
      var p, w;
      this.length > a.length ? (p = this, w = a) : (p = a, w = this);
      for (var _ = 0, x = 0; x < w.length; x++)
        c = (p.words[x] | 0) + (w.words[x] | 0) + _, this.words[x] = c & 67108863, _ = c >>> 26;
      for (; _ !== 0 && x < p.length; x++)
        c = (p.words[x] | 0) + _, this.words[x] = c & 67108863, _ = c >>> 26;
      if (this.length = p.length, _ !== 0)
        this.words[this.length] = _, this.length++;
      else if (p !== this)
        for (; x < p.length; x++)
          this.words[x] = p.words[x];
      return this;
    }, n.prototype.add = function(a) {
      var c;
      return a.negative !== 0 && this.negative === 0 ? (a.negative = 0, c = this.sub(a), a.negative ^= 1, c) : a.negative === 0 && this.negative !== 0 ? (this.negative = 0, c = a.sub(this), this.negative = 1, c) : this.length > a.length ? this.clone().iadd(a) : a.clone().iadd(this);
    }, n.prototype.isub = function(a) {
      if (a.negative !== 0) {
        a.negative = 0;
        var c = this.iadd(a);
        return a.negative = 1, c._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(a), this.negative = 1, this._normSign();
      var p = this.cmp(a);
      if (p === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var w, _;
      p > 0 ? (w = this, _ = a) : (w = a, _ = this);
      for (var x = 0, E = 0; E < _.length; E++)
        c = (w.words[E] | 0) - (_.words[E] | 0) + x, x = c >> 26, this.words[E] = c & 67108863;
      for (; x !== 0 && E < w.length; E++)
        c = (w.words[E] | 0) + x, x = c >> 26, this.words[E] = c & 67108863;
      if (x === 0 && E < w.length && w !== this)
        for (; E < w.length; E++)
          this.words[E] = w.words[E];
      return this.length = Math.max(this.length, E), w !== this && (this.negative = 1), this._strip();
    }, n.prototype.sub = function(a) {
      return this.clone().isub(a);
    };
    function O(g, a, c) {
      c.negative = a.negative ^ g.negative;
      var p = g.length + a.length | 0;
      c.length = p, p = p - 1 | 0;
      var w = g.words[0] | 0, _ = a.words[0] | 0, x = w * _, E = x & 67108863, y = x / 67108864 | 0;
      c.words[0] = E;
      for (var o = 1; o < p; o++) {
        for (var S = y >>> 26, J = y & 67108863, z = Math.min(o, a.length - 1), k = Math.max(0, o - g.length + 1); k <= z; k++) {
          var j = o - k | 0;
          w = g.words[j] | 0, _ = a.words[k] | 0, x = w * _ + J, S += x / 67108864 | 0, J = x & 67108863;
        }
        c.words[o] = J | 0, y = S | 0;
      }
      return y !== 0 ? c.words[o] = y | 0 : c.length--, c._strip();
    }
    var P = function(a, c, p) {
      var w = a.words, _ = c.words, x = p.words, E = 0, y, o, S, J = w[0] | 0, z = J & 8191, k = J >>> 13, j = w[1] | 0, q = j & 8191, K = j >>> 13, U = w[2] | 0, T = U & 8191, D = U >>> 13, te = w[3] | 0, ne = te & 8191, le = te >>> 13, X = w[4] | 0, $ = X & 8191, V = X >>> 13, re = w[5] | 0, fe = re & 8191, ue = re >>> 13, me = w[6] | 0, be = me & 8191, ve = me >>> 13, Ge = w[7] | 0, ye = Ge & 8191, pe = Ge >>> 13, Je = w[8] | 0, Ie = Je & 8191, we = Je >>> 13, at = w[9] | 0, Oe = at & 8191, Ee = at >>> 13, ft = _[0] | 0, Le = ft & 8191, Pe = ft >>> 13, Mt = _[1] | 0, Ve = Mt & 8191, ke = Mt >>> 13, Et = _[2] | 0, Ke = Et & 8191, Be = Et >>> 13, dt = _[3] | 0, ze = dt & 8191, Te = dt >>> 13, pt = _[4] | 0, Fe = pt & 8191, Ae = pt >>> 13, bt = _[5] | 0, He = bt & 8191, Ne = bt >>> 13, yt = _[6] | 0, $e = yt & 8191, De = yt >>> 13, vt = _[7] | 0, je = vt & 8191, Ce = vt >>> 13, mt = _[8] | 0, Ze = mt & 8191, qe = mt >>> 13, Dt = _[9] | 0, We = Dt & 8191, Qe = Dt >>> 13;
      p.negative = a.negative ^ c.negative, p.length = 19, y = Math.imul(z, Le), o = Math.imul(z, Pe), o = o + Math.imul(k, Le) | 0, S = Math.imul(k, Pe);
      var Qt = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Qt >>> 26) | 0, Qt &= 67108863, y = Math.imul(q, Le), o = Math.imul(q, Pe), o = o + Math.imul(K, Le) | 0, S = Math.imul(K, Pe), y = y + Math.imul(z, Ve) | 0, o = o + Math.imul(z, ke) | 0, o = o + Math.imul(k, Ve) | 0, S = S + Math.imul(k, ke) | 0;
      var Zt = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Zt >>> 26) | 0, Zt &= 67108863, y = Math.imul(T, Le), o = Math.imul(T, Pe), o = o + Math.imul(D, Le) | 0, S = Math.imul(D, Pe), y = y + Math.imul(q, Ve) | 0, o = o + Math.imul(q, ke) | 0, o = o + Math.imul(K, Ve) | 0, S = S + Math.imul(K, ke) | 0, y = y + Math.imul(z, Ke) | 0, o = o + Math.imul(z, Be) | 0, o = o + Math.imul(k, Ke) | 0, S = S + Math.imul(k, Be) | 0;
      var Jt = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Jt >>> 26) | 0, Jt &= 67108863, y = Math.imul(ne, Le), o = Math.imul(ne, Pe), o = o + Math.imul(le, Le) | 0, S = Math.imul(le, Pe), y = y + Math.imul(T, Ve) | 0, o = o + Math.imul(T, ke) | 0, o = o + Math.imul(D, Ve) | 0, S = S + Math.imul(D, ke) | 0, y = y + Math.imul(q, Ke) | 0, o = o + Math.imul(q, Be) | 0, o = o + Math.imul(K, Ke) | 0, S = S + Math.imul(K, Be) | 0, y = y + Math.imul(z, ze) | 0, o = o + Math.imul(z, Te) | 0, o = o + Math.imul(k, ze) | 0, S = S + Math.imul(k, Te) | 0;
      var Xt = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Xt >>> 26) | 0, Xt &= 67108863, y = Math.imul($, Le), o = Math.imul($, Pe), o = o + Math.imul(V, Le) | 0, S = Math.imul(V, Pe), y = y + Math.imul(ne, Ve) | 0, o = o + Math.imul(ne, ke) | 0, o = o + Math.imul(le, Ve) | 0, S = S + Math.imul(le, ke) | 0, y = y + Math.imul(T, Ke) | 0, o = o + Math.imul(T, Be) | 0, o = o + Math.imul(D, Ke) | 0, S = S + Math.imul(D, Be) | 0, y = y + Math.imul(q, ze) | 0, o = o + Math.imul(q, Te) | 0, o = o + Math.imul(K, ze) | 0, S = S + Math.imul(K, Te) | 0, y = y + Math.imul(z, Fe) | 0, o = o + Math.imul(z, Ae) | 0, o = o + Math.imul(k, Fe) | 0, S = S + Math.imul(k, Ae) | 0;
      var kt = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, y = Math.imul(fe, Le), o = Math.imul(fe, Pe), o = o + Math.imul(ue, Le) | 0, S = Math.imul(ue, Pe), y = y + Math.imul($, Ve) | 0, o = o + Math.imul($, ke) | 0, o = o + Math.imul(V, Ve) | 0, S = S + Math.imul(V, ke) | 0, y = y + Math.imul(ne, Ke) | 0, o = o + Math.imul(ne, Be) | 0, o = o + Math.imul(le, Ke) | 0, S = S + Math.imul(le, Be) | 0, y = y + Math.imul(T, ze) | 0, o = o + Math.imul(T, Te) | 0, o = o + Math.imul(D, ze) | 0, S = S + Math.imul(D, Te) | 0, y = y + Math.imul(q, Fe) | 0, o = o + Math.imul(q, Ae) | 0, o = o + Math.imul(K, Fe) | 0, S = S + Math.imul(K, Ae) | 0, y = y + Math.imul(z, He) | 0, o = o + Math.imul(z, Ne) | 0, o = o + Math.imul(k, He) | 0, S = S + Math.imul(k, Ne) | 0;
      var ar = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (ar >>> 26) | 0, ar &= 67108863, y = Math.imul(be, Le), o = Math.imul(be, Pe), o = o + Math.imul(ve, Le) | 0, S = Math.imul(ve, Pe), y = y + Math.imul(fe, Ve) | 0, o = o + Math.imul(fe, ke) | 0, o = o + Math.imul(ue, Ve) | 0, S = S + Math.imul(ue, ke) | 0, y = y + Math.imul($, Ke) | 0, o = o + Math.imul($, Be) | 0, o = o + Math.imul(V, Ke) | 0, S = S + Math.imul(V, Be) | 0, y = y + Math.imul(ne, ze) | 0, o = o + Math.imul(ne, Te) | 0, o = o + Math.imul(le, ze) | 0, S = S + Math.imul(le, Te) | 0, y = y + Math.imul(T, Fe) | 0, o = o + Math.imul(T, Ae) | 0, o = o + Math.imul(D, Fe) | 0, S = S + Math.imul(D, Ae) | 0, y = y + Math.imul(q, He) | 0, o = o + Math.imul(q, Ne) | 0, o = o + Math.imul(K, He) | 0, S = S + Math.imul(K, Ne) | 0, y = y + Math.imul(z, $e) | 0, o = o + Math.imul(z, De) | 0, o = o + Math.imul(k, $e) | 0, S = S + Math.imul(k, De) | 0;
      var lr = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (lr >>> 26) | 0, lr &= 67108863, y = Math.imul(ye, Le), o = Math.imul(ye, Pe), o = o + Math.imul(pe, Le) | 0, S = Math.imul(pe, Pe), y = y + Math.imul(be, Ve) | 0, o = o + Math.imul(be, ke) | 0, o = o + Math.imul(ve, Ve) | 0, S = S + Math.imul(ve, ke) | 0, y = y + Math.imul(fe, Ke) | 0, o = o + Math.imul(fe, Be) | 0, o = o + Math.imul(ue, Ke) | 0, S = S + Math.imul(ue, Be) | 0, y = y + Math.imul($, ze) | 0, o = o + Math.imul($, Te) | 0, o = o + Math.imul(V, ze) | 0, S = S + Math.imul(V, Te) | 0, y = y + Math.imul(ne, Fe) | 0, o = o + Math.imul(ne, Ae) | 0, o = o + Math.imul(le, Fe) | 0, S = S + Math.imul(le, Ae) | 0, y = y + Math.imul(T, He) | 0, o = o + Math.imul(T, Ne) | 0, o = o + Math.imul(D, He) | 0, S = S + Math.imul(D, Ne) | 0, y = y + Math.imul(q, $e) | 0, o = o + Math.imul(q, De) | 0, o = o + Math.imul(K, $e) | 0, S = S + Math.imul(K, De) | 0, y = y + Math.imul(z, je) | 0, o = o + Math.imul(z, Ce) | 0, o = o + Math.imul(k, je) | 0, S = S + Math.imul(k, Ce) | 0;
      var or = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (or >>> 26) | 0, or &= 67108863, y = Math.imul(Ie, Le), o = Math.imul(Ie, Pe), o = o + Math.imul(we, Le) | 0, S = Math.imul(we, Pe), y = y + Math.imul(ye, Ve) | 0, o = o + Math.imul(ye, ke) | 0, o = o + Math.imul(pe, Ve) | 0, S = S + Math.imul(pe, ke) | 0, y = y + Math.imul(be, Ke) | 0, o = o + Math.imul(be, Be) | 0, o = o + Math.imul(ve, Ke) | 0, S = S + Math.imul(ve, Be) | 0, y = y + Math.imul(fe, ze) | 0, o = o + Math.imul(fe, Te) | 0, o = o + Math.imul(ue, ze) | 0, S = S + Math.imul(ue, Te) | 0, y = y + Math.imul($, Fe) | 0, o = o + Math.imul($, Ae) | 0, o = o + Math.imul(V, Fe) | 0, S = S + Math.imul(V, Ae) | 0, y = y + Math.imul(ne, He) | 0, o = o + Math.imul(ne, Ne) | 0, o = o + Math.imul(le, He) | 0, S = S + Math.imul(le, Ne) | 0, y = y + Math.imul(T, $e) | 0, o = o + Math.imul(T, De) | 0, o = o + Math.imul(D, $e) | 0, S = S + Math.imul(D, De) | 0, y = y + Math.imul(q, je) | 0, o = o + Math.imul(q, Ce) | 0, o = o + Math.imul(K, je) | 0, S = S + Math.imul(K, Ce) | 0, y = y + Math.imul(z, Ze) | 0, o = o + Math.imul(z, qe) | 0, o = o + Math.imul(k, Ze) | 0, S = S + Math.imul(k, qe) | 0;
      var dr = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (dr >>> 26) | 0, dr &= 67108863, y = Math.imul(Oe, Le), o = Math.imul(Oe, Pe), o = o + Math.imul(Ee, Le) | 0, S = Math.imul(Ee, Pe), y = y + Math.imul(Ie, Ve) | 0, o = o + Math.imul(Ie, ke) | 0, o = o + Math.imul(we, Ve) | 0, S = S + Math.imul(we, ke) | 0, y = y + Math.imul(ye, Ke) | 0, o = o + Math.imul(ye, Be) | 0, o = o + Math.imul(pe, Ke) | 0, S = S + Math.imul(pe, Be) | 0, y = y + Math.imul(be, ze) | 0, o = o + Math.imul(be, Te) | 0, o = o + Math.imul(ve, ze) | 0, S = S + Math.imul(ve, Te) | 0, y = y + Math.imul(fe, Fe) | 0, o = o + Math.imul(fe, Ae) | 0, o = o + Math.imul(ue, Fe) | 0, S = S + Math.imul(ue, Ae) | 0, y = y + Math.imul($, He) | 0, o = o + Math.imul($, Ne) | 0, o = o + Math.imul(V, He) | 0, S = S + Math.imul(V, Ne) | 0, y = y + Math.imul(ne, $e) | 0, o = o + Math.imul(ne, De) | 0, o = o + Math.imul(le, $e) | 0, S = S + Math.imul(le, De) | 0, y = y + Math.imul(T, je) | 0, o = o + Math.imul(T, Ce) | 0, o = o + Math.imul(D, je) | 0, S = S + Math.imul(D, Ce) | 0, y = y + Math.imul(q, Ze) | 0, o = o + Math.imul(q, qe) | 0, o = o + Math.imul(K, Ze) | 0, S = S + Math.imul(K, qe) | 0, y = y + Math.imul(z, We) | 0, o = o + Math.imul(z, Qe) | 0, o = o + Math.imul(k, We) | 0, S = S + Math.imul(k, Qe) | 0;
      var pr = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (pr >>> 26) | 0, pr &= 67108863, y = Math.imul(Oe, Ve), o = Math.imul(Oe, ke), o = o + Math.imul(Ee, Ve) | 0, S = Math.imul(Ee, ke), y = y + Math.imul(Ie, Ke) | 0, o = o + Math.imul(Ie, Be) | 0, o = o + Math.imul(we, Ke) | 0, S = S + Math.imul(we, Be) | 0, y = y + Math.imul(ye, ze) | 0, o = o + Math.imul(ye, Te) | 0, o = o + Math.imul(pe, ze) | 0, S = S + Math.imul(pe, Te) | 0, y = y + Math.imul(be, Fe) | 0, o = o + Math.imul(be, Ae) | 0, o = o + Math.imul(ve, Fe) | 0, S = S + Math.imul(ve, Ae) | 0, y = y + Math.imul(fe, He) | 0, o = o + Math.imul(fe, Ne) | 0, o = o + Math.imul(ue, He) | 0, S = S + Math.imul(ue, Ne) | 0, y = y + Math.imul($, $e) | 0, o = o + Math.imul($, De) | 0, o = o + Math.imul(V, $e) | 0, S = S + Math.imul(V, De) | 0, y = y + Math.imul(ne, je) | 0, o = o + Math.imul(ne, Ce) | 0, o = o + Math.imul(le, je) | 0, S = S + Math.imul(le, Ce) | 0, y = y + Math.imul(T, Ze) | 0, o = o + Math.imul(T, qe) | 0, o = o + Math.imul(D, Ze) | 0, S = S + Math.imul(D, qe) | 0, y = y + Math.imul(q, We) | 0, o = o + Math.imul(q, Qe) | 0, o = o + Math.imul(K, We) | 0, S = S + Math.imul(K, Qe) | 0;
      var fr = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (fr >>> 26) | 0, fr &= 67108863, y = Math.imul(Oe, Ke), o = Math.imul(Oe, Be), o = o + Math.imul(Ee, Ke) | 0, S = Math.imul(Ee, Be), y = y + Math.imul(Ie, ze) | 0, o = o + Math.imul(Ie, Te) | 0, o = o + Math.imul(we, ze) | 0, S = S + Math.imul(we, Te) | 0, y = y + Math.imul(ye, Fe) | 0, o = o + Math.imul(ye, Ae) | 0, o = o + Math.imul(pe, Fe) | 0, S = S + Math.imul(pe, Ae) | 0, y = y + Math.imul(be, He) | 0, o = o + Math.imul(be, Ne) | 0, o = o + Math.imul(ve, He) | 0, S = S + Math.imul(ve, Ne) | 0, y = y + Math.imul(fe, $e) | 0, o = o + Math.imul(fe, De) | 0, o = o + Math.imul(ue, $e) | 0, S = S + Math.imul(ue, De) | 0, y = y + Math.imul($, je) | 0, o = o + Math.imul($, Ce) | 0, o = o + Math.imul(V, je) | 0, S = S + Math.imul(V, Ce) | 0, y = y + Math.imul(ne, Ze) | 0, o = o + Math.imul(ne, qe) | 0, o = o + Math.imul(le, Ze) | 0, S = S + Math.imul(le, qe) | 0, y = y + Math.imul(T, We) | 0, o = o + Math.imul(T, Qe) | 0, o = o + Math.imul(D, We) | 0, S = S + Math.imul(D, Qe) | 0;
      var ur = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (ur >>> 26) | 0, ur &= 67108863, y = Math.imul(Oe, ze), o = Math.imul(Oe, Te), o = o + Math.imul(Ee, ze) | 0, S = Math.imul(Ee, Te), y = y + Math.imul(Ie, Fe) | 0, o = o + Math.imul(Ie, Ae) | 0, o = o + Math.imul(we, Fe) | 0, S = S + Math.imul(we, Ae) | 0, y = y + Math.imul(ye, He) | 0, o = o + Math.imul(ye, Ne) | 0, o = o + Math.imul(pe, He) | 0, S = S + Math.imul(pe, Ne) | 0, y = y + Math.imul(be, $e) | 0, o = o + Math.imul(be, De) | 0, o = o + Math.imul(ve, $e) | 0, S = S + Math.imul(ve, De) | 0, y = y + Math.imul(fe, je) | 0, o = o + Math.imul(fe, Ce) | 0, o = o + Math.imul(ue, je) | 0, S = S + Math.imul(ue, Ce) | 0, y = y + Math.imul($, Ze) | 0, o = o + Math.imul($, qe) | 0, o = o + Math.imul(V, Ze) | 0, S = S + Math.imul(V, qe) | 0, y = y + Math.imul(ne, We) | 0, o = o + Math.imul(ne, Qe) | 0, o = o + Math.imul(le, We) | 0, S = S + Math.imul(le, Qe) | 0;
      var hr = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (hr >>> 26) | 0, hr &= 67108863, y = Math.imul(Oe, Fe), o = Math.imul(Oe, Ae), o = o + Math.imul(Ee, Fe) | 0, S = Math.imul(Ee, Ae), y = y + Math.imul(Ie, He) | 0, o = o + Math.imul(Ie, Ne) | 0, o = o + Math.imul(we, He) | 0, S = S + Math.imul(we, Ne) | 0, y = y + Math.imul(ye, $e) | 0, o = o + Math.imul(ye, De) | 0, o = o + Math.imul(pe, $e) | 0, S = S + Math.imul(pe, De) | 0, y = y + Math.imul(be, je) | 0, o = o + Math.imul(be, Ce) | 0, o = o + Math.imul(ve, je) | 0, S = S + Math.imul(ve, Ce) | 0, y = y + Math.imul(fe, Ze) | 0, o = o + Math.imul(fe, qe) | 0, o = o + Math.imul(ue, Ze) | 0, S = S + Math.imul(ue, qe) | 0, y = y + Math.imul($, We) | 0, o = o + Math.imul($, Qe) | 0, o = o + Math.imul(V, We) | 0, S = S + Math.imul(V, Qe) | 0;
      var qt = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (qt >>> 26) | 0, qt &= 67108863, y = Math.imul(Oe, He), o = Math.imul(Oe, Ne), o = o + Math.imul(Ee, He) | 0, S = Math.imul(Ee, Ne), y = y + Math.imul(Ie, $e) | 0, o = o + Math.imul(Ie, De) | 0, o = o + Math.imul(we, $e) | 0, S = S + Math.imul(we, De) | 0, y = y + Math.imul(ye, je) | 0, o = o + Math.imul(ye, Ce) | 0, o = o + Math.imul(pe, je) | 0, S = S + Math.imul(pe, Ce) | 0, y = y + Math.imul(be, Ze) | 0, o = o + Math.imul(be, qe) | 0, o = o + Math.imul(ve, Ze) | 0, S = S + Math.imul(ve, qe) | 0, y = y + Math.imul(fe, We) | 0, o = o + Math.imul(fe, Qe) | 0, o = o + Math.imul(ue, We) | 0, S = S + Math.imul(ue, Qe) | 0;
      var Er = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Er >>> 26) | 0, Er &= 67108863, y = Math.imul(Oe, $e), o = Math.imul(Oe, De), o = o + Math.imul(Ee, $e) | 0, S = Math.imul(Ee, De), y = y + Math.imul(Ie, je) | 0, o = o + Math.imul(Ie, Ce) | 0, o = o + Math.imul(we, je) | 0, S = S + Math.imul(we, Ce) | 0, y = y + Math.imul(ye, Ze) | 0, o = o + Math.imul(ye, qe) | 0, o = o + Math.imul(pe, Ze) | 0, S = S + Math.imul(pe, qe) | 0, y = y + Math.imul(be, We) | 0, o = o + Math.imul(be, Qe) | 0, o = o + Math.imul(ve, We) | 0, S = S + Math.imul(ve, Qe) | 0;
      var Ir = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Ir >>> 26) | 0, Ir &= 67108863, y = Math.imul(Oe, je), o = Math.imul(Oe, Ce), o = o + Math.imul(Ee, je) | 0, S = Math.imul(Ee, Ce), y = y + Math.imul(Ie, Ze) | 0, o = o + Math.imul(Ie, qe) | 0, o = o + Math.imul(we, Ze) | 0, S = S + Math.imul(we, qe) | 0, y = y + Math.imul(ye, We) | 0, o = o + Math.imul(ye, Qe) | 0, o = o + Math.imul(pe, We) | 0, S = S + Math.imul(pe, Qe) | 0;
      var Ar = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (Ar >>> 26) | 0, Ar &= 67108863, y = Math.imul(Oe, Ze), o = Math.imul(Oe, qe), o = o + Math.imul(Ee, Ze) | 0, S = Math.imul(Ee, qe), y = y + Math.imul(Ie, We) | 0, o = o + Math.imul(Ie, Qe) | 0, o = o + Math.imul(we, We) | 0, S = S + Math.imul(we, Qe) | 0;
      var qr = (E + y | 0) + ((o & 8191) << 13) | 0;
      E = (S + (o >>> 13) | 0) + (qr >>> 26) | 0, qr &= 67108863, y = Math.imul(Oe, We), o = Math.imul(Oe, Qe), o = o + Math.imul(Ee, We) | 0, S = Math.imul(Ee, Qe);
      var zr = (E + y | 0) + ((o & 8191) << 13) | 0;
      return E = (S + (o >>> 13) | 0) + (zr >>> 26) | 0, zr &= 67108863, x[0] = Qt, x[1] = Zt, x[2] = Jt, x[3] = Xt, x[4] = kt, x[5] = ar, x[6] = lr, x[7] = or, x[8] = dr, x[9] = pr, x[10] = fr, x[11] = ur, x[12] = hr, x[13] = qt, x[14] = Er, x[15] = Ir, x[16] = Ar, x[17] = qr, x[18] = zr, E !== 0 && (x[19] = E, p.length++), p;
    };
    Math.imul || (P = O);
    function F(g, a, c) {
      c.negative = a.negative ^ g.negative, c.length = g.length + a.length;
      for (var p = 0, w = 0, _ = 0; _ < c.length - 1; _++) {
        var x = w;
        w = 0;
        for (var E = p & 67108863, y = Math.min(_, a.length - 1), o = Math.max(0, _ - g.length + 1); o <= y; o++) {
          var S = _ - o, J = g.words[S] | 0, z = a.words[o] | 0, k = J * z, j = k & 67108863;
          x = x + (k / 67108864 | 0) | 0, j = j + E | 0, E = j & 67108863, x = x + (j >>> 26) | 0, w += x >>> 26, x &= 67108863;
        }
        c.words[_] = E, p = x, x = w;
      }
      return p !== 0 ? c.words[_] = p : c.length--, c._strip();
    }
    function H(g, a, c) {
      return F(g, a, c);
    }
    n.prototype.mulTo = function(a, c) {
      var p, w = this.length + a.length;
      return this.length === 10 && a.length === 10 ? p = P(this, a, c) : w < 63 ? p = O(this, a, c) : w < 1024 ? p = F(this, a, c) : p = H(this, a, c), p;
    }, n.prototype.mul = function(a) {
      var c = new n(null);
      return c.words = new Array(this.length + a.length), this.mulTo(a, c);
    }, n.prototype.mulf = function(a) {
      var c = new n(null);
      return c.words = new Array(this.length + a.length), H(this, a, c);
    }, n.prototype.imul = function(a) {
      return this.clone().mulTo(a, this);
    }, n.prototype.imuln = function(a) {
      var c = a < 0;
      c && (a = -a), i(typeof a == "number"), i(a < 67108864);
      for (var p = 0, w = 0; w < this.length; w++) {
        var _ = (this.words[w] | 0) * a, x = (_ & 67108863) + (p & 67108863);
        p >>= 26, p += _ / 67108864 | 0, p += x >>> 26, this.words[w] = x & 67108863;
      }
      return p !== 0 && (this.words[w] = p, this.length++), c ? this.ineg() : this;
    }, n.prototype.muln = function(a) {
      return this.clone().imuln(a);
    }, n.prototype.sqr = function() {
      return this.mul(this);
    }, n.prototype.isqr = function() {
      return this.imul(this.clone());
    }, n.prototype.pow = function(a) {
      var c = R(a);
      if (c.length === 0)
        return new n(1);
      for (var p = this, w = 0; w < c.length && c[w] === 0; w++, p = p.sqr())
        ;
      if (++w < c.length)
        for (var _ = p.sqr(); w < c.length; w++, _ = _.sqr())
          c[w] !== 0 && (p = p.mul(_));
      return p;
    }, n.prototype.iushln = function(a) {
      i(typeof a == "number" && a >= 0);
      var c = a % 26, p = (a - c) / 26, w = 67108863 >>> 26 - c << 26 - c, _;
      if (c !== 0) {
        var x = 0;
        for (_ = 0; _ < this.length; _++) {
          var E = this.words[_] & w, y = (this.words[_] | 0) - E << c;
          this.words[_] = y | x, x = E >>> 26 - c;
        }
        x && (this.words[_] = x, this.length++);
      }
      if (p !== 0) {
        for (_ = this.length - 1; _ >= 0; _--)
          this.words[_ + p] = this.words[_];
        for (_ = 0; _ < p; _++)
          this.words[_] = 0;
        this.length += p;
      }
      return this._strip();
    }, n.prototype.ishln = function(a) {
      return i(this.negative === 0), this.iushln(a);
    }, n.prototype.iushrn = function(a, c, p) {
      i(typeof a == "number" && a >= 0);
      var w;
      c ? w = (c - c % 26) / 26 : w = 0;
      var _ = a % 26, x = Math.min((a - _) / 26, this.length), E = 67108863 ^ 67108863 >>> _ << _, y = p;
      if (w -= x, w = Math.max(0, w), y) {
        for (var o = 0; o < x; o++)
          y.words[o] = this.words[o];
        y.length = x;
      }
      if (x !== 0)
        if (this.length > x)
          for (this.length -= x, o = 0; o < this.length; o++)
            this.words[o] = this.words[o + x];
        else
          this.words[0] = 0, this.length = 1;
      var S = 0;
      for (o = this.length - 1; o >= 0 && (S !== 0 || o >= w); o--) {
        var J = this.words[o] | 0;
        this.words[o] = S << 26 - _ | J >>> _, S = J & E;
      }
      return y && S !== 0 && (y.words[y.length++] = S), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, n.prototype.ishrn = function(a, c, p) {
      return i(this.negative === 0), this.iushrn(a, c, p);
    }, n.prototype.shln = function(a) {
      return this.clone().ishln(a);
    }, n.prototype.ushln = function(a) {
      return this.clone().iushln(a);
    }, n.prototype.shrn = function(a) {
      return this.clone().ishrn(a);
    }, n.prototype.ushrn = function(a) {
      return this.clone().iushrn(a);
    }, n.prototype.testn = function(a) {
      i(typeof a == "number" && a >= 0);
      var c = a % 26, p = (a - c) / 26, w = 1 << c;
      if (this.length <= p)
        return !1;
      var _ = this.words[p];
      return !!(_ & w);
    }, n.prototype.imaskn = function(a) {
      i(typeof a == "number" && a >= 0);
      var c = a % 26, p = (a - c) / 26;
      if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= p)
        return this;
      if (c !== 0 && p++, this.length = Math.min(p, this.length), c !== 0) {
        var w = 67108863 ^ 67108863 >>> c << c;
        this.words[this.length - 1] &= w;
      }
      return this._strip();
    }, n.prototype.maskn = function(a) {
      return this.clone().imaskn(a);
    }, n.prototype.iaddn = function(a) {
      return i(typeof a == "number"), i(a < 67108864), a < 0 ? this.isubn(-a) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= a ? (this.words[0] = a - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(a), this.negative = 1, this) : this._iaddn(a);
    }, n.prototype._iaddn = function(a) {
      this.words[0] += a;
      for (var c = 0; c < this.length && this.words[c] >= 67108864; c++)
        this.words[c] -= 67108864, c === this.length - 1 ? this.words[c + 1] = 1 : this.words[c + 1]++;
      return this.length = Math.max(this.length, c + 1), this;
    }, n.prototype.isubn = function(a) {
      if (i(typeof a == "number"), i(a < 67108864), a < 0)
        return this.iaddn(-a);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(a), this.negative = 1, this;
      if (this.words[0] -= a, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var c = 0; c < this.length && this.words[c] < 0; c++)
          this.words[c] += 67108864, this.words[c + 1] -= 1;
      return this._strip();
    }, n.prototype.addn = function(a) {
      return this.clone().iaddn(a);
    }, n.prototype.subn = function(a) {
      return this.clone().isubn(a);
    }, n.prototype.iabs = function() {
      return this.negative = 0, this;
    }, n.prototype.abs = function() {
      return this.clone().iabs();
    }, n.prototype._ishlnsubmul = function(a, c, p) {
      var w = a.length + p, _;
      this._expand(w);
      var x, E = 0;
      for (_ = 0; _ < a.length; _++) {
        x = (this.words[_ + p] | 0) + E;
        var y = (a.words[_] | 0) * c;
        x -= y & 67108863, E = (x >> 26) - (y / 67108864 | 0), this.words[_ + p] = x & 67108863;
      }
      for (; _ < this.length - p; _++)
        x = (this.words[_ + p] | 0) + E, E = x >> 26, this.words[_ + p] = x & 67108863;
      if (E === 0)
        return this._strip();
      for (i(E === -1), E = 0, _ = 0; _ < this.length; _++)
        x = -(this.words[_] | 0) + E, E = x >> 26, this.words[_] = x & 67108863;
      return this.negative = 1, this._strip();
    }, n.prototype._wordDiv = function(a, c) {
      var p = this.length - a.length, w = this.clone(), _ = a, x = _.words[_.length - 1] | 0, E = this._countBits(x);
      p = 26 - E, p !== 0 && (_ = _.ushln(p), w.iushln(p), x = _.words[_.length - 1] | 0);
      var y = w.length - _.length, o;
      if (c !== "mod") {
        o = new n(null), o.length = y + 1, o.words = new Array(o.length);
        for (var S = 0; S < o.length; S++)
          o.words[S] = 0;
      }
      var J = w.clone()._ishlnsubmul(_, 1, y);
      J.negative === 0 && (w = J, o && (o.words[y] = 1));
      for (var z = y - 1; z >= 0; z--) {
        var k = (w.words[_.length + z] | 0) * 67108864 + (w.words[_.length + z - 1] | 0);
        for (k = Math.min(k / x | 0, 67108863), w._ishlnsubmul(_, k, z); w.negative !== 0; )
          k--, w.negative = 0, w._ishlnsubmul(_, 1, z), w.isZero() || (w.negative ^= 1);
        o && (o.words[z] = k);
      }
      return o && o._strip(), w._strip(), c !== "div" && p !== 0 && w.iushrn(p), {
        div: o || null,
        mod: w
      };
    }, n.prototype.divmod = function(a, c, p) {
      if (i(!a.isZero()), this.isZero())
        return {
          div: new n(0),
          mod: new n(0)
        };
      var w, _, x;
      return this.negative !== 0 && a.negative === 0 ? (x = this.neg().divmod(a, c), c !== "mod" && (w = x.div.neg()), c !== "div" && (_ = x.mod.neg(), p && _.negative !== 0 && _.iadd(a)), {
        div: w,
        mod: _
      }) : this.negative === 0 && a.negative !== 0 ? (x = this.divmod(a.neg(), c), c !== "mod" && (w = x.div.neg()), {
        div: w,
        mod: x.mod
      }) : (this.negative & a.negative) !== 0 ? (x = this.neg().divmod(a.neg(), c), c !== "div" && (_ = x.mod.neg(), p && _.negative !== 0 && _.isub(a)), {
        div: x.div,
        mod: _
      }) : a.length > this.length || this.cmp(a) < 0 ? {
        div: new n(0),
        mod: this
      } : a.length === 1 ? c === "div" ? {
        div: this.divn(a.words[0]),
        mod: null
      } : c === "mod" ? {
        div: null,
        mod: new n(this.modrn(a.words[0]))
      } : {
        div: this.divn(a.words[0]),
        mod: new n(this.modrn(a.words[0]))
      } : this._wordDiv(a, c);
    }, n.prototype.div = function(a) {
      return this.divmod(a, "div", !1).div;
    }, n.prototype.mod = function(a) {
      return this.divmod(a, "mod", !1).mod;
    }, n.prototype.umod = function(a) {
      return this.divmod(a, "mod", !0).mod;
    }, n.prototype.divRound = function(a) {
      var c = this.divmod(a);
      if (c.mod.isZero())
        return c.div;
      var p = c.div.negative !== 0 ? c.mod.isub(a) : c.mod, w = a.ushrn(1), _ = a.andln(1), x = p.cmp(w);
      return x < 0 || _ === 1 && x === 0 ? c.div : c.div.negative !== 0 ? c.div.isubn(1) : c.div.iaddn(1);
    }, n.prototype.modrn = function(a) {
      var c = a < 0;
      c && (a = -a), i(a <= 67108863);
      for (var p = (1 << 26) % a, w = 0, _ = this.length - 1; _ >= 0; _--)
        w = (p * w + (this.words[_] | 0)) % a;
      return c ? -w : w;
    }, n.prototype.modn = function(a) {
      return this.modrn(a);
    }, n.prototype.idivn = function(a) {
      var c = a < 0;
      c && (a = -a), i(a <= 67108863);
      for (var p = 0, w = this.length - 1; w >= 0; w--) {
        var _ = (this.words[w] | 0) + p * 67108864;
        this.words[w] = _ / a | 0, p = _ % a;
      }
      return this._strip(), c ? this.ineg() : this;
    }, n.prototype.divn = function(a) {
      return this.clone().idivn(a);
    }, n.prototype.egcd = function(a) {
      i(a.negative === 0), i(!a.isZero());
      var c = this, p = a.clone();
      c.negative !== 0 ? c = c.umod(a) : c = c.clone();
      for (var w = new n(1), _ = new n(0), x = new n(0), E = new n(1), y = 0; c.isEven() && p.isEven(); )
        c.iushrn(1), p.iushrn(1), ++y;
      for (var o = p.clone(), S = c.clone(); !c.isZero(); ) {
        for (var J = 0, z = 1; (c.words[0] & z) === 0 && J < 26; ++J, z <<= 1)
          ;
        if (J > 0)
          for (c.iushrn(J); J-- > 0; )
            (w.isOdd() || _.isOdd()) && (w.iadd(o), _.isub(S)), w.iushrn(1), _.iushrn(1);
        for (var k = 0, j = 1; (p.words[0] & j) === 0 && k < 26; ++k, j <<= 1)
          ;
        if (k > 0)
          for (p.iushrn(k); k-- > 0; )
            (x.isOdd() || E.isOdd()) && (x.iadd(o), E.isub(S)), x.iushrn(1), E.iushrn(1);
        c.cmp(p) >= 0 ? (c.isub(p), w.isub(x), _.isub(E)) : (p.isub(c), x.isub(w), E.isub(_));
      }
      return {
        a: x,
        b: E,
        gcd: p.iushln(y)
      };
    }, n.prototype._invmp = function(a) {
      i(a.negative === 0), i(!a.isZero());
      var c = this, p = a.clone();
      c.negative !== 0 ? c = c.umod(a) : c = c.clone();
      for (var w = new n(1), _ = new n(0), x = p.clone(); c.cmpn(1) > 0 && p.cmpn(1) > 0; ) {
        for (var E = 0, y = 1; (c.words[0] & y) === 0 && E < 26; ++E, y <<= 1)
          ;
        if (E > 0)
          for (c.iushrn(E); E-- > 0; )
            w.isOdd() && w.iadd(x), w.iushrn(1);
        for (var o = 0, S = 1; (p.words[0] & S) === 0 && o < 26; ++o, S <<= 1)
          ;
        if (o > 0)
          for (p.iushrn(o); o-- > 0; )
            _.isOdd() && _.iadd(x), _.iushrn(1);
        c.cmp(p) >= 0 ? (c.isub(p), w.isub(_)) : (p.isub(c), _.isub(w));
      }
      var J;
      return c.cmpn(1) === 0 ? J = w : J = _, J.cmpn(0) < 0 && J.iadd(a), J;
    }, n.prototype.gcd = function(a) {
      if (this.isZero())
        return a.abs();
      if (a.isZero())
        return this.abs();
      var c = this.clone(), p = a.clone();
      c.negative = 0, p.negative = 0;
      for (var w = 0; c.isEven() && p.isEven(); w++)
        c.iushrn(1), p.iushrn(1);
      do {
        for (; c.isEven(); )
          c.iushrn(1);
        for (; p.isEven(); )
          p.iushrn(1);
        var _ = c.cmp(p);
        if (_ < 0) {
          var x = c;
          c = p, p = x;
        } else if (_ === 0 || p.cmpn(1) === 0)
          break;
        c.isub(p);
      } while (!0);
      return p.iushln(w);
    }, n.prototype.invm = function(a) {
      return this.egcd(a).a.umod(a);
    }, n.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, n.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, n.prototype.andln = function(a) {
      return this.words[0] & a;
    }, n.prototype.bincn = function(a) {
      i(typeof a == "number");
      var c = a % 26, p = (a - c) / 26, w = 1 << c;
      if (this.length <= p)
        return this._expand(p + 1), this.words[p] |= w, this;
      for (var _ = w, x = p; _ !== 0 && x < this.length; x++) {
        var E = this.words[x] | 0;
        E += _, _ = E >>> 26, E &= 67108863, this.words[x] = E;
      }
      return _ !== 0 && (this.words[x] = _, this.length++), this;
    }, n.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, n.prototype.cmpn = function(a) {
      var c = a < 0;
      if (this.negative !== 0 && !c)
        return -1;
      if (this.negative === 0 && c)
        return 1;
      this._strip();
      var p;
      if (this.length > 1)
        p = 1;
      else {
        c && (a = -a), i(a <= 67108863, "Number is too big");
        var w = this.words[0] | 0;
        p = w === a ? 0 : w < a ? -1 : 1;
      }
      return this.negative !== 0 ? -p | 0 : p;
    }, n.prototype.cmp = function(a) {
      if (this.negative !== 0 && a.negative === 0)
        return -1;
      if (this.negative === 0 && a.negative !== 0)
        return 1;
      var c = this.ucmp(a);
      return this.negative !== 0 ? -c | 0 : c;
    }, n.prototype.ucmp = function(a) {
      if (this.length > a.length)
        return 1;
      if (this.length < a.length)
        return -1;
      for (var c = 0, p = this.length - 1; p >= 0; p--) {
        var w = this.words[p] | 0, _ = a.words[p] | 0;
        if (w !== _) {
          w < _ ? c = -1 : w > _ && (c = 1);
          break;
        }
      }
      return c;
    }, n.prototype.gtn = function(a) {
      return this.cmpn(a) === 1;
    }, n.prototype.gt = function(a) {
      return this.cmp(a) === 1;
    }, n.prototype.gten = function(a) {
      return this.cmpn(a) >= 0;
    }, n.prototype.gte = function(a) {
      return this.cmp(a) >= 0;
    }, n.prototype.ltn = function(a) {
      return this.cmpn(a) === -1;
    }, n.prototype.lt = function(a) {
      return this.cmp(a) === -1;
    }, n.prototype.lten = function(a) {
      return this.cmpn(a) <= 0;
    }, n.prototype.lte = function(a) {
      return this.cmp(a) <= 0;
    }, n.prototype.eqn = function(a) {
      return this.cmpn(a) === 0;
    }, n.prototype.eq = function(a) {
      return this.cmp(a) === 0;
    }, n.red = function(a) {
      return new W(a);
    }, n.prototype.toRed = function(a) {
      return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), a.convertTo(this)._forceRed(a);
    }, n.prototype.fromRed = function() {
      return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, n.prototype._forceRed = function(a) {
      return this.red = a, this;
    }, n.prototype.forceRed = function(a) {
      return i(!this.red, "Already a number in reduction context"), this._forceRed(a);
    }, n.prototype.redAdd = function(a) {
      return i(this.red, "redAdd works only with red numbers"), this.red.add(this, a);
    }, n.prototype.redIAdd = function(a) {
      return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, a);
    }, n.prototype.redSub = function(a) {
      return i(this.red, "redSub works only with red numbers"), this.red.sub(this, a);
    }, n.prototype.redISub = function(a) {
      return i(this.red, "redISub works only with red numbers"), this.red.isub(this, a);
    }, n.prototype.redShl = function(a) {
      return i(this.red, "redShl works only with red numbers"), this.red.shl(this, a);
    }, n.prototype.redMul = function(a) {
      return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, a), this.red.mul(this, a);
    }, n.prototype.redIMul = function(a) {
      return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, a), this.red.imul(this, a);
    }, n.prototype.redSqr = function() {
      return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, n.prototype.redISqr = function() {
      return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, n.prototype.redSqrt = function() {
      return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, n.prototype.redInvm = function() {
      return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, n.prototype.redNeg = function() {
      return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, n.prototype.redPow = function(a) {
      return i(this.red && !a.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, a);
    };
    var Q = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Z(g, a) {
      this.name = g, this.p = new n(a, 16), this.n = this.p.bitLength(), this.k = new n(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Z.prototype._tmp = function() {
      var a = new n(null);
      return a.words = new Array(Math.ceil(this.n / 13)), a;
    }, Z.prototype.ireduce = function(a) {
      var c = a, p;
      do
        this.split(c, this.tmp), c = this.imulK(c), c = c.iadd(this.tmp), p = c.bitLength();
      while (p > this.n);
      var w = p < this.n ? -1 : c.ucmp(this.p);
      return w === 0 ? (c.words[0] = 0, c.length = 1) : w > 0 ? c.isub(this.p) : c.strip !== void 0 ? c.strip() : c._strip(), c;
    }, Z.prototype.split = function(a, c) {
      a.iushrn(this.n, 0, c);
    }, Z.prototype.imulK = function(a) {
      return a.imul(this.k);
    };
    function B() {
      Z.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    s(B, Z), B.prototype.split = function(a, c) {
      for (var p = 4194303, w = Math.min(a.length, 9), _ = 0; _ < w; _++)
        c.words[_] = a.words[_];
      if (c.length = w, a.length <= 9) {
        a.words[0] = 0, a.length = 1;
        return;
      }
      var x = a.words[9];
      for (c.words[c.length++] = x & p, _ = 10; _ < a.length; _++) {
        var E = a.words[_] | 0;
        a.words[_ - 10] = (E & p) << 4 | x >>> 22, x = E;
      }
      x >>>= 22, a.words[_ - 10] = x, x === 0 && a.length > 10 ? a.length -= 10 : a.length -= 9;
    }, B.prototype.imulK = function(a) {
      a.words[a.length] = 0, a.words[a.length + 1] = 0, a.length += 2;
      for (var c = 0, p = 0; p < a.length; p++) {
        var w = a.words[p] | 0;
        c += w * 977, a.words[p] = c & 67108863, c = w * 64 + (c / 67108864 | 0);
      }
      return a.words[a.length - 1] === 0 && (a.length--, a.words[a.length - 1] === 0 && a.length--), a;
    };
    function Y() {
      Z.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    s(Y, Z);
    function ae() {
      Z.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    s(ae, Z);
    function se() {
      Z.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    s(se, Z), se.prototype.imulK = function(a) {
      for (var c = 0, p = 0; p < a.length; p++) {
        var w = (a.words[p] | 0) * 19 + c, _ = w & 67108863;
        w >>>= 26, a.words[p] = _, c = w;
      }
      return c !== 0 && (a.words[a.length++] = c), a;
    }, n._prime = function(a) {
      if (Q[a])
        return Q[a];
      var c;
      if (a === "k256")
        c = new B();
      else if (a === "p224")
        c = new Y();
      else if (a === "p192")
        c = new ae();
      else if (a === "p25519")
        c = new se();
      else
        throw new Error("Unknown prime " + a);
      return Q[a] = c, c;
    };
    function W(g) {
      if (typeof g == "string") {
        var a = n._prime(g);
        this.m = a.p, this.prime = a;
      } else
        i(g.gtn(1), "modulus must be greater than 1"), this.m = g, this.prime = null;
    }
    W.prototype._verify1 = function(a) {
      i(a.negative === 0, "red works only with positives"), i(a.red, "red works only with red numbers");
    }, W.prototype._verify2 = function(a, c) {
      i((a.negative | c.negative) === 0, "red works only with positives"), i(
        a.red && a.red === c.red,
        "red works only with red numbers"
      );
    }, W.prototype.imod = function(a) {
      return this.prime ? this.prime.ireduce(a)._forceRed(this) : (l(a, a.umod(this.m)._forceRed(this)), a);
    }, W.prototype.neg = function(a) {
      return a.isZero() ? a.clone() : this.m.sub(a)._forceRed(this);
    }, W.prototype.add = function(a, c) {
      this._verify2(a, c);
      var p = a.add(c);
      return p.cmp(this.m) >= 0 && p.isub(this.m), p._forceRed(this);
    }, W.prototype.iadd = function(a, c) {
      this._verify2(a, c);
      var p = a.iadd(c);
      return p.cmp(this.m) >= 0 && p.isub(this.m), p;
    }, W.prototype.sub = function(a, c) {
      this._verify2(a, c);
      var p = a.sub(c);
      return p.cmpn(0) < 0 && p.iadd(this.m), p._forceRed(this);
    }, W.prototype.isub = function(a, c) {
      this._verify2(a, c);
      var p = a.isub(c);
      return p.cmpn(0) < 0 && p.iadd(this.m), p;
    }, W.prototype.shl = function(a, c) {
      return this._verify1(a), this.imod(a.ushln(c));
    }, W.prototype.imul = function(a, c) {
      return this._verify2(a, c), this.imod(a.imul(c));
    }, W.prototype.mul = function(a, c) {
      return this._verify2(a, c), this.imod(a.mul(c));
    }, W.prototype.isqr = function(a) {
      return this.imul(a, a.clone());
    }, W.prototype.sqr = function(a) {
      return this.mul(a, a);
    }, W.prototype.sqrt = function(a) {
      if (a.isZero())
        return a.clone();
      var c = this.m.andln(3);
      if (i(c % 2 === 1), c === 3) {
        var p = this.m.add(new n(1)).iushrn(2);
        return this.pow(a, p);
      }
      for (var w = this.m.subn(1), _ = 0; !w.isZero() && w.andln(1) === 0; )
        _++, w.iushrn(1);
      i(!w.isZero());
      var x = new n(1).toRed(this), E = x.redNeg(), y = this.m.subn(1).iushrn(1), o = this.m.bitLength();
      for (o = new n(2 * o * o).toRed(this); this.pow(o, y).cmp(E) !== 0; )
        o.redIAdd(E);
      for (var S = this.pow(o, w), J = this.pow(a, w.addn(1).iushrn(1)), z = this.pow(a, w), k = _; z.cmp(x) !== 0; ) {
        for (var j = z, q = 0; j.cmp(x) !== 0; q++)
          j = j.redSqr();
        i(q < k);
        var K = this.pow(S, new n(1).iushln(k - q - 1));
        J = J.redMul(K), S = K.redSqr(), z = z.redMul(S), k = q;
      }
      return J;
    }, W.prototype.invm = function(a) {
      var c = a._invmp(this.m);
      return c.negative !== 0 ? (c.negative = 0, this.imod(c).redNeg()) : this.imod(c);
    }, W.prototype.pow = function(a, c) {
      if (c.isZero())
        return new n(1).toRed(this);
      if (c.cmpn(1) === 0)
        return a.clone();
      var p = 4, w = new Array(1 << p);
      w[0] = new n(1).toRed(this), w[1] = a;
      for (var _ = 2; _ < w.length; _++)
        w[_] = this.mul(w[_ - 1], a);
      var x = w[0], E = 0, y = 0, o = c.bitLength() % 26;
      for (o === 0 && (o = 26), _ = c.length - 1; _ >= 0; _--) {
        for (var S = c.words[_], J = o - 1; J >= 0; J--) {
          var z = S >> J & 1;
          if (x !== w[0] && (x = this.sqr(x)), z === 0 && E === 0) {
            y = 0;
            continue;
          }
          E <<= 1, E |= z, y++, !(y !== p && (_ !== 0 || J !== 0)) && (x = this.mul(x, w[E]), y = 0, E = 0);
        }
        o = 26;
      }
      return x;
    }, W.prototype.convertTo = function(a) {
      var c = a.umod(this.m);
      return c === a ? c.clone() : c;
    }, W.prototype.convertFrom = function(a) {
      var c = a.clone();
      return c.red = null, c;
    }, n.mont = function(a) {
      return new C(a);
    };
    function C(g) {
      W.call(this, g), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new n(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    s(C, W), C.prototype.convertTo = function(a) {
      return this.imod(a.ushln(this.shift));
    }, C.prototype.convertFrom = function(a) {
      var c = this.imod(a.mul(this.rinv));
      return c.red = null, c;
    }, C.prototype.imul = function(a, c) {
      if (a.isZero() || c.isZero())
        return a.words[0] = 0, a.length = 1, a;
      var p = a.imul(c), w = p.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _ = p.isub(w).iushrn(this.shift), x = _;
      return _.cmp(this.m) >= 0 ? x = _.isub(this.m) : _.cmpn(0) < 0 && (x = _.iadd(this.m)), x._forceRed(this);
    }, C.prototype.mul = function(a, c) {
      if (a.isZero() || c.isZero())
        return new n(0)._forceRed(this);
      var p = a.mul(c), w = p.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _ = p.isub(w).iushrn(this.shift), x = _;
      return _.cmp(this.m) >= 0 ? x = _.isub(this.m) : _.cmpn(0) < 0 && (x = _.iadd(this.m)), x._forceRed(this);
    }, C.prototype.invm = function(a) {
      var c = this.imod(a._invmp(this.m).mul(this.r2));
      return c._forceRed(this);
    };
  })(t, nt);
})(vI);
const jt = vI.exports;
var Ki = {}, rr = {}, Nn = gI;
function gI(t, e) {
  if (!t)
    throw new Error(e || "Assertion failed");
}
gI.equal = function(e, r, i) {
  if (e != r)
    throw new Error(i || "Assertion failed: " + e + " != " + r);
};
var IJ = Nn, AJ = It.exports;
rr.inherits = AJ;
function TJ(t, e) {
  return (t.charCodeAt(e) & 64512) !== 55296 || e < 0 || e + 1 >= t.length ? !1 : (t.charCodeAt(e + 1) & 64512) === 56320;
}
function NJ(t, e) {
  if (Array.isArray(t))
    return t.slice();
  if (!t)
    return [];
  var r = [];
  if (typeof t == "string")
    if (e) {
      if (e === "hex")
        for (t = t.replace(/[^a-z0-9]+/ig, ""), t.length % 2 !== 0 && (t = "0" + t), s = 0; s < t.length; s += 2)
          r.push(parseInt(t[s] + t[s + 1], 16));
    } else
      for (var i = 0, s = 0; s < t.length; s++) {
        var n = t.charCodeAt(s);
        n < 128 ? r[i++] = n : n < 2048 ? (r[i++] = n >> 6 | 192, r[i++] = n & 63 | 128) : TJ(t, s) ? (n = 65536 + ((n & 1023) << 10) + (t.charCodeAt(++s) & 1023), r[i++] = n >> 18 | 240, r[i++] = n >> 12 & 63 | 128, r[i++] = n >> 6 & 63 | 128, r[i++] = n & 63 | 128) : (r[i++] = n >> 12 | 224, r[i++] = n >> 6 & 63 | 128, r[i++] = n & 63 | 128);
      }
  else
    for (s = 0; s < t.length; s++)
      r[s] = t[s] | 0;
  return r;
}
rr.toArray = NJ;
function DJ(t) {
  for (var e = "", r = 0; r < t.length; r++)
    e += yI(t[r].toString(16));
  return e;
}
rr.toHex = DJ;
function bI(t) {
  var e = t >>> 24 | t >>> 8 & 65280 | t << 8 & 16711680 | (t & 255) << 24;
  return e >>> 0;
}
rr.htonl = bI;
function CJ(t, e) {
  for (var r = "", i = 0; i < t.length; i++) {
    var s = t[i];
    e === "little" && (s = bI(s)), r += mI(s.toString(16));
  }
  return r;
}
rr.toHex32 = CJ;
function yI(t) {
  return t.length === 1 ? "0" + t : t;
}
rr.zero2 = yI;
function mI(t) {
  return t.length === 7 ? "0" + t : t.length === 6 ? "00" + t : t.length === 5 ? "000" + t : t.length === 4 ? "0000" + t : t.length === 3 ? "00000" + t : t.length === 2 ? "000000" + t : t.length === 1 ? "0000000" + t : t;
}
rr.zero8 = mI;
function OJ(t, e, r, i) {
  var s = r - e;
  IJ(s % 4 === 0);
  for (var n = new Array(s / 4), f = 0, u = e; f < n.length; f++, u += 4) {
    var h;
    i === "big" ? h = t[u] << 24 | t[u + 1] << 16 | t[u + 2] << 8 | t[u + 3] : h = t[u + 3] << 24 | t[u + 2] << 16 | t[u + 1] << 8 | t[u], n[f] = h >>> 0;
  }
  return n;
}
rr.join32 = OJ;
function RJ(t, e) {
  for (var r = new Array(t.length * 4), i = 0, s = 0; i < t.length; i++, s += 4) {
    var n = t[i];
    e === "big" ? (r[s] = n >>> 24, r[s + 1] = n >>> 16 & 255, r[s + 2] = n >>> 8 & 255, r[s + 3] = n & 255) : (r[s + 3] = n >>> 24, r[s + 2] = n >>> 16 & 255, r[s + 1] = n >>> 8 & 255, r[s] = n & 255);
  }
  return r;
}
rr.split32 = RJ;
function LJ(t, e) {
  return t >>> e | t << 32 - e;
}
rr.rotr32 = LJ;
function PJ(t, e) {
  return t << e | t >>> 32 - e;
}
rr.rotl32 = PJ;
function kJ(t, e) {
  return t + e >>> 0;
}
rr.sum32 = kJ;
function jJ(t, e, r) {
  return t + e + r >>> 0;
}
rr.sum32_3 = jJ;
function BJ(t, e, r, i) {
  return t + e + r + i >>> 0;
}
rr.sum32_4 = BJ;
function zJ(t, e, r, i, s) {
  return t + e + r + i + s >>> 0;
}
rr.sum32_5 = zJ;
function UJ(t, e, r, i) {
  var s = t[e], n = t[e + 1], f = i + n >>> 0, u = (f < i ? 1 : 0) + r + s;
  t[e] = u >>> 0, t[e + 1] = f;
}
rr.sum64 = UJ;
function FJ(t, e, r, i) {
  var s = e + i >>> 0, n = (s < e ? 1 : 0) + t + r;
  return n >>> 0;
}
rr.sum64_hi = FJ;
function $J(t, e, r, i) {
  var s = e + i;
  return s >>> 0;
}
rr.sum64_lo = $J;
function qJ(t, e, r, i, s, n, f, u) {
  var h = 0, d = e;
  d = d + i >>> 0, h += d < e ? 1 : 0, d = d + n >>> 0, h += d < n ? 1 : 0, d = d + u >>> 0, h += d < u ? 1 : 0;
  var l = t + r + s + f + h;
  return l >>> 0;
}
rr.sum64_4_hi = qJ;
function HJ(t, e, r, i, s, n, f, u) {
  var h = e + i + n + u;
  return h >>> 0;
}
rr.sum64_4_lo = HJ;
function WJ(t, e, r, i, s, n, f, u, h, d) {
  var l = 0, m = e;
  m = m + i >>> 0, l += m < e ? 1 : 0, m = m + n >>> 0, l += m < n ? 1 : 0, m = m + u >>> 0, l += m < u ? 1 : 0, m = m + d >>> 0, l += m < d ? 1 : 0;
  var b = t + r + s + f + h + l;
  return b >>> 0;
}
rr.sum64_5_hi = WJ;
function VJ(t, e, r, i, s, n, f, u, h, d) {
  var l = e + i + n + u + d;
  return l >>> 0;
}
rr.sum64_5_lo = VJ;
function GJ(t, e, r) {
  var i = e << 32 - r | t >>> r;
  return i >>> 0;
}
rr.rotr64_hi = GJ;
function KJ(t, e, r) {
  var i = t << 32 - r | e >>> r;
  return i >>> 0;
}
rr.rotr64_lo = KJ;
function YJ(t, e, r) {
  return t >>> r;
}
rr.shr64_hi = YJ;
function QJ(t, e, r) {
  var i = t << 32 - r | e >>> r;
  return i >>> 0;
}
rr.shr64_lo = QJ;
var Kc = {}, r5 = rr, ZJ = Nn;
function jp() {
  this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
Kc.BlockHash = jp;
jp.prototype.update = function(e, r) {
  if (e = r5.toArray(e, r), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
    e = this.pending;
    var i = e.length % this._delta8;
    this.pending = e.slice(e.length - i, e.length), this.pending.length === 0 && (this.pending = null), e = r5.join32(e, 0, e.length - i, this.endian);
    for (var s = 0; s < e.length; s += this._delta32)
      this._update(e, s, s + this._delta32);
  }
  return this;
};
jp.prototype.digest = function(e) {
  return this.update(this._pad()), ZJ(this.pending === null), this._digest(e);
};
jp.prototype._pad = function() {
  var e = this.pendingTotal, r = this._delta8, i = r - (e + this.padLength) % r, s = new Array(i + this.padLength);
  s[0] = 128;
  for (var n = 1; n < i; n++)
    s[n] = 0;
  if (e <<= 3, this.endian === "big") {
    for (var f = 8; f < this.padLength; f++)
      s[n++] = 0;
    s[n++] = 0, s[n++] = 0, s[n++] = 0, s[n++] = 0, s[n++] = e >>> 24 & 255, s[n++] = e >>> 16 & 255, s[n++] = e >>> 8 & 255, s[n++] = e & 255;
  } else
    for (s[n++] = e & 255, s[n++] = e >>> 8 & 255, s[n++] = e >>> 16 & 255, s[n++] = e >>> 24 & 255, s[n++] = 0, s[n++] = 0, s[n++] = 0, s[n++] = 0, f = 8; f < this.padLength; f++)
      s[n++] = 0;
  return s;
};
var Yc = {}, fa = {}, JJ = rr, Js = JJ.rotr32;
function XJ(t, e, r, i) {
  if (t === 0)
    return wI(e, r, i);
  if (t === 1 || t === 3)
    return MI(e, r, i);
  if (t === 2)
    return _I(e, r, i);
}
fa.ft_1 = XJ;
function wI(t, e, r) {
  return t & e ^ ~t & r;
}
fa.ch32 = wI;
function _I(t, e, r) {
  return t & e ^ t & r ^ e & r;
}
fa.maj32 = _I;
function MI(t, e, r) {
  return t ^ e ^ r;
}
fa.p32 = MI;
function eX(t) {
  return Js(t, 2) ^ Js(t, 13) ^ Js(t, 22);
}
fa.s0_256 = eX;
function tX(t) {
  return Js(t, 6) ^ Js(t, 11) ^ Js(t, 25);
}
fa.s1_256 = tX;
function rX(t) {
  return Js(t, 7) ^ Js(t, 18) ^ t >>> 3;
}
fa.g0_256 = rX;
function iX(t) {
  return Js(t, 17) ^ Js(t, 19) ^ t >>> 10;
}
fa.g1_256 = iX;
var Dc = rr, nX = Kc, sX = fa, Mg = Dc.rotl32, Bu = Dc.sum32, aX = Dc.sum32_5, oX = sX.ft_1, xI = nX.BlockHash, fX = [
  1518500249,
  1859775393,
  2400959708,
  3395469782
];
function ra() {
  if (!(this instanceof ra))
    return new ra();
  xI.call(this), this.h = [
    1732584193,
    4023233417,
    2562383102,
    271733878,
    3285377520
  ], this.W = new Array(80);
}
Dc.inherits(ra, xI);
var cX = ra;
ra.blockSize = 512;
ra.outSize = 160;
ra.hmacStrength = 80;
ra.padLength = 64;
ra.prototype._update = function(e, r) {
  for (var i = this.W, s = 0; s < 16; s++)
    i[s] = e[r + s];
  for (; s < i.length; s++)
    i[s] = Mg(i[s - 3] ^ i[s - 8] ^ i[s - 14] ^ i[s - 16], 1);
  var n = this.h[0], f = this.h[1], u = this.h[2], h = this.h[3], d = this.h[4];
  for (s = 0; s < i.length; s++) {
    var l = ~~(s / 20), m = aX(Mg(n, 5), oX(l, f, u, h), d, i[s], fX[l]);
    d = h, h = u, u = Mg(f, 30), f = n, n = m;
  }
  this.h[0] = Bu(this.h[0], n), this.h[1] = Bu(this.h[1], f), this.h[2] = Bu(this.h[2], u), this.h[3] = Bu(this.h[3], h), this.h[4] = Bu(this.h[4], d);
};
ra.prototype._digest = function(e) {
  return e === "hex" ? Dc.toHex32(this.h, "big") : Dc.split32(this.h, "big");
};
var Cc = rr, uX = Kc, Qc = fa, hX = Nn, bs = Cc.sum32, lX = Cc.sum32_4, dX = Cc.sum32_5, pX = Qc.ch32, vX = Qc.maj32, gX = Qc.s0_256, bX = Qc.s1_256, yX = Qc.g0_256, mX = Qc.g1_256, SI = uX.BlockHash, wX = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
];
function ia() {
  if (!(this instanceof ia))
    return new ia();
  SI.call(this), this.h = [
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ], this.k = wX, this.W = new Array(64);
}
Cc.inherits(ia, SI);
var EI = ia;
ia.blockSize = 512;
ia.outSize = 256;
ia.hmacStrength = 192;
ia.padLength = 64;
ia.prototype._update = function(e, r) {
  for (var i = this.W, s = 0; s < 16; s++)
    i[s] = e[r + s];
  for (; s < i.length; s++)
    i[s] = lX(mX(i[s - 2]), i[s - 7], yX(i[s - 15]), i[s - 16]);
  var n = this.h[0], f = this.h[1], u = this.h[2], h = this.h[3], d = this.h[4], l = this.h[5], m = this.h[6], b = this.h[7];
  for (hX(this.k.length === i.length), s = 0; s < i.length; s++) {
    var M = dX(b, bX(d), pX(d, l, m), this.k[s], i[s]), A = bs(gX(n), vX(n, f, u));
    b = m, m = l, l = d, d = bs(h, M), h = u, u = f, f = n, n = bs(M, A);
  }
  this.h[0] = bs(this.h[0], n), this.h[1] = bs(this.h[1], f), this.h[2] = bs(this.h[2], u), this.h[3] = bs(this.h[3], h), this.h[4] = bs(this.h[4], d), this.h[5] = bs(this.h[5], l), this.h[6] = bs(this.h[6], m), this.h[7] = bs(this.h[7], b);
};
ia.prototype._digest = function(e) {
  return e === "hex" ? Cc.toHex32(this.h, "big") : Cc.split32(this.h, "big");
};
var xm = rr, II = EI;
function Ra() {
  if (!(this instanceof Ra))
    return new Ra();
  II.call(this), this.h = [
    3238371032,
    914150663,
    812702999,
    4144912697,
    4290775857,
    1750603025,
    1694076839,
    3204075428
  ];
}
xm.inherits(Ra, II);
var _X = Ra;
Ra.blockSize = 512;
Ra.outSize = 224;
Ra.hmacStrength = 192;
Ra.padLength = 64;
Ra.prototype._digest = function(e) {
  return e === "hex" ? xm.toHex32(this.h.slice(0, 7), "big") : xm.split32(this.h.slice(0, 7), "big");
};
var hn = rr, MX = Kc, xX = Nn, Xs = hn.rotr64_hi, ea = hn.rotr64_lo, AI = hn.shr64_hi, TI = hn.shr64_lo, Ya = hn.sum64, xg = hn.sum64_hi, Sg = hn.sum64_lo, SX = hn.sum64_4_hi, EX = hn.sum64_4_lo, IX = hn.sum64_5_hi, AX = hn.sum64_5_lo, NI = MX.BlockHash, TX = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
];
function As() {
  if (!(this instanceof As))
    return new As();
  NI.call(this), this.h = [
    1779033703,
    4089235720,
    3144134277,
    2227873595,
    1013904242,
    4271175723,
    2773480762,
    1595750129,
    1359893119,
    2917565137,
    2600822924,
    725511199,
    528734635,
    4215389547,
    1541459225,
    327033209
  ], this.k = TX, this.W = new Array(160);
}
hn.inherits(As, NI);
var DI = As;
As.blockSize = 1024;
As.outSize = 512;
As.hmacStrength = 192;
As.padLength = 128;
As.prototype._prepareBlock = function(e, r) {
  for (var i = this.W, s = 0; s < 32; s++)
    i[s] = e[r + s];
  for (; s < i.length; s += 2) {
    var n = zX(i[s - 4], i[s - 3]), f = UX(i[s - 4], i[s - 3]), u = i[s - 14], h = i[s - 13], d = jX(i[s - 30], i[s - 29]), l = BX(i[s - 30], i[s - 29]), m = i[s - 32], b = i[s - 31];
    i[s] = SX(
      n,
      f,
      u,
      h,
      d,
      l,
      m,
      b
    ), i[s + 1] = EX(
      n,
      f,
      u,
      h,
      d,
      l,
      m,
      b
    );
  }
};
As.prototype._update = function(e, r) {
  this._prepareBlock(e, r);
  var i = this.W, s = this.h[0], n = this.h[1], f = this.h[2], u = this.h[3], h = this.h[4], d = this.h[5], l = this.h[6], m = this.h[7], b = this.h[8], M = this.h[9], A = this.h[10], N = this.h[11], R = this.h[12], O = this.h[13], P = this.h[14], F = this.h[15];
  xX(this.k.length === i.length);
  for (var H = 0; H < i.length; H += 2) {
    var Q = P, Z = F, B = PX(b, M), Y = kX(b, M), ae = NX(b, M, A, N, R), se = DX(b, M, A, N, R, O), W = this.k[H], C = this.k[H + 1], g = i[H], a = i[H + 1], c = IX(
      Q,
      Z,
      B,
      Y,
      ae,
      se,
      W,
      C,
      g,
      a
    ), p = AX(
      Q,
      Z,
      B,
      Y,
      ae,
      se,
      W,
      C,
      g,
      a
    );
    Q = RX(s, n), Z = LX(s, n), B = CX(s, n, f, u, h), Y = OX(s, n, f, u, h, d);
    var w = xg(Q, Z, B, Y), _ = Sg(Q, Z, B, Y);
    P = R, F = O, R = A, O = N, A = b, N = M, b = xg(l, m, c, p), M = Sg(m, m, c, p), l = h, m = d, h = f, d = u, f = s, u = n, s = xg(c, p, w, _), n = Sg(c, p, w, _);
  }
  Ya(this.h, 0, s, n), Ya(this.h, 2, f, u), Ya(this.h, 4, h, d), Ya(this.h, 6, l, m), Ya(this.h, 8, b, M), Ya(this.h, 10, A, N), Ya(this.h, 12, R, O), Ya(this.h, 14, P, F);
};
As.prototype._digest = function(e) {
  return e === "hex" ? hn.toHex32(this.h, "big") : hn.split32(this.h, "big");
};
function NX(t, e, r, i, s) {
  var n = t & r ^ ~t & s;
  return n < 0 && (n += 4294967296), n;
}
function DX(t, e, r, i, s, n) {
  var f = e & i ^ ~e & n;
  return f < 0 && (f += 4294967296), f;
}
function CX(t, e, r, i, s) {
  var n = t & r ^ t & s ^ r & s;
  return n < 0 && (n += 4294967296), n;
}
function OX(t, e, r, i, s, n) {
  var f = e & i ^ e & n ^ i & n;
  return f < 0 && (f += 4294967296), f;
}
function RX(t, e) {
  var r = Xs(t, e, 28), i = Xs(e, t, 2), s = Xs(e, t, 7), n = r ^ i ^ s;
  return n < 0 && (n += 4294967296), n;
}
function LX(t, e) {
  var r = ea(t, e, 28), i = ea(e, t, 2), s = ea(e, t, 7), n = r ^ i ^ s;
  return n < 0 && (n += 4294967296), n;
}
function PX(t, e) {
  var r = Xs(t, e, 14), i = Xs(t, e, 18), s = Xs(e, t, 9), n = r ^ i ^ s;
  return n < 0 && (n += 4294967296), n;
}
function kX(t, e) {
  var r = ea(t, e, 14), i = ea(t, e, 18), s = ea(e, t, 9), n = r ^ i ^ s;
  return n < 0 && (n += 4294967296), n;
}
function jX(t, e) {
  var r = Xs(t, e, 1), i = Xs(t, e, 8), s = AI(t, e, 7), n = r ^ i ^ s;
  return n < 0 && (n += 4294967296), n;
}
function BX(t, e) {
  var r = ea(t, e, 1), i = ea(t, e, 8), s = TI(t, e, 7), n = r ^ i ^ s;
  return n < 0 && (n += 4294967296), n;
}
function zX(t, e) {
  var r = Xs(t, e, 19), i = Xs(e, t, 29), s = AI(t, e, 6), n = r ^ i ^ s;
  return n < 0 && (n += 4294967296), n;
}
function UX(t, e) {
  var r = ea(t, e, 19), i = ea(e, t, 29), s = TI(t, e, 6), n = r ^ i ^ s;
  return n < 0 && (n += 4294967296), n;
}
var Sm = rr, CI = DI;
function La() {
  if (!(this instanceof La))
    return new La();
  CI.call(this), this.h = [
    3418070365,
    3238371032,
    1654270250,
    914150663,
    2438529370,
    812702999,
    355462360,
    4144912697,
    1731405415,
    4290775857,
    2394180231,
    1750603025,
    3675008525,
    1694076839,
    1203062813,
    3204075428
  ];
}
Sm.inherits(La, CI);
var FX = La;
La.blockSize = 1024;
La.outSize = 384;
La.hmacStrength = 192;
La.padLength = 128;
La.prototype._digest = function(e) {
  return e === "hex" ? Sm.toHex32(this.h.slice(0, 12), "big") : Sm.split32(this.h.slice(0, 12), "big");
};
Yc.sha1 = cX;
Yc.sha224 = _X;
Yc.sha256 = EI;
Yc.sha384 = FX;
Yc.sha512 = DI;
var OI = {}, cf = rr, $X = Kc, Id = cf.rotl32, i5 = cf.sum32, zu = cf.sum32_3, n5 = cf.sum32_4, RI = $X.BlockHash;
function na() {
  if (!(this instanceof na))
    return new na();
  RI.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
}
cf.inherits(na, RI);
OI.ripemd160 = na;
na.blockSize = 512;
na.outSize = 160;
na.hmacStrength = 192;
na.padLength = 64;
na.prototype._update = function(e, r) {
  for (var i = this.h[0], s = this.h[1], n = this.h[2], f = this.h[3], u = this.h[4], h = i, d = s, l = n, m = f, b = u, M = 0; M < 80; M++) {
    var A = i5(
      Id(
        n5(i, s5(M, s, n, f), e[WX[M] + r], qX(M)),
        GX[M]
      ),
      u
    );
    i = u, u = f, f = Id(n, 10), n = s, s = A, A = i5(
      Id(
        n5(h, s5(79 - M, d, l, m), e[VX[M] + r], HX(M)),
        KX[M]
      ),
      b
    ), h = b, b = m, m = Id(l, 10), l = d, d = A;
  }
  A = zu(this.h[1], n, m), this.h[1] = zu(this.h[2], f, b), this.h[2] = zu(this.h[3], u, h), this.h[3] = zu(this.h[4], i, d), this.h[4] = zu(this.h[0], s, l), this.h[0] = A;
};
na.prototype._digest = function(e) {
  return e === "hex" ? cf.toHex32(this.h, "little") : cf.split32(this.h, "little");
};
function s5(t, e, r, i) {
  return t <= 15 ? e ^ r ^ i : t <= 31 ? e & r | ~e & i : t <= 47 ? (e | ~r) ^ i : t <= 63 ? e & i | r & ~i : e ^ (r | ~i);
}
function qX(t) {
  return t <= 15 ? 0 : t <= 31 ? 1518500249 : t <= 47 ? 1859775393 : t <= 63 ? 2400959708 : 2840853838;
}
function HX(t) {
  return t <= 15 ? 1352829926 : t <= 31 ? 1548603684 : t <= 47 ? 1836072691 : t <= 63 ? 2053994217 : 0;
}
var WX = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8,
  3,
  10,
  14,
  4,
  9,
  15,
  8,
  1,
  2,
  7,
  0,
  6,
  13,
  11,
  5,
  12,
  1,
  9,
  11,
  10,
  0,
  8,
  12,
  4,
  13,
  3,
  7,
  15,
  14,
  5,
  6,
  2,
  4,
  0,
  5,
  9,
  7,
  12,
  2,
  10,
  14,
  1,
  3,
  8,
  11,
  6,
  15,
  13
], VX = [
  5,
  14,
  7,
  0,
  9,
  2,
  11,
  4,
  13,
  6,
  15,
  8,
  1,
  10,
  3,
  12,
  6,
  11,
  3,
  7,
  0,
  13,
  5,
  10,
  14,
  15,
  8,
  12,
  4,
  9,
  1,
  2,
  15,
  5,
  1,
  3,
  7,
  14,
  6,
  9,
  11,
  8,
  12,
  2,
  10,
  0,
  4,
  13,
  8,
  6,
  4,
  1,
  3,
  11,
  15,
  0,
  5,
  12,
  2,
  13,
  9,
  7,
  10,
  14,
  12,
  15,
  10,
  4,
  1,
  5,
  8,
  7,
  6,
  2,
  13,
  14,
  0,
  3,
  9,
  11
], GX = [
  11,
  14,
  15,
  12,
  5,
  8,
  7,
  9,
  11,
  13,
  14,
  15,
  6,
  7,
  9,
  8,
  7,
  6,
  8,
  13,
  11,
  9,
  7,
  15,
  7,
  12,
  15,
  9,
  11,
  7,
  13,
  12,
  11,
  13,
  6,
  7,
  14,
  9,
  13,
  15,
  14,
  8,
  13,
  6,
  5,
  12,
  7,
  5,
  11,
  12,
  14,
  15,
  14,
  15,
  9,
  8,
  9,
  14,
  5,
  6,
  8,
  6,
  5,
  12,
  9,
  15,
  5,
  11,
  6,
  8,
  13,
  12,
  5,
  12,
  13,
  14,
  11,
  8,
  5,
  6
], KX = [
  8,
  9,
  9,
  11,
  13,
  15,
  15,
  5,
  7,
  7,
  8,
  11,
  14,
  14,
  12,
  6,
  9,
  13,
  15,
  7,
  12,
  8,
  9,
  11,
  7,
  7,
  12,
  7,
  6,
  15,
  13,
  11,
  9,
  7,
  15,
  11,
  8,
  6,
  6,
  14,
  12,
  13,
  5,
  14,
  13,
  13,
  7,
  5,
  15,
  5,
  8,
  11,
  14,
  14,
  6,
  14,
  6,
  9,
  12,
  9,
  12,
  5,
  15,
  8,
  8,
  5,
  12,
  9,
  12,
  5,
  14,
  6,
  8,
  13,
  6,
  5,
  15,
  13,
  11,
  11
], YX = rr, QX = Nn;
function Oc(t, e, r) {
  if (!(this instanceof Oc))
    return new Oc(t, e, r);
  this.Hash = t, this.blockSize = t.blockSize / 8, this.outSize = t.outSize / 8, this.inner = null, this.outer = null, this._init(YX.toArray(e, r));
}
var ZX = Oc;
Oc.prototype._init = function(e) {
  e.length > this.blockSize && (e = new this.Hash().update(e).digest()), QX(e.length <= this.blockSize);
  for (var r = e.length; r < this.blockSize; r++)
    e.push(0);
  for (r = 0; r < e.length; r++)
    e[r] ^= 54;
  for (this.inner = new this.Hash().update(e), r = 0; r < e.length; r++)
    e[r] ^= 106;
  this.outer = new this.Hash().update(e);
};
Oc.prototype.update = function(e, r) {
  return this.inner.update(e, r), this;
};
Oc.prototype.digest = function(e) {
  return this.outer.update(this.inner.digest()), this.outer.digest(e);
};
(function(t) {
  var e = t;
  e.utils = rr, e.common = Kc, e.sha = Yc, e.ripemd = OI, e.hmac = ZX, e.sha1 = e.sha.sha1, e.sha256 = e.sha.sha256, e.sha224 = e.sha.sha224, e.sha384 = e.sha.sha384, e.sha512 = e.sha.sha512, e.ripemd160 = e.ripemd.ripemd160;
})(Ki);
function Zc(t, e, r) {
  return r = {
    path: e,
    exports: {},
    require: function(i, s) {
      return JX(i, s == null ? r.path : s);
    }
  }, t(r, r.exports), r.exports;
}
function JX() {
  throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var sw = LI;
function LI(t, e) {
  if (!t)
    throw new Error(e || "Assertion failed");
}
LI.equal = function(e, r, i) {
  if (e != r)
    throw new Error(i || "Assertion failed: " + e + " != " + r);
};
var Es = Zc(function(t, e) {
  var r = e;
  function i(f, u) {
    if (Array.isArray(f))
      return f.slice();
    if (!f)
      return [];
    var h = [];
    if (typeof f != "string") {
      for (var d = 0; d < f.length; d++)
        h[d] = f[d] | 0;
      return h;
    }
    if (u === "hex") {
      f = f.replace(/[^a-z0-9]+/ig, ""), f.length % 2 !== 0 && (f = "0" + f);
      for (var d = 0; d < f.length; d += 2)
        h.push(parseInt(f[d] + f[d + 1], 16));
    } else
      for (var d = 0; d < f.length; d++) {
        var l = f.charCodeAt(d), m = l >> 8, b = l & 255;
        m ? h.push(m, b) : h.push(b);
      }
    return h;
  }
  r.toArray = i;
  function s(f) {
    return f.length === 1 ? "0" + f : f;
  }
  r.zero2 = s;
  function n(f) {
    for (var u = "", h = 0; h < f.length; h++)
      u += s(f[h].toString(16));
    return u;
  }
  r.toHex = n, r.encode = function(u, h) {
    return h === "hex" ? n(u) : u;
  };
}), Dn = Zc(function(t, e) {
  var r = e;
  r.assert = sw, r.toArray = Es.toArray, r.zero2 = Es.zero2, r.toHex = Es.toHex, r.encode = Es.encode;
  function i(h, d, l) {
    var m = new Array(Math.max(h.bitLength(), l) + 1);
    m.fill(0);
    for (var b = 1 << d + 1, M = h.clone(), A = 0; A < m.length; A++) {
      var N, R = M.andln(b - 1);
      M.isOdd() ? (R > (b >> 1) - 1 ? N = (b >> 1) - R : N = R, M.isubn(N)) : N = 0, m[A] = N, M.iushrn(1);
    }
    return m;
  }
  r.getNAF = i;
  function s(h, d) {
    var l = [
      [],
      []
    ];
    h = h.clone(), d = d.clone();
    for (var m = 0, b = 0, M; h.cmpn(-m) > 0 || d.cmpn(-b) > 0; ) {
      var A = h.andln(3) + m & 3, N = d.andln(3) + b & 3;
      A === 3 && (A = -1), N === 3 && (N = -1);
      var R;
      (A & 1) === 0 ? R = 0 : (M = h.andln(7) + m & 7, (M === 3 || M === 5) && N === 2 ? R = -A : R = A), l[0].push(R);
      var O;
      (N & 1) === 0 ? O = 0 : (M = d.andln(7) + b & 7, (M === 3 || M === 5) && A === 2 ? O = -N : O = N), l[1].push(O), 2 * m === R + 1 && (m = 1 - m), 2 * b === O + 1 && (b = 1 - b), h.iushrn(1), d.iushrn(1);
    }
    return l;
  }
  r.getJSF = s;
  function n(h, d, l) {
    var m = "_" + d;
    h.prototype[d] = function() {
      return this[m] !== void 0 ? this[m] : this[m] = l.call(this);
    };
  }
  r.cachedProperty = n;
  function f(h) {
    return typeof h == "string" ? r.toArray(h, "hex") : h;
  }
  r.parseBytes = f;
  function u(h) {
    return new jt(h, "hex", "le");
  }
  r.intFromLE = u;
}), T0 = Dn.getNAF, XX = Dn.getJSF, N0 = Dn.assert;
function go(t, e) {
  this.type = t, this.p = new jt(e.p, 16), this.red = e.prime ? jt.red(e.prime) : jt.mont(this.p), this.zero = new jt(0).toRed(this.red), this.one = new jt(1).toRed(this.red), this.two = new jt(2).toRed(this.red), this.n = e.n && new jt(e.n, 16), this.g = e.g && this.pointFromJSON(e.g, e.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
  var r = this.n && this.p.div(this.n);
  !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var wf = go;
go.prototype.point = function() {
  throw new Error("Not implemented");
};
go.prototype.validate = function() {
  throw new Error("Not implemented");
};
go.prototype._fixedNafMul = function(e, r) {
  N0(e.precomputed);
  var i = e._getDoubles(), s = T0(r, 1, this._bitLength), n = (1 << i.step + 1) - (i.step % 2 === 0 ? 2 : 1);
  n /= 3;
  var f = [], u, h;
  for (u = 0; u < s.length; u += i.step) {
    h = 0;
    for (var d = u + i.step - 1; d >= u; d--)
      h = (h << 1) + s[d];
    f.push(h);
  }
  for (var l = this.jpoint(null, null, null), m = this.jpoint(null, null, null), b = n; b > 0; b--) {
    for (u = 0; u < f.length; u++)
      h = f[u], h === b ? m = m.mixedAdd(i.points[u]) : h === -b && (m = m.mixedAdd(i.points[u].neg()));
    l = l.add(m);
  }
  return l.toP();
};
go.prototype._wnafMul = function(e, r) {
  var i = 4, s = e._getNAFPoints(i);
  i = s.wnd;
  for (var n = s.points, f = T0(r, i, this._bitLength), u = this.jpoint(null, null, null), h = f.length - 1; h >= 0; h--) {
    for (var d = 0; h >= 0 && f[h] === 0; h--)
      d++;
    if (h >= 0 && d++, u = u.dblp(d), h < 0)
      break;
    var l = f[h];
    N0(l !== 0), e.type === "affine" ? l > 0 ? u = u.mixedAdd(n[l - 1 >> 1]) : u = u.mixedAdd(n[-l - 1 >> 1].neg()) : l > 0 ? u = u.add(n[l - 1 >> 1]) : u = u.add(n[-l - 1 >> 1].neg());
  }
  return e.type === "affine" ? u.toP() : u;
};
go.prototype._wnafMulAdd = function(e, r, i, s, n) {
  var f = this._wnafT1, u = this._wnafT2, h = this._wnafT3, d = 0, l, m, b;
  for (l = 0; l < s; l++) {
    b = r[l];
    var M = b._getNAFPoints(e);
    f[l] = M.wnd, u[l] = M.points;
  }
  for (l = s - 1; l >= 1; l -= 2) {
    var A = l - 1, N = l;
    if (f[A] !== 1 || f[N] !== 1) {
      h[A] = T0(i[A], f[A], this._bitLength), h[N] = T0(i[N], f[N], this._bitLength), d = Math.max(h[A].length, d), d = Math.max(h[N].length, d);
      continue;
    }
    var R = [
      r[A],
      null,
      null,
      r[N]
    ];
    r[A].y.cmp(r[N].y) === 0 ? (R[1] = r[A].add(r[N]), R[2] = r[A].toJ().mixedAdd(r[N].neg())) : r[A].y.cmp(r[N].y.redNeg()) === 0 ? (R[1] = r[A].toJ().mixedAdd(r[N]), R[2] = r[A].add(r[N].neg())) : (R[1] = r[A].toJ().mixedAdd(r[N]), R[2] = r[A].toJ().mixedAdd(r[N].neg()));
    var O = [
      -3,
      -1,
      -5,
      -7,
      0,
      7,
      5,
      1,
      3
    ], P = XX(i[A], i[N]);
    for (d = Math.max(P[0].length, d), h[A] = new Array(d), h[N] = new Array(d), m = 0; m < d; m++) {
      var F = P[0][m] | 0, H = P[1][m] | 0;
      h[A][m] = O[(F + 1) * 3 + (H + 1)], h[N][m] = 0, u[A] = R;
    }
  }
  var Q = this.jpoint(null, null, null), Z = this._wnafT4;
  for (l = d; l >= 0; l--) {
    for (var B = 0; l >= 0; ) {
      var Y = !0;
      for (m = 0; m < s; m++)
        Z[m] = h[m][l] | 0, Z[m] !== 0 && (Y = !1);
      if (!Y)
        break;
      B++, l--;
    }
    if (l >= 0 && B++, Q = Q.dblp(B), l < 0)
      break;
    for (m = 0; m < s; m++) {
      var ae = Z[m];
      ae !== 0 && (ae > 0 ? b = u[m][ae - 1 >> 1] : ae < 0 && (b = u[m][-ae - 1 >> 1].neg()), b.type === "affine" ? Q = Q.mixedAdd(b) : Q = Q.add(b));
    }
  }
  for (l = 0; l < s; l++)
    u[l] = null;
  return n ? Q : Q.toP();
};
function as(t, e) {
  this.curve = t, this.type = e, this.precomputed = null;
}
go.BasePoint = as;
as.prototype.eq = function() {
  throw new Error("Not implemented");
};
as.prototype.validate = function() {
  return this.curve.validate(this);
};
go.prototype.decodePoint = function(e, r) {
  e = Dn.toArray(e, r);
  var i = this.p.byteLength();
  if ((e[0] === 4 || e[0] === 6 || e[0] === 7) && e.length - 1 === 2 * i) {
    e[0] === 6 ? N0(e[e.length - 1] % 2 === 0) : e[0] === 7 && N0(e[e.length - 1] % 2 === 1);
    var s = this.point(
      e.slice(1, 1 + i),
      e.slice(1 + i, 1 + 2 * i)
    );
    return s;
  } else if ((e[0] === 2 || e[0] === 3) && e.length - 1 === i)
    return this.pointFromX(e.slice(1, 1 + i), e[0] === 3);
  throw new Error("Unknown point format");
};
as.prototype.encodeCompressed = function(e) {
  return this.encode(e, !0);
};
as.prototype._encode = function(e) {
  var r = this.curve.p.byteLength(), i = this.getX().toArray("be", r);
  return e ? [this.getY().isEven() ? 2 : 3].concat(i) : [4].concat(i, this.getY().toArray("be", r));
};
as.prototype.encode = function(e, r) {
  return Dn.encode(this._encode(r), e);
};
as.prototype.precompute = function(e) {
  if (this.precomputed)
    return this;
  var r = {
    doubles: null,
    naf: null,
    beta: null
  };
  return r.naf = this._getNAFPoints(8), r.doubles = this._getDoubles(4, e), r.beta = this._getBeta(), this.precomputed = r, this;
};
as.prototype._hasDoubles = function(e) {
  if (!this.precomputed)
    return !1;
  var r = this.precomputed.doubles;
  return r ? r.points.length >= Math.ceil((e.bitLength() + 1) / r.step) : !1;
};
as.prototype._getDoubles = function(e, r) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;
  for (var i = [this], s = this, n = 0; n < r; n += e) {
    for (var f = 0; f < e; f++)
      s = s.dbl();
    i.push(s);
  }
  return {
    step: e,
    points: i
  };
};
as.prototype._getNAFPoints = function(e) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;
  for (var r = [this], i = (1 << e) - 1, s = i === 1 ? null : this.dbl(), n = 1; n < i; n++)
    r[n] = r[n - 1].add(s);
  return {
    wnd: e,
    points: r
  };
};
as.prototype._getBeta = function() {
  return null;
};
as.prototype.dblp = function(e) {
  for (var r = this, i = 0; i < e; i++)
    r = r.dbl();
  return r;
};
var aw = Zc(function(t) {
  typeof Object.create == "function" ? t.exports = function(r, i) {
    i && (r.super_ = i, r.prototype = Object.create(i.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : t.exports = function(r, i) {
    if (i) {
      r.super_ = i;
      var s = function() {
      };
      s.prototype = i.prototype, r.prototype = new s(), r.prototype.constructor = r;
    }
  };
}), eee = Dn.assert;
function os(t) {
  wf.call(this, "short", t), this.a = new jt(t.a, 16).toRed(this.red), this.b = new jt(t.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(t), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
aw(os, wf);
var tee = os;
os.prototype._getEndomorphism = function(e) {
  if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
    var r, i;
    if (e.beta)
      r = new jt(e.beta, 16).toRed(this.red);
    else {
      var s = this._getEndoRoots(this.p);
      r = s[0].cmp(s[1]) < 0 ? s[0] : s[1], r = r.toRed(this.red);
    }
    if (e.lambda)
      i = new jt(e.lambda, 16);
    else {
      var n = this._getEndoRoots(this.n);
      this.g.mul(n[0]).x.cmp(this.g.x.redMul(r)) === 0 ? i = n[0] : (i = n[1], eee(this.g.mul(i).x.cmp(this.g.x.redMul(r)) === 0));
    }
    var f;
    return e.basis ? f = e.basis.map(function(u) {
      return {
        a: new jt(u.a, 16),
        b: new jt(u.b, 16)
      };
    }) : f = this._getEndoBasis(i), {
      beta: r,
      lambda: i,
      basis: f
    };
  }
};
os.prototype._getEndoRoots = function(e) {
  var r = e === this.p ? this.red : jt.mont(e), i = new jt(2).toRed(r).redInvm(), s = i.redNeg(), n = new jt(3).toRed(r).redNeg().redSqrt().redMul(i), f = s.redAdd(n).fromRed(), u = s.redSub(n).fromRed();
  return [f, u];
};
os.prototype._getEndoBasis = function(e) {
  for (var r = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), i = e, s = this.n.clone(), n = new jt(1), f = new jt(0), u = new jt(0), h = new jt(1), d, l, m, b, M, A, N, R = 0, O, P; i.cmpn(0) !== 0; ) {
    var F = s.div(i);
    O = s.sub(F.mul(i)), P = u.sub(F.mul(n));
    var H = h.sub(F.mul(f));
    if (!m && O.cmp(r) < 0)
      d = N.neg(), l = n, m = O.neg(), b = P;
    else if (m && ++R === 2)
      break;
    N = O, s = i, i = O, u = n, n = P, h = f, f = H;
  }
  M = O.neg(), A = P;
  var Q = m.sqr().add(b.sqr()), Z = M.sqr().add(A.sqr());
  return Z.cmp(Q) >= 0 && (M = d, A = l), m.negative && (m = m.neg(), b = b.neg()), M.negative && (M = M.neg(), A = A.neg()), [
    { a: m, b },
    { a: M, b: A }
  ];
};
os.prototype._endoSplit = function(e) {
  var r = this.endo.basis, i = r[0], s = r[1], n = s.b.mul(e).divRound(this.n), f = i.b.neg().mul(e).divRound(this.n), u = n.mul(i.a), h = f.mul(s.a), d = n.mul(i.b), l = f.mul(s.b), m = e.sub(u).sub(h), b = d.add(l).neg();
  return { k1: m, k2: b };
};
os.prototype.pointFromX = function(e, r) {
  e = new jt(e, 16), e.red || (e = e.toRed(this.red));
  var i = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b), s = i.redSqrt();
  if (s.redSqr().redSub(i).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var n = s.fromRed().isOdd();
  return (r && !n || !r && n) && (s = s.redNeg()), this.point(e, s);
};
os.prototype.validate = function(e) {
  if (e.inf)
    return !0;
  var r = e.x, i = e.y, s = this.a.redMul(r), n = r.redSqr().redMul(r).redIAdd(s).redIAdd(this.b);
  return i.redSqr().redISub(n).cmpn(0) === 0;
};
os.prototype._endoWnafMulAdd = function(e, r, i) {
  for (var s = this._endoWnafT1, n = this._endoWnafT2, f = 0; f < e.length; f++) {
    var u = this._endoSplit(r[f]), h = e[f], d = h._getBeta();
    u.k1.negative && (u.k1.ineg(), h = h.neg(!0)), u.k2.negative && (u.k2.ineg(), d = d.neg(!0)), s[f * 2] = h, s[f * 2 + 1] = d, n[f * 2] = u.k1, n[f * 2 + 1] = u.k2;
  }
  for (var l = this._wnafMulAdd(1, s, n, f * 2, i), m = 0; m < f * 2; m++)
    s[m] = null, n[m] = null;
  return l;
};
function _i(t, e, r, i) {
  wf.BasePoint.call(this, t, "affine"), e === null && r === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new jt(e, 16), this.y = new jt(r, 16), i && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
aw(_i, wf.BasePoint);
os.prototype.point = function(e, r, i) {
  return new _i(this, e, r, i);
};
os.prototype.pointFromJSON = function(e, r) {
  return _i.fromJSON(this, e, r);
};
_i.prototype._getBeta = function() {
  if (!!this.curve.endo) {
    var e = this.precomputed;
    if (e && e.beta)
      return e.beta;
    var r = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (e) {
      var i = this.curve, s = function(n) {
        return i.point(n.x.redMul(i.endo.beta), n.y);
      };
      e.beta = r, r.precomputed = {
        beta: null,
        naf: e.naf && {
          wnd: e.naf.wnd,
          points: e.naf.points.map(s)
        },
        doubles: e.doubles && {
          step: e.doubles.step,
          points: e.doubles.points.map(s)
        }
      };
    }
    return r;
  }
};
_i.prototype.toJSON = function() {
  return this.precomputed ? [this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  }] : [this.x, this.y];
};
_i.fromJSON = function(e, r, i) {
  typeof r == "string" && (r = JSON.parse(r));
  var s = e.point(r[0], r[1], i);
  if (!r[2])
    return s;
  function n(u) {
    return e.point(u[0], u[1], i);
  }
  var f = r[2];
  return s.precomputed = {
    beta: null,
    doubles: f.doubles && {
      step: f.doubles.step,
      points: [s].concat(f.doubles.points.map(n))
    },
    naf: f.naf && {
      wnd: f.naf.wnd,
      points: [s].concat(f.naf.points.map(n))
    }
  }, s;
};
_i.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
_i.prototype.isInfinity = function() {
  return this.inf;
};
_i.prototype.add = function(e) {
  if (this.inf)
    return e;
  if (e.inf)
    return this;
  if (this.eq(e))
    return this.dbl();
  if (this.neg().eq(e))
    return this.curve.point(null, null);
  if (this.x.cmp(e.x) === 0)
    return this.curve.point(null, null);
  var r = this.y.redSub(e.y);
  r.cmpn(0) !== 0 && (r = r.redMul(this.x.redSub(e.x).redInvm()));
  var i = r.redSqr().redISub(this.x).redISub(e.x), s = r.redMul(this.x.redSub(i)).redISub(this.y);
  return this.curve.point(i, s);
};
_i.prototype.dbl = function() {
  if (this.inf)
    return this;
  var e = this.y.redAdd(this.y);
  if (e.cmpn(0) === 0)
    return this.curve.point(null, null);
  var r = this.curve.a, i = this.x.redSqr(), s = e.redInvm(), n = i.redAdd(i).redIAdd(i).redIAdd(r).redMul(s), f = n.redSqr().redISub(this.x.redAdd(this.x)), u = n.redMul(this.x.redSub(f)).redISub(this.y);
  return this.curve.point(f, u);
};
_i.prototype.getX = function() {
  return this.x.fromRed();
};
_i.prototype.getY = function() {
  return this.y.fromRed();
};
_i.prototype.mul = function(e) {
  return e = new jt(e, 16), this.isInfinity() ? this : this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [e]) : this.curve._wnafMul(this, e);
};
_i.prototype.mulAdd = function(e, r, i) {
  var s = [this, r], n = [e, i];
  return this.curve.endo ? this.curve._endoWnafMulAdd(s, n) : this.curve._wnafMulAdd(1, s, n, 2);
};
_i.prototype.jmulAdd = function(e, r, i) {
  var s = [this, r], n = [e, i];
  return this.curve.endo ? this.curve._endoWnafMulAdd(s, n, !0) : this.curve._wnafMulAdd(1, s, n, 2, !0);
};
_i.prototype.eq = function(e) {
  return this === e || this.inf === e.inf && (this.inf || this.x.cmp(e.x) === 0 && this.y.cmp(e.y) === 0);
};
_i.prototype.neg = function(e) {
  if (this.inf)
    return this;
  var r = this.curve.point(this.x, this.y.redNeg());
  if (e && this.precomputed) {
    var i = this.precomputed, s = function(n) {
      return n.neg();
    };
    r.precomputed = {
      naf: i.naf && {
        wnd: i.naf.wnd,
        points: i.naf.points.map(s)
      },
      doubles: i.doubles && {
        step: i.doubles.step,
        points: i.doubles.points.map(s)
      }
    };
  }
  return r;
};
_i.prototype.toJ = function() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);
  var e = this.curve.jpoint(this.x, this.y, this.curve.one);
  return e;
};
function Ai(t, e, r, i) {
  wf.BasePoint.call(this, t, "jacobian"), e === null && r === null && i === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new jt(0)) : (this.x = new jt(e, 16), this.y = new jt(r, 16), this.z = new jt(i, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
aw(Ai, wf.BasePoint);
os.prototype.jpoint = function(e, r, i) {
  return new Ai(this, e, r, i);
};
Ai.prototype.toP = function() {
  if (this.isInfinity())
    return this.curve.point(null, null);
  var e = this.z.redInvm(), r = e.redSqr(), i = this.x.redMul(r), s = this.y.redMul(r).redMul(e);
  return this.curve.point(i, s);
};
Ai.prototype.neg = function() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
Ai.prototype.add = function(e) {
  if (this.isInfinity())
    return e;
  if (e.isInfinity())
    return this;
  var r = e.z.redSqr(), i = this.z.redSqr(), s = this.x.redMul(r), n = e.x.redMul(i), f = this.y.redMul(r.redMul(e.z)), u = e.y.redMul(i.redMul(this.z)), h = s.redSub(n), d = f.redSub(u);
  if (h.cmpn(0) === 0)
    return d.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var l = h.redSqr(), m = l.redMul(h), b = s.redMul(l), M = d.redSqr().redIAdd(m).redISub(b).redISub(b), A = d.redMul(b.redISub(M)).redISub(f.redMul(m)), N = this.z.redMul(e.z).redMul(h);
  return this.curve.jpoint(M, A, N);
};
Ai.prototype.mixedAdd = function(e) {
  if (this.isInfinity())
    return e.toJ();
  if (e.isInfinity())
    return this;
  var r = this.z.redSqr(), i = this.x, s = e.x.redMul(r), n = this.y, f = e.y.redMul(r).redMul(this.z), u = i.redSub(s), h = n.redSub(f);
  if (u.cmpn(0) === 0)
    return h.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var d = u.redSqr(), l = d.redMul(u), m = i.redMul(d), b = h.redSqr().redIAdd(l).redISub(m).redISub(m), M = h.redMul(m.redISub(b)).redISub(n.redMul(l)), A = this.z.redMul(u);
  return this.curve.jpoint(b, M, A);
};
Ai.prototype.dblp = function(e) {
  if (e === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!e)
    return this.dbl();
  var r;
  if (this.curve.zeroA || this.curve.threeA) {
    var i = this;
    for (r = 0; r < e; r++)
      i = i.dbl();
    return i;
  }
  var s = this.curve.a, n = this.curve.tinv, f = this.x, u = this.y, h = this.z, d = h.redSqr().redSqr(), l = u.redAdd(u);
  for (r = 0; r < e; r++) {
    var m = f.redSqr(), b = l.redSqr(), M = b.redSqr(), A = m.redAdd(m).redIAdd(m).redIAdd(s.redMul(d)), N = f.redMul(b), R = A.redSqr().redISub(N.redAdd(N)), O = N.redISub(R), P = A.redMul(O);
    P = P.redIAdd(P).redISub(M);
    var F = l.redMul(h);
    r + 1 < e && (d = d.redMul(M)), f = R, h = F, l = P;
  }
  return this.curve.jpoint(f, l.redMul(n), h);
};
Ai.prototype.dbl = function() {
  return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
};
Ai.prototype._zeroDbl = function() {
  var e, r, i;
  if (this.zOne) {
    var s = this.x.redSqr(), n = this.y.redSqr(), f = n.redSqr(), u = this.x.redAdd(n).redSqr().redISub(s).redISub(f);
    u = u.redIAdd(u);
    var h = s.redAdd(s).redIAdd(s), d = h.redSqr().redISub(u).redISub(u), l = f.redIAdd(f);
    l = l.redIAdd(l), l = l.redIAdd(l), e = d, r = h.redMul(u.redISub(d)).redISub(l), i = this.y.redAdd(this.y);
  } else {
    var m = this.x.redSqr(), b = this.y.redSqr(), M = b.redSqr(), A = this.x.redAdd(b).redSqr().redISub(m).redISub(M);
    A = A.redIAdd(A);
    var N = m.redAdd(m).redIAdd(m), R = N.redSqr(), O = M.redIAdd(M);
    O = O.redIAdd(O), O = O.redIAdd(O), e = R.redISub(A).redISub(A), r = N.redMul(A.redISub(e)).redISub(O), i = this.y.redMul(this.z), i = i.redIAdd(i);
  }
  return this.curve.jpoint(e, r, i);
};
Ai.prototype._threeDbl = function() {
  var e, r, i;
  if (this.zOne) {
    var s = this.x.redSqr(), n = this.y.redSqr(), f = n.redSqr(), u = this.x.redAdd(n).redSqr().redISub(s).redISub(f);
    u = u.redIAdd(u);
    var h = s.redAdd(s).redIAdd(s).redIAdd(this.curve.a), d = h.redSqr().redISub(u).redISub(u);
    e = d;
    var l = f.redIAdd(f);
    l = l.redIAdd(l), l = l.redIAdd(l), r = h.redMul(u.redISub(d)).redISub(l), i = this.y.redAdd(this.y);
  } else {
    var m = this.z.redSqr(), b = this.y.redSqr(), M = this.x.redMul(b), A = this.x.redSub(m).redMul(this.x.redAdd(m));
    A = A.redAdd(A).redIAdd(A);
    var N = M.redIAdd(M);
    N = N.redIAdd(N);
    var R = N.redAdd(N);
    e = A.redSqr().redISub(R), i = this.y.redAdd(this.z).redSqr().redISub(b).redISub(m);
    var O = b.redSqr();
    O = O.redIAdd(O), O = O.redIAdd(O), O = O.redIAdd(O), r = A.redMul(N.redISub(e)).redISub(O);
  }
  return this.curve.jpoint(e, r, i);
};
Ai.prototype._dbl = function() {
  var e = this.curve.a, r = this.x, i = this.y, s = this.z, n = s.redSqr().redSqr(), f = r.redSqr(), u = i.redSqr(), h = f.redAdd(f).redIAdd(f).redIAdd(e.redMul(n)), d = r.redAdd(r);
  d = d.redIAdd(d);
  var l = d.redMul(u), m = h.redSqr().redISub(l.redAdd(l)), b = l.redISub(m), M = u.redSqr();
  M = M.redIAdd(M), M = M.redIAdd(M), M = M.redIAdd(M);
  var A = h.redMul(b).redISub(M), N = i.redAdd(i).redMul(s);
  return this.curve.jpoint(m, A, N);
};
Ai.prototype.trpl = function() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);
  var e = this.x.redSqr(), r = this.y.redSqr(), i = this.z.redSqr(), s = r.redSqr(), n = e.redAdd(e).redIAdd(e), f = n.redSqr(), u = this.x.redAdd(r).redSqr().redISub(e).redISub(s);
  u = u.redIAdd(u), u = u.redAdd(u).redIAdd(u), u = u.redISub(f);
  var h = u.redSqr(), d = s.redIAdd(s);
  d = d.redIAdd(d), d = d.redIAdd(d), d = d.redIAdd(d);
  var l = n.redIAdd(u).redSqr().redISub(f).redISub(h).redISub(d), m = r.redMul(l);
  m = m.redIAdd(m), m = m.redIAdd(m);
  var b = this.x.redMul(h).redISub(m);
  b = b.redIAdd(b), b = b.redIAdd(b);
  var M = this.y.redMul(l.redMul(d.redISub(l)).redISub(u.redMul(h)));
  M = M.redIAdd(M), M = M.redIAdd(M), M = M.redIAdd(M);
  var A = this.z.redAdd(u).redSqr().redISub(i).redISub(h);
  return this.curve.jpoint(b, M, A);
};
Ai.prototype.mul = function(e, r) {
  return e = new jt(e, r), this.curve._wnafMul(this, e);
};
Ai.prototype.eq = function(e) {
  if (e.type === "affine")
    return this.eq(e.toJ());
  if (this === e)
    return !0;
  var r = this.z.redSqr(), i = e.z.redSqr();
  if (this.x.redMul(i).redISub(e.x.redMul(r)).cmpn(0) !== 0)
    return !1;
  var s = r.redMul(this.z), n = i.redMul(e.z);
  return this.y.redMul(n).redISub(e.y.redMul(s)).cmpn(0) === 0;
};
Ai.prototype.eqXToP = function(e) {
  var r = this.z.redSqr(), i = e.toRed(this.curve.red).redMul(r);
  if (this.x.cmp(i) === 0)
    return !0;
  for (var s = e.clone(), n = this.curve.redN.redMul(r); ; ) {
    if (s.iadd(this.curve.n), s.cmp(this.curve.p) >= 0)
      return !1;
    if (i.redIAdd(n), this.x.cmp(i) === 0)
      return !0;
  }
};
Ai.prototype.inspect = function() {
  return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
Ai.prototype.isInfinity = function() {
  return this.z.cmpn(0) === 0;
};
var Xd = Zc(function(t, e) {
  var r = e;
  r.base = wf, r.short = tee, r.mont = null, r.edwards = null;
}), e0 = Zc(function(t, e) {
  var r = e, i = Dn.assert;
  function s(u) {
    u.type === "short" ? this.curve = new Xd.short(u) : u.type === "edwards" ? this.curve = new Xd.edwards(u) : this.curve = new Xd.mont(u), this.g = this.curve.g, this.n = this.curve.n, this.hash = u.hash, i(this.g.validate(), "Invalid curve"), i(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }
  r.PresetCurve = s;
  function n(u, h) {
    Object.defineProperty(r, u, {
      configurable: !0,
      enumerable: !0,
      get: function() {
        var d = new s(h);
        return Object.defineProperty(r, u, {
          configurable: !0,
          enumerable: !0,
          value: d
        }), d;
      }
    });
  }
  n("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: Ki.sha256,
    gRed: !1,
    g: [
      "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
      "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
  }), n("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: Ki.sha256,
    gRed: !1,
    g: [
      "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
      "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
  }), n("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: Ki.sha256,
    gRed: !1,
    g: [
      "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
      "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
  }), n("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: Ki.sha384,
    gRed: !1,
    g: [
      "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
      "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
  }), n("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: Ki.sha512,
    gRed: !1,
    g: [
      "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
      "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
  }), n("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: Ki.sha256,
    gRed: !1,
    g: [
      "9"
    ]
  }), n("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: Ki.sha256,
    gRed: !1,
    g: [
      "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
      "6666666666666666666666666666666666666666666666666666666666666658"
    ]
  });
  var f;
  try {
    f = null.crash();
  } catch {
    f = void 0;
  }
  n("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: Ki.sha256,
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
      {
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      },
      {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }
    ],
    gRed: !1,
    g: [
      "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
      "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
      f
    ]
  });
});
function lo(t) {
  if (!(this instanceof lo))
    return new lo(t);
  this.hash = t.hash, this.predResist = !!t.predResist, this.outLen = this.hash.outSize, this.minEntropy = t.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
  var e = Es.toArray(t.entropy, t.entropyEnc || "hex"), r = Es.toArray(t.nonce, t.nonceEnc || "hex"), i = Es.toArray(t.pers, t.persEnc || "hex");
  sw(
    e.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._init(e, r, i);
}
var PI = lo;
lo.prototype._init = function(e, r, i) {
  var s = e.concat(r).concat(i);
  this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
  for (var n = 0; n < this.V.length; n++)
    this.K[n] = 0, this.V[n] = 1;
  this._update(s), this._reseed = 1, this.reseedInterval = 281474976710656;
};
lo.prototype._hmac = function() {
  return new Ki.hmac(this.hash, this.K);
};
lo.prototype._update = function(e) {
  var r = this._hmac().update(this.V).update([0]);
  e && (r = r.update(e)), this.K = r.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([1]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
};
lo.prototype.reseed = function(e, r, i, s) {
  typeof r != "string" && (s = i, i = r, r = null), e = Es.toArray(e, r), i = Es.toArray(i, s), sw(
    e.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._update(e.concat(i || [])), this._reseed = 1;
};
lo.prototype.generate = function(e, r, i, s) {
  if (this._reseed > this.reseedInterval)
    throw new Error("Reseed is required");
  typeof r != "string" && (s = i, i = r, r = null), i && (i = Es.toArray(i, s || "hex"), this._update(i));
  for (var n = []; n.length < e; )
    this.V = this._hmac().update(this.V).digest(), n = n.concat(this.V);
  var f = n.slice(0, e);
  return this._update(i), this._reseed++, Es.encode(f, r);
};
var Em = Dn.assert;
function ji(t, e) {
  this.ec = t, this.priv = null, this.pub = null, e.priv && this._importPrivate(e.priv, e.privEnc), e.pub && this._importPublic(e.pub, e.pubEnc);
}
var ow = ji;
ji.fromPublic = function(e, r, i) {
  return r instanceof ji ? r : new ji(e, {
    pub: r,
    pubEnc: i
  });
};
ji.fromPrivate = function(e, r, i) {
  return r instanceof ji ? r : new ji(e, {
    priv: r,
    privEnc: i
  });
};
ji.prototype.validate = function() {
  var e = this.getPublic();
  return e.isInfinity() ? { result: !1, reason: "Invalid public key" } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
};
ji.prototype.getPublic = function(e, r) {
  return typeof e == "string" && (r = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), r ? this.pub.encode(r, e) : this.pub;
};
ji.prototype.getPrivate = function(e) {
  return e === "hex" ? this.priv.toString(16, 2) : this.priv;
};
ji.prototype._importPrivate = function(e, r) {
  this.priv = new jt(e, r || 16), this.priv = this.priv.umod(this.ec.curve.n);
};
ji.prototype._importPublic = function(e, r) {
  if (e.x || e.y) {
    this.ec.curve.type === "mont" ? Em(e.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && Em(e.x && e.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(e.x, e.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(e, r);
};
ji.prototype.derive = function(e) {
  return e.validate() || Em(e.validate(), "public point not validated"), e.mul(this.priv).getX();
};
ji.prototype.sign = function(e, r, i) {
  return this.ec.sign(e, this, r, i);
};
ji.prototype.verify = function(e, r) {
  return this.ec.verify(e, r, this);
};
ji.prototype.inspect = function() {
  return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var ree = Dn.assert;
function Bp(t, e) {
  if (t instanceof Bp)
    return t;
  this._importDER(t, e) || (ree(t.r && t.s, "Signature without r or s"), this.r = new jt(t.r, 16), this.s = new jt(t.s, 16), t.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = t.recoveryParam);
}
var zp = Bp;
function iee() {
  this.place = 0;
}
function Eg(t, e) {
  var r = t[e.place++];
  if (!(r & 128))
    return r;
  var i = r & 15;
  if (i === 0 || i > 4)
    return !1;
  for (var s = 0, n = 0, f = e.place; n < i; n++, f++)
    s <<= 8, s |= t[f], s >>>= 0;
  return s <= 127 ? !1 : (e.place = f, s);
}
function a5(t) {
  for (var e = 0, r = t.length - 1; !t[e] && !(t[e + 1] & 128) && e < r; )
    e++;
  return e === 0 ? t : t.slice(e);
}
Bp.prototype._importDER = function(e, r) {
  e = Dn.toArray(e, r);
  var i = new iee();
  if (e[i.place++] !== 48)
    return !1;
  var s = Eg(e, i);
  if (s === !1 || s + i.place !== e.length || e[i.place++] !== 2)
    return !1;
  var n = Eg(e, i);
  if (n === !1)
    return !1;
  var f = e.slice(i.place, n + i.place);
  if (i.place += n, e[i.place++] !== 2)
    return !1;
  var u = Eg(e, i);
  if (u === !1 || e.length !== u + i.place)
    return !1;
  var h = e.slice(i.place, u + i.place);
  if (f[0] === 0)
    if (f[1] & 128)
      f = f.slice(1);
    else
      return !1;
  if (h[0] === 0)
    if (h[1] & 128)
      h = h.slice(1);
    else
      return !1;
  return this.r = new jt(f), this.s = new jt(h), this.recoveryParam = null, !0;
};
function Ig(t, e) {
  if (e < 128) {
    t.push(e);
    return;
  }
  var r = 1 + (Math.log(e) / Math.LN2 >>> 3);
  for (t.push(r | 128); --r; )
    t.push(e >>> (r << 3) & 255);
  t.push(e);
}
Bp.prototype.toDER = function(e) {
  var r = this.r.toArray(), i = this.s.toArray();
  for (r[0] & 128 && (r = [0].concat(r)), i[0] & 128 && (i = [0].concat(i)), r = a5(r), i = a5(i); !i[0] && !(i[1] & 128); )
    i = i.slice(1);
  var s = [2];
  Ig(s, r.length), s = s.concat(r), s.push(2), Ig(s, i.length);
  var n = s.concat(i), f = [48];
  return Ig(f, n.length), f = f.concat(n), Dn.encode(f, e);
};
var nee = function() {
  throw new Error("unsupported");
}, kI = Dn.assert;
function rs(t) {
  if (!(this instanceof rs))
    return new rs(t);
  typeof t == "string" && (kI(
    Object.prototype.hasOwnProperty.call(e0, t),
    "Unknown curve " + t
  ), t = e0[t]), t instanceof e0.PresetCurve && (t = { curve: t }), this.curve = t.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = t.curve.g, this.g.precompute(t.curve.n.bitLength() + 1), this.hash = t.hash || t.curve.hash;
}
var see = rs;
rs.prototype.keyPair = function(e) {
  return new ow(this, e);
};
rs.prototype.keyFromPrivate = function(e, r) {
  return ow.fromPrivate(this, e, r);
};
rs.prototype.keyFromPublic = function(e, r) {
  return ow.fromPublic(this, e, r);
};
rs.prototype.genKeyPair = function(e) {
  e || (e = {});
  for (var r = new PI({
    hash: this.hash,
    pers: e.pers,
    persEnc: e.persEnc || "utf8",
    entropy: e.entropy || nee(this.hash.hmacStrength),
    entropyEnc: e.entropy && e.entropyEnc || "utf8",
    nonce: this.n.toArray()
  }), i = this.n.byteLength(), s = this.n.sub(new jt(2)); ; ) {
    var n = new jt(r.generate(i));
    if (!(n.cmp(s) > 0))
      return n.iaddn(1), this.keyFromPrivate(n);
  }
};
rs.prototype._truncateToN = function(e, r) {
  var i = e.byteLength() * 8 - this.n.bitLength();
  return i > 0 && (e = e.ushrn(i)), !r && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
};
rs.prototype.sign = function(e, r, i, s) {
  typeof i == "object" && (s = i, i = null), s || (s = {}), r = this.keyFromPrivate(r, i), e = this._truncateToN(new jt(e, 16));
  for (var n = this.n.byteLength(), f = r.getPrivate().toArray("be", n), u = e.toArray("be", n), h = new PI({
    hash: this.hash,
    entropy: f,
    nonce: u,
    pers: s.pers,
    persEnc: s.persEnc || "utf8"
  }), d = this.n.sub(new jt(1)), l = 0; ; l++) {
    var m = s.k ? s.k(l) : new jt(h.generate(this.n.byteLength()));
    if (m = this._truncateToN(m, !0), !(m.cmpn(1) <= 0 || m.cmp(d) >= 0)) {
      var b = this.g.mul(m);
      if (!b.isInfinity()) {
        var M = b.getX(), A = M.umod(this.n);
        if (A.cmpn(0) !== 0) {
          var N = m.invm(this.n).mul(A.mul(r.getPrivate()).iadd(e));
          if (N = N.umod(this.n), N.cmpn(0) !== 0) {
            var R = (b.getY().isOdd() ? 1 : 0) | (M.cmp(A) !== 0 ? 2 : 0);
            return s.canonical && N.cmp(this.nh) > 0 && (N = this.n.sub(N), R ^= 1), new zp({ r: A, s: N, recoveryParam: R });
          }
        }
      }
    }
  }
};
rs.prototype.verify = function(e, r, i, s) {
  e = this._truncateToN(new jt(e, 16)), i = this.keyFromPublic(i, s), r = new zp(r, "hex");
  var n = r.r, f = r.s;
  if (n.cmpn(1) < 0 || n.cmp(this.n) >= 0 || f.cmpn(1) < 0 || f.cmp(this.n) >= 0)
    return !1;
  var u = f.invm(this.n), h = u.mul(e).umod(this.n), d = u.mul(n).umod(this.n), l;
  return this.curve._maxwellTrick ? (l = this.g.jmulAdd(h, i.getPublic(), d), l.isInfinity() ? !1 : l.eqXToP(n)) : (l = this.g.mulAdd(h, i.getPublic(), d), l.isInfinity() ? !1 : l.getX().umod(this.n).cmp(n) === 0);
};
rs.prototype.recoverPubKey = function(t, e, r, i) {
  kI((3 & r) === r, "The recovery param is more than two bits"), e = new zp(e, i);
  var s = this.n, n = new jt(t), f = e.r, u = e.s, h = r & 1, d = r >> 1;
  if (f.cmp(this.curve.p.umod(this.curve.n)) >= 0 && d)
    throw new Error("Unable to find sencond key candinate");
  d ? f = this.curve.pointFromX(f.add(this.curve.n), h) : f = this.curve.pointFromX(f, h);
  var l = e.r.invm(s), m = s.sub(n).mul(l).umod(s), b = u.mul(l).umod(s);
  return this.g.mulAdd(m, f, b);
};
rs.prototype.getKeyRecoveryParam = function(t, e, r, i) {
  if (e = new zp(e, i), e.recoveryParam !== null)
    return e.recoveryParam;
  for (var s = 0; s < 4; s++) {
    var n;
    try {
      n = this.recoverPubKey(t, e, s);
    } catch {
      continue;
    }
    if (n.eq(r))
      return s;
  }
  throw new Error("Unable to find valid recovery factor");
};
var aee = Zc(function(t, e) {
  var r = e;
  r.version = "6.5.4", r.utils = Dn, r.rand = function() {
    throw new Error("unsupported");
  }, r.curve = Xd, r.curves = e0, r.ec = see, r.eddsa = null;
}), oee = aee.ec;
const fee = "signing-key/5.7.0", Im = new Mr(fee);
let Ag = null;
function Vs() {
  return Ag || (Ag = new oee("secp256k1")), Ag;
}
class cee {
  constructor(e) {
    ju(this, "curve", "secp256k1"), ju(this, "privateKey", cn(e)), hJ(this.privateKey) !== 32 && Im.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
    const r = Vs().keyFromPrivate(ai(this.privateKey));
    ju(this, "publicKey", "0x" + r.getPublic(!1, "hex")), ju(this, "compressedPublicKey", "0x" + r.getPublic(!0, "hex")), ju(this, "_isSigningKey", !0);
  }
  _addPoint(e) {
    const r = Vs().keyFromPublic(ai(this.publicKey)), i = Vs().keyFromPublic(ai(e));
    return "0x" + r.pub.add(i.pub).encodeCompressed("hex");
  }
  signDigest(e) {
    const r = Vs().keyFromPrivate(ai(this.privateKey)), i = ai(e);
    i.length !== 32 && Im.throwArgumentError("bad digest length", "digest", e);
    const s = r.sign(i, { canonical: !0 });
    return uI({
      recoveryParam: s.recoveryParam,
      r: dc("0x" + s.r.toString(16), 32),
      s: dc("0x" + s.s.toString(16), 32)
    });
  }
  computeSharedSecret(e) {
    const r = Vs().keyFromPrivate(ai(this.privateKey)), i = Vs().keyFromPublic(ai(jI(e)));
    return dc("0x" + r.derive(i.getPublic()).toString(16), 32);
  }
  static isSigningKey(e) {
    return !!(e && e._isSigningKey);
  }
}
function uee(t, e) {
  const r = uI(e), i = { r: ai(r.r), s: ai(r.s) };
  return "0x" + Vs().recoverPubKey(ai(t), i, r.recoveryParam).encode("hex", !1);
}
function jI(t, e) {
  const r = ai(t);
  if (r.length === 32) {
    const i = new cee(r);
    return e ? "0x" + Vs().keyFromPrivate(r).getPublic(!0, "hex") : i.publicKey;
  } else {
    if (r.length === 33)
      return e ? cn(r) : "0x" + Vs().keyFromPublic(r).getPublic(!1, "hex");
    if (r.length === 65)
      return e ? "0x" + Vs().keyFromPublic(r).getPublic(!0, "hex") : cn(r);
  }
  return Im.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}
const hee = "transactions/5.7.0";
new Mr(hee);
var o5;
(function(t) {
  t[t.legacy = 0] = "legacy", t[t.eip2930 = 1] = "eip2930", t[t.eip1559 = 2] = "eip1559";
})(o5 || (o5 = {}));
function lee(t) {
  const e = jI(t);
  return SJ(X6(iw(X6(e, 1)), 12));
}
function dee(t, e) {
  return lee(uee(ai(t), e));
}
var fw = {}, Up = {}, Bt = {}, BI = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  function e(u, h) {
    var d = u >>> 16 & 65535, l = u & 65535, m = h >>> 16 & 65535, b = h & 65535;
    return l * b + (d * b + l * m << 16 >>> 0) | 0;
  }
  t.mul = Math.imul || e;
  function r(u, h) {
    return u + h | 0;
  }
  t.add = r;
  function i(u, h) {
    return u - h | 0;
  }
  t.sub = i;
  function s(u, h) {
    return u << h | u >>> 32 - h;
  }
  t.rotl = s;
  function n(u, h) {
    return u << 32 - h | u >>> h;
  }
  t.rotr = n;
  function f(u) {
    return typeof u == "number" && isFinite(u) && Math.floor(u) === u;
  }
  t.isInteger = Number.isInteger || f, t.MAX_SAFE_INTEGER = 9007199254740991, t.isSafeInteger = function(u) {
    return t.isInteger(u) && u >= -t.MAX_SAFE_INTEGER && u <= t.MAX_SAFE_INTEGER;
  };
})(BI);
Object.defineProperty(Bt, "__esModule", { value: !0 });
var zI = BI;
function pee(t, e) {
  return e === void 0 && (e = 0), (t[e + 0] << 8 | t[e + 1]) << 16 >> 16;
}
Bt.readInt16BE = pee;
function vee(t, e) {
  return e === void 0 && (e = 0), (t[e + 0] << 8 | t[e + 1]) >>> 0;
}
Bt.readUint16BE = vee;
function gee(t, e) {
  return e === void 0 && (e = 0), (t[e + 1] << 8 | t[e]) << 16 >> 16;
}
Bt.readInt16LE = gee;
function bee(t, e) {
  return e === void 0 && (e = 0), (t[e + 1] << 8 | t[e]) >>> 0;
}
Bt.readUint16LE = bee;
function UI(t, e, r) {
  return e === void 0 && (e = new Uint8Array(2)), r === void 0 && (r = 0), e[r + 0] = t >>> 8, e[r + 1] = t >>> 0, e;
}
Bt.writeUint16BE = UI;
Bt.writeInt16BE = UI;
function FI(t, e, r) {
  return e === void 0 && (e = new Uint8Array(2)), r === void 0 && (r = 0), e[r + 0] = t >>> 0, e[r + 1] = t >>> 8, e;
}
Bt.writeUint16LE = FI;
Bt.writeInt16LE = FI;
function Am(t, e) {
  return e === void 0 && (e = 0), t[e] << 24 | t[e + 1] << 16 | t[e + 2] << 8 | t[e + 3];
}
Bt.readInt32BE = Am;
function Tm(t, e) {
  return e === void 0 && (e = 0), (t[e] << 24 | t[e + 1] << 16 | t[e + 2] << 8 | t[e + 3]) >>> 0;
}
Bt.readUint32BE = Tm;
function Nm(t, e) {
  return e === void 0 && (e = 0), t[e + 3] << 24 | t[e + 2] << 16 | t[e + 1] << 8 | t[e];
}
Bt.readInt32LE = Nm;
function Dm(t, e) {
  return e === void 0 && (e = 0), (t[e + 3] << 24 | t[e + 2] << 16 | t[e + 1] << 8 | t[e]) >>> 0;
}
Bt.readUint32LE = Dm;
function D0(t, e, r) {
  return e === void 0 && (e = new Uint8Array(4)), r === void 0 && (r = 0), e[r + 0] = t >>> 24, e[r + 1] = t >>> 16, e[r + 2] = t >>> 8, e[r + 3] = t >>> 0, e;
}
Bt.writeUint32BE = D0;
Bt.writeInt32BE = D0;
function C0(t, e, r) {
  return e === void 0 && (e = new Uint8Array(4)), r === void 0 && (r = 0), e[r + 0] = t >>> 0, e[r + 1] = t >>> 8, e[r + 2] = t >>> 16, e[r + 3] = t >>> 24, e;
}
Bt.writeUint32LE = C0;
Bt.writeInt32LE = C0;
function yee(t, e) {
  e === void 0 && (e = 0);
  var r = Am(t, e), i = Am(t, e + 4);
  return r * 4294967296 + i - (i >> 31) * 4294967296;
}
Bt.readInt64BE = yee;
function mee(t, e) {
  e === void 0 && (e = 0);
  var r = Tm(t, e), i = Tm(t, e + 4);
  return r * 4294967296 + i;
}
Bt.readUint64BE = mee;
function wee(t, e) {
  e === void 0 && (e = 0);
  var r = Nm(t, e), i = Nm(t, e + 4);
  return i * 4294967296 + r - (r >> 31) * 4294967296;
}
Bt.readInt64LE = wee;
function _ee(t, e) {
  e === void 0 && (e = 0);
  var r = Dm(t, e), i = Dm(t, e + 4);
  return i * 4294967296 + r;
}
Bt.readUint64LE = _ee;
function $I(t, e, r) {
  return e === void 0 && (e = new Uint8Array(8)), r === void 0 && (r = 0), D0(t / 4294967296 >>> 0, e, r), D0(t >>> 0, e, r + 4), e;
}
Bt.writeUint64BE = $I;
Bt.writeInt64BE = $I;
function qI(t, e, r) {
  return e === void 0 && (e = new Uint8Array(8)), r === void 0 && (r = 0), C0(t >>> 0, e, r), C0(t / 4294967296 >>> 0, e, r + 4), e;
}
Bt.writeUint64LE = qI;
Bt.writeInt64LE = qI;
function Mee(t, e, r) {
  if (r === void 0 && (r = 0), t % 8 !== 0)
    throw new Error("readUintBE supports only bitLengths divisible by 8");
  if (t / 8 > e.length - r)
    throw new Error("readUintBE: array is too short for the given bitLength");
  for (var i = 0, s = 1, n = t / 8 + r - 1; n >= r; n--)
    i += e[n] * s, s *= 256;
  return i;
}
Bt.readUintBE = Mee;
function xee(t, e, r) {
  if (r === void 0 && (r = 0), t % 8 !== 0)
    throw new Error("readUintLE supports only bitLengths divisible by 8");
  if (t / 8 > e.length - r)
    throw new Error("readUintLE: array is too short for the given bitLength");
  for (var i = 0, s = 1, n = r; n < r + t / 8; n++)
    i += e[n] * s, s *= 256;
  return i;
}
Bt.readUintLE = xee;
function See(t, e, r, i) {
  if (r === void 0 && (r = new Uint8Array(t / 8)), i === void 0 && (i = 0), t % 8 !== 0)
    throw new Error("writeUintBE supports only bitLengths divisible by 8");
  if (!zI.isSafeInteger(e))
    throw new Error("writeUintBE value must be an integer");
  for (var s = 1, n = t / 8 + i - 1; n >= i; n--)
    r[n] = e / s & 255, s *= 256;
  return r;
}
Bt.writeUintBE = See;
function Eee(t, e, r, i) {
  if (r === void 0 && (r = new Uint8Array(t / 8)), i === void 0 && (i = 0), t % 8 !== 0)
    throw new Error("writeUintLE supports only bitLengths divisible by 8");
  if (!zI.isSafeInteger(e))
    throw new Error("writeUintLE value must be an integer");
  for (var s = 1, n = i; n < i + t / 8; n++)
    r[n] = e / s & 255, s *= 256;
  return r;
}
Bt.writeUintLE = Eee;
function Iee(t, e) {
  e === void 0 && (e = 0);
  var r = new DataView(t.buffer, t.byteOffset, t.byteLength);
  return r.getFloat32(e);
}
Bt.readFloat32BE = Iee;
function Aee(t, e) {
  e === void 0 && (e = 0);
  var r = new DataView(t.buffer, t.byteOffset, t.byteLength);
  return r.getFloat32(e, !0);
}
Bt.readFloat32LE = Aee;
function Tee(t, e) {
  e === void 0 && (e = 0);
  var r = new DataView(t.buffer, t.byteOffset, t.byteLength);
  return r.getFloat64(e);
}
Bt.readFloat64BE = Tee;
function Nee(t, e) {
  e === void 0 && (e = 0);
  var r = new DataView(t.buffer, t.byteOffset, t.byteLength);
  return r.getFloat64(e, !0);
}
Bt.readFloat64LE = Nee;
function Dee(t, e, r) {
  e === void 0 && (e = new Uint8Array(4)), r === void 0 && (r = 0);
  var i = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return i.setFloat32(r, t), e;
}
Bt.writeFloat32BE = Dee;
function Cee(t, e, r) {
  e === void 0 && (e = new Uint8Array(4)), r === void 0 && (r = 0);
  var i = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return i.setFloat32(r, t, !0), e;
}
Bt.writeFloat32LE = Cee;
function Oee(t, e, r) {
  e === void 0 && (e = new Uint8Array(8)), r === void 0 && (r = 0);
  var i = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return i.setFloat64(r, t), e;
}
Bt.writeFloat64BE = Oee;
function Ree(t, e, r) {
  e === void 0 && (e = new Uint8Array(8)), r === void 0 && (r = 0);
  var i = new DataView(e.buffer, e.byteOffset, e.byteLength);
  return i.setFloat64(r, t, !0), e;
}
Bt.writeFloat64LE = Ree;
var Cn = {};
Object.defineProperty(Cn, "__esModule", { value: !0 });
function Lee(t) {
  for (var e = 0; e < t.length; e++)
    t[e] = 0;
  return t;
}
Cn.wipe = Lee;
Object.defineProperty(Up, "__esModule", { value: !0 });
var ki = Bt, Cm = Cn, Pee = 20;
function kee(t, e, r) {
  for (var i = 1634760805, s = 857760878, n = 2036477234, f = 1797285236, u = r[3] << 24 | r[2] << 16 | r[1] << 8 | r[0], h = r[7] << 24 | r[6] << 16 | r[5] << 8 | r[4], d = r[11] << 24 | r[10] << 16 | r[9] << 8 | r[8], l = r[15] << 24 | r[14] << 16 | r[13] << 8 | r[12], m = r[19] << 24 | r[18] << 16 | r[17] << 8 | r[16], b = r[23] << 24 | r[22] << 16 | r[21] << 8 | r[20], M = r[27] << 24 | r[26] << 16 | r[25] << 8 | r[24], A = r[31] << 24 | r[30] << 16 | r[29] << 8 | r[28], N = e[3] << 24 | e[2] << 16 | e[1] << 8 | e[0], R = e[7] << 24 | e[6] << 16 | e[5] << 8 | e[4], O = e[11] << 24 | e[10] << 16 | e[9] << 8 | e[8], P = e[15] << 24 | e[14] << 16 | e[13] << 8 | e[12], F = i, H = s, Q = n, Z = f, B = u, Y = h, ae = d, se = l, W = m, C = b, g = M, a = A, c = N, p = R, w = O, _ = P, x = 0; x < Pee; x += 2)
    F = F + B | 0, c ^= F, c = c >>> 32 - 16 | c << 16, W = W + c | 0, B ^= W, B = B >>> 32 - 12 | B << 12, H = H + Y | 0, p ^= H, p = p >>> 32 - 16 | p << 16, C = C + p | 0, Y ^= C, Y = Y >>> 32 - 12 | Y << 12, Q = Q + ae | 0, w ^= Q, w = w >>> 32 - 16 | w << 16, g = g + w | 0, ae ^= g, ae = ae >>> 32 - 12 | ae << 12, Z = Z + se | 0, _ ^= Z, _ = _ >>> 32 - 16 | _ << 16, a = a + _ | 0, se ^= a, se = se >>> 32 - 12 | se << 12, Q = Q + ae | 0, w ^= Q, w = w >>> 32 - 8 | w << 8, g = g + w | 0, ae ^= g, ae = ae >>> 32 - 7 | ae << 7, Z = Z + se | 0, _ ^= Z, _ = _ >>> 32 - 8 | _ << 8, a = a + _ | 0, se ^= a, se = se >>> 32 - 7 | se << 7, H = H + Y | 0, p ^= H, p = p >>> 32 - 8 | p << 8, C = C + p | 0, Y ^= C, Y = Y >>> 32 - 7 | Y << 7, F = F + B | 0, c ^= F, c = c >>> 32 - 8 | c << 8, W = W + c | 0, B ^= W, B = B >>> 32 - 7 | B << 7, F = F + Y | 0, _ ^= F, _ = _ >>> 32 - 16 | _ << 16, g = g + _ | 0, Y ^= g, Y = Y >>> 32 - 12 | Y << 12, H = H + ae | 0, c ^= H, c = c >>> 32 - 16 | c << 16, a = a + c | 0, ae ^= a, ae = ae >>> 32 - 12 | ae << 12, Q = Q + se | 0, p ^= Q, p = p >>> 32 - 16 | p << 16, W = W + p | 0, se ^= W, se = se >>> 32 - 12 | se << 12, Z = Z + B | 0, w ^= Z, w = w >>> 32 - 16 | w << 16, C = C + w | 0, B ^= C, B = B >>> 32 - 12 | B << 12, Q = Q + se | 0, p ^= Q, p = p >>> 32 - 8 | p << 8, W = W + p | 0, se ^= W, se = se >>> 32 - 7 | se << 7, Z = Z + B | 0, w ^= Z, w = w >>> 32 - 8 | w << 8, C = C + w | 0, B ^= C, B = B >>> 32 - 7 | B << 7, H = H + ae | 0, c ^= H, c = c >>> 32 - 8 | c << 8, a = a + c | 0, ae ^= a, ae = ae >>> 32 - 7 | ae << 7, F = F + Y | 0, _ ^= F, _ = _ >>> 32 - 8 | _ << 8, g = g + _ | 0, Y ^= g, Y = Y >>> 32 - 7 | Y << 7;
  ki.writeUint32LE(F + i | 0, t, 0), ki.writeUint32LE(H + s | 0, t, 4), ki.writeUint32LE(Q + n | 0, t, 8), ki.writeUint32LE(Z + f | 0, t, 12), ki.writeUint32LE(B + u | 0, t, 16), ki.writeUint32LE(Y + h | 0, t, 20), ki.writeUint32LE(ae + d | 0, t, 24), ki.writeUint32LE(se + l | 0, t, 28), ki.writeUint32LE(W + m | 0, t, 32), ki.writeUint32LE(C + b | 0, t, 36), ki.writeUint32LE(g + M | 0, t, 40), ki.writeUint32LE(a + A | 0, t, 44), ki.writeUint32LE(c + N | 0, t, 48), ki.writeUint32LE(p + R | 0, t, 52), ki.writeUint32LE(w + O | 0, t, 56), ki.writeUint32LE(_ + P | 0, t, 60);
}
function HI(t, e, r, i, s) {
  if (s === void 0 && (s = 0), t.length !== 32)
    throw new Error("ChaCha: key size must be 32 bytes");
  if (i.length < r.length)
    throw new Error("ChaCha: destination is shorter than source");
  var n, f;
  if (s === 0) {
    if (e.length !== 8 && e.length !== 12)
      throw new Error("ChaCha nonce must be 8 or 12 bytes");
    n = new Uint8Array(16), f = n.length - e.length, n.set(e, f);
  } else {
    if (e.length !== 16)
      throw new Error("ChaCha nonce with counter must be 16 bytes");
    n = e, f = s;
  }
  for (var u = new Uint8Array(64), h = 0; h < r.length; h += 64) {
    kee(u, n, t);
    for (var d = h; d < h + 64 && d < r.length; d++)
      i[d] = r[d] ^ u[d - h];
    Bee(n, 0, f);
  }
  return Cm.wipe(u), s === 0 && Cm.wipe(n), i;
}
Up.streamXOR = HI;
function jee(t, e, r, i) {
  return i === void 0 && (i = 0), Cm.wipe(r), HI(t, e, r, r, i);
}
Up.stream = jee;
function Bee(t, e, r) {
  for (var i = 1; r--; )
    i = i + (t[e] & 255) | 0, t[e] = i & 255, i >>>= 8, e++;
  if (i > 0)
    throw new Error("ChaCha: counter overflow");
}
var WI = {}, bo = {};
Object.defineProperty(bo, "__esModule", { value: !0 });
function zee(t, e, r) {
  return ~(t - 1) & e | t - 1 & r;
}
bo.select = zee;
function Uee(t, e) {
  return (t | 0) - (e | 0) - 1 >>> 31 & 1;
}
bo.lessOrEqual = Uee;
function VI(t, e) {
  if (t.length !== e.length)
    return 0;
  for (var r = 0, i = 0; i < t.length; i++)
    r |= t[i] ^ e[i];
  return 1 & r - 1 >>> 8;
}
bo.compare = VI;
function Fee(t, e) {
  return t.length === 0 || e.length === 0 ? !1 : VI(t, e) !== 0;
}
bo.equal = Fee;
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = bo, r = Cn;
  t.DIGEST_LENGTH = 16;
  var i = function() {
    function f(u) {
      this.digestLength = t.DIGEST_LENGTH, this._buffer = new Uint8Array(16), this._r = new Uint16Array(10), this._h = new Uint16Array(10), this._pad = new Uint16Array(8), this._leftover = 0, this._fin = 0, this._finished = !1;
      var h = u[0] | u[1] << 8;
      this._r[0] = h & 8191;
      var d = u[2] | u[3] << 8;
      this._r[1] = (h >>> 13 | d << 3) & 8191;
      var l = u[4] | u[5] << 8;
      this._r[2] = (d >>> 10 | l << 6) & 7939;
      var m = u[6] | u[7] << 8;
      this._r[3] = (l >>> 7 | m << 9) & 8191;
      var b = u[8] | u[9] << 8;
      this._r[4] = (m >>> 4 | b << 12) & 255, this._r[5] = b >>> 1 & 8190;
      var M = u[10] | u[11] << 8;
      this._r[6] = (b >>> 14 | M << 2) & 8191;
      var A = u[12] | u[13] << 8;
      this._r[7] = (M >>> 11 | A << 5) & 8065;
      var N = u[14] | u[15] << 8;
      this._r[8] = (A >>> 8 | N << 8) & 8191, this._r[9] = N >>> 5 & 127, this._pad[0] = u[16] | u[17] << 8, this._pad[1] = u[18] | u[19] << 8, this._pad[2] = u[20] | u[21] << 8, this._pad[3] = u[22] | u[23] << 8, this._pad[4] = u[24] | u[25] << 8, this._pad[5] = u[26] | u[27] << 8, this._pad[6] = u[28] | u[29] << 8, this._pad[7] = u[30] | u[31] << 8;
    }
    return f.prototype._blocks = function(u, h, d) {
      for (var l = this._fin ? 0 : 2048, m = this._h[0], b = this._h[1], M = this._h[2], A = this._h[3], N = this._h[4], R = this._h[5], O = this._h[6], P = this._h[7], F = this._h[8], H = this._h[9], Q = this._r[0], Z = this._r[1], B = this._r[2], Y = this._r[3], ae = this._r[4], se = this._r[5], W = this._r[6], C = this._r[7], g = this._r[8], a = this._r[9]; d >= 16; ) {
        var c = u[h + 0] | u[h + 1] << 8;
        m += c & 8191;
        var p = u[h + 2] | u[h + 3] << 8;
        b += (c >>> 13 | p << 3) & 8191;
        var w = u[h + 4] | u[h + 5] << 8;
        M += (p >>> 10 | w << 6) & 8191;
        var _ = u[h + 6] | u[h + 7] << 8;
        A += (w >>> 7 | _ << 9) & 8191;
        var x = u[h + 8] | u[h + 9] << 8;
        N += (_ >>> 4 | x << 12) & 8191, R += x >>> 1 & 8191;
        var E = u[h + 10] | u[h + 11] << 8;
        O += (x >>> 14 | E << 2) & 8191;
        var y = u[h + 12] | u[h + 13] << 8;
        P += (E >>> 11 | y << 5) & 8191;
        var o = u[h + 14] | u[h + 15] << 8;
        F += (y >>> 8 | o << 8) & 8191, H += o >>> 5 | l;
        var S = 0, J = S;
        J += m * Q, J += b * (5 * a), J += M * (5 * g), J += A * (5 * C), J += N * (5 * W), S = J >>> 13, J &= 8191, J += R * (5 * se), J += O * (5 * ae), J += P * (5 * Y), J += F * (5 * B), J += H * (5 * Z), S += J >>> 13, J &= 8191;
        var z = S;
        z += m * Z, z += b * Q, z += M * (5 * a), z += A * (5 * g), z += N * (5 * C), S = z >>> 13, z &= 8191, z += R * (5 * W), z += O * (5 * se), z += P * (5 * ae), z += F * (5 * Y), z += H * (5 * B), S += z >>> 13, z &= 8191;
        var k = S;
        k += m * B, k += b * Z, k += M * Q, k += A * (5 * a), k += N * (5 * g), S = k >>> 13, k &= 8191, k += R * (5 * C), k += O * (5 * W), k += P * (5 * se), k += F * (5 * ae), k += H * (5 * Y), S += k >>> 13, k &= 8191;
        var j = S;
        j += m * Y, j += b * B, j += M * Z, j += A * Q, j += N * (5 * a), S = j >>> 13, j &= 8191, j += R * (5 * g), j += O * (5 * C), j += P * (5 * W), j += F * (5 * se), j += H * (5 * ae), S += j >>> 13, j &= 8191;
        var q = S;
        q += m * ae, q += b * Y, q += M * B, q += A * Z, q += N * Q, S = q >>> 13, q &= 8191, q += R * (5 * a), q += O * (5 * g), q += P * (5 * C), q += F * (5 * W), q += H * (5 * se), S += q >>> 13, q &= 8191;
        var K = S;
        K += m * se, K += b * ae, K += M * Y, K += A * B, K += N * Z, S = K >>> 13, K &= 8191, K += R * Q, K += O * (5 * a), K += P * (5 * g), K += F * (5 * C), K += H * (5 * W), S += K >>> 13, K &= 8191;
        var U = S;
        U += m * W, U += b * se, U += M * ae, U += A * Y, U += N * B, S = U >>> 13, U &= 8191, U += R * Z, U += O * Q, U += P * (5 * a), U += F * (5 * g), U += H * (5 * C), S += U >>> 13, U &= 8191;
        var T = S;
        T += m * C, T += b * W, T += M * se, T += A * ae, T += N * Y, S = T >>> 13, T &= 8191, T += R * B, T += O * Z, T += P * Q, T += F * (5 * a), T += H * (5 * g), S += T >>> 13, T &= 8191;
        var D = S;
        D += m * g, D += b * C, D += M * W, D += A * se, D += N * ae, S = D >>> 13, D &= 8191, D += R * Y, D += O * B, D += P * Z, D += F * Q, D += H * (5 * a), S += D >>> 13, D &= 8191;
        var te = S;
        te += m * a, te += b * g, te += M * C, te += A * W, te += N * se, S = te >>> 13, te &= 8191, te += R * ae, te += O * Y, te += P * B, te += F * Z, te += H * Q, S += te >>> 13, te &= 8191, S = (S << 2) + S | 0, S = S + J | 0, J = S & 8191, S = S >>> 13, z += S, m = J, b = z, M = k, A = j, N = q, R = K, O = U, P = T, F = D, H = te, h += 16, d -= 16;
      }
      this._h[0] = m, this._h[1] = b, this._h[2] = M, this._h[3] = A, this._h[4] = N, this._h[5] = R, this._h[6] = O, this._h[7] = P, this._h[8] = F, this._h[9] = H;
    }, f.prototype.finish = function(u, h) {
      h === void 0 && (h = 0);
      var d = new Uint16Array(10), l, m, b, M;
      if (this._leftover) {
        for (M = this._leftover, this._buffer[M++] = 1; M < 16; M++)
          this._buffer[M] = 0;
        this._fin = 1, this._blocks(this._buffer, 0, 16);
      }
      for (l = this._h[1] >>> 13, this._h[1] &= 8191, M = 2; M < 10; M++)
        this._h[M] += l, l = this._h[M] >>> 13, this._h[M] &= 8191;
      for (this._h[0] += l * 5, l = this._h[0] >>> 13, this._h[0] &= 8191, this._h[1] += l, l = this._h[1] >>> 13, this._h[1] &= 8191, this._h[2] += l, d[0] = this._h[0] + 5, l = d[0] >>> 13, d[0] &= 8191, M = 1; M < 10; M++)
        d[M] = this._h[M] + l, l = d[M] >>> 13, d[M] &= 8191;
      for (d[9] -= 1 << 13, m = (l ^ 1) - 1, M = 0; M < 10; M++)
        d[M] &= m;
      for (m = ~m, M = 0; M < 10; M++)
        this._h[M] = this._h[M] & m | d[M];
      for (this._h[0] = (this._h[0] | this._h[1] << 13) & 65535, this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 65535, this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 65535, this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 65535, this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 65535, this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 65535, this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 65535, this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 65535, b = this._h[0] + this._pad[0], this._h[0] = b & 65535, M = 1; M < 8; M++)
        b = (this._h[M] + this._pad[M] | 0) + (b >>> 16) | 0, this._h[M] = b & 65535;
      return u[h + 0] = this._h[0] >>> 0, u[h + 1] = this._h[0] >>> 8, u[h + 2] = this._h[1] >>> 0, u[h + 3] = this._h[1] >>> 8, u[h + 4] = this._h[2] >>> 0, u[h + 5] = this._h[2] >>> 8, u[h + 6] = this._h[3] >>> 0, u[h + 7] = this._h[3] >>> 8, u[h + 8] = this._h[4] >>> 0, u[h + 9] = this._h[4] >>> 8, u[h + 10] = this._h[5] >>> 0, u[h + 11] = this._h[5] >>> 8, u[h + 12] = this._h[6] >>> 0, u[h + 13] = this._h[6] >>> 8, u[h + 14] = this._h[7] >>> 0, u[h + 15] = this._h[7] >>> 8, this._finished = !0, this;
    }, f.prototype.update = function(u) {
      var h = 0, d = u.length, l;
      if (this._leftover) {
        l = 16 - this._leftover, l > d && (l = d);
        for (var m = 0; m < l; m++)
          this._buffer[this._leftover + m] = u[h + m];
        if (d -= l, h += l, this._leftover += l, this._leftover < 16)
          return this;
        this._blocks(this._buffer, 0, 16), this._leftover = 0;
      }
      if (d >= 16 && (l = d - d % 16, this._blocks(u, h, l), h += l, d -= l), d) {
        for (var m = 0; m < d; m++)
          this._buffer[this._leftover + m] = u[h + m];
        this._leftover += d;
      }
      return this;
    }, f.prototype.digest = function() {
      if (this._finished)
        throw new Error("Poly1305 was finished");
      var u = new Uint8Array(16);
      return this.finish(u), u;
    }, f.prototype.clean = function() {
      return r.wipe(this._buffer), r.wipe(this._r), r.wipe(this._h), r.wipe(this._pad), this._leftover = 0, this._fin = 0, this._finished = !0, this;
    }, f;
  }();
  t.Poly1305 = i;
  function s(f, u) {
    var h = new i(f);
    h.update(u);
    var d = h.digest();
    return h.clean(), d;
  }
  t.oneTimeAuth = s;
  function n(f, u) {
    return f.length !== t.DIGEST_LENGTH || u.length !== t.DIGEST_LENGTH ? !1 : e.equal(f, u);
  }
  t.equal = n;
})(WI);
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = Up, r = WI, i = Cn, s = Bt, n = bo;
  t.KEY_LENGTH = 32, t.NONCE_LENGTH = 12, t.TAG_LENGTH = 16;
  var f = new Uint8Array(16), u = function() {
    function h(d) {
      if (this.nonceLength = t.NONCE_LENGTH, this.tagLength = t.TAG_LENGTH, d.length !== t.KEY_LENGTH)
        throw new Error("ChaCha20Poly1305 needs 32-byte key");
      this._key = new Uint8Array(d);
    }
    return h.prototype.seal = function(d, l, m, b) {
      if (d.length > 16)
        throw new Error("ChaCha20Poly1305: incorrect nonce length");
      var M = new Uint8Array(16);
      M.set(d, M.length - d.length);
      var A = new Uint8Array(32);
      e.stream(this._key, M, A, 4);
      var N = l.length + this.tagLength, R;
      if (b) {
        if (b.length !== N)
          throw new Error("ChaCha20Poly1305: incorrect destination length");
        R = b;
      } else
        R = new Uint8Array(N);
      return e.streamXOR(this._key, M, l, R, 4), this._authenticate(R.subarray(R.length - this.tagLength, R.length), A, R.subarray(0, R.length - this.tagLength), m), i.wipe(M), R;
    }, h.prototype.open = function(d, l, m, b) {
      if (d.length > 16)
        throw new Error("ChaCha20Poly1305: incorrect nonce length");
      if (l.length < this.tagLength)
        return null;
      var M = new Uint8Array(16);
      M.set(d, M.length - d.length);
      var A = new Uint8Array(32);
      e.stream(this._key, M, A, 4);
      var N = new Uint8Array(this.tagLength);
      if (this._authenticate(N, A, l.subarray(0, l.length - this.tagLength), m), !n.equal(N, l.subarray(l.length - this.tagLength, l.length)))
        return null;
      var R = l.length - this.tagLength, O;
      if (b) {
        if (b.length !== R)
          throw new Error("ChaCha20Poly1305: incorrect destination length");
        O = b;
      } else
        O = new Uint8Array(R);
      return e.streamXOR(this._key, M, l.subarray(0, l.length - this.tagLength), O, 4), i.wipe(M), O;
    }, h.prototype.clean = function() {
      return i.wipe(this._key), this;
    }, h.prototype._authenticate = function(d, l, m, b) {
      var M = new r.Poly1305(l);
      b && (M.update(b), b.length % 16 > 0 && M.update(f.subarray(b.length % 16))), M.update(m), m.length % 16 > 0 && M.update(f.subarray(m.length % 16));
      var A = new Uint8Array(8);
      b && s.writeUint64LE(b.length, A), M.update(A), s.writeUint64LE(m.length, A), M.update(A);
      for (var N = M.digest(), R = 0; R < N.length; R++)
        d[R] = N[R];
      M.clean(), i.wipe(N), i.wipe(A);
    }, h;
  }();
  t.ChaCha20Poly1305 = u;
})(fw);
var GI = {}, Zh = {}, cw = {};
Object.defineProperty(cw, "__esModule", { value: !0 });
function $ee(t) {
  return typeof t.saveState < "u" && typeof t.restoreState < "u" && typeof t.cleanSavedState < "u";
}
cw.isSerializableHash = $ee;
Object.defineProperty(Zh, "__esModule", { value: !0 });
var zs = cw, qee = bo, Hee = Cn, KI = function() {
  function t(e, r) {
    this._finished = !1, this._inner = new e(), this._outer = new e(), this.blockSize = this._outer.blockSize, this.digestLength = this._outer.digestLength;
    var i = new Uint8Array(this.blockSize);
    r.length > this.blockSize ? this._inner.update(r).finish(i).clean() : i.set(r);
    for (var s = 0; s < i.length; s++)
      i[s] ^= 54;
    this._inner.update(i);
    for (var s = 0; s < i.length; s++)
      i[s] ^= 106;
    this._outer.update(i), zs.isSerializableHash(this._inner) && zs.isSerializableHash(this._outer) && (this._innerKeyedState = this._inner.saveState(), this._outerKeyedState = this._outer.saveState()), Hee.wipe(i);
  }
  return t.prototype.reset = function() {
    if (!zs.isSerializableHash(this._inner) || !zs.isSerializableHash(this._outer))
      throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
    return this._inner.restoreState(this._innerKeyedState), this._outer.restoreState(this._outerKeyedState), this._finished = !1, this;
  }, t.prototype.clean = function() {
    zs.isSerializableHash(this._inner) && this._inner.cleanSavedState(this._innerKeyedState), zs.isSerializableHash(this._outer) && this._outer.cleanSavedState(this._outerKeyedState), this._inner.clean(), this._outer.clean();
  }, t.prototype.update = function(e) {
    return this._inner.update(e), this;
  }, t.prototype.finish = function(e) {
    return this._finished ? (this._outer.finish(e), this) : (this._inner.finish(e), this._outer.update(e.subarray(0, this.digestLength)).finish(e), this._finished = !0, this);
  }, t.prototype.digest = function() {
    var e = new Uint8Array(this.digestLength);
    return this.finish(e), e;
  }, t.prototype.saveState = function() {
    if (!zs.isSerializableHash(this._inner))
      throw new Error("hmac: can't saveState() because hash doesn't implement it");
    return this._inner.saveState();
  }, t.prototype.restoreState = function(e) {
    if (!zs.isSerializableHash(this._inner) || !zs.isSerializableHash(this._outer))
      throw new Error("hmac: can't restoreState() because hash doesn't implement it");
    return this._inner.restoreState(e), this._outer.restoreState(this._outerKeyedState), this._finished = !1, this;
  }, t.prototype.cleanSavedState = function(e) {
    if (!zs.isSerializableHash(this._inner))
      throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
    this._inner.cleanSavedState(e);
  }, t;
}();
Zh.HMAC = KI;
function Wee(t, e, r) {
  var i = new KI(t, e);
  i.update(r);
  var s = i.digest();
  return i.clean(), s;
}
Zh.hmac = Wee;
Zh.equal = qee.equal;
Object.defineProperty(GI, "__esModule", { value: !0 });
var f5 = Zh, c5 = Cn, Vee = function() {
  function t(e, r, i, s) {
    i === void 0 && (i = new Uint8Array(0)), this._counter = new Uint8Array(1), this._hash = e, this._info = s;
    var n = f5.hmac(this._hash, i, r);
    this._hmac = new f5.HMAC(e, n), this._buffer = new Uint8Array(this._hmac.digestLength), this._bufpos = this._buffer.length;
  }
  return t.prototype._fillBuffer = function() {
    this._counter[0]++;
    var e = this._counter[0];
    if (e === 0)
      throw new Error("hkdf: cannot expand more");
    this._hmac.reset(), e > 1 && this._hmac.update(this._buffer), this._info && this._hmac.update(this._info), this._hmac.update(this._counter), this._hmac.finish(this._buffer), this._bufpos = 0;
  }, t.prototype.expand = function(e) {
    for (var r = new Uint8Array(e), i = 0; i < r.length; i++)
      this._bufpos === this._buffer.length && this._fillBuffer(), r[i] = this._buffer[this._bufpos++];
    return r;
  }, t.prototype.clean = function() {
    this._hmac.clean(), c5.wipe(this._buffer), c5.wipe(this._counter), this._bufpos = 0;
  }, t;
}(), Gee = GI.HKDF = Vee, yo = {}, Fp = {}, $p = {};
Object.defineProperty($p, "__esModule", { value: !0 });
$p.BrowserRandomSource = void 0;
const u5 = 65536;
class Kee {
  constructor() {
    this.isAvailable = !1, this.isInstantiated = !1;
    const e = typeof self < "u" ? self.crypto || self.msCrypto : null;
    e && e.getRandomValues !== void 0 && (this._crypto = e, this.isAvailable = !0, this.isInstantiated = !0);
  }
  randomBytes(e) {
    if (!this.isAvailable || !this._crypto)
      throw new Error("Browser random byte generator is not available.");
    const r = new Uint8Array(e);
    for (let i = 0; i < r.length; i += u5)
      this._crypto.getRandomValues(r.subarray(i, i + Math.min(r.length - i, u5)));
    return r;
  }
}
$p.BrowserRandomSource = Kee;
function Yee(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var qp = {}, Ut = {}, Ad = { exports: {} }, h5;
function Jc() {
  if (h5)
    return Ad.exports;
  h5 = 1;
  var t = 65536, e = 4294967295;
  function r() {
    throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
  }
  var i = Ft.exports.Buffer, s = nt.crypto || nt.msCrypto;
  s && s.getRandomValues ? Ad.exports = n : Ad.exports = r;
  function n(f, u) {
    if (f > e)
      throw new RangeError("requested too many random bytes");
    var h = i.allocUnsafe(f);
    if (f > 0)
      if (f > t)
        for (var d = 0; d < f; d += t)
          s.getRandomValues(h.slice(d, d + t));
      else
        s.getRandomValues(h);
    return typeof u == "function" ? process.nextTick(function() {
      u(null, h);
    }) : h;
  }
  return Ad.exports;
}
var Td = { exports: {} }, Tg, l5;
function YI() {
  return l5 || (l5 = 1, Tg = Pr.exports.EventEmitter), Tg;
}
var Ng, d5;
function Qee() {
  if (d5)
    return Ng;
  d5 = 1;
  function t(b, M) {
    var A = Object.keys(b);
    if (Object.getOwnPropertySymbols) {
      var N = Object.getOwnPropertySymbols(b);
      M && (N = N.filter(function(R) {
        return Object.getOwnPropertyDescriptor(b, R).enumerable;
      })), A.push.apply(A, N);
    }
    return A;
  }
  function e(b) {
    for (var M = 1; M < arguments.length; M++) {
      var A = arguments[M] != null ? arguments[M] : {};
      M % 2 ? t(Object(A), !0).forEach(function(N) {
        r(b, N, A[N]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(b, Object.getOwnPropertyDescriptors(A)) : t(Object(A)).forEach(function(N) {
        Object.defineProperty(b, N, Object.getOwnPropertyDescriptor(A, N));
      });
    }
    return b;
  }
  function r(b, M, A) {
    return M in b ? Object.defineProperty(b, M, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : b[M] = A, b;
  }
  function i(b, M) {
    if (!(b instanceof M))
      throw new TypeError("Cannot call a class as a function");
  }
  function s(b, M) {
    for (var A = 0; A < M.length; A++) {
      var N = M[A];
      N.enumerable = N.enumerable || !1, N.configurable = !0, "value" in N && (N.writable = !0), Object.defineProperty(b, N.key, N);
    }
  }
  function n(b, M, A) {
    return M && s(b.prototype, M), A && s(b, A), b;
  }
  var f = Tn, u = f.Buffer, h = dn, d = h.inspect, l = d && d.custom || "inspect";
  function m(b, M, A) {
    u.prototype.copy.call(b, M, A);
  }
  return Ng = /* @__PURE__ */ function() {
    function b() {
      i(this, b), this.head = null, this.tail = null, this.length = 0;
    }
    return n(b, [{
      key: "push",
      value: function(A) {
        var N = {
          data: A,
          next: null
        };
        this.length > 0 ? this.tail.next = N : this.head = N, this.tail = N, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(A) {
        var N = {
          data: A,
          next: this.head
        };
        this.length === 0 && (this.tail = N), this.head = N, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var A = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, A;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(A) {
        if (this.length === 0)
          return "";
        for (var N = this.head, R = "" + N.data; N = N.next; )
          R += A + N.data;
        return R;
      }
    }, {
      key: "concat",
      value: function(A) {
        if (this.length === 0)
          return u.alloc(0);
        for (var N = u.allocUnsafe(A >>> 0), R = this.head, O = 0; R; )
          m(R.data, N, O), O += R.data.length, R = R.next;
        return N;
      }
    }, {
      key: "consume",
      value: function(A, N) {
        var R;
        return A < this.head.data.length ? (R = this.head.data.slice(0, A), this.head.data = this.head.data.slice(A)) : A === this.head.data.length ? R = this.shift() : R = N ? this._getString(A) : this._getBuffer(A), R;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
    }, {
      key: "_getString",
      value: function(A) {
        var N = this.head, R = 1, O = N.data;
        for (A -= O.length; N = N.next; ) {
          var P = N.data, F = A > P.length ? P.length : A;
          if (F === P.length ? O += P : O += P.slice(0, A), A -= F, A === 0) {
            F === P.length ? (++R, N.next ? this.head = N.next : this.head = this.tail = null) : (this.head = N, N.data = P.slice(F));
            break;
          }
          ++R;
        }
        return this.length -= R, O;
      }
    }, {
      key: "_getBuffer",
      value: function(A) {
        var N = u.allocUnsafe(A), R = this.head, O = 1;
        for (R.data.copy(N), A -= R.data.length; R = R.next; ) {
          var P = R.data, F = A > P.length ? P.length : A;
          if (P.copy(N, N.length - A, 0, F), A -= F, A === 0) {
            F === P.length ? (++O, R.next ? this.head = R.next : this.head = this.tail = null) : (this.head = R, R.data = P.slice(F));
            break;
          }
          ++O;
        }
        return this.length -= O, N;
      }
    }, {
      key: l,
      value: function(A, N) {
        return d(this, e({}, N, {
          depth: 0,
          customInspect: !1
        }));
      }
    }]), b;
  }(), Ng;
}
var Dg, p5;
function QI() {
  if (p5)
    return Dg;
  p5 = 1;
  function t(f, u) {
    var h = this, d = this._readableState && this._readableState.destroyed, l = this._writableState && this._writableState.destroyed;
    return d || l ? (u ? u(f) : f && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process.nextTick(s, this, f)) : process.nextTick(s, this, f)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(f || null, function(m) {
      !u && m ? h._writableState ? h._writableState.errorEmitted ? process.nextTick(r, h) : (h._writableState.errorEmitted = !0, process.nextTick(e, h, m)) : process.nextTick(e, h, m) : u ? (process.nextTick(r, h), u(m)) : process.nextTick(r, h);
    }), this);
  }
  function e(f, u) {
    s(f, u), r(f);
  }
  function r(f) {
    f._writableState && !f._writableState.emitClose || f._readableState && !f._readableState.emitClose || f.emit("close");
  }
  function i() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function s(f, u) {
    f.emit("error", u);
  }
  function n(f, u) {
    var h = f._readableState, d = f._writableState;
    h && h.autoDestroy || d && d.autoDestroy ? f.destroy(u) : f.emit("error", u);
  }
  return Dg = {
    destroy: t,
    undestroy: i,
    errorOrDestroy: n
  }, Dg;
}
var Cg = {}, v5;
function Xc() {
  if (v5)
    return Cg;
  v5 = 1;
  function t(u, h) {
    u.prototype = Object.create(h.prototype), u.prototype.constructor = u, u.__proto__ = h;
  }
  var e = {};
  function r(u, h, d) {
    d || (d = Error);
    function l(b, M, A) {
      return typeof h == "string" ? h : h(b, M, A);
    }
    var m = /* @__PURE__ */ function(b) {
      t(M, b);
      function M(A, N, R) {
        return b.call(this, l(A, N, R)) || this;
      }
      return M;
    }(d);
    m.prototype.name = d.name, m.prototype.code = u, e[u] = m;
  }
  function i(u, h) {
    if (Array.isArray(u)) {
      var d = u.length;
      return u = u.map(function(l) {
        return String(l);
      }), d > 2 ? "one of ".concat(h, " ").concat(u.slice(0, d - 1).join(", "), ", or ") + u[d - 1] : d === 2 ? "one of ".concat(h, " ").concat(u[0], " or ").concat(u[1]) : "of ".concat(h, " ").concat(u[0]);
    } else
      return "of ".concat(h, " ").concat(String(u));
  }
  function s(u, h, d) {
    return u.substr(!d || d < 0 ? 0 : +d, h.length) === h;
  }
  function n(u, h, d) {
    return (d === void 0 || d > u.length) && (d = u.length), u.substring(d - h.length, d) === h;
  }
  function f(u, h, d) {
    return typeof d != "number" && (d = 0), d + h.length > u.length ? !1 : u.indexOf(h, d) !== -1;
  }
  return r("ERR_INVALID_OPT_VALUE", function(u, h) {
    return 'The value "' + h + '" is invalid for option "' + u + '"';
  }, TypeError), r("ERR_INVALID_ARG_TYPE", function(u, h, d) {
    var l;
    typeof h == "string" && s(h, "not ") ? (l = "must not be", h = h.replace(/^not /, "")) : l = "must be";
    var m;
    if (n(u, " argument"))
      m = "The ".concat(u, " ").concat(l, " ").concat(i(h, "type"));
    else {
      var b = f(u, ".") ? "property" : "argument";
      m = 'The "'.concat(u, '" ').concat(b, " ").concat(l, " ").concat(i(h, "type"));
    }
    return m += ". Received type ".concat(typeof d), m;
  }, TypeError), r("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), r("ERR_METHOD_NOT_IMPLEMENTED", function(u) {
    return "The " + u + " method is not implemented";
  }), r("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), r("ERR_STREAM_DESTROYED", function(u) {
    return "Cannot call " + u + " after a stream was destroyed";
  }), r("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), r("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), r("ERR_STREAM_WRITE_AFTER_END", "write after end"), r("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), r("ERR_UNKNOWN_ENCODING", function(u) {
    return "Unknown encoding: " + u;
  }, TypeError), r("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), Cg.codes = e, Cg;
}
var Og, g5;
function ZI() {
  if (g5)
    return Og;
  g5 = 1;
  var t = Xc().codes.ERR_INVALID_OPT_VALUE;
  function e(i, s, n) {
    return i.highWaterMark != null ? i.highWaterMark : s ? i[n] : null;
  }
  function r(i, s, n, f) {
    var u = e(s, f, n);
    if (u != null) {
      if (!(isFinite(u) && Math.floor(u) === u) || u < 0) {
        var h = f ? n : "highWaterMark";
        throw new t(h, u);
      }
      return Math.floor(u);
    }
    return i.objectMode ? 16 : 16 * 1024;
  }
  return Og = {
    getHighWaterMark: r
  }, Og;
}
var Rg, b5;
function JI() {
  if (b5)
    return Rg;
  b5 = 1, Rg = Y;
  function t(k) {
    var j = this;
    this.next = null, this.entry = null, this.finish = function() {
      z(j, k);
    };
  }
  var e;
  Y.WritableState = Z;
  var r = {
    deprecate: x2()
  }, i = YI(), s = Tn.Buffer, n = nt.Uint8Array || function() {
  };
  function f(k) {
    return s.from(k);
  }
  function u(k) {
    return s.isBuffer(k) || k instanceof n;
  }
  var h = QI(), d = ZI(), l = d.getHighWaterMark, m = Xc().codes, b = m.ERR_INVALID_ARG_TYPE, M = m.ERR_METHOD_NOT_IMPLEMENTED, A = m.ERR_MULTIPLE_CALLBACK, N = m.ERR_STREAM_CANNOT_PIPE, R = m.ERR_STREAM_DESTROYED, O = m.ERR_STREAM_NULL_VALUES, P = m.ERR_STREAM_WRITE_AFTER_END, F = m.ERR_UNKNOWN_ENCODING, H = h.errorOrDestroy;
  It.exports(Y, i);
  function Q() {
  }
  function Z(k, j, q) {
    e = e || Rc(), k = k || {}, typeof q != "boolean" && (q = j instanceof e), this.objectMode = !!k.objectMode, q && (this.objectMode = this.objectMode || !!k.writableObjectMode), this.highWaterMark = l(this, k, "writableHighWaterMark", q), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var K = k.decodeStrings === !1;
    this.decodeStrings = !K, this.defaultEncoding = k.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(U) {
      p(j, U);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = k.emitClose !== !1, this.autoDestroy = !!k.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new t(this);
  }
  Z.prototype.getBuffer = function() {
    for (var j = this.bufferedRequest, q = []; j; )
      q.push(j), j = j.next;
    return q;
  }, function() {
    try {
      Object.defineProperty(Z.prototype, "buffer", {
        get: r.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var B;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (B = Function.prototype[Symbol.hasInstance], Object.defineProperty(Y, Symbol.hasInstance, {
    value: function(j) {
      return B.call(this, j) ? !0 : this !== Y ? !1 : j && j._writableState instanceof Z;
    }
  })) : B = function(j) {
    return j instanceof this;
  };
  function Y(k) {
    e = e || Rc();
    var j = this instanceof e;
    if (!j && !B.call(Y, this))
      return new Y(k);
    this._writableState = new Z(k, this, j), this.writable = !0, k && (typeof k.write == "function" && (this._write = k.write), typeof k.writev == "function" && (this._writev = k.writev), typeof k.destroy == "function" && (this._destroy = k.destroy), typeof k.final == "function" && (this._final = k.final)), i.call(this);
  }
  Y.prototype.pipe = function() {
    H(this, new N());
  };
  function ae(k, j) {
    var q = new P();
    H(k, q), process.nextTick(j, q);
  }
  function se(k, j, q, K) {
    var U;
    return q === null ? U = new O() : typeof q != "string" && !j.objectMode && (U = new b("chunk", ["string", "Buffer"], q)), U ? (H(k, U), process.nextTick(K, U), !1) : !0;
  }
  Y.prototype.write = function(k, j, q) {
    var K = this._writableState, U = !1, T = !K.objectMode && u(k);
    return T && !s.isBuffer(k) && (k = f(k)), typeof j == "function" && (q = j, j = null), T ? j = "buffer" : j || (j = K.defaultEncoding), typeof q != "function" && (q = Q), K.ending ? ae(this, q) : (T || se(this, K, k, q)) && (K.pendingcb++, U = C(this, K, T, k, j, q)), U;
  }, Y.prototype.cork = function() {
    this._writableState.corked++;
  }, Y.prototype.uncork = function() {
    var k = this._writableState;
    k.corked && (k.corked--, !k.writing && !k.corked && !k.bufferProcessing && k.bufferedRequest && x(this, k));
  }, Y.prototype.setDefaultEncoding = function(j) {
    if (typeof j == "string" && (j = j.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((j + "").toLowerCase()) > -1))
      throw new F(j);
    return this._writableState.defaultEncoding = j, this;
  }, Object.defineProperty(Y.prototype, "writableBuffer", {
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function W(k, j, q) {
    return !k.objectMode && k.decodeStrings !== !1 && typeof j == "string" && (j = s.from(j, q)), j;
  }
  Object.defineProperty(Y.prototype, "writableHighWaterMark", {
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function C(k, j, q, K, U, T) {
    if (!q) {
      var D = W(j, K, U);
      K !== D && (q = !0, U = "buffer", K = D);
    }
    var te = j.objectMode ? 1 : K.length;
    j.length += te;
    var ne = j.length < j.highWaterMark;
    if (ne || (j.needDrain = !0), j.writing || j.corked) {
      var le = j.lastBufferedRequest;
      j.lastBufferedRequest = {
        chunk: K,
        encoding: U,
        isBuf: q,
        callback: T,
        next: null
      }, le ? le.next = j.lastBufferedRequest : j.bufferedRequest = j.lastBufferedRequest, j.bufferedRequestCount += 1;
    } else
      g(k, j, !1, te, K, U, T);
    return ne;
  }
  function g(k, j, q, K, U, T, D) {
    j.writelen = K, j.writecb = D, j.writing = !0, j.sync = !0, j.destroyed ? j.onwrite(new R("write")) : q ? k._writev(U, j.onwrite) : k._write(U, T, j.onwrite), j.sync = !1;
  }
  function a(k, j, q, K, U) {
    --j.pendingcb, q ? (process.nextTick(U, K), process.nextTick(S, k, j), k._writableState.errorEmitted = !0, H(k, K)) : (U(K), k._writableState.errorEmitted = !0, H(k, K), S(k, j));
  }
  function c(k) {
    k.writing = !1, k.writecb = null, k.length -= k.writelen, k.writelen = 0;
  }
  function p(k, j) {
    var q = k._writableState, K = q.sync, U = q.writecb;
    if (typeof U != "function")
      throw new A();
    if (c(q), j)
      a(k, q, K, j, U);
    else {
      var T = E(q) || k.destroyed;
      !T && !q.corked && !q.bufferProcessing && q.bufferedRequest && x(k, q), K ? process.nextTick(w, k, q, T, U) : w(k, q, T, U);
    }
  }
  function w(k, j, q, K) {
    q || _(k, j), j.pendingcb--, K(), S(k, j);
  }
  function _(k, j) {
    j.length === 0 && j.needDrain && (j.needDrain = !1, k.emit("drain"));
  }
  function x(k, j) {
    j.bufferProcessing = !0;
    var q = j.bufferedRequest;
    if (k._writev && q && q.next) {
      var K = j.bufferedRequestCount, U = new Array(K), T = j.corkedRequestsFree;
      T.entry = q;
      for (var D = 0, te = !0; q; )
        U[D] = q, q.isBuf || (te = !1), q = q.next, D += 1;
      U.allBuffers = te, g(k, j, !0, j.length, U, "", T.finish), j.pendingcb++, j.lastBufferedRequest = null, T.next ? (j.corkedRequestsFree = T.next, T.next = null) : j.corkedRequestsFree = new t(j), j.bufferedRequestCount = 0;
    } else {
      for (; q; ) {
        var ne = q.chunk, le = q.encoding, X = q.callback, $ = j.objectMode ? 1 : ne.length;
        if (g(k, j, !1, $, ne, le, X), q = q.next, j.bufferedRequestCount--, j.writing)
          break;
      }
      q === null && (j.lastBufferedRequest = null);
    }
    j.bufferedRequest = q, j.bufferProcessing = !1;
  }
  Y.prototype._write = function(k, j, q) {
    q(new M("_write()"));
  }, Y.prototype._writev = null, Y.prototype.end = function(k, j, q) {
    var K = this._writableState;
    return typeof k == "function" ? (q = k, k = null, j = null) : typeof j == "function" && (q = j, j = null), k != null && this.write(k, j), K.corked && (K.corked = 1, this.uncork()), K.ending || J(this, K, q), this;
  }, Object.defineProperty(Y.prototype, "writableLength", {
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function E(k) {
    return k.ending && k.length === 0 && k.bufferedRequest === null && !k.finished && !k.writing;
  }
  function y(k, j) {
    k._final(function(q) {
      j.pendingcb--, q && H(k, q), j.prefinished = !0, k.emit("prefinish"), S(k, j);
    });
  }
  function o(k, j) {
    !j.prefinished && !j.finalCalled && (typeof k._final == "function" && !j.destroyed ? (j.pendingcb++, j.finalCalled = !0, process.nextTick(y, k, j)) : (j.prefinished = !0, k.emit("prefinish")));
  }
  function S(k, j) {
    var q = E(j);
    if (q && (o(k, j), j.pendingcb === 0 && (j.finished = !0, k.emit("finish"), j.autoDestroy))) {
      var K = k._readableState;
      (!K || K.autoDestroy && K.endEmitted) && k.destroy();
    }
    return q;
  }
  function J(k, j, q) {
    j.ending = !0, S(k, j), q && (j.finished ? process.nextTick(q) : k.once("finish", q)), j.ended = !0, k.writable = !1;
  }
  function z(k, j, q) {
    var K = k.entry;
    for (k.entry = null; K; ) {
      var U = K.callback;
      j.pendingcb--, U(q), K = K.next;
    }
    j.corkedRequestsFree.next = k;
  }
  return Object.defineProperty(Y.prototype, "destroyed", {
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(j) {
      !this._writableState || (this._writableState.destroyed = j);
    }
  }), Y.prototype.destroy = h.destroy, Y.prototype._undestroy = h.undestroy, Y.prototype._destroy = function(k, j) {
    j(k);
  }, Rg;
}
var Lg, y5;
function Rc() {
  if (y5)
    return Lg;
  y5 = 1;
  var t = Object.keys || function(d) {
    var l = [];
    for (var m in d)
      l.push(m);
    return l;
  };
  Lg = f;
  var e = XI(), r = JI();
  It.exports(f, e);
  for (var i = t(r.prototype), s = 0; s < i.length; s++) {
    var n = i[s];
    f.prototype[n] || (f.prototype[n] = r.prototype[n]);
  }
  function f(d) {
    if (!(this instanceof f))
      return new f(d);
    e.call(this, d), r.call(this, d), this.allowHalfOpen = !0, d && (d.readable === !1 && (this.readable = !1), d.writable === !1 && (this.writable = !1), d.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", u)));
  }
  Object.defineProperty(f.prototype, "writableHighWaterMark", {
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(f.prototype, "writableBuffer", {
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(f.prototype, "writableLength", {
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function u() {
    this._writableState.ended || process.nextTick(h, this);
  }
  function h(d) {
    d.end();
  }
  return Object.defineProperty(f.prototype, "destroyed", {
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(l) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = l, this._writableState.destroyed = l);
    }
  }), Lg;
}
var Pg, m5;
function uw() {
  if (m5)
    return Pg;
  m5 = 1;
  var t = Xc().codes.ERR_STREAM_PREMATURE_CLOSE;
  function e(n) {
    var f = !1;
    return function() {
      if (!f) {
        f = !0;
        for (var u = arguments.length, h = new Array(u), d = 0; d < u; d++)
          h[d] = arguments[d];
        n.apply(this, h);
      }
    };
  }
  function r() {
  }
  function i(n) {
    return n.setHeader && typeof n.abort == "function";
  }
  function s(n, f, u) {
    if (typeof f == "function")
      return s(n, null, f);
    f || (f = {}), u = e(u || r);
    var h = f.readable || f.readable !== !1 && n.readable, d = f.writable || f.writable !== !1 && n.writable, l = function() {
      n.writable || b();
    }, m = n._writableState && n._writableState.finished, b = function() {
      d = !1, m = !0, h || u.call(n);
    }, M = n._readableState && n._readableState.endEmitted, A = function() {
      h = !1, M = !0, d || u.call(n);
    }, N = function(F) {
      u.call(n, F);
    }, R = function() {
      var F;
      if (h && !M)
        return (!n._readableState || !n._readableState.ended) && (F = new t()), u.call(n, F);
      if (d && !m)
        return (!n._writableState || !n._writableState.ended) && (F = new t()), u.call(n, F);
    }, O = function() {
      n.req.on("finish", b);
    };
    return i(n) ? (n.on("complete", b), n.on("abort", R), n.req ? O() : n.on("request", O)) : d && !n._writableState && (n.on("end", l), n.on("close", l)), n.on("end", A), n.on("finish", b), f.error !== !1 && n.on("error", N), n.on("close", R), function() {
      n.removeListener("complete", b), n.removeListener("abort", R), n.removeListener("request", O), n.req && n.req.removeListener("finish", b), n.removeListener("end", l), n.removeListener("close", l), n.removeListener("finish", b), n.removeListener("end", A), n.removeListener("error", N), n.removeListener("close", R);
    };
  }
  return Pg = s, Pg;
}
var kg, w5;
function Zee() {
  if (w5)
    return kg;
  w5 = 1;
  var t;
  function e(O, P, F) {
    return P in O ? Object.defineProperty(O, P, { value: F, enumerable: !0, configurable: !0, writable: !0 }) : O[P] = F, O;
  }
  var r = uw(), i = Symbol("lastResolve"), s = Symbol("lastReject"), n = Symbol("error"), f = Symbol("ended"), u = Symbol("lastPromise"), h = Symbol("handlePromise"), d = Symbol("stream");
  function l(O, P) {
    return {
      value: O,
      done: P
    };
  }
  function m(O) {
    var P = O[i];
    if (P !== null) {
      var F = O[d].read();
      F !== null && (O[u] = null, O[i] = null, O[s] = null, P(l(F, !1)));
    }
  }
  function b(O) {
    process.nextTick(m, O);
  }
  function M(O, P) {
    return function(F, H) {
      O.then(function() {
        if (P[f]) {
          F(l(void 0, !0));
          return;
        }
        P[h](F, H);
      }, H);
    };
  }
  var A = Object.getPrototypeOf(function() {
  }), N = Object.setPrototypeOf((t = {
    get stream() {
      return this[d];
    },
    next: function() {
      var P = this, F = this[n];
      if (F !== null)
        return Promise.reject(F);
      if (this[f])
        return Promise.resolve(l(void 0, !0));
      if (this[d].destroyed)
        return new Promise(function(B, Y) {
          process.nextTick(function() {
            P[n] ? Y(P[n]) : B(l(void 0, !0));
          });
        });
      var H = this[u], Q;
      if (H)
        Q = new Promise(M(H, this));
      else {
        var Z = this[d].read();
        if (Z !== null)
          return Promise.resolve(l(Z, !1));
        Q = new Promise(this[h]);
      }
      return this[u] = Q, Q;
    }
  }, e(t, Symbol.asyncIterator, function() {
    return this;
  }), e(t, "return", function() {
    var P = this;
    return new Promise(function(F, H) {
      P[d].destroy(null, function(Q) {
        if (Q) {
          H(Q);
          return;
        }
        F(l(void 0, !0));
      });
    });
  }), t), A), R = function(P) {
    var F, H = Object.create(N, (F = {}, e(F, d, {
      value: P,
      writable: !0
    }), e(F, i, {
      value: null,
      writable: !0
    }), e(F, s, {
      value: null,
      writable: !0
    }), e(F, n, {
      value: null,
      writable: !0
    }), e(F, f, {
      value: P._readableState.endEmitted,
      writable: !0
    }), e(F, h, {
      value: function(Z, B) {
        var Y = H[d].read();
        Y ? (H[u] = null, H[i] = null, H[s] = null, Z(l(Y, !1))) : (H[i] = Z, H[s] = B);
      },
      writable: !0
    }), F));
    return H[u] = null, r(P, function(Q) {
      if (Q && Q.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var Z = H[s];
        Z !== null && (H[u] = null, H[i] = null, H[s] = null, Z(Q)), H[n] = Q;
        return;
      }
      var B = H[i];
      B !== null && (H[u] = null, H[i] = null, H[s] = null, B(l(void 0, !0))), H[f] = !0;
    }), P.on("readable", b.bind(null, H)), H;
  };
  return kg = R, kg;
}
var jg, _5;
function Jee() {
  return _5 || (_5 = 1, jg = function() {
    throw new Error("Readable.from is not available in the browser");
  }), jg;
}
var Bg, M5;
function XI() {
  if (M5)
    return Bg;
  M5 = 1, Bg = ae;
  var t;
  ae.ReadableState = Y, Pr.exports.EventEmitter;
  var e = function(D, te) {
    return D.listeners(te).length;
  }, r = YI(), i = Tn.Buffer, s = nt.Uint8Array || function() {
  };
  function n(T) {
    return i.from(T);
  }
  function f(T) {
    return i.isBuffer(T) || T instanceof s;
  }
  var u = dn, h;
  u && u.debuglog ? h = u.debuglog("stream") : h = function() {
  };
  var d = Qee(), l = QI(), m = ZI(), b = m.getHighWaterMark, M = Xc().codes, A = M.ERR_INVALID_ARG_TYPE, N = M.ERR_STREAM_PUSH_AFTER_EOF, R = M.ERR_METHOD_NOT_IMPLEMENTED, O = M.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, P, F, H;
  It.exports(ae, r);
  var Q = l.errorOrDestroy, Z = ["error", "close", "destroy", "pause", "resume"];
  function B(T, D, te) {
    if (typeof T.prependListener == "function")
      return T.prependListener(D, te);
    !T._events || !T._events[D] ? T.on(D, te) : Array.isArray(T._events[D]) ? T._events[D].unshift(te) : T._events[D] = [te, T._events[D]];
  }
  function Y(T, D, te) {
    t = t || Rc(), T = T || {}, typeof te != "boolean" && (te = D instanceof t), this.objectMode = !!T.objectMode, te && (this.objectMode = this.objectMode || !!T.readableObjectMode), this.highWaterMark = b(this, T, "readableHighWaterMark", te), this.buffer = new d(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = T.emitClose !== !1, this.autoDestroy = !!T.autoDestroy, this.destroyed = !1, this.defaultEncoding = T.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, T.encoding && (P || (P = of().StringDecoder), this.decoder = new P(T.encoding), this.encoding = T.encoding);
  }
  function ae(T) {
    if (t = t || Rc(), !(this instanceof ae))
      return new ae(T);
    var D = this instanceof t;
    this._readableState = new Y(T, this, D), this.readable = !0, T && (typeof T.read == "function" && (this._read = T.read), typeof T.destroy == "function" && (this._destroy = T.destroy)), r.call(this);
  }
  Object.defineProperty(ae.prototype, "destroyed", {
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(D) {
      !this._readableState || (this._readableState.destroyed = D);
    }
  }), ae.prototype.destroy = l.destroy, ae.prototype._undestroy = l.undestroy, ae.prototype._destroy = function(T, D) {
    D(T);
  }, ae.prototype.push = function(T, D) {
    var te = this._readableState, ne;
    return te.objectMode ? ne = !0 : typeof T == "string" && (D = D || te.defaultEncoding, D !== te.encoding && (T = i.from(T, D), D = ""), ne = !0), se(this, T, D, !1, ne);
  }, ae.prototype.unshift = function(T) {
    return se(this, T, null, !0, !1);
  };
  function se(T, D, te, ne, le) {
    h("readableAddChunk", D);
    var X = T._readableState;
    if (D === null)
      X.reading = !1, p(T, X);
    else {
      var $;
      if (le || ($ = C(X, D)), $)
        Q(T, $);
      else if (X.objectMode || D && D.length > 0)
        if (typeof D != "string" && !X.objectMode && Object.getPrototypeOf(D) !== i.prototype && (D = n(D)), ne)
          X.endEmitted ? Q(T, new O()) : W(T, X, D, !0);
        else if (X.ended)
          Q(T, new N());
        else {
          if (X.destroyed)
            return !1;
          X.reading = !1, X.decoder && !te ? (D = X.decoder.write(D), X.objectMode || D.length !== 0 ? W(T, X, D, !1) : x(T, X)) : W(T, X, D, !1);
        }
      else
        ne || (X.reading = !1, x(T, X));
    }
    return !X.ended && (X.length < X.highWaterMark || X.length === 0);
  }
  function W(T, D, te, ne) {
    D.flowing && D.length === 0 && !D.sync ? (D.awaitDrain = 0, T.emit("data", te)) : (D.length += D.objectMode ? 1 : te.length, ne ? D.buffer.unshift(te) : D.buffer.push(te), D.needReadable && w(T)), x(T, D);
  }
  function C(T, D) {
    var te;
    return !f(D) && typeof D != "string" && D !== void 0 && !T.objectMode && (te = new A("chunk", ["string", "Buffer", "Uint8Array"], D)), te;
  }
  ae.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, ae.prototype.setEncoding = function(T) {
    P || (P = of().StringDecoder);
    var D = new P(T);
    this._readableState.decoder = D, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var te = this._readableState.buffer.head, ne = ""; te !== null; )
      ne += D.write(te.data), te = te.next;
    return this._readableState.buffer.clear(), ne !== "" && this._readableState.buffer.push(ne), this._readableState.length = ne.length, this;
  };
  var g = 1073741824;
  function a(T) {
    return T >= g ? T = g : (T--, T |= T >>> 1, T |= T >>> 2, T |= T >>> 4, T |= T >>> 8, T |= T >>> 16, T++), T;
  }
  function c(T, D) {
    return T <= 0 || D.length === 0 && D.ended ? 0 : D.objectMode ? 1 : T !== T ? D.flowing && D.length ? D.buffer.head.data.length : D.length : (T > D.highWaterMark && (D.highWaterMark = a(T)), T <= D.length ? T : D.ended ? D.length : (D.needReadable = !0, 0));
  }
  ae.prototype.read = function(T) {
    h("read", T), T = parseInt(T, 10);
    var D = this._readableState, te = T;
    if (T !== 0 && (D.emittedReadable = !1), T === 0 && D.needReadable && ((D.highWaterMark !== 0 ? D.length >= D.highWaterMark : D.length > 0) || D.ended))
      return h("read: emitReadable", D.length, D.ended), D.length === 0 && D.ended ? q(this) : w(this), null;
    if (T = c(T, D), T === 0 && D.ended)
      return D.length === 0 && q(this), null;
    var ne = D.needReadable;
    h("need readable", ne), (D.length === 0 || D.length - T < D.highWaterMark) && (ne = !0, h("length less than watermark", ne)), D.ended || D.reading ? (ne = !1, h("reading or ended", ne)) : ne && (h("do read"), D.reading = !0, D.sync = !0, D.length === 0 && (D.needReadable = !0), this._read(D.highWaterMark), D.sync = !1, D.reading || (T = c(te, D)));
    var le;
    return T > 0 ? le = j(T, D) : le = null, le === null ? (D.needReadable = D.length <= D.highWaterMark, T = 0) : (D.length -= T, D.awaitDrain = 0), D.length === 0 && (D.ended || (D.needReadable = !0), te !== T && D.ended && q(this)), le !== null && this.emit("data", le), le;
  };
  function p(T, D) {
    if (h("onEofChunk"), !D.ended) {
      if (D.decoder) {
        var te = D.decoder.end();
        te && te.length && (D.buffer.push(te), D.length += D.objectMode ? 1 : te.length);
      }
      D.ended = !0, D.sync ? w(T) : (D.needReadable = !1, D.emittedReadable || (D.emittedReadable = !0, _(T)));
    }
  }
  function w(T) {
    var D = T._readableState;
    h("emitReadable", D.needReadable, D.emittedReadable), D.needReadable = !1, D.emittedReadable || (h("emitReadable", D.flowing), D.emittedReadable = !0, process.nextTick(_, T));
  }
  function _(T) {
    var D = T._readableState;
    h("emitReadable_", D.destroyed, D.length, D.ended), !D.destroyed && (D.length || D.ended) && (T.emit("readable"), D.emittedReadable = !1), D.needReadable = !D.flowing && !D.ended && D.length <= D.highWaterMark, k(T);
  }
  function x(T, D) {
    D.readingMore || (D.readingMore = !0, process.nextTick(E, T, D));
  }
  function E(T, D) {
    for (; !D.reading && !D.ended && (D.length < D.highWaterMark || D.flowing && D.length === 0); ) {
      var te = D.length;
      if (h("maybeReadMore read 0"), T.read(0), te === D.length)
        break;
    }
    D.readingMore = !1;
  }
  ae.prototype._read = function(T) {
    Q(this, new R("_read()"));
  }, ae.prototype.pipe = function(T, D) {
    var te = this, ne = this._readableState;
    switch (ne.pipesCount) {
      case 0:
        ne.pipes = T;
        break;
      case 1:
        ne.pipes = [ne.pipes, T];
        break;
      default:
        ne.pipes.push(T);
        break;
    }
    ne.pipesCount += 1, h("pipe count=%d opts=%j", ne.pipesCount, D);
    var le = (!D || D.end !== !1) && T !== process.stdout && T !== process.stderr, X = le ? V : ye;
    ne.endEmitted ? process.nextTick(X) : te.once("end", X), T.on("unpipe", $);
    function $(pe, Je) {
      h("onunpipe"), pe === te && Je && Je.hasUnpiped === !1 && (Je.hasUnpiped = !0, ue());
    }
    function V() {
      h("onend"), T.end();
    }
    var re = y(te);
    T.on("drain", re);
    var fe = !1;
    function ue() {
      h("cleanup"), T.removeListener("close", ve), T.removeListener("finish", Ge), T.removeListener("drain", re), T.removeListener("error", be), T.removeListener("unpipe", $), te.removeListener("end", V), te.removeListener("end", ye), te.removeListener("data", me), fe = !0, ne.awaitDrain && (!T._writableState || T._writableState.needDrain) && re();
    }
    te.on("data", me);
    function me(pe) {
      h("ondata");
      var Je = T.write(pe);
      h("dest.write", Je), Je === !1 && ((ne.pipesCount === 1 && ne.pipes === T || ne.pipesCount > 1 && U(ne.pipes, T) !== -1) && !fe && (h("false write response, pause", ne.awaitDrain), ne.awaitDrain++), te.pause());
    }
    function be(pe) {
      h("onerror", pe), ye(), T.removeListener("error", be), e(T, "error") === 0 && Q(T, pe);
    }
    B(T, "error", be);
    function ve() {
      T.removeListener("finish", Ge), ye();
    }
    T.once("close", ve);
    function Ge() {
      h("onfinish"), T.removeListener("close", ve), ye();
    }
    T.once("finish", Ge);
    function ye() {
      h("unpipe"), te.unpipe(T);
    }
    return T.emit("pipe", te), ne.flowing || (h("pipe resume"), te.resume()), T;
  };
  function y(T) {
    return function() {
      var te = T._readableState;
      h("pipeOnDrain", te.awaitDrain), te.awaitDrain && te.awaitDrain--, te.awaitDrain === 0 && e(T, "data") && (te.flowing = !0, k(T));
    };
  }
  ae.prototype.unpipe = function(T) {
    var D = this._readableState, te = {
      hasUnpiped: !1
    };
    if (D.pipesCount === 0)
      return this;
    if (D.pipesCount === 1)
      return T && T !== D.pipes ? this : (T || (T = D.pipes), D.pipes = null, D.pipesCount = 0, D.flowing = !1, T && T.emit("unpipe", this, te), this);
    if (!T) {
      var ne = D.pipes, le = D.pipesCount;
      D.pipes = null, D.pipesCount = 0, D.flowing = !1;
      for (var X = 0; X < le; X++)
        ne[X].emit("unpipe", this, {
          hasUnpiped: !1
        });
      return this;
    }
    var $ = U(D.pipes, T);
    return $ === -1 ? this : (D.pipes.splice($, 1), D.pipesCount -= 1, D.pipesCount === 1 && (D.pipes = D.pipes[0]), T.emit("unpipe", this, te), this);
  }, ae.prototype.on = function(T, D) {
    var te = r.prototype.on.call(this, T, D), ne = this._readableState;
    return T === "data" ? (ne.readableListening = this.listenerCount("readable") > 0, ne.flowing !== !1 && this.resume()) : T === "readable" && !ne.endEmitted && !ne.readableListening && (ne.readableListening = ne.needReadable = !0, ne.flowing = !1, ne.emittedReadable = !1, h("on readable", ne.length, ne.reading), ne.length ? w(this) : ne.reading || process.nextTick(S, this)), te;
  }, ae.prototype.addListener = ae.prototype.on, ae.prototype.removeListener = function(T, D) {
    var te = r.prototype.removeListener.call(this, T, D);
    return T === "readable" && process.nextTick(o, this), te;
  }, ae.prototype.removeAllListeners = function(T) {
    var D = r.prototype.removeAllListeners.apply(this, arguments);
    return (T === "readable" || T === void 0) && process.nextTick(o, this), D;
  };
  function o(T) {
    var D = T._readableState;
    D.readableListening = T.listenerCount("readable") > 0, D.resumeScheduled && !D.paused ? D.flowing = !0 : T.listenerCount("data") > 0 && T.resume();
  }
  function S(T) {
    h("readable nexttick read 0"), T.read(0);
  }
  ae.prototype.resume = function() {
    var T = this._readableState;
    return T.flowing || (h("resume"), T.flowing = !T.readableListening, J(this, T)), T.paused = !1, this;
  };
  function J(T, D) {
    D.resumeScheduled || (D.resumeScheduled = !0, process.nextTick(z, T, D));
  }
  function z(T, D) {
    h("resume", D.reading), D.reading || T.read(0), D.resumeScheduled = !1, T.emit("resume"), k(T), D.flowing && !D.reading && T.read(0);
  }
  ae.prototype.pause = function() {
    return h("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (h("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function k(T) {
    var D = T._readableState;
    for (h("flow", D.flowing); D.flowing && T.read() !== null; )
      ;
  }
  ae.prototype.wrap = function(T) {
    var D = this, te = this._readableState, ne = !1;
    T.on("end", function() {
      if (h("wrapped end"), te.decoder && !te.ended) {
        var $ = te.decoder.end();
        $ && $.length && D.push($);
      }
      D.push(null);
    }), T.on("data", function($) {
      if (h("wrapped data"), te.decoder && ($ = te.decoder.write($)), !(te.objectMode && $ == null) && !(!te.objectMode && (!$ || !$.length))) {
        var V = D.push($);
        V || (ne = !0, T.pause());
      }
    });
    for (var le in T)
      this[le] === void 0 && typeof T[le] == "function" && (this[le] = function(V) {
        return function() {
          return T[V].apply(T, arguments);
        };
      }(le));
    for (var X = 0; X < Z.length; X++)
      T.on(Z[X], this.emit.bind(this, Z[X]));
    return this._read = function($) {
      h("wrapped _read", $), ne && (ne = !1, T.resume());
    }, this;
  }, typeof Symbol == "function" && (ae.prototype[Symbol.asyncIterator] = function() {
    return F === void 0 && (F = Zee()), F(this);
  }), Object.defineProperty(ae.prototype, "readableHighWaterMark", {
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(ae.prototype, "readableBuffer", {
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(ae.prototype, "readableFlowing", {
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(D) {
      this._readableState && (this._readableState.flowing = D);
    }
  }), ae._fromList = j, Object.defineProperty(ae.prototype, "readableLength", {
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function j(T, D) {
    if (D.length === 0)
      return null;
    var te;
    return D.objectMode ? te = D.buffer.shift() : !T || T >= D.length ? (D.decoder ? te = D.buffer.join("") : D.buffer.length === 1 ? te = D.buffer.first() : te = D.buffer.concat(D.length), D.buffer.clear()) : te = D.buffer.consume(T, D.decoder), te;
  }
  function q(T) {
    var D = T._readableState;
    h("endReadable", D.endEmitted), D.endEmitted || (D.ended = !0, process.nextTick(K, D, T));
  }
  function K(T, D) {
    if (h("endReadableNT", T.endEmitted, T.length), !T.endEmitted && T.length === 0 && (T.endEmitted = !0, D.readable = !1, D.emit("end"), T.autoDestroy)) {
      var te = D._writableState;
      (!te || te.autoDestroy && te.finished) && D.destroy();
    }
  }
  typeof Symbol == "function" && (ae.from = function(T, D) {
    return H === void 0 && (H = Jee()), H(ae, T, D);
  });
  function U(T, D) {
    for (var te = 0, ne = T.length; te < ne; te++)
      if (T[te] === D)
        return te;
    return -1;
  }
  return Bg;
}
var zg, x5;
function eA() {
  if (x5)
    return zg;
  x5 = 1, zg = u;
  var t = Xc().codes, e = t.ERR_METHOD_NOT_IMPLEMENTED, r = t.ERR_MULTIPLE_CALLBACK, i = t.ERR_TRANSFORM_ALREADY_TRANSFORMING, s = t.ERR_TRANSFORM_WITH_LENGTH_0, n = Rc();
  It.exports(u, n);
  function f(l, m) {
    var b = this._transformState;
    b.transforming = !1;
    var M = b.writecb;
    if (M === null)
      return this.emit("error", new r());
    b.writechunk = null, b.writecb = null, m != null && this.push(m), M(l);
    var A = this._readableState;
    A.reading = !1, (A.needReadable || A.length < A.highWaterMark) && this._read(A.highWaterMark);
  }
  function u(l) {
    if (!(this instanceof u))
      return new u(l);
    n.call(this, l), this._transformState = {
      afterTransform: f.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, l && (typeof l.transform == "function" && (this._transform = l.transform), typeof l.flush == "function" && (this._flush = l.flush)), this.on("prefinish", h);
  }
  function h() {
    var l = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(m, b) {
      d(l, m, b);
    }) : d(this, null, null);
  }
  u.prototype.push = function(l, m) {
    return this._transformState.needTransform = !1, n.prototype.push.call(this, l, m);
  }, u.prototype._transform = function(l, m, b) {
    b(new e("_transform()"));
  }, u.prototype._write = function(l, m, b) {
    var M = this._transformState;
    if (M.writecb = b, M.writechunk = l, M.writeencoding = m, !M.transforming) {
      var A = this._readableState;
      (M.needTransform || A.needReadable || A.length < A.highWaterMark) && this._read(A.highWaterMark);
    }
  }, u.prototype._read = function(l) {
    var m = this._transformState;
    m.writechunk !== null && !m.transforming ? (m.transforming = !0, this._transform(m.writechunk, m.writeencoding, m.afterTransform)) : m.needTransform = !0;
  }, u.prototype._destroy = function(l, m) {
    n.prototype._destroy.call(this, l, function(b) {
      m(b);
    });
  };
  function d(l, m, b) {
    if (m)
      return l.emit("error", m);
    if (b != null && l.push(b), l._writableState.length)
      throw new s();
    if (l._transformState.transforming)
      throw new i();
    return l.push(null);
  }
  return zg;
}
var Ug, S5;
function Xee() {
  if (S5)
    return Ug;
  S5 = 1, Ug = e;
  var t = eA();
  It.exports(e, t);
  function e(r) {
    if (!(this instanceof e))
      return new e(r);
    t.call(this, r);
  }
  return e.prototype._transform = function(r, i, s) {
    s(null, r);
  }, Ug;
}
var Fg, E5;
function ete() {
  if (E5)
    return Fg;
  E5 = 1;
  var t;
  function e(b) {
    var M = !1;
    return function() {
      M || (M = !0, b.apply(void 0, arguments));
    };
  }
  var r = Xc().codes, i = r.ERR_MISSING_ARGS, s = r.ERR_STREAM_DESTROYED;
  function n(b) {
    if (b)
      throw b;
  }
  function f(b) {
    return b.setHeader && typeof b.abort == "function";
  }
  function u(b, M, A, N) {
    N = e(N);
    var R = !1;
    b.on("close", function() {
      R = !0;
    }), t === void 0 && (t = uw()), t(b, {
      readable: M,
      writable: A
    }, function(P) {
      if (P)
        return N(P);
      R = !0, N();
    });
    var O = !1;
    return function(P) {
      if (!R && !O) {
        if (O = !0, f(b))
          return b.abort();
        if (typeof b.destroy == "function")
          return b.destroy();
        N(P || new s("pipe"));
      }
    };
  }
  function h(b) {
    b();
  }
  function d(b, M) {
    return b.pipe(M);
  }
  function l(b) {
    return !b.length || typeof b[b.length - 1] != "function" ? n : b.pop();
  }
  function m() {
    for (var b = arguments.length, M = new Array(b), A = 0; A < b; A++)
      M[A] = arguments[A];
    var N = l(M);
    if (Array.isArray(M[0]) && (M = M[0]), M.length < 2)
      throw new i("streams");
    var R, O = M.map(function(P, F) {
      var H = F < M.length - 1, Q = F > 0;
      return u(P, H, Q, function(Z) {
        R || (R = Z), Z && O.forEach(h), !H && (O.forEach(h), N(R));
      });
    });
    return M.reduce(d);
  }
  return Fg = m, Fg;
}
var I5;
function tte() {
  return I5 || (I5 = 1, function(t, e) {
    e = t.exports = XI(), e.Stream = e, e.Readable = e, e.Writable = JI(), e.Duplex = Rc(), e.Transform = eA(), e.PassThrough = Xee(), e.finished = uw(), e.pipeline = ete();
  }(Td, Td.exports)), Td.exports;
}
var $g, A5;
function tA() {
  if (A5)
    return $g;
  A5 = 1;
  var t = Ft.exports.Buffer, e = tte().Transform, r = It.exports;
  function i(n, f) {
    if (!t.isBuffer(n) && typeof n != "string")
      throw new TypeError(f + " must be a string or a buffer");
  }
  function s(n) {
    e.call(this), this._block = t.allocUnsafe(n), this._blockSize = n, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  return r(s, e), s.prototype._transform = function(n, f, u) {
    var h = null;
    try {
      this.update(n, f);
    } catch (d) {
      h = d;
    }
    u(h);
  }, s.prototype._flush = function(n) {
    var f = null;
    try {
      this.push(this.digest());
    } catch (u) {
      f = u;
    }
    n(f);
  }, s.prototype.update = function(n, f) {
    if (i(n, "Data"), this._finalized)
      throw new Error("Digest already called");
    t.isBuffer(n) || (n = t.from(n, f));
    for (var u = this._block, h = 0; this._blockOffset + n.length - h >= this._blockSize; ) {
      for (var d = this._blockOffset; d < this._blockSize; )
        u[d++] = n[h++];
      this._update(), this._blockOffset = 0;
    }
    for (; h < n.length; )
      u[this._blockOffset++] = n[h++];
    for (var l = 0, m = n.length * 8; m > 0; ++l)
      this._length[l] += m, m = this._length[l] / 4294967296 | 0, m > 0 && (this._length[l] -= 4294967296 * m);
    return this;
  }, s.prototype._update = function() {
    throw new Error("_update is not implemented");
  }, s.prototype.digest = function(n) {
    if (this._finalized)
      throw new Error("Digest already called");
    this._finalized = !0;
    var f = this._digest();
    n !== void 0 && (f = f.toString(n)), this._block.fill(0), this._blockOffset = 0;
    for (var u = 0; u < 4; ++u)
      this._length[u] = 0;
    return f;
  }, s.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, $g = s, $g;
}
var qg, T5;
function hw() {
  if (T5)
    return qg;
  T5 = 1;
  var t = It.exports, e = tA(), r = Ft.exports.Buffer, i = new Array(16);
  function s() {
    e.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
  }
  t(s, e), s.prototype._update = function() {
    for (var l = i, m = 0; m < 16; ++m)
      l[m] = this._block.readInt32LE(m * 4);
    var b = this._a, M = this._b, A = this._c, N = this._d;
    b = f(b, M, A, N, l[0], 3614090360, 7), N = f(N, b, M, A, l[1], 3905402710, 12), A = f(A, N, b, M, l[2], 606105819, 17), M = f(M, A, N, b, l[3], 3250441966, 22), b = f(b, M, A, N, l[4], 4118548399, 7), N = f(N, b, M, A, l[5], 1200080426, 12), A = f(A, N, b, M, l[6], 2821735955, 17), M = f(M, A, N, b, l[7], 4249261313, 22), b = f(b, M, A, N, l[8], 1770035416, 7), N = f(N, b, M, A, l[9], 2336552879, 12), A = f(A, N, b, M, l[10], 4294925233, 17), M = f(M, A, N, b, l[11], 2304563134, 22), b = f(b, M, A, N, l[12], 1804603682, 7), N = f(N, b, M, A, l[13], 4254626195, 12), A = f(A, N, b, M, l[14], 2792965006, 17), M = f(M, A, N, b, l[15], 1236535329, 22), b = u(b, M, A, N, l[1], 4129170786, 5), N = u(N, b, M, A, l[6], 3225465664, 9), A = u(A, N, b, M, l[11], 643717713, 14), M = u(M, A, N, b, l[0], 3921069994, 20), b = u(b, M, A, N, l[5], 3593408605, 5), N = u(N, b, M, A, l[10], 38016083, 9), A = u(A, N, b, M, l[15], 3634488961, 14), M = u(M, A, N, b, l[4], 3889429448, 20), b = u(b, M, A, N, l[9], 568446438, 5), N = u(N, b, M, A, l[14], 3275163606, 9), A = u(A, N, b, M, l[3], 4107603335, 14), M = u(M, A, N, b, l[8], 1163531501, 20), b = u(b, M, A, N, l[13], 2850285829, 5), N = u(N, b, M, A, l[2], 4243563512, 9), A = u(A, N, b, M, l[7], 1735328473, 14), M = u(M, A, N, b, l[12], 2368359562, 20), b = h(b, M, A, N, l[5], 4294588738, 4), N = h(N, b, M, A, l[8], 2272392833, 11), A = h(A, N, b, M, l[11], 1839030562, 16), M = h(M, A, N, b, l[14], 4259657740, 23), b = h(b, M, A, N, l[1], 2763975236, 4), N = h(N, b, M, A, l[4], 1272893353, 11), A = h(A, N, b, M, l[7], 4139469664, 16), M = h(M, A, N, b, l[10], 3200236656, 23), b = h(b, M, A, N, l[13], 681279174, 4), N = h(N, b, M, A, l[0], 3936430074, 11), A = h(A, N, b, M, l[3], 3572445317, 16), M = h(M, A, N, b, l[6], 76029189, 23), b = h(b, M, A, N, l[9], 3654602809, 4), N = h(N, b, M, A, l[12], 3873151461, 11), A = h(A, N, b, M, l[15], 530742520, 16), M = h(M, A, N, b, l[2], 3299628645, 23), b = d(b, M, A, N, l[0], 4096336452, 6), N = d(N, b, M, A, l[7], 1126891415, 10), A = d(A, N, b, M, l[14], 2878612391, 15), M = d(M, A, N, b, l[5], 4237533241, 21), b = d(b, M, A, N, l[12], 1700485571, 6), N = d(N, b, M, A, l[3], 2399980690, 10), A = d(A, N, b, M, l[10], 4293915773, 15), M = d(M, A, N, b, l[1], 2240044497, 21), b = d(b, M, A, N, l[8], 1873313359, 6), N = d(N, b, M, A, l[15], 4264355552, 10), A = d(A, N, b, M, l[6], 2734768916, 15), M = d(M, A, N, b, l[13], 1309151649, 21), b = d(b, M, A, N, l[4], 4149444226, 6), N = d(N, b, M, A, l[11], 3174756917, 10), A = d(A, N, b, M, l[2], 718787259, 15), M = d(M, A, N, b, l[9], 3951481745, 21), this._a = this._a + b | 0, this._b = this._b + M | 0, this._c = this._c + A | 0, this._d = this._d + N | 0;
  }, s.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var l = r.allocUnsafe(16);
    return l.writeInt32LE(this._a, 0), l.writeInt32LE(this._b, 4), l.writeInt32LE(this._c, 8), l.writeInt32LE(this._d, 12), l;
  };
  function n(l, m) {
    return l << m | l >>> 32 - m;
  }
  function f(l, m, b, M, A, N, R) {
    return n(l + (m & b | ~m & M) + A + N | 0, R) + m | 0;
  }
  function u(l, m, b, M, A, N, R) {
    return n(l + (m & M | b & ~M) + A + N | 0, R) + m | 0;
  }
  function h(l, m, b, M, A, N, R) {
    return n(l + (m ^ b ^ M) + A + N | 0, R) + m | 0;
  }
  function d(l, m, b, M, A, N, R) {
    return n(l + (b ^ (m | ~M)) + A + N | 0, R) + m | 0;
  }
  return qg = s, qg;
}
var Hg, N5;
function lw() {
  if (N5)
    return Hg;
  N5 = 1;
  var t = Tn.Buffer, e = It.exports, r = tA(), i = new Array(16), s = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], n = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], f = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], u = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ], h = [0, 1518500249, 1859775393, 2400959708, 2840853838], d = [1352829926, 1548603684, 1836072691, 2053994217, 0];
  function l() {
    r.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  e(l, r), l.prototype._update = function() {
    for (var O = i, P = 0; P < 16; ++P)
      O[P] = this._block.readInt32LE(P * 4);
    for (var F = this._a | 0, H = this._b | 0, Q = this._c | 0, Z = this._d | 0, B = this._e | 0, Y = this._a | 0, ae = this._b | 0, se = this._c | 0, W = this._d | 0, C = this._e | 0, g = 0; g < 80; g += 1) {
      var a, c;
      g < 16 ? (a = b(F, H, Q, Z, B, O[s[g]], h[0], f[g]), c = R(Y, ae, se, W, C, O[n[g]], d[0], u[g])) : g < 32 ? (a = M(F, H, Q, Z, B, O[s[g]], h[1], f[g]), c = N(Y, ae, se, W, C, O[n[g]], d[1], u[g])) : g < 48 ? (a = A(F, H, Q, Z, B, O[s[g]], h[2], f[g]), c = A(Y, ae, se, W, C, O[n[g]], d[2], u[g])) : g < 64 ? (a = N(F, H, Q, Z, B, O[s[g]], h[3], f[g]), c = M(Y, ae, se, W, C, O[n[g]], d[3], u[g])) : (a = R(F, H, Q, Z, B, O[s[g]], h[4], f[g]), c = b(Y, ae, se, W, C, O[n[g]], d[4], u[g])), F = B, B = Z, Z = m(Q, 10), Q = H, H = a, Y = C, C = W, W = m(se, 10), se = ae, ae = c;
    }
    var p = this._b + Q + W | 0;
    this._b = this._c + Z + C | 0, this._c = this._d + B + Y | 0, this._d = this._e + F + ae | 0, this._e = this._a + H + se | 0, this._a = p;
  }, l.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var O = t.alloc ? t.alloc(20) : new t(20);
    return O.writeInt32LE(this._a, 0), O.writeInt32LE(this._b, 4), O.writeInt32LE(this._c, 8), O.writeInt32LE(this._d, 12), O.writeInt32LE(this._e, 16), O;
  };
  function m(O, P) {
    return O << P | O >>> 32 - P;
  }
  function b(O, P, F, H, Q, Z, B, Y) {
    return m(O + (P ^ F ^ H) + Z + B | 0, Y) + Q | 0;
  }
  function M(O, P, F, H, Q, Z, B, Y) {
    return m(O + (P & F | ~P & H) + Z + B | 0, Y) + Q | 0;
  }
  function A(O, P, F, H, Q, Z, B, Y) {
    return m(O + ((P | ~F) ^ H) + Z + B | 0, Y) + Q | 0;
  }
  function N(O, P, F, H, Q, Z, B, Y) {
    return m(O + (P & H | F & ~H) + Z + B | 0, Y) + Q | 0;
  }
  function R(O, P, F, H, Q, Z, B, Y) {
    return m(O + (P ^ (F | ~H)) + Z + B | 0, Y) + Q | 0;
  }
  return Hg = l, Hg;
}
var Wg, D5;
function mo() {
  if (D5)
    return Wg;
  D5 = 1;
  var t = Ft.exports.Buffer, e = dn.Transform, r = of().StringDecoder, i = It.exports;
  function s(n) {
    e.call(this), this.hashMode = typeof n == "string", this.hashMode ? this[n] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
  }
  return i(s, e), s.prototype.update = function(n, f, u) {
    typeof n == "string" && (n = t.from(n, f));
    var h = this._update(n);
    return this.hashMode ? this : (u && (h = this._toString(h, u)), h);
  }, s.prototype.setAutoPadding = function() {
  }, s.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
  }, s.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
  }, s.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
  }, s.prototype._transform = function(n, f, u) {
    var h;
    try {
      this.hashMode ? this._update(n) : this.push(this._update(n));
    } catch (d) {
      h = d;
    } finally {
      u(h);
    }
  }, s.prototype._flush = function(n) {
    var f;
    try {
      this.push(this.__final());
    } catch (u) {
      f = u;
    }
    n(f);
  }, s.prototype._finalOrDigest = function(n) {
    var f = this.__final() || t.alloc(0);
    return n && (f = this._toString(f, n, !0)), f;
  }, s.prototype._toString = function(n, f, u) {
    if (this._decoder || (this._decoder = new r(f), this._encoding = f), this._encoding !== f)
      throw new Error("can't switch encodings");
    var h = this._decoder.write(n);
    return u && (h += this._decoder.end()), h;
  }, Wg = s, Wg;
}
var Vg, C5;
function Jh() {
  if (C5)
    return Vg;
  C5 = 1;
  var t = It.exports, e = hw(), r = lw(), i = Oh.exports, s = mo();
  function n(f) {
    s.call(this, "digest"), this._hash = f;
  }
  return t(n, s), n.prototype._update = function(f) {
    this._hash.update(f);
  }, n.prototype._final = function() {
    return this._hash.digest();
  }, Vg = function(u) {
    return u = u.toLowerCase(), u === "md5" ? new e() : u === "rmd160" || u === "ripemd160" ? new r() : new n(i(u));
  }, Vg;
}
var Gg, O5;
function rte() {
  if (O5)
    return Gg;
  O5 = 1;
  var t = It.exports, e = Ft.exports.Buffer, r = mo(), i = e.alloc(128), s = 64;
  function n(f, u) {
    r.call(this, "digest"), typeof u == "string" && (u = e.from(u)), this._alg = f, this._key = u, u.length > s ? u = f(u) : u.length < s && (u = e.concat([u, i], s));
    for (var h = this._ipad = e.allocUnsafe(s), d = this._opad = e.allocUnsafe(s), l = 0; l < s; l++)
      h[l] = u[l] ^ 54, d[l] = u[l] ^ 92;
    this._hash = [h];
  }
  return t(n, r), n.prototype._update = function(f) {
    this._hash.push(f);
  }, n.prototype._final = function() {
    var f = this._alg(e.concat(this._hash));
    return this._alg(e.concat([this._opad, f]));
  }, Gg = n, Gg;
}
var Kg, R5;
function rA() {
  if (R5)
    return Kg;
  R5 = 1;
  var t = hw();
  return Kg = function(e) {
    return new t().update(e).digest();
  }, Kg;
}
var Yg, L5;
function iA() {
  if (L5)
    return Yg;
  L5 = 1;
  var t = It.exports, e = rte(), r = mo(), i = Ft.exports.Buffer, s = rA(), n = lw(), f = Oh.exports, u = i.alloc(128);
  function h(d, l) {
    r.call(this, "digest"), typeof l == "string" && (l = i.from(l));
    var m = d === "sha512" || d === "sha384" ? 128 : 64;
    if (this._alg = d, this._key = l, l.length > m) {
      var b = d === "rmd160" ? new n() : f(d);
      l = b.update(l).digest();
    } else
      l.length < m && (l = i.concat([l, u], m));
    for (var M = this._ipad = i.allocUnsafe(m), A = this._opad = i.allocUnsafe(m), N = 0; N < m; N++)
      M[N] = l[N] ^ 54, A[N] = l[N] ^ 92;
    this._hash = d === "rmd160" ? new n() : f(d), this._hash.update(M);
  }
  return t(h, r), h.prototype._update = function(d) {
    this._hash.update(d);
  }, h.prototype._final = function() {
    var d = this._hash.digest(), l = this._alg === "rmd160" ? new n() : f(this._alg);
    return l.update(this._opad).update(d).digest();
  }, Yg = function(l, m) {
    return l = l.toLowerCase(), l === "rmd160" || l === "ripemd160" ? new h("rmd160", m) : l === "md5" ? new e(s, m) : new h(l, m);
  }, Yg;
}
var Qg = { exports: {} };
const ite = {
  sign: "rsa",
  hash: "sha224",
  id: "302d300d06096086480165030402040500041c"
}, nte = {
  sign: "rsa",
  hash: "sha256",
  id: "3031300d060960864801650304020105000420"
}, ste = {
  sign: "rsa",
  hash: "sha384",
  id: "3041300d060960864801650304020205000430"
}, ate = {
  sign: "rsa",
  hash: "sha512",
  id: "3051300d060960864801650304020305000440"
}, ote = {
  sign: "ecdsa",
  hash: "sha256",
  id: ""
}, fte = {
  sign: "ecdsa",
  hash: "sha224",
  id: ""
}, cte = {
  sign: "ecdsa",
  hash: "sha384",
  id: ""
}, ute = {
  sign: "ecdsa",
  hash: "sha512",
  id: ""
}, hte = {
  sign: "dsa",
  hash: "sha1",
  id: ""
}, lte = {
  sign: "rsa",
  hash: "rmd160",
  id: "3021300906052b2403020105000414"
}, dte = {
  sign: "rsa",
  hash: "md5",
  id: "3020300c06082a864886f70d020505000410"
}, nA = {
  sha224WithRSAEncryption: ite,
  "RSA-SHA224": {
    sign: "ecdsa/rsa",
    hash: "sha224",
    id: "302d300d06096086480165030402040500041c"
  },
  sha256WithRSAEncryption: nte,
  "RSA-SHA256": {
    sign: "ecdsa/rsa",
    hash: "sha256",
    id: "3031300d060960864801650304020105000420"
  },
  sha384WithRSAEncryption: ste,
  "RSA-SHA384": {
    sign: "ecdsa/rsa",
    hash: "sha384",
    id: "3041300d060960864801650304020205000430"
  },
  sha512WithRSAEncryption: ate,
  "RSA-SHA512": {
    sign: "ecdsa/rsa",
    hash: "sha512",
    id: "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    sign: "rsa",
    hash: "sha1",
    id: "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    sign: "ecdsa",
    hash: "sha1",
    id: ""
  },
  sha256: ote,
  sha224: fte,
  sha384: cte,
  sha512: ute,
  "DSA-SHA": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  "DSA-SHA1": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  DSA: hte,
  "DSA-WITH-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-WITH-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-WITH-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-WITH-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-RIPEMD160": {
    sign: "dsa",
    hash: "rmd160",
    id: ""
  },
  ripemd160WithRSA: lte,
  "RSA-RIPEMD160": {
    sign: "rsa",
    hash: "rmd160",
    id: "3021300906052b2403020105000414"
  },
  md5WithRSAEncryption: dte,
  "RSA-MD5": {
    sign: "rsa",
    hash: "md5",
    id: "3020300c06082a864886f70d020505000410"
  }
};
var P5;
function pte() {
  return P5 || (P5 = 1, function(t) {
    t.exports = nA;
  }(Qg)), Qg.exports;
}
var Nd = {}, Zg, k5;
function sA() {
  if (k5)
    return Zg;
  k5 = 1;
  var t = Math.pow(2, 30) - 1;
  return Zg = function(e, r) {
    if (typeof e != "number")
      throw new TypeError("Iterations not a number");
    if (e < 0)
      throw new TypeError("Bad iterations");
    if (typeof r != "number")
      throw new TypeError("Key length not a number");
    if (r < 0 || r > t || r !== r)
      throw new TypeError("Bad key length");
  }, Zg;
}
var Jg, j5;
function aA() {
  if (j5)
    return Jg;
  j5 = 1;
  var t;
  if (nt.process && nt.process.browser)
    t = "utf-8";
  else if (nt.process && nt.process.version) {
    var e = parseInt(process.version.split(".")[0].slice(1), 10);
    t = e >= 6 ? "utf-8" : "binary";
  } else
    t = "utf-8";
  return Jg = t, Jg;
}
var Xg, B5;
function oA() {
  if (B5)
    return Xg;
  B5 = 1;
  var t = Ft.exports.Buffer;
  return Xg = function(e, r, i) {
    if (t.isBuffer(e))
      return e;
    if (typeof e == "string")
      return t.from(e, r);
    if (ArrayBuffer.isView(e))
      return t.from(e.buffer);
    throw new TypeError(i + " must be a string, a Buffer, a typed array or a DataView");
  }, Xg;
}
var eb, z5;
function fA() {
  if (z5)
    return eb;
  z5 = 1;
  var t = rA(), e = lw(), r = Oh.exports, i = Ft.exports.Buffer, s = sA(), n = aA(), f = oA(), u = i.alloc(128), h = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
  };
  function d(b, M, A) {
    var N = l(b), R = b === "sha512" || b === "sha384" ? 128 : 64;
    M.length > R ? M = N(M) : M.length < R && (M = i.concat([M, u], R));
    for (var O = i.allocUnsafe(R + h[b]), P = i.allocUnsafe(R + h[b]), F = 0; F < R; F++)
      O[F] = M[F] ^ 54, P[F] = M[F] ^ 92;
    var H = i.allocUnsafe(R + A + 4);
    O.copy(H, 0, 0, R), this.ipad1 = H, this.ipad2 = O, this.opad = P, this.alg = b, this.blocksize = R, this.hash = N, this.size = h[b];
  }
  d.prototype.run = function(b, M) {
    b.copy(M, this.blocksize);
    var A = this.hash(M);
    return A.copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  function l(b) {
    function M(N) {
      return r(b).update(N).digest();
    }
    function A(N) {
      return new e().update(N).digest();
    }
    return b === "rmd160" || b === "ripemd160" ? A : b === "md5" ? t : M;
  }
  function m(b, M, A, N, R) {
    s(A, N), b = f(b, n, "Password"), M = f(M, n, "Salt"), R = R || "sha1";
    var O = new d(R, b, M.length), P = i.allocUnsafe(N), F = i.allocUnsafe(M.length + 4);
    M.copy(F, 0, 0, M.length);
    for (var H = 0, Q = h[R], Z = Math.ceil(N / Q), B = 1; B <= Z; B++) {
      F.writeUInt32BE(B, M.length);
      for (var Y = O.run(F, O.ipad1), ae = Y, se = 1; se < A; se++) {
        ae = O.run(ae, O.ipad2);
        for (var W = 0; W < Q; W++)
          Y[W] ^= ae[W];
      }
      Y.copy(P, H), H += Q;
    }
    return P;
  }
  return eb = m, eb;
}
var tb, U5;
function vte() {
  if (U5)
    return tb;
  U5 = 1;
  var t = Ft.exports.Buffer, e = sA(), r = aA(), i = fA(), s = oA(), n, f = nt.crypto && nt.crypto.subtle, u = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
  }, h = [];
  function d(A) {
    if (nt.process && !nt.process.browser || !f || !f.importKey || !f.deriveBits)
      return Promise.resolve(!1);
    if (h[A] !== void 0)
      return h[A];
    n = n || t.alloc(8);
    var N = b(n, n, 10, 128, A).then(function() {
      return !0;
    }).catch(function() {
      return !1;
    });
    return h[A] = N, N;
  }
  var l;
  function m() {
    return l || (nt.process && nt.process.nextTick ? l = nt.process.nextTick : nt.queueMicrotask ? l = nt.queueMicrotask : nt.setImmediate ? l = nt.setImmediate : l = nt.setTimeout, l);
  }
  function b(A, N, R, O, P) {
    return f.importKey(
      "raw",
      A,
      { name: "PBKDF2" },
      !1,
      ["deriveBits"]
    ).then(function(F) {
      return f.deriveBits({
        name: "PBKDF2",
        salt: N,
        iterations: R,
        hash: {
          name: P
        }
      }, F, O << 3);
    }).then(function(F) {
      return t.from(F);
    });
  }
  function M(A, N) {
    A.then(function(R) {
      m()(function() {
        N(null, R);
      });
    }, function(R) {
      m()(function() {
        N(R);
      });
    });
  }
  return tb = function(A, N, R, O, P, F) {
    typeof P == "function" && (F = P, P = void 0), P = P || "sha1";
    var H = u[P.toLowerCase()];
    if (!H || typeof nt.Promise != "function") {
      m()(function() {
        var Q;
        try {
          Q = i(A, N, R, O, P);
        } catch (Z) {
          return F(Z);
        }
        F(null, Q);
      });
      return;
    }
    if (e(R, O), A = s(A, r, "Password"), N = s(N, r, "Salt"), typeof F != "function")
      throw new Error("No callback provided to pbkdf2");
    M(d(H).then(function(Q) {
      return Q ? b(A, N, R, O, H) : i(A, N, R, O, P);
    }), F);
  }, tb;
}
var F5;
function cA() {
  return F5 || (F5 = 1, Nd.pbkdf2 = vte(), Nd.pbkdf2Sync = fA()), Nd;
}
var Hn = {}, jo = {}, Mn = {}, $5;
function uA() {
  if ($5)
    return Mn;
  $5 = 1, Mn.readUInt32BE = function(s, n) {
    var f = s[0 + n] << 24 | s[1 + n] << 16 | s[2 + n] << 8 | s[3 + n];
    return f >>> 0;
  }, Mn.writeUInt32BE = function(s, n, f) {
    s[0 + f] = n >>> 24, s[1 + f] = n >>> 16 & 255, s[2 + f] = n >>> 8 & 255, s[3 + f] = n & 255;
  }, Mn.ip = function(s, n, f, u) {
    for (var h = 0, d = 0, l = 6; l >= 0; l -= 2) {
      for (var m = 0; m <= 24; m += 8)
        h <<= 1, h |= n >>> m + l & 1;
      for (var m = 0; m <= 24; m += 8)
        h <<= 1, h |= s >>> m + l & 1;
    }
    for (var l = 6; l >= 0; l -= 2) {
      for (var m = 1; m <= 25; m += 8)
        d <<= 1, d |= n >>> m + l & 1;
      for (var m = 1; m <= 25; m += 8)
        d <<= 1, d |= s >>> m + l & 1;
    }
    f[u + 0] = h >>> 0, f[u + 1] = d >>> 0;
  }, Mn.rip = function(s, n, f, u) {
    for (var h = 0, d = 0, l = 0; l < 4; l++)
      for (var m = 24; m >= 0; m -= 8)
        h <<= 1, h |= n >>> m + l & 1, h <<= 1, h |= s >>> m + l & 1;
    for (var l = 4; l < 8; l++)
      for (var m = 24; m >= 0; m -= 8)
        d <<= 1, d |= n >>> m + l & 1, d <<= 1, d |= s >>> m + l & 1;
    f[u + 0] = h >>> 0, f[u + 1] = d >>> 0;
  }, Mn.pc1 = function(s, n, f, u) {
    for (var h = 0, d = 0, l = 7; l >= 5; l--) {
      for (var m = 0; m <= 24; m += 8)
        h <<= 1, h |= n >> m + l & 1;
      for (var m = 0; m <= 24; m += 8)
        h <<= 1, h |= s >> m + l & 1;
    }
    for (var m = 0; m <= 24; m += 8)
      h <<= 1, h |= n >> m + l & 1;
    for (var l = 1; l <= 3; l++) {
      for (var m = 0; m <= 24; m += 8)
        d <<= 1, d |= n >> m + l & 1;
      for (var m = 0; m <= 24; m += 8)
        d <<= 1, d |= s >> m + l & 1;
    }
    for (var m = 0; m <= 24; m += 8)
      d <<= 1, d |= s >> m + l & 1;
    f[u + 0] = h >>> 0, f[u + 1] = d >>> 0;
  }, Mn.r28shl = function(s, n) {
    return s << n & 268435455 | s >>> 28 - n;
  };
  var t = [
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
  ];
  Mn.pc2 = function(s, n, f, u) {
    for (var h = 0, d = 0, l = t.length >>> 1, m = 0; m < l; m++)
      h <<= 1, h |= s >>> t[m] & 1;
    for (var m = l; m < t.length; m++)
      d <<= 1, d |= n >>> t[m] & 1;
    f[u + 0] = h >>> 0, f[u + 1] = d >>> 0;
  }, Mn.expand = function(s, n, f) {
    var u = 0, h = 0;
    u = (s & 1) << 5 | s >>> 27;
    for (var d = 23; d >= 15; d -= 4)
      u <<= 6, u |= s >>> d & 63;
    for (var d = 11; d >= 3; d -= 4)
      h |= s >>> d & 63, h <<= 6;
    h |= (s & 31) << 1 | s >>> 31, n[f + 0] = u >>> 0, n[f + 1] = h >>> 0;
  };
  var e = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
  ];
  Mn.substitute = function(s, n) {
    for (var f = 0, u = 0; u < 4; u++) {
      var h = s >>> 18 - u * 6 & 63, d = e[u * 64 + h];
      f <<= 4, f |= d;
    }
    for (var u = 0; u < 4; u++) {
      var h = n >>> 18 - u * 6 & 63, d = e[4 * 64 + u * 64 + h];
      f <<= 4, f |= d;
    }
    return f >>> 0;
  };
  var r = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
  ];
  return Mn.permute = function(s) {
    for (var n = 0, f = 0; f < r.length; f++)
      n <<= 1, n |= s >>> r[f] & 1;
    return n >>> 0;
  }, Mn.padSplit = function(s, n, f) {
    for (var u = s.toString(2); u.length < n; )
      u = "0" + u;
    for (var h = [], d = 0; d < n; d += f)
      h.push(u.slice(d, d + f));
    return h.join(" ");
  }, Mn;
}
var rb, q5;
function dw() {
  if (q5)
    return rb;
  q5 = 1;
  var t = Nn;
  function e(r) {
    this.options = r, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0;
  }
  return rb = e, e.prototype._init = function() {
  }, e.prototype.update = function(i) {
    return i.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt(i) : this._updateEncrypt(i);
  }, e.prototype._buffer = function(i, s) {
    for (var n = Math.min(this.buffer.length - this.bufferOff, i.length - s), f = 0; f < n; f++)
      this.buffer[this.bufferOff + f] = i[s + f];
    return this.bufferOff += n, n;
  }, e.prototype._flushBuffer = function(i, s) {
    return this._update(this.buffer, 0, i, s), this.bufferOff = 0, this.blockSize;
  }, e.prototype._updateEncrypt = function(i) {
    var s = 0, n = 0, f = (this.bufferOff + i.length) / this.blockSize | 0, u = new Array(f * this.blockSize);
    this.bufferOff !== 0 && (s += this._buffer(i, s), this.bufferOff === this.buffer.length && (n += this._flushBuffer(u, n)));
    for (var h = i.length - (i.length - s) % this.blockSize; s < h; s += this.blockSize)
      this._update(i, s, u, n), n += this.blockSize;
    for (; s < i.length; s++, this.bufferOff++)
      this.buffer[this.bufferOff] = i[s];
    return u;
  }, e.prototype._updateDecrypt = function(i) {
    for (var s = 0, n = 0, f = Math.ceil((this.bufferOff + i.length) / this.blockSize) - 1, u = new Array(f * this.blockSize); f > 0; f--)
      s += this._buffer(i, s), n += this._flushBuffer(u, n);
    return s += this._buffer(i, s), u;
  }, e.prototype.final = function(i) {
    var s;
    i && (s = this.update(i));
    var n;
    return this.type === "encrypt" ? n = this._finalEncrypt() : n = this._finalDecrypt(), s ? s.concat(n) : n;
  }, e.prototype._pad = function(i, s) {
    if (s === 0)
      return !1;
    for (; s < i.length; )
      i[s++] = 0;
    return !0;
  }, e.prototype._finalEncrypt = function() {
    if (!this._pad(this.buffer, this.bufferOff))
      return [];
    var i = new Array(this.blockSize);
    return this._update(this.buffer, 0, i, 0), i;
  }, e.prototype._unpad = function(i) {
    return i;
  }, e.prototype._finalDecrypt = function() {
    t.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var i = new Array(this.blockSize);
    return this._flushBuffer(i, 0), this._unpad(i);
  }, rb;
}
var ib, H5;
function hA() {
  if (H5)
    return ib;
  H5 = 1;
  var t = Nn, e = It.exports, r = uA(), i = dw();
  function s() {
    this.tmp = new Array(2), this.keys = null;
  }
  function n(u) {
    i.call(this, u);
    var h = new s();
    this._desState = h, this.deriveKeys(h, u.key);
  }
  e(n, i), ib = n, n.create = function(h) {
    return new n(h);
  };
  var f = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
  ];
  return n.prototype.deriveKeys = function(h, d) {
    h.keys = new Array(16 * 2), t.equal(d.length, this.blockSize, "Invalid key length");
    var l = r.readUInt32BE(d, 0), m = r.readUInt32BE(d, 4);
    r.pc1(l, m, h.tmp, 0), l = h.tmp[0], m = h.tmp[1];
    for (var b = 0; b < h.keys.length; b += 2) {
      var M = f[b >>> 1];
      l = r.r28shl(l, M), m = r.r28shl(m, M), r.pc2(l, m, h.keys, b);
    }
  }, n.prototype._update = function(h, d, l, m) {
    var b = this._desState, M = r.readUInt32BE(h, d), A = r.readUInt32BE(h, d + 4);
    r.ip(M, A, b.tmp, 0), M = b.tmp[0], A = b.tmp[1], this.type === "encrypt" ? this._encrypt(b, M, A, b.tmp, 0) : this._decrypt(b, M, A, b.tmp, 0), M = b.tmp[0], A = b.tmp[1], r.writeUInt32BE(l, M, m), r.writeUInt32BE(l, A, m + 4);
  }, n.prototype._pad = function(h, d) {
    for (var l = h.length - d, m = d; m < h.length; m++)
      h[m] = l;
    return !0;
  }, n.prototype._unpad = function(h) {
    for (var d = h[h.length - 1], l = h.length - d; l < h.length; l++)
      t.equal(h[l], d);
    return h.slice(0, h.length - d);
  }, n.prototype._encrypt = function(h, d, l, m, b) {
    for (var M = d, A = l, N = 0; N < h.keys.length; N += 2) {
      var R = h.keys[N], O = h.keys[N + 1];
      r.expand(A, h.tmp, 0), R ^= h.tmp[0], O ^= h.tmp[1];
      var P = r.substitute(R, O), F = r.permute(P), H = A;
      A = (M ^ F) >>> 0, M = H;
    }
    r.rip(A, M, m, b);
  }, n.prototype._decrypt = function(h, d, l, m, b) {
    for (var M = l, A = d, N = h.keys.length - 2; N >= 0; N -= 2) {
      var R = h.keys[N], O = h.keys[N + 1];
      r.expand(M, h.tmp, 0), R ^= h.tmp[0], O ^= h.tmp[1];
      var P = r.substitute(R, O), F = r.permute(P), H = M;
      M = (A ^ F) >>> 0, A = H;
    }
    r.rip(M, A, m, b);
  }, ib;
}
var nb = {}, W5;
function gte() {
  if (W5)
    return nb;
  W5 = 1;
  var t = Nn, e = It.exports, r = {};
  function i(n) {
    t.equal(n.length, 8, "Invalid IV length"), this.iv = new Array(8);
    for (var f = 0; f < this.iv.length; f++)
      this.iv[f] = n[f];
  }
  function s(n) {
    function f(l) {
      n.call(this, l), this._cbcInit();
    }
    e(f, n);
    for (var u = Object.keys(r), h = 0; h < u.length; h++) {
      var d = u[h];
      f.prototype[d] = r[d];
    }
    return f.create = function(m) {
      return new f(m);
    }, f;
  }
  return nb.instantiate = s, r._cbcInit = function() {
    var f = new i(this.options.iv);
    this._cbcState = f;
  }, r._update = function(f, u, h, d) {
    var l = this._cbcState, m = this.constructor.super_.prototype, b = l.iv;
    if (this.type === "encrypt") {
      for (var M = 0; M < this.blockSize; M++)
        b[M] ^= f[u + M];
      m._update.call(this, b, 0, h, d);
      for (var M = 0; M < this.blockSize; M++)
        b[M] = h[d + M];
    } else {
      m._update.call(this, f, u, h, d);
      for (var M = 0; M < this.blockSize; M++)
        h[d + M] ^= b[M];
      for (var M = 0; M < this.blockSize; M++)
        b[M] = f[u + M];
    }
  }, nb;
}
var sb, V5;
function bte() {
  if (V5)
    return sb;
  V5 = 1;
  var t = Nn, e = It.exports, r = dw(), i = hA();
  function s(f, u) {
    t.equal(u.length, 24, "Invalid key length");
    var h = u.slice(0, 8), d = u.slice(8, 16), l = u.slice(16, 24);
    f === "encrypt" ? this.ciphers = [
      i.create({ type: "encrypt", key: h }),
      i.create({ type: "decrypt", key: d }),
      i.create({ type: "encrypt", key: l })
    ] : this.ciphers = [
      i.create({ type: "decrypt", key: l }),
      i.create({ type: "encrypt", key: d }),
      i.create({ type: "decrypt", key: h })
    ];
  }
  function n(f) {
    r.call(this, f);
    var u = new s(this.type, this.options.key);
    this._edeState = u;
  }
  return e(n, r), sb = n, n.create = function(u) {
    return new n(u);
  }, n.prototype._update = function(u, h, d, l) {
    var m = this._edeState;
    m.ciphers[0]._update(u, h, d, l), m.ciphers[1]._update(d, l, d, l), m.ciphers[2]._update(d, l, d, l);
  }, n.prototype._pad = i.prototype._pad, n.prototype._unpad = i.prototype._unpad, sb;
}
var G5;
function yte() {
  return G5 || (G5 = 1, jo.utils = uA(), jo.Cipher = dw(), jo.DES = hA(), jo.CBC = gte(), jo.EDE = bte()), jo;
}
var ab, K5;
function mte() {
  if (K5)
    return ab;
  K5 = 1;
  var t = mo(), e = yte(), r = It.exports, i = Ft.exports.Buffer, s = {
    "des-ede3-cbc": e.CBC.instantiate(e.EDE),
    "des-ede3": e.EDE,
    "des-ede-cbc": e.CBC.instantiate(e.EDE),
    "des-ede": e.EDE,
    "des-cbc": e.CBC.instantiate(e.DES),
    "des-ecb": e.DES
  };
  s.des = s["des-cbc"], s.des3 = s["des-ede3-cbc"], ab = n, r(n, t);
  function n(f) {
    t.call(this);
    var u = f.mode.toLowerCase(), h = s[u], d;
    f.decrypt ? d = "decrypt" : d = "encrypt";
    var l = f.key;
    i.isBuffer(l) || (l = i.from(l)), (u === "des-ede" || u === "des-ede-cbc") && (l = i.concat([l, l.slice(0, 8)]));
    var m = f.iv;
    i.isBuffer(m) || (m = i.from(m)), this._des = h.create({
      key: l,
      iv: m,
      type: d
    });
  }
  return n.prototype._update = function(f) {
    return i.from(this._des.update(f));
  }, n.prototype._final = function() {
    return i.from(this._des.final());
  }, ab;
}
var Wn = {}, Dd = {}, Cd = {}, Y5;
function wte() {
  return Y5 || (Y5 = 1, Cd.encrypt = function(t, e) {
    return t._cipher.encryptBlock(e);
  }, Cd.decrypt = function(t, e) {
    return t._cipher.decryptBlock(e);
  }), Cd;
}
var Od = {}, ob, Q5;
function Xh() {
  return Q5 || (Q5 = 1, ob = function(e, r) {
    for (var i = Math.min(e.length, r.length), s = new Buffer(i), n = 0; n < i; ++n)
      s[n] = e[n] ^ r[n];
    return s;
  }), ob;
}
var Z5;
function _te() {
  if (Z5)
    return Od;
  Z5 = 1;
  var t = Xh();
  return Od.encrypt = function(e, r) {
    var i = t(r, e._prev);
    return e._prev = e._cipher.encryptBlock(i), e._prev;
  }, Od.decrypt = function(e, r) {
    var i = e._prev;
    e._prev = r;
    var s = e._cipher.decryptBlock(r);
    return t(s, i);
  }, Od;
}
var fb = {}, J5;
function Mte() {
  if (J5)
    return fb;
  J5 = 1;
  var t = Ft.exports.Buffer, e = Xh();
  function r(i, s, n) {
    var f = s.length, u = e(s, i._cache);
    return i._cache = i._cache.slice(f), i._prev = t.concat([i._prev, n ? s : u]), u;
  }
  return fb.encrypt = function(i, s, n) {
    for (var f = t.allocUnsafe(0), u; s.length; )
      if (i._cache.length === 0 && (i._cache = i._cipher.encryptBlock(i._prev), i._prev = t.allocUnsafe(0)), i._cache.length <= s.length)
        u = i._cache.length, f = t.concat([f, r(i, s.slice(0, u), n)]), s = s.slice(u);
      else {
        f = t.concat([f, r(i, s, n)]);
        break;
      }
    return f;
  }, fb;
}
var cb = {}, X5;
function xte() {
  if (X5)
    return cb;
  X5 = 1;
  var t = Ft.exports.Buffer;
  function e(r, i, s) {
    var n = r._cipher.encryptBlock(r._prev), f = n[0] ^ i;
    return r._prev = t.concat([
      r._prev.slice(1),
      t.from([s ? i : f])
    ]), f;
  }
  return cb.encrypt = function(r, i, s) {
    for (var n = i.length, f = t.allocUnsafe(n), u = -1; ++u < n; )
      f[u] = e(r, i[u], s);
    return f;
  }, cb;
}
var ub = {}, eM;
function Ste() {
  if (eM)
    return ub;
  eM = 1;
  var t = Ft.exports.Buffer;
  function e(i, s, n) {
    for (var f, u = -1, h = 8, d = 0, l, m; ++u < h; )
      f = i._cipher.encryptBlock(i._prev), l = s & 1 << 7 - u ? 128 : 0, m = f[0] ^ l, d += (m & 128) >> u % 8, i._prev = r(i._prev, n ? l : m);
    return d;
  }
  function r(i, s) {
    var n = i.length, f = -1, u = t.allocUnsafe(i.length);
    for (i = t.concat([i, t.from([s])]); ++f < n; )
      u[f] = i[f] << 1 | i[f + 1] >> 7;
    return u;
  }
  return ub.encrypt = function(i, s, n) {
    for (var f = s.length, u = t.allocUnsafe(f), h = -1; ++h < f; )
      u[h] = e(i, s[h], n);
    return u;
  }, ub;
}
var hb = {}, tM;
function Ete() {
  if (tM)
    return hb;
  tM = 1;
  var t = Xh();
  function e(r) {
    return r._prev = r._cipher.encryptBlock(r._prev), r._prev;
  }
  return hb.encrypt = function(r, i) {
    for (; r._cache.length < i.length; )
      r._cache = Buffer.concat([r._cache, e(r)]);
    var s = r._cache.slice(0, i.length);
    return r._cache = r._cache.slice(i.length), t(i, s);
  }, hb;
}
var lb = {}, db, rM;
function lA() {
  if (rM)
    return db;
  rM = 1;
  function t(e) {
    for (var r = e.length, i; r--; )
      if (i = e.readUInt8(r), i === 255)
        e.writeUInt8(0, r);
      else {
        i++, e.writeUInt8(i, r);
        break;
      }
  }
  return db = t, db;
}
var iM;
function nM() {
  if (iM)
    return lb;
  iM = 1;
  var t = Xh(), e = Ft.exports.Buffer, r = lA();
  function i(n) {
    var f = n._cipher.encryptBlockRaw(n._prev);
    return r(n._prev), f;
  }
  var s = 16;
  return lb.encrypt = function(n, f) {
    var u = Math.ceil(f.length / s), h = n._cache.length;
    n._cache = e.concat([
      n._cache,
      e.allocUnsafe(u * s)
    ]);
    for (var d = 0; d < u; d++) {
      var l = i(n), m = h + d * s;
      n._cache.writeUInt32BE(l[0], m + 0), n._cache.writeUInt32BE(l[1], m + 4), n._cache.writeUInt32BE(l[2], m + 8), n._cache.writeUInt32BE(l[3], m + 12);
    }
    var b = n._cache.slice(0, f.length);
    return n._cache = n._cache.slice(f.length), t(f, b);
  }, lb;
}
const Ite = {
  cipher: "AES",
  key: 128,
  iv: 16,
  mode: "CBC",
  type: "block"
}, Ate = {
  cipher: "AES",
  key: 192,
  iv: 16,
  mode: "CBC",
  type: "block"
}, Tte = {
  cipher: "AES",
  key: 256,
  iv: 16,
  mode: "CBC",
  type: "block"
}, dA = {
  "aes-128-ecb": {
    cipher: "AES",
    key: 128,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-192-ecb": {
    cipher: "AES",
    key: 192,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-256-ecb": {
    cipher: "AES",
    key: 256,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-128-cbc": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-192-cbc": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-256-cbc": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  aes128: Ite,
  aes192: Ate,
  aes256: Tte,
  "aes-128-cfb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-192-cfb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-256-cfb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-128-cfb8": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-192-cfb8": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-256-cfb8": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-128-cfb1": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-192-cfb1": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-256-cfb1": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-128-ofb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-192-ofb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-256-ofb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-128-ctr": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-192-ctr": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-256-ctr": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-128-gcm": {
    cipher: "AES",
    key: 128,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-192-gcm": {
    cipher: "AES",
    key: 192,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-256-gcm": {
    cipher: "AES",
    key: 256,
    iv: 12,
    mode: "GCM",
    type: "auth"
  }
};
var pb, sM;
function pw() {
  if (sM)
    return pb;
  sM = 1;
  var t = {
    ECB: wte(),
    CBC: _te(),
    CFB: Mte(),
    CFB8: xte(),
    CFB1: Ste(),
    OFB: Ete(),
    CTR: nM(),
    GCM: nM()
  }, e = dA;
  for (var r in e)
    e[r].module = t[e[r].mode];
  return pb = e, pb;
}
var vb = {}, aM;
function Hp() {
  if (aM)
    return vb;
  aM = 1;
  var t = Ft.exports.Buffer;
  function e(u) {
    t.isBuffer(u) || (u = t.from(u));
    for (var h = u.length / 4 | 0, d = new Array(h), l = 0; l < h; l++)
      d[l] = u.readUInt32BE(l * 4);
    return d;
  }
  function r(u) {
    for (var h = 0; h < u.length; u++)
      u[h] = 0;
  }
  function i(u, h, d, l, m) {
    for (var b = d[0], M = d[1], A = d[2], N = d[3], R = u[0] ^ h[0], O = u[1] ^ h[1], P = u[2] ^ h[2], F = u[3] ^ h[3], H, Q, Z, B, Y = 4, ae = 1; ae < m; ae++)
      H = b[R >>> 24] ^ M[O >>> 16 & 255] ^ A[P >>> 8 & 255] ^ N[F & 255] ^ h[Y++], Q = b[O >>> 24] ^ M[P >>> 16 & 255] ^ A[F >>> 8 & 255] ^ N[R & 255] ^ h[Y++], Z = b[P >>> 24] ^ M[F >>> 16 & 255] ^ A[R >>> 8 & 255] ^ N[O & 255] ^ h[Y++], B = b[F >>> 24] ^ M[R >>> 16 & 255] ^ A[O >>> 8 & 255] ^ N[P & 255] ^ h[Y++], R = H, O = Q, P = Z, F = B;
    return H = (l[R >>> 24] << 24 | l[O >>> 16 & 255] << 16 | l[P >>> 8 & 255] << 8 | l[F & 255]) ^ h[Y++], Q = (l[O >>> 24] << 24 | l[P >>> 16 & 255] << 16 | l[F >>> 8 & 255] << 8 | l[R & 255]) ^ h[Y++], Z = (l[P >>> 24] << 24 | l[F >>> 16 & 255] << 16 | l[R >>> 8 & 255] << 8 | l[O & 255]) ^ h[Y++], B = (l[F >>> 24] << 24 | l[R >>> 16 & 255] << 16 | l[O >>> 8 & 255] << 8 | l[P & 255]) ^ h[Y++], H = H >>> 0, Q = Q >>> 0, Z = Z >>> 0, B = B >>> 0, [H, Q, Z, B];
  }
  var s = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], n = function() {
    for (var u = new Array(256), h = 0; h < 256; h++)
      h < 128 ? u[h] = h << 1 : u[h] = h << 1 ^ 283;
    for (var d = [], l = [], m = [[], [], [], []], b = [[], [], [], []], M = 0, A = 0, N = 0; N < 256; ++N) {
      var R = A ^ A << 1 ^ A << 2 ^ A << 3 ^ A << 4;
      R = R >>> 8 ^ R & 255 ^ 99, d[M] = R, l[R] = M;
      var O = u[M], P = u[O], F = u[P], H = u[R] * 257 ^ R * 16843008;
      m[0][M] = H << 24 | H >>> 8, m[1][M] = H << 16 | H >>> 16, m[2][M] = H << 8 | H >>> 24, m[3][M] = H, H = F * 16843009 ^ P * 65537 ^ O * 257 ^ M * 16843008, b[0][R] = H << 24 | H >>> 8, b[1][R] = H << 16 | H >>> 16, b[2][R] = H << 8 | H >>> 24, b[3][R] = H, M === 0 ? M = A = 1 : (M = O ^ u[u[u[F ^ O]]], A ^= u[u[A]]);
    }
    return {
      SBOX: d,
      INV_SBOX: l,
      SUB_MIX: m,
      INV_SUB_MIX: b
    };
  }();
  function f(u) {
    this._key = e(u), this._reset();
  }
  return f.blockSize = 4 * 4, f.keySize = 256 / 8, f.prototype.blockSize = f.blockSize, f.prototype.keySize = f.keySize, f.prototype._reset = function() {
    for (var u = this._key, h = u.length, d = h + 6, l = (d + 1) * 4, m = [], b = 0; b < h; b++)
      m[b] = u[b];
    for (b = h; b < l; b++) {
      var M = m[b - 1];
      b % h === 0 ? (M = M << 8 | M >>> 24, M = n.SBOX[M >>> 24] << 24 | n.SBOX[M >>> 16 & 255] << 16 | n.SBOX[M >>> 8 & 255] << 8 | n.SBOX[M & 255], M ^= s[b / h | 0] << 24) : h > 6 && b % h === 4 && (M = n.SBOX[M >>> 24] << 24 | n.SBOX[M >>> 16 & 255] << 16 | n.SBOX[M >>> 8 & 255] << 8 | n.SBOX[M & 255]), m[b] = m[b - h] ^ M;
    }
    for (var A = [], N = 0; N < l; N++) {
      var R = l - N, O = m[R - (N % 4 ? 0 : 4)];
      N < 4 || R <= 4 ? A[N] = O : A[N] = n.INV_SUB_MIX[0][n.SBOX[O >>> 24]] ^ n.INV_SUB_MIX[1][n.SBOX[O >>> 16 & 255]] ^ n.INV_SUB_MIX[2][n.SBOX[O >>> 8 & 255]] ^ n.INV_SUB_MIX[3][n.SBOX[O & 255]];
    }
    this._nRounds = d, this._keySchedule = m, this._invKeySchedule = A;
  }, f.prototype.encryptBlockRaw = function(u) {
    return u = e(u), i(u, this._keySchedule, n.SUB_MIX, n.SBOX, this._nRounds);
  }, f.prototype.encryptBlock = function(u) {
    var h = this.encryptBlockRaw(u), d = t.allocUnsafe(16);
    return d.writeUInt32BE(h[0], 0), d.writeUInt32BE(h[1], 4), d.writeUInt32BE(h[2], 8), d.writeUInt32BE(h[3], 12), d;
  }, f.prototype.decryptBlock = function(u) {
    u = e(u);
    var h = u[1];
    u[1] = u[3], u[3] = h;
    var d = i(u, this._invKeySchedule, n.INV_SUB_MIX, n.INV_SBOX, this._nRounds), l = t.allocUnsafe(16);
    return l.writeUInt32BE(d[0], 0), l.writeUInt32BE(d[3], 4), l.writeUInt32BE(d[2], 8), l.writeUInt32BE(d[1], 12), l;
  }, f.prototype.scrub = function() {
    r(this._keySchedule), r(this._invKeySchedule), r(this._key);
  }, vb.AES = f, vb;
}
var gb, oM;
function Nte() {
  if (oM)
    return gb;
  oM = 1;
  var t = Ft.exports.Buffer, e = t.alloc(16, 0);
  function r(n) {
    return [
      n.readUInt32BE(0),
      n.readUInt32BE(4),
      n.readUInt32BE(8),
      n.readUInt32BE(12)
    ];
  }
  function i(n) {
    var f = t.allocUnsafe(16);
    return f.writeUInt32BE(n[0] >>> 0, 0), f.writeUInt32BE(n[1] >>> 0, 4), f.writeUInt32BE(n[2] >>> 0, 8), f.writeUInt32BE(n[3] >>> 0, 12), f;
  }
  function s(n) {
    this.h = n, this.state = t.alloc(16, 0), this.cache = t.allocUnsafe(0);
  }
  return s.prototype.ghash = function(n) {
    for (var f = -1; ++f < n.length; )
      this.state[f] ^= n[f];
    this._multiply();
  }, s.prototype._multiply = function() {
    for (var n = r(this.h), f = [0, 0, 0, 0], u, h, d, l = -1; ++l < 128; ) {
      for (h = (this.state[~~(l / 8)] & 1 << 7 - l % 8) !== 0, h && (f[0] ^= n[0], f[1] ^= n[1], f[2] ^= n[2], f[3] ^= n[3]), d = (n[3] & 1) !== 0, u = 3; u > 0; u--)
        n[u] = n[u] >>> 1 | (n[u - 1] & 1) << 31;
      n[0] = n[0] >>> 1, d && (n[0] = n[0] ^ 225 << 24);
    }
    this.state = i(f);
  }, s.prototype.update = function(n) {
    this.cache = t.concat([this.cache, n]);
    for (var f; this.cache.length >= 16; )
      f = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(f);
  }, s.prototype.final = function(n, f) {
    return this.cache.length && this.ghash(t.concat([this.cache, e], 16)), this.ghash(i([0, n, 0, f])), this.state;
  }, gb = s, gb;
}
var bb, fM;
function pA() {
  if (fM)
    return bb;
  fM = 1;
  var t = Hp(), e = Ft.exports.Buffer, r = mo(), i = It.exports, s = Nte(), n = Xh(), f = lA();
  function u(l, m) {
    var b = 0;
    l.length !== m.length && b++;
    for (var M = Math.min(l.length, m.length), A = 0; A < M; ++A)
      b += l[A] ^ m[A];
    return b;
  }
  function h(l, m, b) {
    if (m.length === 12)
      return l._finID = e.concat([m, e.from([0, 0, 0, 1])]), e.concat([m, e.from([0, 0, 0, 2])]);
    var M = new s(b), A = m.length, N = A % 16;
    M.update(m), N && (N = 16 - N, M.update(e.alloc(N, 0))), M.update(e.alloc(8, 0));
    var R = A * 8, O = e.alloc(8);
    O.writeUIntBE(R, 0, 8), M.update(O), l._finID = M.state;
    var P = e.from(l._finID);
    return f(P), P;
  }
  function d(l, m, b, M) {
    r.call(this);
    var A = e.alloc(4, 0);
    this._cipher = new t.AES(m);
    var N = this._cipher.encryptBlock(A);
    this._ghash = new s(N), b = h(this, b, N), this._prev = e.from(b), this._cache = e.allocUnsafe(0), this._secCache = e.allocUnsafe(0), this._decrypt = M, this._alen = 0, this._len = 0, this._mode = l, this._authTag = null, this._called = !1;
  }
  return i(d, r), d.prototype._update = function(l) {
    if (!this._called && this._alen) {
      var m = 16 - this._alen % 16;
      m < 16 && (m = e.alloc(m, 0), this._ghash.update(m));
    }
    this._called = !0;
    var b = this._mode.encrypt(this, l);
    return this._decrypt ? this._ghash.update(l) : this._ghash.update(b), this._len += l.length, b;
  }, d.prototype._final = function() {
    if (this._decrypt && !this._authTag)
      throw new Error("Unsupported state or unable to authenticate data");
    var l = n(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && u(l, this._authTag))
      throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = l, this._cipher.scrub();
  }, d.prototype.getAuthTag = function() {
    if (this._decrypt || !e.isBuffer(this._authTag))
      throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, d.prototype.setAuthTag = function(m) {
    if (!this._decrypt)
      throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = m;
  }, d.prototype.setAAD = function(m) {
    if (this._called)
      throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(m), this._alen += m.length;
  }, bb = d, bb;
}
var yb, cM;
function vA() {
  if (cM)
    return yb;
  cM = 1;
  var t = Hp(), e = Ft.exports.Buffer, r = mo(), i = It.exports;
  function s(n, f, u, h) {
    r.call(this), this._cipher = new t.AES(f), this._prev = e.from(u), this._cache = e.allocUnsafe(0), this._secCache = e.allocUnsafe(0), this._decrypt = h, this._mode = n;
  }
  return i(s, r), s.prototype._update = function(n) {
    return this._mode.encrypt(this, n, this._decrypt);
  }, s.prototype._final = function() {
    this._cipher.scrub();
  }, yb = s, yb;
}
var mb, uM;
function Wp() {
  if (uM)
    return mb;
  uM = 1;
  var t = Ft.exports.Buffer, e = hw();
  function r(i, s, n, f) {
    if (t.isBuffer(i) || (i = t.from(i, "binary")), s && (t.isBuffer(s) || (s = t.from(s, "binary")), s.length !== 8))
      throw new RangeError("salt should be Buffer with 8 byte length");
    for (var u = n / 8, h = t.alloc(u), d = t.alloc(f || 0), l = t.alloc(0); u > 0 || f > 0; ) {
      var m = new e();
      m.update(l), m.update(i), s && m.update(s), l = m.digest();
      var b = 0;
      if (u > 0) {
        var M = h.length - u;
        b = Math.min(u, l.length), l.copy(h, M, 0, b), u -= b;
      }
      if (b < l.length && f > 0) {
        var A = d.length - f, N = Math.min(f, l.length - b);
        l.copy(d, A, b, b + N), f -= N;
      }
    }
    return l.fill(0), { key: h, iv: d };
  }
  return mb = r, mb;
}
var hM;
function Dte() {
  if (hM)
    return Dd;
  hM = 1;
  var t = pw(), e = pA(), r = Ft.exports.Buffer, i = vA(), s = mo(), n = Hp(), f = Wp(), u = It.exports;
  function h(M, A, N) {
    s.call(this), this._cache = new l(), this._cipher = new n.AES(A), this._prev = r.from(N), this._mode = M, this._autopadding = !0;
  }
  u(h, s), h.prototype._update = function(M) {
    this._cache.add(M);
    for (var A, N, R = []; A = this._cache.get(); )
      N = this._mode.encrypt(this, A), R.push(N);
    return r.concat(R);
  };
  var d = r.alloc(16, 16);
  h.prototype._final = function() {
    var M = this._cache.flush();
    if (this._autopadding)
      return M = this._mode.encrypt(this, M), this._cipher.scrub(), M;
    if (!M.equals(d))
      throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, h.prototype.setAutoPadding = function(M) {
    return this._autopadding = !!M, this;
  };
  function l() {
    this.cache = r.allocUnsafe(0);
  }
  l.prototype.add = function(M) {
    this.cache = r.concat([this.cache, M]);
  }, l.prototype.get = function() {
    if (this.cache.length > 15) {
      var M = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), M;
    }
    return null;
  }, l.prototype.flush = function() {
    for (var M = 16 - this.cache.length, A = r.allocUnsafe(M), N = -1; ++N < M; )
      A.writeUInt8(M, N);
    return r.concat([this.cache, A]);
  };
  function m(M, A, N) {
    var R = t[M.toLowerCase()];
    if (!R)
      throw new TypeError("invalid suite type");
    if (typeof A == "string" && (A = r.from(A)), A.length !== R.key / 8)
      throw new TypeError("invalid key length " + A.length);
    if (typeof N == "string" && (N = r.from(N)), R.mode !== "GCM" && N.length !== R.iv)
      throw new TypeError("invalid iv length " + N.length);
    return R.type === "stream" ? new i(R.module, A, N) : R.type === "auth" ? new e(R.module, A, N) : new h(R.module, A, N);
  }
  function b(M, A) {
    var N = t[M.toLowerCase()];
    if (!N)
      throw new TypeError("invalid suite type");
    var R = f(A, !1, N.key, N.iv);
    return m(M, R.key, R.iv);
  }
  return Dd.createCipheriv = m, Dd.createCipher = b, Dd;
}
var Rd = {}, lM;
function Cte() {
  if (lM)
    return Rd;
  lM = 1;
  var t = pA(), e = Ft.exports.Buffer, r = pw(), i = vA(), s = mo(), n = Hp(), f = Wp(), u = It.exports;
  function h(M, A, N) {
    s.call(this), this._cache = new d(), this._last = void 0, this._cipher = new n.AES(A), this._prev = e.from(N), this._mode = M, this._autopadding = !0;
  }
  u(h, s), h.prototype._update = function(M) {
    this._cache.add(M);
    for (var A, N, R = []; A = this._cache.get(this._autopadding); )
      N = this._mode.decrypt(this, A), R.push(N);
    return e.concat(R);
  }, h.prototype._final = function() {
    var M = this._cache.flush();
    if (this._autopadding)
      return l(this._mode.decrypt(this, M));
    if (M)
      throw new Error("data not multiple of block length");
  }, h.prototype.setAutoPadding = function(M) {
    return this._autopadding = !!M, this;
  };
  function d() {
    this.cache = e.allocUnsafe(0);
  }
  d.prototype.add = function(M) {
    this.cache = e.concat([this.cache, M]);
  }, d.prototype.get = function(M) {
    var A;
    if (M) {
      if (this.cache.length > 16)
        return A = this.cache.slice(0, 16), this.cache = this.cache.slice(16), A;
    } else if (this.cache.length >= 16)
      return A = this.cache.slice(0, 16), this.cache = this.cache.slice(16), A;
    return null;
  }, d.prototype.flush = function() {
    if (this.cache.length)
      return this.cache;
  };
  function l(M) {
    var A = M[15];
    if (A < 1 || A > 16)
      throw new Error("unable to decrypt data");
    for (var N = -1; ++N < A; )
      if (M[N + (16 - A)] !== A)
        throw new Error("unable to decrypt data");
    if (A !== 16)
      return M.slice(0, 16 - A);
  }
  function m(M, A, N) {
    var R = r[M.toLowerCase()];
    if (!R)
      throw new TypeError("invalid suite type");
    if (typeof N == "string" && (N = e.from(N)), R.mode !== "GCM" && N.length !== R.iv)
      throw new TypeError("invalid iv length " + N.length);
    if (typeof A == "string" && (A = e.from(A)), A.length !== R.key / 8)
      throw new TypeError("invalid key length " + A.length);
    return R.type === "stream" ? new i(R.module, A, N, !0) : R.type === "auth" ? new t(R.module, A, N, !0) : new h(R.module, A, N);
  }
  function b(M, A) {
    var N = r[M.toLowerCase()];
    if (!N)
      throw new TypeError("invalid suite type");
    var R = f(A, !1, N.key, N.iv);
    return m(M, R.key, R.iv);
  }
  return Rd.createDecipher = b, Rd.createDecipheriv = m, Rd;
}
var dM;
function vw() {
  if (dM)
    return Wn;
  dM = 1;
  var t = Dte(), e = Cte(), r = dA;
  function i() {
    return Object.keys(r);
  }
  return Wn.createCipher = Wn.Cipher = t.createCipher, Wn.createCipheriv = Wn.Cipheriv = t.createCipheriv, Wn.createDecipher = Wn.Decipher = e.createDecipher, Wn.createDecipheriv = Wn.Decipheriv = e.createDecipheriv, Wn.listCiphers = Wn.getCiphers = i, Wn;
}
var wb = {}, pM;
function Ote() {
  return pM || (pM = 1, function(t) {
    t["des-ecb"] = {
      key: 8,
      iv: 0
    }, t["des-cbc"] = t.des = {
      key: 8,
      iv: 8
    }, t["des-ede3-cbc"] = t.des3 = {
      key: 24,
      iv: 8
    }, t["des-ede3"] = {
      key: 24,
      iv: 0
    }, t["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, t["des-ede"] = {
      key: 16,
      iv: 0
    };
  }(wb)), wb;
}
var vM;
function Rte() {
  if (vM)
    return Hn;
  vM = 1;
  var t = mte(), e = vw(), r = pw(), i = Ote(), s = Wp();
  function n(l, m) {
    l = l.toLowerCase();
    var b, M;
    if (r[l])
      b = r[l].key, M = r[l].iv;
    else if (i[l])
      b = i[l].key * 8, M = i[l].iv;
    else
      throw new TypeError("invalid suite type");
    var A = s(m, !1, b, M);
    return u(l, A.key, A.iv);
  }
  function f(l, m) {
    l = l.toLowerCase();
    var b, M;
    if (r[l])
      b = r[l].key, M = r[l].iv;
    else if (i[l])
      b = i[l].key * 8, M = i[l].iv;
    else
      throw new TypeError("invalid suite type");
    var A = s(m, !1, b, M);
    return h(l, A.key, A.iv);
  }
  function u(l, m, b) {
    if (l = l.toLowerCase(), r[l])
      return e.createCipheriv(l, m, b);
    if (i[l])
      return new t({ key: m, iv: b, mode: l });
    throw new TypeError("invalid suite type");
  }
  function h(l, m, b) {
    if (l = l.toLowerCase(), r[l])
      return e.createDecipheriv(l, m, b);
    if (i[l])
      return new t({ key: m, iv: b, mode: l, decrypt: !0 });
    throw new TypeError("invalid suite type");
  }
  function d() {
    return Object.keys(i).concat(e.getCiphers());
  }
  return Hn.createCipher = Hn.Cipher = n, Hn.createCipheriv = Hn.Cipheriv = u, Hn.createDecipher = Hn.Decipher = f, Hn.createDecipheriv = Hn.Decipheriv = h, Hn.listCiphers = Hn.getCiphers = d, Hn;
}
var Bo = {}, Sr = { exports: {} };
(function(t) {
  (function(e, r) {
    function i(W, C) {
      if (!W)
        throw new Error(C || "Assertion failed");
    }
    function s(W, C) {
      W.super_ = C;
      var g = function() {
      };
      g.prototype = C.prototype, W.prototype = new g(), W.prototype.constructor = W;
    }
    function n(W, C, g) {
      if (n.isBN(W))
        return W;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, W !== null && ((C === "le" || C === "be") && (g = C, C = 10), this._init(W || 0, C || 10, g || "be"));
    }
    typeof e == "object" ? e.exports = n : r.BN = n, n.BN = n, n.wordSize = 26;
    var f;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? f = window.Buffer : f = dn.Buffer;
    } catch {
    }
    n.isBN = function(C) {
      return C instanceof n ? !0 : C !== null && typeof C == "object" && C.constructor.wordSize === n.wordSize && Array.isArray(C.words);
    }, n.max = function(C, g) {
      return C.cmp(g) > 0 ? C : g;
    }, n.min = function(C, g) {
      return C.cmp(g) < 0 ? C : g;
    }, n.prototype._init = function(C, g, a) {
      if (typeof C == "number")
        return this._initNumber(C, g, a);
      if (typeof C == "object")
        return this._initArray(C, g, a);
      g === "hex" && (g = 16), i(g === (g | 0) && g >= 2 && g <= 36), C = C.toString().replace(/\s+/g, "");
      var c = 0;
      C[0] === "-" && (c++, this.negative = 1), c < C.length && (g === 16 ? this._parseHex(C, c, a) : (this._parseBase(C, g, c), a === "le" && this._initArray(this.toArray(), g, a)));
    }, n.prototype._initNumber = function(C, g, a) {
      C < 0 && (this.negative = 1, C = -C), C < 67108864 ? (this.words = [C & 67108863], this.length = 1) : C < 4503599627370496 ? (this.words = [
        C & 67108863,
        C / 67108864 & 67108863
      ], this.length = 2) : (i(C < 9007199254740992), this.words = [
        C & 67108863,
        C / 67108864 & 67108863,
        1
      ], this.length = 3), a === "le" && this._initArray(this.toArray(), g, a);
    }, n.prototype._initArray = function(C, g, a) {
      if (i(typeof C.length == "number"), C.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(C.length / 3), this.words = new Array(this.length);
      for (var c = 0; c < this.length; c++)
        this.words[c] = 0;
      var p, w, _ = 0;
      if (a === "be")
        for (c = C.length - 1, p = 0; c >= 0; c -= 3)
          w = C[c] | C[c - 1] << 8 | C[c - 2] << 16, this.words[p] |= w << _ & 67108863, this.words[p + 1] = w >>> 26 - _ & 67108863, _ += 24, _ >= 26 && (_ -= 26, p++);
      else if (a === "le")
        for (c = 0, p = 0; c < C.length; c += 3)
          w = C[c] | C[c + 1] << 8 | C[c + 2] << 16, this.words[p] |= w << _ & 67108863, this.words[p + 1] = w >>> 26 - _ & 67108863, _ += 24, _ >= 26 && (_ -= 26, p++);
      return this.strip();
    };
    function u(W, C) {
      var g = W.charCodeAt(C);
      return g >= 65 && g <= 70 ? g - 55 : g >= 97 && g <= 102 ? g - 87 : g - 48 & 15;
    }
    function h(W, C, g) {
      var a = u(W, g);
      return g - 1 >= C && (a |= u(W, g - 1) << 4), a;
    }
    n.prototype._parseHex = function(C, g, a) {
      this.length = Math.ceil((C.length - g) / 6), this.words = new Array(this.length);
      for (var c = 0; c < this.length; c++)
        this.words[c] = 0;
      var p = 0, w = 0, _;
      if (a === "be")
        for (c = C.length - 1; c >= g; c -= 2)
          _ = h(C, g, c) << p, this.words[w] |= _ & 67108863, p >= 18 ? (p -= 18, w += 1, this.words[w] |= _ >>> 26) : p += 8;
      else {
        var x = C.length - g;
        for (c = x % 2 === 0 ? g + 1 : g; c < C.length; c += 2)
          _ = h(C, g, c) << p, this.words[w] |= _ & 67108863, p >= 18 ? (p -= 18, w += 1, this.words[w] |= _ >>> 26) : p += 8;
      }
      this.strip();
    };
    function d(W, C, g, a) {
      for (var c = 0, p = Math.min(W.length, g), w = C; w < p; w++) {
        var _ = W.charCodeAt(w) - 48;
        c *= a, _ >= 49 ? c += _ - 49 + 10 : _ >= 17 ? c += _ - 17 + 10 : c += _;
      }
      return c;
    }
    n.prototype._parseBase = function(C, g, a) {
      this.words = [0], this.length = 1;
      for (var c = 0, p = 1; p <= 67108863; p *= g)
        c++;
      c--, p = p / g | 0;
      for (var w = C.length - a, _ = w % c, x = Math.min(w, w - _) + a, E = 0, y = a; y < x; y += c)
        E = d(C, y, y + c, g), this.imuln(p), this.words[0] + E < 67108864 ? this.words[0] += E : this._iaddn(E);
      if (_ !== 0) {
        var o = 1;
        for (E = d(C, y, C.length, g), y = 0; y < _; y++)
          o *= g;
        this.imuln(o), this.words[0] + E < 67108864 ? this.words[0] += E : this._iaddn(E);
      }
      this.strip();
    }, n.prototype.copy = function(C) {
      C.words = new Array(this.length);
      for (var g = 0; g < this.length; g++)
        C.words[g] = this.words[g];
      C.length = this.length, C.negative = this.negative, C.red = this.red;
    }, n.prototype.clone = function() {
      var C = new n(null);
      return this.copy(C), C;
    }, n.prototype._expand = function(C) {
      for (; this.length < C; )
        this.words[this.length++] = 0;
      return this;
    }, n.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, n.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, n.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var l = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], m = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], b = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    n.prototype.toString = function(C, g) {
      C = C || 10, g = g | 0 || 1;
      var a;
      if (C === 16 || C === "hex") {
        a = "";
        for (var c = 0, p = 0, w = 0; w < this.length; w++) {
          var _ = this.words[w], x = ((_ << c | p) & 16777215).toString(16);
          p = _ >>> 24 - c & 16777215, p !== 0 || w !== this.length - 1 ? a = l[6 - x.length] + x + a : a = x + a, c += 2, c >= 26 && (c -= 26, w--);
        }
        for (p !== 0 && (a = p.toString(16) + a); a.length % g !== 0; )
          a = "0" + a;
        return this.negative !== 0 && (a = "-" + a), a;
      }
      if (C === (C | 0) && C >= 2 && C <= 36) {
        var E = m[C], y = b[C];
        a = "";
        var o = this.clone();
        for (o.negative = 0; !o.isZero(); ) {
          var S = o.modn(y).toString(C);
          o = o.idivn(y), o.isZero() ? a = S + a : a = l[E - S.length] + S + a;
        }
        for (this.isZero() && (a = "0" + a); a.length % g !== 0; )
          a = "0" + a;
        return this.negative !== 0 && (a = "-" + a), a;
      }
      i(!1, "Base should be between 2 and 36");
    }, n.prototype.toNumber = function() {
      var C = this.words[0];
      return this.length === 2 ? C += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? C += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -C : C;
    }, n.prototype.toJSON = function() {
      return this.toString(16);
    }, n.prototype.toBuffer = function(C, g) {
      return i(typeof f < "u"), this.toArrayLike(f, C, g);
    }, n.prototype.toArray = function(C, g) {
      return this.toArrayLike(Array, C, g);
    }, n.prototype.toArrayLike = function(C, g, a) {
      var c = this.byteLength(), p = a || Math.max(1, c);
      i(c <= p, "byte array longer than desired length"), i(p > 0, "Requested array length <= 0"), this.strip();
      var w = g === "le", _ = new C(p), x, E, y = this.clone();
      if (w) {
        for (E = 0; !y.isZero(); E++)
          x = y.andln(255), y.iushrn(8), _[E] = x;
        for (; E < p; E++)
          _[E] = 0;
      } else {
        for (E = 0; E < p - c; E++)
          _[E] = 0;
        for (E = 0; !y.isZero(); E++)
          x = y.andln(255), y.iushrn(8), _[p - E - 1] = x;
      }
      return _;
    }, Math.clz32 ? n.prototype._countBits = function(C) {
      return 32 - Math.clz32(C);
    } : n.prototype._countBits = function(C) {
      var g = C, a = 0;
      return g >= 4096 && (a += 13, g >>>= 13), g >= 64 && (a += 7, g >>>= 7), g >= 8 && (a += 4, g >>>= 4), g >= 2 && (a += 2, g >>>= 2), a + g;
    }, n.prototype._zeroBits = function(C) {
      if (C === 0)
        return 26;
      var g = C, a = 0;
      return (g & 8191) === 0 && (a += 13, g >>>= 13), (g & 127) === 0 && (a += 7, g >>>= 7), (g & 15) === 0 && (a += 4, g >>>= 4), (g & 3) === 0 && (a += 2, g >>>= 2), (g & 1) === 0 && a++, a;
    }, n.prototype.bitLength = function() {
      var C = this.words[this.length - 1], g = this._countBits(C);
      return (this.length - 1) * 26 + g;
    };
    function M(W) {
      for (var C = new Array(W.bitLength()), g = 0; g < C.length; g++) {
        var a = g / 26 | 0, c = g % 26;
        C[g] = (W.words[a] & 1 << c) >>> c;
      }
      return C;
    }
    n.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var C = 0, g = 0; g < this.length; g++) {
        var a = this._zeroBits(this.words[g]);
        if (C += a, a !== 26)
          break;
      }
      return C;
    }, n.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, n.prototype.toTwos = function(C) {
      return this.negative !== 0 ? this.abs().inotn(C).iaddn(1) : this.clone();
    }, n.prototype.fromTwos = function(C) {
      return this.testn(C - 1) ? this.notn(C).iaddn(1).ineg() : this.clone();
    }, n.prototype.isNeg = function() {
      return this.negative !== 0;
    }, n.prototype.neg = function() {
      return this.clone().ineg();
    }, n.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, n.prototype.iuor = function(C) {
      for (; this.length < C.length; )
        this.words[this.length++] = 0;
      for (var g = 0; g < C.length; g++)
        this.words[g] = this.words[g] | C.words[g];
      return this.strip();
    }, n.prototype.ior = function(C) {
      return i((this.negative | C.negative) === 0), this.iuor(C);
    }, n.prototype.or = function(C) {
      return this.length > C.length ? this.clone().ior(C) : C.clone().ior(this);
    }, n.prototype.uor = function(C) {
      return this.length > C.length ? this.clone().iuor(C) : C.clone().iuor(this);
    }, n.prototype.iuand = function(C) {
      var g;
      this.length > C.length ? g = C : g = this;
      for (var a = 0; a < g.length; a++)
        this.words[a] = this.words[a] & C.words[a];
      return this.length = g.length, this.strip();
    }, n.prototype.iand = function(C) {
      return i((this.negative | C.negative) === 0), this.iuand(C);
    }, n.prototype.and = function(C) {
      return this.length > C.length ? this.clone().iand(C) : C.clone().iand(this);
    }, n.prototype.uand = function(C) {
      return this.length > C.length ? this.clone().iuand(C) : C.clone().iuand(this);
    }, n.prototype.iuxor = function(C) {
      var g, a;
      this.length > C.length ? (g = this, a = C) : (g = C, a = this);
      for (var c = 0; c < a.length; c++)
        this.words[c] = g.words[c] ^ a.words[c];
      if (this !== g)
        for (; c < g.length; c++)
          this.words[c] = g.words[c];
      return this.length = g.length, this.strip();
    }, n.prototype.ixor = function(C) {
      return i((this.negative | C.negative) === 0), this.iuxor(C);
    }, n.prototype.xor = function(C) {
      return this.length > C.length ? this.clone().ixor(C) : C.clone().ixor(this);
    }, n.prototype.uxor = function(C) {
      return this.length > C.length ? this.clone().iuxor(C) : C.clone().iuxor(this);
    }, n.prototype.inotn = function(C) {
      i(typeof C == "number" && C >= 0);
      var g = Math.ceil(C / 26) | 0, a = C % 26;
      this._expand(g), a > 0 && g--;
      for (var c = 0; c < g; c++)
        this.words[c] = ~this.words[c] & 67108863;
      return a > 0 && (this.words[c] = ~this.words[c] & 67108863 >> 26 - a), this.strip();
    }, n.prototype.notn = function(C) {
      return this.clone().inotn(C);
    }, n.prototype.setn = function(C, g) {
      i(typeof C == "number" && C >= 0);
      var a = C / 26 | 0, c = C % 26;
      return this._expand(a + 1), g ? this.words[a] = this.words[a] | 1 << c : this.words[a] = this.words[a] & ~(1 << c), this.strip();
    }, n.prototype.iadd = function(C) {
      var g;
      if (this.negative !== 0 && C.negative === 0)
        return this.negative = 0, g = this.isub(C), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && C.negative !== 0)
        return C.negative = 0, g = this.isub(C), C.negative = 1, g._normSign();
      var a, c;
      this.length > C.length ? (a = this, c = C) : (a = C, c = this);
      for (var p = 0, w = 0; w < c.length; w++)
        g = (a.words[w] | 0) + (c.words[w] | 0) + p, this.words[w] = g & 67108863, p = g >>> 26;
      for (; p !== 0 && w < a.length; w++)
        g = (a.words[w] | 0) + p, this.words[w] = g & 67108863, p = g >>> 26;
      if (this.length = a.length, p !== 0)
        this.words[this.length] = p, this.length++;
      else if (a !== this)
        for (; w < a.length; w++)
          this.words[w] = a.words[w];
      return this;
    }, n.prototype.add = function(C) {
      var g;
      return C.negative !== 0 && this.negative === 0 ? (C.negative = 0, g = this.sub(C), C.negative ^= 1, g) : C.negative === 0 && this.negative !== 0 ? (this.negative = 0, g = C.sub(this), this.negative = 1, g) : this.length > C.length ? this.clone().iadd(C) : C.clone().iadd(this);
    }, n.prototype.isub = function(C) {
      if (C.negative !== 0) {
        C.negative = 0;
        var g = this.iadd(C);
        return C.negative = 1, g._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(C), this.negative = 1, this._normSign();
      var a = this.cmp(C);
      if (a === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var c, p;
      a > 0 ? (c = this, p = C) : (c = C, p = this);
      for (var w = 0, _ = 0; _ < p.length; _++)
        g = (c.words[_] | 0) - (p.words[_] | 0) + w, w = g >> 26, this.words[_] = g & 67108863;
      for (; w !== 0 && _ < c.length; _++)
        g = (c.words[_] | 0) + w, w = g >> 26, this.words[_] = g & 67108863;
      if (w === 0 && _ < c.length && c !== this)
        for (; _ < c.length; _++)
          this.words[_] = c.words[_];
      return this.length = Math.max(this.length, _), c !== this && (this.negative = 1), this.strip();
    }, n.prototype.sub = function(C) {
      return this.clone().isub(C);
    };
    function A(W, C, g) {
      g.negative = C.negative ^ W.negative;
      var a = W.length + C.length | 0;
      g.length = a, a = a - 1 | 0;
      var c = W.words[0] | 0, p = C.words[0] | 0, w = c * p, _ = w & 67108863, x = w / 67108864 | 0;
      g.words[0] = _;
      for (var E = 1; E < a; E++) {
        for (var y = x >>> 26, o = x & 67108863, S = Math.min(E, C.length - 1), J = Math.max(0, E - W.length + 1); J <= S; J++) {
          var z = E - J | 0;
          c = W.words[z] | 0, p = C.words[J] | 0, w = c * p + o, y += w / 67108864 | 0, o = w & 67108863;
        }
        g.words[E] = o | 0, x = y | 0;
      }
      return x !== 0 ? g.words[E] = x | 0 : g.length--, g.strip();
    }
    var N = function(C, g, a) {
      var c = C.words, p = g.words, w = a.words, _ = 0, x, E, y, o = c[0] | 0, S = o & 8191, J = o >>> 13, z = c[1] | 0, k = z & 8191, j = z >>> 13, q = c[2] | 0, K = q & 8191, U = q >>> 13, T = c[3] | 0, D = T & 8191, te = T >>> 13, ne = c[4] | 0, le = ne & 8191, X = ne >>> 13, $ = c[5] | 0, V = $ & 8191, re = $ >>> 13, fe = c[6] | 0, ue = fe & 8191, me = fe >>> 13, be = c[7] | 0, ve = be & 8191, Ge = be >>> 13, ye = c[8] | 0, pe = ye & 8191, Je = ye >>> 13, Ie = c[9] | 0, we = Ie & 8191, at = Ie >>> 13, Oe = p[0] | 0, Ee = Oe & 8191, ft = Oe >>> 13, Le = p[1] | 0, Pe = Le & 8191, Mt = Le >>> 13, Ve = p[2] | 0, ke = Ve & 8191, Et = Ve >>> 13, Ke = p[3] | 0, Be = Ke & 8191, dt = Ke >>> 13, ze = p[4] | 0, Te = ze & 8191, pt = ze >>> 13, Fe = p[5] | 0, Ae = Fe & 8191, bt = Fe >>> 13, He = p[6] | 0, Ne = He & 8191, yt = He >>> 13, $e = p[7] | 0, De = $e & 8191, vt = $e >>> 13, je = p[8] | 0, Ce = je & 8191, mt = je >>> 13, Ze = p[9] | 0, qe = Ze & 8191, Dt = Ze >>> 13;
      a.negative = C.negative ^ g.negative, a.length = 19, x = Math.imul(S, Ee), E = Math.imul(S, ft), E = E + Math.imul(J, Ee) | 0, y = Math.imul(J, ft);
      var We = (_ + x | 0) + ((E & 8191) << 13) | 0;
      _ = (y + (E >>> 13) | 0) + (We >>> 26) | 0, We &= 67108863, x = Math.imul(k, Ee), E = Math.imul(k, ft), E = E + Math.imul(j, Ee) | 0, y = Math.imul(j, ft), x = x + Math.imul(S, Pe) | 0, E = E + Math.imul(S, Mt) | 0, E = E + Math.imul(J, Pe) | 0, y = y + Math.imul(J, Mt) | 0;
      var Qe = (_ + x | 0) + ((E & 8191) << 13) | 0;
      _ = (y + (E >>> 13) | 0) + (Qe >>> 26) | 0, Qe &= 67108863, x = Math.imul(K, Ee), E = Math.imul(K, ft), E = E + Math.imul(U, Ee) | 0, y = Math.imul(U, ft), x = x + Math.imul(k, Pe) | 0, E = E + Math.imul(k, Mt) | 0, E = E + Math.imul(j, Pe) | 0, y = y + Math.imul(j, Mt) | 0, x = x + Math.imul(S, ke) | 0, E = E + Math.imul(S, Et) | 0, E = E + Math.imul(J, ke) | 0, y = y + Math.imul(J, Et) | 0;
      var Qt = (_ + x | 0) + ((E & 8191) << 13) | 0;
      _ = (y + (E >>> 13) | 0) + (Qt >>> 26) | 0, Qt &= 67108863, x = Math.imul(D, Ee), E = Math.imul(D, ft), E = E + Math.imul(te, Ee) | 0, y = Math.imul(te, ft), x = x + Math.imul(K, Pe) | 0, E = E + Math.imul(K, Mt) | 0, E = E + Math.imul(U, Pe) | 0, y = y + Math.imul(U, Mt) | 0, x = x + Math.imul(k, ke) | 0, E = E + Math.imul(k, Et) | 0, E = E + Math.imul(j, ke) | 0, y = y + Math.imul(j, Et) | 0, x = x + Math.imul(S, Be) | 0, E = E + Math.imul(S, dt) | 0, E = E + Math.imul(J, Be) | 0, y = y + Math.imul(J, dt) | 0;
      var Zt = (_ + x | 0) + ((E & 8191) << 13) | 0;
      _ = (y + (E >>> 13) | 0) + (Zt >>> 26) | 0, Zt &= 67108863, x = Math.imul(le, Ee), E = Math.imul(le, ft), E = E + Math.imul(X, Ee) | 0, y = Math.imul(X, ft), x = x + Math.imul(D, Pe) | 0, E = E + Math.imul(D, Mt) | 0, E = E + Math.imul(te, Pe) | 0, y = y + Math.imul(te, Mt) | 0, x = x + Math.imul(K, ke) | 0, E = E + Math.imul(K, Et) | 0, E = E + Math.imul(U, ke) | 0, y = y + Math.imul(U, Et) | 0, x = x + Math.imul(k, Be) | 0, E = E + Math.imul(k, dt) | 0, E = E + Math.imul(j, Be) | 0, y = y + Math.imul(j, dt) | 0, x = x + Math.imul(S, Te) | 0, E = E + Math.imul(S, pt) | 0, E = E + Math.imul(J, Te) | 0, y = y + Math.imul(J, pt) | 0;
      var Jt = (_ + x | 0) + ((E & 8191) << 13) | 0;
      _ = (y + (E >>> 13) | 0) + (Jt >>> 26) | 0, Jt &= 67108863, x = Math.imul(V, Ee), E = Math.imul(V, ft), E = E + Math.imul(re, Ee) | 0, y = Math.imul(re, ft), x = x + Math.imul(le, Pe) | 0, E = E + Math.imul(le, Mt) | 0, E = E + Math.imul(X, Pe) | 0, y = y + Math.imul(X, Mt) | 0, x = x + Math.imul(D, ke) | 0, E = E + Math.imul(D, Et) | 0, E = E + Math.imul(te, ke) | 0, y = y + Math.imul(te, Et) | 0, x = x + Math.imul(K, Be) | 0, E = E + Math.imul(K, dt) | 0, E = E + Math.imul(U, Be) | 0, y = y + Math.imul(U, dt) | 0, x = x + Math.imul(k, Te) | 0, E = E + Math.imul(k, pt) | 0, E = E + Math.imul(j, Te) | 0, y = y + Math.imul(j, pt) | 0, x = x + Math.imul(S, Ae) | 0, E = E + Math.imul(S, bt) | 0, E = E + Math.imul(J, Ae) | 0, y = y + Math.imul(J, bt) | 0;
      var Xt = (_ + x | 0) + ((E & 8191) << 13) | 0;
      _ = (y + (E >>> 13) | 0) + (Xt >>> 26) | 0, Xt &= 67108863, x = Math.imul(ue, Ee), E = Math.imul(ue, ft), E = E + Math.imul(me, Ee) | 0, y = Math.imul(me, ft), x = x + Math.imul(V, Pe) | 0, E = E + Math.imul(V, Mt) | 0, E = E + Math.imul(re, Pe) | 0, y = y + Math.imul(re, Mt) | 0, x = x + Math.imul(le, ke) | 0, E = E + Math.imul(le, Et) | 0, E = E + Math.imul(X, ke) | 0, y = y + Math.imul(X, Et) | 0, x = x + Math.imul(D, Be) | 0, E = E + Math.imul(D, dt) | 0, E = E + Math.imul(te, Be) | 0, y = y + Math.imul(te, dt) | 0, x = x + Math.imul(K, Te) | 0, E = E + Math.imul(K, pt) | 0, E = E + Math.imul(U, Te) | 0, y = y + Math.imul(U, pt) | 0, x = x + Math.imul(k, Ae) | 0, E = E + Math.imul(k, bt) | 0, E = E + Math.imul(j, Ae) | 0, y = y + Math.imul(j, bt) | 0, x = x + Math.imul(S, Ne) | 0, E = E + Math.imul(S, yt) | 0, E = E + Math.imul(J, Ne) | 0, y = y + Math.imul(J, yt) | 0;
      var kt = (_ + x | 0) + ((E & 8191) << 13) | 0;
      _ = (y + (E >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, x = Math.imul(ve, Ee), E = Math.imul(ve, ft), E = E + Math.imul(Ge, Ee) | 0, y = Math.imul(Ge, ft), x = x + Math.imul(ue, Pe) | 0, E = E + Math.imul(ue, Mt) | 0, E = E + Math.imul(me, Pe) | 0, y = y + Math.imul(me, Mt) | 0, x = x + Math.imul(V, ke) | 0, E = E + Math.imul(V, Et) | 0, E = E + Math.imul(re, ke) | 0, y = y + Math.imul(re, Et) | 0, x = x + Math.imul(le, Be) | 0, E = E + Math.imul(le, dt) | 0, E = E + Math.imul(X, Be) | 0, y = y + Math.imul(X, dt) | 0, x = x + Math.imul(D, Te) | 0, E = E + Math.imul(D, pt) | 0, E = E + Math.imul(te, Te) | 0, y = y + Math.imul(te, pt) | 0, x = x + Math.imul(K, Ae) | 0, E = E + Math.imul(K, bt) | 0, E = E + Math.imul(U, Ae) | 0, y = y + Math.imul(U, bt) | 0, x = x + Math.imul(k, Ne) | 0, E = E + Math.imul(k, yt) | 0, E = E + Math.imul(j, Ne) | 0, y = y + Math.imul(j, yt) | 0, x = x + Math.imul(S, De) | 0, E = E + Math.imul(S, vt) | 0, E = E + Math.imul(J, De) | 0, y = y + Math.imul(J, vt) | 0;
      var ar = (_ + x | 0) + ((E & 8191) << 13) | 0;
      _ = (y + (E >>> 13) | 0) + (ar >>> 26) | 0, ar &= 67108863, x = Math.imul(pe, Ee), E = Math.imul(pe, ft), E = E + Math.imul(Je, Ee) | 0, y = Math.imul(Je, ft), x = x + Math.imul(ve, Pe) | 0, E = E + Math.imul(ve, Mt) | 0, E = E + Math.imul(Ge, Pe) | 0, y = y + Math.imul(Ge, Mt) | 0, x = x + Math.imul(ue, ke) | 0, E = E + Math.imul(ue, Et) | 0, E = E + Math.imul(me, ke) | 0, y = y + Math.imul(me, Et) | 0, x = x + Math.imul(V, Be) | 0, E = E + Math.imul(V, dt) | 0, E = E + Math.imul(re, Be) | 0, y = y + Math.imul(re, dt) | 0, x = x + Math.imul(le, Te) | 0, E = E + Math.imul(le, pt) | 0, E = E + Math.imul(X, Te) | 0, y = y + Math.imul(X, pt) | 0, x = x + Math.imul(D, Ae) | 0, E = E + Math.imul(D, bt) | 0, E = E + Math.imul(te, Ae) | 0, y = y + Math.imul(te, bt) | 0, x = x + Math.imul(K, Ne) | 0, E = E + Math.imul(K, yt) | 0, E = E + Math.imul(U, Ne) | 0, y = y + Math.imul(U, yt) | 0, x = x + Math.imul(k, De) | 0, E = E + Math.imul(k, vt) | 0, E = E + Math.imul(j, De) | 0, y = y + Math.imul(j, vt) | 0, x = x + Math.imul(S, Ce) | 0, E = E + Math.imul(S, mt) | 0, E = E + Math.imul(J, Ce) | 0, y = y + Math.imul(J, mt) | 0;
      var lr = (_ + x | 0) + ((E & 8191) << 13) | 0;
      _ = (y + (E >>> 13) | 0) + (lr >>> 26) | 0, lr &= 67108863, x = Math.imul(we, Ee), E = Math.imul(we, ft), E = E + Math.imul(at, Ee) | 0, y = Math.imul(at, ft), x = x + Math.imul(pe, Pe) | 0, E = E + Math.imul(pe, Mt) | 0, E = E + Math.imul(Je, Pe) | 0, y = y + Math.imul(Je, Mt) | 0, x = x + Math.imul(ve, ke) | 0, E = E + Math.imul(ve, Et) | 0, E = E + Math.imul(Ge, ke) | 0, y = y + Math.imul(Ge, Et) | 0, x = x + Math.imul(ue, Be) | 0, E = E + Math.imul(ue, dt) | 0, E = E + Math.imul(me, Be) | 0, y = y + Math.imul(me, dt) | 0, x = x + Math.imul(V, Te) | 0, E = E + Math.imul(V, pt) | 0, E = E + Math.imul(re, Te) | 0, y = y + Math.imul(re, pt) | 0, x = x + Math.imul(le, Ae) | 0, E = E + Math.imul(le, bt) | 0, E = E + Math.imul(X, Ae) | 0, y = y + Math.imul(X, bt) | 0, x = x + Math.imul(D, Ne) | 0, E = E + Math.imul(D, yt) | 0, E = E + Math.imul(te, Ne) | 0, y = y + Math.imul(te, yt) | 0, x = x + Math.imul(K, De) | 0, E = E + Math.imul(K, vt) | 0, E = E + Math.imul(U, De) | 0, y = y + Math.imul(U, vt) | 0, x = x + Math.imul(k, Ce) | 0, E = E + Math.imul(k, mt) | 0, E = E + Math.imul(j, Ce) | 0, y = y + Math.imul(j, mt) | 0, x = x + Math.imul(S, qe) | 0, E = E + Math.imul(S, Dt) | 0, E = E + Math.imul(J, qe) | 0, y = y + Math.imul(J, Dt) | 0;
      var or = (_ + x | 0) + ((E & 8191) << 13) | 0;
      _ = (y + (E >>> 13) | 0) + (or >>> 26) | 0, or &= 67108863, x = Math.imul(we, Pe), E = Math.imul(we, Mt), E = E + Math.imul(at, Pe) | 0, y = Math.imul(at, Mt), x = x + Math.imul(pe, ke) | 0, E = E + Math.imul(pe, Et) | 0, E = E + Math.imul(Je, ke) | 0, y = y + Math.imul(Je, Et) | 0, x = x + Math.imul(ve, Be) | 0, E = E + Math.imul(ve, dt) | 0, E = E + Math.imul(Ge, Be) | 0, y = y + Math.imul(Ge, dt) | 0, x = x + Math.imul(ue, Te) | 0, E = E + Math.imul(ue, pt) | 0, E = E + Math.imul(me, Te) | 0, y = y + Math.imul(me, pt) | 0, x = x + Math.imul(V, Ae) | 0, E = E + Math.imul(V, bt) | 0, E = E + Math.imul(re, Ae) | 0, y = y + Math.imul(re, bt) | 0, x = x + Math.imul(le, Ne) | 0, E = E + Math.imul(le, yt) | 0, E = E + Math.imul(X, Ne) | 0, y = y + Math.imul(X, yt) | 0, x = x + Math.imul(D, De) | 0, E = E + Math.imul(D, vt) | 0, E = E + Math.imul(te, De) | 0, y = y + Math.imul(te, vt) | 0, x = x + Math.imul(K, Ce) | 0, E = E + Math.imul(K, mt) | 0, E = E + Math.imul(U, Ce) | 0, y = y + Math.imul(U, mt) | 0, x = x + Math.imul(k, qe) | 0, E = E + Math.imul(k, Dt) | 0, E = E + Math.imul(j, qe) | 0, y = y + Math.imul(j, Dt) | 0;
      var dr = (_ + x | 0) + ((E & 8191) << 13) | 0;
      _ = (y + (E >>> 13) | 0) + (dr >>> 26) | 0, dr &= 67108863, x = Math.imul(we, ke), E = Math.imul(we, Et), E = E + Math.imul(at, ke) | 0, y = Math.imul(at, Et), x = x + Math.imul(pe, Be) | 0, E = E + Math.imul(pe, dt) | 0, E = E + Math.imul(Je, Be) | 0, y = y + Math.imul(Je, dt) | 0, x = x + Math.imul(ve, Te) | 0, E = E + Math.imul(ve, pt) | 0, E = E + Math.imul(Ge, Te) | 0, y = y + Math.imul(Ge, pt) | 0, x = x + Math.imul(ue, Ae) | 0, E = E + Math.imul(ue, bt) | 0, E = E + Math.imul(me, Ae) | 0, y = y + Math.imul(me, bt) | 0, x = x + Math.imul(V, Ne) | 0, E = E + Math.imul(V, yt) | 0, E = E + Math.imul(re, Ne) | 0, y = y + Math.imul(re, yt) | 0, x = x + Math.imul(le, De) | 0, E = E + Math.imul(le, vt) | 0, E = E + Math.imul(X, De) | 0, y = y + Math.imul(X, vt) | 0, x = x + Math.imul(D, Ce) | 0, E = E + Math.imul(D, mt) | 0, E = E + Math.imul(te, Ce) | 0, y = y + Math.imul(te, mt) | 0, x = x + Math.imul(K, qe) | 0, E = E + Math.imul(K, Dt) | 0, E = E + Math.imul(U, qe) | 0, y = y + Math.imul(U, Dt) | 0;
      var pr = (_ + x | 0) + ((E & 8191) << 13) | 0;
      _ = (y + (E >>> 13) | 0) + (pr >>> 26) | 0, pr &= 67108863, x = Math.imul(we, Be), E = Math.imul(we, dt), E = E + Math.imul(at, Be) | 0, y = Math.imul(at, dt), x = x + Math.imul(pe, Te) | 0, E = E + Math.imul(pe, pt) | 0, E = E + Math.imul(Je, Te) | 0, y = y + Math.imul(Je, pt) | 0, x = x + Math.imul(ve, Ae) | 0, E = E + Math.imul(ve, bt) | 0, E = E + Math.imul(Ge, Ae) | 0, y = y + Math.imul(Ge, bt) | 0, x = x + Math.imul(ue, Ne) | 0, E = E + Math.imul(ue, yt) | 0, E = E + Math.imul(me, Ne) | 0, y = y + Math.imul(me, yt) | 0, x = x + Math.imul(V, De) | 0, E = E + Math.imul(V, vt) | 0, E = E + Math.imul(re, De) | 0, y = y + Math.imul(re, vt) | 0, x = x + Math.imul(le, Ce) | 0, E = E + Math.imul(le, mt) | 0, E = E + Math.imul(X, Ce) | 0, y = y + Math.imul(X, mt) | 0, x = x + Math.imul(D, qe) | 0, E = E + Math.imul(D, Dt) | 0, E = E + Math.imul(te, qe) | 0, y = y + Math.imul(te, Dt) | 0;
      var fr = (_ + x | 0) + ((E & 8191) << 13) | 0;
      _ = (y + (E >>> 13) | 0) + (fr >>> 26) | 0, fr &= 67108863, x = Math.imul(we, Te), E = Math.imul(we, pt), E = E + Math.imul(at, Te) | 0, y = Math.imul(at, pt), x = x + Math.imul(pe, Ae) | 0, E = E + Math.imul(pe, bt) | 0, E = E + Math.imul(Je, Ae) | 0, y = y + Math.imul(Je, bt) | 0, x = x + Math.imul(ve, Ne) | 0, E = E + Math.imul(ve, yt) | 0, E = E + Math.imul(Ge, Ne) | 0, y = y + Math.imul(Ge, yt) | 0, x = x + Math.imul(ue, De) | 0, E = E + Math.imul(ue, vt) | 0, E = E + Math.imul(me, De) | 0, y = y + Math.imul(me, vt) | 0, x = x + Math.imul(V, Ce) | 0, E = E + Math.imul(V, mt) | 0, E = E + Math.imul(re, Ce) | 0, y = y + Math.imul(re, mt) | 0, x = x + Math.imul(le, qe) | 0, E = E + Math.imul(le, Dt) | 0, E = E + Math.imul(X, qe) | 0, y = y + Math.imul(X, Dt) | 0;
      var ur = (_ + x | 0) + ((E & 8191) << 13) | 0;
      _ = (y + (E >>> 13) | 0) + (ur >>> 26) | 0, ur &= 67108863, x = Math.imul(we, Ae), E = Math.imul(we, bt), E = E + Math.imul(at, Ae) | 0, y = Math.imul(at, bt), x = x + Math.imul(pe, Ne) | 0, E = E + Math.imul(pe, yt) | 0, E = E + Math.imul(Je, Ne) | 0, y = y + Math.imul(Je, yt) | 0, x = x + Math.imul(ve, De) | 0, E = E + Math.imul(ve, vt) | 0, E = E + Math.imul(Ge, De) | 0, y = y + Math.imul(Ge, vt) | 0, x = x + Math.imul(ue, Ce) | 0, E = E + Math.imul(ue, mt) | 0, E = E + Math.imul(me, Ce) | 0, y = y + Math.imul(me, mt) | 0, x = x + Math.imul(V, qe) | 0, E = E + Math.imul(V, Dt) | 0, E = E + Math.imul(re, qe) | 0, y = y + Math.imul(re, Dt) | 0;
      var hr = (_ + x | 0) + ((E & 8191) << 13) | 0;
      _ = (y + (E >>> 13) | 0) + (hr >>> 26) | 0, hr &= 67108863, x = Math.imul(we, Ne), E = Math.imul(we, yt), E = E + Math.imul(at, Ne) | 0, y = Math.imul(at, yt), x = x + Math.imul(pe, De) | 0, E = E + Math.imul(pe, vt) | 0, E = E + Math.imul(Je, De) | 0, y = y + Math.imul(Je, vt) | 0, x = x + Math.imul(ve, Ce) | 0, E = E + Math.imul(ve, mt) | 0, E = E + Math.imul(Ge, Ce) | 0, y = y + Math.imul(Ge, mt) | 0, x = x + Math.imul(ue, qe) | 0, E = E + Math.imul(ue, Dt) | 0, E = E + Math.imul(me, qe) | 0, y = y + Math.imul(me, Dt) | 0;
      var qt = (_ + x | 0) + ((E & 8191) << 13) | 0;
      _ = (y + (E >>> 13) | 0) + (qt >>> 26) | 0, qt &= 67108863, x = Math.imul(we, De), E = Math.imul(we, vt), E = E + Math.imul(at, De) | 0, y = Math.imul(at, vt), x = x + Math.imul(pe, Ce) | 0, E = E + Math.imul(pe, mt) | 0, E = E + Math.imul(Je, Ce) | 0, y = y + Math.imul(Je, mt) | 0, x = x + Math.imul(ve, qe) | 0, E = E + Math.imul(ve, Dt) | 0, E = E + Math.imul(Ge, qe) | 0, y = y + Math.imul(Ge, Dt) | 0;
      var Er = (_ + x | 0) + ((E & 8191) << 13) | 0;
      _ = (y + (E >>> 13) | 0) + (Er >>> 26) | 0, Er &= 67108863, x = Math.imul(we, Ce), E = Math.imul(we, mt), E = E + Math.imul(at, Ce) | 0, y = Math.imul(at, mt), x = x + Math.imul(pe, qe) | 0, E = E + Math.imul(pe, Dt) | 0, E = E + Math.imul(Je, qe) | 0, y = y + Math.imul(Je, Dt) | 0;
      var Ir = (_ + x | 0) + ((E & 8191) << 13) | 0;
      _ = (y + (E >>> 13) | 0) + (Ir >>> 26) | 0, Ir &= 67108863, x = Math.imul(we, qe), E = Math.imul(we, Dt), E = E + Math.imul(at, qe) | 0, y = Math.imul(at, Dt);
      var Ar = (_ + x | 0) + ((E & 8191) << 13) | 0;
      return _ = (y + (E >>> 13) | 0) + (Ar >>> 26) | 0, Ar &= 67108863, w[0] = We, w[1] = Qe, w[2] = Qt, w[3] = Zt, w[4] = Jt, w[5] = Xt, w[6] = kt, w[7] = ar, w[8] = lr, w[9] = or, w[10] = dr, w[11] = pr, w[12] = fr, w[13] = ur, w[14] = hr, w[15] = qt, w[16] = Er, w[17] = Ir, w[18] = Ar, _ !== 0 && (w[19] = _, a.length++), a;
    };
    Math.imul || (N = A);
    function R(W, C, g) {
      g.negative = C.negative ^ W.negative, g.length = W.length + C.length;
      for (var a = 0, c = 0, p = 0; p < g.length - 1; p++) {
        var w = c;
        c = 0;
        for (var _ = a & 67108863, x = Math.min(p, C.length - 1), E = Math.max(0, p - W.length + 1); E <= x; E++) {
          var y = p - E, o = W.words[y] | 0, S = C.words[E] | 0, J = o * S, z = J & 67108863;
          w = w + (J / 67108864 | 0) | 0, z = z + _ | 0, _ = z & 67108863, w = w + (z >>> 26) | 0, c += w >>> 26, w &= 67108863;
        }
        g.words[p] = _, a = w, w = c;
      }
      return a !== 0 ? g.words[p] = a : g.length--, g.strip();
    }
    function O(W, C, g) {
      var a = new P();
      return a.mulp(W, C, g);
    }
    n.prototype.mulTo = function(C, g) {
      var a, c = this.length + C.length;
      return this.length === 10 && C.length === 10 ? a = N(this, C, g) : c < 63 ? a = A(this, C, g) : c < 1024 ? a = R(this, C, g) : a = O(this, C, g), a;
    };
    function P(W, C) {
      this.x = W, this.y = C;
    }
    P.prototype.makeRBT = function(C) {
      for (var g = new Array(C), a = n.prototype._countBits(C) - 1, c = 0; c < C; c++)
        g[c] = this.revBin(c, a, C);
      return g;
    }, P.prototype.revBin = function(C, g, a) {
      if (C === 0 || C === a - 1)
        return C;
      for (var c = 0, p = 0; p < g; p++)
        c |= (C & 1) << g - p - 1, C >>= 1;
      return c;
    }, P.prototype.permute = function(C, g, a, c, p, w) {
      for (var _ = 0; _ < w; _++)
        c[_] = g[C[_]], p[_] = a[C[_]];
    }, P.prototype.transform = function(C, g, a, c, p, w) {
      this.permute(w, C, g, a, c, p);
      for (var _ = 1; _ < p; _ <<= 1)
        for (var x = _ << 1, E = Math.cos(2 * Math.PI / x), y = Math.sin(2 * Math.PI / x), o = 0; o < p; o += x)
          for (var S = E, J = y, z = 0; z < _; z++) {
            var k = a[o + z], j = c[o + z], q = a[o + z + _], K = c[o + z + _], U = S * q - J * K;
            K = S * K + J * q, q = U, a[o + z] = k + q, c[o + z] = j + K, a[o + z + _] = k - q, c[o + z + _] = j - K, z !== x && (U = E * S - y * J, J = E * J + y * S, S = U);
          }
    }, P.prototype.guessLen13b = function(C, g) {
      var a = Math.max(g, C) | 1, c = a & 1, p = 0;
      for (a = a / 2 | 0; a; a = a >>> 1)
        p++;
      return 1 << p + 1 + c;
    }, P.prototype.conjugate = function(C, g, a) {
      if (!(a <= 1))
        for (var c = 0; c < a / 2; c++) {
          var p = C[c];
          C[c] = C[a - c - 1], C[a - c - 1] = p, p = g[c], g[c] = -g[a - c - 1], g[a - c - 1] = -p;
        }
    }, P.prototype.normalize13b = function(C, g) {
      for (var a = 0, c = 0; c < g / 2; c++) {
        var p = Math.round(C[2 * c + 1] / g) * 8192 + Math.round(C[2 * c] / g) + a;
        C[c] = p & 67108863, p < 67108864 ? a = 0 : a = p / 67108864 | 0;
      }
      return C;
    }, P.prototype.convert13b = function(C, g, a, c) {
      for (var p = 0, w = 0; w < g; w++)
        p = p + (C[w] | 0), a[2 * w] = p & 8191, p = p >>> 13, a[2 * w + 1] = p & 8191, p = p >>> 13;
      for (w = 2 * g; w < c; ++w)
        a[w] = 0;
      i(p === 0), i((p & -8192) === 0);
    }, P.prototype.stub = function(C) {
      for (var g = new Array(C), a = 0; a < C; a++)
        g[a] = 0;
      return g;
    }, P.prototype.mulp = function(C, g, a) {
      var c = 2 * this.guessLen13b(C.length, g.length), p = this.makeRBT(c), w = this.stub(c), _ = new Array(c), x = new Array(c), E = new Array(c), y = new Array(c), o = new Array(c), S = new Array(c), J = a.words;
      J.length = c, this.convert13b(C.words, C.length, _, c), this.convert13b(g.words, g.length, y, c), this.transform(_, w, x, E, c, p), this.transform(y, w, o, S, c, p);
      for (var z = 0; z < c; z++) {
        var k = x[z] * o[z] - E[z] * S[z];
        E[z] = x[z] * S[z] + E[z] * o[z], x[z] = k;
      }
      return this.conjugate(x, E, c), this.transform(x, E, J, w, c, p), this.conjugate(J, w, c), this.normalize13b(J, c), a.negative = C.negative ^ g.negative, a.length = C.length + g.length, a.strip();
    }, n.prototype.mul = function(C) {
      var g = new n(null);
      return g.words = new Array(this.length + C.length), this.mulTo(C, g);
    }, n.prototype.mulf = function(C) {
      var g = new n(null);
      return g.words = new Array(this.length + C.length), O(this, C, g);
    }, n.prototype.imul = function(C) {
      return this.clone().mulTo(C, this);
    }, n.prototype.imuln = function(C) {
      i(typeof C == "number"), i(C < 67108864);
      for (var g = 0, a = 0; a < this.length; a++) {
        var c = (this.words[a] | 0) * C, p = (c & 67108863) + (g & 67108863);
        g >>= 26, g += c / 67108864 | 0, g += p >>> 26, this.words[a] = p & 67108863;
      }
      return g !== 0 && (this.words[a] = g, this.length++), this;
    }, n.prototype.muln = function(C) {
      return this.clone().imuln(C);
    }, n.prototype.sqr = function() {
      return this.mul(this);
    }, n.prototype.isqr = function() {
      return this.imul(this.clone());
    }, n.prototype.pow = function(C) {
      var g = M(C);
      if (g.length === 0)
        return new n(1);
      for (var a = this, c = 0; c < g.length && g[c] === 0; c++, a = a.sqr())
        ;
      if (++c < g.length)
        for (var p = a.sqr(); c < g.length; c++, p = p.sqr())
          g[c] !== 0 && (a = a.mul(p));
      return a;
    }, n.prototype.iushln = function(C) {
      i(typeof C == "number" && C >= 0);
      var g = C % 26, a = (C - g) / 26, c = 67108863 >>> 26 - g << 26 - g, p;
      if (g !== 0) {
        var w = 0;
        for (p = 0; p < this.length; p++) {
          var _ = this.words[p] & c, x = (this.words[p] | 0) - _ << g;
          this.words[p] = x | w, w = _ >>> 26 - g;
        }
        w && (this.words[p] = w, this.length++);
      }
      if (a !== 0) {
        for (p = this.length - 1; p >= 0; p--)
          this.words[p + a] = this.words[p];
        for (p = 0; p < a; p++)
          this.words[p] = 0;
        this.length += a;
      }
      return this.strip();
    }, n.prototype.ishln = function(C) {
      return i(this.negative === 0), this.iushln(C);
    }, n.prototype.iushrn = function(C, g, a) {
      i(typeof C == "number" && C >= 0);
      var c;
      g ? c = (g - g % 26) / 26 : c = 0;
      var p = C % 26, w = Math.min((C - p) / 26, this.length), _ = 67108863 ^ 67108863 >>> p << p, x = a;
      if (c -= w, c = Math.max(0, c), x) {
        for (var E = 0; E < w; E++)
          x.words[E] = this.words[E];
        x.length = w;
      }
      if (w !== 0)
        if (this.length > w)
          for (this.length -= w, E = 0; E < this.length; E++)
            this.words[E] = this.words[E + w];
        else
          this.words[0] = 0, this.length = 1;
      var y = 0;
      for (E = this.length - 1; E >= 0 && (y !== 0 || E >= c); E--) {
        var o = this.words[E] | 0;
        this.words[E] = y << 26 - p | o >>> p, y = o & _;
      }
      return x && y !== 0 && (x.words[x.length++] = y), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, n.prototype.ishrn = function(C, g, a) {
      return i(this.negative === 0), this.iushrn(C, g, a);
    }, n.prototype.shln = function(C) {
      return this.clone().ishln(C);
    }, n.prototype.ushln = function(C) {
      return this.clone().iushln(C);
    }, n.prototype.shrn = function(C) {
      return this.clone().ishrn(C);
    }, n.prototype.ushrn = function(C) {
      return this.clone().iushrn(C);
    }, n.prototype.testn = function(C) {
      i(typeof C == "number" && C >= 0);
      var g = C % 26, a = (C - g) / 26, c = 1 << g;
      if (this.length <= a)
        return !1;
      var p = this.words[a];
      return !!(p & c);
    }, n.prototype.imaskn = function(C) {
      i(typeof C == "number" && C >= 0);
      var g = C % 26, a = (C - g) / 26;
      if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= a)
        return this;
      if (g !== 0 && a++, this.length = Math.min(a, this.length), g !== 0) {
        var c = 67108863 ^ 67108863 >>> g << g;
        this.words[this.length - 1] &= c;
      }
      return this.strip();
    }, n.prototype.maskn = function(C) {
      return this.clone().imaskn(C);
    }, n.prototype.iaddn = function(C) {
      return i(typeof C == "number"), i(C < 67108864), C < 0 ? this.isubn(-C) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < C ? (this.words[0] = C - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(C), this.negative = 1, this) : this._iaddn(C);
    }, n.prototype._iaddn = function(C) {
      this.words[0] += C;
      for (var g = 0; g < this.length && this.words[g] >= 67108864; g++)
        this.words[g] -= 67108864, g === this.length - 1 ? this.words[g + 1] = 1 : this.words[g + 1]++;
      return this.length = Math.max(this.length, g + 1), this;
    }, n.prototype.isubn = function(C) {
      if (i(typeof C == "number"), i(C < 67108864), C < 0)
        return this.iaddn(-C);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(C), this.negative = 1, this;
      if (this.words[0] -= C, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var g = 0; g < this.length && this.words[g] < 0; g++)
          this.words[g] += 67108864, this.words[g + 1] -= 1;
      return this.strip();
    }, n.prototype.addn = function(C) {
      return this.clone().iaddn(C);
    }, n.prototype.subn = function(C) {
      return this.clone().isubn(C);
    }, n.prototype.iabs = function() {
      return this.negative = 0, this;
    }, n.prototype.abs = function() {
      return this.clone().iabs();
    }, n.prototype._ishlnsubmul = function(C, g, a) {
      var c = C.length + a, p;
      this._expand(c);
      var w, _ = 0;
      for (p = 0; p < C.length; p++) {
        w = (this.words[p + a] | 0) + _;
        var x = (C.words[p] | 0) * g;
        w -= x & 67108863, _ = (w >> 26) - (x / 67108864 | 0), this.words[p + a] = w & 67108863;
      }
      for (; p < this.length - a; p++)
        w = (this.words[p + a] | 0) + _, _ = w >> 26, this.words[p + a] = w & 67108863;
      if (_ === 0)
        return this.strip();
      for (i(_ === -1), _ = 0, p = 0; p < this.length; p++)
        w = -(this.words[p] | 0) + _, _ = w >> 26, this.words[p] = w & 67108863;
      return this.negative = 1, this.strip();
    }, n.prototype._wordDiv = function(C, g) {
      var a = this.length - C.length, c = this.clone(), p = C, w = p.words[p.length - 1] | 0, _ = this._countBits(w);
      a = 26 - _, a !== 0 && (p = p.ushln(a), c.iushln(a), w = p.words[p.length - 1] | 0);
      var x = c.length - p.length, E;
      if (g !== "mod") {
        E = new n(null), E.length = x + 1, E.words = new Array(E.length);
        for (var y = 0; y < E.length; y++)
          E.words[y] = 0;
      }
      var o = c.clone()._ishlnsubmul(p, 1, x);
      o.negative === 0 && (c = o, E && (E.words[x] = 1));
      for (var S = x - 1; S >= 0; S--) {
        var J = (c.words[p.length + S] | 0) * 67108864 + (c.words[p.length + S - 1] | 0);
        for (J = Math.min(J / w | 0, 67108863), c._ishlnsubmul(p, J, S); c.negative !== 0; )
          J--, c.negative = 0, c._ishlnsubmul(p, 1, S), c.isZero() || (c.negative ^= 1);
        E && (E.words[S] = J);
      }
      return E && E.strip(), c.strip(), g !== "div" && a !== 0 && c.iushrn(a), {
        div: E || null,
        mod: c
      };
    }, n.prototype.divmod = function(C, g, a) {
      if (i(!C.isZero()), this.isZero())
        return {
          div: new n(0),
          mod: new n(0)
        };
      var c, p, w;
      return this.negative !== 0 && C.negative === 0 ? (w = this.neg().divmod(C, g), g !== "mod" && (c = w.div.neg()), g !== "div" && (p = w.mod.neg(), a && p.negative !== 0 && p.iadd(C)), {
        div: c,
        mod: p
      }) : this.negative === 0 && C.negative !== 0 ? (w = this.divmod(C.neg(), g), g !== "mod" && (c = w.div.neg()), {
        div: c,
        mod: w.mod
      }) : (this.negative & C.negative) !== 0 ? (w = this.neg().divmod(C.neg(), g), g !== "div" && (p = w.mod.neg(), a && p.negative !== 0 && p.isub(C)), {
        div: w.div,
        mod: p
      }) : C.length > this.length || this.cmp(C) < 0 ? {
        div: new n(0),
        mod: this
      } : C.length === 1 ? g === "div" ? {
        div: this.divn(C.words[0]),
        mod: null
      } : g === "mod" ? {
        div: null,
        mod: new n(this.modn(C.words[0]))
      } : {
        div: this.divn(C.words[0]),
        mod: new n(this.modn(C.words[0]))
      } : this._wordDiv(C, g);
    }, n.prototype.div = function(C) {
      return this.divmod(C, "div", !1).div;
    }, n.prototype.mod = function(C) {
      return this.divmod(C, "mod", !1).mod;
    }, n.prototype.umod = function(C) {
      return this.divmod(C, "mod", !0).mod;
    }, n.prototype.divRound = function(C) {
      var g = this.divmod(C);
      if (g.mod.isZero())
        return g.div;
      var a = g.div.negative !== 0 ? g.mod.isub(C) : g.mod, c = C.ushrn(1), p = C.andln(1), w = a.cmp(c);
      return w < 0 || p === 1 && w === 0 ? g.div : g.div.negative !== 0 ? g.div.isubn(1) : g.div.iaddn(1);
    }, n.prototype.modn = function(C) {
      i(C <= 67108863);
      for (var g = (1 << 26) % C, a = 0, c = this.length - 1; c >= 0; c--)
        a = (g * a + (this.words[c] | 0)) % C;
      return a;
    }, n.prototype.idivn = function(C) {
      i(C <= 67108863);
      for (var g = 0, a = this.length - 1; a >= 0; a--) {
        var c = (this.words[a] | 0) + g * 67108864;
        this.words[a] = c / C | 0, g = c % C;
      }
      return this.strip();
    }, n.prototype.divn = function(C) {
      return this.clone().idivn(C);
    }, n.prototype.egcd = function(C) {
      i(C.negative === 0), i(!C.isZero());
      var g = this, a = C.clone();
      g.negative !== 0 ? g = g.umod(C) : g = g.clone();
      for (var c = new n(1), p = new n(0), w = new n(0), _ = new n(1), x = 0; g.isEven() && a.isEven(); )
        g.iushrn(1), a.iushrn(1), ++x;
      for (var E = a.clone(), y = g.clone(); !g.isZero(); ) {
        for (var o = 0, S = 1; (g.words[0] & S) === 0 && o < 26; ++o, S <<= 1)
          ;
        if (o > 0)
          for (g.iushrn(o); o-- > 0; )
            (c.isOdd() || p.isOdd()) && (c.iadd(E), p.isub(y)), c.iushrn(1), p.iushrn(1);
        for (var J = 0, z = 1; (a.words[0] & z) === 0 && J < 26; ++J, z <<= 1)
          ;
        if (J > 0)
          for (a.iushrn(J); J-- > 0; )
            (w.isOdd() || _.isOdd()) && (w.iadd(E), _.isub(y)), w.iushrn(1), _.iushrn(1);
        g.cmp(a) >= 0 ? (g.isub(a), c.isub(w), p.isub(_)) : (a.isub(g), w.isub(c), _.isub(p));
      }
      return {
        a: w,
        b: _,
        gcd: a.iushln(x)
      };
    }, n.prototype._invmp = function(C) {
      i(C.negative === 0), i(!C.isZero());
      var g = this, a = C.clone();
      g.negative !== 0 ? g = g.umod(C) : g = g.clone();
      for (var c = new n(1), p = new n(0), w = a.clone(); g.cmpn(1) > 0 && a.cmpn(1) > 0; ) {
        for (var _ = 0, x = 1; (g.words[0] & x) === 0 && _ < 26; ++_, x <<= 1)
          ;
        if (_ > 0)
          for (g.iushrn(_); _-- > 0; )
            c.isOdd() && c.iadd(w), c.iushrn(1);
        for (var E = 0, y = 1; (a.words[0] & y) === 0 && E < 26; ++E, y <<= 1)
          ;
        if (E > 0)
          for (a.iushrn(E); E-- > 0; )
            p.isOdd() && p.iadd(w), p.iushrn(1);
        g.cmp(a) >= 0 ? (g.isub(a), c.isub(p)) : (a.isub(g), p.isub(c));
      }
      var o;
      return g.cmpn(1) === 0 ? o = c : o = p, o.cmpn(0) < 0 && o.iadd(C), o;
    }, n.prototype.gcd = function(C) {
      if (this.isZero())
        return C.abs();
      if (C.isZero())
        return this.abs();
      var g = this.clone(), a = C.clone();
      g.negative = 0, a.negative = 0;
      for (var c = 0; g.isEven() && a.isEven(); c++)
        g.iushrn(1), a.iushrn(1);
      do {
        for (; g.isEven(); )
          g.iushrn(1);
        for (; a.isEven(); )
          a.iushrn(1);
        var p = g.cmp(a);
        if (p < 0) {
          var w = g;
          g = a, a = w;
        } else if (p === 0 || a.cmpn(1) === 0)
          break;
        g.isub(a);
      } while (!0);
      return a.iushln(c);
    }, n.prototype.invm = function(C) {
      return this.egcd(C).a.umod(C);
    }, n.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, n.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, n.prototype.andln = function(C) {
      return this.words[0] & C;
    }, n.prototype.bincn = function(C) {
      i(typeof C == "number");
      var g = C % 26, a = (C - g) / 26, c = 1 << g;
      if (this.length <= a)
        return this._expand(a + 1), this.words[a] |= c, this;
      for (var p = c, w = a; p !== 0 && w < this.length; w++) {
        var _ = this.words[w] | 0;
        _ += p, p = _ >>> 26, _ &= 67108863, this.words[w] = _;
      }
      return p !== 0 && (this.words[w] = p, this.length++), this;
    }, n.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, n.prototype.cmpn = function(C) {
      var g = C < 0;
      if (this.negative !== 0 && !g)
        return -1;
      if (this.negative === 0 && g)
        return 1;
      this.strip();
      var a;
      if (this.length > 1)
        a = 1;
      else {
        g && (C = -C), i(C <= 67108863, "Number is too big");
        var c = this.words[0] | 0;
        a = c === C ? 0 : c < C ? -1 : 1;
      }
      return this.negative !== 0 ? -a | 0 : a;
    }, n.prototype.cmp = function(C) {
      if (this.negative !== 0 && C.negative === 0)
        return -1;
      if (this.negative === 0 && C.negative !== 0)
        return 1;
      var g = this.ucmp(C);
      return this.negative !== 0 ? -g | 0 : g;
    }, n.prototype.ucmp = function(C) {
      if (this.length > C.length)
        return 1;
      if (this.length < C.length)
        return -1;
      for (var g = 0, a = this.length - 1; a >= 0; a--) {
        var c = this.words[a] | 0, p = C.words[a] | 0;
        if (c !== p) {
          c < p ? g = -1 : c > p && (g = 1);
          break;
        }
      }
      return g;
    }, n.prototype.gtn = function(C) {
      return this.cmpn(C) === 1;
    }, n.prototype.gt = function(C) {
      return this.cmp(C) === 1;
    }, n.prototype.gten = function(C) {
      return this.cmpn(C) >= 0;
    }, n.prototype.gte = function(C) {
      return this.cmp(C) >= 0;
    }, n.prototype.ltn = function(C) {
      return this.cmpn(C) === -1;
    }, n.prototype.lt = function(C) {
      return this.cmp(C) === -1;
    }, n.prototype.lten = function(C) {
      return this.cmpn(C) <= 0;
    }, n.prototype.lte = function(C) {
      return this.cmp(C) <= 0;
    }, n.prototype.eqn = function(C) {
      return this.cmpn(C) === 0;
    }, n.prototype.eq = function(C) {
      return this.cmp(C) === 0;
    }, n.red = function(C) {
      return new ae(C);
    }, n.prototype.toRed = function(C) {
      return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), C.convertTo(this)._forceRed(C);
    }, n.prototype.fromRed = function() {
      return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, n.prototype._forceRed = function(C) {
      return this.red = C, this;
    }, n.prototype.forceRed = function(C) {
      return i(!this.red, "Already a number in reduction context"), this._forceRed(C);
    }, n.prototype.redAdd = function(C) {
      return i(this.red, "redAdd works only with red numbers"), this.red.add(this, C);
    }, n.prototype.redIAdd = function(C) {
      return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, C);
    }, n.prototype.redSub = function(C) {
      return i(this.red, "redSub works only with red numbers"), this.red.sub(this, C);
    }, n.prototype.redISub = function(C) {
      return i(this.red, "redISub works only with red numbers"), this.red.isub(this, C);
    }, n.prototype.redShl = function(C) {
      return i(this.red, "redShl works only with red numbers"), this.red.shl(this, C);
    }, n.prototype.redMul = function(C) {
      return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, C), this.red.mul(this, C);
    }, n.prototype.redIMul = function(C) {
      return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, C), this.red.imul(this, C);
    }, n.prototype.redSqr = function() {
      return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, n.prototype.redISqr = function() {
      return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, n.prototype.redSqrt = function() {
      return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, n.prototype.redInvm = function() {
      return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, n.prototype.redNeg = function() {
      return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, n.prototype.redPow = function(C) {
      return i(this.red && !C.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, C);
    };
    var F = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function H(W, C) {
      this.name = W, this.p = new n(C, 16), this.n = this.p.bitLength(), this.k = new n(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    H.prototype._tmp = function() {
      var C = new n(null);
      return C.words = new Array(Math.ceil(this.n / 13)), C;
    }, H.prototype.ireduce = function(C) {
      var g = C, a;
      do
        this.split(g, this.tmp), g = this.imulK(g), g = g.iadd(this.tmp), a = g.bitLength();
      while (a > this.n);
      var c = a < this.n ? -1 : g.ucmp(this.p);
      return c === 0 ? (g.words[0] = 0, g.length = 1) : c > 0 ? g.isub(this.p) : g.strip !== void 0 ? g.strip() : g._strip(), g;
    }, H.prototype.split = function(C, g) {
      C.iushrn(this.n, 0, g);
    }, H.prototype.imulK = function(C) {
      return C.imul(this.k);
    };
    function Q() {
      H.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    s(Q, H), Q.prototype.split = function(C, g) {
      for (var a = 4194303, c = Math.min(C.length, 9), p = 0; p < c; p++)
        g.words[p] = C.words[p];
      if (g.length = c, C.length <= 9) {
        C.words[0] = 0, C.length = 1;
        return;
      }
      var w = C.words[9];
      for (g.words[g.length++] = w & a, p = 10; p < C.length; p++) {
        var _ = C.words[p] | 0;
        C.words[p - 10] = (_ & a) << 4 | w >>> 22, w = _;
      }
      w >>>= 22, C.words[p - 10] = w, w === 0 && C.length > 10 ? C.length -= 10 : C.length -= 9;
    }, Q.prototype.imulK = function(C) {
      C.words[C.length] = 0, C.words[C.length + 1] = 0, C.length += 2;
      for (var g = 0, a = 0; a < C.length; a++) {
        var c = C.words[a] | 0;
        g += c * 977, C.words[a] = g & 67108863, g = c * 64 + (g / 67108864 | 0);
      }
      return C.words[C.length - 1] === 0 && (C.length--, C.words[C.length - 1] === 0 && C.length--), C;
    };
    function Z() {
      H.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    s(Z, H);
    function B() {
      H.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    s(B, H);
    function Y() {
      H.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    s(Y, H), Y.prototype.imulK = function(C) {
      for (var g = 0, a = 0; a < C.length; a++) {
        var c = (C.words[a] | 0) * 19 + g, p = c & 67108863;
        c >>>= 26, C.words[a] = p, g = c;
      }
      return g !== 0 && (C.words[C.length++] = g), C;
    }, n._prime = function(C) {
      if (F[C])
        return F[C];
      var g;
      if (C === "k256")
        g = new Q();
      else if (C === "p224")
        g = new Z();
      else if (C === "p192")
        g = new B();
      else if (C === "p25519")
        g = new Y();
      else
        throw new Error("Unknown prime " + C);
      return F[C] = g, g;
    };
    function ae(W) {
      if (typeof W == "string") {
        var C = n._prime(W);
        this.m = C.p, this.prime = C;
      } else
        i(W.gtn(1), "modulus must be greater than 1"), this.m = W, this.prime = null;
    }
    ae.prototype._verify1 = function(C) {
      i(C.negative === 0, "red works only with positives"), i(C.red, "red works only with red numbers");
    }, ae.prototype._verify2 = function(C, g) {
      i((C.negative | g.negative) === 0, "red works only with positives"), i(
        C.red && C.red === g.red,
        "red works only with red numbers"
      );
    }, ae.prototype.imod = function(C) {
      return this.prime ? this.prime.ireduce(C)._forceRed(this) : C.umod(this.m)._forceRed(this);
    }, ae.prototype.neg = function(C) {
      return C.isZero() ? C.clone() : this.m.sub(C)._forceRed(this);
    }, ae.prototype.add = function(C, g) {
      this._verify2(C, g);
      var a = C.add(g);
      return a.cmp(this.m) >= 0 && a.isub(this.m), a._forceRed(this);
    }, ae.prototype.iadd = function(C, g) {
      this._verify2(C, g);
      var a = C.iadd(g);
      return a.cmp(this.m) >= 0 && a.isub(this.m), a;
    }, ae.prototype.sub = function(C, g) {
      this._verify2(C, g);
      var a = C.sub(g);
      return a.cmpn(0) < 0 && a.iadd(this.m), a._forceRed(this);
    }, ae.prototype.isub = function(C, g) {
      this._verify2(C, g);
      var a = C.isub(g);
      return a.cmpn(0) < 0 && a.iadd(this.m), a;
    }, ae.prototype.shl = function(C, g) {
      return this._verify1(C), this.imod(C.ushln(g));
    }, ae.prototype.imul = function(C, g) {
      return this._verify2(C, g), this.imod(C.imul(g));
    }, ae.prototype.mul = function(C, g) {
      return this._verify2(C, g), this.imod(C.mul(g));
    }, ae.prototype.isqr = function(C) {
      return this.imul(C, C.clone());
    }, ae.prototype.sqr = function(C) {
      return this.mul(C, C);
    }, ae.prototype.sqrt = function(C) {
      if (C.isZero())
        return C.clone();
      var g = this.m.andln(3);
      if (i(g % 2 === 1), g === 3) {
        var a = this.m.add(new n(1)).iushrn(2);
        return this.pow(C, a);
      }
      for (var c = this.m.subn(1), p = 0; !c.isZero() && c.andln(1) === 0; )
        p++, c.iushrn(1);
      i(!c.isZero());
      var w = new n(1).toRed(this), _ = w.redNeg(), x = this.m.subn(1).iushrn(1), E = this.m.bitLength();
      for (E = new n(2 * E * E).toRed(this); this.pow(E, x).cmp(_) !== 0; )
        E.redIAdd(_);
      for (var y = this.pow(E, c), o = this.pow(C, c.addn(1).iushrn(1)), S = this.pow(C, c), J = p; S.cmp(w) !== 0; ) {
        for (var z = S, k = 0; z.cmp(w) !== 0; k++)
          z = z.redSqr();
        i(k < J);
        var j = this.pow(y, new n(1).iushln(J - k - 1));
        o = o.redMul(j), y = j.redSqr(), S = S.redMul(y), J = k;
      }
      return o;
    }, ae.prototype.invm = function(C) {
      var g = C._invmp(this.m);
      return g.negative !== 0 ? (g.negative = 0, this.imod(g).redNeg()) : this.imod(g);
    }, ae.prototype.pow = function(C, g) {
      if (g.isZero())
        return new n(1).toRed(this);
      if (g.cmpn(1) === 0)
        return C.clone();
      var a = 4, c = new Array(1 << a);
      c[0] = new n(1).toRed(this), c[1] = C;
      for (var p = 2; p < c.length; p++)
        c[p] = this.mul(c[p - 1], C);
      var w = c[0], _ = 0, x = 0, E = g.bitLength() % 26;
      for (E === 0 && (E = 26), p = g.length - 1; p >= 0; p--) {
        for (var y = g.words[p], o = E - 1; o >= 0; o--) {
          var S = y >> o & 1;
          if (w !== c[0] && (w = this.sqr(w)), S === 0 && _ === 0) {
            x = 0;
            continue;
          }
          _ <<= 1, _ |= S, x++, !(x !== a && (p !== 0 || o !== 0)) && (w = this.mul(w, c[_]), x = 0, _ = 0);
        }
        E = 26;
      }
      return w;
    }, ae.prototype.convertTo = function(C) {
      var g = C.umod(this.m);
      return g === C ? g.clone() : g;
    }, ae.prototype.convertFrom = function(C) {
      var g = C.clone();
      return g.red = null, g;
    }, n.mont = function(C) {
      return new se(C);
    };
    function se(W) {
      ae.call(this, W), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new n(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    s(se, ae), se.prototype.convertTo = function(C) {
      return this.imod(C.ushln(this.shift));
    }, se.prototype.convertFrom = function(C) {
      var g = this.imod(C.mul(this.rinv));
      return g.red = null, g;
    }, se.prototype.imul = function(C, g) {
      if (C.isZero() || g.isZero())
        return C.words[0] = 0, C.length = 1, C;
      var a = C.imul(g), c = a.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), p = a.isub(c).iushrn(this.shift), w = p;
      return p.cmp(this.m) >= 0 ? w = p.isub(this.m) : p.cmpn(0) < 0 && (w = p.iadd(this.m)), w._forceRed(this);
    }, se.prototype.mul = function(C, g) {
      if (C.isZero() || g.isZero())
        return new n(0)._forceRed(this);
      var a = C.mul(g), c = a.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), p = a.isub(c).iushrn(this.shift), w = p;
      return p.cmp(this.m) >= 0 ? w = p.isub(this.m) : p.cmpn(0) < 0 && (w = p.iadd(this.m)), w._forceRed(this);
    }, se.prototype.invm = function(C) {
      var g = this.imod(C._invmp(this.m).mul(this.r2));
      return g._forceRed(this);
    };
  })(t, nt);
})(Sr);
var Ld = { exports: {} }, gM;
function el() {
  if (gM)
    return Ld.exports;
  gM = 1;
  var t;
  Ld.exports = function(s) {
    return t || (t = new e(null)), t.generate(s);
  };
  function e(i) {
    this.rand = i;
  }
  if (Ld.exports.Rand = e, e.prototype.generate = function(s) {
    return this._rand(s);
  }, e.prototype._rand = function(s) {
    if (this.rand.getBytes)
      return this.rand.getBytes(s);
    for (var n = new Uint8Array(s), f = 0; f < n.length; f++)
      n[f] = this.rand.getByte();
    return n;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? e.prototype._rand = function(s) {
      var n = new Uint8Array(s);
      return self.crypto.getRandomValues(n), n;
    } : self.msCrypto && self.msCrypto.getRandomValues ? e.prototype._rand = function(s) {
      var n = new Uint8Array(s);
      return self.msCrypto.getRandomValues(n), n;
    } : typeof window == "object" && (e.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var r = jA();
      if (typeof r.randomBytes != "function")
        throw new Error("Not supported");
      e.prototype._rand = function(s) {
        return r.randomBytes(s);
      };
    } catch {
    }
  return Ld.exports;
}
var _b, bM;
function gA() {
  if (bM)
    return _b;
  bM = 1;
  var t = Sr.exports, e = el();
  function r(i) {
    this.rand = i || new e.Rand();
  }
  return _b = r, r.create = function(s) {
    return new r(s);
  }, r.prototype._randbelow = function(s) {
    var n = s.bitLength(), f = Math.ceil(n / 8);
    do
      var u = new t(this.rand.generate(f));
    while (u.cmp(s) >= 0);
    return u;
  }, r.prototype._randrange = function(s, n) {
    var f = n.sub(s);
    return s.add(this._randbelow(f));
  }, r.prototype.test = function(s, n, f) {
    var u = s.bitLength(), h = t.mont(s), d = new t(1).toRed(h);
    n || (n = Math.max(1, u / 48 | 0));
    for (var l = s.subn(1), m = 0; !l.testn(m); m++)
      ;
    for (var b = s.shrn(m), M = l.toRed(h), A = !0; n > 0; n--) {
      var N = this._randrange(new t(2), l);
      f && f(N);
      var R = N.toRed(h).redPow(b);
      if (!(R.cmp(d) === 0 || R.cmp(M) === 0)) {
        for (var O = 1; O < m; O++) {
          if (R = R.redSqr(), R.cmp(d) === 0)
            return !1;
          if (R.cmp(M) === 0)
            break;
        }
        if (O === m)
          return !1;
      }
    }
    return A;
  }, r.prototype.getDivisor = function(s, n) {
    var f = s.bitLength(), u = t.mont(s), h = new t(1).toRed(u);
    n || (n = Math.max(1, f / 48 | 0));
    for (var d = s.subn(1), l = 0; !d.testn(l); l++)
      ;
    for (var m = s.shrn(l), b = d.toRed(u); n > 0; n--) {
      var M = this._randrange(new t(2), d), A = s.gcd(M);
      if (A.cmpn(1) !== 0)
        return A;
      var N = M.toRed(u).redPow(m);
      if (!(N.cmp(h) === 0 || N.cmp(b) === 0)) {
        for (var R = 1; R < l; R++) {
          if (N = N.redSqr(), N.cmp(h) === 0)
            return N.fromRed().subn(1).gcd(s);
          if (N.cmp(b) === 0)
            break;
        }
        if (R === l)
          return N = N.redSqr(), N.fromRed().subn(1).gcd(s);
      }
    }
    return !1;
  }, _b;
}
var Mb, yM;
function bA() {
  if (yM)
    return Mb;
  yM = 1;
  var t = Jc();
  Mb = R, R.simpleSieve = A, R.fermatTest = N;
  var e = Sr.exports, r = new e(24), i = gA(), s = new i(), n = new e(1), f = new e(2), u = new e(5);
  new e(16), new e(8);
  var h = new e(10), d = new e(3);
  new e(7);
  var l = new e(11), m = new e(4);
  new e(12);
  var b = null;
  function M() {
    if (b !== null)
      return b;
    var O = 1048576, P = [];
    P[0] = 2;
    for (var F = 1, H = 3; H < O; H += 2) {
      for (var Q = Math.ceil(Math.sqrt(H)), Z = 0; Z < F && P[Z] <= Q && H % P[Z] !== 0; Z++)
        ;
      F !== Z && P[Z] <= Q || (P[F++] = H);
    }
    return b = P, P;
  }
  function A(O) {
    for (var P = M(), F = 0; F < P.length; F++)
      if (O.modn(P[F]) === 0)
        return O.cmpn(P[F]) === 0;
    return !0;
  }
  function N(O) {
    var P = e.mont(O);
    return f.toRed(P).redPow(O.subn(1)).fromRed().cmpn(1) === 0;
  }
  function R(O, P) {
    if (O < 16)
      return P === 2 || P === 5 ? new e([140, 123]) : new e([140, 39]);
    P = new e(P);
    for (var F, H; ; ) {
      for (F = new e(t(Math.ceil(O / 8))); F.bitLength() > O; )
        F.ishrn(1);
      if (F.isEven() && F.iadd(n), F.testn(1) || F.iadd(f), P.cmp(f)) {
        if (!P.cmp(u))
          for (; F.mod(h).cmp(d); )
            F.iadd(m);
      } else
        for (; F.mod(r).cmp(l); )
          F.iadd(m);
      if (H = F.shrn(1), A(H) && A(F) && N(H) && N(F) && s.test(H) && s.test(F))
        return F;
    }
  }
  return Mb;
}
const Lte = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
}, Pte = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
}, kte = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
}, jte = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
}, Bte = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
}, zte = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
}, Ute = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
}, Fte = {
  gen: "02",
  prime: "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"
}, $te = {
  modp1: Lte,
  modp2: Pte,
  modp5: kte,
  modp14: jte,
  modp15: Bte,
  modp16: zte,
  modp17: Ute,
  modp18: Fte
};
var xb, mM;
function qte() {
  if (mM)
    return xb;
  mM = 1;
  var t = Sr.exports, e = gA(), r = new e(), i = new t(24), s = new t(11), n = new t(10), f = new t(3), u = new t(7), h = bA(), d = Jc();
  xb = A;
  function l(R, O) {
    return O = O || "utf8", Buffer.isBuffer(R) || (R = new Buffer(R, O)), this._pub = new t(R), this;
  }
  function m(R, O) {
    return O = O || "utf8", Buffer.isBuffer(R) || (R = new Buffer(R, O)), this._priv = new t(R), this;
  }
  var b = {};
  function M(R, O) {
    var P = O.toString("hex"), F = [P, R.toString(16)].join("_");
    if (F in b)
      return b[F];
    var H = 0;
    if (R.isEven() || !h.simpleSieve || !h.fermatTest(R) || !r.test(R))
      return H += 1, P === "02" || P === "05" ? H += 8 : H += 4, b[F] = H, H;
    r.test(R.shrn(1)) || (H += 2);
    var Q;
    switch (P) {
      case "02":
        R.mod(i).cmp(s) && (H += 8);
        break;
      case "05":
        Q = R.mod(n), Q.cmp(f) && Q.cmp(u) && (H += 8);
        break;
      default:
        H += 4;
    }
    return b[F] = H, H;
  }
  function A(R, O, P) {
    this.setGenerator(O), this.__prime = new t(R), this._prime = t.mont(this.__prime), this._primeLen = R.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, P ? (this.setPublicKey = l, this.setPrivateKey = m) : this._primeCode = 8;
  }
  Object.defineProperty(A.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = M(this.__prime, this.__gen)), this._primeCode;
    }
  }), A.prototype.generateKeys = function() {
    return this._priv || (this._priv = new t(d(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, A.prototype.computeSecret = function(R) {
    R = new t(R), R = R.toRed(this._prime);
    var O = R.redPow(this._priv).fromRed(), P = new Buffer(O.toArray()), F = this.getPrime();
    if (P.length < F.length) {
      var H = new Buffer(F.length - P.length);
      H.fill(0), P = Buffer.concat([H, P]);
    }
    return P;
  }, A.prototype.getPublicKey = function(O) {
    return N(this._pub, O);
  }, A.prototype.getPrivateKey = function(O) {
    return N(this._priv, O);
  }, A.prototype.getPrime = function(R) {
    return N(this.__prime, R);
  }, A.prototype.getGenerator = function(R) {
    return N(this._gen, R);
  }, A.prototype.setGenerator = function(R, O) {
    return O = O || "utf8", Buffer.isBuffer(R) || (R = new Buffer(R, O)), this.__gen = R, this._gen = new t(R), this;
  };
  function N(R, O) {
    var P = new Buffer(R.toArray());
    return O ? P.toString(O) : P;
  }
  return xb;
}
var wM;
function Hte() {
  if (wM)
    return Bo;
  wM = 1;
  var t = bA(), e = $te, r = qte();
  function i(f) {
    var u = new Buffer(e[f].prime, "hex"), h = new Buffer(e[f].gen, "hex");
    return new r(u, h);
  }
  var s = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function n(f, u, h, d) {
    return Buffer.isBuffer(u) || s[u] === void 0 ? n(f, "binary", u, h) : (u = u || "binary", d = d || "binary", h = h || new Buffer([2]), Buffer.isBuffer(h) || (h = new Buffer(h, d)), typeof f == "number" ? new r(t(f, h), h, !0) : (Buffer.isBuffer(f) || (f = new Buffer(f, u)), new r(f, h, !0)));
  }
  return Bo.DiffieHellmanGroup = Bo.createDiffieHellmanGroup = Bo.getDiffieHellman = i, Bo.createDiffieHellman = Bo.DiffieHellman = n, Bo;
}
var Pd = { exports: {} }, Sb, _M;
function yA() {
  return _M || (_M = 1, Sb = Pr.exports.EventEmitter), Sb;
}
var Eb, MM;
function Wte() {
  if (MM)
    return Eb;
  MM = 1;
  function t(b, M) {
    var A = Object.keys(b);
    if (Object.getOwnPropertySymbols) {
      var N = Object.getOwnPropertySymbols(b);
      M && (N = N.filter(function(R) {
        return Object.getOwnPropertyDescriptor(b, R).enumerable;
      })), A.push.apply(A, N);
    }
    return A;
  }
  function e(b) {
    for (var M = 1; M < arguments.length; M++) {
      var A = arguments[M] != null ? arguments[M] : {};
      M % 2 ? t(Object(A), !0).forEach(function(N) {
        r(b, N, A[N]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(b, Object.getOwnPropertyDescriptors(A)) : t(Object(A)).forEach(function(N) {
        Object.defineProperty(b, N, Object.getOwnPropertyDescriptor(A, N));
      });
    }
    return b;
  }
  function r(b, M, A) {
    return M in b ? Object.defineProperty(b, M, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : b[M] = A, b;
  }
  function i(b, M) {
    if (!(b instanceof M))
      throw new TypeError("Cannot call a class as a function");
  }
  function s(b, M) {
    for (var A = 0; A < M.length; A++) {
      var N = M[A];
      N.enumerable = N.enumerable || !1, N.configurable = !0, "value" in N && (N.writable = !0), Object.defineProperty(b, N.key, N);
    }
  }
  function n(b, M, A) {
    return M && s(b.prototype, M), A && s(b, A), b;
  }
  var f = Tn, u = f.Buffer, h = dn, d = h.inspect, l = d && d.custom || "inspect";
  function m(b, M, A) {
    u.prototype.copy.call(b, M, A);
  }
  return Eb = /* @__PURE__ */ function() {
    function b() {
      i(this, b), this.head = null, this.tail = null, this.length = 0;
    }
    return n(b, [{
      key: "push",
      value: function(A) {
        var N = {
          data: A,
          next: null
        };
        this.length > 0 ? this.tail.next = N : this.head = N, this.tail = N, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(A) {
        var N = {
          data: A,
          next: this.head
        };
        this.length === 0 && (this.tail = N), this.head = N, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var A = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, A;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(A) {
        if (this.length === 0)
          return "";
        for (var N = this.head, R = "" + N.data; N = N.next; )
          R += A + N.data;
        return R;
      }
    }, {
      key: "concat",
      value: function(A) {
        if (this.length === 0)
          return u.alloc(0);
        for (var N = u.allocUnsafe(A >>> 0), R = this.head, O = 0; R; )
          m(R.data, N, O), O += R.data.length, R = R.next;
        return N;
      }
    }, {
      key: "consume",
      value: function(A, N) {
        var R;
        return A < this.head.data.length ? (R = this.head.data.slice(0, A), this.head.data = this.head.data.slice(A)) : A === this.head.data.length ? R = this.shift() : R = N ? this._getString(A) : this._getBuffer(A), R;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
    }, {
      key: "_getString",
      value: function(A) {
        var N = this.head, R = 1, O = N.data;
        for (A -= O.length; N = N.next; ) {
          var P = N.data, F = A > P.length ? P.length : A;
          if (F === P.length ? O += P : O += P.slice(0, A), A -= F, A === 0) {
            F === P.length ? (++R, N.next ? this.head = N.next : this.head = this.tail = null) : (this.head = N, N.data = P.slice(F));
            break;
          }
          ++R;
        }
        return this.length -= R, O;
      }
    }, {
      key: "_getBuffer",
      value: function(A) {
        var N = u.allocUnsafe(A), R = this.head, O = 1;
        for (R.data.copy(N), A -= R.data.length; R = R.next; ) {
          var P = R.data, F = A > P.length ? P.length : A;
          if (P.copy(N, N.length - A, 0, F), A -= F, A === 0) {
            F === P.length ? (++O, R.next ? this.head = R.next : this.head = this.tail = null) : (this.head = R, R.data = P.slice(F));
            break;
          }
          ++O;
        }
        return this.length -= O, N;
      }
    }, {
      key: l,
      value: function(A, N) {
        return d(this, e({}, N, {
          depth: 0,
          customInspect: !1
        }));
      }
    }]), b;
  }(), Eb;
}
var Ib, xM;
function mA() {
  if (xM)
    return Ib;
  xM = 1;
  function t(f, u) {
    var h = this, d = this._readableState && this._readableState.destroyed, l = this._writableState && this._writableState.destroyed;
    return d || l ? (u ? u(f) : f && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process.nextTick(s, this, f)) : process.nextTick(s, this, f)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(f || null, function(m) {
      !u && m ? h._writableState ? h._writableState.errorEmitted ? process.nextTick(r, h) : (h._writableState.errorEmitted = !0, process.nextTick(e, h, m)) : process.nextTick(e, h, m) : u ? (process.nextTick(r, h), u(m)) : process.nextTick(r, h);
    }), this);
  }
  function e(f, u) {
    s(f, u), r(f);
  }
  function r(f) {
    f._writableState && !f._writableState.emitClose || f._readableState && !f._readableState.emitClose || f.emit("close");
  }
  function i() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function s(f, u) {
    f.emit("error", u);
  }
  function n(f, u) {
    var h = f._readableState, d = f._writableState;
    h && h.autoDestroy || d && d.autoDestroy ? f.destroy(u) : f.emit("error", u);
  }
  return Ib = {
    destroy: t,
    undestroy: i,
    errorOrDestroy: n
  }, Ib;
}
var Ab = {}, SM;
function eu() {
  if (SM)
    return Ab;
  SM = 1;
  function t(u, h) {
    u.prototype = Object.create(h.prototype), u.prototype.constructor = u, u.__proto__ = h;
  }
  var e = {};
  function r(u, h, d) {
    d || (d = Error);
    function l(b, M, A) {
      return typeof h == "string" ? h : h(b, M, A);
    }
    var m = /* @__PURE__ */ function(b) {
      t(M, b);
      function M(A, N, R) {
        return b.call(this, l(A, N, R)) || this;
      }
      return M;
    }(d);
    m.prototype.name = d.name, m.prototype.code = u, e[u] = m;
  }
  function i(u, h) {
    if (Array.isArray(u)) {
      var d = u.length;
      return u = u.map(function(l) {
        return String(l);
      }), d > 2 ? "one of ".concat(h, " ").concat(u.slice(0, d - 1).join(", "), ", or ") + u[d - 1] : d === 2 ? "one of ".concat(h, " ").concat(u[0], " or ").concat(u[1]) : "of ".concat(h, " ").concat(u[0]);
    } else
      return "of ".concat(h, " ").concat(String(u));
  }
  function s(u, h, d) {
    return u.substr(!d || d < 0 ? 0 : +d, h.length) === h;
  }
  function n(u, h, d) {
    return (d === void 0 || d > u.length) && (d = u.length), u.substring(d - h.length, d) === h;
  }
  function f(u, h, d) {
    return typeof d != "number" && (d = 0), d + h.length > u.length ? !1 : u.indexOf(h, d) !== -1;
  }
  return r("ERR_INVALID_OPT_VALUE", function(u, h) {
    return 'The value "' + h + '" is invalid for option "' + u + '"';
  }, TypeError), r("ERR_INVALID_ARG_TYPE", function(u, h, d) {
    var l;
    typeof h == "string" && s(h, "not ") ? (l = "must not be", h = h.replace(/^not /, "")) : l = "must be";
    var m;
    if (n(u, " argument"))
      m = "The ".concat(u, " ").concat(l, " ").concat(i(h, "type"));
    else {
      var b = f(u, ".") ? "property" : "argument";
      m = 'The "'.concat(u, '" ').concat(b, " ").concat(l, " ").concat(i(h, "type"));
    }
    return m += ". Received type ".concat(typeof d), m;
  }, TypeError), r("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), r("ERR_METHOD_NOT_IMPLEMENTED", function(u) {
    return "The " + u + " method is not implemented";
  }), r("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), r("ERR_STREAM_DESTROYED", function(u) {
    return "Cannot call " + u + " after a stream was destroyed";
  }), r("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), r("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), r("ERR_STREAM_WRITE_AFTER_END", "write after end"), r("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), r("ERR_UNKNOWN_ENCODING", function(u) {
    return "Unknown encoding: " + u;
  }, TypeError), r("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), Ab.codes = e, Ab;
}
var Tb, EM;
function wA() {
  if (EM)
    return Tb;
  EM = 1;
  var t = eu().codes.ERR_INVALID_OPT_VALUE;
  function e(i, s, n) {
    return i.highWaterMark != null ? i.highWaterMark : s ? i[n] : null;
  }
  function r(i, s, n, f) {
    var u = e(s, f, n);
    if (u != null) {
      if (!(isFinite(u) && Math.floor(u) === u) || u < 0) {
        var h = f ? n : "highWaterMark";
        throw new t(h, u);
      }
      return Math.floor(u);
    }
    return i.objectMode ? 16 : 16 * 1024;
  }
  return Tb = {
    getHighWaterMark: r
  }, Tb;
}
var Nb, IM;
function _A() {
  if (IM)
    return Nb;
  IM = 1, Nb = Y;
  function t(k) {
    var j = this;
    this.next = null, this.entry = null, this.finish = function() {
      z(j, k);
    };
  }
  var e;
  Y.WritableState = Z;
  var r = {
    deprecate: x2()
  }, i = yA(), s = Tn.Buffer, n = nt.Uint8Array || function() {
  };
  function f(k) {
    return s.from(k);
  }
  function u(k) {
    return s.isBuffer(k) || k instanceof n;
  }
  var h = mA(), d = wA(), l = d.getHighWaterMark, m = eu().codes, b = m.ERR_INVALID_ARG_TYPE, M = m.ERR_METHOD_NOT_IMPLEMENTED, A = m.ERR_MULTIPLE_CALLBACK, N = m.ERR_STREAM_CANNOT_PIPE, R = m.ERR_STREAM_DESTROYED, O = m.ERR_STREAM_NULL_VALUES, P = m.ERR_STREAM_WRITE_AFTER_END, F = m.ERR_UNKNOWN_ENCODING, H = h.errorOrDestroy;
  It.exports(Y, i);
  function Q() {
  }
  function Z(k, j, q) {
    e = e || Lc(), k = k || {}, typeof q != "boolean" && (q = j instanceof e), this.objectMode = !!k.objectMode, q && (this.objectMode = this.objectMode || !!k.writableObjectMode), this.highWaterMark = l(this, k, "writableHighWaterMark", q), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var K = k.decodeStrings === !1;
    this.decodeStrings = !K, this.defaultEncoding = k.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(U) {
      p(j, U);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = k.emitClose !== !1, this.autoDestroy = !!k.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new t(this);
  }
  Z.prototype.getBuffer = function() {
    for (var j = this.bufferedRequest, q = []; j; )
      q.push(j), j = j.next;
    return q;
  }, function() {
    try {
      Object.defineProperty(Z.prototype, "buffer", {
        get: r.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var B;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (B = Function.prototype[Symbol.hasInstance], Object.defineProperty(Y, Symbol.hasInstance, {
    value: function(j) {
      return B.call(this, j) ? !0 : this !== Y ? !1 : j && j._writableState instanceof Z;
    }
  })) : B = function(j) {
    return j instanceof this;
  };
  function Y(k) {
    e = e || Lc();
    var j = this instanceof e;
    if (!j && !B.call(Y, this))
      return new Y(k);
    this._writableState = new Z(k, this, j), this.writable = !0, k && (typeof k.write == "function" && (this._write = k.write), typeof k.writev == "function" && (this._writev = k.writev), typeof k.destroy == "function" && (this._destroy = k.destroy), typeof k.final == "function" && (this._final = k.final)), i.call(this);
  }
  Y.prototype.pipe = function() {
    H(this, new N());
  };
  function ae(k, j) {
    var q = new P();
    H(k, q), process.nextTick(j, q);
  }
  function se(k, j, q, K) {
    var U;
    return q === null ? U = new O() : typeof q != "string" && !j.objectMode && (U = new b("chunk", ["string", "Buffer"], q)), U ? (H(k, U), process.nextTick(K, U), !1) : !0;
  }
  Y.prototype.write = function(k, j, q) {
    var K = this._writableState, U = !1, T = !K.objectMode && u(k);
    return T && !s.isBuffer(k) && (k = f(k)), typeof j == "function" && (q = j, j = null), T ? j = "buffer" : j || (j = K.defaultEncoding), typeof q != "function" && (q = Q), K.ending ? ae(this, q) : (T || se(this, K, k, q)) && (K.pendingcb++, U = C(this, K, T, k, j, q)), U;
  }, Y.prototype.cork = function() {
    this._writableState.corked++;
  }, Y.prototype.uncork = function() {
    var k = this._writableState;
    k.corked && (k.corked--, !k.writing && !k.corked && !k.bufferProcessing && k.bufferedRequest && x(this, k));
  }, Y.prototype.setDefaultEncoding = function(j) {
    if (typeof j == "string" && (j = j.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((j + "").toLowerCase()) > -1))
      throw new F(j);
    return this._writableState.defaultEncoding = j, this;
  }, Object.defineProperty(Y.prototype, "writableBuffer", {
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function W(k, j, q) {
    return !k.objectMode && k.decodeStrings !== !1 && typeof j == "string" && (j = s.from(j, q)), j;
  }
  Object.defineProperty(Y.prototype, "writableHighWaterMark", {
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function C(k, j, q, K, U, T) {
    if (!q) {
      var D = W(j, K, U);
      K !== D && (q = !0, U = "buffer", K = D);
    }
    var te = j.objectMode ? 1 : K.length;
    j.length += te;
    var ne = j.length < j.highWaterMark;
    if (ne || (j.needDrain = !0), j.writing || j.corked) {
      var le = j.lastBufferedRequest;
      j.lastBufferedRequest = {
        chunk: K,
        encoding: U,
        isBuf: q,
        callback: T,
        next: null
      }, le ? le.next = j.lastBufferedRequest : j.bufferedRequest = j.lastBufferedRequest, j.bufferedRequestCount += 1;
    } else
      g(k, j, !1, te, K, U, T);
    return ne;
  }
  function g(k, j, q, K, U, T, D) {
    j.writelen = K, j.writecb = D, j.writing = !0, j.sync = !0, j.destroyed ? j.onwrite(new R("write")) : q ? k._writev(U, j.onwrite) : k._write(U, T, j.onwrite), j.sync = !1;
  }
  function a(k, j, q, K, U) {
    --j.pendingcb, q ? (process.nextTick(U, K), process.nextTick(S, k, j), k._writableState.errorEmitted = !0, H(k, K)) : (U(K), k._writableState.errorEmitted = !0, H(k, K), S(k, j));
  }
  function c(k) {
    k.writing = !1, k.writecb = null, k.length -= k.writelen, k.writelen = 0;
  }
  function p(k, j) {
    var q = k._writableState, K = q.sync, U = q.writecb;
    if (typeof U != "function")
      throw new A();
    if (c(q), j)
      a(k, q, K, j, U);
    else {
      var T = E(q) || k.destroyed;
      !T && !q.corked && !q.bufferProcessing && q.bufferedRequest && x(k, q), K ? process.nextTick(w, k, q, T, U) : w(k, q, T, U);
    }
  }
  function w(k, j, q, K) {
    q || _(k, j), j.pendingcb--, K(), S(k, j);
  }
  function _(k, j) {
    j.length === 0 && j.needDrain && (j.needDrain = !1, k.emit("drain"));
  }
  function x(k, j) {
    j.bufferProcessing = !0;
    var q = j.bufferedRequest;
    if (k._writev && q && q.next) {
      var K = j.bufferedRequestCount, U = new Array(K), T = j.corkedRequestsFree;
      T.entry = q;
      for (var D = 0, te = !0; q; )
        U[D] = q, q.isBuf || (te = !1), q = q.next, D += 1;
      U.allBuffers = te, g(k, j, !0, j.length, U, "", T.finish), j.pendingcb++, j.lastBufferedRequest = null, T.next ? (j.corkedRequestsFree = T.next, T.next = null) : j.corkedRequestsFree = new t(j), j.bufferedRequestCount = 0;
    } else {
      for (; q; ) {
        var ne = q.chunk, le = q.encoding, X = q.callback, $ = j.objectMode ? 1 : ne.length;
        if (g(k, j, !1, $, ne, le, X), q = q.next, j.bufferedRequestCount--, j.writing)
          break;
      }
      q === null && (j.lastBufferedRequest = null);
    }
    j.bufferedRequest = q, j.bufferProcessing = !1;
  }
  Y.prototype._write = function(k, j, q) {
    q(new M("_write()"));
  }, Y.prototype._writev = null, Y.prototype.end = function(k, j, q) {
    var K = this._writableState;
    return typeof k == "function" ? (q = k, k = null, j = null) : typeof j == "function" && (q = j, j = null), k != null && this.write(k, j), K.corked && (K.corked = 1, this.uncork()), K.ending || J(this, K, q), this;
  }, Object.defineProperty(Y.prototype, "writableLength", {
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function E(k) {
    return k.ending && k.length === 0 && k.bufferedRequest === null && !k.finished && !k.writing;
  }
  function y(k, j) {
    k._final(function(q) {
      j.pendingcb--, q && H(k, q), j.prefinished = !0, k.emit("prefinish"), S(k, j);
    });
  }
  function o(k, j) {
    !j.prefinished && !j.finalCalled && (typeof k._final == "function" && !j.destroyed ? (j.pendingcb++, j.finalCalled = !0, process.nextTick(y, k, j)) : (j.prefinished = !0, k.emit("prefinish")));
  }
  function S(k, j) {
    var q = E(j);
    if (q && (o(k, j), j.pendingcb === 0 && (j.finished = !0, k.emit("finish"), j.autoDestroy))) {
      var K = k._readableState;
      (!K || K.autoDestroy && K.endEmitted) && k.destroy();
    }
    return q;
  }
  function J(k, j, q) {
    j.ending = !0, S(k, j), q && (j.finished ? process.nextTick(q) : k.once("finish", q)), j.ended = !0, k.writable = !1;
  }
  function z(k, j, q) {
    var K = k.entry;
    for (k.entry = null; K; ) {
      var U = K.callback;
      j.pendingcb--, U(q), K = K.next;
    }
    j.corkedRequestsFree.next = k;
  }
  return Object.defineProperty(Y.prototype, "destroyed", {
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(j) {
      !this._writableState || (this._writableState.destroyed = j);
    }
  }), Y.prototype.destroy = h.destroy, Y.prototype._undestroy = h.undestroy, Y.prototype._destroy = function(k, j) {
    j(k);
  }, Nb;
}
var Db, AM;
function Lc() {
  if (AM)
    return Db;
  AM = 1;
  var t = Object.keys || function(d) {
    var l = [];
    for (var m in d)
      l.push(m);
    return l;
  };
  Db = f;
  var e = MA(), r = _A();
  It.exports(f, e);
  for (var i = t(r.prototype), s = 0; s < i.length; s++) {
    var n = i[s];
    f.prototype[n] || (f.prototype[n] = r.prototype[n]);
  }
  function f(d) {
    if (!(this instanceof f))
      return new f(d);
    e.call(this, d), r.call(this, d), this.allowHalfOpen = !0, d && (d.readable === !1 && (this.readable = !1), d.writable === !1 && (this.writable = !1), d.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", u)));
  }
  Object.defineProperty(f.prototype, "writableHighWaterMark", {
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(f.prototype, "writableBuffer", {
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(f.prototype, "writableLength", {
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function u() {
    this._writableState.ended || process.nextTick(h, this);
  }
  function h(d) {
    d.end();
  }
  return Object.defineProperty(f.prototype, "destroyed", {
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(l) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = l, this._writableState.destroyed = l);
    }
  }), Db;
}
var Cb, TM;
function gw() {
  if (TM)
    return Cb;
  TM = 1;
  var t = eu().codes.ERR_STREAM_PREMATURE_CLOSE;
  function e(n) {
    var f = !1;
    return function() {
      if (!f) {
        f = !0;
        for (var u = arguments.length, h = new Array(u), d = 0; d < u; d++)
          h[d] = arguments[d];
        n.apply(this, h);
      }
    };
  }
  function r() {
  }
  function i(n) {
    return n.setHeader && typeof n.abort == "function";
  }
  function s(n, f, u) {
    if (typeof f == "function")
      return s(n, null, f);
    f || (f = {}), u = e(u || r);
    var h = f.readable || f.readable !== !1 && n.readable, d = f.writable || f.writable !== !1 && n.writable, l = function() {
      n.writable || b();
    }, m = n._writableState && n._writableState.finished, b = function() {
      d = !1, m = !0, h || u.call(n);
    }, M = n._readableState && n._readableState.endEmitted, A = function() {
      h = !1, M = !0, d || u.call(n);
    }, N = function(F) {
      u.call(n, F);
    }, R = function() {
      var F;
      if (h && !M)
        return (!n._readableState || !n._readableState.ended) && (F = new t()), u.call(n, F);
      if (d && !m)
        return (!n._writableState || !n._writableState.ended) && (F = new t()), u.call(n, F);
    }, O = function() {
      n.req.on("finish", b);
    };
    return i(n) ? (n.on("complete", b), n.on("abort", R), n.req ? O() : n.on("request", O)) : d && !n._writableState && (n.on("end", l), n.on("close", l)), n.on("end", A), n.on("finish", b), f.error !== !1 && n.on("error", N), n.on("close", R), function() {
      n.removeListener("complete", b), n.removeListener("abort", R), n.removeListener("request", O), n.req && n.req.removeListener("finish", b), n.removeListener("end", l), n.removeListener("close", l), n.removeListener("finish", b), n.removeListener("end", A), n.removeListener("error", N), n.removeListener("close", R);
    };
  }
  return Cb = s, Cb;
}
var Ob, NM;
function Vte() {
  if (NM)
    return Ob;
  NM = 1;
  var t;
  function e(O, P, F) {
    return P in O ? Object.defineProperty(O, P, { value: F, enumerable: !0, configurable: !0, writable: !0 }) : O[P] = F, O;
  }
  var r = gw(), i = Symbol("lastResolve"), s = Symbol("lastReject"), n = Symbol("error"), f = Symbol("ended"), u = Symbol("lastPromise"), h = Symbol("handlePromise"), d = Symbol("stream");
  function l(O, P) {
    return {
      value: O,
      done: P
    };
  }
  function m(O) {
    var P = O[i];
    if (P !== null) {
      var F = O[d].read();
      F !== null && (O[u] = null, O[i] = null, O[s] = null, P(l(F, !1)));
    }
  }
  function b(O) {
    process.nextTick(m, O);
  }
  function M(O, P) {
    return function(F, H) {
      O.then(function() {
        if (P[f]) {
          F(l(void 0, !0));
          return;
        }
        P[h](F, H);
      }, H);
    };
  }
  var A = Object.getPrototypeOf(function() {
  }), N = Object.setPrototypeOf((t = {
    get stream() {
      return this[d];
    },
    next: function() {
      var P = this, F = this[n];
      if (F !== null)
        return Promise.reject(F);
      if (this[f])
        return Promise.resolve(l(void 0, !0));
      if (this[d].destroyed)
        return new Promise(function(B, Y) {
          process.nextTick(function() {
            P[n] ? Y(P[n]) : B(l(void 0, !0));
          });
        });
      var H = this[u], Q;
      if (H)
        Q = new Promise(M(H, this));
      else {
        var Z = this[d].read();
        if (Z !== null)
          return Promise.resolve(l(Z, !1));
        Q = new Promise(this[h]);
      }
      return this[u] = Q, Q;
    }
  }, e(t, Symbol.asyncIterator, function() {
    return this;
  }), e(t, "return", function() {
    var P = this;
    return new Promise(function(F, H) {
      P[d].destroy(null, function(Q) {
        if (Q) {
          H(Q);
          return;
        }
        F(l(void 0, !0));
      });
    });
  }), t), A), R = function(P) {
    var F, H = Object.create(N, (F = {}, e(F, d, {
      value: P,
      writable: !0
    }), e(F, i, {
      value: null,
      writable: !0
    }), e(F, s, {
      value: null,
      writable: !0
    }), e(F, n, {
      value: null,
      writable: !0
    }), e(F, f, {
      value: P._readableState.endEmitted,
      writable: !0
    }), e(F, h, {
      value: function(Z, B) {
        var Y = H[d].read();
        Y ? (H[u] = null, H[i] = null, H[s] = null, Z(l(Y, !1))) : (H[i] = Z, H[s] = B);
      },
      writable: !0
    }), F));
    return H[u] = null, r(P, function(Q) {
      if (Q && Q.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var Z = H[s];
        Z !== null && (H[u] = null, H[i] = null, H[s] = null, Z(Q)), H[n] = Q;
        return;
      }
      var B = H[i];
      B !== null && (H[u] = null, H[i] = null, H[s] = null, B(l(void 0, !0))), H[f] = !0;
    }), P.on("readable", b.bind(null, H)), H;
  };
  return Ob = R, Ob;
}
var Rb, DM;
function Gte() {
  return DM || (DM = 1, Rb = function() {
    throw new Error("Readable.from is not available in the browser");
  }), Rb;
}
var Lb, CM;
function MA() {
  if (CM)
    return Lb;
  CM = 1, Lb = ae;
  var t;
  ae.ReadableState = Y, Pr.exports.EventEmitter;
  var e = function(D, te) {
    return D.listeners(te).length;
  }, r = yA(), i = Tn.Buffer, s = nt.Uint8Array || function() {
  };
  function n(T) {
    return i.from(T);
  }
  function f(T) {
    return i.isBuffer(T) || T instanceof s;
  }
  var u = dn, h;
  u && u.debuglog ? h = u.debuglog("stream") : h = function() {
  };
  var d = Wte(), l = mA(), m = wA(), b = m.getHighWaterMark, M = eu().codes, A = M.ERR_INVALID_ARG_TYPE, N = M.ERR_STREAM_PUSH_AFTER_EOF, R = M.ERR_METHOD_NOT_IMPLEMENTED, O = M.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, P, F, H;
  It.exports(ae, r);
  var Q = l.errorOrDestroy, Z = ["error", "close", "destroy", "pause", "resume"];
  function B(T, D, te) {
    if (typeof T.prependListener == "function")
      return T.prependListener(D, te);
    !T._events || !T._events[D] ? T.on(D, te) : Array.isArray(T._events[D]) ? T._events[D].unshift(te) : T._events[D] = [te, T._events[D]];
  }
  function Y(T, D, te) {
    t = t || Lc(), T = T || {}, typeof te != "boolean" && (te = D instanceof t), this.objectMode = !!T.objectMode, te && (this.objectMode = this.objectMode || !!T.readableObjectMode), this.highWaterMark = b(this, T, "readableHighWaterMark", te), this.buffer = new d(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = T.emitClose !== !1, this.autoDestroy = !!T.autoDestroy, this.destroyed = !1, this.defaultEncoding = T.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, T.encoding && (P || (P = of().StringDecoder), this.decoder = new P(T.encoding), this.encoding = T.encoding);
  }
  function ae(T) {
    if (t = t || Lc(), !(this instanceof ae))
      return new ae(T);
    var D = this instanceof t;
    this._readableState = new Y(T, this, D), this.readable = !0, T && (typeof T.read == "function" && (this._read = T.read), typeof T.destroy == "function" && (this._destroy = T.destroy)), r.call(this);
  }
  Object.defineProperty(ae.prototype, "destroyed", {
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(D) {
      !this._readableState || (this._readableState.destroyed = D);
    }
  }), ae.prototype.destroy = l.destroy, ae.prototype._undestroy = l.undestroy, ae.prototype._destroy = function(T, D) {
    D(T);
  }, ae.prototype.push = function(T, D) {
    var te = this._readableState, ne;
    return te.objectMode ? ne = !0 : typeof T == "string" && (D = D || te.defaultEncoding, D !== te.encoding && (T = i.from(T, D), D = ""), ne = !0), se(this, T, D, !1, ne);
  }, ae.prototype.unshift = function(T) {
    return se(this, T, null, !0, !1);
  };
  function se(T, D, te, ne, le) {
    h("readableAddChunk", D);
    var X = T._readableState;
    if (D === null)
      X.reading = !1, p(T, X);
    else {
      var $;
      if (le || ($ = C(X, D)), $)
        Q(T, $);
      else if (X.objectMode || D && D.length > 0)
        if (typeof D != "string" && !X.objectMode && Object.getPrototypeOf(D) !== i.prototype && (D = n(D)), ne)
          X.endEmitted ? Q(T, new O()) : W(T, X, D, !0);
        else if (X.ended)
          Q(T, new N());
        else {
          if (X.destroyed)
            return !1;
          X.reading = !1, X.decoder && !te ? (D = X.decoder.write(D), X.objectMode || D.length !== 0 ? W(T, X, D, !1) : x(T, X)) : W(T, X, D, !1);
        }
      else
        ne || (X.reading = !1, x(T, X));
    }
    return !X.ended && (X.length < X.highWaterMark || X.length === 0);
  }
  function W(T, D, te, ne) {
    D.flowing && D.length === 0 && !D.sync ? (D.awaitDrain = 0, T.emit("data", te)) : (D.length += D.objectMode ? 1 : te.length, ne ? D.buffer.unshift(te) : D.buffer.push(te), D.needReadable && w(T)), x(T, D);
  }
  function C(T, D) {
    var te;
    return !f(D) && typeof D != "string" && D !== void 0 && !T.objectMode && (te = new A("chunk", ["string", "Buffer", "Uint8Array"], D)), te;
  }
  ae.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, ae.prototype.setEncoding = function(T) {
    P || (P = of().StringDecoder);
    var D = new P(T);
    this._readableState.decoder = D, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var te = this._readableState.buffer.head, ne = ""; te !== null; )
      ne += D.write(te.data), te = te.next;
    return this._readableState.buffer.clear(), ne !== "" && this._readableState.buffer.push(ne), this._readableState.length = ne.length, this;
  };
  var g = 1073741824;
  function a(T) {
    return T >= g ? T = g : (T--, T |= T >>> 1, T |= T >>> 2, T |= T >>> 4, T |= T >>> 8, T |= T >>> 16, T++), T;
  }
  function c(T, D) {
    return T <= 0 || D.length === 0 && D.ended ? 0 : D.objectMode ? 1 : T !== T ? D.flowing && D.length ? D.buffer.head.data.length : D.length : (T > D.highWaterMark && (D.highWaterMark = a(T)), T <= D.length ? T : D.ended ? D.length : (D.needReadable = !0, 0));
  }
  ae.prototype.read = function(T) {
    h("read", T), T = parseInt(T, 10);
    var D = this._readableState, te = T;
    if (T !== 0 && (D.emittedReadable = !1), T === 0 && D.needReadable && ((D.highWaterMark !== 0 ? D.length >= D.highWaterMark : D.length > 0) || D.ended))
      return h("read: emitReadable", D.length, D.ended), D.length === 0 && D.ended ? q(this) : w(this), null;
    if (T = c(T, D), T === 0 && D.ended)
      return D.length === 0 && q(this), null;
    var ne = D.needReadable;
    h("need readable", ne), (D.length === 0 || D.length - T < D.highWaterMark) && (ne = !0, h("length less than watermark", ne)), D.ended || D.reading ? (ne = !1, h("reading or ended", ne)) : ne && (h("do read"), D.reading = !0, D.sync = !0, D.length === 0 && (D.needReadable = !0), this._read(D.highWaterMark), D.sync = !1, D.reading || (T = c(te, D)));
    var le;
    return T > 0 ? le = j(T, D) : le = null, le === null ? (D.needReadable = D.length <= D.highWaterMark, T = 0) : (D.length -= T, D.awaitDrain = 0), D.length === 0 && (D.ended || (D.needReadable = !0), te !== T && D.ended && q(this)), le !== null && this.emit("data", le), le;
  };
  function p(T, D) {
    if (h("onEofChunk"), !D.ended) {
      if (D.decoder) {
        var te = D.decoder.end();
        te && te.length && (D.buffer.push(te), D.length += D.objectMode ? 1 : te.length);
      }
      D.ended = !0, D.sync ? w(T) : (D.needReadable = !1, D.emittedReadable || (D.emittedReadable = !0, _(T)));
    }
  }
  function w(T) {
    var D = T._readableState;
    h("emitReadable", D.needReadable, D.emittedReadable), D.needReadable = !1, D.emittedReadable || (h("emitReadable", D.flowing), D.emittedReadable = !0, process.nextTick(_, T));
  }
  function _(T) {
    var D = T._readableState;
    h("emitReadable_", D.destroyed, D.length, D.ended), !D.destroyed && (D.length || D.ended) && (T.emit("readable"), D.emittedReadable = !1), D.needReadable = !D.flowing && !D.ended && D.length <= D.highWaterMark, k(T);
  }
  function x(T, D) {
    D.readingMore || (D.readingMore = !0, process.nextTick(E, T, D));
  }
  function E(T, D) {
    for (; !D.reading && !D.ended && (D.length < D.highWaterMark || D.flowing && D.length === 0); ) {
      var te = D.length;
      if (h("maybeReadMore read 0"), T.read(0), te === D.length)
        break;
    }
    D.readingMore = !1;
  }
  ae.prototype._read = function(T) {
    Q(this, new R("_read()"));
  }, ae.prototype.pipe = function(T, D) {
    var te = this, ne = this._readableState;
    switch (ne.pipesCount) {
      case 0:
        ne.pipes = T;
        break;
      case 1:
        ne.pipes = [ne.pipes, T];
        break;
      default:
        ne.pipes.push(T);
        break;
    }
    ne.pipesCount += 1, h("pipe count=%d opts=%j", ne.pipesCount, D);
    var le = (!D || D.end !== !1) && T !== process.stdout && T !== process.stderr, X = le ? V : ye;
    ne.endEmitted ? process.nextTick(X) : te.once("end", X), T.on("unpipe", $);
    function $(pe, Je) {
      h("onunpipe"), pe === te && Je && Je.hasUnpiped === !1 && (Je.hasUnpiped = !0, ue());
    }
    function V() {
      h("onend"), T.end();
    }
    var re = y(te);
    T.on("drain", re);
    var fe = !1;
    function ue() {
      h("cleanup"), T.removeListener("close", ve), T.removeListener("finish", Ge), T.removeListener("drain", re), T.removeListener("error", be), T.removeListener("unpipe", $), te.removeListener("end", V), te.removeListener("end", ye), te.removeListener("data", me), fe = !0, ne.awaitDrain && (!T._writableState || T._writableState.needDrain) && re();
    }
    te.on("data", me);
    function me(pe) {
      h("ondata");
      var Je = T.write(pe);
      h("dest.write", Je), Je === !1 && ((ne.pipesCount === 1 && ne.pipes === T || ne.pipesCount > 1 && U(ne.pipes, T) !== -1) && !fe && (h("false write response, pause", ne.awaitDrain), ne.awaitDrain++), te.pause());
    }
    function be(pe) {
      h("onerror", pe), ye(), T.removeListener("error", be), e(T, "error") === 0 && Q(T, pe);
    }
    B(T, "error", be);
    function ve() {
      T.removeListener("finish", Ge), ye();
    }
    T.once("close", ve);
    function Ge() {
      h("onfinish"), T.removeListener("close", ve), ye();
    }
    T.once("finish", Ge);
    function ye() {
      h("unpipe"), te.unpipe(T);
    }
    return T.emit("pipe", te), ne.flowing || (h("pipe resume"), te.resume()), T;
  };
  function y(T) {
    return function() {
      var te = T._readableState;
      h("pipeOnDrain", te.awaitDrain), te.awaitDrain && te.awaitDrain--, te.awaitDrain === 0 && e(T, "data") && (te.flowing = !0, k(T));
    };
  }
  ae.prototype.unpipe = function(T) {
    var D = this._readableState, te = {
      hasUnpiped: !1
    };
    if (D.pipesCount === 0)
      return this;
    if (D.pipesCount === 1)
      return T && T !== D.pipes ? this : (T || (T = D.pipes), D.pipes = null, D.pipesCount = 0, D.flowing = !1, T && T.emit("unpipe", this, te), this);
    if (!T) {
      var ne = D.pipes, le = D.pipesCount;
      D.pipes = null, D.pipesCount = 0, D.flowing = !1;
      for (var X = 0; X < le; X++)
        ne[X].emit("unpipe", this, {
          hasUnpiped: !1
        });
      return this;
    }
    var $ = U(D.pipes, T);
    return $ === -1 ? this : (D.pipes.splice($, 1), D.pipesCount -= 1, D.pipesCount === 1 && (D.pipes = D.pipes[0]), T.emit("unpipe", this, te), this);
  }, ae.prototype.on = function(T, D) {
    var te = r.prototype.on.call(this, T, D), ne = this._readableState;
    return T === "data" ? (ne.readableListening = this.listenerCount("readable") > 0, ne.flowing !== !1 && this.resume()) : T === "readable" && !ne.endEmitted && !ne.readableListening && (ne.readableListening = ne.needReadable = !0, ne.flowing = !1, ne.emittedReadable = !1, h("on readable", ne.length, ne.reading), ne.length ? w(this) : ne.reading || process.nextTick(S, this)), te;
  }, ae.prototype.addListener = ae.prototype.on, ae.prototype.removeListener = function(T, D) {
    var te = r.prototype.removeListener.call(this, T, D);
    return T === "readable" && process.nextTick(o, this), te;
  }, ae.prototype.removeAllListeners = function(T) {
    var D = r.prototype.removeAllListeners.apply(this, arguments);
    return (T === "readable" || T === void 0) && process.nextTick(o, this), D;
  };
  function o(T) {
    var D = T._readableState;
    D.readableListening = T.listenerCount("readable") > 0, D.resumeScheduled && !D.paused ? D.flowing = !0 : T.listenerCount("data") > 0 && T.resume();
  }
  function S(T) {
    h("readable nexttick read 0"), T.read(0);
  }
  ae.prototype.resume = function() {
    var T = this._readableState;
    return T.flowing || (h("resume"), T.flowing = !T.readableListening, J(this, T)), T.paused = !1, this;
  };
  function J(T, D) {
    D.resumeScheduled || (D.resumeScheduled = !0, process.nextTick(z, T, D));
  }
  function z(T, D) {
    h("resume", D.reading), D.reading || T.read(0), D.resumeScheduled = !1, T.emit("resume"), k(T), D.flowing && !D.reading && T.read(0);
  }
  ae.prototype.pause = function() {
    return h("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (h("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function k(T) {
    var D = T._readableState;
    for (h("flow", D.flowing); D.flowing && T.read() !== null; )
      ;
  }
  ae.prototype.wrap = function(T) {
    var D = this, te = this._readableState, ne = !1;
    T.on("end", function() {
      if (h("wrapped end"), te.decoder && !te.ended) {
        var $ = te.decoder.end();
        $ && $.length && D.push($);
      }
      D.push(null);
    }), T.on("data", function($) {
      if (h("wrapped data"), te.decoder && ($ = te.decoder.write($)), !(te.objectMode && $ == null) && !(!te.objectMode && (!$ || !$.length))) {
        var V = D.push($);
        V || (ne = !0, T.pause());
      }
    });
    for (var le in T)
      this[le] === void 0 && typeof T[le] == "function" && (this[le] = function(V) {
        return function() {
          return T[V].apply(T, arguments);
        };
      }(le));
    for (var X = 0; X < Z.length; X++)
      T.on(Z[X], this.emit.bind(this, Z[X]));
    return this._read = function($) {
      h("wrapped _read", $), ne && (ne = !1, T.resume());
    }, this;
  }, typeof Symbol == "function" && (ae.prototype[Symbol.asyncIterator] = function() {
    return F === void 0 && (F = Vte()), F(this);
  }), Object.defineProperty(ae.prototype, "readableHighWaterMark", {
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(ae.prototype, "readableBuffer", {
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(ae.prototype, "readableFlowing", {
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(D) {
      this._readableState && (this._readableState.flowing = D);
    }
  }), ae._fromList = j, Object.defineProperty(ae.prototype, "readableLength", {
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function j(T, D) {
    if (D.length === 0)
      return null;
    var te;
    return D.objectMode ? te = D.buffer.shift() : !T || T >= D.length ? (D.decoder ? te = D.buffer.join("") : D.buffer.length === 1 ? te = D.buffer.first() : te = D.buffer.concat(D.length), D.buffer.clear()) : te = D.buffer.consume(T, D.decoder), te;
  }
  function q(T) {
    var D = T._readableState;
    h("endReadable", D.endEmitted), D.endEmitted || (D.ended = !0, process.nextTick(K, D, T));
  }
  function K(T, D) {
    if (h("endReadableNT", T.endEmitted, T.length), !T.endEmitted && T.length === 0 && (T.endEmitted = !0, D.readable = !1, D.emit("end"), T.autoDestroy)) {
      var te = D._writableState;
      (!te || te.autoDestroy && te.finished) && D.destroy();
    }
  }
  typeof Symbol == "function" && (ae.from = function(T, D) {
    return H === void 0 && (H = Gte()), H(ae, T, D);
  });
  function U(T, D) {
    for (var te = 0, ne = T.length; te < ne; te++)
      if (T[te] === D)
        return te;
    return -1;
  }
  return Lb;
}
var Pb, OM;
function xA() {
  if (OM)
    return Pb;
  OM = 1, Pb = u;
  var t = eu().codes, e = t.ERR_METHOD_NOT_IMPLEMENTED, r = t.ERR_MULTIPLE_CALLBACK, i = t.ERR_TRANSFORM_ALREADY_TRANSFORMING, s = t.ERR_TRANSFORM_WITH_LENGTH_0, n = Lc();
  It.exports(u, n);
  function f(l, m) {
    var b = this._transformState;
    b.transforming = !1;
    var M = b.writecb;
    if (M === null)
      return this.emit("error", new r());
    b.writechunk = null, b.writecb = null, m != null && this.push(m), M(l);
    var A = this._readableState;
    A.reading = !1, (A.needReadable || A.length < A.highWaterMark) && this._read(A.highWaterMark);
  }
  function u(l) {
    if (!(this instanceof u))
      return new u(l);
    n.call(this, l), this._transformState = {
      afterTransform: f.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, l && (typeof l.transform == "function" && (this._transform = l.transform), typeof l.flush == "function" && (this._flush = l.flush)), this.on("prefinish", h);
  }
  function h() {
    var l = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(m, b) {
      d(l, m, b);
    }) : d(this, null, null);
  }
  u.prototype.push = function(l, m) {
    return this._transformState.needTransform = !1, n.prototype.push.call(this, l, m);
  }, u.prototype._transform = function(l, m, b) {
    b(new e("_transform()"));
  }, u.prototype._write = function(l, m, b) {
    var M = this._transformState;
    if (M.writecb = b, M.writechunk = l, M.writeencoding = m, !M.transforming) {
      var A = this._readableState;
      (M.needTransform || A.needReadable || A.length < A.highWaterMark) && this._read(A.highWaterMark);
    }
  }, u.prototype._read = function(l) {
    var m = this._transformState;
    m.writechunk !== null && !m.transforming ? (m.transforming = !0, this._transform(m.writechunk, m.writeencoding, m.afterTransform)) : m.needTransform = !0;
  }, u.prototype._destroy = function(l, m) {
    n.prototype._destroy.call(this, l, function(b) {
      m(b);
    });
  };
  function d(l, m, b) {
    if (m)
      return l.emit("error", m);
    if (b != null && l.push(b), l._writableState.length)
      throw new s();
    if (l._transformState.transforming)
      throw new i();
    return l.push(null);
  }
  return Pb;
}
var kb, RM;
function Kte() {
  if (RM)
    return kb;
  RM = 1, kb = e;
  var t = xA();
  It.exports(e, t);
  function e(r) {
    if (!(this instanceof e))
      return new e(r);
    t.call(this, r);
  }
  return e.prototype._transform = function(r, i, s) {
    s(null, r);
  }, kb;
}
var jb, LM;
function Yte() {
  if (LM)
    return jb;
  LM = 1;
  var t;
  function e(b) {
    var M = !1;
    return function() {
      M || (M = !0, b.apply(void 0, arguments));
    };
  }
  var r = eu().codes, i = r.ERR_MISSING_ARGS, s = r.ERR_STREAM_DESTROYED;
  function n(b) {
    if (b)
      throw b;
  }
  function f(b) {
    return b.setHeader && typeof b.abort == "function";
  }
  function u(b, M, A, N) {
    N = e(N);
    var R = !1;
    b.on("close", function() {
      R = !0;
    }), t === void 0 && (t = gw()), t(b, {
      readable: M,
      writable: A
    }, function(P) {
      if (P)
        return N(P);
      R = !0, N();
    });
    var O = !1;
    return function(P) {
      if (!R && !O) {
        if (O = !0, f(b))
          return b.abort();
        if (typeof b.destroy == "function")
          return b.destroy();
        N(P || new s("pipe"));
      }
    };
  }
  function h(b) {
    b();
  }
  function d(b, M) {
    return b.pipe(M);
  }
  function l(b) {
    return !b.length || typeof b[b.length - 1] != "function" ? n : b.pop();
  }
  function m() {
    for (var b = arguments.length, M = new Array(b), A = 0; A < b; A++)
      M[A] = arguments[A];
    var N = l(M);
    if (Array.isArray(M[0]) && (M = M[0]), M.length < 2)
      throw new i("streams");
    var R, O = M.map(function(P, F) {
      var H = F < M.length - 1, Q = F > 0;
      return u(P, H, Q, function(Z) {
        R || (R = Z), Z && O.forEach(h), !H && (O.forEach(h), N(R));
      });
    });
    return M.reduce(d);
  }
  return jb = m, jb;
}
var PM;
function Qte() {
  return PM || (PM = 1, function(t, e) {
    e = t.exports = MA(), e.Stream = e, e.Readable = e, e.Writable = _A(), e.Duplex = Lc(), e.Transform = xA(), e.PassThrough = Kte(), e.finished = gw(), e.pipeline = Yte();
  }(Pd, Pd.exports)), Pd.exports;
}
var Uu = { exports: {} }, Bb = { exports: {} }, kM;
function Zte() {
  return kM || (kM = 1, function(t) {
    (function(e, r) {
      function i(g, a) {
        if (!g)
          throw new Error(a || "Assertion failed");
      }
      function s(g, a) {
        g.super_ = a;
        var c = function() {
        };
        c.prototype = a.prototype, g.prototype = new c(), g.prototype.constructor = g;
      }
      function n(g, a, c) {
        if (n.isBN(g))
          return g;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, g !== null && ((a === "le" || a === "be") && (c = a, a = 10), this._init(g || 0, a || 10, c || "be"));
      }
      typeof e == "object" ? e.exports = n : r.BN = n, n.BN = n, n.wordSize = 26;
      var f;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? f = window.Buffer : f = dn.Buffer;
      } catch {
      }
      n.isBN = function(a) {
        return a instanceof n ? !0 : a !== null && typeof a == "object" && a.constructor.wordSize === n.wordSize && Array.isArray(a.words);
      }, n.max = function(a, c) {
        return a.cmp(c) > 0 ? a : c;
      }, n.min = function(a, c) {
        return a.cmp(c) < 0 ? a : c;
      }, n.prototype._init = function(a, c, p) {
        if (typeof a == "number")
          return this._initNumber(a, c, p);
        if (typeof a == "object")
          return this._initArray(a, c, p);
        c === "hex" && (c = 16), i(c === (c | 0) && c >= 2 && c <= 36), a = a.toString().replace(/\s+/g, "");
        var w = 0;
        a[0] === "-" && (w++, this.negative = 1), w < a.length && (c === 16 ? this._parseHex(a, w, p) : (this._parseBase(a, c, w), p === "le" && this._initArray(this.toArray(), c, p)));
      }, n.prototype._initNumber = function(a, c, p) {
        a < 0 && (this.negative = 1, a = -a), a < 67108864 ? (this.words = [a & 67108863], this.length = 1) : a < 4503599627370496 ? (this.words = [
          a & 67108863,
          a / 67108864 & 67108863
        ], this.length = 2) : (i(a < 9007199254740992), this.words = [
          a & 67108863,
          a / 67108864 & 67108863,
          1
        ], this.length = 3), p === "le" && this._initArray(this.toArray(), c, p);
      }, n.prototype._initArray = function(a, c, p) {
        if (i(typeof a.length == "number"), a.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(a.length / 3), this.words = new Array(this.length);
        for (var w = 0; w < this.length; w++)
          this.words[w] = 0;
        var _, x, E = 0;
        if (p === "be")
          for (w = a.length - 1, _ = 0; w >= 0; w -= 3)
            x = a[w] | a[w - 1] << 8 | a[w - 2] << 16, this.words[_] |= x << E & 67108863, this.words[_ + 1] = x >>> 26 - E & 67108863, E += 24, E >= 26 && (E -= 26, _++);
        else if (p === "le")
          for (w = 0, _ = 0; w < a.length; w += 3)
            x = a[w] | a[w + 1] << 8 | a[w + 2] << 16, this.words[_] |= x << E & 67108863, this.words[_ + 1] = x >>> 26 - E & 67108863, E += 24, E >= 26 && (E -= 26, _++);
        return this._strip();
      };
      function u(g, a) {
        var c = g.charCodeAt(a);
        if (c >= 48 && c <= 57)
          return c - 48;
        if (c >= 65 && c <= 70)
          return c - 55;
        if (c >= 97 && c <= 102)
          return c - 87;
        i(!1, "Invalid character in " + g);
      }
      function h(g, a, c) {
        var p = u(g, c);
        return c - 1 >= a && (p |= u(g, c - 1) << 4), p;
      }
      n.prototype._parseHex = function(a, c, p) {
        this.length = Math.ceil((a.length - c) / 6), this.words = new Array(this.length);
        for (var w = 0; w < this.length; w++)
          this.words[w] = 0;
        var _ = 0, x = 0, E;
        if (p === "be")
          for (w = a.length - 1; w >= c; w -= 2)
            E = h(a, c, w) << _, this.words[x] |= E & 67108863, _ >= 18 ? (_ -= 18, x += 1, this.words[x] |= E >>> 26) : _ += 8;
        else {
          var y = a.length - c;
          for (w = y % 2 === 0 ? c + 1 : c; w < a.length; w += 2)
            E = h(a, c, w) << _, this.words[x] |= E & 67108863, _ >= 18 ? (_ -= 18, x += 1, this.words[x] |= E >>> 26) : _ += 8;
        }
        this._strip();
      };
      function d(g, a, c, p) {
        for (var w = 0, _ = 0, x = Math.min(g.length, c), E = a; E < x; E++) {
          var y = g.charCodeAt(E) - 48;
          w *= p, y >= 49 ? _ = y - 49 + 10 : y >= 17 ? _ = y - 17 + 10 : _ = y, i(y >= 0 && _ < p, "Invalid character"), w += _;
        }
        return w;
      }
      n.prototype._parseBase = function(a, c, p) {
        this.words = [0], this.length = 1;
        for (var w = 0, _ = 1; _ <= 67108863; _ *= c)
          w++;
        w--, _ = _ / c | 0;
        for (var x = a.length - p, E = x % w, y = Math.min(x, x - E) + p, o = 0, S = p; S < y; S += w)
          o = d(a, S, S + w, c), this.imuln(_), this.words[0] + o < 67108864 ? this.words[0] += o : this._iaddn(o);
        if (E !== 0) {
          var J = 1;
          for (o = d(a, S, a.length, c), S = 0; S < E; S++)
            J *= c;
          this.imuln(J), this.words[0] + o < 67108864 ? this.words[0] += o : this._iaddn(o);
        }
        this._strip();
      }, n.prototype.copy = function(a) {
        a.words = new Array(this.length);
        for (var c = 0; c < this.length; c++)
          a.words[c] = this.words[c];
        a.length = this.length, a.negative = this.negative, a.red = this.red;
      };
      function l(g, a) {
        g.words = a.words, g.length = a.length, g.negative = a.negative, g.red = a.red;
      }
      if (n.prototype._move = function(a) {
        l(a, this);
      }, n.prototype.clone = function() {
        var a = new n(null);
        return this.copy(a), a;
      }, n.prototype._expand = function(a) {
        for (; this.length < a; )
          this.words[this.length++] = 0;
        return this;
      }, n.prototype._strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, n.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, typeof Symbol < "u" && typeof Symbol.for == "function")
        try {
          n.prototype[Symbol.for("nodejs.util.inspect.custom")] = m;
        } catch {
          n.prototype.inspect = m;
        }
      else
        n.prototype.inspect = m;
      function m() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      }
      var b = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], M = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], A = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      n.prototype.toString = function(a, c) {
        a = a || 10, c = c | 0 || 1;
        var p;
        if (a === 16 || a === "hex") {
          p = "";
          for (var w = 0, _ = 0, x = 0; x < this.length; x++) {
            var E = this.words[x], y = ((E << w | _) & 16777215).toString(16);
            _ = E >>> 24 - w & 16777215, _ !== 0 || x !== this.length - 1 ? p = b[6 - y.length] + y + p : p = y + p, w += 2, w >= 26 && (w -= 26, x--);
          }
          for (_ !== 0 && (p = _.toString(16) + p); p.length % c !== 0; )
            p = "0" + p;
          return this.negative !== 0 && (p = "-" + p), p;
        }
        if (a === (a | 0) && a >= 2 && a <= 36) {
          var o = M[a], S = A[a];
          p = "";
          var J = this.clone();
          for (J.negative = 0; !J.isZero(); ) {
            var z = J.modrn(S).toString(a);
            J = J.idivn(S), J.isZero() ? p = z + p : p = b[o - z.length] + z + p;
          }
          for (this.isZero() && (p = "0" + p); p.length % c !== 0; )
            p = "0" + p;
          return this.negative !== 0 && (p = "-" + p), p;
        }
        i(!1, "Base should be between 2 and 36");
      }, n.prototype.toNumber = function() {
        var a = this.words[0];
        return this.length === 2 ? a += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? a += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -a : a;
      }, n.prototype.toJSON = function() {
        return this.toString(16, 2);
      }, f && (n.prototype.toBuffer = function(a, c) {
        return this.toArrayLike(f, a, c);
      }), n.prototype.toArray = function(a, c) {
        return this.toArrayLike(Array, a, c);
      };
      var N = function(a, c) {
        return a.allocUnsafe ? a.allocUnsafe(c) : new a(c);
      };
      n.prototype.toArrayLike = function(a, c, p) {
        this._strip();
        var w = this.byteLength(), _ = p || Math.max(1, w);
        i(w <= _, "byte array longer than desired length"), i(_ > 0, "Requested array length <= 0");
        var x = N(a, _), E = c === "le" ? "LE" : "BE";
        return this["_toArrayLike" + E](x, w), x;
      }, n.prototype._toArrayLikeLE = function(a, c) {
        for (var p = 0, w = 0, _ = 0, x = 0; _ < this.length; _++) {
          var E = this.words[_] << x | w;
          a[p++] = E & 255, p < a.length && (a[p++] = E >> 8 & 255), p < a.length && (a[p++] = E >> 16 & 255), x === 6 ? (p < a.length && (a[p++] = E >> 24 & 255), w = 0, x = 0) : (w = E >>> 24, x += 2);
        }
        if (p < a.length)
          for (a[p++] = w; p < a.length; )
            a[p++] = 0;
      }, n.prototype._toArrayLikeBE = function(a, c) {
        for (var p = a.length - 1, w = 0, _ = 0, x = 0; _ < this.length; _++) {
          var E = this.words[_] << x | w;
          a[p--] = E & 255, p >= 0 && (a[p--] = E >> 8 & 255), p >= 0 && (a[p--] = E >> 16 & 255), x === 6 ? (p >= 0 && (a[p--] = E >> 24 & 255), w = 0, x = 0) : (w = E >>> 24, x += 2);
        }
        if (p >= 0)
          for (a[p--] = w; p >= 0; )
            a[p--] = 0;
      }, Math.clz32 ? n.prototype._countBits = function(a) {
        return 32 - Math.clz32(a);
      } : n.prototype._countBits = function(a) {
        var c = a, p = 0;
        return c >= 4096 && (p += 13, c >>>= 13), c >= 64 && (p += 7, c >>>= 7), c >= 8 && (p += 4, c >>>= 4), c >= 2 && (p += 2, c >>>= 2), p + c;
      }, n.prototype._zeroBits = function(a) {
        if (a === 0)
          return 26;
        var c = a, p = 0;
        return (c & 8191) === 0 && (p += 13, c >>>= 13), (c & 127) === 0 && (p += 7, c >>>= 7), (c & 15) === 0 && (p += 4, c >>>= 4), (c & 3) === 0 && (p += 2, c >>>= 2), (c & 1) === 0 && p++, p;
      }, n.prototype.bitLength = function() {
        var a = this.words[this.length - 1], c = this._countBits(a);
        return (this.length - 1) * 26 + c;
      };
      function R(g) {
        for (var a = new Array(g.bitLength()), c = 0; c < a.length; c++) {
          var p = c / 26 | 0, w = c % 26;
          a[c] = g.words[p] >>> w & 1;
        }
        return a;
      }
      n.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var a = 0, c = 0; c < this.length; c++) {
          var p = this._zeroBits(this.words[c]);
          if (a += p, p !== 26)
            break;
        }
        return a;
      }, n.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, n.prototype.toTwos = function(a) {
        return this.negative !== 0 ? this.abs().inotn(a).iaddn(1) : this.clone();
      }, n.prototype.fromTwos = function(a) {
        return this.testn(a - 1) ? this.notn(a).iaddn(1).ineg() : this.clone();
      }, n.prototype.isNeg = function() {
        return this.negative !== 0;
      }, n.prototype.neg = function() {
        return this.clone().ineg();
      }, n.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, n.prototype.iuor = function(a) {
        for (; this.length < a.length; )
          this.words[this.length++] = 0;
        for (var c = 0; c < a.length; c++)
          this.words[c] = this.words[c] | a.words[c];
        return this._strip();
      }, n.prototype.ior = function(a) {
        return i((this.negative | a.negative) === 0), this.iuor(a);
      }, n.prototype.or = function(a) {
        return this.length > a.length ? this.clone().ior(a) : a.clone().ior(this);
      }, n.prototype.uor = function(a) {
        return this.length > a.length ? this.clone().iuor(a) : a.clone().iuor(this);
      }, n.prototype.iuand = function(a) {
        var c;
        this.length > a.length ? c = a : c = this;
        for (var p = 0; p < c.length; p++)
          this.words[p] = this.words[p] & a.words[p];
        return this.length = c.length, this._strip();
      }, n.prototype.iand = function(a) {
        return i((this.negative | a.negative) === 0), this.iuand(a);
      }, n.prototype.and = function(a) {
        return this.length > a.length ? this.clone().iand(a) : a.clone().iand(this);
      }, n.prototype.uand = function(a) {
        return this.length > a.length ? this.clone().iuand(a) : a.clone().iuand(this);
      }, n.prototype.iuxor = function(a) {
        var c, p;
        this.length > a.length ? (c = this, p = a) : (c = a, p = this);
        for (var w = 0; w < p.length; w++)
          this.words[w] = c.words[w] ^ p.words[w];
        if (this !== c)
          for (; w < c.length; w++)
            this.words[w] = c.words[w];
        return this.length = c.length, this._strip();
      }, n.prototype.ixor = function(a) {
        return i((this.negative | a.negative) === 0), this.iuxor(a);
      }, n.prototype.xor = function(a) {
        return this.length > a.length ? this.clone().ixor(a) : a.clone().ixor(this);
      }, n.prototype.uxor = function(a) {
        return this.length > a.length ? this.clone().iuxor(a) : a.clone().iuxor(this);
      }, n.prototype.inotn = function(a) {
        i(typeof a == "number" && a >= 0);
        var c = Math.ceil(a / 26) | 0, p = a % 26;
        this._expand(c), p > 0 && c--;
        for (var w = 0; w < c; w++)
          this.words[w] = ~this.words[w] & 67108863;
        return p > 0 && (this.words[w] = ~this.words[w] & 67108863 >> 26 - p), this._strip();
      }, n.prototype.notn = function(a) {
        return this.clone().inotn(a);
      }, n.prototype.setn = function(a, c) {
        i(typeof a == "number" && a >= 0);
        var p = a / 26 | 0, w = a % 26;
        return this._expand(p + 1), c ? this.words[p] = this.words[p] | 1 << w : this.words[p] = this.words[p] & ~(1 << w), this._strip();
      }, n.prototype.iadd = function(a) {
        var c;
        if (this.negative !== 0 && a.negative === 0)
          return this.negative = 0, c = this.isub(a), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && a.negative !== 0)
          return a.negative = 0, c = this.isub(a), a.negative = 1, c._normSign();
        var p, w;
        this.length > a.length ? (p = this, w = a) : (p = a, w = this);
        for (var _ = 0, x = 0; x < w.length; x++)
          c = (p.words[x] | 0) + (w.words[x] | 0) + _, this.words[x] = c & 67108863, _ = c >>> 26;
        for (; _ !== 0 && x < p.length; x++)
          c = (p.words[x] | 0) + _, this.words[x] = c & 67108863, _ = c >>> 26;
        if (this.length = p.length, _ !== 0)
          this.words[this.length] = _, this.length++;
        else if (p !== this)
          for (; x < p.length; x++)
            this.words[x] = p.words[x];
        return this;
      }, n.prototype.add = function(a) {
        var c;
        return a.negative !== 0 && this.negative === 0 ? (a.negative = 0, c = this.sub(a), a.negative ^= 1, c) : a.negative === 0 && this.negative !== 0 ? (this.negative = 0, c = a.sub(this), this.negative = 1, c) : this.length > a.length ? this.clone().iadd(a) : a.clone().iadd(this);
      }, n.prototype.isub = function(a) {
        if (a.negative !== 0) {
          a.negative = 0;
          var c = this.iadd(a);
          return a.negative = 1, c._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(a), this.negative = 1, this._normSign();
        var p = this.cmp(a);
        if (p === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var w, _;
        p > 0 ? (w = this, _ = a) : (w = a, _ = this);
        for (var x = 0, E = 0; E < _.length; E++)
          c = (w.words[E] | 0) - (_.words[E] | 0) + x, x = c >> 26, this.words[E] = c & 67108863;
        for (; x !== 0 && E < w.length; E++)
          c = (w.words[E] | 0) + x, x = c >> 26, this.words[E] = c & 67108863;
        if (x === 0 && E < w.length && w !== this)
          for (; E < w.length; E++)
            this.words[E] = w.words[E];
        return this.length = Math.max(this.length, E), w !== this && (this.negative = 1), this._strip();
      }, n.prototype.sub = function(a) {
        return this.clone().isub(a);
      };
      function O(g, a, c) {
        c.negative = a.negative ^ g.negative;
        var p = g.length + a.length | 0;
        c.length = p, p = p - 1 | 0;
        var w = g.words[0] | 0, _ = a.words[0] | 0, x = w * _, E = x & 67108863, y = x / 67108864 | 0;
        c.words[0] = E;
        for (var o = 1; o < p; o++) {
          for (var S = y >>> 26, J = y & 67108863, z = Math.min(o, a.length - 1), k = Math.max(0, o - g.length + 1); k <= z; k++) {
            var j = o - k | 0;
            w = g.words[j] | 0, _ = a.words[k] | 0, x = w * _ + J, S += x / 67108864 | 0, J = x & 67108863;
          }
          c.words[o] = J | 0, y = S | 0;
        }
        return y !== 0 ? c.words[o] = y | 0 : c.length--, c._strip();
      }
      var P = function(a, c, p) {
        var w = a.words, _ = c.words, x = p.words, E = 0, y, o, S, J = w[0] | 0, z = J & 8191, k = J >>> 13, j = w[1] | 0, q = j & 8191, K = j >>> 13, U = w[2] | 0, T = U & 8191, D = U >>> 13, te = w[3] | 0, ne = te & 8191, le = te >>> 13, X = w[4] | 0, $ = X & 8191, V = X >>> 13, re = w[5] | 0, fe = re & 8191, ue = re >>> 13, me = w[6] | 0, be = me & 8191, ve = me >>> 13, Ge = w[7] | 0, ye = Ge & 8191, pe = Ge >>> 13, Je = w[8] | 0, Ie = Je & 8191, we = Je >>> 13, at = w[9] | 0, Oe = at & 8191, Ee = at >>> 13, ft = _[0] | 0, Le = ft & 8191, Pe = ft >>> 13, Mt = _[1] | 0, Ve = Mt & 8191, ke = Mt >>> 13, Et = _[2] | 0, Ke = Et & 8191, Be = Et >>> 13, dt = _[3] | 0, ze = dt & 8191, Te = dt >>> 13, pt = _[4] | 0, Fe = pt & 8191, Ae = pt >>> 13, bt = _[5] | 0, He = bt & 8191, Ne = bt >>> 13, yt = _[6] | 0, $e = yt & 8191, De = yt >>> 13, vt = _[7] | 0, je = vt & 8191, Ce = vt >>> 13, mt = _[8] | 0, Ze = mt & 8191, qe = mt >>> 13, Dt = _[9] | 0, We = Dt & 8191, Qe = Dt >>> 13;
        p.negative = a.negative ^ c.negative, p.length = 19, y = Math.imul(z, Le), o = Math.imul(z, Pe), o = o + Math.imul(k, Le) | 0, S = Math.imul(k, Pe);
        var Qt = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (Qt >>> 26) | 0, Qt &= 67108863, y = Math.imul(q, Le), o = Math.imul(q, Pe), o = o + Math.imul(K, Le) | 0, S = Math.imul(K, Pe), y = y + Math.imul(z, Ve) | 0, o = o + Math.imul(z, ke) | 0, o = o + Math.imul(k, Ve) | 0, S = S + Math.imul(k, ke) | 0;
        var Zt = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (Zt >>> 26) | 0, Zt &= 67108863, y = Math.imul(T, Le), o = Math.imul(T, Pe), o = o + Math.imul(D, Le) | 0, S = Math.imul(D, Pe), y = y + Math.imul(q, Ve) | 0, o = o + Math.imul(q, ke) | 0, o = o + Math.imul(K, Ve) | 0, S = S + Math.imul(K, ke) | 0, y = y + Math.imul(z, Ke) | 0, o = o + Math.imul(z, Be) | 0, o = o + Math.imul(k, Ke) | 0, S = S + Math.imul(k, Be) | 0;
        var Jt = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (Jt >>> 26) | 0, Jt &= 67108863, y = Math.imul(ne, Le), o = Math.imul(ne, Pe), o = o + Math.imul(le, Le) | 0, S = Math.imul(le, Pe), y = y + Math.imul(T, Ve) | 0, o = o + Math.imul(T, ke) | 0, o = o + Math.imul(D, Ve) | 0, S = S + Math.imul(D, ke) | 0, y = y + Math.imul(q, Ke) | 0, o = o + Math.imul(q, Be) | 0, o = o + Math.imul(K, Ke) | 0, S = S + Math.imul(K, Be) | 0, y = y + Math.imul(z, ze) | 0, o = o + Math.imul(z, Te) | 0, o = o + Math.imul(k, ze) | 0, S = S + Math.imul(k, Te) | 0;
        var Xt = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (Xt >>> 26) | 0, Xt &= 67108863, y = Math.imul($, Le), o = Math.imul($, Pe), o = o + Math.imul(V, Le) | 0, S = Math.imul(V, Pe), y = y + Math.imul(ne, Ve) | 0, o = o + Math.imul(ne, ke) | 0, o = o + Math.imul(le, Ve) | 0, S = S + Math.imul(le, ke) | 0, y = y + Math.imul(T, Ke) | 0, o = o + Math.imul(T, Be) | 0, o = o + Math.imul(D, Ke) | 0, S = S + Math.imul(D, Be) | 0, y = y + Math.imul(q, ze) | 0, o = o + Math.imul(q, Te) | 0, o = o + Math.imul(K, ze) | 0, S = S + Math.imul(K, Te) | 0, y = y + Math.imul(z, Fe) | 0, o = o + Math.imul(z, Ae) | 0, o = o + Math.imul(k, Fe) | 0, S = S + Math.imul(k, Ae) | 0;
        var kt = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, y = Math.imul(fe, Le), o = Math.imul(fe, Pe), o = o + Math.imul(ue, Le) | 0, S = Math.imul(ue, Pe), y = y + Math.imul($, Ve) | 0, o = o + Math.imul($, ke) | 0, o = o + Math.imul(V, Ve) | 0, S = S + Math.imul(V, ke) | 0, y = y + Math.imul(ne, Ke) | 0, o = o + Math.imul(ne, Be) | 0, o = o + Math.imul(le, Ke) | 0, S = S + Math.imul(le, Be) | 0, y = y + Math.imul(T, ze) | 0, o = o + Math.imul(T, Te) | 0, o = o + Math.imul(D, ze) | 0, S = S + Math.imul(D, Te) | 0, y = y + Math.imul(q, Fe) | 0, o = o + Math.imul(q, Ae) | 0, o = o + Math.imul(K, Fe) | 0, S = S + Math.imul(K, Ae) | 0, y = y + Math.imul(z, He) | 0, o = o + Math.imul(z, Ne) | 0, o = o + Math.imul(k, He) | 0, S = S + Math.imul(k, Ne) | 0;
        var ar = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (ar >>> 26) | 0, ar &= 67108863, y = Math.imul(be, Le), o = Math.imul(be, Pe), o = o + Math.imul(ve, Le) | 0, S = Math.imul(ve, Pe), y = y + Math.imul(fe, Ve) | 0, o = o + Math.imul(fe, ke) | 0, o = o + Math.imul(ue, Ve) | 0, S = S + Math.imul(ue, ke) | 0, y = y + Math.imul($, Ke) | 0, o = o + Math.imul($, Be) | 0, o = o + Math.imul(V, Ke) | 0, S = S + Math.imul(V, Be) | 0, y = y + Math.imul(ne, ze) | 0, o = o + Math.imul(ne, Te) | 0, o = o + Math.imul(le, ze) | 0, S = S + Math.imul(le, Te) | 0, y = y + Math.imul(T, Fe) | 0, o = o + Math.imul(T, Ae) | 0, o = o + Math.imul(D, Fe) | 0, S = S + Math.imul(D, Ae) | 0, y = y + Math.imul(q, He) | 0, o = o + Math.imul(q, Ne) | 0, o = o + Math.imul(K, He) | 0, S = S + Math.imul(K, Ne) | 0, y = y + Math.imul(z, $e) | 0, o = o + Math.imul(z, De) | 0, o = o + Math.imul(k, $e) | 0, S = S + Math.imul(k, De) | 0;
        var lr = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (lr >>> 26) | 0, lr &= 67108863, y = Math.imul(ye, Le), o = Math.imul(ye, Pe), o = o + Math.imul(pe, Le) | 0, S = Math.imul(pe, Pe), y = y + Math.imul(be, Ve) | 0, o = o + Math.imul(be, ke) | 0, o = o + Math.imul(ve, Ve) | 0, S = S + Math.imul(ve, ke) | 0, y = y + Math.imul(fe, Ke) | 0, o = o + Math.imul(fe, Be) | 0, o = o + Math.imul(ue, Ke) | 0, S = S + Math.imul(ue, Be) | 0, y = y + Math.imul($, ze) | 0, o = o + Math.imul($, Te) | 0, o = o + Math.imul(V, ze) | 0, S = S + Math.imul(V, Te) | 0, y = y + Math.imul(ne, Fe) | 0, o = o + Math.imul(ne, Ae) | 0, o = o + Math.imul(le, Fe) | 0, S = S + Math.imul(le, Ae) | 0, y = y + Math.imul(T, He) | 0, o = o + Math.imul(T, Ne) | 0, o = o + Math.imul(D, He) | 0, S = S + Math.imul(D, Ne) | 0, y = y + Math.imul(q, $e) | 0, o = o + Math.imul(q, De) | 0, o = o + Math.imul(K, $e) | 0, S = S + Math.imul(K, De) | 0, y = y + Math.imul(z, je) | 0, o = o + Math.imul(z, Ce) | 0, o = o + Math.imul(k, je) | 0, S = S + Math.imul(k, Ce) | 0;
        var or = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (or >>> 26) | 0, or &= 67108863, y = Math.imul(Ie, Le), o = Math.imul(Ie, Pe), o = o + Math.imul(we, Le) | 0, S = Math.imul(we, Pe), y = y + Math.imul(ye, Ve) | 0, o = o + Math.imul(ye, ke) | 0, o = o + Math.imul(pe, Ve) | 0, S = S + Math.imul(pe, ke) | 0, y = y + Math.imul(be, Ke) | 0, o = o + Math.imul(be, Be) | 0, o = o + Math.imul(ve, Ke) | 0, S = S + Math.imul(ve, Be) | 0, y = y + Math.imul(fe, ze) | 0, o = o + Math.imul(fe, Te) | 0, o = o + Math.imul(ue, ze) | 0, S = S + Math.imul(ue, Te) | 0, y = y + Math.imul($, Fe) | 0, o = o + Math.imul($, Ae) | 0, o = o + Math.imul(V, Fe) | 0, S = S + Math.imul(V, Ae) | 0, y = y + Math.imul(ne, He) | 0, o = o + Math.imul(ne, Ne) | 0, o = o + Math.imul(le, He) | 0, S = S + Math.imul(le, Ne) | 0, y = y + Math.imul(T, $e) | 0, o = o + Math.imul(T, De) | 0, o = o + Math.imul(D, $e) | 0, S = S + Math.imul(D, De) | 0, y = y + Math.imul(q, je) | 0, o = o + Math.imul(q, Ce) | 0, o = o + Math.imul(K, je) | 0, S = S + Math.imul(K, Ce) | 0, y = y + Math.imul(z, Ze) | 0, o = o + Math.imul(z, qe) | 0, o = o + Math.imul(k, Ze) | 0, S = S + Math.imul(k, qe) | 0;
        var dr = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (dr >>> 26) | 0, dr &= 67108863, y = Math.imul(Oe, Le), o = Math.imul(Oe, Pe), o = o + Math.imul(Ee, Le) | 0, S = Math.imul(Ee, Pe), y = y + Math.imul(Ie, Ve) | 0, o = o + Math.imul(Ie, ke) | 0, o = o + Math.imul(we, Ve) | 0, S = S + Math.imul(we, ke) | 0, y = y + Math.imul(ye, Ke) | 0, o = o + Math.imul(ye, Be) | 0, o = o + Math.imul(pe, Ke) | 0, S = S + Math.imul(pe, Be) | 0, y = y + Math.imul(be, ze) | 0, o = o + Math.imul(be, Te) | 0, o = o + Math.imul(ve, ze) | 0, S = S + Math.imul(ve, Te) | 0, y = y + Math.imul(fe, Fe) | 0, o = o + Math.imul(fe, Ae) | 0, o = o + Math.imul(ue, Fe) | 0, S = S + Math.imul(ue, Ae) | 0, y = y + Math.imul($, He) | 0, o = o + Math.imul($, Ne) | 0, o = o + Math.imul(V, He) | 0, S = S + Math.imul(V, Ne) | 0, y = y + Math.imul(ne, $e) | 0, o = o + Math.imul(ne, De) | 0, o = o + Math.imul(le, $e) | 0, S = S + Math.imul(le, De) | 0, y = y + Math.imul(T, je) | 0, o = o + Math.imul(T, Ce) | 0, o = o + Math.imul(D, je) | 0, S = S + Math.imul(D, Ce) | 0, y = y + Math.imul(q, Ze) | 0, o = o + Math.imul(q, qe) | 0, o = o + Math.imul(K, Ze) | 0, S = S + Math.imul(K, qe) | 0, y = y + Math.imul(z, We) | 0, o = o + Math.imul(z, Qe) | 0, o = o + Math.imul(k, We) | 0, S = S + Math.imul(k, Qe) | 0;
        var pr = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (pr >>> 26) | 0, pr &= 67108863, y = Math.imul(Oe, Ve), o = Math.imul(Oe, ke), o = o + Math.imul(Ee, Ve) | 0, S = Math.imul(Ee, ke), y = y + Math.imul(Ie, Ke) | 0, o = o + Math.imul(Ie, Be) | 0, o = o + Math.imul(we, Ke) | 0, S = S + Math.imul(we, Be) | 0, y = y + Math.imul(ye, ze) | 0, o = o + Math.imul(ye, Te) | 0, o = o + Math.imul(pe, ze) | 0, S = S + Math.imul(pe, Te) | 0, y = y + Math.imul(be, Fe) | 0, o = o + Math.imul(be, Ae) | 0, o = o + Math.imul(ve, Fe) | 0, S = S + Math.imul(ve, Ae) | 0, y = y + Math.imul(fe, He) | 0, o = o + Math.imul(fe, Ne) | 0, o = o + Math.imul(ue, He) | 0, S = S + Math.imul(ue, Ne) | 0, y = y + Math.imul($, $e) | 0, o = o + Math.imul($, De) | 0, o = o + Math.imul(V, $e) | 0, S = S + Math.imul(V, De) | 0, y = y + Math.imul(ne, je) | 0, o = o + Math.imul(ne, Ce) | 0, o = o + Math.imul(le, je) | 0, S = S + Math.imul(le, Ce) | 0, y = y + Math.imul(T, Ze) | 0, o = o + Math.imul(T, qe) | 0, o = o + Math.imul(D, Ze) | 0, S = S + Math.imul(D, qe) | 0, y = y + Math.imul(q, We) | 0, o = o + Math.imul(q, Qe) | 0, o = o + Math.imul(K, We) | 0, S = S + Math.imul(K, Qe) | 0;
        var fr = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (fr >>> 26) | 0, fr &= 67108863, y = Math.imul(Oe, Ke), o = Math.imul(Oe, Be), o = o + Math.imul(Ee, Ke) | 0, S = Math.imul(Ee, Be), y = y + Math.imul(Ie, ze) | 0, o = o + Math.imul(Ie, Te) | 0, o = o + Math.imul(we, ze) | 0, S = S + Math.imul(we, Te) | 0, y = y + Math.imul(ye, Fe) | 0, o = o + Math.imul(ye, Ae) | 0, o = o + Math.imul(pe, Fe) | 0, S = S + Math.imul(pe, Ae) | 0, y = y + Math.imul(be, He) | 0, o = o + Math.imul(be, Ne) | 0, o = o + Math.imul(ve, He) | 0, S = S + Math.imul(ve, Ne) | 0, y = y + Math.imul(fe, $e) | 0, o = o + Math.imul(fe, De) | 0, o = o + Math.imul(ue, $e) | 0, S = S + Math.imul(ue, De) | 0, y = y + Math.imul($, je) | 0, o = o + Math.imul($, Ce) | 0, o = o + Math.imul(V, je) | 0, S = S + Math.imul(V, Ce) | 0, y = y + Math.imul(ne, Ze) | 0, o = o + Math.imul(ne, qe) | 0, o = o + Math.imul(le, Ze) | 0, S = S + Math.imul(le, qe) | 0, y = y + Math.imul(T, We) | 0, o = o + Math.imul(T, Qe) | 0, o = o + Math.imul(D, We) | 0, S = S + Math.imul(D, Qe) | 0;
        var ur = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (ur >>> 26) | 0, ur &= 67108863, y = Math.imul(Oe, ze), o = Math.imul(Oe, Te), o = o + Math.imul(Ee, ze) | 0, S = Math.imul(Ee, Te), y = y + Math.imul(Ie, Fe) | 0, o = o + Math.imul(Ie, Ae) | 0, o = o + Math.imul(we, Fe) | 0, S = S + Math.imul(we, Ae) | 0, y = y + Math.imul(ye, He) | 0, o = o + Math.imul(ye, Ne) | 0, o = o + Math.imul(pe, He) | 0, S = S + Math.imul(pe, Ne) | 0, y = y + Math.imul(be, $e) | 0, o = o + Math.imul(be, De) | 0, o = o + Math.imul(ve, $e) | 0, S = S + Math.imul(ve, De) | 0, y = y + Math.imul(fe, je) | 0, o = o + Math.imul(fe, Ce) | 0, o = o + Math.imul(ue, je) | 0, S = S + Math.imul(ue, Ce) | 0, y = y + Math.imul($, Ze) | 0, o = o + Math.imul($, qe) | 0, o = o + Math.imul(V, Ze) | 0, S = S + Math.imul(V, qe) | 0, y = y + Math.imul(ne, We) | 0, o = o + Math.imul(ne, Qe) | 0, o = o + Math.imul(le, We) | 0, S = S + Math.imul(le, Qe) | 0;
        var hr = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (hr >>> 26) | 0, hr &= 67108863, y = Math.imul(Oe, Fe), o = Math.imul(Oe, Ae), o = o + Math.imul(Ee, Fe) | 0, S = Math.imul(Ee, Ae), y = y + Math.imul(Ie, He) | 0, o = o + Math.imul(Ie, Ne) | 0, o = o + Math.imul(we, He) | 0, S = S + Math.imul(we, Ne) | 0, y = y + Math.imul(ye, $e) | 0, o = o + Math.imul(ye, De) | 0, o = o + Math.imul(pe, $e) | 0, S = S + Math.imul(pe, De) | 0, y = y + Math.imul(be, je) | 0, o = o + Math.imul(be, Ce) | 0, o = o + Math.imul(ve, je) | 0, S = S + Math.imul(ve, Ce) | 0, y = y + Math.imul(fe, Ze) | 0, o = o + Math.imul(fe, qe) | 0, o = o + Math.imul(ue, Ze) | 0, S = S + Math.imul(ue, qe) | 0, y = y + Math.imul($, We) | 0, o = o + Math.imul($, Qe) | 0, o = o + Math.imul(V, We) | 0, S = S + Math.imul(V, Qe) | 0;
        var qt = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (qt >>> 26) | 0, qt &= 67108863, y = Math.imul(Oe, He), o = Math.imul(Oe, Ne), o = o + Math.imul(Ee, He) | 0, S = Math.imul(Ee, Ne), y = y + Math.imul(Ie, $e) | 0, o = o + Math.imul(Ie, De) | 0, o = o + Math.imul(we, $e) | 0, S = S + Math.imul(we, De) | 0, y = y + Math.imul(ye, je) | 0, o = o + Math.imul(ye, Ce) | 0, o = o + Math.imul(pe, je) | 0, S = S + Math.imul(pe, Ce) | 0, y = y + Math.imul(be, Ze) | 0, o = o + Math.imul(be, qe) | 0, o = o + Math.imul(ve, Ze) | 0, S = S + Math.imul(ve, qe) | 0, y = y + Math.imul(fe, We) | 0, o = o + Math.imul(fe, Qe) | 0, o = o + Math.imul(ue, We) | 0, S = S + Math.imul(ue, Qe) | 0;
        var Er = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (Er >>> 26) | 0, Er &= 67108863, y = Math.imul(Oe, $e), o = Math.imul(Oe, De), o = o + Math.imul(Ee, $e) | 0, S = Math.imul(Ee, De), y = y + Math.imul(Ie, je) | 0, o = o + Math.imul(Ie, Ce) | 0, o = o + Math.imul(we, je) | 0, S = S + Math.imul(we, Ce) | 0, y = y + Math.imul(ye, Ze) | 0, o = o + Math.imul(ye, qe) | 0, o = o + Math.imul(pe, Ze) | 0, S = S + Math.imul(pe, qe) | 0, y = y + Math.imul(be, We) | 0, o = o + Math.imul(be, Qe) | 0, o = o + Math.imul(ve, We) | 0, S = S + Math.imul(ve, Qe) | 0;
        var Ir = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (Ir >>> 26) | 0, Ir &= 67108863, y = Math.imul(Oe, je), o = Math.imul(Oe, Ce), o = o + Math.imul(Ee, je) | 0, S = Math.imul(Ee, Ce), y = y + Math.imul(Ie, Ze) | 0, o = o + Math.imul(Ie, qe) | 0, o = o + Math.imul(we, Ze) | 0, S = S + Math.imul(we, qe) | 0, y = y + Math.imul(ye, We) | 0, o = o + Math.imul(ye, Qe) | 0, o = o + Math.imul(pe, We) | 0, S = S + Math.imul(pe, Qe) | 0;
        var Ar = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (Ar >>> 26) | 0, Ar &= 67108863, y = Math.imul(Oe, Ze), o = Math.imul(Oe, qe), o = o + Math.imul(Ee, Ze) | 0, S = Math.imul(Ee, qe), y = y + Math.imul(Ie, We) | 0, o = o + Math.imul(Ie, Qe) | 0, o = o + Math.imul(we, We) | 0, S = S + Math.imul(we, Qe) | 0;
        var qr = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (qr >>> 26) | 0, qr &= 67108863, y = Math.imul(Oe, We), o = Math.imul(Oe, Qe), o = o + Math.imul(Ee, We) | 0, S = Math.imul(Ee, Qe);
        var zr = (E + y | 0) + ((o & 8191) << 13) | 0;
        return E = (S + (o >>> 13) | 0) + (zr >>> 26) | 0, zr &= 67108863, x[0] = Qt, x[1] = Zt, x[2] = Jt, x[3] = Xt, x[4] = kt, x[5] = ar, x[6] = lr, x[7] = or, x[8] = dr, x[9] = pr, x[10] = fr, x[11] = ur, x[12] = hr, x[13] = qt, x[14] = Er, x[15] = Ir, x[16] = Ar, x[17] = qr, x[18] = zr, E !== 0 && (x[19] = E, p.length++), p;
      };
      Math.imul || (P = O);
      function F(g, a, c) {
        c.negative = a.negative ^ g.negative, c.length = g.length + a.length;
        for (var p = 0, w = 0, _ = 0; _ < c.length - 1; _++) {
          var x = w;
          w = 0;
          for (var E = p & 67108863, y = Math.min(_, a.length - 1), o = Math.max(0, _ - g.length + 1); o <= y; o++) {
            var S = _ - o, J = g.words[S] | 0, z = a.words[o] | 0, k = J * z, j = k & 67108863;
            x = x + (k / 67108864 | 0) | 0, j = j + E | 0, E = j & 67108863, x = x + (j >>> 26) | 0, w += x >>> 26, x &= 67108863;
          }
          c.words[_] = E, p = x, x = w;
        }
        return p !== 0 ? c.words[_] = p : c.length--, c._strip();
      }
      function H(g, a, c) {
        return F(g, a, c);
      }
      n.prototype.mulTo = function(a, c) {
        var p, w = this.length + a.length;
        return this.length === 10 && a.length === 10 ? p = P(this, a, c) : w < 63 ? p = O(this, a, c) : w < 1024 ? p = F(this, a, c) : p = H(this, a, c), p;
      }, n.prototype.mul = function(a) {
        var c = new n(null);
        return c.words = new Array(this.length + a.length), this.mulTo(a, c);
      }, n.prototype.mulf = function(a) {
        var c = new n(null);
        return c.words = new Array(this.length + a.length), H(this, a, c);
      }, n.prototype.imul = function(a) {
        return this.clone().mulTo(a, this);
      }, n.prototype.imuln = function(a) {
        var c = a < 0;
        c && (a = -a), i(typeof a == "number"), i(a < 67108864);
        for (var p = 0, w = 0; w < this.length; w++) {
          var _ = (this.words[w] | 0) * a, x = (_ & 67108863) + (p & 67108863);
          p >>= 26, p += _ / 67108864 | 0, p += x >>> 26, this.words[w] = x & 67108863;
        }
        return p !== 0 && (this.words[w] = p, this.length++), c ? this.ineg() : this;
      }, n.prototype.muln = function(a) {
        return this.clone().imuln(a);
      }, n.prototype.sqr = function() {
        return this.mul(this);
      }, n.prototype.isqr = function() {
        return this.imul(this.clone());
      }, n.prototype.pow = function(a) {
        var c = R(a);
        if (c.length === 0)
          return new n(1);
        for (var p = this, w = 0; w < c.length && c[w] === 0; w++, p = p.sqr())
          ;
        if (++w < c.length)
          for (var _ = p.sqr(); w < c.length; w++, _ = _.sqr())
            c[w] !== 0 && (p = p.mul(_));
        return p;
      }, n.prototype.iushln = function(a) {
        i(typeof a == "number" && a >= 0);
        var c = a % 26, p = (a - c) / 26, w = 67108863 >>> 26 - c << 26 - c, _;
        if (c !== 0) {
          var x = 0;
          for (_ = 0; _ < this.length; _++) {
            var E = this.words[_] & w, y = (this.words[_] | 0) - E << c;
            this.words[_] = y | x, x = E >>> 26 - c;
          }
          x && (this.words[_] = x, this.length++);
        }
        if (p !== 0) {
          for (_ = this.length - 1; _ >= 0; _--)
            this.words[_ + p] = this.words[_];
          for (_ = 0; _ < p; _++)
            this.words[_] = 0;
          this.length += p;
        }
        return this._strip();
      }, n.prototype.ishln = function(a) {
        return i(this.negative === 0), this.iushln(a);
      }, n.prototype.iushrn = function(a, c, p) {
        i(typeof a == "number" && a >= 0);
        var w;
        c ? w = (c - c % 26) / 26 : w = 0;
        var _ = a % 26, x = Math.min((a - _) / 26, this.length), E = 67108863 ^ 67108863 >>> _ << _, y = p;
        if (w -= x, w = Math.max(0, w), y) {
          for (var o = 0; o < x; o++)
            y.words[o] = this.words[o];
          y.length = x;
        }
        if (x !== 0)
          if (this.length > x)
            for (this.length -= x, o = 0; o < this.length; o++)
              this.words[o] = this.words[o + x];
          else
            this.words[0] = 0, this.length = 1;
        var S = 0;
        for (o = this.length - 1; o >= 0 && (S !== 0 || o >= w); o--) {
          var J = this.words[o] | 0;
          this.words[o] = S << 26 - _ | J >>> _, S = J & E;
        }
        return y && S !== 0 && (y.words[y.length++] = S), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
      }, n.prototype.ishrn = function(a, c, p) {
        return i(this.negative === 0), this.iushrn(a, c, p);
      }, n.prototype.shln = function(a) {
        return this.clone().ishln(a);
      }, n.prototype.ushln = function(a) {
        return this.clone().iushln(a);
      }, n.prototype.shrn = function(a) {
        return this.clone().ishrn(a);
      }, n.prototype.ushrn = function(a) {
        return this.clone().iushrn(a);
      }, n.prototype.testn = function(a) {
        i(typeof a == "number" && a >= 0);
        var c = a % 26, p = (a - c) / 26, w = 1 << c;
        if (this.length <= p)
          return !1;
        var _ = this.words[p];
        return !!(_ & w);
      }, n.prototype.imaskn = function(a) {
        i(typeof a == "number" && a >= 0);
        var c = a % 26, p = (a - c) / 26;
        if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= p)
          return this;
        if (c !== 0 && p++, this.length = Math.min(p, this.length), c !== 0) {
          var w = 67108863 ^ 67108863 >>> c << c;
          this.words[this.length - 1] &= w;
        }
        return this._strip();
      }, n.prototype.maskn = function(a) {
        return this.clone().imaskn(a);
      }, n.prototype.iaddn = function(a) {
        return i(typeof a == "number"), i(a < 67108864), a < 0 ? this.isubn(-a) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= a ? (this.words[0] = a - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(a), this.negative = 1, this) : this._iaddn(a);
      }, n.prototype._iaddn = function(a) {
        this.words[0] += a;
        for (var c = 0; c < this.length && this.words[c] >= 67108864; c++)
          this.words[c] -= 67108864, c === this.length - 1 ? this.words[c + 1] = 1 : this.words[c + 1]++;
        return this.length = Math.max(this.length, c + 1), this;
      }, n.prototype.isubn = function(a) {
        if (i(typeof a == "number"), i(a < 67108864), a < 0)
          return this.iaddn(-a);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(a), this.negative = 1, this;
        if (this.words[0] -= a, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var c = 0; c < this.length && this.words[c] < 0; c++)
            this.words[c] += 67108864, this.words[c + 1] -= 1;
        return this._strip();
      }, n.prototype.addn = function(a) {
        return this.clone().iaddn(a);
      }, n.prototype.subn = function(a) {
        return this.clone().isubn(a);
      }, n.prototype.iabs = function() {
        return this.negative = 0, this;
      }, n.prototype.abs = function() {
        return this.clone().iabs();
      }, n.prototype._ishlnsubmul = function(a, c, p) {
        var w = a.length + p, _;
        this._expand(w);
        var x, E = 0;
        for (_ = 0; _ < a.length; _++) {
          x = (this.words[_ + p] | 0) + E;
          var y = (a.words[_] | 0) * c;
          x -= y & 67108863, E = (x >> 26) - (y / 67108864 | 0), this.words[_ + p] = x & 67108863;
        }
        for (; _ < this.length - p; _++)
          x = (this.words[_ + p] | 0) + E, E = x >> 26, this.words[_ + p] = x & 67108863;
        if (E === 0)
          return this._strip();
        for (i(E === -1), E = 0, _ = 0; _ < this.length; _++)
          x = -(this.words[_] | 0) + E, E = x >> 26, this.words[_] = x & 67108863;
        return this.negative = 1, this._strip();
      }, n.prototype._wordDiv = function(a, c) {
        var p = this.length - a.length, w = this.clone(), _ = a, x = _.words[_.length - 1] | 0, E = this._countBits(x);
        p = 26 - E, p !== 0 && (_ = _.ushln(p), w.iushln(p), x = _.words[_.length - 1] | 0);
        var y = w.length - _.length, o;
        if (c !== "mod") {
          o = new n(null), o.length = y + 1, o.words = new Array(o.length);
          for (var S = 0; S < o.length; S++)
            o.words[S] = 0;
        }
        var J = w.clone()._ishlnsubmul(_, 1, y);
        J.negative === 0 && (w = J, o && (o.words[y] = 1));
        for (var z = y - 1; z >= 0; z--) {
          var k = (w.words[_.length + z] | 0) * 67108864 + (w.words[_.length + z - 1] | 0);
          for (k = Math.min(k / x | 0, 67108863), w._ishlnsubmul(_, k, z); w.negative !== 0; )
            k--, w.negative = 0, w._ishlnsubmul(_, 1, z), w.isZero() || (w.negative ^= 1);
          o && (o.words[z] = k);
        }
        return o && o._strip(), w._strip(), c !== "div" && p !== 0 && w.iushrn(p), {
          div: o || null,
          mod: w
        };
      }, n.prototype.divmod = function(a, c, p) {
        if (i(!a.isZero()), this.isZero())
          return {
            div: new n(0),
            mod: new n(0)
          };
        var w, _, x;
        return this.negative !== 0 && a.negative === 0 ? (x = this.neg().divmod(a, c), c !== "mod" && (w = x.div.neg()), c !== "div" && (_ = x.mod.neg(), p && _.negative !== 0 && _.iadd(a)), {
          div: w,
          mod: _
        }) : this.negative === 0 && a.negative !== 0 ? (x = this.divmod(a.neg(), c), c !== "mod" && (w = x.div.neg()), {
          div: w,
          mod: x.mod
        }) : (this.negative & a.negative) !== 0 ? (x = this.neg().divmod(a.neg(), c), c !== "div" && (_ = x.mod.neg(), p && _.negative !== 0 && _.isub(a)), {
          div: x.div,
          mod: _
        }) : a.length > this.length || this.cmp(a) < 0 ? {
          div: new n(0),
          mod: this
        } : a.length === 1 ? c === "div" ? {
          div: this.divn(a.words[0]),
          mod: null
        } : c === "mod" ? {
          div: null,
          mod: new n(this.modrn(a.words[0]))
        } : {
          div: this.divn(a.words[0]),
          mod: new n(this.modrn(a.words[0]))
        } : this._wordDiv(a, c);
      }, n.prototype.div = function(a) {
        return this.divmod(a, "div", !1).div;
      }, n.prototype.mod = function(a) {
        return this.divmod(a, "mod", !1).mod;
      }, n.prototype.umod = function(a) {
        return this.divmod(a, "mod", !0).mod;
      }, n.prototype.divRound = function(a) {
        var c = this.divmod(a);
        if (c.mod.isZero())
          return c.div;
        var p = c.div.negative !== 0 ? c.mod.isub(a) : c.mod, w = a.ushrn(1), _ = a.andln(1), x = p.cmp(w);
        return x < 0 || _ === 1 && x === 0 ? c.div : c.div.negative !== 0 ? c.div.isubn(1) : c.div.iaddn(1);
      }, n.prototype.modrn = function(a) {
        var c = a < 0;
        c && (a = -a), i(a <= 67108863);
        for (var p = (1 << 26) % a, w = 0, _ = this.length - 1; _ >= 0; _--)
          w = (p * w + (this.words[_] | 0)) % a;
        return c ? -w : w;
      }, n.prototype.modn = function(a) {
        return this.modrn(a);
      }, n.prototype.idivn = function(a) {
        var c = a < 0;
        c && (a = -a), i(a <= 67108863);
        for (var p = 0, w = this.length - 1; w >= 0; w--) {
          var _ = (this.words[w] | 0) + p * 67108864;
          this.words[w] = _ / a | 0, p = _ % a;
        }
        return this._strip(), c ? this.ineg() : this;
      }, n.prototype.divn = function(a) {
        return this.clone().idivn(a);
      }, n.prototype.egcd = function(a) {
        i(a.negative === 0), i(!a.isZero());
        var c = this, p = a.clone();
        c.negative !== 0 ? c = c.umod(a) : c = c.clone();
        for (var w = new n(1), _ = new n(0), x = new n(0), E = new n(1), y = 0; c.isEven() && p.isEven(); )
          c.iushrn(1), p.iushrn(1), ++y;
        for (var o = p.clone(), S = c.clone(); !c.isZero(); ) {
          for (var J = 0, z = 1; (c.words[0] & z) === 0 && J < 26; ++J, z <<= 1)
            ;
          if (J > 0)
            for (c.iushrn(J); J-- > 0; )
              (w.isOdd() || _.isOdd()) && (w.iadd(o), _.isub(S)), w.iushrn(1), _.iushrn(1);
          for (var k = 0, j = 1; (p.words[0] & j) === 0 && k < 26; ++k, j <<= 1)
            ;
          if (k > 0)
            for (p.iushrn(k); k-- > 0; )
              (x.isOdd() || E.isOdd()) && (x.iadd(o), E.isub(S)), x.iushrn(1), E.iushrn(1);
          c.cmp(p) >= 0 ? (c.isub(p), w.isub(x), _.isub(E)) : (p.isub(c), x.isub(w), E.isub(_));
        }
        return {
          a: x,
          b: E,
          gcd: p.iushln(y)
        };
      }, n.prototype._invmp = function(a) {
        i(a.negative === 0), i(!a.isZero());
        var c = this, p = a.clone();
        c.negative !== 0 ? c = c.umod(a) : c = c.clone();
        for (var w = new n(1), _ = new n(0), x = p.clone(); c.cmpn(1) > 0 && p.cmpn(1) > 0; ) {
          for (var E = 0, y = 1; (c.words[0] & y) === 0 && E < 26; ++E, y <<= 1)
            ;
          if (E > 0)
            for (c.iushrn(E); E-- > 0; )
              w.isOdd() && w.iadd(x), w.iushrn(1);
          for (var o = 0, S = 1; (p.words[0] & S) === 0 && o < 26; ++o, S <<= 1)
            ;
          if (o > 0)
            for (p.iushrn(o); o-- > 0; )
              _.isOdd() && _.iadd(x), _.iushrn(1);
          c.cmp(p) >= 0 ? (c.isub(p), w.isub(_)) : (p.isub(c), _.isub(w));
        }
        var J;
        return c.cmpn(1) === 0 ? J = w : J = _, J.cmpn(0) < 0 && J.iadd(a), J;
      }, n.prototype.gcd = function(a) {
        if (this.isZero())
          return a.abs();
        if (a.isZero())
          return this.abs();
        var c = this.clone(), p = a.clone();
        c.negative = 0, p.negative = 0;
        for (var w = 0; c.isEven() && p.isEven(); w++)
          c.iushrn(1), p.iushrn(1);
        do {
          for (; c.isEven(); )
            c.iushrn(1);
          for (; p.isEven(); )
            p.iushrn(1);
          var _ = c.cmp(p);
          if (_ < 0) {
            var x = c;
            c = p, p = x;
          } else if (_ === 0 || p.cmpn(1) === 0)
            break;
          c.isub(p);
        } while (!0);
        return p.iushln(w);
      }, n.prototype.invm = function(a) {
        return this.egcd(a).a.umod(a);
      }, n.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, n.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, n.prototype.andln = function(a) {
        return this.words[0] & a;
      }, n.prototype.bincn = function(a) {
        i(typeof a == "number");
        var c = a % 26, p = (a - c) / 26, w = 1 << c;
        if (this.length <= p)
          return this._expand(p + 1), this.words[p] |= w, this;
        for (var _ = w, x = p; _ !== 0 && x < this.length; x++) {
          var E = this.words[x] | 0;
          E += _, _ = E >>> 26, E &= 67108863, this.words[x] = E;
        }
        return _ !== 0 && (this.words[x] = _, this.length++), this;
      }, n.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, n.prototype.cmpn = function(a) {
        var c = a < 0;
        if (this.negative !== 0 && !c)
          return -1;
        if (this.negative === 0 && c)
          return 1;
        this._strip();
        var p;
        if (this.length > 1)
          p = 1;
        else {
          c && (a = -a), i(a <= 67108863, "Number is too big");
          var w = this.words[0] | 0;
          p = w === a ? 0 : w < a ? -1 : 1;
        }
        return this.negative !== 0 ? -p | 0 : p;
      }, n.prototype.cmp = function(a) {
        if (this.negative !== 0 && a.negative === 0)
          return -1;
        if (this.negative === 0 && a.negative !== 0)
          return 1;
        var c = this.ucmp(a);
        return this.negative !== 0 ? -c | 0 : c;
      }, n.prototype.ucmp = function(a) {
        if (this.length > a.length)
          return 1;
        if (this.length < a.length)
          return -1;
        for (var c = 0, p = this.length - 1; p >= 0; p--) {
          var w = this.words[p] | 0, _ = a.words[p] | 0;
          if (w !== _) {
            w < _ ? c = -1 : w > _ && (c = 1);
            break;
          }
        }
        return c;
      }, n.prototype.gtn = function(a) {
        return this.cmpn(a) === 1;
      }, n.prototype.gt = function(a) {
        return this.cmp(a) === 1;
      }, n.prototype.gten = function(a) {
        return this.cmpn(a) >= 0;
      }, n.prototype.gte = function(a) {
        return this.cmp(a) >= 0;
      }, n.prototype.ltn = function(a) {
        return this.cmpn(a) === -1;
      }, n.prototype.lt = function(a) {
        return this.cmp(a) === -1;
      }, n.prototype.lten = function(a) {
        return this.cmpn(a) <= 0;
      }, n.prototype.lte = function(a) {
        return this.cmp(a) <= 0;
      }, n.prototype.eqn = function(a) {
        return this.cmpn(a) === 0;
      }, n.prototype.eq = function(a) {
        return this.cmp(a) === 0;
      }, n.red = function(a) {
        return new W(a);
      }, n.prototype.toRed = function(a) {
        return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), a.convertTo(this)._forceRed(a);
      }, n.prototype.fromRed = function() {
        return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, n.prototype._forceRed = function(a) {
        return this.red = a, this;
      }, n.prototype.forceRed = function(a) {
        return i(!this.red, "Already a number in reduction context"), this._forceRed(a);
      }, n.prototype.redAdd = function(a) {
        return i(this.red, "redAdd works only with red numbers"), this.red.add(this, a);
      }, n.prototype.redIAdd = function(a) {
        return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, a);
      }, n.prototype.redSub = function(a) {
        return i(this.red, "redSub works only with red numbers"), this.red.sub(this, a);
      }, n.prototype.redISub = function(a) {
        return i(this.red, "redISub works only with red numbers"), this.red.isub(this, a);
      }, n.prototype.redShl = function(a) {
        return i(this.red, "redShl works only with red numbers"), this.red.shl(this, a);
      }, n.prototype.redMul = function(a) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, a), this.red.mul(this, a);
      }, n.prototype.redIMul = function(a) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, a), this.red.imul(this, a);
      }, n.prototype.redSqr = function() {
        return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, n.prototype.redISqr = function() {
        return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, n.prototype.redSqrt = function() {
        return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, n.prototype.redInvm = function() {
        return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, n.prototype.redNeg = function() {
        return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, n.prototype.redPow = function(a) {
        return i(this.red && !a.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, a);
      };
      var Q = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Z(g, a) {
        this.name = g, this.p = new n(a, 16), this.n = this.p.bitLength(), this.k = new n(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Z.prototype._tmp = function() {
        var a = new n(null);
        return a.words = new Array(Math.ceil(this.n / 13)), a;
      }, Z.prototype.ireduce = function(a) {
        var c = a, p;
        do
          this.split(c, this.tmp), c = this.imulK(c), c = c.iadd(this.tmp), p = c.bitLength();
        while (p > this.n);
        var w = p < this.n ? -1 : c.ucmp(this.p);
        return w === 0 ? (c.words[0] = 0, c.length = 1) : w > 0 ? c.isub(this.p) : c.strip !== void 0 ? c.strip() : c._strip(), c;
      }, Z.prototype.split = function(a, c) {
        a.iushrn(this.n, 0, c);
      }, Z.prototype.imulK = function(a) {
        return a.imul(this.k);
      };
      function B() {
        Z.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      s(B, Z), B.prototype.split = function(a, c) {
        for (var p = 4194303, w = Math.min(a.length, 9), _ = 0; _ < w; _++)
          c.words[_] = a.words[_];
        if (c.length = w, a.length <= 9) {
          a.words[0] = 0, a.length = 1;
          return;
        }
        var x = a.words[9];
        for (c.words[c.length++] = x & p, _ = 10; _ < a.length; _++) {
          var E = a.words[_] | 0;
          a.words[_ - 10] = (E & p) << 4 | x >>> 22, x = E;
        }
        x >>>= 22, a.words[_ - 10] = x, x === 0 && a.length > 10 ? a.length -= 10 : a.length -= 9;
      }, B.prototype.imulK = function(a) {
        a.words[a.length] = 0, a.words[a.length + 1] = 0, a.length += 2;
        for (var c = 0, p = 0; p < a.length; p++) {
          var w = a.words[p] | 0;
          c += w * 977, a.words[p] = c & 67108863, c = w * 64 + (c / 67108864 | 0);
        }
        return a.words[a.length - 1] === 0 && (a.length--, a.words[a.length - 1] === 0 && a.length--), a;
      };
      function Y() {
        Z.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      s(Y, Z);
      function ae() {
        Z.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      s(ae, Z);
      function se() {
        Z.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      s(se, Z), se.prototype.imulK = function(a) {
        for (var c = 0, p = 0; p < a.length; p++) {
          var w = (a.words[p] | 0) * 19 + c, _ = w & 67108863;
          w >>>= 26, a.words[p] = _, c = w;
        }
        return c !== 0 && (a.words[a.length++] = c), a;
      }, n._prime = function(a) {
        if (Q[a])
          return Q[a];
        var c;
        if (a === "k256")
          c = new B();
        else if (a === "p224")
          c = new Y();
        else if (a === "p192")
          c = new ae();
        else if (a === "p25519")
          c = new se();
        else
          throw new Error("Unknown prime " + a);
        return Q[a] = c, c;
      };
      function W(g) {
        if (typeof g == "string") {
          var a = n._prime(g);
          this.m = a.p, this.prime = a;
        } else
          i(g.gtn(1), "modulus must be greater than 1"), this.m = g, this.prime = null;
      }
      W.prototype._verify1 = function(a) {
        i(a.negative === 0, "red works only with positives"), i(a.red, "red works only with red numbers");
      }, W.prototype._verify2 = function(a, c) {
        i((a.negative | c.negative) === 0, "red works only with positives"), i(
          a.red && a.red === c.red,
          "red works only with red numbers"
        );
      }, W.prototype.imod = function(a) {
        return this.prime ? this.prime.ireduce(a)._forceRed(this) : (l(a, a.umod(this.m)._forceRed(this)), a);
      }, W.prototype.neg = function(a) {
        return a.isZero() ? a.clone() : this.m.sub(a)._forceRed(this);
      }, W.prototype.add = function(a, c) {
        this._verify2(a, c);
        var p = a.add(c);
        return p.cmp(this.m) >= 0 && p.isub(this.m), p._forceRed(this);
      }, W.prototype.iadd = function(a, c) {
        this._verify2(a, c);
        var p = a.iadd(c);
        return p.cmp(this.m) >= 0 && p.isub(this.m), p;
      }, W.prototype.sub = function(a, c) {
        this._verify2(a, c);
        var p = a.sub(c);
        return p.cmpn(0) < 0 && p.iadd(this.m), p._forceRed(this);
      }, W.prototype.isub = function(a, c) {
        this._verify2(a, c);
        var p = a.isub(c);
        return p.cmpn(0) < 0 && p.iadd(this.m), p;
      }, W.prototype.shl = function(a, c) {
        return this._verify1(a), this.imod(a.ushln(c));
      }, W.prototype.imul = function(a, c) {
        return this._verify2(a, c), this.imod(a.imul(c));
      }, W.prototype.mul = function(a, c) {
        return this._verify2(a, c), this.imod(a.mul(c));
      }, W.prototype.isqr = function(a) {
        return this.imul(a, a.clone());
      }, W.prototype.sqr = function(a) {
        return this.mul(a, a);
      }, W.prototype.sqrt = function(a) {
        if (a.isZero())
          return a.clone();
        var c = this.m.andln(3);
        if (i(c % 2 === 1), c === 3) {
          var p = this.m.add(new n(1)).iushrn(2);
          return this.pow(a, p);
        }
        for (var w = this.m.subn(1), _ = 0; !w.isZero() && w.andln(1) === 0; )
          _++, w.iushrn(1);
        i(!w.isZero());
        var x = new n(1).toRed(this), E = x.redNeg(), y = this.m.subn(1).iushrn(1), o = this.m.bitLength();
        for (o = new n(2 * o * o).toRed(this); this.pow(o, y).cmp(E) !== 0; )
          o.redIAdd(E);
        for (var S = this.pow(o, w), J = this.pow(a, w.addn(1).iushrn(1)), z = this.pow(a, w), k = _; z.cmp(x) !== 0; ) {
          for (var j = z, q = 0; j.cmp(x) !== 0; q++)
            j = j.redSqr();
          i(q < k);
          var K = this.pow(S, new n(1).iushln(k - q - 1));
          J = J.redMul(K), S = K.redSqr(), z = z.redMul(S), k = q;
        }
        return J;
      }, W.prototype.invm = function(a) {
        var c = a._invmp(this.m);
        return c.negative !== 0 ? (c.negative = 0, this.imod(c).redNeg()) : this.imod(c);
      }, W.prototype.pow = function(a, c) {
        if (c.isZero())
          return new n(1).toRed(this);
        if (c.cmpn(1) === 0)
          return a.clone();
        var p = 4, w = new Array(1 << p);
        w[0] = new n(1).toRed(this), w[1] = a;
        for (var _ = 2; _ < w.length; _++)
          w[_] = this.mul(w[_ - 1], a);
        var x = w[0], E = 0, y = 0, o = c.bitLength() % 26;
        for (o === 0 && (o = 26), _ = c.length - 1; _ >= 0; _--) {
          for (var S = c.words[_], J = o - 1; J >= 0; J--) {
            var z = S >> J & 1;
            if (x !== w[0] && (x = this.sqr(x)), z === 0 && E === 0) {
              y = 0;
              continue;
            }
            E <<= 1, E |= z, y++, !(y !== p && (_ !== 0 || J !== 0)) && (x = this.mul(x, w[E]), y = 0, E = 0);
          }
          o = 26;
        }
        return x;
      }, W.prototype.convertTo = function(a) {
        var c = a.umod(this.m);
        return c === a ? c.clone() : c;
      }, W.prototype.convertFrom = function(a) {
        var c = a.clone();
        return c.red = null, c;
      }, n.mont = function(a) {
        return new C(a);
      };
      function C(g) {
        W.call(this, g), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new n(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      s(C, W), C.prototype.convertTo = function(a) {
        return this.imod(a.ushln(this.shift));
      }, C.prototype.convertFrom = function(a) {
        var c = this.imod(a.mul(this.rinv));
        return c.red = null, c;
      }, C.prototype.imul = function(a, c) {
        if (a.isZero() || c.isZero())
          return a.words[0] = 0, a.length = 1, a;
        var p = a.imul(c), w = p.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _ = p.isub(w).iushrn(this.shift), x = _;
        return _.cmp(this.m) >= 0 ? x = _.isub(this.m) : _.cmpn(0) < 0 && (x = _.iadd(this.m)), x._forceRed(this);
      }, C.prototype.mul = function(a, c) {
        if (a.isZero() || c.isZero())
          return new n(0)._forceRed(this);
        var p = a.mul(c), w = p.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _ = p.isub(w).iushrn(this.shift), x = _;
        return _.cmp(this.m) >= 0 ? x = _.isub(this.m) : _.cmpn(0) < 0 && (x = _.iadd(this.m)), x._forceRed(this);
      }, C.prototype.invm = function(a) {
        var c = this.imod(a._invmp(this.m).mul(this.r2));
        return c._forceRed(this);
      };
    })(t, nt);
  }(Bb)), Bb.exports;
}
var zb, jM;
function bw() {
  if (jM)
    return zb;
  jM = 1;
  var t = Zte(), e = Jc();
  function r(n) {
    var f = i(n), u = f.toRed(t.mont(n.modulus)).redPow(new t(n.publicExponent)).fromRed();
    return { blinder: u, unblinder: f.invm(n.modulus) };
  }
  function i(n) {
    var f = n.modulus.byteLength(), u;
    do
      u = new t(e(f));
    while (u.cmp(n.modulus) >= 0 || !u.umod(n.prime1) || !u.umod(n.prime2));
    return u;
  }
  function s(n, f) {
    var u = r(f), h = f.modulus.byteLength(), d = new t(n).mul(u.blinder).umod(f.modulus), l = d.toRed(t.mont(f.prime1)), m = d.toRed(t.mont(f.prime2)), b = f.coefficient, M = f.prime1, A = f.prime2, N = l.redPow(f.exponent1).fromRed(), R = m.redPow(f.exponent2).fromRed(), O = N.isub(R).imul(b).umod(M).imul(A);
    return R.iadd(O).imul(u.unblinder).umod(f.modulus).toArrayLike(Buffer, "be", h);
  }
  return s.getr = i, zb = s, zb;
}
var Ub = {};
const Jte = "elliptic", Xte = "6.5.4", ere = "EC cryptography", tre = "lib/elliptic.js", rre = [
  "lib"
], ire = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, nre = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, sre = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], are = "Fedor Indutny <fedor@indutny.com>", ore = "MIT", fre = {
  url: "https://github.com/indutny/elliptic/issues"
}, cre = "https://github.com/indutny/elliptic", ure = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, hre = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, lre = {
  name: Jte,
  version: Xte,
  description: ere,
  main: tre,
  files: rre,
  scripts: ire,
  repository: nre,
  keywords: sre,
  author: are,
  license: ore,
  bugs: fre,
  homepage: cre,
  devDependencies: ure,
  dependencies: hre
};
var Fb = {}, Vp = {};
(function(t) {
  var e = t;
  function r(n, f) {
    if (Array.isArray(n))
      return n.slice();
    if (!n)
      return [];
    var u = [];
    if (typeof n != "string") {
      for (var h = 0; h < n.length; h++)
        u[h] = n[h] | 0;
      return u;
    }
    if (f === "hex") {
      n = n.replace(/[^a-z0-9]+/ig, ""), n.length % 2 !== 0 && (n = "0" + n);
      for (var h = 0; h < n.length; h += 2)
        u.push(parseInt(n[h] + n[h + 1], 16));
    } else
      for (var h = 0; h < n.length; h++) {
        var d = n.charCodeAt(h), l = d >> 8, m = d & 255;
        l ? u.push(l, m) : u.push(m);
      }
    return u;
  }
  e.toArray = r;
  function i(n) {
    return n.length === 1 ? "0" + n : n;
  }
  e.zero2 = i;
  function s(n) {
    for (var f = "", u = 0; u < n.length; u++)
      f += i(n[u].toString(16));
    return f;
  }
  e.toHex = s, e.encode = function(f, u) {
    return u === "hex" ? s(f) : f;
  };
})(Vp);
var BM;
function fs() {
  return BM || (BM = 1, function(t) {
    var e = t, r = Sr.exports, i = Nn, s = Vp;
    e.assert = i, e.toArray = s.toArray, e.zero2 = s.zero2, e.toHex = s.toHex, e.encode = s.encode;
    function n(l, m, b) {
      var M = new Array(Math.max(l.bitLength(), b) + 1);
      M.fill(0);
      for (var A = 1 << m + 1, N = l.clone(), R = 0; R < M.length; R++) {
        var O, P = N.andln(A - 1);
        N.isOdd() ? (P > (A >> 1) - 1 ? O = (A >> 1) - P : O = P, N.isubn(O)) : O = 0, M[R] = O, N.iushrn(1);
      }
      return M;
    }
    e.getNAF = n;
    function f(l, m) {
      var b = [
        [],
        []
      ];
      l = l.clone(), m = m.clone();
      for (var M = 0, A = 0, N; l.cmpn(-M) > 0 || m.cmpn(-A) > 0; ) {
        var R = l.andln(3) + M & 3, O = m.andln(3) + A & 3;
        R === 3 && (R = -1), O === 3 && (O = -1);
        var P;
        (R & 1) === 0 ? P = 0 : (N = l.andln(7) + M & 7, (N === 3 || N === 5) && O === 2 ? P = -R : P = R), b[0].push(P);
        var F;
        (O & 1) === 0 ? F = 0 : (N = m.andln(7) + A & 7, (N === 3 || N === 5) && R === 2 ? F = -O : F = O), b[1].push(F), 2 * M === P + 1 && (M = 1 - M), 2 * A === F + 1 && (A = 1 - A), l.iushrn(1), m.iushrn(1);
      }
      return b;
    }
    e.getJSF = f;
    function u(l, m, b) {
      var M = "_" + m;
      l.prototype[m] = function() {
        return this[M] !== void 0 ? this[M] : this[M] = b.call(this);
      };
    }
    e.cachedProperty = u;
    function h(l) {
      return typeof l == "string" ? e.toArray(l, "hex") : l;
    }
    e.parseBytes = h;
    function d(l) {
      return new r(l, "hex", "le");
    }
    e.intFromLE = d;
  }(Fb)), Fb;
}
var $b = {}, qb, zM;
function Gp() {
  if (zM)
    return qb;
  zM = 1;
  var t = Sr.exports, e = fs(), r = e.getNAF, i = e.getJSF, s = e.assert;
  function n(u, h) {
    this.type = u, this.p = new t(h.p, 16), this.red = h.prime ? t.red(h.prime) : t.mont(this.p), this.zero = new t(0).toRed(this.red), this.one = new t(1).toRed(this.red), this.two = new t(2).toRed(this.red), this.n = h.n && new t(h.n, 16), this.g = h.g && this.pointFromJSON(h.g, h.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var d = this.n && this.p.div(this.n);
    !d || d.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
  }
  qb = n, n.prototype.point = function() {
    throw new Error("Not implemented");
  }, n.prototype.validate = function() {
    throw new Error("Not implemented");
  }, n.prototype._fixedNafMul = function(h, d) {
    s(h.precomputed);
    var l = h._getDoubles(), m = r(d, 1, this._bitLength), b = (1 << l.step + 1) - (l.step % 2 === 0 ? 2 : 1);
    b /= 3;
    var M = [], A, N;
    for (A = 0; A < m.length; A += l.step) {
      N = 0;
      for (var R = A + l.step - 1; R >= A; R--)
        N = (N << 1) + m[R];
      M.push(N);
    }
    for (var O = this.jpoint(null, null, null), P = this.jpoint(null, null, null), F = b; F > 0; F--) {
      for (A = 0; A < M.length; A++)
        N = M[A], N === F ? P = P.mixedAdd(l.points[A]) : N === -F && (P = P.mixedAdd(l.points[A].neg()));
      O = O.add(P);
    }
    return O.toP();
  }, n.prototype._wnafMul = function(h, d) {
    var l = 4, m = h._getNAFPoints(l);
    l = m.wnd;
    for (var b = m.points, M = r(d, l, this._bitLength), A = this.jpoint(null, null, null), N = M.length - 1; N >= 0; N--) {
      for (var R = 0; N >= 0 && M[N] === 0; N--)
        R++;
      if (N >= 0 && R++, A = A.dblp(R), N < 0)
        break;
      var O = M[N];
      s(O !== 0), h.type === "affine" ? O > 0 ? A = A.mixedAdd(b[O - 1 >> 1]) : A = A.mixedAdd(b[-O - 1 >> 1].neg()) : O > 0 ? A = A.add(b[O - 1 >> 1]) : A = A.add(b[-O - 1 >> 1].neg());
    }
    return h.type === "affine" ? A.toP() : A;
  }, n.prototype._wnafMulAdd = function(h, d, l, m, b) {
    var M = this._wnafT1, A = this._wnafT2, N = this._wnafT3, R = 0, O, P, F;
    for (O = 0; O < m; O++) {
      F = d[O];
      var H = F._getNAFPoints(h);
      M[O] = H.wnd, A[O] = H.points;
    }
    for (O = m - 1; O >= 1; O -= 2) {
      var Q = O - 1, Z = O;
      if (M[Q] !== 1 || M[Z] !== 1) {
        N[Q] = r(l[Q], M[Q], this._bitLength), N[Z] = r(l[Z], M[Z], this._bitLength), R = Math.max(N[Q].length, R), R = Math.max(N[Z].length, R);
        continue;
      }
      var B = [
        d[Q],
        null,
        null,
        d[Z]
      ];
      d[Q].y.cmp(d[Z].y) === 0 ? (B[1] = d[Q].add(d[Z]), B[2] = d[Q].toJ().mixedAdd(d[Z].neg())) : d[Q].y.cmp(d[Z].y.redNeg()) === 0 ? (B[1] = d[Q].toJ().mixedAdd(d[Z]), B[2] = d[Q].add(d[Z].neg())) : (B[1] = d[Q].toJ().mixedAdd(d[Z]), B[2] = d[Q].toJ().mixedAdd(d[Z].neg()));
      var Y = [
        -3,
        -1,
        -5,
        -7,
        0,
        7,
        5,
        1,
        3
      ], ae = i(l[Q], l[Z]);
      for (R = Math.max(ae[0].length, R), N[Q] = new Array(R), N[Z] = new Array(R), P = 0; P < R; P++) {
        var se = ae[0][P] | 0, W = ae[1][P] | 0;
        N[Q][P] = Y[(se + 1) * 3 + (W + 1)], N[Z][P] = 0, A[Q] = B;
      }
    }
    var C = this.jpoint(null, null, null), g = this._wnafT4;
    for (O = R; O >= 0; O--) {
      for (var a = 0; O >= 0; ) {
        var c = !0;
        for (P = 0; P < m; P++)
          g[P] = N[P][O] | 0, g[P] !== 0 && (c = !1);
        if (!c)
          break;
        a++, O--;
      }
      if (O >= 0 && a++, C = C.dblp(a), O < 0)
        break;
      for (P = 0; P < m; P++) {
        var p = g[P];
        p !== 0 && (p > 0 ? F = A[P][p - 1 >> 1] : p < 0 && (F = A[P][-p - 1 >> 1].neg()), F.type === "affine" ? C = C.mixedAdd(F) : C = C.add(F));
      }
    }
    for (O = 0; O < m; O++)
      A[O] = null;
    return b ? C : C.toP();
  };
  function f(u, h) {
    this.curve = u, this.type = h, this.precomputed = null;
  }
  return n.BasePoint = f, f.prototype.eq = function() {
    throw new Error("Not implemented");
  }, f.prototype.validate = function() {
    return this.curve.validate(this);
  }, n.prototype.decodePoint = function(h, d) {
    h = e.toArray(h, d);
    var l = this.p.byteLength();
    if ((h[0] === 4 || h[0] === 6 || h[0] === 7) && h.length - 1 === 2 * l) {
      h[0] === 6 ? s(h[h.length - 1] % 2 === 0) : h[0] === 7 && s(h[h.length - 1] % 2 === 1);
      var m = this.point(
        h.slice(1, 1 + l),
        h.slice(1 + l, 1 + 2 * l)
      );
      return m;
    } else if ((h[0] === 2 || h[0] === 3) && h.length - 1 === l)
      return this.pointFromX(h.slice(1, 1 + l), h[0] === 3);
    throw new Error("Unknown point format");
  }, f.prototype.encodeCompressed = function(h) {
    return this.encode(h, !0);
  }, f.prototype._encode = function(h) {
    var d = this.curve.p.byteLength(), l = this.getX().toArray("be", d);
    return h ? [this.getY().isEven() ? 2 : 3].concat(l) : [4].concat(l, this.getY().toArray("be", d));
  }, f.prototype.encode = function(h, d) {
    return e.encode(this._encode(d), h);
  }, f.prototype.precompute = function(h) {
    if (this.precomputed)
      return this;
    var d = {
      doubles: null,
      naf: null,
      beta: null
    };
    return d.naf = this._getNAFPoints(8), d.doubles = this._getDoubles(4, h), d.beta = this._getBeta(), this.precomputed = d, this;
  }, f.prototype._hasDoubles = function(h) {
    if (!this.precomputed)
      return !1;
    var d = this.precomputed.doubles;
    return d ? d.points.length >= Math.ceil((h.bitLength() + 1) / d.step) : !1;
  }, f.prototype._getDoubles = function(h, d) {
    if (this.precomputed && this.precomputed.doubles)
      return this.precomputed.doubles;
    for (var l = [this], m = this, b = 0; b < d; b += h) {
      for (var M = 0; M < h; M++)
        m = m.dbl();
      l.push(m);
    }
    return {
      step: h,
      points: l
    };
  }, f.prototype._getNAFPoints = function(h) {
    if (this.precomputed && this.precomputed.naf)
      return this.precomputed.naf;
    for (var d = [this], l = (1 << h) - 1, m = l === 1 ? null : this.dbl(), b = 1; b < l; b++)
      d[b] = d[b - 1].add(m);
    return {
      wnd: h,
      points: d
    };
  }, f.prototype._getBeta = function() {
    return null;
  }, f.prototype.dblp = function(h) {
    for (var d = this, l = 0; l < h; l++)
      d = d.dbl();
    return d;
  }, qb;
}
var Hb, UM;
function dre() {
  if (UM)
    return Hb;
  UM = 1;
  var t = fs(), e = Sr.exports, r = It.exports, i = Gp(), s = t.assert;
  function n(h) {
    i.call(this, "short", h), this.a = new e(h.a, 16).toRed(this.red), this.b = new e(h.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(h), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
  }
  r(n, i), Hb = n, n.prototype._getEndomorphism = function(d) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
      var l, m;
      if (d.beta)
        l = new e(d.beta, 16).toRed(this.red);
      else {
        var b = this._getEndoRoots(this.p);
        l = b[0].cmp(b[1]) < 0 ? b[0] : b[1], l = l.toRed(this.red);
      }
      if (d.lambda)
        m = new e(d.lambda, 16);
      else {
        var M = this._getEndoRoots(this.n);
        this.g.mul(M[0]).x.cmp(this.g.x.redMul(l)) === 0 ? m = M[0] : (m = M[1], s(this.g.mul(m).x.cmp(this.g.x.redMul(l)) === 0));
      }
      var A;
      return d.basis ? A = d.basis.map(function(N) {
        return {
          a: new e(N.a, 16),
          b: new e(N.b, 16)
        };
      }) : A = this._getEndoBasis(m), {
        beta: l,
        lambda: m,
        basis: A
      };
    }
  }, n.prototype._getEndoRoots = function(d) {
    var l = d === this.p ? this.red : e.mont(d), m = new e(2).toRed(l).redInvm(), b = m.redNeg(), M = new e(3).toRed(l).redNeg().redSqrt().redMul(m), A = b.redAdd(M).fromRed(), N = b.redSub(M).fromRed();
    return [A, N];
  }, n.prototype._getEndoBasis = function(d) {
    for (var l = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), m = d, b = this.n.clone(), M = new e(1), A = new e(0), N = new e(0), R = new e(1), O, P, F, H, Q, Z, B, Y = 0, ae, se; m.cmpn(0) !== 0; ) {
      var W = b.div(m);
      ae = b.sub(W.mul(m)), se = N.sub(W.mul(M));
      var C = R.sub(W.mul(A));
      if (!F && ae.cmp(l) < 0)
        O = B.neg(), P = M, F = ae.neg(), H = se;
      else if (F && ++Y === 2)
        break;
      B = ae, b = m, m = ae, N = M, M = se, R = A, A = C;
    }
    Q = ae.neg(), Z = se;
    var g = F.sqr().add(H.sqr()), a = Q.sqr().add(Z.sqr());
    return a.cmp(g) >= 0 && (Q = O, Z = P), F.negative && (F = F.neg(), H = H.neg()), Q.negative && (Q = Q.neg(), Z = Z.neg()), [
      { a: F, b: H },
      { a: Q, b: Z }
    ];
  }, n.prototype._endoSplit = function(d) {
    var l = this.endo.basis, m = l[0], b = l[1], M = b.b.mul(d).divRound(this.n), A = m.b.neg().mul(d).divRound(this.n), N = M.mul(m.a), R = A.mul(b.a), O = M.mul(m.b), P = A.mul(b.b), F = d.sub(N).sub(R), H = O.add(P).neg();
    return { k1: F, k2: H };
  }, n.prototype.pointFromX = function(d, l) {
    d = new e(d, 16), d.red || (d = d.toRed(this.red));
    var m = d.redSqr().redMul(d).redIAdd(d.redMul(this.a)).redIAdd(this.b), b = m.redSqrt();
    if (b.redSqr().redSub(m).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var M = b.fromRed().isOdd();
    return (l && !M || !l && M) && (b = b.redNeg()), this.point(d, b);
  }, n.prototype.validate = function(d) {
    if (d.inf)
      return !0;
    var l = d.x, m = d.y, b = this.a.redMul(l), M = l.redSqr().redMul(l).redIAdd(b).redIAdd(this.b);
    return m.redSqr().redISub(M).cmpn(0) === 0;
  }, n.prototype._endoWnafMulAdd = function(d, l, m) {
    for (var b = this._endoWnafT1, M = this._endoWnafT2, A = 0; A < d.length; A++) {
      var N = this._endoSplit(l[A]), R = d[A], O = R._getBeta();
      N.k1.negative && (N.k1.ineg(), R = R.neg(!0)), N.k2.negative && (N.k2.ineg(), O = O.neg(!0)), b[A * 2] = R, b[A * 2 + 1] = O, M[A * 2] = N.k1, M[A * 2 + 1] = N.k2;
    }
    for (var P = this._wnafMulAdd(1, b, M, A * 2, m), F = 0; F < A * 2; F++)
      b[F] = null, M[F] = null;
    return P;
  };
  function f(h, d, l, m) {
    i.BasePoint.call(this, h, "affine"), d === null && l === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new e(d, 16), this.y = new e(l, 16), m && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }
  r(f, i.BasePoint), n.prototype.point = function(d, l, m) {
    return new f(this, d, l, m);
  }, n.prototype.pointFromJSON = function(d, l) {
    return f.fromJSON(this, d, l);
  }, f.prototype._getBeta = function() {
    if (!!this.curve.endo) {
      var d = this.precomputed;
      if (d && d.beta)
        return d.beta;
      var l = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
      if (d) {
        var m = this.curve, b = function(M) {
          return m.point(M.x.redMul(m.endo.beta), M.y);
        };
        d.beta = l, l.precomputed = {
          beta: null,
          naf: d.naf && {
            wnd: d.naf.wnd,
            points: d.naf.points.map(b)
          },
          doubles: d.doubles && {
            step: d.doubles.step,
            points: d.doubles.points.map(b)
          }
        };
      }
      return l;
    }
  }, f.prototype.toJSON = function() {
    return this.precomputed ? [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }] : [this.x, this.y];
  }, f.fromJSON = function(d, l, m) {
    typeof l == "string" && (l = JSON.parse(l));
    var b = d.point(l[0], l[1], m);
    if (!l[2])
      return b;
    function M(N) {
      return d.point(N[0], N[1], m);
    }
    var A = l[2];
    return b.precomputed = {
      beta: null,
      doubles: A.doubles && {
        step: A.doubles.step,
        points: [b].concat(A.doubles.points.map(M))
      },
      naf: A.naf && {
        wnd: A.naf.wnd,
        points: [b].concat(A.naf.points.map(M))
      }
    }, b;
  }, f.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
  }, f.prototype.isInfinity = function() {
    return this.inf;
  }, f.prototype.add = function(d) {
    if (this.inf)
      return d;
    if (d.inf)
      return this;
    if (this.eq(d))
      return this.dbl();
    if (this.neg().eq(d))
      return this.curve.point(null, null);
    if (this.x.cmp(d.x) === 0)
      return this.curve.point(null, null);
    var l = this.y.redSub(d.y);
    l.cmpn(0) !== 0 && (l = l.redMul(this.x.redSub(d.x).redInvm()));
    var m = l.redSqr().redISub(this.x).redISub(d.x), b = l.redMul(this.x.redSub(m)).redISub(this.y);
    return this.curve.point(m, b);
  }, f.prototype.dbl = function() {
    if (this.inf)
      return this;
    var d = this.y.redAdd(this.y);
    if (d.cmpn(0) === 0)
      return this.curve.point(null, null);
    var l = this.curve.a, m = this.x.redSqr(), b = d.redInvm(), M = m.redAdd(m).redIAdd(m).redIAdd(l).redMul(b), A = M.redSqr().redISub(this.x.redAdd(this.x)), N = M.redMul(this.x.redSub(A)).redISub(this.y);
    return this.curve.point(A, N);
  }, f.prototype.getX = function() {
    return this.x.fromRed();
  }, f.prototype.getY = function() {
    return this.y.fromRed();
  }, f.prototype.mul = function(d) {
    return d = new e(d, 16), this.isInfinity() ? this : this._hasDoubles(d) ? this.curve._fixedNafMul(this, d) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [d]) : this.curve._wnafMul(this, d);
  }, f.prototype.mulAdd = function(d, l, m) {
    var b = [this, l], M = [d, m];
    return this.curve.endo ? this.curve._endoWnafMulAdd(b, M) : this.curve._wnafMulAdd(1, b, M, 2);
  }, f.prototype.jmulAdd = function(d, l, m) {
    var b = [this, l], M = [d, m];
    return this.curve.endo ? this.curve._endoWnafMulAdd(b, M, !0) : this.curve._wnafMulAdd(1, b, M, 2, !0);
  }, f.prototype.eq = function(d) {
    return this === d || this.inf === d.inf && (this.inf || this.x.cmp(d.x) === 0 && this.y.cmp(d.y) === 0);
  }, f.prototype.neg = function(d) {
    if (this.inf)
      return this;
    var l = this.curve.point(this.x, this.y.redNeg());
    if (d && this.precomputed) {
      var m = this.precomputed, b = function(M) {
        return M.neg();
      };
      l.precomputed = {
        naf: m.naf && {
          wnd: m.naf.wnd,
          points: m.naf.points.map(b)
        },
        doubles: m.doubles && {
          step: m.doubles.step,
          points: m.doubles.points.map(b)
        }
      };
    }
    return l;
  }, f.prototype.toJ = function() {
    if (this.inf)
      return this.curve.jpoint(null, null, null);
    var d = this.curve.jpoint(this.x, this.y, this.curve.one);
    return d;
  };
  function u(h, d, l, m) {
    i.BasePoint.call(this, h, "jacobian"), d === null && l === null && m === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new e(0)) : (this.x = new e(d, 16), this.y = new e(l, 16), this.z = new e(m, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }
  return r(u, i.BasePoint), n.prototype.jpoint = function(d, l, m) {
    return new u(this, d, l, m);
  }, u.prototype.toP = function() {
    if (this.isInfinity())
      return this.curve.point(null, null);
    var d = this.z.redInvm(), l = d.redSqr(), m = this.x.redMul(l), b = this.y.redMul(l).redMul(d);
    return this.curve.point(m, b);
  }, u.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, u.prototype.add = function(d) {
    if (this.isInfinity())
      return d;
    if (d.isInfinity())
      return this;
    var l = d.z.redSqr(), m = this.z.redSqr(), b = this.x.redMul(l), M = d.x.redMul(m), A = this.y.redMul(l.redMul(d.z)), N = d.y.redMul(m.redMul(this.z)), R = b.redSub(M), O = A.redSub(N);
    if (R.cmpn(0) === 0)
      return O.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var P = R.redSqr(), F = P.redMul(R), H = b.redMul(P), Q = O.redSqr().redIAdd(F).redISub(H).redISub(H), Z = O.redMul(H.redISub(Q)).redISub(A.redMul(F)), B = this.z.redMul(d.z).redMul(R);
    return this.curve.jpoint(Q, Z, B);
  }, u.prototype.mixedAdd = function(d) {
    if (this.isInfinity())
      return d.toJ();
    if (d.isInfinity())
      return this;
    var l = this.z.redSqr(), m = this.x, b = d.x.redMul(l), M = this.y, A = d.y.redMul(l).redMul(this.z), N = m.redSub(b), R = M.redSub(A);
    if (N.cmpn(0) === 0)
      return R.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var O = N.redSqr(), P = O.redMul(N), F = m.redMul(O), H = R.redSqr().redIAdd(P).redISub(F).redISub(F), Q = R.redMul(F.redISub(H)).redISub(M.redMul(P)), Z = this.z.redMul(N);
    return this.curve.jpoint(H, Q, Z);
  }, u.prototype.dblp = function(d) {
    if (d === 0)
      return this;
    if (this.isInfinity())
      return this;
    if (!d)
      return this.dbl();
    var l;
    if (this.curve.zeroA || this.curve.threeA) {
      var m = this;
      for (l = 0; l < d; l++)
        m = m.dbl();
      return m;
    }
    var b = this.curve.a, M = this.curve.tinv, A = this.x, N = this.y, R = this.z, O = R.redSqr().redSqr(), P = N.redAdd(N);
    for (l = 0; l < d; l++) {
      var F = A.redSqr(), H = P.redSqr(), Q = H.redSqr(), Z = F.redAdd(F).redIAdd(F).redIAdd(b.redMul(O)), B = A.redMul(H), Y = Z.redSqr().redISub(B.redAdd(B)), ae = B.redISub(Y), se = Z.redMul(ae);
      se = se.redIAdd(se).redISub(Q);
      var W = P.redMul(R);
      l + 1 < d && (O = O.redMul(Q)), A = Y, R = W, P = se;
    }
    return this.curve.jpoint(A, P.redMul(M), R);
  }, u.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, u.prototype._zeroDbl = function() {
    var d, l, m;
    if (this.zOne) {
      var b = this.x.redSqr(), M = this.y.redSqr(), A = M.redSqr(), N = this.x.redAdd(M).redSqr().redISub(b).redISub(A);
      N = N.redIAdd(N);
      var R = b.redAdd(b).redIAdd(b), O = R.redSqr().redISub(N).redISub(N), P = A.redIAdd(A);
      P = P.redIAdd(P), P = P.redIAdd(P), d = O, l = R.redMul(N.redISub(O)).redISub(P), m = this.y.redAdd(this.y);
    } else {
      var F = this.x.redSqr(), H = this.y.redSqr(), Q = H.redSqr(), Z = this.x.redAdd(H).redSqr().redISub(F).redISub(Q);
      Z = Z.redIAdd(Z);
      var B = F.redAdd(F).redIAdd(F), Y = B.redSqr(), ae = Q.redIAdd(Q);
      ae = ae.redIAdd(ae), ae = ae.redIAdd(ae), d = Y.redISub(Z).redISub(Z), l = B.redMul(Z.redISub(d)).redISub(ae), m = this.y.redMul(this.z), m = m.redIAdd(m);
    }
    return this.curve.jpoint(d, l, m);
  }, u.prototype._threeDbl = function() {
    var d, l, m;
    if (this.zOne) {
      var b = this.x.redSqr(), M = this.y.redSqr(), A = M.redSqr(), N = this.x.redAdd(M).redSqr().redISub(b).redISub(A);
      N = N.redIAdd(N);
      var R = b.redAdd(b).redIAdd(b).redIAdd(this.curve.a), O = R.redSqr().redISub(N).redISub(N);
      d = O;
      var P = A.redIAdd(A);
      P = P.redIAdd(P), P = P.redIAdd(P), l = R.redMul(N.redISub(O)).redISub(P), m = this.y.redAdd(this.y);
    } else {
      var F = this.z.redSqr(), H = this.y.redSqr(), Q = this.x.redMul(H), Z = this.x.redSub(F).redMul(this.x.redAdd(F));
      Z = Z.redAdd(Z).redIAdd(Z);
      var B = Q.redIAdd(Q);
      B = B.redIAdd(B);
      var Y = B.redAdd(B);
      d = Z.redSqr().redISub(Y), m = this.y.redAdd(this.z).redSqr().redISub(H).redISub(F);
      var ae = H.redSqr();
      ae = ae.redIAdd(ae), ae = ae.redIAdd(ae), ae = ae.redIAdd(ae), l = Z.redMul(B.redISub(d)).redISub(ae);
    }
    return this.curve.jpoint(d, l, m);
  }, u.prototype._dbl = function() {
    var d = this.curve.a, l = this.x, m = this.y, b = this.z, M = b.redSqr().redSqr(), A = l.redSqr(), N = m.redSqr(), R = A.redAdd(A).redIAdd(A).redIAdd(d.redMul(M)), O = l.redAdd(l);
    O = O.redIAdd(O);
    var P = O.redMul(N), F = R.redSqr().redISub(P.redAdd(P)), H = P.redISub(F), Q = N.redSqr();
    Q = Q.redIAdd(Q), Q = Q.redIAdd(Q), Q = Q.redIAdd(Q);
    var Z = R.redMul(H).redISub(Q), B = m.redAdd(m).redMul(b);
    return this.curve.jpoint(F, Z, B);
  }, u.prototype.trpl = function() {
    if (!this.curve.zeroA)
      return this.dbl().add(this);
    var d = this.x.redSqr(), l = this.y.redSqr(), m = this.z.redSqr(), b = l.redSqr(), M = d.redAdd(d).redIAdd(d), A = M.redSqr(), N = this.x.redAdd(l).redSqr().redISub(d).redISub(b);
    N = N.redIAdd(N), N = N.redAdd(N).redIAdd(N), N = N.redISub(A);
    var R = N.redSqr(), O = b.redIAdd(b);
    O = O.redIAdd(O), O = O.redIAdd(O), O = O.redIAdd(O);
    var P = M.redIAdd(N).redSqr().redISub(A).redISub(R).redISub(O), F = l.redMul(P);
    F = F.redIAdd(F), F = F.redIAdd(F);
    var H = this.x.redMul(R).redISub(F);
    H = H.redIAdd(H), H = H.redIAdd(H);
    var Q = this.y.redMul(P.redMul(O.redISub(P)).redISub(N.redMul(R)));
    Q = Q.redIAdd(Q), Q = Q.redIAdd(Q), Q = Q.redIAdd(Q);
    var Z = this.z.redAdd(N).redSqr().redISub(m).redISub(R);
    return this.curve.jpoint(H, Q, Z);
  }, u.prototype.mul = function(d, l) {
    return d = new e(d, l), this.curve._wnafMul(this, d);
  }, u.prototype.eq = function(d) {
    if (d.type === "affine")
      return this.eq(d.toJ());
    if (this === d)
      return !0;
    var l = this.z.redSqr(), m = d.z.redSqr();
    if (this.x.redMul(m).redISub(d.x.redMul(l)).cmpn(0) !== 0)
      return !1;
    var b = l.redMul(this.z), M = m.redMul(d.z);
    return this.y.redMul(M).redISub(d.y.redMul(b)).cmpn(0) === 0;
  }, u.prototype.eqXToP = function(d) {
    var l = this.z.redSqr(), m = d.toRed(this.curve.red).redMul(l);
    if (this.x.cmp(m) === 0)
      return !0;
    for (var b = d.clone(), M = this.curve.redN.redMul(l); ; ) {
      if (b.iadd(this.curve.n), b.cmp(this.curve.p) >= 0)
        return !1;
      if (m.redIAdd(M), this.x.cmp(m) === 0)
        return !0;
    }
  }, u.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
  }, u.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, Hb;
}
var Wb, FM;
function pre() {
  if (FM)
    return Wb;
  FM = 1;
  var t = Sr.exports, e = It.exports, r = Gp(), i = fs();
  function s(f) {
    r.call(this, "mont", f), this.a = new t(f.a, 16).toRed(this.red), this.b = new t(f.b, 16).toRed(this.red), this.i4 = new t(4).toRed(this.red).redInvm(), this.two = new t(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }
  e(s, r), Wb = s, s.prototype.validate = function(u) {
    var h = u.normalize().x, d = h.redSqr(), l = d.redMul(h).redAdd(d.redMul(this.a)).redAdd(h), m = l.redSqrt();
    return m.redSqr().cmp(l) === 0;
  };
  function n(f, u, h) {
    r.BasePoint.call(this, f, "projective"), u === null && h === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new t(u, 16), this.z = new t(h, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }
  return e(n, r.BasePoint), s.prototype.decodePoint = function(u, h) {
    return this.point(i.toArray(u, h), 1);
  }, s.prototype.point = function(u, h) {
    return new n(this, u, h);
  }, s.prototype.pointFromJSON = function(u) {
    return n.fromJSON(this, u);
  }, n.prototype.precompute = function() {
  }, n.prototype._encode = function() {
    return this.getX().toArray("be", this.curve.p.byteLength());
  }, n.fromJSON = function(u, h) {
    return new n(u, h[0], h[1] || u.one);
  }, n.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, n.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, n.prototype.dbl = function() {
    var u = this.x.redAdd(this.z), h = u.redSqr(), d = this.x.redSub(this.z), l = d.redSqr(), m = h.redSub(l), b = h.redMul(l), M = m.redMul(l.redAdd(this.curve.a24.redMul(m)));
    return this.curve.point(b, M);
  }, n.prototype.add = function() {
    throw new Error("Not supported on Montgomery curve");
  }, n.prototype.diffAdd = function(u, h) {
    var d = this.x.redAdd(this.z), l = this.x.redSub(this.z), m = u.x.redAdd(u.z), b = u.x.redSub(u.z), M = b.redMul(d), A = m.redMul(l), N = h.z.redMul(M.redAdd(A).redSqr()), R = h.x.redMul(M.redISub(A).redSqr());
    return this.curve.point(N, R);
  }, n.prototype.mul = function(u) {
    for (var h = u.clone(), d = this, l = this.curve.point(null, null), m = this, b = []; h.cmpn(0) !== 0; h.iushrn(1))
      b.push(h.andln(1));
    for (var M = b.length - 1; M >= 0; M--)
      b[M] === 0 ? (d = d.diffAdd(l, m), l = l.dbl()) : (l = d.diffAdd(l, m), d = d.dbl());
    return l;
  }, n.prototype.mulAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, n.prototype.jumlAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, n.prototype.eq = function(u) {
    return this.getX().cmp(u.getX()) === 0;
  }, n.prototype.normalize = function() {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, n.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, Wb;
}
var Vb, $M;
function vre() {
  if ($M)
    return Vb;
  $M = 1;
  var t = fs(), e = Sr.exports, r = It.exports, i = Gp(), s = t.assert;
  function n(u) {
    this.twisted = (u.a | 0) !== 1, this.mOneA = this.twisted && (u.a | 0) === -1, this.extended = this.mOneA, i.call(this, "edwards", u), this.a = new e(u.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new e(u.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new e(u.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), s(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (u.c | 0) === 1;
  }
  r(n, i), Vb = n, n.prototype._mulA = function(h) {
    return this.mOneA ? h.redNeg() : this.a.redMul(h);
  }, n.prototype._mulC = function(h) {
    return this.oneC ? h : this.c.redMul(h);
  }, n.prototype.jpoint = function(h, d, l, m) {
    return this.point(h, d, l, m);
  }, n.prototype.pointFromX = function(h, d) {
    h = new e(h, 16), h.red || (h = h.toRed(this.red));
    var l = h.redSqr(), m = this.c2.redSub(this.a.redMul(l)), b = this.one.redSub(this.c2.redMul(this.d).redMul(l)), M = m.redMul(b.redInvm()), A = M.redSqrt();
    if (A.redSqr().redSub(M).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var N = A.fromRed().isOdd();
    return (d && !N || !d && N) && (A = A.redNeg()), this.point(h, A);
  }, n.prototype.pointFromY = function(h, d) {
    h = new e(h, 16), h.red || (h = h.toRed(this.red));
    var l = h.redSqr(), m = l.redSub(this.c2), b = l.redMul(this.d).redMul(this.c2).redSub(this.a), M = m.redMul(b.redInvm());
    if (M.cmp(this.zero) === 0) {
      if (d)
        throw new Error("invalid point");
      return this.point(this.zero, h);
    }
    var A = M.redSqrt();
    if (A.redSqr().redSub(M).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    return A.fromRed().isOdd() !== d && (A = A.redNeg()), this.point(A, h);
  }, n.prototype.validate = function(h) {
    if (h.isInfinity())
      return !0;
    h.normalize();
    var d = h.x.redSqr(), l = h.y.redSqr(), m = d.redMul(this.a).redAdd(l), b = this.c2.redMul(this.one.redAdd(this.d.redMul(d).redMul(l)));
    return m.cmp(b) === 0;
  };
  function f(u, h, d, l, m) {
    i.BasePoint.call(this, u, "projective"), h === null && d === null && l === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new e(h, 16), this.y = new e(d, 16), this.z = l ? new e(l, 16) : this.curve.one, this.t = m && new e(m, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }
  return r(f, i.BasePoint), n.prototype.pointFromJSON = function(h) {
    return f.fromJSON(this, h);
  }, n.prototype.point = function(h, d, l, m) {
    return new f(this, h, d, l, m);
  }, f.fromJSON = function(h, d) {
    return new f(h, d[0], d[1], d[2]);
  }, f.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, f.prototype.isInfinity = function() {
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
  }, f.prototype._extDbl = function() {
    var h = this.x.redSqr(), d = this.y.redSqr(), l = this.z.redSqr();
    l = l.redIAdd(l);
    var m = this.curve._mulA(h), b = this.x.redAdd(this.y).redSqr().redISub(h).redISub(d), M = m.redAdd(d), A = M.redSub(l), N = m.redSub(d), R = b.redMul(A), O = M.redMul(N), P = b.redMul(N), F = A.redMul(M);
    return this.curve.point(R, O, F, P);
  }, f.prototype._projDbl = function() {
    var h = this.x.redAdd(this.y).redSqr(), d = this.x.redSqr(), l = this.y.redSqr(), m, b, M, A, N, R;
    if (this.curve.twisted) {
      A = this.curve._mulA(d);
      var O = A.redAdd(l);
      this.zOne ? (m = h.redSub(d).redSub(l).redMul(O.redSub(this.curve.two)), b = O.redMul(A.redSub(l)), M = O.redSqr().redSub(O).redSub(O)) : (N = this.z.redSqr(), R = O.redSub(N).redISub(N), m = h.redSub(d).redISub(l).redMul(R), b = O.redMul(A.redSub(l)), M = O.redMul(R));
    } else
      A = d.redAdd(l), N = this.curve._mulC(this.z).redSqr(), R = A.redSub(N).redSub(N), m = this.curve._mulC(h.redISub(A)).redMul(R), b = this.curve._mulC(A).redMul(d.redISub(l)), M = A.redMul(R);
    return this.curve.point(m, b, M);
  }, f.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, f.prototype._extAdd = function(h) {
    var d = this.y.redSub(this.x).redMul(h.y.redSub(h.x)), l = this.y.redAdd(this.x).redMul(h.y.redAdd(h.x)), m = this.t.redMul(this.curve.dd).redMul(h.t), b = this.z.redMul(h.z.redAdd(h.z)), M = l.redSub(d), A = b.redSub(m), N = b.redAdd(m), R = l.redAdd(d), O = M.redMul(A), P = N.redMul(R), F = M.redMul(R), H = A.redMul(N);
    return this.curve.point(O, P, H, F);
  }, f.prototype._projAdd = function(h) {
    var d = this.z.redMul(h.z), l = d.redSqr(), m = this.x.redMul(h.x), b = this.y.redMul(h.y), M = this.curve.d.redMul(m).redMul(b), A = l.redSub(M), N = l.redAdd(M), R = this.x.redAdd(this.y).redMul(h.x.redAdd(h.y)).redISub(m).redISub(b), O = d.redMul(A).redMul(R), P, F;
    return this.curve.twisted ? (P = d.redMul(N).redMul(b.redSub(this.curve._mulA(m))), F = A.redMul(N)) : (P = d.redMul(N).redMul(b.redSub(m)), F = this.curve._mulC(A).redMul(N)), this.curve.point(O, P, F);
  }, f.prototype.add = function(h) {
    return this.isInfinity() ? h : h.isInfinity() ? this : this.curve.extended ? this._extAdd(h) : this._projAdd(h);
  }, f.prototype.mul = function(h) {
    return this._hasDoubles(h) ? this.curve._fixedNafMul(this, h) : this.curve._wnafMul(this, h);
  }, f.prototype.mulAdd = function(h, d, l) {
    return this.curve._wnafMulAdd(1, [this, d], [h, l], 2, !1);
  }, f.prototype.jmulAdd = function(h, d, l) {
    return this.curve._wnafMulAdd(1, [this, d], [h, l], 2, !0);
  }, f.prototype.normalize = function() {
    if (this.zOne)
      return this;
    var h = this.z.redInvm();
    return this.x = this.x.redMul(h), this.y = this.y.redMul(h), this.t && (this.t = this.t.redMul(h)), this.z = this.curve.one, this.zOne = !0, this;
  }, f.prototype.neg = function() {
    return this.curve.point(
      this.x.redNeg(),
      this.y,
      this.z,
      this.t && this.t.redNeg()
    );
  }, f.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, f.prototype.getY = function() {
    return this.normalize(), this.y.fromRed();
  }, f.prototype.eq = function(h) {
    return this === h || this.getX().cmp(h.getX()) === 0 && this.getY().cmp(h.getY()) === 0;
  }, f.prototype.eqXToP = function(h) {
    var d = h.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(d) === 0)
      return !0;
    for (var l = h.clone(), m = this.curve.redN.redMul(this.z); ; ) {
      if (l.iadd(this.curve.n), l.cmp(this.curve.p) >= 0)
        return !1;
      if (d.redIAdd(m), this.x.cmp(d) === 0)
        return !0;
    }
  }, f.prototype.toP = f.prototype.normalize, f.prototype.mixedAdd = f.prototype.add, Vb;
}
var qM;
function SA() {
  return qM || (qM = 1, function(t) {
    var e = t;
    e.base = Gp(), e.short = dre(), e.mont = pre(), e.edwards = vre();
  }($b)), $b;
}
var Gb = {}, Kb, HM;
function gre() {
  return HM || (HM = 1, Kb = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), Kb;
}
var WM;
function yw() {
  return WM || (WM = 1, function(t) {
    var e = t, r = Ki, i = SA(), s = fs(), n = s.assert;
    function f(d) {
      d.type === "short" ? this.curve = new i.short(d) : d.type === "edwards" ? this.curve = new i.edwards(d) : this.curve = new i.mont(d), this.g = this.curve.g, this.n = this.curve.n, this.hash = d.hash, n(this.g.validate(), "Invalid curve"), n(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    e.PresetCurve = f;
    function u(d, l) {
      Object.defineProperty(e, d, {
        configurable: !0,
        enumerable: !0,
        get: function() {
          var m = new f(l);
          return Object.defineProperty(e, d, {
            configurable: !0,
            enumerable: !0,
            value: m
          }), m;
        }
      });
    }
    u("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: r.sha256,
      gRed: !1,
      g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
      ]
    }), u("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: r.sha256,
      gRed: !1,
      g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
      ]
    }), u("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: r.sha256,
      gRed: !1,
      g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
      ]
    }), u("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: r.sha384,
      gRed: !1,
      g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
      ]
    }), u("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: r.sha512,
      gRed: !1,
      g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
      ]
    }), u("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: r.sha256,
      gRed: !1,
      g: [
        "9"
      ]
    }), u("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: r.sha256,
      gRed: !1,
      g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        "6666666666666666666666666666666666666666666666666666666666666658"
      ]
    });
    var h;
    try {
      h = gre();
    } catch {
      h = void 0;
    }
    u("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: r.sha256,
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [
        {
          a: "3086d221a7d46bcde86c90e49284eb15",
          b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
          a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
          b: "3086d221a7d46bcde86c90e49284eb15"
        }
      ],
      gRed: !1,
      g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        h
      ]
    });
  }(Gb)), Gb;
}
var bre = Ki, tf = Vp, EA = Nn;
function po(t) {
  if (!(this instanceof po))
    return new po(t);
  this.hash = t.hash, this.predResist = !!t.predResist, this.outLen = this.hash.outSize, this.minEntropy = t.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
  var e = tf.toArray(t.entropy, t.entropyEnc || "hex"), r = tf.toArray(t.nonce, t.nonceEnc || "hex"), i = tf.toArray(t.pers, t.persEnc || "hex");
  EA(
    e.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._init(e, r, i);
}
var IA = po;
po.prototype._init = function(e, r, i) {
  var s = e.concat(r).concat(i);
  this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
  for (var n = 0; n < this.V.length; n++)
    this.K[n] = 0, this.V[n] = 1;
  this._update(s), this._reseed = 1, this.reseedInterval = 281474976710656;
};
po.prototype._hmac = function() {
  return new bre.hmac(this.hash, this.K);
};
po.prototype._update = function(e) {
  var r = this._hmac().update(this.V).update([0]);
  e && (r = r.update(e)), this.K = r.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([1]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
};
po.prototype.reseed = function(e, r, i, s) {
  typeof r != "string" && (s = i, i = r, r = null), e = tf.toArray(e, r), i = tf.toArray(i, s), EA(
    e.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._update(e.concat(i || [])), this._reseed = 1;
};
po.prototype.generate = function(e, r, i, s) {
  if (this._reseed > this.reseedInterval)
    throw new Error("Reseed is required");
  typeof r != "string" && (s = i, i = r, r = null), i && (i = tf.toArray(i, s || "hex"), this._update(i));
  for (var n = []; n.length < e; )
    this.V = this._hmac().update(this.V).digest(), n = n.concat(this.V);
  var f = n.slice(0, e);
  return this._update(i), this._reseed++, tf.encode(f, r);
};
var Yb, VM;
function yre() {
  if (VM)
    return Yb;
  VM = 1;
  var t = Sr.exports, e = fs(), r = e.assert;
  function i(s, n) {
    this.ec = s, this.priv = null, this.pub = null, n.priv && this._importPrivate(n.priv, n.privEnc), n.pub && this._importPublic(n.pub, n.pubEnc);
  }
  return Yb = i, i.fromPublic = function(n, f, u) {
    return f instanceof i ? f : new i(n, {
      pub: f,
      pubEnc: u
    });
  }, i.fromPrivate = function(n, f, u) {
    return f instanceof i ? f : new i(n, {
      priv: f,
      privEnc: u
    });
  }, i.prototype.validate = function() {
    var n = this.getPublic();
    return n.isInfinity() ? { result: !1, reason: "Invalid public key" } : n.validate() ? n.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
  }, i.prototype.getPublic = function(n, f) {
    return typeof n == "string" && (f = n, n = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), f ? this.pub.encode(f, n) : this.pub;
  }, i.prototype.getPrivate = function(n) {
    return n === "hex" ? this.priv.toString(16, 2) : this.priv;
  }, i.prototype._importPrivate = function(n, f) {
    this.priv = new t(n, f || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, i.prototype._importPublic = function(n, f) {
    if (n.x || n.y) {
      this.ec.curve.type === "mont" ? r(n.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && r(n.x && n.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(n.x, n.y);
      return;
    }
    this.pub = this.ec.curve.decodePoint(n, f);
  }, i.prototype.derive = function(n) {
    return n.validate() || r(n.validate(), "public point not validated"), n.mul(this.priv).getX();
  }, i.prototype.sign = function(n, f, u) {
    return this.ec.sign(n, this, f, u);
  }, i.prototype.verify = function(n, f) {
    return this.ec.verify(n, f, this);
  }, i.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
  }, Yb;
}
var Qb, GM;
function mre() {
  if (GM)
    return Qb;
  GM = 1;
  var t = Sr.exports, e = fs(), r = e.assert;
  function i(h, d) {
    if (h instanceof i)
      return h;
    this._importDER(h, d) || (r(h.r && h.s, "Signature without r or s"), this.r = new t(h.r, 16), this.s = new t(h.s, 16), h.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = h.recoveryParam);
  }
  Qb = i;
  function s() {
    this.place = 0;
  }
  function n(h, d) {
    var l = h[d.place++];
    if (!(l & 128))
      return l;
    var m = l & 15;
    if (m === 0 || m > 4)
      return !1;
    for (var b = 0, M = 0, A = d.place; M < m; M++, A++)
      b <<= 8, b |= h[A], b >>>= 0;
    return b <= 127 ? !1 : (d.place = A, b);
  }
  function f(h) {
    for (var d = 0, l = h.length - 1; !h[d] && !(h[d + 1] & 128) && d < l; )
      d++;
    return d === 0 ? h : h.slice(d);
  }
  i.prototype._importDER = function(d, l) {
    d = e.toArray(d, l);
    var m = new s();
    if (d[m.place++] !== 48)
      return !1;
    var b = n(d, m);
    if (b === !1 || b + m.place !== d.length || d[m.place++] !== 2)
      return !1;
    var M = n(d, m);
    if (M === !1)
      return !1;
    var A = d.slice(m.place, M + m.place);
    if (m.place += M, d[m.place++] !== 2)
      return !1;
    var N = n(d, m);
    if (N === !1 || d.length !== N + m.place)
      return !1;
    var R = d.slice(m.place, N + m.place);
    if (A[0] === 0)
      if (A[1] & 128)
        A = A.slice(1);
      else
        return !1;
    if (R[0] === 0)
      if (R[1] & 128)
        R = R.slice(1);
      else
        return !1;
    return this.r = new t(A), this.s = new t(R), this.recoveryParam = null, !0;
  };
  function u(h, d) {
    if (d < 128) {
      h.push(d);
      return;
    }
    var l = 1 + (Math.log(d) / Math.LN2 >>> 3);
    for (h.push(l | 128); --l; )
      h.push(d >>> (l << 3) & 255);
    h.push(d);
  }
  return i.prototype.toDER = function(d) {
    var l = this.r.toArray(), m = this.s.toArray();
    for (l[0] & 128 && (l = [0].concat(l)), m[0] & 128 && (m = [0].concat(m)), l = f(l), m = f(m); !m[0] && !(m[1] & 128); )
      m = m.slice(1);
    var b = [2];
    u(b, l.length), b = b.concat(l), b.push(2), u(b, m.length);
    var M = b.concat(m), A = [48];
    return u(A, M.length), A = A.concat(M), e.encode(A, d);
  }, Qb;
}
var Zb, KM;
function wre() {
  if (KM)
    return Zb;
  KM = 1;
  var t = Sr.exports, e = IA, r = fs(), i = yw(), s = el(), n = r.assert, f = yre(), u = mre();
  function h(d) {
    if (!(this instanceof h))
      return new h(d);
    typeof d == "string" && (n(
      Object.prototype.hasOwnProperty.call(i, d),
      "Unknown curve " + d
    ), d = i[d]), d instanceof i.PresetCurve && (d = { curve: d }), this.curve = d.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = d.curve.g, this.g.precompute(d.curve.n.bitLength() + 1), this.hash = d.hash || d.curve.hash;
  }
  return Zb = h, h.prototype.keyPair = function(l) {
    return new f(this, l);
  }, h.prototype.keyFromPrivate = function(l, m) {
    return f.fromPrivate(this, l, m);
  }, h.prototype.keyFromPublic = function(l, m) {
    return f.fromPublic(this, l, m);
  }, h.prototype.genKeyPair = function(l) {
    l || (l = {});
    for (var m = new e({
      hash: this.hash,
      pers: l.pers,
      persEnc: l.persEnc || "utf8",
      entropy: l.entropy || s(this.hash.hmacStrength),
      entropyEnc: l.entropy && l.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), b = this.n.byteLength(), M = this.n.sub(new t(2)); ; ) {
      var A = new t(m.generate(b));
      if (!(A.cmp(M) > 0))
        return A.iaddn(1), this.keyFromPrivate(A);
    }
  }, h.prototype._truncateToN = function(l, m) {
    var b = l.byteLength() * 8 - this.n.bitLength();
    return b > 0 && (l = l.ushrn(b)), !m && l.cmp(this.n) >= 0 ? l.sub(this.n) : l;
  }, h.prototype.sign = function(l, m, b, M) {
    typeof b == "object" && (M = b, b = null), M || (M = {}), m = this.keyFromPrivate(m, b), l = this._truncateToN(new t(l, 16));
    for (var A = this.n.byteLength(), N = m.getPrivate().toArray("be", A), R = l.toArray("be", A), O = new e({
      hash: this.hash,
      entropy: N,
      nonce: R,
      pers: M.pers,
      persEnc: M.persEnc || "utf8"
    }), P = this.n.sub(new t(1)), F = 0; ; F++) {
      var H = M.k ? M.k(F) : new t(O.generate(this.n.byteLength()));
      if (H = this._truncateToN(H, !0), !(H.cmpn(1) <= 0 || H.cmp(P) >= 0)) {
        var Q = this.g.mul(H);
        if (!Q.isInfinity()) {
          var Z = Q.getX(), B = Z.umod(this.n);
          if (B.cmpn(0) !== 0) {
            var Y = H.invm(this.n).mul(B.mul(m.getPrivate()).iadd(l));
            if (Y = Y.umod(this.n), Y.cmpn(0) !== 0) {
              var ae = (Q.getY().isOdd() ? 1 : 0) | (Z.cmp(B) !== 0 ? 2 : 0);
              return M.canonical && Y.cmp(this.nh) > 0 && (Y = this.n.sub(Y), ae ^= 1), new u({ r: B, s: Y, recoveryParam: ae });
            }
          }
        }
      }
    }
  }, h.prototype.verify = function(l, m, b, M) {
    l = this._truncateToN(new t(l, 16)), b = this.keyFromPublic(b, M), m = new u(m, "hex");
    var A = m.r, N = m.s;
    if (A.cmpn(1) < 0 || A.cmp(this.n) >= 0 || N.cmpn(1) < 0 || N.cmp(this.n) >= 0)
      return !1;
    var R = N.invm(this.n), O = R.mul(l).umod(this.n), P = R.mul(A).umod(this.n), F;
    return this.curve._maxwellTrick ? (F = this.g.jmulAdd(O, b.getPublic(), P), F.isInfinity() ? !1 : F.eqXToP(A)) : (F = this.g.mulAdd(O, b.getPublic(), P), F.isInfinity() ? !1 : F.getX().umod(this.n).cmp(A) === 0);
  }, h.prototype.recoverPubKey = function(d, l, m, b) {
    n((3 & m) === m, "The recovery param is more than two bits"), l = new u(l, b);
    var M = this.n, A = new t(d), N = l.r, R = l.s, O = m & 1, P = m >> 1;
    if (N.cmp(this.curve.p.umod(this.curve.n)) >= 0 && P)
      throw new Error("Unable to find sencond key candinate");
    P ? N = this.curve.pointFromX(N.add(this.curve.n), O) : N = this.curve.pointFromX(N, O);
    var F = l.r.invm(M), H = M.sub(A).mul(F).umod(M), Q = R.mul(F).umod(M);
    return this.g.mulAdd(H, N, Q);
  }, h.prototype.getKeyRecoveryParam = function(d, l, m, b) {
    if (l = new u(l, b), l.recoveryParam !== null)
      return l.recoveryParam;
    for (var M = 0; M < 4; M++) {
      var A;
      try {
        A = this.recoverPubKey(d, l, M);
      } catch {
        continue;
      }
      if (A.eq(m))
        return M;
    }
    throw new Error("Unable to find valid recovery factor");
  }, Zb;
}
var Jb, YM;
function _re() {
  if (YM)
    return Jb;
  YM = 1;
  var t = fs(), e = t.assert, r = t.parseBytes, i = t.cachedProperty;
  function s(n, f) {
    this.eddsa = n, this._secret = r(f.secret), n.isPoint(f.pub) ? this._pub = f.pub : this._pubBytes = r(f.pub);
  }
  return s.fromPublic = function(f, u) {
    return u instanceof s ? u : new s(f, { pub: u });
  }, s.fromSecret = function(f, u) {
    return u instanceof s ? u : new s(f, { secret: u });
  }, s.prototype.secret = function() {
    return this._secret;
  }, i(s, "pubBytes", function() {
    return this.eddsa.encodePoint(this.pub());
  }), i(s, "pub", function() {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), i(s, "privBytes", function() {
    var f = this.eddsa, u = this.hash(), h = f.encodingLength - 1, d = u.slice(0, f.encodingLength);
    return d[0] &= 248, d[h] &= 127, d[h] |= 64, d;
  }), i(s, "priv", function() {
    return this.eddsa.decodeInt(this.privBytes());
  }), i(s, "hash", function() {
    return this.eddsa.hash().update(this.secret()).digest();
  }), i(s, "messagePrefix", function() {
    return this.hash().slice(this.eddsa.encodingLength);
  }), s.prototype.sign = function(f) {
    return e(this._secret, "KeyPair can only verify"), this.eddsa.sign(f, this);
  }, s.prototype.verify = function(f, u) {
    return this.eddsa.verify(f, u, this);
  }, s.prototype.getSecret = function(f) {
    return e(this._secret, "KeyPair is public only"), t.encode(this.secret(), f);
  }, s.prototype.getPublic = function(f) {
    return t.encode(this.pubBytes(), f);
  }, Jb = s, Jb;
}
var Xb, QM;
function Mre() {
  if (QM)
    return Xb;
  QM = 1;
  var t = Sr.exports, e = fs(), r = e.assert, i = e.cachedProperty, s = e.parseBytes;
  function n(f, u) {
    this.eddsa = f, typeof u != "object" && (u = s(u)), Array.isArray(u) && (u = {
      R: u.slice(0, f.encodingLength),
      S: u.slice(f.encodingLength)
    }), r(u.R && u.S, "Signature without R or S"), f.isPoint(u.R) && (this._R = u.R), u.S instanceof t && (this._S = u.S), this._Rencoded = Array.isArray(u.R) ? u.R : u.Rencoded, this._Sencoded = Array.isArray(u.S) ? u.S : u.Sencoded;
  }
  return i(n, "S", function() {
    return this.eddsa.decodeInt(this.Sencoded());
  }), i(n, "R", function() {
    return this.eddsa.decodePoint(this.Rencoded());
  }), i(n, "Rencoded", function() {
    return this.eddsa.encodePoint(this.R());
  }), i(n, "Sencoded", function() {
    return this.eddsa.encodeInt(this.S());
  }), n.prototype.toBytes = function() {
    return this.Rencoded().concat(this.Sencoded());
  }, n.prototype.toHex = function() {
    return e.encode(this.toBytes(), "hex").toUpperCase();
  }, Xb = n, Xb;
}
var ey, ZM;
function xre() {
  if (ZM)
    return ey;
  ZM = 1;
  var t = Ki, e = yw(), r = fs(), i = r.assert, s = r.parseBytes, n = _re(), f = Mre();
  function u(h) {
    if (i(h === "ed25519", "only tested with ed25519 so far"), !(this instanceof u))
      return new u(h);
    h = e[h].curve, this.curve = h, this.g = h.g, this.g.precompute(h.n.bitLength() + 1), this.pointClass = h.point().constructor, this.encodingLength = Math.ceil(h.n.bitLength() / 8), this.hash = t.sha512;
  }
  return ey = u, u.prototype.sign = function(d, l) {
    d = s(d);
    var m = this.keyFromSecret(l), b = this.hashInt(m.messagePrefix(), d), M = this.g.mul(b), A = this.encodePoint(M), N = this.hashInt(A, m.pubBytes(), d).mul(m.priv()), R = b.add(N).umod(this.curve.n);
    return this.makeSignature({ R: M, S: R, Rencoded: A });
  }, u.prototype.verify = function(d, l, m) {
    d = s(d), l = this.makeSignature(l);
    var b = this.keyFromPublic(m), M = this.hashInt(l.Rencoded(), b.pubBytes(), d), A = this.g.mul(l.S()), N = l.R().add(b.pub().mul(M));
    return N.eq(A);
  }, u.prototype.hashInt = function() {
    for (var d = this.hash(), l = 0; l < arguments.length; l++)
      d.update(arguments[l]);
    return r.intFromLE(d.digest()).umod(this.curve.n);
  }, u.prototype.keyFromPublic = function(d) {
    return n.fromPublic(this, d);
  }, u.prototype.keyFromSecret = function(d) {
    return n.fromSecret(this, d);
  }, u.prototype.makeSignature = function(d) {
    return d instanceof f ? d : new f(this, d);
  }, u.prototype.encodePoint = function(d) {
    var l = d.getY().toArray("le", this.encodingLength);
    return l[this.encodingLength - 1] |= d.getX().isOdd() ? 128 : 0, l;
  }, u.prototype.decodePoint = function(d) {
    d = r.parseBytes(d);
    var l = d.length - 1, m = d.slice(0, l).concat(d[l] & -129), b = (d[l] & 128) !== 0, M = r.intFromLE(m);
    return this.curve.pointFromY(M, b);
  }, u.prototype.encodeInt = function(d) {
    return d.toArray("le", this.encodingLength);
  }, u.prototype.decodeInt = function(d) {
    return r.intFromLE(d);
  }, u.prototype.isPoint = function(d) {
    return d instanceof this.pointClass;
  }, ey;
}
var JM;
function mw() {
  return JM || (JM = 1, function(t) {
    var e = t;
    e.version = lre.version, e.utils = fs(), e.rand = el(), e.curve = SA(), e.curves = yw(), e.ec = wre(), e.eddsa = xre();
  }(Ub)), Ub;
}
var ty = { exports: {} }, XM;
function AA() {
  return XM || (XM = 1, function(t) {
    (function(e, r) {
      function i(g, a) {
        if (!g)
          throw new Error(a || "Assertion failed");
      }
      function s(g, a) {
        g.super_ = a;
        var c = function() {
        };
        c.prototype = a.prototype, g.prototype = new c(), g.prototype.constructor = g;
      }
      function n(g, a, c) {
        if (n.isBN(g))
          return g;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, g !== null && ((a === "le" || a === "be") && (c = a, a = 10), this._init(g || 0, a || 10, c || "be"));
      }
      typeof e == "object" ? e.exports = n : r.BN = n, n.BN = n, n.wordSize = 26;
      var f;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? f = window.Buffer : f = dn.Buffer;
      } catch {
      }
      n.isBN = function(a) {
        return a instanceof n ? !0 : a !== null && typeof a == "object" && a.constructor.wordSize === n.wordSize && Array.isArray(a.words);
      }, n.max = function(a, c) {
        return a.cmp(c) > 0 ? a : c;
      }, n.min = function(a, c) {
        return a.cmp(c) < 0 ? a : c;
      }, n.prototype._init = function(a, c, p) {
        if (typeof a == "number")
          return this._initNumber(a, c, p);
        if (typeof a == "object")
          return this._initArray(a, c, p);
        c === "hex" && (c = 16), i(c === (c | 0) && c >= 2 && c <= 36), a = a.toString().replace(/\s+/g, "");
        var w = 0;
        a[0] === "-" && (w++, this.negative = 1), w < a.length && (c === 16 ? this._parseHex(a, w, p) : (this._parseBase(a, c, w), p === "le" && this._initArray(this.toArray(), c, p)));
      }, n.prototype._initNumber = function(a, c, p) {
        a < 0 && (this.negative = 1, a = -a), a < 67108864 ? (this.words = [a & 67108863], this.length = 1) : a < 4503599627370496 ? (this.words = [
          a & 67108863,
          a / 67108864 & 67108863
        ], this.length = 2) : (i(a < 9007199254740992), this.words = [
          a & 67108863,
          a / 67108864 & 67108863,
          1
        ], this.length = 3), p === "le" && this._initArray(this.toArray(), c, p);
      }, n.prototype._initArray = function(a, c, p) {
        if (i(typeof a.length == "number"), a.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(a.length / 3), this.words = new Array(this.length);
        for (var w = 0; w < this.length; w++)
          this.words[w] = 0;
        var _, x, E = 0;
        if (p === "be")
          for (w = a.length - 1, _ = 0; w >= 0; w -= 3)
            x = a[w] | a[w - 1] << 8 | a[w - 2] << 16, this.words[_] |= x << E & 67108863, this.words[_ + 1] = x >>> 26 - E & 67108863, E += 24, E >= 26 && (E -= 26, _++);
        else if (p === "le")
          for (w = 0, _ = 0; w < a.length; w += 3)
            x = a[w] | a[w + 1] << 8 | a[w + 2] << 16, this.words[_] |= x << E & 67108863, this.words[_ + 1] = x >>> 26 - E & 67108863, E += 24, E >= 26 && (E -= 26, _++);
        return this._strip();
      };
      function u(g, a) {
        var c = g.charCodeAt(a);
        if (c >= 48 && c <= 57)
          return c - 48;
        if (c >= 65 && c <= 70)
          return c - 55;
        if (c >= 97 && c <= 102)
          return c - 87;
        i(!1, "Invalid character in " + g);
      }
      function h(g, a, c) {
        var p = u(g, c);
        return c - 1 >= a && (p |= u(g, c - 1) << 4), p;
      }
      n.prototype._parseHex = function(a, c, p) {
        this.length = Math.ceil((a.length - c) / 6), this.words = new Array(this.length);
        for (var w = 0; w < this.length; w++)
          this.words[w] = 0;
        var _ = 0, x = 0, E;
        if (p === "be")
          for (w = a.length - 1; w >= c; w -= 2)
            E = h(a, c, w) << _, this.words[x] |= E & 67108863, _ >= 18 ? (_ -= 18, x += 1, this.words[x] |= E >>> 26) : _ += 8;
        else {
          var y = a.length - c;
          for (w = y % 2 === 0 ? c + 1 : c; w < a.length; w += 2)
            E = h(a, c, w) << _, this.words[x] |= E & 67108863, _ >= 18 ? (_ -= 18, x += 1, this.words[x] |= E >>> 26) : _ += 8;
        }
        this._strip();
      };
      function d(g, a, c, p) {
        for (var w = 0, _ = 0, x = Math.min(g.length, c), E = a; E < x; E++) {
          var y = g.charCodeAt(E) - 48;
          w *= p, y >= 49 ? _ = y - 49 + 10 : y >= 17 ? _ = y - 17 + 10 : _ = y, i(y >= 0 && _ < p, "Invalid character"), w += _;
        }
        return w;
      }
      n.prototype._parseBase = function(a, c, p) {
        this.words = [0], this.length = 1;
        for (var w = 0, _ = 1; _ <= 67108863; _ *= c)
          w++;
        w--, _ = _ / c | 0;
        for (var x = a.length - p, E = x % w, y = Math.min(x, x - E) + p, o = 0, S = p; S < y; S += w)
          o = d(a, S, S + w, c), this.imuln(_), this.words[0] + o < 67108864 ? this.words[0] += o : this._iaddn(o);
        if (E !== 0) {
          var J = 1;
          for (o = d(a, S, a.length, c), S = 0; S < E; S++)
            J *= c;
          this.imuln(J), this.words[0] + o < 67108864 ? this.words[0] += o : this._iaddn(o);
        }
        this._strip();
      }, n.prototype.copy = function(a) {
        a.words = new Array(this.length);
        for (var c = 0; c < this.length; c++)
          a.words[c] = this.words[c];
        a.length = this.length, a.negative = this.negative, a.red = this.red;
      };
      function l(g, a) {
        g.words = a.words, g.length = a.length, g.negative = a.negative, g.red = a.red;
      }
      if (n.prototype._move = function(a) {
        l(a, this);
      }, n.prototype.clone = function() {
        var a = new n(null);
        return this.copy(a), a;
      }, n.prototype._expand = function(a) {
        for (; this.length < a; )
          this.words[this.length++] = 0;
        return this;
      }, n.prototype._strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, n.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, typeof Symbol < "u" && typeof Symbol.for == "function")
        try {
          n.prototype[Symbol.for("nodejs.util.inspect.custom")] = m;
        } catch {
          n.prototype.inspect = m;
        }
      else
        n.prototype.inspect = m;
      function m() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      }
      var b = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], M = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], A = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      n.prototype.toString = function(a, c) {
        a = a || 10, c = c | 0 || 1;
        var p;
        if (a === 16 || a === "hex") {
          p = "";
          for (var w = 0, _ = 0, x = 0; x < this.length; x++) {
            var E = this.words[x], y = ((E << w | _) & 16777215).toString(16);
            _ = E >>> 24 - w & 16777215, _ !== 0 || x !== this.length - 1 ? p = b[6 - y.length] + y + p : p = y + p, w += 2, w >= 26 && (w -= 26, x--);
          }
          for (_ !== 0 && (p = _.toString(16) + p); p.length % c !== 0; )
            p = "0" + p;
          return this.negative !== 0 && (p = "-" + p), p;
        }
        if (a === (a | 0) && a >= 2 && a <= 36) {
          var o = M[a], S = A[a];
          p = "";
          var J = this.clone();
          for (J.negative = 0; !J.isZero(); ) {
            var z = J.modrn(S).toString(a);
            J = J.idivn(S), J.isZero() ? p = z + p : p = b[o - z.length] + z + p;
          }
          for (this.isZero() && (p = "0" + p); p.length % c !== 0; )
            p = "0" + p;
          return this.negative !== 0 && (p = "-" + p), p;
        }
        i(!1, "Base should be between 2 and 36");
      }, n.prototype.toNumber = function() {
        var a = this.words[0];
        return this.length === 2 ? a += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? a += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -a : a;
      }, n.prototype.toJSON = function() {
        return this.toString(16, 2);
      }, f && (n.prototype.toBuffer = function(a, c) {
        return this.toArrayLike(f, a, c);
      }), n.prototype.toArray = function(a, c) {
        return this.toArrayLike(Array, a, c);
      };
      var N = function(a, c) {
        return a.allocUnsafe ? a.allocUnsafe(c) : new a(c);
      };
      n.prototype.toArrayLike = function(a, c, p) {
        this._strip();
        var w = this.byteLength(), _ = p || Math.max(1, w);
        i(w <= _, "byte array longer than desired length"), i(_ > 0, "Requested array length <= 0");
        var x = N(a, _), E = c === "le" ? "LE" : "BE";
        return this["_toArrayLike" + E](x, w), x;
      }, n.prototype._toArrayLikeLE = function(a, c) {
        for (var p = 0, w = 0, _ = 0, x = 0; _ < this.length; _++) {
          var E = this.words[_] << x | w;
          a[p++] = E & 255, p < a.length && (a[p++] = E >> 8 & 255), p < a.length && (a[p++] = E >> 16 & 255), x === 6 ? (p < a.length && (a[p++] = E >> 24 & 255), w = 0, x = 0) : (w = E >>> 24, x += 2);
        }
        if (p < a.length)
          for (a[p++] = w; p < a.length; )
            a[p++] = 0;
      }, n.prototype._toArrayLikeBE = function(a, c) {
        for (var p = a.length - 1, w = 0, _ = 0, x = 0; _ < this.length; _++) {
          var E = this.words[_] << x | w;
          a[p--] = E & 255, p >= 0 && (a[p--] = E >> 8 & 255), p >= 0 && (a[p--] = E >> 16 & 255), x === 6 ? (p >= 0 && (a[p--] = E >> 24 & 255), w = 0, x = 0) : (w = E >>> 24, x += 2);
        }
        if (p >= 0)
          for (a[p--] = w; p >= 0; )
            a[p--] = 0;
      }, Math.clz32 ? n.prototype._countBits = function(a) {
        return 32 - Math.clz32(a);
      } : n.prototype._countBits = function(a) {
        var c = a, p = 0;
        return c >= 4096 && (p += 13, c >>>= 13), c >= 64 && (p += 7, c >>>= 7), c >= 8 && (p += 4, c >>>= 4), c >= 2 && (p += 2, c >>>= 2), p + c;
      }, n.prototype._zeroBits = function(a) {
        if (a === 0)
          return 26;
        var c = a, p = 0;
        return (c & 8191) === 0 && (p += 13, c >>>= 13), (c & 127) === 0 && (p += 7, c >>>= 7), (c & 15) === 0 && (p += 4, c >>>= 4), (c & 3) === 0 && (p += 2, c >>>= 2), (c & 1) === 0 && p++, p;
      }, n.prototype.bitLength = function() {
        var a = this.words[this.length - 1], c = this._countBits(a);
        return (this.length - 1) * 26 + c;
      };
      function R(g) {
        for (var a = new Array(g.bitLength()), c = 0; c < a.length; c++) {
          var p = c / 26 | 0, w = c % 26;
          a[c] = g.words[p] >>> w & 1;
        }
        return a;
      }
      n.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var a = 0, c = 0; c < this.length; c++) {
          var p = this._zeroBits(this.words[c]);
          if (a += p, p !== 26)
            break;
        }
        return a;
      }, n.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, n.prototype.toTwos = function(a) {
        return this.negative !== 0 ? this.abs().inotn(a).iaddn(1) : this.clone();
      }, n.prototype.fromTwos = function(a) {
        return this.testn(a - 1) ? this.notn(a).iaddn(1).ineg() : this.clone();
      }, n.prototype.isNeg = function() {
        return this.negative !== 0;
      }, n.prototype.neg = function() {
        return this.clone().ineg();
      }, n.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, n.prototype.iuor = function(a) {
        for (; this.length < a.length; )
          this.words[this.length++] = 0;
        for (var c = 0; c < a.length; c++)
          this.words[c] = this.words[c] | a.words[c];
        return this._strip();
      }, n.prototype.ior = function(a) {
        return i((this.negative | a.negative) === 0), this.iuor(a);
      }, n.prototype.or = function(a) {
        return this.length > a.length ? this.clone().ior(a) : a.clone().ior(this);
      }, n.prototype.uor = function(a) {
        return this.length > a.length ? this.clone().iuor(a) : a.clone().iuor(this);
      }, n.prototype.iuand = function(a) {
        var c;
        this.length > a.length ? c = a : c = this;
        for (var p = 0; p < c.length; p++)
          this.words[p] = this.words[p] & a.words[p];
        return this.length = c.length, this._strip();
      }, n.prototype.iand = function(a) {
        return i((this.negative | a.negative) === 0), this.iuand(a);
      }, n.prototype.and = function(a) {
        return this.length > a.length ? this.clone().iand(a) : a.clone().iand(this);
      }, n.prototype.uand = function(a) {
        return this.length > a.length ? this.clone().iuand(a) : a.clone().iuand(this);
      }, n.prototype.iuxor = function(a) {
        var c, p;
        this.length > a.length ? (c = this, p = a) : (c = a, p = this);
        for (var w = 0; w < p.length; w++)
          this.words[w] = c.words[w] ^ p.words[w];
        if (this !== c)
          for (; w < c.length; w++)
            this.words[w] = c.words[w];
        return this.length = c.length, this._strip();
      }, n.prototype.ixor = function(a) {
        return i((this.negative | a.negative) === 0), this.iuxor(a);
      }, n.prototype.xor = function(a) {
        return this.length > a.length ? this.clone().ixor(a) : a.clone().ixor(this);
      }, n.prototype.uxor = function(a) {
        return this.length > a.length ? this.clone().iuxor(a) : a.clone().iuxor(this);
      }, n.prototype.inotn = function(a) {
        i(typeof a == "number" && a >= 0);
        var c = Math.ceil(a / 26) | 0, p = a % 26;
        this._expand(c), p > 0 && c--;
        for (var w = 0; w < c; w++)
          this.words[w] = ~this.words[w] & 67108863;
        return p > 0 && (this.words[w] = ~this.words[w] & 67108863 >> 26 - p), this._strip();
      }, n.prototype.notn = function(a) {
        return this.clone().inotn(a);
      }, n.prototype.setn = function(a, c) {
        i(typeof a == "number" && a >= 0);
        var p = a / 26 | 0, w = a % 26;
        return this._expand(p + 1), c ? this.words[p] = this.words[p] | 1 << w : this.words[p] = this.words[p] & ~(1 << w), this._strip();
      }, n.prototype.iadd = function(a) {
        var c;
        if (this.negative !== 0 && a.negative === 0)
          return this.negative = 0, c = this.isub(a), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && a.negative !== 0)
          return a.negative = 0, c = this.isub(a), a.negative = 1, c._normSign();
        var p, w;
        this.length > a.length ? (p = this, w = a) : (p = a, w = this);
        for (var _ = 0, x = 0; x < w.length; x++)
          c = (p.words[x] | 0) + (w.words[x] | 0) + _, this.words[x] = c & 67108863, _ = c >>> 26;
        for (; _ !== 0 && x < p.length; x++)
          c = (p.words[x] | 0) + _, this.words[x] = c & 67108863, _ = c >>> 26;
        if (this.length = p.length, _ !== 0)
          this.words[this.length] = _, this.length++;
        else if (p !== this)
          for (; x < p.length; x++)
            this.words[x] = p.words[x];
        return this;
      }, n.prototype.add = function(a) {
        var c;
        return a.negative !== 0 && this.negative === 0 ? (a.negative = 0, c = this.sub(a), a.negative ^= 1, c) : a.negative === 0 && this.negative !== 0 ? (this.negative = 0, c = a.sub(this), this.negative = 1, c) : this.length > a.length ? this.clone().iadd(a) : a.clone().iadd(this);
      }, n.prototype.isub = function(a) {
        if (a.negative !== 0) {
          a.negative = 0;
          var c = this.iadd(a);
          return a.negative = 1, c._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(a), this.negative = 1, this._normSign();
        var p = this.cmp(a);
        if (p === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var w, _;
        p > 0 ? (w = this, _ = a) : (w = a, _ = this);
        for (var x = 0, E = 0; E < _.length; E++)
          c = (w.words[E] | 0) - (_.words[E] | 0) + x, x = c >> 26, this.words[E] = c & 67108863;
        for (; x !== 0 && E < w.length; E++)
          c = (w.words[E] | 0) + x, x = c >> 26, this.words[E] = c & 67108863;
        if (x === 0 && E < w.length && w !== this)
          for (; E < w.length; E++)
            this.words[E] = w.words[E];
        return this.length = Math.max(this.length, E), w !== this && (this.negative = 1), this._strip();
      }, n.prototype.sub = function(a) {
        return this.clone().isub(a);
      };
      function O(g, a, c) {
        c.negative = a.negative ^ g.negative;
        var p = g.length + a.length | 0;
        c.length = p, p = p - 1 | 0;
        var w = g.words[0] | 0, _ = a.words[0] | 0, x = w * _, E = x & 67108863, y = x / 67108864 | 0;
        c.words[0] = E;
        for (var o = 1; o < p; o++) {
          for (var S = y >>> 26, J = y & 67108863, z = Math.min(o, a.length - 1), k = Math.max(0, o - g.length + 1); k <= z; k++) {
            var j = o - k | 0;
            w = g.words[j] | 0, _ = a.words[k] | 0, x = w * _ + J, S += x / 67108864 | 0, J = x & 67108863;
          }
          c.words[o] = J | 0, y = S | 0;
        }
        return y !== 0 ? c.words[o] = y | 0 : c.length--, c._strip();
      }
      var P = function(a, c, p) {
        var w = a.words, _ = c.words, x = p.words, E = 0, y, o, S, J = w[0] | 0, z = J & 8191, k = J >>> 13, j = w[1] | 0, q = j & 8191, K = j >>> 13, U = w[2] | 0, T = U & 8191, D = U >>> 13, te = w[3] | 0, ne = te & 8191, le = te >>> 13, X = w[4] | 0, $ = X & 8191, V = X >>> 13, re = w[5] | 0, fe = re & 8191, ue = re >>> 13, me = w[6] | 0, be = me & 8191, ve = me >>> 13, Ge = w[7] | 0, ye = Ge & 8191, pe = Ge >>> 13, Je = w[8] | 0, Ie = Je & 8191, we = Je >>> 13, at = w[9] | 0, Oe = at & 8191, Ee = at >>> 13, ft = _[0] | 0, Le = ft & 8191, Pe = ft >>> 13, Mt = _[1] | 0, Ve = Mt & 8191, ke = Mt >>> 13, Et = _[2] | 0, Ke = Et & 8191, Be = Et >>> 13, dt = _[3] | 0, ze = dt & 8191, Te = dt >>> 13, pt = _[4] | 0, Fe = pt & 8191, Ae = pt >>> 13, bt = _[5] | 0, He = bt & 8191, Ne = bt >>> 13, yt = _[6] | 0, $e = yt & 8191, De = yt >>> 13, vt = _[7] | 0, je = vt & 8191, Ce = vt >>> 13, mt = _[8] | 0, Ze = mt & 8191, qe = mt >>> 13, Dt = _[9] | 0, We = Dt & 8191, Qe = Dt >>> 13;
        p.negative = a.negative ^ c.negative, p.length = 19, y = Math.imul(z, Le), o = Math.imul(z, Pe), o = o + Math.imul(k, Le) | 0, S = Math.imul(k, Pe);
        var Qt = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (Qt >>> 26) | 0, Qt &= 67108863, y = Math.imul(q, Le), o = Math.imul(q, Pe), o = o + Math.imul(K, Le) | 0, S = Math.imul(K, Pe), y = y + Math.imul(z, Ve) | 0, o = o + Math.imul(z, ke) | 0, o = o + Math.imul(k, Ve) | 0, S = S + Math.imul(k, ke) | 0;
        var Zt = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (Zt >>> 26) | 0, Zt &= 67108863, y = Math.imul(T, Le), o = Math.imul(T, Pe), o = o + Math.imul(D, Le) | 0, S = Math.imul(D, Pe), y = y + Math.imul(q, Ve) | 0, o = o + Math.imul(q, ke) | 0, o = o + Math.imul(K, Ve) | 0, S = S + Math.imul(K, ke) | 0, y = y + Math.imul(z, Ke) | 0, o = o + Math.imul(z, Be) | 0, o = o + Math.imul(k, Ke) | 0, S = S + Math.imul(k, Be) | 0;
        var Jt = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (Jt >>> 26) | 0, Jt &= 67108863, y = Math.imul(ne, Le), o = Math.imul(ne, Pe), o = o + Math.imul(le, Le) | 0, S = Math.imul(le, Pe), y = y + Math.imul(T, Ve) | 0, o = o + Math.imul(T, ke) | 0, o = o + Math.imul(D, Ve) | 0, S = S + Math.imul(D, ke) | 0, y = y + Math.imul(q, Ke) | 0, o = o + Math.imul(q, Be) | 0, o = o + Math.imul(K, Ke) | 0, S = S + Math.imul(K, Be) | 0, y = y + Math.imul(z, ze) | 0, o = o + Math.imul(z, Te) | 0, o = o + Math.imul(k, ze) | 0, S = S + Math.imul(k, Te) | 0;
        var Xt = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (Xt >>> 26) | 0, Xt &= 67108863, y = Math.imul($, Le), o = Math.imul($, Pe), o = o + Math.imul(V, Le) | 0, S = Math.imul(V, Pe), y = y + Math.imul(ne, Ve) | 0, o = o + Math.imul(ne, ke) | 0, o = o + Math.imul(le, Ve) | 0, S = S + Math.imul(le, ke) | 0, y = y + Math.imul(T, Ke) | 0, o = o + Math.imul(T, Be) | 0, o = o + Math.imul(D, Ke) | 0, S = S + Math.imul(D, Be) | 0, y = y + Math.imul(q, ze) | 0, o = o + Math.imul(q, Te) | 0, o = o + Math.imul(K, ze) | 0, S = S + Math.imul(K, Te) | 0, y = y + Math.imul(z, Fe) | 0, o = o + Math.imul(z, Ae) | 0, o = o + Math.imul(k, Fe) | 0, S = S + Math.imul(k, Ae) | 0;
        var kt = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, y = Math.imul(fe, Le), o = Math.imul(fe, Pe), o = o + Math.imul(ue, Le) | 0, S = Math.imul(ue, Pe), y = y + Math.imul($, Ve) | 0, o = o + Math.imul($, ke) | 0, o = o + Math.imul(V, Ve) | 0, S = S + Math.imul(V, ke) | 0, y = y + Math.imul(ne, Ke) | 0, o = o + Math.imul(ne, Be) | 0, o = o + Math.imul(le, Ke) | 0, S = S + Math.imul(le, Be) | 0, y = y + Math.imul(T, ze) | 0, o = o + Math.imul(T, Te) | 0, o = o + Math.imul(D, ze) | 0, S = S + Math.imul(D, Te) | 0, y = y + Math.imul(q, Fe) | 0, o = o + Math.imul(q, Ae) | 0, o = o + Math.imul(K, Fe) | 0, S = S + Math.imul(K, Ae) | 0, y = y + Math.imul(z, He) | 0, o = o + Math.imul(z, Ne) | 0, o = o + Math.imul(k, He) | 0, S = S + Math.imul(k, Ne) | 0;
        var ar = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (ar >>> 26) | 0, ar &= 67108863, y = Math.imul(be, Le), o = Math.imul(be, Pe), o = o + Math.imul(ve, Le) | 0, S = Math.imul(ve, Pe), y = y + Math.imul(fe, Ve) | 0, o = o + Math.imul(fe, ke) | 0, o = o + Math.imul(ue, Ve) | 0, S = S + Math.imul(ue, ke) | 0, y = y + Math.imul($, Ke) | 0, o = o + Math.imul($, Be) | 0, o = o + Math.imul(V, Ke) | 0, S = S + Math.imul(V, Be) | 0, y = y + Math.imul(ne, ze) | 0, o = o + Math.imul(ne, Te) | 0, o = o + Math.imul(le, ze) | 0, S = S + Math.imul(le, Te) | 0, y = y + Math.imul(T, Fe) | 0, o = o + Math.imul(T, Ae) | 0, o = o + Math.imul(D, Fe) | 0, S = S + Math.imul(D, Ae) | 0, y = y + Math.imul(q, He) | 0, o = o + Math.imul(q, Ne) | 0, o = o + Math.imul(K, He) | 0, S = S + Math.imul(K, Ne) | 0, y = y + Math.imul(z, $e) | 0, o = o + Math.imul(z, De) | 0, o = o + Math.imul(k, $e) | 0, S = S + Math.imul(k, De) | 0;
        var lr = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (lr >>> 26) | 0, lr &= 67108863, y = Math.imul(ye, Le), o = Math.imul(ye, Pe), o = o + Math.imul(pe, Le) | 0, S = Math.imul(pe, Pe), y = y + Math.imul(be, Ve) | 0, o = o + Math.imul(be, ke) | 0, o = o + Math.imul(ve, Ve) | 0, S = S + Math.imul(ve, ke) | 0, y = y + Math.imul(fe, Ke) | 0, o = o + Math.imul(fe, Be) | 0, o = o + Math.imul(ue, Ke) | 0, S = S + Math.imul(ue, Be) | 0, y = y + Math.imul($, ze) | 0, o = o + Math.imul($, Te) | 0, o = o + Math.imul(V, ze) | 0, S = S + Math.imul(V, Te) | 0, y = y + Math.imul(ne, Fe) | 0, o = o + Math.imul(ne, Ae) | 0, o = o + Math.imul(le, Fe) | 0, S = S + Math.imul(le, Ae) | 0, y = y + Math.imul(T, He) | 0, o = o + Math.imul(T, Ne) | 0, o = o + Math.imul(D, He) | 0, S = S + Math.imul(D, Ne) | 0, y = y + Math.imul(q, $e) | 0, o = o + Math.imul(q, De) | 0, o = o + Math.imul(K, $e) | 0, S = S + Math.imul(K, De) | 0, y = y + Math.imul(z, je) | 0, o = o + Math.imul(z, Ce) | 0, o = o + Math.imul(k, je) | 0, S = S + Math.imul(k, Ce) | 0;
        var or = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (or >>> 26) | 0, or &= 67108863, y = Math.imul(Ie, Le), o = Math.imul(Ie, Pe), o = o + Math.imul(we, Le) | 0, S = Math.imul(we, Pe), y = y + Math.imul(ye, Ve) | 0, o = o + Math.imul(ye, ke) | 0, o = o + Math.imul(pe, Ve) | 0, S = S + Math.imul(pe, ke) | 0, y = y + Math.imul(be, Ke) | 0, o = o + Math.imul(be, Be) | 0, o = o + Math.imul(ve, Ke) | 0, S = S + Math.imul(ve, Be) | 0, y = y + Math.imul(fe, ze) | 0, o = o + Math.imul(fe, Te) | 0, o = o + Math.imul(ue, ze) | 0, S = S + Math.imul(ue, Te) | 0, y = y + Math.imul($, Fe) | 0, o = o + Math.imul($, Ae) | 0, o = o + Math.imul(V, Fe) | 0, S = S + Math.imul(V, Ae) | 0, y = y + Math.imul(ne, He) | 0, o = o + Math.imul(ne, Ne) | 0, o = o + Math.imul(le, He) | 0, S = S + Math.imul(le, Ne) | 0, y = y + Math.imul(T, $e) | 0, o = o + Math.imul(T, De) | 0, o = o + Math.imul(D, $e) | 0, S = S + Math.imul(D, De) | 0, y = y + Math.imul(q, je) | 0, o = o + Math.imul(q, Ce) | 0, o = o + Math.imul(K, je) | 0, S = S + Math.imul(K, Ce) | 0, y = y + Math.imul(z, Ze) | 0, o = o + Math.imul(z, qe) | 0, o = o + Math.imul(k, Ze) | 0, S = S + Math.imul(k, qe) | 0;
        var dr = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (dr >>> 26) | 0, dr &= 67108863, y = Math.imul(Oe, Le), o = Math.imul(Oe, Pe), o = o + Math.imul(Ee, Le) | 0, S = Math.imul(Ee, Pe), y = y + Math.imul(Ie, Ve) | 0, o = o + Math.imul(Ie, ke) | 0, o = o + Math.imul(we, Ve) | 0, S = S + Math.imul(we, ke) | 0, y = y + Math.imul(ye, Ke) | 0, o = o + Math.imul(ye, Be) | 0, o = o + Math.imul(pe, Ke) | 0, S = S + Math.imul(pe, Be) | 0, y = y + Math.imul(be, ze) | 0, o = o + Math.imul(be, Te) | 0, o = o + Math.imul(ve, ze) | 0, S = S + Math.imul(ve, Te) | 0, y = y + Math.imul(fe, Fe) | 0, o = o + Math.imul(fe, Ae) | 0, o = o + Math.imul(ue, Fe) | 0, S = S + Math.imul(ue, Ae) | 0, y = y + Math.imul($, He) | 0, o = o + Math.imul($, Ne) | 0, o = o + Math.imul(V, He) | 0, S = S + Math.imul(V, Ne) | 0, y = y + Math.imul(ne, $e) | 0, o = o + Math.imul(ne, De) | 0, o = o + Math.imul(le, $e) | 0, S = S + Math.imul(le, De) | 0, y = y + Math.imul(T, je) | 0, o = o + Math.imul(T, Ce) | 0, o = o + Math.imul(D, je) | 0, S = S + Math.imul(D, Ce) | 0, y = y + Math.imul(q, Ze) | 0, o = o + Math.imul(q, qe) | 0, o = o + Math.imul(K, Ze) | 0, S = S + Math.imul(K, qe) | 0, y = y + Math.imul(z, We) | 0, o = o + Math.imul(z, Qe) | 0, o = o + Math.imul(k, We) | 0, S = S + Math.imul(k, Qe) | 0;
        var pr = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (pr >>> 26) | 0, pr &= 67108863, y = Math.imul(Oe, Ve), o = Math.imul(Oe, ke), o = o + Math.imul(Ee, Ve) | 0, S = Math.imul(Ee, ke), y = y + Math.imul(Ie, Ke) | 0, o = o + Math.imul(Ie, Be) | 0, o = o + Math.imul(we, Ke) | 0, S = S + Math.imul(we, Be) | 0, y = y + Math.imul(ye, ze) | 0, o = o + Math.imul(ye, Te) | 0, o = o + Math.imul(pe, ze) | 0, S = S + Math.imul(pe, Te) | 0, y = y + Math.imul(be, Fe) | 0, o = o + Math.imul(be, Ae) | 0, o = o + Math.imul(ve, Fe) | 0, S = S + Math.imul(ve, Ae) | 0, y = y + Math.imul(fe, He) | 0, o = o + Math.imul(fe, Ne) | 0, o = o + Math.imul(ue, He) | 0, S = S + Math.imul(ue, Ne) | 0, y = y + Math.imul($, $e) | 0, o = o + Math.imul($, De) | 0, o = o + Math.imul(V, $e) | 0, S = S + Math.imul(V, De) | 0, y = y + Math.imul(ne, je) | 0, o = o + Math.imul(ne, Ce) | 0, o = o + Math.imul(le, je) | 0, S = S + Math.imul(le, Ce) | 0, y = y + Math.imul(T, Ze) | 0, o = o + Math.imul(T, qe) | 0, o = o + Math.imul(D, Ze) | 0, S = S + Math.imul(D, qe) | 0, y = y + Math.imul(q, We) | 0, o = o + Math.imul(q, Qe) | 0, o = o + Math.imul(K, We) | 0, S = S + Math.imul(K, Qe) | 0;
        var fr = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (fr >>> 26) | 0, fr &= 67108863, y = Math.imul(Oe, Ke), o = Math.imul(Oe, Be), o = o + Math.imul(Ee, Ke) | 0, S = Math.imul(Ee, Be), y = y + Math.imul(Ie, ze) | 0, o = o + Math.imul(Ie, Te) | 0, o = o + Math.imul(we, ze) | 0, S = S + Math.imul(we, Te) | 0, y = y + Math.imul(ye, Fe) | 0, o = o + Math.imul(ye, Ae) | 0, o = o + Math.imul(pe, Fe) | 0, S = S + Math.imul(pe, Ae) | 0, y = y + Math.imul(be, He) | 0, o = o + Math.imul(be, Ne) | 0, o = o + Math.imul(ve, He) | 0, S = S + Math.imul(ve, Ne) | 0, y = y + Math.imul(fe, $e) | 0, o = o + Math.imul(fe, De) | 0, o = o + Math.imul(ue, $e) | 0, S = S + Math.imul(ue, De) | 0, y = y + Math.imul($, je) | 0, o = o + Math.imul($, Ce) | 0, o = o + Math.imul(V, je) | 0, S = S + Math.imul(V, Ce) | 0, y = y + Math.imul(ne, Ze) | 0, o = o + Math.imul(ne, qe) | 0, o = o + Math.imul(le, Ze) | 0, S = S + Math.imul(le, qe) | 0, y = y + Math.imul(T, We) | 0, o = o + Math.imul(T, Qe) | 0, o = o + Math.imul(D, We) | 0, S = S + Math.imul(D, Qe) | 0;
        var ur = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (ur >>> 26) | 0, ur &= 67108863, y = Math.imul(Oe, ze), o = Math.imul(Oe, Te), o = o + Math.imul(Ee, ze) | 0, S = Math.imul(Ee, Te), y = y + Math.imul(Ie, Fe) | 0, o = o + Math.imul(Ie, Ae) | 0, o = o + Math.imul(we, Fe) | 0, S = S + Math.imul(we, Ae) | 0, y = y + Math.imul(ye, He) | 0, o = o + Math.imul(ye, Ne) | 0, o = o + Math.imul(pe, He) | 0, S = S + Math.imul(pe, Ne) | 0, y = y + Math.imul(be, $e) | 0, o = o + Math.imul(be, De) | 0, o = o + Math.imul(ve, $e) | 0, S = S + Math.imul(ve, De) | 0, y = y + Math.imul(fe, je) | 0, o = o + Math.imul(fe, Ce) | 0, o = o + Math.imul(ue, je) | 0, S = S + Math.imul(ue, Ce) | 0, y = y + Math.imul($, Ze) | 0, o = o + Math.imul($, qe) | 0, o = o + Math.imul(V, Ze) | 0, S = S + Math.imul(V, qe) | 0, y = y + Math.imul(ne, We) | 0, o = o + Math.imul(ne, Qe) | 0, o = o + Math.imul(le, We) | 0, S = S + Math.imul(le, Qe) | 0;
        var hr = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (hr >>> 26) | 0, hr &= 67108863, y = Math.imul(Oe, Fe), o = Math.imul(Oe, Ae), o = o + Math.imul(Ee, Fe) | 0, S = Math.imul(Ee, Ae), y = y + Math.imul(Ie, He) | 0, o = o + Math.imul(Ie, Ne) | 0, o = o + Math.imul(we, He) | 0, S = S + Math.imul(we, Ne) | 0, y = y + Math.imul(ye, $e) | 0, o = o + Math.imul(ye, De) | 0, o = o + Math.imul(pe, $e) | 0, S = S + Math.imul(pe, De) | 0, y = y + Math.imul(be, je) | 0, o = o + Math.imul(be, Ce) | 0, o = o + Math.imul(ve, je) | 0, S = S + Math.imul(ve, Ce) | 0, y = y + Math.imul(fe, Ze) | 0, o = o + Math.imul(fe, qe) | 0, o = o + Math.imul(ue, Ze) | 0, S = S + Math.imul(ue, qe) | 0, y = y + Math.imul($, We) | 0, o = o + Math.imul($, Qe) | 0, o = o + Math.imul(V, We) | 0, S = S + Math.imul(V, Qe) | 0;
        var qt = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (qt >>> 26) | 0, qt &= 67108863, y = Math.imul(Oe, He), o = Math.imul(Oe, Ne), o = o + Math.imul(Ee, He) | 0, S = Math.imul(Ee, Ne), y = y + Math.imul(Ie, $e) | 0, o = o + Math.imul(Ie, De) | 0, o = o + Math.imul(we, $e) | 0, S = S + Math.imul(we, De) | 0, y = y + Math.imul(ye, je) | 0, o = o + Math.imul(ye, Ce) | 0, o = o + Math.imul(pe, je) | 0, S = S + Math.imul(pe, Ce) | 0, y = y + Math.imul(be, Ze) | 0, o = o + Math.imul(be, qe) | 0, o = o + Math.imul(ve, Ze) | 0, S = S + Math.imul(ve, qe) | 0, y = y + Math.imul(fe, We) | 0, o = o + Math.imul(fe, Qe) | 0, o = o + Math.imul(ue, We) | 0, S = S + Math.imul(ue, Qe) | 0;
        var Er = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (Er >>> 26) | 0, Er &= 67108863, y = Math.imul(Oe, $e), o = Math.imul(Oe, De), o = o + Math.imul(Ee, $e) | 0, S = Math.imul(Ee, De), y = y + Math.imul(Ie, je) | 0, o = o + Math.imul(Ie, Ce) | 0, o = o + Math.imul(we, je) | 0, S = S + Math.imul(we, Ce) | 0, y = y + Math.imul(ye, Ze) | 0, o = o + Math.imul(ye, qe) | 0, o = o + Math.imul(pe, Ze) | 0, S = S + Math.imul(pe, qe) | 0, y = y + Math.imul(be, We) | 0, o = o + Math.imul(be, Qe) | 0, o = o + Math.imul(ve, We) | 0, S = S + Math.imul(ve, Qe) | 0;
        var Ir = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (Ir >>> 26) | 0, Ir &= 67108863, y = Math.imul(Oe, je), o = Math.imul(Oe, Ce), o = o + Math.imul(Ee, je) | 0, S = Math.imul(Ee, Ce), y = y + Math.imul(Ie, Ze) | 0, o = o + Math.imul(Ie, qe) | 0, o = o + Math.imul(we, Ze) | 0, S = S + Math.imul(we, qe) | 0, y = y + Math.imul(ye, We) | 0, o = o + Math.imul(ye, Qe) | 0, o = o + Math.imul(pe, We) | 0, S = S + Math.imul(pe, Qe) | 0;
        var Ar = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (Ar >>> 26) | 0, Ar &= 67108863, y = Math.imul(Oe, Ze), o = Math.imul(Oe, qe), o = o + Math.imul(Ee, Ze) | 0, S = Math.imul(Ee, qe), y = y + Math.imul(Ie, We) | 0, o = o + Math.imul(Ie, Qe) | 0, o = o + Math.imul(we, We) | 0, S = S + Math.imul(we, Qe) | 0;
        var qr = (E + y | 0) + ((o & 8191) << 13) | 0;
        E = (S + (o >>> 13) | 0) + (qr >>> 26) | 0, qr &= 67108863, y = Math.imul(Oe, We), o = Math.imul(Oe, Qe), o = o + Math.imul(Ee, We) | 0, S = Math.imul(Ee, Qe);
        var zr = (E + y | 0) + ((o & 8191) << 13) | 0;
        return E = (S + (o >>> 13) | 0) + (zr >>> 26) | 0, zr &= 67108863, x[0] = Qt, x[1] = Zt, x[2] = Jt, x[3] = Xt, x[4] = kt, x[5] = ar, x[6] = lr, x[7] = or, x[8] = dr, x[9] = pr, x[10] = fr, x[11] = ur, x[12] = hr, x[13] = qt, x[14] = Er, x[15] = Ir, x[16] = Ar, x[17] = qr, x[18] = zr, E !== 0 && (x[19] = E, p.length++), p;
      };
      Math.imul || (P = O);
      function F(g, a, c) {
        c.negative = a.negative ^ g.negative, c.length = g.length + a.length;
        for (var p = 0, w = 0, _ = 0; _ < c.length - 1; _++) {
          var x = w;
          w = 0;
          for (var E = p & 67108863, y = Math.min(_, a.length - 1), o = Math.max(0, _ - g.length + 1); o <= y; o++) {
            var S = _ - o, J = g.words[S] | 0, z = a.words[o] | 0, k = J * z, j = k & 67108863;
            x = x + (k / 67108864 | 0) | 0, j = j + E | 0, E = j & 67108863, x = x + (j >>> 26) | 0, w += x >>> 26, x &= 67108863;
          }
          c.words[_] = E, p = x, x = w;
        }
        return p !== 0 ? c.words[_] = p : c.length--, c._strip();
      }
      function H(g, a, c) {
        return F(g, a, c);
      }
      n.prototype.mulTo = function(a, c) {
        var p, w = this.length + a.length;
        return this.length === 10 && a.length === 10 ? p = P(this, a, c) : w < 63 ? p = O(this, a, c) : w < 1024 ? p = F(this, a, c) : p = H(this, a, c), p;
      }, n.prototype.mul = function(a) {
        var c = new n(null);
        return c.words = new Array(this.length + a.length), this.mulTo(a, c);
      }, n.prototype.mulf = function(a) {
        var c = new n(null);
        return c.words = new Array(this.length + a.length), H(this, a, c);
      }, n.prototype.imul = function(a) {
        return this.clone().mulTo(a, this);
      }, n.prototype.imuln = function(a) {
        var c = a < 0;
        c && (a = -a), i(typeof a == "number"), i(a < 67108864);
        for (var p = 0, w = 0; w < this.length; w++) {
          var _ = (this.words[w] | 0) * a, x = (_ & 67108863) + (p & 67108863);
          p >>= 26, p += _ / 67108864 | 0, p += x >>> 26, this.words[w] = x & 67108863;
        }
        return p !== 0 && (this.words[w] = p, this.length++), c ? this.ineg() : this;
      }, n.prototype.muln = function(a) {
        return this.clone().imuln(a);
      }, n.prototype.sqr = function() {
        return this.mul(this);
      }, n.prototype.isqr = function() {
        return this.imul(this.clone());
      }, n.prototype.pow = function(a) {
        var c = R(a);
        if (c.length === 0)
          return new n(1);
        for (var p = this, w = 0; w < c.length && c[w] === 0; w++, p = p.sqr())
          ;
        if (++w < c.length)
          for (var _ = p.sqr(); w < c.length; w++, _ = _.sqr())
            c[w] !== 0 && (p = p.mul(_));
        return p;
      }, n.prototype.iushln = function(a) {
        i(typeof a == "number" && a >= 0);
        var c = a % 26, p = (a - c) / 26, w = 67108863 >>> 26 - c << 26 - c, _;
        if (c !== 0) {
          var x = 0;
          for (_ = 0; _ < this.length; _++) {
            var E = this.words[_] & w, y = (this.words[_] | 0) - E << c;
            this.words[_] = y | x, x = E >>> 26 - c;
          }
          x && (this.words[_] = x, this.length++);
        }
        if (p !== 0) {
          for (_ = this.length - 1; _ >= 0; _--)
            this.words[_ + p] = this.words[_];
          for (_ = 0; _ < p; _++)
            this.words[_] = 0;
          this.length += p;
        }
        return this._strip();
      }, n.prototype.ishln = function(a) {
        return i(this.negative === 0), this.iushln(a);
      }, n.prototype.iushrn = function(a, c, p) {
        i(typeof a == "number" && a >= 0);
        var w;
        c ? w = (c - c % 26) / 26 : w = 0;
        var _ = a % 26, x = Math.min((a - _) / 26, this.length), E = 67108863 ^ 67108863 >>> _ << _, y = p;
        if (w -= x, w = Math.max(0, w), y) {
          for (var o = 0; o < x; o++)
            y.words[o] = this.words[o];
          y.length = x;
        }
        if (x !== 0)
          if (this.length > x)
            for (this.length -= x, o = 0; o < this.length; o++)
              this.words[o] = this.words[o + x];
          else
            this.words[0] = 0, this.length = 1;
        var S = 0;
        for (o = this.length - 1; o >= 0 && (S !== 0 || o >= w); o--) {
          var J = this.words[o] | 0;
          this.words[o] = S << 26 - _ | J >>> _, S = J & E;
        }
        return y && S !== 0 && (y.words[y.length++] = S), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
      }, n.prototype.ishrn = function(a, c, p) {
        return i(this.negative === 0), this.iushrn(a, c, p);
      }, n.prototype.shln = function(a) {
        return this.clone().ishln(a);
      }, n.prototype.ushln = function(a) {
        return this.clone().iushln(a);
      }, n.prototype.shrn = function(a) {
        return this.clone().ishrn(a);
      }, n.prototype.ushrn = function(a) {
        return this.clone().iushrn(a);
      }, n.prototype.testn = function(a) {
        i(typeof a == "number" && a >= 0);
        var c = a % 26, p = (a - c) / 26, w = 1 << c;
        if (this.length <= p)
          return !1;
        var _ = this.words[p];
        return !!(_ & w);
      }, n.prototype.imaskn = function(a) {
        i(typeof a == "number" && a >= 0);
        var c = a % 26, p = (a - c) / 26;
        if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= p)
          return this;
        if (c !== 0 && p++, this.length = Math.min(p, this.length), c !== 0) {
          var w = 67108863 ^ 67108863 >>> c << c;
          this.words[this.length - 1] &= w;
        }
        return this._strip();
      }, n.prototype.maskn = function(a) {
        return this.clone().imaskn(a);
      }, n.prototype.iaddn = function(a) {
        return i(typeof a == "number"), i(a < 67108864), a < 0 ? this.isubn(-a) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= a ? (this.words[0] = a - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(a), this.negative = 1, this) : this._iaddn(a);
      }, n.prototype._iaddn = function(a) {
        this.words[0] += a;
        for (var c = 0; c < this.length && this.words[c] >= 67108864; c++)
          this.words[c] -= 67108864, c === this.length - 1 ? this.words[c + 1] = 1 : this.words[c + 1]++;
        return this.length = Math.max(this.length, c + 1), this;
      }, n.prototype.isubn = function(a) {
        if (i(typeof a == "number"), i(a < 67108864), a < 0)
          return this.iaddn(-a);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(a), this.negative = 1, this;
        if (this.words[0] -= a, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var c = 0; c < this.length && this.words[c] < 0; c++)
            this.words[c] += 67108864, this.words[c + 1] -= 1;
        return this._strip();
      }, n.prototype.addn = function(a) {
        return this.clone().iaddn(a);
      }, n.prototype.subn = function(a) {
        return this.clone().isubn(a);
      }, n.prototype.iabs = function() {
        return this.negative = 0, this;
      }, n.prototype.abs = function() {
        return this.clone().iabs();
      }, n.prototype._ishlnsubmul = function(a, c, p) {
        var w = a.length + p, _;
        this._expand(w);
        var x, E = 0;
        for (_ = 0; _ < a.length; _++) {
          x = (this.words[_ + p] | 0) + E;
          var y = (a.words[_] | 0) * c;
          x -= y & 67108863, E = (x >> 26) - (y / 67108864 | 0), this.words[_ + p] = x & 67108863;
        }
        for (; _ < this.length - p; _++)
          x = (this.words[_ + p] | 0) + E, E = x >> 26, this.words[_ + p] = x & 67108863;
        if (E === 0)
          return this._strip();
        for (i(E === -1), E = 0, _ = 0; _ < this.length; _++)
          x = -(this.words[_] | 0) + E, E = x >> 26, this.words[_] = x & 67108863;
        return this.negative = 1, this._strip();
      }, n.prototype._wordDiv = function(a, c) {
        var p = this.length - a.length, w = this.clone(), _ = a, x = _.words[_.length - 1] | 0, E = this._countBits(x);
        p = 26 - E, p !== 0 && (_ = _.ushln(p), w.iushln(p), x = _.words[_.length - 1] | 0);
        var y = w.length - _.length, o;
        if (c !== "mod") {
          o = new n(null), o.length = y + 1, o.words = new Array(o.length);
          for (var S = 0; S < o.length; S++)
            o.words[S] = 0;
        }
        var J = w.clone()._ishlnsubmul(_, 1, y);
        J.negative === 0 && (w = J, o && (o.words[y] = 1));
        for (var z = y - 1; z >= 0; z--) {
          var k = (w.words[_.length + z] | 0) * 67108864 + (w.words[_.length + z - 1] | 0);
          for (k = Math.min(k / x | 0, 67108863), w._ishlnsubmul(_, k, z); w.negative !== 0; )
            k--, w.negative = 0, w._ishlnsubmul(_, 1, z), w.isZero() || (w.negative ^= 1);
          o && (o.words[z] = k);
        }
        return o && o._strip(), w._strip(), c !== "div" && p !== 0 && w.iushrn(p), {
          div: o || null,
          mod: w
        };
      }, n.prototype.divmod = function(a, c, p) {
        if (i(!a.isZero()), this.isZero())
          return {
            div: new n(0),
            mod: new n(0)
          };
        var w, _, x;
        return this.negative !== 0 && a.negative === 0 ? (x = this.neg().divmod(a, c), c !== "mod" && (w = x.div.neg()), c !== "div" && (_ = x.mod.neg(), p && _.negative !== 0 && _.iadd(a)), {
          div: w,
          mod: _
        }) : this.negative === 0 && a.negative !== 0 ? (x = this.divmod(a.neg(), c), c !== "mod" && (w = x.div.neg()), {
          div: w,
          mod: x.mod
        }) : (this.negative & a.negative) !== 0 ? (x = this.neg().divmod(a.neg(), c), c !== "div" && (_ = x.mod.neg(), p && _.negative !== 0 && _.isub(a)), {
          div: x.div,
          mod: _
        }) : a.length > this.length || this.cmp(a) < 0 ? {
          div: new n(0),
          mod: this
        } : a.length === 1 ? c === "div" ? {
          div: this.divn(a.words[0]),
          mod: null
        } : c === "mod" ? {
          div: null,
          mod: new n(this.modrn(a.words[0]))
        } : {
          div: this.divn(a.words[0]),
          mod: new n(this.modrn(a.words[0]))
        } : this._wordDiv(a, c);
      }, n.prototype.div = function(a) {
        return this.divmod(a, "div", !1).div;
      }, n.prototype.mod = function(a) {
        return this.divmod(a, "mod", !1).mod;
      }, n.prototype.umod = function(a) {
        return this.divmod(a, "mod", !0).mod;
      }, n.prototype.divRound = function(a) {
        var c = this.divmod(a);
        if (c.mod.isZero())
          return c.div;
        var p = c.div.negative !== 0 ? c.mod.isub(a) : c.mod, w = a.ushrn(1), _ = a.andln(1), x = p.cmp(w);
        return x < 0 || _ === 1 && x === 0 ? c.div : c.div.negative !== 0 ? c.div.isubn(1) : c.div.iaddn(1);
      }, n.prototype.modrn = function(a) {
        var c = a < 0;
        c && (a = -a), i(a <= 67108863);
        for (var p = (1 << 26) % a, w = 0, _ = this.length - 1; _ >= 0; _--)
          w = (p * w + (this.words[_] | 0)) % a;
        return c ? -w : w;
      }, n.prototype.modn = function(a) {
        return this.modrn(a);
      }, n.prototype.idivn = function(a) {
        var c = a < 0;
        c && (a = -a), i(a <= 67108863);
        for (var p = 0, w = this.length - 1; w >= 0; w--) {
          var _ = (this.words[w] | 0) + p * 67108864;
          this.words[w] = _ / a | 0, p = _ % a;
        }
        return this._strip(), c ? this.ineg() : this;
      }, n.prototype.divn = function(a) {
        return this.clone().idivn(a);
      }, n.prototype.egcd = function(a) {
        i(a.negative === 0), i(!a.isZero());
        var c = this, p = a.clone();
        c.negative !== 0 ? c = c.umod(a) : c = c.clone();
        for (var w = new n(1), _ = new n(0), x = new n(0), E = new n(1), y = 0; c.isEven() && p.isEven(); )
          c.iushrn(1), p.iushrn(1), ++y;
        for (var o = p.clone(), S = c.clone(); !c.isZero(); ) {
          for (var J = 0, z = 1; (c.words[0] & z) === 0 && J < 26; ++J, z <<= 1)
            ;
          if (J > 0)
            for (c.iushrn(J); J-- > 0; )
              (w.isOdd() || _.isOdd()) && (w.iadd(o), _.isub(S)), w.iushrn(1), _.iushrn(1);
          for (var k = 0, j = 1; (p.words[0] & j) === 0 && k < 26; ++k, j <<= 1)
            ;
          if (k > 0)
            for (p.iushrn(k); k-- > 0; )
              (x.isOdd() || E.isOdd()) && (x.iadd(o), E.isub(S)), x.iushrn(1), E.iushrn(1);
          c.cmp(p) >= 0 ? (c.isub(p), w.isub(x), _.isub(E)) : (p.isub(c), x.isub(w), E.isub(_));
        }
        return {
          a: x,
          b: E,
          gcd: p.iushln(y)
        };
      }, n.prototype._invmp = function(a) {
        i(a.negative === 0), i(!a.isZero());
        var c = this, p = a.clone();
        c.negative !== 0 ? c = c.umod(a) : c = c.clone();
        for (var w = new n(1), _ = new n(0), x = p.clone(); c.cmpn(1) > 0 && p.cmpn(1) > 0; ) {
          for (var E = 0, y = 1; (c.words[0] & y) === 0 && E < 26; ++E, y <<= 1)
            ;
          if (E > 0)
            for (c.iushrn(E); E-- > 0; )
              w.isOdd() && w.iadd(x), w.iushrn(1);
          for (var o = 0, S = 1; (p.words[0] & S) === 0 && o < 26; ++o, S <<= 1)
            ;
          if (o > 0)
            for (p.iushrn(o); o-- > 0; )
              _.isOdd() && _.iadd(x), _.iushrn(1);
          c.cmp(p) >= 0 ? (c.isub(p), w.isub(_)) : (p.isub(c), _.isub(w));
        }
        var J;
        return c.cmpn(1) === 0 ? J = w : J = _, J.cmpn(0) < 0 && J.iadd(a), J;
      }, n.prototype.gcd = function(a) {
        if (this.isZero())
          return a.abs();
        if (a.isZero())
          return this.abs();
        var c = this.clone(), p = a.clone();
        c.negative = 0, p.negative = 0;
        for (var w = 0; c.isEven() && p.isEven(); w++)
          c.iushrn(1), p.iushrn(1);
        do {
          for (; c.isEven(); )
            c.iushrn(1);
          for (; p.isEven(); )
            p.iushrn(1);
          var _ = c.cmp(p);
          if (_ < 0) {
            var x = c;
            c = p, p = x;
          } else if (_ === 0 || p.cmpn(1) === 0)
            break;
          c.isub(p);
        } while (!0);
        return p.iushln(w);
      }, n.prototype.invm = function(a) {
        return this.egcd(a).a.umod(a);
      }, n.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, n.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, n.prototype.andln = function(a) {
        return this.words[0] & a;
      }, n.prototype.bincn = function(a) {
        i(typeof a == "number");
        var c = a % 26, p = (a - c) / 26, w = 1 << c;
        if (this.length <= p)
          return this._expand(p + 1), this.words[p] |= w, this;
        for (var _ = w, x = p; _ !== 0 && x < this.length; x++) {
          var E = this.words[x] | 0;
          E += _, _ = E >>> 26, E &= 67108863, this.words[x] = E;
        }
        return _ !== 0 && (this.words[x] = _, this.length++), this;
      }, n.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, n.prototype.cmpn = function(a) {
        var c = a < 0;
        if (this.negative !== 0 && !c)
          return -1;
        if (this.negative === 0 && c)
          return 1;
        this._strip();
        var p;
        if (this.length > 1)
          p = 1;
        else {
          c && (a = -a), i(a <= 67108863, "Number is too big");
          var w = this.words[0] | 0;
          p = w === a ? 0 : w < a ? -1 : 1;
        }
        return this.negative !== 0 ? -p | 0 : p;
      }, n.prototype.cmp = function(a) {
        if (this.negative !== 0 && a.negative === 0)
          return -1;
        if (this.negative === 0 && a.negative !== 0)
          return 1;
        var c = this.ucmp(a);
        return this.negative !== 0 ? -c | 0 : c;
      }, n.prototype.ucmp = function(a) {
        if (this.length > a.length)
          return 1;
        if (this.length < a.length)
          return -1;
        for (var c = 0, p = this.length - 1; p >= 0; p--) {
          var w = this.words[p] | 0, _ = a.words[p] | 0;
          if (w !== _) {
            w < _ ? c = -1 : w > _ && (c = 1);
            break;
          }
        }
        return c;
      }, n.prototype.gtn = function(a) {
        return this.cmpn(a) === 1;
      }, n.prototype.gt = function(a) {
        return this.cmp(a) === 1;
      }, n.prototype.gten = function(a) {
        return this.cmpn(a) >= 0;
      }, n.prototype.gte = function(a) {
        return this.cmp(a) >= 0;
      }, n.prototype.ltn = function(a) {
        return this.cmpn(a) === -1;
      }, n.prototype.lt = function(a) {
        return this.cmp(a) === -1;
      }, n.prototype.lten = function(a) {
        return this.cmpn(a) <= 0;
      }, n.prototype.lte = function(a) {
        return this.cmp(a) <= 0;
      }, n.prototype.eqn = function(a) {
        return this.cmpn(a) === 0;
      }, n.prototype.eq = function(a) {
        return this.cmp(a) === 0;
      }, n.red = function(a) {
        return new W(a);
      }, n.prototype.toRed = function(a) {
        return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), a.convertTo(this)._forceRed(a);
      }, n.prototype.fromRed = function() {
        return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, n.prototype._forceRed = function(a) {
        return this.red = a, this;
      }, n.prototype.forceRed = function(a) {
        return i(!this.red, "Already a number in reduction context"), this._forceRed(a);
      }, n.prototype.redAdd = function(a) {
        return i(this.red, "redAdd works only with red numbers"), this.red.add(this, a);
      }, n.prototype.redIAdd = function(a) {
        return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, a);
      }, n.prototype.redSub = function(a) {
        return i(this.red, "redSub works only with red numbers"), this.red.sub(this, a);
      }, n.prototype.redISub = function(a) {
        return i(this.red, "redISub works only with red numbers"), this.red.isub(this, a);
      }, n.prototype.redShl = function(a) {
        return i(this.red, "redShl works only with red numbers"), this.red.shl(this, a);
      }, n.prototype.redMul = function(a) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, a), this.red.mul(this, a);
      }, n.prototype.redIMul = function(a) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, a), this.red.imul(this, a);
      }, n.prototype.redSqr = function() {
        return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, n.prototype.redISqr = function() {
        return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, n.prototype.redSqrt = function() {
        return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, n.prototype.redInvm = function() {
        return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, n.prototype.redNeg = function() {
        return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, n.prototype.redPow = function(a) {
        return i(this.red && !a.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, a);
      };
      var Q = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function Z(g, a) {
        this.name = g, this.p = new n(a, 16), this.n = this.p.bitLength(), this.k = new n(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      Z.prototype._tmp = function() {
        var a = new n(null);
        return a.words = new Array(Math.ceil(this.n / 13)), a;
      }, Z.prototype.ireduce = function(a) {
        var c = a, p;
        do
          this.split(c, this.tmp), c = this.imulK(c), c = c.iadd(this.tmp), p = c.bitLength();
        while (p > this.n);
        var w = p < this.n ? -1 : c.ucmp(this.p);
        return w === 0 ? (c.words[0] = 0, c.length = 1) : w > 0 ? c.isub(this.p) : c.strip !== void 0 ? c.strip() : c._strip(), c;
      }, Z.prototype.split = function(a, c) {
        a.iushrn(this.n, 0, c);
      }, Z.prototype.imulK = function(a) {
        return a.imul(this.k);
      };
      function B() {
        Z.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      s(B, Z), B.prototype.split = function(a, c) {
        for (var p = 4194303, w = Math.min(a.length, 9), _ = 0; _ < w; _++)
          c.words[_] = a.words[_];
        if (c.length = w, a.length <= 9) {
          a.words[0] = 0, a.length = 1;
          return;
        }
        var x = a.words[9];
        for (c.words[c.length++] = x & p, _ = 10; _ < a.length; _++) {
          var E = a.words[_] | 0;
          a.words[_ - 10] = (E & p) << 4 | x >>> 22, x = E;
        }
        x >>>= 22, a.words[_ - 10] = x, x === 0 && a.length > 10 ? a.length -= 10 : a.length -= 9;
      }, B.prototype.imulK = function(a) {
        a.words[a.length] = 0, a.words[a.length + 1] = 0, a.length += 2;
        for (var c = 0, p = 0; p < a.length; p++) {
          var w = a.words[p] | 0;
          c += w * 977, a.words[p] = c & 67108863, c = w * 64 + (c / 67108864 | 0);
        }
        return a.words[a.length - 1] === 0 && (a.length--, a.words[a.length - 1] === 0 && a.length--), a;
      };
      function Y() {
        Z.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      s(Y, Z);
      function ae() {
        Z.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      s(ae, Z);
      function se() {
        Z.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      s(se, Z), se.prototype.imulK = function(a) {
        for (var c = 0, p = 0; p < a.length; p++) {
          var w = (a.words[p] | 0) * 19 + c, _ = w & 67108863;
          w >>>= 26, a.words[p] = _, c = w;
        }
        return c !== 0 && (a.words[a.length++] = c), a;
      }, n._prime = function(a) {
        if (Q[a])
          return Q[a];
        var c;
        if (a === "k256")
          c = new B();
        else if (a === "p224")
          c = new Y();
        else if (a === "p192")
          c = new ae();
        else if (a === "p25519")
          c = new se();
        else
          throw new Error("Unknown prime " + a);
        return Q[a] = c, c;
      };
      function W(g) {
        if (typeof g == "string") {
          var a = n._prime(g);
          this.m = a.p, this.prime = a;
        } else
          i(g.gtn(1), "modulus must be greater than 1"), this.m = g, this.prime = null;
      }
      W.prototype._verify1 = function(a) {
        i(a.negative === 0, "red works only with positives"), i(a.red, "red works only with red numbers");
      }, W.prototype._verify2 = function(a, c) {
        i((a.negative | c.negative) === 0, "red works only with positives"), i(
          a.red && a.red === c.red,
          "red works only with red numbers"
        );
      }, W.prototype.imod = function(a) {
        return this.prime ? this.prime.ireduce(a)._forceRed(this) : (l(a, a.umod(this.m)._forceRed(this)), a);
      }, W.prototype.neg = function(a) {
        return a.isZero() ? a.clone() : this.m.sub(a)._forceRed(this);
      }, W.prototype.add = function(a, c) {
        this._verify2(a, c);
        var p = a.add(c);
        return p.cmp(this.m) >= 0 && p.isub(this.m), p._forceRed(this);
      }, W.prototype.iadd = function(a, c) {
        this._verify2(a, c);
        var p = a.iadd(c);
        return p.cmp(this.m) >= 0 && p.isub(this.m), p;
      }, W.prototype.sub = function(a, c) {
        this._verify2(a, c);
        var p = a.sub(c);
        return p.cmpn(0) < 0 && p.iadd(this.m), p._forceRed(this);
      }, W.prototype.isub = function(a, c) {
        this._verify2(a, c);
        var p = a.isub(c);
        return p.cmpn(0) < 0 && p.iadd(this.m), p;
      }, W.prototype.shl = function(a, c) {
        return this._verify1(a), this.imod(a.ushln(c));
      }, W.prototype.imul = function(a, c) {
        return this._verify2(a, c), this.imod(a.imul(c));
      }, W.prototype.mul = function(a, c) {
        return this._verify2(a, c), this.imod(a.mul(c));
      }, W.prototype.isqr = function(a) {
        return this.imul(a, a.clone());
      }, W.prototype.sqr = function(a) {
        return this.mul(a, a);
      }, W.prototype.sqrt = function(a) {
        if (a.isZero())
          return a.clone();
        var c = this.m.andln(3);
        if (i(c % 2 === 1), c === 3) {
          var p = this.m.add(new n(1)).iushrn(2);
          return this.pow(a, p);
        }
        for (var w = this.m.subn(1), _ = 0; !w.isZero() && w.andln(1) === 0; )
          _++, w.iushrn(1);
        i(!w.isZero());
        var x = new n(1).toRed(this), E = x.redNeg(), y = this.m.subn(1).iushrn(1), o = this.m.bitLength();
        for (o = new n(2 * o * o).toRed(this); this.pow(o, y).cmp(E) !== 0; )
          o.redIAdd(E);
        for (var S = this.pow(o, w), J = this.pow(a, w.addn(1).iushrn(1)), z = this.pow(a, w), k = _; z.cmp(x) !== 0; ) {
          for (var j = z, q = 0; j.cmp(x) !== 0; q++)
            j = j.redSqr();
          i(q < k);
          var K = this.pow(S, new n(1).iushln(k - q - 1));
          J = J.redMul(K), S = K.redSqr(), z = z.redMul(S), k = q;
        }
        return J;
      }, W.prototype.invm = function(a) {
        var c = a._invmp(this.m);
        return c.negative !== 0 ? (c.negative = 0, this.imod(c).redNeg()) : this.imod(c);
      }, W.prototype.pow = function(a, c) {
        if (c.isZero())
          return new n(1).toRed(this);
        if (c.cmpn(1) === 0)
          return a.clone();
        var p = 4, w = new Array(1 << p);
        w[0] = new n(1).toRed(this), w[1] = a;
        for (var _ = 2; _ < w.length; _++)
          w[_] = this.mul(w[_ - 1], a);
        var x = w[0], E = 0, y = 0, o = c.bitLength() % 26;
        for (o === 0 && (o = 26), _ = c.length - 1; _ >= 0; _--) {
          for (var S = c.words[_], J = o - 1; J >= 0; J--) {
            var z = S >> J & 1;
            if (x !== w[0] && (x = this.sqr(x)), z === 0 && E === 0) {
              y = 0;
              continue;
            }
            E <<= 1, E |= z, y++, !(y !== p && (_ !== 0 || J !== 0)) && (x = this.mul(x, w[E]), y = 0, E = 0);
          }
          o = 26;
        }
        return x;
      }, W.prototype.convertTo = function(a) {
        var c = a.umod(this.m);
        return c === a ? c.clone() : c;
      }, W.prototype.convertFrom = function(a) {
        var c = a.clone();
        return c.red = null, c;
      }, n.mont = function(a) {
        return new C(a);
      };
      function C(g) {
        W.call(this, g), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new n(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      s(C, W), C.prototype.convertTo = function(a) {
        return this.imod(a.ushln(this.shift));
      }, C.prototype.convertFrom = function(a) {
        var c = this.imod(a.mul(this.rinv));
        return c.red = null, c;
      }, C.prototype.imul = function(a, c) {
        if (a.isZero() || c.isZero())
          return a.words[0] = 0, a.length = 1, a;
        var p = a.imul(c), w = p.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _ = p.isub(w).iushrn(this.shift), x = _;
        return _.cmp(this.m) >= 0 ? x = _.isub(this.m) : _.cmpn(0) < 0 && (x = _.iadd(this.m)), x._forceRed(this);
      }, C.prototype.mul = function(a, c) {
        if (a.isZero() || c.isZero())
          return new n(0)._forceRed(this);
        var p = a.mul(c), w = p.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _ = p.isub(w).iushrn(this.shift), x = _;
        return _.cmp(this.m) >= 0 ? x = _.isub(this.m) : _.cmpn(0) < 0 && (x = _.iadd(this.m)), x._forceRed(this);
      }, C.prototype.invm = function(a) {
        var c = this.imod(a._invmp(this.m).mul(this.r2));
        return c._forceRed(this);
      };
    })(t, nt);
  }(ty)), ty.exports;
}
var Vn = {}, ry = {}, iy = {}, ny = {}, sy, e8;
function ww() {
  if (e8)
    return sy;
  e8 = 1;
  var t = Tn, e = t.Buffer, r = {}, i;
  for (i in t)
    !t.hasOwnProperty(i) || i === "SlowBuffer" || i === "Buffer" || (r[i] = t[i]);
  var s = r.Buffer = {};
  for (i in e)
    !e.hasOwnProperty(i) || i === "allocUnsafe" || i === "allocUnsafeSlow" || (s[i] = e[i]);
  if (r.Buffer.prototype = e.prototype, (!s.from || s.from === Uint8Array.from) && (s.from = function(n, f, u) {
    if (typeof n == "number")
      throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof n);
    if (n && typeof n.length > "u")
      throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof n);
    return e(n, f, u);
  }), s.alloc || (s.alloc = function(n, f, u) {
    if (typeof n != "number")
      throw new TypeError('The "size" argument must be of type number. Received type ' + typeof n);
    if (n < 0 || n >= 2 * (1 << 30))
      throw new RangeError('The value "' + n + '" is invalid for option "size"');
    var h = e(n);
    return !f || f.length === 0 ? h.fill(0) : typeof u == "string" ? h.fill(f, u) : h.fill(f), h;
  }), !r.kStringMaxLength)
    try {
      r.kStringMaxLength = process.binding("buffer").kStringMaxLength;
    } catch {
    }
  return r.constants || (r.constants = {
    MAX_LENGTH: r.kMaxLength
  }, r.kStringMaxLength && (r.constants.MAX_STRING_LENGTH = r.kStringMaxLength)), sy = r, sy;
}
var ay = {}, t8;
function _w() {
  if (t8)
    return ay;
  t8 = 1;
  const t = It.exports;
  function e(i) {
    this._reporterState = {
      obj: null,
      path: [],
      options: i || {},
      errors: []
    };
  }
  ay.Reporter = e, e.prototype.isError = function(s) {
    return s instanceof r;
  }, e.prototype.save = function() {
    const s = this._reporterState;
    return { obj: s.obj, pathLen: s.path.length };
  }, e.prototype.restore = function(s) {
    const n = this._reporterState;
    n.obj = s.obj, n.path = n.path.slice(0, s.pathLen);
  }, e.prototype.enterKey = function(s) {
    return this._reporterState.path.push(s);
  }, e.prototype.exitKey = function(s) {
    const n = this._reporterState;
    n.path = n.path.slice(0, s - 1);
  }, e.prototype.leaveKey = function(s, n, f) {
    const u = this._reporterState;
    this.exitKey(s), u.obj !== null && (u.obj[n] = f);
  }, e.prototype.path = function() {
    return this._reporterState.path.join("/");
  }, e.prototype.enterObject = function() {
    const s = this._reporterState, n = s.obj;
    return s.obj = {}, n;
  }, e.prototype.leaveObject = function(s) {
    const n = this._reporterState, f = n.obj;
    return n.obj = s, f;
  }, e.prototype.error = function(s) {
    let n;
    const f = this._reporterState, u = s instanceof r;
    if (u ? n = s : n = new r(f.path.map(function(h) {
      return "[" + JSON.stringify(h) + "]";
    }).join(""), s.message || s, s.stack), !f.options.partial)
      throw n;
    return u || f.errors.push(n), n;
  }, e.prototype.wrapResult = function(s) {
    const n = this._reporterState;
    return n.options.partial ? {
      result: this.isError(s) ? null : s,
      errors: n.errors
    } : s;
  };
  function r(i, s) {
    this.path = i, this.rethrow(s);
  }
  return t(r, Error), r.prototype.rethrow = function(s) {
    if (this.message = s + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, r), !this.stack)
      try {
        throw new Error(this.message);
      } catch (n) {
        this.stack = n.stack;
      }
    return this;
  }, ay;
}
var kd = {}, r8;
function mh() {
  if (r8)
    return kd;
  r8 = 1;
  const t = It.exports, e = _w().Reporter, r = ww().Buffer;
  function i(n, f) {
    if (e.call(this, f), !r.isBuffer(n)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = n, this.offset = 0, this.length = n.length;
  }
  t(i, e), kd.DecoderBuffer = i, i.isDecoderBuffer = function(f) {
    return f instanceof i ? !0 : typeof f == "object" && r.isBuffer(f.base) && f.constructor.name === "DecoderBuffer" && typeof f.offset == "number" && typeof f.length == "number" && typeof f.save == "function" && typeof f.restore == "function" && typeof f.isEmpty == "function" && typeof f.readUInt8 == "function" && typeof f.skip == "function" && typeof f.raw == "function";
  }, i.prototype.save = function() {
    return { offset: this.offset, reporter: e.prototype.save.call(this) };
  }, i.prototype.restore = function(f) {
    const u = new i(this.base);
    return u.offset = f.offset, u.length = this.offset, this.offset = f.offset, e.prototype.restore.call(this, f.reporter), u;
  }, i.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, i.prototype.readUInt8 = function(f) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(f || "DecoderBuffer overrun");
  }, i.prototype.skip = function(f, u) {
    if (!(this.offset + f <= this.length))
      return this.error(u || "DecoderBuffer overrun");
    const h = new i(this.base);
    return h._reporterState = this._reporterState, h.offset = this.offset, h.length = this.offset + f, this.offset += f, h;
  }, i.prototype.raw = function(f) {
    return this.base.slice(f ? f.offset : this.offset, this.length);
  };
  function s(n, f) {
    if (Array.isArray(n))
      this.length = 0, this.value = n.map(function(u) {
        return s.isEncoderBuffer(u) || (u = new s(u, f)), this.length += u.length, u;
      }, this);
    else if (typeof n == "number") {
      if (!(0 <= n && n <= 255))
        return f.error("non-byte EncoderBuffer value");
      this.value = n, this.length = 1;
    } else if (typeof n == "string")
      this.value = n, this.length = r.byteLength(n);
    else if (r.isBuffer(n))
      this.value = n, this.length = n.length;
    else
      return f.error("Unsupported type: " + typeof n);
  }
  return kd.EncoderBuffer = s, s.isEncoderBuffer = function(f) {
    return f instanceof s ? !0 : typeof f == "object" && f.constructor.name === "EncoderBuffer" && typeof f.length == "number" && typeof f.join == "function";
  }, s.prototype.join = function(f, u) {
    return f || (f = r.alloc(this.length)), u || (u = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(h) {
      h.join(f, u), u += h.length;
    }) : (typeof this.value == "number" ? f[u] = this.value : typeof this.value == "string" ? f.write(this.value, u) : r.isBuffer(this.value) && this.value.copy(f, u), u += this.length)), f;
  }, kd;
}
var oy, i8;
function Mw() {
  if (i8)
    return oy;
  i8 = 1;
  const t = _w().Reporter, e = mh().EncoderBuffer, r = mh().DecoderBuffer, i = Nn, s = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], n = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat(s), f = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function u(d, l, m) {
    const b = {};
    this._baseState = b, b.name = m, b.enc = d, b.parent = l || null, b.children = null, b.tag = null, b.args = null, b.reverseArgs = null, b.choice = null, b.optional = !1, b.any = !1, b.obj = !1, b.use = null, b.useDecoder = null, b.key = null, b.default = null, b.explicit = null, b.implicit = null, b.contains = null, b.parent || (b.children = [], this._wrap());
  }
  oy = u;
  const h = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return u.prototype.clone = function() {
    const l = this._baseState, m = {};
    h.forEach(function(M) {
      m[M] = l[M];
    });
    const b = new this.constructor(m.parent);
    return b._baseState = m, b;
  }, u.prototype._wrap = function() {
    const l = this._baseState;
    n.forEach(function(m) {
      this[m] = function() {
        const M = new this.constructor(this);
        return l.children.push(M), M[m].apply(M, arguments);
      };
    }, this);
  }, u.prototype._init = function(l) {
    const m = this._baseState;
    i(m.parent === null), l.call(this), m.children = m.children.filter(function(b) {
      return b._baseState.parent === this;
    }, this), i.equal(m.children.length, 1, "Root node can have only one child");
  }, u.prototype._useArgs = function(l) {
    const m = this._baseState, b = l.filter(function(M) {
      return M instanceof this.constructor;
    }, this);
    l = l.filter(function(M) {
      return !(M instanceof this.constructor);
    }, this), b.length !== 0 && (i(m.children === null), m.children = b, b.forEach(function(M) {
      M._baseState.parent = this;
    }, this)), l.length !== 0 && (i(m.args === null), m.args = l, m.reverseArgs = l.map(function(M) {
      if (typeof M != "object" || M.constructor !== Object)
        return M;
      const A = {};
      return Object.keys(M).forEach(function(N) {
        N == (N | 0) && (N |= 0);
        const R = M[N];
        A[R] = N;
      }), A;
    }));
  }, f.forEach(function(d) {
    u.prototype[d] = function() {
      const m = this._baseState;
      throw new Error(d + " not implemented for encoding: " + m.enc);
    };
  }), s.forEach(function(d) {
    u.prototype[d] = function() {
      const m = this._baseState, b = Array.prototype.slice.call(arguments);
      return i(m.tag === null), m.tag = d, this._useArgs(b), this;
    };
  }), u.prototype.use = function(l) {
    i(l);
    const m = this._baseState;
    return i(m.use === null), m.use = l, this;
  }, u.prototype.optional = function() {
    const l = this._baseState;
    return l.optional = !0, this;
  }, u.prototype.def = function(l) {
    const m = this._baseState;
    return i(m.default === null), m.default = l, m.optional = !0, this;
  }, u.prototype.explicit = function(l) {
    const m = this._baseState;
    return i(m.explicit === null && m.implicit === null), m.explicit = l, this;
  }, u.prototype.implicit = function(l) {
    const m = this._baseState;
    return i(m.explicit === null && m.implicit === null), m.implicit = l, this;
  }, u.prototype.obj = function() {
    const l = this._baseState, m = Array.prototype.slice.call(arguments);
    return l.obj = !0, m.length !== 0 && this._useArgs(m), this;
  }, u.prototype.key = function(l) {
    const m = this._baseState;
    return i(m.key === null), m.key = l, this;
  }, u.prototype.any = function() {
    const l = this._baseState;
    return l.any = !0, this;
  }, u.prototype.choice = function(l) {
    const m = this._baseState;
    return i(m.choice === null), m.choice = l, this._useArgs(Object.keys(l).map(function(b) {
      return l[b];
    })), this;
  }, u.prototype.contains = function(l) {
    const m = this._baseState;
    return i(m.use === null), m.contains = l, this;
  }, u.prototype._decode = function(l, m) {
    const b = this._baseState;
    if (b.parent === null)
      return l.wrapResult(b.children[0]._decode(l, m));
    let M = b.default, A = !0, N = null;
    if (b.key !== null && (N = l.enterKey(b.key)), b.optional) {
      let O = null;
      if (b.explicit !== null ? O = b.explicit : b.implicit !== null ? O = b.implicit : b.tag !== null && (O = b.tag), O === null && !b.any) {
        const P = l.save();
        try {
          b.choice === null ? this._decodeGeneric(b.tag, l, m) : this._decodeChoice(l, m), A = !0;
        } catch {
          A = !1;
        }
        l.restore(P);
      } else if (A = this._peekTag(l, O, b.any), l.isError(A))
        return A;
    }
    let R;
    if (b.obj && A && (R = l.enterObject()), A) {
      if (b.explicit !== null) {
        const P = this._decodeTag(l, b.explicit);
        if (l.isError(P))
          return P;
        l = P;
      }
      const O = l.offset;
      if (b.use === null && b.choice === null) {
        let P;
        b.any && (P = l.save());
        const F = this._decodeTag(
          l,
          b.implicit !== null ? b.implicit : b.tag,
          b.any
        );
        if (l.isError(F))
          return F;
        b.any ? M = l.raw(P) : l = F;
      }
      if (m && m.track && b.tag !== null && m.track(l.path(), O, l.length, "tagged"), m && m.track && b.tag !== null && m.track(l.path(), l.offset, l.length, "content"), b.any || (b.choice === null ? M = this._decodeGeneric(b.tag, l, m) : M = this._decodeChoice(l, m)), l.isError(M))
        return M;
      if (!b.any && b.choice === null && b.children !== null && b.children.forEach(function(F) {
        F._decode(l, m);
      }), b.contains && (b.tag === "octstr" || b.tag === "bitstr")) {
        const P = new r(M);
        M = this._getUse(b.contains, l._reporterState.obj)._decode(P, m);
      }
    }
    return b.obj && A && (M = l.leaveObject(R)), b.key !== null && (M !== null || A === !0) ? l.leaveKey(N, b.key, M) : N !== null && l.exitKey(N), M;
  }, u.prototype._decodeGeneric = function(l, m, b) {
    const M = this._baseState;
    return l === "seq" || l === "set" ? null : l === "seqof" || l === "setof" ? this._decodeList(m, l, M.args[0], b) : /str$/.test(l) ? this._decodeStr(m, l, b) : l === "objid" && M.args ? this._decodeObjid(m, M.args[0], M.args[1], b) : l === "objid" ? this._decodeObjid(m, null, null, b) : l === "gentime" || l === "utctime" ? this._decodeTime(m, l, b) : l === "null_" ? this._decodeNull(m, b) : l === "bool" ? this._decodeBool(m, b) : l === "objDesc" ? this._decodeStr(m, l, b) : l === "int" || l === "enum" ? this._decodeInt(m, M.args && M.args[0], b) : M.use !== null ? this._getUse(M.use, m._reporterState.obj)._decode(m, b) : m.error("unknown tag: " + l);
  }, u.prototype._getUse = function(l, m) {
    const b = this._baseState;
    return b.useDecoder = this._use(l, m), i(b.useDecoder._baseState.parent === null), b.useDecoder = b.useDecoder._baseState.children[0], b.implicit !== b.useDecoder._baseState.implicit && (b.useDecoder = b.useDecoder.clone(), b.useDecoder._baseState.implicit = b.implicit), b.useDecoder;
  }, u.prototype._decodeChoice = function(l, m) {
    const b = this._baseState;
    let M = null, A = !1;
    return Object.keys(b.choice).some(function(N) {
      const R = l.save(), O = b.choice[N];
      try {
        const P = O._decode(l, m);
        if (l.isError(P))
          return !1;
        M = { type: N, value: P }, A = !0;
      } catch {
        return l.restore(R), !1;
      }
      return !0;
    }, this), A ? M : l.error("Choice not matched");
  }, u.prototype._createEncoderBuffer = function(l) {
    return new e(l, this.reporter);
  }, u.prototype._encode = function(l, m, b) {
    const M = this._baseState;
    if (M.default !== null && M.default === l)
      return;
    const A = this._encodeValue(l, m, b);
    if (A !== void 0 && !this._skipDefault(A, m, b))
      return A;
  }, u.prototype._encodeValue = function(l, m, b) {
    const M = this._baseState;
    if (M.parent === null)
      return M.children[0]._encode(l, m || new t());
    let A = null;
    if (this.reporter = m, M.optional && l === void 0)
      if (M.default !== null)
        l = M.default;
      else
        return;
    let N = null, R = !1;
    if (M.any)
      A = this._createEncoderBuffer(l);
    else if (M.choice)
      A = this._encodeChoice(l, m);
    else if (M.contains)
      N = this._getUse(M.contains, b)._encode(l, m), R = !0;
    else if (M.children)
      N = M.children.map(function(O) {
        if (O._baseState.tag === "null_")
          return O._encode(null, m, l);
        if (O._baseState.key === null)
          return m.error("Child should have a key");
        const P = m.enterKey(O._baseState.key);
        if (typeof l != "object")
          return m.error("Child expected, but input is not object");
        const F = O._encode(l[O._baseState.key], m, l);
        return m.leaveKey(P), F;
      }, this).filter(function(O) {
        return O;
      }), N = this._createEncoderBuffer(N);
    else if (M.tag === "seqof" || M.tag === "setof") {
      if (!(M.args && M.args.length === 1))
        return m.error("Too many args for : " + M.tag);
      if (!Array.isArray(l))
        return m.error("seqof/setof, but data is not Array");
      const O = this.clone();
      O._baseState.implicit = null, N = this._createEncoderBuffer(l.map(function(P) {
        const F = this._baseState;
        return this._getUse(F.args[0], l)._encode(P, m);
      }, O));
    } else
      M.use !== null ? A = this._getUse(M.use, b)._encode(l, m) : (N = this._encodePrimitive(M.tag, l), R = !0);
    if (!M.any && M.choice === null) {
      const O = M.implicit !== null ? M.implicit : M.tag, P = M.implicit === null ? "universal" : "context";
      O === null ? M.use === null && m.error("Tag could be omitted only for .use()") : M.use === null && (A = this._encodeComposite(O, R, P, N));
    }
    return M.explicit !== null && (A = this._encodeComposite(M.explicit, !1, "context", A)), A;
  }, u.prototype._encodeChoice = function(l, m) {
    const b = this._baseState, M = b.choice[l.type];
    return M || i(
      !1,
      l.type + " not found in " + JSON.stringify(Object.keys(b.choice))
    ), M._encode(l.value, m);
  }, u.prototype._encodePrimitive = function(l, m) {
    const b = this._baseState;
    if (/str$/.test(l))
      return this._encodeStr(m, l);
    if (l === "objid" && b.args)
      return this._encodeObjid(m, b.reverseArgs[0], b.args[1]);
    if (l === "objid")
      return this._encodeObjid(m, null, null);
    if (l === "gentime" || l === "utctime")
      return this._encodeTime(m, l);
    if (l === "null_")
      return this._encodeNull();
    if (l === "int" || l === "enum")
      return this._encodeInt(m, b.args && b.reverseArgs[0]);
    if (l === "bool")
      return this._encodeBool(m);
    if (l === "objDesc")
      return this._encodeStr(m, l);
    throw new Error("Unsupported tag: " + l);
  }, u.prototype._isNumstr = function(l) {
    return /^[0-9 ]*$/.test(l);
  }, u.prototype._isPrintstr = function(l) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(l);
  }, oy;
}
var fy = {}, n8;
function xw() {
  return n8 || (n8 = 1, function(t) {
    function e(r) {
      const i = {};
      return Object.keys(r).forEach(function(s) {
        (s | 0) == s && (s = s | 0);
        const n = r[s];
        i[n] = s;
      }), i;
    }
    t.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, t.tagClassByName = e(t.tagClass), t.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, t.tagByName = e(t.tag);
  }(fy)), fy;
}
var cy, s8;
function TA() {
  if (s8)
    return cy;
  s8 = 1;
  const t = It.exports, e = ww().Buffer, r = Mw(), i = xw();
  function s(h) {
    this.enc = "der", this.name = h.name, this.entity = h, this.tree = new n(), this.tree._init(h.body);
  }
  cy = s, s.prototype.encode = function(d, l) {
    return this.tree._encode(d, l).join();
  };
  function n(h) {
    r.call(this, "der", h);
  }
  t(n, r), n.prototype._encodeComposite = function(d, l, m, b) {
    const M = u(d, l, m, this.reporter);
    if (b.length < 128) {
      const R = e.alloc(2);
      return R[0] = M, R[1] = b.length, this._createEncoderBuffer([R, b]);
    }
    let A = 1;
    for (let R = b.length; R >= 256; R >>= 8)
      A++;
    const N = e.alloc(1 + 1 + A);
    N[0] = M, N[1] = 128 | A;
    for (let R = 1 + A, O = b.length; O > 0; R--, O >>= 8)
      N[R] = O & 255;
    return this._createEncoderBuffer([N, b]);
  }, n.prototype._encodeStr = function(d, l) {
    if (l === "bitstr")
      return this._createEncoderBuffer([d.unused | 0, d.data]);
    if (l === "bmpstr") {
      const m = e.alloc(d.length * 2);
      for (let b = 0; b < d.length; b++)
        m.writeUInt16BE(d.charCodeAt(b), b * 2);
      return this._createEncoderBuffer(m);
    } else
      return l === "numstr" ? this._isNumstr(d) ? this._createEncoderBuffer(d) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : l === "printstr" ? this._isPrintstr(d) ? this._createEncoderBuffer(d) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(l) ? this._createEncoderBuffer(d) : l === "objDesc" ? this._createEncoderBuffer(d) : this.reporter.error("Encoding of string type: " + l + " unsupported");
  }, n.prototype._encodeObjid = function(d, l, m) {
    if (typeof d == "string") {
      if (!l)
        return this.reporter.error("string objid given, but no values map found");
      if (!l.hasOwnProperty(d))
        return this.reporter.error("objid not found in values map");
      d = l[d].split(/[\s.]+/g);
      for (let N = 0; N < d.length; N++)
        d[N] |= 0;
    } else if (Array.isArray(d)) {
      d = d.slice();
      for (let N = 0; N < d.length; N++)
        d[N] |= 0;
    }
    if (!Array.isArray(d))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(d));
    if (!m) {
      if (d[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      d.splice(0, 2, d[0] * 40 + d[1]);
    }
    let b = 0;
    for (let N = 0; N < d.length; N++) {
      let R = d[N];
      for (b++; R >= 128; R >>= 7)
        b++;
    }
    const M = e.alloc(b);
    let A = M.length - 1;
    for (let N = d.length - 1; N >= 0; N--) {
      let R = d[N];
      for (M[A--] = R & 127; (R >>= 7) > 0; )
        M[A--] = 128 | R & 127;
    }
    return this._createEncoderBuffer(M);
  };
  function f(h) {
    return h < 10 ? "0" + h : h;
  }
  n.prototype._encodeTime = function(d, l) {
    let m;
    const b = new Date(d);
    return l === "gentime" ? m = [
      f(b.getUTCFullYear()),
      f(b.getUTCMonth() + 1),
      f(b.getUTCDate()),
      f(b.getUTCHours()),
      f(b.getUTCMinutes()),
      f(b.getUTCSeconds()),
      "Z"
    ].join("") : l === "utctime" ? m = [
      f(b.getUTCFullYear() % 100),
      f(b.getUTCMonth() + 1),
      f(b.getUTCDate()),
      f(b.getUTCHours()),
      f(b.getUTCMinutes()),
      f(b.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + l + " time is not supported yet"), this._encodeStr(m, "octstr");
  }, n.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, n.prototype._encodeInt = function(d, l) {
    if (typeof d == "string") {
      if (!l)
        return this.reporter.error("String int or enum given, but no values map");
      if (!l.hasOwnProperty(d))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify(d));
      d = l[d];
    }
    if (typeof d != "number" && !e.isBuffer(d)) {
      const M = d.toArray();
      !d.sign && M[0] & 128 && M.unshift(0), d = e.from(M);
    }
    if (e.isBuffer(d)) {
      let M = d.length;
      d.length === 0 && M++;
      const A = e.alloc(M);
      return d.copy(A), d.length === 0 && (A[0] = 0), this._createEncoderBuffer(A);
    }
    if (d < 128)
      return this._createEncoderBuffer(d);
    if (d < 256)
      return this._createEncoderBuffer([0, d]);
    let m = 1;
    for (let M = d; M >= 256; M >>= 8)
      m++;
    const b = new Array(m);
    for (let M = b.length - 1; M >= 0; M--)
      b[M] = d & 255, d >>= 8;
    return b[0] & 128 && b.unshift(0), this._createEncoderBuffer(e.from(b));
  }, n.prototype._encodeBool = function(d) {
    return this._createEncoderBuffer(d ? 255 : 0);
  }, n.prototype._use = function(d, l) {
    return typeof d == "function" && (d = d(l)), d._getEncoder("der").tree;
  }, n.prototype._skipDefault = function(d, l, m) {
    const b = this._baseState;
    let M;
    if (b.default === null)
      return !1;
    const A = d.join();
    if (b.defaultBuffer === void 0 && (b.defaultBuffer = this._encodeValue(b.default, l, m).join()), A.length !== b.defaultBuffer.length)
      return !1;
    for (M = 0; M < A.length; M++)
      if (A[M] !== b.defaultBuffer[M])
        return !1;
    return !0;
  };
  function u(h, d, l, m) {
    let b;
    if (h === "seqof" ? h = "seq" : h === "setof" && (h = "set"), i.tagByName.hasOwnProperty(h))
      b = i.tagByName[h];
    else if (typeof h == "number" && (h | 0) === h)
      b = h;
    else
      return m.error("Unknown tag: " + h);
    return b >= 31 ? m.error("Multi-octet tag encoding unsupported") : (d || (b |= 32), b |= i.tagClassByName[l || "universal"] << 6, b);
  }
  return cy;
}
var uy, a8;
function Sre() {
  if (a8)
    return uy;
  a8 = 1;
  const t = It.exports, e = TA();
  function r(i) {
    e.call(this, i), this.enc = "pem";
  }
  return t(r, e), uy = r, r.prototype.encode = function(s, n) {
    const u = e.prototype.encode.call(this, s).toString("base64"), h = ["-----BEGIN " + n.label + "-----"];
    for (let d = 0; d < u.length; d += 64)
      h.push(u.slice(d, d + 64));
    return h.push("-----END " + n.label + "-----"), h.join(`
`);
  }, uy;
}
var o8;
function NA() {
  return o8 || (o8 = 1, function(t) {
    const e = t;
    e.der = TA(), e.pem = Sre();
  }(ny)), ny;
}
var hy = {}, ly, f8;
function DA() {
  if (f8)
    return ly;
  f8 = 1;
  const t = It.exports, e = Sr.exports, r = mh().DecoderBuffer, i = Mw(), s = xw();
  function n(d) {
    this.enc = "der", this.name = d.name, this.entity = d, this.tree = new f(), this.tree._init(d.body);
  }
  ly = n, n.prototype.decode = function(l, m) {
    return r.isDecoderBuffer(l) || (l = new r(l, m)), this.tree._decode(l, m);
  };
  function f(d) {
    i.call(this, "der", d);
  }
  t(f, i), f.prototype._peekTag = function(l, m, b) {
    if (l.isEmpty())
      return !1;
    const M = l.save(), A = u(l, 'Failed to peek tag: "' + m + '"');
    return l.isError(A) ? A : (l.restore(M), A.tag === m || A.tagStr === m || A.tagStr + "of" === m || b);
  }, f.prototype._decodeTag = function(l, m, b) {
    const M = u(
      l,
      'Failed to decode tag of "' + m + '"'
    );
    if (l.isError(M))
      return M;
    let A = h(
      l,
      M.primitive,
      'Failed to get length of "' + m + '"'
    );
    if (l.isError(A))
      return A;
    if (!b && M.tag !== m && M.tagStr !== m && M.tagStr + "of" !== m)
      return l.error('Failed to match tag: "' + m + '"');
    if (M.primitive || A !== null)
      return l.skip(A, 'Failed to match body of: "' + m + '"');
    const N = l.save(), R = this._skipUntilEnd(
      l,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return l.isError(R) ? R : (A = l.offset - N.offset, l.restore(N), l.skip(A, 'Failed to match body of: "' + m + '"'));
  }, f.prototype._skipUntilEnd = function(l, m) {
    for (; ; ) {
      const b = u(l, m);
      if (l.isError(b))
        return b;
      const M = h(l, b.primitive, m);
      if (l.isError(M))
        return M;
      let A;
      if (b.primitive || M !== null ? A = l.skip(M) : A = this._skipUntilEnd(l, m), l.isError(A))
        return A;
      if (b.tagStr === "end")
        break;
    }
  }, f.prototype._decodeList = function(l, m, b, M) {
    const A = [];
    for (; !l.isEmpty(); ) {
      const N = this._peekTag(l, "end");
      if (l.isError(N))
        return N;
      const R = b.decode(l, "der", M);
      if (l.isError(R) && N)
        break;
      A.push(R);
    }
    return A;
  }, f.prototype._decodeStr = function(l, m) {
    if (m === "bitstr") {
      const b = l.readUInt8();
      return l.isError(b) ? b : { unused: b, data: l.raw() };
    } else if (m === "bmpstr") {
      const b = l.raw();
      if (b.length % 2 === 1)
        return l.error("Decoding of string type: bmpstr length mismatch");
      let M = "";
      for (let A = 0; A < b.length / 2; A++)
        M += String.fromCharCode(b.readUInt16BE(A * 2));
      return M;
    } else if (m === "numstr") {
      const b = l.raw().toString("ascii");
      return this._isNumstr(b) ? b : l.error("Decoding of string type: numstr unsupported characters");
    } else {
      if (m === "octstr")
        return l.raw();
      if (m === "objDesc")
        return l.raw();
      if (m === "printstr") {
        const b = l.raw().toString("ascii");
        return this._isPrintstr(b) ? b : l.error("Decoding of string type: printstr unsupported characters");
      } else
        return /str$/.test(m) ? l.raw().toString() : l.error("Decoding of string type: " + m + " unsupported");
    }
  }, f.prototype._decodeObjid = function(l, m, b) {
    let M;
    const A = [];
    let N = 0, R = 0;
    for (; !l.isEmpty(); )
      R = l.readUInt8(), N <<= 7, N |= R & 127, (R & 128) === 0 && (A.push(N), N = 0);
    R & 128 && A.push(N);
    const O = A[0] / 40 | 0, P = A[0] % 40;
    if (b ? M = A : M = [O, P].concat(A.slice(1)), m) {
      let F = m[M.join(" ")];
      F === void 0 && (F = m[M.join(".")]), F !== void 0 && (M = F);
    }
    return M;
  }, f.prototype._decodeTime = function(l, m) {
    const b = l.raw().toString();
    let M, A, N, R, O, P;
    if (m === "gentime")
      M = b.slice(0, 4) | 0, A = b.slice(4, 6) | 0, N = b.slice(6, 8) | 0, R = b.slice(8, 10) | 0, O = b.slice(10, 12) | 0, P = b.slice(12, 14) | 0;
    else if (m === "utctime")
      M = b.slice(0, 2) | 0, A = b.slice(2, 4) | 0, N = b.slice(4, 6) | 0, R = b.slice(6, 8) | 0, O = b.slice(8, 10) | 0, P = b.slice(10, 12) | 0, M < 70 ? M = 2e3 + M : M = 1900 + M;
    else
      return l.error("Decoding " + m + " time is not supported yet");
    return Date.UTC(M, A - 1, N, R, O, P, 0);
  }, f.prototype._decodeNull = function() {
    return null;
  }, f.prototype._decodeBool = function(l) {
    const m = l.readUInt8();
    return l.isError(m) ? m : m !== 0;
  }, f.prototype._decodeInt = function(l, m) {
    const b = l.raw();
    let M = new e(b);
    return m && (M = m[M.toString(10)] || M), M;
  }, f.prototype._use = function(l, m) {
    return typeof l == "function" && (l = l(m)), l._getDecoder("der").tree;
  };
  function u(d, l) {
    let m = d.readUInt8(l);
    if (d.isError(m))
      return m;
    const b = s.tagClass[m >> 6], M = (m & 32) === 0;
    if ((m & 31) === 31) {
      let N = m;
      for (m = 0; (N & 128) === 128; ) {
        if (N = d.readUInt8(l), d.isError(N))
          return N;
        m <<= 7, m |= N & 127;
      }
    } else
      m &= 31;
    const A = s.tag[m];
    return {
      cls: b,
      primitive: M,
      tag: m,
      tagStr: A
    };
  }
  function h(d, l, m) {
    let b = d.readUInt8(m);
    if (d.isError(b))
      return b;
    if (!l && b === 128)
      return null;
    if ((b & 128) === 0)
      return b;
    const M = b & 127;
    if (M > 4)
      return d.error("length octect is too long");
    b = 0;
    for (let A = 0; A < M; A++) {
      b <<= 8;
      const N = d.readUInt8(m);
      if (d.isError(N))
        return N;
      b |= N;
    }
    return b;
  }
  return ly;
}
var dy, c8;
function Ere() {
  if (c8)
    return dy;
  c8 = 1;
  const t = It.exports, e = ww().Buffer, r = DA();
  function i(s) {
    r.call(this, s), this.enc = "pem";
  }
  return t(i, r), dy = i, i.prototype.decode = function(n, f) {
    const u = n.toString().split(/[\r\n]+/g), h = f.label.toUpperCase(), d = /^-----(BEGIN|END) ([^-]+)-----$/;
    let l = -1, m = -1;
    for (let A = 0; A < u.length; A++) {
      const N = u[A].match(d);
      if (N !== null && N[2] === h)
        if (l === -1) {
          if (N[1] !== "BEGIN")
            break;
          l = A;
        } else {
          if (N[1] !== "END")
            break;
          m = A;
          break;
        }
    }
    if (l === -1 || m === -1)
      throw new Error("PEM section not found for: " + h);
    const b = u.slice(l + 1, m).join("");
    b.replace(/[^a-z0-9+/=]+/gi, "");
    const M = e.from(b, "base64");
    return r.prototype.decode.call(this, M, f);
  }, dy;
}
var u8;
function CA() {
  return u8 || (u8 = 1, function(t) {
    const e = t;
    e.der = DA(), e.pem = Ere();
  }(hy)), hy;
}
var h8;
function Ire() {
  return h8 || (h8 = 1, function(t) {
    const e = NA(), r = CA(), i = It.exports, s = t;
    s.define = function(u, h) {
      return new n(u, h);
    };
    function n(f, u) {
      this.name = f, this.body = u, this.decoders = {}, this.encoders = {};
    }
    n.prototype._createNamed = function(u) {
      const h = this.name;
      function d(l) {
        this._initNamed(l, h);
      }
      return i(d, u), d.prototype._initNamed = function(m, b) {
        u.call(this, m, b);
      }, new d(this);
    }, n.prototype._getDecoder = function(u) {
      return u = u || "der", this.decoders.hasOwnProperty(u) || (this.decoders[u] = this._createNamed(r[u])), this.decoders[u];
    }, n.prototype.decode = function(u, h, d) {
      return this._getDecoder(h).decode(u, d);
    }, n.prototype._getEncoder = function(u) {
      return u = u || "der", this.encoders.hasOwnProperty(u) || (this.encoders[u] = this._createNamed(e[u])), this.encoders[u];
    }, n.prototype.encode = function(u, h, d) {
      return this._getEncoder(h).encode(u, d);
    };
  }(iy)), iy;
}
var py = {}, l8;
function Are() {
  return l8 || (l8 = 1, function(t) {
    const e = t;
    e.Reporter = _w().Reporter, e.DecoderBuffer = mh().DecoderBuffer, e.EncoderBuffer = mh().EncoderBuffer, e.Node = Mw();
  }(py)), py;
}
var vy = {}, d8;
function Tre() {
  return d8 || (d8 = 1, function(t) {
    const e = t;
    e._reverse = function(i) {
      const s = {};
      return Object.keys(i).forEach(function(n) {
        (n | 0) == n && (n = n | 0);
        const f = i[n];
        s[f] = n;
      }), s;
    }, e.der = xw();
  }(vy)), vy;
}
var p8;
function OA() {
  return p8 || (p8 = 1, function(t) {
    const e = t;
    e.bignum = Sr.exports, e.define = Ire().define, e.base = Are(), e.constants = Tre(), e.decoders = CA(), e.encoders = NA();
  }(ry)), ry;
}
var gy, v8;
function Nre() {
  if (v8)
    return gy;
  v8 = 1;
  var t = OA(), e = t.define("Time", function() {
    this.choice({
      utcTime: this.utctime(),
      generalTime: this.gentime()
    });
  }), r = t.define("AttributeTypeValue", function() {
    this.seq().obj(
      this.key("type").objid(),
      this.key("value").any()
    );
  }), i = t.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("parameters").optional(),
      this.key("curve").objid().optional()
    );
  }), s = t.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(i),
      this.key("subjectPublicKey").bitstr()
    );
  }), n = t.define("RelativeDistinguishedName", function() {
    this.setof(r);
  }), f = t.define("RDNSequence", function() {
    this.seqof(n);
  }), u = t.define("Name", function() {
    this.choice({
      rdnSequence: this.use(f)
    });
  }), h = t.define("Validity", function() {
    this.seq().obj(
      this.key("notBefore").use(e),
      this.key("notAfter").use(e)
    );
  }), d = t.define("Extension", function() {
    this.seq().obj(
      this.key("extnID").objid(),
      this.key("critical").bool().def(!1),
      this.key("extnValue").octstr()
    );
  }), l = t.define("TBSCertificate", function() {
    this.seq().obj(
      this.key("version").explicit(0).int().optional(),
      this.key("serialNumber").int(),
      this.key("signature").use(i),
      this.key("issuer").use(u),
      this.key("validity").use(h),
      this.key("subject").use(u),
      this.key("subjectPublicKeyInfo").use(s),
      this.key("issuerUniqueID").implicit(1).bitstr().optional(),
      this.key("subjectUniqueID").implicit(2).bitstr().optional(),
      this.key("extensions").explicit(3).seqof(d).optional()
    );
  }), m = t.define("X509Certificate", function() {
    this.seq().obj(
      this.key("tbsCertificate").use(l),
      this.key("signatureAlgorithm").use(i),
      this.key("signatureValue").bitstr()
    );
  });
  return gy = m, gy;
}
var g8;
function Dre() {
  if (g8)
    return Vn;
  g8 = 1;
  var t = OA();
  Vn.certificate = Nre();
  var e = t.define("RSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("modulus").int(),
      this.key("publicExponent").int(),
      this.key("privateExponent").int(),
      this.key("prime1").int(),
      this.key("prime2").int(),
      this.key("exponent1").int(),
      this.key("exponent2").int(),
      this.key("coefficient").int()
    );
  });
  Vn.RSAPrivateKey = e;
  var r = t.define("RSAPublicKey", function() {
    this.seq().obj(
      this.key("modulus").int(),
      this.key("publicExponent").int()
    );
  });
  Vn.RSAPublicKey = r;
  var i = t.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(s),
      this.key("subjectPublicKey").bitstr()
    );
  });
  Vn.PublicKey = i;
  var s = t.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("none").null_().optional(),
      this.key("curve").objid().optional(),
      this.key("params").seq().obj(
        this.key("p").int(),
        this.key("q").int(),
        this.key("g").int()
      ).optional()
    );
  }), n = t.define("PrivateKeyInfo", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("algorithm").use(s),
      this.key("subjectPrivateKey").octstr()
    );
  });
  Vn.PrivateKey = n;
  var f = t.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").seq().obj(
        this.key("id").objid(),
        this.key("decrypt").seq().obj(
          this.key("kde").seq().obj(
            this.key("id").objid(),
            this.key("kdeparams").seq().obj(
              this.key("salt").octstr(),
              this.key("iters").int()
            )
          ),
          this.key("cipher").seq().obj(
            this.key("algo").objid(),
            this.key("iv").octstr()
          )
        )
      ),
      this.key("subjectPrivateKey").octstr()
    );
  });
  Vn.EncryptedPrivateKey = f;
  var u = t.define("DSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int(),
      this.key("pub_key").int(),
      this.key("priv_key").int()
    );
  });
  Vn.DSAPrivateKey = u, Vn.DSAparam = t.define("DSAparam", function() {
    this.int();
  });
  var h = t.define("ECPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("privateKey").octstr(),
      this.key("parameters").optional().explicit(0).use(d),
      this.key("publicKey").optional().explicit(1).bitstr()
    );
  });
  Vn.ECPrivateKey = h;
  var d = t.define("ECParameters", function() {
    this.choice({
      namedCurve: this.objid()
    });
  });
  return Vn.signature = t.define("signature", function() {
    this.seq().obj(
      this.key("r").int(),
      this.key("s").int()
    );
  }), Vn;
}
const Cre = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var by, b8;
function Ore() {
  if (b8)
    return by;
  b8 = 1;
  var t = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, e = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, r = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, i = Wp(), s = vw(), n = Ft.exports.Buffer;
  return by = function(f, u) {
    var h = f.toString(), d = h.match(t), l;
    if (d) {
      var b = "aes" + d[1], M = n.from(d[2], "hex"), A = n.from(d[3].replace(/[\r\n]/g, ""), "base64"), N = i(u, M.slice(0, 8), parseInt(d[1], 10)).key, R = [], O = s.createDecipheriv(b, N, M);
      R.push(O.update(A)), R.push(O.final()), l = n.concat(R);
    } else {
      var m = h.match(r);
      l = n.from(m[2].replace(/[\r\n]/g, ""), "base64");
    }
    var P = h.match(e)[1];
    return {
      tag: P,
      data: l
    };
  }, by;
}
var yy, y8;
function Kp() {
  if (y8)
    return yy;
  y8 = 1;
  var t = Dre(), e = Cre, r = Ore(), i = vw(), s = cA(), n = Ft.exports.Buffer;
  yy = f;
  function f(h) {
    var d;
    typeof h == "object" && !n.isBuffer(h) && (d = h.passphrase, h = h.key), typeof h == "string" && (h = n.from(h));
    var l = r(h, d), m = l.tag, b = l.data, M, A;
    switch (m) {
      case "CERTIFICATE":
        A = t.certificate.decode(b, "der").tbsCertificate.subjectPublicKeyInfo;
      case "PUBLIC KEY":
        switch (A || (A = t.PublicKey.decode(b, "der")), M = A.algorithm.algorithm.join("."), M) {
          case "1.2.840.113549.1.1.1":
            return t.RSAPublicKey.decode(A.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return A.subjectPrivateKey = A.subjectPublicKey, {
              type: "ec",
              data: A
            };
          case "1.2.840.10040.4.1":
            return A.algorithm.params.pub_key = t.DSAparam.decode(A.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: A.algorithm.params
            };
          default:
            throw new Error("unknown key id " + M);
        }
      case "ENCRYPTED PRIVATE KEY":
        b = t.EncryptedPrivateKey.decode(b, "der"), b = u(b, d);
      case "PRIVATE KEY":
        switch (A = t.PrivateKey.decode(b, "der"), M = A.algorithm.algorithm.join("."), M) {
          case "1.2.840.113549.1.1.1":
            return t.RSAPrivateKey.decode(A.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: A.algorithm.curve,
              privateKey: t.ECPrivateKey.decode(A.subjectPrivateKey, "der").privateKey
            };
          case "1.2.840.10040.4.1":
            return A.algorithm.params.priv_key = t.DSAparam.decode(A.subjectPrivateKey, "der"), {
              type: "dsa",
              params: A.algorithm.params
            };
          default:
            throw new Error("unknown key id " + M);
        }
      case "RSA PUBLIC KEY":
        return t.RSAPublicKey.decode(b, "der");
      case "RSA PRIVATE KEY":
        return t.RSAPrivateKey.decode(b, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: t.DSAPrivateKey.decode(b, "der")
        };
      case "EC PRIVATE KEY":
        return b = t.ECPrivateKey.decode(b, "der"), {
          curve: b.parameters.value,
          privateKey: b.privateKey
        };
      default:
        throw new Error("unknown key type " + m);
    }
  }
  f.signature = t.signature;
  function u(h, d) {
    var l = h.algorithm.decrypt.kde.kdeparams.salt, m = parseInt(h.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), b = e[h.algorithm.decrypt.cipher.algo.join(".")], M = h.algorithm.decrypt.cipher.iv, A = h.subjectPrivateKey, N = parseInt(b.split("-")[1], 10) / 8, R = s.pbkdf2Sync(d, l, m, N, "sha1"), O = i.createDecipheriv(b, R, M), P = [];
    return P.push(O.update(A)), P.push(O.final()), n.concat(P);
  }
  return yy;
}
const RA = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var m8;
function Rre() {
  if (m8)
    return Uu.exports;
  m8 = 1;
  var t = Ft.exports.Buffer, e = iA(), r = bw(), i = mw().ec, s = AA(), n = Kp(), f = RA;
  function u(R, O, P, F, H) {
    var Q = n(O);
    if (Q.curve) {
      if (F !== "ecdsa" && F !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return h(R, Q);
    } else if (Q.type === "dsa") {
      if (F !== "dsa")
        throw new Error("wrong private key type");
      return d(R, Q, P);
    } else if (F !== "rsa" && F !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    R = t.concat([H, R]);
    for (var Z = Q.modulus.byteLength(), B = [0, 1]; R.length + B.length + 1 < Z; )
      B.push(255);
    B.push(0);
    for (var Y = -1; ++Y < R.length; )
      B.push(R[Y]);
    var ae = r(B, Q);
    return ae;
  }
  function h(R, O) {
    var P = f[O.curve.join(".")];
    if (!P)
      throw new Error("unknown curve " + O.curve.join("."));
    var F = new i(P), H = F.keyFromPrivate(O.privateKey), Q = H.sign(R);
    return t.from(Q.toDER());
  }
  function d(R, O, P) {
    for (var F = O.params.priv_key, H = O.params.p, Q = O.params.q, Z = O.params.g, B = new s(0), Y, ae = b(R, Q).mod(Q), se = !1, W = m(F, Q, R, P); se === !1; )
      Y = A(Q, W, P), B = N(Z, Y, H, Q), se = Y.invm(Q).imul(ae.add(F.mul(B))).mod(Q), se.cmpn(0) === 0 && (se = !1, B = new s(0));
    return l(B, se);
  }
  function l(R, O) {
    R = R.toArray(), O = O.toArray(), R[0] & 128 && (R = [0].concat(R)), O[0] & 128 && (O = [0].concat(O));
    var P = R.length + O.length + 4, F = [48, P, 2, R.length];
    return F = F.concat(R, [2, O.length], O), t.from(F);
  }
  function m(R, O, P, F) {
    if (R = t.from(R.toArray()), R.length < O.byteLength()) {
      var H = t.alloc(O.byteLength() - R.length);
      R = t.concat([H, R]);
    }
    var Q = P.length, Z = M(P, O), B = t.alloc(Q);
    B.fill(1);
    var Y = t.alloc(Q);
    return Y = e(F, Y).update(B).update(t.from([0])).update(R).update(Z).digest(), B = e(F, Y).update(B).digest(), Y = e(F, Y).update(B).update(t.from([1])).update(R).update(Z).digest(), B = e(F, Y).update(B).digest(), { k: Y, v: B };
  }
  function b(R, O) {
    var P = new s(R), F = (R.length << 3) - O.bitLength();
    return F > 0 && P.ishrn(F), P;
  }
  function M(R, O) {
    R = b(R, O), R = R.mod(O);
    var P = t.from(R.toArray());
    if (P.length < O.byteLength()) {
      var F = t.alloc(O.byteLength() - P.length);
      P = t.concat([F, P]);
    }
    return P;
  }
  function A(R, O, P) {
    var F, H;
    do {
      for (F = t.alloc(0); F.length * 8 < R.bitLength(); )
        O.v = e(P, O.k).update(O.v).digest(), F = t.concat([F, O.v]);
      H = b(F, R), O.k = e(P, O.k).update(O.v).update(t.from([0])).digest(), O.v = e(P, O.k).update(O.v).digest();
    } while (H.cmp(R) !== -1);
    return H;
  }
  function N(R, O, P, F) {
    return R.toRed(s.mont(P)).redPow(O).fromRed().mod(F);
  }
  return Uu.exports = u, Uu.exports.getKey = m, Uu.exports.makeKey = A, Uu.exports;
}
var my, w8;
function Lre() {
  if (w8)
    return my;
  w8 = 1;
  var t = Ft.exports.Buffer, e = AA(), r = mw().ec, i = Kp(), s = RA;
  function n(d, l, m, b, M) {
    var A = i(m);
    if (A.type === "ec") {
      if (b !== "ecdsa" && b !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return f(d, l, A);
    } else if (A.type === "dsa") {
      if (b !== "dsa")
        throw new Error("wrong public key type");
      return u(d, l, A);
    } else if (b !== "rsa" && b !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    l = t.concat([M, l]);
    for (var N = A.modulus.byteLength(), R = [1], O = 0; l.length + R.length + 2 < N; )
      R.push(255), O++;
    R.push(0);
    for (var P = -1; ++P < l.length; )
      R.push(l[P]);
    R = t.from(R);
    var F = e.mont(A.modulus);
    d = new e(d).toRed(F), d = d.redPow(new e(A.publicExponent)), d = t.from(d.fromRed().toArray());
    var H = O < 8 ? 1 : 0;
    for (N = Math.min(d.length, R.length), d.length !== R.length && (H = 1), P = -1; ++P < N; )
      H |= d[P] ^ R[P];
    return H === 0;
  }
  function f(d, l, m) {
    var b = s[m.data.algorithm.curve.join(".")];
    if (!b)
      throw new Error("unknown curve " + m.data.algorithm.curve.join("."));
    var M = new r(b), A = m.data.subjectPrivateKey.data;
    return M.verify(l, d, A);
  }
  function u(d, l, m) {
    var b = m.data.p, M = m.data.q, A = m.data.g, N = m.data.pub_key, R = i.signature.decode(d, "der"), O = R.s, P = R.r;
    h(O, M), h(P, M);
    var F = e.mont(b), H = O.invm(M), Q = A.toRed(F).redPow(new e(l).mul(H).mod(M)).fromRed().mul(N.toRed(F).redPow(P.mul(H).mod(M)).fromRed()).mod(b).mod(M);
    return Q.cmp(P) === 0;
  }
  function h(d, l) {
    if (d.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if (d.cmp(l) >= l)
      throw new Error("invalid sig");
  }
  return my = n, my;
}
var wy, _8;
function Pre() {
  if (_8)
    return wy;
  _8 = 1;
  var t = Ft.exports.Buffer, e = Jh(), r = Qte(), i = It.exports, s = Rre(), n = Lre(), f = nA;
  Object.keys(f).forEach(function(m) {
    f[m].id = t.from(f[m].id, "hex"), f[m.toLowerCase()] = f[m];
  });
  function u(m) {
    r.Writable.call(this);
    var b = f[m];
    if (!b)
      throw new Error("Unknown message digest");
    this._hashType = b.hash, this._hash = e(b.hash), this._tag = b.id, this._signType = b.sign;
  }
  i(u, r.Writable), u.prototype._write = function(b, M, A) {
    this._hash.update(b), A();
  }, u.prototype.update = function(b, M) {
    return typeof b == "string" && (b = t.from(b, M)), this._hash.update(b), this;
  }, u.prototype.sign = function(b, M) {
    this.end();
    var A = this._hash.digest(), N = s(A, b, this._hashType, this._signType, this._tag);
    return M ? N.toString(M) : N;
  };
  function h(m) {
    r.Writable.call(this);
    var b = f[m];
    if (!b)
      throw new Error("Unknown message digest");
    this._hash = e(b.hash), this._tag = b.id, this._signType = b.sign;
  }
  i(h, r.Writable), h.prototype._write = function(b, M, A) {
    this._hash.update(b), A();
  }, h.prototype.update = function(b, M) {
    return typeof b == "string" && (b = t.from(b, M)), this._hash.update(b), this;
  }, h.prototype.verify = function(b, M, A) {
    typeof M == "string" && (M = t.from(M, A)), this.end();
    var N = this._hash.digest();
    return n(M, N, b, this._signType, this._tag);
  };
  function d(m) {
    return new u(m);
  }
  function l(m) {
    return new h(m);
  }
  return wy = {
    Sign: d,
    Verify: l,
    createSign: d,
    createVerify: l
  }, wy;
}
var _y, M8;
function kre() {
  if (M8)
    return _y;
  M8 = 1;
  var t = mw(), e = Sr.exports;
  _y = function(f) {
    return new i(f);
  };
  var r = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  r.p224 = r.secp224r1, r.p256 = r.secp256r1 = r.prime256v1, r.p192 = r.secp192r1 = r.prime192v1, r.p384 = r.secp384r1, r.p521 = r.secp521r1;
  function i(n) {
    this.curveType = r[n], this.curveType || (this.curveType = {
      name: n
    }), this.curve = new t.ec(this.curveType.name), this.keys = void 0;
  }
  i.prototype.generateKeys = function(n, f) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(n, f);
  }, i.prototype.computeSecret = function(n, f, u) {
    f = f || "utf8", Buffer.isBuffer(n) || (n = new Buffer(n, f));
    var h = this.curve.keyFromPublic(n).getPublic(), d = h.mul(this.keys.getPrivate()).getX();
    return s(d, u, this.curveType.byteLength);
  }, i.prototype.getPublicKey = function(n, f) {
    var u = this.keys.getPublic(f === "compressed", !0);
    return f === "hybrid" && (u[u.length - 1] % 2 ? u[0] = 7 : u[0] = 6), s(u, n);
  }, i.prototype.getPrivateKey = function(n) {
    return s(this.keys.getPrivate(), n);
  }, i.prototype.setPublicKey = function(n, f) {
    return f = f || "utf8", Buffer.isBuffer(n) || (n = new Buffer(n, f)), this.keys._importPublic(n), this;
  }, i.prototype.setPrivateKey = function(n, f) {
    f = f || "utf8", Buffer.isBuffer(n) || (n = new Buffer(n, f));
    var u = new e(n);
    return u = u.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(u), this;
  };
  function s(n, f, u) {
    Array.isArray(n) || (n = n.toArray());
    var h = new Buffer(n);
    if (u && h.length < u) {
      var d = new Buffer(u - h.length);
      d.fill(0), h = Buffer.concat([d, h]);
    }
    return f ? h.toString(f) : h;
  }
  return _y;
}
var My = {}, xy, x8;
function LA() {
  if (x8)
    return xy;
  x8 = 1;
  var t = Jh(), e = Ft.exports.Buffer;
  xy = function(i, s) {
    for (var n = e.alloc(0), f = 0, u; n.length < s; )
      u = r(f++), n = e.concat([n, t("sha1").update(i).update(u).digest()]);
    return n.slice(0, s);
  };
  function r(i) {
    var s = e.allocUnsafe(4);
    return s.writeUInt32BE(i, 0), s;
  }
  return xy;
}
var Sy, S8;
function PA() {
  return S8 || (S8 = 1, Sy = function(e, r) {
    for (var i = e.length, s = -1; ++s < i; )
      e[s] ^= r[s];
    return e;
  }), Sy;
}
var Ey, E8;
function kA() {
  if (E8)
    return Ey;
  E8 = 1;
  var t = Sr.exports, e = Ft.exports.Buffer;
  function r(i, s) {
    return e.from(i.toRed(t.mont(s.modulus)).redPow(new t(s.publicExponent)).fromRed().toArray());
  }
  return Ey = r, Ey;
}
var Iy, I8;
function jre() {
  if (I8)
    return Iy;
  I8 = 1;
  var t = Kp(), e = Jc(), r = Jh(), i = LA(), s = PA(), n = Sr.exports, f = kA(), u = bw(), h = Ft.exports.Buffer;
  Iy = function(M, A, N) {
    var R;
    M.padding ? R = M.padding : N ? R = 1 : R = 4;
    var O = t(M), P;
    if (R === 4)
      P = d(O, A);
    else if (R === 1)
      P = l(O, A, N);
    else if (R === 3) {
      if (P = new n(A), P.cmp(O.modulus) >= 0)
        throw new Error("data too long for modulus");
    } else
      throw new Error("unknown padding");
    return N ? u(P, O) : f(P, O);
  };
  function d(b, M) {
    var A = b.modulus.byteLength(), N = M.length, R = r("sha1").update(h.alloc(0)).digest(), O = R.length, P = 2 * O;
    if (N > A - P - 2)
      throw new Error("message too long");
    var F = h.alloc(A - N - P - 2), H = A - O - 1, Q = e(O), Z = s(h.concat([R, F, h.alloc(1, 1), M], H), i(Q, H)), B = s(Q, i(Z, O));
    return new n(h.concat([h.alloc(1), B, Z], A));
  }
  function l(b, M, A) {
    var N = M.length, R = b.modulus.byteLength();
    if (N > R - 11)
      throw new Error("message too long");
    var O;
    return A ? O = h.alloc(R - N - 3, 255) : O = m(R - N - 3), new n(h.concat([h.from([0, A ? 1 : 2]), O, h.alloc(1), M], R));
  }
  function m(b) {
    for (var M = h.allocUnsafe(b), A = 0, N = e(b * 2), R = 0, O; A < b; )
      R === N.length && (N = e(b * 2), R = 0), O = N[R++], O && (M[A++] = O);
    return M;
  }
  return Iy;
}
var Ay, A8;
function Bre() {
  if (A8)
    return Ay;
  A8 = 1;
  var t = Kp(), e = LA(), r = PA(), i = Sr.exports, s = bw(), n = Jh(), f = kA(), u = Ft.exports.Buffer;
  Ay = function(b, M, A) {
    var N;
    b.padding ? N = b.padding : A ? N = 1 : N = 4;
    var R = t(b), O = R.modulus.byteLength();
    if (M.length > O || new i(M).cmp(R.modulus) >= 0)
      throw new Error("decryption error");
    var P;
    A ? P = f(new i(M), R) : P = s(M, R);
    var F = u.alloc(O - P.length);
    if (P = u.concat([F, P], O), N === 4)
      return h(R, P);
    if (N === 1)
      return d(R, P, A);
    if (N === 3)
      return P;
    throw new Error("unknown padding");
  };
  function h(m, b) {
    var M = m.modulus.byteLength(), A = n("sha1").update(u.alloc(0)).digest(), N = A.length;
    if (b[0] !== 0)
      throw new Error("decryption error");
    var R = b.slice(1, N + 1), O = b.slice(N + 1), P = r(R, e(O, N)), F = r(O, e(P, M - N - 1));
    if (l(A, F.slice(0, N)))
      throw new Error("decryption error");
    for (var H = N; F[H] === 0; )
      H++;
    if (F[H++] !== 1)
      throw new Error("decryption error");
    return F.slice(H);
  }
  function d(m, b, M) {
    for (var A = b.slice(0, 2), N = 2, R = 0; b[N++] !== 0; )
      if (N >= b.length) {
        R++;
        break;
      }
    var O = b.slice(2, N - 1);
    if ((A.toString("hex") !== "0002" && !M || A.toString("hex") !== "0001" && M) && R++, O.length < 8 && R++, R)
      throw new Error("decryption error");
    return b.slice(N);
  }
  function l(m, b) {
    m = u.from(m), b = u.from(b);
    var M = 0, A = m.length;
    m.length !== b.length && (M++, A = Math.min(m.length, b.length));
    for (var N = -1; ++N < A; )
      M += m[N] ^ b[N];
    return M;
  }
  return Ay;
}
var T8;
function zre() {
  return T8 || (T8 = 1, function(t) {
    t.publicEncrypt = jre(), t.privateDecrypt = Bre(), t.privateEncrypt = function(r, i) {
      return t.publicEncrypt(r, i, !0);
    }, t.publicDecrypt = function(r, i) {
      return t.privateDecrypt(r, i, !0);
    };
  }(My)), My;
}
var Yf = {}, N8;
function Ure() {
  if (N8)
    return Yf;
  N8 = 1;
  function t() {
    throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var e = Ft.exports, r = Jc(), i = e.Buffer, s = e.kMaxLength, n = nt.crypto || nt.msCrypto, f = Math.pow(2, 32) - 1;
  function u(b, M) {
    if (typeof b != "number" || b !== b)
      throw new TypeError("offset must be a number");
    if (b > f || b < 0)
      throw new TypeError("offset must be a uint32");
    if (b > s || b > M)
      throw new RangeError("offset out of range");
  }
  function h(b, M, A) {
    if (typeof b != "number" || b !== b)
      throw new TypeError("size must be a number");
    if (b > f || b < 0)
      throw new TypeError("size must be a uint32");
    if (b + M > A || b > s)
      throw new RangeError("buffer too small");
  }
  n && n.getRandomValues || !process.browser ? (Yf.randomFill = d, Yf.randomFillSync = m) : (Yf.randomFill = t, Yf.randomFillSync = t);
  function d(b, M, A, N) {
    if (!i.isBuffer(b) && !(b instanceof nt.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof M == "function")
      N = M, M = 0, A = b.length;
    else if (typeof A == "function")
      N = A, A = b.length - M;
    else if (typeof N != "function")
      throw new TypeError('"cb" argument must be a function');
    return u(M, b.length), h(A, M, b.length), l(b, M, A, N);
  }
  function l(b, M, A, N) {
    if (process.browser) {
      var R = b.buffer, O = new Uint8Array(R, M, A);
      if (n.getRandomValues(O), N) {
        process.nextTick(function() {
          N(null, b);
        });
        return;
      }
      return b;
    }
    if (N) {
      r(A, function(F, H) {
        if (F)
          return N(F);
        H.copy(b, M), N(null, b);
      });
      return;
    }
    var P = r(A);
    return P.copy(b, M), b;
  }
  function m(b, M, A) {
    if (typeof M > "u" && (M = 0), !i.isBuffer(b) && !(b instanceof nt.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    return u(M, b.length), A === void 0 && (A = b.length - M), h(A, M, b.length), l(b, M, A);
  }
  return Yf;
}
var D8;
function jA() {
  if (D8)
    return Ut;
  D8 = 1, Ut.randomBytes = Ut.rng = Ut.pseudoRandomBytes = Ut.prng = Jc(), Ut.createHash = Ut.Hash = Jh(), Ut.createHmac = Ut.Hmac = iA();
  var t = pte(), e = Object.keys(t), r = ["sha1", "sha224", "sha256", "sha384", "sha512", "md5", "rmd160"].concat(e);
  Ut.getHashes = function() {
    return r;
  };
  var i = cA();
  Ut.pbkdf2 = i.pbkdf2, Ut.pbkdf2Sync = i.pbkdf2Sync;
  var s = Rte();
  Ut.Cipher = s.Cipher, Ut.createCipher = s.createCipher, Ut.Cipheriv = s.Cipheriv, Ut.createCipheriv = s.createCipheriv, Ut.Decipher = s.Decipher, Ut.createDecipher = s.createDecipher, Ut.Decipheriv = s.Decipheriv, Ut.createDecipheriv = s.createDecipheriv, Ut.getCiphers = s.getCiphers, Ut.listCiphers = s.listCiphers;
  var n = Hte();
  Ut.DiffieHellmanGroup = n.DiffieHellmanGroup, Ut.createDiffieHellmanGroup = n.createDiffieHellmanGroup, Ut.getDiffieHellman = n.getDiffieHellman, Ut.createDiffieHellman = n.createDiffieHellman, Ut.DiffieHellman = n.DiffieHellman;
  var f = Pre();
  Ut.createSign = f.createSign, Ut.Sign = f.Sign, Ut.createVerify = f.createVerify, Ut.Verify = f.Verify, Ut.createECDH = kre();
  var u = zre();
  Ut.publicEncrypt = u.publicEncrypt, Ut.privateEncrypt = u.privateEncrypt, Ut.publicDecrypt = u.publicDecrypt, Ut.privateDecrypt = u.privateDecrypt;
  var h = Ure();
  return Ut.randomFill = h.randomFill, Ut.randomFillSync = h.randomFillSync, Ut.createCredentials = function() {
    throw new Error([
      "sorry, createCredentials is not implemented yet",
      "we accept pull requests",
      "https://github.com/crypto-browserify/crypto-browserify"
    ].join(`
`));
  }, Ut.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, Ut;
}
Object.defineProperty(qp, "__esModule", { value: !0 });
qp.NodeRandomSource = void 0;
const Fre = Cn;
class $re {
  constructor() {
    if (this.isAvailable = !1, this.isInstantiated = !1, typeof Yee < "u") {
      const e = jA();
      e && e.randomBytes && (this._crypto = e, this.isAvailable = !0, this.isInstantiated = !0);
    }
  }
  randomBytes(e) {
    if (!this.isAvailable || !this._crypto)
      throw new Error("Node.js random byte generator is not available.");
    let r = this._crypto.randomBytes(e);
    if (r.length !== e)
      throw new Error("NodeRandomSource: got fewer bytes than requested");
    const i = new Uint8Array(e);
    for (let s = 0; s < i.length; s++)
      i[s] = r[s];
    return (0, Fre.wipe)(r), i;
  }
}
qp.NodeRandomSource = $re;
Object.defineProperty(Fp, "__esModule", { value: !0 });
Fp.SystemRandomSource = void 0;
const qre = $p, Hre = qp;
class Wre {
  constructor() {
    if (this.isAvailable = !1, this.name = "", this._source = new qre.BrowserRandomSource(), this._source.isAvailable) {
      this.isAvailable = !0, this.name = "Browser";
      return;
    }
    if (this._source = new Hre.NodeRandomSource(), this._source.isAvailable) {
      this.isAvailable = !0, this.name = "Node";
      return;
    }
  }
  randomBytes(e) {
    if (!this.isAvailable)
      throw new Error("System random byte generator is not available.");
    return this._source.randomBytes(e);
  }
}
Fp.SystemRandomSource = Wre;
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.randomStringForEntropy = t.randomString = t.randomUint32 = t.randomBytes = t.defaultRandomSource = void 0;
  const e = Fp, r = Bt, i = Cn;
  t.defaultRandomSource = new e.SystemRandomSource();
  function s(d, l = t.defaultRandomSource) {
    return l.randomBytes(d);
  }
  t.randomBytes = s;
  function n(d = t.defaultRandomSource) {
    const l = s(4, d), m = (0, r.readUint32LE)(l);
    return (0, i.wipe)(l), m;
  }
  t.randomUint32 = n;
  const f = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  function u(d, l = f, m = t.defaultRandomSource) {
    if (l.length < 2)
      throw new Error("randomString charset is too short");
    if (l.length > 256)
      throw new Error("randomString charset is too long");
    let b = "";
    const M = l.length, A = 256 - 256 % M;
    for (; d > 0; ) {
      const N = s(Math.ceil(d * 256 / A), m);
      for (let R = 0; R < N.length && d > 0; R++) {
        const O = N[R];
        O < A && (b += l.charAt(O % M), d--);
      }
      (0, i.wipe)(N);
    }
    return b;
  }
  t.randomString = u;
  function h(d, l = f, m = t.defaultRandomSource) {
    const b = Math.ceil(d / (Math.log(l.length) / Math.LN2));
    return u(b, l, m);
  }
  t.randomStringForEntropy = h;
})(yo);
var tl = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = Bt, r = Cn;
  t.DIGEST_LENGTH = 32, t.BLOCK_SIZE = 64;
  var i = function() {
    function u() {
      this.digestLength = t.DIGEST_LENGTH, this.blockSize = t.BLOCK_SIZE, this._state = new Int32Array(8), this._temp = new Int32Array(64), this._buffer = new Uint8Array(128), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this.reset();
    }
    return u.prototype._initState = function() {
      this._state[0] = 1779033703, this._state[1] = 3144134277, this._state[2] = 1013904242, this._state[3] = 2773480762, this._state[4] = 1359893119, this._state[5] = 2600822924, this._state[6] = 528734635, this._state[7] = 1541459225;
    }, u.prototype.reset = function() {
      return this._initState(), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this;
    }, u.prototype.clean = function() {
      r.wipe(this._buffer), r.wipe(this._temp), this.reset();
    }, u.prototype.update = function(h, d) {
      if (d === void 0 && (d = h.length), this._finished)
        throw new Error("SHA256: can't update because hash was finished.");
      var l = 0;
      if (this._bytesHashed += d, this._bufferLength > 0) {
        for (; this._bufferLength < this.blockSize && d > 0; )
          this._buffer[this._bufferLength++] = h[l++], d--;
        this._bufferLength === this.blockSize && (n(this._temp, this._state, this._buffer, 0, this.blockSize), this._bufferLength = 0);
      }
      for (d >= this.blockSize && (l = n(this._temp, this._state, h, l, d), d %= this.blockSize); d > 0; )
        this._buffer[this._bufferLength++] = h[l++], d--;
      return this;
    }, u.prototype.finish = function(h) {
      if (!this._finished) {
        var d = this._bytesHashed, l = this._bufferLength, m = d / 536870912 | 0, b = d << 3, M = d % 64 < 56 ? 64 : 128;
        this._buffer[l] = 128;
        for (var A = l + 1; A < M - 8; A++)
          this._buffer[A] = 0;
        e.writeUint32BE(m, this._buffer, M - 8), e.writeUint32BE(b, this._buffer, M - 4), n(this._temp, this._state, this._buffer, 0, M), this._finished = !0;
      }
      for (var A = 0; A < this.digestLength / 4; A++)
        e.writeUint32BE(this._state[A], h, A * 4);
      return this;
    }, u.prototype.digest = function() {
      var h = new Uint8Array(this.digestLength);
      return this.finish(h), h;
    }, u.prototype.saveState = function() {
      if (this._finished)
        throw new Error("SHA256: cannot save finished state");
      return {
        state: new Int32Array(this._state),
        buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : void 0,
        bufferLength: this._bufferLength,
        bytesHashed: this._bytesHashed
      };
    }, u.prototype.restoreState = function(h) {
      return this._state.set(h.state), this._bufferLength = h.bufferLength, h.buffer && this._buffer.set(h.buffer), this._bytesHashed = h.bytesHashed, this._finished = !1, this;
    }, u.prototype.cleanSavedState = function(h) {
      r.wipe(h.state), h.buffer && r.wipe(h.buffer), h.bufferLength = 0, h.bytesHashed = 0;
    }, u;
  }();
  t.SHA256 = i;
  var s = new Int32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]);
  function n(u, h, d, l, m) {
    for (; m >= 64; ) {
      for (var b = h[0], M = h[1], A = h[2], N = h[3], R = h[4], O = h[5], P = h[6], F = h[7], H = 0; H < 16; H++) {
        var Q = l + H * 4;
        u[H] = e.readUint32BE(d, Q);
      }
      for (var H = 16; H < 64; H++) {
        var Z = u[H - 2], B = (Z >>> 17 | Z << 32 - 17) ^ (Z >>> 19 | Z << 32 - 19) ^ Z >>> 10;
        Z = u[H - 15];
        var Y = (Z >>> 7 | Z << 32 - 7) ^ (Z >>> 18 | Z << 32 - 18) ^ Z >>> 3;
        u[H] = (B + u[H - 7] | 0) + (Y + u[H - 16] | 0);
      }
      for (var H = 0; H < 64; H++) {
        var B = (((R >>> 6 | R << 26) ^ (R >>> 11 | R << 21) ^ (R >>> 25 | R << 7)) + (R & O ^ ~R & P) | 0) + (F + (s[H] + u[H] | 0) | 0) | 0, Y = ((b >>> 2 | b << 32 - 2) ^ (b >>> 13 | b << 32 - 13) ^ (b >>> 22 | b << 32 - 22)) + (b & M ^ b & A ^ M & A) | 0;
        F = P, P = O, O = R, R = N + B | 0, N = A, A = M, M = b, b = B + Y | 0;
      }
      h[0] += b, h[1] += M, h[2] += A, h[3] += N, h[4] += R, h[5] += O, h[6] += P, h[7] += F, l += 64, m -= 64;
    }
    return l;
  }
  function f(u) {
    var h = new i();
    h.update(u);
    var d = h.digest();
    return h.clean(), d;
  }
  t.hash = f;
})(tl);
var Sw = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.sharedKey = t.generateKeyPair = t.generateKeyPairFromSeed = t.scalarMultBase = t.scalarMult = t.SHARED_KEY_LENGTH = t.SECRET_KEY_LENGTH = t.PUBLIC_KEY_LENGTH = void 0;
  const e = yo, r = Cn;
  t.PUBLIC_KEY_LENGTH = 32, t.SECRET_KEY_LENGTH = 32, t.SHARED_KEY_LENGTH = 32;
  function i(H) {
    const Q = new Float64Array(16);
    if (H)
      for (let Z = 0; Z < H.length; Z++)
        Q[Z] = H[Z];
    return Q;
  }
  const s = new Uint8Array(32);
  s[0] = 9;
  const n = i([56129, 1]);
  function f(H) {
    let Q = 1;
    for (let Z = 0; Z < 16; Z++) {
      let B = H[Z] + Q + 65535;
      Q = Math.floor(B / 65536), H[Z] = B - Q * 65536;
    }
    H[0] += Q - 1 + 37 * (Q - 1);
  }
  function u(H, Q, Z) {
    const B = ~(Z - 1);
    for (let Y = 0; Y < 16; Y++) {
      const ae = B & (H[Y] ^ Q[Y]);
      H[Y] ^= ae, Q[Y] ^= ae;
    }
  }
  function h(H, Q) {
    const Z = i(), B = i();
    for (let Y = 0; Y < 16; Y++)
      B[Y] = Q[Y];
    f(B), f(B), f(B);
    for (let Y = 0; Y < 2; Y++) {
      Z[0] = B[0] - 65517;
      for (let se = 1; se < 15; se++)
        Z[se] = B[se] - 65535 - (Z[se - 1] >> 16 & 1), Z[se - 1] &= 65535;
      Z[15] = B[15] - 32767 - (Z[14] >> 16 & 1);
      const ae = Z[15] >> 16 & 1;
      Z[14] &= 65535, u(B, Z, 1 - ae);
    }
    for (let Y = 0; Y < 16; Y++)
      H[2 * Y] = B[Y] & 255, H[2 * Y + 1] = B[Y] >> 8;
  }
  function d(H, Q) {
    for (let Z = 0; Z < 16; Z++)
      H[Z] = Q[2 * Z] + (Q[2 * Z + 1] << 8);
    H[15] &= 32767;
  }
  function l(H, Q, Z) {
    for (let B = 0; B < 16; B++)
      H[B] = Q[B] + Z[B];
  }
  function m(H, Q, Z) {
    for (let B = 0; B < 16; B++)
      H[B] = Q[B] - Z[B];
  }
  function b(H, Q, Z) {
    let B, Y, ae = 0, se = 0, W = 0, C = 0, g = 0, a = 0, c = 0, p = 0, w = 0, _ = 0, x = 0, E = 0, y = 0, o = 0, S = 0, J = 0, z = 0, k = 0, j = 0, q = 0, K = 0, U = 0, T = 0, D = 0, te = 0, ne = 0, le = 0, X = 0, $ = 0, V = 0, re = 0, fe = Z[0], ue = Z[1], me = Z[2], be = Z[3], ve = Z[4], Ge = Z[5], ye = Z[6], pe = Z[7], Je = Z[8], Ie = Z[9], we = Z[10], at = Z[11], Oe = Z[12], Ee = Z[13], ft = Z[14], Le = Z[15];
    B = Q[0], ae += B * fe, se += B * ue, W += B * me, C += B * be, g += B * ve, a += B * Ge, c += B * ye, p += B * pe, w += B * Je, _ += B * Ie, x += B * we, E += B * at, y += B * Oe, o += B * Ee, S += B * ft, J += B * Le, B = Q[1], se += B * fe, W += B * ue, C += B * me, g += B * be, a += B * ve, c += B * Ge, p += B * ye, w += B * pe, _ += B * Je, x += B * Ie, E += B * we, y += B * at, o += B * Oe, S += B * Ee, J += B * ft, z += B * Le, B = Q[2], W += B * fe, C += B * ue, g += B * me, a += B * be, c += B * ve, p += B * Ge, w += B * ye, _ += B * pe, x += B * Je, E += B * Ie, y += B * we, o += B * at, S += B * Oe, J += B * Ee, z += B * ft, k += B * Le, B = Q[3], C += B * fe, g += B * ue, a += B * me, c += B * be, p += B * ve, w += B * Ge, _ += B * ye, x += B * pe, E += B * Je, y += B * Ie, o += B * we, S += B * at, J += B * Oe, z += B * Ee, k += B * ft, j += B * Le, B = Q[4], g += B * fe, a += B * ue, c += B * me, p += B * be, w += B * ve, _ += B * Ge, x += B * ye, E += B * pe, y += B * Je, o += B * Ie, S += B * we, J += B * at, z += B * Oe, k += B * Ee, j += B * ft, q += B * Le, B = Q[5], a += B * fe, c += B * ue, p += B * me, w += B * be, _ += B * ve, x += B * Ge, E += B * ye, y += B * pe, o += B * Je, S += B * Ie, J += B * we, z += B * at, k += B * Oe, j += B * Ee, q += B * ft, K += B * Le, B = Q[6], c += B * fe, p += B * ue, w += B * me, _ += B * be, x += B * ve, E += B * Ge, y += B * ye, o += B * pe, S += B * Je, J += B * Ie, z += B * we, k += B * at, j += B * Oe, q += B * Ee, K += B * ft, U += B * Le, B = Q[7], p += B * fe, w += B * ue, _ += B * me, x += B * be, E += B * ve, y += B * Ge, o += B * ye, S += B * pe, J += B * Je, z += B * Ie, k += B * we, j += B * at, q += B * Oe, K += B * Ee, U += B * ft, T += B * Le, B = Q[8], w += B * fe, _ += B * ue, x += B * me, E += B * be, y += B * ve, o += B * Ge, S += B * ye, J += B * pe, z += B * Je, k += B * Ie, j += B * we, q += B * at, K += B * Oe, U += B * Ee, T += B * ft, D += B * Le, B = Q[9], _ += B * fe, x += B * ue, E += B * me, y += B * be, o += B * ve, S += B * Ge, J += B * ye, z += B * pe, k += B * Je, j += B * Ie, q += B * we, K += B * at, U += B * Oe, T += B * Ee, D += B * ft, te += B * Le, B = Q[10], x += B * fe, E += B * ue, y += B * me, o += B * be, S += B * ve, J += B * Ge, z += B * ye, k += B * pe, j += B * Je, q += B * Ie, K += B * we, U += B * at, T += B * Oe, D += B * Ee, te += B * ft, ne += B * Le, B = Q[11], E += B * fe, y += B * ue, o += B * me, S += B * be, J += B * ve, z += B * Ge, k += B * ye, j += B * pe, q += B * Je, K += B * Ie, U += B * we, T += B * at, D += B * Oe, te += B * Ee, ne += B * ft, le += B * Le, B = Q[12], y += B * fe, o += B * ue, S += B * me, J += B * be, z += B * ve, k += B * Ge, j += B * ye, q += B * pe, K += B * Je, U += B * Ie, T += B * we, D += B * at, te += B * Oe, ne += B * Ee, le += B * ft, X += B * Le, B = Q[13], o += B * fe, S += B * ue, J += B * me, z += B * be, k += B * ve, j += B * Ge, q += B * ye, K += B * pe, U += B * Je, T += B * Ie, D += B * we, te += B * at, ne += B * Oe, le += B * Ee, X += B * ft, $ += B * Le, B = Q[14], S += B * fe, J += B * ue, z += B * me, k += B * be, j += B * ve, q += B * Ge, K += B * ye, U += B * pe, T += B * Je, D += B * Ie, te += B * we, ne += B * at, le += B * Oe, X += B * Ee, $ += B * ft, V += B * Le, B = Q[15], J += B * fe, z += B * ue, k += B * me, j += B * be, q += B * ve, K += B * Ge, U += B * ye, T += B * pe, D += B * Je, te += B * Ie, ne += B * we, le += B * at, X += B * Oe, $ += B * Ee, V += B * ft, re += B * Le, ae += 38 * z, se += 38 * k, W += 38 * j, C += 38 * q, g += 38 * K, a += 38 * U, c += 38 * T, p += 38 * D, w += 38 * te, _ += 38 * ne, x += 38 * le, E += 38 * X, y += 38 * $, o += 38 * V, S += 38 * re, Y = 1, B = ae + Y + 65535, Y = Math.floor(B / 65536), ae = B - Y * 65536, B = se + Y + 65535, Y = Math.floor(B / 65536), se = B - Y * 65536, B = W + Y + 65535, Y = Math.floor(B / 65536), W = B - Y * 65536, B = C + Y + 65535, Y = Math.floor(B / 65536), C = B - Y * 65536, B = g + Y + 65535, Y = Math.floor(B / 65536), g = B - Y * 65536, B = a + Y + 65535, Y = Math.floor(B / 65536), a = B - Y * 65536, B = c + Y + 65535, Y = Math.floor(B / 65536), c = B - Y * 65536, B = p + Y + 65535, Y = Math.floor(B / 65536), p = B - Y * 65536, B = w + Y + 65535, Y = Math.floor(B / 65536), w = B - Y * 65536, B = _ + Y + 65535, Y = Math.floor(B / 65536), _ = B - Y * 65536, B = x + Y + 65535, Y = Math.floor(B / 65536), x = B - Y * 65536, B = E + Y + 65535, Y = Math.floor(B / 65536), E = B - Y * 65536, B = y + Y + 65535, Y = Math.floor(B / 65536), y = B - Y * 65536, B = o + Y + 65535, Y = Math.floor(B / 65536), o = B - Y * 65536, B = S + Y + 65535, Y = Math.floor(B / 65536), S = B - Y * 65536, B = J + Y + 65535, Y = Math.floor(B / 65536), J = B - Y * 65536, ae += Y - 1 + 37 * (Y - 1), Y = 1, B = ae + Y + 65535, Y = Math.floor(B / 65536), ae = B - Y * 65536, B = se + Y + 65535, Y = Math.floor(B / 65536), se = B - Y * 65536, B = W + Y + 65535, Y = Math.floor(B / 65536), W = B - Y * 65536, B = C + Y + 65535, Y = Math.floor(B / 65536), C = B - Y * 65536, B = g + Y + 65535, Y = Math.floor(B / 65536), g = B - Y * 65536, B = a + Y + 65535, Y = Math.floor(B / 65536), a = B - Y * 65536, B = c + Y + 65535, Y = Math.floor(B / 65536), c = B - Y * 65536, B = p + Y + 65535, Y = Math.floor(B / 65536), p = B - Y * 65536, B = w + Y + 65535, Y = Math.floor(B / 65536), w = B - Y * 65536, B = _ + Y + 65535, Y = Math.floor(B / 65536), _ = B - Y * 65536, B = x + Y + 65535, Y = Math.floor(B / 65536), x = B - Y * 65536, B = E + Y + 65535, Y = Math.floor(B / 65536), E = B - Y * 65536, B = y + Y + 65535, Y = Math.floor(B / 65536), y = B - Y * 65536, B = o + Y + 65535, Y = Math.floor(B / 65536), o = B - Y * 65536, B = S + Y + 65535, Y = Math.floor(B / 65536), S = B - Y * 65536, B = J + Y + 65535, Y = Math.floor(B / 65536), J = B - Y * 65536, ae += Y - 1 + 37 * (Y - 1), H[0] = ae, H[1] = se, H[2] = W, H[3] = C, H[4] = g, H[5] = a, H[6] = c, H[7] = p, H[8] = w, H[9] = _, H[10] = x, H[11] = E, H[12] = y, H[13] = o, H[14] = S, H[15] = J;
  }
  function M(H, Q) {
    b(H, Q, Q);
  }
  function A(H, Q) {
    const Z = i();
    for (let B = 0; B < 16; B++)
      Z[B] = Q[B];
    for (let B = 253; B >= 0; B--)
      M(Z, Z), B !== 2 && B !== 4 && b(Z, Z, Q);
    for (let B = 0; B < 16; B++)
      H[B] = Z[B];
  }
  function N(H, Q) {
    const Z = new Uint8Array(32), B = new Float64Array(80), Y = i(), ae = i(), se = i(), W = i(), C = i(), g = i();
    for (let w = 0; w < 31; w++)
      Z[w] = H[w];
    Z[31] = H[31] & 127 | 64, Z[0] &= 248, d(B, Q);
    for (let w = 0; w < 16; w++)
      ae[w] = B[w];
    Y[0] = W[0] = 1;
    for (let w = 254; w >= 0; --w) {
      const _ = Z[w >>> 3] >>> (w & 7) & 1;
      u(Y, ae, _), u(se, W, _), l(C, Y, se), m(Y, Y, se), l(se, ae, W), m(ae, ae, W), M(W, C), M(g, Y), b(Y, se, Y), b(se, ae, C), l(C, Y, se), m(Y, Y, se), M(ae, Y), m(se, W, g), b(Y, se, n), l(Y, Y, W), b(se, se, Y), b(Y, W, g), b(W, ae, B), M(ae, C), u(Y, ae, _), u(se, W, _);
    }
    for (let w = 0; w < 16; w++)
      B[w + 16] = Y[w], B[w + 32] = se[w], B[w + 48] = ae[w], B[w + 64] = W[w];
    const a = B.subarray(32), c = B.subarray(16);
    A(a, a), b(c, c, a);
    const p = new Uint8Array(32);
    return h(p, c), p;
  }
  t.scalarMult = N;
  function R(H) {
    return N(H, s);
  }
  t.scalarMultBase = R;
  function O(H) {
    if (H.length !== t.SECRET_KEY_LENGTH)
      throw new Error(`x25519: seed must be ${t.SECRET_KEY_LENGTH} bytes`);
    const Q = new Uint8Array(H);
    return {
      publicKey: R(Q),
      secretKey: Q
    };
  }
  t.generateKeyPairFromSeed = O;
  function P(H) {
    const Q = (0, e.randomBytes)(32, H), Z = O(Q);
    return (0, r.wipe)(Q), Z;
  }
  t.generateKeyPair = P;
  function F(H, Q, Z = !1) {
    if (H.length !== t.PUBLIC_KEY_LENGTH)
      throw new Error("X25519: incorrect secret key length");
    if (Q.length !== t.PUBLIC_KEY_LENGTH)
      throw new Error("X25519: incorrect public key length");
    const B = N(H, Q);
    if (Z) {
      let Y = 0;
      for (let ae = 0; ae < B.length; ae++)
        Y |= B[ae];
      if (Y === 0)
        throw new Error("X25519: invalid shared key");
    }
    return B;
  }
  t.sharedKey = F;
})(Sw);
function BA(t = 0) {
  return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? globalThis.Buffer.allocUnsafe(t) : new Uint8Array(t);
}
function Ty(t, e) {
  e || (e = t.reduce((s, n) => s + n.length, 0));
  const r = BA(e);
  let i = 0;
  for (const s of t)
    r.set(s, i), i += s.length;
  return r;
}
function Vre(t, e) {
  if (t.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var r = new Uint8Array(256), i = 0; i < r.length; i++)
    r[i] = 255;
  for (var s = 0; s < t.length; s++) {
    var n = t.charAt(s), f = n.charCodeAt(0);
    if (r[f] !== 255)
      throw new TypeError(n + " is ambiguous");
    r[f] = s;
  }
  var u = t.length, h = t.charAt(0), d = Math.log(u) / Math.log(256), l = Math.log(256) / Math.log(u);
  function m(A) {
    if (A instanceof Uint8Array || (ArrayBuffer.isView(A) ? A = new Uint8Array(A.buffer, A.byteOffset, A.byteLength) : Array.isArray(A) && (A = Uint8Array.from(A))), !(A instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (A.length === 0)
      return "";
    for (var N = 0, R = 0, O = 0, P = A.length; O !== P && A[O] === 0; )
      O++, N++;
    for (var F = (P - O) * l + 1 >>> 0, H = new Uint8Array(F); O !== P; ) {
      for (var Q = A[O], Z = 0, B = F - 1; (Q !== 0 || Z < R) && B !== -1; B--, Z++)
        Q += 256 * H[B] >>> 0, H[B] = Q % u >>> 0, Q = Q / u >>> 0;
      if (Q !== 0)
        throw new Error("Non-zero carry");
      R = Z, O++;
    }
    for (var Y = F - R; Y !== F && H[Y] === 0; )
      Y++;
    for (var ae = h.repeat(N); Y < F; ++Y)
      ae += t.charAt(H[Y]);
    return ae;
  }
  function b(A) {
    if (typeof A != "string")
      throw new TypeError("Expected String");
    if (A.length === 0)
      return new Uint8Array();
    var N = 0;
    if (A[N] !== " ") {
      for (var R = 0, O = 0; A[N] === h; )
        R++, N++;
      for (var P = (A.length - N) * d + 1 >>> 0, F = new Uint8Array(P); A[N]; ) {
        var H = r[A.charCodeAt(N)];
        if (H === 255)
          return;
        for (var Q = 0, Z = P - 1; (H !== 0 || Q < O) && Z !== -1; Z--, Q++)
          H += u * F[Z] >>> 0, F[Z] = H % 256 >>> 0, H = H / 256 >>> 0;
        if (H !== 0)
          throw new Error("Non-zero carry");
        O = Q, N++;
      }
      if (A[N] !== " ") {
        for (var B = P - O; B !== P && F[B] === 0; )
          B++;
        for (var Y = new Uint8Array(R + (P - B)), ae = R; B !== P; )
          Y[ae++] = F[B++];
        return Y;
      }
    }
  }
  function M(A) {
    var N = b(A);
    if (N)
      return N;
    throw new Error(`Non-${e} character`);
  }
  return {
    encode: m,
    decodeUnsafe: b,
    decode: M
  };
}
var Gre = Vre, Kre = Gre;
const zA = (t) => {
  if (t instanceof Uint8Array && t.constructor.name === "Uint8Array")
    return t;
  if (t instanceof ArrayBuffer)
    return new Uint8Array(t);
  if (ArrayBuffer.isView(t))
    return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  throw new Error("Unknown type, must be binary type");
}, Yre = (t) => new TextEncoder().encode(t), Qre = (t) => new TextDecoder().decode(t);
class Zre {
  constructor(e, r, i) {
    this.name = e, this.prefix = r, this.baseEncode = i;
  }
  encode(e) {
    if (e instanceof Uint8Array)
      return `${this.prefix}${this.baseEncode(e)}`;
    throw Error("Unknown type, must be binary type");
  }
}
class Jre {
  constructor(e, r, i) {
    if (this.name = e, this.prefix = r, r.codePointAt(0) === void 0)
      throw new Error("Invalid prefix character");
    this.prefixCodePoint = r.codePointAt(0), this.baseDecode = i;
  }
  decode(e) {
    if (typeof e == "string") {
      if (e.codePointAt(0) !== this.prefixCodePoint)
        throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
      return this.baseDecode(e.slice(this.prefix.length));
    } else
      throw Error("Can only multibase decode strings");
  }
  or(e) {
    return UA(this, e);
  }
}
class Xre {
  constructor(e) {
    this.decoders = e;
  }
  or(e) {
    return UA(this, e);
  }
  decode(e) {
    const r = e[0], i = this.decoders[r];
    if (i)
      return i.decode(e);
    throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
  }
}
const UA = (t, e) => new Xre({
  ...t.decoders || { [t.prefix]: t },
  ...e.decoders || { [e.prefix]: e }
});
class eie {
  constructor(e, r, i, s) {
    this.name = e, this.prefix = r, this.baseEncode = i, this.baseDecode = s, this.encoder = new Zre(e, r, i), this.decoder = new Jre(e, r, s);
  }
  encode(e) {
    return this.encoder.encode(e);
  }
  decode(e) {
    return this.decoder.decode(e);
  }
}
const Yp = ({ name: t, prefix: e, encode: r, decode: i }) => new eie(t, e, r, i), rl = ({ prefix: t, name: e, alphabet: r }) => {
  const { encode: i, decode: s } = Kre(r, e);
  return Yp({
    prefix: t,
    name: e,
    encode: i,
    decode: (n) => zA(s(n))
  });
}, tie = (t, e, r, i) => {
  const s = {};
  for (let l = 0; l < e.length; ++l)
    s[e[l]] = l;
  let n = t.length;
  for (; t[n - 1] === "="; )
    --n;
  const f = new Uint8Array(n * r / 8 | 0);
  let u = 0, h = 0, d = 0;
  for (let l = 0; l < n; ++l) {
    const m = s[t[l]];
    if (m === void 0)
      throw new SyntaxError(`Non-${i} character`);
    h = h << r | m, u += r, u >= 8 && (u -= 8, f[d++] = 255 & h >> u);
  }
  if (u >= r || 255 & h << 8 - u)
    throw new SyntaxError("Unexpected end of data");
  return f;
}, rie = (t, e, r) => {
  const i = e[e.length - 1] === "=", s = (1 << r) - 1;
  let n = "", f = 0, u = 0;
  for (let h = 0; h < t.length; ++h)
    for (u = u << 8 | t[h], f += 8; f > r; )
      f -= r, n += e[s & u >> f];
  if (f && (n += e[s & u << r - f]), i)
    for (; n.length * r & 7; )
      n += "=";
  return n;
}, Ti = ({ name: t, prefix: e, bitsPerChar: r, alphabet: i }) => Yp({
  prefix: e,
  name: t,
  encode(s) {
    return rie(s, i, r);
  },
  decode(s) {
    return tie(s, i, r, t);
  }
}), iie = Yp({
  prefix: "\0",
  name: "identity",
  encode: (t) => Qre(t),
  decode: (t) => Yre(t)
}), nie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  identity: iie
}, Symbol.toStringTag, { value: "Module" })), sie = Ti({
  prefix: "0",
  name: "base2",
  alphabet: "01",
  bitsPerChar: 1
}), aie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base2: sie
}, Symbol.toStringTag, { value: "Module" })), oie = Ti({
  prefix: "7",
  name: "base8",
  alphabet: "01234567",
  bitsPerChar: 3
}), fie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base8: oie
}, Symbol.toStringTag, { value: "Module" })), cie = rl({
  prefix: "9",
  name: "base10",
  alphabet: "0123456789"
}), uie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base10: cie
}, Symbol.toStringTag, { value: "Module" })), hie = Ti({
  prefix: "f",
  name: "base16",
  alphabet: "0123456789abcdef",
  bitsPerChar: 4
}), lie = Ti({
  prefix: "F",
  name: "base16upper",
  alphabet: "0123456789ABCDEF",
  bitsPerChar: 4
}), die = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base16: hie,
  base16upper: lie
}, Symbol.toStringTag, { value: "Module" })), pie = Ti({
  prefix: "b",
  name: "base32",
  alphabet: "abcdefghijklmnopqrstuvwxyz234567",
  bitsPerChar: 5
}), vie = Ti({
  prefix: "B",
  name: "base32upper",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
  bitsPerChar: 5
}), gie = Ti({
  prefix: "c",
  name: "base32pad",
  alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
  bitsPerChar: 5
}), bie = Ti({
  prefix: "C",
  name: "base32padupper",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
  bitsPerChar: 5
}), yie = Ti({
  prefix: "v",
  name: "base32hex",
  alphabet: "0123456789abcdefghijklmnopqrstuv",
  bitsPerChar: 5
}), mie = Ti({
  prefix: "V",
  name: "base32hexupper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
  bitsPerChar: 5
}), wie = Ti({
  prefix: "t",
  name: "base32hexpad",
  alphabet: "0123456789abcdefghijklmnopqrstuv=",
  bitsPerChar: 5
}), _ie = Ti({
  prefix: "T",
  name: "base32hexpadupper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
  bitsPerChar: 5
}), Mie = Ti({
  prefix: "h",
  name: "base32z",
  alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
  bitsPerChar: 5
}), xie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base32: pie,
  base32upper: vie,
  base32pad: gie,
  base32padupper: bie,
  base32hex: yie,
  base32hexupper: mie,
  base32hexpad: wie,
  base32hexpadupper: _ie,
  base32z: Mie
}, Symbol.toStringTag, { value: "Module" })), Sie = rl({
  prefix: "k",
  name: "base36",
  alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), Eie = rl({
  prefix: "K",
  name: "base36upper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
}), Iie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base36: Sie,
  base36upper: Eie
}, Symbol.toStringTag, { value: "Module" })), Aie = rl({
  name: "base58btc",
  prefix: "z",
  alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), Tie = rl({
  name: "base58flickr",
  prefix: "Z",
  alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
}), Nie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base58btc: Aie,
  base58flickr: Tie
}, Symbol.toStringTag, { value: "Module" })), Die = Ti({
  prefix: "m",
  name: "base64",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
  bitsPerChar: 6
}), Cie = Ti({
  prefix: "M",
  name: "base64pad",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  bitsPerChar: 6
}), Oie = Ti({
  prefix: "u",
  name: "base64url",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
  bitsPerChar: 6
}), Rie = Ti({
  prefix: "U",
  name: "base64urlpad",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
  bitsPerChar: 6
}), Lie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base64: Die,
  base64pad: Cie,
  base64url: Oie,
  base64urlpad: Rie
}, Symbol.toStringTag, { value: "Module" })), FA = Array.from("\u{1F680}\u{1FA90}\u2604\u{1F6F0}\u{1F30C}\u{1F311}\u{1F312}\u{1F313}\u{1F314}\u{1F315}\u{1F316}\u{1F317}\u{1F318}\u{1F30D}\u{1F30F}\u{1F30E}\u{1F409}\u2600\u{1F4BB}\u{1F5A5}\u{1F4BE}\u{1F4BF}\u{1F602}\u2764\u{1F60D}\u{1F923}\u{1F60A}\u{1F64F}\u{1F495}\u{1F62D}\u{1F618}\u{1F44D}\u{1F605}\u{1F44F}\u{1F601}\u{1F525}\u{1F970}\u{1F494}\u{1F496}\u{1F499}\u{1F622}\u{1F914}\u{1F606}\u{1F644}\u{1F4AA}\u{1F609}\u263A\u{1F44C}\u{1F917}\u{1F49C}\u{1F614}\u{1F60E}\u{1F607}\u{1F339}\u{1F926}\u{1F389}\u{1F49E}\u270C\u2728\u{1F937}\u{1F631}\u{1F60C}\u{1F338}\u{1F64C}\u{1F60B}\u{1F497}\u{1F49A}\u{1F60F}\u{1F49B}\u{1F642}\u{1F493}\u{1F929}\u{1F604}\u{1F600}\u{1F5A4}\u{1F603}\u{1F4AF}\u{1F648}\u{1F447}\u{1F3B6}\u{1F612}\u{1F92D}\u2763\u{1F61C}\u{1F48B}\u{1F440}\u{1F62A}\u{1F611}\u{1F4A5}\u{1F64B}\u{1F61E}\u{1F629}\u{1F621}\u{1F92A}\u{1F44A}\u{1F973}\u{1F625}\u{1F924}\u{1F449}\u{1F483}\u{1F633}\u270B\u{1F61A}\u{1F61D}\u{1F634}\u{1F31F}\u{1F62C}\u{1F643}\u{1F340}\u{1F337}\u{1F63B}\u{1F613}\u2B50\u2705\u{1F97A}\u{1F308}\u{1F608}\u{1F918}\u{1F4A6}\u2714\u{1F623}\u{1F3C3}\u{1F490}\u2639\u{1F38A}\u{1F498}\u{1F620}\u261D\u{1F615}\u{1F33A}\u{1F382}\u{1F33B}\u{1F610}\u{1F595}\u{1F49D}\u{1F64A}\u{1F639}\u{1F5E3}\u{1F4AB}\u{1F480}\u{1F451}\u{1F3B5}\u{1F91E}\u{1F61B}\u{1F534}\u{1F624}\u{1F33C}\u{1F62B}\u26BD\u{1F919}\u2615\u{1F3C6}\u{1F92B}\u{1F448}\u{1F62E}\u{1F646}\u{1F37B}\u{1F343}\u{1F436}\u{1F481}\u{1F632}\u{1F33F}\u{1F9E1}\u{1F381}\u26A1\u{1F31E}\u{1F388}\u274C\u270A\u{1F44B}\u{1F630}\u{1F928}\u{1F636}\u{1F91D}\u{1F6B6}\u{1F4B0}\u{1F353}\u{1F4A2}\u{1F91F}\u{1F641}\u{1F6A8}\u{1F4A8}\u{1F92C}\u2708\u{1F380}\u{1F37A}\u{1F913}\u{1F619}\u{1F49F}\u{1F331}\u{1F616}\u{1F476}\u{1F974}\u25B6\u27A1\u2753\u{1F48E}\u{1F4B8}\u2B07\u{1F628}\u{1F31A}\u{1F98B}\u{1F637}\u{1F57A}\u26A0\u{1F645}\u{1F61F}\u{1F635}\u{1F44E}\u{1F932}\u{1F920}\u{1F927}\u{1F4CC}\u{1F535}\u{1F485}\u{1F9D0}\u{1F43E}\u{1F352}\u{1F617}\u{1F911}\u{1F30A}\u{1F92F}\u{1F437}\u260E\u{1F4A7}\u{1F62F}\u{1F486}\u{1F446}\u{1F3A4}\u{1F647}\u{1F351}\u2744\u{1F334}\u{1F4A3}\u{1F438}\u{1F48C}\u{1F4CD}\u{1F940}\u{1F922}\u{1F445}\u{1F4A1}\u{1F4A9}\u{1F450}\u{1F4F8}\u{1F47B}\u{1F910}\u{1F92E}\u{1F3BC}\u{1F975}\u{1F6A9}\u{1F34E}\u{1F34A}\u{1F47C}\u{1F48D}\u{1F4E3}\u{1F942}"), Pie = FA.reduce((t, e, r) => (t[r] = e, t), []), kie = FA.reduce((t, e, r) => (t[e.codePointAt(0)] = r, t), []);
function jie(t) {
  return t.reduce((e, r) => (e += Pie[r], e), "");
}
function Bie(t) {
  const e = [];
  for (const r of t) {
    const i = kie[r.codePointAt(0)];
    if (i === void 0)
      throw new Error(`Non-base256emoji character: ${r}`);
    e.push(i);
  }
  return new Uint8Array(e);
}
const zie = Yp({
  prefix: "\u{1F680}",
  name: "base256emoji",
  encode: jie,
  decode: Bie
}), Uie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base256emoji: zie
}, Symbol.toStringTag, { value: "Module" }));
var Fie = $A, C8 = 128, $ie = 127, qie = ~$ie, Hie = Math.pow(2, 31);
function $A(t, e, r) {
  e = e || [], r = r || 0;
  for (var i = r; t >= Hie; )
    e[r++] = t & 255 | C8, t /= 128;
  for (; t & qie; )
    e[r++] = t & 255 | C8, t >>>= 7;
  return e[r] = t | 0, $A.bytes = r - i + 1, e;
}
var Wie = Om, Vie = 128, O8 = 127;
function Om(t, i) {
  var r = 0, i = i || 0, s = 0, n = i, f, u = t.length;
  do {
    if (n >= u)
      throw Om.bytes = 0, new RangeError("Could not decode varint");
    f = t[n++], r += s < 28 ? (f & O8) << s : (f & O8) * Math.pow(2, s), s += 7;
  } while (f >= Vie);
  return Om.bytes = n - i, r;
}
var Gie = Math.pow(2, 7), Kie = Math.pow(2, 14), Yie = Math.pow(2, 21), Qie = Math.pow(2, 28), Zie = Math.pow(2, 35), Jie = Math.pow(2, 42), Xie = Math.pow(2, 49), ene = Math.pow(2, 56), tne = Math.pow(2, 63), rne = function(t) {
  return t < Gie ? 1 : t < Kie ? 2 : t < Yie ? 3 : t < Qie ? 4 : t < Zie ? 5 : t < Jie ? 6 : t < Xie ? 7 : t < ene ? 8 : t < tne ? 9 : 10;
}, ine = {
  encode: Fie,
  decode: Wie,
  encodingLength: rne
}, qA = ine;
const R8 = (t, e, r = 0) => (qA.encode(t, e, r), e), L8 = (t) => qA.encodingLength(t), Rm = (t, e) => {
  const r = e.byteLength, i = L8(t), s = i + L8(r), n = new Uint8Array(s + r);
  return R8(t, n, 0), R8(r, n, i), n.set(e, s), new nne(t, r, e, n);
};
class nne {
  constructor(e, r, i, s) {
    this.code = e, this.size = r, this.digest = i, this.bytes = s;
  }
}
const HA = ({ name: t, code: e, encode: r }) => new sne(t, e, r);
class sne {
  constructor(e, r, i) {
    this.name = e, this.code = r, this.encode = i;
  }
  digest(e) {
    if (e instanceof Uint8Array) {
      const r = this.encode(e);
      return r instanceof Uint8Array ? Rm(this.code, r) : r.then((i) => Rm(this.code, i));
    } else
      throw Error("Unknown type, must be binary type");
  }
}
const WA = (t) => async (e) => new Uint8Array(await crypto.subtle.digest(t, e)), ane = HA({
  name: "sha2-256",
  code: 18,
  encode: WA("SHA-256")
}), one = HA({
  name: "sha2-512",
  code: 19,
  encode: WA("SHA-512")
}), fne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  sha256: ane,
  sha512: one
}, Symbol.toStringTag, { value: "Module" })), VA = 0, cne = "identity", GA = zA, une = (t) => Rm(VA, GA(t)), hne = {
  code: VA,
  name: cne,
  encode: GA,
  digest: une
}, lne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  identity: hne
}, Symbol.toStringTag, { value: "Module" }));
new TextEncoder();
new TextDecoder();
const O0 = {
  ...nie,
  ...aie,
  ...fie,
  ...uie,
  ...die,
  ...xie,
  ...Iie,
  ...Nie,
  ...Lie,
  ...Uie
};
({
  ...fne,
  ...lne
});
function KA(t, e, r, i) {
  return {
    name: t,
    prefix: e,
    encoder: {
      name: t,
      prefix: e,
      encode: r
    },
    decoder: { decode: i }
  };
}
const P8 = KA("utf8", "u", (t) => {
  const e = new TextDecoder("utf8");
  return "u" + e.decode(t);
}, (t) => new TextEncoder().encode(t.substring(1))), Ny = KA("ascii", "a", (t) => {
  let e = "a";
  for (let r = 0; r < t.length; r++)
    e += String.fromCharCode(t[r]);
  return e;
}, (t) => {
  t = t.substring(1);
  const e = BA(t.length);
  for (let r = 0; r < t.length; r++)
    e[r] = t.charCodeAt(r);
  return e;
}), YA = {
  utf8: P8,
  "utf-8": P8,
  hex: O0.base16,
  latin1: Ny,
  ascii: Ny,
  binary: Ny,
  ...O0
};
function Xn(t, e = "utf8") {
  const r = YA[e];
  if (!r)
    throw new Error(`Unsupported encoding "${e}"`);
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? globalThis.Buffer.from(t, "utf8") : r.decoder.decode(`${r.prefix}${t}`);
}
function un(t, e = "utf8") {
  const r = YA[e];
  if (!r)
    throw new Error(`Unsupported encoding "${e}"`);
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? globalThis.Buffer.from(t.buffer, t.byteOffset, t.byteLength).toString("utf8") : r.encoder.encode(t).substring(1);
}
var QA = {};
const dne = "elliptic", pne = "6.5.7", vne = "EC cryptography", gne = "lib/elliptic.js", bne = [
  "lib"
], yne = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, mne = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, wne = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], _ne = "Fedor Indutny <fedor@indutny.com>", Mne = "MIT", xne = {
  url: "https://github.com/indutny/elliptic/issues"
}, Sne = "https://github.com/indutny/elliptic", Ene = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, Ine = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, Ane = {
  name: dne,
  version: pne,
  description: vne,
  main: gne,
  files: bne,
  scripts: yne,
  repository: mne,
  keywords: wne,
  author: _ne,
  license: Mne,
  bugs: xne,
  homepage: Sne,
  devDependencies: Ene,
  dependencies: Ine
};
var On = {};
(function(t) {
  var e = t, r = Sr.exports, i = Nn, s = Vp;
  e.assert = i, e.toArray = s.toArray, e.zero2 = s.zero2, e.toHex = s.toHex, e.encode = s.encode;
  function n(l, m, b) {
    var M = new Array(Math.max(l.bitLength(), b) + 1), A;
    for (A = 0; A < M.length; A += 1)
      M[A] = 0;
    var N = 1 << m + 1, R = l.clone();
    for (A = 0; A < M.length; A++) {
      var O, P = R.andln(N - 1);
      R.isOdd() ? (P > (N >> 1) - 1 ? O = (N >> 1) - P : O = P, R.isubn(O)) : O = 0, M[A] = O, R.iushrn(1);
    }
    return M;
  }
  e.getNAF = n;
  function f(l, m) {
    var b = [
      [],
      []
    ];
    l = l.clone(), m = m.clone();
    for (var M = 0, A = 0, N; l.cmpn(-M) > 0 || m.cmpn(-A) > 0; ) {
      var R = l.andln(3) + M & 3, O = m.andln(3) + A & 3;
      R === 3 && (R = -1), O === 3 && (O = -1);
      var P;
      (R & 1) === 0 ? P = 0 : (N = l.andln(7) + M & 7, (N === 3 || N === 5) && O === 2 ? P = -R : P = R), b[0].push(P);
      var F;
      (O & 1) === 0 ? F = 0 : (N = m.andln(7) + A & 7, (N === 3 || N === 5) && R === 2 ? F = -O : F = O), b[1].push(F), 2 * M === P + 1 && (M = 1 - M), 2 * A === F + 1 && (A = 1 - A), l.iushrn(1), m.iushrn(1);
    }
    return b;
  }
  e.getJSF = f;
  function u(l, m, b) {
    var M = "_" + m;
    l.prototype[m] = function() {
      return this[M] !== void 0 ? this[M] : this[M] = b.call(this);
    };
  }
  e.cachedProperty = u;
  function h(l) {
    return typeof l == "string" ? e.toArray(l, "hex") : l;
  }
  e.parseBytes = h;
  function d(l) {
    return new r(l, "hex", "le");
  }
  e.intFromLE = d;
})(On);
var Ew = {}, zo = Sr.exports, il = On, R0 = il.getNAF, Tne = il.getJSF, L0 = il.assert;
function wo(t, e) {
  this.type = t, this.p = new zo(e.p, 16), this.red = e.prime ? zo.red(e.prime) : zo.mont(this.p), this.zero = new zo(0).toRed(this.red), this.one = new zo(1).toRed(this.red), this.two = new zo(2).toRed(this.red), this.n = e.n && new zo(e.n, 16), this.g = e.g && this.pointFromJSON(e.g, e.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
  var r = this.n && this.p.div(this.n);
  !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var Qp = wo;
wo.prototype.point = function() {
  throw new Error("Not implemented");
};
wo.prototype.validate = function() {
  throw new Error("Not implemented");
};
wo.prototype._fixedNafMul = function(e, r) {
  L0(e.precomputed);
  var i = e._getDoubles(), s = R0(r, 1, this._bitLength), n = (1 << i.step + 1) - (i.step % 2 === 0 ? 2 : 1);
  n /= 3;
  var f = [], u, h;
  for (u = 0; u < s.length; u += i.step) {
    h = 0;
    for (var d = u + i.step - 1; d >= u; d--)
      h = (h << 1) + s[d];
    f.push(h);
  }
  for (var l = this.jpoint(null, null, null), m = this.jpoint(null, null, null), b = n; b > 0; b--) {
    for (u = 0; u < f.length; u++)
      h = f[u], h === b ? m = m.mixedAdd(i.points[u]) : h === -b && (m = m.mixedAdd(i.points[u].neg()));
    l = l.add(m);
  }
  return l.toP();
};
wo.prototype._wnafMul = function(e, r) {
  var i = 4, s = e._getNAFPoints(i);
  i = s.wnd;
  for (var n = s.points, f = R0(r, i, this._bitLength), u = this.jpoint(null, null, null), h = f.length - 1; h >= 0; h--) {
    for (var d = 0; h >= 0 && f[h] === 0; h--)
      d++;
    if (h >= 0 && d++, u = u.dblp(d), h < 0)
      break;
    var l = f[h];
    L0(l !== 0), e.type === "affine" ? l > 0 ? u = u.mixedAdd(n[l - 1 >> 1]) : u = u.mixedAdd(n[-l - 1 >> 1].neg()) : l > 0 ? u = u.add(n[l - 1 >> 1]) : u = u.add(n[-l - 1 >> 1].neg());
  }
  return e.type === "affine" ? u.toP() : u;
};
wo.prototype._wnafMulAdd = function(e, r, i, s, n) {
  var f = this._wnafT1, u = this._wnafT2, h = this._wnafT3, d = 0, l, m, b;
  for (l = 0; l < s; l++) {
    b = r[l];
    var M = b._getNAFPoints(e);
    f[l] = M.wnd, u[l] = M.points;
  }
  for (l = s - 1; l >= 1; l -= 2) {
    var A = l - 1, N = l;
    if (f[A] !== 1 || f[N] !== 1) {
      h[A] = R0(i[A], f[A], this._bitLength), h[N] = R0(i[N], f[N], this._bitLength), d = Math.max(h[A].length, d), d = Math.max(h[N].length, d);
      continue;
    }
    var R = [
      r[A],
      null,
      null,
      r[N]
    ];
    r[A].y.cmp(r[N].y) === 0 ? (R[1] = r[A].add(r[N]), R[2] = r[A].toJ().mixedAdd(r[N].neg())) : r[A].y.cmp(r[N].y.redNeg()) === 0 ? (R[1] = r[A].toJ().mixedAdd(r[N]), R[2] = r[A].add(r[N].neg())) : (R[1] = r[A].toJ().mixedAdd(r[N]), R[2] = r[A].toJ().mixedAdd(r[N].neg()));
    var O = [
      -3,
      -1,
      -5,
      -7,
      0,
      7,
      5,
      1,
      3
    ], P = Tne(i[A], i[N]);
    for (d = Math.max(P[0].length, d), h[A] = new Array(d), h[N] = new Array(d), m = 0; m < d; m++) {
      var F = P[0][m] | 0, H = P[1][m] | 0;
      h[A][m] = O[(F + 1) * 3 + (H + 1)], h[N][m] = 0, u[A] = R;
    }
  }
  var Q = this.jpoint(null, null, null), Z = this._wnafT4;
  for (l = d; l >= 0; l--) {
    for (var B = 0; l >= 0; ) {
      var Y = !0;
      for (m = 0; m < s; m++)
        Z[m] = h[m][l] | 0, Z[m] !== 0 && (Y = !1);
      if (!Y)
        break;
      B++, l--;
    }
    if (l >= 0 && B++, Q = Q.dblp(B), l < 0)
      break;
    for (m = 0; m < s; m++) {
      var ae = Z[m];
      ae !== 0 && (ae > 0 ? b = u[m][ae - 1 >> 1] : ae < 0 && (b = u[m][-ae - 1 >> 1].neg()), b.type === "affine" ? Q = Q.mixedAdd(b) : Q = Q.add(b));
    }
  }
  for (l = 0; l < s; l++)
    u[l] = null;
  return n ? Q : Q.toP();
};
function cs(t, e) {
  this.curve = t, this.type = e, this.precomputed = null;
}
wo.BasePoint = cs;
cs.prototype.eq = function() {
  throw new Error("Not implemented");
};
cs.prototype.validate = function() {
  return this.curve.validate(this);
};
wo.prototype.decodePoint = function(e, r) {
  e = il.toArray(e, r);
  var i = this.p.byteLength();
  if ((e[0] === 4 || e[0] === 6 || e[0] === 7) && e.length - 1 === 2 * i) {
    e[0] === 6 ? L0(e[e.length - 1] % 2 === 0) : e[0] === 7 && L0(e[e.length - 1] % 2 === 1);
    var s = this.point(
      e.slice(1, 1 + i),
      e.slice(1 + i, 1 + 2 * i)
    );
    return s;
  } else if ((e[0] === 2 || e[0] === 3) && e.length - 1 === i)
    return this.pointFromX(e.slice(1, 1 + i), e[0] === 3);
  throw new Error("Unknown point format");
};
cs.prototype.encodeCompressed = function(e) {
  return this.encode(e, !0);
};
cs.prototype._encode = function(e) {
  var r = this.curve.p.byteLength(), i = this.getX().toArray("be", r);
  return e ? [this.getY().isEven() ? 2 : 3].concat(i) : [4].concat(i, this.getY().toArray("be", r));
};
cs.prototype.encode = function(e, r) {
  return il.encode(this._encode(r), e);
};
cs.prototype.precompute = function(e) {
  if (this.precomputed)
    return this;
  var r = {
    doubles: null,
    naf: null,
    beta: null
  };
  return r.naf = this._getNAFPoints(8), r.doubles = this._getDoubles(4, e), r.beta = this._getBeta(), this.precomputed = r, this;
};
cs.prototype._hasDoubles = function(e) {
  if (!this.precomputed)
    return !1;
  var r = this.precomputed.doubles;
  return r ? r.points.length >= Math.ceil((e.bitLength() + 1) / r.step) : !1;
};
cs.prototype._getDoubles = function(e, r) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;
  for (var i = [this], s = this, n = 0; n < r; n += e) {
    for (var f = 0; f < e; f++)
      s = s.dbl();
    i.push(s);
  }
  return {
    step: e,
    points: i
  };
};
cs.prototype._getNAFPoints = function(e) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;
  for (var r = [this], i = (1 << e) - 1, s = i === 1 ? null : this.dbl(), n = 1; n < i; n++)
    r[n] = r[n - 1].add(s);
  return {
    wnd: e,
    points: r
  };
};
cs.prototype._getBeta = function() {
  return null;
};
cs.prototype.dblp = function(e) {
  for (var r = this, i = 0; i < e; i++)
    r = r.dbl();
  return r;
};
var Nne = On, Yr = Sr.exports, Iw = It.exports, tu = Qp, Dne = Nne.assert;
function us(t) {
  tu.call(this, "short", t), this.a = new Yr(t.a, 16).toRed(this.red), this.b = new Yr(t.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(t), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
Iw(us, tu);
var Cne = us;
us.prototype._getEndomorphism = function(e) {
  if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
    var r, i;
    if (e.beta)
      r = new Yr(e.beta, 16).toRed(this.red);
    else {
      var s = this._getEndoRoots(this.p);
      r = s[0].cmp(s[1]) < 0 ? s[0] : s[1], r = r.toRed(this.red);
    }
    if (e.lambda)
      i = new Yr(e.lambda, 16);
    else {
      var n = this._getEndoRoots(this.n);
      this.g.mul(n[0]).x.cmp(this.g.x.redMul(r)) === 0 ? i = n[0] : (i = n[1], Dne(this.g.mul(i).x.cmp(this.g.x.redMul(r)) === 0));
    }
    var f;
    return e.basis ? f = e.basis.map(function(u) {
      return {
        a: new Yr(u.a, 16),
        b: new Yr(u.b, 16)
      };
    }) : f = this._getEndoBasis(i), {
      beta: r,
      lambda: i,
      basis: f
    };
  }
};
us.prototype._getEndoRoots = function(e) {
  var r = e === this.p ? this.red : Yr.mont(e), i = new Yr(2).toRed(r).redInvm(), s = i.redNeg(), n = new Yr(3).toRed(r).redNeg().redSqrt().redMul(i), f = s.redAdd(n).fromRed(), u = s.redSub(n).fromRed();
  return [f, u];
};
us.prototype._getEndoBasis = function(e) {
  for (var r = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), i = e, s = this.n.clone(), n = new Yr(1), f = new Yr(0), u = new Yr(0), h = new Yr(1), d, l, m, b, M, A, N, R = 0, O, P; i.cmpn(0) !== 0; ) {
    var F = s.div(i);
    O = s.sub(F.mul(i)), P = u.sub(F.mul(n));
    var H = h.sub(F.mul(f));
    if (!m && O.cmp(r) < 0)
      d = N.neg(), l = n, m = O.neg(), b = P;
    else if (m && ++R === 2)
      break;
    N = O, s = i, i = O, u = n, n = P, h = f, f = H;
  }
  M = O.neg(), A = P;
  var Q = m.sqr().add(b.sqr()), Z = M.sqr().add(A.sqr());
  return Z.cmp(Q) >= 0 && (M = d, A = l), m.negative && (m = m.neg(), b = b.neg()), M.negative && (M = M.neg(), A = A.neg()), [
    { a: m, b },
    { a: M, b: A }
  ];
};
us.prototype._endoSplit = function(e) {
  var r = this.endo.basis, i = r[0], s = r[1], n = s.b.mul(e).divRound(this.n), f = i.b.neg().mul(e).divRound(this.n), u = n.mul(i.a), h = f.mul(s.a), d = n.mul(i.b), l = f.mul(s.b), m = e.sub(u).sub(h), b = d.add(l).neg();
  return { k1: m, k2: b };
};
us.prototype.pointFromX = function(e, r) {
  e = new Yr(e, 16), e.red || (e = e.toRed(this.red));
  var i = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b), s = i.redSqrt();
  if (s.redSqr().redSub(i).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var n = s.fromRed().isOdd();
  return (r && !n || !r && n) && (s = s.redNeg()), this.point(e, s);
};
us.prototype.validate = function(e) {
  if (e.inf)
    return !0;
  var r = e.x, i = e.y, s = this.a.redMul(r), n = r.redSqr().redMul(r).redIAdd(s).redIAdd(this.b);
  return i.redSqr().redISub(n).cmpn(0) === 0;
};
us.prototype._endoWnafMulAdd = function(e, r, i) {
  for (var s = this._endoWnafT1, n = this._endoWnafT2, f = 0; f < e.length; f++) {
    var u = this._endoSplit(r[f]), h = e[f], d = h._getBeta();
    u.k1.negative && (u.k1.ineg(), h = h.neg(!0)), u.k2.negative && (u.k2.ineg(), d = d.neg(!0)), s[f * 2] = h, s[f * 2 + 1] = d, n[f * 2] = u.k1, n[f * 2 + 1] = u.k2;
  }
  for (var l = this._wnafMulAdd(1, s, n, f * 2, i), m = 0; m < f * 2; m++)
    s[m] = null, n[m] = null;
  return l;
};
function Mi(t, e, r, i) {
  tu.BasePoint.call(this, t, "affine"), e === null && r === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new Yr(e, 16), this.y = new Yr(r, 16), i && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
Iw(Mi, tu.BasePoint);
us.prototype.point = function(e, r, i) {
  return new Mi(this, e, r, i);
};
us.prototype.pointFromJSON = function(e, r) {
  return Mi.fromJSON(this, e, r);
};
Mi.prototype._getBeta = function() {
  if (!!this.curve.endo) {
    var e = this.precomputed;
    if (e && e.beta)
      return e.beta;
    var r = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (e) {
      var i = this.curve, s = function(n) {
        return i.point(n.x.redMul(i.endo.beta), n.y);
      };
      e.beta = r, r.precomputed = {
        beta: null,
        naf: e.naf && {
          wnd: e.naf.wnd,
          points: e.naf.points.map(s)
        },
        doubles: e.doubles && {
          step: e.doubles.step,
          points: e.doubles.points.map(s)
        }
      };
    }
    return r;
  }
};
Mi.prototype.toJSON = function() {
  return this.precomputed ? [this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  }] : [this.x, this.y];
};
Mi.fromJSON = function(e, r, i) {
  typeof r == "string" && (r = JSON.parse(r));
  var s = e.point(r[0], r[1], i);
  if (!r[2])
    return s;
  function n(u) {
    return e.point(u[0], u[1], i);
  }
  var f = r[2];
  return s.precomputed = {
    beta: null,
    doubles: f.doubles && {
      step: f.doubles.step,
      points: [s].concat(f.doubles.points.map(n))
    },
    naf: f.naf && {
      wnd: f.naf.wnd,
      points: [s].concat(f.naf.points.map(n))
    }
  }, s;
};
Mi.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Mi.prototype.isInfinity = function() {
  return this.inf;
};
Mi.prototype.add = function(e) {
  if (this.inf)
    return e;
  if (e.inf)
    return this;
  if (this.eq(e))
    return this.dbl();
  if (this.neg().eq(e))
    return this.curve.point(null, null);
  if (this.x.cmp(e.x) === 0)
    return this.curve.point(null, null);
  var r = this.y.redSub(e.y);
  r.cmpn(0) !== 0 && (r = r.redMul(this.x.redSub(e.x).redInvm()));
  var i = r.redSqr().redISub(this.x).redISub(e.x), s = r.redMul(this.x.redSub(i)).redISub(this.y);
  return this.curve.point(i, s);
};
Mi.prototype.dbl = function() {
  if (this.inf)
    return this;
  var e = this.y.redAdd(this.y);
  if (e.cmpn(0) === 0)
    return this.curve.point(null, null);
  var r = this.curve.a, i = this.x.redSqr(), s = e.redInvm(), n = i.redAdd(i).redIAdd(i).redIAdd(r).redMul(s), f = n.redSqr().redISub(this.x.redAdd(this.x)), u = n.redMul(this.x.redSub(f)).redISub(this.y);
  return this.curve.point(f, u);
};
Mi.prototype.getX = function() {
  return this.x.fromRed();
};
Mi.prototype.getY = function() {
  return this.y.fromRed();
};
Mi.prototype.mul = function(e) {
  return e = new Yr(e, 16), this.isInfinity() ? this : this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [e]) : this.curve._wnafMul(this, e);
};
Mi.prototype.mulAdd = function(e, r, i) {
  var s = [this, r], n = [e, i];
  return this.curve.endo ? this.curve._endoWnafMulAdd(s, n) : this.curve._wnafMulAdd(1, s, n, 2);
};
Mi.prototype.jmulAdd = function(e, r, i) {
  var s = [this, r], n = [e, i];
  return this.curve.endo ? this.curve._endoWnafMulAdd(s, n, !0) : this.curve._wnafMulAdd(1, s, n, 2, !0);
};
Mi.prototype.eq = function(e) {
  return this === e || this.inf === e.inf && (this.inf || this.x.cmp(e.x) === 0 && this.y.cmp(e.y) === 0);
};
Mi.prototype.neg = function(e) {
  if (this.inf)
    return this;
  var r = this.curve.point(this.x, this.y.redNeg());
  if (e && this.precomputed) {
    var i = this.precomputed, s = function(n) {
      return n.neg();
    };
    r.precomputed = {
      naf: i.naf && {
        wnd: i.naf.wnd,
        points: i.naf.points.map(s)
      },
      doubles: i.doubles && {
        step: i.doubles.step,
        points: i.doubles.points.map(s)
      }
    };
  }
  return r;
};
Mi.prototype.toJ = function() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);
  var e = this.curve.jpoint(this.x, this.y, this.curve.one);
  return e;
};
function Ni(t, e, r, i) {
  tu.BasePoint.call(this, t, "jacobian"), e === null && r === null && i === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new Yr(0)) : (this.x = new Yr(e, 16), this.y = new Yr(r, 16), this.z = new Yr(i, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
Iw(Ni, tu.BasePoint);
us.prototype.jpoint = function(e, r, i) {
  return new Ni(this, e, r, i);
};
Ni.prototype.toP = function() {
  if (this.isInfinity())
    return this.curve.point(null, null);
  var e = this.z.redInvm(), r = e.redSqr(), i = this.x.redMul(r), s = this.y.redMul(r).redMul(e);
  return this.curve.point(i, s);
};
Ni.prototype.neg = function() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
Ni.prototype.add = function(e) {
  if (this.isInfinity())
    return e;
  if (e.isInfinity())
    return this;
  var r = e.z.redSqr(), i = this.z.redSqr(), s = this.x.redMul(r), n = e.x.redMul(i), f = this.y.redMul(r.redMul(e.z)), u = e.y.redMul(i.redMul(this.z)), h = s.redSub(n), d = f.redSub(u);
  if (h.cmpn(0) === 0)
    return d.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var l = h.redSqr(), m = l.redMul(h), b = s.redMul(l), M = d.redSqr().redIAdd(m).redISub(b).redISub(b), A = d.redMul(b.redISub(M)).redISub(f.redMul(m)), N = this.z.redMul(e.z).redMul(h);
  return this.curve.jpoint(M, A, N);
};
Ni.prototype.mixedAdd = function(e) {
  if (this.isInfinity())
    return e.toJ();
  if (e.isInfinity())
    return this;
  var r = this.z.redSqr(), i = this.x, s = e.x.redMul(r), n = this.y, f = e.y.redMul(r).redMul(this.z), u = i.redSub(s), h = n.redSub(f);
  if (u.cmpn(0) === 0)
    return h.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var d = u.redSqr(), l = d.redMul(u), m = i.redMul(d), b = h.redSqr().redIAdd(l).redISub(m).redISub(m), M = h.redMul(m.redISub(b)).redISub(n.redMul(l)), A = this.z.redMul(u);
  return this.curve.jpoint(b, M, A);
};
Ni.prototype.dblp = function(e) {
  if (e === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!e)
    return this.dbl();
  var r;
  if (this.curve.zeroA || this.curve.threeA) {
    var i = this;
    for (r = 0; r < e; r++)
      i = i.dbl();
    return i;
  }
  var s = this.curve.a, n = this.curve.tinv, f = this.x, u = this.y, h = this.z, d = h.redSqr().redSqr(), l = u.redAdd(u);
  for (r = 0; r < e; r++) {
    var m = f.redSqr(), b = l.redSqr(), M = b.redSqr(), A = m.redAdd(m).redIAdd(m).redIAdd(s.redMul(d)), N = f.redMul(b), R = A.redSqr().redISub(N.redAdd(N)), O = N.redISub(R), P = A.redMul(O);
    P = P.redIAdd(P).redISub(M);
    var F = l.redMul(h);
    r + 1 < e && (d = d.redMul(M)), f = R, h = F, l = P;
  }
  return this.curve.jpoint(f, l.redMul(n), h);
};
Ni.prototype.dbl = function() {
  return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
};
Ni.prototype._zeroDbl = function() {
  var e, r, i;
  if (this.zOne) {
    var s = this.x.redSqr(), n = this.y.redSqr(), f = n.redSqr(), u = this.x.redAdd(n).redSqr().redISub(s).redISub(f);
    u = u.redIAdd(u);
    var h = s.redAdd(s).redIAdd(s), d = h.redSqr().redISub(u).redISub(u), l = f.redIAdd(f);
    l = l.redIAdd(l), l = l.redIAdd(l), e = d, r = h.redMul(u.redISub(d)).redISub(l), i = this.y.redAdd(this.y);
  } else {
    var m = this.x.redSqr(), b = this.y.redSqr(), M = b.redSqr(), A = this.x.redAdd(b).redSqr().redISub(m).redISub(M);
    A = A.redIAdd(A);
    var N = m.redAdd(m).redIAdd(m), R = N.redSqr(), O = M.redIAdd(M);
    O = O.redIAdd(O), O = O.redIAdd(O), e = R.redISub(A).redISub(A), r = N.redMul(A.redISub(e)).redISub(O), i = this.y.redMul(this.z), i = i.redIAdd(i);
  }
  return this.curve.jpoint(e, r, i);
};
Ni.prototype._threeDbl = function() {
  var e, r, i;
  if (this.zOne) {
    var s = this.x.redSqr(), n = this.y.redSqr(), f = n.redSqr(), u = this.x.redAdd(n).redSqr().redISub(s).redISub(f);
    u = u.redIAdd(u);
    var h = s.redAdd(s).redIAdd(s).redIAdd(this.curve.a), d = h.redSqr().redISub(u).redISub(u);
    e = d;
    var l = f.redIAdd(f);
    l = l.redIAdd(l), l = l.redIAdd(l), r = h.redMul(u.redISub(d)).redISub(l), i = this.y.redAdd(this.y);
  } else {
    var m = this.z.redSqr(), b = this.y.redSqr(), M = this.x.redMul(b), A = this.x.redSub(m).redMul(this.x.redAdd(m));
    A = A.redAdd(A).redIAdd(A);
    var N = M.redIAdd(M);
    N = N.redIAdd(N);
    var R = N.redAdd(N);
    e = A.redSqr().redISub(R), i = this.y.redAdd(this.z).redSqr().redISub(b).redISub(m);
    var O = b.redSqr();
    O = O.redIAdd(O), O = O.redIAdd(O), O = O.redIAdd(O), r = A.redMul(N.redISub(e)).redISub(O);
  }
  return this.curve.jpoint(e, r, i);
};
Ni.prototype._dbl = function() {
  var e = this.curve.a, r = this.x, i = this.y, s = this.z, n = s.redSqr().redSqr(), f = r.redSqr(), u = i.redSqr(), h = f.redAdd(f).redIAdd(f).redIAdd(e.redMul(n)), d = r.redAdd(r);
  d = d.redIAdd(d);
  var l = d.redMul(u), m = h.redSqr().redISub(l.redAdd(l)), b = l.redISub(m), M = u.redSqr();
  M = M.redIAdd(M), M = M.redIAdd(M), M = M.redIAdd(M);
  var A = h.redMul(b).redISub(M), N = i.redAdd(i).redMul(s);
  return this.curve.jpoint(m, A, N);
};
Ni.prototype.trpl = function() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);
  var e = this.x.redSqr(), r = this.y.redSqr(), i = this.z.redSqr(), s = r.redSqr(), n = e.redAdd(e).redIAdd(e), f = n.redSqr(), u = this.x.redAdd(r).redSqr().redISub(e).redISub(s);
  u = u.redIAdd(u), u = u.redAdd(u).redIAdd(u), u = u.redISub(f);
  var h = u.redSqr(), d = s.redIAdd(s);
  d = d.redIAdd(d), d = d.redIAdd(d), d = d.redIAdd(d);
  var l = n.redIAdd(u).redSqr().redISub(f).redISub(h).redISub(d), m = r.redMul(l);
  m = m.redIAdd(m), m = m.redIAdd(m);
  var b = this.x.redMul(h).redISub(m);
  b = b.redIAdd(b), b = b.redIAdd(b);
  var M = this.y.redMul(l.redMul(d.redISub(l)).redISub(u.redMul(h)));
  M = M.redIAdd(M), M = M.redIAdd(M), M = M.redIAdd(M);
  var A = this.z.redAdd(u).redSqr().redISub(i).redISub(h);
  return this.curve.jpoint(b, M, A);
};
Ni.prototype.mul = function(e, r) {
  return e = new Yr(e, r), this.curve._wnafMul(this, e);
};
Ni.prototype.eq = function(e) {
  if (e.type === "affine")
    return this.eq(e.toJ());
  if (this === e)
    return !0;
  var r = this.z.redSqr(), i = e.z.redSqr();
  if (this.x.redMul(i).redISub(e.x.redMul(r)).cmpn(0) !== 0)
    return !1;
  var s = r.redMul(this.z), n = i.redMul(e.z);
  return this.y.redMul(n).redISub(e.y.redMul(s)).cmpn(0) === 0;
};
Ni.prototype.eqXToP = function(e) {
  var r = this.z.redSqr(), i = e.toRed(this.curve.red).redMul(r);
  if (this.x.cmp(i) === 0)
    return !0;
  for (var s = e.clone(), n = this.curve.redN.redMul(r); ; ) {
    if (s.iadd(this.curve.n), s.cmp(this.curve.p) >= 0)
      return !1;
    if (i.redIAdd(n), this.x.cmp(i) === 0)
      return !0;
  }
};
Ni.prototype.inspect = function() {
  return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
Ni.prototype.isInfinity = function() {
  return this.z.cmpn(0) === 0;
};
var sc = Sr.exports, ZA = It.exports, Zp = Qp, One = On;
function ru(t) {
  Zp.call(this, "mont", t), this.a = new sc(t.a, 16).toRed(this.red), this.b = new sc(t.b, 16).toRed(this.red), this.i4 = new sc(4).toRed(this.red).redInvm(), this.two = new sc(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
ZA(ru, Zp);
var Rne = ru;
ru.prototype.validate = function(e) {
  var r = e.normalize().x, i = r.redSqr(), s = i.redMul(r).redAdd(i.redMul(this.a)).redAdd(r), n = s.redSqrt();
  return n.redSqr().cmp(s) === 0;
};
function wi(t, e, r) {
  Zp.BasePoint.call(this, t, "projective"), e === null && r === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new sc(e, 16), this.z = new sc(r, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
}
ZA(wi, Zp.BasePoint);
ru.prototype.decodePoint = function(e, r) {
  return this.point(One.toArray(e, r), 1);
};
ru.prototype.point = function(e, r) {
  return new wi(this, e, r);
};
ru.prototype.pointFromJSON = function(e) {
  return wi.fromJSON(this, e);
};
wi.prototype.precompute = function() {
};
wi.prototype._encode = function() {
  return this.getX().toArray("be", this.curve.p.byteLength());
};
wi.fromJSON = function(e, r) {
  return new wi(e, r[0], r[1] || e.one);
};
wi.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
wi.prototype.isInfinity = function() {
  return this.z.cmpn(0) === 0;
};
wi.prototype.dbl = function() {
  var e = this.x.redAdd(this.z), r = e.redSqr(), i = this.x.redSub(this.z), s = i.redSqr(), n = r.redSub(s), f = r.redMul(s), u = n.redMul(s.redAdd(this.curve.a24.redMul(n)));
  return this.curve.point(f, u);
};
wi.prototype.add = function() {
  throw new Error("Not supported on Montgomery curve");
};
wi.prototype.diffAdd = function(e, r) {
  var i = this.x.redAdd(this.z), s = this.x.redSub(this.z), n = e.x.redAdd(e.z), f = e.x.redSub(e.z), u = f.redMul(i), h = n.redMul(s), d = r.z.redMul(u.redAdd(h).redSqr()), l = r.x.redMul(u.redISub(h).redSqr());
  return this.curve.point(d, l);
};
wi.prototype.mul = function(e) {
  for (var r = e.clone(), i = this, s = this.curve.point(null, null), n = this, f = []; r.cmpn(0) !== 0; r.iushrn(1))
    f.push(r.andln(1));
  for (var u = f.length - 1; u >= 0; u--)
    f[u] === 0 ? (i = i.diffAdd(s, n), s = s.dbl()) : (s = i.diffAdd(s, n), i = i.dbl());
  return s;
};
wi.prototype.mulAdd = function() {
  throw new Error("Not supported on Montgomery curve");
};
wi.prototype.jumlAdd = function() {
  throw new Error("Not supported on Montgomery curve");
};
wi.prototype.eq = function(e) {
  return this.getX().cmp(e.getX()) === 0;
};
wi.prototype.normalize = function() {
  return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
};
wi.prototype.getX = function() {
  return this.normalize(), this.x.fromRed();
};
var Lne = On, Aa = Sr.exports, JA = It.exports, Jp = Qp, Pne = Lne.assert;
function ca(t) {
  this.twisted = (t.a | 0) !== 1, this.mOneA = this.twisted && (t.a | 0) === -1, this.extended = this.mOneA, Jp.call(this, "edwards", t), this.a = new Aa(t.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new Aa(t.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new Aa(t.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), Pne(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (t.c | 0) === 1;
}
JA(ca, Jp);
var kne = ca;
ca.prototype._mulA = function(e) {
  return this.mOneA ? e.redNeg() : this.a.redMul(e);
};
ca.prototype._mulC = function(e) {
  return this.oneC ? e : this.c.redMul(e);
};
ca.prototype.jpoint = function(e, r, i, s) {
  return this.point(e, r, i, s);
};
ca.prototype.pointFromX = function(e, r) {
  e = new Aa(e, 16), e.red || (e = e.toRed(this.red));
  var i = e.redSqr(), s = this.c2.redSub(this.a.redMul(i)), n = this.one.redSub(this.c2.redMul(this.d).redMul(i)), f = s.redMul(n.redInvm()), u = f.redSqrt();
  if (u.redSqr().redSub(f).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var h = u.fromRed().isOdd();
  return (r && !h || !r && h) && (u = u.redNeg()), this.point(e, u);
};
ca.prototype.pointFromY = function(e, r) {
  e = new Aa(e, 16), e.red || (e = e.toRed(this.red));
  var i = e.redSqr(), s = i.redSub(this.c2), n = i.redMul(this.d).redMul(this.c2).redSub(this.a), f = s.redMul(n.redInvm());
  if (f.cmp(this.zero) === 0) {
    if (r)
      throw new Error("invalid point");
    return this.point(this.zero, e);
  }
  var u = f.redSqrt();
  if (u.redSqr().redSub(f).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  return u.fromRed().isOdd() !== r && (u = u.redNeg()), this.point(u, e);
};
ca.prototype.validate = function(e) {
  if (e.isInfinity())
    return !0;
  e.normalize();
  var r = e.x.redSqr(), i = e.y.redSqr(), s = r.redMul(this.a).redAdd(i), n = this.c2.redMul(this.one.redAdd(this.d.redMul(r).redMul(i)));
  return s.cmp(n) === 0;
};
function Lr(t, e, r, i, s) {
  Jp.BasePoint.call(this, t, "projective"), e === null && r === null && i === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new Aa(e, 16), this.y = new Aa(r, 16), this.z = i ? new Aa(i, 16) : this.curve.one, this.t = s && new Aa(s, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
}
JA(Lr, Jp.BasePoint);
ca.prototype.pointFromJSON = function(e) {
  return Lr.fromJSON(this, e);
};
ca.prototype.point = function(e, r, i, s) {
  return new Lr(this, e, r, i, s);
};
Lr.fromJSON = function(e, r) {
  return new Lr(e, r[0], r[1], r[2]);
};
Lr.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Lr.prototype.isInfinity = function() {
  return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
Lr.prototype._extDbl = function() {
  var e = this.x.redSqr(), r = this.y.redSqr(), i = this.z.redSqr();
  i = i.redIAdd(i);
  var s = this.curve._mulA(e), n = this.x.redAdd(this.y).redSqr().redISub(e).redISub(r), f = s.redAdd(r), u = f.redSub(i), h = s.redSub(r), d = n.redMul(u), l = f.redMul(h), m = n.redMul(h), b = u.redMul(f);
  return this.curve.point(d, l, b, m);
};
Lr.prototype._projDbl = function() {
  var e = this.x.redAdd(this.y).redSqr(), r = this.x.redSqr(), i = this.y.redSqr(), s, n, f, u, h, d;
  if (this.curve.twisted) {
    u = this.curve._mulA(r);
    var l = u.redAdd(i);
    this.zOne ? (s = e.redSub(r).redSub(i).redMul(l.redSub(this.curve.two)), n = l.redMul(u.redSub(i)), f = l.redSqr().redSub(l).redSub(l)) : (h = this.z.redSqr(), d = l.redSub(h).redISub(h), s = e.redSub(r).redISub(i).redMul(d), n = l.redMul(u.redSub(i)), f = l.redMul(d));
  } else
    u = r.redAdd(i), h = this.curve._mulC(this.z).redSqr(), d = u.redSub(h).redSub(h), s = this.curve._mulC(e.redISub(u)).redMul(d), n = this.curve._mulC(u).redMul(r.redISub(i)), f = u.redMul(d);
  return this.curve.point(s, n, f);
};
Lr.prototype.dbl = function() {
  return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
};
Lr.prototype._extAdd = function(e) {
  var r = this.y.redSub(this.x).redMul(e.y.redSub(e.x)), i = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)), s = this.t.redMul(this.curve.dd).redMul(e.t), n = this.z.redMul(e.z.redAdd(e.z)), f = i.redSub(r), u = n.redSub(s), h = n.redAdd(s), d = i.redAdd(r), l = f.redMul(u), m = h.redMul(d), b = f.redMul(d), M = u.redMul(h);
  return this.curve.point(l, m, M, b);
};
Lr.prototype._projAdd = function(e) {
  var r = this.z.redMul(e.z), i = r.redSqr(), s = this.x.redMul(e.x), n = this.y.redMul(e.y), f = this.curve.d.redMul(s).redMul(n), u = i.redSub(f), h = i.redAdd(f), d = this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(s).redISub(n), l = r.redMul(u).redMul(d), m, b;
  return this.curve.twisted ? (m = r.redMul(h).redMul(n.redSub(this.curve._mulA(s))), b = u.redMul(h)) : (m = r.redMul(h).redMul(n.redSub(s)), b = this.curve._mulC(u).redMul(h)), this.curve.point(l, m, b);
};
Lr.prototype.add = function(e) {
  return this.isInfinity() ? e : e.isInfinity() ? this : this.curve.extended ? this._extAdd(e) : this._projAdd(e);
};
Lr.prototype.mul = function(e) {
  return this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve._wnafMul(this, e);
};
Lr.prototype.mulAdd = function(e, r, i) {
  return this.curve._wnafMulAdd(1, [this, r], [e, i], 2, !1);
};
Lr.prototype.jmulAdd = function(e, r, i) {
  return this.curve._wnafMulAdd(1, [this, r], [e, i], 2, !0);
};
Lr.prototype.normalize = function() {
  if (this.zOne)
    return this;
  var e = this.z.redInvm();
  return this.x = this.x.redMul(e), this.y = this.y.redMul(e), this.t && (this.t = this.t.redMul(e)), this.z = this.curve.one, this.zOne = !0, this;
};
Lr.prototype.neg = function() {
  return this.curve.point(
    this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg()
  );
};
Lr.prototype.getX = function() {
  return this.normalize(), this.x.fromRed();
};
Lr.prototype.getY = function() {
  return this.normalize(), this.y.fromRed();
};
Lr.prototype.eq = function(e) {
  return this === e || this.getX().cmp(e.getX()) === 0 && this.getY().cmp(e.getY()) === 0;
};
Lr.prototype.eqXToP = function(e) {
  var r = e.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(r) === 0)
    return !0;
  for (var i = e.clone(), s = this.curve.redN.redMul(this.z); ; ) {
    if (i.iadd(this.curve.n), i.cmp(this.curve.p) >= 0)
      return !1;
    if (r.redIAdd(s), this.x.cmp(r) === 0)
      return !0;
  }
};
Lr.prototype.toP = Lr.prototype.normalize;
Lr.prototype.mixedAdd = Lr.prototype.add;
(function(t) {
  var e = t;
  e.base = Qp, e.short = Cne, e.mont = Rne, e.edwards = kne;
})(Ew);
var Xp = {}, Dy, k8;
function jne() {
  return k8 || (k8 = 1, Dy = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), Dy;
}
(function(t) {
  var e = t, r = Ki, i = Ew, s = On, n = s.assert;
  function f(d) {
    d.type === "short" ? this.curve = new i.short(d) : d.type === "edwards" ? this.curve = new i.edwards(d) : this.curve = new i.mont(d), this.g = this.curve.g, this.n = this.curve.n, this.hash = d.hash, n(this.g.validate(), "Invalid curve"), n(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }
  e.PresetCurve = f;
  function u(d, l) {
    Object.defineProperty(e, d, {
      configurable: !0,
      enumerable: !0,
      get: function() {
        var m = new f(l);
        return Object.defineProperty(e, d, {
          configurable: !0,
          enumerable: !0,
          value: m
        }), m;
      }
    });
  }
  u("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: r.sha256,
    gRed: !1,
    g: [
      "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
      "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
  }), u("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: r.sha256,
    gRed: !1,
    g: [
      "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
      "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
  }), u("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: r.sha256,
    gRed: !1,
    g: [
      "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
      "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
  }), u("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: r.sha384,
    gRed: !1,
    g: [
      "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
      "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
  }), u("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: r.sha512,
    gRed: !1,
    g: [
      "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
      "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
  }), u("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: r.sha256,
    gRed: !1,
    g: [
      "9"
    ]
  }), u("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: r.sha256,
    gRed: !1,
    g: [
      "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
      "6666666666666666666666666666666666666666666666666666666666666658"
    ]
  });
  var h;
  try {
    h = jne();
  } catch {
    h = void 0;
  }
  u("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: r.sha256,
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
      {
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      },
      {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }
    ],
    gRed: !1,
    g: [
      "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
      "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
      h
    ]
  });
})(Xp);
var Bne = Sr.exports, zne = On, Lm = zne.assert;
function Bi(t, e) {
  this.ec = t, this.priv = null, this.pub = null, e.priv && this._importPrivate(e.priv, e.privEnc), e.pub && this._importPublic(e.pub, e.pubEnc);
}
var Une = Bi;
Bi.fromPublic = function(e, r, i) {
  return r instanceof Bi ? r : new Bi(e, {
    pub: r,
    pubEnc: i
  });
};
Bi.fromPrivate = function(e, r, i) {
  return r instanceof Bi ? r : new Bi(e, {
    priv: r,
    privEnc: i
  });
};
Bi.prototype.validate = function() {
  var e = this.getPublic();
  return e.isInfinity() ? { result: !1, reason: "Invalid public key" } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
};
Bi.prototype.getPublic = function(e, r) {
  return typeof e == "string" && (r = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), r ? this.pub.encode(r, e) : this.pub;
};
Bi.prototype.getPrivate = function(e) {
  return e === "hex" ? this.priv.toString(16, 2) : this.priv;
};
Bi.prototype._importPrivate = function(e, r) {
  this.priv = new Bne(e, r || 16), this.priv = this.priv.umod(this.ec.curve.n);
};
Bi.prototype._importPublic = function(e, r) {
  if (e.x || e.y) {
    this.ec.curve.type === "mont" ? Lm(e.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && Lm(e.x && e.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(e.x, e.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(e, r);
};
Bi.prototype.derive = function(e) {
  return e.validate() || Lm(e.validate(), "public point not validated"), e.mul(this.priv).getX();
};
Bi.prototype.sign = function(e, r, i) {
  return this.ec.sign(e, this, r, i);
};
Bi.prototype.verify = function(e, r) {
  return this.ec.verify(e, r, this);
};
Bi.prototype.inspect = function() {
  return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var P0 = Sr.exports, Aw = On, Fne = Aw.assert;
function e1(t, e) {
  if (t instanceof e1)
    return t;
  this._importDER(t, e) || (Fne(t.r && t.s, "Signature without r or s"), this.r = new P0(t.r, 16), this.s = new P0(t.s, 16), t.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = t.recoveryParam);
}
var $ne = e1;
function qne() {
  this.place = 0;
}
function Cy(t, e) {
  var r = t[e.place++];
  if (!(r & 128))
    return r;
  var i = r & 15;
  if (i === 0 || i > 4 || t[e.place] === 0)
    return !1;
  for (var s = 0, n = 0, f = e.place; n < i; n++, f++)
    s <<= 8, s |= t[f], s >>>= 0;
  return s <= 127 ? !1 : (e.place = f, s);
}
function j8(t) {
  for (var e = 0, r = t.length - 1; !t[e] && !(t[e + 1] & 128) && e < r; )
    e++;
  return e === 0 ? t : t.slice(e);
}
e1.prototype._importDER = function(e, r) {
  e = Aw.toArray(e, r);
  var i = new qne();
  if (e[i.place++] !== 48)
    return !1;
  var s = Cy(e, i);
  if (s === !1 || s + i.place !== e.length || e[i.place++] !== 2)
    return !1;
  var n = Cy(e, i);
  if (n === !1 || (e[i.place] & 128) !== 0)
    return !1;
  var f = e.slice(i.place, n + i.place);
  if (i.place += n, e[i.place++] !== 2)
    return !1;
  var u = Cy(e, i);
  if (u === !1 || e.length !== u + i.place || (e[i.place] & 128) !== 0)
    return !1;
  var h = e.slice(i.place, u + i.place);
  if (f[0] === 0)
    if (f[1] & 128)
      f = f.slice(1);
    else
      return !1;
  if (h[0] === 0)
    if (h[1] & 128)
      h = h.slice(1);
    else
      return !1;
  return this.r = new P0(f), this.s = new P0(h), this.recoveryParam = null, !0;
};
function Oy(t, e) {
  if (e < 128) {
    t.push(e);
    return;
  }
  var r = 1 + (Math.log(e) / Math.LN2 >>> 3);
  for (t.push(r | 128); --r; )
    t.push(e >>> (r << 3) & 255);
  t.push(e);
}
e1.prototype.toDER = function(e) {
  var r = this.r.toArray(), i = this.s.toArray();
  for (r[0] & 128 && (r = [0].concat(r)), i[0] & 128 && (i = [0].concat(i)), r = j8(r), i = j8(i); !i[0] && !(i[1] & 128); )
    i = i.slice(1);
  var s = [2];
  Oy(s, r.length), s = s.concat(r), s.push(2), Oy(s, i.length);
  var n = s.concat(i), f = [48];
  return Oy(f, n.length), f = f.concat(n), Aw.encode(f, e);
};
var rf = Sr.exports, XA = IA, Hne = On, Ry = Xp, Wne = el(), eT = Hne.assert, Tw = Une, t1 = $ne;
function is(t) {
  if (!(this instanceof is))
    return new is(t);
  typeof t == "string" && (eT(
    Object.prototype.hasOwnProperty.call(Ry, t),
    "Unknown curve " + t
  ), t = Ry[t]), t instanceof Ry.PresetCurve && (t = { curve: t }), this.curve = t.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = t.curve.g, this.g.precompute(t.curve.n.bitLength() + 1), this.hash = t.hash || t.curve.hash;
}
var Vne = is;
is.prototype.keyPair = function(e) {
  return new Tw(this, e);
};
is.prototype.keyFromPrivate = function(e, r) {
  return Tw.fromPrivate(this, e, r);
};
is.prototype.keyFromPublic = function(e, r) {
  return Tw.fromPublic(this, e, r);
};
is.prototype.genKeyPair = function(e) {
  e || (e = {});
  for (var r = new XA({
    hash: this.hash,
    pers: e.pers,
    persEnc: e.persEnc || "utf8",
    entropy: e.entropy || Wne(this.hash.hmacStrength),
    entropyEnc: e.entropy && e.entropyEnc || "utf8",
    nonce: this.n.toArray()
  }), i = this.n.byteLength(), s = this.n.sub(new rf(2)); ; ) {
    var n = new rf(r.generate(i));
    if (!(n.cmp(s) > 0))
      return n.iaddn(1), this.keyFromPrivate(n);
  }
};
is.prototype._truncateToN = function(e, r) {
  var i = e.byteLength() * 8 - this.n.bitLength();
  return i > 0 && (e = e.ushrn(i)), !r && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
};
is.prototype.sign = function(e, r, i, s) {
  typeof i == "object" && (s = i, i = null), s || (s = {}), r = this.keyFromPrivate(r, i), e = this._truncateToN(new rf(e, 16));
  for (var n = this.n.byteLength(), f = r.getPrivate().toArray("be", n), u = e.toArray("be", n), h = new XA({
    hash: this.hash,
    entropy: f,
    nonce: u,
    pers: s.pers,
    persEnc: s.persEnc || "utf8"
  }), d = this.n.sub(new rf(1)), l = 0; ; l++) {
    var m = s.k ? s.k(l) : new rf(h.generate(this.n.byteLength()));
    if (m = this._truncateToN(m, !0), !(m.cmpn(1) <= 0 || m.cmp(d) >= 0)) {
      var b = this.g.mul(m);
      if (!b.isInfinity()) {
        var M = b.getX(), A = M.umod(this.n);
        if (A.cmpn(0) !== 0) {
          var N = m.invm(this.n).mul(A.mul(r.getPrivate()).iadd(e));
          if (N = N.umod(this.n), N.cmpn(0) !== 0) {
            var R = (b.getY().isOdd() ? 1 : 0) | (M.cmp(A) !== 0 ? 2 : 0);
            return s.canonical && N.cmp(this.nh) > 0 && (N = this.n.sub(N), R ^= 1), new t1({ r: A, s: N, recoveryParam: R });
          }
        }
      }
    }
  }
};
is.prototype.verify = function(e, r, i, s) {
  e = this._truncateToN(new rf(e, 16)), i = this.keyFromPublic(i, s), r = new t1(r, "hex");
  var n = r.r, f = r.s;
  if (n.cmpn(1) < 0 || n.cmp(this.n) >= 0 || f.cmpn(1) < 0 || f.cmp(this.n) >= 0)
    return !1;
  var u = f.invm(this.n), h = u.mul(e).umod(this.n), d = u.mul(n).umod(this.n), l;
  return this.curve._maxwellTrick ? (l = this.g.jmulAdd(h, i.getPublic(), d), l.isInfinity() ? !1 : l.eqXToP(n)) : (l = this.g.mulAdd(h, i.getPublic(), d), l.isInfinity() ? !1 : l.getX().umod(this.n).cmp(n) === 0);
};
is.prototype.recoverPubKey = function(t, e, r, i) {
  eT((3 & r) === r, "The recovery param is more than two bits"), e = new t1(e, i);
  var s = this.n, n = new rf(t), f = e.r, u = e.s, h = r & 1, d = r >> 1;
  if (f.cmp(this.curve.p.umod(this.curve.n)) >= 0 && d)
    throw new Error("Unable to find sencond key candinate");
  d ? f = this.curve.pointFromX(f.add(this.curve.n), h) : f = this.curve.pointFromX(f, h);
  var l = e.r.invm(s), m = s.sub(n).mul(l).umod(s), b = u.mul(l).umod(s);
  return this.g.mulAdd(m, f, b);
};
is.prototype.getKeyRecoveryParam = function(t, e, r, i) {
  if (e = new t1(e, i), e.recoveryParam !== null)
    return e.recoveryParam;
  for (var s = 0; s < 4; s++) {
    var n;
    try {
      n = this.recoverPubKey(t, e, s);
    } catch {
      continue;
    }
    if (n.eq(r))
      return s;
  }
  throw new Error("Unable to find valid recovery factor");
};
var nl = On, tT = nl.assert, B8 = nl.parseBytes, iu = nl.cachedProperty;
function yi(t, e) {
  this.eddsa = t, this._secret = B8(e.secret), t.isPoint(e.pub) ? this._pub = e.pub : this._pubBytes = B8(e.pub);
}
yi.fromPublic = function(e, r) {
  return r instanceof yi ? r : new yi(e, { pub: r });
};
yi.fromSecret = function(e, r) {
  return r instanceof yi ? r : new yi(e, { secret: r });
};
yi.prototype.secret = function() {
  return this._secret;
};
iu(yi, "pubBytes", function() {
  return this.eddsa.encodePoint(this.pub());
});
iu(yi, "pub", function() {
  return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
});
iu(yi, "privBytes", function() {
  var e = this.eddsa, r = this.hash(), i = e.encodingLength - 1, s = r.slice(0, e.encodingLength);
  return s[0] &= 248, s[i] &= 127, s[i] |= 64, s;
});
iu(yi, "priv", function() {
  return this.eddsa.decodeInt(this.privBytes());
});
iu(yi, "hash", function() {
  return this.eddsa.hash().update(this.secret()).digest();
});
iu(yi, "messagePrefix", function() {
  return this.hash().slice(this.eddsa.encodingLength);
});
yi.prototype.sign = function(e) {
  return tT(this._secret, "KeyPair can only verify"), this.eddsa.sign(e, this);
};
yi.prototype.verify = function(e, r) {
  return this.eddsa.verify(e, r, this);
};
yi.prototype.getSecret = function(e) {
  return tT(this._secret, "KeyPair is public only"), nl.encode(this.secret(), e);
};
yi.prototype.getPublic = function(e) {
  return nl.encode(this.pubBytes(), e);
};
var Gne = yi, Kne = Sr.exports, r1 = On, z8 = r1.assert, i1 = r1.cachedProperty, Yne = r1.parseBytes;
function _f(t, e) {
  this.eddsa = t, typeof e != "object" && (e = Yne(e)), Array.isArray(e) && (z8(e.length === t.encodingLength * 2, "Signature has invalid size"), e = {
    R: e.slice(0, t.encodingLength),
    S: e.slice(t.encodingLength)
  }), z8(e.R && e.S, "Signature without R or S"), t.isPoint(e.R) && (this._R = e.R), e.S instanceof Kne && (this._S = e.S), this._Rencoded = Array.isArray(e.R) ? e.R : e.Rencoded, this._Sencoded = Array.isArray(e.S) ? e.S : e.Sencoded;
}
i1(_f, "S", function() {
  return this.eddsa.decodeInt(this.Sencoded());
});
i1(_f, "R", function() {
  return this.eddsa.decodePoint(this.Rencoded());
});
i1(_f, "Rencoded", function() {
  return this.eddsa.encodePoint(this.R());
});
i1(_f, "Sencoded", function() {
  return this.eddsa.encodeInt(this.S());
});
_f.prototype.toBytes = function() {
  return this.Rencoded().concat(this.Sencoded());
};
_f.prototype.toHex = function() {
  return r1.encode(this.toBytes(), "hex").toUpperCase();
};
var Qne = _f, Zne = Ki, Jne = Xp, Pc = On, Xne = Pc.assert, rT = Pc.parseBytes, iT = Gne, U8 = Qne;
function ln(t) {
  if (Xne(t === "ed25519", "only tested with ed25519 so far"), !(this instanceof ln))
    return new ln(t);
  t = Jne[t].curve, this.curve = t, this.g = t.g, this.g.precompute(t.n.bitLength() + 1), this.pointClass = t.point().constructor, this.encodingLength = Math.ceil(t.n.bitLength() / 8), this.hash = Zne.sha512;
}
var ese = ln;
ln.prototype.sign = function(e, r) {
  e = rT(e);
  var i = this.keyFromSecret(r), s = this.hashInt(i.messagePrefix(), e), n = this.g.mul(s), f = this.encodePoint(n), u = this.hashInt(f, i.pubBytes(), e).mul(i.priv()), h = s.add(u).umod(this.curve.n);
  return this.makeSignature({ R: n, S: h, Rencoded: f });
};
ln.prototype.verify = function(e, r, i) {
  if (e = rT(e), r = this.makeSignature(r), r.S().gte(r.eddsa.curve.n) || r.S().isNeg())
    return !1;
  var s = this.keyFromPublic(i), n = this.hashInt(r.Rencoded(), s.pubBytes(), e), f = this.g.mul(r.S()), u = r.R().add(s.pub().mul(n));
  return u.eq(f);
};
ln.prototype.hashInt = function() {
  for (var e = this.hash(), r = 0; r < arguments.length; r++)
    e.update(arguments[r]);
  return Pc.intFromLE(e.digest()).umod(this.curve.n);
};
ln.prototype.keyFromPublic = function(e) {
  return iT.fromPublic(this, e);
};
ln.prototype.keyFromSecret = function(e) {
  return iT.fromSecret(this, e);
};
ln.prototype.makeSignature = function(e) {
  return e instanceof U8 ? e : new U8(this, e);
};
ln.prototype.encodePoint = function(e) {
  var r = e.getY().toArray("le", this.encodingLength);
  return r[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0, r;
};
ln.prototype.decodePoint = function(e) {
  e = Pc.parseBytes(e);
  var r = e.length - 1, i = e.slice(0, r).concat(e[r] & -129), s = (e[r] & 128) !== 0, n = Pc.intFromLE(i);
  return this.curve.pointFromY(n, s);
};
ln.prototype.encodeInt = function(e) {
  return e.toArray("le", this.encodingLength);
};
ln.prototype.decodeInt = function(e) {
  return Pc.intFromLE(e);
};
ln.prototype.isPoint = function(e) {
  return e instanceof this.pointClass;
};
(function(t) {
  var e = t;
  e.version = Ane.version, e.utils = On, e.rand = el(), e.curve = Ew, e.curves = Xp, e.ec = Vne, e.eddsa = ese;
})(QA);
var Nw = {}, nT = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = Bt, r = Cn;
  t.DIGEST_LENGTH = 64, t.BLOCK_SIZE = 128;
  var i = function() {
    function u() {
      this.digestLength = t.DIGEST_LENGTH, this.blockSize = t.BLOCK_SIZE, this._stateHi = new Int32Array(8), this._stateLo = new Int32Array(8), this._tempHi = new Int32Array(16), this._tempLo = new Int32Array(16), this._buffer = new Uint8Array(256), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this.reset();
    }
    return u.prototype._initState = function() {
      this._stateHi[0] = 1779033703, this._stateHi[1] = 3144134277, this._stateHi[2] = 1013904242, this._stateHi[3] = 2773480762, this._stateHi[4] = 1359893119, this._stateHi[5] = 2600822924, this._stateHi[6] = 528734635, this._stateHi[7] = 1541459225, this._stateLo[0] = 4089235720, this._stateLo[1] = 2227873595, this._stateLo[2] = 4271175723, this._stateLo[3] = 1595750129, this._stateLo[4] = 2917565137, this._stateLo[5] = 725511199, this._stateLo[6] = 4215389547, this._stateLo[7] = 327033209;
    }, u.prototype.reset = function() {
      return this._initState(), this._bufferLength = 0, this._bytesHashed = 0, this._finished = !1, this;
    }, u.prototype.clean = function() {
      r.wipe(this._buffer), r.wipe(this._tempHi), r.wipe(this._tempLo), this.reset();
    }, u.prototype.update = function(h, d) {
      if (d === void 0 && (d = h.length), this._finished)
        throw new Error("SHA512: can't update because hash was finished.");
      var l = 0;
      if (this._bytesHashed += d, this._bufferLength > 0) {
        for (; this._bufferLength < t.BLOCK_SIZE && d > 0; )
          this._buffer[this._bufferLength++] = h[l++], d--;
        this._bufferLength === this.blockSize && (n(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize), this._bufferLength = 0);
      }
      for (d >= this.blockSize && (l = n(this._tempHi, this._tempLo, this._stateHi, this._stateLo, h, l, d), d %= this.blockSize); d > 0; )
        this._buffer[this._bufferLength++] = h[l++], d--;
      return this;
    }, u.prototype.finish = function(h) {
      if (!this._finished) {
        var d = this._bytesHashed, l = this._bufferLength, m = d / 536870912 | 0, b = d << 3, M = d % 128 < 112 ? 128 : 256;
        this._buffer[l] = 128;
        for (var A = l + 1; A < M - 8; A++)
          this._buffer[A] = 0;
        e.writeUint32BE(m, this._buffer, M - 8), e.writeUint32BE(b, this._buffer, M - 4), n(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, M), this._finished = !0;
      }
      for (var A = 0; A < this.digestLength / 8; A++)
        e.writeUint32BE(this._stateHi[A], h, A * 8), e.writeUint32BE(this._stateLo[A], h, A * 8 + 4);
      return this;
    }, u.prototype.digest = function() {
      var h = new Uint8Array(this.digestLength);
      return this.finish(h), h;
    }, u.prototype.saveState = function() {
      if (this._finished)
        throw new Error("SHA256: cannot save finished state");
      return {
        stateHi: new Int32Array(this._stateHi),
        stateLo: new Int32Array(this._stateLo),
        buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : void 0,
        bufferLength: this._bufferLength,
        bytesHashed: this._bytesHashed
      };
    }, u.prototype.restoreState = function(h) {
      return this._stateHi.set(h.stateHi), this._stateLo.set(h.stateLo), this._bufferLength = h.bufferLength, h.buffer && this._buffer.set(h.buffer), this._bytesHashed = h.bytesHashed, this._finished = !1, this;
    }, u.prototype.cleanSavedState = function(h) {
      r.wipe(h.stateHi), r.wipe(h.stateLo), h.buffer && r.wipe(h.buffer), h.bufferLength = 0, h.bytesHashed = 0;
    }, u;
  }();
  t.SHA512 = i;
  var s = new Int32Array([
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ]);
  function n(u, h, d, l, m, b, M) {
    for (var A = d[0], N = d[1], R = d[2], O = d[3], P = d[4], F = d[5], H = d[6], Q = d[7], Z = l[0], B = l[1], Y = l[2], ae = l[3], se = l[4], W = l[5], C = l[6], g = l[7], a, c, p, w, _, x, E, y; M >= 128; ) {
      for (var o = 0; o < 16; o++) {
        var S = 8 * o + b;
        u[o] = e.readUint32BE(m, S), h[o] = e.readUint32BE(m, S + 4);
      }
      for (var o = 0; o < 80; o++) {
        var J = A, z = N, k = R, j = O, q = P, K = F, U = H, T = Q, D = Z, te = B, ne = Y, le = ae, X = se, $ = W, V = C, re = g;
        if (a = Q, c = g, _ = c & 65535, x = c >>> 16, E = a & 65535, y = a >>> 16, a = (P >>> 14 | se << 32 - 14) ^ (P >>> 18 | se << 32 - 18) ^ (se >>> 41 - 32 | P << 32 - (41 - 32)), c = (se >>> 14 | P << 32 - 14) ^ (se >>> 18 | P << 32 - 18) ^ (P >>> 41 - 32 | se << 32 - (41 - 32)), _ += c & 65535, x += c >>> 16, E += a & 65535, y += a >>> 16, a = P & F ^ ~P & H, c = se & W ^ ~se & C, _ += c & 65535, x += c >>> 16, E += a & 65535, y += a >>> 16, a = s[o * 2], c = s[o * 2 + 1], _ += c & 65535, x += c >>> 16, E += a & 65535, y += a >>> 16, a = u[o % 16], c = h[o % 16], _ += c & 65535, x += c >>> 16, E += a & 65535, y += a >>> 16, x += _ >>> 16, E += x >>> 16, y += E >>> 16, p = E & 65535 | y << 16, w = _ & 65535 | x << 16, a = p, c = w, _ = c & 65535, x = c >>> 16, E = a & 65535, y = a >>> 16, a = (A >>> 28 | Z << 32 - 28) ^ (Z >>> 34 - 32 | A << 32 - (34 - 32)) ^ (Z >>> 39 - 32 | A << 32 - (39 - 32)), c = (Z >>> 28 | A << 32 - 28) ^ (A >>> 34 - 32 | Z << 32 - (34 - 32)) ^ (A >>> 39 - 32 | Z << 32 - (39 - 32)), _ += c & 65535, x += c >>> 16, E += a & 65535, y += a >>> 16, a = A & N ^ A & R ^ N & R, c = Z & B ^ Z & Y ^ B & Y, _ += c & 65535, x += c >>> 16, E += a & 65535, y += a >>> 16, x += _ >>> 16, E += x >>> 16, y += E >>> 16, T = E & 65535 | y << 16, re = _ & 65535 | x << 16, a = j, c = le, _ = c & 65535, x = c >>> 16, E = a & 65535, y = a >>> 16, a = p, c = w, _ += c & 65535, x += c >>> 16, E += a & 65535, y += a >>> 16, x += _ >>> 16, E += x >>> 16, y += E >>> 16, j = E & 65535 | y << 16, le = _ & 65535 | x << 16, N = J, R = z, O = k, P = j, F = q, H = K, Q = U, A = T, B = D, Y = te, ae = ne, se = le, W = X, C = $, g = V, Z = re, o % 16 === 15)
          for (var S = 0; S < 16; S++)
            a = u[S], c = h[S], _ = c & 65535, x = c >>> 16, E = a & 65535, y = a >>> 16, a = u[(S + 9) % 16], c = h[(S + 9) % 16], _ += c & 65535, x += c >>> 16, E += a & 65535, y += a >>> 16, p = u[(S + 1) % 16], w = h[(S + 1) % 16], a = (p >>> 1 | w << 32 - 1) ^ (p >>> 8 | w << 32 - 8) ^ p >>> 7, c = (w >>> 1 | p << 32 - 1) ^ (w >>> 8 | p << 32 - 8) ^ (w >>> 7 | p << 32 - 7), _ += c & 65535, x += c >>> 16, E += a & 65535, y += a >>> 16, p = u[(S + 14) % 16], w = h[(S + 14) % 16], a = (p >>> 19 | w << 32 - 19) ^ (w >>> 61 - 32 | p << 32 - (61 - 32)) ^ p >>> 6, c = (w >>> 19 | p << 32 - 19) ^ (p >>> 61 - 32 | w << 32 - (61 - 32)) ^ (w >>> 6 | p << 32 - 6), _ += c & 65535, x += c >>> 16, E += a & 65535, y += a >>> 16, x += _ >>> 16, E += x >>> 16, y += E >>> 16, u[S] = E & 65535 | y << 16, h[S] = _ & 65535 | x << 16;
      }
      a = A, c = Z, _ = c & 65535, x = c >>> 16, E = a & 65535, y = a >>> 16, a = d[0], c = l[0], _ += c & 65535, x += c >>> 16, E += a & 65535, y += a >>> 16, x += _ >>> 16, E += x >>> 16, y += E >>> 16, d[0] = A = E & 65535 | y << 16, l[0] = Z = _ & 65535 | x << 16, a = N, c = B, _ = c & 65535, x = c >>> 16, E = a & 65535, y = a >>> 16, a = d[1], c = l[1], _ += c & 65535, x += c >>> 16, E += a & 65535, y += a >>> 16, x += _ >>> 16, E += x >>> 16, y += E >>> 16, d[1] = N = E & 65535 | y << 16, l[1] = B = _ & 65535 | x << 16, a = R, c = Y, _ = c & 65535, x = c >>> 16, E = a & 65535, y = a >>> 16, a = d[2], c = l[2], _ += c & 65535, x += c >>> 16, E += a & 65535, y += a >>> 16, x += _ >>> 16, E += x >>> 16, y += E >>> 16, d[2] = R = E & 65535 | y << 16, l[2] = Y = _ & 65535 | x << 16, a = O, c = ae, _ = c & 65535, x = c >>> 16, E = a & 65535, y = a >>> 16, a = d[3], c = l[3], _ += c & 65535, x += c >>> 16, E += a & 65535, y += a >>> 16, x += _ >>> 16, E += x >>> 16, y += E >>> 16, d[3] = O = E & 65535 | y << 16, l[3] = ae = _ & 65535 | x << 16, a = P, c = se, _ = c & 65535, x = c >>> 16, E = a & 65535, y = a >>> 16, a = d[4], c = l[4], _ += c & 65535, x += c >>> 16, E += a & 65535, y += a >>> 16, x += _ >>> 16, E += x >>> 16, y += E >>> 16, d[4] = P = E & 65535 | y << 16, l[4] = se = _ & 65535 | x << 16, a = F, c = W, _ = c & 65535, x = c >>> 16, E = a & 65535, y = a >>> 16, a = d[5], c = l[5], _ += c & 65535, x += c >>> 16, E += a & 65535, y += a >>> 16, x += _ >>> 16, E += x >>> 16, y += E >>> 16, d[5] = F = E & 65535 | y << 16, l[5] = W = _ & 65535 | x << 16, a = H, c = C, _ = c & 65535, x = c >>> 16, E = a & 65535, y = a >>> 16, a = d[6], c = l[6], _ += c & 65535, x += c >>> 16, E += a & 65535, y += a >>> 16, x += _ >>> 16, E += x >>> 16, y += E >>> 16, d[6] = H = E & 65535 | y << 16, l[6] = C = _ & 65535 | x << 16, a = Q, c = g, _ = c & 65535, x = c >>> 16, E = a & 65535, y = a >>> 16, a = d[7], c = l[7], _ += c & 65535, x += c >>> 16, E += a & 65535, y += a >>> 16, x += _ >>> 16, E += x >>> 16, y += E >>> 16, d[7] = Q = E & 65535 | y << 16, l[7] = g = _ & 65535 | x << 16, b += 128, M -= 128;
    }
    return b;
  }
  function f(u) {
    var h = new i();
    h.update(u);
    var d = h.digest();
    return h.clean(), d;
  }
  t.hash = f;
})(nT);
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.convertSecretKeyToX25519 = t.convertPublicKeyToX25519 = t.verify = t.sign = t.extractPublicKeyFromSecretKey = t.generateKeyPair = t.generateKeyPairFromSeed = t.SEED_LENGTH = t.SECRET_KEY_LENGTH = t.PUBLIC_KEY_LENGTH = t.SIGNATURE_LENGTH = void 0;
  const e = yo, r = nT, i = Cn;
  t.SIGNATURE_LENGTH = 64, t.PUBLIC_KEY_LENGTH = 32, t.SECRET_KEY_LENGTH = 64, t.SEED_LENGTH = 32;
  function s(j) {
    const q = new Float64Array(16);
    if (j)
      for (let K = 0; K < j.length; K++)
        q[K] = j[K];
    return q;
  }
  const n = new Uint8Array(32);
  n[0] = 9;
  const f = s(), u = s([1]), h = s([
    30883,
    4953,
    19914,
    30187,
    55467,
    16705,
    2637,
    112,
    59544,
    30585,
    16505,
    36039,
    65139,
    11119,
    27886,
    20995
  ]), d = s([
    61785,
    9906,
    39828,
    60374,
    45398,
    33411,
    5274,
    224,
    53552,
    61171,
    33010,
    6542,
    64743,
    22239,
    55772,
    9222
  ]), l = s([
    54554,
    36645,
    11616,
    51542,
    42930,
    38181,
    51040,
    26924,
    56412,
    64982,
    57905,
    49316,
    21502,
    52590,
    14035,
    8553
  ]), m = s([
    26200,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214,
    26214
  ]), b = s([
    41136,
    18958,
    6951,
    50414,
    58488,
    44335,
    6150,
    12099,
    55207,
    15867,
    153,
    11085,
    57099,
    20417,
    9344,
    11139
  ]);
  function M(j, q) {
    for (let K = 0; K < 16; K++)
      j[K] = q[K] | 0;
  }
  function A(j) {
    let q = 1;
    for (let K = 0; K < 16; K++) {
      let U = j[K] + q + 65535;
      q = Math.floor(U / 65536), j[K] = U - q * 65536;
    }
    j[0] += q - 1 + 37 * (q - 1);
  }
  function N(j, q, K) {
    const U = ~(K - 1);
    for (let T = 0; T < 16; T++) {
      const D = U & (j[T] ^ q[T]);
      j[T] ^= D, q[T] ^= D;
    }
  }
  function R(j, q) {
    const K = s(), U = s();
    for (let T = 0; T < 16; T++)
      U[T] = q[T];
    A(U), A(U), A(U);
    for (let T = 0; T < 2; T++) {
      K[0] = U[0] - 65517;
      for (let te = 1; te < 15; te++)
        K[te] = U[te] - 65535 - (K[te - 1] >> 16 & 1), K[te - 1] &= 65535;
      K[15] = U[15] - 32767 - (K[14] >> 16 & 1);
      const D = K[15] >> 16 & 1;
      K[14] &= 65535, N(U, K, 1 - D);
    }
    for (let T = 0; T < 16; T++)
      j[2 * T] = U[T] & 255, j[2 * T + 1] = U[T] >> 8;
  }
  function O(j, q) {
    let K = 0;
    for (let U = 0; U < 32; U++)
      K |= j[U] ^ q[U];
    return (1 & K - 1 >>> 8) - 1;
  }
  function P(j, q) {
    const K = new Uint8Array(32), U = new Uint8Array(32);
    return R(K, j), R(U, q), O(K, U);
  }
  function F(j) {
    const q = new Uint8Array(32);
    return R(q, j), q[0] & 1;
  }
  function H(j, q) {
    for (let K = 0; K < 16; K++)
      j[K] = q[2 * K] + (q[2 * K + 1] << 8);
    j[15] &= 32767;
  }
  function Q(j, q, K) {
    for (let U = 0; U < 16; U++)
      j[U] = q[U] + K[U];
  }
  function Z(j, q, K) {
    for (let U = 0; U < 16; U++)
      j[U] = q[U] - K[U];
  }
  function B(j, q, K) {
    let U, T, D = 0, te = 0, ne = 0, le = 0, X = 0, $ = 0, V = 0, re = 0, fe = 0, ue = 0, me = 0, be = 0, ve = 0, Ge = 0, ye = 0, pe = 0, Je = 0, Ie = 0, we = 0, at = 0, Oe = 0, Ee = 0, ft = 0, Le = 0, Pe = 0, Mt = 0, Ve = 0, ke = 0, Et = 0, Ke = 0, Be = 0, dt = K[0], ze = K[1], Te = K[2], pt = K[3], Fe = K[4], Ae = K[5], bt = K[6], He = K[7], Ne = K[8], yt = K[9], $e = K[10], De = K[11], vt = K[12], je = K[13], Ce = K[14], mt = K[15];
    U = q[0], D += U * dt, te += U * ze, ne += U * Te, le += U * pt, X += U * Fe, $ += U * Ae, V += U * bt, re += U * He, fe += U * Ne, ue += U * yt, me += U * $e, be += U * De, ve += U * vt, Ge += U * je, ye += U * Ce, pe += U * mt, U = q[1], te += U * dt, ne += U * ze, le += U * Te, X += U * pt, $ += U * Fe, V += U * Ae, re += U * bt, fe += U * He, ue += U * Ne, me += U * yt, be += U * $e, ve += U * De, Ge += U * vt, ye += U * je, pe += U * Ce, Je += U * mt, U = q[2], ne += U * dt, le += U * ze, X += U * Te, $ += U * pt, V += U * Fe, re += U * Ae, fe += U * bt, ue += U * He, me += U * Ne, be += U * yt, ve += U * $e, Ge += U * De, ye += U * vt, pe += U * je, Je += U * Ce, Ie += U * mt, U = q[3], le += U * dt, X += U * ze, $ += U * Te, V += U * pt, re += U * Fe, fe += U * Ae, ue += U * bt, me += U * He, be += U * Ne, ve += U * yt, Ge += U * $e, ye += U * De, pe += U * vt, Je += U * je, Ie += U * Ce, we += U * mt, U = q[4], X += U * dt, $ += U * ze, V += U * Te, re += U * pt, fe += U * Fe, ue += U * Ae, me += U * bt, be += U * He, ve += U * Ne, Ge += U * yt, ye += U * $e, pe += U * De, Je += U * vt, Ie += U * je, we += U * Ce, at += U * mt, U = q[5], $ += U * dt, V += U * ze, re += U * Te, fe += U * pt, ue += U * Fe, me += U * Ae, be += U * bt, ve += U * He, Ge += U * Ne, ye += U * yt, pe += U * $e, Je += U * De, Ie += U * vt, we += U * je, at += U * Ce, Oe += U * mt, U = q[6], V += U * dt, re += U * ze, fe += U * Te, ue += U * pt, me += U * Fe, be += U * Ae, ve += U * bt, Ge += U * He, ye += U * Ne, pe += U * yt, Je += U * $e, Ie += U * De, we += U * vt, at += U * je, Oe += U * Ce, Ee += U * mt, U = q[7], re += U * dt, fe += U * ze, ue += U * Te, me += U * pt, be += U * Fe, ve += U * Ae, Ge += U * bt, ye += U * He, pe += U * Ne, Je += U * yt, Ie += U * $e, we += U * De, at += U * vt, Oe += U * je, Ee += U * Ce, ft += U * mt, U = q[8], fe += U * dt, ue += U * ze, me += U * Te, be += U * pt, ve += U * Fe, Ge += U * Ae, ye += U * bt, pe += U * He, Je += U * Ne, Ie += U * yt, we += U * $e, at += U * De, Oe += U * vt, Ee += U * je, ft += U * Ce, Le += U * mt, U = q[9], ue += U * dt, me += U * ze, be += U * Te, ve += U * pt, Ge += U * Fe, ye += U * Ae, pe += U * bt, Je += U * He, Ie += U * Ne, we += U * yt, at += U * $e, Oe += U * De, Ee += U * vt, ft += U * je, Le += U * Ce, Pe += U * mt, U = q[10], me += U * dt, be += U * ze, ve += U * Te, Ge += U * pt, ye += U * Fe, pe += U * Ae, Je += U * bt, Ie += U * He, we += U * Ne, at += U * yt, Oe += U * $e, Ee += U * De, ft += U * vt, Le += U * je, Pe += U * Ce, Mt += U * mt, U = q[11], be += U * dt, ve += U * ze, Ge += U * Te, ye += U * pt, pe += U * Fe, Je += U * Ae, Ie += U * bt, we += U * He, at += U * Ne, Oe += U * yt, Ee += U * $e, ft += U * De, Le += U * vt, Pe += U * je, Mt += U * Ce, Ve += U * mt, U = q[12], ve += U * dt, Ge += U * ze, ye += U * Te, pe += U * pt, Je += U * Fe, Ie += U * Ae, we += U * bt, at += U * He, Oe += U * Ne, Ee += U * yt, ft += U * $e, Le += U * De, Pe += U * vt, Mt += U * je, Ve += U * Ce, ke += U * mt, U = q[13], Ge += U * dt, ye += U * ze, pe += U * Te, Je += U * pt, Ie += U * Fe, we += U * Ae, at += U * bt, Oe += U * He, Ee += U * Ne, ft += U * yt, Le += U * $e, Pe += U * De, Mt += U * vt, Ve += U * je, ke += U * Ce, Et += U * mt, U = q[14], ye += U * dt, pe += U * ze, Je += U * Te, Ie += U * pt, we += U * Fe, at += U * Ae, Oe += U * bt, Ee += U * He, ft += U * Ne, Le += U * yt, Pe += U * $e, Mt += U * De, Ve += U * vt, ke += U * je, Et += U * Ce, Ke += U * mt, U = q[15], pe += U * dt, Je += U * ze, Ie += U * Te, we += U * pt, at += U * Fe, Oe += U * Ae, Ee += U * bt, ft += U * He, Le += U * Ne, Pe += U * yt, Mt += U * $e, Ve += U * De, ke += U * vt, Et += U * je, Ke += U * Ce, Be += U * mt, D += 38 * Je, te += 38 * Ie, ne += 38 * we, le += 38 * at, X += 38 * Oe, $ += 38 * Ee, V += 38 * ft, re += 38 * Le, fe += 38 * Pe, ue += 38 * Mt, me += 38 * Ve, be += 38 * ke, ve += 38 * Et, Ge += 38 * Ke, ye += 38 * Be, T = 1, U = D + T + 65535, T = Math.floor(U / 65536), D = U - T * 65536, U = te + T + 65535, T = Math.floor(U / 65536), te = U - T * 65536, U = ne + T + 65535, T = Math.floor(U / 65536), ne = U - T * 65536, U = le + T + 65535, T = Math.floor(U / 65536), le = U - T * 65536, U = X + T + 65535, T = Math.floor(U / 65536), X = U - T * 65536, U = $ + T + 65535, T = Math.floor(U / 65536), $ = U - T * 65536, U = V + T + 65535, T = Math.floor(U / 65536), V = U - T * 65536, U = re + T + 65535, T = Math.floor(U / 65536), re = U - T * 65536, U = fe + T + 65535, T = Math.floor(U / 65536), fe = U - T * 65536, U = ue + T + 65535, T = Math.floor(U / 65536), ue = U - T * 65536, U = me + T + 65535, T = Math.floor(U / 65536), me = U - T * 65536, U = be + T + 65535, T = Math.floor(U / 65536), be = U - T * 65536, U = ve + T + 65535, T = Math.floor(U / 65536), ve = U - T * 65536, U = Ge + T + 65535, T = Math.floor(U / 65536), Ge = U - T * 65536, U = ye + T + 65535, T = Math.floor(U / 65536), ye = U - T * 65536, U = pe + T + 65535, T = Math.floor(U / 65536), pe = U - T * 65536, D += T - 1 + 37 * (T - 1), T = 1, U = D + T + 65535, T = Math.floor(U / 65536), D = U - T * 65536, U = te + T + 65535, T = Math.floor(U / 65536), te = U - T * 65536, U = ne + T + 65535, T = Math.floor(U / 65536), ne = U - T * 65536, U = le + T + 65535, T = Math.floor(U / 65536), le = U - T * 65536, U = X + T + 65535, T = Math.floor(U / 65536), X = U - T * 65536, U = $ + T + 65535, T = Math.floor(U / 65536), $ = U - T * 65536, U = V + T + 65535, T = Math.floor(U / 65536), V = U - T * 65536, U = re + T + 65535, T = Math.floor(U / 65536), re = U - T * 65536, U = fe + T + 65535, T = Math.floor(U / 65536), fe = U - T * 65536, U = ue + T + 65535, T = Math.floor(U / 65536), ue = U - T * 65536, U = me + T + 65535, T = Math.floor(U / 65536), me = U - T * 65536, U = be + T + 65535, T = Math.floor(U / 65536), be = U - T * 65536, U = ve + T + 65535, T = Math.floor(U / 65536), ve = U - T * 65536, U = Ge + T + 65535, T = Math.floor(U / 65536), Ge = U - T * 65536, U = ye + T + 65535, T = Math.floor(U / 65536), ye = U - T * 65536, U = pe + T + 65535, T = Math.floor(U / 65536), pe = U - T * 65536, D += T - 1 + 37 * (T - 1), j[0] = D, j[1] = te, j[2] = ne, j[3] = le, j[4] = X, j[5] = $, j[6] = V, j[7] = re, j[8] = fe, j[9] = ue, j[10] = me, j[11] = be, j[12] = ve, j[13] = Ge, j[14] = ye, j[15] = pe;
  }
  function Y(j, q) {
    B(j, q, q);
  }
  function ae(j, q) {
    const K = s();
    let U;
    for (U = 0; U < 16; U++)
      K[U] = q[U];
    for (U = 253; U >= 0; U--)
      Y(K, K), U !== 2 && U !== 4 && B(K, K, q);
    for (U = 0; U < 16; U++)
      j[U] = K[U];
  }
  function se(j, q) {
    const K = s();
    let U;
    for (U = 0; U < 16; U++)
      K[U] = q[U];
    for (U = 250; U >= 0; U--)
      Y(K, K), U !== 1 && B(K, K, q);
    for (U = 0; U < 16; U++)
      j[U] = K[U];
  }
  function W(j, q) {
    const K = s(), U = s(), T = s(), D = s(), te = s(), ne = s(), le = s(), X = s(), $ = s();
    Z(K, j[1], j[0]), Z($, q[1], q[0]), B(K, K, $), Q(U, j[0], j[1]), Q($, q[0], q[1]), B(U, U, $), B(T, j[3], q[3]), B(T, T, d), B(D, j[2], q[2]), Q(D, D, D), Z(te, U, K), Z(ne, D, T), Q(le, D, T), Q(X, U, K), B(j[0], te, ne), B(j[1], X, le), B(j[2], le, ne), B(j[3], te, X);
  }
  function C(j, q, K) {
    for (let U = 0; U < 4; U++)
      N(j[U], q[U], K);
  }
  function g(j, q) {
    const K = s(), U = s(), T = s();
    ae(T, q[2]), B(K, q[0], T), B(U, q[1], T), R(j, U), j[31] ^= F(K) << 7;
  }
  function a(j, q, K) {
    M(j[0], f), M(j[1], u), M(j[2], u), M(j[3], f);
    for (let U = 255; U >= 0; --U) {
      const T = K[U / 8 | 0] >> (U & 7) & 1;
      C(j, q, T), W(q, j), W(j, j), C(j, q, T);
    }
  }
  function c(j, q) {
    const K = [s(), s(), s(), s()];
    M(K[0], l), M(K[1], m), M(K[2], u), B(K[3], l, m), a(j, K, q);
  }
  function p(j) {
    if (j.length !== t.SEED_LENGTH)
      throw new Error(`ed25519: seed must be ${t.SEED_LENGTH} bytes`);
    const q = (0, r.hash)(j);
    q[0] &= 248, q[31] &= 127, q[31] |= 64;
    const K = new Uint8Array(32), U = [s(), s(), s(), s()];
    c(U, q), g(K, U);
    const T = new Uint8Array(64);
    return T.set(j), T.set(K, 32), {
      publicKey: K,
      secretKey: T
    };
  }
  t.generateKeyPairFromSeed = p;
  function w(j) {
    const q = (0, e.randomBytes)(32, j), K = p(q);
    return (0, i.wipe)(q), K;
  }
  t.generateKeyPair = w;
  function _(j) {
    if (j.length !== t.SECRET_KEY_LENGTH)
      throw new Error(`ed25519: secret key must be ${t.SECRET_KEY_LENGTH} bytes`);
    return new Uint8Array(j.subarray(32));
  }
  t.extractPublicKeyFromSecretKey = _;
  const x = new Float64Array([
    237,
    211,
    245,
    92,
    26,
    99,
    18,
    88,
    214,
    156,
    247,
    162,
    222,
    249,
    222,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    16
  ]);
  function E(j, q) {
    let K, U, T, D;
    for (U = 63; U >= 32; --U) {
      for (K = 0, T = U - 32, D = U - 12; T < D; ++T)
        q[T] += K - 16 * q[U] * x[T - (U - 32)], K = Math.floor((q[T] + 128) / 256), q[T] -= K * 256;
      q[T] += K, q[U] = 0;
    }
    for (K = 0, T = 0; T < 32; T++)
      q[T] += K - (q[31] >> 4) * x[T], K = q[T] >> 8, q[T] &= 255;
    for (T = 0; T < 32; T++)
      q[T] -= K * x[T];
    for (U = 0; U < 32; U++)
      q[U + 1] += q[U] >> 8, j[U] = q[U] & 255;
  }
  function y(j) {
    const q = new Float64Array(64);
    for (let K = 0; K < 64; K++)
      q[K] = j[K];
    for (let K = 0; K < 64; K++)
      j[K] = 0;
    E(j, q);
  }
  function o(j, q) {
    const K = new Float64Array(64), U = [s(), s(), s(), s()], T = (0, r.hash)(j.subarray(0, 32));
    T[0] &= 248, T[31] &= 127, T[31] |= 64;
    const D = new Uint8Array(64);
    D.set(T.subarray(32), 32);
    const te = new r.SHA512();
    te.update(D.subarray(32)), te.update(q);
    const ne = te.digest();
    te.clean(), y(ne), c(U, ne), g(D, U), te.reset(), te.update(D.subarray(0, 32)), te.update(j.subarray(32)), te.update(q);
    const le = te.digest();
    y(le);
    for (let X = 0; X < 32; X++)
      K[X] = ne[X];
    for (let X = 0; X < 32; X++)
      for (let $ = 0; $ < 32; $++)
        K[X + $] += le[X] * T[$];
    return E(D.subarray(32), K), D;
  }
  t.sign = o;
  function S(j, q) {
    const K = s(), U = s(), T = s(), D = s(), te = s(), ne = s(), le = s();
    return M(j[2], u), H(j[1], q), Y(T, j[1]), B(D, T, h), Z(T, T, j[2]), Q(D, j[2], D), Y(te, D), Y(ne, te), B(le, ne, te), B(K, le, T), B(K, K, D), se(K, K), B(K, K, T), B(K, K, D), B(K, K, D), B(j[0], K, D), Y(U, j[0]), B(U, U, D), P(U, T) && B(j[0], j[0], b), Y(U, j[0]), B(U, U, D), P(U, T) ? -1 : (F(j[0]) === q[31] >> 7 && Z(j[0], f, j[0]), B(j[3], j[0], j[1]), 0);
  }
  function J(j, q, K) {
    const U = new Uint8Array(32), T = [s(), s(), s(), s()], D = [s(), s(), s(), s()];
    if (K.length !== t.SIGNATURE_LENGTH)
      throw new Error(`ed25519: signature must be ${t.SIGNATURE_LENGTH} bytes`);
    if (S(D, j))
      return !1;
    const te = new r.SHA512();
    te.update(K.subarray(0, 32)), te.update(j), te.update(q);
    const ne = te.digest();
    return y(ne), a(T, D, ne), c(D, K.subarray(32)), W(T, D), g(U, T), !O(K, U);
  }
  t.verify = J;
  function z(j) {
    let q = [s(), s(), s(), s()];
    if (S(q, j))
      throw new Error("Ed25519: invalid public key");
    let K = s(), U = s(), T = q[1];
    Q(K, u, T), Z(U, u, T), ae(U, U), B(K, K, U);
    let D = new Uint8Array(32);
    return R(D, K), D;
  }
  t.convertPublicKeyToX25519 = z;
  function k(j) {
    const q = (0, r.hash)(j.subarray(0, 32));
    q[0] &= 248, q[31] &= 127, q[31] |= 64;
    const K = new Uint8Array(q.subarray(0, 32));
    return (0, i.wipe)(q), K;
  }
  t.convertSecretKeyToX25519 = k;
})(Nw);
const tse = "EdDSA", rse = "JWT", k0 = ".", n1 = "base64url", sT = "utf8", aT = "utf8", ise = ":", nse = "did", sse = "key", F8 = "base58btc", ase = "z", ose = "K36", fse = 32;
function Dw(t) {
  return globalThis.Buffer != null ? new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : t;
}
function oT(t = 0) {
  return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? Dw(globalThis.Buffer.allocUnsafe(t)) : new Uint8Array(t);
}
function cse(t, e) {
  e || (e = t.reduce((s, n) => s + n.length, 0));
  const r = oT(e);
  let i = 0;
  for (const s of t)
    r.set(s, i), i += s.length;
  return Dw(r);
}
function fT(t, e, r, i) {
  return {
    name: t,
    prefix: e,
    encoder: {
      name: t,
      prefix: e,
      encode: r
    },
    decoder: { decode: i }
  };
}
const $8 = fT("utf8", "u", (t) => {
  const e = new TextDecoder("utf8");
  return "u" + e.decode(t);
}, (t) => new TextEncoder().encode(t.substring(1))), Ly = fT("ascii", "a", (t) => {
  let e = "a";
  for (let r = 0; r < t.length; r++)
    e += String.fromCharCode(t[r]);
  return e;
}, (t) => {
  t = t.substring(1);
  const e = oT(t.length);
  for (let r = 0; r < t.length; r++)
    e[r] = t.charCodeAt(r);
  return e;
}), cT = {
  utf8: $8,
  "utf-8": $8,
  hex: O0.base16,
  latin1: Ly,
  ascii: Ly,
  binary: Ly,
  ...O0
};
function s1(t, e = "utf8") {
  const r = cT[e];
  if (!r)
    throw new Error(`Unsupported encoding "${e}"`);
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? globalThis.Buffer.from(t.buffer, t.byteOffset, t.byteLength).toString("utf8") : r.encoder.encode(t).substring(1);
}
function nu(t, e = "utf8") {
  const r = cT[e];
  if (!r)
    throw new Error(`Unsupported encoding "${e}"`);
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? Dw(globalThis.Buffer.from(t, "utf-8")) : r.decoder.decode(`${r.prefix}${t}`);
}
const use = (t) => JSON.stringify(t, (e, r) => typeof r == "bigint" ? r.toString() + "n" : r), hse = (t) => {
  const e = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g, r = t.replace(e, '$1"$2n"$3');
  return JSON.parse(r, (i, s) => typeof s == "string" && s.match(/^\d+n$/) ? BigInt(s.substring(0, s.length - 1)) : s);
};
function uf(t) {
  if (typeof t != "string")
    throw new Error(`Cannot safe json parse value of type ${typeof t}`);
  try {
    return hse(t);
  } catch {
    return t;
  }
}
function Pa(t) {
  return typeof t == "string" ? t : use(t) || "";
}
function q8(t) {
  return uf(s1(nu(t, n1), sT));
}
function j0(t) {
  return s1(nu(Pa(t), sT), n1);
}
function uT(t) {
  const e = nu(ose, F8), r = ase + s1(cse([e, t]), F8);
  return [nse, sse, r].join(ise);
}
function lse(t) {
  return s1(t, n1);
}
function dse(t) {
  return nu(t, n1);
}
function pse(t) {
  return nu([j0(t.header), j0(t.payload)].join(k0), aT);
}
function vse(t) {
  return [
    j0(t.header),
    j0(t.payload),
    lse(t.signature)
  ].join(k0);
}
function Pm(t) {
  const e = t.split(k0), r = q8(e[0]), i = q8(e[1]), s = dse(e[2]), n = nu(e.slice(0, 2).join(k0), aT);
  return { header: r, payload: i, signature: s, data: n };
}
function H8(t = yo.randomBytes(fse)) {
  return Nw.generateKeyPairFromSeed(t);
}
async function gse(t, e, r, i, s = ct.fromMiliseconds(Date.now())) {
  const n = { alg: tse, typ: rse }, f = uT(i.publicKey), u = s + r, h = { iss: f, sub: t, aud: e, iat: s, exp: u }, d = pse({ header: n, payload: h }), l = Nw.sign(i.secretKey, d);
  return vse({ header: n, payload: h, signature: l });
}
const bse = { waku: { publish: "waku_publish", batchPublish: "waku_batchPublish", subscribe: "waku_subscribe", batchSubscribe: "waku_batchSubscribe", subscription: "waku_subscription", unsubscribe: "waku_unsubscribe", batchUnsubscribe: "waku_batchUnsubscribe", batchFetchMessages: "waku_batchFetchMessages" }, irn: { publish: "irn_publish", batchPublish: "irn_batchPublish", subscribe: "irn_subscribe", batchSubscribe: "irn_batchSubscribe", subscription: "irn_subscription", unsubscribe: "irn_unsubscribe", batchUnsubscribe: "irn_batchUnsubscribe", batchFetchMessages: "irn_batchFetchMessages" }, iridium: { publish: "iridium_publish", batchPublish: "iridium_batchPublish", subscribe: "iridium_subscribe", batchSubscribe: "iridium_batchSubscribe", subscription: "iridium_subscription", unsubscribe: "iridium_unsubscribe", batchUnsubscribe: "iridium_batchUnsubscribe", batchFetchMessages: "iridium_batchFetchMessages" } }, yse = ":";
function vc(t) {
  const [e, r] = t.split(yse);
  return { namespace: e, reference: r };
}
function W8(t, e = []) {
  const r = [];
  return Object.keys(t).forEach((i) => {
    if (e.length && !e.includes(i))
      return;
    const s = t[i];
    r.push(...s.accounts);
  }), r;
}
function hT(t, e) {
  return t.includes(":") ? [t] : e.chains || [];
}
var mse = Object.defineProperty, V8 = Object.getOwnPropertySymbols, wse = Object.prototype.hasOwnProperty, _se = Object.prototype.propertyIsEnumerable, G8 = (t, e, r) => e in t ? mse(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, K8 = (t, e) => {
  for (var r in e || (e = {}))
    wse.call(e, r) && G8(t, r, e[r]);
  if (V8)
    for (var r of V8(e))
      _se.call(e, r) && G8(t, r, e[r]);
  return t;
};
const Mse = "ReactNative", In = { reactNative: "react-native", node: "node", browser: "browser", unknown: "unknown" }, xse = "js";
function B0() {
  return typeof process < "u" && typeof process.versions < "u" && typeof process.versions.node < "u";
}
function su() {
  return !Qh() && !!ew() && navigator.product === Mse;
}
function sl() {
  return !B0() && !!ew() && !!Qh();
}
function al() {
  return su() ? In.reactNative : B0() ? In.node : sl() ? In.browser : In.unknown;
}
function Sse() {
  var t;
  try {
    return su() && typeof global < "u" && typeof (global == null ? void 0 : global.Application) < "u" ? (t = global.Application) == null ? void 0 : t.applicationId : void 0;
  } catch {
    return;
  }
}
function Ese(t, e) {
  let r = yh.parse(t);
  return r = K8(K8({}, r), e), t = yh.stringify(r), t;
}
function lT() {
  return aI() || { name: "", description: "", url: "", icons: [""] };
}
function Ise() {
  if (al() === In.reactNative && typeof global < "u" && typeof (global == null ? void 0 : global.Platform) < "u") {
    const { OS: r, Version: i } = global.Platform;
    return [r, i].join("-");
  }
  const t = TZ();
  if (t === null)
    return "unknown";
  const e = t.os ? t.os.replace(" ", "").toLowerCase() : "unknown";
  return t.type === "browser" ? [e, t.name, t.version].join("-") : [e, t.version].join("-");
}
function Ase() {
  var t;
  const e = al();
  return e === In.browser ? [e, ((t = sI()) == null ? void 0 : t.host) || "unknown"].join(":") : e;
}
function dT(t, e, r) {
  const i = Ise(), s = Ase();
  return [[t, e].join("-"), [xse, r].join("-"), i, s].join("/");
}
function Tse({ protocol: t, version: e, relayUrl: r, sdkVersion: i, auth: s, projectId: n, useOnCloseEvent: f, bundleId: u }) {
  const h = r.split("?"), d = dT(t, e, i), l = { auth: s, ua: d, projectId: n, useOnCloseEvent: f || void 0, origin: u || void 0 }, m = Ese(h[1] || "", l);
  return h[0] + "?" + m;
}
function Jo(t, e) {
  return t.filter((r) => e.includes(r)).length === t.length;
}
function pT(t) {
  return Object.fromEntries(t.entries());
}
function vT(t) {
  return new Map(Object.entries(t));
}
function $o(t = ct.FIVE_MINUTES, e) {
  const r = ct.toMiliseconds(t || ct.FIVE_MINUTES);
  let i, s, n;
  return { resolve: (f) => {
    n && i && (clearTimeout(n), i(f));
  }, reject: (f) => {
    n && s && (clearTimeout(n), s(f));
  }, done: () => new Promise((f, u) => {
    n = setTimeout(() => {
      u(new Error(e));
    }, r), i = f, s = u;
  }) };
}
function gc(t, e, r) {
  return new Promise(async (i, s) => {
    const n = setTimeout(() => s(new Error(r)), e);
    try {
      const f = await t;
      i(f);
    } catch (f) {
      s(f);
    }
    clearTimeout(n);
  });
}
function gT(t, e) {
  if (typeof e == "string" && e.startsWith(`${t}:`))
    return e;
  if (t.toLowerCase() === "topic") {
    if (typeof e != "string")
      throw new Error('Value must be "string" for expirer target type: topic');
    return `topic:${e}`;
  } else if (t.toLowerCase() === "id") {
    if (typeof e != "number")
      throw new Error('Value must be "number" for expirer target type: id');
    return `id:${e}`;
  }
  throw new Error(`Unknown expirer target type: ${t}`);
}
function Nse(t) {
  return gT("topic", t);
}
function Dse(t) {
  return gT("id", t);
}
function bT(t) {
  const [e, r] = t.split(":"), i = { id: void 0, topic: void 0 };
  if (e === "topic" && typeof r == "string")
    i.topic = r;
  else if (e === "id" && Number.isInteger(Number(r)))
    i.id = Number(r);
  else
    throw new Error(`Invalid target, expected id:number or topic:string, got ${e}:${r}`);
  return i;
}
function ci(t, e) {
  return ct.fromMiliseconds((e || Date.now()) + ct.toMiliseconds(t));
}
function Ja(t) {
  return Date.now() >= ct.toMiliseconds(t);
}
function Yt(t, e) {
  return `${t}${e ? `:${e}` : ""}`;
}
function t0(t = [], e = []) {
  return [.../* @__PURE__ */ new Set([...t, ...e])];
}
async function Cse({ id: t, topic: e, wcDeepLink: r }) {
  var i;
  try {
    if (!r)
      return;
    const s = typeof r == "string" ? JSON.parse(r) : r, n = s == null ? void 0 : s.href;
    if (typeof n != "string")
      return;
    const f = Ose(n, t, e), u = al();
    if (u === In.browser) {
      if (!((i = Qh()) != null && i.hasFocus())) {
        console.warn("Document does not have focus, skipping deeplink.");
        return;
      }
      f.startsWith("https://") || f.startsWith("http://") ? window.open(f, "_blank", "noreferrer noopener") : window.open(f, Lse() ? "_blank" : "_self", "noreferrer noopener");
    } else
      u === In.reactNative && typeof (global == null ? void 0 : global.Linking) < "u" && await global.Linking.openURL(f);
  } catch (s) {
    console.error(s);
  }
}
function Ose(t, e, r) {
  const i = `requestId=${e}&sessionTopic=${r}`;
  t.endsWith("/") && (t = t.slice(0, -1));
  let s = `${t}`;
  if (t.startsWith("https://t.me")) {
    const n = t.includes("?") ? "&startapp=" : "?startapp=";
    s = `${s}${n}${Pse(i, !0)}`;
  } else
    s = `${s}/wc?${i}`;
  return s;
}
async function Rse(t, e) {
  let r = "";
  try {
    if (sl() && (r = localStorage.getItem(e), r))
      return r;
    r = await t.getItem(e);
  } catch (i) {
    console.error(i);
  }
  return r;
}
function Y8(t, e) {
  if (!t.includes(e))
    return null;
  const r = t.split(/([&,?,=])/), i = r.indexOf(e);
  return r[i + 2];
}
function Q8() {
  return typeof crypto < "u" && crypto != null && crypto.randomUUID ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/gu, (t) => {
    const e = Math.random() * 16 | 0;
    return (t === "x" ? e : e & 3 | 8).toString(16);
  });
}
function Cw() {
  return typeof process < "u" && process.env.IS_VITEST === "true";
}
function Lse() {
  return typeof window < "u" && (!!window.TelegramWebviewProxy || !!window.Telegram || !!window.TelegramWebviewProxyProto);
}
function Pse(t, e = !1) {
  const r = Buffer.from(t).toString("base64");
  return e ? r.replace(/[=]/g, "") : r;
}
function yT(t) {
  return Buffer.from(t, "base64").toString("utf-8");
}
const kse = "https://rpc.walletconnect.org/v1";
async function jse(t, e, r, i, s, n) {
  switch (r.t) {
    case "eip191":
      return Bse(t, e, r.s);
    case "eip1271":
      return await zse(t, e, r.s, i, s, n);
    default:
      throw new Error(`verifySignature failed: Attempted to verify CacaoSignature with unknown type: ${r.t}`);
  }
}
function Bse(t, e, r) {
  return dee(pI(e), r).toLowerCase() === t.toLowerCase();
}
async function zse(t, e, r, i, s, n) {
  const f = vc(i);
  if (!f.namespace || !f.reference)
    throw new Error(`isValidEip1271Signature failed: chainId must be in CAIP-2 format, received: ${i}`);
  try {
    const u = "0x1626ba7e", h = "0000000000000000000000000000000000000000000000000000000000000040", d = "0000000000000000000000000000000000000000000000000000000000000041", l = r.substring(2), m = pI(e).substring(2), b = u + m + h + d + l, M = await fetch(`${n || kse}/?chainId=${i}&projectId=${s}`, { method: "POST", body: JSON.stringify({ id: Use(), jsonrpc: "2.0", method: "eth_call", params: [{ to: t, data: b }, "latest"] }) }), { result: A } = await M.json();
    return A ? A.slice(0, u.length).toLowerCase() === u.toLowerCase() : !1;
  } catch (u) {
    return console.error("isValidEip1271Signature: ", u), !1;
  }
}
function Use() {
  return Date.now() + Math.floor(Math.random() * 1e3);
}
var Fse = Object.defineProperty, $se = Object.defineProperties, qse = Object.getOwnPropertyDescriptors, Z8 = Object.getOwnPropertySymbols, Hse = Object.prototype.hasOwnProperty, Wse = Object.prototype.propertyIsEnumerable, J8 = (t, e, r) => e in t ? Fse(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Vse = (t, e) => {
  for (var r in e || (e = {}))
    Hse.call(e, r) && J8(t, r, e[r]);
  if (Z8)
    for (var r of Z8(e))
      Wse.call(e, r) && J8(t, r, e[r]);
  return t;
}, Gse = (t, e) => $se(t, qse(e));
const Kse = "did:pkh:", Ow = (t) => t == null ? void 0 : t.split(":"), Yse = (t) => {
  const e = t && Ow(t);
  if (e)
    return t.includes(Kse) ? e[3] : e[1];
}, km = (t) => {
  const e = t && Ow(t);
  if (e)
    return e[2] + ":" + e[3];
}, z0 = (t) => {
  const e = t && Ow(t);
  if (e)
    return e.pop();
};
async function X8(t) {
  const { cacao: e, projectId: r } = t, { s: i, p: s } = e, n = mT(s, s.iss), f = z0(s.iss);
  return await jse(f, n, i, km(s.iss), r);
}
const mT = (t, e) => {
  const r = `${t.domain} wants you to sign in with your Ethereum account:`, i = z0(e);
  if (!t.aud && !t.uri)
    throw new Error("Either `aud` or `uri` is required to construct the message");
  let s = t.statement || void 0;
  const n = `URI: ${t.aud || t.uri}`, f = `Version: ${t.version}`, u = `Chain ID: ${Yse(e)}`, h = `Nonce: ${t.nonce}`, d = `Issued At: ${t.iat}`, l = t.exp ? `Expiration Time: ${t.exp}` : void 0, m = t.nbf ? `Not Before: ${t.nbf}` : void 0, b = t.requestId ? `Request ID: ${t.requestId}` : void 0, M = t.resources ? `Resources:${t.resources.map((N) => `
- ${N}`).join("")}` : void 0, A = r0(t.resources);
  if (A) {
    const N = wh(A);
    s = nae(s, N);
  }
  return [r, i, "", s, "", n, f, u, h, d, l, m, b, M].filter((N) => N != null).join(`
`);
};
function Qse(t) {
  return Buffer.from(JSON.stringify(t)).toString("base64");
}
function Zse(t) {
  return JSON.parse(Buffer.from(t, "base64").toString("utf-8"));
}
function hf(t) {
  if (!t)
    throw new Error("No recap provided, value is undefined");
  if (!t.att)
    throw new Error("No `att` property found");
  const e = Object.keys(t.att);
  if (!(e != null && e.length))
    throw new Error("No resources found in `att` property");
  e.forEach((r) => {
    const i = t.att[r];
    if (Array.isArray(i))
      throw new Error(`Resource must be an object: ${r}`);
    if (typeof i != "object")
      throw new Error(`Resource must be an object: ${r}`);
    if (!Object.keys(i).length)
      throw new Error(`Resource object is empty: ${r}`);
    Object.keys(i).forEach((s) => {
      const n = i[s];
      if (!Array.isArray(n))
        throw new Error(`Ability limits ${s} must be an array of objects, found: ${n}`);
      if (!n.length)
        throw new Error(`Value of ${s} is empty array, must be an array with objects`);
      n.forEach((f) => {
        if (typeof f != "object")
          throw new Error(`Ability limits (${s}) must be an array of objects, found: ${f}`);
      });
    });
  });
}
function Jse(t, e, r, i = {}) {
  return r == null || r.sort((s, n) => s.localeCompare(n)), { att: { [t]: Xse(e, r, i) } };
}
function Xse(t, e, r = {}) {
  e = e == null ? void 0 : e.sort((s, n) => s.localeCompare(n));
  const i = e.map((s) => ({ [`${t}/${s}`]: [r] }));
  return Object.assign({}, ...i);
}
function wT(t) {
  return hf(t), `urn:recap:${Qse(t).replace(/=/g, "")}`;
}
function wh(t) {
  const e = Zse(t.replace("urn:recap:", ""));
  return hf(e), e;
}
function eae(t, e, r) {
  const i = Jse(t, e, r);
  return wT(i);
}
function tae(t) {
  return t && t.includes("urn:recap:");
}
function rae(t, e) {
  const r = wh(t), i = wh(e), s = iae(r, i);
  return wT(s);
}
function iae(t, e) {
  hf(t), hf(e);
  const r = Object.keys(t.att).concat(Object.keys(e.att)).sort((s, n) => s.localeCompare(n)), i = { att: {} };
  return r.forEach((s) => {
    var n, f;
    Object.keys(((n = t.att) == null ? void 0 : n[s]) || {}).concat(Object.keys(((f = e.att) == null ? void 0 : f[s]) || {})).sort((u, h) => u.localeCompare(h)).forEach((u) => {
      var h, d;
      i.att[s] = Gse(Vse({}, i.att[s]), { [u]: ((h = t.att[s]) == null ? void 0 : h[u]) || ((d = e.att[s]) == null ? void 0 : d[u]) });
    });
  }), i;
}
function nae(t = "", e) {
  hf(e);
  const r = "I further authorize the stated URI to perform the following actions on my behalf: ";
  if (t.includes(r))
    return t;
  const i = [];
  let s = 0;
  Object.keys(e.att).forEach((u) => {
    const h = Object.keys(e.att[u]).map((m) => ({ ability: m.split("/")[0], action: m.split("/")[1] }));
    h.sort((m, b) => m.action.localeCompare(b.action));
    const d = {};
    h.forEach((m) => {
      d[m.ability] || (d[m.ability] = []), d[m.ability].push(m.action);
    });
    const l = Object.keys(d).map((m) => (s++, `(${s}) '${m}': '${d[m].join("', '")}' for '${u}'.`));
    i.push(l.join(", ").replace(".,", "."));
  });
  const n = i.join(" "), f = `${r}${n}`;
  return `${t ? t + " " : ""}${f}`;
}
function ex(t) {
  var e;
  const r = wh(t);
  hf(r);
  const i = (e = r.att) == null ? void 0 : e.eip155;
  return i ? Object.keys(i).map((s) => s.split("/")[1]) : [];
}
function tx(t) {
  const e = wh(t);
  hf(e);
  const r = [];
  return Object.values(e.att).forEach((i) => {
    Object.values(i).forEach((s) => {
      var n;
      (n = s == null ? void 0 : s[0]) != null && n.chains && r.push(s[0].chains);
    });
  }), [...new Set(r.flat())];
}
function r0(t) {
  if (!t)
    return;
  const e = t == null ? void 0 : t[t.length - 1];
  return tae(e) ? e : void 0;
}
const _T = "base10", Zi = "base16", io = "base64pad", Fu = "base64url", ol = "utf8", MT = 0, Na = 1, fl = 2, sae = 0, rx = 1, ah = 12, Rw = 32;
function aae() {
  const t = Sw.generateKeyPair();
  return { privateKey: un(t.secretKey, Zi), publicKey: un(t.publicKey, Zi) };
}
function jm() {
  const t = yo.randomBytes(Rw);
  return un(t, Zi);
}
function oae(t, e) {
  const r = Sw.sharedKey(Xn(t, Zi), Xn(e, Zi), !0), i = new Gee(tl.SHA256, r).expand(Rw);
  return un(i, Zi);
}
function i0(t) {
  const e = tl.hash(Xn(t, Zi));
  return un(e, Zi);
}
function Ea(t) {
  const e = tl.hash(Xn(t, ol));
  return un(e, Zi);
}
function xT(t) {
  return Xn(`${t}`, _T);
}
function lf(t) {
  return Number(un(t, _T));
}
function fae(t) {
  const e = xT(typeof t.type < "u" ? t.type : MT);
  if (lf(e) === Na && typeof t.senderPublicKey > "u")
    throw new Error("Missing sender public key for type 1 envelope");
  const r = typeof t.senderPublicKey < "u" ? Xn(t.senderPublicKey, Zi) : void 0, i = typeof t.iv < "u" ? Xn(t.iv, Zi) : yo.randomBytes(ah), s = new fw.ChaCha20Poly1305(Xn(t.symKey, Zi)).seal(i, Xn(t.message, ol));
  return ST({ type: e, sealed: s, iv: i, senderPublicKey: r, encoding: t.encoding });
}
function cae(t, e) {
  const r = xT(fl), i = yo.randomBytes(ah), s = Xn(t, ol);
  return ST({ type: r, sealed: s, iv: i, encoding: e });
}
function uae(t) {
  const e = new fw.ChaCha20Poly1305(Xn(t.symKey, Zi)), { sealed: r, iv: i } = _h({ encoded: t.encoded, encoding: t == null ? void 0 : t.encoding }), s = e.open(i, r);
  if (s === null)
    throw new Error("Failed to decrypt");
  return un(s, ol);
}
function hae(t, e) {
  const { sealed: r } = _h({ encoded: t, encoding: e });
  return un(r, ol);
}
function ST(t) {
  const { encoding: e = io } = t;
  if (lf(t.type) === fl)
    return un(Ty([t.type, t.sealed]), e);
  if (lf(t.type) === Na) {
    if (typeof t.senderPublicKey > "u")
      throw new Error("Missing sender public key for type 1 envelope");
    return un(Ty([t.type, t.senderPublicKey, t.iv, t.sealed]), e);
  }
  return un(Ty([t.type, t.iv, t.sealed]), e);
}
function _h(t) {
  const { encoded: e, encoding: r = io } = t, i = Xn(e, r), s = i.slice(sae, rx), n = rx;
  if (lf(s) === Na) {
    const d = n + Rw, l = d + ah, m = i.slice(n, d), b = i.slice(d, l), M = i.slice(l);
    return { type: s, sealed: M, iv: b, senderPublicKey: m };
  }
  if (lf(s) === fl) {
    const d = i.slice(n), l = yo.randomBytes(ah);
    return { type: s, sealed: d, iv: l };
  }
  const f = n + ah, u = i.slice(n, f), h = i.slice(f);
  return { type: s, sealed: h, iv: u };
}
function lae(t, e) {
  const r = _h({ encoded: t, encoding: e == null ? void 0 : e.encoding });
  return ET({ type: lf(r.type), senderPublicKey: typeof r.senderPublicKey < "u" ? un(r.senderPublicKey, Zi) : void 0, receiverPublicKey: e == null ? void 0 : e.receiverPublicKey });
}
function ET(t) {
  const e = (t == null ? void 0 : t.type) || MT;
  if (e === Na) {
    if (typeof (t == null ? void 0 : t.senderPublicKey) > "u")
      throw new Error("missing sender public key");
    if (typeof (t == null ? void 0 : t.receiverPublicKey) > "u")
      throw new Error("missing receiver public key");
  }
  return { type: e, senderPublicKey: t == null ? void 0 : t.senderPublicKey, receiverPublicKey: t == null ? void 0 : t.receiverPublicKey };
}
function ix(t) {
  return t.type === Na && typeof t.senderPublicKey == "string" && typeof t.receiverPublicKey == "string";
}
function nx(t) {
  return t.type === fl;
}
function dae(t) {
  return new QA.ec("p256").keyFromPublic({ x: Buffer.from(t.x, "base64").toString("hex"), y: Buffer.from(t.y, "base64").toString("hex") }, "hex");
}
function pae(t) {
  let e = t.replace(/-/g, "+").replace(/_/g, "/");
  const r = e.length % 4;
  return r > 0 && (e += "=".repeat(4 - r)), e;
}
function vae(t) {
  return Buffer.from(pae(t), "base64");
}
function gae(t, e) {
  const [r, i, s] = t.split("."), n = vae(s);
  if (n.length !== 64)
    throw new Error("Invalid signature length");
  const f = n.slice(0, 32).toString("hex"), u = n.slice(32, 64).toString("hex"), h = `${r}.${i}`, d = new tl.SHA256().update(Buffer.from(h)).digest(), l = dae(e), m = Buffer.from(d).toString("hex");
  if (!l.verify(m, { r: f, s: u }))
    throw new Error("Invalid signature");
  return Pm(t).payload;
}
const bae = "irn";
function Bm(t) {
  return (t == null ? void 0 : t.relay) || { protocol: bae };
}
function Ku(t) {
  const e = bse[t];
  if (typeof e > "u")
    throw new Error(`Relay Protocol not supported: ${t}`);
  return e;
}
var yae = Object.defineProperty, mae = Object.defineProperties, wae = Object.getOwnPropertyDescriptors, sx = Object.getOwnPropertySymbols, _ae = Object.prototype.hasOwnProperty, Mae = Object.prototype.propertyIsEnumerable, ax = (t, e, r) => e in t ? yae(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, ox = (t, e) => {
  for (var r in e || (e = {}))
    _ae.call(e, r) && ax(t, r, e[r]);
  if (sx)
    for (var r of sx(e))
      Mae.call(e, r) && ax(t, r, e[r]);
  return t;
}, xae = (t, e) => mae(t, wae(e));
function Sae(t, e = "-") {
  const r = {}, i = "relay" + e;
  return Object.keys(t).forEach((s) => {
    if (s.startsWith(i)) {
      const n = s.replace(i, ""), f = t[s];
      r[n] = f;
    }
  }), r;
}
function fx(t) {
  if (!t.includes("wc:")) {
    const h = yT(t);
    h != null && h.includes("wc:") && (t = h);
  }
  t = t.includes("wc://") ? t.replace("wc://", "") : t, t = t.includes("wc:") ? t.replace("wc:", "") : t;
  const e = t.indexOf(":"), r = t.indexOf("?") !== -1 ? t.indexOf("?") : void 0, i = t.substring(0, e), s = t.substring(e + 1, r).split("@"), n = typeof r < "u" ? t.substring(r) : "", f = yh.parse(n), u = typeof f.methods == "string" ? f.methods.split(",") : void 0;
  return { protocol: i, topic: Eae(s[0]), version: parseInt(s[1], 10), symKey: f.symKey, relay: Sae(f), methods: u, expiryTimestamp: f.expiryTimestamp ? parseInt(f.expiryTimestamp, 10) : void 0 };
}
function Eae(t) {
  return t.startsWith("//") ? t.substring(2) : t;
}
function Iae(t, e = "-") {
  const r = "relay", i = {};
  return Object.keys(t).forEach((s) => {
    const n = r + e + s;
    t[s] && (i[n] = t[s]);
  }), i;
}
function cx(t) {
  return `${t.protocol}:${t.topic}@${t.version}?` + yh.stringify(ox(xae(ox({ symKey: t.symKey }, Iae(t.relay)), { expiryTimestamp: t.expiryTimestamp }), t.methods ? { methods: t.methods.join(",") } : {}));
}
function jd(t, e, r) {
  return `${t}?wc_ev=${r}&topic=${e}`;
}
function au(t) {
  const e = [];
  return t.forEach((r) => {
    const [i, s] = r.split(":");
    e.push(`${i}:${s}`);
  }), e;
}
function Aae(t) {
  const e = [];
  return Object.values(t).forEach((r) => {
    e.push(...au(r.accounts));
  }), e;
}
function Tae(t, e) {
  const r = [];
  return Object.values(t).forEach((i) => {
    au(i.accounts).includes(e) && r.push(...i.methods);
  }), r;
}
function Nae(t, e) {
  const r = [];
  return Object.values(t).forEach((i) => {
    au(i.accounts).includes(e) && r.push(...i.events);
  }), r;
}
function Lw(t) {
  return t.includes(":");
}
function Yu(t) {
  return Lw(t) ? t.split(":")[0] : t;
}
function Dae(t) {
  const e = {};
  return t == null || t.forEach((r) => {
    const [i, s] = r.split(":");
    e[i] || (e[i] = { accounts: [], chains: [], events: [] }), e[i].accounts.push(r), e[i].chains.push(`${i}:${s}`);
  }), e;
}
function ux(t, e) {
  e = e.map((i) => i.replace("did:pkh:", ""));
  const r = Dae(e);
  for (const [i, s] of Object.entries(r))
    s.methods ? s.methods = t0(s.methods, t) : s.methods = t, s.events = ["chainChanged", "accountsChanged"];
  return r;
}
const Cae = { INVALID_METHOD: { message: "Invalid method.", code: 1001 }, INVALID_EVENT: { message: "Invalid event.", code: 1002 }, INVALID_UPDATE_REQUEST: { message: "Invalid update request.", code: 1003 }, INVALID_EXTEND_REQUEST: { message: "Invalid extend request.", code: 1004 }, INVALID_SESSION_SETTLE_REQUEST: { message: "Invalid session settle request.", code: 1005 }, UNAUTHORIZED_METHOD: { message: "Unauthorized method.", code: 3001 }, UNAUTHORIZED_EVENT: { message: "Unauthorized event.", code: 3002 }, UNAUTHORIZED_UPDATE_REQUEST: { message: "Unauthorized update request.", code: 3003 }, UNAUTHORIZED_EXTEND_REQUEST: { message: "Unauthorized extend request.", code: 3004 }, USER_REJECTED: { message: "User rejected.", code: 5e3 }, USER_REJECTED_CHAINS: { message: "User rejected chains.", code: 5001 }, USER_REJECTED_METHODS: { message: "User rejected methods.", code: 5002 }, USER_REJECTED_EVENTS: { message: "User rejected events.", code: 5003 }, UNSUPPORTED_CHAINS: { message: "Unsupported chains.", code: 5100 }, UNSUPPORTED_METHODS: { message: "Unsupported methods.", code: 5101 }, UNSUPPORTED_EVENTS: { message: "Unsupported events.", code: 5102 }, UNSUPPORTED_ACCOUNTS: { message: "Unsupported accounts.", code: 5103 }, UNSUPPORTED_NAMESPACE_KEY: { message: "Unsupported namespace key.", code: 5104 }, USER_DISCONNECTED: { message: "User disconnected.", code: 6e3 }, SESSION_SETTLEMENT_FAILED: { message: "Session settlement failed.", code: 7e3 }, WC_METHOD_UNSUPPORTED: { message: "Unsupported wc_ method.", code: 10001 } }, Oae = { NOT_INITIALIZED: { message: "Not initialized.", code: 1 }, NO_MATCHING_KEY: { message: "No matching key.", code: 2 }, RESTORE_WILL_OVERRIDE: { message: "Restore will override.", code: 3 }, RESUBSCRIBED: { message: "Resubscribed.", code: 4 }, MISSING_OR_INVALID: { message: "Missing or invalid.", code: 5 }, EXPIRED: { message: "Expired.", code: 6 }, UNKNOWN_TYPE: { message: "Unknown type.", code: 7 }, MISMATCHED_TOPIC: { message: "Mismatched topic.", code: 8 }, NON_CONFORMING_NAMESPACES: { message: "Non conforming namespaces.", code: 9 } };
function ot(t, e) {
  const { message: r, code: i } = Oae[t];
  return { message: e ? `${r} ${e}` : r, code: i };
}
function wr(t, e) {
  const { message: r, code: i } = Cae[t];
  return { message: e ? `${r} ${e}` : r, code: i };
}
function sa(t, e) {
  return Array.isArray(t) ? typeof e < "u" && t.length ? t.every(e) : !0 : !1;
}
function Mh(t) {
  return Object.getPrototypeOf(t) === Object.prototype && Object.keys(t).length;
}
function Qi(t) {
  return typeof t > "u";
}
function ii(t, e) {
  return e && Qi(t) ? !0 : typeof t == "string" && !!t.trim().length;
}
function Pw(t, e) {
  return e && Qi(t) ? !0 : typeof t == "number" && !isNaN(t);
}
function Rae(t, e) {
  const { requiredNamespaces: r } = e, i = Object.keys(t.namespaces), s = Object.keys(r);
  let n = !0;
  return Jo(s, i) ? (i.forEach((f) => {
    const { accounts: u, methods: h, events: d } = t.namespaces[f], l = au(u), m = r[f];
    (!Jo(hT(f, m), l) || !Jo(m.methods, h) || !Jo(m.events, d)) && (n = !1);
  }), n) : !1;
}
function U0(t) {
  return ii(t, !1) && t.includes(":") ? t.split(":").length === 2 : !1;
}
function Lae(t) {
  if (ii(t, !1) && t.includes(":")) {
    const e = t.split(":");
    if (e.length === 3) {
      const r = e[0] + ":" + e[1];
      return !!e[2] && U0(r);
    }
  }
  return !1;
}
function Pae(t) {
  function e(r) {
    try {
      return typeof new URL(r) < "u";
    } catch {
      return !1;
    }
  }
  try {
    if (ii(t, !1)) {
      if (e(t))
        return !0;
      const r = yT(t);
      return e(r);
    }
  } catch {
  }
  return !1;
}
function kae(t) {
  var e;
  return (e = t == null ? void 0 : t.proposer) == null ? void 0 : e.publicKey;
}
function jae(t) {
  return t == null ? void 0 : t.topic;
}
function Bae(t, e) {
  let r = null;
  return ii(t == null ? void 0 : t.publicKey, !1) || (r = ot("MISSING_OR_INVALID", `${e} controller public key should be a string`)), r;
}
function hx(t) {
  let e = !0;
  return sa(t) ? t.length && (e = t.every((r) => ii(r, !1))) : e = !1, e;
}
function zae(t, e, r) {
  let i = null;
  return sa(e) && e.length ? e.forEach((s) => {
    i || U0(s) || (i = wr("UNSUPPORTED_CHAINS", `${r}, chain ${s} should be a string and conform to "namespace:chainId" format`));
  }) : U0(t) || (i = wr("UNSUPPORTED_CHAINS", `${r}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), i;
}
function Uae(t, e, r) {
  let i = null;
  return Object.entries(t).forEach(([s, n]) => {
    if (i)
      return;
    const f = zae(s, hT(s, n), `${e} ${r}`);
    f && (i = f);
  }), i;
}
function Fae(t, e) {
  let r = null;
  return sa(t) ? t.forEach((i) => {
    r || Lae(i) || (r = wr("UNSUPPORTED_ACCOUNTS", `${e}, account ${i} should be a string and conform to "namespace:chainId:address" format`));
  }) : r = wr("UNSUPPORTED_ACCOUNTS", `${e}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), r;
}
function $ae(t, e) {
  let r = null;
  return Object.values(t).forEach((i) => {
    if (r)
      return;
    const s = Fae(i == null ? void 0 : i.accounts, `${e} namespace`);
    s && (r = s);
  }), r;
}
function qae(t, e) {
  let r = null;
  return hx(t == null ? void 0 : t.methods) ? hx(t == null ? void 0 : t.events) || (r = wr("UNSUPPORTED_EVENTS", `${e}, events should be an array of strings or empty array for no events`)) : r = wr("UNSUPPORTED_METHODS", `${e}, methods should be an array of strings or empty array for no methods`), r;
}
function IT(t, e) {
  let r = null;
  return Object.values(t).forEach((i) => {
    if (r)
      return;
    const s = qae(i, `${e}, namespace`);
    s && (r = s);
  }), r;
}
function Hae(t, e, r) {
  let i = null;
  if (t && Mh(t)) {
    const s = IT(t, e);
    s && (i = s);
    const n = Uae(t, e, r);
    n && (i = n);
  } else
    i = ot("MISSING_OR_INVALID", `${e}, ${r} should be an object with data`);
  return i;
}
function Py(t, e) {
  let r = null;
  if (t && Mh(t)) {
    const i = IT(t, e);
    i && (r = i);
    const s = $ae(t, e);
    s && (r = s);
  } else
    r = ot("MISSING_OR_INVALID", `${e}, namespaces should be an object with data`);
  return r;
}
function AT(t) {
  return ii(t.protocol, !0);
}
function Wae(t, e) {
  let r = !1;
  return e && !t ? r = !0 : t && sa(t) && t.length && t.forEach((i) => {
    r = AT(i);
  }), r;
}
function Vae(t) {
  return typeof t == "number";
}
function fn(t) {
  return typeof t < "u" && typeof t !== null;
}
function Gae(t) {
  return !(!t || typeof t != "object" || !t.code || !Pw(t.code, !1) || !t.message || !ii(t.message, !1));
}
function Kae(t) {
  return !(Qi(t) || !ii(t.method, !1));
}
function Yae(t) {
  return !(Qi(t) || Qi(t.result) && Qi(t.error) || !Pw(t.id, !1) || !ii(t.jsonrpc, !1));
}
function Qae(t) {
  return !(Qi(t) || !ii(t.name, !1));
}
function lx(t, e) {
  return !(!U0(e) || !Aae(t).includes(e));
}
function Zae(t, e, r) {
  return ii(r, !1) ? Tae(t, e).includes(r) : !1;
}
function Jae(t, e, r) {
  return ii(r, !1) ? Nae(t, e).includes(r) : !1;
}
function dx(t, e, r) {
  let i = null;
  const s = Xae(t), n = eoe(e), f = Object.keys(s), u = Object.keys(n), h = px(Object.keys(t)), d = px(Object.keys(e)), l = h.filter((m) => !d.includes(m));
  return l.length && (i = ot("NON_CONFORMING_NAMESPACES", `${r} namespaces keys don't satisfy requiredNamespaces.
      Required: ${l.toString()}
      Received: ${Object.keys(e).toString()}`)), Jo(f, u) || (i = ot("NON_CONFORMING_NAMESPACES", `${r} namespaces chains don't satisfy required namespaces.
      Required: ${f.toString()}
      Approved: ${u.toString()}`)), Object.keys(e).forEach((m) => {
    if (!m.includes(":") || i)
      return;
    const b = au(e[m].accounts);
    b.includes(m) || (i = ot("NON_CONFORMING_NAMESPACES", `${r} namespaces accounts don't satisfy namespace accounts for ${m}
        Required: ${m}
        Approved: ${b.toString()}`));
  }), f.forEach((m) => {
    i || (Jo(s[m].methods, n[m].methods) ? Jo(s[m].events, n[m].events) || (i = ot("NON_CONFORMING_NAMESPACES", `${r} namespaces events don't satisfy namespace events for ${m}`)) : i = ot("NON_CONFORMING_NAMESPACES", `${r} namespaces methods don't satisfy namespace methods for ${m}`));
  }), i;
}
function Xae(t) {
  const e = {};
  return Object.keys(t).forEach((r) => {
    var i;
    r.includes(":") ? e[r] = t[r] : (i = t[r].chains) == null || i.forEach((s) => {
      e[s] = { methods: t[r].methods, events: t[r].events };
    });
  }), e;
}
function px(t) {
  return [...new Set(t.map((e) => e.includes(":") ? e.split(":")[0] : e))];
}
function eoe(t) {
  const e = {};
  return Object.keys(t).forEach((r) => {
    if (r.includes(":"))
      e[r] = t[r];
    else {
      const i = au(t[r].accounts);
      i == null || i.forEach((s) => {
        e[s] = { accounts: t[r].accounts.filter((n) => n.includes(`${s}:`)), methods: t[r].methods, events: t[r].events };
      });
    }
  }), e;
}
function toe(t, e) {
  return Pw(t, !1) && t <= e.max && t >= e.min;
}
function vx() {
  const t = al();
  return new Promise((e) => {
    switch (t) {
      case In.browser:
        e(roe());
        break;
      case In.reactNative:
        e(ioe());
        break;
      case In.node:
        e(noe());
        break;
      default:
        e(!0);
    }
  });
}
function roe() {
  return sl() && (navigator == null ? void 0 : navigator.onLine);
}
async function ioe() {
  if (su() && typeof global < "u" && global != null && global.NetInfo) {
    const t = await (global == null ? void 0 : global.NetInfo.fetch());
    return t == null ? void 0 : t.isConnected;
  }
  return !0;
}
function noe() {
  return !0;
}
function soe(t) {
  switch (al()) {
    case In.browser:
      aoe(t);
      break;
    case In.reactNative:
      ooe(t);
      break;
  }
}
function aoe(t) {
  !su() && sl() && (window.addEventListener("online", () => t(!0)), window.addEventListener("offline", () => t(!1)));
}
function ooe(t) {
  su() && typeof global < "u" && global != null && global.NetInfo && (global == null || global.NetInfo.addEventListener((e) => t(e == null ? void 0 : e.isConnected)));
}
const ky = {};
class $u {
  static get(e) {
    return ky[e];
  }
  static set(e, r) {
    ky[e] = r;
  }
  static delete(e) {
    delete ky[e];
  }
}
class Mf {
}
class foe extends Mf {
  constructor(e) {
    super();
  }
}
const gx = ct.FIVE_SECONDS, ou = { pulse: "heartbeat_pulse" };
class kw extends foe {
  constructor(e) {
    super(e), this.events = new Pr.exports.EventEmitter(), this.interval = gx, this.interval = (e == null ? void 0 : e.interval) || gx;
  }
  static async init(e) {
    const r = new kw(e);
    return await r.init(), r;
  }
  async init() {
    await this.initialize();
  }
  stop() {
    clearInterval(this.intervalRef);
  }
  on(e, r) {
    this.events.on(e, r);
  }
  once(e, r) {
    this.events.once(e, r);
  }
  off(e, r) {
    this.events.off(e, r);
  }
  removeListener(e, r) {
    this.events.removeListener(e, r);
  }
  async initialize() {
    this.intervalRef = setInterval(() => this.pulse(), ct.toMiliseconds(this.interval));
  }
  pulse() {
    this.events.emit(ou.pulse);
  }
}
const coe = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/, uoe = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/, hoe = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function loe(t, e) {
  if (t === "__proto__" || t === "constructor" && e && typeof e == "object" && "prototype" in e) {
    doe(t);
    return;
  }
  return e;
}
function doe(t) {
  console.warn(`[destr] Dropping "${t}" key to prevent prototype pollution.`);
}
function Bd(t, e = {}) {
  if (typeof t != "string")
    return t;
  const r = t.trim();
  if (t[0] === '"' && t.endsWith('"') && !t.includes("\\"))
    return r.slice(1, -1);
  if (r.length <= 9) {
    const i = r.toLowerCase();
    if (i === "true")
      return !0;
    if (i === "false")
      return !1;
    if (i === "undefined")
      return;
    if (i === "null")
      return null;
    if (i === "nan")
      return Number.NaN;
    if (i === "infinity")
      return Number.POSITIVE_INFINITY;
    if (i === "-infinity")
      return Number.NEGATIVE_INFINITY;
  }
  if (!hoe.test(t)) {
    if (e.strict)
      throw new SyntaxError("[destr] Invalid JSON");
    return t;
  }
  try {
    if (coe.test(t) || uoe.test(t)) {
      if (e.strict)
        throw new Error("[destr] Possible prototype pollution");
      return JSON.parse(t, loe);
    }
    return JSON.parse(t);
  } catch (i) {
    if (e.strict)
      throw i;
    return t;
  }
}
function poe(t) {
  return !t || typeof t.then != "function" ? Promise.resolve(t) : t;
}
function vi(t, ...e) {
  try {
    return poe(t(...e));
  } catch (r) {
    return Promise.reject(r);
  }
}
function voe(t) {
  const e = typeof t;
  return t === null || e !== "object" && e !== "function";
}
function goe(t) {
  const e = Object.getPrototypeOf(t);
  return !e || e.isPrototypeOf(Object);
}
function n0(t) {
  if (voe(t))
    return String(t);
  if (goe(t) || Array.isArray(t))
    return JSON.stringify(t);
  if (typeof t.toJSON == "function")
    return n0(t.toJSON());
  throw new Error("[unstorage] Cannot stringify value!");
}
function TT() {
  if (typeof Buffer > "u")
    throw new TypeError("[unstorage] Buffer is not supported!");
}
const zm = "base64:";
function boe(t) {
  if (typeof t == "string")
    return t;
  TT();
  const e = Buffer.from(t).toString("base64");
  return zm + e;
}
function yoe(t) {
  return typeof t != "string" || !t.startsWith(zm) ? t : (TT(), Buffer.from(t.slice(zm.length), "base64"));
}
function on(t) {
  return t ? t.split("?")[0].replace(/[/\\]/g, ":").replace(/:+/g, ":").replace(/^:|:$/g, "") : "";
}
function moe(...t) {
  return on(t.join(":"));
}
function zd(t) {
  return t = on(t), t ? t + ":" : "";
}
const woe = "memory", _oe = () => {
  const t = /* @__PURE__ */ new Map();
  return {
    name: woe,
    getInstance: () => t,
    hasItem(e) {
      return t.has(e);
    },
    getItem(e) {
      var r;
      return (r = t.get(e)) != null ? r : null;
    },
    getItemRaw(e) {
      var r;
      return (r = t.get(e)) != null ? r : null;
    },
    setItem(e, r) {
      t.set(e, r);
    },
    setItemRaw(e, r) {
      t.set(e, r);
    },
    removeItem(e) {
      t.delete(e);
    },
    getKeys() {
      return [...t.keys()];
    },
    clear() {
      t.clear();
    },
    dispose() {
      t.clear();
    }
  };
};
function Moe(t = {}) {
  const e = {
    mounts: { "": t.driver || _oe() },
    mountpoints: [""],
    watching: !1,
    watchListeners: [],
    unwatch: {}
  }, r = (d) => {
    for (const l of e.mountpoints)
      if (d.startsWith(l))
        return {
          base: l,
          relativeKey: d.slice(l.length),
          driver: e.mounts[l]
        };
    return {
      base: "",
      relativeKey: d,
      driver: e.mounts[""]
    };
  }, i = (d, l) => e.mountpoints.filter(
    (m) => m.startsWith(d) || l && d.startsWith(m)
  ).map((m) => ({
    relativeBase: d.length > m.length ? d.slice(m.length) : void 0,
    mountpoint: m,
    driver: e.mounts[m]
  })), s = (d, l) => {
    if (!!e.watching) {
      l = on(l);
      for (const m of e.watchListeners)
        m(d, l);
    }
  }, n = async () => {
    if (!e.watching) {
      e.watching = !0;
      for (const d in e.mounts)
        e.unwatch[d] = await bx(
          e.mounts[d],
          s,
          d
        );
    }
  }, f = async () => {
    if (!!e.watching) {
      for (const d in e.unwatch)
        await e.unwatch[d]();
      e.unwatch = {}, e.watching = !1;
    }
  }, u = (d, l, m) => {
    const b = /* @__PURE__ */ new Map(), M = (A) => {
      let N = b.get(A.base);
      return N || (N = {
        driver: A.driver,
        base: A.base,
        items: []
      }, b.set(A.base, N)), N;
    };
    for (const A of d) {
      const N = typeof A == "string", R = on(N ? A : A.key), O = N ? void 0 : A.value, P = N || !A.options ? l : { ...l, ...A.options }, F = r(R);
      M(F).items.push({
        key: R,
        value: O,
        relativeKey: F.relativeKey,
        options: P
      });
    }
    return Promise.all([...b.values()].map((A) => m(A))).then(
      (A) => A.flat()
    );
  }, h = {
    hasItem(d, l = {}) {
      d = on(d);
      const { relativeKey: m, driver: b } = r(d);
      return vi(b.hasItem, m, l);
    },
    getItem(d, l = {}) {
      d = on(d);
      const { relativeKey: m, driver: b } = r(d);
      return vi(b.getItem, m, l).then(
        (M) => Bd(M)
      );
    },
    getItems(d, l) {
      return u(d, l, (m) => m.driver.getItems ? vi(
        m.driver.getItems,
        m.items.map((b) => ({
          key: b.relativeKey,
          options: b.options
        })),
        l
      ).then(
        (b) => b.map((M) => ({
          key: moe(m.base, M.key),
          value: Bd(M.value)
        }))
      ) : Promise.all(
        m.items.map((b) => vi(
          m.driver.getItem,
          b.relativeKey,
          b.options
        ).then((M) => ({
          key: b.key,
          value: Bd(M)
        })))
      ));
    },
    getItemRaw(d, l = {}) {
      d = on(d);
      const { relativeKey: m, driver: b } = r(d);
      return b.getItemRaw ? vi(b.getItemRaw, m, l) : vi(b.getItem, m, l).then(
        (M) => yoe(M)
      );
    },
    async setItem(d, l, m = {}) {
      if (l === void 0)
        return h.removeItem(d);
      d = on(d);
      const { relativeKey: b, driver: M } = r(d);
      !M.setItem || (await vi(M.setItem, b, n0(l), m), M.watch || s("update", d));
    },
    async setItems(d, l) {
      await u(d, l, async (m) => {
        if (m.driver.setItems)
          return vi(
            m.driver.setItems,
            m.items.map((b) => ({
              key: b.relativeKey,
              value: n0(b.value),
              options: b.options
            })),
            l
          );
        !m.driver.setItem || await Promise.all(
          m.items.map((b) => vi(
            m.driver.setItem,
            b.relativeKey,
            n0(b.value),
            b.options
          ))
        );
      });
    },
    async setItemRaw(d, l, m = {}) {
      if (l === void 0)
        return h.removeItem(d, m);
      d = on(d);
      const { relativeKey: b, driver: M } = r(d);
      if (M.setItemRaw)
        await vi(M.setItemRaw, b, l, m);
      else if (M.setItem)
        await vi(M.setItem, b, boe(l), m);
      else
        return;
      M.watch || s("update", d);
    },
    async removeItem(d, l = {}) {
      typeof l == "boolean" && (l = { removeMeta: l }), d = on(d);
      const { relativeKey: m, driver: b } = r(d);
      !b.removeItem || (await vi(b.removeItem, m, l), (l.removeMeta || l.removeMata) && await vi(b.removeItem, m + "$", l), b.watch || s("remove", d));
    },
    async getMeta(d, l = {}) {
      typeof l == "boolean" && (l = { nativeOnly: l }), d = on(d);
      const { relativeKey: m, driver: b } = r(d), M = /* @__PURE__ */ Object.create(null);
      if (b.getMeta && Object.assign(M, await vi(b.getMeta, m, l)), !l.nativeOnly) {
        const A = await vi(
          b.getItem,
          m + "$",
          l
        ).then((N) => Bd(N));
        A && typeof A == "object" && (typeof A.atime == "string" && (A.atime = new Date(A.atime)), typeof A.mtime == "string" && (A.mtime = new Date(A.mtime)), Object.assign(M, A));
      }
      return M;
    },
    setMeta(d, l, m = {}) {
      return this.setItem(d + "$", l, m);
    },
    removeMeta(d, l = {}) {
      return this.removeItem(d + "$", l);
    },
    async getKeys(d, l = {}) {
      d = zd(d);
      const m = i(d, !0);
      let b = [];
      const M = [];
      for (const A of m) {
        const N = await vi(
          A.driver.getKeys,
          A.relativeBase,
          l
        );
        for (const R of N) {
          const O = A.mountpoint + on(R);
          b.some((P) => O.startsWith(P)) || M.push(O);
        }
        b = [
          A.mountpoint,
          ...b.filter((R) => !R.startsWith(A.mountpoint))
        ];
      }
      return d ? M.filter(
        (A) => A.startsWith(d) && A[A.length - 1] !== "$"
      ) : M.filter((A) => A[A.length - 1] !== "$");
    },
    async clear(d, l = {}) {
      d = zd(d), await Promise.all(
        i(d, !1).map(async (m) => {
          if (m.driver.clear)
            return vi(m.driver.clear, m.relativeBase, l);
          if (m.driver.removeItem) {
            const b = await m.driver.getKeys(m.relativeBase || "", l);
            return Promise.all(
              b.map((M) => m.driver.removeItem(M, l))
            );
          }
        })
      );
    },
    async dispose() {
      await Promise.all(
        Object.values(e.mounts).map((d) => yx(d))
      );
    },
    async watch(d) {
      return await n(), e.watchListeners.push(d), async () => {
        e.watchListeners = e.watchListeners.filter(
          (l) => l !== d
        ), e.watchListeners.length === 0 && await f();
      };
    },
    async unwatch() {
      e.watchListeners = [], await f();
    },
    mount(d, l) {
      if (d = zd(d), d && e.mounts[d])
        throw new Error(`already mounted at ${d}`);
      return d && (e.mountpoints.push(d), e.mountpoints.sort((m, b) => b.length - m.length)), e.mounts[d] = l, e.watching && Promise.resolve(bx(l, s, d)).then((m) => {
        e.unwatch[d] = m;
      }).catch(console.error), h;
    },
    async unmount(d, l = !0) {
      d = zd(d), !(!d || !e.mounts[d]) && (e.watching && d in e.unwatch && (e.unwatch[d](), delete e.unwatch[d]), l && await yx(e.mounts[d]), e.mountpoints = e.mountpoints.filter((m) => m !== d), delete e.mounts[d]);
    },
    getMount(d = "") {
      d = on(d) + ":";
      const l = r(d);
      return {
        driver: l.driver,
        base: l.base
      };
    },
    getMounts(d = "", l = {}) {
      return d = on(d), i(d, l.parents).map((b) => ({
        driver: b.driver,
        base: b.mountpoint
      }));
    },
    keys: (d, l = {}) => h.getKeys(d, l),
    get: (d, l = {}) => h.getItem(d, l),
    set: (d, l, m = {}) => h.setItem(d, l, m),
    has: (d, l = {}) => h.hasItem(d, l),
    del: (d, l = {}) => h.removeItem(d, l),
    remove: (d, l = {}) => h.removeItem(d, l)
  };
  return h;
}
function bx(t, e, r) {
  return t.watch ? t.watch((i, s) => e(i, r + s)) : () => {
  };
}
async function yx(t) {
  typeof t.dispose == "function" && await vi(t.dispose);
}
function xf(t) {
  return new Promise((e, r) => {
    t.oncomplete = t.onsuccess = () => e(t.result), t.onabort = t.onerror = () => r(t.error);
  });
}
function NT(t, e) {
  const r = indexedDB.open(t);
  r.onupgradeneeded = () => r.result.createObjectStore(e);
  const i = xf(r);
  return (s, n) => i.then((f) => n(f.transaction(e, s).objectStore(e)));
}
let jy;
function cl() {
  return jy || (jy = NT("keyval-store", "keyval")), jy;
}
function mx(t, e = cl()) {
  return e("readonly", (r) => xf(r.get(t)));
}
function xoe(t, e, r = cl()) {
  return r("readwrite", (i) => (i.put(e, t), xf(i.transaction)));
}
function Soe(t, e = cl()) {
  return e("readwrite", (r) => (r.delete(t), xf(r.transaction)));
}
function Eoe(t = cl()) {
  return t("readwrite", (e) => (e.clear(), xf(e.transaction)));
}
function Ioe(t, e) {
  return t.openCursor().onsuccess = function() {
    !this.result || (e(this.result), this.result.continue());
  }, xf(t.transaction);
}
function Aoe(t = cl()) {
  return t("readonly", (e) => {
    if (e.getAllKeys)
      return xf(e.getAllKeys());
    const r = [];
    return Ioe(e, (i) => r.push(i.key)).then(() => r);
  });
}
const Toe = "idb-keyval";
var Noe = (t = {}) => {
  const e = t.base && t.base.length > 0 ? `${t.base}:` : "", r = (s) => e + s;
  let i;
  return t.dbName && t.storeName && (i = NT(t.dbName, t.storeName)), { name: Toe, options: t, async hasItem(s) {
    return !(typeof await mx(r(s), i) > "u");
  }, async getItem(s) {
    var n;
    return (n = await mx(r(s), i)) != null ? n : null;
  }, setItem(s, n) {
    return xoe(r(s), n, i);
  }, removeItem(s) {
    return Soe(r(s), i);
  }, getKeys() {
    return Aoe(i);
  }, clear() {
    return Eoe(i);
  } };
};
const Doe = "WALLET_CONNECT_V2_INDEXED_DB", Coe = "keyvaluestorage";
class Ooe {
  constructor() {
    this.indexedDb = Moe({ driver: Noe({ dbName: Doe, storeName: Coe }) });
  }
  async getKeys() {
    return this.indexedDb.getKeys();
  }
  async getEntries() {
    return (await this.indexedDb.getItems(await this.indexedDb.getKeys())).map((e) => [e.key, e.value]);
  }
  async getItem(e) {
    const r = await this.indexedDb.getItem(e);
    if (r !== null)
      return r;
  }
  async setItem(e, r) {
    await this.indexedDb.setItem(e, Pa(r));
  }
  async removeItem(e) {
    await this.indexedDb.removeItem(e);
  }
}
var By = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, s0 = { exports: {} };
(function() {
  let t;
  function e() {
  }
  t = e, t.prototype.getItem = function(r) {
    return this.hasOwnProperty(r) ? String(this[r]) : null;
  }, t.prototype.setItem = function(r, i) {
    this[r] = String(i);
  }, t.prototype.removeItem = function(r) {
    delete this[r];
  }, t.prototype.clear = function() {
    const r = this;
    Object.keys(r).forEach(function(i) {
      r[i] = void 0, delete r[i];
    });
  }, t.prototype.key = function(r) {
    return r = r || 0, Object.keys(this)[r];
  }, t.prototype.__defineGetter__("length", function() {
    return Object.keys(this).length;
  }), typeof By < "u" && By.localStorage ? s0.exports = By.localStorage : typeof window < "u" && window.localStorage ? s0.exports = window.localStorage : s0.exports = new e();
})();
function Roe(t) {
  var e;
  return [t[0], uf((e = t[1]) != null ? e : "")];
}
class Loe {
  constructor() {
    this.localStorage = s0.exports;
  }
  async getKeys() {
    return Object.keys(this.localStorage);
  }
  async getEntries() {
    return Object.entries(this.localStorage).map(Roe);
  }
  async getItem(e) {
    const r = this.localStorage.getItem(e);
    if (r !== null)
      return uf(r);
  }
  async setItem(e, r) {
    this.localStorage.setItem(e, Pa(r));
  }
  async removeItem(e) {
    this.localStorage.removeItem(e);
  }
}
const Poe = "wc_storage_version", wx = 1, koe = async (t, e, r) => {
  const i = Poe, s = await e.getItem(i);
  if (s && s >= wx) {
    r(e);
    return;
  }
  const n = await t.getKeys();
  if (!n.length) {
    r(e);
    return;
  }
  const f = [];
  for (; n.length; ) {
    const u = n.shift();
    if (!u)
      continue;
    const h = u.toLowerCase();
    if (h.includes("wc@") || h.includes("walletconnect") || h.includes("wc_") || h.includes("wallet_connect")) {
      const d = await t.getItem(u);
      await e.setItem(u, d), f.push(u);
    }
  }
  await e.setItem(i, wx), r(e), joe(t, f);
}, joe = async (t, e) => {
  e.length && e.forEach(async (r) => {
    await t.removeItem(r);
  });
};
class Boe {
  constructor() {
    this.initialized = !1, this.setInitialized = (r) => {
      this.storage = r, this.initialized = !0;
    };
    const e = new Loe();
    this.storage = e;
    try {
      const r = new Ooe();
      koe(e, r, this.setInitialized);
    } catch {
      this.initialized = !0;
    }
  }
  async getKeys() {
    return await this.initialize(), this.storage.getKeys();
  }
  async getEntries() {
    return await this.initialize(), this.storage.getEntries();
  }
  async getItem(e) {
    return await this.initialize(), this.storage.getItem(e);
  }
  async setItem(e, r) {
    return await this.initialize(), this.storage.setItem(e, r);
  }
  async removeItem(e) {
    return await this.initialize(), this.storage.removeItem(e);
  }
  async initialize() {
    this.initialized || await new Promise((e) => {
      const r = setInterval(() => {
        this.initialized && (clearInterval(r), e());
      }, 20);
    });
  }
}
function zoe(t) {
  try {
    return JSON.stringify(t);
  } catch {
    return '"[Circular]"';
  }
}
var Uoe = Foe;
function Foe(t, e, r) {
  var i = r && r.stringify || zoe, s = 1;
  if (typeof t == "object" && t !== null) {
    var n = e.length + s;
    if (n === 1)
      return t;
    var f = new Array(n);
    f[0] = i(t);
    for (var u = 1; u < n; u++)
      f[u] = i(e[u]);
    return f.join(" ");
  }
  if (typeof t != "string")
    return t;
  var h = e.length;
  if (h === 0)
    return t;
  for (var d = "", l = 1 - s, m = -1, b = t && t.length || 0, M = 0; M < b; ) {
    if (t.charCodeAt(M) === 37 && M + 1 < b) {
      switch (m = m > -1 ? m : 0, t.charCodeAt(M + 1)) {
        case 100:
        case 102:
          if (l >= h || e[l] == null)
            break;
          m < M && (d += t.slice(m, M)), d += Number(e[l]), m = M + 2, M++;
          break;
        case 105:
          if (l >= h || e[l] == null)
            break;
          m < M && (d += t.slice(m, M)), d += Math.floor(Number(e[l])), m = M + 2, M++;
          break;
        case 79:
        case 111:
        case 106:
          if (l >= h || e[l] === void 0)
            break;
          m < M && (d += t.slice(m, M));
          var A = typeof e[l];
          if (A === "string") {
            d += "'" + e[l] + "'", m = M + 2, M++;
            break;
          }
          if (A === "function") {
            d += e[l].name || "<anonymous>", m = M + 2, M++;
            break;
          }
          d += i(e[l]), m = M + 2, M++;
          break;
        case 115:
          if (l >= h)
            break;
          m < M && (d += t.slice(m, M)), d += String(e[l]), m = M + 2, M++;
          break;
        case 37:
          m < M && (d += t.slice(m, M)), d += "%", m = M + 2, M++, l--;
          break;
      }
      ++l;
    }
    ++M;
  }
  return m === -1 ? t : (m < b && (d += t.slice(m)), d);
}
const _x = Uoe;
var Ys = ta;
const xh = Zoe().console || {}, $oe = {
  mapHttpRequest: Ud,
  mapHttpResponse: Ud,
  wrapRequestSerializer: zy,
  wrapResponseSerializer: zy,
  wrapErrorSerializer: zy,
  req: Ud,
  res: Ud,
  err: Goe
};
function qoe(t, e) {
  return Array.isArray(t) ? t.filter(function(i) {
    return i !== "!stdSerializers.err";
  }) : t === !0 ? Object.keys(e) : !1;
}
function ta(t) {
  t = t || {}, t.browser = t.browser || {};
  const e = t.browser.transmit;
  if (e && typeof e.send != "function")
    throw Error("pino: transmit option must have a send function");
  const r = t.browser.write || xh;
  t.browser.write && (t.browser.asObject = !0);
  const i = t.serializers || {}, s = qoe(t.browser.serialize, i);
  let n = t.browser.serialize;
  Array.isArray(t.browser.serialize) && t.browser.serialize.indexOf("!stdSerializers.err") > -1 && (n = !1);
  const f = ["error", "fatal", "warn", "info", "debug", "trace"];
  typeof r == "function" && (r.error = r.fatal = r.warn = r.info = r.debug = r.trace = r), t.enabled === !1 && (t.level = "silent");
  const u = t.level || "info", h = Object.create(r);
  h.log || (h.log = Sh), Object.defineProperty(h, "levelVal", {
    get: l
  }), Object.defineProperty(h, "level", {
    get: m,
    set: b
  });
  const d = {
    transmit: e,
    serialize: s,
    asObject: t.browser.asObject,
    levels: f,
    timestamp: Koe(t)
  };
  h.levels = ta.levels, h.level = u, h.setMaxListeners = h.getMaxListeners = h.emit = h.addListener = h.on = h.prependListener = h.once = h.prependOnceListener = h.removeListener = h.removeAllListeners = h.listeners = h.listenerCount = h.eventNames = h.write = h.flush = Sh, h.serializers = i, h._serialize = s, h._stdErrSerialize = n, h.child = M, e && (h._logEvent = Um());
  function l() {
    return this.level === "silent" ? 1 / 0 : this.levels.values[this.level];
  }
  function m() {
    return this._level;
  }
  function b(A) {
    if (A !== "silent" && !this.levels.values[A])
      throw Error("unknown level " + A);
    this._level = A, Qf(d, h, "error", "log"), Qf(d, h, "fatal", "error"), Qf(d, h, "warn", "error"), Qf(d, h, "info", "log"), Qf(d, h, "debug", "log"), Qf(d, h, "trace", "log");
  }
  function M(A, N) {
    if (!A)
      throw new Error("missing bindings for child Pino");
    N = N || {}, s && A.serializers && (N.serializers = A.serializers);
    const R = N.serializers;
    if (s && R) {
      var O = Object.assign({}, i, R), P = t.browser.serialize === !0 ? Object.keys(O) : s;
      delete A.serializers, a1([A], P, O, this._stdErrSerialize);
    }
    function F(H) {
      this._childLevel = (H._childLevel | 0) + 1, this.error = Zf(H, A, "error"), this.fatal = Zf(H, A, "fatal"), this.warn = Zf(H, A, "warn"), this.info = Zf(H, A, "info"), this.debug = Zf(H, A, "debug"), this.trace = Zf(H, A, "trace"), O && (this.serializers = O, this._serialize = P), e && (this._logEvent = Um(
        [].concat(H._logEvent.bindings, A)
      ));
    }
    return F.prototype = this, new F(this);
  }
  return h;
}
ta.levels = {
  values: {
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10
  },
  labels: {
    10: "trace",
    20: "debug",
    30: "info",
    40: "warn",
    50: "error",
    60: "fatal"
  }
};
ta.stdSerializers = $oe;
ta.stdTimeFunctions = Object.assign({}, { nullTime: DT, epochTime: CT, unixTime: Yoe, isoTime: Qoe });
function Qf(t, e, r, i) {
  const s = Object.getPrototypeOf(e);
  e[r] = e.levelVal > e.levels.values[r] ? Sh : s[r] ? s[r] : xh[r] || xh[i] || Sh, Hoe(t, e, r);
}
function Hoe(t, e, r) {
  !t.transmit && e[r] === Sh || (e[r] = function(i) {
    return function() {
      const n = t.timestamp(), f = new Array(arguments.length), u = Object.getPrototypeOf && Object.getPrototypeOf(this) === xh ? xh : this;
      for (var h = 0; h < f.length; h++)
        f[h] = arguments[h];
      if (t.serialize && !t.asObject && a1(f, this._serialize, this.serializers, this._stdErrSerialize), t.asObject ? i.call(u, Woe(this, r, f, n)) : i.apply(u, f), t.transmit) {
        const d = t.transmit.level || e.level, l = ta.levels.values[d], m = ta.levels.values[r];
        if (m < l)
          return;
        Voe(this, {
          ts: n,
          methodLevel: r,
          methodValue: m,
          transmitLevel: d,
          transmitValue: ta.levels.values[t.transmit.level || e.level],
          send: t.transmit.send,
          val: e.levelVal
        }, f);
      }
    };
  }(e[r]));
}
function Woe(t, e, r, i) {
  t._serialize && a1(r, t._serialize, t.serializers, t._stdErrSerialize);
  const s = r.slice();
  let n = s[0];
  const f = {};
  i && (f.time = i), f.level = ta.levels.values[e];
  let u = (t._childLevel | 0) + 1;
  if (u < 1 && (u = 1), n !== null && typeof n == "object") {
    for (; u-- && typeof s[0] == "object"; )
      Object.assign(f, s.shift());
    n = s.length ? _x(s.shift(), s) : void 0;
  } else
    typeof n == "string" && (n = _x(s.shift(), s));
  return n !== void 0 && (f.msg = n), f;
}
function a1(t, e, r, i) {
  for (const s in t)
    if (i && t[s] instanceof Error)
      t[s] = ta.stdSerializers.err(t[s]);
    else if (typeof t[s] == "object" && !Array.isArray(t[s]))
      for (const n in t[s])
        e && e.indexOf(n) > -1 && n in r && (t[s][n] = r[n](t[s][n]));
}
function Zf(t, e, r) {
  return function() {
    const i = new Array(1 + arguments.length);
    i[0] = e;
    for (var s = 1; s < i.length; s++)
      i[s] = arguments[s - 1];
    return t[r].apply(this, i);
  };
}
function Voe(t, e, r) {
  const i = e.send, s = e.ts, n = e.methodLevel, f = e.methodValue, u = e.val, h = t._logEvent.bindings;
  a1(
    r,
    t._serialize || Object.keys(t.serializers),
    t.serializers,
    t._stdErrSerialize === void 0 ? !0 : t._stdErrSerialize
  ), t._logEvent.ts = s, t._logEvent.messages = r.filter(function(d) {
    return h.indexOf(d) === -1;
  }), t._logEvent.level.label = n, t._logEvent.level.value = f, i(n, t._logEvent, u), t._logEvent = Um(h);
}
function Um(t) {
  return {
    ts: 0,
    messages: [],
    bindings: t || [],
    level: { label: "", value: 0 }
  };
}
function Goe(t) {
  const e = {
    type: t.constructor.name,
    msg: t.message,
    stack: t.stack
  };
  for (const r in t)
    e[r] === void 0 && (e[r] = t[r]);
  return e;
}
function Koe(t) {
  return typeof t.timestamp == "function" ? t.timestamp : t.timestamp === !1 ? DT : CT;
}
function Ud() {
  return {};
}
function zy(t) {
  return t;
}
function Sh() {
}
function DT() {
  return !1;
}
function CT() {
  return Date.now();
}
function Yoe() {
  return Math.round(Date.now() / 1e3);
}
function Qoe() {
  return new Date(Date.now()).toISOString();
}
function Zoe() {
  function t(e) {
    return typeof e < "u" && e;
  }
  try {
    return typeof globalThis < "u" || Object.defineProperty(Object.prototype, "globalThis", {
      get: function() {
        return delete Object.prototype.globalThis, this.globalThis = this;
      },
      configurable: !0
    }), globalThis;
  } catch {
    return t(self) || t(window) || t(this) || {};
  }
}
const Joe = { level: "info" }, ul = "custom_context", jw = 1e3 * 1024;
class Xoe {
  constructor(e) {
    this.nodeValue = e, this.sizeInBytes = new TextEncoder().encode(this.nodeValue).length, this.next = null;
  }
  get value() {
    return this.nodeValue;
  }
  get size() {
    return this.sizeInBytes;
  }
}
class Mx {
  constructor(e) {
    this.head = null, this.tail = null, this.lengthInNodes = 0, this.maxSizeInBytes = e, this.sizeInBytes = 0;
  }
  append(e) {
    const r = new Xoe(e);
    if (r.size > this.maxSizeInBytes)
      throw new Error(`[LinkedList] Value too big to insert into list: ${e} with size ${r.size}`);
    for (; this.size + r.size > this.maxSizeInBytes; )
      this.shift();
    this.head ? (this.tail && (this.tail.next = r), this.tail = r) : (this.head = r, this.tail = r), this.lengthInNodes++, this.sizeInBytes += r.size;
  }
  shift() {
    if (!this.head)
      return;
    const e = this.head;
    this.head = this.head.next, this.head || (this.tail = null), this.lengthInNodes--, this.sizeInBytes -= e.size;
  }
  toArray() {
    const e = [];
    let r = this.head;
    for (; r !== null; )
      e.push(r.value), r = r.next;
    return e;
  }
  get length() {
    return this.lengthInNodes;
  }
  get size() {
    return this.sizeInBytes;
  }
  toOrderedArray() {
    return Array.from(this);
  }
  [Symbol.iterator]() {
    let e = this.head;
    return { next: () => {
      if (!e)
        return { done: !0, value: null };
      const r = e.value;
      return e = e.next, { done: !1, value: r };
    } };
  }
}
class OT {
  constructor(e, r = jw) {
    this.level = e != null ? e : "error", this.levelValue = Ys.levels.values[this.level], this.MAX_LOG_SIZE_IN_BYTES = r, this.logs = new Mx(this.MAX_LOG_SIZE_IN_BYTES);
  }
  forwardToConsole(e, r) {
    r === Ys.levels.values.error ? console.error(e) : r === Ys.levels.values.warn ? console.warn(e) : r === Ys.levels.values.debug ? console.debug(e) : r === Ys.levels.values.trace ? console.trace(e) : console.log(e);
  }
  appendToLogs(e) {
    this.logs.append(Pa({ timestamp: new Date().toISOString(), log: e }));
    const r = typeof e == "string" ? JSON.parse(e).level : e.level;
    r >= this.levelValue && this.forwardToConsole(e, r);
  }
  getLogs() {
    return this.logs;
  }
  clearLogs() {
    this.logs = new Mx(this.MAX_LOG_SIZE_IN_BYTES);
  }
  getLogArray() {
    return Array.from(this.logs);
  }
  logsToBlob(e) {
    const r = this.getLogArray();
    return r.push(Pa({ extraMetadata: e })), new Blob(r, { type: "application/json" });
  }
}
class efe {
  constructor(e, r = jw) {
    this.baseChunkLogger = new OT(e, r);
  }
  write(e) {
    this.baseChunkLogger.appendToLogs(e);
  }
  getLogs() {
    return this.baseChunkLogger.getLogs();
  }
  clearLogs() {
    this.baseChunkLogger.clearLogs();
  }
  getLogArray() {
    return this.baseChunkLogger.getLogArray();
  }
  logsToBlob(e) {
    return this.baseChunkLogger.logsToBlob(e);
  }
  downloadLogsBlobInBrowser(e) {
    const r = URL.createObjectURL(this.logsToBlob(e)), i = document.createElement("a");
    i.href = r, i.download = `walletconnect-logs-${new Date().toISOString()}.txt`, document.body.appendChild(i), i.click(), document.body.removeChild(i), URL.revokeObjectURL(r);
  }
}
class tfe {
  constructor(e, r = jw) {
    this.baseChunkLogger = new OT(e, r);
  }
  write(e) {
    this.baseChunkLogger.appendToLogs(e);
  }
  getLogs() {
    return this.baseChunkLogger.getLogs();
  }
  clearLogs() {
    this.baseChunkLogger.clearLogs();
  }
  getLogArray() {
    return this.baseChunkLogger.getLogArray();
  }
  logsToBlob(e) {
    return this.baseChunkLogger.logsToBlob(e);
  }
}
var rfe = Object.defineProperty, ife = Object.defineProperties, nfe = Object.getOwnPropertyDescriptors, xx = Object.getOwnPropertySymbols, sfe = Object.prototype.hasOwnProperty, afe = Object.prototype.propertyIsEnumerable, Sx = (t, e, r) => e in t ? rfe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, F0 = (t, e) => {
  for (var r in e || (e = {}))
    sfe.call(e, r) && Sx(t, r, e[r]);
  if (xx)
    for (var r of xx(e))
      afe.call(e, r) && Sx(t, r, e[r]);
  return t;
}, $0 = (t, e) => ife(t, nfe(e));
function o1(t) {
  return $0(F0({}, t), { level: (t == null ? void 0 : t.level) || Joe.level });
}
function ofe(t, e = ul) {
  return t[e] || "";
}
function ffe(t, e, r = ul) {
  return t[r] = e, t;
}
function pn(t, e = ul) {
  let r = "";
  return typeof t.bindings > "u" ? r = ofe(t, e) : r = t.bindings().context || "", r;
}
function cfe(t, e, r = ul) {
  const i = pn(t, r);
  return i.trim() ? `${i}/${e}` : e;
}
function en(t, e, r = ul) {
  const i = cfe(t, e, r), s = t.child({ context: i });
  return ffe(s, i, r);
}
function ufe(t) {
  var e, r;
  const i = new efe((e = t.opts) == null ? void 0 : e.level, t.maxSizeInBytes);
  return { logger: Ys($0(F0({}, t.opts), { level: "trace", browser: $0(F0({}, (r = t.opts) == null ? void 0 : r.browser), { write: (s) => i.write(s) }) })), chunkLoggerController: i };
}
function hfe(t) {
  var e;
  const r = new tfe((e = t.opts) == null ? void 0 : e.level, t.maxSizeInBytes);
  return { logger: Ys($0(F0({}, t.opts), { level: "trace" })), chunkLoggerController: r };
}
function lfe(t) {
  return typeof t.loggerOverride < "u" && typeof t.loggerOverride != "string" ? { logger: t.loggerOverride, chunkLoggerController: null } : typeof window < "u" ? ufe(t) : hfe(t);
}
class dfe extends Mf {
  constructor(e) {
    super(), this.opts = e, this.protocol = "wc", this.version = 2;
  }
}
class pfe extends Mf {
  constructor(e, r) {
    super(), this.core = e, this.logger = r, this.records = /* @__PURE__ */ new Map();
  }
}
class vfe {
  constructor(e, r) {
    this.logger = e, this.core = r;
  }
}
class gfe extends Mf {
  constructor(e, r) {
    super(), this.relayer = e, this.logger = r;
  }
}
class bfe extends Mf {
  constructor(e) {
    super();
  }
}
class yfe {
  constructor(e, r, i, s) {
    this.core = e, this.logger = r, this.name = i;
  }
}
class mfe extends Mf {
  constructor(e, r) {
    super(), this.relayer = e, this.logger = r;
  }
}
class wfe extends Mf {
  constructor(e, r) {
    super(), this.core = e, this.logger = r;
  }
}
class _fe {
  constructor(e, r, i) {
    this.core = e, this.logger = r, this.store = i;
  }
}
class Mfe {
  constructor(e, r) {
    this.projectId = e, this.logger = r;
  }
}
class xfe {
  constructor(e, r, i) {
    this.core = e, this.logger = r, this.telemetryEnabled = i;
  }
}
class Sfe {
  constructor(e) {
    this.opts = e, this.protocol = "wc", this.version = 2;
  }
}
class Efe {
  constructor(e) {
    this.client = e;
  }
}
const Ife = "PARSE_ERROR", Afe = "INVALID_REQUEST", Tfe = "METHOD_NOT_FOUND", Nfe = "INVALID_PARAMS", RT = "INTERNAL_ERROR", Bw = "SERVER_ERROR", Dfe = [-32700, -32600, -32601, -32602, -32603], oh = {
  [Ife]: { code: -32700, message: "Parse error" },
  [Afe]: { code: -32600, message: "Invalid Request" },
  [Tfe]: { code: -32601, message: "Method not found" },
  [Nfe]: { code: -32602, message: "Invalid params" },
  [RT]: { code: -32603, message: "Internal error" },
  [Bw]: { code: -32e3, message: "Server error" }
}, LT = Bw;
function Cfe(t) {
  return Dfe.includes(t);
}
function Ex(t) {
  return Object.keys(oh).includes(t) ? oh[t] : oh[LT];
}
function Ofe(t) {
  const e = Object.values(oh).find((r) => r.code === t);
  return e || oh[LT];
}
function PT(t, e, r) {
  return t.message.includes("getaddrinfo ENOTFOUND") || t.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${r} RPC url at ${e}`) : t;
}
var kT = {}, jT = { exports: {} };
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
(function(t) {
  var e, r, i, s, n, f, u, h, d, l, m, b, M, A, N, R, O, P, F, H, Q, Z, B;
  (function(Y) {
    var ae = typeof nt == "object" ? nt : typeof self == "object" ? self : typeof this == "object" ? this : {};
    Y(se(ae, se(t.exports)));
    function se(W, C) {
      return W !== ae && (typeof Object.create == "function" ? Object.defineProperty(W, "__esModule", { value: !0 }) : W.__esModule = !0), function(g, a) {
        return W[g] = C ? C(g, a) : a;
      };
    }
  })(function(Y) {
    var ae = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(se, W) {
      se.__proto__ = W;
    } || function(se, W) {
      for (var C in W)
        W.hasOwnProperty(C) && (se[C] = W[C]);
    };
    e = function(se, W) {
      ae(se, W);
      function C() {
        this.constructor = se;
      }
      se.prototype = W === null ? Object.create(W) : (C.prototype = W.prototype, new C());
    }, r = Object.assign || function(se) {
      for (var W, C = 1, g = arguments.length; C < g; C++) {
        W = arguments[C];
        for (var a in W)
          Object.prototype.hasOwnProperty.call(W, a) && (se[a] = W[a]);
      }
      return se;
    }, i = function(se, W) {
      var C = {};
      for (var g in se)
        Object.prototype.hasOwnProperty.call(se, g) && W.indexOf(g) < 0 && (C[g] = se[g]);
      if (se != null && typeof Object.getOwnPropertySymbols == "function")
        for (var a = 0, g = Object.getOwnPropertySymbols(se); a < g.length; a++)
          W.indexOf(g[a]) < 0 && Object.prototype.propertyIsEnumerable.call(se, g[a]) && (C[g[a]] = se[g[a]]);
      return C;
    }, s = function(se, W, C, g) {
      var a = arguments.length, c = a < 3 ? W : g === null ? g = Object.getOwnPropertyDescriptor(W, C) : g, p;
      if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
        c = Reflect.decorate(se, W, C, g);
      else
        for (var w = se.length - 1; w >= 0; w--)
          (p = se[w]) && (c = (a < 3 ? p(c) : a > 3 ? p(W, C, c) : p(W, C)) || c);
      return a > 3 && c && Object.defineProperty(W, C, c), c;
    }, n = function(se, W) {
      return function(C, g) {
        W(C, g, se);
      };
    }, f = function(se, W) {
      if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
        return Reflect.metadata(se, W);
    }, u = function(se, W, C, g) {
      function a(c) {
        return c instanceof C ? c : new C(function(p) {
          p(c);
        });
      }
      return new (C || (C = Promise))(function(c, p) {
        function w(E) {
          try {
            x(g.next(E));
          } catch (y) {
            p(y);
          }
        }
        function _(E) {
          try {
            x(g.throw(E));
          } catch (y) {
            p(y);
          }
        }
        function x(E) {
          E.done ? c(E.value) : a(E.value).then(w, _);
        }
        x((g = g.apply(se, W || [])).next());
      });
    }, h = function(se, W) {
      var C = { label: 0, sent: function() {
        if (c[0] & 1)
          throw c[1];
        return c[1];
      }, trys: [], ops: [] }, g, a, c, p;
      return p = { next: w(0), throw: w(1), return: w(2) }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
        return this;
      }), p;
      function w(x) {
        return function(E) {
          return _([x, E]);
        };
      }
      function _(x) {
        if (g)
          throw new TypeError("Generator is already executing.");
        for (; C; )
          try {
            if (g = 1, a && (c = x[0] & 2 ? a.return : x[0] ? a.throw || ((c = a.return) && c.call(a), 0) : a.next) && !(c = c.call(a, x[1])).done)
              return c;
            switch (a = 0, c && (x = [x[0] & 2, c.value]), x[0]) {
              case 0:
              case 1:
                c = x;
                break;
              case 4:
                return C.label++, { value: x[1], done: !1 };
              case 5:
                C.label++, a = x[1], x = [0];
                continue;
              case 7:
                x = C.ops.pop(), C.trys.pop();
                continue;
              default:
                if (c = C.trys, !(c = c.length > 0 && c[c.length - 1]) && (x[0] === 6 || x[0] === 2)) {
                  C = 0;
                  continue;
                }
                if (x[0] === 3 && (!c || x[1] > c[0] && x[1] < c[3])) {
                  C.label = x[1];
                  break;
                }
                if (x[0] === 6 && C.label < c[1]) {
                  C.label = c[1], c = x;
                  break;
                }
                if (c && C.label < c[2]) {
                  C.label = c[2], C.ops.push(x);
                  break;
                }
                c[2] && C.ops.pop(), C.trys.pop();
                continue;
            }
            x = W.call(se, C);
          } catch (E) {
            x = [6, E], a = 0;
          } finally {
            g = c = 0;
          }
        if (x[0] & 5)
          throw x[1];
        return { value: x[0] ? x[1] : void 0, done: !0 };
      }
    }, B = function(se, W, C, g) {
      g === void 0 && (g = C), se[g] = W[C];
    }, d = function(se, W) {
      for (var C in se)
        C !== "default" && !W.hasOwnProperty(C) && (W[C] = se[C]);
    }, l = function(se) {
      var W = typeof Symbol == "function" && Symbol.iterator, C = W && se[W], g = 0;
      if (C)
        return C.call(se);
      if (se && typeof se.length == "number")
        return {
          next: function() {
            return se && g >= se.length && (se = void 0), { value: se && se[g++], done: !se };
          }
        };
      throw new TypeError(W ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }, m = function(se, W) {
      var C = typeof Symbol == "function" && se[Symbol.iterator];
      if (!C)
        return se;
      var g = C.call(se), a, c = [], p;
      try {
        for (; (W === void 0 || W-- > 0) && !(a = g.next()).done; )
          c.push(a.value);
      } catch (w) {
        p = { error: w };
      } finally {
        try {
          a && !a.done && (C = g.return) && C.call(g);
        } finally {
          if (p)
            throw p.error;
        }
      }
      return c;
    }, b = function() {
      for (var se = [], W = 0; W < arguments.length; W++)
        se = se.concat(m(arguments[W]));
      return se;
    }, M = function() {
      for (var se = 0, W = 0, C = arguments.length; W < C; W++)
        se += arguments[W].length;
      for (var g = Array(se), a = 0, W = 0; W < C; W++)
        for (var c = arguments[W], p = 0, w = c.length; p < w; p++, a++)
          g[a] = c[p];
      return g;
    }, A = function(se) {
      return this instanceof A ? (this.v = se, this) : new A(se);
    }, N = function(se, W, C) {
      if (!Symbol.asyncIterator)
        throw new TypeError("Symbol.asyncIterator is not defined.");
      var g = C.apply(se, W || []), a, c = [];
      return a = {}, p("next"), p("throw"), p("return"), a[Symbol.asyncIterator] = function() {
        return this;
      }, a;
      function p(o) {
        g[o] && (a[o] = function(S) {
          return new Promise(function(J, z) {
            c.push([o, S, J, z]) > 1 || w(o, S);
          });
        });
      }
      function w(o, S) {
        try {
          _(g[o](S));
        } catch (J) {
          y(c[0][3], J);
        }
      }
      function _(o) {
        o.value instanceof A ? Promise.resolve(o.value.v).then(x, E) : y(c[0][2], o);
      }
      function x(o) {
        w("next", o);
      }
      function E(o) {
        w("throw", o);
      }
      function y(o, S) {
        o(S), c.shift(), c.length && w(c[0][0], c[0][1]);
      }
    }, R = function(se) {
      var W, C;
      return W = {}, g("next"), g("throw", function(a) {
        throw a;
      }), g("return"), W[Symbol.iterator] = function() {
        return this;
      }, W;
      function g(a, c) {
        W[a] = se[a] ? function(p) {
          return (C = !C) ? { value: A(se[a](p)), done: a === "return" } : c ? c(p) : p;
        } : c;
      }
    }, O = function(se) {
      if (!Symbol.asyncIterator)
        throw new TypeError("Symbol.asyncIterator is not defined.");
      var W = se[Symbol.asyncIterator], C;
      return W ? W.call(se) : (se = typeof l == "function" ? l(se) : se[Symbol.iterator](), C = {}, g("next"), g("throw"), g("return"), C[Symbol.asyncIterator] = function() {
        return this;
      }, C);
      function g(c) {
        C[c] = se[c] && function(p) {
          return new Promise(function(w, _) {
            p = se[c](p), a(w, _, p.done, p.value);
          });
        };
      }
      function a(c, p, w, _) {
        Promise.resolve(_).then(function(x) {
          c({ value: x, done: w });
        }, p);
      }
    }, P = function(se, W) {
      return Object.defineProperty ? Object.defineProperty(se, "raw", { value: W }) : se.raw = W, se;
    }, F = function(se) {
      if (se && se.__esModule)
        return se;
      var W = {};
      if (se != null)
        for (var C in se)
          Object.hasOwnProperty.call(se, C) && (W[C] = se[C]);
      return W.default = se, W;
    }, H = function(se) {
      return se && se.__esModule ? se : { default: se };
    }, Q = function(se, W) {
      if (!W.has(se))
        throw new TypeError("attempted to get private field on non-instance");
      return W.get(se);
    }, Z = function(se, W, C) {
      if (!W.has(se))
        throw new TypeError("attempted to set private field on non-instance");
      return W.set(se, C), C;
    }, Y("__extends", e), Y("__assign", r), Y("__rest", i), Y("__decorate", s), Y("__param", n), Y("__metadata", f), Y("__awaiter", u), Y("__generator", h), Y("__exportStar", d), Y("__createBinding", B), Y("__values", l), Y("__read", m), Y("__spread", b), Y("__spreadArrays", M), Y("__await", A), Y("__asyncGenerator", N), Y("__asyncDelegator", R), Y("__asyncValues", O), Y("__makeTemplateObject", P), Y("__importStar", F), Y("__importDefault", H), Y("__classPrivateFieldGet", Q), Y("__classPrivateFieldSet", Z);
  });
})(jT);
var _a = {}, Ix;
function Rfe() {
  if (Ix)
    return _a;
  Ix = 1, Object.defineProperty(_a, "__esModule", { value: !0 }), _a.isBrowserCryptoAvailable = _a.getSubtleCrypto = _a.getBrowerCrypto = void 0;
  function t() {
    return (nt == null ? void 0 : nt.crypto) || (nt == null ? void 0 : nt.msCrypto) || {};
  }
  _a.getBrowerCrypto = t;
  function e() {
    const i = t();
    return i.subtle || i.webkitSubtle;
  }
  _a.getSubtleCrypto = e;
  function r() {
    return !!t() && !!e();
  }
  return _a.isBrowserCryptoAvailable = r, _a;
}
var Ma = {}, Ax;
function Lfe() {
  if (Ax)
    return Ma;
  Ax = 1, Object.defineProperty(Ma, "__esModule", { value: !0 }), Ma.isBrowser = Ma.isNode = Ma.isReactNative = void 0;
  function t() {
    return typeof document > "u" && typeof navigator < "u" && navigator.product === "ReactNative";
  }
  Ma.isReactNative = t;
  function e() {
    return typeof process < "u" && typeof process.versions < "u" && typeof process.versions.node < "u";
  }
  Ma.isNode = e;
  function r() {
    return !t() && !e();
  }
  return Ma.isBrowser = r, Ma;
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  const e = jT.exports;
  e.__exportStar(Rfe(), t), e.__exportStar(Lfe(), t);
})(kT);
function Xa(t = 3) {
  const e = Date.now() * Math.pow(10, t), r = Math.floor(Math.random() * Math.pow(10, t));
  return e + r;
}
function Xo(t = 6) {
  return BigInt(Xa(t));
}
function no(t, e, r) {
  return {
    id: r || Xa(),
    jsonrpc: "2.0",
    method: t,
    params: e
  };
}
function f1(t, e) {
  return {
    id: t,
    jsonrpc: "2.0",
    result: e
  };
}
function c1(t, e, r) {
  return {
    id: t,
    jsonrpc: "2.0",
    error: Pfe(e, r)
  };
}
function Pfe(t, e) {
  return typeof t > "u" ? Ex(RT) : (typeof t == "string" && (t = Object.assign(Object.assign({}, Ex(Bw)), { message: t })), typeof e < "u" && (t.data = e), Cfe(t.code) && (t = Ofe(t.code)), t);
}
class kfe {
}
class jfe extends kfe {
  constructor() {
    super();
  }
}
class Bfe extends jfe {
  constructor(e) {
    super();
  }
}
const zfe = "^https?:", Ufe = "^wss?:";
function Ffe(t) {
  const e = t.match(new RegExp(/^\w+:/, "gi"));
  if (!(!e || !e.length))
    return e[0];
}
function BT(t, e) {
  const r = Ffe(t);
  return typeof r > "u" ? !1 : new RegExp(e).test(r);
}
function Tx(t) {
  return BT(t, zfe);
}
function Nx(t) {
  return BT(t, Ufe);
}
function $fe(t) {
  return new RegExp("wss?://localhost(:d{2,5})?").test(t);
}
function zT(t) {
  return typeof t == "object" && "id" in t && "jsonrpc" in t && t.jsonrpc === "2.0";
}
function zw(t) {
  return zT(t) && "method" in t;
}
function u1(t) {
  return zT(t) && (Hs(t) || Qn(t));
}
function Hs(t) {
  return "result" in t;
}
function Qn(t) {
  return "error" in t;
}
class Ns extends Bfe {
  constructor(e) {
    super(e), this.events = new Pr.exports.EventEmitter(), this.hasRegisteredEventListeners = !1, this.connection = this.setConnection(e), this.connection.connected && this.registerEventListeners();
  }
  async connect(e = this.connection) {
    await this.open(e);
  }
  async disconnect() {
    await this.close();
  }
  on(e, r) {
    this.events.on(e, r);
  }
  once(e, r) {
    this.events.once(e, r);
  }
  off(e, r) {
    this.events.off(e, r);
  }
  removeListener(e, r) {
    this.events.removeListener(e, r);
  }
  async request(e, r) {
    return this.requestStrict(no(e.method, e.params || [], e.id || Xo().toString()), r);
  }
  async requestStrict(e, r) {
    return new Promise(async (i, s) => {
      if (!this.connection.connected)
        try {
          await this.open();
        } catch (n) {
          s(n);
        }
      this.events.on(`${e.id}`, (n) => {
        Qn(n) ? s(n.error) : i(n.result);
      });
      try {
        await this.connection.send(e, r);
      } catch (n) {
        s(n);
      }
    });
  }
  setConnection(e = this.connection) {
    return e;
  }
  onPayload(e) {
    this.events.emit("payload", e), u1(e) ? this.events.emit(`${e.id}`, e) : this.events.emit("message", { type: e.method, data: e.params });
  }
  onClose(e) {
    e && e.code === 3e3 && this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${e.code} ${e.reason ? `(${e.reason})` : ""}`)), this.events.emit("disconnect");
  }
  async open(e = this.connection) {
    this.connection === e && this.connection.connected || (this.connection.connected && this.close(), typeof e == "string" && (await this.connection.open(e), e = this.connection), this.connection = this.setConnection(e), await this.connection.open(), this.registerEventListeners(), this.events.emit("connect"));
  }
  async close() {
    await this.connection.close();
  }
  registerEventListeners() {
    this.hasRegisteredEventListeners || (this.connection.on("payload", (e) => this.onPayload(e)), this.connection.on("close", (e) => this.onClose(e)), this.connection.on("error", (e) => this.events.emit("error", e)), this.connection.on("register_error", (e) => this.onClose()), this.hasRegisteredEventListeners = !0);
  }
}
const qfe = () => typeof WebSocket < "u" ? WebSocket : typeof global < "u" && typeof global.WebSocket < "u" ? global.WebSocket : typeof window < "u" && typeof window.WebSocket < "u" ? window.WebSocket : typeof self < "u" && typeof self.WebSocket < "u" ? self.WebSocket : require("ws"), Hfe = () => typeof WebSocket < "u" || typeof global < "u" && typeof global.WebSocket < "u" || typeof window < "u" && typeof window.WebSocket < "u" || typeof self < "u" && typeof self.WebSocket < "u", Dx = (t) => t.split("?")[0], Cx = 10, Wfe = qfe();
class Vfe {
  constructor(e) {
    if (this.url = e, this.events = new Pr.exports.EventEmitter(), this.registering = !1, !Nx(e))
      throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
    this.url = e;
  }
  get connected() {
    return typeof this.socket < "u";
  }
  get connecting() {
    return this.registering;
  }
  on(e, r) {
    this.events.on(e, r);
  }
  once(e, r) {
    this.events.once(e, r);
  }
  off(e, r) {
    this.events.off(e, r);
  }
  removeListener(e, r) {
    this.events.removeListener(e, r);
  }
  async open(e = this.url) {
    await this.register(e);
  }
  async close() {
    return new Promise((e, r) => {
      if (typeof this.socket > "u") {
        r(new Error("Connection already closed"));
        return;
      }
      this.socket.onclose = (i) => {
        this.onClose(i), e();
      }, this.socket.close();
    });
  }
  async send(e) {
    typeof this.socket > "u" && (this.socket = await this.register());
    try {
      this.socket.send(Pa(e));
    } catch (r) {
      this.onError(e.id, r);
    }
  }
  register(e = this.url) {
    if (!Nx(e))
      throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);
    if (this.registering) {
      const r = this.events.getMaxListeners();
      return (this.events.listenerCount("register_error") >= r || this.events.listenerCount("open") >= r) && this.events.setMaxListeners(r + 1), new Promise((i, s) => {
        this.events.once("register_error", (n) => {
          this.resetMaxListeners(), s(n);
        }), this.events.once("open", () => {
          if (this.resetMaxListeners(), typeof this.socket > "u")
            return s(new Error("WebSocket connection is missing or invalid"));
          i(this.socket);
        });
      });
    }
    return this.url = e, this.registering = !0, new Promise((r, i) => {
      const s = new URLSearchParams(e).get("origin"), n = kT.isReactNative() ? { headers: { origin: s } } : { rejectUnauthorized: !$fe(e) }, f = new Wfe(e, [], n);
      Hfe() ? f.onerror = (u) => {
        const h = u;
        i(this.emitError(h.error));
      } : f.on("error", (u) => {
        i(this.emitError(u));
      }), f.onopen = () => {
        this.onOpen(f), r(f);
      };
    });
  }
  onOpen(e) {
    e.onmessage = (r) => this.onPayload(r), e.onclose = (r) => this.onClose(r), this.socket = e, this.registering = !1, this.events.emit("open");
  }
  onClose(e) {
    this.socket = void 0, this.registering = !1, this.events.emit("close", e);
  }
  onPayload(e) {
    if (typeof e.data > "u")
      return;
    const r = typeof e.data == "string" ? uf(e.data) : e.data;
    this.events.emit("payload", r);
  }
  onError(e, r) {
    const i = this.parseError(r), s = i.message || i.toString(), n = c1(e, s);
    this.events.emit("payload", n);
  }
  parseError(e, r = this.url) {
    return PT(e, Dx(r), "WS");
  }
  resetMaxListeners() {
    this.events.getMaxListeners() > Cx && this.events.setMaxListeners(Cx);
  }
  emitError(e) {
    const r = this.parseError(new Error((e == null ? void 0 : e.message) || `WebSocket connection failed for host: ${Dx(this.url)}`));
    return this.events.emit("register_error", r), r;
  }
}
var Fm = { exports: {} };
(function(t, e) {
  var r = 200, i = "__lodash_hash_undefined__", s = 1, n = 2, f = 9007199254740991, u = "[object Arguments]", h = "[object Array]", d = "[object AsyncFunction]", l = "[object Boolean]", m = "[object Date]", b = "[object Error]", M = "[object Function]", A = "[object GeneratorFunction]", N = "[object Map]", R = "[object Number]", O = "[object Null]", P = "[object Object]", F = "[object Promise]", H = "[object Proxy]", Q = "[object RegExp]", Z = "[object Set]", B = "[object String]", Y = "[object Symbol]", ae = "[object Undefined]", se = "[object WeakMap]", W = "[object ArrayBuffer]", C = "[object DataView]", g = "[object Float32Array]", a = "[object Float64Array]", c = "[object Int8Array]", p = "[object Int16Array]", w = "[object Int32Array]", _ = "[object Uint8Array]", x = "[object Uint8ClampedArray]", E = "[object Uint16Array]", y = "[object Uint32Array]", o = /[\\^$.*+?()[\]{}|]/g, S = /^\[object .+?Constructor\]$/, J = /^(?:0|[1-9]\d*)$/, z = {};
  z[g] = z[a] = z[c] = z[p] = z[w] = z[_] = z[x] = z[E] = z[y] = !0, z[u] = z[h] = z[W] = z[l] = z[C] = z[m] = z[b] = z[M] = z[N] = z[R] = z[P] = z[Q] = z[Z] = z[B] = z[se] = !1;
  var k = typeof nt == "object" && nt && nt.Object === Object && nt, j = typeof self == "object" && self && self.Object === Object && self, q = k || j || Function("return this")(), K = e && !e.nodeType && e, U = K && !0 && t && !t.nodeType && t, T = U && U.exports === K, D = T && k.process, te = function() {
    try {
      return D && D.binding && D.binding("util");
    } catch {
    }
  }(), ne = te && te.isTypedArray;
  function le(he, Me) {
    for (var tt = -1, lt = he == null ? 0 : he.length, Nr = 0, Lt = []; ++tt < lt; ) {
      var kr = he[tt];
      Me(kr, tt, he) && (Lt[Nr++] = kr);
    }
    return Lt;
  }
  function X(he, Me) {
    for (var tt = -1, lt = Me.length, Nr = he.length; ++tt < lt; )
      he[Nr + tt] = Me[tt];
    return he;
  }
  function $(he, Me) {
    for (var tt = -1, lt = he == null ? 0 : he.length; ++tt < lt; )
      if (Me(he[tt], tt, he))
        return !0;
    return !1;
  }
  function V(he, Me) {
    for (var tt = -1, lt = Array(he); ++tt < he; )
      lt[tt] = Me(tt);
    return lt;
  }
  function re(he) {
    return function(Me) {
      return he(Me);
    };
  }
  function fe(he, Me) {
    return he.has(Me);
  }
  function ue(he, Me) {
    return he == null ? void 0 : he[Me];
  }
  function me(he) {
    var Me = -1, tt = Array(he.size);
    return he.forEach(function(lt, Nr) {
      tt[++Me] = [Nr, lt];
    }), tt;
  }
  function be(he, Me) {
    return function(tt) {
      return he(Me(tt));
    };
  }
  function ve(he) {
    var Me = -1, tt = Array(he.size);
    return he.forEach(function(lt) {
      tt[++Me] = lt;
    }), tt;
  }
  var Ge = Array.prototype, ye = Function.prototype, pe = Object.prototype, Je = q["__core-js_shared__"], Ie = ye.toString, we = pe.hasOwnProperty, at = function() {
    var he = /[^.]+$/.exec(Je && Je.keys && Je.keys.IE_PROTO || "");
    return he ? "Symbol(src)_1." + he : "";
  }(), Oe = pe.toString, Ee = RegExp(
    "^" + Ie.call(we).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), ft = T ? q.Buffer : void 0, Le = q.Symbol, Pe = q.Uint8Array, Mt = pe.propertyIsEnumerable, Ve = Ge.splice, ke = Le ? Le.toStringTag : void 0, Et = Object.getOwnPropertySymbols, Ke = ft ? ft.isBuffer : void 0, Be = be(Object.keys, Object), dt = vn(q, "DataView"), ze = vn(q, "Map"), Te = vn(q, "Promise"), pt = vn(q, "Set"), Fe = vn(q, "WeakMap"), Ae = vn(Object, "create"), bt = ha(dt), He = ha(ze), Ne = ha(Te), yt = ha(pt), $e = ha(Fe), De = Le ? Le.prototype : void 0, vt = De ? De.valueOf : void 0;
  function je(he) {
    var Me = -1, tt = he == null ? 0 : he.length;
    for (this.clear(); ++Me < tt; ) {
      var lt = he[Me];
      this.set(lt[0], lt[1]);
    }
  }
  function Ce() {
    this.__data__ = Ae ? Ae(null) : {}, this.size = 0;
  }
  function mt(he) {
    var Me = this.has(he) && delete this.__data__[he];
    return this.size -= Me ? 1 : 0, Me;
  }
  function Ze(he) {
    var Me = this.__data__;
    if (Ae) {
      var tt = Me[he];
      return tt === i ? void 0 : tt;
    }
    return we.call(Me, he) ? Me[he] : void 0;
  }
  function qe(he) {
    var Me = this.__data__;
    return Ae ? Me[he] !== void 0 : we.call(Me, he);
  }
  function Dt(he, Me) {
    var tt = this.__data__;
    return this.size += this.has(he) ? 0 : 1, tt[he] = Ae && Me === void 0 ? i : Me, this;
  }
  je.prototype.clear = Ce, je.prototype.delete = mt, je.prototype.get = Ze, je.prototype.has = qe, je.prototype.set = Dt;
  function We(he) {
    var Me = -1, tt = he == null ? 0 : he.length;
    for (this.clear(); ++Me < tt; ) {
      var lt = he[Me];
      this.set(lt[0], lt[1]);
    }
  }
  function Qe() {
    this.__data__ = [], this.size = 0;
  }
  function Qt(he) {
    var Me = this.__data__, tt = _o(Me, he);
    if (tt < 0)
      return !1;
    var lt = Me.length - 1;
    return tt == lt ? Me.pop() : Ve.call(Me, tt, 1), --this.size, !0;
  }
  function Zt(he) {
    var Me = this.__data__, tt = _o(Me, he);
    return tt < 0 ? void 0 : Me[tt][1];
  }
  function Jt(he) {
    return _o(this.__data__, he) > -1;
  }
  function Xt(he, Me) {
    var tt = this.__data__, lt = _o(tt, he);
    return lt < 0 ? (++this.size, tt.push([he, Me])) : tt[lt][1] = Me, this;
  }
  We.prototype.clear = Qe, We.prototype.delete = Qt, We.prototype.get = Zt, We.prototype.has = Jt, We.prototype.set = Xt;
  function kt(he) {
    var Me = -1, tt = he == null ? 0 : he.length;
    for (this.clear(); ++Me < tt; ) {
      var lt = he[Me];
      this.set(lt[0], lt[1]);
    }
  }
  function ar() {
    this.size = 0, this.__data__ = {
      hash: new je(),
      map: new (ze || We)(),
      string: new je()
    };
  }
  function lr(he) {
    var Me = ja(this, he).delete(he);
    return this.size -= Me ? 1 : 0, Me;
  }
  function or(he) {
    return ja(this, he).get(he);
  }
  function dr(he) {
    return ja(this, he).has(he);
  }
  function pr(he, Me) {
    var tt = ja(this, he), lt = tt.size;
    return tt.set(he, Me), this.size += tt.size == lt ? 0 : 1, this;
  }
  kt.prototype.clear = ar, kt.prototype.delete = lr, kt.prototype.get = or, kt.prototype.has = dr, kt.prototype.set = pr;
  function fr(he) {
    var Me = -1, tt = he == null ? 0 : he.length;
    for (this.__data__ = new kt(); ++Me < tt; )
      this.add(he[Me]);
  }
  function ur(he) {
    return this.__data__.set(he, i), this;
  }
  function hr(he) {
    return this.__data__.has(he);
  }
  fr.prototype.add = fr.prototype.push = ur, fr.prototype.has = hr;
  function qt(he) {
    var Me = this.__data__ = new We(he);
    this.size = Me.size;
  }
  function Er() {
    this.__data__ = new We(), this.size = 0;
  }
  function Ir(he) {
    var Me = this.__data__, tt = Me.delete(he);
    return this.size = Me.size, tt;
  }
  function Ar(he) {
    return this.__data__.get(he);
  }
  function qr(he) {
    return this.__data__.has(he);
  }
  function zr(he, Me) {
    var tt = this.__data__;
    if (tt instanceof We) {
      var lt = tt.__data__;
      if (!ze || lt.length < r - 1)
        return lt.push([he, Me]), this.size = ++tt.size, this;
      tt = this.__data__ = new kt(lt);
    }
    return tt.set(he, Me), this.size = tt.size, this;
  }
  qt.prototype.clear = Er, qt.prototype.delete = Ir, qt.prototype.get = Ar, qt.prototype.has = qr, qt.prototype.set = zr;
  function ll(he, Me) {
    var tt = Tf(he), lt = !tt && Sl(he), Nr = !tt && !lt && uu(he), Lt = !tt && !lt && !Nr && Al(he), kr = tt || lt || Nr || Lt, ni = kr ? V(he.length, String) : [], ir = ni.length;
    for (var Dr in he)
      (Me || we.call(he, Dr)) && !(kr && (Dr == "length" || Nr && (Dr == "offset" || Dr == "parent") || Lt && (Dr == "buffer" || Dr == "byteLength" || Dr == "byteOffset") || ml(Dr, ir))) && ni.push(Dr);
    return ni;
  }
  function _o(he, Me) {
    for (var tt = he.length; tt--; )
      if (xl(he[tt][0], Me))
        return tt;
    return -1;
  }
  function fu(he, Me, tt) {
    var lt = Me(he);
    return Tf(he) ? lt : X(lt, tt(he));
  }
  function Mo(he) {
    return he == null ? he === void 0 ? ae : O : ke && ke in Object(he) ? bl(he) : v1(he);
  }
  function cu(he) {
    return So(he) && Mo(he) == u;
  }
  function xo(he, Me, tt, lt, Nr) {
    return he === Me ? !0 : he == null || Me == null || !So(he) && !So(Me) ? he !== he && Me !== Me : dl(he, Me, tt, lt, xo, Nr);
  }
  function dl(he, Me, tt, lt, Nr, Lt) {
    var kr = Tf(he), ni = Tf(Me), ir = kr ? h : Cs(he), Dr = ni ? h : Cs(Me);
    ir = ir == u ? P : ir, Dr = Dr == u ? P : Dr;
    var Xr = ir == P, tn = Dr == P, si = ir == Dr;
    if (si && uu(he)) {
      if (!uu(Me))
        return !1;
      kr = !0, Xr = !1;
    }
    if (si && !Xr)
      return Lt || (Lt = new qt()), kr || Al(he) ? If(he, Me, tt, lt, Nr, Lt) : p1(he, Me, ir, tt, lt, Nr, Lt);
    if (!(tt & s)) {
      var jr = Xr && we.call(he, "__wrapped__"), Ui = tn && we.call(Me, "__wrapped__");
      if (jr || Ui) {
        var hs = jr ? he.value() : he, Rn = Ui ? Me.value() : Me;
        return Lt || (Lt = new qt()), Nr(hs, Rn, tt, lt, Lt);
      }
    }
    return si ? (Lt || (Lt = new qt()), gl(he, Me, tt, lt, Nr, Lt)) : !1;
  }
  function d1(he) {
    if (!Il(he) || _l(he))
      return !1;
    var Me = Nf(he) ? Ee : S;
    return Me.test(ha(he));
  }
  function pl(he) {
    return So(he) && El(he.length) && !!z[Mo(he)];
  }
  function vl(he) {
    if (!Ml(he))
      return Be(he);
    var Me = [];
    for (var tt in Object(he))
      we.call(he, tt) && tt != "constructor" && Me.push(tt);
    return Me;
  }
  function If(he, Me, tt, lt, Nr, Lt) {
    var kr = tt & s, ni = he.length, ir = Me.length;
    if (ni != ir && !(kr && ir > ni))
      return !1;
    var Dr = Lt.get(he);
    if (Dr && Lt.get(Me))
      return Dr == Me;
    var Xr = -1, tn = !0, si = tt & n ? new fr() : void 0;
    for (Lt.set(he, Me), Lt.set(Me, he); ++Xr < ni; ) {
      var jr = he[Xr], Ui = Me[Xr];
      if (lt)
        var hs = kr ? lt(Ui, jr, Xr, Me, he, Lt) : lt(jr, Ui, Xr, he, Me, Lt);
      if (hs !== void 0) {
        if (hs)
          continue;
        tn = !1;
        break;
      }
      if (si) {
        if (!$(Me, function(Rn, Os) {
          if (!fe(si, Os) && (jr === Rn || Nr(jr, Rn, tt, lt, Lt)))
            return si.push(Os);
        })) {
          tn = !1;
          break;
        }
      } else if (!(jr === Ui || Nr(jr, Ui, tt, lt, Lt))) {
        tn = !1;
        break;
      }
    }
    return Lt.delete(he), Lt.delete(Me), tn;
  }
  function p1(he, Me, tt, lt, Nr, Lt, kr) {
    switch (tt) {
      case C:
        if (he.byteLength != Me.byteLength || he.byteOffset != Me.byteOffset)
          return !1;
        he = he.buffer, Me = Me.buffer;
      case W:
        return !(he.byteLength != Me.byteLength || !Lt(new Pe(he), new Pe(Me)));
      case l:
      case m:
      case R:
        return xl(+he, +Me);
      case b:
        return he.name == Me.name && he.message == Me.message;
      case Q:
      case B:
        return he == Me + "";
      case N:
        var ni = me;
      case Z:
        var ir = lt & s;
        if (ni || (ni = ve), he.size != Me.size && !ir)
          return !1;
        var Dr = kr.get(he);
        if (Dr)
          return Dr == Me;
        lt |= n, kr.set(he, Me);
        var Xr = If(ni(he), ni(Me), lt, Nr, Lt, kr);
        return kr.delete(he), Xr;
      case Y:
        if (vt)
          return vt.call(he) == vt.call(Me);
    }
    return !1;
  }
  function gl(he, Me, tt, lt, Nr, Lt) {
    var kr = tt & s, ni = Af(he), ir = ni.length, Dr = Af(Me), Xr = Dr.length;
    if (ir != Xr && !kr)
      return !1;
    for (var tn = ir; tn--; ) {
      var si = ni[tn];
      if (!(kr ? si in Me : we.call(Me, si)))
        return !1;
    }
    var jr = Lt.get(he);
    if (jr && Lt.get(Me))
      return jr == Me;
    var Ui = !0;
    Lt.set(he, Me), Lt.set(Me, he);
    for (var hs = kr; ++tn < ir; ) {
      si = ni[tn];
      var Rn = he[si], Os = Me[si];
      if (lt)
        var hu = kr ? lt(Os, Rn, si, Me, he, Lt) : lt(Rn, Os, si, he, Me, Lt);
      if (!(hu === void 0 ? Rn === Os || Nr(Rn, Os, tt, lt, Lt) : hu)) {
        Ui = !1;
        break;
      }
      hs || (hs = si == "constructor");
    }
    if (Ui && !hs) {
      var Eo = he.constructor, ui = Me.constructor;
      Eo != ui && "constructor" in he && "constructor" in Me && !(typeof Eo == "function" && Eo instanceof Eo && typeof ui == "function" && ui instanceof ui) && (Ui = !1);
    }
    return Lt.delete(he), Lt.delete(Me), Ui;
  }
  function Af(he) {
    return fu(he, y1, yl);
  }
  function ja(he, Me) {
    var tt = he.__data__;
    return wl(Me) ? tt[typeof Me == "string" ? "string" : "hash"] : tt.map;
  }
  function vn(he, Me) {
    var tt = ue(he, Me);
    return d1(tt) ? tt : void 0;
  }
  function bl(he) {
    var Me = we.call(he, ke), tt = he[ke];
    try {
      he[ke] = void 0;
      var lt = !0;
    } catch {
    }
    var Nr = Oe.call(he);
    return lt && (Me ? he[ke] = tt : delete he[ke]), Nr;
  }
  var yl = Et ? function(he) {
    return he == null ? [] : (he = Object(he), le(Et(he), function(Me) {
      return Mt.call(he, Me);
    }));
  } : Tr, Cs = Mo;
  (dt && Cs(new dt(new ArrayBuffer(1))) != C || ze && Cs(new ze()) != N || Te && Cs(Te.resolve()) != F || pt && Cs(new pt()) != Z || Fe && Cs(new Fe()) != se) && (Cs = function(he) {
    var Me = Mo(he), tt = Me == P ? he.constructor : void 0, lt = tt ? ha(tt) : "";
    if (lt)
      switch (lt) {
        case bt:
          return C;
        case He:
          return N;
        case Ne:
          return F;
        case yt:
          return Z;
        case $e:
          return se;
      }
    return Me;
  });
  function ml(he, Me) {
    return Me = Me == null ? f : Me, !!Me && (typeof he == "number" || J.test(he)) && he > -1 && he % 1 == 0 && he < Me;
  }
  function wl(he) {
    var Me = typeof he;
    return Me == "string" || Me == "number" || Me == "symbol" || Me == "boolean" ? he !== "__proto__" : he === null;
  }
  function _l(he) {
    return !!at && at in he;
  }
  function Ml(he) {
    var Me = he && he.constructor, tt = typeof Me == "function" && Me.prototype || pe;
    return he === tt;
  }
  function v1(he) {
    return Oe.call(he);
  }
  function ha(he) {
    if (he != null) {
      try {
        return Ie.call(he);
      } catch {
      }
      try {
        return he + "";
      } catch {
      }
    }
    return "";
  }
  function xl(he, Me) {
    return he === Me || he !== he && Me !== Me;
  }
  var Sl = cu(function() {
    return arguments;
  }()) ? cu : function(he) {
    return So(he) && we.call(he, "callee") && !Mt.call(he, "callee");
  }, Tf = Array.isArray;
  function g1(he) {
    return he != null && El(he.length) && !Nf(he);
  }
  var uu = Ke || _r;
  function b1(he, Me) {
    return xo(he, Me);
  }
  function Nf(he) {
    if (!Il(he))
      return !1;
    var Me = Mo(he);
    return Me == M || Me == A || Me == d || Me == H;
  }
  function El(he) {
    return typeof he == "number" && he > -1 && he % 1 == 0 && he <= f;
  }
  function Il(he) {
    var Me = typeof he;
    return he != null && (Me == "object" || Me == "function");
  }
  function So(he) {
    return he != null && typeof he == "object";
  }
  var Al = ne ? re(ne) : pl;
  function y1(he) {
    return g1(he) ? ll(he) : vl(he);
  }
  function Tr() {
    return [];
  }
  function _r() {
    return !1;
  }
  t.exports = b1;
})(Fm, Fm.exports);
const Gfe = Fm.exports, UT = "wc", FT = 2, Uw = "core", aa = `${UT}@2:${Uw}:`, Kfe = { name: Uw, logger: "error" }, Yfe = { database: ":memory:" }, Qfe = "crypto", Ox = "client_ed25519_seed", Zfe = ct.ONE_DAY, Jfe = "keychain", Xfe = "0.3", ece = "messages", tce = "0.3", rce = ct.SIX_HOURS, ice = "publisher", $T = "irn", nce = "error", qT = "wss://relay.walletconnect.org", sce = "relayer", Yi = { message: "relayer_message", message_ack: "relayer_message_ack", connect: "relayer_connect", disconnect: "relayer_disconnect", error: "relayer_error", connection_stalled: "relayer_connection_stalled", transport_closed: "relayer_transport_closed", publish: "relayer_publish" }, ace = "_subscription", Gn = { payload: "payload", connect: "connect", disconnect: "disconnect", error: "error" }, oce = 0.1, $m = "2.17.1", Or = { link_mode: "link_mode", relay: "relay" }, fce = "0.3", cce = "WALLETCONNECT_CLIENT_ID", Rx = "WALLETCONNECT_LINK_MODE_APPS", Ws = { created: "subscription_created", deleted: "subscription_deleted", expired: "subscription_expired", disabled: "subscription_disabled", sync: "subscription_sync", resubscribed: "subscription_resubscribed" }, uce = "subscription", hce = "0.3", lce = ct.FIVE_SECONDS * 1e3, dce = "pairing", pce = "0.3", qu = { wc_pairingDelete: { req: { ttl: ct.ONE_DAY, prompt: !1, tag: 1e3 }, res: { ttl: ct.ONE_DAY, prompt: !1, tag: 1001 } }, wc_pairingPing: { req: { ttl: ct.THIRTY_SECONDS, prompt: !1, tag: 1002 }, res: { ttl: ct.THIRTY_SECONDS, prompt: !1, tag: 1003 } }, unregistered_method: { req: { ttl: ct.ONE_DAY, prompt: !1, tag: 0 }, res: { ttl: ct.ONE_DAY, prompt: !1, tag: 0 } } }, Go = { create: "pairing_create", expire: "pairing_expire", delete: "pairing_delete", ping: "pairing_ping" }, ys = { created: "history_created", updated: "history_updated", deleted: "history_deleted", sync: "history_sync" }, vce = "history", gce = "0.3", bce = "expirer", Kn = { created: "expirer_created", deleted: "expirer_deleted", expired: "expirer_expired", sync: "expirer_sync" }, yce = "0.3", mce = "verify-api", wce = "https://verify.walletconnect.com", HT = "https://verify.walletconnect.org", fh = HT, _ce = `${fh}/v3`, Mce = [wce, HT], xce = "echo", Sce = "https://echo.walletconnect.com", Fs = { pairing_started: "pairing_started", pairing_uri_validation_success: "pairing_uri_validation_success", pairing_uri_not_expired: "pairing_uri_not_expired", store_new_pairing: "store_new_pairing", subscribing_pairing_topic: "subscribing_pairing_topic", subscribe_pairing_topic_success: "subscribe_pairing_topic_success", existing_pairing: "existing_pairing", pairing_not_expired: "pairing_not_expired", emit_inactive_pairing: "emit_inactive_pairing", emit_session_proposal: "emit_session_proposal", subscribing_to_pairing_topic: "subscribing_to_pairing_topic" }, xa = { no_wss_connection: "no_wss_connection", no_internet_connection: "no_internet_connection", malformed_pairing_uri: "malformed_pairing_uri", active_pairing_already_exists: "active_pairing_already_exists", subscribe_pairing_topic_failure: "subscribe_pairing_topic_failure", pairing_expired: "pairing_expired", proposal_expired: "proposal_expired", proposal_listener_not_found: "proposal_listener_not_found" }, ms = { session_approve_started: "session_approve_started", proposal_not_expired: "proposal_not_expired", session_namespaces_validation_success: "session_namespaces_validation_success", create_session_topic: "create_session_topic", subscribing_session_topic: "subscribing_session_topic", subscribe_session_topic_success: "subscribe_session_topic_success", publishing_session_approve: "publishing_session_approve", session_approve_publish_success: "session_approve_publish_success", store_session: "store_session", publishing_session_settle: "publishing_session_settle", session_settle_publish_success: "session_settle_publish_success" }, Uo = { no_internet_connection: "no_internet_connection", no_wss_connection: "no_wss_connection", proposal_expired: "proposal_expired", subscribe_session_topic_failure: "subscribe_session_topic_failure", session_approve_publish_failure: "session_approve_publish_failure", session_settle_publish_failure: "session_settle_publish_failure", session_approve_namespace_validation_failure: "session_approve_namespace_validation_failure", proposal_not_found: "proposal_not_found" }, Fo = { authenticated_session_approve_started: "authenticated_session_approve_started", authenticated_session_not_expired: "authenticated_session_not_expired", chains_caip2_compliant: "chains_caip2_compliant", chains_evm_compliant: "chains_evm_compliant", create_authenticated_session_topic: "create_authenticated_session_topic", cacaos_verified: "cacaos_verified", store_authenticated_session: "store_authenticated_session", subscribing_authenticated_session_topic: "subscribing_authenticated_session_topic", subscribe_authenticated_session_topic_success: "subscribe_authenticated_session_topic_success", publishing_authenticated_session_approve: "publishing_authenticated_session_approve", authenticated_session_approve_publish_success: "authenticated_session_approve_publish_success" }, Hu = { no_internet_connection: "no_internet_connection", no_wss_connection: "no_wss_connection", missing_session_authenticate_request: "missing_session_authenticate_request", session_authenticate_request_expired: "session_authenticate_request_expired", chains_caip2_compliant_failure: "chains_caip2_compliant_failure", chains_evm_compliant_failure: "chains_evm_compliant_failure", invalid_cacao: "invalid_cacao", subscribe_authenticated_session_topic_failure: "subscribe_authenticated_session_topic_failure", authenticated_session_approve_publish_failure: "authenticated_session_approve_publish_failure", authenticated_session_pending_request_not_found: "authenticated_session_pending_request_not_found" }, Ece = 0.1, Ice = "event-client", Ace = 86400, Tce = "https://pulse.walletconnect.org/batch";
function Nce(t, e) {
  if (t.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var r = new Uint8Array(256), i = 0; i < r.length; i++)
    r[i] = 255;
  for (var s = 0; s < t.length; s++) {
    var n = t.charAt(s), f = n.charCodeAt(0);
    if (r[f] !== 255)
      throw new TypeError(n + " is ambiguous");
    r[f] = s;
  }
  var u = t.length, h = t.charAt(0), d = Math.log(u) / Math.log(256), l = Math.log(256) / Math.log(u);
  function m(A) {
    if (A instanceof Uint8Array || (ArrayBuffer.isView(A) ? A = new Uint8Array(A.buffer, A.byteOffset, A.byteLength) : Array.isArray(A) && (A = Uint8Array.from(A))), !(A instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (A.length === 0)
      return "";
    for (var N = 0, R = 0, O = 0, P = A.length; O !== P && A[O] === 0; )
      O++, N++;
    for (var F = (P - O) * l + 1 >>> 0, H = new Uint8Array(F); O !== P; ) {
      for (var Q = A[O], Z = 0, B = F - 1; (Q !== 0 || Z < R) && B !== -1; B--, Z++)
        Q += 256 * H[B] >>> 0, H[B] = Q % u >>> 0, Q = Q / u >>> 0;
      if (Q !== 0)
        throw new Error("Non-zero carry");
      R = Z, O++;
    }
    for (var Y = F - R; Y !== F && H[Y] === 0; )
      Y++;
    for (var ae = h.repeat(N); Y < F; ++Y)
      ae += t.charAt(H[Y]);
    return ae;
  }
  function b(A) {
    if (typeof A != "string")
      throw new TypeError("Expected String");
    if (A.length === 0)
      return new Uint8Array();
    var N = 0;
    if (A[N] !== " ") {
      for (var R = 0, O = 0; A[N] === h; )
        R++, N++;
      for (var P = (A.length - N) * d + 1 >>> 0, F = new Uint8Array(P); A[N]; ) {
        var H = r[A.charCodeAt(N)];
        if (H === 255)
          return;
        for (var Q = 0, Z = P - 1; (H !== 0 || Q < O) && Z !== -1; Z--, Q++)
          H += u * F[Z] >>> 0, F[Z] = H % 256 >>> 0, H = H / 256 >>> 0;
        if (H !== 0)
          throw new Error("Non-zero carry");
        O = Q, N++;
      }
      if (A[N] !== " ") {
        for (var B = P - O; B !== P && F[B] === 0; )
          B++;
        for (var Y = new Uint8Array(R + (P - B)), ae = R; B !== P; )
          Y[ae++] = F[B++];
        return Y;
      }
    }
  }
  function M(A) {
    var N = b(A);
    if (N)
      return N;
    throw new Error(`Non-${e} character`);
  }
  return { encode: m, decodeUnsafe: b, decode: M };
}
var Dce = Nce, Cce = Dce;
const WT = (t) => {
  if (t instanceof Uint8Array && t.constructor.name === "Uint8Array")
    return t;
  if (t instanceof ArrayBuffer)
    return new Uint8Array(t);
  if (ArrayBuffer.isView(t))
    return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  throw new Error("Unknown type, must be binary type");
}, Oce = (t) => new TextEncoder().encode(t), Rce = (t) => new TextDecoder().decode(t);
class Lce {
  constructor(e, r, i) {
    this.name = e, this.prefix = r, this.baseEncode = i;
  }
  encode(e) {
    if (e instanceof Uint8Array)
      return `${this.prefix}${this.baseEncode(e)}`;
    throw Error("Unknown type, must be binary type");
  }
}
class Pce {
  constructor(e, r, i) {
    if (this.name = e, this.prefix = r, r.codePointAt(0) === void 0)
      throw new Error("Invalid prefix character");
    this.prefixCodePoint = r.codePointAt(0), this.baseDecode = i;
  }
  decode(e) {
    if (typeof e == "string") {
      if (e.codePointAt(0) !== this.prefixCodePoint)
        throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
      return this.baseDecode(e.slice(this.prefix.length));
    } else
      throw Error("Can only multibase decode strings");
  }
  or(e) {
    return VT(this, e);
  }
}
class kce {
  constructor(e) {
    this.decoders = e;
  }
  or(e) {
    return VT(this, e);
  }
  decode(e) {
    const r = e[0], i = this.decoders[r];
    if (i)
      return i.decode(e);
    throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
  }
}
const VT = (t, e) => new kce({ ...t.decoders || { [t.prefix]: t }, ...e.decoders || { [e.prefix]: e } });
class jce {
  constructor(e, r, i, s) {
    this.name = e, this.prefix = r, this.baseEncode = i, this.baseDecode = s, this.encoder = new Lce(e, r, i), this.decoder = new Pce(e, r, s);
  }
  encode(e) {
    return this.encoder.encode(e);
  }
  decode(e) {
    return this.decoder.decode(e);
  }
}
const h1 = ({ name: t, prefix: e, encode: r, decode: i }) => new jce(t, e, r, i), hl = ({ prefix: t, name: e, alphabet: r }) => {
  const { encode: i, decode: s } = Cce(r, e);
  return h1({ prefix: t, name: e, encode: i, decode: (n) => WT(s(n)) });
}, Bce = (t, e, r, i) => {
  const s = {};
  for (let l = 0; l < e.length; ++l)
    s[e[l]] = l;
  let n = t.length;
  for (; t[n - 1] === "="; )
    --n;
  const f = new Uint8Array(n * r / 8 | 0);
  let u = 0, h = 0, d = 0;
  for (let l = 0; l < n; ++l) {
    const m = s[t[l]];
    if (m === void 0)
      throw new SyntaxError(`Non-${i} character`);
    h = h << r | m, u += r, u >= 8 && (u -= 8, f[d++] = 255 & h >> u);
  }
  if (u >= r || 255 & h << 8 - u)
    throw new SyntaxError("Unexpected end of data");
  return f;
}, zce = (t, e, r) => {
  const i = e[e.length - 1] === "=", s = (1 << r) - 1;
  let n = "", f = 0, u = 0;
  for (let h = 0; h < t.length; ++h)
    for (u = u << 8 | t[h], f += 8; f > r; )
      f -= r, n += e[s & u >> f];
  if (f && (n += e[s & u << r - f]), i)
    for (; n.length * r & 7; )
      n += "=";
  return n;
}, Di = ({ name: t, prefix: e, bitsPerChar: r, alphabet: i }) => h1({ prefix: e, name: t, encode(s) {
  return zce(s, i, r);
}, decode(s) {
  return Bce(s, i, r, t);
} }), Uce = h1({ prefix: "\0", name: "identity", encode: (t) => Rce(t), decode: (t) => Oce(t) });
var Fce = Object.freeze({ __proto__: null, identity: Uce });
const $ce = Di({ prefix: "0", name: "base2", alphabet: "01", bitsPerChar: 1 });
var qce = Object.freeze({ __proto__: null, base2: $ce });
const Hce = Di({ prefix: "7", name: "base8", alphabet: "01234567", bitsPerChar: 3 });
var Wce = Object.freeze({ __proto__: null, base8: Hce });
const Vce = hl({ prefix: "9", name: "base10", alphabet: "0123456789" });
var Gce = Object.freeze({ __proto__: null, base10: Vce });
const Kce = Di({ prefix: "f", name: "base16", alphabet: "0123456789abcdef", bitsPerChar: 4 }), Yce = Di({ prefix: "F", name: "base16upper", alphabet: "0123456789ABCDEF", bitsPerChar: 4 });
var Qce = Object.freeze({ __proto__: null, base16: Kce, base16upper: Yce });
const Zce = Di({ prefix: "b", name: "base32", alphabet: "abcdefghijklmnopqrstuvwxyz234567", bitsPerChar: 5 }), Jce = Di({ prefix: "B", name: "base32upper", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567", bitsPerChar: 5 }), Xce = Di({ prefix: "c", name: "base32pad", alphabet: "abcdefghijklmnopqrstuvwxyz234567=", bitsPerChar: 5 }), eue = Di({ prefix: "C", name: "base32padupper", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=", bitsPerChar: 5 }), tue = Di({ prefix: "v", name: "base32hex", alphabet: "0123456789abcdefghijklmnopqrstuv", bitsPerChar: 5 }), rue = Di({ prefix: "V", name: "base32hexupper", alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV", bitsPerChar: 5 }), iue = Di({ prefix: "t", name: "base32hexpad", alphabet: "0123456789abcdefghijklmnopqrstuv=", bitsPerChar: 5 }), nue = Di({ prefix: "T", name: "base32hexpadupper", alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=", bitsPerChar: 5 }), sue = Di({ prefix: "h", name: "base32z", alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769", bitsPerChar: 5 });
var aue = Object.freeze({ __proto__: null, base32: Zce, base32upper: Jce, base32pad: Xce, base32padupper: eue, base32hex: tue, base32hexupper: rue, base32hexpad: iue, base32hexpadupper: nue, base32z: sue });
const oue = hl({ prefix: "k", name: "base36", alphabet: "0123456789abcdefghijklmnopqrstuvwxyz" }), fue = hl({ prefix: "K", name: "base36upper", alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ" });
var cue = Object.freeze({ __proto__: null, base36: oue, base36upper: fue });
const uue = hl({ name: "base58btc", prefix: "z", alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz" }), hue = hl({ name: "base58flickr", prefix: "Z", alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ" });
var lue = Object.freeze({ __proto__: null, base58btc: uue, base58flickr: hue });
const due = Di({ prefix: "m", name: "base64", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", bitsPerChar: 6 }), pue = Di({ prefix: "M", name: "base64pad", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", bitsPerChar: 6 }), vue = Di({ prefix: "u", name: "base64url", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_", bitsPerChar: 6 }), gue = Di({ prefix: "U", name: "base64urlpad", alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=", bitsPerChar: 6 });
var bue = Object.freeze({ __proto__: null, base64: due, base64pad: pue, base64url: vue, base64urlpad: gue });
const GT = Array.from("\u{1F680}\u{1FA90}\u2604\u{1F6F0}\u{1F30C}\u{1F311}\u{1F312}\u{1F313}\u{1F314}\u{1F315}\u{1F316}\u{1F317}\u{1F318}\u{1F30D}\u{1F30F}\u{1F30E}\u{1F409}\u2600\u{1F4BB}\u{1F5A5}\u{1F4BE}\u{1F4BF}\u{1F602}\u2764\u{1F60D}\u{1F923}\u{1F60A}\u{1F64F}\u{1F495}\u{1F62D}\u{1F618}\u{1F44D}\u{1F605}\u{1F44F}\u{1F601}\u{1F525}\u{1F970}\u{1F494}\u{1F496}\u{1F499}\u{1F622}\u{1F914}\u{1F606}\u{1F644}\u{1F4AA}\u{1F609}\u263A\u{1F44C}\u{1F917}\u{1F49C}\u{1F614}\u{1F60E}\u{1F607}\u{1F339}\u{1F926}\u{1F389}\u{1F49E}\u270C\u2728\u{1F937}\u{1F631}\u{1F60C}\u{1F338}\u{1F64C}\u{1F60B}\u{1F497}\u{1F49A}\u{1F60F}\u{1F49B}\u{1F642}\u{1F493}\u{1F929}\u{1F604}\u{1F600}\u{1F5A4}\u{1F603}\u{1F4AF}\u{1F648}\u{1F447}\u{1F3B6}\u{1F612}\u{1F92D}\u2763\u{1F61C}\u{1F48B}\u{1F440}\u{1F62A}\u{1F611}\u{1F4A5}\u{1F64B}\u{1F61E}\u{1F629}\u{1F621}\u{1F92A}\u{1F44A}\u{1F973}\u{1F625}\u{1F924}\u{1F449}\u{1F483}\u{1F633}\u270B\u{1F61A}\u{1F61D}\u{1F634}\u{1F31F}\u{1F62C}\u{1F643}\u{1F340}\u{1F337}\u{1F63B}\u{1F613}\u2B50\u2705\u{1F97A}\u{1F308}\u{1F608}\u{1F918}\u{1F4A6}\u2714\u{1F623}\u{1F3C3}\u{1F490}\u2639\u{1F38A}\u{1F498}\u{1F620}\u261D\u{1F615}\u{1F33A}\u{1F382}\u{1F33B}\u{1F610}\u{1F595}\u{1F49D}\u{1F64A}\u{1F639}\u{1F5E3}\u{1F4AB}\u{1F480}\u{1F451}\u{1F3B5}\u{1F91E}\u{1F61B}\u{1F534}\u{1F624}\u{1F33C}\u{1F62B}\u26BD\u{1F919}\u2615\u{1F3C6}\u{1F92B}\u{1F448}\u{1F62E}\u{1F646}\u{1F37B}\u{1F343}\u{1F436}\u{1F481}\u{1F632}\u{1F33F}\u{1F9E1}\u{1F381}\u26A1\u{1F31E}\u{1F388}\u274C\u270A\u{1F44B}\u{1F630}\u{1F928}\u{1F636}\u{1F91D}\u{1F6B6}\u{1F4B0}\u{1F353}\u{1F4A2}\u{1F91F}\u{1F641}\u{1F6A8}\u{1F4A8}\u{1F92C}\u2708\u{1F380}\u{1F37A}\u{1F913}\u{1F619}\u{1F49F}\u{1F331}\u{1F616}\u{1F476}\u{1F974}\u25B6\u27A1\u2753\u{1F48E}\u{1F4B8}\u2B07\u{1F628}\u{1F31A}\u{1F98B}\u{1F637}\u{1F57A}\u26A0\u{1F645}\u{1F61F}\u{1F635}\u{1F44E}\u{1F932}\u{1F920}\u{1F927}\u{1F4CC}\u{1F535}\u{1F485}\u{1F9D0}\u{1F43E}\u{1F352}\u{1F617}\u{1F911}\u{1F30A}\u{1F92F}\u{1F437}\u260E\u{1F4A7}\u{1F62F}\u{1F486}\u{1F446}\u{1F3A4}\u{1F647}\u{1F351}\u2744\u{1F334}\u{1F4A3}\u{1F438}\u{1F48C}\u{1F4CD}\u{1F940}\u{1F922}\u{1F445}\u{1F4A1}\u{1F4A9}\u{1F450}\u{1F4F8}\u{1F47B}\u{1F910}\u{1F92E}\u{1F3BC}\u{1F975}\u{1F6A9}\u{1F34E}\u{1F34A}\u{1F47C}\u{1F48D}\u{1F4E3}\u{1F942}"), yue = GT.reduce((t, e, r) => (t[r] = e, t), []), mue = GT.reduce((t, e, r) => (t[e.codePointAt(0)] = r, t), []);
function wue(t) {
  return t.reduce((e, r) => (e += yue[r], e), "");
}
function _ue(t) {
  const e = [];
  for (const r of t) {
    const i = mue[r.codePointAt(0)];
    if (i === void 0)
      throw new Error(`Non-base256emoji character: ${r}`);
    e.push(i);
  }
  return new Uint8Array(e);
}
const Mue = h1({ prefix: "\u{1F680}", name: "base256emoji", encode: wue, decode: _ue });
var xue = Object.freeze({ __proto__: null, base256emoji: Mue }), Sue = KT, Lx = 128, Eue = 127, Iue = ~Eue, Aue = Math.pow(2, 31);
function KT(t, e, r) {
  e = e || [], r = r || 0;
  for (var i = r; t >= Aue; )
    e[r++] = t & 255 | Lx, t /= 128;
  for (; t & Iue; )
    e[r++] = t & 255 | Lx, t >>>= 7;
  return e[r] = t | 0, KT.bytes = r - i + 1, e;
}
var Tue = qm, Nue = 128, Px = 127;
function qm(t, i) {
  var r = 0, i = i || 0, s = 0, n = i, f, u = t.length;
  do {
    if (n >= u)
      throw qm.bytes = 0, new RangeError("Could not decode varint");
    f = t[n++], r += s < 28 ? (f & Px) << s : (f & Px) * Math.pow(2, s), s += 7;
  } while (f >= Nue);
  return qm.bytes = n - i, r;
}
var Due = Math.pow(2, 7), Cue = Math.pow(2, 14), Oue = Math.pow(2, 21), Rue = Math.pow(2, 28), Lue = Math.pow(2, 35), Pue = Math.pow(2, 42), kue = Math.pow(2, 49), jue = Math.pow(2, 56), Bue = Math.pow(2, 63), zue = function(t) {
  return t < Due ? 1 : t < Cue ? 2 : t < Oue ? 3 : t < Rue ? 4 : t < Lue ? 5 : t < Pue ? 6 : t < kue ? 7 : t < jue ? 8 : t < Bue ? 9 : 10;
}, Uue = { encode: Sue, decode: Tue, encodingLength: zue }, YT = Uue;
const kx = (t, e, r = 0) => (YT.encode(t, e, r), e), jx = (t) => YT.encodingLength(t), Hm = (t, e) => {
  const r = e.byteLength, i = jx(t), s = i + jx(r), n = new Uint8Array(s + r);
  return kx(t, n, 0), kx(r, n, i), n.set(e, s), new Fue(t, r, e, n);
};
class Fue {
  constructor(e, r, i, s) {
    this.code = e, this.size = r, this.digest = i, this.bytes = s;
  }
}
const QT = ({ name: t, code: e, encode: r }) => new $ue(t, e, r);
class $ue {
  constructor(e, r, i) {
    this.name = e, this.code = r, this.encode = i;
  }
  digest(e) {
    if (e instanceof Uint8Array) {
      const r = this.encode(e);
      return r instanceof Uint8Array ? Hm(this.code, r) : r.then((i) => Hm(this.code, i));
    } else
      throw Error("Unknown type, must be binary type");
  }
}
const ZT = (t) => async (e) => new Uint8Array(await crypto.subtle.digest(t, e)), que = QT({ name: "sha2-256", code: 18, encode: ZT("SHA-256") }), Hue = QT({ name: "sha2-512", code: 19, encode: ZT("SHA-512") });
var Wue = Object.freeze({ __proto__: null, sha256: que, sha512: Hue });
const JT = 0, Vue = "identity", XT = WT, Gue = (t) => Hm(JT, XT(t)), Kue = { code: JT, name: Vue, encode: XT, digest: Gue };
var Yue = Object.freeze({ __proto__: null, identity: Kue });
new TextEncoder(), new TextDecoder();
const Bx = { ...Fce, ...qce, ...Wce, ...Gce, ...Qce, ...aue, ...cue, ...lue, ...bue, ...xue };
({ ...Wue, ...Yue });
function Que(t = 0) {
  return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? globalThis.Buffer.allocUnsafe(t) : new Uint8Array(t);
}
function eN(t, e, r, i) {
  return { name: t, prefix: e, encoder: { name: t, prefix: e, encode: r }, decoder: { decode: i } };
}
const zx = eN("utf8", "u", (t) => "u" + new TextDecoder("utf8").decode(t), (t) => new TextEncoder().encode(t.substring(1))), Uy = eN("ascii", "a", (t) => {
  let e = "a";
  for (let r = 0; r < t.length; r++)
    e += String.fromCharCode(t[r]);
  return e;
}, (t) => {
  t = t.substring(1);
  const e = Que(t.length);
  for (let r = 0; r < t.length; r++)
    e[r] = t.charCodeAt(r);
  return e;
}), Zue = { utf8: zx, "utf-8": zx, hex: Bx.base16, latin1: Uy, ascii: Uy, binary: Uy, ...Bx };
function Jue(t, e = "utf8") {
  const r = Zue[e];
  if (!r)
    throw new Error(`Unsupported encoding "${e}"`);
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? globalThis.Buffer.from(t, "utf8") : r.decoder.decode(`${r.prefix}${t}`);
}
class Xue {
  constructor(e, r) {
    this.core = e, this.logger = r, this.keychain = /* @__PURE__ */ new Map(), this.name = Jfe, this.version = Xfe, this.initialized = !1, this.storagePrefix = aa, this.init = async () => {
      if (!this.initialized) {
        const i = await this.getKeyChain();
        typeof i < "u" && (this.keychain = i), this.initialized = !0;
      }
    }, this.has = (i) => (this.isInitialized(), this.keychain.has(i)), this.set = async (i, s) => {
      this.isInitialized(), this.keychain.set(i, s), await this.persist();
    }, this.get = (i) => {
      this.isInitialized();
      const s = this.keychain.get(i);
      if (typeof s > "u") {
        const { message: n } = ot("NO_MATCHING_KEY", `${this.name}: ${i}`);
        throw new Error(n);
      }
      return s;
    }, this.del = async (i) => {
      this.isInitialized(), this.keychain.delete(i), await this.persist();
    }, this.core = e, this.logger = en(r, this.name);
  }
  get context() {
    return pn(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  async setKeyChain(e) {
    await this.core.storage.setItem(this.storageKey, pT(e));
  }
  async getKeyChain() {
    const e = await this.core.storage.getItem(this.storageKey);
    return typeof e < "u" ? vT(e) : void 0;
  }
  async persist() {
    await this.setKeyChain(this.keychain);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = ot("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
class ehe {
  constructor(e, r, i) {
    this.core = e, this.logger = r, this.name = Qfe, this.randomSessionIdentifier = jm(), this.initialized = !1, this.init = async () => {
      this.initialized || (await this.keychain.init(), this.initialized = !0);
    }, this.hasKeys = (s) => (this.isInitialized(), this.keychain.has(s)), this.getClientId = async () => {
      this.isInitialized();
      const s = await this.getClientSeed(), n = H8(s);
      return uT(n.publicKey);
    }, this.generateKeyPair = () => {
      this.isInitialized();
      const s = aae();
      return this.setPrivateKey(s.publicKey, s.privateKey);
    }, this.signJWT = async (s) => {
      this.isInitialized();
      const n = await this.getClientSeed(), f = H8(n), u = this.randomSessionIdentifier;
      return await gse(u, s, Zfe, f);
    }, this.generateSharedKey = (s, n, f) => {
      this.isInitialized();
      const u = this.getPrivateKey(s), h = oae(u, n);
      return this.setSymKey(h, f);
    }, this.setSymKey = async (s, n) => {
      this.isInitialized();
      const f = n || i0(s);
      return await this.keychain.set(f, s), f;
    }, this.deleteKeyPair = async (s) => {
      this.isInitialized(), await this.keychain.del(s);
    }, this.deleteSymKey = async (s) => {
      this.isInitialized(), await this.keychain.del(s);
    }, this.encode = async (s, n, f) => {
      this.isInitialized();
      const u = ET(f), h = Pa(n);
      if (nx(u))
        return cae(h, f == null ? void 0 : f.encoding);
      if (ix(u)) {
        const b = u.senderPublicKey, M = u.receiverPublicKey;
        s = await this.generateSharedKey(b, M);
      }
      const d = this.getSymKey(s), { type: l, senderPublicKey: m } = u;
      return fae({ type: l, symKey: d, message: h, senderPublicKey: m, encoding: f == null ? void 0 : f.encoding });
    }, this.decode = async (s, n, f) => {
      this.isInitialized();
      const u = lae(n, f);
      if (nx(u)) {
        const h = hae(n, f == null ? void 0 : f.encoding);
        return uf(h);
      }
      if (ix(u)) {
        const h = u.receiverPublicKey, d = u.senderPublicKey;
        s = await this.generateSharedKey(h, d);
      }
      try {
        const h = this.getSymKey(s), d = uae({ symKey: h, encoded: n, encoding: f == null ? void 0 : f.encoding });
        return uf(d);
      } catch (h) {
        this.logger.error(`Failed to decode message from topic: '${s}', clientId: '${await this.getClientId()}'`), this.logger.error(h);
      }
    }, this.getPayloadType = (s, n = io) => {
      const f = _h({ encoded: s, encoding: n });
      return lf(f.type);
    }, this.getPayloadSenderPublicKey = (s, n = io) => {
      const f = _h({ encoded: s, encoding: n });
      return f.senderPublicKey ? un(f.senderPublicKey, Zi) : void 0;
    }, this.core = e, this.logger = en(r, this.name), this.keychain = i || new Xue(this.core, this.logger);
  }
  get context() {
    return pn(this.logger);
  }
  async setPrivateKey(e, r) {
    return await this.keychain.set(e, r), e;
  }
  getPrivateKey(e) {
    return this.keychain.get(e);
  }
  async getClientSeed() {
    let e = "";
    try {
      e = this.keychain.get(Ox);
    } catch {
      e = jm(), await this.keychain.set(Ox, e);
    }
    return Jue(e, "base16");
  }
  getSymKey(e) {
    return this.keychain.get(e);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = ot("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
class the extends vfe {
  constructor(e, r) {
    super(e, r), this.logger = e, this.core = r, this.messages = /* @__PURE__ */ new Map(), this.name = ece, this.version = tce, this.initialized = !1, this.storagePrefix = aa, this.init = async () => {
      if (!this.initialized) {
        this.logger.trace("Initialized");
        try {
          const i = await this.getRelayerMessages();
          typeof i < "u" && (this.messages = i), this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({ type: "method", method: "restore", size: this.messages.size });
        } catch (i) {
          this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(i);
        } finally {
          this.initialized = !0;
        }
      }
    }, this.set = async (i, s) => {
      this.isInitialized();
      const n = Ea(s);
      let f = this.messages.get(i);
      return typeof f > "u" && (f = {}), typeof f[n] < "u" || (f[n] = s, this.messages.set(i, f), await this.persist()), n;
    }, this.get = (i) => {
      this.isInitialized();
      let s = this.messages.get(i);
      return typeof s > "u" && (s = {}), s;
    }, this.has = (i, s) => {
      this.isInitialized();
      const n = this.get(i), f = Ea(s);
      return typeof n[f] < "u";
    }, this.del = async (i) => {
      this.isInitialized(), this.messages.delete(i), await this.persist();
    }, this.logger = en(e, this.name), this.core = r;
  }
  get context() {
    return pn(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  async setRelayerMessages(e) {
    await this.core.storage.setItem(this.storageKey, pT(e));
  }
  async getRelayerMessages() {
    const e = await this.core.storage.getItem(this.storageKey);
    return typeof e < "u" ? vT(e) : void 0;
  }
  async persist() {
    await this.setRelayerMessages(this.messages);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = ot("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
class rhe extends gfe {
  constructor(e, r) {
    super(e, r), this.relayer = e, this.logger = r, this.events = new Pr.exports.EventEmitter(), this.name = ice, this.queue = /* @__PURE__ */ new Map(), this.publishTimeout = ct.toMiliseconds(ct.ONE_MINUTE), this.failedPublishTimeout = ct.toMiliseconds(ct.ONE_SECOND), this.needsTransportRestart = !1, this.publish = async (i, s, n) => {
      var f;
      this.logger.debug("Publishing Payload"), this.logger.trace({ type: "method", method: "publish", params: { topic: i, message: s, opts: n } });
      const u = (n == null ? void 0 : n.ttl) || rce, h = Bm(n), d = (n == null ? void 0 : n.prompt) || !1, l = (n == null ? void 0 : n.tag) || 0, m = (n == null ? void 0 : n.id) || Xo().toString(), b = { topic: i, message: s, opts: { ttl: u, relay: h, prompt: d, tag: l, id: m, attestation: n == null ? void 0 : n.attestation } }, M = `Failed to publish payload, please try again. id:${m} tag:${l}`, A = Date.now();
      let N, R = 1;
      try {
        for (; N === void 0; ) {
          if (Date.now() - A > this.publishTimeout)
            throw new Error(M);
          this.logger.trace({ id: m, attempts: R }, `publisher.publish - attempt ${R}`), N = await await gc(this.rpcPublish(i, s, u, h, d, l, m, n == null ? void 0 : n.attestation).catch((O) => this.logger.warn(O)), this.publishTimeout, M), R++, N || await new Promise((O) => setTimeout(O, this.failedPublishTimeout));
        }
        this.relayer.events.emit(Yi.publish, b), this.logger.debug("Successfully Published Payload"), this.logger.trace({ type: "method", method: "publish", params: { id: m, topic: i, message: s, opts: n } });
      } catch (O) {
        if (this.logger.debug("Failed to Publish Payload"), this.logger.error(O), (f = n == null ? void 0 : n.internal) != null && f.throwOnFailedPublish)
          throw O;
        this.queue.set(m, b);
      }
    }, this.on = (i, s) => {
      this.events.on(i, s);
    }, this.once = (i, s) => {
      this.events.once(i, s);
    }, this.off = (i, s) => {
      this.events.off(i, s);
    }, this.removeListener = (i, s) => {
      this.events.removeListener(i, s);
    }, this.relayer = e, this.logger = en(r, this.name), this.registerEventListeners();
  }
  get context() {
    return pn(this.logger);
  }
  rpcPublish(e, r, i, s, n, f, u, h) {
    var d, l, m, b;
    const M = { method: Ku(s.protocol).publish, params: { topic: e, message: r, ttl: i, prompt: n, tag: f, attestation: h }, id: u };
    return Qi((d = M.params) == null ? void 0 : d.prompt) && ((l = M.params) == null || delete l.prompt), Qi((m = M.params) == null ? void 0 : m.tag) && ((b = M.params) == null || delete b.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "message", direction: "outgoing", request: M }), this.relayer.request(M);
  }
  removeRequestFromQueue(e) {
    this.queue.delete(e);
  }
  checkQueue() {
    this.queue.forEach(async (e) => {
      const { topic: r, message: i, opts: s } = e;
      await this.publish(r, i, s);
    });
  }
  registerEventListeners() {
    this.relayer.core.heartbeat.on(ou.pulse, () => {
      if (this.needsTransportRestart) {
        this.needsTransportRestart = !1, this.relayer.events.emit(Yi.connection_stalled);
        return;
      }
      this.checkQueue();
    }), this.relayer.on(Yi.message_ack, (e) => {
      this.removeRequestFromQueue(e.id.toString());
    });
  }
}
class ihe {
  constructor() {
    this.map = /* @__PURE__ */ new Map(), this.set = (e, r) => {
      const i = this.get(e);
      this.exists(e, r) || this.map.set(e, [...i, r]);
    }, this.get = (e) => this.map.get(e) || [], this.exists = (e, r) => this.get(e).includes(r), this.delete = (e, r) => {
      if (typeof r > "u") {
        this.map.delete(e);
        return;
      }
      if (!this.map.has(e))
        return;
      const i = this.get(e);
      if (!this.exists(e, r))
        return;
      const s = i.filter((n) => n !== r);
      if (!s.length) {
        this.map.delete(e);
        return;
      }
      this.map.set(e, s);
    }, this.clear = () => {
      this.map.clear();
    };
  }
  get topics() {
    return Array.from(this.map.keys());
  }
}
var nhe = Object.defineProperty, she = Object.defineProperties, ahe = Object.getOwnPropertyDescriptors, Ux = Object.getOwnPropertySymbols, ohe = Object.prototype.hasOwnProperty, fhe = Object.prototype.propertyIsEnumerable, Fx = (t, e, r) => e in t ? nhe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Wu = (t, e) => {
  for (var r in e || (e = {}))
    ohe.call(e, r) && Fx(t, r, e[r]);
  if (Ux)
    for (var r of Ux(e))
      fhe.call(e, r) && Fx(t, r, e[r]);
  return t;
}, Fy = (t, e) => she(t, ahe(e));
class che extends mfe {
  constructor(e, r) {
    super(e, r), this.relayer = e, this.logger = r, this.subscriptions = /* @__PURE__ */ new Map(), this.topicMap = new ihe(), this.events = new Pr.exports.EventEmitter(), this.name = uce, this.version = hce, this.pending = /* @__PURE__ */ new Map(), this.cached = [], this.initialized = !1, this.pendingSubscriptionWatchLabel = "pending_sub_watch_label", this.pollingInterval = 20, this.storagePrefix = aa, this.subscribeTimeout = ct.toMiliseconds(ct.ONE_MINUTE), this.restartInProgress = !1, this.batchSubscribeTopicsLimit = 500, this.pendingBatchMessages = [], this.init = async () => {
      this.initialized || (this.logger.trace("Initialized"), this.registerEventListeners(), this.clientId = await this.relayer.core.crypto.getClientId(), await this.restore()), this.initialized = !0;
    }, this.subscribe = async (i, s) => {
      this.isInitialized(), this.logger.debug("Subscribing Topic"), this.logger.trace({ type: "method", method: "subscribe", params: { topic: i, opts: s } });
      try {
        const n = Bm(s), f = { topic: i, relay: n, transportType: s == null ? void 0 : s.transportType };
        this.pending.set(i, f);
        const u = await this.rpcSubscribe(i, n, s);
        return typeof u == "string" && (this.onSubscribe(u, f), this.logger.debug("Successfully Subscribed Topic"), this.logger.trace({ type: "method", method: "subscribe", params: { topic: i, opts: s } })), u;
      } catch (n) {
        throw this.logger.debug("Failed to Subscribe Topic"), this.logger.error(n), n;
      }
    }, this.unsubscribe = async (i, s) => {
      await this.restartToComplete(), this.isInitialized(), typeof (s == null ? void 0 : s.id) < "u" ? await this.unsubscribeById(i, s.id, s) : await this.unsubscribeByTopic(i, s);
    }, this.isSubscribed = async (i) => {
      if (this.topics.includes(i))
        return !0;
      const s = `${this.pendingSubscriptionWatchLabel}_${i}`;
      return await new Promise((n, f) => {
        const u = new ct.Watch();
        u.start(s);
        const h = setInterval(() => {
          !this.pending.has(i) && this.topics.includes(i) && (clearInterval(h), u.stop(s), n(!0)), u.elapsed(s) >= lce && (clearInterval(h), u.stop(s), f(new Error("Subscription resolution timeout")));
        }, this.pollingInterval);
      }).catch(() => !1);
    }, this.on = (i, s) => {
      this.events.on(i, s);
    }, this.once = (i, s) => {
      this.events.once(i, s);
    }, this.off = (i, s) => {
      this.events.off(i, s);
    }, this.removeListener = (i, s) => {
      this.events.removeListener(i, s);
    }, this.start = async () => {
      await this.onConnect();
    }, this.stop = async () => {
      await this.onDisconnect();
    }, this.restart = async () => {
      this.restartInProgress = !0, await this.restore(), await this.reset(), this.restartInProgress = !1;
    }, this.relayer = e, this.logger = en(r, this.name), this.clientId = "";
  }
  get context() {
    return pn(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.relayer.core.customStoragePrefix + "//" + this.name;
  }
  get length() {
    return this.subscriptions.size;
  }
  get ids() {
    return Array.from(this.subscriptions.keys());
  }
  get values() {
    return Array.from(this.subscriptions.values());
  }
  get topics() {
    return this.topicMap.topics;
  }
  hasSubscription(e, r) {
    let i = !1;
    try {
      i = this.getSubscription(e).topic === r;
    } catch {
    }
    return i;
  }
  onEnable() {
    this.cached = [], this.initialized = !0;
  }
  onDisable() {
    this.cached = this.values, this.subscriptions.clear(), this.topicMap.clear();
  }
  async unsubscribeByTopic(e, r) {
    const i = this.topicMap.get(e);
    await Promise.all(i.map(async (s) => await this.unsubscribeById(e, s, r)));
  }
  async unsubscribeById(e, r, i) {
    this.logger.debug("Unsubscribing Topic"), this.logger.trace({ type: "method", method: "unsubscribe", params: { topic: e, id: r, opts: i } });
    try {
      const s = Bm(i);
      await this.rpcUnsubscribe(e, r, s);
      const n = wr("USER_DISCONNECTED", `${this.name}, ${e}`);
      await this.onUnsubscribe(e, r, n), this.logger.debug("Successfully Unsubscribed Topic"), this.logger.trace({ type: "method", method: "unsubscribe", params: { topic: e, id: r, opts: i } });
    } catch (s) {
      throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(s), s;
    }
  }
  async rpcSubscribe(e, r, i) {
    var s;
    (i == null ? void 0 : i.transportType) === Or.relay && await this.restartToComplete();
    const n = { method: Ku(r.protocol).subscribe, params: { topic: e } };
    this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "payload", direction: "outgoing", request: n });
    const f = (s = i == null ? void 0 : i.internal) == null ? void 0 : s.throwOnFailedPublish;
    try {
      const u = Ea(e + this.clientId);
      if ((i == null ? void 0 : i.transportType) === Or.link_mode)
        return setTimeout(() => {
          (this.relayer.connected || this.relayer.connecting) && this.relayer.request(n).catch((d) => this.logger.warn(d));
        }, ct.toMiliseconds(ct.ONE_SECOND)), u;
      const h = await gc(this.relayer.request(n).catch((d) => this.logger.warn(d)), this.subscribeTimeout, `Subscribing to ${e} failed, please try again`);
      if (!h && f)
        throw new Error(`Subscribing to ${e} failed, please try again`);
      return h ? u : null;
    } catch (u) {
      if (this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit(Yi.connection_stalled), f)
        throw u;
    }
    return null;
  }
  async rpcBatchSubscribe(e) {
    if (!e.length)
      return;
    const r = e[0].relay, i = { method: Ku(r.protocol).batchSubscribe, params: { topics: e.map((s) => s.topic) } };
    this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "payload", direction: "outgoing", request: i });
    try {
      return await await gc(this.relayer.request(i).catch((s) => this.logger.warn(s)), this.subscribeTimeout);
    } catch {
      this.relayer.events.emit(Yi.connection_stalled);
    }
  }
  async rpcBatchFetchMessages(e) {
    if (!e.length)
      return;
    const r = e[0].relay, i = { method: Ku(r.protocol).batchFetchMessages, params: { topics: e.map((n) => n.topic) } };
    this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "payload", direction: "outgoing", request: i });
    let s;
    try {
      s = await await gc(this.relayer.request(i).catch((n) => this.logger.warn(n)), this.subscribeTimeout);
    } catch {
      this.relayer.events.emit(Yi.connection_stalled);
    }
    return s;
  }
  rpcUnsubscribe(e, r, i) {
    const s = { method: Ku(i.protocol).unsubscribe, params: { topic: e, id: r } };
    return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({ type: "payload", direction: "outgoing", request: s }), this.relayer.request(s);
  }
  onSubscribe(e, r) {
    this.setSubscription(e, Fy(Wu({}, r), { id: e })), this.pending.delete(r.topic);
  }
  onBatchSubscribe(e) {
    e.length && e.forEach((r) => {
      this.setSubscription(r.id, Wu({}, r)), this.pending.delete(r.topic);
    });
  }
  async onUnsubscribe(e, r, i) {
    this.events.removeAllListeners(r), this.hasSubscription(r, e) && this.deleteSubscription(r, i), await this.relayer.messages.del(e);
  }
  async setRelayerSubscriptions(e) {
    await this.relayer.core.storage.setItem(this.storageKey, e);
  }
  async getRelayerSubscriptions() {
    return await this.relayer.core.storage.getItem(this.storageKey);
  }
  setSubscription(e, r) {
    this.logger.debug("Setting subscription"), this.logger.trace({ type: "method", method: "setSubscription", id: e, subscription: r }), this.addSubscription(e, r);
  }
  addSubscription(e, r) {
    this.subscriptions.set(e, Wu({}, r)), this.topicMap.set(r.topic, e), this.events.emit(Ws.created, r);
  }
  getSubscription(e) {
    this.logger.debug("Getting subscription"), this.logger.trace({ type: "method", method: "getSubscription", id: e });
    const r = this.subscriptions.get(e);
    if (!r) {
      const { message: i } = ot("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw new Error(i);
    }
    return r;
  }
  deleteSubscription(e, r) {
    this.logger.debug("Deleting subscription"), this.logger.trace({ type: "method", method: "deleteSubscription", id: e, reason: r });
    const i = this.getSubscription(e);
    this.subscriptions.delete(e), this.topicMap.delete(i.topic, e), this.events.emit(Ws.deleted, Fy(Wu({}, i), { reason: r }));
  }
  async persist() {
    await this.setRelayerSubscriptions(this.values), this.events.emit(Ws.sync);
  }
  async reset() {
    if (this.cached.length) {
      const e = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
      for (let r = 0; r < e; r++) {
        const i = this.cached.splice(0, this.batchSubscribeTopicsLimit);
        await this.batchFetchMessages(i), await this.batchSubscribe(i);
      }
    }
    this.events.emit(Ws.resubscribed);
  }
  async restore() {
    try {
      const e = await this.getRelayerSubscriptions();
      if (typeof e > "u" || !e.length)
        return;
      if (this.subscriptions.size) {
        const { message: r } = ot("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(r), this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`), new Error(r);
      }
      this.cached = e, this.logger.debug(`Successfully Restored subscriptions for ${this.name}`), this.logger.trace({ type: "method", method: "restore", subscriptions: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore subscriptions for ${this.name}`), this.logger.error(e);
    }
  }
  async batchSubscribe(e) {
    if (!e.length)
      return;
    const r = await this.rpcBatchSubscribe(e);
    sa(r) && this.onBatchSubscribe(r.map((i, s) => Fy(Wu({}, e[s]), { id: i })));
  }
  async batchFetchMessages(e) {
    if (!e.length)
      return;
    this.logger.trace(`Fetching batch messages for ${e.length} subscriptions`);
    const r = await this.rpcBatchFetchMessages(e);
    r && r.messages && (this.pendingBatchMessages = this.pendingBatchMessages.concat(r.messages));
  }
  async onConnect() {
    await this.restart(), this.onEnable();
  }
  onDisconnect() {
    this.onDisable();
  }
  async checkPending() {
    if (!this.initialized || !this.relayer.connected)
      return;
    const e = [];
    this.pending.forEach((r) => {
      e.push(r);
    }), await this.batchSubscribe(e), this.pendingBatchMessages.length && (await this.relayer.handleBatchMessageEvents(this.pendingBatchMessages), this.pendingBatchMessages = []);
  }
  registerEventListeners() {
    this.relayer.core.heartbeat.on(ou.pulse, async () => {
      await this.checkPending();
    }), this.events.on(Ws.created, async (e) => {
      const r = Ws.created;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, data: e }), await this.persist();
    }), this.events.on(Ws.deleted, async (e) => {
      const r = Ws.deleted;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, data: e }), await this.persist();
    });
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = ot("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
  async restartToComplete() {
    !this.relayer.connected && !this.relayer.connecting && await this.relayer.transportOpen(), this.restartInProgress && await new Promise((e) => {
      const r = setInterval(() => {
        this.restartInProgress || (clearInterval(r), e());
      }, this.pollingInterval);
    });
  }
}
var uhe = Object.defineProperty, $x = Object.getOwnPropertySymbols, hhe = Object.prototype.hasOwnProperty, lhe = Object.prototype.propertyIsEnumerable, qx = (t, e, r) => e in t ? uhe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Hx = (t, e) => {
  for (var r in e || (e = {}))
    hhe.call(e, r) && qx(t, r, e[r]);
  if ($x)
    for (var r of $x(e))
      lhe.call(e, r) && qx(t, r, e[r]);
  return t;
};
class dhe extends bfe {
  constructor(e) {
    super(e), this.protocol = "wc", this.version = 2, this.events = new Pr.exports.EventEmitter(), this.name = sce, this.transportExplicitlyClosed = !1, this.initialized = !1, this.connectionAttemptInProgress = !1, this.connectionStatusPollingInterval = 20, this.staleConnectionErrors = ["socket hang up", "stalled", "interrupted"], this.hasExperiencedNetworkDisruption = !1, this.requestsInFlight = /* @__PURE__ */ new Map(), this.heartBeatTimeout = ct.toMiliseconds(ct.THIRTY_SECONDS + ct.ONE_SECOND), this.request = async (r) => {
      var i, s;
      this.logger.debug("Publishing Request Payload");
      const n = r.id || Xo().toString();
      await this.toEstablishConnection();
      try {
        const f = this.provider.request(r);
        this.requestsInFlight.set(n, { promise: f, request: r }), this.logger.trace({ id: n, method: r.method, topic: (i = r.params) == null ? void 0 : i.topic }, "relayer.request - attempt to publish...");
        const u = await new Promise(async (h, d) => {
          const l = () => {
            d(new Error(`relayer.request - publish interrupted, id: ${n}`));
          };
          this.provider.on(Gn.disconnect, l);
          const m = await f;
          this.provider.off(Gn.disconnect, l), h(m);
        });
        return this.logger.trace({ id: n, method: r.method, topic: (s = r.params) == null ? void 0 : s.topic }, "relayer.request - published"), u;
      } catch (f) {
        throw this.logger.debug(`Failed to Publish Request: ${n}`), f;
      } finally {
        this.requestsInFlight.delete(n);
      }
    }, this.resetPingTimeout = () => {
      if (B0())
        try {
          clearTimeout(this.pingTimeout), this.pingTimeout = setTimeout(() => {
            var r, i, s;
            (s = (i = (r = this.provider) == null ? void 0 : r.connection) == null ? void 0 : i.socket) == null || s.terminate();
          }, this.heartBeatTimeout);
        } catch (r) {
          this.logger.warn(r);
        }
    }, this.onPayloadHandler = (r) => {
      this.onProviderPayload(r), this.resetPingTimeout();
    }, this.onConnectHandler = () => {
      this.logger.trace("relayer connected"), this.startPingTimeout(), this.events.emit(Yi.connect);
    }, this.onDisconnectHandler = () => {
      this.logger.trace("relayer disconnected"), this.onProviderDisconnect();
    }, this.onProviderErrorHandler = (r) => {
      this.logger.error(r), this.events.emit(Yi.error, r), this.logger.info("Fatal socket error received, closing transport"), this.transportClose();
    }, this.registerProviderListeners = () => {
      this.provider.on(Gn.payload, this.onPayloadHandler), this.provider.on(Gn.connect, this.onConnectHandler), this.provider.on(Gn.disconnect, this.onDisconnectHandler), this.provider.on(Gn.error, this.onProviderErrorHandler);
    }, this.core = e.core, this.logger = typeof e.logger < "u" && typeof e.logger != "string" ? en(e.logger, this.name) : Ys(o1({ level: e.logger || nce })), this.messages = new the(this.logger, e.core), this.subscriber = new che(this, this.logger), this.publisher = new rhe(this, this.logger), this.relayUrl = (e == null ? void 0 : e.relayUrl) || qT, this.projectId = e.projectId, this.bundleId = Sse(), this.provider = {};
  }
  async init() {
    if (this.logger.trace("Initialized"), this.registerEventListeners(), await Promise.all([this.messages.init(), this.subscriber.init()]), this.initialized = !0, this.subscriber.cached.length > 0)
      try {
        await this.transportOpen();
      } catch (e) {
        this.logger.warn(e);
      }
  }
  get context() {
    return pn(this.logger);
  }
  get connected() {
    var e, r, i;
    return ((i = (r = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : r.socket) == null ? void 0 : i.readyState) === 1;
  }
  get connecting() {
    var e, r, i;
    return ((i = (r = (e = this.provider) == null ? void 0 : e.connection) == null ? void 0 : r.socket) == null ? void 0 : i.readyState) === 0;
  }
  async publish(e, r, i) {
    this.isInitialized(), await this.publisher.publish(e, r, i), await this.recordMessageEvent({ topic: e, message: r, publishedAt: Date.now(), transportType: Or.relay });
  }
  async subscribe(e, r) {
    var i, s, n;
    this.isInitialized(), (r == null ? void 0 : r.transportType) === "relay" && await this.toEstablishConnection();
    const f = typeof ((i = r == null ? void 0 : r.internal) == null ? void 0 : i.throwOnFailedPublish) > "u" ? !0 : (s = r == null ? void 0 : r.internal) == null ? void 0 : s.throwOnFailedPublish;
    let u = ((n = this.subscriber.topicMap.get(e)) == null ? void 0 : n[0]) || "", h;
    const d = (l) => {
      l.topic === e && (this.subscriber.off(Ws.created, d), h());
    };
    return await Promise.all([new Promise((l) => {
      h = l, this.subscriber.on(Ws.created, d);
    }), new Promise(async (l, m) => {
      u = await this.subscriber.subscribe(e, Hx({ internal: { throwOnFailedPublish: f } }, r)).catch((b) => {
        f && m(b);
      }) || u, l();
    })]), u;
  }
  async unsubscribe(e, r) {
    this.isInitialized(), await this.subscriber.unsubscribe(e, r);
  }
  on(e, r) {
    this.events.on(e, r);
  }
  once(e, r) {
    this.events.once(e, r);
  }
  off(e, r) {
    this.events.off(e, r);
  }
  removeListener(e, r) {
    this.events.removeListener(e, r);
  }
  async transportDisconnect() {
    if (!this.hasExperiencedNetworkDisruption && this.connected && this.requestsInFlight.size > 0)
      try {
        await Promise.all(Array.from(this.requestsInFlight.values()).map((e) => e.promise));
      } catch (e) {
        this.logger.warn(e);
      }
    this.hasExperiencedNetworkDisruption || this.connected ? await gc(this.provider.disconnect(), 2e3, "provider.disconnect()").catch(() => this.onProviderDisconnect()) : this.onProviderDisconnect();
  }
  async transportClose() {
    this.transportExplicitlyClosed = !0, await this.transportDisconnect();
  }
  async transportOpen(e) {
    await this.confirmOnlineStateOrThrow(), e && e !== this.relayUrl && (this.relayUrl = e, await this.transportDisconnect()), await this.createProvider(), this.connectionAttemptInProgress = !0, this.transportExplicitlyClosed = !1;
    try {
      await new Promise(async (r, i) => {
        const s = () => {
          this.provider.off(Gn.disconnect, s), i(new Error("Connection interrupted while trying to subscribe"));
        };
        this.provider.on(Gn.disconnect, s), await gc(this.provider.connect(), ct.toMiliseconds(ct.ONE_MINUTE), `Socket stalled when trying to connect to ${this.relayUrl}`).catch((n) => {
          i(n);
        }).finally(() => {
          clearTimeout(this.reconnectTimeout), this.reconnectTimeout = void 0;
        }), this.subscriber.start().catch((n) => {
          this.logger.error(n), this.onDisconnectHandler();
        }), this.hasExperiencedNetworkDisruption = !1, r();
      });
    } catch (r) {
      this.logger.error(r);
      const i = r;
      if (this.hasExperiencedNetworkDisruption = !0, !this.isConnectionStalled(i.message))
        throw r;
    } finally {
      this.connectionAttemptInProgress = !1;
    }
  }
  async restartTransport(e) {
    this.connectionAttemptInProgress || (this.relayUrl = e || this.relayUrl, await this.confirmOnlineStateOrThrow(), await this.transportClose(), await this.transportOpen());
  }
  async confirmOnlineStateOrThrow() {
    if (!await vx())
      throw new Error("No internet connection detected. Please restart your network and try again.");
  }
  async handleBatchMessageEvents(e) {
    if ((e == null ? void 0 : e.length) === 0) {
      this.logger.trace("Batch message events is empty. Ignoring...");
      return;
    }
    const r = e.sort((i, s) => i.publishedAt - s.publishedAt);
    this.logger.trace(`Batch of ${r.length} message events sorted`);
    for (const i of r)
      try {
        await this.onMessageEvent(i);
      } catch (s) {
        this.logger.warn(s);
      }
    this.logger.trace(`Batch of ${r.length} message events processed`);
  }
  async onLinkMessageEvent(e, r) {
    const { topic: i } = e;
    if (!r.sessionExists) {
      const s = ci(ct.FIVE_MINUTES), n = { topic: i, expiry: s, relay: { protocol: "irn" }, active: !1 };
      await this.core.pairing.pairings.set(i, n);
    }
    this.events.emit(Yi.message, e), await this.recordMessageEvent(e);
  }
  startPingTimeout() {
    var e, r, i, s, n;
    if (B0())
      try {
        (r = (e = this.provider) == null ? void 0 : e.connection) != null && r.socket && ((n = (s = (i = this.provider) == null ? void 0 : i.connection) == null ? void 0 : s.socket) == null || n.once("ping", () => {
          this.resetPingTimeout();
        })), this.resetPingTimeout();
      } catch (f) {
        this.logger.warn(f);
      }
  }
  isConnectionStalled(e) {
    return this.staleConnectionErrors.some((r) => e.includes(r));
  }
  async createProvider() {
    this.provider.connection && this.unregisterProviderListeners();
    const e = await this.core.crypto.signJWT(this.relayUrl);
    this.provider = new Ns(new Vfe(Tse({ sdkVersion: $m, protocol: this.protocol, version: this.version, relayUrl: this.relayUrl, projectId: this.projectId, auth: e, useOnCloseEvent: !0, bundleId: this.bundleId }))), this.registerProviderListeners();
  }
  async recordMessageEvent(e) {
    const { topic: r, message: i } = e;
    await this.messages.set(r, i);
  }
  async shouldIgnoreMessageEvent(e) {
    const { topic: r, message: i } = e;
    if (!i || i.length === 0)
      return this.logger.debug(`Ignoring invalid/empty message: ${i}`), !0;
    if (!await this.subscriber.isSubscribed(r))
      return this.logger.debug(`Ignoring message for non-subscribed topic ${r}`), !0;
    const s = this.messages.has(r, i);
    return s && this.logger.debug(`Ignoring duplicate message: ${i}`), s;
  }
  async onProviderPayload(e) {
    if (this.logger.debug("Incoming Relay Payload"), this.logger.trace({ type: "payload", direction: "incoming", payload: e }), zw(e)) {
      if (!e.method.endsWith(ace))
        return;
      const r = e.params, { topic: i, message: s, publishedAt: n, attestation: f } = r.data, u = { topic: i, message: s, publishedAt: n, transportType: Or.relay, attestation: f };
      this.logger.debug("Emitting Relayer Payload"), this.logger.trace(Hx({ type: "event", event: r.id }, u)), this.events.emit(r.id, u), await this.acknowledgePayload(e), await this.onMessageEvent(u);
    } else
      u1(e) && this.events.emit(Yi.message_ack, e);
  }
  async onMessageEvent(e) {
    await this.shouldIgnoreMessageEvent(e) || (this.events.emit(Yi.message, e), await this.recordMessageEvent(e));
  }
  async acknowledgePayload(e) {
    const r = f1(e.id, !0);
    await this.provider.connection.send(r);
  }
  unregisterProviderListeners() {
    this.provider.off(Gn.payload, this.onPayloadHandler), this.provider.off(Gn.connect, this.onConnectHandler), this.provider.off(Gn.disconnect, this.onDisconnectHandler), this.provider.off(Gn.error, this.onProviderErrorHandler), clearTimeout(this.pingTimeout);
  }
  async registerEventListeners() {
    let e = await vx();
    soe(async (r) => {
      e !== r && (e = r, r ? await this.restartTransport().catch((i) => this.logger.error(i)) : (this.hasExperiencedNetworkDisruption = !0, await this.transportDisconnect(), this.transportExplicitlyClosed = !1));
    });
  }
  async onProviderDisconnect() {
    await this.subscriber.stop(), this.requestsInFlight.clear(), clearTimeout(this.pingTimeout), this.events.emit(Yi.disconnect), this.connectionAttemptInProgress = !1, !this.transportExplicitlyClosed && (this.reconnectTimeout || (this.reconnectTimeout = setTimeout(async () => {
      await this.transportOpen().catch((e) => this.logger.error(e));
    }, ct.toMiliseconds(oce))));
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = ot("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
  async toEstablishConnection() {
    await this.confirmOnlineStateOrThrow(), !this.connected && (this.connectionAttemptInProgress && await new Promise((e) => {
      const r = setInterval(() => {
        this.connected && (clearInterval(r), e());
      }, this.connectionStatusPollingInterval);
    }), await this.transportOpen());
  }
}
var phe = Object.defineProperty, Wx = Object.getOwnPropertySymbols, vhe = Object.prototype.hasOwnProperty, ghe = Object.prototype.propertyIsEnumerable, Vx = (t, e, r) => e in t ? phe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Gx = (t, e) => {
  for (var r in e || (e = {}))
    vhe.call(e, r) && Vx(t, r, e[r]);
  if (Wx)
    for (var r of Wx(e))
      ghe.call(e, r) && Vx(t, r, e[r]);
  return t;
};
class Sf extends yfe {
  constructor(e, r, i, s = aa, n = void 0) {
    super(e, r, i, s), this.core = e, this.logger = r, this.name = i, this.map = /* @__PURE__ */ new Map(), this.version = fce, this.cached = [], this.initialized = !1, this.storagePrefix = aa, this.recentlyDeleted = [], this.recentlyDeletedLimit = 200, this.init = async () => {
      this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((f) => {
        this.getKey && f !== null && !Qi(f) ? this.map.set(this.getKey(f), f) : kae(f) ? this.map.set(f.id, f) : jae(f) && this.map.set(f.topic, f);
      }), this.cached = [], this.initialized = !0);
    }, this.set = async (f, u) => {
      this.isInitialized(), this.map.has(f) ? await this.update(f, u) : (this.logger.debug("Setting value"), this.logger.trace({ type: "method", method: "set", key: f, value: u }), this.map.set(f, u), await this.persist());
    }, this.get = (f) => (this.isInitialized(), this.logger.debug("Getting value"), this.logger.trace({ type: "method", method: "get", key: f }), this.getData(f)), this.getAll = (f) => (this.isInitialized(), f ? this.values.filter((u) => Object.keys(f).every((h) => Gfe(u[h], f[h]))) : this.values), this.update = async (f, u) => {
      this.isInitialized(), this.logger.debug("Updating value"), this.logger.trace({ type: "method", method: "update", key: f, update: u });
      const h = Gx(Gx({}, this.getData(f)), u);
      this.map.set(f, h), await this.persist();
    }, this.delete = async (f, u) => {
      this.isInitialized(), this.map.has(f) && (this.logger.debug("Deleting value"), this.logger.trace({ type: "method", method: "delete", key: f, reason: u }), this.map.delete(f), this.addToRecentlyDeleted(f), await this.persist());
    }, this.logger = en(r, this.name), this.storagePrefix = s, this.getKey = n;
  }
  get context() {
    return pn(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  get length() {
    return this.map.size;
  }
  get keys() {
    return Array.from(this.map.keys());
  }
  get values() {
    return Array.from(this.map.values());
  }
  addToRecentlyDeleted(e) {
    this.recentlyDeleted.push(e), this.recentlyDeleted.length >= this.recentlyDeletedLimit && this.recentlyDeleted.splice(0, this.recentlyDeletedLimit / 2);
  }
  async setDataStore(e) {
    await this.core.storage.setItem(this.storageKey, e);
  }
  async getDataStore() {
    return await this.core.storage.getItem(this.storageKey);
  }
  getData(e) {
    const r = this.map.get(e);
    if (!r) {
      if (this.recentlyDeleted.includes(e)) {
        const { message: s } = ot("MISSING_OR_INVALID", `Record was recently deleted - ${this.name}: ${e}`);
        throw this.logger.error(s), new Error(s);
      }
      const { message: i } = ot("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw this.logger.error(i), new Error(i);
    }
    return r;
  }
  async persist() {
    await this.setDataStore(this.values);
  }
  async restore() {
    try {
      const e = await this.getDataStore();
      if (typeof e > "u" || !e.length)
        return;
      if (this.map.size) {
        const { message: r } = ot("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(r), new Error(r);
      }
      this.cached = e, this.logger.debug(`Successfully Restored value for ${this.name}`), this.logger.trace({ type: "method", method: "restore", value: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore value for ${this.name}`), this.logger.error(e);
    }
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = ot("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
class bhe {
  constructor(e, r) {
    this.core = e, this.logger = r, this.name = dce, this.version = pce, this.events = new Pr.exports(), this.initialized = !1, this.storagePrefix = aa, this.ignoredPayloadTypes = [Na], this.registeredMethods = [], this.init = async () => {
      this.initialized || (await this.pairings.init(), await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.initialized = !0, this.logger.trace("Initialized"));
    }, this.register = ({ methods: i }) => {
      this.isInitialized(), this.registeredMethods = [.../* @__PURE__ */ new Set([...this.registeredMethods, ...i])];
    }, this.create = async (i) => {
      this.isInitialized();
      const s = jm(), n = await this.core.crypto.setSymKey(s), f = ci(ct.FIVE_MINUTES), u = { protocol: $T }, h = { topic: n, expiry: f, relay: u, active: !1, methods: i == null ? void 0 : i.methods }, d = cx({ protocol: this.core.protocol, version: this.core.version, topic: n, symKey: s, relay: u, expiryTimestamp: f, methods: i == null ? void 0 : i.methods });
      return this.events.emit(Go.create, h), this.core.expirer.set(n, f), await this.pairings.set(n, h), await this.core.relayer.subscribe(n, { transportType: i == null ? void 0 : i.transportType }), { topic: n, uri: d };
    }, this.pair = async (i) => {
      this.isInitialized();
      const s = this.core.eventClient.createEvent({ properties: { topic: i == null ? void 0 : i.uri, trace: [Fs.pairing_started] } });
      this.isValidPair(i, s);
      const { topic: n, symKey: f, relay: u, expiryTimestamp: h, methods: d } = fx(i.uri);
      s.props.properties.topic = n, s.addTrace(Fs.pairing_uri_validation_success), s.addTrace(Fs.pairing_uri_not_expired);
      let l;
      if (this.pairings.keys.includes(n)) {
        if (l = this.pairings.get(n), s.addTrace(Fs.existing_pairing), l.active)
          throw s.setError(xa.active_pairing_already_exists), new Error(`Pairing already exists: ${n}. Please try again with a new connection URI.`);
        s.addTrace(Fs.pairing_not_expired);
      }
      const m = h || ci(ct.FIVE_MINUTES), b = { topic: n, relay: u, expiry: m, active: !1, methods: d };
      this.core.expirer.set(n, m), await this.pairings.set(n, b), s.addTrace(Fs.store_new_pairing), i.activatePairing && await this.activate({ topic: n }), this.events.emit(Go.create, b), s.addTrace(Fs.emit_inactive_pairing), this.core.crypto.keychain.has(n) || await this.core.crypto.setSymKey(f, n), s.addTrace(Fs.subscribing_pairing_topic);
      try {
        await this.core.relayer.confirmOnlineStateOrThrow();
      } catch {
        s.setError(xa.no_internet_connection);
      }
      try {
        await this.core.relayer.subscribe(n, { relay: u });
      } catch (M) {
        throw s.setError(xa.subscribe_pairing_topic_failure), M;
      }
      return s.addTrace(Fs.subscribe_pairing_topic_success), b;
    }, this.activate = async ({ topic: i }) => {
      this.isInitialized();
      const s = ci(ct.THIRTY_DAYS);
      this.core.expirer.set(i, s), await this.pairings.update(i, { active: !0, expiry: s });
    }, this.ping = async (i) => {
      this.isInitialized(), await this.isValidPing(i);
      const { topic: s } = i;
      if (this.pairings.keys.includes(s)) {
        const n = await this.sendRequest(s, "wc_pairingPing", {}), { done: f, resolve: u, reject: h } = $o();
        this.events.once(Yt("pairing_ping", n), ({ error: d }) => {
          d ? h(d) : u();
        }), await f();
      }
    }, this.updateExpiry = async ({ topic: i, expiry: s }) => {
      this.isInitialized(), await this.pairings.update(i, { expiry: s });
    }, this.updateMetadata = async ({ topic: i, metadata: s }) => {
      this.isInitialized(), await this.pairings.update(i, { peerMetadata: s });
    }, this.getPairings = () => (this.isInitialized(), this.pairings.values), this.disconnect = async (i) => {
      this.isInitialized(), await this.isValidDisconnect(i);
      const { topic: s } = i;
      this.pairings.keys.includes(s) && (await this.sendRequest(s, "wc_pairingDelete", wr("USER_DISCONNECTED")), await this.deletePairing(s));
    }, this.formatUriFromPairing = (i) => {
      this.isInitialized();
      const { topic: s, relay: n, expiry: f, methods: u } = i, h = this.core.crypto.keychain.get(s);
      return cx({ protocol: this.core.protocol, version: this.core.version, topic: s, symKey: h, relay: n, expiryTimestamp: f, methods: u });
    }, this.sendRequest = async (i, s, n) => {
      const f = no(s, n), u = await this.core.crypto.encode(i, f), h = qu[s].req;
      return this.core.history.set(i, f), this.core.relayer.publish(i, u, h), f.id;
    }, this.sendResult = async (i, s, n) => {
      const f = f1(i, n), u = await this.core.crypto.encode(s, f), h = await this.core.history.get(s, i), d = qu[h.request.method].res;
      await this.core.relayer.publish(s, u, d), await this.core.history.resolve(f);
    }, this.sendError = async (i, s, n) => {
      const f = c1(i, n), u = await this.core.crypto.encode(s, f), h = await this.core.history.get(s, i), d = qu[h.request.method] ? qu[h.request.method].res : qu.unregistered_method.res;
      await this.core.relayer.publish(s, u, d), await this.core.history.resolve(f);
    }, this.deletePairing = async (i, s) => {
      await this.core.relayer.unsubscribe(i), await Promise.all([this.pairings.delete(i, wr("USER_DISCONNECTED")), this.core.crypto.deleteSymKey(i), s ? Promise.resolve() : this.core.expirer.del(i)]);
    }, this.cleanup = async () => {
      const i = this.pairings.getAll().filter((s) => Ja(s.expiry));
      await Promise.all(i.map((s) => this.deletePairing(s.topic)));
    }, this.onRelayEventRequest = (i) => {
      const { topic: s, payload: n } = i;
      switch (n.method) {
        case "wc_pairingPing":
          return this.onPairingPingRequest(s, n);
        case "wc_pairingDelete":
          return this.onPairingDeleteRequest(s, n);
        default:
          return this.onUnknownRpcMethodRequest(s, n);
      }
    }, this.onRelayEventResponse = async (i) => {
      const { topic: s, payload: n } = i, f = (await this.core.history.get(s, n.id)).request.method;
      switch (f) {
        case "wc_pairingPing":
          return this.onPairingPingResponse(s, n);
        default:
          return this.onUnknownRpcMethodResponse(f);
      }
    }, this.onPairingPingRequest = async (i, s) => {
      const { id: n } = s;
      try {
        this.isValidPing({ topic: i }), await this.sendResult(n, i, !0), this.events.emit(Go.ping, { id: n, topic: i });
      } catch (f) {
        await this.sendError(n, i, f), this.logger.error(f);
      }
    }, this.onPairingPingResponse = (i, s) => {
      const { id: n } = s;
      setTimeout(() => {
        Hs(s) ? this.events.emit(Yt("pairing_ping", n), {}) : Qn(s) && this.events.emit(Yt("pairing_ping", n), { error: s.error });
      }, 500);
    }, this.onPairingDeleteRequest = async (i, s) => {
      const { id: n } = s;
      try {
        this.isValidDisconnect({ topic: i }), await this.deletePairing(i), this.events.emit(Go.delete, { id: n, topic: i });
      } catch (f) {
        await this.sendError(n, i, f), this.logger.error(f);
      }
    }, this.onUnknownRpcMethodRequest = async (i, s) => {
      const { id: n, method: f } = s;
      try {
        if (this.registeredMethods.includes(f))
          return;
        const u = wr("WC_METHOD_UNSUPPORTED", f);
        await this.sendError(n, i, u), this.logger.error(u);
      } catch (u) {
        await this.sendError(n, i, u), this.logger.error(u);
      }
    }, this.onUnknownRpcMethodResponse = (i) => {
      this.registeredMethods.includes(i) || this.logger.error(wr("WC_METHOD_UNSUPPORTED", i));
    }, this.isValidPair = (i, s) => {
      var n;
      if (!fn(i)) {
        const { message: u } = ot("MISSING_OR_INVALID", `pair() params: ${i}`);
        throw s.setError(xa.malformed_pairing_uri), new Error(u);
      }
      if (!Pae(i.uri)) {
        const { message: u } = ot("MISSING_OR_INVALID", `pair() uri: ${i.uri}`);
        throw s.setError(xa.malformed_pairing_uri), new Error(u);
      }
      const f = fx(i == null ? void 0 : i.uri);
      if (!((n = f == null ? void 0 : f.relay) != null && n.protocol)) {
        const { message: u } = ot("MISSING_OR_INVALID", "pair() uri#relay-protocol");
        throw s.setError(xa.malformed_pairing_uri), new Error(u);
      }
      if (!(f != null && f.symKey)) {
        const { message: u } = ot("MISSING_OR_INVALID", "pair() uri#symKey");
        throw s.setError(xa.malformed_pairing_uri), new Error(u);
      }
      if (f != null && f.expiryTimestamp && ct.toMiliseconds(f == null ? void 0 : f.expiryTimestamp) < Date.now()) {
        s.setError(xa.pairing_expired);
        const { message: u } = ot("EXPIRED", "pair() URI has expired. Please try again with a new connection URI.");
        throw new Error(u);
      }
    }, this.isValidPing = async (i) => {
      if (!fn(i)) {
        const { message: n } = ot("MISSING_OR_INVALID", `ping() params: ${i}`);
        throw new Error(n);
      }
      const { topic: s } = i;
      await this.isValidPairingTopic(s);
    }, this.isValidDisconnect = async (i) => {
      if (!fn(i)) {
        const { message: n } = ot("MISSING_OR_INVALID", `disconnect() params: ${i}`);
        throw new Error(n);
      }
      const { topic: s } = i;
      await this.isValidPairingTopic(s);
    }, this.isValidPairingTopic = async (i) => {
      if (!ii(i, !1)) {
        const { message: s } = ot("MISSING_OR_INVALID", `pairing topic should be a string: ${i}`);
        throw new Error(s);
      }
      if (!this.pairings.keys.includes(i)) {
        const { message: s } = ot("NO_MATCHING_KEY", `pairing topic doesn't exist: ${i}`);
        throw new Error(s);
      }
      if (Ja(this.pairings.get(i).expiry)) {
        await this.deletePairing(i);
        const { message: s } = ot("EXPIRED", `pairing topic: ${i}`);
        throw new Error(s);
      }
    }, this.core = e, this.logger = en(r, this.name), this.pairings = new Sf(this.core, this.logger, this.name, this.storagePrefix);
  }
  get context() {
    return pn(this.logger);
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = ot("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
  registerRelayerEvents() {
    this.core.relayer.on(Yi.message, async (e) => {
      const { topic: r, message: i, transportType: s } = e;
      if (!this.pairings.keys.includes(r) || s === Or.link_mode || this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(i)))
        return;
      const n = await this.core.crypto.decode(r, i);
      try {
        zw(n) ? (this.core.history.set(r, n), this.onRelayEventRequest({ topic: r, payload: n })) : u1(n) && (await this.core.history.resolve(n), await this.onRelayEventResponse({ topic: r, payload: n }), this.core.history.delete(r, n.id));
      } catch (f) {
        this.logger.error(f);
      }
    });
  }
  registerExpirerEvents() {
    this.core.expirer.on(Kn.expired, async (e) => {
      const { topic: r } = bT(e.target);
      r && this.pairings.keys.includes(r) && (await this.deletePairing(r, !0), this.events.emit(Go.expire, { topic: r }));
    });
  }
}
class yhe extends pfe {
  constructor(e, r) {
    super(e, r), this.core = e, this.logger = r, this.records = /* @__PURE__ */ new Map(), this.events = new Pr.exports.EventEmitter(), this.name = vce, this.version = gce, this.cached = [], this.initialized = !1, this.storagePrefix = aa, this.init = async () => {
      this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i) => this.records.set(i.id, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
    }, this.set = (i, s, n) => {
      if (this.isInitialized(), this.logger.debug("Setting JSON-RPC request history record"), this.logger.trace({ type: "method", method: "set", topic: i, request: s, chainId: n }), this.records.has(s.id))
        return;
      const f = { id: s.id, topic: i, request: { method: s.method, params: s.params || null }, chainId: n, expiry: ci(ct.THIRTY_DAYS) };
      this.records.set(f.id, f), this.persist(), this.events.emit(ys.created, f);
    }, this.resolve = async (i) => {
      if (this.isInitialized(), this.logger.debug("Updating JSON-RPC response history record"), this.logger.trace({ type: "method", method: "update", response: i }), !this.records.has(i.id))
        return;
      const s = await this.getRecord(i.id);
      typeof s.response > "u" && (s.response = Qn(i) ? { error: i.error } : { result: i.result }, this.records.set(s.id, s), this.persist(), this.events.emit(ys.updated, s));
    }, this.get = async (i, s) => (this.isInitialized(), this.logger.debug("Getting record"), this.logger.trace({ type: "method", method: "get", topic: i, id: s }), await this.getRecord(s)), this.delete = (i, s) => {
      this.isInitialized(), this.logger.debug("Deleting record"), this.logger.trace({ type: "method", method: "delete", id: s }), this.values.forEach((n) => {
        if (n.topic === i) {
          if (typeof s < "u" && n.id !== s)
            return;
          this.records.delete(n.id), this.events.emit(ys.deleted, n);
        }
      }), this.persist();
    }, this.exists = async (i, s) => (this.isInitialized(), this.records.has(s) ? (await this.getRecord(s)).topic === i : !1), this.on = (i, s) => {
      this.events.on(i, s);
    }, this.once = (i, s) => {
      this.events.once(i, s);
    }, this.off = (i, s) => {
      this.events.off(i, s);
    }, this.removeListener = (i, s) => {
      this.events.removeListener(i, s);
    }, this.logger = en(r, this.name);
  }
  get context() {
    return pn(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  get size() {
    return this.records.size;
  }
  get keys() {
    return Array.from(this.records.keys());
  }
  get values() {
    return Array.from(this.records.values());
  }
  get pending() {
    const e = [];
    return this.values.forEach((r) => {
      if (typeof r.response < "u")
        return;
      const i = { topic: r.topic, request: no(r.request.method, r.request.params, r.id), chainId: r.chainId };
      return e.push(i);
    }), e;
  }
  async setJsonRpcRecords(e) {
    await this.core.storage.setItem(this.storageKey, e);
  }
  async getJsonRpcRecords() {
    return await this.core.storage.getItem(this.storageKey);
  }
  getRecord(e) {
    this.isInitialized();
    const r = this.records.get(e);
    if (!r) {
      const { message: i } = ot("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw new Error(i);
    }
    return r;
  }
  async persist() {
    await this.setJsonRpcRecords(this.values), this.events.emit(ys.sync);
  }
  async restore() {
    try {
      const e = await this.getJsonRpcRecords();
      if (typeof e > "u" || !e.length)
        return;
      if (this.records.size) {
        const { message: r } = ot("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(r), new Error(r);
      }
      this.cached = e, this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({ type: "method", method: "restore", records: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(e);
    }
  }
  registerEventListeners() {
    this.events.on(ys.created, (e) => {
      const r = ys.created;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, record: e });
    }), this.events.on(ys.updated, (e) => {
      const r = ys.updated;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, record: e });
    }), this.events.on(ys.deleted, (e) => {
      const r = ys.deleted;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, record: e });
    }), this.core.heartbeat.on(ou.pulse, () => {
      this.cleanup();
    });
  }
  cleanup() {
    try {
      this.isInitialized();
      let e = !1;
      this.records.forEach((r) => {
        ct.toMiliseconds(r.expiry || 0) - Date.now() <= 0 && (this.logger.info(`Deleting expired history log: ${r.id}`), this.records.delete(r.id), this.events.emit(ys.deleted, r, !1), e = !0);
      }), e && this.persist();
    } catch (e) {
      this.logger.warn(e);
    }
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = ot("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
class mhe extends wfe {
  constructor(e, r) {
    super(e, r), this.core = e, this.logger = r, this.expirations = /* @__PURE__ */ new Map(), this.events = new Pr.exports.EventEmitter(), this.name = bce, this.version = yce, this.cached = [], this.initialized = !1, this.storagePrefix = aa, this.init = async () => {
      this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i) => this.expirations.set(i.target, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
    }, this.has = (i) => {
      try {
        const s = this.formatTarget(i);
        return typeof this.getExpiration(s) < "u";
      } catch {
        return !1;
      }
    }, this.set = (i, s) => {
      this.isInitialized();
      const n = this.formatTarget(i), f = { target: n, expiry: s };
      this.expirations.set(n, f), this.checkExpiry(n, f), this.events.emit(Kn.created, { target: n, expiration: f });
    }, this.get = (i) => {
      this.isInitialized();
      const s = this.formatTarget(i);
      return this.getExpiration(s);
    }, this.del = (i) => {
      if (this.isInitialized(), this.has(i)) {
        const s = this.formatTarget(i), n = this.getExpiration(s);
        this.expirations.delete(s), this.events.emit(Kn.deleted, { target: s, expiration: n });
      }
    }, this.on = (i, s) => {
      this.events.on(i, s);
    }, this.once = (i, s) => {
      this.events.once(i, s);
    }, this.off = (i, s) => {
      this.events.off(i, s);
    }, this.removeListener = (i, s) => {
      this.events.removeListener(i, s);
    }, this.logger = en(r, this.name);
  }
  get context() {
    return pn(this.logger);
  }
  get storageKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
  }
  get length() {
    return this.expirations.size;
  }
  get keys() {
    return Array.from(this.expirations.keys());
  }
  get values() {
    return Array.from(this.expirations.values());
  }
  formatTarget(e) {
    if (typeof e == "string")
      return Nse(e);
    if (typeof e == "number")
      return Dse(e);
    const { message: r } = ot("UNKNOWN_TYPE", `Target type: ${typeof e}`);
    throw new Error(r);
  }
  async setExpirations(e) {
    await this.core.storage.setItem(this.storageKey, e);
  }
  async getExpirations() {
    return await this.core.storage.getItem(this.storageKey);
  }
  async persist() {
    await this.setExpirations(this.values), this.events.emit(Kn.sync);
  }
  async restore() {
    try {
      const e = await this.getExpirations();
      if (typeof e > "u" || !e.length)
        return;
      if (this.expirations.size) {
        const { message: r } = ot("RESTORE_WILL_OVERRIDE", this.name);
        throw this.logger.error(r), new Error(r);
      }
      this.cached = e, this.logger.debug(`Successfully Restored expirations for ${this.name}`), this.logger.trace({ type: "method", method: "restore", expirations: this.values });
    } catch (e) {
      this.logger.debug(`Failed to Restore expirations for ${this.name}`), this.logger.error(e);
    }
  }
  getExpiration(e) {
    const r = this.expirations.get(e);
    if (!r) {
      const { message: i } = ot("NO_MATCHING_KEY", `${this.name}: ${e}`);
      throw this.logger.warn(i), new Error(i);
    }
    return r;
  }
  checkExpiry(e, r) {
    const { expiry: i } = r;
    ct.toMiliseconds(i) - Date.now() <= 0 && this.expire(e, r);
  }
  expire(e, r) {
    this.expirations.delete(e), this.events.emit(Kn.expired, { target: e, expiration: r });
  }
  checkExpirations() {
    this.core.relayer.connected && this.expirations.forEach((e, r) => this.checkExpiry(r, e));
  }
  registerEventListeners() {
    this.core.heartbeat.on(ou.pulse, () => this.checkExpirations()), this.events.on(Kn.created, (e) => {
      const r = Kn.created;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, data: e }), this.persist();
    }), this.events.on(Kn.expired, (e) => {
      const r = Kn.expired;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, data: e }), this.persist();
    }), this.events.on(Kn.deleted, (e) => {
      const r = Kn.deleted;
      this.logger.info(`Emitting ${r}`), this.logger.debug({ type: "event", event: r, data: e }), this.persist();
    });
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = ot("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
}
class whe extends _fe {
  constructor(e, r, i) {
    super(e, r, i), this.core = e, this.logger = r, this.store = i, this.name = mce, this.verifyUrlV3 = _ce, this.storagePrefix = aa, this.version = FT, this.init = async () => {
      var s;
      this.isDevEnv || (this.publicKey = await this.store.getItem(this.storeKey), this.publicKey && ct.toMiliseconds((s = this.publicKey) == null ? void 0 : s.expiresAt) < Date.now() && (this.logger.debug("verify v2 public key expired"), await this.removePublicKey()));
    }, this.register = async (s) => {
      if (!sl() || this.isDevEnv)
        return;
      const n = window.location.origin, { id: f, decryptedId: u } = s, h = `${this.verifyUrlV3}/attestation?projectId=${this.core.projectId}&origin=${n}&id=${f}&decryptedId=${u}`;
      try {
        const d = Qh(), l = this.startAbortTimer(ct.ONE_SECOND * 5), m = await new Promise((b, M) => {
          const A = () => {
            window.removeEventListener("message", R), d.body.removeChild(N), M("attestation aborted");
          };
          this.abortController.signal.addEventListener("abort", A);
          const N = d.createElement("iframe");
          N.src = h, N.style.display = "none", N.addEventListener("error", A, { signal: this.abortController.signal });
          const R = (O) => {
            if (O.data && typeof O.data == "string")
              try {
                const P = JSON.parse(O.data);
                if (P.type === "verify_attestation") {
                  if (Pm(P.attestation).payload.id !== f)
                    return;
                  clearInterval(l), d.body.removeChild(N), this.abortController.signal.removeEventListener("abort", A), window.removeEventListener("message", R), b(P.attestation === null ? "" : P.attestation);
                }
              } catch (P) {
                this.logger.warn(P);
              }
          };
          d.body.appendChild(N), window.addEventListener("message", R, { signal: this.abortController.signal });
        });
        return this.logger.debug("jwt attestation", m), m;
      } catch (d) {
        this.logger.warn(d);
      }
      return "";
    }, this.resolve = async (s) => {
      if (this.isDevEnv)
        return "";
      const { attestationId: n, hash: f, encryptedId: u } = s;
      if (n === "") {
        this.logger.debug("resolve: attestationId is empty, skipping");
        return;
      }
      if (n) {
        if (Pm(n).payload.id !== u)
          return;
        const d = await this.isValidJwtAttestation(n);
        if (d) {
          if (!d.isVerified) {
            this.logger.warn("resolve: jwt attestation: origin url not verified");
            return;
          }
          return d;
        }
      }
      if (!f)
        return;
      const h = this.getVerifyUrl(s == null ? void 0 : s.verifyUrl);
      return this.fetchAttestation(f, h);
    }, this.fetchAttestation = async (s, n) => {
      this.logger.debug(`resolving attestation: ${s} from url: ${n}`);
      const f = this.startAbortTimer(ct.ONE_SECOND * 5), u = await fetch(`${n}/attestation/${s}?v2Supported=true`, { signal: this.abortController.signal });
      return clearTimeout(f), u.status === 200 ? await u.json() : void 0;
    }, this.getVerifyUrl = (s) => {
      let n = s || fh;
      return Mce.includes(n) || (this.logger.info(`verify url: ${n}, not included in trusted list, assigning default: ${fh}`), n = fh), n;
    }, this.fetchPublicKey = async () => {
      try {
        this.logger.debug(`fetching public key from: ${this.verifyUrlV3}`);
        const s = this.startAbortTimer(ct.FIVE_SECONDS), n = await fetch(`${this.verifyUrlV3}/public-key`, { signal: this.abortController.signal });
        return clearTimeout(s), await n.json();
      } catch (s) {
        this.logger.warn(s);
      }
    }, this.persistPublicKey = async (s) => {
      this.logger.debug("persisting public key to local storage", s), await this.store.setItem(this.storeKey, s), this.publicKey = s;
    }, this.removePublicKey = async () => {
      this.logger.debug("removing verify v2 public key from storage"), await this.store.removeItem(this.storeKey), this.publicKey = void 0;
    }, this.isValidJwtAttestation = async (s) => {
      const n = await this.getPublicKey();
      try {
        if (n)
          return this.validateAttestation(s, n);
      } catch (u) {
        this.logger.error(u), this.logger.warn("error validating attestation");
      }
      const f = await this.fetchAndPersistPublicKey();
      try {
        if (f)
          return this.validateAttestation(s, f);
      } catch (u) {
        this.logger.error(u), this.logger.warn("error validating attestation");
      }
    }, this.getPublicKey = async () => this.publicKey ? this.publicKey : await this.fetchAndPersistPublicKey(), this.fetchAndPersistPublicKey = async () => {
      if (this.fetchPromise)
        return await this.fetchPromise, this.publicKey;
      this.fetchPromise = new Promise(async (n) => {
        const f = await this.fetchPublicKey();
        f && (await this.persistPublicKey(f), n(f));
      });
      const s = await this.fetchPromise;
      return this.fetchPromise = void 0, s;
    }, this.validateAttestation = (s, n) => {
      const f = gae(s, n.publicKey), u = { hasExpired: ct.toMiliseconds(f.exp) < Date.now(), payload: f };
      if (u.hasExpired)
        throw this.logger.warn("resolve: jwt attestation expired"), new Error("JWT attestation expired");
      return { origin: u.payload.origin, isScam: u.payload.isScam, isVerified: u.payload.isVerified };
    }, this.logger = en(r, this.name), this.abortController = new AbortController(), this.isDevEnv = Cw(), this.init();
  }
  get storeKey() {
    return this.storagePrefix + this.version + this.core.customStoragePrefix + "//verify:public:key";
  }
  get context() {
    return pn(this.logger);
  }
  startAbortTimer(e) {
    return this.abortController = new AbortController(), setTimeout(() => this.abortController.abort(), ct.toMiliseconds(e));
  }
}
class _he extends Mfe {
  constructor(e, r) {
    super(e, r), this.projectId = e, this.logger = r, this.context = xce, this.registerDeviceToken = async (i) => {
      const { clientId: s, token: n, notificationType: f, enableEncrypted: u = !1 } = i, h = `${Sce}/${this.projectId}/clients`;
      await fetch(h, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ client_id: s, type: f, token: n, always_raw: u }) });
    }, this.logger = en(r, this.context);
  }
}
var Mhe = Object.defineProperty, Kx = Object.getOwnPropertySymbols, xhe = Object.prototype.hasOwnProperty, She = Object.prototype.propertyIsEnumerable, Yx = (t, e, r) => e in t ? Mhe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Vu = (t, e) => {
  for (var r in e || (e = {}))
    xhe.call(e, r) && Yx(t, r, e[r]);
  if (Kx)
    for (var r of Kx(e))
      She.call(e, r) && Yx(t, r, e[r]);
  return t;
};
class Ehe extends xfe {
  constructor(e, r, i = !0) {
    super(e, r, i), this.core = e, this.logger = r, this.context = Ice, this.storagePrefix = aa, this.storageVersion = Ece, this.events = /* @__PURE__ */ new Map(), this.shouldPersist = !1, this.init = async () => {
      if (!Cw())
        try {
          const s = { eventId: Q8(), timestamp: Date.now(), domain: this.getAppDomain(), props: { event: "INIT", type: "", properties: { client_id: await this.core.crypto.getClientId(), user_agent: dT(this.core.relayer.protocol, this.core.relayer.version, $m) } } };
          await this.sendEvent([s]);
        } catch (s) {
          this.logger.warn(s);
        }
    }, this.createEvent = (s) => {
      const { event: n = "ERROR", type: f = "", properties: { topic: u, trace: h } } = s, d = Q8(), l = this.core.projectId || "", m = Date.now(), b = Vu({ eventId: d, timestamp: m, props: { event: n, type: f, properties: { topic: u, trace: h } }, bundleId: l, domain: this.getAppDomain() }, this.setMethods(d));
      return this.telemetryEnabled && (this.events.set(d, b), this.shouldPersist = !0), b;
    }, this.getEvent = (s) => {
      const { eventId: n, topic: f } = s;
      if (n)
        return this.events.get(n);
      const u = Array.from(this.events.values()).find((h) => h.props.properties.topic === f);
      if (u)
        return Vu(Vu({}, u), this.setMethods(u.eventId));
    }, this.deleteEvent = (s) => {
      const { eventId: n } = s;
      this.events.delete(n), this.shouldPersist = !0;
    }, this.setEventListeners = () => {
      this.core.heartbeat.on(ou.pulse, async () => {
        this.shouldPersist && await this.persist(), this.events.forEach((s) => {
          ct.fromMiliseconds(Date.now()) - ct.fromMiliseconds(s.timestamp) > Ace && (this.events.delete(s.eventId), this.shouldPersist = !0);
        });
      });
    }, this.setMethods = (s) => ({ addTrace: (n) => this.addTrace(s, n), setError: (n) => this.setError(s, n) }), this.addTrace = (s, n) => {
      const f = this.events.get(s);
      f && (f.props.properties.trace.push(n), this.events.set(s, f), this.shouldPersist = !0);
    }, this.setError = (s, n) => {
      const f = this.events.get(s);
      f && (f.props.type = n, f.timestamp = Date.now(), this.events.set(s, f), this.shouldPersist = !0);
    }, this.persist = async () => {
      await this.core.storage.setItem(this.storageKey, Array.from(this.events.values())), this.shouldPersist = !1;
    }, this.restore = async () => {
      try {
        const s = await this.core.storage.getItem(this.storageKey) || [];
        if (!s.length)
          return;
        s.forEach((n) => {
          this.events.set(n.eventId, Vu(Vu({}, n), this.setMethods(n.eventId)));
        });
      } catch (s) {
        this.logger.warn(s);
      }
    }, this.submit = async () => {
      if (!this.telemetryEnabled || this.events.size === 0)
        return;
      const s = [];
      for (const [n, f] of this.events)
        f.props.type && s.push(f);
      if (s.length !== 0)
        try {
          if ((await this.sendEvent(s)).ok)
            for (const n of s)
              this.events.delete(n.eventId), this.shouldPersist = !0;
        } catch (n) {
          this.logger.warn(n);
        }
    }, this.sendEvent = async (s) => {
      const n = this.getAppDomain() ? "" : "&sp=desktop";
      return await fetch(`${Tce}?projectId=${this.core.projectId}&st=events_sdk&sv=js-${$m}${n}`, { method: "POST", body: JSON.stringify(s) });
    }, this.getAppDomain = () => lT().url, this.logger = en(r, this.context), this.telemetryEnabled = i, i ? this.restore().then(async () => {
      await this.submit(), this.setEventListeners();
    }) : this.persist();
  }
  get storageKey() {
    return this.storagePrefix + this.storageVersion + this.core.customStoragePrefix + "//" + this.context;
  }
}
var Ihe = Object.defineProperty, Qx = Object.getOwnPropertySymbols, Ahe = Object.prototype.hasOwnProperty, The = Object.prototype.propertyIsEnumerable, Zx = (t, e, r) => e in t ? Ihe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Jx = (t, e) => {
  for (var r in e || (e = {}))
    Ahe.call(e, r) && Zx(t, r, e[r]);
  if (Qx)
    for (var r of Qx(e))
      The.call(e, r) && Zx(t, r, e[r]);
  return t;
};
class Fw extends dfe {
  constructor(e) {
    var r;
    super(e), this.protocol = UT, this.version = FT, this.name = Uw, this.events = new Pr.exports.EventEmitter(), this.initialized = !1, this.on = (f, u) => this.events.on(f, u), this.once = (f, u) => this.events.once(f, u), this.off = (f, u) => this.events.off(f, u), this.removeListener = (f, u) => this.events.removeListener(f, u), this.dispatchEnvelope = ({ topic: f, message: u, sessionExists: h }) => {
      if (!f || !u)
        return;
      const d = { topic: f, message: u, publishedAt: Date.now(), transportType: Or.link_mode };
      this.relayer.onLinkMessageEvent(d, { sessionExists: h });
    }, this.projectId = e == null ? void 0 : e.projectId, this.relayUrl = (e == null ? void 0 : e.relayUrl) || qT, this.customStoragePrefix = e != null && e.customStoragePrefix ? `:${e.customStoragePrefix}` : "";
    const i = o1({ level: typeof (e == null ? void 0 : e.logger) == "string" && e.logger ? e.logger : Kfe.logger }), { logger: s, chunkLoggerController: n } = lfe({ opts: i, maxSizeInBytes: e == null ? void 0 : e.maxLogBlobSizeInBytes, loggerOverride: e == null ? void 0 : e.logger });
    this.logChunkController = n, (r = this.logChunkController) != null && r.downloadLogsBlobInBrowser && (window.downloadLogsBlobInBrowser = async () => {
      var f, u;
      (f = this.logChunkController) != null && f.downloadLogsBlobInBrowser && ((u = this.logChunkController) == null || u.downloadLogsBlobInBrowser({ clientId: await this.crypto.getClientId() }));
    }), this.logger = en(s, this.name), this.heartbeat = new kw(), this.crypto = new ehe(this, this.logger, e == null ? void 0 : e.keychain), this.history = new yhe(this, this.logger), this.expirer = new mhe(this, this.logger), this.storage = e != null && e.storage ? e.storage : new Boe(Jx(Jx({}, Yfe), e == null ? void 0 : e.storageOptions)), this.relayer = new dhe({ core: this, logger: this.logger, relayUrl: this.relayUrl, projectId: this.projectId }), this.pairing = new bhe(this, this.logger), this.verify = new whe(this, this.logger, this.storage), this.echoClient = new _he(this.projectId || "", this.logger), this.linkModeSupportedApps = [], this.eventClient = new Ehe(this, this.logger, e == null ? void 0 : e.telemetryEnabled);
  }
  static async init(e) {
    const r = new Fw(e);
    await r.initialize();
    const i = await r.crypto.getClientId();
    return await r.storage.setItem(cce, i), r;
  }
  get context() {
    return pn(this.logger);
  }
  async start() {
    this.initialized || await this.initialize();
  }
  async getLogsBlob() {
    var e;
    return (e = this.logChunkController) == null ? void 0 : e.logsToBlob({ clientId: await this.crypto.getClientId() });
  }
  async addLinkModeSupportedApp(e) {
    this.linkModeSupportedApps.includes(e) || (this.linkModeSupportedApps.push(e), await this.storage.setItem(Rx, this.linkModeSupportedApps));
  }
  async initialize() {
    this.logger.trace("Initialized");
    try {
      await this.crypto.init(), await this.history.init(), await this.expirer.init(), await this.relayer.init(), await this.heartbeat.init(), await this.pairing.init(), this.eventClient.init(), this.linkModeSupportedApps = await this.storage.getItem(Rx) || [], this.initialized = !0, this.logger.info("Core Initialization Success");
    } catch (e) {
      throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`, e), this.logger.error(e.message), e;
    }
  }
}
const Nhe = Fw, tN = "wc", rN = 2, iN = "client", $w = `${tN}@${rN}:${iN}:`, $y = { name: iN, logger: "error", controller: !1, relayUrl: "wss://relay.walletconnect.org" }, Xx = "WALLETCONNECT_DEEPLINK_CHOICE", Dhe = "proposal", nN = "Proposal expired", Che = "session", Jf = ct.SEVEN_DAYS, Ohe = "engine", pi = { wc_sessionPropose: { req: { ttl: ct.FIVE_MINUTES, prompt: !0, tag: 1100 }, res: { ttl: ct.FIVE_MINUTES, prompt: !1, tag: 1101 }, reject: { ttl: ct.FIVE_MINUTES, prompt: !1, tag: 1120 }, autoReject: { ttl: ct.FIVE_MINUTES, prompt: !1, tag: 1121 } }, wc_sessionSettle: { req: { ttl: ct.FIVE_MINUTES, prompt: !1, tag: 1102 }, res: { ttl: ct.FIVE_MINUTES, prompt: !1, tag: 1103 } }, wc_sessionUpdate: { req: { ttl: ct.ONE_DAY, prompt: !1, tag: 1104 }, res: { ttl: ct.ONE_DAY, prompt: !1, tag: 1105 } }, wc_sessionExtend: { req: { ttl: ct.ONE_DAY, prompt: !1, tag: 1106 }, res: { ttl: ct.ONE_DAY, prompt: !1, tag: 1107 } }, wc_sessionRequest: { req: { ttl: ct.FIVE_MINUTES, prompt: !0, tag: 1108 }, res: { ttl: ct.FIVE_MINUTES, prompt: !1, tag: 1109 } }, wc_sessionEvent: { req: { ttl: ct.FIVE_MINUTES, prompt: !0, tag: 1110 }, res: { ttl: ct.FIVE_MINUTES, prompt: !1, tag: 1111 } }, wc_sessionDelete: { req: { ttl: ct.ONE_DAY, prompt: !1, tag: 1112 }, res: { ttl: ct.ONE_DAY, prompt: !1, tag: 1113 } }, wc_sessionPing: { req: { ttl: ct.ONE_DAY, prompt: !1, tag: 1114 }, res: { ttl: ct.ONE_DAY, prompt: !1, tag: 1115 } }, wc_sessionAuthenticate: { req: { ttl: ct.ONE_HOUR, prompt: !0, tag: 1116 }, res: { ttl: ct.ONE_HOUR, prompt: !1, tag: 1117 }, reject: { ttl: ct.FIVE_MINUTES, prompt: !1, tag: 1118 }, autoReject: { ttl: ct.FIVE_MINUTES, prompt: !1, tag: 1119 } } }, qy = { min: ct.FIVE_MINUTES, max: ct.SEVEN_DAYS }, Us = { idle: "IDLE", active: "ACTIVE" }, Rhe = "request", Lhe = ["wc_sessionPropose", "wc_sessionRequest", "wc_authRequest", "wc_sessionAuthenticate"], Phe = "wc", khe = "auth", jhe = "authKeys", Bhe = "pairingTopics", zhe = "requests", l1 = `${Phe}@${1.5}:${khe}:`, a0 = `${l1}:PUB_KEY`;
var Uhe = Object.defineProperty, Fhe = Object.defineProperties, $he = Object.getOwnPropertyDescriptors, eS = Object.getOwnPropertySymbols, qhe = Object.prototype.hasOwnProperty, Hhe = Object.prototype.propertyIsEnumerable, tS = (t, e, r) => e in t ? Uhe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Kr = (t, e) => {
  for (var r in e || (e = {}))
    qhe.call(e, r) && tS(t, r, e[r]);
  if (eS)
    for (var r of eS(e))
      Hhe.call(e, r) && tS(t, r, e[r]);
  return t;
}, ws = (t, e) => Fhe(t, $he(e));
class Whe extends Efe {
  constructor(e) {
    super(e), this.name = Ohe, this.events = new Pr.exports(), this.initialized = !1, this.requestQueue = { state: Us.idle, queue: [] }, this.sessionRequestQueue = { state: Us.idle, queue: [] }, this.requestQueueDelay = ct.ONE_SECOND, this.expectedPairingMethodMap = /* @__PURE__ */ new Map(), this.recentlyDeletedMap = /* @__PURE__ */ new Map(), this.recentlyDeletedLimit = 200, this.relayMessageCache = [], this.init = async () => {
      this.initialized || (await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.registerPairingEvents(), await this.registerLinkModeListeners(), this.client.core.pairing.register({ methods: Object.keys(pi) }), this.initialized = !0, setTimeout(() => {
        this.sessionRequestQueue.queue = this.getPendingSessionRequests(), this.processSessionRequestQueue();
      }, ct.toMiliseconds(this.requestQueueDelay)));
    }, this.connect = async (r) => {
      this.isInitialized(), await this.confirmOnlineStateOrThrow();
      const i = ws(Kr({}, r), { requiredNamespaces: r.requiredNamespaces || {}, optionalNamespaces: r.optionalNamespaces || {} });
      await this.isValidConnect(i);
      const { pairingTopic: s, requiredNamespaces: n, optionalNamespaces: f, sessionProperties: u, relays: h } = i;
      let d = s, l, m = !1;
      try {
        d && (m = this.client.core.pairing.pairings.get(d).active);
      } catch (H) {
        throw this.client.logger.error(`connect() -> pairing.get(${d}) failed`), H;
      }
      if (!d || !m) {
        const { topic: H, uri: Q } = await this.client.core.pairing.create();
        d = H, l = Q;
      }
      if (!d) {
        const { message: H } = ot("NO_MATCHING_KEY", `connect() pairing topic: ${d}`);
        throw new Error(H);
      }
      const b = await this.client.core.crypto.generateKeyPair(), M = pi.wc_sessionPropose.req.ttl || ct.FIVE_MINUTES, A = ci(M), N = Kr({ requiredNamespaces: n, optionalNamespaces: f, relays: h != null ? h : [{ protocol: $T }], proposer: { publicKey: b, metadata: this.client.metadata }, expiryTimestamp: A, pairingTopic: d }, u && { sessionProperties: u }), { reject: R, resolve: O, done: P } = $o(M, nN);
      this.events.once(Yt("session_connect"), async ({ error: H, session: Q }) => {
        if (H)
          R(H);
        else if (Q) {
          Q.self.publicKey = b;
          const Z = ws(Kr({}, Q), { pairingTopic: N.pairingTopic, requiredNamespaces: N.requiredNamespaces, optionalNamespaces: N.optionalNamespaces, transportType: Or.relay });
          await this.client.session.set(Q.topic, Z), await this.setExpiry(Q.topic, Q.expiry), d && await this.client.core.pairing.updateMetadata({ topic: d, metadata: Q.peer.metadata }), this.cleanupDuplicatePairings(Z), O(Z);
        }
      });
      const F = await this.sendRequest({ topic: d, method: "wc_sessionPropose", params: N, throwOnFailedPublish: !0 });
      return await this.setProposal(F, Kr({ id: F }, N)), { uri: l, approval: P };
    }, this.pair = async (r) => {
      this.isInitialized(), await this.confirmOnlineStateOrThrow();
      try {
        return await this.client.core.pairing.pair(r);
      } catch (i) {
        throw this.client.logger.error("pair() failed"), i;
      }
    }, this.approve = async (r) => {
      var i, s, n;
      const f = this.client.core.eventClient.createEvent({ properties: { topic: (i = r == null ? void 0 : r.id) == null ? void 0 : i.toString(), trace: [ms.session_approve_started] } });
      try {
        this.isInitialized(), await this.confirmOnlineStateOrThrow();
      } catch (Y) {
        throw f.setError(Uo.no_internet_connection), Y;
      }
      try {
        await this.isValidProposalId(r == null ? void 0 : r.id);
      } catch (Y) {
        throw this.client.logger.error(`approve() -> proposal.get(${r == null ? void 0 : r.id}) failed`), f.setError(Uo.proposal_not_found), Y;
      }
      try {
        await this.isValidApprove(r);
      } catch (Y) {
        throw this.client.logger.error("approve() -> isValidApprove() failed"), f.setError(Uo.session_approve_namespace_validation_failure), Y;
      }
      const { id: u, relayProtocol: h, namespaces: d, sessionProperties: l, sessionConfig: m } = r, b = this.client.proposal.get(u);
      this.client.core.eventClient.deleteEvent({ eventId: f.eventId });
      const { pairingTopic: M, proposer: A, requiredNamespaces: N, optionalNamespaces: R } = b;
      let O = (s = this.client.core.eventClient) == null ? void 0 : s.getEvent({ topic: M });
      O || (O = (n = this.client.core.eventClient) == null ? void 0 : n.createEvent({ type: ms.session_approve_started, properties: { topic: M, trace: [ms.session_approve_started, ms.session_namespaces_validation_success] } }));
      const P = await this.client.core.crypto.generateKeyPair(), F = A.publicKey, H = await this.client.core.crypto.generateSharedKey(P, F), Q = Kr(Kr({ relay: { protocol: h != null ? h : "irn" }, namespaces: d, controller: { publicKey: P, metadata: this.client.metadata }, expiry: ci(Jf) }, l && { sessionProperties: l }), m && { sessionConfig: m }), Z = Or.relay;
      O.addTrace(ms.subscribing_session_topic);
      try {
        await this.client.core.relayer.subscribe(H, { transportType: Z });
      } catch (Y) {
        throw O.setError(Uo.subscribe_session_topic_failure), Y;
      }
      O.addTrace(ms.subscribe_session_topic_success);
      const B = ws(Kr({}, Q), { topic: H, requiredNamespaces: N, optionalNamespaces: R, pairingTopic: M, acknowledged: !1, self: Q.controller, peer: { publicKey: A.publicKey, metadata: A.metadata }, controller: P, transportType: Or.relay });
      await this.client.session.set(H, B), O.addTrace(ms.store_session);
      try {
        O.addTrace(ms.publishing_session_settle), await this.sendRequest({ topic: H, method: "wc_sessionSettle", params: Q, throwOnFailedPublish: !0 }).catch((Y) => {
          throw O == null || O.setError(Uo.session_settle_publish_failure), Y;
        }), O.addTrace(ms.session_settle_publish_success), O.addTrace(ms.publishing_session_approve), await this.sendResult({ id: u, topic: M, result: { relay: { protocol: h != null ? h : "irn" }, responderPublicKey: P }, throwOnFailedPublish: !0 }).catch((Y) => {
          throw O == null || O.setError(Uo.session_approve_publish_failure), Y;
        }), O.addTrace(ms.session_approve_publish_success);
      } catch (Y) {
        throw this.client.logger.error(Y), this.client.session.delete(H, wr("USER_DISCONNECTED")), await this.client.core.relayer.unsubscribe(H), Y;
      }
      return this.client.core.eventClient.deleteEvent({ eventId: O.eventId }), await this.client.core.pairing.updateMetadata({ topic: M, metadata: A.metadata }), await this.client.proposal.delete(u, wr("USER_DISCONNECTED")), await this.client.core.pairing.activate({ topic: M }), await this.setExpiry(H, ci(Jf)), { topic: H, acknowledged: () => Promise.resolve(this.client.session.get(H)) };
    }, this.reject = async (r) => {
      this.isInitialized(), await this.confirmOnlineStateOrThrow();
      try {
        await this.isValidReject(r);
      } catch (f) {
        throw this.client.logger.error("reject() -> isValidReject() failed"), f;
      }
      const { id: i, reason: s } = r;
      let n;
      try {
        n = this.client.proposal.get(i).pairingTopic;
      } catch (f) {
        throw this.client.logger.error(`reject() -> proposal.get(${i}) failed`), f;
      }
      n && (await this.sendError({ id: i, topic: n, error: s, rpcOpts: pi.wc_sessionPropose.reject }), await this.client.proposal.delete(i, wr("USER_DISCONNECTED")));
    }, this.update = async (r) => {
      this.isInitialized(), await this.confirmOnlineStateOrThrow();
      try {
        await this.isValidUpdate(r);
      } catch (m) {
        throw this.client.logger.error("update() -> isValidUpdate() failed"), m;
      }
      const { topic: i, namespaces: s } = r, { done: n, resolve: f, reject: u } = $o(), h = Xa(), d = Xo().toString(), l = this.client.session.get(i).namespaces;
      return this.events.once(Yt("session_update", h), ({ error: m }) => {
        m ? u(m) : f();
      }), await this.client.session.update(i, { namespaces: s }), await this.sendRequest({ topic: i, method: "wc_sessionUpdate", params: { namespaces: s }, throwOnFailedPublish: !0, clientRpcId: h, relayRpcId: d }).catch((m) => {
        this.client.logger.error(m), this.client.session.update(i, { namespaces: l }), u(m);
      }), { acknowledged: n };
    }, this.extend = async (r) => {
      this.isInitialized(), await this.confirmOnlineStateOrThrow();
      try {
        await this.isValidExtend(r);
      } catch (h) {
        throw this.client.logger.error("extend() -> isValidExtend() failed"), h;
      }
      const { topic: i } = r, s = Xa(), { done: n, resolve: f, reject: u } = $o();
      return this.events.once(Yt("session_extend", s), ({ error: h }) => {
        h ? u(h) : f();
      }), await this.setExpiry(i, ci(Jf)), this.sendRequest({ topic: i, method: "wc_sessionExtend", params: {}, clientRpcId: s, throwOnFailedPublish: !0 }).catch((h) => {
        u(h);
      }), { acknowledged: n };
    }, this.request = async (r) => {
      this.isInitialized();
      try {
        await this.isValidRequest(r);
      } catch (A) {
        throw this.client.logger.error("request() -> isValidRequest() failed"), A;
      }
      const { chainId: i, request: s, topic: n, expiry: f = pi.wc_sessionRequest.req.ttl } = r, u = this.client.session.get(n);
      (u == null ? void 0 : u.transportType) === Or.relay && await this.confirmOnlineStateOrThrow();
      const h = Xa(), d = Xo().toString(), { done: l, resolve: m, reject: b } = $o(f, "Request expired. Please try again.");
      this.events.once(Yt("session_request", h), ({ error: A, result: N }) => {
        A ? b(A) : m(N);
      });
      const M = this.getAppLinkIfEnabled(u.peer.metadata, u.transportType);
      return M ? (await this.sendRequest({ clientRpcId: h, relayRpcId: d, topic: n, method: "wc_sessionRequest", params: { request: ws(Kr({}, s), { expiryTimestamp: ci(f) }), chainId: i }, expiry: f, throwOnFailedPublish: !0, appLink: M }).catch((A) => b(A)), this.client.events.emit("session_request_sent", { topic: n, request: s, chainId: i, id: h }), await l()) : await Promise.all([new Promise(async (A) => {
        await this.sendRequest({ clientRpcId: h, relayRpcId: d, topic: n, method: "wc_sessionRequest", params: { request: ws(Kr({}, s), { expiryTimestamp: ci(f) }), chainId: i }, expiry: f, throwOnFailedPublish: !0 }).catch((N) => b(N)), this.client.events.emit("session_request_sent", { topic: n, request: s, chainId: i, id: h }), A();
      }), new Promise(async (A) => {
        var N;
        if (!((N = u.sessionConfig) != null && N.disableDeepLink)) {
          const R = await Rse(this.client.core.storage, Xx);
          await Cse({ id: h, topic: n, wcDeepLink: R });
        }
        A();
      }), l()]).then((A) => A[2]);
    }, this.respond = async (r) => {
      this.isInitialized(), await this.isValidRespond(r);
      const { topic: i, response: s } = r, { id: n } = s, f = this.client.session.get(i);
      f.transportType === Or.relay && await this.confirmOnlineStateOrThrow();
      const u = this.getAppLinkIfEnabled(f.peer.metadata, f.transportType);
      Hs(s) ? await this.sendResult({ id: n, topic: i, result: s.result, throwOnFailedPublish: !0, appLink: u }) : Qn(s) && await this.sendError({ id: n, topic: i, error: s.error, appLink: u }), this.cleanupAfterResponse(r);
    }, this.ping = async (r) => {
      this.isInitialized(), await this.confirmOnlineStateOrThrow();
      try {
        await this.isValidPing(r);
      } catch (s) {
        throw this.client.logger.error("ping() -> isValidPing() failed"), s;
      }
      const { topic: i } = r;
      if (this.client.session.keys.includes(i)) {
        const s = Xa(), n = Xo().toString(), { done: f, resolve: u, reject: h } = $o();
        this.events.once(Yt("session_ping", s), ({ error: d }) => {
          d ? h(d) : u();
        }), await Promise.all([this.sendRequest({ topic: i, method: "wc_sessionPing", params: {}, throwOnFailedPublish: !0, clientRpcId: s, relayRpcId: n }), f()]);
      } else
        this.client.core.pairing.pairings.keys.includes(i) && await this.client.core.pairing.ping({ topic: i });
    }, this.emit = async (r) => {
      this.isInitialized(), await this.confirmOnlineStateOrThrow(), await this.isValidEmit(r);
      const { topic: i, event: s, chainId: n } = r, f = Xo().toString();
      await this.sendRequest({ topic: i, method: "wc_sessionEvent", params: { event: s, chainId: n }, throwOnFailedPublish: !0, relayRpcId: f });
    }, this.disconnect = async (r) => {
      this.isInitialized(), await this.confirmOnlineStateOrThrow(), await this.isValidDisconnect(r);
      const { topic: i } = r;
      if (this.client.session.keys.includes(i))
        await this.sendRequest({ topic: i, method: "wc_sessionDelete", params: wr("USER_DISCONNECTED"), throwOnFailedPublish: !0 }), await this.deleteSession({ topic: i, emitEvent: !1 });
      else if (this.client.core.pairing.pairings.keys.includes(i))
        await this.client.core.pairing.disconnect({ topic: i });
      else {
        const { message: s } = ot("MISMATCHED_TOPIC", `Session or pairing topic not found: ${i}`);
        throw new Error(s);
      }
    }, this.find = (r) => (this.isInitialized(), this.client.session.getAll().filter((i) => Rae(i, r))), this.getPendingSessionRequests = () => this.client.pendingRequest.getAll(), this.authenticate = async (r, i) => {
      var s;
      this.isInitialized(), this.isValidAuthenticate(r);
      const n = i && this.client.core.linkModeSupportedApps.includes(i) && ((s = this.client.metadata.redirect) == null ? void 0 : s.linkMode), f = n ? Or.link_mode : Or.relay;
      f === Or.relay && await this.confirmOnlineStateOrThrow();
      const { chains: u, statement: h = "", uri: d, domain: l, nonce: m, type: b, exp: M, nbf: A, methods: N = [], expiry: R } = r, O = [...r.resources || []], { topic: P, uri: F } = await this.client.core.pairing.create({ methods: ["wc_sessionAuthenticate"], transportType: f });
      this.client.logger.info({ message: "Generated new pairing", pairing: { topic: P, uri: F } });
      const H = await this.client.core.crypto.generateKeyPair(), Q = i0(H);
      if (await Promise.all([this.client.auth.authKeys.set(a0, { responseTopic: Q, publicKey: H }), this.client.auth.pairingTopics.set(Q, { topic: Q, pairingTopic: P })]), await this.client.core.relayer.subscribe(Q, { transportType: f }), this.client.logger.info(`sending request to new pairing topic: ${P}`), N.length > 0) {
        const { namespace: _ } = vc(u[0]);
        let x = eae(_, "request", N);
        r0(O) && (x = rae(x, O.pop())), O.push(x);
      }
      const Z = R && R > pi.wc_sessionAuthenticate.req.ttl ? R : pi.wc_sessionAuthenticate.req.ttl, B = { authPayload: { type: b != null ? b : "caip122", chains: u, statement: h, aud: d, domain: l, version: "1", nonce: m, iat: new Date().toISOString(), exp: M, nbf: A, resources: O }, requester: { publicKey: H, metadata: this.client.metadata }, expiryTimestamp: ci(Z) }, Y = { eip155: { chains: u, methods: [.../* @__PURE__ */ new Set(["personal_sign", ...N])], events: ["chainChanged", "accountsChanged"] } }, ae = { requiredNamespaces: {}, optionalNamespaces: Y, relays: [{ protocol: "irn" }], pairingTopic: P, proposer: { publicKey: H, metadata: this.client.metadata }, expiryTimestamp: ci(pi.wc_sessionPropose.req.ttl) }, { done: se, resolve: W, reject: C } = $o(Z, "Request expired"), g = async ({ error: _, session: x }) => {
        if (this.events.off(Yt("session_request", c), a), _)
          C(_);
        else if (x) {
          x.self.publicKey = H, await this.client.session.set(x.topic, x), await this.setExpiry(x.topic, x.expiry), P && await this.client.core.pairing.updateMetadata({ topic: P, metadata: x.peer.metadata });
          const E = this.client.session.get(x.topic);
          await this.deleteProposal(p), W({ session: E });
        }
      }, a = async (_) => {
        var x, E, y;
        if (await this.deletePendingAuthRequest(c, { message: "fulfilled", code: 0 }), _.error) {
          const q = wr("WC_METHOD_UNSUPPORTED", "wc_sessionAuthenticate");
          return _.error.code === q.code ? void 0 : (this.events.off(Yt("session_connect"), g), C(_.error.message));
        }
        await this.deleteProposal(p), this.events.off(Yt("session_connect"), g);
        const { cacaos: o, responder: S } = _.result, J = [], z = [];
        for (const q of o) {
          await X8({ cacao: q, projectId: this.client.core.projectId }) || (this.client.logger.error(q, "Signature verification failed"), C(wr("SESSION_SETTLEMENT_FAILED", "Signature verification failed")));
          const { p: K } = q, U = r0(K.resources), T = [km(K.iss)], D = z0(K.iss);
          if (U) {
            const te = ex(U), ne = tx(U);
            J.push(...te), T.push(...ne);
          }
          for (const te of T)
            z.push(`${te}:${D}`);
        }
        const k = await this.client.core.crypto.generateSharedKey(H, S.publicKey);
        let j;
        J.length > 0 && (j = { topic: k, acknowledged: !0, self: { publicKey: H, metadata: this.client.metadata }, peer: S, controller: S.publicKey, expiry: ci(Jf), requiredNamespaces: {}, optionalNamespaces: {}, relay: { protocol: "irn" }, pairingTopic: P, namespaces: ux([...new Set(J)], [...new Set(z)]), transportType: f }, await this.client.core.relayer.subscribe(k, { transportType: f }), await this.client.session.set(k, j), P && await this.client.core.pairing.updateMetadata({ topic: P, metadata: S.metadata }), j = this.client.session.get(k)), (x = this.client.metadata.redirect) != null && x.linkMode && (E = S.metadata.redirect) != null && E.linkMode && (y = S.metadata.redirect) != null && y.universal && i && (this.client.core.addLinkModeSupportedApp(S.metadata.redirect.universal), this.client.session.update(k, { transportType: Or.link_mode })), W({ auths: o, session: j });
      }, c = Xa(), p = Xa();
      this.events.once(Yt("session_connect"), g), this.events.once(Yt("session_request", c), a);
      let w;
      try {
        if (n) {
          const _ = no("wc_sessionAuthenticate", B, c);
          this.client.core.history.set(P, _);
          const x = await this.client.core.crypto.encode("", _, { type: fl, encoding: Fu });
          w = jd(i, P, x);
        } else
          await Promise.all([this.sendRequest({ topic: P, method: "wc_sessionAuthenticate", params: B, expiry: r.expiry, throwOnFailedPublish: !0, clientRpcId: c }), this.sendRequest({ topic: P, method: "wc_sessionPropose", params: ae, expiry: pi.wc_sessionPropose.req.ttl, throwOnFailedPublish: !0, clientRpcId: p })]);
      } catch (_) {
        throw this.events.off(Yt("session_connect"), g), this.events.off(Yt("session_request", c), a), _;
      }
      return await this.setProposal(p, Kr({ id: p }, ae)), await this.setAuthRequest(c, { request: ws(Kr({}, B), { verifyContext: {} }), pairingTopic: P, transportType: f }), { uri: w != null ? w : F, response: se };
    }, this.approveSessionAuthenticate = async (r) => {
      const { id: i, auths: s } = r, n = this.client.core.eventClient.createEvent({ properties: { topic: i.toString(), trace: [Fo.authenticated_session_approve_started] } });
      try {
        this.isInitialized();
      } catch (R) {
        throw n.setError(Hu.no_internet_connection), R;
      }
      const f = this.getPendingAuthRequest(i);
      if (!f)
        throw n.setError(Hu.authenticated_session_pending_request_not_found), new Error(`Could not find pending auth request with id ${i}`);
      const u = f.transportType || Or.relay;
      u === Or.relay && await this.confirmOnlineStateOrThrow();
      const h = f.requester.publicKey, d = await this.client.core.crypto.generateKeyPair(), l = i0(h), m = { type: Na, receiverPublicKey: h, senderPublicKey: d }, b = [], M = [];
      for (const R of s) {
        if (!await X8({ cacao: R, projectId: this.client.core.projectId })) {
          n.setError(Hu.invalid_cacao);
          const Q = wr("SESSION_SETTLEMENT_FAILED", "Signature verification failed");
          throw await this.sendError({ id: i, topic: l, error: Q, encodeOpts: m }), new Error(Q.message);
        }
        n.addTrace(Fo.cacaos_verified);
        const { p: O } = R, P = r0(O.resources), F = [km(O.iss)], H = z0(O.iss);
        if (P) {
          const Q = ex(P), Z = tx(P);
          b.push(...Q), F.push(...Z);
        }
        for (const Q of F)
          M.push(`${Q}:${H}`);
      }
      const A = await this.client.core.crypto.generateSharedKey(d, h);
      n.addTrace(Fo.create_authenticated_session_topic);
      let N;
      if ((b == null ? void 0 : b.length) > 0) {
        N = { topic: A, acknowledged: !0, self: { publicKey: d, metadata: this.client.metadata }, peer: { publicKey: h, metadata: f.requester.metadata }, controller: h, expiry: ci(Jf), authentication: s, requiredNamespaces: {}, optionalNamespaces: {}, relay: { protocol: "irn" }, pairingTopic: f.pairingTopic, namespaces: ux([...new Set(b)], [...new Set(M)]), transportType: u }, n.addTrace(Fo.subscribing_authenticated_session_topic);
        try {
          await this.client.core.relayer.subscribe(A, { transportType: u });
        } catch (R) {
          throw n.setError(Hu.subscribe_authenticated_session_topic_failure), R;
        }
        n.addTrace(Fo.subscribe_authenticated_session_topic_success), await this.client.session.set(A, N), n.addTrace(Fo.store_authenticated_session), await this.client.core.pairing.updateMetadata({ topic: f.pairingTopic, metadata: f.requester.metadata });
      }
      n.addTrace(Fo.publishing_authenticated_session_approve);
      try {
        await this.sendResult({ topic: l, id: i, result: { cacaos: s, responder: { publicKey: d, metadata: this.client.metadata } }, encodeOpts: m, throwOnFailedPublish: !0, appLink: this.getAppLinkIfEnabled(f.requester.metadata, u) });
      } catch (R) {
        throw n.setError(Hu.authenticated_session_approve_publish_failure), R;
      }
      return await this.client.auth.requests.delete(i, { message: "fulfilled", code: 0 }), await this.client.core.pairing.activate({ topic: f.pairingTopic }), this.client.core.eventClient.deleteEvent({ eventId: n.eventId }), { session: N };
    }, this.rejectSessionAuthenticate = async (r) => {
      this.isInitialized();
      const { id: i, reason: s } = r, n = this.getPendingAuthRequest(i);
      if (!n)
        throw new Error(`Could not find pending auth request with id ${i}`);
      n.transportType === Or.relay && await this.confirmOnlineStateOrThrow();
      const f = n.requester.publicKey, u = await this.client.core.crypto.generateKeyPair(), h = i0(f), d = { type: Na, receiverPublicKey: f, senderPublicKey: u };
      await this.sendError({ id: i, topic: h, error: s, encodeOpts: d, rpcOpts: pi.wc_sessionAuthenticate.reject, appLink: this.getAppLinkIfEnabled(n.requester.metadata, n.transportType) }), await this.client.auth.requests.delete(i, { message: "rejected", code: 0 }), await this.client.proposal.delete(i, wr("USER_DISCONNECTED"));
    }, this.formatAuthMessage = (r) => {
      this.isInitialized();
      const { request: i, iss: s } = r;
      return mT(i, s);
    }, this.processRelayMessageCache = () => {
      setTimeout(async () => {
        if (this.relayMessageCache.length !== 0)
          for (; this.relayMessageCache.length > 0; )
            try {
              const r = this.relayMessageCache.shift();
              r && await this.onRelayMessage(r);
            } catch (r) {
              this.client.logger.error(r);
            }
      }, 50);
    }, this.cleanupDuplicatePairings = async (r) => {
      if (r.pairingTopic)
        try {
          const i = this.client.core.pairing.pairings.get(r.pairingTopic), s = this.client.core.pairing.pairings.getAll().filter((n) => {
            var f, u;
            return ((f = n.peerMetadata) == null ? void 0 : f.url) && ((u = n.peerMetadata) == null ? void 0 : u.url) === r.peer.metadata.url && n.topic && n.topic !== i.topic;
          });
          if (s.length === 0)
            return;
          this.client.logger.info(`Cleaning up ${s.length} duplicate pairing(s)`), await Promise.all(s.map((n) => this.client.core.pairing.disconnect({ topic: n.topic }))), this.client.logger.info("Duplicate pairings clean up finished");
        } catch (i) {
          this.client.logger.error(i);
        }
    }, this.deleteSession = async (r) => {
      var i;
      const { topic: s, expirerHasDeleted: n = !1, emitEvent: f = !0, id: u = 0 } = r, { self: h } = this.client.session.get(s);
      await this.client.core.relayer.unsubscribe(s), await this.client.session.delete(s, wr("USER_DISCONNECTED")), this.addToRecentlyDeleted(s, "session"), this.client.core.crypto.keychain.has(h.publicKey) && await this.client.core.crypto.deleteKeyPair(h.publicKey), this.client.core.crypto.keychain.has(s) && await this.client.core.crypto.deleteSymKey(s), n || this.client.core.expirer.del(s), this.client.core.storage.removeItem(Xx).catch((d) => this.client.logger.warn(d)), this.getPendingSessionRequests().forEach((d) => {
        d.topic === s && this.deletePendingSessionRequest(d.id, wr("USER_DISCONNECTED"));
      }), s === ((i = this.sessionRequestQueue.queue[0]) == null ? void 0 : i.topic) && (this.sessionRequestQueue.state = Us.idle), f && this.client.events.emit("session_delete", { id: u, topic: s });
    }, this.deleteProposal = async (r, i) => {
      if (i)
        try {
          const s = this.client.proposal.get(r), n = this.client.core.eventClient.getEvent({ topic: s.pairingTopic });
          n == null || n.setError(Uo.proposal_expired);
        } catch {
        }
      await Promise.all([this.client.proposal.delete(r, wr("USER_DISCONNECTED")), i ? Promise.resolve() : this.client.core.expirer.del(r)]), this.addToRecentlyDeleted(r, "proposal");
    }, this.deletePendingSessionRequest = async (r, i, s = !1) => {
      await Promise.all([this.client.pendingRequest.delete(r, i), s ? Promise.resolve() : this.client.core.expirer.del(r)]), this.addToRecentlyDeleted(r, "request"), this.sessionRequestQueue.queue = this.sessionRequestQueue.queue.filter((n) => n.id !== r), s && (this.sessionRequestQueue.state = Us.idle, this.client.events.emit("session_request_expire", { id: r }));
    }, this.deletePendingAuthRequest = async (r, i, s = !1) => {
      await Promise.all([this.client.auth.requests.delete(r, i), s ? Promise.resolve() : this.client.core.expirer.del(r)]);
    }, this.setExpiry = async (r, i) => {
      this.client.session.keys.includes(r) && (this.client.core.expirer.set(r, i), await this.client.session.update(r, { expiry: i }));
    }, this.setProposal = async (r, i) => {
      this.client.core.expirer.set(r, ci(pi.wc_sessionPropose.req.ttl)), await this.client.proposal.set(r, i);
    }, this.setAuthRequest = async (r, i) => {
      const { request: s, pairingTopic: n, transportType: f = Or.relay } = i;
      this.client.core.expirer.set(r, s.expiryTimestamp), await this.client.auth.requests.set(r, { authPayload: s.authPayload, requester: s.requester, expiryTimestamp: s.expiryTimestamp, id: r, pairingTopic: n, verifyContext: s.verifyContext, transportType: f });
    }, this.setPendingSessionRequest = async (r) => {
      const { id: i, topic: s, params: n, verifyContext: f } = r, u = n.request.expiryTimestamp || ci(pi.wc_sessionRequest.req.ttl);
      this.client.core.expirer.set(i, u), await this.client.pendingRequest.set(i, { id: i, topic: s, params: n, verifyContext: f });
    }, this.sendRequest = async (r) => {
      const { topic: i, method: s, params: n, expiry: f, relayRpcId: u, clientRpcId: h, throwOnFailedPublish: d, appLink: l } = r, m = no(s, n, h);
      let b;
      const M = !!l;
      try {
        const R = M ? Fu : io;
        b = await this.client.core.crypto.encode(i, m, { encoding: R });
      } catch (R) {
        throw await this.cleanup(), this.client.logger.error(`sendRequest() -> core.crypto.encode() for topic ${i} failed`), R;
      }
      let A;
      if (Lhe.includes(s)) {
        const R = Ea(JSON.stringify(m)), O = Ea(b);
        A = await this.client.core.verify.register({ id: O, decryptedId: R });
      }
      const N = pi[s].req;
      if (N.attestation = A, f && (N.ttl = f), u && (N.id = u), this.client.core.history.set(i, m), M) {
        const R = jd(l, i, b);
        await global.Linking.openURL(R, this.client.name);
      } else {
        const R = pi[s].req;
        f && (R.ttl = f), u && (R.id = u), d ? (R.internal = ws(Kr({}, R.internal), { throwOnFailedPublish: !0 }), await this.client.core.relayer.publish(i, b, R)) : this.client.core.relayer.publish(i, b, R).catch((O) => this.client.logger.error(O));
      }
      return m.id;
    }, this.sendResult = async (r) => {
      const { id: i, topic: s, result: n, throwOnFailedPublish: f, encodeOpts: u, appLink: h } = r, d = f1(i, n);
      let l;
      const m = h && typeof (global == null ? void 0 : global.Linking) < "u";
      try {
        const M = m ? Fu : io;
        l = await this.client.core.crypto.encode(s, d, ws(Kr({}, u || {}), { encoding: M }));
      } catch (M) {
        throw await this.cleanup(), this.client.logger.error(`sendResult() -> core.crypto.encode() for topic ${s} failed`), M;
      }
      let b;
      try {
        b = await this.client.core.history.get(s, i);
      } catch (M) {
        throw this.client.logger.error(`sendResult() -> history.get(${s}, ${i}) failed`), M;
      }
      if (m) {
        const M = jd(h, s, l);
        await global.Linking.openURL(M, this.client.name);
      } else {
        const M = pi[b.request.method].res;
        f ? (M.internal = ws(Kr({}, M.internal), { throwOnFailedPublish: !0 }), await this.client.core.relayer.publish(s, l, M)) : this.client.core.relayer.publish(s, l, M).catch((A) => this.client.logger.error(A));
      }
      await this.client.core.history.resolve(d);
    }, this.sendError = async (r) => {
      const { id: i, topic: s, error: n, encodeOpts: f, rpcOpts: u, appLink: h } = r, d = c1(i, n);
      let l;
      const m = h && typeof (global == null ? void 0 : global.Linking) < "u";
      try {
        const M = m ? Fu : io;
        l = await this.client.core.crypto.encode(s, d, ws(Kr({}, f || {}), { encoding: M }));
      } catch (M) {
        throw await this.cleanup(), this.client.logger.error(`sendError() -> core.crypto.encode() for topic ${s} failed`), M;
      }
      let b;
      try {
        b = await this.client.core.history.get(s, i);
      } catch (M) {
        throw this.client.logger.error(`sendError() -> history.get(${s}, ${i}) failed`), M;
      }
      if (m) {
        const M = jd(h, s, l);
        await global.Linking.openURL(M, this.client.name);
      } else {
        const M = u || pi[b.request.method].res;
        this.client.core.relayer.publish(s, l, M);
      }
      await this.client.core.history.resolve(d);
    }, this.cleanup = async () => {
      const r = [], i = [];
      this.client.session.getAll().forEach((s) => {
        let n = !1;
        Ja(s.expiry) && (n = !0), this.client.core.crypto.keychain.has(s.topic) || (n = !0), n && r.push(s.topic);
      }), this.client.proposal.getAll().forEach((s) => {
        Ja(s.expiryTimestamp) && i.push(s.id);
      }), await Promise.all([...r.map((s) => this.deleteSession({ topic: s })), ...i.map((s) => this.deleteProposal(s))]);
    }, this.onRelayEventRequest = async (r) => {
      this.requestQueue.queue.push(r), await this.processRequestsQueue();
    }, this.processRequestsQueue = async () => {
      if (this.requestQueue.state === Us.active) {
        this.client.logger.info("Request queue already active, skipping...");
        return;
      }
      for (this.client.logger.info(`Request queue starting with ${this.requestQueue.queue.length} requests`); this.requestQueue.queue.length > 0; ) {
        this.requestQueue.state = Us.active;
        const r = this.requestQueue.queue.shift();
        if (r)
          try {
            await this.processRequest(r);
          } catch (i) {
            this.client.logger.warn(i);
          }
      }
      this.requestQueue.state = Us.idle;
    }, this.processRequest = async (r) => {
      const { topic: i, payload: s, attestation: n, transportType: f, encryptedId: u } = r, h = s.method;
      if (!this.shouldIgnorePairingRequest({ topic: i, requestMethod: h }))
        switch (h) {
          case "wc_sessionPropose":
            return await this.onSessionProposeRequest({ topic: i, payload: s, attestation: n, encryptedId: u });
          case "wc_sessionSettle":
            return await this.onSessionSettleRequest(i, s);
          case "wc_sessionUpdate":
            return await this.onSessionUpdateRequest(i, s);
          case "wc_sessionExtend":
            return await this.onSessionExtendRequest(i, s);
          case "wc_sessionPing":
            return await this.onSessionPingRequest(i, s);
          case "wc_sessionDelete":
            return await this.onSessionDeleteRequest(i, s);
          case "wc_sessionRequest":
            return await this.onSessionRequest({ topic: i, payload: s, attestation: n, encryptedId: u, transportType: f });
          case "wc_sessionEvent":
            return await this.onSessionEventRequest(i, s);
          case "wc_sessionAuthenticate":
            return await this.onSessionAuthenticateRequest({ topic: i, payload: s, attestation: n, encryptedId: u, transportType: f });
          default:
            return this.client.logger.info(`Unsupported request method ${h}`);
        }
    }, this.onRelayEventResponse = async (r) => {
      const { topic: i, payload: s, transportType: n } = r, f = (await this.client.core.history.get(i, s.id)).request.method;
      switch (f) {
        case "wc_sessionPropose":
          return this.onSessionProposeResponse(i, s, n);
        case "wc_sessionSettle":
          return this.onSessionSettleResponse(i, s);
        case "wc_sessionUpdate":
          return this.onSessionUpdateResponse(i, s);
        case "wc_sessionExtend":
          return this.onSessionExtendResponse(i, s);
        case "wc_sessionPing":
          return this.onSessionPingResponse(i, s);
        case "wc_sessionRequest":
          return this.onSessionRequestResponse(i, s);
        case "wc_sessionAuthenticate":
          return this.onSessionAuthenticateResponse(i, s);
        default:
          return this.client.logger.info(`Unsupported response method ${f}`);
      }
    }, this.onRelayEventUnknownPayload = (r) => {
      const { topic: i } = r, { message: s } = ot("MISSING_OR_INVALID", `Decoded payload on topic ${i} is not identifiable as a JSON-RPC request or a response.`);
      throw new Error(s);
    }, this.shouldIgnorePairingRequest = (r) => {
      const { topic: i, requestMethod: s } = r, n = this.expectedPairingMethodMap.get(i);
      return !n || n.includes(s) ? !1 : !!(n.includes("wc_sessionAuthenticate") && this.client.events.listenerCount("session_authenticate") > 0);
    }, this.onSessionProposeRequest = async (r) => {
      const { topic: i, payload: s, attestation: n, encryptedId: f } = r, { params: u, id: h } = s;
      try {
        const d = this.client.core.eventClient.getEvent({ topic: i });
        this.isValidConnect(Kr({}, s.params));
        const l = u.expiryTimestamp || ci(pi.wc_sessionPropose.req.ttl), m = Kr({ id: h, pairingTopic: i, expiryTimestamp: l }, u);
        await this.setProposal(h, m);
        const b = await this.getVerifyContext({ attestationId: n, hash: Ea(JSON.stringify(s)), encryptedId: f, metadata: m.proposer.metadata });
        this.client.events.listenerCount("session_proposal") === 0 && (console.warn("No listener for session_proposal event"), d == null || d.setError(xa.proposal_listener_not_found)), d == null || d.addTrace(Fs.emit_session_proposal), this.client.events.emit("session_proposal", { id: h, params: m, verifyContext: b });
      } catch (d) {
        await this.sendError({ id: h, topic: i, error: d, rpcOpts: pi.wc_sessionPropose.autoReject }), this.client.logger.error(d);
      }
    }, this.onSessionProposeResponse = async (r, i, s) => {
      const { id: n } = i;
      if (Hs(i)) {
        const { result: f } = i;
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", result: f });
        const u = this.client.proposal.get(n);
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", proposal: u });
        const h = u.proposer.publicKey;
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", selfPublicKey: h });
        const d = f.responderPublicKey;
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", peerPublicKey: d });
        const l = await this.client.core.crypto.generateSharedKey(h, d);
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", sessionTopic: l });
        const m = await this.client.core.relayer.subscribe(l, { transportType: s });
        this.client.logger.trace({ type: "method", method: "onSessionProposeResponse", subscriptionId: m }), await this.client.core.pairing.activate({ topic: r });
      } else if (Qn(i)) {
        await this.client.proposal.delete(n, wr("USER_DISCONNECTED"));
        const f = Yt("session_connect");
        if (this.events.listenerCount(f) === 0)
          throw new Error(`emitting ${f} without any listeners, 954`);
        this.events.emit(Yt("session_connect"), { error: i.error });
      }
    }, this.onSessionSettleRequest = async (r, i) => {
      const { id: s, params: n } = i;
      try {
        this.isValidSessionSettleRequest(n);
        const { relay: f, controller: u, expiry: h, namespaces: d, sessionProperties: l, sessionConfig: m } = i.params, b = ws(Kr(Kr({ topic: r, relay: f, expiry: h, namespaces: d, acknowledged: !0, pairingTopic: "", requiredNamespaces: {}, optionalNamespaces: {}, controller: u.publicKey, self: { publicKey: "", metadata: this.client.metadata }, peer: { publicKey: u.publicKey, metadata: u.metadata } }, l && { sessionProperties: l }), m && { sessionConfig: m }), { transportType: Or.relay }), M = Yt("session_connect");
        if (this.events.listenerCount(M) === 0)
          throw new Error(`emitting ${M} without any listeners 997`);
        this.events.emit(Yt("session_connect"), { session: b }), await this.sendResult({ id: i.id, topic: r, result: !0, throwOnFailedPublish: !0 });
      } catch (f) {
        await this.sendError({ id: s, topic: r, error: f }), this.client.logger.error(f);
      }
    }, this.onSessionSettleResponse = async (r, i) => {
      const { id: s } = i;
      Hs(i) ? (await this.client.session.update(r, { acknowledged: !0 }), this.events.emit(Yt("session_approve", s), {})) : Qn(i) && (await this.client.session.delete(r, wr("USER_DISCONNECTED")), this.events.emit(Yt("session_approve", s), { error: i.error }));
    }, this.onSessionUpdateRequest = async (r, i) => {
      const { params: s, id: n } = i;
      try {
        const f = `${r}_session_update`, u = $u.get(f);
        if (u && this.isRequestOutOfSync(u, n)) {
          this.client.logger.info(`Discarding out of sync request - ${n}`), this.sendError({ id: n, topic: r, error: wr("INVALID_UPDATE_REQUEST") });
          return;
        }
        this.isValidUpdate(Kr({ topic: r }, s));
        try {
          $u.set(f, n), await this.client.session.update(r, { namespaces: s.namespaces }), await this.sendResult({ id: n, topic: r, result: !0, throwOnFailedPublish: !0 });
        } catch (h) {
          throw $u.delete(f), h;
        }
        this.client.events.emit("session_update", { id: n, topic: r, params: s });
      } catch (f) {
        await this.sendError({ id: n, topic: r, error: f }), this.client.logger.error(f);
      }
    }, this.isRequestOutOfSync = (r, i) => parseInt(i.toString().slice(0, -3)) <= parseInt(r.toString().slice(0, -3)), this.onSessionUpdateResponse = (r, i) => {
      const { id: s } = i, n = Yt("session_update", s);
      if (this.events.listenerCount(n) === 0)
        throw new Error(`emitting ${n} without any listeners`);
      Hs(i) ? this.events.emit(Yt("session_update", s), {}) : Qn(i) && this.events.emit(Yt("session_update", s), { error: i.error });
    }, this.onSessionExtendRequest = async (r, i) => {
      const { id: s } = i;
      try {
        this.isValidExtend({ topic: r }), await this.setExpiry(r, ci(Jf)), await this.sendResult({ id: s, topic: r, result: !0, throwOnFailedPublish: !0 }), this.client.events.emit("session_extend", { id: s, topic: r });
      } catch (n) {
        await this.sendError({ id: s, topic: r, error: n }), this.client.logger.error(n);
      }
    }, this.onSessionExtendResponse = (r, i) => {
      const { id: s } = i, n = Yt("session_extend", s);
      if (this.events.listenerCount(n) === 0)
        throw new Error(`emitting ${n} without any listeners`);
      Hs(i) ? this.events.emit(Yt("session_extend", s), {}) : Qn(i) && this.events.emit(Yt("session_extend", s), { error: i.error });
    }, this.onSessionPingRequest = async (r, i) => {
      const { id: s } = i;
      try {
        this.isValidPing({ topic: r }), await this.sendResult({ id: s, topic: r, result: !0, throwOnFailedPublish: !0 }), this.client.events.emit("session_ping", { id: s, topic: r });
      } catch (n) {
        await this.sendError({ id: s, topic: r, error: n }), this.client.logger.error(n);
      }
    }, this.onSessionPingResponse = (r, i) => {
      const { id: s } = i, n = Yt("session_ping", s);
      if (this.events.listenerCount(n) === 0)
        throw new Error(`emitting ${n} without any listeners`);
      setTimeout(() => {
        Hs(i) ? this.events.emit(Yt("session_ping", s), {}) : Qn(i) && this.events.emit(Yt("session_ping", s), { error: i.error });
      }, 500);
    }, this.onSessionDeleteRequest = async (r, i) => {
      const { id: s } = i;
      try {
        this.isValidDisconnect({ topic: r, reason: i.params }), Promise.all([new Promise((n) => {
          this.client.core.relayer.once(Yi.publish, async () => {
            n(await this.deleteSession({ topic: r, id: s }));
          });
        }), this.sendResult({ id: s, topic: r, result: !0, throwOnFailedPublish: !0 }), this.cleanupPendingSentRequestsForTopic({ topic: r, error: wr("USER_DISCONNECTED") })]).catch((n) => this.client.logger.error(n));
      } catch (n) {
        this.client.logger.error(n);
      }
    }, this.onSessionRequest = async (r) => {
      var i, s, n;
      const { topic: f, payload: u, attestation: h, encryptedId: d, transportType: l } = r, { id: m, params: b } = u;
      try {
        await this.isValidRequest(Kr({ topic: f }, b));
        const M = this.client.session.get(f), A = await this.getVerifyContext({ attestationId: h, hash: Ea(JSON.stringify(no("wc_sessionRequest", b, m))), encryptedId: d, metadata: M.peer.metadata, transportType: l }), N = { id: m, topic: f, params: b, verifyContext: A };
        await this.setPendingSessionRequest(N), l === Or.link_mode && (i = M.peer.metadata.redirect) != null && i.universal && this.client.core.addLinkModeSupportedApp((s = M.peer.metadata.redirect) == null ? void 0 : s.universal), (n = this.client.signConfig) != null && n.disableRequestQueue ? this.emitSessionRequest(N) : (this.addSessionRequestToSessionRequestQueue(N), this.processSessionRequestQueue());
      } catch (M) {
        await this.sendError({ id: m, topic: f, error: M }), this.client.logger.error(M);
      }
    }, this.onSessionRequestResponse = (r, i) => {
      const { id: s } = i, n = Yt("session_request", s);
      if (this.events.listenerCount(n) === 0)
        throw new Error(`emitting ${n} without any listeners`);
      Hs(i) ? this.events.emit(Yt("session_request", s), { result: i.result }) : Qn(i) && this.events.emit(Yt("session_request", s), { error: i.error });
    }, this.onSessionEventRequest = async (r, i) => {
      const { id: s, params: n } = i;
      try {
        const f = `${r}_session_event_${n.event.name}`, u = $u.get(f);
        if (u && this.isRequestOutOfSync(u, s)) {
          this.client.logger.info(`Discarding out of sync request - ${s}`);
          return;
        }
        this.isValidEmit(Kr({ topic: r }, n)), this.client.events.emit("session_event", { id: s, topic: r, params: n }), $u.set(f, s);
      } catch (f) {
        await this.sendError({ id: s, topic: r, error: f }), this.client.logger.error(f);
      }
    }, this.onSessionAuthenticateResponse = (r, i) => {
      const { id: s } = i;
      this.client.logger.trace({ type: "method", method: "onSessionAuthenticateResponse", topic: r, payload: i }), Hs(i) ? this.events.emit(Yt("session_request", s), { result: i.result }) : Qn(i) && this.events.emit(Yt("session_request", s), { error: i.error });
    }, this.onSessionAuthenticateRequest = async (r) => {
      var i;
      const { topic: s, payload: n, attestation: f, encryptedId: u, transportType: h } = r;
      try {
        const { requester: d, authPayload: l, expiryTimestamp: m } = n.params, b = await this.getVerifyContext({ attestationId: f, hash: Ea(JSON.stringify(n)), encryptedId: u, metadata: d.metadata, transportType: h }), M = { requester: d, pairingTopic: s, id: n.id, authPayload: l, verifyContext: b, expiryTimestamp: m };
        await this.setAuthRequest(n.id, { request: M, pairingTopic: s, transportType: h }), h === Or.link_mode && (i = d.metadata.redirect) != null && i.universal && this.client.core.addLinkModeSupportedApp(d.metadata.redirect.universal), this.client.events.emit("session_authenticate", { topic: s, params: n.params, id: n.id, verifyContext: b });
      } catch (d) {
        this.client.logger.error(d);
        const l = n.params.requester.publicKey, m = await this.client.core.crypto.generateKeyPair(), b = this.getAppLinkIfEnabled(n.params.requester.metadata, h), M = { type: Na, receiverPublicKey: l, senderPublicKey: m };
        await this.sendError({ id: n.id, topic: s, error: d, encodeOpts: M, rpcOpts: pi.wc_sessionAuthenticate.autoReject, appLink: b });
      }
    }, this.addSessionRequestToSessionRequestQueue = (r) => {
      this.sessionRequestQueue.queue.push(r);
    }, this.cleanupAfterResponse = (r) => {
      this.deletePendingSessionRequest(r.response.id, { message: "fulfilled", code: 0 }), setTimeout(() => {
        this.sessionRequestQueue.state = Us.idle, this.processSessionRequestQueue();
      }, ct.toMiliseconds(this.requestQueueDelay));
    }, this.cleanupPendingSentRequestsForTopic = ({ topic: r, error: i }) => {
      const s = this.client.core.history.pending;
      s.length > 0 && s.filter((n) => n.topic === r && n.request.method === "wc_sessionRequest").forEach((n) => {
        const f = n.request.id, u = Yt("session_request", f);
        if (this.events.listenerCount(u) === 0)
          throw new Error(`emitting ${u} without any listeners`);
        this.events.emit(Yt("session_request", n.request.id), { error: i });
      });
    }, this.processSessionRequestQueue = () => {
      if (this.sessionRequestQueue.state === Us.active) {
        this.client.logger.info("session request queue is already active.");
        return;
      }
      const r = this.sessionRequestQueue.queue[0];
      if (!r) {
        this.client.logger.info("session request queue is empty.");
        return;
      }
      try {
        this.sessionRequestQueue.state = Us.active, this.emitSessionRequest(r);
      } catch (i) {
        this.client.logger.error(i);
      }
    }, this.emitSessionRequest = (r) => {
      this.client.events.emit("session_request", r);
    }, this.onPairingCreated = (r) => {
      if (r.methods && this.expectedPairingMethodMap.set(r.topic, r.methods), r.active)
        return;
      const i = this.client.proposal.getAll().find((s) => s.pairingTopic === r.topic);
      i && this.onSessionProposeRequest({ topic: r.topic, payload: no("wc_sessionPropose", { requiredNamespaces: i.requiredNamespaces, optionalNamespaces: i.optionalNamespaces, relays: i.relays, proposer: i.proposer, sessionProperties: i.sessionProperties }, i.id) });
    }, this.isValidConnect = async (r) => {
      if (!fn(r)) {
        const { message: h } = ot("MISSING_OR_INVALID", `connect() params: ${JSON.stringify(r)}`);
        throw new Error(h);
      }
      const { pairingTopic: i, requiredNamespaces: s, optionalNamespaces: n, sessionProperties: f, relays: u } = r;
      if (Qi(i) || await this.isValidPairingTopic(i), !Wae(u, !0)) {
        const { message: h } = ot("MISSING_OR_INVALID", `connect() relays: ${u}`);
        throw new Error(h);
      }
      !Qi(s) && Mh(s) !== 0 && this.validateNamespaces(s, "requiredNamespaces"), !Qi(n) && Mh(n) !== 0 && this.validateNamespaces(n, "optionalNamespaces"), Qi(f) || this.validateSessionProps(f, "sessionProperties");
    }, this.validateNamespaces = (r, i) => {
      const s = Hae(r, "connect()", i);
      if (s)
        throw new Error(s.message);
    }, this.isValidApprove = async (r) => {
      if (!fn(r))
        throw new Error(ot("MISSING_OR_INVALID", `approve() params: ${r}`).message);
      const { id: i, namespaces: s, relayProtocol: n, sessionProperties: f } = r;
      this.checkRecentlyDeleted(i), await this.isValidProposalId(i);
      const u = this.client.proposal.get(i), h = Py(s, "approve()");
      if (h)
        throw new Error(h.message);
      const d = dx(u.requiredNamespaces, s, "approve()");
      if (d)
        throw new Error(d.message);
      if (!ii(n, !0)) {
        const { message: l } = ot("MISSING_OR_INVALID", `approve() relayProtocol: ${n}`);
        throw new Error(l);
      }
      Qi(f) || this.validateSessionProps(f, "sessionProperties");
    }, this.isValidReject = async (r) => {
      if (!fn(r)) {
        const { message: n } = ot("MISSING_OR_INVALID", `reject() params: ${r}`);
        throw new Error(n);
      }
      const { id: i, reason: s } = r;
      if (this.checkRecentlyDeleted(i), await this.isValidProposalId(i), !Gae(s)) {
        const { message: n } = ot("MISSING_OR_INVALID", `reject() reason: ${JSON.stringify(s)}`);
        throw new Error(n);
      }
    }, this.isValidSessionSettleRequest = (r) => {
      if (!fn(r)) {
        const { message: d } = ot("MISSING_OR_INVALID", `onSessionSettleRequest() params: ${r}`);
        throw new Error(d);
      }
      const { relay: i, controller: s, namespaces: n, expiry: f } = r;
      if (!AT(i)) {
        const { message: d } = ot("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string");
        throw new Error(d);
      }
      const u = Bae(s, "onSessionSettleRequest()");
      if (u)
        throw new Error(u.message);
      const h = Py(n, "onSessionSettleRequest()");
      if (h)
        throw new Error(h.message);
      if (Ja(f)) {
        const { message: d } = ot("EXPIRED", "onSessionSettleRequest()");
        throw new Error(d);
      }
    }, this.isValidUpdate = async (r) => {
      if (!fn(r)) {
        const { message: h } = ot("MISSING_OR_INVALID", `update() params: ${r}`);
        throw new Error(h);
      }
      const { topic: i, namespaces: s } = r;
      this.checkRecentlyDeleted(i), await this.isValidSessionTopic(i);
      const n = this.client.session.get(i), f = Py(s, "update()");
      if (f)
        throw new Error(f.message);
      const u = dx(n.requiredNamespaces, s, "update()");
      if (u)
        throw new Error(u.message);
    }, this.isValidExtend = async (r) => {
      if (!fn(r)) {
        const { message: s } = ot("MISSING_OR_INVALID", `extend() params: ${r}`);
        throw new Error(s);
      }
      const { topic: i } = r;
      this.checkRecentlyDeleted(i), await this.isValidSessionTopic(i);
    }, this.isValidRequest = async (r) => {
      if (!fn(r)) {
        const { message: h } = ot("MISSING_OR_INVALID", `request() params: ${r}`);
        throw new Error(h);
      }
      const { topic: i, request: s, chainId: n, expiry: f } = r;
      this.checkRecentlyDeleted(i), await this.isValidSessionTopic(i);
      const { namespaces: u } = this.client.session.get(i);
      if (!lx(u, n)) {
        const { message: h } = ot("MISSING_OR_INVALID", `request() chainId: ${n}`);
        throw new Error(h);
      }
      if (!Kae(s)) {
        const { message: h } = ot("MISSING_OR_INVALID", `request() ${JSON.stringify(s)}`);
        throw new Error(h);
      }
      if (!Zae(u, n, s.method)) {
        const { message: h } = ot("MISSING_OR_INVALID", `request() method: ${s.method}`);
        throw new Error(h);
      }
      if (f && !toe(f, qy)) {
        const { message: h } = ot("MISSING_OR_INVALID", `request() expiry: ${f}. Expiry must be a number (in seconds) between ${qy.min} and ${qy.max}`);
        throw new Error(h);
      }
    }, this.isValidRespond = async (r) => {
      var i;
      if (!fn(r)) {
        const { message: f } = ot("MISSING_OR_INVALID", `respond() params: ${r}`);
        throw new Error(f);
      }
      const { topic: s, response: n } = r;
      try {
        await this.isValidSessionTopic(s);
      } catch (f) {
        throw (i = r == null ? void 0 : r.response) != null && i.id && this.cleanupAfterResponse(r), f;
      }
      if (!Yae(n)) {
        const { message: f } = ot("MISSING_OR_INVALID", `respond() response: ${JSON.stringify(n)}`);
        throw new Error(f);
      }
    }, this.isValidPing = async (r) => {
      if (!fn(r)) {
        const { message: s } = ot("MISSING_OR_INVALID", `ping() params: ${r}`);
        throw new Error(s);
      }
      const { topic: i } = r;
      await this.isValidSessionOrPairingTopic(i);
    }, this.isValidEmit = async (r) => {
      if (!fn(r)) {
        const { message: u } = ot("MISSING_OR_INVALID", `emit() params: ${r}`);
        throw new Error(u);
      }
      const { topic: i, event: s, chainId: n } = r;
      await this.isValidSessionTopic(i);
      const { namespaces: f } = this.client.session.get(i);
      if (!lx(f, n)) {
        const { message: u } = ot("MISSING_OR_INVALID", `emit() chainId: ${n}`);
        throw new Error(u);
      }
      if (!Qae(s)) {
        const { message: u } = ot("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(s)}`);
        throw new Error(u);
      }
      if (!Jae(f, n, s.name)) {
        const { message: u } = ot("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(s)}`);
        throw new Error(u);
      }
    }, this.isValidDisconnect = async (r) => {
      if (!fn(r)) {
        const { message: s } = ot("MISSING_OR_INVALID", `disconnect() params: ${r}`);
        throw new Error(s);
      }
      const { topic: i } = r;
      await this.isValidSessionOrPairingTopic(i);
    }, this.isValidAuthenticate = (r) => {
      const { chains: i, uri: s, domain: n, nonce: f } = r;
      if (!Array.isArray(i) || i.length === 0)
        throw new Error("chains is required and must be a non-empty array");
      if (!ii(s, !1))
        throw new Error("uri is required parameter");
      if (!ii(n, !1))
        throw new Error("domain is required parameter");
      if (!ii(f, !1))
        throw new Error("nonce is required parameter");
      if ([...new Set(i.map((h) => vc(h).namespace))].length > 1)
        throw new Error("Multi-namespace requests are not supported. Please request single namespace only.");
      const { namespace: u } = vc(i[0]);
      if (u !== "eip155")
        throw new Error("Only eip155 namespace is supported for authenticated sessions. Please use .connect() for non-eip155 chains.");
    }, this.getVerifyContext = async (r) => {
      const { attestationId: i, hash: s, encryptedId: n, metadata: f, transportType: u } = r, h = { verified: { verifyUrl: f.verifyUrl || fh, validation: "UNKNOWN", origin: f.url || "" } };
      try {
        if (u === Or.link_mode) {
          const l = this.getAppLinkIfEnabled(f, u);
          return h.verified.validation = l && new URL(l).origin === new URL(f.url).origin ? "VALID" : "INVALID", h;
        }
        const d = await this.client.core.verify.resolve({ attestationId: i, hash: s, encryptedId: n, verifyUrl: f.verifyUrl });
        d && (h.verified.origin = d.origin, h.verified.isScam = d.isScam, h.verified.validation = d.origin === new URL(f.url).origin ? "VALID" : "INVALID");
      } catch (d) {
        this.client.logger.warn(d);
      }
      return this.client.logger.debug(`Verify context: ${JSON.stringify(h)}`), h;
    }, this.validateSessionProps = (r, i) => {
      Object.values(r).forEach((s) => {
        if (!ii(s, !1)) {
          const { message: n } = ot("MISSING_OR_INVALID", `${i} must be in Record<string, string> format. Received: ${JSON.stringify(s)}`);
          throw new Error(n);
        }
      });
    }, this.getPendingAuthRequest = (r) => {
      const i = this.client.auth.requests.get(r);
      return typeof i == "object" ? i : void 0;
    }, this.addToRecentlyDeleted = (r, i) => {
      if (this.recentlyDeletedMap.set(r, i), this.recentlyDeletedMap.size >= this.recentlyDeletedLimit) {
        let s = 0;
        const n = this.recentlyDeletedLimit / 2;
        for (const f of this.recentlyDeletedMap.keys()) {
          if (s++ >= n)
            break;
          this.recentlyDeletedMap.delete(f);
        }
      }
    }, this.checkRecentlyDeleted = (r) => {
      const i = this.recentlyDeletedMap.get(r);
      if (i) {
        const { message: s } = ot("MISSING_OR_INVALID", `Record was recently deleted - ${i}: ${r}`);
        throw new Error(s);
      }
    }, this.isLinkModeEnabled = (r, i) => {
      var s, n, f, u, h, d, l, m, b;
      return !r || i !== Or.link_mode ? !1 : ((n = (s = this.client.metadata) == null ? void 0 : s.redirect) == null ? void 0 : n.linkMode) === !0 && ((u = (f = this.client.metadata) == null ? void 0 : f.redirect) == null ? void 0 : u.universal) !== void 0 && ((d = (h = this.client.metadata) == null ? void 0 : h.redirect) == null ? void 0 : d.universal) !== "" && ((l = r == null ? void 0 : r.redirect) == null ? void 0 : l.universal) !== void 0 && ((m = r == null ? void 0 : r.redirect) == null ? void 0 : m.universal) !== "" && ((b = r == null ? void 0 : r.redirect) == null ? void 0 : b.linkMode) === !0 && this.client.core.linkModeSupportedApps.includes(r.redirect.universal) && typeof (global == null ? void 0 : global.Linking) < "u";
    }, this.getAppLinkIfEnabled = (r, i) => {
      var s;
      return this.isLinkModeEnabled(r, i) ? (s = r == null ? void 0 : r.redirect) == null ? void 0 : s.universal : void 0;
    }, this.handleLinkModeMessage = ({ url: r }) => {
      if (!r || !r.includes("wc_ev") || !r.includes("topic"))
        return;
      const i = Y8(r, "topic") || "", s = decodeURIComponent(Y8(r, "wc_ev") || ""), n = this.client.session.keys.includes(i);
      n && this.client.session.update(i, { transportType: Or.link_mode }), this.client.core.dispatchEnvelope({ topic: i, message: s, sessionExists: n });
    }, this.registerLinkModeListeners = async () => {
      var r;
      if (Cw() || su() && (r = this.client.metadata.redirect) != null && r.linkMode) {
        const i = global == null ? void 0 : global.Linking;
        if (typeof i < "u") {
          i.addEventListener("url", this.handleLinkModeMessage, this.client.name);
          const s = await i.getInitialURL();
          s && setTimeout(() => {
            this.handleLinkModeMessage({ url: s });
          }, 50);
        }
      }
    };
  }
  isInitialized() {
    if (!this.initialized) {
      const { message: e } = ot("NOT_INITIALIZED", this.name);
      throw new Error(e);
    }
  }
  async confirmOnlineStateOrThrow() {
    await this.client.core.relayer.confirmOnlineStateOrThrow();
  }
  registerRelayerEvents() {
    this.client.core.relayer.on(Yi.message, (e) => {
      !this.initialized || this.relayMessageCache.length > 0 ? this.relayMessageCache.push(e) : this.onRelayMessage(e);
    });
  }
  async onRelayMessage(e) {
    const { topic: r, message: i, attestation: s, transportType: n } = e, { publicKey: f } = this.client.auth.authKeys.keys.includes(a0) ? this.client.auth.authKeys.get(a0) : { responseTopic: void 0, publicKey: void 0 }, u = await this.client.core.crypto.decode(r, i, { receiverPublicKey: f, encoding: n === Or.link_mode ? Fu : io });
    try {
      zw(u) ? (this.client.core.history.set(r, u), this.onRelayEventRequest({ topic: r, payload: u, attestation: s, transportType: n, encryptedId: Ea(i) })) : u1(u) ? (await this.client.core.history.resolve(u), await this.onRelayEventResponse({ topic: r, payload: u, transportType: n }), this.client.core.history.delete(r, u.id)) : this.onRelayEventUnknownPayload({ topic: r, payload: u, transportType: n });
    } catch (h) {
      this.client.logger.error(h);
    }
  }
  registerExpirerEvents() {
    this.client.core.expirer.on(Kn.expired, async (e) => {
      const { topic: r, id: i } = bT(e.target);
      if (i && this.client.pendingRequest.keys.includes(i))
        return await this.deletePendingSessionRequest(i, ot("EXPIRED"), !0);
      if (i && this.client.auth.requests.keys.includes(i))
        return await this.deletePendingAuthRequest(i, ot("EXPIRED"), !0);
      r ? this.client.session.keys.includes(r) && (await this.deleteSession({ topic: r, expirerHasDeleted: !0 }), this.client.events.emit("session_expire", { topic: r })) : i && (await this.deleteProposal(i, !0), this.client.events.emit("proposal_expire", { id: i }));
    });
  }
  registerPairingEvents() {
    this.client.core.pairing.events.on(Go.create, (e) => this.onPairingCreated(e)), this.client.core.pairing.events.on(Go.delete, (e) => {
      this.addToRecentlyDeleted(e.topic, "pairing");
    });
  }
  isValidPairingTopic(e) {
    if (!ii(e, !1)) {
      const { message: r } = ot("MISSING_OR_INVALID", `pairing topic should be a string: ${e}`);
      throw new Error(r);
    }
    if (!this.client.core.pairing.pairings.keys.includes(e)) {
      const { message: r } = ot("NO_MATCHING_KEY", `pairing topic doesn't exist: ${e}`);
      throw new Error(r);
    }
    if (Ja(this.client.core.pairing.pairings.get(e).expiry)) {
      const { message: r } = ot("EXPIRED", `pairing topic: ${e}`);
      throw new Error(r);
    }
  }
  async isValidSessionTopic(e) {
    if (!ii(e, !1)) {
      const { message: r } = ot("MISSING_OR_INVALID", `session topic should be a string: ${e}`);
      throw new Error(r);
    }
    if (this.checkRecentlyDeleted(e), !this.client.session.keys.includes(e)) {
      const { message: r } = ot("NO_MATCHING_KEY", `session topic doesn't exist: ${e}`);
      throw new Error(r);
    }
    if (Ja(this.client.session.get(e).expiry)) {
      await this.deleteSession({ topic: e });
      const { message: r } = ot("EXPIRED", `session topic: ${e}`);
      throw new Error(r);
    }
    if (!this.client.core.crypto.keychain.has(e)) {
      const { message: r } = ot("MISSING_OR_INVALID", `session topic does not exist in keychain: ${e}`);
      throw await this.deleteSession({ topic: e }), new Error(r);
    }
  }
  async isValidSessionOrPairingTopic(e) {
    if (this.checkRecentlyDeleted(e), this.client.session.keys.includes(e))
      await this.isValidSessionTopic(e);
    else if (this.client.core.pairing.pairings.keys.includes(e))
      this.isValidPairingTopic(e);
    else if (ii(e, !1)) {
      const { message: r } = ot("NO_MATCHING_KEY", `session or pairing topic doesn't exist: ${e}`);
      throw new Error(r);
    } else {
      const { message: r } = ot("MISSING_OR_INVALID", `session or pairing topic should be a string: ${e}`);
      throw new Error(r);
    }
  }
  async isValidProposalId(e) {
    if (!Vae(e)) {
      const { message: r } = ot("MISSING_OR_INVALID", `proposal id should be a number: ${e}`);
      throw new Error(r);
    }
    if (!this.client.proposal.keys.includes(e)) {
      const { message: r } = ot("NO_MATCHING_KEY", `proposal id doesn't exist: ${e}`);
      throw new Error(r);
    }
    if (Ja(this.client.proposal.get(e).expiryTimestamp)) {
      await this.deleteProposal(e);
      const { message: r } = ot("EXPIRED", `proposal id: ${e}`);
      throw new Error(r);
    }
  }
}
class Vhe extends Sf {
  constructor(e, r) {
    super(e, r, Dhe, $w), this.core = e, this.logger = r;
  }
}
class Ghe extends Sf {
  constructor(e, r) {
    super(e, r, Che, $w), this.core = e, this.logger = r;
  }
}
class Khe extends Sf {
  constructor(e, r) {
    super(e, r, Rhe, $w, (i) => i.id), this.core = e, this.logger = r;
  }
}
class Yhe extends Sf {
  constructor(e, r) {
    super(e, r, jhe, l1, () => a0), this.core = e, this.logger = r;
  }
}
class Qhe extends Sf {
  constructor(e, r) {
    super(e, r, Bhe, l1), this.core = e, this.logger = r;
  }
}
class Zhe extends Sf {
  constructor(e, r) {
    super(e, r, zhe, l1, (i) => i.id), this.core = e, this.logger = r;
  }
}
class Jhe {
  constructor(e, r) {
    this.core = e, this.logger = r, this.authKeys = new Yhe(this.core, this.logger), this.pairingTopics = new Qhe(this.core, this.logger), this.requests = new Zhe(this.core, this.logger);
  }
  async init() {
    await this.authKeys.init(), await this.pairingTopics.init(), await this.requests.init();
  }
}
class qw extends Sfe {
  constructor(e) {
    super(e), this.protocol = tN, this.version = rN, this.name = $y.name, this.events = new Pr.exports.EventEmitter(), this.on = (i, s) => this.events.on(i, s), this.once = (i, s) => this.events.once(i, s), this.off = (i, s) => this.events.off(i, s), this.removeListener = (i, s) => this.events.removeListener(i, s), this.removeAllListeners = (i) => this.events.removeAllListeners(i), this.connect = async (i) => {
      try {
        return await this.engine.connect(i);
      } catch (s) {
        throw this.logger.error(s.message), s;
      }
    }, this.pair = async (i) => {
      try {
        return await this.engine.pair(i);
      } catch (s) {
        throw this.logger.error(s.message), s;
      }
    }, this.approve = async (i) => {
      try {
        return await this.engine.approve(i);
      } catch (s) {
        throw this.logger.error(s.message), s;
      }
    }, this.reject = async (i) => {
      try {
        return await this.engine.reject(i);
      } catch (s) {
        throw this.logger.error(s.message), s;
      }
    }, this.update = async (i) => {
      try {
        return await this.engine.update(i);
      } catch (s) {
        throw this.logger.error(s.message), s;
      }
    }, this.extend = async (i) => {
      try {
        return await this.engine.extend(i);
      } catch (s) {
        throw this.logger.error(s.message), s;
      }
    }, this.request = async (i) => {
      try {
        return await this.engine.request(i);
      } catch (s) {
        throw this.logger.error(s.message), s;
      }
    }, this.respond = async (i) => {
      try {
        return await this.engine.respond(i);
      } catch (s) {
        throw this.logger.error(s.message), s;
      }
    }, this.ping = async (i) => {
      try {
        return await this.engine.ping(i);
      } catch (s) {
        throw this.logger.error(s.message), s;
      }
    }, this.emit = async (i) => {
      try {
        return await this.engine.emit(i);
      } catch (s) {
        throw this.logger.error(s.message), s;
      }
    }, this.disconnect = async (i) => {
      try {
        return await this.engine.disconnect(i);
      } catch (s) {
        throw this.logger.error(s.message), s;
      }
    }, this.find = (i) => {
      try {
        return this.engine.find(i);
      } catch (s) {
        throw this.logger.error(s.message), s;
      }
    }, this.getPendingSessionRequests = () => {
      try {
        return this.engine.getPendingSessionRequests();
      } catch (i) {
        throw this.logger.error(i.message), i;
      }
    }, this.authenticate = async (i, s) => {
      try {
        return await this.engine.authenticate(i, s);
      } catch (n) {
        throw this.logger.error(n.message), n;
      }
    }, this.formatAuthMessage = (i) => {
      try {
        return this.engine.formatAuthMessage(i);
      } catch (s) {
        throw this.logger.error(s.message), s;
      }
    }, this.approveSessionAuthenticate = async (i) => {
      try {
        return await this.engine.approveSessionAuthenticate(i);
      } catch (s) {
        throw this.logger.error(s.message), s;
      }
    }, this.rejectSessionAuthenticate = async (i) => {
      try {
        return await this.engine.rejectSessionAuthenticate(i);
      } catch (s) {
        throw this.logger.error(s.message), s;
      }
    }, this.name = (e == null ? void 0 : e.name) || $y.name, this.metadata = (e == null ? void 0 : e.metadata) || lT(), this.signConfig = e == null ? void 0 : e.signConfig;
    const r = typeof (e == null ? void 0 : e.logger) < "u" && typeof (e == null ? void 0 : e.logger) != "string" ? e.logger : Ys(o1({ level: (e == null ? void 0 : e.logger) || $y.logger }));
    this.core = (e == null ? void 0 : e.core) || new Nhe(e), this.logger = en(r, this.name), this.session = new Ghe(this.core, this.logger), this.proposal = new Vhe(this.core, this.logger), this.pendingRequest = new Khe(this.core, this.logger), this.engine = new Whe(this), this.auth = new Jhe(this.core, this.logger);
  }
  static async init(e) {
    const r = new qw(e);
    return await r.initialize(), r;
  }
  get context() {
    return pn(this.logger);
  }
  get pairing() {
    return this.core.pairing.pairings;
  }
  async initialize() {
    this.logger.trace("Initialized");
    try {
      await this.core.start(), await this.session.init(), await this.proposal.init(), await this.pendingRequest.init(), await this.auth.init(), await this.engine.init(), this.logger.info("SignClient Initialization Success"), this.engine.processRelayMessageCache();
    } catch (e) {
      throw this.logger.info("SignClient Initialization Failure"), this.logger.error(e.message), e;
    }
  }
}
var Wm = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(t, e) {
  (function() {
    var r, i = "4.17.21", s = 200, n = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", f = "Expected a function", u = "Invalid `variable` option passed into `_.template`", h = "__lodash_hash_undefined__", d = 500, l = "__lodash_placeholder__", m = 1, b = 2, M = 4, A = 1, N = 2, R = 1, O = 2, P = 4, F = 8, H = 16, Q = 32, Z = 64, B = 128, Y = 256, ae = 512, se = 30, W = "...", C = 800, g = 16, a = 1, c = 2, p = 3, w = 1 / 0, _ = 9007199254740991, x = 17976931348623157e292, E = 0 / 0, y = 4294967295, o = y - 1, S = y >>> 1, J = [
      ["ary", B],
      ["bind", R],
      ["bindKey", O],
      ["curry", F],
      ["curryRight", H],
      ["flip", ae],
      ["partial", Q],
      ["partialRight", Z],
      ["rearg", Y]
    ], z = "[object Arguments]", k = "[object Array]", j = "[object AsyncFunction]", q = "[object Boolean]", K = "[object Date]", U = "[object DOMException]", T = "[object Error]", D = "[object Function]", te = "[object GeneratorFunction]", ne = "[object Map]", le = "[object Number]", X = "[object Null]", $ = "[object Object]", V = "[object Promise]", re = "[object Proxy]", fe = "[object RegExp]", ue = "[object Set]", me = "[object String]", be = "[object Symbol]", ve = "[object Undefined]", Ge = "[object WeakMap]", ye = "[object WeakSet]", pe = "[object ArrayBuffer]", Je = "[object DataView]", Ie = "[object Float32Array]", we = "[object Float64Array]", at = "[object Int8Array]", Oe = "[object Int16Array]", Ee = "[object Int32Array]", ft = "[object Uint8Array]", Le = "[object Uint8ClampedArray]", Pe = "[object Uint16Array]", Mt = "[object Uint32Array]", Ve = /\b__p \+= '';/g, ke = /\b(__p \+=) '' \+/g, Et = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Ke = /&(?:amp|lt|gt|quot|#39);/g, Be = /[&<>"']/g, dt = RegExp(Ke.source), ze = RegExp(Be.source), Te = /<%-([\s\S]+?)%>/g, pt = /<%([\s\S]+?)%>/g, Fe = /<%=([\s\S]+?)%>/g, Ae = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, bt = /^\w*$/, He = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ne = /[\\^$.*+?()[\]{}|]/g, yt = RegExp(Ne.source), $e = /^\s+/, De = /\s/, vt = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, je = /\{\n\/\* \[wrapped with (.+)\] \*/, Ce = /,? & /, mt = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Ze = /[()=,{}\[\]\/\s]/, qe = /\\(\\)?/g, Dt = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, We = /\w*$/, Qe = /^[-+]0x[0-9a-f]+$/i, Qt = /^0b[01]+$/i, Zt = /^\[object .+?Constructor\]$/, Jt = /^0o[0-7]+$/i, Xt = /^(?:0|[1-9]\d*)$/, kt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, ar = /($^)/, lr = /['\n\r\u2028\u2029\\]/g, or = "\\ud800-\\udfff", dr = "\\u0300-\\u036f", pr = "\\ufe20-\\ufe2f", fr = "\\u20d0-\\u20ff", ur = dr + pr + fr, hr = "\\u2700-\\u27bf", qt = "a-z\\xdf-\\xf6\\xf8-\\xff", Er = "\\xac\\xb1\\xd7\\xf7", Ir = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Ar = "\\u2000-\\u206f", qr = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", zr = "A-Z\\xc0-\\xd6\\xd8-\\xde", ll = "\\ufe0e\\ufe0f", _o = Er + Ir + Ar + qr, fu = "['\u2019]", Mo = "[" + or + "]", cu = "[" + _o + "]", xo = "[" + ur + "]", dl = "\\d+", d1 = "[" + hr + "]", pl = "[" + qt + "]", vl = "[^" + or + _o + dl + hr + qt + zr + "]", If = "\\ud83c[\\udffb-\\udfff]", p1 = "(?:" + xo + "|" + If + ")", gl = "[^" + or + "]", Af = "(?:\\ud83c[\\udde6-\\uddff]){2}", ja = "[\\ud800-\\udbff][\\udc00-\\udfff]", vn = "[" + zr + "]", bl = "\\u200d", yl = "(?:" + pl + "|" + vl + ")", Cs = "(?:" + vn + "|" + vl + ")", ml = "(?:" + fu + "(?:d|ll|m|re|s|t|ve))?", wl = "(?:" + fu + "(?:D|LL|M|RE|S|T|VE))?", _l = p1 + "?", Ml = "[" + ll + "]?", v1 = "(?:" + bl + "(?:" + [gl, Af, ja].join("|") + ")" + Ml + _l + ")*", ha = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", xl = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Sl = Ml + _l + v1, Tf = "(?:" + [d1, Af, ja].join("|") + ")" + Sl, g1 = "(?:" + [gl + xo + "?", xo, Af, ja, Mo].join("|") + ")", uu = RegExp(fu, "g"), b1 = RegExp(xo, "g"), Nf = RegExp(If + "(?=" + If + ")|" + g1 + Sl, "g"), El = RegExp([
      vn + "?" + pl + "+" + ml + "(?=" + [cu, vn, "$"].join("|") + ")",
      Cs + "+" + wl + "(?=" + [cu, vn + yl, "$"].join("|") + ")",
      vn + "?" + yl + "+" + ml,
      vn + "+" + wl,
      xl,
      ha,
      dl,
      Tf
    ].join("|"), "g"), Il = RegExp("[" + bl + or + ur + ll + "]"), So = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Al = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], y1 = -1, Tr = {};
    Tr[Ie] = Tr[we] = Tr[at] = Tr[Oe] = Tr[Ee] = Tr[ft] = Tr[Le] = Tr[Pe] = Tr[Mt] = !0, Tr[z] = Tr[k] = Tr[pe] = Tr[q] = Tr[Je] = Tr[K] = Tr[T] = Tr[D] = Tr[ne] = Tr[le] = Tr[$] = Tr[fe] = Tr[ue] = Tr[me] = Tr[Ge] = !1;
    var _r = {};
    _r[z] = _r[k] = _r[pe] = _r[Je] = _r[q] = _r[K] = _r[Ie] = _r[we] = _r[at] = _r[Oe] = _r[Ee] = _r[ne] = _r[le] = _r[$] = _r[fe] = _r[ue] = _r[me] = _r[be] = _r[ft] = _r[Le] = _r[Pe] = _r[Mt] = !0, _r[T] = _r[D] = _r[Ge] = !1;
    var he = {
      \u00C0: "A",
      \u00C1: "A",
      \u00C2: "A",
      \u00C3: "A",
      \u00C4: "A",
      \u00C5: "A",
      \u00E0: "a",
      \u00E1: "a",
      \u00E2: "a",
      \u00E3: "a",
      \u00E4: "a",
      \u00E5: "a",
      \u00C7: "C",
      \u00E7: "c",
      \u00D0: "D",
      \u00F0: "d",
      \u00C8: "E",
      \u00C9: "E",
      \u00CA: "E",
      \u00CB: "E",
      \u00E8: "e",
      \u00E9: "e",
      \u00EA: "e",
      \u00EB: "e",
      \u00CC: "I",
      \u00CD: "I",
      \u00CE: "I",
      \u00CF: "I",
      \u00EC: "i",
      \u00ED: "i",
      \u00EE: "i",
      \u00EF: "i",
      \u00D1: "N",
      \u00F1: "n",
      \u00D2: "O",
      \u00D3: "O",
      \u00D4: "O",
      \u00D5: "O",
      \u00D6: "O",
      \u00D8: "O",
      \u00F2: "o",
      \u00F3: "o",
      \u00F4: "o",
      \u00F5: "o",
      \u00F6: "o",
      \u00F8: "o",
      \u00D9: "U",
      \u00DA: "U",
      \u00DB: "U",
      \u00DC: "U",
      \u00F9: "u",
      \u00FA: "u",
      \u00FB: "u",
      \u00FC: "u",
      \u00DD: "Y",
      \u00FD: "y",
      \u00FF: "y",
      \u00C6: "Ae",
      \u00E6: "ae",
      \u00DE: "Th",
      \u00FE: "th",
      \u00DF: "ss",
      \u0100: "A",
      \u0102: "A",
      \u0104: "A",
      \u0101: "a",
      \u0103: "a",
      \u0105: "a",
      \u0106: "C",
      \u0108: "C",
      \u010A: "C",
      \u010C: "C",
      \u0107: "c",
      \u0109: "c",
      \u010B: "c",
      \u010D: "c",
      \u010E: "D",
      \u0110: "D",
      \u010F: "d",
      \u0111: "d",
      \u0112: "E",
      \u0114: "E",
      \u0116: "E",
      \u0118: "E",
      \u011A: "E",
      \u0113: "e",
      \u0115: "e",
      \u0117: "e",
      \u0119: "e",
      \u011B: "e",
      \u011C: "G",
      \u011E: "G",
      \u0120: "G",
      \u0122: "G",
      \u011D: "g",
      \u011F: "g",
      \u0121: "g",
      \u0123: "g",
      \u0124: "H",
      \u0126: "H",
      \u0125: "h",
      \u0127: "h",
      \u0128: "I",
      \u012A: "I",
      \u012C: "I",
      \u012E: "I",
      \u0130: "I",
      \u0129: "i",
      \u012B: "i",
      \u012D: "i",
      \u012F: "i",
      \u0131: "i",
      \u0134: "J",
      \u0135: "j",
      \u0136: "K",
      \u0137: "k",
      \u0138: "k",
      \u0139: "L",
      \u013B: "L",
      \u013D: "L",
      \u013F: "L",
      \u0141: "L",
      \u013A: "l",
      \u013C: "l",
      \u013E: "l",
      \u0140: "l",
      \u0142: "l",
      \u0143: "N",
      \u0145: "N",
      \u0147: "N",
      \u014A: "N",
      \u0144: "n",
      \u0146: "n",
      \u0148: "n",
      \u014B: "n",
      \u014C: "O",
      \u014E: "O",
      \u0150: "O",
      \u014D: "o",
      \u014F: "o",
      \u0151: "o",
      \u0154: "R",
      \u0156: "R",
      \u0158: "R",
      \u0155: "r",
      \u0157: "r",
      \u0159: "r",
      \u015A: "S",
      \u015C: "S",
      \u015E: "S",
      \u0160: "S",
      \u015B: "s",
      \u015D: "s",
      \u015F: "s",
      \u0161: "s",
      \u0162: "T",
      \u0164: "T",
      \u0166: "T",
      \u0163: "t",
      \u0165: "t",
      \u0167: "t",
      \u0168: "U",
      \u016A: "U",
      \u016C: "U",
      \u016E: "U",
      \u0170: "U",
      \u0172: "U",
      \u0169: "u",
      \u016B: "u",
      \u016D: "u",
      \u016F: "u",
      \u0171: "u",
      \u0173: "u",
      \u0174: "W",
      \u0175: "w",
      \u0176: "Y",
      \u0177: "y",
      \u0178: "Y",
      \u0179: "Z",
      \u017B: "Z",
      \u017D: "Z",
      \u017A: "z",
      \u017C: "z",
      \u017E: "z",
      \u0132: "IJ",
      \u0133: "ij",
      \u0152: "Oe",
      \u0153: "oe",
      \u0149: "'n",
      \u017F: "s"
    }, Me = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, tt = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, lt = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Nr = parseFloat, Lt = parseInt, kr = typeof nt == "object" && nt && nt.Object === Object && nt, ni = typeof self == "object" && self && self.Object === Object && self, ir = kr || ni || Function("return this")(), Dr = e && !e.nodeType && e, Xr = Dr && !0 && t && !t.nodeType && t, tn = Xr && Xr.exports === Dr, si = tn && kr.process, jr = function() {
      try {
        var _e = Xr && Xr.require && Xr.require("util").types;
        return _e || si && si.binding && si.binding("util");
      } catch {
      }
    }(), Ui = jr && jr.isArrayBuffer, hs = jr && jr.isDate, Rn = jr && jr.isMap, Os = jr && jr.isRegExp, hu = jr && jr.isSet, Eo = jr && jr.isTypedArray;
    function ui(_e, Ye, Ue) {
      switch (Ue.length) {
        case 0:
          return _e.call(Ye);
        case 1:
          return _e.call(Ye, Ue[0]);
        case 2:
          return _e.call(Ye, Ue[0], Ue[1]);
        case 3:
          return _e.call(Ye, Ue[0], Ue[1], Ue[2]);
      }
      return _e.apply(Ye, Ue);
    }
    function uN(_e, Ye, Ue, gt) {
      for (var Ot = -1, vr = _e == null ? 0 : _e.length; ++Ot < vr; ) {
        var oi = _e[Ot];
        Ye(gt, oi, Ue(oi), _e);
      }
      return gt;
    }
    function Ln(_e, Ye) {
      for (var Ue = -1, gt = _e == null ? 0 : _e.length; ++Ue < gt && Ye(_e[Ue], Ue, _e) !== !1; )
        ;
      return _e;
    }
    function hN(_e, Ye) {
      for (var Ue = _e == null ? 0 : _e.length; Ue-- && Ye(_e[Ue], Ue, _e) !== !1; )
        ;
      return _e;
    }
    function Vw(_e, Ye) {
      for (var Ue = -1, gt = _e == null ? 0 : _e.length; ++Ue < gt; )
        if (!Ye(_e[Ue], Ue, _e))
          return !1;
      return !0;
    }
    function Ba(_e, Ye) {
      for (var Ue = -1, gt = _e == null ? 0 : _e.length, Ot = 0, vr = []; ++Ue < gt; ) {
        var oi = _e[Ue];
        Ye(oi, Ue, _e) && (vr[Ot++] = oi);
      }
      return vr;
    }
    function Tl(_e, Ye) {
      var Ue = _e == null ? 0 : _e.length;
      return !!Ue && Df(_e, Ye, 0) > -1;
    }
    function m1(_e, Ye, Ue) {
      for (var gt = -1, Ot = _e == null ? 0 : _e.length; ++gt < Ot; )
        if (Ue(Ye, _e[gt]))
          return !0;
      return !1;
    }
    function Ur(_e, Ye) {
      for (var Ue = -1, gt = _e == null ? 0 : _e.length, Ot = Array(gt); ++Ue < gt; )
        Ot[Ue] = Ye(_e[Ue], Ue, _e);
      return Ot;
    }
    function za(_e, Ye) {
      for (var Ue = -1, gt = Ye.length, Ot = _e.length; ++Ue < gt; )
        _e[Ot + Ue] = Ye[Ue];
      return _e;
    }
    function w1(_e, Ye, Ue, gt) {
      var Ot = -1, vr = _e == null ? 0 : _e.length;
      for (gt && vr && (Ue = _e[++Ot]); ++Ot < vr; )
        Ue = Ye(Ue, _e[Ot], Ot, _e);
      return Ue;
    }
    function lN(_e, Ye, Ue, gt) {
      var Ot = _e == null ? 0 : _e.length;
      for (gt && Ot && (Ue = _e[--Ot]); Ot--; )
        Ue = Ye(Ue, _e[Ot], Ot, _e);
      return Ue;
    }
    function _1(_e, Ye) {
      for (var Ue = -1, gt = _e == null ? 0 : _e.length; ++Ue < gt; )
        if (Ye(_e[Ue], Ue, _e))
          return !0;
      return !1;
    }
    var dN = M1("length");
    function pN(_e) {
      return _e.split("");
    }
    function vN(_e) {
      return _e.match(mt) || [];
    }
    function Gw(_e, Ye, Ue) {
      var gt;
      return Ue(_e, function(Ot, vr, oi) {
        if (Ye(Ot, vr, oi))
          return gt = vr, !1;
      }), gt;
    }
    function Nl(_e, Ye, Ue, gt) {
      for (var Ot = _e.length, vr = Ue + (gt ? 1 : -1); gt ? vr-- : ++vr < Ot; )
        if (Ye(_e[vr], vr, _e))
          return vr;
      return -1;
    }
    function Df(_e, Ye, Ue) {
      return Ye === Ye ? AN(_e, Ye, Ue) : Nl(_e, Kw, Ue);
    }
    function gN(_e, Ye, Ue, gt) {
      for (var Ot = Ue - 1, vr = _e.length; ++Ot < vr; )
        if (gt(_e[Ot], Ye))
          return Ot;
      return -1;
    }
    function Kw(_e) {
      return _e !== _e;
    }
    function Yw(_e, Ye) {
      var Ue = _e == null ? 0 : _e.length;
      return Ue ? S1(_e, Ye) / Ue : E;
    }
    function M1(_e) {
      return function(Ye) {
        return Ye == null ? r : Ye[_e];
      };
    }
    function x1(_e) {
      return function(Ye) {
        return _e == null ? r : _e[Ye];
      };
    }
    function Qw(_e, Ye, Ue, gt, Ot) {
      return Ot(_e, function(vr, oi, Cr) {
        Ue = gt ? (gt = !1, vr) : Ye(Ue, vr, oi, Cr);
      }), Ue;
    }
    function bN(_e, Ye) {
      var Ue = _e.length;
      for (_e.sort(Ye); Ue--; )
        _e[Ue] = _e[Ue].value;
      return _e;
    }
    function S1(_e, Ye) {
      for (var Ue, gt = -1, Ot = _e.length; ++gt < Ot; ) {
        var vr = Ye(_e[gt]);
        vr !== r && (Ue = Ue === r ? vr : Ue + vr);
      }
      return Ue;
    }
    function E1(_e, Ye) {
      for (var Ue = -1, gt = Array(_e); ++Ue < _e; )
        gt[Ue] = Ye(Ue);
      return gt;
    }
    function yN(_e, Ye) {
      return Ur(Ye, function(Ue) {
        return [Ue, _e[Ue]];
      });
    }
    function Zw(_e) {
      return _e && _e.slice(0, t3(_e) + 1).replace($e, "");
    }
    function gn(_e) {
      return function(Ye) {
        return _e(Ye);
      };
    }
    function I1(_e, Ye) {
      return Ur(Ye, function(Ue) {
        return _e[Ue];
      });
    }
    function lu(_e, Ye) {
      return _e.has(Ye);
    }
    function Jw(_e, Ye) {
      for (var Ue = -1, gt = _e.length; ++Ue < gt && Df(Ye, _e[Ue], 0) > -1; )
        ;
      return Ue;
    }
    function Xw(_e, Ye) {
      for (var Ue = _e.length; Ue-- && Df(Ye, _e[Ue], 0) > -1; )
        ;
      return Ue;
    }
    function mN(_e, Ye) {
      for (var Ue = _e.length, gt = 0; Ue--; )
        _e[Ue] === Ye && ++gt;
      return gt;
    }
    var wN = x1(he), _N = x1(Me);
    function MN(_e) {
      return "\\" + lt[_e];
    }
    function xN(_e, Ye) {
      return _e == null ? r : _e[Ye];
    }
    function Cf(_e) {
      return Il.test(_e);
    }
    function SN(_e) {
      return So.test(_e);
    }
    function EN(_e) {
      for (var Ye, Ue = []; !(Ye = _e.next()).done; )
        Ue.push(Ye.value);
      return Ue;
    }
    function A1(_e) {
      var Ye = -1, Ue = Array(_e.size);
      return _e.forEach(function(gt, Ot) {
        Ue[++Ye] = [Ot, gt];
      }), Ue;
    }
    function e3(_e, Ye) {
      return function(Ue) {
        return _e(Ye(Ue));
      };
    }
    function Ua(_e, Ye) {
      for (var Ue = -1, gt = _e.length, Ot = 0, vr = []; ++Ue < gt; ) {
        var oi = _e[Ue];
        (oi === Ye || oi === l) && (_e[Ue] = l, vr[Ot++] = Ue);
      }
      return vr;
    }
    function Dl(_e) {
      var Ye = -1, Ue = Array(_e.size);
      return _e.forEach(function(gt) {
        Ue[++Ye] = gt;
      }), Ue;
    }
    function IN(_e) {
      var Ye = -1, Ue = Array(_e.size);
      return _e.forEach(function(gt) {
        Ue[++Ye] = [gt, gt];
      }), Ue;
    }
    function AN(_e, Ye, Ue) {
      for (var gt = Ue - 1, Ot = _e.length; ++gt < Ot; )
        if (_e[gt] === Ye)
          return gt;
      return -1;
    }
    function TN(_e, Ye, Ue) {
      for (var gt = Ue + 1; gt--; )
        if (_e[gt] === Ye)
          return gt;
      return gt;
    }
    function Of(_e) {
      return Cf(_e) ? DN(_e) : dN(_e);
    }
    function ls(_e) {
      return Cf(_e) ? CN(_e) : pN(_e);
    }
    function t3(_e) {
      for (var Ye = _e.length; Ye-- && De.test(_e.charAt(Ye)); )
        ;
      return Ye;
    }
    var NN = x1(tt);
    function DN(_e) {
      for (var Ye = Nf.lastIndex = 0; Nf.test(_e); )
        ++Ye;
      return Ye;
    }
    function CN(_e) {
      return _e.match(Nf) || [];
    }
    function ON(_e) {
      return _e.match(El) || [];
    }
    var RN = function _e(Ye) {
      Ye = Ye == null ? ir : Rf.defaults(ir.Object(), Ye, Rf.pick(ir, Al));
      var Ue = Ye.Array, gt = Ye.Date, Ot = Ye.Error, vr = Ye.Function, oi = Ye.Math, Cr = Ye.Object, T1 = Ye.RegExp, LN = Ye.String, Pn = Ye.TypeError, Cl = Ue.prototype, PN = vr.prototype, Lf = Cr.prototype, Ol = Ye["__core-js_shared__"], Rl = PN.toString, mr = Lf.hasOwnProperty, kN = 0, r3 = function() {
        var v = /[^.]+$/.exec(Ol && Ol.keys && Ol.keys.IE_PROTO || "");
        return v ? "Symbol(src)_1." + v : "";
      }(), Ll = Lf.toString, jN = Rl.call(Cr), BN = ir._, zN = T1(
        "^" + Rl.call(mr).replace(Ne, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Pl = tn ? Ye.Buffer : r, Fa = Ye.Symbol, kl = Ye.Uint8Array, i3 = Pl ? Pl.allocUnsafe : r, jl = e3(Cr.getPrototypeOf, Cr), n3 = Cr.create, s3 = Lf.propertyIsEnumerable, Bl = Cl.splice, a3 = Fa ? Fa.isConcatSpreadable : r, du = Fa ? Fa.iterator : r, Io = Fa ? Fa.toStringTag : r, zl = function() {
        try {
          var v = Co(Cr, "defineProperty");
          return v({}, "", {}), v;
        } catch {
        }
      }(), UN = Ye.clearTimeout !== ir.clearTimeout && Ye.clearTimeout, FN = gt && gt.now !== ir.Date.now && gt.now, $N = Ye.setTimeout !== ir.setTimeout && Ye.setTimeout, Ul = oi.ceil, Fl = oi.floor, N1 = Cr.getOwnPropertySymbols, qN = Pl ? Pl.isBuffer : r, o3 = Ye.isFinite, HN = Cl.join, WN = e3(Cr.keys, Cr), fi = oi.max, Ci = oi.min, VN = gt.now, GN = Ye.parseInt, f3 = oi.random, KN = Cl.reverse, D1 = Co(Ye, "DataView"), pu = Co(Ye, "Map"), C1 = Co(Ye, "Promise"), Pf = Co(Ye, "Set"), vu = Co(Ye, "WeakMap"), gu = Co(Cr, "create"), $l = vu && new vu(), kf = {}, YN = Oo(D1), QN = Oo(pu), ZN = Oo(C1), JN = Oo(Pf), XN = Oo(vu), ql = Fa ? Fa.prototype : r, bu = ql ? ql.valueOf : r, c3 = ql ? ql.toString : r;
      function oe(v) {
        if (Gr(v) && !Pt(v) && !(v instanceof er)) {
          if (v instanceof kn)
            return v;
          if (mr.call(v, "__wrapped__"))
            return u_(v);
        }
        return new kn(v);
      }
      var jf = function() {
        function v() {
        }
        return function(I) {
          if (!Hr(I))
            return {};
          if (n3)
            return n3(I);
          v.prototype = I;
          var L = new v();
          return v.prototype = r, L;
        };
      }();
      function Hl() {
      }
      function kn(v, I) {
        this.__wrapped__ = v, this.__actions__ = [], this.__chain__ = !!I, this.__index__ = 0, this.__values__ = r;
      }
      oe.templateSettings = {
        escape: Te,
        evaluate: pt,
        interpolate: Fe,
        variable: "",
        imports: {
          _: oe
        }
      }, oe.prototype = Hl.prototype, oe.prototype.constructor = oe, kn.prototype = jf(Hl.prototype), kn.prototype.constructor = kn;
      function er(v) {
        this.__wrapped__ = v, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = y, this.__views__ = [];
      }
      function eD() {
        var v = new er(this.__wrapped__);
        return v.__actions__ = rn(this.__actions__), v.__dir__ = this.__dir__, v.__filtered__ = this.__filtered__, v.__iteratees__ = rn(this.__iteratees__), v.__takeCount__ = this.__takeCount__, v.__views__ = rn(this.__views__), v;
      }
      function tD() {
        if (this.__filtered__) {
          var v = new er(this);
          v.__dir__ = -1, v.__filtered__ = !0;
        } else
          v = this.clone(), v.__dir__ *= -1;
        return v;
      }
      function rD() {
        var v = this.__wrapped__.value(), I = this.__dir__, L = Pt(v), G = I < 0, ie = L ? v.length : 0, ce = pC(0, ie, this.__views__), de = ce.start, ge = ce.end, xe = ge - de, Xe = G ? ge : de - 1, et = this.__iteratees__, rt = et.length, ut = 0, _t = Ci(xe, this.__takeCount__);
        if (!L || !G && ie == xe && _t == xe)
          return R3(v, this.__actions__);
        var Tt = [];
        e:
          for (; xe-- && ut < _t; ) {
            Xe += I;
            for (var $t = -1, Nt = v[Xe]; ++$t < rt; ) {
              var Kt = et[$t], nr = Kt.iteratee, mn = Kt.type, qi = nr(Nt);
              if (mn == c)
                Nt = qi;
              else if (!qi) {
                if (mn == a)
                  continue e;
                break e;
              }
            }
            Tt[ut++] = Nt;
          }
        return Tt;
      }
      er.prototype = jf(Hl.prototype), er.prototype.constructor = er;
      function Ao(v) {
        var I = -1, L = v == null ? 0 : v.length;
        for (this.clear(); ++I < L; ) {
          var G = v[I];
          this.set(G[0], G[1]);
        }
      }
      function iD() {
        this.__data__ = gu ? gu(null) : {}, this.size = 0;
      }
      function nD(v) {
        var I = this.has(v) && delete this.__data__[v];
        return this.size -= I ? 1 : 0, I;
      }
      function sD(v) {
        var I = this.__data__;
        if (gu) {
          var L = I[v];
          return L === h ? r : L;
        }
        return mr.call(I, v) ? I[v] : r;
      }
      function aD(v) {
        var I = this.__data__;
        return gu ? I[v] !== r : mr.call(I, v);
      }
      function oD(v, I) {
        var L = this.__data__;
        return this.size += this.has(v) ? 0 : 1, L[v] = gu && I === r ? h : I, this;
      }
      Ao.prototype.clear = iD, Ao.prototype.delete = nD, Ao.prototype.get = sD, Ao.prototype.has = aD, Ao.prototype.set = oD;
      function la(v) {
        var I = -1, L = v == null ? 0 : v.length;
        for (this.clear(); ++I < L; ) {
          var G = v[I];
          this.set(G[0], G[1]);
        }
      }
      function fD() {
        this.__data__ = [], this.size = 0;
      }
      function cD(v) {
        var I = this.__data__, L = Wl(I, v);
        if (L < 0)
          return !1;
        var G = I.length - 1;
        return L == G ? I.pop() : Bl.call(I, L, 1), --this.size, !0;
      }
      function uD(v) {
        var I = this.__data__, L = Wl(I, v);
        return L < 0 ? r : I[L][1];
      }
      function hD(v) {
        return Wl(this.__data__, v) > -1;
      }
      function lD(v, I) {
        var L = this.__data__, G = Wl(L, v);
        return G < 0 ? (++this.size, L.push([v, I])) : L[G][1] = I, this;
      }
      la.prototype.clear = fD, la.prototype.delete = cD, la.prototype.get = uD, la.prototype.has = hD, la.prototype.set = lD;
      function da(v) {
        var I = -1, L = v == null ? 0 : v.length;
        for (this.clear(); ++I < L; ) {
          var G = v[I];
          this.set(G[0], G[1]);
        }
      }
      function dD() {
        this.size = 0, this.__data__ = {
          hash: new Ao(),
          map: new (pu || la)(),
          string: new Ao()
        };
      }
      function pD(v) {
        var I = id(this, v).delete(v);
        return this.size -= I ? 1 : 0, I;
      }
      function vD(v) {
        return id(this, v).get(v);
      }
      function gD(v) {
        return id(this, v).has(v);
      }
      function bD(v, I) {
        var L = id(this, v), G = L.size;
        return L.set(v, I), this.size += L.size == G ? 0 : 1, this;
      }
      da.prototype.clear = dD, da.prototype.delete = pD, da.prototype.get = vD, da.prototype.has = gD, da.prototype.set = bD;
      function To(v) {
        var I = -1, L = v == null ? 0 : v.length;
        for (this.__data__ = new da(); ++I < L; )
          this.add(v[I]);
      }
      function yD(v) {
        return this.__data__.set(v, h), this;
      }
      function mD(v) {
        return this.__data__.has(v);
      }
      To.prototype.add = To.prototype.push = yD, To.prototype.has = mD;
      function ds(v) {
        var I = this.__data__ = new la(v);
        this.size = I.size;
      }
      function wD() {
        this.__data__ = new la(), this.size = 0;
      }
      function _D(v) {
        var I = this.__data__, L = I.delete(v);
        return this.size = I.size, L;
      }
      function MD(v) {
        return this.__data__.get(v);
      }
      function xD(v) {
        return this.__data__.has(v);
      }
      function SD(v, I) {
        var L = this.__data__;
        if (L instanceof la) {
          var G = L.__data__;
          if (!pu || G.length < s - 1)
            return G.push([v, I]), this.size = ++L.size, this;
          L = this.__data__ = new da(G);
        }
        return L.set(v, I), this.size = L.size, this;
      }
      ds.prototype.clear = wD, ds.prototype.delete = _D, ds.prototype.get = MD, ds.prototype.has = xD, ds.prototype.set = SD;
      function u3(v, I) {
        var L = Pt(v), G = !L && Ro(v), ie = !L && !G && Va(v), ce = !L && !G && !ie && Ff(v), de = L || G || ie || ce, ge = de ? E1(v.length, LN) : [], xe = ge.length;
        for (var Xe in v)
          (I || mr.call(v, Xe)) && !(de && (Xe == "length" || ie && (Xe == "offset" || Xe == "parent") || ce && (Xe == "buffer" || Xe == "byteLength" || Xe == "byteOffset") || ba(Xe, xe))) && ge.push(Xe);
        return ge;
      }
      function h3(v) {
        var I = v.length;
        return I ? v[$1(0, I - 1)] : r;
      }
      function ED(v, I) {
        return nd(rn(v), No(I, 0, v.length));
      }
      function ID(v) {
        return nd(rn(v));
      }
      function O1(v, I, L) {
        (L !== r && !ps(v[I], L) || L === r && !(I in v)) && pa(v, I, L);
      }
      function yu(v, I, L) {
        var G = v[I];
        (!(mr.call(v, I) && ps(G, L)) || L === r && !(I in v)) && pa(v, I, L);
      }
      function Wl(v, I) {
        for (var L = v.length; L--; )
          if (ps(v[L][0], I))
            return L;
        return -1;
      }
      function AD(v, I, L, G) {
        return $a(v, function(ie, ce, de) {
          I(G, ie, L(ie), de);
        }), G;
      }
      function l3(v, I) {
        return v && Ls(I, hi(I), v);
      }
      function TD(v, I) {
        return v && Ls(I, sn(I), v);
      }
      function pa(v, I, L) {
        I == "__proto__" && zl ? zl(v, I, {
          configurable: !0,
          enumerable: !0,
          value: L,
          writable: !0
        }) : v[I] = L;
      }
      function R1(v, I) {
        for (var L = -1, G = I.length, ie = Ue(G), ce = v == null; ++L < G; )
          ie[L] = ce ? r : dv(v, I[L]);
        return ie;
      }
      function No(v, I, L) {
        return v === v && (L !== r && (v = v <= L ? v : L), I !== r && (v = v >= I ? v : I)), v;
      }
      function jn(v, I, L, G, ie, ce) {
        var de, ge = I & m, xe = I & b, Xe = I & M;
        if (L && (de = ie ? L(v, G, ie, ce) : L(v)), de !== r)
          return de;
        if (!Hr(v))
          return v;
        var et = Pt(v);
        if (et) {
          if (de = gC(v), !ge)
            return rn(v, de);
        } else {
          var rt = Oi(v), ut = rt == D || rt == te;
          if (Va(v))
            return k3(v, ge);
          if (rt == $ || rt == z || ut && !ie) {
            if (de = xe || ut ? {} : t_(v), !ge)
              return xe ? sC(v, TD(de, v)) : nC(v, l3(de, v));
          } else {
            if (!_r[rt])
              return ie ? v : {};
            de = bC(v, rt, ge);
          }
        }
        ce || (ce = new ds());
        var _t = ce.get(v);
        if (_t)
          return _t;
        ce.set(v, de), D_(v) ? v.forEach(function(Nt) {
          de.add(jn(Nt, I, L, Nt, v, ce));
        }) : T_(v) && v.forEach(function(Nt, Kt) {
          de.set(Kt, jn(Nt, I, L, Kt, v, ce));
        });
        var Tt = Xe ? xe ? X1 : J1 : xe ? sn : hi, $t = et ? r : Tt(v);
        return Ln($t || v, function(Nt, Kt) {
          $t && (Kt = Nt, Nt = v[Kt]), yu(de, Kt, jn(Nt, I, L, Kt, v, ce));
        }), de;
      }
      function ND(v) {
        var I = hi(v);
        return function(L) {
          return d3(L, v, I);
        };
      }
      function d3(v, I, L) {
        var G = L.length;
        if (v == null)
          return !G;
        for (v = Cr(v); G--; ) {
          var ie = L[G], ce = I[ie], de = v[ie];
          if (de === r && !(ie in v) || !ce(de))
            return !1;
        }
        return !0;
      }
      function p3(v, I, L) {
        if (typeof v != "function")
          throw new Pn(f);
        return Eu(function() {
          v.apply(r, L);
        }, I);
      }
      function mu(v, I, L, G) {
        var ie = -1, ce = Tl, de = !0, ge = v.length, xe = [], Xe = I.length;
        if (!ge)
          return xe;
        L && (I = Ur(I, gn(L))), G ? (ce = m1, de = !1) : I.length >= s && (ce = lu, de = !1, I = new To(I));
        e:
          for (; ++ie < ge; ) {
            var et = v[ie], rt = L == null ? et : L(et);
            if (et = G || et !== 0 ? et : 0, de && rt === rt) {
              for (var ut = Xe; ut--; )
                if (I[ut] === rt)
                  continue e;
              xe.push(et);
            } else
              ce(I, rt, G) || xe.push(et);
          }
        return xe;
      }
      var $a = F3(Rs), v3 = F3(P1, !0);
      function DD(v, I) {
        var L = !0;
        return $a(v, function(G, ie, ce) {
          return L = !!I(G, ie, ce), L;
        }), L;
      }
      function Vl(v, I, L) {
        for (var G = -1, ie = v.length; ++G < ie; ) {
          var ce = v[G], de = I(ce);
          if (de != null && (ge === r ? de === de && !yn(de) : L(de, ge)))
            var ge = de, xe = ce;
        }
        return xe;
      }
      function CD(v, I, L, G) {
        var ie = v.length;
        for (L = zt(L), L < 0 && (L = -L > ie ? 0 : ie + L), G = G === r || G > ie ? ie : zt(G), G < 0 && (G += ie), G = L > G ? 0 : O_(G); L < G; )
          v[L++] = I;
        return v;
      }
      function g3(v, I) {
        var L = [];
        return $a(v, function(G, ie, ce) {
          I(G, ie, ce) && L.push(G);
        }), L;
      }
      function xi(v, I, L, G, ie) {
        var ce = -1, de = v.length;
        for (L || (L = mC), ie || (ie = []); ++ce < de; ) {
          var ge = v[ce];
          I > 0 && L(ge) ? I > 1 ? xi(ge, I - 1, L, G, ie) : za(ie, ge) : G || (ie[ie.length] = ge);
        }
        return ie;
      }
      var L1 = $3(), b3 = $3(!0);
      function Rs(v, I) {
        return v && L1(v, I, hi);
      }
      function P1(v, I) {
        return v && b3(v, I, hi);
      }
      function Gl(v, I) {
        return Ba(I, function(L) {
          return ya(v[L]);
        });
      }
      function Do(v, I) {
        I = Ha(I, v);
        for (var L = 0, G = I.length; v != null && L < G; )
          v = v[Ps(I[L++])];
        return L && L == G ? v : r;
      }
      function y3(v, I, L) {
        var G = I(v);
        return Pt(v) ? G : za(G, L(v));
      }
      function Fi(v) {
        return v == null ? v === r ? ve : X : Io && Io in Cr(v) ? dC(v) : IC(v);
      }
      function k1(v, I) {
        return v > I;
      }
      function OD(v, I) {
        return v != null && mr.call(v, I);
      }
      function RD(v, I) {
        return v != null && I in Cr(v);
      }
      function LD(v, I, L) {
        return v >= Ci(I, L) && v < fi(I, L);
      }
      function j1(v, I, L) {
        for (var G = L ? m1 : Tl, ie = v[0].length, ce = v.length, de = ce, ge = Ue(ce), xe = 1 / 0, Xe = []; de--; ) {
          var et = v[de];
          de && I && (et = Ur(et, gn(I))), xe = Ci(et.length, xe), ge[de] = !L && (I || ie >= 120 && et.length >= 120) ? new To(de && et) : r;
        }
        et = v[0];
        var rt = -1, ut = ge[0];
        e:
          for (; ++rt < ie && Xe.length < xe; ) {
            var _t = et[rt], Tt = I ? I(_t) : _t;
            if (_t = L || _t !== 0 ? _t : 0, !(ut ? lu(ut, Tt) : G(Xe, Tt, L))) {
              for (de = ce; --de; ) {
                var $t = ge[de];
                if (!($t ? lu($t, Tt) : G(v[de], Tt, L)))
                  continue e;
              }
              ut && ut.push(Tt), Xe.push(_t);
            }
          }
        return Xe;
      }
      function PD(v, I, L, G) {
        return Rs(v, function(ie, ce, de) {
          I(G, L(ie), ce, de);
        }), G;
      }
      function wu(v, I, L) {
        I = Ha(I, v), v = s_(v, I);
        var G = v == null ? v : v[Ps(zn(I))];
        return G == null ? r : ui(G, v, L);
      }
      function m3(v) {
        return Gr(v) && Fi(v) == z;
      }
      function kD(v) {
        return Gr(v) && Fi(v) == pe;
      }
      function jD(v) {
        return Gr(v) && Fi(v) == K;
      }
      function _u(v, I, L, G, ie) {
        return v === I ? !0 : v == null || I == null || !Gr(v) && !Gr(I) ? v !== v && I !== I : BD(v, I, L, G, _u, ie);
      }
      function BD(v, I, L, G, ie, ce) {
        var de = Pt(v), ge = Pt(I), xe = de ? k : Oi(v), Xe = ge ? k : Oi(I);
        xe = xe == z ? $ : xe, Xe = Xe == z ? $ : Xe;
        var et = xe == $, rt = Xe == $, ut = xe == Xe;
        if (ut && Va(v)) {
          if (!Va(I))
            return !1;
          de = !0, et = !1;
        }
        if (ut && !et)
          return ce || (ce = new ds()), de || Ff(v) ? J3(v, I, L, G, ie, ce) : hC(v, I, xe, L, G, ie, ce);
        if (!(L & A)) {
          var _t = et && mr.call(v, "__wrapped__"), Tt = rt && mr.call(I, "__wrapped__");
          if (_t || Tt) {
            var $t = _t ? v.value() : v, Nt = Tt ? I.value() : I;
            return ce || (ce = new ds()), ie($t, Nt, L, G, ce);
          }
        }
        return ut ? (ce || (ce = new ds()), lC(v, I, L, G, ie, ce)) : !1;
      }
      function zD(v) {
        return Gr(v) && Oi(v) == ne;
      }
      function B1(v, I, L, G) {
        var ie = L.length, ce = ie, de = !G;
        if (v == null)
          return !ce;
        for (v = Cr(v); ie--; ) {
          var ge = L[ie];
          if (de && ge[2] ? ge[1] !== v[ge[0]] : !(ge[0] in v))
            return !1;
        }
        for (; ++ie < ce; ) {
          ge = L[ie];
          var xe = ge[0], Xe = v[xe], et = ge[1];
          if (de && ge[2]) {
            if (Xe === r && !(xe in v))
              return !1;
          } else {
            var rt = new ds();
            if (G)
              var ut = G(Xe, et, xe, v, I, rt);
            if (!(ut === r ? _u(et, Xe, A | N, G, rt) : ut))
              return !1;
          }
        }
        return !0;
      }
      function w3(v) {
        if (!Hr(v) || _C(v))
          return !1;
        var I = ya(v) ? zN : Zt;
        return I.test(Oo(v));
      }
      function UD(v) {
        return Gr(v) && Fi(v) == fe;
      }
      function FD(v) {
        return Gr(v) && Oi(v) == ue;
      }
      function $D(v) {
        return Gr(v) && ud(v.length) && !!Tr[Fi(v)];
      }
      function _3(v) {
        return typeof v == "function" ? v : v == null ? an : typeof v == "object" ? Pt(v) ? S3(v[0], v[1]) : x3(v) : q_(v);
      }
      function z1(v) {
        if (!Su(v))
          return WN(v);
        var I = [];
        for (var L in Cr(v))
          mr.call(v, L) && L != "constructor" && I.push(L);
        return I;
      }
      function qD(v) {
        if (!Hr(v))
          return EC(v);
        var I = Su(v), L = [];
        for (var G in v)
          G == "constructor" && (I || !mr.call(v, G)) || L.push(G);
        return L;
      }
      function U1(v, I) {
        return v < I;
      }
      function M3(v, I) {
        var L = -1, G = nn(v) ? Ue(v.length) : [];
        return $a(v, function(ie, ce, de) {
          G[++L] = I(ie, ce, de);
        }), G;
      }
      function x3(v) {
        var I = tv(v);
        return I.length == 1 && I[0][2] ? i_(I[0][0], I[0][1]) : function(L) {
          return L === v || B1(L, v, I);
        };
      }
      function S3(v, I) {
        return iv(v) && r_(I) ? i_(Ps(v), I) : function(L) {
          var G = dv(L, v);
          return G === r && G === I ? pv(L, v) : _u(I, G, A | N);
        };
      }
      function Kl(v, I, L, G, ie) {
        v !== I && L1(I, function(ce, de) {
          if (ie || (ie = new ds()), Hr(ce))
            HD(v, I, de, L, Kl, G, ie);
          else {
            var ge = G ? G(sv(v, de), ce, de + "", v, I, ie) : r;
            ge === r && (ge = ce), O1(v, de, ge);
          }
        }, sn);
      }
      function HD(v, I, L, G, ie, ce, de) {
        var ge = sv(v, L), xe = sv(I, L), Xe = de.get(xe);
        if (Xe) {
          O1(v, L, Xe);
          return;
        }
        var et = ce ? ce(ge, xe, L + "", v, I, de) : r, rt = et === r;
        if (rt) {
          var ut = Pt(xe), _t = !ut && Va(xe), Tt = !ut && !_t && Ff(xe);
          et = xe, ut || _t || Tt ? Pt(ge) ? et = ge : ei(ge) ? et = rn(ge) : _t ? (rt = !1, et = k3(xe, !0)) : Tt ? (rt = !1, et = j3(xe, !0)) : et = [] : Iu(xe) || Ro(xe) ? (et = ge, Ro(ge) ? et = R_(ge) : (!Hr(ge) || ya(ge)) && (et = t_(xe))) : rt = !1;
        }
        rt && (de.set(xe, et), ie(et, xe, G, ce, de), de.delete(xe)), O1(v, L, et);
      }
      function E3(v, I) {
        var L = v.length;
        if (!!L)
          return I += I < 0 ? L : 0, ba(I, L) ? v[I] : r;
      }
      function I3(v, I, L) {
        I.length ? I = Ur(I, function(ce) {
          return Pt(ce) ? function(de) {
            return Do(de, ce.length === 1 ? ce[0] : ce);
          } : ce;
        }) : I = [an];
        var G = -1;
        I = Ur(I, gn(At()));
        var ie = M3(v, function(ce, de, ge) {
          var xe = Ur(I, function(Xe) {
            return Xe(ce);
          });
          return { criteria: xe, index: ++G, value: ce };
        });
        return bN(ie, function(ce, de) {
          return iC(ce, de, L);
        });
      }
      function WD(v, I) {
        return A3(v, I, function(L, G) {
          return pv(v, G);
        });
      }
      function A3(v, I, L) {
        for (var G = -1, ie = I.length, ce = {}; ++G < ie; ) {
          var de = I[G], ge = Do(v, de);
          L(ge, de) && Mu(ce, Ha(de, v), ge);
        }
        return ce;
      }
      function VD(v) {
        return function(I) {
          return Do(I, v);
        };
      }
      function F1(v, I, L, G) {
        var ie = G ? gN : Df, ce = -1, de = I.length, ge = v;
        for (v === I && (I = rn(I)), L && (ge = Ur(v, gn(L))); ++ce < de; )
          for (var xe = 0, Xe = I[ce], et = L ? L(Xe) : Xe; (xe = ie(ge, et, xe, G)) > -1; )
            ge !== v && Bl.call(ge, xe, 1), Bl.call(v, xe, 1);
        return v;
      }
      function T3(v, I) {
        for (var L = v ? I.length : 0, G = L - 1; L--; ) {
          var ie = I[L];
          if (L == G || ie !== ce) {
            var ce = ie;
            ba(ie) ? Bl.call(v, ie, 1) : W1(v, ie);
          }
        }
        return v;
      }
      function $1(v, I) {
        return v + Fl(f3() * (I - v + 1));
      }
      function GD(v, I, L, G) {
        for (var ie = -1, ce = fi(Ul((I - v) / (L || 1)), 0), de = Ue(ce); ce--; )
          de[G ? ce : ++ie] = v, v += L;
        return de;
      }
      function q1(v, I) {
        var L = "";
        if (!v || I < 1 || I > _)
          return L;
        do
          I % 2 && (L += v), I = Fl(I / 2), I && (v += v);
        while (I);
        return L;
      }
      function Ht(v, I) {
        return av(n_(v, I, an), v + "");
      }
      function KD(v) {
        return h3($f(v));
      }
      function YD(v, I) {
        var L = $f(v);
        return nd(L, No(I, 0, L.length));
      }
      function Mu(v, I, L, G) {
        if (!Hr(v))
          return v;
        I = Ha(I, v);
        for (var ie = -1, ce = I.length, de = ce - 1, ge = v; ge != null && ++ie < ce; ) {
          var xe = Ps(I[ie]), Xe = L;
          if (xe === "__proto__" || xe === "constructor" || xe === "prototype")
            return v;
          if (ie != de) {
            var et = ge[xe];
            Xe = G ? G(et, xe, ge) : r, Xe === r && (Xe = Hr(et) ? et : ba(I[ie + 1]) ? [] : {});
          }
          yu(ge, xe, Xe), ge = ge[xe];
        }
        return v;
      }
      var N3 = $l ? function(v, I) {
        return $l.set(v, I), v;
      } : an, QD = zl ? function(v, I) {
        return zl(v, "toString", {
          configurable: !0,
          enumerable: !1,
          value: gv(I),
          writable: !0
        });
      } : an;
      function ZD(v) {
        return nd($f(v));
      }
      function Bn(v, I, L) {
        var G = -1, ie = v.length;
        I < 0 && (I = -I > ie ? 0 : ie + I), L = L > ie ? ie : L, L < 0 && (L += ie), ie = I > L ? 0 : L - I >>> 0, I >>>= 0;
        for (var ce = Ue(ie); ++G < ie; )
          ce[G] = v[G + I];
        return ce;
      }
      function JD(v, I) {
        var L;
        return $a(v, function(G, ie, ce) {
          return L = I(G, ie, ce), !L;
        }), !!L;
      }
      function Yl(v, I, L) {
        var G = 0, ie = v == null ? G : v.length;
        if (typeof I == "number" && I === I && ie <= S) {
          for (; G < ie; ) {
            var ce = G + ie >>> 1, de = v[ce];
            de !== null && !yn(de) && (L ? de <= I : de < I) ? G = ce + 1 : ie = ce;
          }
          return ie;
        }
        return H1(v, I, an, L);
      }
      function H1(v, I, L, G) {
        var ie = 0, ce = v == null ? 0 : v.length;
        if (ce === 0)
          return 0;
        I = L(I);
        for (var de = I !== I, ge = I === null, xe = yn(I), Xe = I === r; ie < ce; ) {
          var et = Fl((ie + ce) / 2), rt = L(v[et]), ut = rt !== r, _t = rt === null, Tt = rt === rt, $t = yn(rt);
          if (de)
            var Nt = G || Tt;
          else
            Xe ? Nt = Tt && (G || ut) : ge ? Nt = Tt && ut && (G || !_t) : xe ? Nt = Tt && ut && !_t && (G || !$t) : _t || $t ? Nt = !1 : Nt = G ? rt <= I : rt < I;
          Nt ? ie = et + 1 : ce = et;
        }
        return Ci(ce, o);
      }
      function D3(v, I) {
        for (var L = -1, G = v.length, ie = 0, ce = []; ++L < G; ) {
          var de = v[L], ge = I ? I(de) : de;
          if (!L || !ps(ge, xe)) {
            var xe = ge;
            ce[ie++] = de === 0 ? 0 : de;
          }
        }
        return ce;
      }
      function C3(v) {
        return typeof v == "number" ? v : yn(v) ? E : +v;
      }
      function bn(v) {
        if (typeof v == "string")
          return v;
        if (Pt(v))
          return Ur(v, bn) + "";
        if (yn(v))
          return c3 ? c3.call(v) : "";
        var I = v + "";
        return I == "0" && 1 / v == -w ? "-0" : I;
      }
      function qa(v, I, L) {
        var G = -1, ie = Tl, ce = v.length, de = !0, ge = [], xe = ge;
        if (L)
          de = !1, ie = m1;
        else if (ce >= s) {
          var Xe = I ? null : cC(v);
          if (Xe)
            return Dl(Xe);
          de = !1, ie = lu, xe = new To();
        } else
          xe = I ? [] : ge;
        e:
          for (; ++G < ce; ) {
            var et = v[G], rt = I ? I(et) : et;
            if (et = L || et !== 0 ? et : 0, de && rt === rt) {
              for (var ut = xe.length; ut--; )
                if (xe[ut] === rt)
                  continue e;
              I && xe.push(rt), ge.push(et);
            } else
              ie(xe, rt, L) || (xe !== ge && xe.push(rt), ge.push(et));
          }
        return ge;
      }
      function W1(v, I) {
        return I = Ha(I, v), v = s_(v, I), v == null || delete v[Ps(zn(I))];
      }
      function O3(v, I, L, G) {
        return Mu(v, I, L(Do(v, I)), G);
      }
      function Ql(v, I, L, G) {
        for (var ie = v.length, ce = G ? ie : -1; (G ? ce-- : ++ce < ie) && I(v[ce], ce, v); )
          ;
        return L ? Bn(v, G ? 0 : ce, G ? ce + 1 : ie) : Bn(v, G ? ce + 1 : 0, G ? ie : ce);
      }
      function R3(v, I) {
        var L = v;
        return L instanceof er && (L = L.value()), w1(I, function(G, ie) {
          return ie.func.apply(ie.thisArg, za([G], ie.args));
        }, L);
      }
      function V1(v, I, L) {
        var G = v.length;
        if (G < 2)
          return G ? qa(v[0]) : [];
        for (var ie = -1, ce = Ue(G); ++ie < G; )
          for (var de = v[ie], ge = -1; ++ge < G; )
            ge != ie && (ce[ie] = mu(ce[ie] || de, v[ge], I, L));
        return qa(xi(ce, 1), I, L);
      }
      function L3(v, I, L) {
        for (var G = -1, ie = v.length, ce = I.length, de = {}; ++G < ie; ) {
          var ge = G < ce ? I[G] : r;
          L(de, v[G], ge);
        }
        return de;
      }
      function G1(v) {
        return ei(v) ? v : [];
      }
      function K1(v) {
        return typeof v == "function" ? v : an;
      }
      function Ha(v, I) {
        return Pt(v) ? v : iv(v, I) ? [v] : c_(gr(v));
      }
      var XD = Ht;
      function Wa(v, I, L) {
        var G = v.length;
        return L = L === r ? G : L, !I && L >= G ? v : Bn(v, I, L);
      }
      var P3 = UN || function(v) {
        return ir.clearTimeout(v);
      };
      function k3(v, I) {
        if (I)
          return v.slice();
        var L = v.length, G = i3 ? i3(L) : new v.constructor(L);
        return v.copy(G), G;
      }
      function Y1(v) {
        var I = new v.constructor(v.byteLength);
        return new kl(I).set(new kl(v)), I;
      }
      function eC(v, I) {
        var L = I ? Y1(v.buffer) : v.buffer;
        return new v.constructor(L, v.byteOffset, v.byteLength);
      }
      function tC(v) {
        var I = new v.constructor(v.source, We.exec(v));
        return I.lastIndex = v.lastIndex, I;
      }
      function rC(v) {
        return bu ? Cr(bu.call(v)) : {};
      }
      function j3(v, I) {
        var L = I ? Y1(v.buffer) : v.buffer;
        return new v.constructor(L, v.byteOffset, v.length);
      }
      function B3(v, I) {
        if (v !== I) {
          var L = v !== r, G = v === null, ie = v === v, ce = yn(v), de = I !== r, ge = I === null, xe = I === I, Xe = yn(I);
          if (!ge && !Xe && !ce && v > I || ce && de && xe && !ge && !Xe || G && de && xe || !L && xe || !ie)
            return 1;
          if (!G && !ce && !Xe && v < I || Xe && L && ie && !G && !ce || ge && L && ie || !de && ie || !xe)
            return -1;
        }
        return 0;
      }
      function iC(v, I, L) {
        for (var G = -1, ie = v.criteria, ce = I.criteria, de = ie.length, ge = L.length; ++G < de; ) {
          var xe = B3(ie[G], ce[G]);
          if (xe) {
            if (G >= ge)
              return xe;
            var Xe = L[G];
            return xe * (Xe == "desc" ? -1 : 1);
          }
        }
        return v.index - I.index;
      }
      function z3(v, I, L, G) {
        for (var ie = -1, ce = v.length, de = L.length, ge = -1, xe = I.length, Xe = fi(ce - de, 0), et = Ue(xe + Xe), rt = !G; ++ge < xe; )
          et[ge] = I[ge];
        for (; ++ie < de; )
          (rt || ie < ce) && (et[L[ie]] = v[ie]);
        for (; Xe--; )
          et[ge++] = v[ie++];
        return et;
      }
      function U3(v, I, L, G) {
        for (var ie = -1, ce = v.length, de = -1, ge = L.length, xe = -1, Xe = I.length, et = fi(ce - ge, 0), rt = Ue(et + Xe), ut = !G; ++ie < et; )
          rt[ie] = v[ie];
        for (var _t = ie; ++xe < Xe; )
          rt[_t + xe] = I[xe];
        for (; ++de < ge; )
          (ut || ie < ce) && (rt[_t + L[de]] = v[ie++]);
        return rt;
      }
      function rn(v, I) {
        var L = -1, G = v.length;
        for (I || (I = Ue(G)); ++L < G; )
          I[L] = v[L];
        return I;
      }
      function Ls(v, I, L, G) {
        var ie = !L;
        L || (L = {});
        for (var ce = -1, de = I.length; ++ce < de; ) {
          var ge = I[ce], xe = G ? G(L[ge], v[ge], ge, L, v) : r;
          xe === r && (xe = v[ge]), ie ? pa(L, ge, xe) : yu(L, ge, xe);
        }
        return L;
      }
      function nC(v, I) {
        return Ls(v, rv(v), I);
      }
      function sC(v, I) {
        return Ls(v, X3(v), I);
      }
      function Zl(v, I) {
        return function(L, G) {
          var ie = Pt(L) ? uN : AD, ce = I ? I() : {};
          return ie(L, v, At(G, 2), ce);
        };
      }
      function Bf(v) {
        return Ht(function(I, L) {
          var G = -1, ie = L.length, ce = ie > 1 ? L[ie - 1] : r, de = ie > 2 ? L[2] : r;
          for (ce = v.length > 3 && typeof ce == "function" ? (ie--, ce) : r, de && $i(L[0], L[1], de) && (ce = ie < 3 ? r : ce, ie = 1), I = Cr(I); ++G < ie; ) {
            var ge = L[G];
            ge && v(I, ge, G, ce);
          }
          return I;
        });
      }
      function F3(v, I) {
        return function(L, G) {
          if (L == null)
            return L;
          if (!nn(L))
            return v(L, G);
          for (var ie = L.length, ce = I ? ie : -1, de = Cr(L); (I ? ce-- : ++ce < ie) && G(de[ce], ce, de) !== !1; )
            ;
          return L;
        };
      }
      function $3(v) {
        return function(I, L, G) {
          for (var ie = -1, ce = Cr(I), de = G(I), ge = de.length; ge--; ) {
            var xe = de[v ? ge : ++ie];
            if (L(ce[xe], xe, ce) === !1)
              break;
          }
          return I;
        };
      }
      function aC(v, I, L) {
        var G = I & R, ie = xu(v);
        function ce() {
          var de = this && this !== ir && this instanceof ce ? ie : v;
          return de.apply(G ? L : this, arguments);
        }
        return ce;
      }
      function q3(v) {
        return function(I) {
          I = gr(I);
          var L = Cf(I) ? ls(I) : r, G = L ? L[0] : I.charAt(0), ie = L ? Wa(L, 1).join("") : I.slice(1);
          return G[v]() + ie;
        };
      }
      function zf(v) {
        return function(I) {
          return w1(F_(U_(I).replace(uu, "")), v, "");
        };
      }
      function xu(v) {
        return function() {
          var I = arguments;
          switch (I.length) {
            case 0:
              return new v();
            case 1:
              return new v(I[0]);
            case 2:
              return new v(I[0], I[1]);
            case 3:
              return new v(I[0], I[1], I[2]);
            case 4:
              return new v(I[0], I[1], I[2], I[3]);
            case 5:
              return new v(I[0], I[1], I[2], I[3], I[4]);
            case 6:
              return new v(I[0], I[1], I[2], I[3], I[4], I[5]);
            case 7:
              return new v(I[0], I[1], I[2], I[3], I[4], I[5], I[6]);
          }
          var L = jf(v.prototype), G = v.apply(L, I);
          return Hr(G) ? G : L;
        };
      }
      function oC(v, I, L) {
        var G = xu(v);
        function ie() {
          for (var ce = arguments.length, de = Ue(ce), ge = ce, xe = Uf(ie); ge--; )
            de[ge] = arguments[ge];
          var Xe = ce < 3 && de[0] !== xe && de[ce - 1] !== xe ? [] : Ua(de, xe);
          if (ce -= Xe.length, ce < L)
            return K3(
              v,
              I,
              Jl,
              ie.placeholder,
              r,
              de,
              Xe,
              r,
              r,
              L - ce
            );
          var et = this && this !== ir && this instanceof ie ? G : v;
          return ui(et, this, de);
        }
        return ie;
      }
      function H3(v) {
        return function(I, L, G) {
          var ie = Cr(I);
          if (!nn(I)) {
            var ce = At(L, 3);
            I = hi(I), L = function(ge) {
              return ce(ie[ge], ge, ie);
            };
          }
          var de = v(I, L, G);
          return de > -1 ? ie[ce ? I[de] : de] : r;
        };
      }
      function W3(v) {
        return ga(function(I) {
          var L = I.length, G = L, ie = kn.prototype.thru;
          for (v && I.reverse(); G--; ) {
            var ce = I[G];
            if (typeof ce != "function")
              throw new Pn(f);
            if (ie && !de && rd(ce) == "wrapper")
              var de = new kn([], !0);
          }
          for (G = de ? G : L; ++G < L; ) {
            ce = I[G];
            var ge = rd(ce), xe = ge == "wrapper" ? ev(ce) : r;
            xe && nv(xe[0]) && xe[1] == (B | F | Q | Y) && !xe[4].length && xe[9] == 1 ? de = de[rd(xe[0])].apply(de, xe[3]) : de = ce.length == 1 && nv(ce) ? de[ge]() : de.thru(ce);
          }
          return function() {
            var Xe = arguments, et = Xe[0];
            if (de && Xe.length == 1 && Pt(et))
              return de.plant(et).value();
            for (var rt = 0, ut = L ? I[rt].apply(this, Xe) : et; ++rt < L; )
              ut = I[rt].call(this, ut);
            return ut;
          };
        });
      }
      function Jl(v, I, L, G, ie, ce, de, ge, xe, Xe) {
        var et = I & B, rt = I & R, ut = I & O, _t = I & (F | H), Tt = I & ae, $t = ut ? r : xu(v);
        function Nt() {
          for (var Kt = arguments.length, nr = Ue(Kt), mn = Kt; mn--; )
            nr[mn] = arguments[mn];
          if (_t)
            var qi = Uf(Nt), wn = mN(nr, qi);
          if (G && (nr = z3(nr, G, ie, _t)), ce && (nr = U3(nr, ce, de, _t)), Kt -= wn, _t && Kt < Xe) {
            var ti = Ua(nr, qi);
            return K3(
              v,
              I,
              Jl,
              Nt.placeholder,
              L,
              nr,
              ti,
              ge,
              xe,
              Xe - Kt
            );
          }
          var vs = rt ? L : this, wa = ut ? vs[v] : v;
          return Kt = nr.length, ge ? nr = AC(nr, ge) : Tt && Kt > 1 && nr.reverse(), et && xe < Kt && (nr.length = xe), this && this !== ir && this instanceof Nt && (wa = $t || xu(wa)), wa.apply(vs, nr);
        }
        return Nt;
      }
      function V3(v, I) {
        return function(L, G) {
          return PD(L, v, I(G), {});
        };
      }
      function Xl(v, I) {
        return function(L, G) {
          var ie;
          if (L === r && G === r)
            return I;
          if (L !== r && (ie = L), G !== r) {
            if (ie === r)
              return G;
            typeof L == "string" || typeof G == "string" ? (L = bn(L), G = bn(G)) : (L = C3(L), G = C3(G)), ie = v(L, G);
          }
          return ie;
        };
      }
      function Q1(v) {
        return ga(function(I) {
          return I = Ur(I, gn(At())), Ht(function(L) {
            var G = this;
            return v(I, function(ie) {
              return ui(ie, G, L);
            });
          });
        });
      }
      function ed(v, I) {
        I = I === r ? " " : bn(I);
        var L = I.length;
        if (L < 2)
          return L ? q1(I, v) : I;
        var G = q1(I, Ul(v / Of(I)));
        return Cf(I) ? Wa(ls(G), 0, v).join("") : G.slice(0, v);
      }
      function fC(v, I, L, G) {
        var ie = I & R, ce = xu(v);
        function de() {
          for (var ge = -1, xe = arguments.length, Xe = -1, et = G.length, rt = Ue(et + xe), ut = this && this !== ir && this instanceof de ? ce : v; ++Xe < et; )
            rt[Xe] = G[Xe];
          for (; xe--; )
            rt[Xe++] = arguments[++ge];
          return ui(ut, ie ? L : this, rt);
        }
        return de;
      }
      function G3(v) {
        return function(I, L, G) {
          return G && typeof G != "number" && $i(I, L, G) && (L = G = r), I = ma(I), L === r ? (L = I, I = 0) : L = ma(L), G = G === r ? I < L ? 1 : -1 : ma(G), GD(I, L, G, v);
        };
      }
      function td(v) {
        return function(I, L) {
          return typeof I == "string" && typeof L == "string" || (I = Un(I), L = Un(L)), v(I, L);
        };
      }
      function K3(v, I, L, G, ie, ce, de, ge, xe, Xe) {
        var et = I & F, rt = et ? de : r, ut = et ? r : de, _t = et ? ce : r, Tt = et ? r : ce;
        I |= et ? Q : Z, I &= ~(et ? Z : Q), I & P || (I &= ~(R | O));
        var $t = [
          v,
          I,
          ie,
          _t,
          rt,
          Tt,
          ut,
          ge,
          xe,
          Xe
        ], Nt = L.apply(r, $t);
        return nv(v) && a_(Nt, $t), Nt.placeholder = G, o_(Nt, v, I);
      }
      function Z1(v) {
        var I = oi[v];
        return function(L, G) {
          if (L = Un(L), G = G == null ? 0 : Ci(zt(G), 292), G && o3(L)) {
            var ie = (gr(L) + "e").split("e"), ce = I(ie[0] + "e" + (+ie[1] + G));
            return ie = (gr(ce) + "e").split("e"), +(ie[0] + "e" + (+ie[1] - G));
          }
          return I(L);
        };
      }
      var cC = Pf && 1 / Dl(new Pf([, -0]))[1] == w ? function(v) {
        return new Pf(v);
      } : mv;
      function Y3(v) {
        return function(I) {
          var L = Oi(I);
          return L == ne ? A1(I) : L == ue ? IN(I) : yN(I, v(I));
        };
      }
      function va(v, I, L, G, ie, ce, de, ge) {
        var xe = I & O;
        if (!xe && typeof v != "function")
          throw new Pn(f);
        var Xe = G ? G.length : 0;
        if (Xe || (I &= ~(Q | Z), G = ie = r), de = de === r ? de : fi(zt(de), 0), ge = ge === r ? ge : zt(ge), Xe -= ie ? ie.length : 0, I & Z) {
          var et = G, rt = ie;
          G = ie = r;
        }
        var ut = xe ? r : ev(v), _t = [
          v,
          I,
          L,
          G,
          ie,
          et,
          rt,
          ce,
          de,
          ge
        ];
        if (ut && SC(_t, ut), v = _t[0], I = _t[1], L = _t[2], G = _t[3], ie = _t[4], ge = _t[9] = _t[9] === r ? xe ? 0 : v.length : fi(_t[9] - Xe, 0), !ge && I & (F | H) && (I &= ~(F | H)), !I || I == R)
          var Tt = aC(v, I, L);
        else
          I == F || I == H ? Tt = oC(v, I, ge) : (I == Q || I == (R | Q)) && !ie.length ? Tt = fC(v, I, L, G) : Tt = Jl.apply(r, _t);
        var $t = ut ? N3 : a_;
        return o_($t(Tt, _t), v, I);
      }
      function Q3(v, I, L, G) {
        return v === r || ps(v, Lf[L]) && !mr.call(G, L) ? I : v;
      }
      function Z3(v, I, L, G, ie, ce) {
        return Hr(v) && Hr(I) && (ce.set(I, v), Kl(v, I, r, Z3, ce), ce.delete(I)), v;
      }
      function uC(v) {
        return Iu(v) ? r : v;
      }
      function J3(v, I, L, G, ie, ce) {
        var de = L & A, ge = v.length, xe = I.length;
        if (ge != xe && !(de && xe > ge))
          return !1;
        var Xe = ce.get(v), et = ce.get(I);
        if (Xe && et)
          return Xe == I && et == v;
        var rt = -1, ut = !0, _t = L & N ? new To() : r;
        for (ce.set(v, I), ce.set(I, v); ++rt < ge; ) {
          var Tt = v[rt], $t = I[rt];
          if (G)
            var Nt = de ? G($t, Tt, rt, I, v, ce) : G(Tt, $t, rt, v, I, ce);
          if (Nt !== r) {
            if (Nt)
              continue;
            ut = !1;
            break;
          }
          if (_t) {
            if (!_1(I, function(Kt, nr) {
              if (!lu(_t, nr) && (Tt === Kt || ie(Tt, Kt, L, G, ce)))
                return _t.push(nr);
            })) {
              ut = !1;
              break;
            }
          } else if (!(Tt === $t || ie(Tt, $t, L, G, ce))) {
            ut = !1;
            break;
          }
        }
        return ce.delete(v), ce.delete(I), ut;
      }
      function hC(v, I, L, G, ie, ce, de) {
        switch (L) {
          case Je:
            if (v.byteLength != I.byteLength || v.byteOffset != I.byteOffset)
              return !1;
            v = v.buffer, I = I.buffer;
          case pe:
            return !(v.byteLength != I.byteLength || !ce(new kl(v), new kl(I)));
          case q:
          case K:
          case le:
            return ps(+v, +I);
          case T:
            return v.name == I.name && v.message == I.message;
          case fe:
          case me:
            return v == I + "";
          case ne:
            var ge = A1;
          case ue:
            var xe = G & A;
            if (ge || (ge = Dl), v.size != I.size && !xe)
              return !1;
            var Xe = de.get(v);
            if (Xe)
              return Xe == I;
            G |= N, de.set(v, I);
            var et = J3(ge(v), ge(I), G, ie, ce, de);
            return de.delete(v), et;
          case be:
            if (bu)
              return bu.call(v) == bu.call(I);
        }
        return !1;
      }
      function lC(v, I, L, G, ie, ce) {
        var de = L & A, ge = J1(v), xe = ge.length, Xe = J1(I), et = Xe.length;
        if (xe != et && !de)
          return !1;
        for (var rt = xe; rt--; ) {
          var ut = ge[rt];
          if (!(de ? ut in I : mr.call(I, ut)))
            return !1;
        }
        var _t = ce.get(v), Tt = ce.get(I);
        if (_t && Tt)
          return _t == I && Tt == v;
        var $t = !0;
        ce.set(v, I), ce.set(I, v);
        for (var Nt = de; ++rt < xe; ) {
          ut = ge[rt];
          var Kt = v[ut], nr = I[ut];
          if (G)
            var mn = de ? G(nr, Kt, ut, I, v, ce) : G(Kt, nr, ut, v, I, ce);
          if (!(mn === r ? Kt === nr || ie(Kt, nr, L, G, ce) : mn)) {
            $t = !1;
            break;
          }
          Nt || (Nt = ut == "constructor");
        }
        if ($t && !Nt) {
          var qi = v.constructor, wn = I.constructor;
          qi != wn && "constructor" in v && "constructor" in I && !(typeof qi == "function" && qi instanceof qi && typeof wn == "function" && wn instanceof wn) && ($t = !1);
        }
        return ce.delete(v), ce.delete(I), $t;
      }
      function ga(v) {
        return av(n_(v, r, d_), v + "");
      }
      function J1(v) {
        return y3(v, hi, rv);
      }
      function X1(v) {
        return y3(v, sn, X3);
      }
      var ev = $l ? function(v) {
        return $l.get(v);
      } : mv;
      function rd(v) {
        for (var I = v.name + "", L = kf[I], G = mr.call(kf, I) ? L.length : 0; G--; ) {
          var ie = L[G], ce = ie.func;
          if (ce == null || ce == v)
            return ie.name;
        }
        return I;
      }
      function Uf(v) {
        var I = mr.call(oe, "placeholder") ? oe : v;
        return I.placeholder;
      }
      function At() {
        var v = oe.iteratee || bv;
        return v = v === bv ? _3 : v, arguments.length ? v(arguments[0], arguments[1]) : v;
      }
      function id(v, I) {
        var L = v.__data__;
        return wC(I) ? L[typeof I == "string" ? "string" : "hash"] : L.map;
      }
      function tv(v) {
        for (var I = hi(v), L = I.length; L--; ) {
          var G = I[L], ie = v[G];
          I[L] = [G, ie, r_(ie)];
        }
        return I;
      }
      function Co(v, I) {
        var L = xN(v, I);
        return w3(L) ? L : r;
      }
      function dC(v) {
        var I = mr.call(v, Io), L = v[Io];
        try {
          v[Io] = r;
          var G = !0;
        } catch {
        }
        var ie = Ll.call(v);
        return G && (I ? v[Io] = L : delete v[Io]), ie;
      }
      var rv = N1 ? function(v) {
        return v == null ? [] : (v = Cr(v), Ba(N1(v), function(I) {
          return s3.call(v, I);
        }));
      } : wv, X3 = N1 ? function(v) {
        for (var I = []; v; )
          za(I, rv(v)), v = jl(v);
        return I;
      } : wv, Oi = Fi;
      (D1 && Oi(new D1(new ArrayBuffer(1))) != Je || pu && Oi(new pu()) != ne || C1 && Oi(C1.resolve()) != V || Pf && Oi(new Pf()) != ue || vu && Oi(new vu()) != Ge) && (Oi = function(v) {
        var I = Fi(v), L = I == $ ? v.constructor : r, G = L ? Oo(L) : "";
        if (G)
          switch (G) {
            case YN:
              return Je;
            case QN:
              return ne;
            case ZN:
              return V;
            case JN:
              return ue;
            case XN:
              return Ge;
          }
        return I;
      });
      function pC(v, I, L) {
        for (var G = -1, ie = L.length; ++G < ie; ) {
          var ce = L[G], de = ce.size;
          switch (ce.type) {
            case "drop":
              v += de;
              break;
            case "dropRight":
              I -= de;
              break;
            case "take":
              I = Ci(I, v + de);
              break;
            case "takeRight":
              v = fi(v, I - de);
              break;
          }
        }
        return { start: v, end: I };
      }
      function vC(v) {
        var I = v.match(je);
        return I ? I[1].split(Ce) : [];
      }
      function e_(v, I, L) {
        I = Ha(I, v);
        for (var G = -1, ie = I.length, ce = !1; ++G < ie; ) {
          var de = Ps(I[G]);
          if (!(ce = v != null && L(v, de)))
            break;
          v = v[de];
        }
        return ce || ++G != ie ? ce : (ie = v == null ? 0 : v.length, !!ie && ud(ie) && ba(de, ie) && (Pt(v) || Ro(v)));
      }
      function gC(v) {
        var I = v.length, L = new v.constructor(I);
        return I && typeof v[0] == "string" && mr.call(v, "index") && (L.index = v.index, L.input = v.input), L;
      }
      function t_(v) {
        return typeof v.constructor == "function" && !Su(v) ? jf(jl(v)) : {};
      }
      function bC(v, I, L) {
        var G = v.constructor;
        switch (I) {
          case pe:
            return Y1(v);
          case q:
          case K:
            return new G(+v);
          case Je:
            return eC(v, L);
          case Ie:
          case we:
          case at:
          case Oe:
          case Ee:
          case ft:
          case Le:
          case Pe:
          case Mt:
            return j3(v, L);
          case ne:
            return new G();
          case le:
          case me:
            return new G(v);
          case fe:
            return tC(v);
          case ue:
            return new G();
          case be:
            return rC(v);
        }
      }
      function yC(v, I) {
        var L = I.length;
        if (!L)
          return v;
        var G = L - 1;
        return I[G] = (L > 1 ? "& " : "") + I[G], I = I.join(L > 2 ? ", " : " "), v.replace(vt, `{
/* [wrapped with ` + I + `] */
`);
      }
      function mC(v) {
        return Pt(v) || Ro(v) || !!(a3 && v && v[a3]);
      }
      function ba(v, I) {
        var L = typeof v;
        return I = I == null ? _ : I, !!I && (L == "number" || L != "symbol" && Xt.test(v)) && v > -1 && v % 1 == 0 && v < I;
      }
      function $i(v, I, L) {
        if (!Hr(L))
          return !1;
        var G = typeof I;
        return (G == "number" ? nn(L) && ba(I, L.length) : G == "string" && I in L) ? ps(L[I], v) : !1;
      }
      function iv(v, I) {
        if (Pt(v))
          return !1;
        var L = typeof v;
        return L == "number" || L == "symbol" || L == "boolean" || v == null || yn(v) ? !0 : bt.test(v) || !Ae.test(v) || I != null && v in Cr(I);
      }
      function wC(v) {
        var I = typeof v;
        return I == "string" || I == "number" || I == "symbol" || I == "boolean" ? v !== "__proto__" : v === null;
      }
      function nv(v) {
        var I = rd(v), L = oe[I];
        if (typeof L != "function" || !(I in er.prototype))
          return !1;
        if (v === L)
          return !0;
        var G = ev(L);
        return !!G && v === G[0];
      }
      function _C(v) {
        return !!r3 && r3 in v;
      }
      var MC = Ol ? ya : _v;
      function Su(v) {
        var I = v && v.constructor, L = typeof I == "function" && I.prototype || Lf;
        return v === L;
      }
      function r_(v) {
        return v === v && !Hr(v);
      }
      function i_(v, I) {
        return function(L) {
          return L == null ? !1 : L[v] === I && (I !== r || v in Cr(L));
        };
      }
      function xC(v) {
        var I = fd(v, function(G) {
          return L.size === d && L.clear(), G;
        }), L = I.cache;
        return I;
      }
      function SC(v, I) {
        var L = v[1], G = I[1], ie = L | G, ce = ie < (R | O | B), de = G == B && L == F || G == B && L == Y && v[7].length <= I[8] || G == (B | Y) && I[7].length <= I[8] && L == F;
        if (!(ce || de))
          return v;
        G & R && (v[2] = I[2], ie |= L & R ? 0 : P);
        var ge = I[3];
        if (ge) {
          var xe = v[3];
          v[3] = xe ? z3(xe, ge, I[4]) : ge, v[4] = xe ? Ua(v[3], l) : I[4];
        }
        return ge = I[5], ge && (xe = v[5], v[5] = xe ? U3(xe, ge, I[6]) : ge, v[6] = xe ? Ua(v[5], l) : I[6]), ge = I[7], ge && (v[7] = ge), G & B && (v[8] = v[8] == null ? I[8] : Ci(v[8], I[8])), v[9] == null && (v[9] = I[9]), v[0] = I[0], v[1] = ie, v;
      }
      function EC(v) {
        var I = [];
        if (v != null)
          for (var L in Cr(v))
            I.push(L);
        return I;
      }
      function IC(v) {
        return Ll.call(v);
      }
      function n_(v, I, L) {
        return I = fi(I === r ? v.length - 1 : I, 0), function() {
          for (var G = arguments, ie = -1, ce = fi(G.length - I, 0), de = Ue(ce); ++ie < ce; )
            de[ie] = G[I + ie];
          ie = -1;
          for (var ge = Ue(I + 1); ++ie < I; )
            ge[ie] = G[ie];
          return ge[I] = L(de), ui(v, this, ge);
        };
      }
      function s_(v, I) {
        return I.length < 2 ? v : Do(v, Bn(I, 0, -1));
      }
      function AC(v, I) {
        for (var L = v.length, G = Ci(I.length, L), ie = rn(v); G--; ) {
          var ce = I[G];
          v[G] = ba(ce, L) ? ie[ce] : r;
        }
        return v;
      }
      function sv(v, I) {
        if (!(I === "constructor" && typeof v[I] == "function") && I != "__proto__")
          return v[I];
      }
      var a_ = f_(N3), Eu = $N || function(v, I) {
        return ir.setTimeout(v, I);
      }, av = f_(QD);
      function o_(v, I, L) {
        var G = I + "";
        return av(v, yC(G, TC(vC(G), L)));
      }
      function f_(v) {
        var I = 0, L = 0;
        return function() {
          var G = VN(), ie = g - (G - L);
          if (L = G, ie > 0) {
            if (++I >= C)
              return arguments[0];
          } else
            I = 0;
          return v.apply(r, arguments);
        };
      }
      function nd(v, I) {
        var L = -1, G = v.length, ie = G - 1;
        for (I = I === r ? G : I; ++L < I; ) {
          var ce = $1(L, ie), de = v[ce];
          v[ce] = v[L], v[L] = de;
        }
        return v.length = I, v;
      }
      var c_ = xC(function(v) {
        var I = [];
        return v.charCodeAt(0) === 46 && I.push(""), v.replace(He, function(L, G, ie, ce) {
          I.push(ie ? ce.replace(qe, "$1") : G || L);
        }), I;
      });
      function Ps(v) {
        if (typeof v == "string" || yn(v))
          return v;
        var I = v + "";
        return I == "0" && 1 / v == -w ? "-0" : I;
      }
      function Oo(v) {
        if (v != null) {
          try {
            return Rl.call(v);
          } catch {
          }
          try {
            return v + "";
          } catch {
          }
        }
        return "";
      }
      function TC(v, I) {
        return Ln(J, function(L) {
          var G = "_." + L[0];
          I & L[1] && !Tl(v, G) && v.push(G);
        }), v.sort();
      }
      function u_(v) {
        if (v instanceof er)
          return v.clone();
        var I = new kn(v.__wrapped__, v.__chain__);
        return I.__actions__ = rn(v.__actions__), I.__index__ = v.__index__, I.__values__ = v.__values__, I;
      }
      function NC(v, I, L) {
        (L ? $i(v, I, L) : I === r) ? I = 1 : I = fi(zt(I), 0);
        var G = v == null ? 0 : v.length;
        if (!G || I < 1)
          return [];
        for (var ie = 0, ce = 0, de = Ue(Ul(G / I)); ie < G; )
          de[ce++] = Bn(v, ie, ie += I);
        return de;
      }
      function DC(v) {
        for (var I = -1, L = v == null ? 0 : v.length, G = 0, ie = []; ++I < L; ) {
          var ce = v[I];
          ce && (ie[G++] = ce);
        }
        return ie;
      }
      function CC() {
        var v = arguments.length;
        if (!v)
          return [];
        for (var I = Ue(v - 1), L = arguments[0], G = v; G--; )
          I[G - 1] = arguments[G];
        return za(Pt(L) ? rn(L) : [L], xi(I, 1));
      }
      var OC = Ht(function(v, I) {
        return ei(v) ? mu(v, xi(I, 1, ei, !0)) : [];
      }), RC = Ht(function(v, I) {
        var L = zn(I);
        return ei(L) && (L = r), ei(v) ? mu(v, xi(I, 1, ei, !0), At(L, 2)) : [];
      }), LC = Ht(function(v, I) {
        var L = zn(I);
        return ei(L) && (L = r), ei(v) ? mu(v, xi(I, 1, ei, !0), r, L) : [];
      });
      function PC(v, I, L) {
        var G = v == null ? 0 : v.length;
        return G ? (I = L || I === r ? 1 : zt(I), Bn(v, I < 0 ? 0 : I, G)) : [];
      }
      function kC(v, I, L) {
        var G = v == null ? 0 : v.length;
        return G ? (I = L || I === r ? 1 : zt(I), I = G - I, Bn(v, 0, I < 0 ? 0 : I)) : [];
      }
      function jC(v, I) {
        return v && v.length ? Ql(v, At(I, 3), !0, !0) : [];
      }
      function BC(v, I) {
        return v && v.length ? Ql(v, At(I, 3), !0) : [];
      }
      function zC(v, I, L, G) {
        var ie = v == null ? 0 : v.length;
        return ie ? (L && typeof L != "number" && $i(v, I, L) && (L = 0, G = ie), CD(v, I, L, G)) : [];
      }
      function h_(v, I, L) {
        var G = v == null ? 0 : v.length;
        if (!G)
          return -1;
        var ie = L == null ? 0 : zt(L);
        return ie < 0 && (ie = fi(G + ie, 0)), Nl(v, At(I, 3), ie);
      }
      function l_(v, I, L) {
        var G = v == null ? 0 : v.length;
        if (!G)
          return -1;
        var ie = G - 1;
        return L !== r && (ie = zt(L), ie = L < 0 ? fi(G + ie, 0) : Ci(ie, G - 1)), Nl(v, At(I, 3), ie, !0);
      }
      function d_(v) {
        var I = v == null ? 0 : v.length;
        return I ? xi(v, 1) : [];
      }
      function UC(v) {
        var I = v == null ? 0 : v.length;
        return I ? xi(v, w) : [];
      }
      function FC(v, I) {
        var L = v == null ? 0 : v.length;
        return L ? (I = I === r ? 1 : zt(I), xi(v, I)) : [];
      }
      function $C(v) {
        for (var I = -1, L = v == null ? 0 : v.length, G = {}; ++I < L; ) {
          var ie = v[I];
          G[ie[0]] = ie[1];
        }
        return G;
      }
      function p_(v) {
        return v && v.length ? v[0] : r;
      }
      function qC(v, I, L) {
        var G = v == null ? 0 : v.length;
        if (!G)
          return -1;
        var ie = L == null ? 0 : zt(L);
        return ie < 0 && (ie = fi(G + ie, 0)), Df(v, I, ie);
      }
      function HC(v) {
        var I = v == null ? 0 : v.length;
        return I ? Bn(v, 0, -1) : [];
      }
      var WC = Ht(function(v) {
        var I = Ur(v, G1);
        return I.length && I[0] === v[0] ? j1(I) : [];
      }), VC = Ht(function(v) {
        var I = zn(v), L = Ur(v, G1);
        return I === zn(L) ? I = r : L.pop(), L.length && L[0] === v[0] ? j1(L, At(I, 2)) : [];
      }), GC = Ht(function(v) {
        var I = zn(v), L = Ur(v, G1);
        return I = typeof I == "function" ? I : r, I && L.pop(), L.length && L[0] === v[0] ? j1(L, r, I) : [];
      });
      function KC(v, I) {
        return v == null ? "" : HN.call(v, I);
      }
      function zn(v) {
        var I = v == null ? 0 : v.length;
        return I ? v[I - 1] : r;
      }
      function YC(v, I, L) {
        var G = v == null ? 0 : v.length;
        if (!G)
          return -1;
        var ie = G;
        return L !== r && (ie = zt(L), ie = ie < 0 ? fi(G + ie, 0) : Ci(ie, G - 1)), I === I ? TN(v, I, ie) : Nl(v, Kw, ie, !0);
      }
      function QC(v, I) {
        return v && v.length ? E3(v, zt(I)) : r;
      }
      var ZC = Ht(v_);
      function v_(v, I) {
        return v && v.length && I && I.length ? F1(v, I) : v;
      }
      function JC(v, I, L) {
        return v && v.length && I && I.length ? F1(v, I, At(L, 2)) : v;
      }
      function XC(v, I, L) {
        return v && v.length && I && I.length ? F1(v, I, r, L) : v;
      }
      var eO = ga(function(v, I) {
        var L = v == null ? 0 : v.length, G = R1(v, I);
        return T3(v, Ur(I, function(ie) {
          return ba(ie, L) ? +ie : ie;
        }).sort(B3)), G;
      });
      function tO(v, I) {
        var L = [];
        if (!(v && v.length))
          return L;
        var G = -1, ie = [], ce = v.length;
        for (I = At(I, 3); ++G < ce; ) {
          var de = v[G];
          I(de, G, v) && (L.push(de), ie.push(G));
        }
        return T3(v, ie), L;
      }
      function ov(v) {
        return v == null ? v : KN.call(v);
      }
      function rO(v, I, L) {
        var G = v == null ? 0 : v.length;
        return G ? (L && typeof L != "number" && $i(v, I, L) ? (I = 0, L = G) : (I = I == null ? 0 : zt(I), L = L === r ? G : zt(L)), Bn(v, I, L)) : [];
      }
      function iO(v, I) {
        return Yl(v, I);
      }
      function nO(v, I, L) {
        return H1(v, I, At(L, 2));
      }
      function sO(v, I) {
        var L = v == null ? 0 : v.length;
        if (L) {
          var G = Yl(v, I);
          if (G < L && ps(v[G], I))
            return G;
        }
        return -1;
      }
      function aO(v, I) {
        return Yl(v, I, !0);
      }
      function oO(v, I, L) {
        return H1(v, I, At(L, 2), !0);
      }
      function fO(v, I) {
        var L = v == null ? 0 : v.length;
        if (L) {
          var G = Yl(v, I, !0) - 1;
          if (ps(v[G], I))
            return G;
        }
        return -1;
      }
      function cO(v) {
        return v && v.length ? D3(v) : [];
      }
      function uO(v, I) {
        return v && v.length ? D3(v, At(I, 2)) : [];
      }
      function hO(v) {
        var I = v == null ? 0 : v.length;
        return I ? Bn(v, 1, I) : [];
      }
      function lO(v, I, L) {
        return v && v.length ? (I = L || I === r ? 1 : zt(I), Bn(v, 0, I < 0 ? 0 : I)) : [];
      }
      function dO(v, I, L) {
        var G = v == null ? 0 : v.length;
        return G ? (I = L || I === r ? 1 : zt(I), I = G - I, Bn(v, I < 0 ? 0 : I, G)) : [];
      }
      function pO(v, I) {
        return v && v.length ? Ql(v, At(I, 3), !1, !0) : [];
      }
      function vO(v, I) {
        return v && v.length ? Ql(v, At(I, 3)) : [];
      }
      var gO = Ht(function(v) {
        return qa(xi(v, 1, ei, !0));
      }), bO = Ht(function(v) {
        var I = zn(v);
        return ei(I) && (I = r), qa(xi(v, 1, ei, !0), At(I, 2));
      }), yO = Ht(function(v) {
        var I = zn(v);
        return I = typeof I == "function" ? I : r, qa(xi(v, 1, ei, !0), r, I);
      });
      function mO(v) {
        return v && v.length ? qa(v) : [];
      }
      function wO(v, I) {
        return v && v.length ? qa(v, At(I, 2)) : [];
      }
      function _O(v, I) {
        return I = typeof I == "function" ? I : r, v && v.length ? qa(v, r, I) : [];
      }
      function fv(v) {
        if (!(v && v.length))
          return [];
        var I = 0;
        return v = Ba(v, function(L) {
          if (ei(L))
            return I = fi(L.length, I), !0;
        }), E1(I, function(L) {
          return Ur(v, M1(L));
        });
      }
      function g_(v, I) {
        if (!(v && v.length))
          return [];
        var L = fv(v);
        return I == null ? L : Ur(L, function(G) {
          return ui(I, r, G);
        });
      }
      var MO = Ht(function(v, I) {
        return ei(v) ? mu(v, I) : [];
      }), xO = Ht(function(v) {
        return V1(Ba(v, ei));
      }), SO = Ht(function(v) {
        var I = zn(v);
        return ei(I) && (I = r), V1(Ba(v, ei), At(I, 2));
      }), EO = Ht(function(v) {
        var I = zn(v);
        return I = typeof I == "function" ? I : r, V1(Ba(v, ei), r, I);
      }), IO = Ht(fv);
      function AO(v, I) {
        return L3(v || [], I || [], yu);
      }
      function TO(v, I) {
        return L3(v || [], I || [], Mu);
      }
      var NO = Ht(function(v) {
        var I = v.length, L = I > 1 ? v[I - 1] : r;
        return L = typeof L == "function" ? (v.pop(), L) : r, g_(v, L);
      });
      function b_(v) {
        var I = oe(v);
        return I.__chain__ = !0, I;
      }
      function DO(v, I) {
        return I(v), v;
      }
      function sd(v, I) {
        return I(v);
      }
      var CO = ga(function(v) {
        var I = v.length, L = I ? v[0] : 0, G = this.__wrapped__, ie = function(ce) {
          return R1(ce, v);
        };
        return I > 1 || this.__actions__.length || !(G instanceof er) || !ba(L) ? this.thru(ie) : (G = G.slice(L, +L + (I ? 1 : 0)), G.__actions__.push({
          func: sd,
          args: [ie],
          thisArg: r
        }), new kn(G, this.__chain__).thru(function(ce) {
          return I && !ce.length && ce.push(r), ce;
        }));
      });
      function OO() {
        return b_(this);
      }
      function RO() {
        return new kn(this.value(), this.__chain__);
      }
      function LO() {
        this.__values__ === r && (this.__values__ = C_(this.value()));
        var v = this.__index__ >= this.__values__.length, I = v ? r : this.__values__[this.__index__++];
        return { done: v, value: I };
      }
      function PO() {
        return this;
      }
      function kO(v) {
        for (var I, L = this; L instanceof Hl; ) {
          var G = u_(L);
          G.__index__ = 0, G.__values__ = r, I ? ie.__wrapped__ = G : I = G;
          var ie = G;
          L = L.__wrapped__;
        }
        return ie.__wrapped__ = v, I;
      }
      function jO() {
        var v = this.__wrapped__;
        if (v instanceof er) {
          var I = v;
          return this.__actions__.length && (I = new er(this)), I = I.reverse(), I.__actions__.push({
            func: sd,
            args: [ov],
            thisArg: r
          }), new kn(I, this.__chain__);
        }
        return this.thru(ov);
      }
      function BO() {
        return R3(this.__wrapped__, this.__actions__);
      }
      var zO = Zl(function(v, I, L) {
        mr.call(v, L) ? ++v[L] : pa(v, L, 1);
      });
      function UO(v, I, L) {
        var G = Pt(v) ? Vw : DD;
        return L && $i(v, I, L) && (I = r), G(v, At(I, 3));
      }
      function FO(v, I) {
        var L = Pt(v) ? Ba : g3;
        return L(v, At(I, 3));
      }
      var $O = H3(h_), qO = H3(l_);
      function HO(v, I) {
        return xi(ad(v, I), 1);
      }
      function WO(v, I) {
        return xi(ad(v, I), w);
      }
      function VO(v, I, L) {
        return L = L === r ? 1 : zt(L), xi(ad(v, I), L);
      }
      function y_(v, I) {
        var L = Pt(v) ? Ln : $a;
        return L(v, At(I, 3));
      }
      function m_(v, I) {
        var L = Pt(v) ? hN : v3;
        return L(v, At(I, 3));
      }
      var GO = Zl(function(v, I, L) {
        mr.call(v, L) ? v[L].push(I) : pa(v, L, [I]);
      });
      function KO(v, I, L, G) {
        v = nn(v) ? v : $f(v), L = L && !G ? zt(L) : 0;
        var ie = v.length;
        return L < 0 && (L = fi(ie + L, 0)), hd(v) ? L <= ie && v.indexOf(I, L) > -1 : !!ie && Df(v, I, L) > -1;
      }
      var YO = Ht(function(v, I, L) {
        var G = -1, ie = typeof I == "function", ce = nn(v) ? Ue(v.length) : [];
        return $a(v, function(de) {
          ce[++G] = ie ? ui(I, de, L) : wu(de, I, L);
        }), ce;
      }), QO = Zl(function(v, I, L) {
        pa(v, L, I);
      });
      function ad(v, I) {
        var L = Pt(v) ? Ur : M3;
        return L(v, At(I, 3));
      }
      function ZO(v, I, L, G) {
        return v == null ? [] : (Pt(I) || (I = I == null ? [] : [I]), L = G ? r : L, Pt(L) || (L = L == null ? [] : [L]), I3(v, I, L));
      }
      var JO = Zl(function(v, I, L) {
        v[L ? 0 : 1].push(I);
      }, function() {
        return [[], []];
      });
      function XO(v, I, L) {
        var G = Pt(v) ? w1 : Qw, ie = arguments.length < 3;
        return G(v, At(I, 4), L, ie, $a);
      }
      function eR(v, I, L) {
        var G = Pt(v) ? lN : Qw, ie = arguments.length < 3;
        return G(v, At(I, 4), L, ie, v3);
      }
      function tR(v, I) {
        var L = Pt(v) ? Ba : g3;
        return L(v, cd(At(I, 3)));
      }
      function rR(v) {
        var I = Pt(v) ? h3 : KD;
        return I(v);
      }
      function iR(v, I, L) {
        (L ? $i(v, I, L) : I === r) ? I = 1 : I = zt(I);
        var G = Pt(v) ? ED : YD;
        return G(v, I);
      }
      function nR(v) {
        var I = Pt(v) ? ID : ZD;
        return I(v);
      }
      function sR(v) {
        if (v == null)
          return 0;
        if (nn(v))
          return hd(v) ? Of(v) : v.length;
        var I = Oi(v);
        return I == ne || I == ue ? v.size : z1(v).length;
      }
      function aR(v, I, L) {
        var G = Pt(v) ? _1 : JD;
        return L && $i(v, I, L) && (I = r), G(v, At(I, 3));
      }
      var oR = Ht(function(v, I) {
        if (v == null)
          return [];
        var L = I.length;
        return L > 1 && $i(v, I[0], I[1]) ? I = [] : L > 2 && $i(I[0], I[1], I[2]) && (I = [I[0]]), I3(v, xi(I, 1), []);
      }), od = FN || function() {
        return ir.Date.now();
      };
      function fR(v, I) {
        if (typeof I != "function")
          throw new Pn(f);
        return v = zt(v), function() {
          if (--v < 1)
            return I.apply(this, arguments);
        };
      }
      function w_(v, I, L) {
        return I = L ? r : I, I = v && I == null ? v.length : I, va(v, B, r, r, r, r, I);
      }
      function __(v, I) {
        var L;
        if (typeof I != "function")
          throw new Pn(f);
        return v = zt(v), function() {
          return --v > 0 && (L = I.apply(this, arguments)), v <= 1 && (I = r), L;
        };
      }
      var cv = Ht(function(v, I, L) {
        var G = R;
        if (L.length) {
          var ie = Ua(L, Uf(cv));
          G |= Q;
        }
        return va(v, G, I, L, ie);
      }), M_ = Ht(function(v, I, L) {
        var G = R | O;
        if (L.length) {
          var ie = Ua(L, Uf(M_));
          G |= Q;
        }
        return va(I, G, v, L, ie);
      });
      function x_(v, I, L) {
        I = L ? r : I;
        var G = va(v, F, r, r, r, r, r, I);
        return G.placeholder = x_.placeholder, G;
      }
      function S_(v, I, L) {
        I = L ? r : I;
        var G = va(v, H, r, r, r, r, r, I);
        return G.placeholder = S_.placeholder, G;
      }
      function E_(v, I, L) {
        var G, ie, ce, de, ge, xe, Xe = 0, et = !1, rt = !1, ut = !0;
        if (typeof v != "function")
          throw new Pn(f);
        I = Un(I) || 0, Hr(L) && (et = !!L.leading, rt = "maxWait" in L, ce = rt ? fi(Un(L.maxWait) || 0, I) : ce, ut = "trailing" in L ? !!L.trailing : ut);
        function _t(ti) {
          var vs = G, wa = ie;
          return G = ie = r, Xe = ti, de = v.apply(wa, vs), de;
        }
        function Tt(ti) {
          return Xe = ti, ge = Eu(Kt, I), et ? _t(ti) : de;
        }
        function $t(ti) {
          var vs = ti - xe, wa = ti - Xe, H_ = I - vs;
          return rt ? Ci(H_, ce - wa) : H_;
        }
        function Nt(ti) {
          var vs = ti - xe, wa = ti - Xe;
          return xe === r || vs >= I || vs < 0 || rt && wa >= ce;
        }
        function Kt() {
          var ti = od();
          if (Nt(ti))
            return nr(ti);
          ge = Eu(Kt, $t(ti));
        }
        function nr(ti) {
          return ge = r, ut && G ? _t(ti) : (G = ie = r, de);
        }
        function mn() {
          ge !== r && P3(ge), Xe = 0, G = xe = ie = ge = r;
        }
        function qi() {
          return ge === r ? de : nr(od());
        }
        function wn() {
          var ti = od(), vs = Nt(ti);
          if (G = arguments, ie = this, xe = ti, vs) {
            if (ge === r)
              return Tt(xe);
            if (rt)
              return P3(ge), ge = Eu(Kt, I), _t(xe);
          }
          return ge === r && (ge = Eu(Kt, I)), de;
        }
        return wn.cancel = mn, wn.flush = qi, wn;
      }
      var cR = Ht(function(v, I) {
        return p3(v, 1, I);
      }), uR = Ht(function(v, I, L) {
        return p3(v, Un(I) || 0, L);
      });
      function hR(v) {
        return va(v, ae);
      }
      function fd(v, I) {
        if (typeof v != "function" || I != null && typeof I != "function")
          throw new Pn(f);
        var L = function() {
          var G = arguments, ie = I ? I.apply(this, G) : G[0], ce = L.cache;
          if (ce.has(ie))
            return ce.get(ie);
          var de = v.apply(this, G);
          return L.cache = ce.set(ie, de) || ce, de;
        };
        return L.cache = new (fd.Cache || da)(), L;
      }
      fd.Cache = da;
      function cd(v) {
        if (typeof v != "function")
          throw new Pn(f);
        return function() {
          var I = arguments;
          switch (I.length) {
            case 0:
              return !v.call(this);
            case 1:
              return !v.call(this, I[0]);
            case 2:
              return !v.call(this, I[0], I[1]);
            case 3:
              return !v.call(this, I[0], I[1], I[2]);
          }
          return !v.apply(this, I);
        };
      }
      function lR(v) {
        return __(2, v);
      }
      var dR = XD(function(v, I) {
        I = I.length == 1 && Pt(I[0]) ? Ur(I[0], gn(At())) : Ur(xi(I, 1), gn(At()));
        var L = I.length;
        return Ht(function(G) {
          for (var ie = -1, ce = Ci(G.length, L); ++ie < ce; )
            G[ie] = I[ie].call(this, G[ie]);
          return ui(v, this, G);
        });
      }), uv = Ht(function(v, I) {
        var L = Ua(I, Uf(uv));
        return va(v, Q, r, I, L);
      }), I_ = Ht(function(v, I) {
        var L = Ua(I, Uf(I_));
        return va(v, Z, r, I, L);
      }), pR = ga(function(v, I) {
        return va(v, Y, r, r, r, I);
      });
      function vR(v, I) {
        if (typeof v != "function")
          throw new Pn(f);
        return I = I === r ? I : zt(I), Ht(v, I);
      }
      function gR(v, I) {
        if (typeof v != "function")
          throw new Pn(f);
        return I = I == null ? 0 : fi(zt(I), 0), Ht(function(L) {
          var G = L[I], ie = Wa(L, 0, I);
          return G && za(ie, G), ui(v, this, ie);
        });
      }
      function bR(v, I, L) {
        var G = !0, ie = !0;
        if (typeof v != "function")
          throw new Pn(f);
        return Hr(L) && (G = "leading" in L ? !!L.leading : G, ie = "trailing" in L ? !!L.trailing : ie), E_(v, I, {
          leading: G,
          maxWait: I,
          trailing: ie
        });
      }
      function yR(v) {
        return w_(v, 1);
      }
      function mR(v, I) {
        return uv(K1(I), v);
      }
      function wR() {
        if (!arguments.length)
          return [];
        var v = arguments[0];
        return Pt(v) ? v : [v];
      }
      function _R(v) {
        return jn(v, M);
      }
      function MR(v, I) {
        return I = typeof I == "function" ? I : r, jn(v, M, I);
      }
      function xR(v) {
        return jn(v, m | M);
      }
      function SR(v, I) {
        return I = typeof I == "function" ? I : r, jn(v, m | M, I);
      }
      function ER(v, I) {
        return I == null || d3(v, I, hi(I));
      }
      function ps(v, I) {
        return v === I || v !== v && I !== I;
      }
      var IR = td(k1), AR = td(function(v, I) {
        return v >= I;
      }), Ro = m3(function() {
        return arguments;
      }()) ? m3 : function(v) {
        return Gr(v) && mr.call(v, "callee") && !s3.call(v, "callee");
      }, Pt = Ue.isArray, TR = Ui ? gn(Ui) : kD;
      function nn(v) {
        return v != null && ud(v.length) && !ya(v);
      }
      function ei(v) {
        return Gr(v) && nn(v);
      }
      function NR(v) {
        return v === !0 || v === !1 || Gr(v) && Fi(v) == q;
      }
      var Va = qN || _v, DR = hs ? gn(hs) : jD;
      function CR(v) {
        return Gr(v) && v.nodeType === 1 && !Iu(v);
      }
      function OR(v) {
        if (v == null)
          return !0;
        if (nn(v) && (Pt(v) || typeof v == "string" || typeof v.splice == "function" || Va(v) || Ff(v) || Ro(v)))
          return !v.length;
        var I = Oi(v);
        if (I == ne || I == ue)
          return !v.size;
        if (Su(v))
          return !z1(v).length;
        for (var L in v)
          if (mr.call(v, L))
            return !1;
        return !0;
      }
      function RR(v, I) {
        return _u(v, I);
      }
      function LR(v, I, L) {
        L = typeof L == "function" ? L : r;
        var G = L ? L(v, I) : r;
        return G === r ? _u(v, I, r, L) : !!G;
      }
      function hv(v) {
        if (!Gr(v))
          return !1;
        var I = Fi(v);
        return I == T || I == U || typeof v.message == "string" && typeof v.name == "string" && !Iu(v);
      }
      function PR(v) {
        return typeof v == "number" && o3(v);
      }
      function ya(v) {
        if (!Hr(v))
          return !1;
        var I = Fi(v);
        return I == D || I == te || I == j || I == re;
      }
      function A_(v) {
        return typeof v == "number" && v == zt(v);
      }
      function ud(v) {
        return typeof v == "number" && v > -1 && v % 1 == 0 && v <= _;
      }
      function Hr(v) {
        var I = typeof v;
        return v != null && (I == "object" || I == "function");
      }
      function Gr(v) {
        return v != null && typeof v == "object";
      }
      var T_ = Rn ? gn(Rn) : zD;
      function kR(v, I) {
        return v === I || B1(v, I, tv(I));
      }
      function jR(v, I, L) {
        return L = typeof L == "function" ? L : r, B1(v, I, tv(I), L);
      }
      function BR(v) {
        return N_(v) && v != +v;
      }
      function zR(v) {
        if (MC(v))
          throw new Ot(n);
        return w3(v);
      }
      function UR(v) {
        return v === null;
      }
      function FR(v) {
        return v == null;
      }
      function N_(v) {
        return typeof v == "number" || Gr(v) && Fi(v) == le;
      }
      function Iu(v) {
        if (!Gr(v) || Fi(v) != $)
          return !1;
        var I = jl(v);
        if (I === null)
          return !0;
        var L = mr.call(I, "constructor") && I.constructor;
        return typeof L == "function" && L instanceof L && Rl.call(L) == jN;
      }
      var lv = Os ? gn(Os) : UD;
      function $R(v) {
        return A_(v) && v >= -_ && v <= _;
      }
      var D_ = hu ? gn(hu) : FD;
      function hd(v) {
        return typeof v == "string" || !Pt(v) && Gr(v) && Fi(v) == me;
      }
      function yn(v) {
        return typeof v == "symbol" || Gr(v) && Fi(v) == be;
      }
      var Ff = Eo ? gn(Eo) : $D;
      function qR(v) {
        return v === r;
      }
      function HR(v) {
        return Gr(v) && Oi(v) == Ge;
      }
      function WR(v) {
        return Gr(v) && Fi(v) == ye;
      }
      var VR = td(U1), GR = td(function(v, I) {
        return v <= I;
      });
      function C_(v) {
        if (!v)
          return [];
        if (nn(v))
          return hd(v) ? ls(v) : rn(v);
        if (du && v[du])
          return EN(v[du]());
        var I = Oi(v), L = I == ne ? A1 : I == ue ? Dl : $f;
        return L(v);
      }
      function ma(v) {
        if (!v)
          return v === 0 ? v : 0;
        if (v = Un(v), v === w || v === -w) {
          var I = v < 0 ? -1 : 1;
          return I * x;
        }
        return v === v ? v : 0;
      }
      function zt(v) {
        var I = ma(v), L = I % 1;
        return I === I ? L ? I - L : I : 0;
      }
      function O_(v) {
        return v ? No(zt(v), 0, y) : 0;
      }
      function Un(v) {
        if (typeof v == "number")
          return v;
        if (yn(v))
          return E;
        if (Hr(v)) {
          var I = typeof v.valueOf == "function" ? v.valueOf() : v;
          v = Hr(I) ? I + "" : I;
        }
        if (typeof v != "string")
          return v === 0 ? v : +v;
        v = Zw(v);
        var L = Qt.test(v);
        return L || Jt.test(v) ? Lt(v.slice(2), L ? 2 : 8) : Qe.test(v) ? E : +v;
      }
      function R_(v) {
        return Ls(v, sn(v));
      }
      function KR(v) {
        return v ? No(zt(v), -_, _) : v === 0 ? v : 0;
      }
      function gr(v) {
        return v == null ? "" : bn(v);
      }
      var YR = Bf(function(v, I) {
        if (Su(I) || nn(I)) {
          Ls(I, hi(I), v);
          return;
        }
        for (var L in I)
          mr.call(I, L) && yu(v, L, I[L]);
      }), L_ = Bf(function(v, I) {
        Ls(I, sn(I), v);
      }), ld = Bf(function(v, I, L, G) {
        Ls(I, sn(I), v, G);
      }), QR = Bf(function(v, I, L, G) {
        Ls(I, hi(I), v, G);
      }), ZR = ga(R1);
      function JR(v, I) {
        var L = jf(v);
        return I == null ? L : l3(L, I);
      }
      var XR = Ht(function(v, I) {
        v = Cr(v);
        var L = -1, G = I.length, ie = G > 2 ? I[2] : r;
        for (ie && $i(I[0], I[1], ie) && (G = 1); ++L < G; )
          for (var ce = I[L], de = sn(ce), ge = -1, xe = de.length; ++ge < xe; ) {
            var Xe = de[ge], et = v[Xe];
            (et === r || ps(et, Lf[Xe]) && !mr.call(v, Xe)) && (v[Xe] = ce[Xe]);
          }
        return v;
      }), eL = Ht(function(v) {
        return v.push(r, Z3), ui(P_, r, v);
      });
      function tL(v, I) {
        return Gw(v, At(I, 3), Rs);
      }
      function rL(v, I) {
        return Gw(v, At(I, 3), P1);
      }
      function iL(v, I) {
        return v == null ? v : L1(v, At(I, 3), sn);
      }
      function nL(v, I) {
        return v == null ? v : b3(v, At(I, 3), sn);
      }
      function sL(v, I) {
        return v && Rs(v, At(I, 3));
      }
      function aL(v, I) {
        return v && P1(v, At(I, 3));
      }
      function oL(v) {
        return v == null ? [] : Gl(v, hi(v));
      }
      function fL(v) {
        return v == null ? [] : Gl(v, sn(v));
      }
      function dv(v, I, L) {
        var G = v == null ? r : Do(v, I);
        return G === r ? L : G;
      }
      function cL(v, I) {
        return v != null && e_(v, I, OD);
      }
      function pv(v, I) {
        return v != null && e_(v, I, RD);
      }
      var uL = V3(function(v, I, L) {
        I != null && typeof I.toString != "function" && (I = Ll.call(I)), v[I] = L;
      }, gv(an)), hL = V3(function(v, I, L) {
        I != null && typeof I.toString != "function" && (I = Ll.call(I)), mr.call(v, I) ? v[I].push(L) : v[I] = [L];
      }, At), lL = Ht(wu);
      function hi(v) {
        return nn(v) ? u3(v) : z1(v);
      }
      function sn(v) {
        return nn(v) ? u3(v, !0) : qD(v);
      }
      function dL(v, I) {
        var L = {};
        return I = At(I, 3), Rs(v, function(G, ie, ce) {
          pa(L, I(G, ie, ce), G);
        }), L;
      }
      function pL(v, I) {
        var L = {};
        return I = At(I, 3), Rs(v, function(G, ie, ce) {
          pa(L, ie, I(G, ie, ce));
        }), L;
      }
      var vL = Bf(function(v, I, L) {
        Kl(v, I, L);
      }), P_ = Bf(function(v, I, L, G) {
        Kl(v, I, L, G);
      }), gL = ga(function(v, I) {
        var L = {};
        if (v == null)
          return L;
        var G = !1;
        I = Ur(I, function(ce) {
          return ce = Ha(ce, v), G || (G = ce.length > 1), ce;
        }), Ls(v, X1(v), L), G && (L = jn(L, m | b | M, uC));
        for (var ie = I.length; ie--; )
          W1(L, I[ie]);
        return L;
      });
      function bL(v, I) {
        return k_(v, cd(At(I)));
      }
      var yL = ga(function(v, I) {
        return v == null ? {} : WD(v, I);
      });
      function k_(v, I) {
        if (v == null)
          return {};
        var L = Ur(X1(v), function(G) {
          return [G];
        });
        return I = At(I), A3(v, L, function(G, ie) {
          return I(G, ie[0]);
        });
      }
      function mL(v, I, L) {
        I = Ha(I, v);
        var G = -1, ie = I.length;
        for (ie || (ie = 1, v = r); ++G < ie; ) {
          var ce = v == null ? r : v[Ps(I[G])];
          ce === r && (G = ie, ce = L), v = ya(ce) ? ce.call(v) : ce;
        }
        return v;
      }
      function wL(v, I, L) {
        return v == null ? v : Mu(v, I, L);
      }
      function _L(v, I, L, G) {
        return G = typeof G == "function" ? G : r, v == null ? v : Mu(v, I, L, G);
      }
      var j_ = Y3(hi), B_ = Y3(sn);
      function ML(v, I, L) {
        var G = Pt(v), ie = G || Va(v) || Ff(v);
        if (I = At(I, 4), L == null) {
          var ce = v && v.constructor;
          ie ? L = G ? new ce() : [] : Hr(v) ? L = ya(ce) ? jf(jl(v)) : {} : L = {};
        }
        return (ie ? Ln : Rs)(v, function(de, ge, xe) {
          return I(L, de, ge, xe);
        }), L;
      }
      function xL(v, I) {
        return v == null ? !0 : W1(v, I);
      }
      function SL(v, I, L) {
        return v == null ? v : O3(v, I, K1(L));
      }
      function EL(v, I, L, G) {
        return G = typeof G == "function" ? G : r, v == null ? v : O3(v, I, K1(L), G);
      }
      function $f(v) {
        return v == null ? [] : I1(v, hi(v));
      }
      function IL(v) {
        return v == null ? [] : I1(v, sn(v));
      }
      function AL(v, I, L) {
        return L === r && (L = I, I = r), L !== r && (L = Un(L), L = L === L ? L : 0), I !== r && (I = Un(I), I = I === I ? I : 0), No(Un(v), I, L);
      }
      function TL(v, I, L) {
        return I = ma(I), L === r ? (L = I, I = 0) : L = ma(L), v = Un(v), LD(v, I, L);
      }
      function NL(v, I, L) {
        if (L && typeof L != "boolean" && $i(v, I, L) && (I = L = r), L === r && (typeof I == "boolean" ? (L = I, I = r) : typeof v == "boolean" && (L = v, v = r)), v === r && I === r ? (v = 0, I = 1) : (v = ma(v), I === r ? (I = v, v = 0) : I = ma(I)), v > I) {
          var G = v;
          v = I, I = G;
        }
        if (L || v % 1 || I % 1) {
          var ie = f3();
          return Ci(v + ie * (I - v + Nr("1e-" + ((ie + "").length - 1))), I);
        }
        return $1(v, I);
      }
      var DL = zf(function(v, I, L) {
        return I = I.toLowerCase(), v + (L ? z_(I) : I);
      });
      function z_(v) {
        return vv(gr(v).toLowerCase());
      }
      function U_(v) {
        return v = gr(v), v && v.replace(kt, wN).replace(b1, "");
      }
      function CL(v, I, L) {
        v = gr(v), I = bn(I);
        var G = v.length;
        L = L === r ? G : No(zt(L), 0, G);
        var ie = L;
        return L -= I.length, L >= 0 && v.slice(L, ie) == I;
      }
      function OL(v) {
        return v = gr(v), v && ze.test(v) ? v.replace(Be, _N) : v;
      }
      function RL(v) {
        return v = gr(v), v && yt.test(v) ? v.replace(Ne, "\\$&") : v;
      }
      var LL = zf(function(v, I, L) {
        return v + (L ? "-" : "") + I.toLowerCase();
      }), PL = zf(function(v, I, L) {
        return v + (L ? " " : "") + I.toLowerCase();
      }), kL = q3("toLowerCase");
      function jL(v, I, L) {
        v = gr(v), I = zt(I);
        var G = I ? Of(v) : 0;
        if (!I || G >= I)
          return v;
        var ie = (I - G) / 2;
        return ed(Fl(ie), L) + v + ed(Ul(ie), L);
      }
      function BL(v, I, L) {
        v = gr(v), I = zt(I);
        var G = I ? Of(v) : 0;
        return I && G < I ? v + ed(I - G, L) : v;
      }
      function zL(v, I, L) {
        v = gr(v), I = zt(I);
        var G = I ? Of(v) : 0;
        return I && G < I ? ed(I - G, L) + v : v;
      }
      function UL(v, I, L) {
        return L || I == null ? I = 0 : I && (I = +I), GN(gr(v).replace($e, ""), I || 0);
      }
      function FL(v, I, L) {
        return (L ? $i(v, I, L) : I === r) ? I = 1 : I = zt(I), q1(gr(v), I);
      }
      function $L() {
        var v = arguments, I = gr(v[0]);
        return v.length < 3 ? I : I.replace(v[1], v[2]);
      }
      var qL = zf(function(v, I, L) {
        return v + (L ? "_" : "") + I.toLowerCase();
      });
      function HL(v, I, L) {
        return L && typeof L != "number" && $i(v, I, L) && (I = L = r), L = L === r ? y : L >>> 0, L ? (v = gr(v), v && (typeof I == "string" || I != null && !lv(I)) && (I = bn(I), !I && Cf(v)) ? Wa(ls(v), 0, L) : v.split(I, L)) : [];
      }
      var WL = zf(function(v, I, L) {
        return v + (L ? " " : "") + vv(I);
      });
      function VL(v, I, L) {
        return v = gr(v), L = L == null ? 0 : No(zt(L), 0, v.length), I = bn(I), v.slice(L, L + I.length) == I;
      }
      function GL(v, I, L) {
        var G = oe.templateSettings;
        L && $i(v, I, L) && (I = r), v = gr(v), I = ld({}, I, G, Q3);
        var ie = ld({}, I.imports, G.imports, Q3), ce = hi(ie), de = I1(ie, ce), ge, xe, Xe = 0, et = I.interpolate || ar, rt = "__p += '", ut = T1(
          (I.escape || ar).source + "|" + et.source + "|" + (et === Fe ? Dt : ar).source + "|" + (I.evaluate || ar).source + "|$",
          "g"
        ), _t = "//# sourceURL=" + (mr.call(I, "sourceURL") ? (I.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++y1 + "]") + `
`;
        v.replace(ut, function(Nt, Kt, nr, mn, qi, wn) {
          return nr || (nr = mn), rt += v.slice(Xe, wn).replace(lr, MN), Kt && (ge = !0, rt += `' +
__e(` + Kt + `) +
'`), qi && (xe = !0, rt += `';
` + qi + `;
__p += '`), nr && (rt += `' +
((__t = (` + nr + `)) == null ? '' : __t) +
'`), Xe = wn + Nt.length, Nt;
        }), rt += `';
`;
        var Tt = mr.call(I, "variable") && I.variable;
        if (!Tt)
          rt = `with (obj) {
` + rt + `
}
`;
        else if (Ze.test(Tt))
          throw new Ot(u);
        rt = (xe ? rt.replace(Ve, "") : rt).replace(ke, "$1").replace(Et, "$1;"), rt = "function(" + (Tt || "obj") + `) {
` + (Tt ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (ge ? ", __e = _.escape" : "") + (xe ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + rt + `return __p
}`;
        var $t = $_(function() {
          return vr(ce, _t + "return " + rt).apply(r, de);
        });
        if ($t.source = rt, hv($t))
          throw $t;
        return $t;
      }
      function KL(v) {
        return gr(v).toLowerCase();
      }
      function YL(v) {
        return gr(v).toUpperCase();
      }
      function QL(v, I, L) {
        if (v = gr(v), v && (L || I === r))
          return Zw(v);
        if (!v || !(I = bn(I)))
          return v;
        var G = ls(v), ie = ls(I), ce = Jw(G, ie), de = Xw(G, ie) + 1;
        return Wa(G, ce, de).join("");
      }
      function ZL(v, I, L) {
        if (v = gr(v), v && (L || I === r))
          return v.slice(0, t3(v) + 1);
        if (!v || !(I = bn(I)))
          return v;
        var G = ls(v), ie = Xw(G, ls(I)) + 1;
        return Wa(G, 0, ie).join("");
      }
      function JL(v, I, L) {
        if (v = gr(v), v && (L || I === r))
          return v.replace($e, "");
        if (!v || !(I = bn(I)))
          return v;
        var G = ls(v), ie = Jw(G, ls(I));
        return Wa(G, ie).join("");
      }
      function XL(v, I) {
        var L = se, G = W;
        if (Hr(I)) {
          var ie = "separator" in I ? I.separator : ie;
          L = "length" in I ? zt(I.length) : L, G = "omission" in I ? bn(I.omission) : G;
        }
        v = gr(v);
        var ce = v.length;
        if (Cf(v)) {
          var de = ls(v);
          ce = de.length;
        }
        if (L >= ce)
          return v;
        var ge = L - Of(G);
        if (ge < 1)
          return G;
        var xe = de ? Wa(de, 0, ge).join("") : v.slice(0, ge);
        if (ie === r)
          return xe + G;
        if (de && (ge += xe.length - ge), lv(ie)) {
          if (v.slice(ge).search(ie)) {
            var Xe, et = xe;
            for (ie.global || (ie = T1(ie.source, gr(We.exec(ie)) + "g")), ie.lastIndex = 0; Xe = ie.exec(et); )
              var rt = Xe.index;
            xe = xe.slice(0, rt === r ? ge : rt);
          }
        } else if (v.indexOf(bn(ie), ge) != ge) {
          var ut = xe.lastIndexOf(ie);
          ut > -1 && (xe = xe.slice(0, ut));
        }
        return xe + G;
      }
      function eP(v) {
        return v = gr(v), v && dt.test(v) ? v.replace(Ke, NN) : v;
      }
      var tP = zf(function(v, I, L) {
        return v + (L ? " " : "") + I.toUpperCase();
      }), vv = q3("toUpperCase");
      function F_(v, I, L) {
        return v = gr(v), I = L ? r : I, I === r ? SN(v) ? ON(v) : vN(v) : v.match(I) || [];
      }
      var $_ = Ht(function(v, I) {
        try {
          return ui(v, r, I);
        } catch (L) {
          return hv(L) ? L : new Ot(L);
        }
      }), rP = ga(function(v, I) {
        return Ln(I, function(L) {
          L = Ps(L), pa(v, L, cv(v[L], v));
        }), v;
      });
      function iP(v) {
        var I = v == null ? 0 : v.length, L = At();
        return v = I ? Ur(v, function(G) {
          if (typeof G[1] != "function")
            throw new Pn(f);
          return [L(G[0]), G[1]];
        }) : [], Ht(function(G) {
          for (var ie = -1; ++ie < I; ) {
            var ce = v[ie];
            if (ui(ce[0], this, G))
              return ui(ce[1], this, G);
          }
        });
      }
      function nP(v) {
        return ND(jn(v, m));
      }
      function gv(v) {
        return function() {
          return v;
        };
      }
      function sP(v, I) {
        return v == null || v !== v ? I : v;
      }
      var aP = W3(), oP = W3(!0);
      function an(v) {
        return v;
      }
      function bv(v) {
        return _3(typeof v == "function" ? v : jn(v, m));
      }
      function fP(v) {
        return x3(jn(v, m));
      }
      function cP(v, I) {
        return S3(v, jn(I, m));
      }
      var uP = Ht(function(v, I) {
        return function(L) {
          return wu(L, v, I);
        };
      }), hP = Ht(function(v, I) {
        return function(L) {
          return wu(v, L, I);
        };
      });
      function yv(v, I, L) {
        var G = hi(I), ie = Gl(I, G);
        L == null && !(Hr(I) && (ie.length || !G.length)) && (L = I, I = v, v = this, ie = Gl(I, hi(I)));
        var ce = !(Hr(L) && "chain" in L) || !!L.chain, de = ya(v);
        return Ln(ie, function(ge) {
          var xe = I[ge];
          v[ge] = xe, de && (v.prototype[ge] = function() {
            var Xe = this.__chain__;
            if (ce || Xe) {
              var et = v(this.__wrapped__), rt = et.__actions__ = rn(this.__actions__);
              return rt.push({ func: xe, args: arguments, thisArg: v }), et.__chain__ = Xe, et;
            }
            return xe.apply(v, za([this.value()], arguments));
          });
        }), v;
      }
      function lP() {
        return ir._ === this && (ir._ = BN), this;
      }
      function mv() {
      }
      function dP(v) {
        return v = zt(v), Ht(function(I) {
          return E3(I, v);
        });
      }
      var pP = Q1(Ur), vP = Q1(Vw), gP = Q1(_1);
      function q_(v) {
        return iv(v) ? M1(Ps(v)) : VD(v);
      }
      function bP(v) {
        return function(I) {
          return v == null ? r : Do(v, I);
        };
      }
      var yP = G3(), mP = G3(!0);
      function wv() {
        return [];
      }
      function _v() {
        return !1;
      }
      function wP() {
        return {};
      }
      function _P() {
        return "";
      }
      function MP() {
        return !0;
      }
      function xP(v, I) {
        if (v = zt(v), v < 1 || v > _)
          return [];
        var L = y, G = Ci(v, y);
        I = At(I), v -= y;
        for (var ie = E1(G, I); ++L < v; )
          I(L);
        return ie;
      }
      function SP(v) {
        return Pt(v) ? Ur(v, Ps) : yn(v) ? [v] : rn(c_(gr(v)));
      }
      function EP(v) {
        var I = ++kN;
        return gr(v) + I;
      }
      var IP = Xl(function(v, I) {
        return v + I;
      }, 0), AP = Z1("ceil"), TP = Xl(function(v, I) {
        return v / I;
      }, 1), NP = Z1("floor");
      function DP(v) {
        return v && v.length ? Vl(v, an, k1) : r;
      }
      function CP(v, I) {
        return v && v.length ? Vl(v, At(I, 2), k1) : r;
      }
      function OP(v) {
        return Yw(v, an);
      }
      function RP(v, I) {
        return Yw(v, At(I, 2));
      }
      function LP(v) {
        return v && v.length ? Vl(v, an, U1) : r;
      }
      function PP(v, I) {
        return v && v.length ? Vl(v, At(I, 2), U1) : r;
      }
      var kP = Xl(function(v, I) {
        return v * I;
      }, 1), jP = Z1("round"), BP = Xl(function(v, I) {
        return v - I;
      }, 0);
      function zP(v) {
        return v && v.length ? S1(v, an) : 0;
      }
      function UP(v, I) {
        return v && v.length ? S1(v, At(I, 2)) : 0;
      }
      return oe.after = fR, oe.ary = w_, oe.assign = YR, oe.assignIn = L_, oe.assignInWith = ld, oe.assignWith = QR, oe.at = ZR, oe.before = __, oe.bind = cv, oe.bindAll = rP, oe.bindKey = M_, oe.castArray = wR, oe.chain = b_, oe.chunk = NC, oe.compact = DC, oe.concat = CC, oe.cond = iP, oe.conforms = nP, oe.constant = gv, oe.countBy = zO, oe.create = JR, oe.curry = x_, oe.curryRight = S_, oe.debounce = E_, oe.defaults = XR, oe.defaultsDeep = eL, oe.defer = cR, oe.delay = uR, oe.difference = OC, oe.differenceBy = RC, oe.differenceWith = LC, oe.drop = PC, oe.dropRight = kC, oe.dropRightWhile = jC, oe.dropWhile = BC, oe.fill = zC, oe.filter = FO, oe.flatMap = HO, oe.flatMapDeep = WO, oe.flatMapDepth = VO, oe.flatten = d_, oe.flattenDeep = UC, oe.flattenDepth = FC, oe.flip = hR, oe.flow = aP, oe.flowRight = oP, oe.fromPairs = $C, oe.functions = oL, oe.functionsIn = fL, oe.groupBy = GO, oe.initial = HC, oe.intersection = WC, oe.intersectionBy = VC, oe.intersectionWith = GC, oe.invert = uL, oe.invertBy = hL, oe.invokeMap = YO, oe.iteratee = bv, oe.keyBy = QO, oe.keys = hi, oe.keysIn = sn, oe.map = ad, oe.mapKeys = dL, oe.mapValues = pL, oe.matches = fP, oe.matchesProperty = cP, oe.memoize = fd, oe.merge = vL, oe.mergeWith = P_, oe.method = uP, oe.methodOf = hP, oe.mixin = yv, oe.negate = cd, oe.nthArg = dP, oe.omit = gL, oe.omitBy = bL, oe.once = lR, oe.orderBy = ZO, oe.over = pP, oe.overArgs = dR, oe.overEvery = vP, oe.overSome = gP, oe.partial = uv, oe.partialRight = I_, oe.partition = JO, oe.pick = yL, oe.pickBy = k_, oe.property = q_, oe.propertyOf = bP, oe.pull = ZC, oe.pullAll = v_, oe.pullAllBy = JC, oe.pullAllWith = XC, oe.pullAt = eO, oe.range = yP, oe.rangeRight = mP, oe.rearg = pR, oe.reject = tR, oe.remove = tO, oe.rest = vR, oe.reverse = ov, oe.sampleSize = iR, oe.set = wL, oe.setWith = _L, oe.shuffle = nR, oe.slice = rO, oe.sortBy = oR, oe.sortedUniq = cO, oe.sortedUniqBy = uO, oe.split = HL, oe.spread = gR, oe.tail = hO, oe.take = lO, oe.takeRight = dO, oe.takeRightWhile = pO, oe.takeWhile = vO, oe.tap = DO, oe.throttle = bR, oe.thru = sd, oe.toArray = C_, oe.toPairs = j_, oe.toPairsIn = B_, oe.toPath = SP, oe.toPlainObject = R_, oe.transform = ML, oe.unary = yR, oe.union = gO, oe.unionBy = bO, oe.unionWith = yO, oe.uniq = mO, oe.uniqBy = wO, oe.uniqWith = _O, oe.unset = xL, oe.unzip = fv, oe.unzipWith = g_, oe.update = SL, oe.updateWith = EL, oe.values = $f, oe.valuesIn = IL, oe.without = MO, oe.words = F_, oe.wrap = mR, oe.xor = xO, oe.xorBy = SO, oe.xorWith = EO, oe.zip = IO, oe.zipObject = AO, oe.zipObjectDeep = TO, oe.zipWith = NO, oe.entries = j_, oe.entriesIn = B_, oe.extend = L_, oe.extendWith = ld, yv(oe, oe), oe.add = IP, oe.attempt = $_, oe.camelCase = DL, oe.capitalize = z_, oe.ceil = AP, oe.clamp = AL, oe.clone = _R, oe.cloneDeep = xR, oe.cloneDeepWith = SR, oe.cloneWith = MR, oe.conformsTo = ER, oe.deburr = U_, oe.defaultTo = sP, oe.divide = TP, oe.endsWith = CL, oe.eq = ps, oe.escape = OL, oe.escapeRegExp = RL, oe.every = UO, oe.find = $O, oe.findIndex = h_, oe.findKey = tL, oe.findLast = qO, oe.findLastIndex = l_, oe.findLastKey = rL, oe.floor = NP, oe.forEach = y_, oe.forEachRight = m_, oe.forIn = iL, oe.forInRight = nL, oe.forOwn = sL, oe.forOwnRight = aL, oe.get = dv, oe.gt = IR, oe.gte = AR, oe.has = cL, oe.hasIn = pv, oe.head = p_, oe.identity = an, oe.includes = KO, oe.indexOf = qC, oe.inRange = TL, oe.invoke = lL, oe.isArguments = Ro, oe.isArray = Pt, oe.isArrayBuffer = TR, oe.isArrayLike = nn, oe.isArrayLikeObject = ei, oe.isBoolean = NR, oe.isBuffer = Va, oe.isDate = DR, oe.isElement = CR, oe.isEmpty = OR, oe.isEqual = RR, oe.isEqualWith = LR, oe.isError = hv, oe.isFinite = PR, oe.isFunction = ya, oe.isInteger = A_, oe.isLength = ud, oe.isMap = T_, oe.isMatch = kR, oe.isMatchWith = jR, oe.isNaN = BR, oe.isNative = zR, oe.isNil = FR, oe.isNull = UR, oe.isNumber = N_, oe.isObject = Hr, oe.isObjectLike = Gr, oe.isPlainObject = Iu, oe.isRegExp = lv, oe.isSafeInteger = $R, oe.isSet = D_, oe.isString = hd, oe.isSymbol = yn, oe.isTypedArray = Ff, oe.isUndefined = qR, oe.isWeakMap = HR, oe.isWeakSet = WR, oe.join = KC, oe.kebabCase = LL, oe.last = zn, oe.lastIndexOf = YC, oe.lowerCase = PL, oe.lowerFirst = kL, oe.lt = VR, oe.lte = GR, oe.max = DP, oe.maxBy = CP, oe.mean = OP, oe.meanBy = RP, oe.min = LP, oe.minBy = PP, oe.stubArray = wv, oe.stubFalse = _v, oe.stubObject = wP, oe.stubString = _P, oe.stubTrue = MP, oe.multiply = kP, oe.nth = QC, oe.noConflict = lP, oe.noop = mv, oe.now = od, oe.pad = jL, oe.padEnd = BL, oe.padStart = zL, oe.parseInt = UL, oe.random = NL, oe.reduce = XO, oe.reduceRight = eR, oe.repeat = FL, oe.replace = $L, oe.result = mL, oe.round = jP, oe.runInContext = _e, oe.sample = rR, oe.size = sR, oe.snakeCase = qL, oe.some = aR, oe.sortedIndex = iO, oe.sortedIndexBy = nO, oe.sortedIndexOf = sO, oe.sortedLastIndex = aO, oe.sortedLastIndexBy = oO, oe.sortedLastIndexOf = fO, oe.startCase = WL, oe.startsWith = VL, oe.subtract = BP, oe.sum = zP, oe.sumBy = UP, oe.template = GL, oe.times = xP, oe.toFinite = ma, oe.toInteger = zt, oe.toLength = O_, oe.toLower = KL, oe.toNumber = Un, oe.toSafeInteger = KR, oe.toString = gr, oe.toUpper = YL, oe.trim = QL, oe.trimEnd = ZL, oe.trimStart = JL, oe.truncate = XL, oe.unescape = eP, oe.uniqueId = EP, oe.upperCase = tP, oe.upperFirst = vv, oe.each = y_, oe.eachRight = m_, oe.first = p_, yv(oe, function() {
        var v = {};
        return Rs(oe, function(I, L) {
          mr.call(oe.prototype, L) || (v[L] = I);
        }), v;
      }(), { chain: !1 }), oe.VERSION = i, Ln(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(v) {
        oe[v].placeholder = oe;
      }), Ln(["drop", "take"], function(v, I) {
        er.prototype[v] = function(L) {
          L = L === r ? 1 : fi(zt(L), 0);
          var G = this.__filtered__ && !I ? new er(this) : this.clone();
          return G.__filtered__ ? G.__takeCount__ = Ci(L, G.__takeCount__) : G.__views__.push({
            size: Ci(L, y),
            type: v + (G.__dir__ < 0 ? "Right" : "")
          }), G;
        }, er.prototype[v + "Right"] = function(L) {
          return this.reverse()[v](L).reverse();
        };
      }), Ln(["filter", "map", "takeWhile"], function(v, I) {
        var L = I + 1, G = L == a || L == p;
        er.prototype[v] = function(ie) {
          var ce = this.clone();
          return ce.__iteratees__.push({
            iteratee: At(ie, 3),
            type: L
          }), ce.__filtered__ = ce.__filtered__ || G, ce;
        };
      }), Ln(["head", "last"], function(v, I) {
        var L = "take" + (I ? "Right" : "");
        er.prototype[v] = function() {
          return this[L](1).value()[0];
        };
      }), Ln(["initial", "tail"], function(v, I) {
        var L = "drop" + (I ? "" : "Right");
        er.prototype[v] = function() {
          return this.__filtered__ ? new er(this) : this[L](1);
        };
      }), er.prototype.compact = function() {
        return this.filter(an);
      }, er.prototype.find = function(v) {
        return this.filter(v).head();
      }, er.prototype.findLast = function(v) {
        return this.reverse().find(v);
      }, er.prototype.invokeMap = Ht(function(v, I) {
        return typeof v == "function" ? new er(this) : this.map(function(L) {
          return wu(L, v, I);
        });
      }), er.prototype.reject = function(v) {
        return this.filter(cd(At(v)));
      }, er.prototype.slice = function(v, I) {
        v = zt(v);
        var L = this;
        return L.__filtered__ && (v > 0 || I < 0) ? new er(L) : (v < 0 ? L = L.takeRight(-v) : v && (L = L.drop(v)), I !== r && (I = zt(I), L = I < 0 ? L.dropRight(-I) : L.take(I - v)), L);
      }, er.prototype.takeRightWhile = function(v) {
        return this.reverse().takeWhile(v).reverse();
      }, er.prototype.toArray = function() {
        return this.take(y);
      }, Rs(er.prototype, function(v, I) {
        var L = /^(?:filter|find|map|reject)|While$/.test(I), G = /^(?:head|last)$/.test(I), ie = oe[G ? "take" + (I == "last" ? "Right" : "") : I], ce = G || /^find/.test(I);
        !ie || (oe.prototype[I] = function() {
          var de = this.__wrapped__, ge = G ? [1] : arguments, xe = de instanceof er, Xe = ge[0], et = xe || Pt(de), rt = function(Kt) {
            var nr = ie.apply(oe, za([Kt], ge));
            return G && ut ? nr[0] : nr;
          };
          et && L && typeof Xe == "function" && Xe.length != 1 && (xe = et = !1);
          var ut = this.__chain__, _t = !!this.__actions__.length, Tt = ce && !ut, $t = xe && !_t;
          if (!ce && et) {
            de = $t ? de : new er(this);
            var Nt = v.apply(de, ge);
            return Nt.__actions__.push({ func: sd, args: [rt], thisArg: r }), new kn(Nt, ut);
          }
          return Tt && $t ? v.apply(this, ge) : (Nt = this.thru(rt), Tt ? G ? Nt.value()[0] : Nt.value() : Nt);
        });
      }), Ln(["pop", "push", "shift", "sort", "splice", "unshift"], function(v) {
        var I = Cl[v], L = /^(?:push|sort|unshift)$/.test(v) ? "tap" : "thru", G = /^(?:pop|shift)$/.test(v);
        oe.prototype[v] = function() {
          var ie = arguments;
          if (G && !this.__chain__) {
            var ce = this.value();
            return I.apply(Pt(ce) ? ce : [], ie);
          }
          return this[L](function(de) {
            return I.apply(Pt(de) ? de : [], ie);
          });
        };
      }), Rs(er.prototype, function(v, I) {
        var L = oe[I];
        if (L) {
          var G = L.name + "";
          mr.call(kf, G) || (kf[G] = []), kf[G].push({ name: I, func: L });
        }
      }), kf[Jl(r, O).name] = [{
        name: "wrapper",
        func: r
      }], er.prototype.clone = eD, er.prototype.reverse = tD, er.prototype.value = rD, oe.prototype.at = CO, oe.prototype.chain = OO, oe.prototype.commit = RO, oe.prototype.next = LO, oe.prototype.plant = kO, oe.prototype.reverse = jO, oe.prototype.toJSON = oe.prototype.valueOf = oe.prototype.value = BO, oe.prototype.first = oe.prototype.head, du && (oe.prototype[du] = PO), oe;
    }, Rf = RN();
    Xr ? ((Xr.exports = Rf)._ = Rf, Dr._ = Rf) : ir._ = Rf;
  }).call(nt);
})(Wm, Wm.exports);
var Vm = { exports: {} };
(function(t, e) {
  var r = typeof self < "u" ? self : nt, i = function() {
    function n() {
      this.fetch = !1, this.DOMException = r.DOMException;
    }
    return n.prototype = r, new n();
  }();
  (function(n) {
    (function(f) {
      var u = {
        searchParams: "URLSearchParams" in n,
        iterable: "Symbol" in n && "iterator" in Symbol,
        blob: "FileReader" in n && "Blob" in n && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in n,
        arrayBuffer: "ArrayBuffer" in n
      };
      function h(a) {
        return a && DataView.prototype.isPrototypeOf(a);
      }
      if (u.arrayBuffer)
        var d = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], l = ArrayBuffer.isView || function(a) {
          return a && d.indexOf(Object.prototype.toString.call(a)) > -1;
        };
      function m(a) {
        if (typeof a != "string" && (a = String(a)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(a))
          throw new TypeError("Invalid character in header field name");
        return a.toLowerCase();
      }
      function b(a) {
        return typeof a != "string" && (a = String(a)), a;
      }
      function M(a) {
        var c = {
          next: function() {
            var p = a.shift();
            return { done: p === void 0, value: p };
          }
        };
        return u.iterable && (c[Symbol.iterator] = function() {
          return c;
        }), c;
      }
      function A(a) {
        this.map = {}, a instanceof A ? a.forEach(function(c, p) {
          this.append(p, c);
        }, this) : Array.isArray(a) ? a.forEach(function(c) {
          this.append(c[0], c[1]);
        }, this) : a && Object.getOwnPropertyNames(a).forEach(function(c) {
          this.append(c, a[c]);
        }, this);
      }
      A.prototype.append = function(a, c) {
        a = m(a), c = b(c);
        var p = this.map[a];
        this.map[a] = p ? p + ", " + c : c;
      }, A.prototype.delete = function(a) {
        delete this.map[m(a)];
      }, A.prototype.get = function(a) {
        return a = m(a), this.has(a) ? this.map[a] : null;
      }, A.prototype.has = function(a) {
        return this.map.hasOwnProperty(m(a));
      }, A.prototype.set = function(a, c) {
        this.map[m(a)] = b(c);
      }, A.prototype.forEach = function(a, c) {
        for (var p in this.map)
          this.map.hasOwnProperty(p) && a.call(c, this.map[p], p, this);
      }, A.prototype.keys = function() {
        var a = [];
        return this.forEach(function(c, p) {
          a.push(p);
        }), M(a);
      }, A.prototype.values = function() {
        var a = [];
        return this.forEach(function(c) {
          a.push(c);
        }), M(a);
      }, A.prototype.entries = function() {
        var a = [];
        return this.forEach(function(c, p) {
          a.push([p, c]);
        }), M(a);
      }, u.iterable && (A.prototype[Symbol.iterator] = A.prototype.entries);
      function N(a) {
        if (a.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        a.bodyUsed = !0;
      }
      function R(a) {
        return new Promise(function(c, p) {
          a.onload = function() {
            c(a.result);
          }, a.onerror = function() {
            p(a.error);
          };
        });
      }
      function O(a) {
        var c = new FileReader(), p = R(c);
        return c.readAsArrayBuffer(a), p;
      }
      function P(a) {
        var c = new FileReader(), p = R(c);
        return c.readAsText(a), p;
      }
      function F(a) {
        for (var c = new Uint8Array(a), p = new Array(c.length), w = 0; w < c.length; w++)
          p[w] = String.fromCharCode(c[w]);
        return p.join("");
      }
      function H(a) {
        if (a.slice)
          return a.slice(0);
        var c = new Uint8Array(a.byteLength);
        return c.set(new Uint8Array(a)), c.buffer;
      }
      function Q() {
        return this.bodyUsed = !1, this._initBody = function(a) {
          this._bodyInit = a, a ? typeof a == "string" ? this._bodyText = a : u.blob && Blob.prototype.isPrototypeOf(a) ? this._bodyBlob = a : u.formData && FormData.prototype.isPrototypeOf(a) ? this._bodyFormData = a : u.searchParams && URLSearchParams.prototype.isPrototypeOf(a) ? this._bodyText = a.toString() : u.arrayBuffer && u.blob && h(a) ? (this._bodyArrayBuffer = H(a.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : u.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(a) || l(a)) ? this._bodyArrayBuffer = H(a) : this._bodyText = a = Object.prototype.toString.call(a) : this._bodyText = "", this.headers.get("content-type") || (typeof a == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : u.searchParams && URLSearchParams.prototype.isPrototypeOf(a) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, u.blob && (this.blob = function() {
          var a = N(this);
          if (a)
            return a;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? N(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(O);
        }), this.text = function() {
          var a = N(this);
          if (a)
            return a;
          if (this._bodyBlob)
            return P(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(F(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, u.formData && (this.formData = function() {
          return this.text().then(ae);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var Z = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function B(a) {
        var c = a.toUpperCase();
        return Z.indexOf(c) > -1 ? c : a;
      }
      function Y(a, c) {
        c = c || {};
        var p = c.body;
        if (a instanceof Y) {
          if (a.bodyUsed)
            throw new TypeError("Already read");
          this.url = a.url, this.credentials = a.credentials, c.headers || (this.headers = new A(a.headers)), this.method = a.method, this.mode = a.mode, this.signal = a.signal, !p && a._bodyInit != null && (p = a._bodyInit, a.bodyUsed = !0);
        } else
          this.url = String(a);
        if (this.credentials = c.credentials || this.credentials || "same-origin", (c.headers || !this.headers) && (this.headers = new A(c.headers)), this.method = B(c.method || this.method || "GET"), this.mode = c.mode || this.mode || null, this.signal = c.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && p)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(p);
      }
      Y.prototype.clone = function() {
        return new Y(this, { body: this._bodyInit });
      };
      function ae(a) {
        var c = new FormData();
        return a.trim().split("&").forEach(function(p) {
          if (p) {
            var w = p.split("="), _ = w.shift().replace(/\+/g, " "), x = w.join("=").replace(/\+/g, " ");
            c.append(decodeURIComponent(_), decodeURIComponent(x));
          }
        }), c;
      }
      function se(a) {
        var c = new A(), p = a.replace(/\r?\n[\t ]+/g, " ");
        return p.split(/\r?\n/).forEach(function(w) {
          var _ = w.split(":"), x = _.shift().trim();
          if (x) {
            var E = _.join(":").trim();
            c.append(x, E);
          }
        }), c;
      }
      Q.call(Y.prototype);
      function W(a, c) {
        c || (c = {}), this.type = "default", this.status = c.status === void 0 ? 200 : c.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in c ? c.statusText : "OK", this.headers = new A(c.headers), this.url = c.url || "", this._initBody(a);
      }
      Q.call(W.prototype), W.prototype.clone = function() {
        return new W(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new A(this.headers),
          url: this.url
        });
      }, W.error = function() {
        var a = new W(null, { status: 0, statusText: "" });
        return a.type = "error", a;
      };
      var C = [301, 302, 303, 307, 308];
      W.redirect = function(a, c) {
        if (C.indexOf(c) === -1)
          throw new RangeError("Invalid status code");
        return new W(null, { status: c, headers: { location: a } });
      }, f.DOMException = n.DOMException;
      try {
        new f.DOMException();
      } catch {
        f.DOMException = function(c, p) {
          this.message = c, this.name = p;
          var w = Error(c);
          this.stack = w.stack;
        }, f.DOMException.prototype = Object.create(Error.prototype), f.DOMException.prototype.constructor = f.DOMException;
      }
      function g(a, c) {
        return new Promise(function(p, w) {
          var _ = new Y(a, c);
          if (_.signal && _.signal.aborted)
            return w(new f.DOMException("Aborted", "AbortError"));
          var x = new XMLHttpRequest();
          function E() {
            x.abort();
          }
          x.onload = function() {
            var y = {
              status: x.status,
              statusText: x.statusText,
              headers: se(x.getAllResponseHeaders() || "")
            };
            y.url = "responseURL" in x ? x.responseURL : y.headers.get("X-Request-URL");
            var o = "response" in x ? x.response : x.responseText;
            p(new W(o, y));
          }, x.onerror = function() {
            w(new TypeError("Network request failed"));
          }, x.ontimeout = function() {
            w(new TypeError("Network request failed"));
          }, x.onabort = function() {
            w(new f.DOMException("Aborted", "AbortError"));
          }, x.open(_.method, _.url, !0), _.credentials === "include" ? x.withCredentials = !0 : _.credentials === "omit" && (x.withCredentials = !1), "responseType" in x && u.blob && (x.responseType = "blob"), _.headers.forEach(function(y, o) {
            x.setRequestHeader(o, y);
          }), _.signal && (_.signal.addEventListener("abort", E), x.onreadystatechange = function() {
            x.readyState === 4 && _.signal.removeEventListener("abort", E);
          }), x.send(typeof _._bodyInit > "u" ? null : _._bodyInit);
        });
      }
      return g.polyfill = !0, n.fetch || (n.fetch = g, n.Headers = A, n.Request = Y, n.Response = W), f.Headers = A, f.Request = Y, f.Response = W, f.fetch = g, Object.defineProperty(f, "__esModule", { value: !0 }), f;
    })({});
  })(i), i.fetch.ponyfill = !0, delete i.fetch.polyfill;
  var s = i;
  e = s.fetch, e.default = s.fetch, e.fetch = s.fetch, e.Headers = s.Headers, e.Request = s.Request, e.Response = s.Response, t.exports = e;
})(Vm, Vm.exports);
const rS = /* @__PURE__ */ PS(Vm.exports);
var Xhe = Object.defineProperty, ele = Object.defineProperties, tle = Object.getOwnPropertyDescriptors, iS = Object.getOwnPropertySymbols, rle = Object.prototype.hasOwnProperty, ile = Object.prototype.propertyIsEnumerable, nS = (t, e, r) => e in t ? Xhe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, sS = (t, e) => {
  for (var r in e || (e = {}))
    rle.call(e, r) && nS(t, r, e[r]);
  if (iS)
    for (var r of iS(e))
      ile.call(e, r) && nS(t, r, e[r]);
  return t;
}, aS = (t, e) => ele(t, tle(e));
const nle = { Accept: "application/json", "Content-Type": "application/json" }, sle = "POST", oS = { headers: nle, method: sle }, fS = 10;
class ua {
  constructor(e, r = !1) {
    if (this.url = e, this.disableProviderPing = r, this.events = new Pr.exports.EventEmitter(), this.isAvailable = !1, this.registering = !1, !Tx(e))
      throw new Error(`Provided URL is not compatible with HTTP connection: ${e}`);
    this.url = e, this.disableProviderPing = r;
  }
  get connected() {
    return this.isAvailable;
  }
  get connecting() {
    return this.registering;
  }
  on(e, r) {
    this.events.on(e, r);
  }
  once(e, r) {
    this.events.once(e, r);
  }
  off(e, r) {
    this.events.off(e, r);
  }
  removeListener(e, r) {
    this.events.removeListener(e, r);
  }
  async open(e = this.url) {
    await this.register(e);
  }
  async close() {
    if (!this.isAvailable)
      throw new Error("Connection already closed");
    this.onClose();
  }
  async send(e) {
    this.isAvailable || await this.register();
    try {
      const r = Pa(e), i = await (await rS(this.url, aS(sS({}, oS), { body: r }))).json();
      this.onPayload({ data: i });
    } catch (r) {
      this.onError(e.id, r);
    }
  }
  async register(e = this.url) {
    if (!Tx(e))
      throw new Error(`Provided URL is not compatible with HTTP connection: ${e}`);
    if (this.registering) {
      const r = this.events.getMaxListeners();
      return (this.events.listenerCount("register_error") >= r || this.events.listenerCount("open") >= r) && this.events.setMaxListeners(r + 1), new Promise((i, s) => {
        this.events.once("register_error", (n) => {
          this.resetMaxListeners(), s(n);
        }), this.events.once("open", () => {
          if (this.resetMaxListeners(), typeof this.isAvailable > "u")
            return s(new Error("HTTP connection is missing or invalid"));
          i();
        });
      });
    }
    this.url = e, this.registering = !0;
    try {
      if (!this.disableProviderPing) {
        const r = Pa({ id: 1, jsonrpc: "2.0", method: "test", params: [] });
        await rS(e, aS(sS({}, oS), { body: r }));
      }
      this.onOpen();
    } catch (r) {
      const i = this.parseError(r);
      throw this.events.emit("register_error", i), this.onClose(), i;
    }
  }
  onOpen() {
    this.isAvailable = !0, this.registering = !1, this.events.emit("open");
  }
  onClose() {
    this.isAvailable = !1, this.registering = !1, this.events.emit("close");
  }
  onPayload(e) {
    if (typeof e.data > "u")
      return;
    const r = typeof e.data == "string" ? uf(e.data) : e.data;
    this.events.emit("payload", r);
  }
  onError(e, r) {
    const i = this.parseError(r), s = i.message || i.toString(), n = c1(e, s);
    this.events.emit("payload", n);
  }
  parseError(e, r = this.url) {
    return PT(e, r, "HTTP");
  }
  resetMaxListeners() {
    this.events.getMaxListeners() > fS && this.events.setMaxListeners(fS);
  }
}
const cS = "error", ale = "wss://relay.walletconnect.org", ole = "wc", fle = "universal_provider", uS = `${ole}@2:${fle}:`, sN = "https://rpc.walletconnect.org/v1/", tc = "generic", cle = `${sN}bundler`, Ds = { DEFAULT_CHAIN_CHANGED: "default_chain_changed" };
var ule = Object.defineProperty, hle = Object.defineProperties, lle = Object.getOwnPropertyDescriptors, hS = Object.getOwnPropertySymbols, dle = Object.prototype.hasOwnProperty, ple = Object.prototype.propertyIsEnumerable, lS = (t, e, r) => e in t ? ule(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Fd = (t, e) => {
  for (var r in e || (e = {}))
    dle.call(e, r) && lS(t, r, e[r]);
  if (hS)
    for (var r of hS(e))
      ple.call(e, r) && lS(t, r, e[r]);
  return t;
}, vle = (t, e) => hle(t, lle(e));
function Ts(t, e, r) {
  var i;
  const s = vc(t);
  return ((i = e.rpcMap) == null ? void 0 : i[s.reference]) || `${sN}?chainId=${s.namespace}:${s.reference}&projectId=${r}`;
}
function Ef(t) {
  return t.includes(":") ? t.split(":")[1] : t;
}
function aN(t) {
  return t.map((e) => `${e.split(":")[0]}:${e.split(":")[1]}`);
}
function gle(t, e) {
  const r = Object.keys(e.namespaces).filter((s) => s.includes(t));
  if (!r.length)
    return [];
  const i = [];
  return r.forEach((s) => {
    const n = e.namespaces[s].accounts;
    i.push(...n);
  }), i;
}
function Hy(t = {}, e = {}) {
  const r = dS(t), i = dS(e);
  return Wm.exports.merge(r, i);
}
function dS(t) {
  var e, r, i, s;
  const n = {};
  if (!Mh(t))
    return n;
  for (const [f, u] of Object.entries(t)) {
    const h = Lw(f) ? [f] : u.chains, d = u.methods || [], l = u.events || [], m = u.rpcMap || {}, b = Yu(f);
    n[b] = vle(Fd(Fd({}, n[b]), u), { chains: t0(h, (e = n[b]) == null ? void 0 : e.chains), methods: t0(d, (r = n[b]) == null ? void 0 : r.methods), events: t0(l, (i = n[b]) == null ? void 0 : i.events), rpcMap: Fd(Fd({}, m), (s = n[b]) == null ? void 0 : s.rpcMap) });
  }
  return n;
}
function ble(t) {
  return t.includes(":") ? t.split(":")[2] : t;
}
function pS(t) {
  const e = {};
  for (const [r, i] of Object.entries(t)) {
    const s = i.methods || [], n = i.events || [], f = i.accounts || [], u = Lw(r) ? [r] : i.chains ? i.chains : aN(i.accounts);
    e[r] = { chains: u, methods: s, events: n, accounts: f };
  }
  return e;
}
function Wy(t) {
  return typeof t == "number" ? t : t.includes("0x") ? parseInt(t, 16) : (t = t.includes(":") ? t.split(":")[1] : t, isNaN(Number(t)) ? t : Number(t));
}
const oN = {}, yr = (t) => oN[t], Vy = (t, e) => {
  oN[t] = e;
};
class yle {
  constructor(e) {
    this.name = "polkadot", this.namespace = e.namespace, this.events = yr("events"), this.client = yr("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(e) {
    this.namespace = Object.assign(this.namespace, e);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  getDefaultChain() {
    if (this.chainId)
      return this.chainId;
    if (this.namespace.defaultChain)
      return this.namespace.defaultChain;
    const e = this.namespace.chains[0];
    if (!e)
      throw new Error("ChainId not found");
    return e.split(":")[1];
  }
  request(e) {
    return this.namespace.methods.includes(e.request.method) ? this.client.request(e) : this.getHttpProvider().request(e.request);
  }
  setDefaultChain(e, r) {
    this.httpProviders[e] || this.setHttpProvider(e, r), this.chainId = e, this.events.emit(Ds.DEFAULT_CHAIN_CHANGED, `${this.name}:${e}`);
  }
  getAccounts() {
    const e = this.namespace.accounts;
    return e ? e.filter((r) => r.split(":")[1] === this.chainId.toString()).map((r) => r.split(":")[2]) || [] : [];
  }
  createHttpProviders() {
    const e = {};
    return this.namespace.chains.forEach((r) => {
      var i;
      const s = Ef(r);
      e[s] = this.createHttpProvider(s, (i = this.namespace.rpcMap) == null ? void 0 : i[r]);
    }), e;
  }
  getHttpProvider() {
    const e = `${this.name}:${this.chainId}`, r = this.httpProviders[e];
    if (typeof r > "u")
      throw new Error(`JSON-RPC provider for ${e} not found`);
    return r;
  }
  setHttpProvider(e, r) {
    const i = this.createHttpProvider(e, r);
    i && (this.httpProviders[e] = i);
  }
  createHttpProvider(e, r) {
    const i = r || Ts(e, this.namespace, this.client.core.projectId);
    if (!i)
      throw new Error(`No RPC url provided for chainId: ${e}`);
    return new Ns(new ua(i, yr("disableProviderPing")));
  }
}
var mle = Object.defineProperty, wle = Object.defineProperties, _le = Object.getOwnPropertyDescriptors, vS = Object.getOwnPropertySymbols, Mle = Object.prototype.hasOwnProperty, xle = Object.prototype.propertyIsEnumerable, gS = (t, e, r) => e in t ? mle(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, bS = (t, e) => {
  for (var r in e || (e = {}))
    Mle.call(e, r) && gS(t, r, e[r]);
  if (vS)
    for (var r of vS(e))
      xle.call(e, r) && gS(t, r, e[r]);
  return t;
}, yS = (t, e) => wle(t, _le(e));
class Sle {
  constructor(e) {
    this.name = "eip155", this.namespace = e.namespace, this.events = yr("events"), this.client = yr("client"), this.httpProviders = this.createHttpProviders(), this.chainId = parseInt(this.getDefaultChain());
  }
  async request(e) {
    switch (e.request.method) {
      case "eth_requestAccounts":
        return this.getAccounts();
      case "eth_accounts":
        return this.getAccounts();
      case "wallet_switchEthereumChain":
        return await this.handleSwitchChain(e);
      case "eth_chainId":
        return parseInt(this.getDefaultChain());
      case "wallet_getCapabilities":
        return await this.getCapabilities(e);
      case "wallet_getCallsStatus":
        return await this.getCallStatus(e);
    }
    return this.namespace.methods.includes(e.request.method) ? await this.client.request(e) : this.getHttpProvider().request(e.request);
  }
  updateNamespace(e) {
    this.namespace = Object.assign(this.namespace, e);
  }
  setDefaultChain(e, r) {
    this.httpProviders[e] || this.setHttpProvider(parseInt(e), r), this.chainId = parseInt(e), this.events.emit(Ds.DEFAULT_CHAIN_CHANGED, `${this.name}:${e}`);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  getDefaultChain() {
    if (this.chainId)
      return this.chainId.toString();
    if (this.namespace.defaultChain)
      return this.namespace.defaultChain;
    const e = this.namespace.chains[0];
    if (!e)
      throw new Error("ChainId not found");
    return e.split(":")[1];
  }
  createHttpProvider(e, r) {
    const i = r || Ts(`${this.name}:${e}`, this.namespace, this.client.core.projectId);
    if (!i)
      throw new Error(`No RPC url provided for chainId: ${e}`);
    return new Ns(new ua(i, yr("disableProviderPing")));
  }
  setHttpProvider(e, r) {
    const i = this.createHttpProvider(e, r);
    i && (this.httpProviders[e] = i);
  }
  createHttpProviders() {
    const e = {};
    return this.namespace.chains.forEach((r) => {
      var i;
      const s = parseInt(Ef(r));
      e[s] = this.createHttpProvider(s, (i = this.namespace.rpcMap) == null ? void 0 : i[r]);
    }), e;
  }
  getAccounts() {
    const e = this.namespace.accounts;
    return e ? [...new Set(e.filter((r) => r.split(":")[1] === this.chainId.toString()).map((r) => r.split(":")[2]))] : [];
  }
  getHttpProvider() {
    const e = this.chainId, r = this.httpProviders[e];
    if (typeof r > "u")
      throw new Error(`JSON-RPC provider for ${e} not found`);
    return r;
  }
  async handleSwitchChain(e) {
    var r, i;
    let s = e.request.params ? (r = e.request.params[0]) == null ? void 0 : r.chainId : "0x0";
    s = s.startsWith("0x") ? s : `0x${s}`;
    const n = parseInt(s, 16);
    if (this.isChainApproved(n))
      this.setDefaultChain(`${n}`);
    else if (this.namespace.methods.includes("wallet_switchEthereumChain"))
      await this.client.request({ topic: e.topic, request: { method: e.request.method, params: [{ chainId: s }] }, chainId: (i = this.namespace.chains) == null ? void 0 : i[0] }), this.setDefaultChain(`${n}`);
    else
      throw new Error(`Failed to switch to chain 'eip155:${n}'. The chain is not approved or the wallet does not support 'wallet_switchEthereumChain' method.`);
    return null;
  }
  isChainApproved(e) {
    return this.namespace.chains.includes(`${this.name}:${e}`);
  }
  async getCapabilities(e) {
    var r, i, s;
    const n = (i = (r = e.request) == null ? void 0 : r.params) == null ? void 0 : i[0];
    if (!n)
      throw new Error("Missing address parameter in `wallet_getCapabilities` request");
    const f = this.client.session.get(e.topic), u = ((s = f == null ? void 0 : f.sessionProperties) == null ? void 0 : s.capabilities) || {};
    if (u != null && u[n])
      return u == null ? void 0 : u[n];
    const h = await this.client.request(e);
    try {
      await this.client.session.update(e.topic, { sessionProperties: yS(bS({}, f.sessionProperties || {}), { capabilities: yS(bS({}, u || {}), { [n]: h }) }) });
    } catch (d) {
      console.warn("Failed to update session with capabilities", d);
    }
    return h;
  }
  async getCallStatus(e) {
    var r, i;
    const s = this.client.session.get(e.topic), n = (r = s.sessionProperties) == null ? void 0 : r.bundler_name;
    if (n) {
      const u = this.getBundlerUrl(e.chainId, n);
      try {
        return await this.getUserOperationReceipt(u, e);
      } catch (h) {
        console.warn("Failed to fetch call status from bundler", h, u);
      }
    }
    const f = (i = s.sessionProperties) == null ? void 0 : i.bundler_url;
    if (f)
      try {
        return await this.getUserOperationReceipt(f, e);
      } catch (u) {
        console.warn("Failed to fetch call status from custom bundler", u, f);
      }
    if (this.namespace.methods.includes(e.request.method))
      return await this.client.request(e);
    throw new Error("Fetching call status not approved by the wallet.");
  }
  async getUserOperationReceipt(e, r) {
    var i;
    const s = new URL(e), n = await fetch(s, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(no("eth_getUserOperationReceipt", [(i = r.request.params) == null ? void 0 : i[0]])) });
    if (!n.ok)
      throw new Error(`Failed to fetch user operation receipt - ${n.status}`);
    return await n.json();
  }
  getBundlerUrl(e, r) {
    return `${cle}?projectId=${this.client.core.projectId}&chainId=${e}&bundler=${r}`;
  }
}
class Ele {
  constructor(e) {
    this.name = "solana", this.namespace = e.namespace, this.events = yr("events"), this.client = yr("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(e) {
    this.namespace = Object.assign(this.namespace, e);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  request(e) {
    return this.namespace.methods.includes(e.request.method) ? this.client.request(e) : this.getHttpProvider().request(e.request);
  }
  setDefaultChain(e, r) {
    this.httpProviders[e] || this.setHttpProvider(e, r), this.chainId = e, this.events.emit(Ds.DEFAULT_CHAIN_CHANGED, `${this.name}:${e}`);
  }
  getDefaultChain() {
    if (this.chainId)
      return this.chainId;
    if (this.namespace.defaultChain)
      return this.namespace.defaultChain;
    const e = this.namespace.chains[0];
    if (!e)
      throw new Error("ChainId not found");
    return e.split(":")[1];
  }
  getAccounts() {
    const e = this.namespace.accounts;
    return e ? [...new Set(e.filter((r) => r.split(":")[1] === this.chainId.toString()).map((r) => r.split(":")[2]))] : [];
  }
  createHttpProviders() {
    const e = {};
    return this.namespace.chains.forEach((r) => {
      var i;
      const s = Ef(r);
      e[s] = this.createHttpProvider(s, (i = this.namespace.rpcMap) == null ? void 0 : i[r]);
    }), e;
  }
  getHttpProvider() {
    const e = `${this.name}:${this.chainId}`, r = this.httpProviders[e];
    if (typeof r > "u")
      throw new Error(`JSON-RPC provider for ${e} not found`);
    return r;
  }
  setHttpProvider(e, r) {
    const i = this.createHttpProvider(e, r);
    i && (this.httpProviders[e] = i);
  }
  createHttpProvider(e, r) {
    const i = r || Ts(e, this.namespace, this.client.core.projectId);
    if (!i)
      throw new Error(`No RPC url provided for chainId: ${e}`);
    return new Ns(new ua(i, yr("disableProviderPing")));
  }
}
class Ile {
  constructor(e) {
    this.name = "cosmos", this.namespace = e.namespace, this.events = yr("events"), this.client = yr("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(e) {
    this.namespace = Object.assign(this.namespace, e);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  getDefaultChain() {
    if (this.chainId)
      return this.chainId;
    if (this.namespace.defaultChain)
      return this.namespace.defaultChain;
    const e = this.namespace.chains[0];
    if (!e)
      throw new Error("ChainId not found");
    return e.split(":")[1];
  }
  request(e) {
    return this.namespace.methods.includes(e.request.method) ? this.client.request(e) : this.getHttpProvider().request(e.request);
  }
  setDefaultChain(e, r) {
    this.httpProviders[e] || this.setHttpProvider(e, r), this.chainId = e, this.events.emit(Ds.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
  }
  getAccounts() {
    const e = this.namespace.accounts;
    return e ? [...new Set(e.filter((r) => r.split(":")[1] === this.chainId.toString()).map((r) => r.split(":")[2]))] : [];
  }
  createHttpProviders() {
    const e = {};
    return this.namespace.chains.forEach((r) => {
      var i;
      const s = Ef(r);
      e[s] = this.createHttpProvider(s, (i = this.namespace.rpcMap) == null ? void 0 : i[r]);
    }), e;
  }
  getHttpProvider() {
    const e = `${this.name}:${this.chainId}`, r = this.httpProviders[e];
    if (typeof r > "u")
      throw new Error(`JSON-RPC provider for ${e} not found`);
    return r;
  }
  setHttpProvider(e, r) {
    const i = this.createHttpProvider(e, r);
    i && (this.httpProviders[e] = i);
  }
  createHttpProvider(e, r) {
    const i = r || Ts(e, this.namespace, this.client.core.projectId);
    if (!i)
      throw new Error(`No RPC url provided for chainId: ${e}`);
    return new Ns(new ua(i, yr("disableProviderPing")));
  }
}
class Ale {
  constructor(e) {
    this.name = "algorand", this.namespace = e.namespace, this.events = yr("events"), this.client = yr("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(e) {
    this.namespace = Object.assign(this.namespace, e);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  request(e) {
    return this.namespace.methods.includes(e.request.method) ? this.client.request(e) : this.getHttpProvider().request(e.request);
  }
  setDefaultChain(e, r) {
    if (!this.httpProviders[e]) {
      const i = r || Ts(`${this.name}:${e}`, this.namespace, this.client.core.projectId);
      if (!i)
        throw new Error(`No RPC url provided for chainId: ${e}`);
      this.setHttpProvider(e, i);
    }
    this.chainId = e, this.events.emit(Ds.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
  }
  getDefaultChain() {
    if (this.chainId)
      return this.chainId;
    if (this.namespace.defaultChain)
      return this.namespace.defaultChain;
    const e = this.namespace.chains[0];
    if (!e)
      throw new Error("ChainId not found");
    return e.split(":")[1];
  }
  getAccounts() {
    const e = this.namespace.accounts;
    return e ? [...new Set(e.filter((r) => r.split(":")[1] === this.chainId.toString()).map((r) => r.split(":")[2]))] : [];
  }
  createHttpProviders() {
    const e = {};
    return this.namespace.chains.forEach((r) => {
      var i;
      e[r] = this.createHttpProvider(r, (i = this.namespace.rpcMap) == null ? void 0 : i[r]);
    }), e;
  }
  getHttpProvider() {
    const e = `${this.name}:${this.chainId}`, r = this.httpProviders[e];
    if (typeof r > "u")
      throw new Error(`JSON-RPC provider for ${e} not found`);
    return r;
  }
  setHttpProvider(e, r) {
    const i = this.createHttpProvider(e, r);
    i && (this.httpProviders[e] = i);
  }
  createHttpProvider(e, r) {
    const i = r || Ts(e, this.namespace, this.client.core.projectId);
    return typeof i > "u" ? void 0 : new Ns(new ua(i, yr("disableProviderPing")));
  }
}
class Tle {
  constructor(e) {
    this.name = "cip34", this.namespace = e.namespace, this.events = yr("events"), this.client = yr("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(e) {
    this.namespace = Object.assign(this.namespace, e);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  getDefaultChain() {
    if (this.chainId)
      return this.chainId;
    if (this.namespace.defaultChain)
      return this.namespace.defaultChain;
    const e = this.namespace.chains[0];
    if (!e)
      throw new Error("ChainId not found");
    return e.split(":")[1];
  }
  request(e) {
    return this.namespace.methods.includes(e.request.method) ? this.client.request(e) : this.getHttpProvider().request(e.request);
  }
  setDefaultChain(e, r) {
    this.httpProviders[e] || this.setHttpProvider(e, r), this.chainId = e, this.events.emit(Ds.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
  }
  getAccounts() {
    const e = this.namespace.accounts;
    return e ? [...new Set(e.filter((r) => r.split(":")[1] === this.chainId.toString()).map((r) => r.split(":")[2]))] : [];
  }
  createHttpProviders() {
    const e = {};
    return this.namespace.chains.forEach((r) => {
      const i = this.getCardanoRPCUrl(r), s = Ef(r);
      e[s] = this.createHttpProvider(s, i);
    }), e;
  }
  getHttpProvider() {
    const e = `${this.name}:${this.chainId}`, r = this.httpProviders[e];
    if (typeof r > "u")
      throw new Error(`JSON-RPC provider for ${e} not found`);
    return r;
  }
  getCardanoRPCUrl(e) {
    const r = this.namespace.rpcMap;
    if (r)
      return r[e];
  }
  setHttpProvider(e, r) {
    const i = this.createHttpProvider(e, r);
    i && (this.httpProviders[e] = i);
  }
  createHttpProvider(e, r) {
    const i = r || this.getCardanoRPCUrl(e);
    if (!i)
      throw new Error(`No RPC url provided for chainId: ${e}`);
    return new Ns(new ua(i, yr("disableProviderPing")));
  }
}
class Nle {
  constructor(e) {
    this.name = "elrond", this.namespace = e.namespace, this.events = yr("events"), this.client = yr("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(e) {
    this.namespace = Object.assign(this.namespace, e);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  request(e) {
    return this.namespace.methods.includes(e.request.method) ? this.client.request(e) : this.getHttpProvider().request(e.request);
  }
  setDefaultChain(e, r) {
    this.httpProviders[e] || this.setHttpProvider(e, r), this.chainId = e, this.events.emit(Ds.DEFAULT_CHAIN_CHANGED, `${this.name}:${e}`);
  }
  getDefaultChain() {
    if (this.chainId)
      return this.chainId;
    if (this.namespace.defaultChain)
      return this.namespace.defaultChain;
    const e = this.namespace.chains[0];
    if (!e)
      throw new Error("ChainId not found");
    return e.split(":")[1];
  }
  getAccounts() {
    const e = this.namespace.accounts;
    return e ? [...new Set(e.filter((r) => r.split(":")[1] === this.chainId.toString()).map((r) => r.split(":")[2]))] : [];
  }
  createHttpProviders() {
    const e = {};
    return this.namespace.chains.forEach((r) => {
      var i;
      const s = Ef(r);
      e[s] = this.createHttpProvider(s, (i = this.namespace.rpcMap) == null ? void 0 : i[r]);
    }), e;
  }
  getHttpProvider() {
    const e = `${this.name}:${this.chainId}`, r = this.httpProviders[e];
    if (typeof r > "u")
      throw new Error(`JSON-RPC provider for ${e} not found`);
    return r;
  }
  setHttpProvider(e, r) {
    const i = this.createHttpProvider(e, r);
    i && (this.httpProviders[e] = i);
  }
  createHttpProvider(e, r) {
    const i = r || Ts(e, this.namespace, this.client.core.projectId);
    if (!i)
      throw new Error(`No RPC url provided for chainId: ${e}`);
    return new Ns(new ua(i, yr("disableProviderPing")));
  }
}
class Dle {
  constructor(e) {
    this.name = "multiversx", this.namespace = e.namespace, this.events = yr("events"), this.client = yr("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(e) {
    this.namespace = Object.assign(this.namespace, e);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  request(e) {
    return this.namespace.methods.includes(e.request.method) ? this.client.request(e) : this.getHttpProvider().request(e.request);
  }
  setDefaultChain(e, r) {
    this.httpProviders[e] || this.setHttpProvider(e, r), this.chainId = e, this.events.emit(Ds.DEFAULT_CHAIN_CHANGED, `${this.name}:${e}`);
  }
  getDefaultChain() {
    if (this.chainId)
      return this.chainId;
    if (this.namespace.defaultChain)
      return this.namespace.defaultChain;
    const e = this.namespace.chains[0];
    if (!e)
      throw new Error("ChainId not found");
    return e.split(":")[1];
  }
  getAccounts() {
    const e = this.namespace.accounts;
    return e ? [...new Set(e.filter((r) => r.split(":")[1] === this.chainId.toString()).map((r) => r.split(":")[2]))] : [];
  }
  createHttpProviders() {
    const e = {};
    return this.namespace.chains.forEach((r) => {
      var i;
      const s = Ef(r);
      e[s] = this.createHttpProvider(s, (i = this.namespace.rpcMap) == null ? void 0 : i[r]);
    }), e;
  }
  getHttpProvider() {
    const e = `${this.name}:${this.chainId}`, r = this.httpProviders[e];
    if (typeof r > "u")
      throw new Error(`JSON-RPC provider for ${e} not found`);
    return r;
  }
  setHttpProvider(e, r) {
    const i = this.createHttpProvider(e, r);
    i && (this.httpProviders[e] = i);
  }
  createHttpProvider(e, r) {
    const i = r || Ts(e, this.namespace, this.client.core.projectId);
    if (!i)
      throw new Error(`No RPC url provided for chainId: ${e}`);
    return new Ns(new ua(i, yr("disableProviderPing")));
  }
}
class Cle {
  constructor(e) {
    this.name = "near", this.namespace = e.namespace, this.events = yr("events"), this.client = yr("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(e) {
    this.namespace = Object.assign(this.namespace, e);
  }
  requestAccounts() {
    return this.getAccounts();
  }
  getDefaultChain() {
    if (this.chainId)
      return this.chainId;
    if (this.namespace.defaultChain)
      return this.namespace.defaultChain;
    const e = this.namespace.chains[0];
    if (!e)
      throw new Error("ChainId not found");
    return e.split(":")[1];
  }
  request(e) {
    return this.namespace.methods.includes(e.request.method) ? this.client.request(e) : this.getHttpProvider().request(e.request);
  }
  setDefaultChain(e, r) {
    if (this.chainId = e, !this.httpProviders[e]) {
      const i = r || Ts(`${this.name}:${e}`, this.namespace);
      if (!i)
        throw new Error(`No RPC url provided for chainId: ${e}`);
      this.setHttpProvider(e, i);
    }
    this.events.emit(Ds.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
  }
  getAccounts() {
    const e = this.namespace.accounts;
    return e ? e.filter((r) => r.split(":")[1] === this.chainId.toString()).map((r) => r.split(":")[2]) || [] : [];
  }
  createHttpProviders() {
    const e = {};
    return this.namespace.chains.forEach((r) => {
      var i;
      e[r] = this.createHttpProvider(r, (i = this.namespace.rpcMap) == null ? void 0 : i[r]);
    }), e;
  }
  getHttpProvider() {
    const e = `${this.name}:${this.chainId}`, r = this.httpProviders[e];
    if (typeof r > "u")
      throw new Error(`JSON-RPC provider for ${e} not found`);
    return r;
  }
  setHttpProvider(e, r) {
    const i = this.createHttpProvider(e, r);
    i && (this.httpProviders[e] = i);
  }
  createHttpProvider(e, r) {
    const i = r || Ts(e, this.namespace);
    return typeof i > "u" ? void 0 : new Ns(new ua(i, yr("disableProviderPing")));
  }
}
class Ole {
  constructor(e) {
    this.name = tc, this.namespace = e.namespace, this.events = yr("events"), this.client = yr("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
  }
  updateNamespace(e) {
    this.namespace.chains = [...new Set((this.namespace.chains || []).concat(e.chains || []))], this.namespace.accounts = [...new Set((this.namespace.accounts || []).concat(e.accounts || []))], this.namespace.methods = [...new Set((this.namespace.methods || []).concat(e.methods || []))], this.namespace.events = [...new Set((this.namespace.events || []).concat(e.events || []))], this.httpProviders = this.createHttpProviders();
  }
  requestAccounts() {
    return this.getAccounts();
  }
  request(e) {
    return this.namespace.methods.includes(e.request.method) ? this.client.request(e) : this.getHttpProvider(e.chainId).request(e.request);
  }
  setDefaultChain(e, r) {
    this.httpProviders[e] || this.setHttpProvider(e, r), this.chainId = e, this.events.emit(Ds.DEFAULT_CHAIN_CHANGED, `${this.name}:${e}`);
  }
  getDefaultChain() {
    if (this.chainId)
      return this.chainId;
    if (this.namespace.defaultChain)
      return this.namespace.defaultChain;
    const e = this.namespace.chains[0];
    if (!e)
      throw new Error("ChainId not found");
    return e.split(":")[1];
  }
  getAccounts() {
    const e = this.namespace.accounts;
    return e ? [...new Set(e.filter((r) => r.split(":")[1] === this.chainId.toString()).map((r) => r.split(":")[2]))] : [];
  }
  createHttpProviders() {
    var e, r;
    const i = {};
    return (r = (e = this.namespace) == null ? void 0 : e.accounts) == null || r.forEach((s) => {
      const n = vc(s);
      i[`${n.namespace}:${n.reference}`] = this.createHttpProvider(s);
    }), i;
  }
  getHttpProvider(e) {
    const r = this.httpProviders[e];
    if (typeof r > "u")
      throw new Error(`JSON-RPC provider for ${e} not found`);
    return r;
  }
  setHttpProvider(e, r) {
    const i = this.createHttpProvider(e, r);
    i && (this.httpProviders[e] = i);
  }
  createHttpProvider(e, r) {
    const i = r || Ts(e, this.namespace, this.client.core.projectId);
    if (!i)
      throw new Error(`No RPC url provided for chainId: ${e}`);
    return new Ns(new ua(i, yr("disableProviderPing")));
  }
}
var Rle = Object.defineProperty, Lle = Object.defineProperties, Ple = Object.getOwnPropertyDescriptors, mS = Object.getOwnPropertySymbols, kle = Object.prototype.hasOwnProperty, jle = Object.prototype.propertyIsEnumerable, wS = (t, e, r) => e in t ? Rle(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, $d = (t, e) => {
  for (var r in e || (e = {}))
    kle.call(e, r) && wS(t, r, e[r]);
  if (mS)
    for (var r of mS(e))
      jle.call(e, r) && wS(t, r, e[r]);
  return t;
}, Gy = (t, e) => Lle(t, Ple(e));
class Hw {
  constructor(e) {
    this.events = new Pr.exports(), this.rpcProviders = {}, this.shouldAbortPairingAttempt = !1, this.maxPairingAttempts = 10, this.disableProviderPing = !1, this.providerOpts = e, this.logger = typeof (e == null ? void 0 : e.logger) < "u" && typeof (e == null ? void 0 : e.logger) != "string" ? e.logger : Ys(o1({ level: (e == null ? void 0 : e.logger) || cS })), this.disableProviderPing = (e == null ? void 0 : e.disableProviderPing) || !1;
  }
  static async init(e) {
    const r = new Hw(e);
    return await r.initialize(), r;
  }
  async request(e, r, i) {
    const [s, n] = this.validateChain(r);
    if (!this.session)
      throw new Error("Please call connect() before request()");
    return await this.getProvider(s).request({ request: $d({}, e), chainId: `${s}:${n}`, topic: this.session.topic, expiry: i });
  }
  sendAsync(e, r, i, s) {
    const n = new Date().getTime();
    this.request(e, i, s).then((f) => r(null, f1(n, f))).catch((f) => r(f, void 0));
  }
  async enable() {
    if (!this.client)
      throw new Error("Sign Client not initialized");
    return this.session || await this.connect({ namespaces: this.namespaces, optionalNamespaces: this.optionalNamespaces, sessionProperties: this.sessionProperties }), await this.requestAccounts();
  }
  async disconnect() {
    var e;
    if (!this.session)
      throw new Error("Please call connect() before enable()");
    await this.client.disconnect({ topic: (e = this.session) == null ? void 0 : e.topic, reason: wr("USER_DISCONNECTED") }), await this.cleanup();
  }
  async connect(e) {
    if (!this.client)
      throw new Error("Sign Client not initialized");
    if (this.setNamespaces(e), await this.cleanupPendingPairings(), !e.skipPairing)
      return await this.pair(e.pairingTopic);
  }
  async authenticate(e, r) {
    if (!this.client)
      throw new Error("Sign Client not initialized");
    this.setNamespaces(e), await this.cleanupPendingPairings();
    const { uri: i, response: s } = await this.client.authenticate(e, r);
    i && (this.uri = i, this.events.emit("display_uri", i));
    const n = await s();
    if (this.session = n.session, this.session) {
      const f = pS(this.session.namespaces);
      this.namespaces = Hy(this.namespaces, f), this.persist("namespaces", this.namespaces), this.onConnect();
    }
    return n;
  }
  on(e, r) {
    this.events.on(e, r);
  }
  once(e, r) {
    this.events.once(e, r);
  }
  removeListener(e, r) {
    this.events.removeListener(e, r);
  }
  off(e, r) {
    this.events.off(e, r);
  }
  get isWalletConnect() {
    return !0;
  }
  async pair(e) {
    this.shouldAbortPairingAttempt = !1;
    let r = 0;
    do {
      if (this.shouldAbortPairingAttempt)
        throw new Error("Pairing aborted");
      if (r >= this.maxPairingAttempts)
        throw new Error("Max auto pairing attempts reached");
      const { uri: i, approval: s } = await this.client.connect({ pairingTopic: e, requiredNamespaces: this.namespaces, optionalNamespaces: this.optionalNamespaces, sessionProperties: this.sessionProperties });
      i && (this.uri = i, this.events.emit("display_uri", i)), await s().then((n) => {
        this.session = n;
        const f = pS(n.namespaces);
        this.namespaces = Hy(this.namespaces, f), this.persist("namespaces", this.namespaces);
      }).catch((n) => {
        if (n.message !== nN)
          throw n;
        r++;
      });
    } while (!this.session);
    return this.onConnect(), this.session;
  }
  setDefaultChain(e, r) {
    try {
      if (!this.session)
        return;
      const [i, s] = this.validateChain(e), n = this.getProvider(i);
      n.name === tc ? n.setDefaultChain(`${i}:${s}`, r) : n.setDefaultChain(s, r);
    } catch (i) {
      if (!/Please call connect/.test(i.message))
        throw i;
    }
  }
  async cleanupPendingPairings(e = {}) {
    this.logger.info("Cleaning up inactive pairings...");
    const r = this.client.pairing.getAll();
    if (sa(r)) {
      for (const i of r)
        e.deletePairings ? this.client.core.expirer.set(i.topic, 0) : await this.client.core.relayer.subscriber.unsubscribe(i.topic);
      this.logger.info(`Inactive pairings cleared: ${r.length}`);
    }
  }
  abortPairingAttempt() {
    this.shouldAbortPairingAttempt = !0;
  }
  async checkStorage() {
    if (this.namespaces = await this.getFromStore("namespaces"), this.optionalNamespaces = await this.getFromStore("optionalNamespaces") || {}, this.client.session.length) {
      const e = this.client.session.keys.length - 1;
      this.session = this.client.session.get(this.client.session.keys[e]), this.createProviders();
    }
  }
  async initialize() {
    this.logger.trace("Initialized"), await this.createClient(), await this.checkStorage(), this.registerEventListeners();
  }
  async createClient() {
    this.client = this.providerOpts.client || await qw.init({ core: this.providerOpts.core, logger: this.providerOpts.logger || cS, relayUrl: this.providerOpts.relayUrl || ale, projectId: this.providerOpts.projectId, metadata: this.providerOpts.metadata, storageOptions: this.providerOpts.storageOptions, storage: this.providerOpts.storage, name: this.providerOpts.name, customStoragePrefix: this.providerOpts.customStoragePrefix, telemetryEnabled: this.providerOpts.telemetryEnabled }), this.logger.trace("SignClient Initialized");
  }
  createProviders() {
    if (!this.client)
      throw new Error("Sign Client not initialized");
    if (!this.session)
      throw new Error("Session not initialized. Please call connect() before enable()");
    const e = [...new Set(Object.keys(this.session.namespaces).map((r) => Yu(r)))];
    Vy("client", this.client), Vy("events", this.events), Vy("disableProviderPing", this.disableProviderPing), e.forEach((r) => {
      if (!this.session)
        return;
      const i = gle(r, this.session), s = aN(i), n = Hy(this.namespaces, this.optionalNamespaces), f = Gy($d({}, n[r]), { accounts: i, chains: s });
      switch (r) {
        case "eip155":
          this.rpcProviders[r] = new Sle({ namespace: f });
          break;
        case "algorand":
          this.rpcProviders[r] = new Ale({ namespace: f });
          break;
        case "solana":
          this.rpcProviders[r] = new Ele({ namespace: f });
          break;
        case "cosmos":
          this.rpcProviders[r] = new Ile({ namespace: f });
          break;
        case "polkadot":
          this.rpcProviders[r] = new yle({ namespace: f });
          break;
        case "cip34":
          this.rpcProviders[r] = new Tle({ namespace: f });
          break;
        case "elrond":
          this.rpcProviders[r] = new Nle({ namespace: f });
          break;
        case "multiversx":
          this.rpcProviders[r] = new Dle({ namespace: f });
          break;
        case "near":
          this.rpcProviders[r] = new Cle({ namespace: f });
          break;
        default:
          this.rpcProviders[tc] ? this.rpcProviders[tc].updateNamespace(f) : this.rpcProviders[tc] = new Ole({ namespace: f });
      }
    });
  }
  registerEventListeners() {
    if (typeof this.client > "u")
      throw new Error("Sign Client is not initialized");
    this.client.on("session_ping", (e) => {
      this.events.emit("session_ping", e);
    }), this.client.on("session_event", (e) => {
      const { params: r } = e, { event: i } = r;
      if (i.name === "accountsChanged") {
        const s = i.data;
        s && sa(s) && this.events.emit("accountsChanged", s.map(ble));
      } else if (i.name === "chainChanged") {
        const s = r.chainId, n = r.event.data, f = Yu(s), u = Wy(s) !== Wy(n) ? `${f}:${Wy(n)}` : s;
        this.onChainChanged(u);
      } else
        this.events.emit(i.name, i.data);
      this.events.emit("session_event", e);
    }), this.client.on("session_update", ({ topic: e, params: r }) => {
      var i;
      const { namespaces: s } = r, n = (i = this.client) == null ? void 0 : i.session.get(e);
      this.session = Gy($d({}, n), { namespaces: s }), this.onSessionUpdate(), this.events.emit("session_update", { topic: e, params: r });
    }), this.client.on("session_delete", async (e) => {
      await this.cleanup(), this.events.emit("session_delete", e), this.events.emit("disconnect", Gy($d({}, wr("USER_DISCONNECTED")), { data: e.topic }));
    }), this.on(Ds.DEFAULT_CHAIN_CHANGED, (e) => {
      this.onChainChanged(e, !0);
    });
  }
  getProvider(e) {
    return this.rpcProviders[e] || this.rpcProviders[tc];
  }
  onSessionUpdate() {
    Object.keys(this.rpcProviders).forEach((e) => {
      var r;
      this.getProvider(e).updateNamespace((r = this.session) == null ? void 0 : r.namespaces[e]);
    });
  }
  setNamespaces(e) {
    const { namespaces: r, optionalNamespaces: i, sessionProperties: s } = e;
    r && Object.keys(r).length && (this.namespaces = r), i && Object.keys(i).length && (this.optionalNamespaces = i), this.sessionProperties = s, this.persist("namespaces", r), this.persist("optionalNamespaces", i);
  }
  validateChain(e) {
    const [r, i] = (e == null ? void 0 : e.split(":")) || ["", ""];
    if (!this.namespaces || !Object.keys(this.namespaces).length)
      return [r, i];
    if (r && !Object.keys(this.namespaces || {}).map((f) => Yu(f)).includes(r))
      throw new Error(`Namespace '${r}' is not configured. Please call connect() first with namespace config.`);
    if (r && i)
      return [r, i];
    const s = Yu(Object.keys(this.namespaces)[0]), n = this.rpcProviders[s].getDefaultChain();
    return [s, n];
  }
  async requestAccounts() {
    const [e] = this.validateChain();
    return await this.getProvider(e).requestAccounts();
  }
  onChainChanged(e, r = !1) {
    if (!this.namespaces)
      return;
    const [i, s] = this.validateChain(e);
    s && (r || this.getProvider(i).setDefaultChain(s), this.namespaces[i] ? this.namespaces[i].defaultChain = s : this.namespaces[`${i}:${s}`] ? this.namespaces[`${i}:${s}`].defaultChain = s : this.namespaces[`${i}:${s}`] = { defaultChain: s }, this.persist("namespaces", this.namespaces), this.events.emit("chainChanged", s));
  }
  onConnect() {
    this.createProviders(), this.events.emit("connect", { session: this.session });
  }
  async cleanup() {
    this.session = void 0, this.namespaces = void 0, this.optionalNamespaces = void 0, this.sessionProperties = void 0, this.persist("namespaces", void 0), this.persist("optionalNamespaces", void 0), this.persist("sessionProperties", void 0), await this.cleanupPendingPairings({ deletePairings: !0 });
  }
  persist(e, r) {
    this.client.core.storage.setItem(`${uS}/${e}`, r);
  }
  async getFromStore(e) {
    return await this.client.core.storage.getItem(`${uS}/${e}`);
  }
}
const Ble = Hw, zle = "wc", Ule = "ethereum_provider", Fle = `${zle}@2:${Ule}:`, $le = "https://rpc.walletconnect.org/v1/", Gm = ["eth_sendTransaction", "personal_sign"], qle = ["eth_accounts", "eth_requestAccounts", "eth_sendRawTransaction", "eth_sign", "eth_signTransaction", "eth_signTypedData", "eth_signTypedData_v3", "eth_signTypedData_v4", "eth_sendTransaction", "personal_sign", "wallet_switchEthereumChain", "wallet_addEthereumChain", "wallet_getPermissions", "wallet_requestPermissions", "wallet_registerOnboarding", "wallet_watchAsset", "wallet_scanQRCode", "wallet_sendCalls", "wallet_getCapabilities", "wallet_getCallsStatus", "wallet_showCallsStatus"], Km = ["chainChanged", "accountsChanged"], Hle = ["chainChanged", "accountsChanged", "message", "disconnect", "connect"];
var Wle = Object.defineProperty, Vle = Object.defineProperties, Gle = Object.getOwnPropertyDescriptors, _S = Object.getOwnPropertySymbols, Kle = Object.prototype.hasOwnProperty, Yle = Object.prototype.propertyIsEnumerable, MS = (t, e, r) => e in t ? Wle(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, rc = (t, e) => {
  for (var r in e || (e = {}))
    Kle.call(e, r) && MS(t, r, e[r]);
  if (_S)
    for (var r of _S(e))
      Yle.call(e, r) && MS(t, r, e[r]);
  return t;
}, Ky = (t, e) => Vle(t, Gle(e));
function q0(t) {
  return Number(t[0].split(":")[1]);
}
function qd(t) {
  return `0x${t.toString(16)}`;
}
function Qle(t) {
  const { chains: e, optionalChains: r, methods: i, optionalMethods: s, events: n, optionalEvents: f, rpcMap: u } = t;
  if (!sa(e))
    throw new Error("Invalid chains");
  const h = { chains: e, methods: i || Gm, events: n || Km, rpcMap: rc({}, e.length ? { [q0(e)]: u[q0(e)] } : {}) }, d = n == null ? void 0 : n.filter((M) => !Km.includes(M)), l = i == null ? void 0 : i.filter((M) => !Gm.includes(M));
  if (!r && !f && !s && !(d != null && d.length) && !(l != null && l.length))
    return { required: e.length ? h : void 0 };
  const m = (d == null ? void 0 : d.length) && (l == null ? void 0 : l.length) || !r, b = { chains: [...new Set(m ? h.chains.concat(r || []) : r)], methods: [...new Set(h.methods.concat(s != null && s.length ? s : qle))], events: [...new Set(h.events.concat(f != null && f.length ? f : Hle))], rpcMap: u };
  return { required: e.length ? h : void 0, optional: r.length ? b : void 0 };
}
class Ww {
  constructor() {
    this.events = new Pr.exports.EventEmitter(), this.namespace = "eip155", this.accounts = [], this.chainId = 1, this.STORAGE_KEY = Fle, this.on = (e, r) => (this.events.on(e, r), this), this.once = (e, r) => (this.events.once(e, r), this), this.removeListener = (e, r) => (this.events.removeListener(e, r), this), this.off = (e, r) => (this.events.off(e, r), this), this.parseAccount = (e) => this.isCompatibleChainId(e) ? this.parseAccountId(e).address : e, this.signer = {}, this.rpc = {};
  }
  static async init(e) {
    const r = new Ww();
    return await r.initialize(e), r;
  }
  async request(e, r) {
    return await this.signer.request(e, this.formatChainId(this.chainId), r);
  }
  sendAsync(e, r, i) {
    this.signer.sendAsync(e, r, this.formatChainId(this.chainId), i);
  }
  get connected() {
    return this.signer.client ? this.signer.client.core.relayer.connected : !1;
  }
  get connecting() {
    return this.signer.client ? this.signer.client.core.relayer.connecting : !1;
  }
  async enable() {
    return this.session || await this.connect(), await this.request({ method: "eth_requestAccounts" });
  }
  async connect(e) {
    if (!this.signer.client)
      throw new Error("Provider not initialized. Call init() first");
    this.loadConnectOpts(e);
    const { required: r, optional: i } = Qle(this.rpc);
    try {
      const s = await new Promise(async (f, u) => {
        var h;
        this.rpc.showQrModal && ((h = this.modal) == null || h.subscribeModal((d) => {
          !d.open && !this.signer.session && (this.signer.abortPairingAttempt(), u(new Error("Connection request reset. Please try again.")));
        })), await this.signer.connect(Ky(rc({ namespaces: rc({}, r && { [this.namespace]: r }) }, i && { optionalNamespaces: { [this.namespace]: i } }), { pairingTopic: e == null ? void 0 : e.pairingTopic })).then((d) => {
          f(d);
        }).catch((d) => {
          u(new Error(d.message));
        });
      });
      if (!s)
        return;
      const n = W8(s.namespaces, [this.namespace]);
      this.setChainIds(this.rpc.chains.length ? this.rpc.chains : n), this.setAccounts(n), this.events.emit("connect", { chainId: qd(this.chainId) });
    } catch (s) {
      throw this.signer.logger.error(s), s;
    } finally {
      this.modal && this.modal.closeModal();
    }
  }
  async authenticate(e, r) {
    if (!this.signer.client)
      throw new Error("Provider not initialized. Call init() first");
    this.loadConnectOpts({ chains: e == null ? void 0 : e.chains });
    try {
      const i = await new Promise(async (n, f) => {
        var u;
        this.rpc.showQrModal && ((u = this.modal) == null || u.subscribeModal((h) => {
          !h.open && !this.signer.session && (this.signer.abortPairingAttempt(), f(new Error("Connection request reset. Please try again.")));
        })), await this.signer.authenticate(Ky(rc({}, e), { chains: this.rpc.chains }), r).then((h) => {
          n(h);
        }).catch((h) => {
          f(new Error(h.message));
        });
      }), s = i.session;
      if (s) {
        const n = W8(s.namespaces, [this.namespace]);
        this.setChainIds(this.rpc.chains.length ? this.rpc.chains : n), this.setAccounts(n), this.events.emit("connect", { chainId: qd(this.chainId) });
      }
      return i;
    } catch (i) {
      throw this.signer.logger.error(i), i;
    } finally {
      this.modal && this.modal.closeModal();
    }
  }
  async disconnect() {
    this.session && await this.signer.disconnect(), this.reset();
  }
  get isWalletConnect() {
    return !0;
  }
  get session() {
    return this.signer.session;
  }
  registerEventListeners() {
    this.signer.on("session_event", (e) => {
      const { params: r } = e, { event: i } = r;
      i.name === "accountsChanged" ? (this.accounts = this.parseAccounts(i.data), this.events.emit("accountsChanged", this.accounts)) : i.name === "chainChanged" ? this.setChainId(this.formatChainId(i.data)) : this.events.emit(i.name, i.data), this.events.emit("session_event", e);
    }), this.signer.on("chainChanged", (e) => {
      const r = parseInt(e);
      this.chainId = r, this.events.emit("chainChanged", qd(this.chainId)), this.persist();
    }), this.signer.on("session_update", (e) => {
      this.events.emit("session_update", e);
    }), this.signer.on("session_delete", (e) => {
      this.reset(), this.events.emit("session_delete", e), this.events.emit("disconnect", Ky(rc({}, wr("USER_DISCONNECTED")), { data: e.topic, name: "USER_DISCONNECTED" }));
    }), this.signer.on("display_uri", (e) => {
      var r, i;
      this.rpc.showQrModal && ((r = this.modal) == null || r.closeModal(), (i = this.modal) == null || i.openModal({ uri: e })), this.events.emit("display_uri", e);
    });
  }
  switchEthereumChain(e) {
    this.request({ method: "wallet_switchEthereumChain", params: [{ chainId: e.toString(16) }] });
  }
  isCompatibleChainId(e) {
    return typeof e == "string" ? e.startsWith(`${this.namespace}:`) : !1;
  }
  formatChainId(e) {
    return `${this.namespace}:${e}`;
  }
  parseChainId(e) {
    return Number(e.split(":")[1]);
  }
  setChainIds(e) {
    const r = e.filter((i) => this.isCompatibleChainId(i)).map((i) => this.parseChainId(i));
    r.length && (this.chainId = r[0], this.events.emit("chainChanged", qd(this.chainId)), this.persist());
  }
  setChainId(e) {
    if (this.isCompatibleChainId(e)) {
      const r = this.parseChainId(e);
      this.chainId = r, this.switchEthereumChain(r);
    }
  }
  parseAccountId(e) {
    const [r, i, s] = e.split(":");
    return { chainId: `${r}:${i}`, address: s };
  }
  setAccounts(e) {
    this.accounts = e.filter((r) => this.parseChainId(this.parseAccountId(r).chainId) === this.chainId).map((r) => this.parseAccountId(r).address), this.events.emit("accountsChanged", this.accounts);
  }
  getRpcConfig(e) {
    var r, i;
    const s = (r = e == null ? void 0 : e.chains) != null ? r : [], n = (i = e == null ? void 0 : e.optionalChains) != null ? i : [], f = s.concat(n);
    if (!f.length)
      throw new Error("No chains specified in either `chains` or `optionalChains`");
    const u = s.length ? (e == null ? void 0 : e.methods) || Gm : [], h = s.length ? (e == null ? void 0 : e.events) || Km : [], d = (e == null ? void 0 : e.optionalMethods) || [], l = (e == null ? void 0 : e.optionalEvents) || [], m = (e == null ? void 0 : e.rpcMap) || this.buildRpcMap(f, e.projectId), b = (e == null ? void 0 : e.qrModalOptions) || void 0;
    return { chains: s == null ? void 0 : s.map((M) => this.formatChainId(M)), optionalChains: n.map((M) => this.formatChainId(M)), methods: u, events: h, optionalMethods: d, optionalEvents: l, rpcMap: m, showQrModal: !!(e != null && e.showQrModal), qrModalOptions: b, projectId: e.projectId, metadata: e.metadata };
  }
  buildRpcMap(e, r) {
    const i = {};
    return e.forEach((s) => {
      i[s] = this.getRpcUrl(s, r);
    }), i;
  }
  async initialize(e) {
    if (this.rpc = this.getRpcConfig(e), this.chainId = this.rpc.chains.length ? q0(this.rpc.chains) : q0(this.rpc.optionalChains), this.signer = await Ble.init({ projectId: this.rpc.projectId, metadata: this.rpc.metadata, disableProviderPing: e.disableProviderPing, relayUrl: e.relayUrl, storageOptions: e.storageOptions, customStoragePrefix: e.customStoragePrefix, telemetryEnabled: e.telemetryEnabled }), this.registerEventListeners(), await this.loadPersistedSession(), this.rpc.showQrModal) {
      let r;
      try {
        const { WalletConnectModal: i } = await import("./index2.js").then((s) => s.i);
        r = i;
      } catch {
        throw new Error("To use QR modal, please install @walletconnect/modal package");
      }
      if (r)
        try {
          this.modal = new r(rc({ projectId: this.rpc.projectId }, this.rpc.qrModalOptions));
        } catch (i) {
          throw this.signer.logger.error(i), new Error("Could not generate WalletConnectModal Instance");
        }
    }
  }
  loadConnectOpts(e) {
    if (!e)
      return;
    const { chains: r, optionalChains: i, rpcMap: s } = e;
    r && sa(r) && (this.rpc.chains = r.map((n) => this.formatChainId(n)), r.forEach((n) => {
      this.rpc.rpcMap[n] = (s == null ? void 0 : s[n]) || this.getRpcUrl(n);
    })), i && sa(i) && (this.rpc.optionalChains = [], this.rpc.optionalChains = i == null ? void 0 : i.map((n) => this.formatChainId(n)), i.forEach((n) => {
      this.rpc.rpcMap[n] = (s == null ? void 0 : s[n]) || this.getRpcUrl(n);
    }));
  }
  getRpcUrl(e, r) {
    var i;
    return ((i = this.rpc.rpcMap) == null ? void 0 : i[e]) || `${$le}?chainId=eip155:${e}&projectId=${r || this.rpc.projectId}`;
  }
  async loadPersistedSession() {
    if (this.session)
      try {
        const e = await this.signer.client.core.storage.getItem(`${this.STORAGE_KEY}/chainId`), r = this.session.namespaces[`${this.namespace}:${e}`] ? this.session.namespaces[`${this.namespace}:${e}`] : this.session.namespaces[this.namespace];
        this.setChainIds(e ? [this.formatChainId(e)] : r == null ? void 0 : r.accounts), this.setAccounts(r == null ? void 0 : r.accounts);
      } catch (e) {
        this.signer.logger.error("Failed to load persisted session, clearing state..."), this.signer.logger.error(e), await this.disconnect().catch((r) => this.signer.logger.warn(r));
      }
  }
  reset() {
    this.chainId = 1, this.accounts = [];
  }
  persist() {
    this.session && this.signer.client.core.storage.setItem(`${this.STORAGE_KEY}/chainId`, this.chainId);
  }
  parseAccounts(e) {
    return typeof e == "string" || e instanceof String ? [this.parseAccount(e)] : e.map((r) => this.parseAccount(r));
  }
}
const Zle = Ww, fN = () => {
  const { ethereum: t } = window;
  return DS(t) ? !!t.isMetaMask && !Zm(t) && !H0(t) : !1;
};
function xS(t, e) {
  return e in t;
}
const SS = Object.entries(Zy).reduce(
  (t, [e, { rpcUrls: r }]) => ({ ...t, [e]: r[0] }),
  {}
), Yy = "eip6963:announceProvider", Jle = "persist:auth", Xle = "TRUSTWALLET_MOCK_EVENT";
function ede() {
  const t = window.localStorage.getItem(Jle);
  if (!!t)
    try {
      const e = JSON.parse(t), { chainId: r } = JSON.parse(e.ethCompatible);
      return r;
    } catch {
      return;
    }
}
const tde = {
  [st.injected]: {
    display: {
      logo: xn(st.injected),
      name: Sn(st.injected),
      description: ""
    },
    connector: async () => {
      let t = null;
      function e(r) {
        const { detail: i } = r;
        (i.info.rdns === "io.metamask" || i.info.rdns === "com.okx.wallet" || i.info.rdns === "com.coinbase.wallet") && (t = i.provider, window.removeEventListener(
          Yy,
          e
        ));
      }
      if (window.addEventListener(
        Yy,
        e
      ), window.dispatchEvent(new Event("eip6963:requestProvider")), !t)
        throw new Error("Wallet provider not found");
      return await t.enable(), setTimeout(() => {
        window.removeEventListener(
          Yy,
          e
        );
      }, 1e3), t;
    }
  },
  [st.walletconnect]: {
    display: {
      logo: xn(st.walletconnect),
      name: Sn(st.walletconnect),
      description: ""
    },
    connector: async () => {
      const t = Object.values(ee).filter(
        (i) => typeof i != "string"
      ), e = await Zle.init({
        projectId: VP,
        optionalChains: t,
        showQrModal: !0,
        rpcMap: SS,
        methods: ["eth_sendTransaction", "eth_signTransaction"],
        optionalMethods: [
          "account_signTransaction",
          "eth_sendTransaction",
          "eth_signTransaction",
          "eth_subscribe",
          "eth_unsubscribe",
          "eth_decrypt",
          "eth_accounts",
          "personal_sign",
          "eth_getEncryptionPublicKey",
          "wallet_switchEthereumChain",
          "wallet_addEthereumChain",
          "eth_requestAccounts",
          "eth_maxPriorityFeePerGas",
          "eth_signTypedData_v4",
          "web3_clientVersion",
          "eth_sign",
          "personal_sign",
          "personal_sendTransaction",
          "personal_signTransaction",
          "eth_estimateGas",
          "eth_feeHistory",
          "eth_getBalance",
          "eth_newFilter",
          "eth_newBlockFilter",
          "eth_newPendingTransactionFilter",
          "eth_uninstallFilter",
          "eth_getFilterChanges",
          "eth_getFilterLogs",
          "eth_gasPrice",
          "eth_getLogs",
          "eth_mining",
          "eth_submitWork",
          "eth_submitHashrate",
          "eth_pendingTransactions",
          "eth_getStorageAt",
          "eth_getWork",
          "eth_hashrate",
          "eth_chainId",
          "eth_call",
          "eth_syncing",
          "eth_coinbase",
          "eth_blockNumber",
          "eth_getBlockByHash",
          "eth_getBlockByNumber",
          "eth_getTransactionCount",
          "eth_getTransactionByHash",
          "eth_getCode",
          "eth_getProof",
          "eth_getBlockTransactionCountByHash",
          "eth_getBlockTransactionCountByNumber",
          "eth_getTransactionByBlockHashAndIndex",
          "eth_getTransactionByBlockNumberAndIndex",
          "eth_sendRawTransaction",
          "eth_getUncleCountByBlockHash",
          "eth_getUncleCountByBlockNumber",
          "eth_getTransactionReceipt",
          "wallet_switchEthereumChain",
          "wallet_addEthereumChain",
          "wallet_watchAsset",
          "wallet_requestPermissions",
          "wallet_getPermissions",
          "wallet_registerOnboarding"
        ],
        events: ["chainChanged", "accountsChanged"],
        optionalEvents: ["message", "disconnect"],
        qrModalOptions: {
          themeMode: "light",
          themeVariables: {
            "--wcm-z-index": "1301"
          }
        }
      });
      return await e.enable(), new Proxy(e, {
        get(i, s) {
          if (xS(i, s))
            return i[s];
          if (xS(i.events, s))
            return i.events[s];
        }
      });
    }
  },
  [st.coin98]: {
    display: {
      logo: xn(st.coin98),
      name: Sn(st.coin98),
      description: ""
    },
    connector: async () => {
      const { provider: t } = window.coin98;
      if (!TS(t) || !NS())
        throw new Error("Coin 98 wallet isn't installed");
      return await t.request({
        method: "eth_requestAccounts"
      }), t;
    }
  },
  [st.binanceWallet]: {
    display: {
      logo: xn(st.binanceWallet),
      name: Sn(st.binanceWallet),
      description: "A Crypto Wallet for BNB Beacon Chain, BNB Smart Chain and Ethereum"
    },
    connector: async () => (await new Fk({
      supportedChainIds: [
        ee.smartchain,
        ee.smartchainTestnet
      ]
    }).activate()).provider
  },
  [st.trust]: {
    display: {
      logo: xn(st.trust),
      name: Sn(st.trust),
      description: "The most trusted & secure crypto wallet"
    },
    connector: async () => {
      const { trustwallet: t } = window;
      if (!OS(t) || !Xm())
        throw new Error("Trust Wallet isn't installed");
      return await t.request({
        method: "eth_requestAccounts"
      }), t.off(Xle, () => {
      });
    }
  },
  [st.coinbase]: {
    display: {
      logo: xn(st.coinbase),
      name: Sn(st.coinbase),
      description: "Coinbase wallet"
    },
    connector: async () => {
      const t = ede(), r = new mZ({
        appName: "App",
        reloadOnDisconnect: !1
      }).makeWeb3Provider(
        t ? SS[t] : void 0,
        t
      );
      return await r.enable(), r;
    }
  },
  [st.okxwallet]: {
    display: {
      logo: xn(st.okxwallet),
      name: Sn(st.okxwallet),
      description: "Your portal to Web3"
    },
    connector: async () => {
      const { okxwallet: t } = window;
      if (!Zm(t) || !Jm())
        throw new Error("OKX wallet isn't installed");
      return await t.enable(), t;
    }
  },
  [st.clover]: {
    display: {
      logo: xn(st.clover),
      name: Sn(st.clover),
      description: "CLV - Passport to the Omniverse"
    },
    connector: async () => {
      const t = AS();
      if (!Qm(t))
        throw new Error("CLV wallet isn't installed");
      return await t.enable(), t;
    }
  },
  [st.mirage]: {
    display: {
      logo: xn(st.mirage),
      name: Sn(st.mirage),
      description: "The best crypto wallet"
    },
    connector: async () => {
      const t = vk();
      return await t.request({
        method: "eth_requestAccounts"
      }), t;
    }
  },
  [st.bitget]: {
    display: {
      logo: xn(st.bitget),
      name: Sn(st.bitget),
      description: "Bitget wallet"
    },
    connector: async () => {
      const { bitkeep: t } = window;
      if (!LS(t == null ? void 0 : t.ethereum) || !e2())
        throw new Error("Bitget Wallet isn't installed");
      return await t.ethereum.request({
        method: "eth_requestAccounts"
      }), t.ethereum;
    }
  },
  [st.bybit]: {
    display: {
      logo: xn(st.bybit),
      name: Sn(st.bybit),
      description: "Bybit wallet"
    },
    connector: async () => {
      const { bybitWallet: t } = window;
      if (!IS(t) || !Ym())
        throw new Error("Bybit Wallet isn't installed");
      return await t.request({
        method: "eth_requestAccounts"
      }), t;
    }
  },
  [st.flow]: {
    display: {
      logo: xn(st.flow),
      name: Sn(st.flow),
      description: "Flow wallet"
    },
    connector: async () => {
      const t = await hk(), e = "Flow Wallet isn't installed";
      if (!t)
        throw new Error(e);
      if (fN() && !H0(t))
        throw new Error(
          "Can't connect to Flow Wallet. Disable MetaMask extension for connecting to Flow Wallet."
        );
      return await t.enable(), t;
    }
  }
};
class rde extends Error {
  constructor(r, i) {
    super(r);
    Hi(this, "cause");
    this.cause = i.cause;
  }
}
class ide extends Ak {
  constructor(e) {
    const { rpcConfig: r } = e != null ? e : {};
    super(), this.rpcConfig = { ...Re, ...r };
  }
  async inject(e = st.walletconnect, r = tde) {
    var i;
    try {
      const { connector: s } = (i = r[e]) != null ? i : {};
      if (!s)
        throw new Error(`Connector is not found for wallet: ${e}`);
      this.provider = await s(), this.web3 = new es(this.provider);
    } catch (s) {
      throw console.error(s), new rde(
        "Unable to connect. Please check if the connection has already been requested.",
        { cause: s instanceof Error ? s : void 0 }
      );
    }
  }
}
class Dde extends Eh {
  constructor(r) {
    super();
    Hi(this, "url");
    this.web3 = new es(), this.url = r, this.web3.setProvider(new es.providers.HttpProvider(r));
  }
  get rpcUrl() {
    return this.url;
  }
}
class Cde extends Eh {
  constructor(r) {
    super();
    Hi(this, "url");
    this.web3 = new es(), this.url = r, this.web3.setProvider(new es.providers.HttpProvider(r));
  }
  get rpcUrl() {
    return this.url;
  }
}
class Ode {
  constructor(e, r = W_) {
    Hi(this, "providers", {});
    this.providerOptions = e, this.rpcUrls = r;
  }
  addProvider(e, r, i = !1) {
    this.providers[e] !== void 0 && !i || (this.providers[e] = r);
  }
  async getProvider(e, r) {
    const i = this.providers[e];
    if (i)
      return i.isConnected() || await i.connect(), i;
    switch (e) {
      case Qy.ethCompatible:
        return await this.getETHWriteProvider(
          r
        );
      default:
        throw new Error(
          `The provider isn't supported: ${e.toString()}`
        );
    }
  }
  async getETHReadProvider(e) {
    const r = this.providers[e];
    if (r !== void 0)
      return r.isConnected() || await r.connect(), r;
    const s = { ...W_, ...this.rpcUrls }[e];
    if (!s)
      throw new Error(`The ${e} provider is not supported`);
    return new HP(s);
  }
  async getETHWriteProvider(e) {
    const r = Qy.ethCompatible, i = this.providers[r];
    if (i)
      return i.isConnected() || await i.connect(), i;
    const s = Object.entries(this.rpcUrls).reduce(
      (f, [u, h]) => {
        const d = WP[u];
        return f[d] = h, f;
      },
      {}
    ), n = new ide({ rpcConfig: s });
    return await n.inject(e, this.providerOptions), await n.connect(), this.providers[r] = n, n;
  }
  getWriteProviderById(e) {
    const r = this.providers[e];
    return r != null ? r : null;
  }
  disconnect(e) {
    const r = this.providers[e];
    r && (r.disconnect(), delete this.providers[e]);
  }
}
const nde = "https://chrome.google.com/webstore/detail/binance-wallet/fhbohimaelbohpjbbldcngcnapndodjp", sde = "https://docs.clv.org/use-clv-wallet/clv-extension-wallet", ade = "https://docs.coin98.com/products/coin98-super-app/extension#install-coin98-extension", ode = "https://www.coinbase.com/wallet", fde = "https://metamask.io/download", cde = "https://www.okx.com/web3", ude = "https://trustwallet.com/download", hde = "https://web3.bitget.com/en/wallet-download", lde = "https://www.bybit.com/web3/home", dde = "https://wallet.flow.com/";
function pde() {
  const { BinanceChain: t } = window;
  return !!t;
}
const Rde = () => ({
  walletId: st.binanceWallet,
  isDisabled: !1,
  isInjected: pde(),
  downloadUrl: nde
});
function vde(t) {
  return `https://bkcode.vip?action=dapp&url=${t}`;
}
const Lde = (t = window.location.href) => {
  const e = df(() => vde(t), [t]);
  return {
    walletId: st.bitget,
    isInjected: e2(),
    isDisabled: !1,
    deepLink: e,
    downloadUrl: hde
  };
}, Pde = () => ({
  walletId: st.bybit,
  isInjected: Ym(),
  isDisabled: !1,
  downloadUrl: lde
}), kde = () => {
  const t = ok(), e = AS(), r = Qm(e), i = t && !r;
  return {
    walletId: st.clover,
    isInjected: t,
    isDisabled: i,
    downloadUrl: sde
  };
};
function cN(t) {
  return t.replace(/(^\w+:|^)\/\//, "");
}
function gde(t, e) {
  return `https://coin98.com/dapp/${cN(t)}/${e} `;
}
const jde = (t = window.location.href, e = ee.mainnet) => {
  const r = df(
    () => gde(t, e),
    [t, e]
  );
  return {
    walletId: st.coin98,
    isInjected: NS(),
    isDisabled: !1,
    downloadUrl: ade,
    deepLink: r
  };
};
function bde(t) {
  return `https://go.cb-w.com/dapp?cb_url=${encodeURIComponent(t)}}`;
}
const Bde = (t = window.location.href) => {
  const e = df(() => bde(t), [t]);
  return {
    walletId: st.coinbase,
    isInjected: CS(),
    isDisabled: !1,
    deepLink: e,
    downloadUrl: ode
  };
};
function yde(t) {
  return `https://metamask.app.link/dapp/${cN(t)}`;
}
const zde = (t = window.location.href) => {
  var b;
  const e = CS(), r = Jm(), i = fN(), s = Xm(), n = df(() => yde(t), [t]), f = !!((b = window == null ? void 0 : window.ethereum) != null && b.isCoin98), u = e && r, h = s && !i, d = e2(), l = Ym(), m = u || f || h || d || l;
  return {
    walletId: st.injected,
    isDisabled: m,
    isDisabledByTrustWallet: h,
    isDisabledByOtherWallets: u,
    isRedefinedByCoin98: f,
    isDisabledByBitget: d,
    isDisabledByBybit: l,
    isInjected: i,
    deepLink: n,
    downloadUrl: fde
  };
};
function mde(t) {
  return `okx://wallet/dapp/details?dappUrl=${t}`;
}
const Ude = (t = window.location.href) => ({
  deepLink: df(() => mde(t), [t]),
  walletId: st.okxwallet,
  isInjected: Jm(),
  isDisabled: !1,
  downloadUrl: cde
});
function wde({
  link: t,
  coinId: e
}) {
  const r = new URLSearchParams();
  return r.set("url", t), e && r.set("coin_id", e.toString()), `https://link.trustwallet.com/open_url?${r.toString()}`;
}
const Fde = ({
  link: t = window.location.href,
  coinId: e
} = {}) => {
  const r = df(
    () => wde({ link: t, coinId: e }),
    [e, t]
  );
  return {
    walletId: st.trust,
    isInjected: Xm(),
    isDisabled: !1,
    deepLink: r,
    downloadUrl: ude
  };
};
function _de() {
  return "https://link.lilico.app/";
}
const $de = () => ({
  deepLink: df(() => _de(), []),
  walletId: st.flow,
  isInjected: dk() || lk(),
  isDisabled: !1,
  downloadUrl: dde
});
function qde(t) {
  return !!t.currentAccount;
}
export {
  Se as AvailableReadProviders,
  Qy as AvailableWriteProviders,
  Ade as AvalancheHttpWeb3KeyProvider,
  Dde as BinanceHttpWeb3KeyProvider,
  SS as DEFAULT_RPC,
  nde as DOWNLOAD_BINANCE_URL,
  hde as DOWNLOAD_BITGET_URL,
  lde as DOWNLOAD_BYBIT_URL,
  sde as DOWNLOAD_CLOVER_URL,
  ade as DOWNLOAD_COIN98_URL,
  ode as DOWNLOAD_COINBASE_URL,
  dde as DOWNLOAD_FLOW_URL,
  fde as DOWNLOAD_METAMASK_URL,
  cde as DOWNLOAD_OKX_URL,
  ude as DOWNLOAD_TRUST_URL,
  ee as EEthereumNetworkId,
  bk as EVENTS,
  st as EWalletId,
  HP as EthereumHttpWeb3KeyProvider,
  ide as EthereumWeb3KeyProvider,
  WP as NETWORK_ID_BY_READ_PROVIDER,
  Qu as ProviderEvents,
  Ode as ProviderManager,
  Zy as RPCConfig,
  W_ as RPC_URLS,
  Re as RPC_URLS_BY_NETWORK,
  VP as WC_PROJECT_ID,
  Eh as Web3KeyReadProvider,
  Ak as Web3KeyWriteProvider,
  Cde as XDCHttpWeb3KeyProvider,
  vde as getBitgetDeepLink,
  AS as getCloverProvider,
  gde as getCoin98DeepLink,
  bde as getCoinbaseDeepLink,
  _de as getFlowDeepLink,
  hk as getFlowProvider,
  pde as getIsBinanceInjected,
  LS as getIsBitget,
  e2 as getIsBitgetInjected,
  IS as getIsBybit,
  Ym as getIsBybitInjected,
  Qm as getIsClover,
  ok as getIsCloverInjected,
  TS as getIsCoin98,
  NS as getIsCoin98Injected,
  ck as getIsCoinbase,
  CS as getIsCoinbaseInjected,
  DS as getIsEthereum,
  H0 as getIsFlow,
  lk as getIsFlowExtensionInjected,
  dk as getIsFlowMobileInjected,
  fN as getIsMetaMaskInjected,
  Zm as getIsOKX,
  Jm as getIsOKXInjected,
  OS as getIsTrustWallet,
  Xm as getIsTrustWalletInjected,
  yde as getMetaMaskDeepLink,
  mde as getOKXDeepLink,
  Tde as getProvider,
  wde as getTrustWalletDeepLink,
  xn as getWalletIcon,
  Sn as getWalletName,
  V_ as isEventProvider,
  qde as isWriteProvider,
  tde as providerDefaultOptions,
  Rde as useConnectBtnBinance,
  Lde as useConnectBtnBitget,
  Pde as useConnectBtnBybit,
  kde as useConnectBtnClover,
  jde as useConnectBtnCoin98,
  Bde as useConnectBtnCoinbase,
  $de as useConnectBtnFlow,
  zde as useConnectBtnMetaMask,
  Ude as useConnectBtnOKX,
  Fde as useConnectBtnTrust
};
//# sourceMappingURL=index.js.map
